/* eslint-disable */
import { gql } from '@apollo/client/core';
import * as ApolloReactHooks from 'src/gql/base-hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Arbitrary-precision integer, serialized as a string to avoid JavaScript number limits */
  BigInt: number;
  /** Calendar date without time (YYYY-MM-DD) */
  Date: string;
  /** ISO 8601 date-time with timezone (e.g. 2024-01-15T09:30:00Z) */
  DateTime: string;
  /** RFC 5322 compliant email address */
  EmailAddress: string;
  /** Arbitrary JSON value — use sparingly for unstructured data */
  JSON: { [key: string]: any };
  /** Plate editor value - array of paragraph elements for rich text content */
  PlateValue: import("@aline/common").AlinePlateValue;
  /** RFC 4122 UUID (e.g. 550e8400-e29b-41d4-a716-446655440000) */
  UUID: string;
  /** File upload via multipart request */
  Upload: File;
  /** Operation that returns no meaningful value */
  Void: void;
};

/** Preset AI completion operations available for document text. */
export enum AiCompletionType {
  /** Correct spelling and grammar errors without changing meaning. */
  FixSpelling = 'FixSpelling',
  /** Execute a user-provided freeform prompt against the selected text. */
  FreeForm = 'FreeForm',
  /** Enhance clarity, tone, and readability of the selected text. */
  ImproveLanguage = 'ImproveLanguage',
  /** Expand the selected text with additional detail and elaboration. */
  MakeLonger = 'MakeLonger',
  /** Condense the selected text while preserving key meaning. */
  MakeShorter = 'MakeShorter',
  /** Rewrite the selected text using simpler vocabulary and sentence structure. */
  SimplifyLanguage = 'SimplifyLanguage',
  /** Identify and suggest negotiation leverage points within the contract text. */
  SuggestNegotiationPoints = 'SuggestNegotiationPoints',
  /** Generate a concise summary of the selected text. */
  Summarize = 'Summarize'
}

/**
 * An automation that uses AI to analyze report documents and generate reminders.
 * Runs on a schedule against workflows in a report, extracting date-based obligations
 * and creating reminders that go through a review workflow before activation.
 */
export type AiReminderAutomation = {
  __typename: 'AIReminderAutomation';
  /** Number of approved reminders currently active */
  activeRemindersCount: Scalars['Int'];
  /** Users who will be assigned to reminders generated by this automation */
  assignees: Array<User>;
  /** Timestamp when the automation was created */
  createdAt: Scalars['DateTime'];
  /** Timestamp when the automation was soft-deleted, or null if active */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the automation */
  id: Scalars['UUID'];
  /** Whether the automation is currently executing a run */
  isRunning: Scalars['Boolean'];
  /** Timestamp when the most recent run finished successfully */
  lastCompletedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp of the most recent run attempt */
  lastRunAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when the automation was last triggered by the scheduler */
  lastTriggeredAt: Maybe<Scalars['DateTime']>;
  /** Scheduled timestamp for the next automatic run */
  nextRunAt: Maybe<Scalars['DateTime']>;
  /** Notification schedule offsets relative to extracted due dates */
  notificationOffsets: Array<NotificationOffset>;
  /** Number of generated reminders still awaiting reviewer approval */
  pendingRemindersCount: Scalars['Int'];
  /** Natural language instructions telling the AI what to look for when analyzing documents */
  prompt: Scalars['String'];
  /** Report this automation is configured to analyze */
  report: Report;
  /** Users who must approve AI-generated reminders before they become active */
  reviewers: Array<User>;
  /** History of automation runs against individual documents */
  runs: Array<AiReminderAutomationRun>;
  /** Built-in report field keys included in the AI analysis context */
  selectedBuiltInFields: Array<Scalars['String']>;
  /** Report column IDs whose data is included in the AI analysis context */
  selectedColumnIds: Array<Scalars['String']>;
  /** Current lifecycle status of the automation */
  status: AiReminderAutomationStatus;
  /** Display name for the automation */
  title: Scalars['String'];
  /** Total number of reminders generated across all runs */
  totalRemindersGenerated: Scalars['Int'];
  /** Timestamp when the automation was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Editable properties of an AI reminder automation */
export type AiReminderAutomationProps = {
  /** Updated notification schedule offsets */
  notificationOffsets?: InputMaybe<Array<NotificationOffsetInput>>;
  /** Updated AI analysis prompt */
  prompt?: InputMaybe<Scalars['String']>;
  /** Updated lifecycle status */
  status?: InputMaybe<AiReminderAutomationStatus>;
  /** Updated display name */
  title?: InputMaybe<Scalars['String']>;
};

/** Record of a single automation execution against one document */
export type AiReminderAutomationRun = {
  __typename: 'AIReminderAutomationRun';
  /** Automation that initiated this run */
  aiReminderAutomation: AiReminderAutomation;
  /** Timestamp when the run record was created */
  createdAt: Scalars['DateTime'];
  /** Document that was analyzed during this run */
  document: Document;
  /** Error message if the run failed, or null on success */
  errorMessage: Maybe<Scalars['String']>;
  /** Timestamp when the document was processed */
  processedAt: Maybe<Scalars['DateTime']>;
  /** Number of reminders generated during this run */
  remindersGenerated: Scalars['Int'];
  /** Execution status of this run */
  status: AiReminderAutomationRunStatus;
  /** Timestamp when the run record was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Execution status of a single automation run against a document */
export enum AiReminderAutomationRunStatus {
  /** Run finished successfully */
  Completed = 'Completed',
  /** Run encountered an error during processing */
  Failed = 'Failed',
  /** Run is currently analyzing the document and generating reminders */
  Processing = 'Processing'
}

/** Lifecycle status of an AI reminder automation */
export enum AiReminderAutomationStatus {
  /** Automation is running on schedule and processing documents */
  Active = 'Active',
  /** Automation is archived and no longer visible in the active list */
  Archived = 'Archived',
  /** Automation is temporarily suspended and will not run until resumed */
  Paused = 'Paused'
}

/** Real-time event emitted when an AI reminder automation is created, updated, or changes status */
export type AiReminderAutomationUpdatedEvent = {
  __typename: 'AIReminderAutomationUpdatedEvent';
  /** Updated automation object with current state */
  automation: AiReminderAutomation;
  /** ID of the automation that changed */
  automationId: Scalars['UUID'];
};

/** Input for accepting or rejecting questions produced by a generation job. */
export type AcceptGeneratedQuestionInput = {
  /** IDs of generated questions to accept and keep. */
  acceptedQuestions?: InputMaybe<Array<Scalars['UUID']>>;
  /** IDs of generated questions to reject and discard. */
  rejectedQuestions?: InputMaybe<Array<Scalars['UUID']>>;
};

/** Access request record (one per document) */
export type AccessRequest = {
  __typename: 'AccessRequest';
  /** Batch ID (groups requests created together) */
  batchId: Scalars['UUID'];
  /** When request was created */
  createdAt: Scalars['DateTime'];
  /** Document being requested */
  document: Maybe<Document>;
  /** Role granted if accepted */
  grantedRole: Maybe<PermissionRole>;
  /** Request ID */
  id: Scalars['UUID'];
  /** Optional message from the requester explaining why they need access */
  message: Maybe<Scalars['String']>;
  /** Owner who should grant access */
  recipient: User;
  /** When set, access should be granted to these emails instead of the requester */
  requestedForEmails: Maybe<Array<Scalars['String']>>;
  /** Requested permission role */
  requestedRole: Maybe<PermissionRole>;
  /** User who requested access */
  requester: User;
  /** When the owner responded */
  respondedAt: Maybe<Scalars['DateTime']>;
  /** Status of the request */
  status: AccessRequestStatus;
};

/** Error reasons for access request by batch query */
export enum AccessRequestByBatchErrorReason {
  /** Current user is not the recipient */
  NotAuthorized = 'NOT_AUTHORIZED',
  /** No requests found for this batch */
  NotFound = 'NOT_FOUND'
}

/** Result when querying access requests by batch ID */
export type AccessRequestByBatchResult = {
  __typename: 'AccessRequestByBatchResult';
  /** The access requests if found and user is authorized */
  accessRequests: Array<AccessRequest>;
  /** Error reason if requests cannot be viewed */
  errorReason: Maybe<AccessRequestByBatchErrorReason>;
};

/** Input for granting access to a single request */
export type AccessRequestGrant = {
  /** Role to grant */
  grantedRole: PermissionRole;
  /** Request ID */
  requestId: Scalars['UUID'];
};

/** Status of an access request */
export enum AccessRequestStatus {
  /** Owner granted the requested access. */
  Accepted = 'ACCEPTED',
  /** Request has been submitted and is awaiting the owner's decision. */
  Pending = 'PENDING',
  /** Owner denied the requested access. */
  Rejected = 'REJECTED'
}

/** Polymorphic account — either an individual user or an organization */
export type Account = Org | User;

export type AccountInterface = {
  /** Discriminator indicating whether this account is a User or an Org */
  accountType: AccountType;
  /** Hex color used to render the account's avatar in autocompletes, comments, and mentions */
  avatarColor: Scalars['String'];
  /** Timestamp when the account was created */
  createdAt: Scalars['DateTime'];
  /** Timestamp when the account was soft-deleted, or null if still active */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier (GUID) for the account */
  id: Scalars['UUID'];
  /** Timestamp of the most recent update to the account */
  updatedAt: Scalars['DateTime'];
};

/** A User's account status (used to display status of user invites to the app) */
export enum AccountStatus {
  /** User has accepted the invite and completed account setup */
  Confirmed = 'CONFIRMED',
  /** User has been invited but has not yet accepted or logged in */
  Pending = 'PENDING'
}

/** Discriminator for the two kinds of accounts in the system */
export enum AccountType {
  /** Organization account — represents a company or team */
  Org = 'ORG',
  /** Individual user account */
  User = 'USER'
}

/** Container for querying both user and organization accounts together */
export type Accounts = {
  __typename: 'Accounts';
  /** All matching organization accounts */
  orgs: Array<Org>;
  /** All matching user accounts */
  users: Array<User>;
};

/** Filters for retrieving accounts scoped to a specific resource */
export type AccountsByInput = {
  /** Return accounts that have access to this document */
  documentId?: InputMaybe<Scalars['UUID']>;
  /** Return accounts that have access to this workflow */
  workflowId?: InputMaybe<Scalars['UUID']>;
};

/** Where to place an action relative to a workflow step. */
export enum ActionPlacement {
  /** Insert the action into a new step after the target step. */
  AfterStep = 'AFTER_STEP',
  /** Insert the action into a new step before the target step. */
  BeforeStep = 'BEFORE_STEP',
  /** Add the action to the target step itself. */
  WithinStep = 'WITHIN_STEP'
}

/** How an assignment-style activity event changed a task's assignees */
export enum ActivityAssignmentChange {
  /** Aline AI was delegated the task */
  AiDelegated = 'AI_DELEGATED',
  /** Aline AI delegation was removed */
  AiDelegationRemoved = 'AI_DELEGATION_REMOVED',
  /** At least one assignee was added */
  Assigned = 'ASSIGNED',
  /** Assignees were removed and none were added */
  Unassigned = 'UNASSIGNED',
  /** A coalesced run of changes cancelled itself out */
  Updated = 'UPDATED'
}

/** Who can see an activity entry */
export enum ActivityAudience {
  /** Shared with external assignees; members of the workflow owner's org see it too */
  External = 'EXTERNAL',
  /** Only members of the workflow owner's org */
  Internal = 'INTERNAL'
}

/** Variant payload for an ActivityItem, discriminated by itemType */
export type ActivityBody = AgentThreadActivity | CommentActivity | StatusUpdateActivity;

export enum ActivityFeedChangeType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

/**
 * Activity row change for a task or workflow feed. Carries the feed parent so clients can absorb
 * derived state the change may have altered (e.g. a new comment adding its author to the subscriber
 * set) straight from the event instead of refetching.
 */
export type ActivityFeedChangedEvent = {
  __typename: 'ActivityFeedChangedEvent';
  /** Changed row; null only when the row cannot be resolved or was deleted */
  activityItem: Maybe<ActivityItem>;
  /** Changed row id */
  activityItemId: Scalars['UUID'];
  /** What happened to the activity row */
  changeType: ActivityFeedChangeType;
  /** Feed parent; set on task feed events */
  task: Maybe<Task>;
  /** Feed parent; set on workflow feed events */
  workflow: Maybe<Workflow>;
};

/** A single entry on a Task or Workflow activity timeline */
export type ActivityItem = {
  __typename: 'ActivityItem';
  /** Who can see this entry. External viewers never receive INTERNAL entries. */
  audience: ActivityAudience;
  /** User who triggered this entry; null for SYSTEM-generated events */
  author: Maybe<User>;
  /** The variant-specific payload for this entry */
  body: ActivityBody;
  /** Set when this entry mirrors an external channel (Slack) thread; null for native entries */
  channelThread: Maybe<ChannelThread>;
  /** When the entry was created */
  createdAt: Scalars['DateTime'];
  /** Unique identifier for this activity entry */
  id: Scalars['UUID'];
  /** What kind of entry this is — drives which body variant is populated */
  itemType: ActivityItemType;
  /** Where this entry originated */
  sourceType: ActivitySourceType;
};

/** Page of activity items with pagination metadata */
export type ActivityItemRowsInfo = {
  __typename: 'ActivityItemRowsInfo';
  /** Aggregate metadata about the result set */
  meta: ActivityItemsMeta;
  /** Activity items in display order (oldest first; newest at the bottom) */
  rows: Array<ActivityItem>;
};

/** The kind of activity entry on a Task or Workflow timeline */
export enum ActivityItemType {
  /** An @Aline AI agent thread (invoked from the composer or by an AI task-assignment kickoff) */
  AgentThread = 'AGENT_THREAD',
  /** A user comment posted to the task/workflow */
  Comment = 'COMMENT',
  /** A system-emitted lifecycle event (creation, assignment, completion, etc.) */
  StatusUpdate = 'STATUS_UPDATE'
}

/** Pagination metadata for an activity feed page */
export type ActivityItemsMeta = {
  __typename: 'ActivityItemsMeta';
  /** Whether there are newer items beyond this page */
  hasMore: Scalars['Boolean'];
  /** Whether there are older items beyond this page */
  hasPrevious: Scalars['Boolean'];
  /** Cursor to pass on the next request to fetch newer items; null when at the newest history */
  nextCursor: Maybe<Scalars['UUID']>;
  /** Cursor to pass as before on the next request to fetch older items; null when at the oldest history */
  previousCursor: Maybe<Scalars['UUID']>;
  /** Total number of activity items on this task/workflow */
  totalCount: Scalars['Int'];
};

/** Where an activity entry originated */
export enum ActivitySourceType {
  /** Generated by an AI agent */
  Ai = 'AI',
  /** Arrived via email integration */
  Email = 'EMAIL',
  /** Arrived via Slack integration */
  Slack = 'SLACK',
  /** Emitted by the system (lifecycle automation) */
  System = 'SYSTEM',
  /** Arrived via Microsoft Teams integration */
  Teams = 'TEAMS',
  /** Posted from the Aline web app */
  Web = 'WEB'
}

/** A single lifecycle event within a (possibly coalesced) status update */
export type ActivityStatusEvent = {
  __typename: 'ActivityStatusEvent';
  /** What an assignment-style event did to the assignee list; null when the event carries no assignment payload */
  assignmentChange: Maybe<ActivityAssignmentChange>;
  /** Structured payload for this event (IDs, not pre-rendered text) */
  data: Maybe<Scalars['JSON']>;
  /** Which lifecycle event this is */
  eventType: ActivityStatusEventType;
  /** How many people the payload named as switching sides, counting any whose account no longer resolves */
  movedCount: Scalars['Int'];
  /** How many of movedCount switched to reviewer */
  movedReviewerCount: Scalars['Int'];
  movedRoles: Array<UserDefinedRole>;
  /** People who stayed on the task but switched between assignee and reviewer */
  movedUsers: Array<User>;
  /** The assignee a decision was recorded for, when someone else recorded it */
  onBehalfOfUser: Maybe<User>;
  /** How many assignees the payload named as removed, counting any whose account no longer resolves */
  removedCount: Scalars['Int'];
  /** How many of removedCount left as reviewers */
  removedReviewerCount: Scalars['Int'];
  /** Resolved dropped assignment target roles for role-assignment events, for each removed role the payload names */
  removedRoles: Array<UserDefinedRole>;
  /** Resolved dropped assignment targets for assignment-style events, for each removed user the payload names */
  removedUsers: Array<User>;
  /** The reviewers a review request asked, or whose request was taken back */
  reviewRequestUsers: Array<User>;
  /** The user and role ids among the added and removed that joined or left as reviewers */
  reviewerIds: Array<Scalars['ID']>;
  /** How many assignees the payload named as added, counting any whose account no longer resolves */
  targetCount: Scalars['Int'];
  /** How many of targetCount joined as reviewers */
  targetReviewerCount: Scalars['Int'];
  /** Resolved added assignment target roles for role-assignment events, for each added role the payload names */
  targetRoles: Array<UserDefinedRole>;
  /** Resolved added assignment targets for assignment-style events, for each added user the payload names */
  targetUsers: Array<User>;
};

/** Lifecycle event recorded as a STATUS_UPDATE activity entry */
export enum ActivityStatusEventType {
  /** A reviewer approved the task while other required reviewers have not */
  TaskApproved = 'TASK_APPROVED',
  /** Task was assigned to a workflow permission/role */
  TaskAssigned = 'TASK_ASSIGNED',
  /** One assignee completed the task while other required assignees have not */
  TaskAssigneeCompleted = 'TASK_ASSIGNEE_COMPLETED',
  /** An assignee took back their Complete while the task was still open */
  TaskAssigneeCompletionUndone = 'TASK_ASSIGNEE_COMPLETION_UNDONE',
  /** An optional reviewer rejected the task without rejecting it. No longer emitted; kept so older feed rows render */
  TaskAssigneeRejected = 'TASK_ASSIGNEE_REJECTED',
  /** A reviewer who requested changes reminded the task's subscribers they are still waiting */
  TaskChangesReminderSent = 'TASK_CHANGES_REMINDER_SENT',
  /** A reviewer requested changes, sending the task back to its assignees */
  TaskChangesRequested = 'TASK_CHANGES_REQUESTED',
  /** Task was marked completed */
  TaskCompleted = 'TASK_COMPLETED',
  /** Task was created */
  TaskCreated = 'TASK_CREATED',
  /** Task title or description was edited */
  TaskEdited = 'TASK_EDITED',
  /** A file was uploaded as a new version of one of the task's documents */
  TaskFileUploaded = 'TASK_FILE_UPLOADED',
  /** External assignees were emailed an invitation to their task */
  TaskInvitationSent = 'TASK_INVITATION_SENT',
  /** The task started with reviewers but nobody to do the work */
  TaskMissingAssignee = 'TASK_MISSING_ASSIGNEE',
  /** Task was moved to a different phase */
  TaskPhaseChanged = 'TASK_PHASE_CHANGED',
  /** An internal assignee or reviewer rejected the task and the workflow moved to Cancelled */
  TaskRejected = 'TASK_REJECTED',
  /** Task was reopened after completion */
  TaskReopened = 'TASK_REOPENED',
  /** An assignee reminded the reviewers who were asked and have not answered */
  TaskReviewReminderSent = 'TASK_REVIEW_REMINDER_SENT',
  /** An assignee or editor took back the open review request */
  TaskReviewRequestWithdrawn = 'TASK_REVIEW_REQUEST_WITHDRAWN',
  /** Someone asked chosen reviewers to review again, starting a new round. Older rows only; a review request now records TASK_SUBMITTED_FOR_REVIEW */
  TaskReReviewRequested = 'TASK_RE_REVIEW_REQUESTED',
  /** The task started */
  TaskStarted = 'TASK_STARTED',
  /** Reviewers were asked to review: by an assignee, when the phase started, or when Aline AI finished */
  TaskSubmittedForReview = 'TASK_SUBMITTED_FOR_REVIEW',
  /** Workflow was marked completed */
  WorkflowCompleted = 'WORKFLOW_COMPLETED',
  /** Workflow was created */
  WorkflowCreated = 'WORKFLOW_CREATED',
  /** Workflow owner was changed (reserved: nothing emits this yet) */
  WorkflowOwnerChanged = 'WORKFLOW_OWNER_CHANGED',
  /** Workflow priority was changed */
  WorkflowPriorityChanged = 'WORKFLOW_PRIORITY_CHANGED',
  /** Workflow was reverted to draft from signing */
  WorkflowRevertedToDraft = 'WORKFLOW_REVERTED_TO_DRAFT',
  /** Workflow was sent for e-signature */
  WorkflowSentForSignature = 'WORKFLOW_SENT_FOR_SIGNATURE',
  /** Workflow was signed by all recipients */
  WorkflowSigned = 'WORKFLOW_SIGNED',
  /** Workflow execution started */
  WorkflowStarted = 'WORKFLOW_STARTED'
}

/** Why a subscriber cannot be unsubscribed from the activity thread. */
export enum ActivitySubscriberLockReason {
  Assignee = 'Assignee'
}

/** A candidate subscriber row for the 'change subscribers' picker: an active org member with their current subscribed + locked state. */
export type ActivitySubscriberOption = {
  __typename: 'ActivitySubscriberOption';
  /** Why this user cannot be unsubscribed; null when they can be toggled freely. */
  lockReason: Maybe<ActivitySubscriberLockReason>;
  /** Whether this user is currently subscribed (the checkbox is checked). */
  subscribed: Scalars['Boolean'];
  /** The candidate user (an active member of the entity's org). */
  user: User;
};

/** Identifies the Task or Workflow activity thread to subscribe to or unsubscribe from (exactly one of taskId/workflowId) */
export type ActivitySubscriptionInput = {
  taskId?: InputMaybe<Scalars['UUID']>;
  /** The user to subscribe or unsubscribe. Defaults to the authenticated user when omitted; anyone with access to the entity may change anyone's subscription (except a locked assignee). */
  userId?: InputMaybe<Scalars['UUID']>;
  workflowId?: InputMaybe<Scalars['UUID']>;
};

/** Result of toggling the viewer's subscription to a Task or Workflow activity thread */
export type ActivitySubscriptionToggleResult = {
  __typename: 'ActivitySubscriptionToggleResult';
  /** The updated effective subscriber list */
  subscribers: Array<User>;
  /** Whether the viewer is now subscribed */
  viewerSubscribed: Scalars['Boolean'];
};

/** Input for adding documents to an existing workflow. */
export type AddDocumentsToWorkflowInput = {
  /** IDs of documents to attach. */
  documentIds: Array<Scalars['UUID']>;
  /** Role for the added documents (General or Signing). */
  documentRole?: InputMaybe<WorkflowFileDocumentRole>;
  /** The workflow to add documents to. */
  workflowId: Scalars['UUID'];
};

/** Input for linking a party to a document. */
export type AddPartyToDocumentInput = {
  /** ID of the document to add the party to. */
  documentId: Scalars['UUID'];
  /** ID of the party to add. */
  partyId: Scalars['UUID'];
};

/** Input for appending a fallback position to a rule. */
export type AddPlaybookRulePositionInput = {
  /** Text and guidance for the new fallback. */
  props: PlaybookRulePositionProps;
  /** ID of the rule to add a fallback to. */
  ruleId: Scalars['UUID'];
};

/** Input for adding a new option to a question. */
export type AddQuestionOptionInput = {
  /** Properties for the new option. */
  option: QuestionOptionInput;
  /** ID of the question to add the option to. */
  questionId: Scalars['UUID'];
};

/** Input for adding new options to a question. */
export type AddQuestionOptionsInput = {
  /** Properties for the new options. */
  options: Array<QuestionOptionInput>;
  /** ID of the question to add the options to. */
  questionId: Scalars['UUID'];
};

/** Input for adding users to an existing group */
export type AddUsersToGroupInput = {
  /** ID of the group to add users to */
  id: Scalars['UUID'];
  /** IDs of the users to add */
  userIds: Array<Scalars['UUID']>;
};

/** Input for adding one or more collaborators to a workflow. */
export type AddWorkflowPermissionsInput = {
  /** Optional notification message sent to added collaborators. */
  message?: InputMaybe<Scalars['String']>;
  /** Properties for each new collaborator. */
  props: Array<NewWorkflowPermissionProps>;
  /** The workflow to add collaborators to. */
  workflowId: Scalars['UUID'];
};

export type AddWorkflowViewChartInput = {
  pin: WorkflowViewPinInput;
  state: Scalars['JSON'];
  viewId: Scalars['UUID'];
};

export type AdminAiUsage = {
  __typename: 'AdminAiUsage';
  dimensionOptions: AdminAiUsageDimensionOptions;
  series: Array<AdminAiUsageSeriesPoint>;
  summary: AdminAiUsageSummary;
};

/** Date bucket size for admin usage analytics */
export enum AdminAiUsageBucket {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type AdminAiUsageDetailRow = {
  __typename: 'AdminAiUsageDetailRow';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inputTokensUsed: Scalars['BigInt'];
  modelKey: Scalars['String'];
  outputTokensUsed: Scalars['BigInt'];
  source: AiUsageSource;
  totalCostMicrodollars: Scalars['BigInt'];
  totalTokensUsed: Scalars['BigInt'];
  user: User;
};

export type AdminAiUsageDetailRows = {
  __typename: 'AdminAiUsageDetailRows';
  rows: Array<AdminAiUsageDetailRow>;
  totalCount: Scalars['Int'];
};

export type AdminAiUsageDetailRowsInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortModel?: InputMaybe<Scalars['JSON']>;
  usageInput: AdminAiUsageInput;
};

export type AdminAiUsageDimensionOptions = {
  __typename: 'AdminAiUsageDimensionOptions';
  modelKeys: Array<Scalars['String']>;
  sources: Array<AiUsageSource>;
  users: Array<AdminAiUsageUserOption>;
};

/** Dimension used to group admin usage analytics */
export enum AdminAiUsageGroupBy {
  Model = 'MODEL',
  None = 'NONE',
  Source = 'SOURCE',
  User = 'USER'
}

export type AdminAiUsageInput = {
  bucket: AdminAiUsageBucket;
  endDate: Scalars['Date'];
  groupBy: AdminAiUsageGroupBy;
  modelKeys?: InputMaybe<Array<Scalars['String']>>;
  sources?: InputMaybe<Array<AiUsageSource>>;
  startDate: Scalars['Date'];
  timeZone: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type AdminAiUsageSeriesPoint = {
  __typename: 'AdminAiUsageSeriesPoint';
  bucketStartDate: Scalars['Date'];
  groupKey: Scalars['String'];
  groupLabel: Scalars['String'];
  inputTokensUsed: Scalars['BigInt'];
  outputTokensUsed: Scalars['BigInt'];
  totalCostMicrodollars: Scalars['BigInt'];
  totalTokensUsed: Scalars['BigInt'];
};

export type AdminAiUsageSummary = {
  __typename: 'AdminAiUsageSummary';
  includedMicrodollars: Scalars['BigInt'];
  inputTokensUsed: Scalars['BigInt'];
  outputTokensUsed: Scalars['BigInt'];
  totalCostMicrodollars: Scalars['BigInt'];
  totalTokensUsed: Scalars['BigInt'];
};

export type AdminAiUsageUserOption = {
  __typename: 'AdminAiUsageUserOption';
  id: Scalars['UUID'];
  label: Scalars['String'];
};

/** A still-present document that lost relationship children to a bulk trash, and how many it lost. Lets the relationship grid decrement (or drop) exactly the affected parent rows without a full refetch. */
export type AffectedRelationshipParent = {
  __typename: 'AffectedRelationshipParent';
  documentId: Scalars['UUID'];
  trashedChildCount: Scalars['Int'];
};

/** Specific subtype of an agent event, used to route event handling on the client */
export enum AgentEventSubtype {
  /** A new or updated message from the AI assistant */
  AssistantMessage = 'ASSISTANT_MESSAGE',
  /** A loading/thinking indicator while the agent processes */
  Loading = 'LOADING',
  /** A status update for a tool the agent is currently executing */
  UpdateToolStatus = 'UPDATE_TOOL_STATUS',
  /** A new message from the user */
  UserMessage = 'USER_MESSAGE'
}

/** Top-level category of an agent event delivered via subscription */
export enum AgentEventType {
  /** A message-related event (new message, update, or completion) */
  Message = 'MESSAGE'
}

/** A single message in an agent conversation thread */
export type AgentMessage = {
  __typename: 'AgentMessage';
  /** When this message was first persisted. Used by the artifacts bar to render stable relative timestamps. */
  createdAt: Scalars['DateTime'];
  /** Structured payload containing tool results, suggested edits, and other machine-readable content */
  data: Scalars['JSON'];
  /** Optional user feedback on message quality */
  feedback: Maybe<AgentMessageFeedback>;
  /** Unique identifier for the message */
  id: Scalars['UUID'];
  /**
   * Validated PlanState JSON for chat-harness-authored messages; null for
   * messages produced by the legacy chat path. Shape matches
   * @aline/common PlanStateSchema. Used by the client to render the plan
   * tree UI.
   */
  planState: Maybe<Scalars['JSON']>;
  /** Whether this message was sent by the user or the AI assistant */
  role: AgentMessageRole;
  /** Current lifecycle status (streaming, complete, error, etc.) */
  status: AgentMessageStatus;
  /** Markdown-formatted content of the message */
  text: Scalars['String'];
};

/** User-provided quality feedback on an agent message */
export enum AgentMessageFeedback {
  /** User indicated the message was not helpful */
  Negative = 'NEGATIVE',
  /** User indicated the message was helpful */
  Positive = 'POSITIVE'
}

/** Role an artifact plays for an AgentMessage join table. */
export enum AgentMessageJoinKind {
  /** AI created the artifact. */
  Created = 'created',
  /** AI drafted the artifact. */
  Drafted = 'drafted',
  /** AI edited the artifact. */
  Edited = 'edited',
  /** User mentioned the artifact in their prompt. */
  Mentioned = 'mentioned'
}

/** Identifies which participant sent a message in the agent thread */
export enum AgentMessageRole {
  /** Message generated by the AI assistant */
  Assistant = 'ASSISTANT',
  /** Message sent by the human user */
  User = 'USER'
}

/** Lifecycle status of an agent message */
export enum AgentMessageStatus {
  /** Message generation was cancelled by the user */
  Cancelled = 'CANCELLED',
  /** Cancellation has been requested but the stream has not yet stopped */
  Cancelling = 'CANCELLING',
  /** Message generation is finished */
  Complete = 'COMPLETE',
  /** An error occurred during message generation */
  Error = 'ERROR',
  /** Message content is actively being streamed from the agent */
  Streaming = 'STREAMING'
}

export type AgentMessageSuggestionFeedbackInput = {
  /** The feedback of the message. */
  feedback?: InputMaybe<AgentMessageFeedback>;
  /** ID of the message this feedback belongs to. */
  messageId: Scalars['UUID'];
};

export type AgentMessageSuggestionsInput = {
  /** The groupIds of the suggestions to update. */
  groupIds: Array<Scalars['String']>;
  /** ID of the message this suggestion belongs to. */
  messageId: Scalars['UUID'];
  /** The new status of the suggestions. */
  status: MessageSuggestionStatus;
};

/** Input for sending a new prompt to the AI agent */
export type AgentPromptInput = {
  /** Immutable Skill versions pinned to this turn. The client never sends Skill content. */
  agentSkills?: InputMaybe<Array<AgentSkillReferenceInput>>;
  /** ID of the assistant message that this prompt belongs to */
  assistantMessageId: Scalars['UUID'];
  /** ID of the document that is currently being viewed in the editor */
  editorDocumentId?: InputMaybe<Scalars['UUID']>;
  /** The prompt text to send to the agent. May contain markdown mention links in the format [@fileName](mention:mentionTypeName:fileId) */
  prompt: Scalars['String'];
  /** ID of the thread this prompt belongs to. Client should generate this for new threads. */
  threadId: Scalars['UUID'];
  /** ID of the user message that this prompt belongs to */
  userMessageId: Scalars['UUID'];
  /** Artifact surface currently visible/active for this turn */
  visibleContext?: InputMaybe<AgentVisibleContextInput>;
};

/** Acknowledgement returned after a prompt is submitted, before streaming begins */
export type AgentResponse = {
  __typename: 'AgentResponse';
  /** The skill versions pinned to this turn, validated before it started, in the order they were pinned. Empty when the turn pins none. */
  agentSkillVersions: Array<AgentSkillVersion>;
  /** ID of the assistant message that will be streamed */
  messageId: Scalars['UUID'];
  /** The prompt that was sent */
  prompt: Scalars['String'];
  /** ID of the thread the response belongs to */
  threadId: Scalars['UUID'];
};

/** A reusable unit of agent instructions backed by an immutable current version. */
export type AgentSkill = {
  __typename: 'AgentSkill';
  /** The published version's files, or the draft's for a skill that was never published. */
  attachments: Array<AgentSkillAttachment>;
  /** The published version's whole SKILL.md, or the draft's for a skill that was never published. */
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Null until the skill is first published. */
  currentVersion: Maybe<AgentSkillVersion>;
  /** The published version's description, or the draft's for a skill that was never published. */
  description: Scalars['String'];
  /** What the author edits. Null for anyone but the author. */
  draft: Maybe<AgentSkillDraft>;
  /** Whether the author has saved changes that aren't published yet. Always false for anyone else. */
  hasUnpublishedChanges: Scalars['Boolean'];
  id: Scalars['UUID'];
  /** Whether the skill has a valid name and a description, and so can be offered to the agent. */
  isComplete: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  /** The published version's name, or the draft's for a skill that was never published. */
  name: Scalars['String'];
  org: Org;
  owner: User;
  scope: AgentSkillScope;
  updatedAt: Scalars['DateTime'];
};

export type AgentSkillAttachment = {
  __typename: 'AgentSkillAttachment';
  capturedAt: Maybe<Scalars['DateTime']>;
  contentType: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  processing: AgentSkillFileProcessing;
  /** Why the file could not be processed, written for the author. */
  processingError: Maybe<Scalars['String']>;
  sha256: Scalars['String'];
  sourceDocumentId: Maybe<Scalars['UUID']>;
  sourceStatus: AgentSkillAttachmentSourceStatus;
};

export type AgentSkillAttachmentContent = {
  __typename: 'AgentSkillAttachmentContent';
  base64: Scalars['String'];
  contentType: Scalars['String'];
  name: Scalars['String'];
};

/** Whether a skill's copy of a document still matches the document it was taken from. */
export enum AgentSkillAttachmentSourceStatus {
  Changed = 'CHANGED',
  Current = 'CURRENT',
  /** The attachment was uploaded, not copied from a document. */
  NotApplicable = 'NOT_APPLICABLE',
  /** The source document was deleted, or the viewer can no longer read it. */
  Unavailable = 'UNAVAILABLE'
}

/** The skill as its author edits it: the unpublished changes, or the published version when there are none. */
export type AgentSkillDraft = {
  __typename: 'AgentSkillDraft';
  attachments: Array<AgentSkillAttachment>;
  /** The draft's whole SKILL.md, frontmatter included. */
  content: Scalars['String'];
  description: Scalars['String'];
  /** Whether every attached file is processed, which testing and publishing require. */
  filesReady: Scalars['Boolean'];
  isComplete: Scalars['Boolean'];
  name: Scalars['String'];
  /** Bumped by every save. A save made on an older revision fails with OUTDATED_SKILL_VERSION. */
  revision: Scalars['Int'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Whether an attached file has been processed into the structure Aline reads. */
export enum AgentSkillFileProcessing {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

/** A server-validated immutable Skill selection for one chat turn. */
export type AgentSkillReferenceInput = {
  skillId: Scalars['UUID'];
  versionId: Scalars['UUID'];
};

export type AgentSkillResponse = {
  __typename: 'AgentSkillResponse';
  agentSkill: AgentSkill;
  refetch: Query;
};

/** Visibility scope that determines who can see and use an agent skill. */
export enum AgentSkillScope {
  /** Readable by every org. */
  Community = 'COMMUNITY',
  Org = 'ORG',
  Personal = 'PERSONAL'
}

/** An immutable skill definition. */
export type AgentSkillVersion = {
  __typename: 'AgentSkillVersion';
  contentSha256: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** The spec description from this version's SKILL.md frontmatter. Empty while the skill is unfinished. */
  description: Scalars['String'];
  id: Scalars['UUID'];
  /** The spec name from this version's SKILL.md frontmatter. Empty while the skill is unfinished. */
  name: Scalars['String'];
  number: Scalars['Int'];
  /** When the version was published. Null for a test version, which only the author can load. */
  publishedAt: Maybe<Scalars['DateTime']>;
  skillId: Scalars['UUID'];
};

/** A conversation thread between a user and the AI agent */
export type AgentThread = {
  __typename: 'AgentThread';
  /**
   * Deduped artifact list for the thread's artifacts bar. Documents, reports,
   * tasks, and workflows are returned as a union so the client consumes one
   * artifact stream instead of one field per backing join table.
   */
  artifacts: Array<ThreadArtifact>;
  /** Documents referenced as context in this thread */
  context: Array<Document>;
  /** Timestamp when the thread was created */
  createdAt: Scalars['DateTime'];
  /** Unique identifier for the thread */
  id: Scalars['UUID'];
  /** Ordered list of messages in the conversation */
  messages: Array<AgentMessage>;
  /**
   * The user who owns the thread — the only one authorized to edit or stop a
   * run. Task-execution threads re-point to the latest requester on re-kick,
   * so this can differ from whoever originally started the thread.
   */
  ownerUserId: Scalars['UUID'];
  /** Auto-generated or user-edited title summarizing the conversation */
  title: Scalars['String'];
  /** Timestamp when the thread was last updated */
  updatedAt: Scalars['DateTime'];
  /** Whether the thread belongs to an activity and can only use shared skills */
  usesSharedSkills: Scalars['Boolean'];
};

/** Body of an AGENT_THREAD activity entry */
export type AgentThreadActivity = {
  __typename: 'AgentThreadActivity';
  /** The AI agent thread invoked from the composer; null if it was deleted after the row was read */
  agentThread: Maybe<AgentThread>;
};

/** Limits agent thread history by whether a thread is linked to a task or workflow activity feed */
export enum AgentThreadHistoryFilter {
  /** Return threads linked to a task or workflow activity feed */
  Activity = 'ACTIVITY',
  /** Return every thread */
  All = 'ALL',
  /** Return threads that are not linked to an activity feed */
  Direct = 'DIRECT'
}

/** Artifact surface that is currently visible/active for this agent turn. */
export type AgentVisibleContextInput = {
  /** Skill open in the skill editor */
  skillId?: InputMaybe<Scalars['UUID']>;
  /** Task currently visible to the user or active for an automatic task run */
  taskId?: InputMaybe<Scalars['UUID']>;
  /** Workflow currently visible to the user */
  workflowId?: InputMaybe<Scalars['UUID']>;
};

/** Tracks which AI extraction questions are currently running for a specific document. */
export type AiQuestionsRunningForDoc = {
  __typename: 'AiQuestionsRunningForDoc';
  /** The document that extraction is running on. */
  documentId: Scalars['UUID'];
  /** IDs of the extraction questions currently being processed for this document. */
  questionIds: Array<Scalars['UUID']>;
};

/** Record of AI usage consumption for a single model call */
export type AiTokenUsage = {
  __typename: 'AiTokenUsage';
  /** Timestamp when this usage record was created */
  createdAt: Scalars['DateTime'];
  /** Unique identifier for this usage record */
  id: Scalars['UUID'];
  /** Estimated input cost in microdollars */
  inputCostMicrodollars: Scalars['BigInt'];
  /** Number of tokens consumed by the prompt (input) */
  inputTokensUsed: Scalars['BigInt'];
  /** Internal model key used for the request */
  modelKey: Scalars['String'];
  /** Estimated output cost in microdollars */
  outputCostMicrodollars: Scalars['BigInt'];
  /** Number of tokens consumed by the model's completion (output) */
  outputTokensUsed: Scalars['BigInt'];
  /** Business source category */
  source: AiUsageSource;
  /** Estimated total cost in microdollars */
  totalCostMicrodollars: Scalars['BigInt'];
  /** Total input and output tokens consumed */
  totalTokensUsed: Scalars['BigInt'];
  /** Timestamp of the most recent update to this usage record */
  updatedAt: Scalars['DateTime'];
  /** The user who initiated the AI request */
  user: User;
};

/** Summary of AI usage within the current billing period */
export type AiUsage = {
  __typename: 'AiUsage';
  /** Included AI usage allowance in microdollars */
  includedMicrodollars: Scalars['BigInt'];
  /** Timestamp when the usage counter resets for the next billing period */
  resetsAt: Scalars['DateTime'];
  /** Token allowance for the current billing period */
  totalAvailableTokens: Scalars['BigInt'];
  /** Total tokens consumed so far in the current billing period */
  totalTokensUsed: Scalars['BigInt'];
  /** Total estimated spend so far in microdollars */
  usedMicrodollars: Scalars['BigInt'];
  /** Total tokens consumed so far in the current billing period */
  usedTokens: Scalars['BigInt'];
};

/** Source category for AI usage accounting */
export enum AiUsageSource {
  AiReminders = 'AI_REMINDERS',
  Chat = 'CHAT',
  CoreAiExtraction = 'CORE_AI_EXTRACTION',
  ParentChildRelationships = 'PARENT_CHILD_RELATIONSHIPS',
  Playbooks = 'PLAYBOOKS',
  Reports = 'REPORTS',
  Unknown = 'UNKNOWN'
}

/** The input control type for an Aline-only template field exposed on the launch form. */
export enum AlineFieldType {
  /** Boolean checkbox (serialized as "true" / "false"). */
  Checkbox = 'CHECKBOX',
  /** Date input (YYYY-MM-DD). */
  Date = 'DATE',
  /** Numeric input. */
  Number = 'NUMBER',
  /** Single-select from a list of options. */
  Picklist = 'PICKLIST',
  /** Free-form text input. */
  Text = 'TEXT'
}

/** A value submitted for an Aline-only template field on launch. */
export type AlineFieldValueInput = {
  /** Identifier from AlineTemplateField.fieldId. */
  fieldId: Scalars['UUID'];
  /** Value serialized as a string, parsed per the field's declared type. */
  value: Scalars['String'];
};

/** A location within the Aline rich-text editor, identified by a Slate path. */
export type AlineLocation = {
  __typename: 'AlineLocation';
  /** Slate node path identifying the location in the editor tree. */
  locationPath: Array<Scalars['Int']>;
  /** The text content at this location used as a reference anchor. */
  referenceText: Scalars['String'];
};

/** A selectable option for a PICKLIST Aline template field. */
export type AlinePicklistOption = {
  __typename: 'AlinePicklistOption';
  /** Display label rendered in the form. */
  label: Scalars['String'];
  /** Stable value submitted back on launch. */
  value: Scalars['String'];
};

/** Details about an Account's subscription in Aline (synced from Salesbricks) */
export type AlineSubscription = {
  __typename: 'AlineSubscription';
  /** When this subscription record was created */
  createdAt: Scalars['DateTime'];
  /** When this subscription was soft-deleted (null if active) */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the subscription record */
  id: Scalars['UUID'];
  /** Number of basic seats. */
  numBasicSeats: Scalars['Int'];
  /** Number of full seats. */
  numFullSeats: Scalars['Int'];
  /** Array of open orders (pending checkout/signature). */
  openOrders: Array<OpenOrder>;
  /** Array of past due invoices (unpaid and overdue). */
  pastDueInvoices: Array<PastDueInvoice>;
  /** Salesbricks subscription ID */
  salesbricksSubscriptionId: Scalars['String'];
  /** Subscription status. */
  status: SubscriptionStatus;
  /** DateTime when subscription contract ends. */
  subscriptionEndsAt: Scalars['DateTime'];
  /** DateTime when subscription contract started. */
  subscriptionStartedAt: Scalars['DateTime'];
  /** Subscription plan type. */
  tier: SubscriptionTier;
  /** When this subscription record was last updated */
  updatedAt: Scalars['DateTime'];
};

/** A template field that is not linked to Salesforce, exposed for input on the launch form. */
export type AlineTemplateField = {
  __typename: 'AlineTemplateField';
  /** Stable identifier. Round-trips back as createWorkflowInstance.alineFieldValues[*].fieldId. */
  fieldId: Scalars['UUID'];
  /** Display label rendered in the form. */
  label: Scalars['String'];
  /** 1-based render position. */
  order: Scalars['Int'];
  /** Options for PICKLIST fields. Null otherwise. */
  picklistOptions: Maybe<Array<AlinePicklistOption>>;
  /** Optional question/help text shown with the input. Null when none is set. */
  question: Maybe<Scalars['String']>;
  /** If true, the field must be filled before launch. */
  required: Scalars['Boolean'];
  /** Input control type. */
  type: AlineFieldType;
  /** IDs of the template documents that contain this field. Matches documentsList entries. */
  usedInDocuments: Array<Scalars['UUID']>;
};

/** Real-time event emitted when annotations on a file version are created, updated, or deleted */
export type AnnotationsChangedEvent = {
  __typename: 'AnnotationsChangedEvent';
  /** Updated annotations after the change, or null if annotations were deleted */
  annotationsXFDF: Maybe<AnnotationsXfdf>;
  /** ID of the file version whose annotations changed */
  fileVersionId: Scalars['UUID'];
  /** User who made the annotation change */
  user: User;
  /** ID of the user who made the annotation change */
  userId: Scalars['UUID'];
};

/** PDF annotations stored in XFDF format (an XML-based standard for PDF markup) */
export type AnnotationsXfdf = {
  __typename: 'AnnotationsXFDF';
  /** Timestamp when this annotation record was created */
  createdAt: Scalars['DateTime'];
  /** Timestamp when this annotation record was soft-deleted, or null if active */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** The file version these annotations are attached to */
  fileVersion: FileVersion;
  /** Unique identifier for this annotation record */
  id: Scalars['UUID'];
  /** Timestamp of the most recent update to this annotation record */
  updatedAt: Scalars['DateTime'];
  /** XFDF XML string containing all PDF annotations (highlights, comments, stamps, etc.) */
  xfdf: Scalars['String'];
};

/** A single selectable choice within an answer option set, linked to a conditional content action in the document. */
export type AnswerOption = {
  __typename: 'AnswerOption';
  /** Links this option to a conditional content region in the document JSON. */
  choiceRefId: Scalars['UUID'];
  /** When this answer option was created. */
  createdAt: Scalars['DateTime'];
  /** When this answer option was soft-deleted; null if active. */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this answer option. */
  id: Scalars['UUID'];
  /** Display text shown to the participant when choosing this option. */
  optionText: Scalars['String'];
  /** Document action triggered when this option is selected (merge or insert content). */
  triggerAction: TriggerAction;
  /** When this answer option was last modified. */
  updatedAt: Scalars['DateTime'];
};

/** Inline answer option data used when creating or updating options as part of a set. */
export type AnswerOptionProps = {
  /** Existing option ID for updates; omit when adding a new option. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Display text shown to the participant. */
  optionText: Scalars['String'];
  /** Document action triggered when this option is selected. */
  triggerAction: TriggerAction;
};

/** Wrapper returned by answer option mutations, includes the affected option and a refetch entry point. */
export type AnswerOptionResponse = {
  __typename: 'AnswerOptionResponse';
  /** The created or updated answer option. */
  answerOption: AnswerOption;
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
};

/** A named collection of answer options that drive conditional content in documents. Can be saved as a reusable preset. */
export type AnswerOptions = {
  __typename: 'AnswerOptions';
  /** User who created this answer option set. */
  author: Maybe<User>;
  /** When this option set was created. */
  createdAt: Scalars['DateTime'];
  /** When this option set was soft-deleted; null if active. */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Number of documents currently referencing this option set. */
  documentsUsing: Scalars['Int'];
  /** Unique identifier for this answer option set. */
  id: Scalars['UUID'];
  /** True if this set is saved as a reusable preset available across documents. */
  isPreset: Scalars['Boolean'];
  /** Individual choices within this set, each linked to a document content action. */
  options: Array<AnswerOption>;
  /** Display name for this option set, shown in preset lists and document editors. */
  title: Maybe<Scalars['String']>;
  /** When this option set was last modified. */
  updatedAt: Scalars['DateTime'];
};

/** Properties for creating or updating an answer option set. */
export type AnswerOptionsProps = {
  /** Whether to save this set as a reusable preset. */
  isPreset?: InputMaybe<Scalars['Boolean']>;
  /** Complete list of choices in this set. Replaces all existing options on update. */
  options: Array<AnswerOptionProps>;
  /** Display name for the option set. */
  title?: InputMaybe<Scalars['String']>;
};

/** Wrapper returned by answer options mutations, includes the affected set and a refetch entry point. */
export type AnswerOptionsResponse = {
  __typename: 'AnswerOptionsResponse';
  /** The created or updated answer option set. */
  answerOptions: AnswerOptions;
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
};

/** A configured connection to a third-party CRM service (e.g., HubSpot, Salesforce) via ApiDeck. */
export type ApiDeckConnection = {
  __typename: 'ApiDeckConnection';
  /** Whether the connection has been enabled by the user. */
  enabled: Maybe<Scalars['Boolean']>;
  /** URL to the service provider's icon or logo. */
  icon: Scalars['String'];
  /** Unique id for Apollo cache. Points to the serviceId of the integration provider. */
  id: Scalars['String'];
  /** The third-party integration this connection belongs to. */
  integration: Integration;
  /** Display name of the service provider (e.g., 'HubSpot'). */
  name: Maybe<Scalars['String']>;
  /** Current lifecycle state of this connection. */
  state: Maybe<ApiDeckConnectionState>;
  /** Short marketing description of the service provider. */
  tagLine: Maybe<Scalars['String']>;
};

/** Connection lifecycle state for an ApiDeck service provider integration. */
export enum ApiDeckConnectionState {
  /** Connection has been added but not yet authorized by the user. */
  Added = 'Added',
  /** User has completed OAuth or credential authorization. */
  Authorized = 'Authorized',
  /** Integration is available for setup but has not been added. */
  Available = 'Available',
  /** Connection is fully authorized and ready to make API calls. */
  Callable = 'Callable',
  /** Authorization has expired or credentials are no longer valid. */
  Invalid = 'Invalid'
}

/** Represents the org's ApiDeck consumer account and its available service connections. */
export type ApiDeckConsumer = {
  __typename: 'ApiDeckConsumer';
  /** All CRM connections available to this consumer, including both configured and unconfigured services. */
  apiDeckConnections: Array<ApiDeckConnection>;
  /** Unique identifier for the ApiDeck consumer. */
  id: Scalars['UUID'];
};

/** A lead record retrieved from a connected CRM integration. */
export type ApiDeckLead = {
  __typename: 'ApiDeckLead';
  /** Company or organization the lead is associated with. */
  companyName: Maybe<Scalars['String']>;
  /** Free-text description or notes about the lead. */
  description: Maybe<Scalars['String']>;
  /** CRM-native identifier for the lead. */
  leadId: Scalars['String'];
  /** Full name of the lead contact. */
  name: Scalars['String'];
};

/** Paginated response for listing CRM opportunities. */
export type ApiDeckOpportunitiesResponse = {
  __typename: 'ApiDeckOpportunitiesResponse';
  /** Opaque cursor for fetching the next page of results. Null when no more pages remain. */
  nextCursor: Maybe<Scalars['String']>;
  /** The list of opportunities for the current page. */
  opportunities: Array<ApiDeckOpportunity>;
};

/** A sales opportunity record retrieved from a connected CRM. */
export type ApiDeckOpportunity = {
  __typename: 'ApiDeckOpportunity';
  /** CRM-native identifier for the opportunity. */
  id: Scalars['String'];
  /** Tags or labels assigned to this opportunity in the CRM. */
  tags: Maybe<Array<Scalars['String']>>;
  /** Display title or name of the opportunity. */
  title: Maybe<Scalars['String']>;
  /** CRM-defined opportunity type (e.g., 'New Business', 'Renewal'). */
  type: Maybe<Scalars['String']>;
};

/** A CRM opportunity enriched with integration-mapped field data for use in Aline workflows. */
export type ApiDeckOpportunityWithRelations = {
  __typename: 'ApiDeckOpportunityWithRelations';
  /** Opportunity fields mapped to Aline's integration field format for use in workflows. */
  fields: Array<IntegrationField>;
  /** CRM-native identifier for the opportunity. */
  id: Scalars['String'];
  /** Tags or labels assigned to this opportunity in the CRM. */
  tags: Maybe<Array<Scalars['String']>>;
  /** Display title or name of the opportunity. */
  title: Maybe<Scalars['String']>;
  /** CRM-defined opportunity type (e.g., 'New Business', 'Renewal'). */
  type: Maybe<Scalars['String']>;
};

/** A short-lived session for the ApiDeck Vault UI, used to let users configure connections. */
export type ApiDeckSession = {
  __typename: 'ApiDeckSession';
  /** ISO timestamp when this session token expires. */
  expiresAt: Scalars['DateTime'];
  /** Bearer token for authenticating with the ApiDeck Vault session. */
  sessionToken: Scalars['String'];
};

/**
 * Apideck unified API a Vault session is scoped to, so a session opened for one
 * API cannot surface the other's connectors.
 */
export enum ApiDeckUnifiedApi {
  /** CRM connectors. */
  Crm = 'Crm',
  /** File storage connectors. */
  FileStorage = 'FileStorage'
}

/**
 * An API key used for programmatic access to the GraphQL API.
 *
 * HTTP: send Authorization Bearer header on POST /graphql.
 * WebSocket subscriptions: connect to /subscriptions and pass extensions.auth with
 * __typename ApiKeyBearerToken and the raw key token on each subscribe message.
 * Read scopes gate which subscription fields are allowed; effective data visibility still follows the
 * org-admin impersonation model below.
 *
 * Authentication model:
 * - Each request is authorized by the key's permission scopes (which operations may be called).
 * - The request also runs as the organization's oldest active admin user (oldest by createdAt). Resource-level
 *   checks (documents, workflows, reports, etc.) use that admin's org access—not a separate least-privilege principal.
 * - Example: a key with only documents:read may return any document that admin can read, which is often
 *   broader than a single end user's repository.
 *
 * Limits: query depth 20; rate limit 2500 requests/minute per key.
 */
export type ApiKey = {
  __typename: 'ApiKey';
  /** When this key was created (ISO 8601) */
  createdAt: Scalars['DateTime'];
  /** Unique identifier for this API key */
  id: Scalars['String'];
  /** When this key was last used to authenticate a request; null if never used */
  lastUsedAt: Maybe<Scalars['DateTime']>;
  /** Human-readable name to identify this key */
  name: Scalars['String'];
  /** Masked version of the key value (e.g., 'sk_test_****abcd') for display purposes */
  obfuscatedValue: Scalars['String'];
  /** Permission scopes granted to this key */
  permissions: Array<Scalars['String']>;
};

/** CRM opportunity to link when launching a workflow. */
export type ApideckOpportunityInput = {
  /** Which CRM integration this opportunity belongs to. */
  integration: Integration;
  /** External opportunity identifier from the CRM. */
  opportunityId: Scalars['String'];
};

/** Application version information for client-server compatibility checks */
export type AppVersion = {
  __typename: 'AppVersion';
  /** Build timestamp or release date */
  buildDate: Scalars['String'];
  /** Client application version (from package.json) */
  version: Scalars['String'];
};

/**
 * Apply a signed PDF onto a Sign-outside workflow document from an upload
 * or a standalone repository document (exactly one of props / sourceDocumentId).
 */
export type ApplySignedVersionOutsideAlineInput = {
  /** Workflow document that receives the signed version */
  documentId: Scalars['UUID'];
  /** Uploaded PDF. Mutually exclusive with sourceDocumentId. */
  props?: InputMaybe<FileVersionProps>;
  /** Standalone repository PDF to copy then soft-delete. Mutually exclusive with props. */
  sourceDocumentId?: InputMaybe<Scalars['UUID']>;
  /** Workflow being signed outside Aline */
  workflowId: Scalars['UUID'];
};

/** Input for approving a task. */
export type ApproveTaskInput = {
  /** Optional comment, posted to the feed. */
  comment?: InputMaybe<Scalars['String']>;
  taskId: Scalars['UUID'];
};

/**
 * Streamed event fired when a drafter or editor node finishes and persists
 * its writer artifact. Carries the artifact as flat primitive fields so
 * the codegen mapper for Document doesn't propagate into the subscription
 * union (which makes the resolver's expected variant non-assignable to
 * what we publish). The client reconstructs the ThreadArtifact shape from
 * these primitives and patches AgentThread.artifacts via cache.modify.
 */
export type ArtifactCreatedEvent = {
  __typename: 'ArtifactCreatedEvent';
  /** ID of the message that owns the join row (assistant for drafted/edited) */
  agentMessageId: Scalars['UUID'];
  /** When the join row was created — used for the bar's relative timestamps */
  artifactCreatedAt: Scalars['DateTime'];
  /** Soft-delete timestamp on the linked document, if any */
  documentDeletedAt: Maybe<Scalars['DateTime']>;
  /** ID of the linked document */
  documentId: Scalars['UUID'];
  /** Display name of the linked document */
  documentName: Scalars['String'];
  /** All roles this artifact link carries — matches AgentMessageJoinKind enum */
  kindList: Array<AgentMessageJoinKind>;
  /** ID of the assistant message that owns the new artifact */
  messageId: Scalars['UUID'];
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** ID of the user who initiated the agent prompt */
  userId: Scalars['UUID'];
};

/** Entities that can be assigned to a workflow collaborator (variables, signature fields, or permissions). DocumentAssignees and DocumentFollowers are excluded as they lack GraphQL entities. */
export type Assignable = DocumentVariable | SignatureField | WorkflowPermission;

/** Input for assigning a user as an assignee (e.g. on a task or workflow) */
export type AssigneeProps = {
  /** ID of the user to assign */
  assigneeId: Scalars['String'];
};

/** Streamed event containing an assistant message chunk or completion */
export type AssistantMessageEvent = {
  __typename: 'AssistantMessageEvent';
  /** The streaming message payload */
  message: StreamingAgentMessage;
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** ID of the user who initiated the agent prompt */
  userId: Scalars['UUID'];
};

/** Input for attaching an intake form template to a TEMPLATE workflow. */
export type AttachIntakeFormTemplateInput = {
  /** The intake form template to attach. */
  intakeFormTemplateId: Scalars['UUID'];
  /** When true, atomically replace any template already attached to the workflow (the 'link a different template' flow) instead of failing. Defaults to a strict attach that errors when one is already attached. */
  replaceExisting?: InputMaybe<Scalars['Boolean']>;
  /** The template workflow to attach to. */
  workflowId: Scalars['UUID'];
};

/** Saves the author's edits to the skill's draft. Never publishes. */
export type AutoSaveAgentSkillDraftInput = {
  attachmentRenames?: InputMaybe<Array<SkillAttachmentRenameInput>>;
  /** The whole SKILL.md, frontmatter included. */
  content: Scalars['String'];
  documentSnapshots?: InputMaybe<Array<SkillDocumentSnapshotInput>>;
  /** The draft revision the edit was made on. */
  expectedRevision: Scalars['Int'];
  id: Scalars['UUID'];
  pdfAttachments?: InputMaybe<Array<SkillPdfAttachmentInput>>;
  retainedAttachmentPaths?: InputMaybe<Array<Scalars['String']>>;
  textFiles?: InputMaybe<Array<SkillTextFileInput>>;
};

/** A kanban-style board that organizes workflows into columns. Each organization can have multiple boards. */
export type Board = {
  __typename: 'Board';
  /** Hex color code used for the board's visual theme */
  color: Scalars['String'];
  /** Ordered list of columns (stages) on this board */
  columns: Array<Column>;
  /** Timestamp when the board was created */
  createdAt: Scalars['DateTime'];
  /** Icon identifier used for the board's visual representation */
  icon: Scalars['String'];
  /** Unique identifier for the board */
  id: Scalars['UUID'];
  /** Display name of the board */
  name: Scalars['String'];
  /** Organization that owns this board */
  org: Org;
  /** Optional Signing singleton column for e-sign phases */
  signingColumn: Maybe<Column>;
  triageColumn: Maybe<Column>;
  /** Timestamp when the board was last updated */
  updatedAt: Scalars['DateTime'];
};

export type BulkCreateDocumentRelationshipItem = {
  childDocumentId: Scalars['UUID'];
  childRelationshipType: ChildRelationshipType;
  parentDocumentId: Scalars['UUID'];
};

/** Input for creating folder sync jobs across one or more drives in a single operation. */
export type BulkCreateFolderSyncJobInput = {
  /** List of drives and their folders to sync or unsync. */
  driveSyncs: Array<DriveSyncInput>;
  /** The cloud storage provider to sync from. */
  integration: FileStorageIntegration;
};

/** Result of a bulk folder sync job creation, including any jobs that were replaced. */
export type BulkCreateFolderSyncJobResult = {
  __typename: 'BulkCreateFolderSyncJobResult';
  /** Newly created folder sync jobs. */
  createdJobs: Array<FolderSyncJob>;
  /** IDs of previously existing jobs that were replaced by the new ones. */
  deletedFolderSyncJobIds: Array<Scalars['UUID']>;
};

/** Input for deleting multiple parties at once. */
export type BulkDeletePartiesInput = {
  /** IDs of the parties to delete. */
  partyIds: Array<Scalars['UUID']>;
};

export type BulkDocumentActionResponse = {
  __typename: 'BulkDocumentActionResponse';
  /** Non-trashed documents that lost relationship children to this trash (disableDocuments only; null elsewhere). Drives the relationship-grid surgical update. */
  affectedRelationshipParents: Maybe<Array<AffectedRelationshipParent>>;
  /** IDs of documents that were successfully processed */
  documentIds: Array<Scalars['UUID']>;
  /** Number of documents skipped (e.g., part of active workflow, unauthorized) */
  numSkipped: Scalars['Int'];
  /** Document IDs that were not processed (same count as numSkipped when lists are complete) */
  skippedDocumentIds: Array<Scalars['UUID']>;
};

export type BulkExport = {
  __typename: 'BulkExport';
  createdAt: Scalars['DateTime'];
  documentCount: Scalars['Int'];
  /**
   * Pre-signed download URL for the (first) export ZIP. Null until COMPLETED.
   * Clients should prefer BulkExport.parts for the full list when the export
   * was split into multiple ZIPs.
   */
  downloadUrl: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  expiresAt: Maybe<Scalars['DateTime']>;
  fileSizeBytes: Maybe<Scalars['BigInt']>;
  format: BulkExportFormat;
  id: Scalars['UUID'];
  orgId: Scalars['UUID'];
  /**
   * Documents the ZIP step has finished with (written into the ZIP or skipped).
   * Counts up to documentCount after processedCount gets there, while the ZIP
   * is being built.
   */
  packagedCount: Scalars['Int'];
  /**
   * All ZIP artifacts for this export, each with its own pre-signed URL.
   * Empty until the export reaches COMPLETED. Single-part exports return one
   * element; split exports return one per ZIP.
   */
  parts: Array<BulkExportPart>;
  processedCount: Scalars['Int'];
  /** Number of documents that were skipped (render failure, missing source). */
  skippedCount: Scalars['Int'];
  /** Detail on each skipped document. Empty when skippedCount is 0. */
  skippedDocuments: Array<BulkExportSkippedDocument>;
  status: BulkExportStatus;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['UUID'];
};

export enum BulkExportFormat {
  Original = 'ORIGINAL',
  Pdf = 'PDF'
}

/**
 * A single ZIP artifact within a bulk export. Most exports return one part;
 * exports above ~10GB are split across multiple parts so each download stays
 * manageable. Use BulkExport.parts to enumerate all parts.
 */
export type BulkExportPart = {
  __typename: 'BulkExportPart';
  downloadUrl: Scalars['String'];
  partNumber: Scalars['Int'];
  sizeBytes: Scalars['BigInt'];
};

/**
 * A document that the export pipeline could not include in the ZIP. The export
 * still completes; we surface these so the user knows exactly what is missing
 * and why (e.g. render failure, source file missing in S3).
 */
export type BulkExportSkippedDocument = {
  __typename: 'BulkExportSkippedDocument';
  documentId: Scalars['UUID'];
  entryName: Scalars['String'];
  reason: Scalars['String'];
};

export enum BulkExportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type BulkLockExtractionJobsInput = {
  extractionJobIds?: InputMaybe<Array<Scalars['UUID']>>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  isLocked: Scalars['Boolean'];
  questionId?: InputMaybe<Scalars['UUID']>;
  reportId?: InputMaybe<Scalars['UUID']>;
  rowStatus?: InputMaybe<Array<RowStatus>>;
  runAllJobs?: InputMaybe<Scalars['Boolean']>;
  /** When set, the mutation only returns ExtractionJobs whose document is in this list. The DB update itself still covers every authorized job — this just trims the response so a column-wide lock doesn't ship thousands of entities back to a client that only has a virtualized slice on screen. */
  visibleDocumentIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type BulkRelationshipTarget = {
  /** The ID of a document (to resolve its unconfirmed child relationships) or a relationship ID */
  id: Scalars['UUID'];
  /** Whether this ID refers to a root document or a specific relationship */
  type: BulkRelationshipTargetType;
};

/** Whether a bulk relationship target refers to a root document or a specific relationship */
export enum BulkRelationshipTargetType {
  /** Target is a document ID — the server resolves its unconfirmed child relationships */
  Document = 'DOCUMENT',
  /** Target is a relationship ID — used directly */
  Relationship = 'RELATIONSHIP'
}

export type BulkReviewRelationshipsInput = {
  /** When true with runAll, targets orphan relationships (missing matches) instead of unconfirmed ones */
  missingMatchesOnly?: InputMaybe<Scalars['Boolean']>;
  /** Required when runAll is true — scopes the operation to a specific report */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** When true, accept/reject ALL unconfirmed relationships in the report (ignores targets) */
  runAll?: InputMaybe<Scalars['Boolean']>;
  /** Explicit targets to accept/reject */
  targets: Array<BulkRelationshipTarget>;
};

export type BulkReviewRelationshipsResponse = {
  __typename: 'BulkReviewRelationshipsResponse';
  /** Number of relationships skipped (already reviewed, unauthorized, etc.) */
  skippedCount: Scalars['Int'];
  /** The relationships that were updated */
  updatedRelationships: Array<DocumentRelationship>;
};

/** Input for bulk-adding and removing labels across multiple documents */
export type BulkSetDocumentLabelsInput = {
  /** Documents to modify; ignored when runAllDocs is true */
  documentIds: Array<Scalars['UUID']>;
  /** AG Grid filter model to select documents server-side when runAllDocs is true */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** Per-group select-all: restrict the action to documents in this group path. */
  groupSelection?: InputMaybe<GroupSelectionInput>;
  /** Labels to apply to the target documents */
  labelIdsToAdd: Array<Scalars['UUID']>;
  /** Labels to remove from the target documents */
  labelIdsToRemove: Array<Scalars['UUID']>;
  /** Scope to a specific report's document set */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** When true, applies to all documents matching the filter instead of the explicit documentIds */
  runAllDocs?: InputMaybe<Scalars['Boolean']>;
};

/** Category of CRM data being accessed through an integration. */
export enum CrmIntegrationCategory {
  /** Company or account records in the CRM. */
  Company = 'Company',
  /** Lead records representing prospective contacts. */
  Lead = 'Lead',
  /** Sales opportunity or deal records. */
  Opportunity = 'Opportunity',
  /** CRM user who owns records (e.g., account executive). */
  Owner = 'Owner'
}

/** CSRF token used to verify OAuth and third-party integration callbacks */
export type CsrfToken = {
  __typename: 'CSRFToken';
  /** Account that requested this token */
  accountId: Scalars['UUID'];
  /** When this token expires and can no longer be verified */
  expiresAt: Scalars['DateTime'];
  /** Unique identifier for this token record */
  id: Scalars['UUID'];
  /** Opaque token value sent as the OAuth state parameter and verified on callback */
  token: Scalars['UUID'];
};

/** An auto-populated field placed in a workflow, shared across its documents. */
export type CannedField = {
  __typename: 'CannedField';
  /** Assigned recipient. */
  assignee: Maybe<WorkflowRecipient>;
  /** Workflow recipient this field is assigned to. */
  assigneeId: Maybe<Scalars['UUID']>;
  /** When this canned field was created. */
  createdAt: Scalars['DateTime'];
  /**
   * Placeholder default computed on the fly from the assignee's profile
   * (or 'today' for DateSigned). Null when nothing sensible is available.
   * Not persisted — recomputed at read time.
   */
  defaultValue: Maybe<Scalars['String']>;
  /** When this canned field was soft-deleted; null if active. */
  deletedAt: Maybe<Scalars['DateTime']>;
  /**
   * Server-issued primary key. Stable within a workflow but re-issued on
   * template launch — clients that link to Slate/PDF should use nodeId
   * instead.
   */
  id: Scalars['UUID'];
  /**
   * Stable identity shared with Slate JSON and PDF customData. Preserved
   * when a template is launched into a workflow instance, so document
   * references keep resolving without a rewrite.
   */
  nodeId: Scalars['UUID'];
  /** Persisted document placements retained after signing and PDF flattening. */
  placements: Array<CannedFieldPlacement>;
  /** When this canned field was last modified. */
  updatedAt: Scalars['DateTime'];
  /**
   * Persisted value. Null until either the recipient enters something or
   * the server materializes the default at finish-signing.
   */
  value: Maybe<Scalars['String']>;
  /** Variant — determines label, tooltip, and how defaultValue is computed. */
  variant: CannedFieldVariant;
  /** Parent workflow. */
  workflow: Workflow;
  /** Which workflow this canned field belongs to. */
  workflowId: Scalars['UUID'];
};

/** A persisted document membership record for a canned field. */
export type CannedFieldPlacement = {
  __typename: 'CannedFieldPlacement';
  /** Canned field represented by this placement. */
  cannedFieldId: Scalars['UUID'];
  /** Document containing one or more occurrences of the canned field. */
  documentId: Scalars['UUID'];
  /** Unique identifier. */
  id: Scalars['UUID'];
};

/** Wrapper returned by canned field mutations. */
export type CannedFieldResponse = {
  __typename: 'CannedFieldResponse';
  /** The created or updated canned field. */
  cannedField: CannedField;
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
};

/**
 * Auto-populated fields whose value comes from the signer profile or the signing
 * ceremony itself (name, email, title, address, date signed). Scoped to a
 * Workflow so the same 'Email' for a given recipient shares one value across
 * every document in the workflow.
 */
export enum CannedFieldVariant {
  /** Signer's address. No auto-populated default — filled by the recipient. */
  Address = 'Address',
  /**
   * Signer's company — sourced from their org.name (the workspace they
   * onboarded into). Editable per contract; not back-written to the org.
   */
  Company = 'Company',
  /** Date the recipient completed signing. Materialized at signature time. */
  DateSigned = 'DateSigned',
  /** Signer's email address. */
  UserEmail = 'UserEmail',
  /** Name the signer writes in the document. Stored on User.signingName. */
  UserName = 'UserName',
  /** Signer's job title (from User.jobTitle). */
  UserTitle = 'UserTitle'
}

/** Input for reassigning a workflow collaborator to a different user, role, or external email. */
export type ChangeCollaboratorAssignmentInput = {
  /** New role to assign. Mutually exclusive with assignedUserId and email. */
  assignedRoleId?: InputMaybe<Scalars['UUID']>;
  /** New internal user to assign. Mutually exclusive with assignedRoleId and email. */
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  /** Email for an external user assignment. Mutually exclusive with assignedUserId. */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** The permission entry to reassign. */
  permissionId: Scalars['UUID'];
};

/** Input for changing the contract type of one or more documents. */
export type ChangeDocumentsTypeInput = {
  /** IDs of the documents to update. Ignored when runAllDocs is true. */
  documentIds: Array<Scalars['UUID']>;
  /** AG Grid filter model to scope which documents are affected when runAllDocs is true. */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** Per-group select-all: restrict the action to documents in this group path. */
  groupSelection?: InputMaybe<GroupSelectionInput>;
  /** Report ID whose saved filters determine the document set when runAllDocs is true. */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** When true, apply the change to all documents matching the report/filter instead of documentIds. */
  runAllDocs?: InputMaybe<Scalars['Boolean']>;
  /** New contract type ID to assign, or null to clear the type. */
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for changing a recipient's action type. */
export type ChangeRecipientActionInput = {
  /** New action type (signer or carbon copy). */
  action: WorkflowRecipientType;
  /** The action to reassign to. */
  actionId: Scalars['UUID'];
  /** The recipient to change. */
  recipientId: Scalars['UUID'];
};

/** Input for reassigning a recipient action to a different collaborator. */
export type ChangeRecipientAssignmentInput = {
  /** The workflow permission of the new collaborator. */
  permissionId: Scalars['UUID'];
  /** The recipient action to reassign. */
  recipientId: Scalars['UUID'];
};

/** Input for toggling a task's completion state. */
export type ChangeTaskStatusProps = {
  /** Optional comment posted with an assignee's completion. */
  comment?: InputMaybe<Scalars['String']>;
  /** Allow completing this task to return the workflow to its active phase's home column when it is parked in a Paused or Cancelled column. */
  confirmUnpark?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to mark complete, false to revert to incomplete. */
  isCompleted: Scalars['Boolean'];
  /** When reopening a completed task, clear everyone's decisions and start a new round. Otherwise only the requester's own decision is cleared. */
  startNewRound?: InputMaybe<Scalars['Boolean']>;
  /** ID of the task to update. */
  taskId: Scalars['UUID'];
};

/**
 * Workspace-level install record binding an external account (Slack team,
 * Resend domain, Teams tenant) to an org. One row per
 * (provider, externalAccountId) — paranoid; soft-deletion is the disconnect
 * path. Tokens are not surfaced here — the chat-sdk stores them encrypted in
 * its own state store.
 */
export type ChannelInstallation = {
  __typename: 'ChannelInstallation';
  /**
   * Deep link that opens this workspace's Aline app install prompt in the Teams
   * client. Null unless the install is still awaiting the provider, and null when
   * the tenant has not added the Aline app package to its own catalog — no link
   * can resolve until it does, so the UI explains the upload instead.
   */
  appInstallUrl: Maybe<Scalars['String']>;
  /** Row creation time. */
  createdAt: Scalars['DateTime'];
  /** Human-readable label — Slack workspace name, sender domain, or Teams tenant. May be null. */
  displayName: Maybe<Scalars['String']>;
  /** Provider-native workspace/account identifier (Slack team_id, sender domain, …). */
  externalAccountId: Scalars['String'];
  /** Install row ID. */
  id: Scalars['UUID'];
  /** First install or latest reinstall time. */
  installedAt: Maybe<Scalars['DateTime']>;
  /** User who completed the install. Null if they were since deactivated. */
  installedBy: Maybe<User>;
  /** Owning Aline org. */
  orgId: Scalars['UUID'];
  /** Provider this install belongs to. */
  provider: ChannelProvider;
  /**
   * True when this Slack or Teams install must reauthorize to pick up newer
   * permissions (Slack bot scopes, Teams Graph application permissions) or to
   * apply a newer integration version. Always false for providers with no
   * required grant or version update.
   */
  requiresReauthorization: Scalars['Boolean'];
  /** Whether the provider has confirmed the app is actually installed. */
  status: ChannelInstallationStatus;
};

/** How far along a channel install is. */
export enum ChannelInstallationStatus {
  /** Linked to this org but not yet usable — the provider has not confirmed it. */
  ActionNeeded = 'ActionNeeded',
  /** The provider has confirmed the app is present; the assistant works. */
  Connected = 'Connected'
}

/** Channel providers the assistant accepts inbound messages from. */
export enum ChannelProvider {
  /** Resend email sender domain. */
  Resend = 'Resend',
  /** Slack workspace install. */
  Slack = 'Slack',
  /** Microsoft Teams tenant workspace install. */
  Teams = 'Teams'
}

/**
 * An external channel conversation (a Slack thread today) linked to a Task or Workflow activity
 * timeline. Replies posted in Aline post back to the thread; new messages in the thread mirror into
 * the feed. Surfaced via the channelThread field on the SLACK-sourced anchor comment item.
 */
export type ChannelThread = {
  __typename: 'ChannelThread';
  /** Provider-native channel identifier (Slack channel id). */
  externalChannelId: Scalars['String'];
  /** Provider-native thread identifier (Slack thread root timestamp). */
  externalThreadId: Scalars['String'];
  /** Channel thread row ID. */
  id: Scalars['UUID'];
  /** Provider this thread belongs to. */
  provider: ChannelProvider;
  /** Deep link to open the thread in the provider (Slack web client). Null when not derivable. */
  webUrl: Maybe<Scalars['String']>;
};

/** Pricing estimate for a checkout configuration */
export type CheckoutEstimate = {
  __typename: 'CheckoutEstimate';
  /** Total cost for all basic seats in dollars */
  basicSeatTotal: Scalars['Float'];
  /** Unit cost per basic seat in dollars */
  basicSeatUnitCost: Scalars['Float'];
  /** Total cost for all full seats in dollars */
  fullSeatTotal: Scalars['Float'];
  /** Unit cost per full seat in dollars */
  fullSeatUnitCost: Scalars['Float'];
  /** Grand total including all seats, taxes, and discounts in dollars */
  total: Scalars['Float'];
};

/** Relationship types between parent and child documents */
export enum ChildRelationshipType {
  /** Modifies terms of the parent document. */
  Amendment = 'AMENDMENT',
  /** Additional material attached to the parent. */
  Appendix = 'APPENDIX',
  /** Transfers rights or obligations from the parent to another party. */
  Assignment = 'ASSIGNMENT',
  /** Fixes errors in the parent document. */
  Correction = 'CORRECTION',
  /** Supporting evidence or referenced material for the parent. */
  Exhibit = 'EXHIBIT',
  /** Extends the term or duration of the parent agreement. */
  Extension = 'EXTENSION',
  /** Imposes parent obligations on subcontracted parties. */
  Flowdown = 'FLOWDOWN',
  /** The child document states it is governed by, subject to, or entered into under the parent agreement. */
  GovernedBy = 'GOVERNED_BY',
  /** References or includes the parent document by reference. */
  Incorporation = 'INCORPORATION',
  /** References or cites the parent document. */
  Mention = 'MENTION',
  /** Replaces a party in the parent agreement with a new party. */
  Novation = 'NOVATION',
  /** General relationship with no specific legal category. */
  Related = 'RELATED',
  /** Renews the parent agreement for a new term. */
  Renewal = 'RENEWAL',
  /** Detailed specifications supplementing the parent. */
  Schedule = 'SCHEDULE',
  /** Replaces the parent document entirely. */
  Supersede = 'SUPERSEDE',
  /** Adds additional terms to the parent agreement. */
  Supplement = 'SUPPLEMENT',
  /** The child terminates the parent agreement: a notice of termination, termination letter, or termination agreement. */
  Termination = 'TERMINATION'
}

/** Whether the child of a relationship is a document or a URL */
export enum ChildType {
  /** Child is an Aline document stored in the repository. */
  Document = 'DOCUMENT',
  /** Child is an external URL reference (not a managed document). */
  Url = 'URL'
}

/** Identifies one rule job whose resolution is being cleared. */
export type ClearPlaybookRuleJobResolutionInput = {
  /** ID of the rule job whose resolution is being cleared. */
  id: Scalars['UUID'];
};

/** A stage (kanban column) within a board. Workflows are organized into columns to track progress. */
export type Column = {
  __typename: 'Column';
  /** Board this column belongs to */
  board: Board;
  /** High-level status category this column represents */
  category: ColumnCategory;
  /** Hex or named color used to visually distinguish this column on the board */
  color: Scalars['String'];
  /** Timestamp when the column was created */
  createdAt: Scalars['DateTime'];
  /** Unique identifier for the column */
  id: Scalars['UUID'];
  /** Display name of the column */
  name: Scalars['String'];
  /** Opaque fractional index used for display ordering within the board */
  sortKey: Scalars['String'];
  /** Timestamp when the column was last updated */
  updatedAt: Scalars['DateTime'];
  /** Contract workflows currently in this column. Templates are never board cards, so they are excluded. */
  workflows: Array<Workflow>;
};

/** High-level classification for a column, used to derive board-wide workflow status metrics */
export enum ColumnCategory {
  /** Workflows that have been cancelled and will not proceed */
  Cancelled = 'Cancelled',
  /** Workflows that have been completed */
  Done = 'Done',
  /** Workflows that have not been started yet */
  NotStarted = 'NotStarted',
  /** Workflows that are temporarily on hold */
  Paused = 'Paused',
  /** Workflows that are actively in progress */
  Started = 'Started',
  /** Workflows needing initial review or categorization */
  Triage = 'Triage'
}

/** A user's comment */
export type Comment = {
  __typename: 'Comment';
  /** Author of the comment */
  author: Maybe<User>;
  /** The document, task, or workflow this comment is attached to */
  commentable: Commentable;
  /** Whether this comment is on a Document, Task, or Workflow */
  commentableType: CommentableType;
  /** When the comment was created */
  createdAt: Scalars['DateTime'];
  /** When the comment was soft-deleted */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this comment */
  id: Scalars['UUID'];
  /** Author name for imported comments (e.g., coming from MS Word) */
  importedAuthorName: Maybe<Scalars['String']>;
  /** Whether this comment thread is visible only to users in the document owner organization. Only document comments can be private. For replies, this resolves from the root comment. */
  isPrivate: Scalars['Boolean'];
  /** An id that is carried on textNode.comments array.  Optional as replies and task comments don't have an id attached to textNode.comments. */
  nodeRefId: Maybe<Scalars['UUID']>;
  /** Parent comment (e.g., if its a reply) */
  parent: Maybe<Comment>;
  /** List of replies to this comment */
  replies: Array<Comment>;
  /** Whether comment is resolved */
  resolved: Scalars['Boolean'];
  /** Comment text body (Markdown) */
  text: Scalars['String'];
  /** When the comment was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Body of a COMMENT activity entry */
export type CommentActivity = {
  __typename: 'CommentActivity';
  /** The user comment posted to the task/workflow; null if it was deleted after the row was read */
  comment: Maybe<Comment>;
};

/** Response to comment mutations */
export type CommentResponse = {
  __typename: 'CommentResponse';
  /** Mutated comment */
  comment: Maybe<Comment>;
  refetch: Query;
};

/** Filter to look up a single comment */
export type CommentWhereInput = {
  /** ID of the comment to retrieve */
  id: Scalars['UUID'];
};

/** A thing that users can comment on */
export type Commentable = Document | Task | Workflow;

/** The type of the commentable linked to a comment */
export enum CommentableType {
  /** Comment on a document, anchored to specific text via nodeRefId */
  Document = 'Document',
  /** Comment on a task within a workflow */
  Task = 'Task',
  /** Comment on a workflow */
  Workflow = 'Workflow'
}

/** Response wrapping multiple comments after a bulk mutation */
export type CommentsResponse = {
  __typename: 'CommentsResponse';
  /** Mutated comments */
  comments: Array<Comment>;
  refetch: Query;
};

/** Filter to look up all comments on a specific commentable */
export type CommentsWhereInput = {
  /** ID of the document, task, or workflow to fetch comments for */
  commentableId: Scalars['UUID'];
  /** Whether the target is a Document, Task, or Workflow */
  commentableType: CommentableType;
};

/** A browsable category that organizes community-shared templates and workflows (e.g. Sales, HR, Finance) */
export type CommunityCategory = {
  __typename: 'CommunityCategory';
  /** When the community category was created */
  createdAt: Scalars['DateTime'];
  /** Human-readable explanation of what this category contains */
  description: Scalars['String'];
  /** Community templates filed under this category */
  documents: Array<Document>;
  /** Emoji icon displayed alongside the category title in the UI */
  emoji: Scalars['String'];
  /** Unique identifier */
  id: Scalars['UUID'];
  /** Nested child categories for finer-grained organization */
  subcategories: Array<CommunityCategory>;
  /** Display name shown in the community browser */
  title: Scalars['String'];
  /** When the community category was last updated */
  updatedAt: Scalars['DateTime'];
  /** Community workflows filed under this category */
  workflows: Array<Workflow>;
};

/** Input for completing a task on an assignee's behalf. */
export type CompleteTaskForAssigneeInput = {
  /** The assignee's workflow permission. */
  permissionId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** A completed AI text generation result stored for a document. */
export type Completion = {
  __typename: 'Completion';
  /** The completion type given for the completion. */
  completionType: AiCompletionType;
  /** Unique identifier for this completion. */
  id: Scalars['UUID'];
  /** The prompt given for this completion. */
  prompt: Scalars['String'];
  /** The text the user selected when generating the completion. */
  selectedText: Scalars['String'];
  /** The text that GPT generated. */
  text: Scalars['String'];
};

/** Real-time event emitted as AI-generated text streams for a document completion. */
export type CompletionEvent = {
  __typename: 'CompletionEvent';
  /** The completion data for this event. */
  completion: Completion;
  /** The document this completion is being generated for. */
  documentId: Scalars['UUID'];
  /** Whether this is a mid-stream chunk or the final result. */
  position: CompletionPosition;
  /** The user who initiated the completion request. */
  userId: Scalars['UUID'];
};

/** Input representation of a completion, used when passing prior completions for retry context. */
export type CompletionInput = {
  /** The type of AI operation to perform. */
  completionType: AiCompletionType;
  /** Unique identifier for the completion. */
  id: Scalars['UUID'];
  /** The user-provided or system-generated prompt. */
  prompt: Scalars['String'];
  /** The document text the user selected for the completion. */
  selectedText: Scalars['String'];
  /** The AI-generated output text. */
  text: Scalars['String'];
};

/** Position indicator for streamed AI completion responses. */
export enum CompletionPosition {
  /** The final chunk, signaling the completion is finished. */
  End = 'End',
  /** An intermediate chunk in the response stream. */
  Stream = 'Stream'
}

/** Acknowledgement that an AI completion request was accepted for processing. */
export type CompletionResponse = {
  __typename: 'CompletionResponse';
  /** True if the completion request was successfully queued for generation. */
  succeeded: Scalars['Boolean'];
};

/** Input for linking an existing variable config to a new document variable. */
export type ConnectConfigInput = {
  /** ID of the existing variable config to link. */
  configId: Scalars['UUID'];
};

/** Input for linking an existing user to an organization with a specific role */
export type ConnectOrgUser = {
  /** Role to assign within the organization */
  role: OrgRole;
  /** ID of the user to connect */
  userId: Scalars['UUID'];
};

/** Pagination metadata for a page of connection folder files. */
export type ConnectionFolderFilesMeta = {
  __typename: 'ConnectionFolderFilesMeta';
  /** Whether more children exist beyond this page. */
  hasMore: Scalars['Boolean'];
  /** Cursor to pass on the next request; null when there are no more pages. */
  nextCursor: Maybe<Scalars['String']>;
};

/** One page of files/folders within a connected storage folder. */
export type ConnectionFolderFilesPage = {
  __typename: 'ConnectionFolderFilesPage';
  /** Folder children in this page. */
  files: Array<FolderFile>;
  /** Pagination metadata for requesting additional pages. */
  meta: ConnectionFolderFilesMeta;
};

export type ContinueAgentChatInput = {
  /** ID of the assistant message the user just answered. Scopes the continuation to this message so a prior turn's answered approval is never resumed by mistake. */
  messageId: Scalars['UUID'];
  /** The explicit continuation answer (agentContinuationResponseSchema): a single approval decision, or one or more client-tool outputs. The server locates and patches the paused parts itself under the message row lock. */
  response: Scalars['JSON'];
  /** ID of the thread whose assistant message the user answered. */
  threadId: Scalars['UUID'];
};

/** A user-defined document category (e.g. NDA, MSA, Employment Agreement) used to classify and filter documents */
export type ContractType = {
  __typename: 'ContractType';
  /** When the contract type was created */
  createdAt: Scalars['DateTime'];
  /** Number of documents currently assigned to this contract type */
  documentCount: Scalars['Int'];
  /** Unique identifier */
  id: Scalars['UUID'];
  /** When the contract type was last updated */
  updatedAt: Scalars['DateTime'];
  /** Display label for this contract type */
  value: Scalars['String'];
};

/** Properties required to create a new AI reminder automation */
export type CreateAiReminderAutomationInput = {
  /** User IDs to assign to generated reminders */
  assigneeIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Initial notification schedule offsets */
  notificationOffsets?: InputMaybe<Array<NotificationOffsetInput>>;
  /** Natural language instructions for the AI analyzer */
  prompt: Scalars['String'];
  /** Report to attach this automation to */
  reportId: Scalars['UUID'];
  /** User IDs who must review generated reminders */
  reviewerIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Display name for the automation */
  title: Scalars['String'];
};

export type CreateAgentSkillInput = {
  attachmentRenames?: InputMaybe<Array<SkillAttachmentRenameInput>>;
  /** The whole SKILL.md, frontmatter included. */
  content: Scalars['String'];
  documentSnapshots?: InputMaybe<Array<SkillDocumentSnapshotInput>>;
  pdfAttachments?: InputMaybe<Array<SkillPdfAttachmentInput>>;
  /** Publish the skill right away. Otherwise it is created unpublished, with only a draft. */
  publish?: InputMaybe<Scalars['Boolean']>;
  retainedAttachmentPaths?: InputMaybe<Array<Scalars['String']>>;
  scope: AgentSkillScope;
  textFiles?: InputMaybe<Array<SkillTextFileInput>>;
};

/** Input for creating a new answer option. */
export type CreateAnswerOptionInput = {
  /** Properties for the new answer option. */
  props: CreateAnswerOptionProps;
};

/** Core properties for a new answer option. */
export type CreateAnswerOptionProps = {
  /** The answer option set to add this choice to. */
  answerOptionsId: Scalars['UUID'];
  /** Display text shown to the participant. */
  optionText: Scalars['String'];
  /** Document action triggered when this option is selected. */
  triggerAction: TriggerAction;
};

/** Input for creating a new answer option set. */
export type CreateAnswerOptionsInput = {
  /** Properties for the new answer option set. */
  props: AnswerOptionsProps;
};

/** Input for creating a new API key */
export type CreateApiKeyInput = {
  /** Human-readable name to identify this key (e.g., 'CI Pipeline', 'Salesforce Integration') */
  name: Scalars['String'];
  /**
   * Permission scopes to assign. If omitted, defaults to read-only scopes.
   * Scopes gate which GraphQL operations and subscription fields the key may use; they do not narrow
   * document/workflow visibility beyond the effective admin user described on the ApiKey type.
   * Available: account:create, account:read, account:update, account:delete, api-keys:manage,
   * chats:create, chats:read, chats:update, chats:delete, documents:create, documents:read,
   * documents:update, documents:delete, playbooks:create, playbooks:read, playbooks:update,
   * playbooks:delete, reports:create, reports:read, reports:update, reports:delete,
   * reminders:create, reminders:read, reminders:update, reminders:delete, templates:create,
   * templates:read, templates:update, templates:delete, workflows:create, workflows:read,
   * workflows:update, workflows:delete
   */
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

/** Response from creating a new API key */
export type CreateApiKeyResponse = {
  __typename: 'CreateApiKeyResponse';
  /** The created API key metadata */
  apiKey: ApiKey;
  /** The full API key value. Store securely — this is only returned once at creation time. */
  value: Scalars['String'];
};

/** Properties required to create a new board */
export type CreateBoardInput = {
  /** Hex color code for the board's theme */
  color: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  /** Icon identifier for the board */
  icon: Scalars['String'];
  /** Display name for the new board */
  name: Scalars['String'];
  useSigningColumns: Scalars['Boolean'];
};

/** Payload for placing a new canned field into a workflow. */
export type CreateCannedFieldInput = {
  /** The workflow recipient to assign this canned field to. */
  assigneeId?: InputMaybe<Scalars['UUID']>;
  /** Which document in the workflow the field is being placed into. */
  documentId: Scalars['UUID'];
  /**
   * Stable identity the client inserts into document content before calling
   * this mutation. When a canned field of this variant and assignee already
   * exists, this must be that row's nodeId; a different one is rejected.
   * Omit it to let the server issue one.
   */
  nodeId?: InputMaybe<Scalars['UUID']>;
  /** Which canned variant to insert. */
  variant: CannedFieldVariant;
  /** Which workflow to place the canned field in. */
  workflowId: Scalars['UUID'];
};

/** Configuration for generating a new subscription checkout URL */
export type CreateCheckoutUrlInput = {
  /** Billing cadence (monthly or yearly) */
  interval: SubscriptionInterval;
  /** Number of basic (limited-access) seats to purchase */
  numNewBasicSeats: Scalars['Int'];
  /** Number of full (unrestricted-access) seats to purchase */
  numNewFullSeats: Scalars['Int'];
  /** Plan tier to subscribe to */
  tier: SubscriptionTier;
};

/** Properties required to create a new column */
export type CreateColumnInput = {
  /** Board to add this column to */
  boardId: Scalars['UUID'];
  /** Status category this column represents */
  category: ColumnCategory;
  /** Optional. If not provided, server uses category default. */
  color?: InputMaybe<Scalars['String']>;
  /** Display name for the column */
  name: Scalars['String'];
};

/** Wrapper input for creating a community category */
export type CreateCommunityCategoryInput = {
  /** Properties for the new category */
  props: CreateCommunityCategoryProps;
};

/** Fields required to create a new community category */
export type CreateCommunityCategoryProps = {
  /** Human-readable explanation of what this category contains */
  description: Scalars['String'];
  /** Emoji icon displayed alongside the category title */
  emoji: Scalars['String'];
  /** Display name for the category */
  title: Scalars['String'];
};

/** Fields required to create a new contract type */
export type CreateContractTypeProps = {
  /** Display label (e.g. 'NDA', 'Master Services Agreement') */
  value: Scalars['String'];
};

export type CreateDocFileLocationInput = {
  documentProps: FileLocationDocumentProps;
  fileLocationProps: FileLocationProps;
};

/** Input for creating a new document variable with optional config and answer options. */
export type CreateDocumentVariableInput = {
  /** Optional config to create or connect. */
  config?: InputMaybe<CreateOrConnectConfigInput>;
  /** Optional predefined answer options for Options/RadioOptions variants. */
  createAnswerOptions?: InputMaybe<CreateVariableAnswerOptionListInput>;
  /** The variable properties. */
  props: CreateDocumentVariableProps;
};

/** Properties for creating a new document variable. */
export type CreateDocumentVariableProps = {
  /** ID of the workflow action (recipient step) this variable is associated with. */
  actionId: Scalars['UUID'];
  /** Whether to include this field in the launch form. */
  addToLaunchForm?: InputMaybe<Scalars['Boolean']>;
  /** CRM attribute path for auto-population (e.g., 'opportunity.company.name'). */
  attributePath?: InputMaybe<Scalars['String']>;
  /** ID of the document this variable belongs to. */
  documentId: Scalars['UUID'];
  /** CRM integration to pull auto-populated values from. */
  integration?: InputMaybe<Integration>;
  /** Whether this variable is a fillable field placed in the document body. */
  isField: Scalars['Boolean'];
  /** Display label for the variable (e.g., 'Client Name'). */
  label: Scalars['String'];
  /** Checkbox variant: maximum checked answers. Omit for no maximum. */
  maxRequired?: InputMaybe<Scalars['Int']>;
  /** Checkbox variant: minimum checked answers (0 = no minimum). Defaults to 0. */
  minRequired?: InputMaybe<Scalars['Int']>;
  /** Unique identifier for this variable within the document, used in the document JSON. */
  nodeId: Scalars['UUID'];
  /** Optional prefix displayed before the value (e.g., '$'). */
  prefix?: InputMaybe<Scalars['String']>;
  /** The question prompt shown to users when filling in this variable. */
  question: Scalars['String'];
  /** Checkbox variant: selected answer option IDs. Omit or empty = all unchecked. */
  selectedAnswerIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Pre-filled value for non-options variants. */
  value?: InputMaybe<Scalars['String']>;
  /** Input type for this variable (e.g., Text, Currency, Date, Options). */
  variant: MetadataVariant;
};

/** Input for creating a new draft envelope. */
export type CreateDraftEnvelopeInput = {
  /** IDs of the documents and files to include in the envelope. */
  storableIds: Array<Scalars['UUID']>;
  /** Optional display title for the envelope (defaults to document name if omitted). */
  title?: InputMaybe<Scalars['String']>;
};

/** Input for creating a new extraction job for a document. */
export type CreateExtractionJobInput = {
  /** Properties for the new extraction job. */
  props: CreateExtractionJobProps;
  /** ID of the extraction question to run. */
  questionId: Scalars['UUID'];
  /** Pre-selected option IDs for Single/Multi select questions. */
  selectedOptionIds?: InputMaybe<Array<Scalars['UUID']>>;
};

/** Properties for creating a new extraction job. */
export type CreateExtractionJobProps = {
  /** Manual answer to record instead of running AI extraction. */
  answer?: InputMaybe<Scalars['String']>;
};

/** Input for creating a new extraction question. */
export type CreateExtractionQuestionInput = {
  /** Optional instructions to guide AI extraction. */
  aiGuidance?: InputMaybe<Scalars['String']>;
  /** Category to group this question under. */
  category: Scalars['String'];
  /** Optional contract type IDs to associate with this question. */
  contractTypeIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Extraction mode — AI-powered or Manual entry. */
  mode?: InputMaybe<ExtractionQuestionMode>;
  /** The prompt text the AI will use to extract an answer from documents. */
  questionText: Scalars['String'];
  /** Display title for the question. Auto-generated from questionText if omitted. */
  title?: InputMaybe<Scalars['String']>;
  /** Expected answer type for this question. */
  type: ExtractionQuestionType;
  /** Variant identifier — Custom for user-created, or a built-in variant. */
  variant?: InputMaybe<ExtractionQuestionVariant>;
};

/** Input for creating file location records without associated documents. */
export type CreateFileLocationsInput = {
  /** List of filestack upload results to persist. */
  records: Array<FileLocationProps>;
};

/** A single file record pairing upload location data with document metadata. */
export type CreateFileRecord = {
  /** Document properties to apply to this file. */
  documentProps: CreateFilesDocumentProps;
  /** Filestack upload result for this file. */
  fileLocationProps: FileLocationProps;
};

/** Document metadata to apply to each file in a bulk upload. */
export type CreateFilesDocumentProps = {
  /** Whether the uploaded file is already signed. */
  isSigned: Scalars['Boolean'];
  /** Whether to create a template or a concrete document. */
  variant: DocumentVariant;
};

/** Input for creating multiple documents from uploaded files in a single operation. */
export type CreateFilesInput = {
  /** Party IDs to associate with all created documents. */
  partyIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** List of file records to create. */
  records: Array<CreateFileRecord>;
};

export type CreateFilesViaLaunchConfigInput = {
  /** The enabled launch config receiving the upload. */
  launchConfigId: Scalars['UUID'];
  /** Uploaded file metadata and document properties. */
  records: Array<CreateFileRecord>;
};

/** Input for creating a new group with initial members */
export type CreateGroupInput = {
  /** Properties for the new group */
  props: CreateGroupProps;
  /** IDs of users to add as initial members */
  userIds: Array<Scalars['UUID']>;
};

/** Settable properties when creating a group */
export type CreateGroupProps = {
  /** Display name for the new group */
  name: Scalars['String'];
};

export type CreateInsightPinInput = {
  chartId: Scalars['String'];
  layout: Scalars['JSON'];
  scope?: InputMaybe<InsightScope>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  viewId: Scalars['UUID'];
};

/** Input for creating a reusable intake form template. schemaVersion is derived from formDefinition.version. */
export type CreateIntakeFormTemplateInput = {
  /** Default values for the form fields. Optional. */
  defaultValues?: InputMaybe<Scalars['JSON']>;
  /** Optional longer description. */
  description?: InputMaybe<Scalars['String']>;
  /** Structured form field definition (validated against the shared zod schema). */
  formDefinition: Scalars['JSON'];
  /** Display title. */
  title: Scalars['String'];
};

/** Input for optionally creating a new config or connecting an existing one when creating a document variable. */
export type CreateOrConnectConfigInput = {
  /** Connect an existing variable config by ID. */
  connect?: InputMaybe<ConnectConfigInput>;
  /** When true, create a new variable config from the variable's properties. */
  create?: InputMaybe<Scalars['Boolean']>;
};

/** Input for creating a new party. */
export type CreatePartyInput = {
  /** The party properties. */
  props: CreatePartyProps;
};

/** Properties for creating a new party. */
export type CreatePartyProps = {
  /** Optional description or notes about this party. */
  description?: InputMaybe<Scalars['String']>;
  /** Display name for the party. */
  name: Scalars['String'];
};

/** Fields required to create a new phase within a workflow. */
export type CreatePhaseInput = {
  /** Optional Started-category home column. Defaults via server inheritance / board signing column. */
  columnId?: InputMaybe<Scalars['UUID']>;
  /** Optional description explaining the phase's purpose. */
  description?: InputMaybe<Scalars['String']>;
  /** When true, creates a SigningPhase with ordered steps instead of a task-based NonSigningPhase. */
  isSigning?: InputMaybe<Scalars['Boolean']>;
  /** Display name for the new phase. */
  name: Scalars['String'];
  /** Explicit position in the phase sequence. Appended to the end if omitted. */
  order?: InputMaybe<Scalars['Int']>;
  /** The workflow to attach this phase to. */
  workflowId: Scalars['UUID'];
};

/** Input for creating a new playbook with optional pre-defined categorized rules. */
export type CreatePlaybookInput = {
  /** Optional list of categories with rules to seed the playbook with. */
  categories?: InputMaybe<Array<PlaybookCategoryInput>>;
  /** Core playbook properties (title, description). */
  props: CreatePlaybookProps;
};

/** Properties for creating a new playbook. */
export type CreatePlaybookProps = {
  /** Optional description for the new playbook. */
  description?: InputMaybe<Scalars['String']>;
  /** Title for the new playbook. */
  title: Scalars['String'];
};

/** Input for creating a category within a playbook. The new category is appended after the playbook's existing categories. */
export type CreatePlaybookRuleCategoryInput = {
  /** Display name for the category. */
  name: Scalars['String'];
  /** ID of the playbook to add this category to. */
  playbookId: Scalars['UUID'];
};

/** Input for creating a rule within a category. */
export type CreatePlaybookRuleInput = {
  /** ID of the category to file the rule under. */
  categoryId: Scalars['UUID'];
  /** Core rule properties. */
  props: CreatePlaybookRuleProps;
};

/** Properties for creating a new rule. */
export type CreatePlaybookRuleProps = {
  /**
   * Ordered positions for the new rule. The first entry becomes the Starting
   * Position; any others become its fallbacks. Must not be empty.
   */
  positions: Array<PlaybookRulePositionProps>;
  /** Optional short name for the rule. Omit it to create the rule unnamed. */
  title?: InputMaybe<Scalars['String']>;
};

/** Input for creating a new reminder on a document. */
export type CreateReminderInput = {
  /** The document to attach the reminder to. */
  documentId: Scalars['UUID'];
  /** Properties for the new reminder. */
  props: ReminderProps;
};

/** Input for creating a new report. */
export type CreateReportInput = {
  /** The properties for the new report. */
  reportProps: CreateReportProps;
};

/** Properties for creating a new report. */
export type CreateReportProps = {
  /** Display name of the report. */
  name: Scalars['String'];
  /** Initial DataGrid state (columns, filters, sort order) serialized as JSON. */
  state?: InputMaybe<Scalars['JSON']>;
};

/** Wrapper input for creating a signature field */
export type CreateSignatureFieldInput = {
  /** Properties for the new signature field */
  props: CreateSignatureFieldProps;
};

/** Properties required to create a new signature field */
export type CreateSignatureFieldProps = {
  /** ID of the workflow recipient (action) assigned to sign this field */
  actionId: Scalars['UUID'];
  /** ID of the document to place the signature field in */
  documentId: Scalars['UUID'];
  /** Reference ID of the node in the document JSON where this field is rendered */
  nodeRefId: Scalars['UUID'];
};

/** Input for creating a new static file version from an uploaded file */
export type CreateStaticFileVersionInput = {
  /** ID of the parent document this version belongs to */
  documentId: Scalars['UUID'];
  /** File location and metadata for the upload */
  props: FileVersionProps;
};

/** Input for creating multiple static file versions in a single operation */
export type CreateStaticFileVersionsInput = {
  /** List of static file version records to create */
  records: Array<CreateStaticFileVersionInput>;
};

/** Properties for creating a new workflow step. */
export type CreateStepProps = {
  /** Insert the new step after this step. Omit to append at the end. */
  prevStepId?: InputMaybe<Scalars['UUID']>;
  /** The workflow this step belongs to. */
  workflowId: Scalars['UUID'];
};

/** Input for creating a new workflow step and moving existing actions into it. */
export type CreateStepWithActionsInput = {
  /** IDs of actions to move into the new step. */
  actionIds: Array<Scalars['UUID']>;
  /** User to assign to the new step. Mutually exclusive with userDefinedRoleId and email. */
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  /** Email for an external user assignment. Use instead of assignedUserId for external users. */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Properties for the new step (workflow ID and optional position). */
  props: CreateStepProps;
  /** Role to assign to the new step. Mutually exclusive with assignedUserId and email. */
  userDefinedRoleId?: InputMaybe<Scalars['UUID']>;
};

/** Fields required to add a new form field to a task. */
export type CreateTaskFieldInput = {
  /** Type-specific settings such as dropdown options or file size limits. */
  config?: InputMaybe<Scalars['JSON']>;
  /** Whether the participant must fill out this field. Defaults to false. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** Prompt or question shown to the participant. */
  label: Scalars['String'];
  /** Explicit position in the field order. Appended to the end if omitted. */
  order?: InputMaybe<Scalars['Int']>;
  /** The task to attach this field to. */
  taskId: Scalars['UUID'];
  /** Input control type (text, date, file upload, etc.). */
  type: TaskFieldType;
};

/** Input for creating a task with an optional initial assignee list. */
export type CreateTaskInput = {
  /** Initial assignees. Omitted or empty means the task starts unassigned. */
  assignees?: InputMaybe<Array<TaskAssigneeInput>>;
  /** Core task properties (title, description, workflow, etc.). */
  props: NewTaskProps;
};

/** Input for creating a new user-defined role */
export type CreateUserDefinedRoleInput = {
  /** Properties for the new role */
  props: UserDefinedRoleProps;
};

/** Input for creating a list of answer options for a variable (used with Options/RadioOptions variants). */
export type CreateVariableAnswerOptionListInput = {
  /** Zero-based index of the option to set as the default answer, or null for no default. */
  defaultAnswerIndex?: InputMaybe<Scalars['Int']>;
  /** The answer options to create. */
  options: Array<VariableAnswerOptionProps>;
};

/** Input for creating a new variable configuration template with optional predefined answer options. */
export type CreateVariableConfigInput = {
  /** Optional predefined answer options for Options/RadioOptions variants. */
  createAnswerOptions?: InputMaybe<CreateVariableAnswerOptionListInput>;
  /** The config properties. */
  props: CreateVariableConfigProps;
};

/** Properties for creating a new variable configuration template. */
export type CreateVariableConfigProps = {
  /** Display label for the config (e.g., 'Governing Law'). */
  label: Scalars['String'];
  /** Optional notes explaining usage or context for this config. */
  notes?: InputMaybe<Scalars['String']>;
  /** Optional prefix displayed before the value (e.g., '$' for currency). */
  prefix?: InputMaybe<Scalars['String']>;
  /** The question prompt shown to users when filling in this variable. */
  question: Scalars['String'];
  /** Input type for this config (e.g., Text, Currency, Date, Options). */
  variant: MetadataVariant;
};

/** Input for launching a new workflow instance from a template. */
export type CreateWorkflowInstanceInput = {
  /** Values for Aline-only template fields, keyed by AlineTemplateField.fieldId. Omitted fields fall back to template defaults. */
  alineFieldValues?: InputMaybe<Array<AlineFieldValueInput>>;
  /** Template document IDs to exclude from the instance. */
  excludedDocumentIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Assignments mapping template roles to concrete users. */
  instanceAssignments: Array<InstanceAssignmentInput>;
  /** Intake form field values to seed on the launched instance's snapshot, keyed by field name. Required fields gate launch. */
  intakeFormValues?: InputMaybe<Scalars['JSON']>;
  /** CRM opportunity records to link. */
  integrationRecords?: InputMaybe<Array<ApideckOpportunityInput>>;
  /** Whether the template is a community workflow. */
  isCommunityWorkflow?: InputMaybe<Scalars['Boolean']>;
  /** Additional document IDs to include beyond the template documents. */
  moreDocumentIds: Array<Scalars['UUID']>;
  /** Party IDs to associate with the launched workflow. */
  partyIds: Array<Scalars['UUID']>;
  /** Properties for the new workflow instance (name, document names). */
  props: WorkflowInstanceProps;
  /** Template documents to replace with uploaded files. */
  replacementFiles: Array<ReplacementFilesInput>;
  /** Signer name/email assignments, keyed by TemplateSignerRole.roleId. Every signer role must be provided. */
  signerAssignments?: InputMaybe<Array<SignerAssignmentInput>>;
  /** Template workflow to instantiate. */
  templateWorkflowId: Scalars['UUID'];
};

/** Input for creating a new recipient action in a workflow. */
export type CreateWorkflowRecipientInput = {
  /** Where to place the action relative to the target step. */
  actionPlacement: ActionPlacement;
  /** Email for an external user. Use instead of props.assignedUserId for external users. */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Properties for the new recipient. */
  props: CreateWorkflowRecipientProps;
  /**
   * Org-scoped display name for this recipient (stored on OrgContact for the workflow owner's
   * org). Ignored for recipients inside that org, who are named by their User record.
   */
  recipientName?: InputMaybe<Scalars['String']>;
  /** Existing step to place the action relative to. */
  targetStepId?: InputMaybe<Scalars['UUID']>;
};

/** Properties for creating a new workflow recipient action. */
export type CreateWorkflowRecipientProps = {
  /** Role to assign as the recipient. */
  assignedRoleId?: InputMaybe<Scalars['UUID']>;
  /** Internal user to assign as the recipient. */
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  /** Assign to whoever launches this template. Only valid on a template; assignedUserId and assignedRoleId are ignored. */
  isLauncher?: InputMaybe<Scalars['Boolean']>;
  /** Target step to place the action in. Optional when actionPlacement determines position. */
  stepId?: InputMaybe<Scalars['UUID']>;
  /** Whether the recipient is a signer or carbon copy. */
  type: WorkflowRecipientType;
  /** The workflow to add the recipient to. */
  workflowId: Scalars['UUID'];
};

export type CreateWorkflowViewInput = {
  initialPin?: InputMaybe<WorkflowViewPinInput>;
  name: Scalars['String'];
  showInSavedViews?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['JSON']>;
};

/** Why a CRM connection needs an admin's attention before Aline can use it fully. */
export enum CrmConnectionIssueKind {
  /** The CRM revoked or expired the OAuth token; reconnecting signs in again. */
  AuthorizationExpired = 'AuthorizationExpired',
  /** The CRM refuses the records Aline writes because the connection lacks the custom object scopes. */
  MissingScopes = 'MissingScopes',
  /** The signing key could not be written into the CRM, so the CRM package cannot call Aline. */
  PackageSecretUndelivered = 'PackageSecretUndelivered',
  /** OAuth finished but the connection never became callable; the Vault setup has to be completed. */
  SetupIncomplete = 'SetupIncomplete'
}

/** A download URL on Aline's own domain. It expires about an hour after it is minted. */
export type CrmDownloadUrlResponse = {
  __typename: 'CrmDownloadUrlResponse';
  url: Scalars['String'];
};

/** A CRM property edit written back before launch. */
export type CrmFieldEditInput = {
  /** CRM-native object type that owns the property. */
  customObjectType?: InputMaybe<Scalars['String']>;
  /** CRM property API name. */
  fieldApiName: Scalars['String'];
  /** A string, a number, a boolean for Checkbox, or a list for MultiPicklist. Null or an empty string clears the property. */
  newValue?: InputMaybe<Scalars['JSON']>;
  /**
   * Legacy CRM record category. Custom objects use customObjectType.
   * @deprecated Use customObjectType instead
   */
  objectType?: InputMaybe<CrmObjectType>;
};

/** CRM records a template field can read from. The owner is read-only, so it cannot be edited. */
export enum CrmFieldObjectType {
  /** The CRM's company or account record (a Salesforce Account, a HubSpot Company). */
  Company = 'Company',
  /** The CRM's primary sales record (a Salesforce Opportunity, a HubSpot Deal). */
  Opportunity = 'Opportunity',
  /** The record's owner (a Salesforce User, a HubSpot owner). */
  Owner = 'Owner'
}

/** A CRM property a template reads at launch, described for the CRM launch form. */
export type CrmFieldRequirement = {
  __typename: 'CrmFieldRequirement';
  /** The property's raw CRM value. Null unless crmLaunchForm was given a source record. Reference fields hold IDs, semicolon-separated when there are several. */
  currentValue: Maybe<Scalars['String']>;
  /** CRM-native object type that owns the property. */
  customObjectType: Maybe<Scalars['String']>;
  /** The value to display: owner and user names, picklist labels, formatted dates and numbers. Null when there is no source record, the property is empty, or an ID in it could not be resolved. */
  displayValue: Maybe<Scalars['String']>;
  /** CRM property API name (e.g. dealname, amount). */
  fieldApiName: Scalars['String'];
  /** Human-readable label. */
  label: Scalars['String'];
  /**
   * Legacy CRM record category. Custom objects use customObjectType.
   * @deprecated Use customObjectType instead
   */
  objectType: Maybe<CrmFieldObjectType>;
  /** Options when type is Picklist or MultiPicklist; null otherwise. */
  picklistOptions: Maybe<Array<CrmPicklistOption>>;
  /** Whether the CRM calculates or otherwise prevents edits to this property. */
  readOnly: Scalars['Boolean'];
  /** CRM object referenced by the stored ID (for example OWNER or USER), or null for ordinary fields. Derived from the property name when the CRM declares no reference but still stores ids. */
  referencedObjectType: Maybe<Scalars['String']>;
  /** Whether the field must be populated before launch. */
  required: Scalars['Boolean'];
  /** Input control type. */
  type: CrmFieldType;
  /** IDs of the template documents that contain this field. Matches documentsList entries. */
  usedInDocuments: Array<Scalars['UUID']>;
};

/** Input control type for a CRM-mapped template field. */
export enum CrmFieldType {
  /** Boolean checkbox. */
  Checkbox = 'Checkbox',
  /** Numeric input shown with a currency symbol. */
  Currency = 'Currency',
  /** Date input (YYYY-MM-DD). */
  Date = 'Date',
  /** Timestamp input. */
  DateTime = 'DateTime',
  /** Reference to another CRM record, submitted as that record's ID. */
  Lookup = 'Lookup',
  /** Multi-select from picklistOptions; submit the chosen values as a list. */
  MultiPicklist = 'MultiPicklist',
  /** Numeric input. */
  Number = 'Number',
  /** Numeric input shown as a percentage. */
  Percent = 'Percent',
  /** Single-select from picklistOptions. */
  Picklist = 'Picklist',
  /** Free-form text input. */
  Text = 'Text'
}

/** CRM-compatible intake form shape reserved for future launch-form projection. */
export type CrmIntakeForm = {
  __typename: 'CrmIntakeForm';
  description: Scalars['String'];
  formId: Scalars['UUID'];
  questions: Array<CrmIntakeQuestion>;
  schemaVersion: Scalars['Int'];
  title: Scalars['String'];
};

/** CRM-compatible intake question shape reserved for future launch-form projection. */
export type CrmIntakeQuestion = {
  __typename: 'CrmIntakeQuestion';
  format: Maybe<Scalars['String']>;
  helpText: Scalars['String'];
  label: Scalars['String'];
  maxLength: Maybe<Scalars['Int']>;
  maxValue: Maybe<Scalars['Float']>;
  minLength: Maybe<Scalars['Int']>;
  minValue: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  options: Maybe<Array<CrmPicklistOption>>;
  order: Scalars['Int'];
  placeholder: Scalars['String'];
  required: Scalars['Boolean'];
  type: Scalars['String'];
};

/**
 * CRM integrations that launch Aline workflows over signed requests; sessions and API keys are
 * refused. Every crm-prefixed root field is nullable so a refusal or a failed lookup is reported in
 * errors while the caller keeps its HTTP 200 contract.
 */
export enum CrmIntegration {
  /** HubSpot CRM. */
  HubSpot = 'HubSpot',
  /** Salesforce CRM. Not yet served by the crm* fields; it launches through templateSalesforceFields. */
  SalesForce = 'SalesForce'
}

/** Everything needed to render a CRM launch form. Current CRM values are read from the CRM itself. */
export type CrmLaunchFormResponse = {
  __typename: 'CrmLaunchFormResponse';
  /** Aline-only fields with no CRM backing. Empty when none. */
  alineFields: Array<AlineTemplateField>;
  /** CRM-mapped fields. Empty when the template has no CRM-backed variables. */
  crmFields: Array<CrmFieldRequirement>;
  /** Documents belonging to the template, referenced by usedInDocuments. Empty when none. */
  documentsList: Array<TemplateDocument>;
  /**
   * Reserved for the template intake form; currently null.
   * @deprecated Intake forms are not currently supported via CRM launch
   */
  intakeForm: Maybe<CrmIntakeForm>;
  /** Signer roles in signing order. Empty when none. */
  signerRoles: Array<TemplateSignerRole>;
  /** The template this form was built for; echo it back on crmLaunchWorkflow. */
  templateId: Scalars['UUID'];
};

/** Everything needed to launch one template against one CRM record. */
export type CrmLaunchWorkflowInput = {
  /** Aline-only field values. Send blanks explicitly; omitted fields fall back to template defaults. */
  alineFieldValues?: InputMaybe<Array<AlineFieldValueInput>>;
  /**
   * Legacy HubSpot Deal ID alias.
   * @deprecated Use sourceRecordId instead
   */
  dealId?: InputMaybe<Scalars['ID']>;
  /** CRM property edits to write before launch. Changed fields only. */
  fieldEdits?: InputMaybe<Array<CrmFieldEditInput>>;
  /** Which CRM the source record lives in. */
  integration: CrmIntegration;
  /**
   * Legacy CRM Opportunity record ID.
   * @deprecated Use sourceRecordId instead
   */
  opportunityId?: InputMaybe<Scalars['ID']>;
  /** One entry per signer role; each needs a name and a valid email. */
  signerAssignments?: InputMaybe<Array<SignerAssignmentInput>>;
  /** CRM-native ID of the record the workflow launches from. */
  sourceRecordId?: InputMaybe<Scalars['ID']>;
  /** CRM-native type of the record the workflow launches from. */
  sourceRecordType?: InputMaybe<Scalars['String']>;
  /** Aline template workflow ID. */
  templateId: Scalars['UUID'];
};

/** Result of a successful CRM launch. A failed launch is reported in errors instead. */
export type CrmLaunchWorkflowResponse = {
  __typename: 'CrmLaunchWorkflowResponse';
  /** Always true, since a failure is reported in errors. CRM packages already select it. */
  success: Scalars['Boolean'];
  /** The launched workflow. */
  workflowId: Scalars['UUID'];
  /** Deep link into Aline for the launched workflow. */
  workflowUrl: Scalars['String'];
};

/** CRM records a launch reads from and writes back to. */
export enum CrmObjectType {
  /** The CRM's company or account record (a Salesforce Account, a HubSpot Company). */
  Company = 'Company',
  /** The CRM's primary sales record (a Salesforce Opportunity, a HubSpot Deal). */
  Opportunity = 'Opportunity'
}

/** An active org member offered by the CRM signer picker. */
export type CrmOrgMember = {
  __typename: 'CrmOrgMember';
  /** Lower-cased, and unique within the org. */
  email: Scalars['String'];
  /** Display name; falls back to the email when the user has no name. */
  name: Scalars['String'];
};

/** CRM tenant <-> Aline org pairing for HMAC-signed package auth. */
export type CrmPairing = {
  __typename: 'CrmPairing';
  /** The CRM-native tenant identifier (e.g. Salesforce org id, HubSpot portal id). */
  crmTenantId: Scalars['String'];
  id: Scalars['UUID'];
  /** The CRM integration this pairing belongs to. */
  integration: Integration;
  /** Last time a request reached this pairing but the signature did not match. */
  lastRejectedRequestAt: Maybe<Scalars['DateTime']>;
  /** Last time a request signed with this pairing's key passed HMAC. */
  lastVerifiedRequestAt: Maybe<Scalars['DateTime']>;
  orgId: Maybe<Scalars['UUID']>;
  /** When the signing secret was last written into Salesforce. Cleared on rotate until the next successful push. */
  secretDeliveredAt: Maybe<Scalars['DateTime']>;
  /** Why the last Salesforce secret push failed; null after a successful delivery. */
  secretDeliveryError: Maybe<Scalars['String']>;
  /** Whether the signing secret is shared app-wide or issued per tenant. */
  secretScope: CrmSecretScope;
  status: Scalars['String'];
};

/** A selectable option for a CRM Picklist or MultiPicklist field. */
export type CrmPicklistOption = {
  __typename: 'CrmPicklistOption';
  /** Display label rendered in the form. */
  label: Scalars['String'];
  /** Stable value submitted back on launch. */
  value: Scalars['String'];
};

/** Whether a CRM's signing secret is shared per app or issued per paired tenant. */
export enum CrmSecretScope {
  App = 'APP',
  Tenant = 'TENANT'
}

/** A HubSpot owner or user resolved from an ID stored in a CRM field. */
export type CrmUser = {
  __typename: 'CrmUser';
  email: Maybe<Scalars['String']>;
  /** Display name; falls back to the email when HubSpot has no name. */
  name: Scalars['String'];
  /** The requested HubSpot owner or user ID. */
  userId: Scalars['String'];
};

export type DeleteAgentSkillResponse = {
  __typename: 'DeleteAgentSkillResponse';
  agentSkillId: Scalars['UUID'];
  refetch: Query;
};

/** Input for deleting annotations from a file version */
export type DeleteAnnotationsInput = {
  /** ID of the file version whose annotations should be deleted */
  fileVersionId: Scalars['UUID'];
};

/** Input for deleting or disabling a comment */
export type DeleteCommentInput = {
  /** ID of the comment to delete or disable */
  id: Scalars['UUID'];
};

/** Input for deleting a contract type and reassigning its documents */
export type DeleteContractTypeInput = {
  /** The contract type to be deleted. */
  deletedTypeId: Scalars['UUID'];
  /** The contract type that all Documents using deletedTypeId will now use. */
  newTypeId: Scalars['UUID'];
};

/** Input for permanently deleting documents in bulk. */
export type DeleteDocumentsInput = {
  /** IDs of the documents to delete. Ignored when runAllDocs is true. */
  documentIds: Array<Scalars['UUID']>;
  /** AG Grid filter model to scope which documents are affected when runAllDocs is true. */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** Per-group select-all: restrict the action to documents in this group path. */
  groupSelection?: InputMaybe<GroupSelectionInput>;
  /** Report ID whose saved filters determine the document set when runAllDocs is true. */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** When true, delete all matching documents instead of only those in documentIds. */
  runAllDocs?: InputMaybe<Scalars['Boolean']>;
};

/** Input for deleting one or more envelopes. */
export type DeleteEnvelopesInput = {
  /** IDs of the envelopes to delete. */
  ids: Array<Scalars['UUID']>;
};

export type DeleteFilesViaLaunchConfigInput = {
  /** Temporary upload document IDs to soft-delete. */
  documentIds: Array<Scalars['UUID']>;
  /** The launch config that created the temporary uploads. */
  launchConfigId: Scalars['UUID'];
};

export type DeleteInsightPinResponse = {
  __typename: 'DeleteInsightPinResponse';
  id: Scalars['UUID'];
};

export type DeleteMetadataImportsResult = {
  __typename: 'DeleteMetadataImportsResult';
  deletedIds: Array<Scalars['UUID']>;
};

/** Input for deleting one of a rule's fallback positions. */
export type DeletePlaybookRulePositionInput = {
  /** ID of the fallback to delete. Must not be the starting position. */
  positionId: Scalars['UUID'];
  /** ID of the rule that owns the position. */
  ruleId: Scalars['UUID'];
};

/** Input for deleting one or more reports. */
export type DeleteReportsInput = {
  /** IDs of the reports to delete. */
  reportIds: Array<Scalars['UUID']>;
};

/** Input for deleting or disabling multiple storables */
export type DeleteStorables = {
  /** IDs of the storables to delete or disable */
  storableIds: Array<Scalars['UUID']>;
};

/** Input for deleting a user-defined role */
export type DeleteUserDefinedRoleInput = {
  /** ID of the role to delete */
  roleId: Scalars['UUID'];
};

/** Input for deleting workflow actions by their IDs. */
export type DeleteWorkflowActionsInput = {
  /** IDs of the actions to delete. */
  actionIds: Array<Scalars['UUID']>;
};

export type DeleteWorkflowViewChartInput = {
  chartId: Scalars['String'];
  state: Scalars['JSON'];
  viewId: Scalars['UUID'];
};

export type DeleteWorkflowViewResponse = {
  __typename: 'DeleteWorkflowViewResponse';
  id: Scalars['UUID'];
};

/** Input for detaching the intake form template from a TEMPLATE workflow. */
export type DetachIntakeFormTemplateInput = {
  /** The template workflow to detach from. */
  workflowId: Scalars['UUID'];
};

/** Input for soft-deleting (disabling) documents in bulk. */
export type DisableDocumentsInput = {
  /** IDs of the documents to disable. Ignored when runAllDocs is true. */
  documentIds: Array<Scalars['UUID']>;
  /** AG Grid filter model to scope which documents are affected when runAllDocs is true. */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** Per-group select-all: restrict the action to documents in this group path. */
  groupSelection?: InputMaybe<GroupSelectionInput>;
  /** Report ID whose saved filters determine the document set when runAllDocs is true. */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** When true, disable all documents matching the report/filter instead of documentIds. */
  runAllDocs?: InputMaybe<Scalars['Boolean']>;
};

/** If the requester can't perform an action, a String explaining it is returned, otherwise null. */
export type DisallowedTaskReasons = {
  __typename: 'DisallowedTaskReasons';
  /** Reason the requester cannot change this task's status, or null if status changes are allowed. */
  changeStatus: Maybe<Scalars['String']>;
  /** Reason the requester cannot edit this task, or null if editing is allowed. */
  edit: Maybe<Scalars['String']>;
};

export type DiscardAgentSkillDraftInput = {
  expectedRevision: Scalars['Int'];
  id: Scalars['UUID'];
};

/** Display mode for the report rows query. */
export enum DisplayMode {
  /** Simple flat list of document rows with no hierarchy. */
  Flat = 'FLAT',
  /** Rows grouped by a selected field (e.g., status, owner) with collapsible group headers. */
  Grouped = 'GROUPED',
  /** Tree view showing parent-child document relationships; rows can be expanded. */
  Relationship = 'RELATIONSHIP'
}

/** Document-level access granted to a collaborator for all documents in the workflow. */
export enum DocAccessLevel {
  /** Can view and add comments. */
  Commenter = 'COMMENTER',
  /** Custom per-document access overrides. */
  Custom = 'CUSTOM',
  /** Full editing access to workflow documents. */
  Editor = 'EDITOR',
  /** No access to workflow documents. */
  NoAccess = 'NO_ACCESS',
  /** Full control including permission management. */
  Owner = 'OWNER',
  /** Can view, comment, and suggest edits via tracked changes. */
  Suggester = 'SUGGESTER',
  /** Read-only access to workflow documents. */
  Viewer = 'VIEWER'
}

/** Describes a File (PDF, DOCX) */
export type DocFile = {
  __typename: 'DocFile';
  /** When the doc file was created */
  createdAt: Scalars['DateTime'];
  /** When the doc file was soft-deleted */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** DocFile Filestack CDN URL */
  filestackUrl: Scalars['String'];
  /** Filestack handle */
  handle: Scalars['String'];
  /** Unique identifier for this file. */
  id: Scalars['UUID'];
  /** Mimetype / Content-Type */
  mimetype: Scalars['String'];
  /** Original file name */
  name: Scalars['String'];
  /** Size of the file in bytes */
  size: Maybe<Scalars['BigInt']>;
  /** When the doc file was last updated */
  updatedAt: Scalars['DateTime'];
};

/** A location within a document where an extracted answer was found. Either an Aline editor location or a file-based (PDF) location. */
export type DocLocation = AlineLocation | FileLocation;

/**
 * Event payload when playbooks associated with a document change. An event is
 * one of two kinds. A full update carries playbooks: every playbook with its
 * rules and their runs on the document. A rule job update carries ruleJob and
 * playbook: the one rule job that changed and the playbook it ran under, which
 * is how a finishing rule is announced without re-reading the whole run.
 */
export type DocPlaybooksUpdatedEvent = {
  __typename: 'DocPlaybooksUpdatedEvent';
  /** ID of the document whose playbooks changed. */
  documentId: Scalars['UUID'];
  /** The playbook the changed rule job ran under, so its run status follows the rule. Null on a full update. */
  playbook: Maybe<Playbook>;
  /** Current set of playbooks for the document. Null on a rule job update. */
  playbooks: Maybe<Array<Playbook>>;
  /** The one rule job that changed. Null on a full update. */
  ruleJob: Maybe<PlaybookRuleJob>;
  /** ID of the one rule job that changed. Null on a full update. */
  ruleJobId: Maybe<Scalars['UUID']>;
};

/** An org's DocuSign authorization record linking a DocuSign account to an Aline org. */
export type DocuSignAuth = {
  __typename: 'DocuSignAuth';
  /** Whether this user performed the org-wide admin consent (true) vs. individual consent (false). */
  admin: Scalars['Boolean'];
  /** DocuSign API account GUID used for API calls on behalf of this account. */
  docuSignApiId: Scalars['UUID'];
  /** Email address associated with the linked DocuSign account. */
  docuSignEmail: Scalars['String'];
  /** Primary key for the DocuSign authorization record. */
  id: Scalars['UUID'];
  /** Aline org this DocuSign authorization belongs to. */
  orgId: Scalars['UUID'];
  /** Current state of the integration setup process. */
  status: DocuSignIntegrationStatus;
  /** Aline user who authorized the DocuSign connection. */
  userId: Scalars['UUID'];
};

/** Response indicating whether a DocuSign integration exists for the current account. */
export type DocuSignIntegratedResponse = {
  __typename: 'DocuSignIntegratedResponse';
  /** True if the org has an active DocuSign integration. */
  hasDocuSignIntegration: Scalars['Boolean'];
  /** Refetch handle for updating cached query results after mutation. */
  refetch: Query;
};

/** Current state of the DocuSign integration setup process. */
export enum DocuSignIntegrationStatus {
  /** Integration is fully authorized and ready for use. */
  Integrated = 'INTEGRATED',
  /** Integration has been initiated but the OAuth consent flow is not yet complete. */
  Pending = 'PENDING'
}

/** Describes an Aline document. */
export type Document = StorableInterface & {
  __typename: 'Document';
  /** The IDs of the AI questions that are currently running for this document. */
  aiQuestionIdsQueueing: Array<Scalars['UUID']>;
  /** The assets (images) associated with a document. */
  assets: Array<DocFile>;
  /** Child document relationships where this document is the parent (confirmed + unconfirmed) */
  childRelationships: Array<DocumentRelationship>;
  /** Comments by user on the document. */
  comments: Array<Comment>;
  /** Categories if published to the Community. */
  communityCategories: Array<CommunityCategory>;
  /** Document conversion to Aline failed at. */
  conversionFailedAt: Maybe<Scalars['DateTime']>;
  /** Document conversion to Aline finished at. */
  conversionFinishedAt: Maybe<Scalars['DateTime']>;
  /** Document conversion to Aline started at. */
  conversionStartedAt: Maybe<Scalars['DateTime']>;
  /** Core AI properties extraction failed at. */
  coreAiPropertiesExtractionFailedAt: Maybe<Scalars['DateTime']>;
  /** Core AI properties extraction finished at. */
  coreAiPropertiesExtractionFinishedAt: Maybe<Scalars['DateTime']>;
  /** Core AI properties extraction started at. */
  coreAiPropertiesExtractionStartedAt: Maybe<Scalars['DateTime']>;
  /** Document was created at. */
  createdAt: Scalars['DateTime'];
  /** Document was soft deleted at. */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Description for the document. */
  description: Maybe<Scalars['String']>;
  /** Envelope the Document belongs to, if any. */
  envelope: Maybe<Envelope>;
  /** The FolderSyncJob this document is associated with, if any. */
  folderSyncJobId: Maybe<Scalars['UUID']>;
  /** Recipient forwarding for the document. */
  forwardingPermissionRole: Maybe<PermissionRole>;
  /** Groups that are allowed to view this Document. */
  groups: Array<Group>;
  /** Whether the Document has a Workflow.  Used in cases where user has access to Document but not Workflow. */
  hasWorkflow: Scalars['Boolean'];
  /** Document ID - GUID. */
  id: Scalars['UUID'];
  /** Flag that indicates whether the document is active. */
  isActive: Scalars['Boolean'];
  /** Flag that indicates whether the document is a Certificate of Completion doc. */
  isCertificate: Scalars['Boolean'];
  /** Defines whether a document is a public community template. Defaults to False. */
  isCommunityTemplate: Scalars['Boolean'];
  /** Whether this document is an Internal General file on its workflow, kept within the owner's org. */
  isInternalOnWorkflow: Scalars['Boolean'];
  /** Flag that indicates whether the document has a pending DB save (debounced save in progress). */
  isSavePending: Scalars['Boolean'];
  /** Flag that indicates whether the document is signed. */
  isSigned: Scalars['Boolean'];
  /** Labels for this Document. */
  labels: Array<Label>;
  /** Timestamp for when the requester last accessed, if any. */
  lastAccessedByRequesterAt: Maybe<Scalars['DateTime']>;
  /** The latest FileVersion of the Document. */
  latestVersion: FileVersion;
  /** Open-source license details, if applicable. */
  license: Maybe<SupportedLicense>;
  /** Document Name. */
  name: Scalars['String'];
  /** The number of times this template has been imported. Usually reserved for community templates. */
  numTimesImported: Scalars['Int'];
  /** The number of times this document has been used.  Usually reserved for community templates. */
  numTimesUsed: Scalars['Int'];
  /** Versions of Document. */
  orderedVersions: Array<FileVersion>;
  /** Document owner - the user who owns the document. */
  owner: User;
  /** Storable owner id. */
  ownerId: Scalars['UUID'];
  /** Parent document relationships where this document is the child (confirmed + unconfirmed) */
  parentRelationships: Array<DocumentRelationship>;
  /** Parties for the Document. */
  parties: Array<Party>;
  /** Permissions for the document. */
  permissions: Array<StorablePermission>;
  /** Question job for the document */
  questionJobs: Array<ExtractionJob>;
  /** User-facing reason for relationship pipeline failure (sanitized). */
  relationshipMatchingFailedReason: Maybe<Scalars['String']>;
  /** Relationship graph matching finished at. */
  relationshipMatchingFinishedAt: Maybe<Scalars['DateTime']>;
  /** Relationship graph matching started at (covers entire pipeline: extraction + matching). */
  relationshipMatchingStartedAt: Maybe<Scalars['DateTime']>;
  /** SHA-256 hash of the content used for the most recent relationship properties extraction. */
  relationshipPropertiesExtractionHash: Maybe<Scalars['String']>;
  /** Document favorited by requester. */
  requesterFavorited: Scalars['Boolean'];
  /** Returns the ids of the templates the requester imported. */
  requesterImportedDocumentIds: Array<Scalars['String']>;
  /** Requester is in owner's org. */
  requesterInOwnerOrg: Scalars['Boolean'];
  /** The permission role of the user requesting the document. */
  requesterRole: Maybe<PermissionRole>;
  /** SignatureFields for the Document. */
  signatureFields: Array<SignatureField>;
  /** Timestamp document was signed, if any. */
  signedAt: Maybe<Scalars['DateTime']>;
  /** The source document (e.g., template). */
  sourceDocument: Maybe<Document>;
  /** Document status. */
  status: Maybe<DocumentStatus>;
  /** Storable's type - Document, DocFile, or Folder. */
  storableType: StorableType;
  /** The ID of the file in the external file storage integration (e.g., Google Drive, SharePoint). */
  storageIntegrationId: Maybe<Scalars['String']>;
  /** Type defined by the Org. */
  type: Maybe<ContractType>;
  /** Document was most recently updated at. */
  updatedAt: Scalars['DateTime'];
  /** URL relationships where this document is the parent */
  urlRelationships: Array<DocumentRelationship>;
  /** Variables associated with the Document. */
  variables: Array<DocumentVariable>;
  /** Document Variant - Template or Document. */
  variant: DocumentVariant;
  /** Document workflow. */
  workflow: Maybe<Workflow>;
  /** Role of this document on its workflow. Null when the document is not a workflow file. */
  workflowFileRole: Maybe<WorkflowFileDocumentRole>;
};

/** Identifies a specific asset (image, attachment) within a document. */
export type DocumentAssetInput = {
  /** ID of the document the asset belongs to. */
  documentId: Scalars['UUID'];
  /** ID of the file asset. */
  fileId: Scalars['UUID'];
};

/** Tri-state indicating whether a label is applied to all, none, or some documents in a set */
export enum DocumentLabelState {
  /** Label is applied to every document in the set */
  Checked = 'Checked',
  /** Label is applied to some but not all documents in the set */
  Indeterminate = 'Indeterminate',
  /** Label is not applied to any document in the set */
  NotChecked = 'NotChecked'
}

/** Input for querying label state across a set of documents */
export type DocumentLabelStateInput = {
  /** Documents to check; ignored when runAllDocs is true */
  documentIds: Array<Scalars['UUID']>;
  /** AG Grid filter model to select documents server-side when runAllDocs is true */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** Per-group select-all: restrict to documents in this group path. */
  groupSelection?: InputMaybe<GroupSelectionInput>;
  /** Scope to a specific report's document set */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** When true, checks all documents matching the filter instead of the explicit documentIds */
  runAllDocs: Scalars['Boolean'];
};

/** Filter for which documents to include in the report based on organizational access. */
export enum DocumentListFilter {
  /** Include all documents the requester can access. */
  All = 'All',
  /** Include only documents owned by the requester's organization. */
  Organization = 'Organization',
  /** Include only documents shared with the requester. */
  Shared = 'Shared'
}

/** Result of checking document mention access. */
export type DocumentMentionAccessResult = Document | MentionAccessError;

export type DocumentMetadataImport = {
  __typename: 'DocumentMetadataImport';
  createdAt: Scalars['DateTime'];
  createdBy: User;
  displayName: Scalars['String'];
  failedReason: Maybe<Scalars['String']>;
  finishedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  questions: Array<ExtractionQuestion>;
  sourceFileName: Maybe<Scalars['String']>;
  startedAt: Maybe<Scalars['DateTime']>;
  status: DocumentMetadataImportStatus;
  summary: Maybe<DocumentMetadataImportSummary>;
  templateVersion: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DocumentMetadataImportPreview = {
  __typename: 'DocumentMetadataImportPreview';
  columns: Array<DocumentMetadataImportPreviewColumn>;
  conflictRows: Scalars['Int'];
  errorRows: Scalars['Int'];
  totalRows: Scalars['Int'];
};

export type DocumentMetadataImportPreviewColumn = {
  __typename: 'DocumentMetadataImportPreviewColumn';
  canOverwrite: Scalars['Boolean'];
  errorCount: Scalars['Int'];
  questionId: Scalars['UUID'];
  title: Scalars['String'];
  type: ExtractionQuestionType;
  warningCount: Scalars['Int'];
};

export enum DocumentMetadataImportRowStatus {
  Error = 'Error',
  Pending = 'Pending',
  Skipped = 'Skipped',
  Success = 'Success',
  Warning = 'Warning'
}

export enum DocumentMetadataImportStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  CompletedWithErrors = 'CompletedWithErrors',
  Draft = 'Draft',
  Failed = 'Failed',
  Processing = 'Processing',
  ReadyToImport = 'ReadyToImport',
  Uploaded = 'Uploaded',
  Validating = 'Validating'
}

export type DocumentMetadataImportSummary = {
  __typename: 'DocumentMetadataImportSummary';
  conflictRows: Scalars['Int'];
  createdJobs: Scalars['Int'];
  emptyColumns: Array<Scalars['String']>;
  errorRows: Scalars['Int'];
  processedRowCount: Scalars['Int'];
  skippedCells: Scalars['Int'];
  totalRows: Scalars['Int'];
  updatedJobs: Scalars['Int'];
  validRows: Scalars['Int'];
};

export type DocumentMetadataImportValidationIssue = {
  __typename: 'DocumentMetadataImportValidationIssue';
  columnIndex: Maybe<Scalars['Int']>;
  message: Scalars['String'];
  questionId: Maybe<Scalars['UUID']>;
  type: DocumentMetadataImportValidationIssueType;
};

export enum DocumentMetadataImportValidationIssueType {
  Error = 'Error',
  Warning = 'Warning'
}

export type DocumentParts = {
  __typename: 'DocumentParts';
  /** Assets (e.g., media like images) that are referenced in the document. */
  assets: Array<DocFile>;
  /** List of users that have authored a tracked change or comment. */
  authors: Array<User>;
  /** Comments made on the document content/text. */
  comments: Array<Comment>;
};

/**
 * Updatable document metadata properties.
 * Note: documentJSON is intentionally omitted — use the saveDocument mutation for content changes.
 */
export type DocumentProps = {
  /** Updated description for the document. */
  description?: InputMaybe<Scalars['String']>;
  /** Permission role granted to forwarded recipients. */
  forwardingPermissionRole?: InputMaybe<PermissionRole>;
  /** Updated document name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Describes a parent-child relationship between documents */
export type DocumentRelationship = {
  __typename: 'DocumentRelationship';
  /** The child document, if resolvable/accessible */
  childDocument: Maybe<Document>;
  /** The child document ID in this relationship */
  childDocumentId: Maybe<Scalars['UUID']>;
  /** The type of relationship (amendment, appendix, supersede) */
  childRelationshipType: ChildRelationshipType;
  /** Whether the child is a document or a URL */
  childType: ChildType;
  /** The URL of the child, when childType is URL */
  childUrl: Maybe<Scalars['String']>;
  /** Short text snippets supporting this relationship suggestion */
  citations: Array<Scalars['String']>;
  /** When the relationship was created */
  createdAt: Scalars['DateTime'];
  /** The referenced document's agreement date (yyyy-MM-dd) as cited in the known document's text, when stated. */
  expectedDocumentAgreementDate: Maybe<Scalars['String']>;
  /** The referenced document's name as extracted from the known document's text, for display on unresolved or self-referencing rows. */
  expectedDocumentName: Maybe<Scalars['String']>;
  /** Unique identifier for the relationship */
  id: Scalars['UUID'];
  /** Markdown-formatted explanation with inline citation links */
  llmReasonsMarkdown: Maybe<Scalars['String']>;
  /** The parent document, if resolvable/accessible */
  parentDocument: Maybe<Document>;
  /** The parent document ID in this relationship */
  parentDocumentId: Maybe<Scalars['UUID']>;
  /** Short explanation of why this relationship was suggested */
  reason: Maybe<Scalars['String']>;
  /** Review information (outcome, user, timestamp) if this relationship has been reviewed */
  review: Maybe<DocumentRelationshipReview>;
  /** How this relationship row was introduced (AI pipeline vs user-driven create). */
  source: DocumentRelationshipSource;
  /** For an equal-ID (self-referencing) edge, the child-role agreement's name inside the file. Null for ordinary and manual relationships. */
  sourceAgreementName: Maybe<Scalars['String']>;
};

/** Review information for a document relationship */
export type DocumentRelationshipReview = {
  __typename: 'DocumentRelationshipReview';
  /** The review outcome (confirmed or rejected) */
  outcome: ReviewOutcome;
  /** When the relationship was reviewed */
  reviewedAt: Scalars['DateTime'];
  /** User who reviewed this relationship (null if the user has been deleted) */
  reviewedBy: Maybe<User>;
};

/** Whether the relationship row was introduced by AI extraction or by explicit user create. */
export enum DocumentRelationshipSource {
  Ai = 'AI',
  Manual = 'MANUAL'
}

/** Response for Document mutations */
export type DocumentResponse = {
  __typename: 'DocumentResponse';
  /** Updated or created document */
  document: Maybe<Document>;
  refetch: Query;
};

/** A document row containing the full document data. */
export type DocumentRow = {
  __typename: 'DocumentRow';
  childRowCount: Maybe<Scalars['Int']>;
  /** The document data. */
  document: Document;
  /** The underlying document ID. */
  documentId: Scalars['UUID'];
  id: Scalars['ID'];
  parentTreeRowId: Maybe<Scalars['ID']>;
  /** The relationship edge connecting this document to the expanded parent (RELATIONSHIP mode nested rows only). */
  relationship: Maybe<DocumentRelationship>;
  /** Direction of this document relative to the expanded parent (RELATIONSHIP mode nested rows only). */
  relationshipDirection: Maybe<RelationshipDirection>;
};

/** Lifecycle status of a document. */
export enum DocumentStatus {
  /** Document is being authored and has not been finalized. */
  Draft = 'DRAFT',
  /** Document's term has ended or it has been explicitly terminated. */
  Expired = 'EXPIRED',
  /** Document has been executed with signatures. */
  Signed = 'SIGNED',
  /** Document is a reusable template, not an active agreement. */
  Template = 'TEMPLATE'
}

/** A background setDocumentsStatus job. Its documents are split into batches that run side by side. */
export type DocumentStatusJob = {
  __typename: 'DocumentStatusJob';
  /** Batches known so far. The job is finished once these cover numQueued and all are finished. */
  batches: Array<DocumentStatusJobBatch>;
  /** The job id returned by setDocumentsStatus. */
  id: Scalars['UUID'];
  /** Documents across every batch. */
  numQueued: Scalars['Int'];
  status: DocumentStatus;
};

/** Running totals for one batch of a job. */
export type DocumentStatusJobBatch = {
  __typename: 'DocumentStatusJobBatch';
  index: Scalars['Int'];
  /** Documents left unchanged because their chunk failed. */
  numFailed: Scalars['Int'];
  /** Documents a cancel stopped before their chunk started. */
  numNotRun: Scalars['Int'];
  /** Documents whose chunk finished, changed or not, including failed chunks. */
  numProcessed: Scalars['Int'];
  numQueued: Scalars['Int'];
  numSuccess: Scalars['Int'];
  skipCounts: Array<DocumentStatusSkipCount>;
  state: DocumentStatusJobState;
};

/** Progress on one batch of a background setDocumentsStatus job. */
export type DocumentStatusJobProgressEvent = {
  __typename: 'DocumentStatusJobProgressEvent';
  /** Documents the batch's latest chunk changed. */
  documentIds: Array<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  /** Null for Expired, which does not rewrite isSigned. */
  isSigned: Maybe<Scalars['Boolean']>;
  job: DocumentStatusJob;
  /** Null for Expired, which does not rewrite variant. */
  variant: Maybe<DocumentVariant>;
};

export enum DocumentStatusJobState {
  Cancelled = 'CANCELLED',
  /** A cancel arrived and the chunks already running are finishing. */
  Cancelling = 'CANCELLING',
  Done = 'DONE',
  Running = 'RUNNING'
}

export type DocumentStatusSkipCount = {
  __typename: 'DocumentStatusSkipCount';
  count: Scalars['Int'];
  reason: DocumentStatusSkipReason;
};

/** Why a document was left unchanged by setDocumentsStatus. */
export enum DocumentStatusSkipReason {
  AttachedToWorkflow = 'ATTACHED_TO_WORKFLOW',
  CannotSignTemplate = 'CANNOT_SIGN_TEMPLATE',
  NotAuthorized = 'NOT_AUTHORIZED',
  NotPdf = 'NOT_PDF',
  SignedOrCertificate = 'SIGNED_OR_CERTIFICATE',
  SigningWithinAline = 'SIGNING_WITHIN_ALINE',
  WorkflowSentForSignature = 'WORKFLOW_SENT_FOR_SIGNATURE'
}

/** Event payload when a single document changes. */
export type DocumentUpdatedEvent = {
  __typename: 'DocumentUpdatedEvent';
  /** True when document comment threads changed (create, update, delete, or visibility). */
  commentsChanged: Scalars['Boolean'];
  /** Full document object with the latest state. */
  document: Document;
  /** ID of the updated document. */
  documentId: Scalars['UUID'];
  /** AI extraction questions associated with this document update. */
  questions: Array<ExtractionQuestion>;
};

/** Input for looking up a user associated with a specific document */
export type DocumentUserInput = {
  /** ID of the document to scope the lookup to */
  documentId: Scalars['UUID'];
  /** ID of the user to retrieve */
  userId: Scalars['UUID'];
};

/** Variables carrying data for Documents. */
export type DocumentVariable = {
  __typename: 'DocumentVariable';
  /** Action associated with the variable */
  action: Maybe<WorkflowRecipient>;
  /** Whether to include this field in the launch form. */
  addToLaunchForm: Scalars['Boolean'];
  /** Answer options - e.g. New York, New Jersey, etc. */
  answerOptions: AnswerOptions;
  /** Config linked to the DocumentVariable. */
  config: Maybe<DocumentVariableConfig>;
  /** Created at date - ISO 8601. */
  createdAt: Scalars['DateTime'];
  /** Default answer option if the variant is options. */
  defaultAnswer: Maybe<AnswerOption>;
  /** Deleted at date - ISO 8601. */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Associated Document. */
  document: Document;
  /** Id - UUID */
  id: Scalars['UUID'];
  /** Integration info. */
  integrationLink: IntegrationLink;
  /** Whether variable is a field (i.e., at some point was in documentJSON). */
  isField: Scalars['Boolean'];
  /** Label to easily find variable. */
  label: Scalars['String'];
  /** Checkbox variant: maximum checked answers. Null = no maximum. */
  maxRequired: Maybe<Scalars['Int']>;
  /** Checkbox variant: minimum checked answers (0 = no minimum). */
  minRequired: Scalars['Int'];
  /** Variable identifier that is unique *per Document* used in the JSON. */
  nodeId: Scalars['UUID'];
  /** Optional prefix (e.g., for currency). */
  prefix: Maybe<Scalars['String']>;
  /** Question to ask the user. */
  question: Scalars['String'];
  /** Metadata selectedAnswer if the variant is options. */
  selectedAnswer: Maybe<AnswerOption>;
  /** Checkbox variant: selected answer options (multi-value). */
  selectedAnswers: Maybe<Array<AnswerOption>>;
  /** Whether the user chose to skip this variable (e.g. optional checkbox). */
  skipped: Scalars['Boolean'];
  /** Updated at date - ISO 8601. */
  updatedAt: Scalars['DateTime'];
  /** Value of metadata.  Used as value for all non-options variants. */
  value: Maybe<Scalars['String']>;
  /** Metadata variant. */
  variant: MetadataVariant;
};

/** A reusable template for document variables, defining the label, question, input type, and predefined answer options. Configs can be linked to multiple document variables across documents for consistency. */
export type DocumentVariableConfig = {
  __typename: 'DocumentVariableConfig';
  /** List of options for config. */
  answerOptions: AnswerOptions;
  /** Field created at date - ISO 8601. */
  createdAt: Scalars['DateTime'];
  /** Default answer, if any. */
  defaultAnswer: Maybe<AnswerOption>;
  /** Field soft deleted at date - ISO 8601. */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Config id - UUID. */
  id: Scalars['UUID'];
  /** Label of config. */
  label: Scalars['String'];
  /** Notes for users to understand config. */
  notes: Scalars['String'];
  /** Number of times used in variables. */
  numTimesUsed: Scalars['Int'];
  /** Owner of the config. */
  owner: User;
  /** Prefix of config (e.g., currency symbol for currency config). */
  prefix: Maybe<Scalars['String']>;
  /** Question asked of user. */
  question: Scalars['String'];
  /** Field updated at date - ISO 8601. */
  updatedAt: Scalars['DateTime'];
  /** Config variant - text, number, date, radio, dropdown. */
  variant: MetadataVariant;
};

/** Whether this storable is a reusable template or a concrete document instance. */
export enum DocumentVariant {
  /** A concrete document instance, possibly created from a template. */
  Document = 'DOCUMENT',
  /** A reusable starting point from which new documents can be created. */
  Template = 'TEMPLATE'
}

/** A file version backed by Aline's native editor content (Slate JSON) */
export type DocumentVersion = FileVersionInterface & {
  __typename: 'DocumentVersion';
  /** Users who have authored or edited this version */
  authors: Array<User>;
  /** Timestamp when this version was created */
  createdAt: Scalars['DateTime'];
  /** Slate editor JSON representing the document content */
  documentJSON: Scalars['JSON'];
  /** Timestamp when the file content was last modified, or null if unchanged since creation */
  fileContentChangedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this file version */
  id: Scalars['UUID'];
  /** Display name of this version */
  name: Scalars['String'];
  /** The task this version was uploaded for, or null when it was not uploaded through a task */
  taskUpload: Maybe<TaskUpload>;
  /** Timestamp of the most recent update to this version */
  updatedAt: Scalars['DateTime'];
  /** Timestamp when AI vector embedding generation failed, or null if not attempted or successful */
  vectorsFailedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when AI vector embeddings were successfully persisted */
  vectorsSavedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when AI vector embedding generation began */
  vectorsStartedAt: Maybe<Scalars['DateTime']>;
};

/** Response for multiple-Document mutations */
export type DocumentsResponse = {
  __typename: 'DocumentsResponse';
  /** Updated or created documents */
  documents: Array<Document>;
  refetch: Query;
};

/** Event payload when multiple documents in the repository change. */
export type DocumentsUpdatedEvent = {
  __typename: 'DocumentsUpdatedEvent';
  /** IDs of the documents that changed. */
  documentIds: Array<Scalars['UUID']>;
  /** Full document objects for the changed documents. */
  documents: Array<Document>;
};

/** A cloud storage drive (e.g., a Google Shared Drive or OneDrive root) available for folder sync. */
export type Drive = {
  __typename: 'Drive';
  /** Unique identifier for the drive. */
  id: Scalars['String'];
  /** The file storage integration that is being synced. */
  integration: FileStorageIntegration;
  /** Name of the drive. */
  name: Scalars['String'];
};

/** Configuration for syncing or unsyncing folders within a single drive. */
export type DriveSyncInput = {
  /** MIME types to include in the sync. Empty array means all file types. */
  allowedMimeTypes: Array<Scalars['String']>;
  /** Folders within this drive to sync or unsync. */
  folderIds: Array<FolderSync>;
  /** Cloud storage provider's native identifier for the drive. */
  id: Scalars['String'];
  /** Whether to sync or unsync the specified folders. */
  jobType: JobType;
  /** Display name of the drive. */
  name: Scalars['String'];
};

/** Input for duplicating an existing document. */
export type DuplicateDocument = {
  /** Name for the new copy. Defaults to the original name if omitted. */
  name?: InputMaybe<Scalars['String']>;
};

/** Input for duplicating a template to a different owner. */
export type DuplicateTemplateInput = {
  /** Email of the new owner. Used to invite an external user as the owner if they don't have an account yet. */
  newOwnerEmail?: InputMaybe<Scalars['EmailAddress']>;
  /** User ID of the new owner. Falls back to the requester if both newOwnerId and newOwnerEmail are omitted. */
  newOwnerId?: InputMaybe<Scalars['UUID']>;
  /** ID of the template to duplicate. */
  templateId: Scalars['UUID'];
};

/** A signing package containing documents sent to recipients for signature, either via DocuSign or Aline's native signing. */
export type Envelope = {
  __typename: 'Envelope';
  /** Envelope completedAt timestamp - ISO 8601 */
  completedAt: Maybe<Scalars['DateTime']>;
  /** Created at - ISO 8601 */
  createdAt: Scalars['DateTime'];
  /** Envelope ID from DocuSign (if applicable) */
  docuSignEnvelopeId: Maybe<Scalars['UUID']>;
  /** Envelope URI from DocuSign (if applicable) */
  docuSignUri: Maybe<Scalars['String']>;
  /** Unique identifier for this envelope. */
  id: Scalars['UUID'];
  /** List of WorkflowRecipients */
  recipients: Array<WorkflowRecipient>;
  /** DateTime time when status of envelope was set */
  statusDateTime: Scalars['DateTime'];
  /** Envelopes name/title */
  title: Scalars['String'];
  /** Updated at - ISO 8601 */
  updatedAt: Scalars['DateTime'];
  /** The kind of envelope this is */
  variant: EnvelopeVariant;
  /** The Workflow associated with this Envelope */
  workflow: Workflow;
};

/** A response for mutations of a single Envelope */
export type EnvelopeResponse = {
  __typename: 'EnvelopeResponse';
  /** The updated envelope */
  envelope: Envelope;
  refetch: Query;
};

/** Signature envelope lifecycle status, mirroring the e-signature provider states. */
export enum EnvelopeStatus {
  /** Envelope processing is fully complete. */
  Completed = 'COMPLETED',
  /** Envelope has been created in the e-signature provider. */
  Created = 'CREATED',
  /** A recipient declined to sign. */
  Declined = 'DECLINED',
  /** Envelope has been delivered and viewed by a recipient. */
  Delivered = 'DELIVERED',
  /** Envelope has been drafted but not yet created in the e-signature provider. */
  Drafted = 'DRAFTED',
  /** Envelope has been sent to recipients. */
  Sent = 'SENT',
  /** All required signatures have been applied. */
  Signed = 'SIGNED',
  /** Envelope was voided by the sender. */
  Voided = 'VOIDED'
}

/** The documents and files included in an envelope's signing package. */
export type EnvelopeStorables = {
  __typename: 'EnvelopeStorables';
  /** Documents (contracts) included in this envelope. */
  documents: Array<Document>;
  /** Uploaded files (attachments) included in this envelope. */
  files: Array<DocFile>;
};

/** Signing provider used for an envelope. */
export enum EnvelopeVariant {
  /** Envelope sent via Aline's built-in native signing flow. */
  AlineSign = 'AlineSign',
  /** Envelope sent via DocuSign for external e-signature. */
  DocuSign = 'DocuSign'
}

/** A response for mutations of multiple Envelopes */
export type EnvelopesResponse = {
  __typename: 'EnvelopesResponse';
  /** The updated Envelopes */
  envelopes: Array<Envelope>;
  refetch: Query;
};

/** File format for exporting report data. */
export enum ExportFormat {
  /** Comma-separated values (CSV) format. */
  Csv = 'CSV',
  /** Microsoft Excel (XLSX) spreadsheet format. */
  Xlsx = 'XLSX'
}

/** One provider action that a user can allow for workflow execution. */
export type ExternalTool = {
  __typename: 'ExternalTool';
  /** Provider-supplied description of the action. */
  description: Maybe<Scalars['String']>;
  /** Whether the user currently allows this action. */
  enabled: Scalars['Boolean'];
  /** Whether Aline classifies the action as capable of changing external data. */
  mutates: Scalars['Boolean'];
  /** Provider-supplied display name. */
  name: Scalars['String'];
  /** Provider action identifier, preserved exactly. */
  slug: Scalars['String'];
};

/** A governed external toolkit and its current-user connection state. */
export type ExternalToolkit = {
  __typename: 'ExternalToolkit';
  /** Provider account label when one is available. */
  accountLabel: Maybe<Scalars['String']>;
  /** Whether the current organization allows this toolkit. */
  allowedByOrg: Scalars['Boolean'];
  /** Whether the provider tool catalogue was available for this request. */
  catalogueAvailable: Scalars['Boolean'];
  /** Number of actions currently allowed by the user. */
  enabledCount: Scalars['Int'];
  /** Whether this environment is configured to allow toolkit connections and changes. */
  environmentAvailable: Scalars['Boolean'];
  /** Human-readable toolkit name. */
  name: Scalars['String'];
  /** Toolkit identifier. */
  slug: ExternalToolkitSlug;
  /** Current-user connection state. */
  status: ExternalToolkitConnectionStatus;
  /** Actions visible to the current user. */
  tools: Array<ExternalTool>;
};

/** A provider-hosted authorization request for connecting an external toolkit. */
export type ExternalToolkitConnectRequest = {
  __typename: 'ExternalToolkitConnectRequest';
  /** Trusted provider authorization URL. */
  redirectUrl: Scalars['String'];
};

/** Connection state for an external toolkit available through Composio. */
export enum ExternalToolkitConnectionStatus {
  /** The current user has an active toolkit connection. */
  Connected = 'Connected',
  /** The current user's toolkit connection is no longer active. */
  Expired = 'Expired',
  /** The current user has not connected the toolkit. */
  NotConnected = 'NotConnected'
}

/** Organization policy state for one offered external toolkit. */
export type ExternalToolkitPolicyRow = {
  __typename: 'ExternalToolkitPolicyRow';
  /** Whether the organization allows this toolkit. */
  allowed: Scalars['Boolean'];
  /** Human-readable toolkit name. */
  name: Scalars['String'];
  /** Toolkit identifier. */
  slug: ExternalToolkitSlug;
  /** Number of users retaining stored grants for the toolkit. */
  usersWithGrants: Scalars['Int'];
};

/**
 * The external toolkits Aline offers. The value is the provider's own toolkit
 * identifier, sent and stored verbatim; naming them here makes an unknown
 * toolkit a schema validation error rather than a runtime one.
 */
export enum ExternalToolkitSlug {
  Attio = 'attio',
  Basecamp = 'basecamp',
  Blackbaud = 'blackbaud',
  Boldsign = 'boldsign',
  Box = 'box',
  CapsuleCrm = 'capsule_crm',
  Confluence = 'confluence',
  Crowdin = 'crowdin',
  Dialpad = 'dialpad',
  Discord = 'discord',
  Discordbot = 'discordbot',
  Dropbox = 'dropbox',
  Dynamics365 = 'dynamics365',
  Figma = 'figma',
  Fireflies = 'fireflies',
  Gmail = 'gmail',
  Gong = 'gong',
  Googledocs = 'googledocs',
  Googledrive = 'googledrive',
  Googlemeet = 'googlemeet',
  Googlephotos = 'googlephotos',
  Googleslides = 'googleslides',
  Googlesuper = 'googlesuper',
  Gorgias = 'gorgias',
  Intercom = 'intercom',
  MicrosoftTeams = 'microsoft_teams',
  Miro = 'miro',
  Mural = 'mural',
  Notion = 'notion',
  OneDrive = 'one_drive',
  Outlook = 'outlook',
  Pushbullet = 'pushbullet',
  Roam = 'roam',
  Salesforce = 'salesforce',
  SharePoint = 'share_point',
  Slack = 'slack',
  Slackbot = 'slackbot',
  Webex = 'webex',
  Whatsapp = 'whatsapp',
  Wrike = 'wrike',
  Yandex = 'yandex',
  Zendesk = 'zendesk',
  Zeplin = 'zeplin',
  Zoho = 'zoho',
  ZohoBigin = 'zoho_bigin',
  ZohoDesk = 'zoho_desk',
  ZohoMail = 'zoho_mail',
  Zoom = 'zoom'
}

/** An execution of an extraction question against a document, containing the AI-generated or manually-entered answer. */
export type ExtractionJob = {
  __typename: 'ExtractionJob';
  /** Answer for the extraction question. */
  answer: Scalars['String'];
  /** When this job record was created. */
  createdAt: Scalars['DateTime'];
  /** Document this job was run on. */
  document: Document;
  /** When the job failed, if at all. */
  failedAt: Maybe<Scalars['DateTime']>;
  /** Why the job failed, if at all. */
  failedReason: Maybe<Scalars['String']>;
  /** The FileVersion the ExtractionJob was run against. */
  fileVersion: Maybe<FileVersion>;
  /** The date at which this job finished executing against the document. */
  finishedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this extraction job. */
  id: Scalars['UUID'];
  /** The locations of the answer in the document. */
  locations: Array<DocLocation>;
  /** When this extraction job was locked. */
  lockedAt: Maybe<Scalars['DateTime']>;
  /** User who locked this specific extraction job, if any. Locked jobs cannot be overwritten by AI or manually edited. */
  lockedBy: Maybe<User>;
  /** Previous answer before it was edited (for revert functionality). */
  previousAnswer: Maybe<Scalars['String']>;
  /** Previously selected options (used for revert). */
  previousSelectedOptions: Array<QuestionOption>;
  /** ExtractionQuestion that this job is for. */
  question: ExtractionQuestion;
  /** Question content hash at run. */
  questionContentHashAtRun: Maybe<Scalars['String']>;
  /** Plain-text explanation of why the AI chose this answer. Null for manually entered answers, jobs that have not been run, or jobs created before this field existed. Preserved across user edits and reverts; only overwritten on a fresh AI run. */
  reasoning: Maybe<Scalars['String']>;
  /** Review actions and dates */
  review: Maybe<ExtractionQuestionReview>;
  /** Selected options for Single/Multi select questions. */
  selectedOptions: Array<QuestionOption>;
  /** The date at which this job was started running against the document. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** When this job record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A question that can be run against documents to extract structured data — either via AI or manual entry. */
export type ExtractionQuestion = {
  __typename: 'ExtractionQuestion';
  /** Whether the question was Ai Generated. */
  aiGenerated: Scalars['Boolean'];
  /** Optional instructions that guide the AI on how to interpret and answer this question. */
  aiGuidance: Maybe<Scalars['String']>;
  /** The category for the question. */
  category: Scalars['String'];
  /** Content hash of the question. */
  contentHash: Maybe<Scalars['String']>;
  /** Zero or more contract types associated with this question. */
  contractTypes: Array<ContractType>;
  /** When this question was created. */
  createdAt: Scalars['DateTime'];
  /** The extraction job for the given document. */
  extractionJob: Maybe<ExtractionJob>;
  /** Unique identifier for this extraction question. */
  id: Scalars['UUID'];
  /** Built-in file fields that serve as inputs to the current ExtractionQuestion. */
  inputFileFields: Array<ReportColumnFileField>;
  /** ExtractionQuestions that serve as inputs to the current ExtractionQuestion. */
  inputs: Array<ExtractionQuestion>;
  /** Whether the question is active or not. */
  isActive: Scalars['Boolean'];
  /** The mode of extraction - AI or Manual. */
  mode: ExtractionQuestionMode;
  /** Options available for SingleSelect and MultiSelect questions. */
  options: Array<QuestionOption>;
  /** Text of the question. */
  questionText: Scalars['String'];
  /** Title of the question. */
  title: Scalars['String'];
  /** Expected answer type. */
  type: ExtractionQuestionType;
  /** When this question was last modified. */
  updatedAt: Scalars['DateTime'];
  /** The variant of the question. */
  variant: ExtractionQuestionVariant;
};


/** A question that can be run against documents to extract structured data — either via AI or manual entry. */
export type ExtractionQuestionExtractionJobArgs = {
  documentId: Scalars['UUID'];
};

/** Response containing a document and its associated extraction questions. */
export type ExtractionQuestionForDocumentResponse = {
  __typename: 'ExtractionQuestionForDocumentResponse';
  /** The document the questions apply to. */
  document: Document;
  /** Extraction questions applicable to this document. */
  extractionQuestions: Array<ExtractionQuestion>;
};

/** Background job that analyzes a document and generates suggested extraction questions from its content. */
export type ExtractionQuestionGenerationJob = {
  __typename: 'ExtractionQuestionGenerationJob';
  /** When this job record was created. */
  createdAt: Scalars['DateTime'];
  /** Document being analyzed to generate extraction questions. */
  document: Document;
  /** Extraction questions produced by this generation job. */
  extractionQuestions: Array<ExtractionQuestion>;
  /** When the job failed, if at all. */
  failedAt: Maybe<Scalars['DateTime']>;
  /** Why the job failed, if at all. */
  failedReason: Maybe<Scalars['String']>;
  /** The date at which this job finished executing against the document. */
  finishedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this generation job. */
  id: Scalars['UUID'];
  /** The date at which this job was started running against the document. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** When this job record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** How the extraction question is answered. */
export enum ExtractionQuestionMode {
  /** Answer is generated by AI analysis of the document. */
  Ai = 'AI',
  /** Answer is entered manually by a user. */
  Manual = 'Manual'
}

/** Records a reviewer's action on an extraction job answer, including who reviewed and when. */
export type ExtractionQuestionReview = {
  __typename: 'ExtractionQuestionReview';
  /** The review action taken (Accepted, Rejected, or Edited). */
  reviewAction: ReviewAction;
  /** When the review was performed. */
  reviewedAt: Scalars['DateTime'];
  /** The user who performed the review. */
  reviewedBy: User;
};

/** The data type of an extraction question's expected answer. */
export enum ExtractionQuestionType {
  /** Yes/No answer. */
  Boolean = 'Boolean',
  /** Calendar date answer. */
  Date = 'Date',
  /** One or more options selected from a predefined list. */
  MultiSelect = 'MultiSelect',
  /** Numeric answer. */
  Number = 'Number',
  /** Exactly one option selected from a predefined list. */
  SingleSelect = 'SingleSelect',
  /** Free-form text answer. */
  Text = 'Text'
}

/** Identifies whether a question is user-created or one of the built-in standard fields. */
export enum ExtractionQuestionVariant {
  /** Built-in: Date the agreement was signed or executed. */
  AgreementDate = 'AgreementDate',
  /** Built-in: Duration or term of the agreement. */
  AgreementTerm = 'AgreementTerm',
  /** Built-in: Whether the contract auto-renews. */
  AutoRenewal = 'AutoRenewal',
  /** Built-in: Date the contract expires. */
  ContractExpirationDate = 'ContractExpirationDate',
  /** Built-in: Total monetary value of the contract. */
  ContractValue = 'ContractValue',
  /** Built-in: Address of the counterparty. */
  CounterPartyAddress = 'CounterPartyAddress',
  /** Built-in: Email address of the counterparty. */
  CounterPartyEmailAddress = 'CounterPartyEmailAddress',
  /** Built-in: Name of the counterparty signer. */
  CounterPartySignerName = 'CounterPartySignerName',
  /** Built-in: Title of the counterparty signer. */
  CounterPartySignerTitle = 'CounterPartySignerTitle',
  /** User-created custom question. */
  Custom = 'Custom',
  /** Built-in: Governing law jurisdiction clause. */
  GoverningLaw = 'GoverningLaw',
  /** Built-in: Jurisdiction for dispute resolution. */
  Jurisdiction = 'Jurisdiction',
  /** Built-in: Language the contract is written in. */
  Language = 'Language',
  /** Built-in: Marketing rights granted by the contract. */
  MarketingRights = 'MarketingRights',
  /** Built-in: How often payments are made. */
  PaymentFrequency = 'PaymentFrequency',
  /** Built-in: Payment terms (e.g. Net 30). */
  PaymentTerm = 'PaymentTerm',
  /** Built-in: Notice period required to opt out of renewal. */
  RenewalOptOutLength = 'RenewalOptOutLength',
  /** Built-in: Duration of each renewal period. */
  RenewalTerm = 'RenewalTerm',
  /** Built-in: Conditions under which the contract can be terminated for cause. */
  TerminationForCause = 'TerminationForCause',
  /** Built-in: Conditions for termination without cause. */
  TerminationForConvenience = 'TerminationForConvenience',
  /** Built-in: Required notice period before termination. */
  TerminationNoticePeriod = 'TerminationNoticePeriod'
}

/** A report column backed by an AI extraction question. */
export type ExtractionReportColumn = {
  __typename: 'ExtractionReportColumn';
  /** The data type used for filtering and sorting this column. */
  dataType: ReportColumnDataType;
  /** Human-readable column header label (defaults to the question text). */
  displayName: Scalars['String'];
  /** Whether this column can be used as a report row-grouping field. */
  isGroupable: Scalars['Boolean'];
  /** The full extraction question definition. */
  question: ExtractionQuestion;
  /** UUID of the extraction question powering this column. */
  questionId: Scalars['UUID'];
};

/** Information about a file that failed to sync during folder sync operations. */
export type FailedFile = {
  __typename: 'FailedFile';
  /** ISO timestamp of when the failure occurred. */
  failedAt: Scalars['DateTime'];
  /** Human-readable description of why the file failed. */
  failedReason: Scalars['String'];
  /** The unique identifier of the file that failed to sync. */
  fileId: Scalars['String'];
  /** The name of the file that failed. */
  fileName: Scalars['String'];
  /** Whether the user dismissed the file as being not relevant to sync. */
  isDimissed: Scalars['Boolean'];
  /** The MIME type of the file that failed. */
  mimeType: Maybe<Scalars['String']>;
};

/** Input for toggling favorite status on multiple storables */
export type FavoriteStorables = {
  /** True to mark as favorited, false to remove from favorites */
  favorited: Scalars['Boolean'];
  /** IDs of the storables to favorite or unfavorite */
  storableIds: Array<Scalars['UUID']>;
};

/** A fillable field embedded in a document. Either a variable (text/number/date/select) or a signature. */
export type Field = DocumentVariable | SignatureField;

/** Lookup input for resolving a field by its document and node reference */
export type FieldInput = {
  /** ID of the document containing the field */
  documentId: Scalars['UUID'];
  /** Reference ID of the field node within the document JSON */
  nodeRefId: Scalars['UUID'];
};

/** The type of input control rendered for a field in the document editor */
export enum FieldVariant {
  /** Checkbox group input */
  Checkbox = 'CHECKBOX',
  /** Date picker input */
  Date = 'DATE',
  /** Single-select dropdown menu */
  Dropdown = 'DROPDOWN',
  /** Numeric input with optional formatting */
  Number = 'NUMBER',
  /** Single-select radio button group */
  Radiobutton = 'RADIOBUTTON',
  /** Signature capture input */
  Signature = 'SIGNATURE',
  /** Free-form text input */
  Text = 'TEXT'
}

/** A report column backed by a built-in document file field. */
export type FileFieldColumn = {
  __typename: 'FileFieldColumn';
  /** The data type used for filtering and sorting this column. */
  dataType: ReportColumnDataType;
  /** Human-readable column header label. */
  displayName: Scalars['String'];
  /** The built-in file field this column represents. */
  field: ReportColumnFileField;
  /** Whether this column can be used as a report row-grouping field. */
  isGroupable: Scalars['Boolean'];
};

/** A location within an uploaded file (e.g. PDF), identified by page number and bounding rectangle. */
export type FileLocation = {
  __typename: 'FileLocation';
  /** One-indexed page number where the answer was found. */
  pageNum: Scalars['Int'];
  /** From Apryse. A rectangle in the form of [left, top, right, bottom]. */
  rect: Array<Scalars['Float']>;
  /** The text content at this location used as a reference anchor. */
  referenceText: Scalars['String'];
};

export type FileLocationDocumentProps = {
  /** Name of new document */
  name: Scalars['String'];
  /** Variant of Document */
  variant: DocumentVariant;
};

/** Return from successful filestack upload */
export type FileLocationProps = {
  /** S3 Bucket */
  container: Scalars['String'];
  /** File name */
  filename: Scalars['String'];
  /** Filestack ID */
  handle: Scalars['String'];
  /** S3 file name */
  key: Scalars['String'];
  /** File mimetype */
  mimetype: Scalars['String'];
  /** Size in bytes */
  size: Scalars['BigInt'];
  /** Filestack CDN URL */
  url: Scalars['String'];
};

/** A configured connection to a cloud file storage provider via ApiDeck. */
export type FileStorageConnection = {
  __typename: 'FileStorageConnection';
  /** Optional description of the connection. */
  description: Maybe<Scalars['String']>;
  /** Unique identifier for the connection */
  id: Scalars['String'];
  /** URL to the connection's icon or logo. */
  imageUrl: Scalars['String'];
  /** Display name for the connection. */
  name: Scalars['String'];
  /** Service-specific identifier for the connection. */
  serviceId: FileStorageIntegration;
  /** Current state of the connection. */
  state: Maybe<ApiDeckConnectionState>;
};

/** Supported cloud file storage providers for folder sync. */
export enum FileStorageIntegration {
  /** Box cloud storage. */
  Box = 'Box',
  /** Dropbox file storage. */
  Dropbox = 'Dropbox',
  /** Google Drive file storage. */
  GoogleDrive = 'GoogleDrive',
  /** Microsoft OneDrive personal or business storage. */
  OneDrive = 'OneDrive',
  /** Microsoft SharePoint document library. */
  SharePoint = 'SharePoint'
}

/** Distinguishes between files and folders in a storage integration. */
export enum FileType {
  /** An individual file (document, image, etc.). */
  File = 'File',
  /** A directory that can contain other files and folders. */
  Folder = 'Folder'
}

/** A version of a document's content — either a native editor version or an uploaded file */
export type FileVersion = DocumentVersion | StaticFileVersion;

/** Base interface for all file version types within a document */
export type FileVersionInterface = {
  /** Users who have authored or edited this version */
  authors: Array<User>;
  /** Timestamp when this version was created */
  createdAt: Scalars['DateTime'];
  /** Timestamp when the file content was last modified, or null if unchanged since creation */
  fileContentChangedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this file version */
  id: Scalars['UUID'];
  /** Display name of this version */
  name: Scalars['String'];
  /** The task this version was uploaded for, or null when it was not uploaded through a task */
  taskUpload: Maybe<TaskUpload>;
  /** Timestamp of the most recent update to this version */
  updatedAt: Scalars['DateTime'];
  /** Timestamp when AI vector embedding generation failed, or null if not attempted or successful */
  vectorsFailedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when AI vector embeddings were successfully persisted */
  vectorsSavedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when AI vector embedding generation began */
  vectorsStartedAt: Maybe<Scalars['DateTime']>;
};

/** Properties describing the uploaded file for a new static file version */
export type FileVersionProps = {
  /** Override the creation timestamp (defaults to now if omitted) */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Cloud storage location of the uploaded file */
  fileLocation: FileLocationProps;
};

/** Response wrapper for file version mutations */
export type FileVersionResponse = {
  __typename: 'FileVersionResponse';
  /** The created or updated file version */
  fileVersion: FileVersion;
  /** Entry point to refetch related queries after the mutation */
  refetch: Query;
};

/** Options for downloading a file from filestack's cdn */
export type FilestackDownloadOptions = {
  __typename: 'FilestackDownloadOptions';
  /** Docfile Id */
  docFileId: Scalars['UUID'];
  /** Filestack file handle */
  handle: Scalars['String'];
  /** Filestack security granted for read call and handle */
  security: FilestackSecurity;
};

/** Filestack policy and signature for requests */
export type FilestackSecurity = {
  __typename: 'FilestackSecurity';
  /** FileStack Policy - expiry, calls, handle, maxSize, minSize */
  policy: Scalars['String'];
  /** HMAC  - takes base64 encoded policy and signs with project secret as key */
  signature: Scalars['String'];
};

/** Options for setting up filestack client */
export type FilestackUploadOptions = {
  __typename: 'FilestackUploadOptions';
  /** S3 Bucket (returned from server so as not to leak other env buckets) */
  bucket: Scalars['String'];
  /** Filestack security */
  security: FilestackSecurity;
};

/** A file or folder entry from a connected cloud storage provider. */
export type FolderFile = {
  __typename: 'FolderFile';
  /** Unique identifier for the file. */
  id: Scalars['String'];
  /** MIME type of the file (e.g. application/pdf, image/jpeg, etc.). */
  mimeType: Maybe<Scalars['String']>;
  /** Name of the file. */
  name: Scalars['String'];
  /** Full path to the file in the storage service. */
  path: Maybe<Scalars['String']>;
  /** Size of the file in bytes. */
  size: Maybe<Scalars['BigInt']>;
  /** Type of the file (folder, file, etc.). */
  type: Maybe<FileType>;
};

/** Identifies a folder to include in a drive sync operation. */
export type FolderSync = {
  /** Cloud storage provider's native identifier for the folder. */
  id: Scalars['String'];
  /** Display name of the folder. */
  name: Scalars['String'];
};

/** A scheduled or completed job that syncs a cloud storage folder into Aline. */
export type FolderSyncJob = {
  __typename: 'FolderSyncJob';
  /** Allowed MIME types for this sync job. Empty array means all files. */
  allowedMimeTypes: Array<Scalars['String']>;
  /** The ids that have been synced to Aline. */
  completedIds: Array<Scalars['String']>;
  /** Use for when job initially started. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The drive that is being synced. */
  driveId: Scalars['String'];
  /** Name of the drive */
  driveName: Scalars['String'];
  /** Detailed information about files that could not be processed correctly. */
  failedFiles: Array<FailedFile>;
  /** Unique identifier for the folder */
  folderId: Scalars['String'];
  /** Name of the folder */
  folderName: Maybe<Scalars['String']>;
  /** Unique identifier for the folder sync job */
  id: Scalars['UUID'];
  /** The file storage integration that is being synced. */
  integration: FileStorageIntegration;
  /** Labels associated with this folder sync job */
  labels: Array<Label>;
  /** The ids of the file storage integration that need to be synced. */
  storageIntegrationIds: Array<Scalars['String']>;
  /** Will be same as syncStartedAt when job is finished, or may be later than syncStartedAt if another sync is kicked off. */
  syncFinishedAt: Maybe<Scalars['DateTime']>;
  /** Will be same as createdAt when job is started, or may be later than createdAt if another sync is kicked off. */
  syncStartedAt: Scalars['DateTime'];
};

/** Real-time event emitted when folder sync jobs are created, updated, or deleted. */
export type FolderSyncJobUpdatedEvent = {
  __typename: 'FolderSyncJobUpdatedEvent';
  /** List of folder sync job IDs that were deleted. */
  deletedFolderSyncJobIds: Array<Scalars['UUID']>;
  /** List of folder sync job IDs that were updated. */
  folderSyncJobIds: Array<Scalars['UUID']>;
  /** The updated folder sync job objects. */
  folderSyncJobs: Array<FolderSyncJob>;
};

/** Input for forwarding a document to external recipients. */
export type ForwardDocumentInput = {
  /** ID of the document to forward. */
  documentId: Scalars['UUID'];
  /** Optional message included in the forwarding notification. */
  message?: InputMaybe<Scalars['String']>;
  /** Email addresses of the recipients to forward the document to. */
  recipientEmails: Array<Scalars['EmailAddress']>;
};

/** Input for forwarding a workflow to external recipients. */
export type ForwardWorkflowInput = {
  /** Optional message to include in the forwarding notification. */
  message?: InputMaybe<Scalars['String']>;
  /** Email addresses of the recipients. */
  recipientEmails: Array<Scalars['EmailAddress']>;
  /** The workflow to forward. */
  workflowId: Scalars['UUID'];
};

/** Input for requesting an AI text completion on a document. */
export type GenerateAiCompletionInput = {
  /** The completion parameters including type, prompt, and selected text. */
  completionInput: CompletionInput;
  /** The document to generate the completion for. */
  documentId: Scalars['UUID'];
  /** Whether this is a retry of a previous completion (sends prior result for context). */
  isRetry: Scalars['Boolean'];
  /** The previous completion result, provided when isRetry is true so the AI can improve upon it. */
  priorCompletion?: InputMaybe<CompletionInput>;
};

export type GenerateMetadataImportTemplateResult = {
  __typename: 'GenerateMetadataImportTemplateResult';
  documentMetadataImport: DocumentMetadataImport;
  fileContent: Scalars['String'];
  fileName: Scalars['String'];
  templateVersion: Scalars['String'];
};

/** Input for granting access via batch */
export type GrantAccessByRequestInput = {
  /** List of grants (one per request) */
  grants: Array<AccessRequestGrant>;
};

/** A named collection of users within an organization, used for access control and label-based visibility */
export type Group = {
  __typename: 'Group';
  /** Hex color used to render the group's avatar */
  avatarColor: Scalars['String'];
  /** When true, members of this group can access all documents and workflows regardless of label restrictions */
  canAccessAllDocAndWorkflows: Scalars['Boolean'];
  /** Timestamp when the group was created */
  createdAt: Scalars['DateTime'];
  /** Timestamp when the group was soft-deleted, or null if still active */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the group */
  id: Scalars['UUID'];
  /** Labels assigned to this group, controlling which documents and workflows its members can access */
  labels: Array<Label>;
  /** Display name of the group */
  name: Scalars['String'];
  /** The organization this group belongs to */
  org: Org;
  /** Timestamp of the most recent update to the group */
  updatedAt: Scalars['DateTime'];
  /** Number of users currently in this group */
  userCount: Scalars['Int'];
  /** Users who are members of this group */
  users: Array<User>;
};

/** A group header row in grouped display mode (no document data). */
export type GroupHeaderRow = {
  __typename: 'GroupHeaderRow';
  /**
   * Number of immediate child rows this group expands into (distinct next-level
   * subgroups at an intermediate level). Drives the grid's getChildrenCount for
   * native nested lazy loading so intermediate groups aren't over-padded with
   * skeleton rows. Null at the deepest grouping level, where the immediate child
   * rows ARE the documents — readers fall back to documentCount.
   */
  childRowCount: Maybe<Scalars['Int']>;
  /** Number of documents under this group (the '(N)' shown in the header). */
  documentCount: Scalars['Int'];
  /**
   * The field being grouped (e.g., 'status'). Null when the group is keyed on a column outside the legacy enum.
   * @deprecated Use groupFieldId, which covers every report column. This field is null for columns outside the legacy enum.
   */
  groupField: Maybe<GroupableField>;
  /**
   * Identifier of the grouped column: a ReportColumnFileField name (e.g.
   * 'status') or an ExtractionQuestion UUID.
   */
  groupFieldId: Scalars['String'];
  /** The group key value (e.g., 'Signed' for status grouping). */
  groupKey: Scalars['String'];
  id: Scalars['ID'];
  parentTreeRowId: Maybe<Scalars['ID']>;
};

/**
 * Selected group path for per-group "select all" bulk actions. When set, the
 * action applies to every document in the group (groupFields x groupKeys, raw
 * key values), not just the currently-loaded rows. Combined with the filter.
 */
export type GroupSelectionInput = {
  /**
   * Column identifiers for each level of the selected group path - a
   * ReportColumnFileField name or an ExtractionQuestion UUID. Values from the
   * legacy GroupableField enum are valid identifiers, so clients built before
   * arbitrary-column grouping keep working unchanged.
   */
  groupFields: Array<Scalars['String']>;
  groupKeys: Array<Scalars['String']>;
  /**
   * IANA timezone the group keys were computed in. Required whenever a group
   * column is date-typed: those group by calendar day, so resolving membership in
   * a different zone moves documents across groups at the day boundary and applies
   * the action to the wrong ones. Enforced by the resolver rather than the schema
   * so that clients built before arbitrary-column grouping keep working - they can
   * only name the legacy GroupableField columns, none of which are dates, and a
   * non-null field here would fail input coercion on every already-open tab.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

/**
 * Legacy closed set of groupable fields. Superseded by the open String column
 * identifiers accepted by groupFieldIds - a ReportColumnFileField name or an
 * ExtractionQuestion UUID, the same identifier space used by filterModel.field
 * and sortModel.field. Kept only so operations built before arbitrary-column
 * grouping still validate against this schema; remove once no such clients remain.
 */
export enum GroupableField {
  /** Group rows by applied labels. */
  Labels = 'labels',
  /** Group rows by document owner. */
  Owner = 'owner',
  /** Group rows by associated party. */
  Parties = 'parties',
  /** Group rows by document status (e.g., Draft, Signed, Executed). */
  Status = 'status',
  /** Group rows by contract type. */
  Type = 'type'
}

/** Input for importing a community workflow into the requester's account. */
export type ImportCommunityWorkflowInput = {
  /** The community workflow to import. */
  workflowId: Scalars['UUID'];
};

/** Available column metadata for report automation context */
export type ImprovePromptColumnInput = {
  /** Display name of the column */
  displayName: Scalars['String'];
  /** Unique identifier of the column */
  id: Scalars['String'];
};

export enum ImprovePromptContext {
  /** Default context for the main AI chat editor */
  Chat = 'Chat',
  /** Context for AI reminder automation prompts */
  ReportAutomation = 'ReportAutomation'
}

/** Input for improvePrompt mutation */
export type ImprovePromptInput = {
  /** Available report columns to reference (for ReportAutomation context) */
  availableColumns?: InputMaybe<Array<ImprovePromptColumnInput>>;
  /** Context where the improve prompt is being used, affects the system prompt */
  context?: InputMaybe<ImprovePromptContext>;
  /** The original prompt text to improve */
  originalText: Scalars['String'];
  /** Unique request ID for tracking the improvement request */
  requestId: Scalars['UUID'];
};

/** Response from improvePrompt mutation */
export type ImprovePromptResponse = {
  __typename: 'ImprovePromptResponse';
  /** Unique request ID for tracking the improvement request */
  requestId: Scalars['UUID'];
};

/** Event emitted during prompt improvement streaming */
export type ImprovedPromptEvent = {
  __typename: 'ImprovedPromptEvent';
  /** The AI-improved prompt text (chunk during streaming, empty on end) */
  improvedText: Scalars['String'];
  /** Position in the stream (Stream for chunks, End for completion) */
  position: CompletionPosition;
  /** The request ID that was provided in the mutation */
  requestId: Scalars['UUID'];
  /** The user who requested the improvement */
  userId: Scalars['UUID'];
};

/** A notification shown in the header's bell to every member of the org. */
export type InboxNotification = {
  __typename: 'InboxNotification';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  kind: InboxNotificationKind;
  /** Kind-specific data, validated against the kind's schema on write. */
  payload: Scalars['JSON'];
  /** Whether the viewer has read it: by opening it, marking it read, or dismissing it. Opening the inbox alone does not. */
  read: Scalars['Boolean'];
  severity: InboxNotificationSeverity;
};

/** What an inbox notification is about; each kind has its own payload shape and dismiss rule. */
export enum InboxNotificationKind {
  /** A CRM connection needs an admin's attention. Resolves on its own once fixed; cannot be dismissed. */
  CrmConnectionIssue = 'CrmConnectionIssue',
  /** A CRM record linked to a workflow was deleted in the CRM. */
  CrmRecordDeleted = 'CrmRecordDeleted'
}

export enum InboxNotificationSeverity {
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning'
}

/** Signals that the org's notifications changed; clients refetch inboxNotifications. */
export type InboxNotificationsChangedEvent = {
  __typename: 'InboxNotificationsChangedEvent';
  orgId: Scalars['UUID'];
};

export type InboxNotificationsResult = {
  __typename: 'InboxNotificationsResult';
  /** Active notifications the viewer has not dismissed, newest first. */
  items: Array<InboxNotification>;
  unreadCount: Scalars['Int'];
};

/** Input for creating a new workflow from one or more documents. */
export type InitializeWorkflowInput = {
  assigneeIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Documents to include in the new workflow. */
  documentIds: Array<Scalars['UUID']>;
  /** Optional workflow properties. */
  props?: InputMaybe<InitializeWorkflowProps>;
};

/** Optional properties when initializing a new workflow. */
export type InitializeWorkflowProps = {
  /** Board column to place the workflow in. */
  columnId?: InputMaybe<Scalars['UUID']>;
  /** Description for the new workflow. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether to create as a template (true) or contract (false). */
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  /** Name for the new workflow. */
  name?: InputMaybe<Scalars['String']>;
  /** Initial priority level. */
  priority?: InputMaybe<WorkflowPriority>;
  /** Skip Triage on launch (templates / STP). */
  skipTriage?: InputMaybe<Scalars['Boolean']>;
};

/** A Chart pinned to Insights (references a Chart id on a Workflow View). */
export type InsightPin = {
  __typename: 'InsightPin';
  /** Key in view.state.chartsIntegration.charts. */
  chartId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  /** Grid placement on Insights. */
  layout: Scalars['JSON'];
  /** Owning organization. */
  org: Org;
  /** Pin creator. */
  owner: User;
  /** Personal or org Insights board. */
  scope: InsightScope;
  /** Order among Pins on the board. */
  sortOrder: Scalars['Int'];
  /** Product-authored System preset this editable workspace Chart was created from. */
  sourceSystemPresetId: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /** Workflow View that owns the Chart. */
  view: WorkflowView;
};

export type InsightPinResponse = {
  __typename: 'InsightPinResponse';
  insightPin: Maybe<InsightPin>;
};

/** Visibility scope for Insight Pins. */
export enum InsightScope {
  /** Published to the organization Insights board / library. */
  Org = 'ORG',
  /** Visible only to the user who created it. */
  Personal = 'PERSONAL'
}

/** Usually we have either userId or email, not both.  Email is provided when the requester maps a role to an external email. */
export type InstanceAssignmentInput = {
  /** Email of an external party to assign. Mutually exclusive with userId. */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Permission level to grant the assignee on the document. */
  permissionRole?: InputMaybe<PermissionRole>;
  /** The user-defined role to assign. */
  userDefinedRoleId: Scalars['UUID'];
  /** ID of an existing user to assign. Mutually exclusive with email. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A launched-instance snapshot of an intake form, with collected values. */
export type IntakeForm = {
  __typename: 'IntakeForm';
  /** When the form was completed; null until complete. Readiness gates on this. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** User who completed the form, if completed. */
  completedBy: Maybe<User>;
  /** Snapshot of the default values at launch time. */
  defaultValues: Scalars['JSON'];
  /** Snapshot of the description at launch time. */
  description: Scalars['String'];
  /** Snapshot of the form definition at launch time (zod-parsed server-side). */
  formDefinition: Scalars['JSON'];
  /** Primary identifier for the intake form instance. */
  id: Scalars['UUID'];
  /** Document ids referenced by file upload values whose document has been permanently deleted. A trashed document still exists and is not listed. */
  missingFileDocumentIds: Array<Scalars['UUID']>;
  /** Snapshot of the schema version at launch time. */
  schemaVersion: Scalars['Int'];
  /** The template this snapshot was copied from, if still present. */
  sourceIntakeFormTemplateId: Maybe<Scalars['UUID']>;
  /** Snapshot of the title at launch time. */
  title: Scalars['String'];
  /** Collected values for the form, keyed by field name. */
  values: Scalars['JSON'];
  /** The launched (instance) workflow this form belongs to. */
  workflowId: Scalars['UUID'];
};

/** Wrapper returned by intake form instance mutations. */
export type IntakeFormResponse = {
  __typename: 'IntakeFormResponse';
  /** The created or updated intake form instance. */
  intakeForm: IntakeForm;
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
  /** The owning launched workflow, so derived fields (e.g. isReadyForSignature) refresh in the cache. */
  workflow: Workflow;
};

/** A reusable intake form definition that can be attached to template workflows. */
export type IntakeFormTemplate = {
  __typename: 'IntakeFormTemplate';
  /** Template workflows this reusable form is attached to (drives the shared-use warning). */
  attachedWorkflows: Array<Workflow>;
  /** Created at - ISO 8601 */
  createdAt: Scalars['DateTime'];
  /** Default values for the form fields, keyed by field name. */
  defaultValues: Scalars['JSON'];
  /** Optional longer description. */
  description: Scalars['String'];
  /** Structured form field definition (zod-parsed server-side; never typed as any). */
  formDefinition: Scalars['JSON'];
  /** Primary identifier for the intake form template. */
  id: Scalars['UUID'];
  /** Owning organization. */
  orgId: Scalars['UUID'];
  /** User who owns this template. */
  owner: User;
  /** Schema version of the formDefinition payload. */
  schemaVersion: Scalars['Int'];
  /** Display title. */
  title: Scalars['String'];
  /** Updated at - ISO 8601 */
  updatedAt: Scalars['DateTime'];
};

/** Wrapper returned by intake form template mutations. */
export type IntakeFormTemplateResponse = {
  __typename: 'IntakeFormTemplateResponse';
  /** The created or updated intake form template. */
  intakeFormTemplate: IntakeFormTemplate;
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
};

/** Supported CRM integrations that can auto-populate document variable values. */
export enum Integration {
  /** Act! CRM */
  Act = 'Act',
  /** ActiveCampaign CRM */
  ActiveCampaign = 'ActiveCampaign',
  /** Close CRM */
  Close = 'Close',
  /** Copper CRM */
  Copper = 'Copper',
  /** HubSpot CRM */
  HubSpot = 'HubSpot',
  /** Microsoft Dynamics 365 CRM */
  MicrosoftDynamics = 'MicrosoftDynamics',
  /** Pipedrive CRM */
  Pipedrive = 'Pipedrive',
  /** Salesforce CRM */
  SalesForce = 'SalesForce',
  /** Salesflare CRM */
  Salesflare = 'Salesflare',
  /** Teamleader CRM */
  Teamleader = 'Teamleader',
  /** Zendesk Sell CRM */
  ZendeskSell = 'ZendeskSell',
  /** Zoho CRM */
  ZohoCrm = 'ZohoCRM'
}

/** A field from a CRM integration record (e.g., Salesforce opportunity). */
export type IntegrationField = {
  __typename: 'IntegrationField';
  /** Section or group this field belongs to in the CRM layout. */
  category: CrmIntegrationCategory;
  /** CRM field API name (e.g. Amount, dealname). Null when the path has no native CRM field. */
  fieldApiName: Maybe<Scalars['String']>;
  /** Picker group header derived from the CRM category. */
  groupDisplayName: Scalars['String'];
  /** Picker group sort index. Lower values sort first. */
  groupSortIndex: Scalars['Int'];
  /** Whether field is custom field. */
  isCustom: Scalars['Boolean'];
  /** Salesforce object type for this field identity. Null when the path is not Salesforce-mappable. */
  objectType: Maybe<SalesforceFieldObjectType>;
  /** Dot-notation path to this field in the CRM record. */
  path: Scalars['String'];
  /** Id of the linked CRM record this field is read from (Salesforce Account / Opportunity / User, HubSpot deal / company / owner). Null when no linked record. */
  recordId: Maybe<Scalars['String']>;
  /** The title is the key in a human-readable first-letter-capitalized format. */
  title: Scalars['String'];
  /** The type of field i.e., string, boolean etc. */
  type: IntegrationFieldType;
  /** The raw string value of the field, or null if unset. */
  value: Maybe<Scalars['String']>;
  /** Whether the value could be read from the CRM at all. A null value only means empty when this is AVAILABLE. */
  valueStatus: IntegrationFieldValueStatus;
  /** The variant of the field. */
  variant: IntegrationFieldVariant;
};

/** Identifies a specific field within a CRM opportunity for data retrieval. */
export type IntegrationFieldInput = {
  /** CRM-native identifier of the opportunity containing the field. */
  opportunityId: Scalars['String'];
  /** Dot-notation path to the field within the opportunity record (e.g., 'monetary_amount'). */
  path: Scalars['String'];
  /** Service identifier for the CRM integration (e.g., 'hubspot'). */
  serviceId: Scalars['String'];
};

/** Data type of a CRM integration field value. */
export enum IntegrationFieldType {
  /** List of values. */
  Array = 'Array',
  /** True/false value. */
  Boolean = 'Boolean',
  /** Numeric value (integer or decimal). */
  Number = 'Number',
  /** Text value. */
  String = 'String'
}

/**
 * Whether a field value could be read from the CRM. Distinguishes an empty CRM field from one
 * Aline never managed to read (query rejected, record not visible, or no SOQL plan for the column).
 */
export enum IntegrationFieldValueStatus {
  /** The CRM was queried successfully, so the value reflects the record (possibly empty). */
  Available = 'AVAILABLE',
  /** The value could not be read, so it is null regardless of what the CRM holds. */
  Unavailable = 'UNAVAILABLE'
}

export enum IntegrationFieldVariant {
  /** A CRM-native field from the provider's own catalog (Salesforce Describe/Layout, HubSpot properties; native.* path). */
  Native = 'NATIVE',
  /** An Apideck unified field (CRM-agnostic path, e.g. opportunity.title). */
  Unified = 'UNIFIED'
}

/** Link between a document variable and a CRM integration field, enabling auto-population of values from external systems. */
export type IntegrationLink = {
  __typename: 'IntegrationLink';
  /** the path of the value (e.g., opportunity.company.name). */
  attributePath: Maybe<Scalars['String']>;
  /** The integration (e.g. Hubspot or Salesforce). */
  integration: Maybe<Integration>;
};

/** The sync operation type for a folder sync job. */
export enum JobType {
  /** Sync files from the cloud storage provider into Aline. */
  Sync = 'Sync',
  /** Remove the sync relationship and stop tracking files from the provider. */
  Unsync = 'Unsync'
}

/** A reusable tag that can be applied to workflows and documents for categorization */
export type Label = {
  __typename: 'Label';
  /** Unique identifier for this label */
  id: Scalars['UUID'];
  /** The text of the label. */
  labelText: Scalars['String'];
  /** Workflows which use this label that are available to the user. */
  workflows: Array<Workflow>;
};

/** The state of a label for a set of documents. */
export type LabelWithDocumentState = {
  __typename: 'LabelWithDocumentState';
  /** Unique identifier for this label */
  id: Scalars['UUID'];
  /** Display text of the label */
  labelText: Scalars['String'];
  /** Whether this label is applied to all, none, or some of the queried documents */
  state: DocumentLabelState;
};

export type LaunchConfigFile = {
  __typename: 'LaunchConfigFile';
  /** Document created for a public launch intake upload. */
  documentId: Scalars['UUID'];
  /** Original uploaded filename. */
  name: Scalars['String'];
};

export type LaunchConfigForm = {
  __typename: 'LaunchConfigForm';
  /** Aline-only document fields enabled for the launch form. */
  alineFields: Array<AlineTemplateField>;
  /** Template documents referenced by launch-form fields. */
  documentsList: Array<TemplateDocument>;
  /** Optional intake form definition and defaults. */
  intakeForm: Maybe<LaunchConfigIntakeForm>;
};

export type LaunchConfigIntakeForm = {
  __typename: 'LaunchConfigIntakeForm';
  /** Values prefilled when the form opens. */
  defaultValues: Scalars['JSON'];
  /** Structured field definition. */
  formDefinition: Scalars['JSON'];
  /** Display title for the intake section. */
  title: Scalars['String'];
};

/** Input for launching a workflow instance via a public launch config. */
export type LaunchWorkflowViaConfigInput = {
  /** Values for Aline-only document fields. */
  alineFieldValues?: InputMaybe<Array<AlineFieldValueInput>>;
  /** Values for the template's intake form. */
  intakeFormValues?: InputMaybe<Scalars['JSON']>;
  /** The launch config to use. */
  launchConfigId: Scalars['UUID'];
  /** Assignments for each placeholder role defined in the config. */
  placeholderAssignments: Array<PlaceholderAssignmentInput>;
  /** Company name of the external user. */
  requesterCompanyName: Scalars['String'];
  /** Email of the external user launching the workflow. */
  requesterEmail: Scalars['EmailAddress'];
  /** Optional note from the external user. */
  requesterNote?: InputMaybe<Scalars['String']>;
};

export type LaunchWorkflowViaConfigResponse = {
  __typename: 'LaunchWorkflowViaConfigResponse';
  /** The launched workflow. */
  workflow: Workflow;
};

/** A link between a workflow and an external CRM opportunity. */
export type LinkedOpportunity = {
  __typename: 'LinkedOpportunity';
  /** User who created this opportunity link. */
  author: User;
  /** Created at - ISO 8601 */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Primary identifier for this link. */
  id: Scalars['UUID'];
  /** The integration source of the opportunity. */
  integration: Integration;
  /** External identifier of the opportunity in the CRM system. */
  opportunityId: Scalars['String'];
  /**
   * CRM display name of the opportunity, stored when the link is created so it
   * survives a disconnected CRM. Null until the name has been read once, or when
   * the CRM never returned one.
   */
  opportunityName: Maybe<Scalars['String']>;
  /** Updated at - ISO 8601 */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** The workflow this opportunity is linked to. */
  workflow: Workflow;
};

/** Input for linking a workflow to a CRM opportunity. */
export type LinkedOpportunityInput = {
  /** Which CRM integration the opportunity belongs to. */
  integration: Integration;
  /** External identifier of the opportunity in the CRM. */
  opportunityId: Scalars['String'];
  /** The workflow to link. */
  workflowId: Scalars['UUID'];
};

/** Streamed event indicating the agent is processing and thinking */
export type LoadingEvent = {
  __typename: 'LoadingEvent';
  /** ID of the message being generated */
  messageId: Scalars['UUID'];
  /** Human-readable description of what the agent is currently doing */
  thinkingMessage: Scalars['String'];
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** ID of the user who initiated the agent prompt */
  userId: Scalars['UUID'];
};

/** How the user authenticates when logging in */
export enum LoginType {
  /** Traditional email and password authentication */
  Password = 'PASSWORD',
  /** Magic-link authentication without a password */
  Passwordless = 'PASSWORDLESS'
}

/** Result of checking whether a template or workflow may be published to the community */
export type MayPublishToCommunityResult = {
  __typename: 'MayPublishToCommunityResult';
  /** Reasons publishing is blocked, empty when ok is true */
  errorMsgs: Array<Scalars['String']>;
  /** True if publishing is allowed */
  ok: Scalars['Boolean'];
};

/** An @-mention of a user within a comment, used to notify them and track engagement */
export type Mention = {
  __typename: 'Mention';
  /** The comment containing this mention */
  comment: Comment;
  /** When the mention was created */
  createdAt: Scalars['DateTime'];
  /** Soft-delete timestamp, set when the parent comment is removed */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier */
  id: Scalars['UUID'];
  /** The user who was @-mentioned */
  mentionedUser: User;
  /** Whether the mentioned user has read the notification */
  notificationRead: Scalars['Boolean'];
  /** When the mentioned user was notified, or null if notification hasn't been sent yet */
  notifiedAt: Maybe<Scalars['DateTime']>;
  /** When the mention was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Error returned when a mentioned entity cannot be hydrated. */
export type MentionAccessError = {
  __typename: 'MentionAccessError';
  /** Mentioned entity ID. */
  id: Scalars['UUID'];
  /** Reason why the mentioned entity is not accessible. */
  reason: MentionAccessErrorReason;
};

/** Reason why a mention entity is not accessible in AI Chat. */
export enum MentionAccessErrorReason {
  /** Mentioned entity has been deleted or no longer exists. */
  Deleted = 'DELETED',
  /** User does not have permission to access the mentioned entity. */
  NoAccess = 'NO_ACCESS'
}

export type MentionEntitiesInput = {
  /** Document IDs to hydrate. Selection mentions should contribute their document ID here. */
  documentIds: Array<Scalars['UUID']>;
  /** Playbook IDs to hydrate. */
  playbookIds: Array<Scalars['UUID']>;
  /** Report IDs to hydrate. */
  reportIds: Array<Scalars['UUID']>;
  /** Skill version IDs to hydrate, from the skill loads in chat messages. */
  skillVersionIds: Array<Scalars['UUID']>;
  /** Workflow task IDs to hydrate. */
  taskIds: Array<Scalars['UUID']>;
  /** Workflow IDs to hydrate. */
  workflowIds: Array<Scalars['UUID']>;
};

/** Hydrated entities used to render chat mention chips. */
export type MentionEntitiesResult = {
  __typename: 'MentionEntitiesResult';
  /** Document access results preserve deleted/no-access states for chat validation. */
  documents: Array<DocumentMentionAccessResult>;
  /** Playbooks referenced by chat mentions, or access errors. */
  playbooks: Array<PlaybookMentionAccessResult>;
  /** Reports referenced by chat mentions, or access errors. */
  reports: Array<ReportMentionAccessResult>;
  /** Skill versions referenced by chat messages, or access errors. */
  skillVersions: Array<SkillVersionMentionAccessResult>;
  /** Workflow tasks referenced by chat mentions, or access errors. */
  tasks: Array<TaskMentionAccessResult>;
  /** Workflows referenced by chat mentions, or access errors. */
  workflows: Array<WorkflowMentionAccessResult>;
};

/** Returned cursor for continuing a single mention entity search group. */
export type MentionEntitySearchCursor = {
  __typename: 'MentionEntitySearchCursor';
  /** Last entity ID returned for that type. */
  id: Scalars['UUID'];
  /** Entity type this cursor belongs to. */
  type: MentionEntitySearchType;
};

/** Cursor for continuing a single mention entity search group. */
export type MentionEntitySearchCursorInput = {
  /** Last entity ID returned for that type. */
  id: Scalars['UUID'];
  /** Entity type this cursor belongs to. */
  type: MentionEntitySearchType;
};

/** One grouped page of mention search results for a requested entity type. */
export type MentionEntitySearchGroup = {
  __typename: 'MentionEntitySearchGroup';
  /** Pagination state for this entity type. */
  pageInfo: MentionEntitySearchPageInfo;
  /** Entities for this page. */
  results: Array<MentionEntitySearchResult>;
  /** Total matches for this entity type before pagination. */
  totalCount: Scalars['Int'];
  /** Entity type represented by this group. */
  type: MentionEntitySearchType;
};

/** Page information for a mention search group. */
export type MentionEntitySearchPageInfo = {
  __typename: 'MentionEntitySearchPageInfo';
  /** Whether this group has more results after the current page. */
  hasMore: Scalars['Boolean'];
  /** Cursor to pass back when fetching the next page for this group. */
  nextCursor: Maybe<MentionEntitySearchCursor>;
};

/** Search result item returned by mention discovery. */
export type MentionEntitySearchResult = Document | Playbook | Report | User | Workflow;

/** Entity types that can be discovered through the unified mention picker. */
export enum MentionEntitySearchType {
  Document = 'DOCUMENT',
  Playbook = 'PLAYBOOK',
  Report = 'REPORT',
  User = 'USER',
  Workflow = 'WORKFLOW'
}

/** Input for merging multiple parties into one. All document and workflow associations from source parties are transferred to the target. */
export type MergePartiesInput = {
  /** IDs of the parties to merge from (these will be deleted after merge). */
  sourcePartyIds: Array<Scalars['UUID']>;
  /** ID of the party to merge into (this one survives). */
  targetPartyId: Scalars['UUID'];
};

/** Input for merging multiple roles into one, consolidating all references */
export type MergeRolesInput = {
  /** IDs of the roles to merge into the target */
  sourceRoleIds: Array<Scalars['UUID']>;
  /** ID of the role that will absorb the source roles */
  targetRoleId: Scalars['UUID'];
};

/** Input for merging multiple contract types into a single target */
export type MergeTypesInput = {
  /** Contract types to merge into the target; these will be deleted */
  sourceTypeIds: Array<Scalars['UUID']>;
  /** The contract type that will absorb the source types */
  targetTypeId: Scalars['UUID'];
};

/** Input for merging multiple variable configs into a single target config. All variables linked to source configs are re-linked to the target. */
export type MergeVariableConfigsInput = {
  /** IDs of the configs to merge from (these will be deleted after merge). */
  sourceConfigIds: Array<Scalars['UUID']>;
  /** ID of the config to merge into (this one survives). */
  targetConfigId: Scalars['UUID'];
};

/** Review status of AI-generated suggested edits within a message */
export enum MessageSuggestionStatus {
  /** Suggestion was accepted and applied to the document */
  Accepted = 'ACCEPTED',
  /** Suggestion is awaiting user review */
  Pending = 'PENDING',
  /** Suggestion was redlined (marked up with changes) by the user */
  Redlined = 'REDLINED',
  /** Suggestion was rejected by the user */
  Rejected = 'REJECTED'
}

export type MetadataImportOperationResult = {
  __typename: 'MetadataImportOperationResult';
  documentMetadataImport: DocumentMetadataImport;
};

/** Input type for a document variable field, determining the UI control and validation. */
export enum MetadataVariant {
  /** Checkbox group input. */
  Checkbox = 'Checkbox',
  /** Currency input with an optional prefix symbol (e.g., $, €). */
  Currency = 'Currency',
  /** Date picker input. */
  Date = 'Date',
  /** Decimal number input. */
  Decimal = 'Decimal',
  /** Email address input with format validation. */
  Email = 'Email',
  /** Dropdown select from a list of predefined options. */
  Options = 'Options',
  /** Radio button group from a list of predefined options. */
  RadioOptions = 'RadioOptions',
  /** Free-text input. */
  Text = 'Text'
}

/** Type of action missing from a workflow before it can proceed. */
export enum MissingActionType {
  /** A document-content completion action is missing. */
  CompleteDocumentContent = 'Complete_Document_Content',
  /** A signature field assignment is missing. */
  Signature = 'Signature'
}

/** A workflow action that has not yet been assigned to a collaborator. */
export type MissingWorkflowAction = {
  __typename: 'MissingWorkflowAction';
  /** The user currently assigned to this action, if any. */
  assignee: Maybe<User>;
  /** The role assigned to this action, if any. */
  assigneeRole: Maybe<UserDefinedRole>;
  /** Whether this is a signature or document-content action. */
  type: MissingActionType;
};

export type MoveColumnInput = {
  columnId: Scalars['UUID'];
  /** Column that the moved column was dropped onto; must be same board and category */
  targetColumnId: Scalars['UUID'];
};

/** Input for moving one category within its playbook. */
export type MovePlaybookRuleCategoryInput = {
  /** ID of the category to move. */
  categoryId: Scalars['UUID'];
  /**
   * Zero-based position among the playbook's other categories, excluding the
   * one being moved.
   */
  toIndex: Scalars['Int'];
};

/** Input for moving a rule within or between the categories of one playbook. */
export type MovePlaybookRuleInput = {
  /** Category to file the rule under. Must belong to the rule's playbook. */
  categoryId: Scalars['UUID'];
  /** ID of the rule to move. */
  ruleId: Scalars['UUID'];
  /**
   * Zero-based position among the target category's other rules, excluding the
   * one being moved.
   */
  toIndex: Scalars['Int'];
};

/** Input for moving some of a rule's positions without restating the others. */
export type MovePlaybookRulePositionsInput = {
  /**
   * The position the group lands directly after. Pass null to move the group to
   * the front, which makes its first entry the rule's new starting position. Must
   * name a position of this rule that is not itself being moved.
   */
  afterPositionId?: InputMaybe<Scalars['UUID']>;
  /**
   * The positions to move, in the order they should end up in. They land as one
   * contiguous group; any position not named here keeps the rank it has.
   */
  positionIds: Array<Scalars['UUID']>;
  /** ID of the rule that owns the positions. */
  ruleId: Scalars['UUID'];
};

/** Input for moving multiple storables to a new parent folder */
export type MoveStorables = {
  /** ID of the destination parent folder */
  newParentId: Scalars['UUID'];
  /** IDs of the storables to move */
  storableIds: Array<Scalars['UUID']>;
};

/** Input for moving actions between workflow steps. */
export type MoveWorkflowStepActionsInput = {
  /** Where to place the actions relative to the target step. */
  actionPlacement: ActionPlacement;
  /** Target step to move actions to. Required for BEFORE_STEP and AFTER_STEP placements. */
  targetStepId?: InputMaybe<Scalars['UUID']>;
  /** The workflow containing the actions. */
  workflowId: Scalars['UUID'];
  /** IDs of the actions to move. */
  workflowStepActionIds: Array<Scalars['UUID']>;
};

/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type Mutation = {
  __typename: 'Mutation';
  /** Accept or reject individual questions produced by a generation job. */
  acceptGeneratedQuestions: ExtractionQuestionGenerationJob;
  /** Approve a pending AI-generated reminder, making it active */
  acceptReminder: Reminder;
  /** Batch-approve multiple pending AI-generated reminders */
  acceptReminders: Array<Reminder>;
  /** Add storables to a Workflow. */
  addDocumentsToWorkflow: WorkflowResponse;
  /** Add a member to an org. */
  addOrgMember: UserResponse;
  /** Add a Party to a Document. */
  addPartyToDocument: Party;
  /** Append a fallback position to a rule. Returns the rule with its updated positions. */
  addPlaybookRulePosition: PlaybookRule;
  /** Add a new selectable option to a Single/Multi select question. */
  addQuestionOption: QuestionOption;
  /** Add new selectable options to a Single/Multi select question. */
  addQuestionOptions: Array<QuestionOption>;
  /** Add to User's recently-accessed Documents. */
  addToRecentlyAccessedDocuments: UserResponse;
  /**
   * Add the Triage column to a board, or return the board unchanged if it already has one.
   * Removing Triage is deleteColumn, which asks where the workflows waiting in it should go.
   */
  addTriageColumn: Board;
  /** Add one or more users to an existing group */
  addUsersToGroup: Group;
  /** Add workflow assignments to a given workflow */
  addWorkflowPermissions: Array<WorkflowPermission>;
  addWorkflowViewChart: WorkflowViewResponse;
  /**
   * Apply a signed PDF to a workflow document while signing outside Aline,
   * either from a computer upload or by copying a standalone repository PDF
   * and permanently deleting the source document.
   */
  applySignedVersionOutsideAline: FileVersionResponse;
  /** As a reviewer, approve the task. It completes once every required reviewer, or any one when none is required, approves. */
  approveTask: TaskResponse;
  /** Attach an intake form template to a template workflow. */
  attachIntakeFormTemplate: WorkflowIntakeFormTemplateResponse;
  autoSaveAgentSkillDraft: AgentSkillResponse;
  /** Accept multiple relationships in bulk. Supports document IDs (resolves children), relationship IDs, and runAll. */
  bulkConfirmDocumentRelationships: BulkReviewRelationshipsResponse;
  /** Create multiple document relationships in a single transaction. One row per distinct (parentDocumentId, childDocumentId); duplicate items are merged (last relationship type wins). */
  bulkCreateDocumentRelationships: Array<DocumentRelationship>;
  /** Create multiple folder sync jobs in bulk. */
  bulkCreateFolderSyncJobs: BulkCreateFolderSyncJobResult;
  /** Bulk delete parties. */
  bulkDeleteParties: Array<Scalars['UUID']>;
  /** Reject multiple relationships in bulk. Same input semantics as bulkConfirmDocumentRelationships. */
  bulkRejectDocumentRelationships: BulkReviewRelationshipsResponse;
  /** Bulk set label for documents. */
  bulkSetDocumentLabels: UpdateDocumentsResponse;
  /** Cancel an in-flight bulk export. No-op for already-terminal rows. */
  cancelBulkExport: BulkExport;
  /**
   * Stop a background status change. Chunks already running finish and the rest are left
   * unchanged. Documents already updated keep their new status. False when nothing was running.
   */
  cancelDocumentStatusJob: Scalars['Boolean'];
  /** Cancel run of all provided ExtractionQuestions. */
  cancelExtractionJobs: Array<ExtractionQuestion>;
  /** Cancel an in-progress playbook generation job. Returns the cancelled job's ID. */
  cancelPlaybookGenerationJob: Scalars['UUID'];
  /**
   * Stop a playbook's in-flight rules on a document. Rules that already finished
   * keep their results; the ones still running are discarded and read as never
   * run.
   */
  cancelPlaybookRuleJobs: Playbook;
  /** Cancel an in-progress question generation job. Returns the cancelled job's ID. */
  cancelQuestionGenerationJob: Scalars['UUID'];
  /** Cancel an open upgrade request. */
  cancelUpgradeRequest: UpgradeRequest;
  /** Cancel an active AI workflow build while preserving generated content. */
  cancelWorkflowAiBuild: Workflow;
  /** Change the assignment (user/role) of a workflow collaborator. */
  changeCollaboratorAssignment: WorkflowPermission;
  /** Change the type of multiple documents. */
  changeDocumentsType: UpdateDocumentsResponse;
  /** Change the action type (signer/carbon copy) for a recipient. */
  changeRecipientAction: WorkflowRecipient;
  /** Reassign a recipient action to a different workflow collaborator. */
  changeRecipientAssignment: WorkflowRecipient;
  /** Toggle a task between completed and incomplete states. */
  changeTaskStatus: TaskResponse;
  /** Change user's role in an org */
  changeUserOrgRole: UserResponse;
  /**
   * Clear a rule's resolution, reopening it for review. Clearing a Reviewed
   * resolution also forgets the position's rejected decisions — accepted ones
   * are permanent, their edits being the reviewer's own document changes.
   */
  clearPlaybookRuleJobResolution: PlaybookRuleJob;
  /** Discard a pending task upload. It never reached version history, so nothing else changes. Allowed for the assignee it belongs to or the internal editor who uploaded it. */
  clearTaskUpload: TaskResponse;
  /** Whatever actions are unused in a workflow, delete them. */
  clearUnusedWorkflowActions: WorkflowResponse;
  /** As an internal workflow editor, record another person's part this round: an approval for a reviewer, a review request or completion for an assignee. */
  completeTaskForAssignee: TaskResponse;
  /** Confirm a document relationship suggested by AI. */
  confirmDocumentRelationship: DocumentRelationship;
  confirmMetadataImport: MetadataImportOperationResult;
  /** Start authorization for one external toolkit. */
  connectExternalToolkit: ExternalToolkitConnectRequest;
  /** Continue an agent response after the client patches AI SDK tool approval state */
  continueAgentChat: AgentResponse;
  /** Duplicates document with new parameters. */
  copyDocument: DocumentResponse;
  /** Create a new AI reminder automation linked to a report */
  createAIReminderAutomation: AiReminderAutomation;
  createAgentSkill: AgentSkillResponse;
  /** Add a new choice to an existing answer option set. */
  createAnswerOption: AnswerOptionResponse;
  /** Create a new answer option set, optionally saving it as a reusable preset. */
  createAnswerOptions: AnswerOptionsResponse;
  /** Create a new ApiDeck Vault session token for configuring connections in the embedded UI. */
  createApiDeckSession: ApiDeckSession;
  /**
   * Create a new API key for the authenticated organization. Admin only.
   * The value field in the response contains the full key and is only returned once.
   */
  createApiKey: CreateApiKeyResponse;
  /** Create billing session URL to redirect to billing portal. */
  createBillingSessionUrl: Scalars['String'];
  /** Create a new board in the current user's organization */
  createBoard: Board;
  /**
   * Place a new canned field in a workflow. If a canned field of the same
   * variant and assignee already exists for this workflow, the existing row
   * is returned — canned fields dedupe across documents.
   */
  createCannedField: CannedFieldResponse;
  /** Create a new checkout URL for the user to subscribe to an Aline subscription. */
  createCheckoutUrl: Scalars['String'];
  /** Create a close order URL to close an open order. */
  createCloseOrderUrl: Scalars['String'];
  /** Create a new column on a board */
  createColumn: Column;
  /** Create a comment */
  createComment: CommentResponse;
  /** Create a new community category for organizing shared templates and workflows */
  createCommunityCategory: CommunityCategory;
  /** Create one or more new contract types in bulk */
  createContractTypes: Array<ContractType>;
  /** Creates a Document that has a file as its single version. */
  createDocFile: Document;
  /** Create an Aline document. */
  createDocument: DocumentResponse;
  /** Create (or upsert) a parent-child document relationship and mark it as confirmed by the requester. */
  createDocumentRelationship: DocumentRelationship;
  /** Creates a new Envelope record */
  createDraftEnvelope: Envelope;
  /** Create Example Report */
  createExampleReport: UserSettings;
  /** Create an ExtractionJob. */
  createExtractionJob: ExtractionQuestion;
  /** Create a new extraction question. */
  createExtractionQuestion: ExtractionQuestion;
  /** Creates a file location. */
  createFileLocations: Array<DocFile>;
  /** Create Documents that have a file as their single version. */
  createFiles: Array<Document>;
  /** Creates intake-upload documents owned by the launch config owner. */
  createFilesViaLaunchConfig: Array<LaunchConfigFile>;
  /** Create a new group with an initial set of members */
  createGroup: Group;
  createInsightPin: InsightPinResponse;
  /** Create a reusable intake form template. */
  createIntakeFormTemplate: IntakeFormTemplateResponse;
  /** Create a new org. */
  createOrg: OrgResponse;
  /** Create a new Party. */
  createParty: Party;
  /** Add a new phase to a workflow. Defaults to a non-signing phase unless isSigning is true. */
  createPhase: PhaseResponse;
  /** Create a new playbook, optionally seeded with categorized rules. */
  createPlaybook: Playbook;
  /** Create a rule at the end of a category. */
  createPlaybookRule: PlaybookRule;
  /** Create a category at the end of a playbook. Names need not be unique within a playbook. */
  createPlaybookRuleCategory: PlaybookRuleCategory;
  /** Create a Reminder. */
  createReminder: Reminder;
  /** Create an Aline report. */
  createReport: ReportResponse;
  /** Create a new signature field and associate it with a document and workflow recipient */
  createSignatureField: SignatureField;
  /** Create a new static file version from an uploaded file */
  createStaticFileVersion: FileVersionResponse;
  /** Create multiple static file versions from uploaded files in a single operation */
  createStaticFileVersions: Array<FileVersion>;
  /** Create a new task and optionally assign it to a user, role, or external email. */
  createTask: TaskResponse;
  /** Add a new form field to a task. */
  createTaskField: TaskFieldResponse;
  /** Create a user. */
  createUser: UserResponse;
  /** Create a new user-defined role in the requesting user's organization */
  createUserDefinedRole: UserDefinedRoleResponse;
  /** Create DocumentVariable. */
  createVariable: DocumentVariable;
  /** Create variable config. */
  createVariableConfig: DocumentVariableConfig;
  /** Launch a Workflow. */
  createWorkflowInstance: WorkflowResponse;
  /** Create a workflow launch config. */
  createWorkflowLaunchConfig: WorkflowResponse;
  /** Create an WorkflowRecipient in a given Workflow. */
  createWorkflowRecipient: WorkflowResponse;
  createWorkflowView: WorkflowViewResponse;
  /** Writes the field edits to the CRM, then launches the template linked to the Opportunity. The edits are rolled back if the launch fails. */
  crmLaunchWorkflow: Maybe<CrmLaunchWorkflowResponse>;
  declineSignatureReminders: WorkflowRecipient;
  /** Soft-delete an AI reminder automation, optionally deleting generated reminders */
  deleteAIReminderAutomation: Scalars['UUID'];
  deleteAgentSkill: DeleteAgentSkillResponse;
  /** Permanently delete an agent thread and all its messages */
  deleteAgentThread: Scalars['UUID'];
  /** Delete all annotations for a file version. Returns the deleted annotation record ID. */
  deleteAnnotations: Scalars['UUID'];
  /** Remove an answer option. Returns the deleted option's UUID. */
  deleteAnswerOption: Scalars['UUID'];
  /** Remove an answer option set. Returns the deleted set's UUID. */
  deleteAnswerOptions: Scalars['UUID'];
  /** Permanently delete a board and return its ID */
  deleteBoard: Scalars['UUID'];
  /** Soft-delete a canned field. Its Slate elements should be removed by the client in the same transaction. */
  deleteCannedField: CannedFieldResponse;
  /**
   * Delete a column and return its ID. Workflows and phase homes referencing this column move to
   * targetColumnId, which must be a column the delete offers: the same category while the category
   * has another column, otherwise the categories that can absorb the emptied one. Deleting Triage
   * this way is how a board turns triage off.
   */
  deleteColumn: Scalars['UUID'];
  /** Delete a comment by its id */
  deleteComment: CommentResponse;
  /** Disconnect and remove a CRM service connection by its service ID. */
  deleteConsumerConnection: ApiDeckConsumer;
  /** Delete a ContractType.  Returns the ContractType that the deleted ContractType is merged into. */
  deleteContractType: ContractType;
  /** Permanently remove the DocuSign integration for the current org. */
  deleteDocuSignIntegration: DocuSignIntegratedResponse;
  /** Delete a document relationship entirely. */
  deleteDocumentRelationship: Scalars['UUID'];
  /** Delete Documents in bulk. */
  deleteDocuments: BulkDocumentActionResponse;
  /** Permanently delete an extraction question. Returns the deleted question's ID. */
  deleteExtractionQuestion: Scalars['UUID'];
  /** Permanently delete a file version by ID */
  deleteFileVersion: Scalars['UUID'];
  /** Soft-deletes unsubmitted intake-upload documents created through this launch config. */
  deleteFilesViaLaunchConfig: Array<Scalars['UUID']>;
  /** Delete multiple folder sync jobs. */
  deleteFolderSyncJobs: Array<Scalars['UUID']>;
  /** Soft-delete a group by ID. Returns the ID of the deleted group. */
  deleteGroup: Scalars['UUID'];
  /** Remove a single label permission from a group, revoking access to documents and workflows tagged with that label */
  deleteGroupPermission: Group;
  deleteInsightPin: DeleteInsightPinResponse;
  /** Delete an intake form template. Blocked (UserInputError) if attached to any template workflow. */
  deleteIntakeFormTemplate: Scalars['UUID'];
  /** Delete a label. */
  deleteLabel: Scalars['UUID'];
  deleteMetadataImports: DeleteMetadataImportsResult;
  /** Permanently delete an organization and disassociate its members */
  deleteOrg: OrgResponse;
  /** Delete a party. */
  deleteParty: Scalars['UUID'];
  /** Permanently remove a phase and its associated tasks or steps. Returns the deleted phase ID. */
  deletePhase: Scalars['UUID'];
  /** Permanently delete a playbook and its rules. Restricted to its author or an organization admin. Returns the deleted playbook's ID. */
  deletePlaybook: Scalars['UUID'];
  /** Permanently delete a rule. Returns the deleted rule's ID. */
  deletePlaybookRule: Scalars['UUID'];
  /**
   * Permanently delete a category and all of its rules. Returns the owning
   * playbook so callers can renormalize both lists; the surviving categories keep
   * the ranks they had, since a rank leaves no gap to close.
   */
  deletePlaybookRuleCategory: Playbook;
  /**
   * Delete one of a rule's positions. Deleting the starting position promotes the
   * next one; a rule must keep at least one position.
   */
  deletePlaybookRulePosition: PlaybookRule;
  /** Delete a selectable option from a question. Returns the deleted option's ID. */
  deleteQuestionOption: Scalars['UUID'];
  /** Delete a Reminder. */
  deleteReminder: Scalars['UUID'];
  /** Delete multiple Reminders. */
  deleteReminders: Array<Scalars['UUID']>;
  /** Deletes reports by id. */
  deleteReports: Array<Scalars['UUID']>;
  /** Permanently remove a permission entry, revoking that account's access */
  deleteStorablePermission: StorablePermissionResponse;
  /** Permanently delete storables by ID. Returns the IDs of successfully deleted storables. */
  deleteStorables: Array<Scalars['UUID']>;
  /** Delete a task by ID. Returns the deleted task's UUID. */
  deleteTask: Scalars['UUID'];
  /** Remove a form field from a task. Returns the deleted field's UUID. */
  deleteTaskField: Scalars['UUID'];
  /** Soft-delete a user-defined role by ID */
  deleteUserDefinedRole: Scalars['UUID'];
  /** Delete a user by id. */
  deleteUsers: UsersResponse;
  /** Delete a variable config by id. */
  deleteVariableConfig: Scalars['UUID'];
  /** Delete a workflow. */
  deleteWorkflow: Scalars['UUID'];
  /** Delete workflow actions by id. */
  deleteWorkflowActions: WorkflowResponse;
  /** Delete a workflow launch config. */
  deleteWorkflowLaunchConfig: Scalars['UUID'];
  deleteWorkflowView: DeleteWorkflowViewResponse;
  deleteWorkflowViewChart: WorkflowViewResponse;
  /** Detach the intake form template from a template workflow. */
  detachIntakeFormTemplate: WorkflowIntakeFormTemplateResponse;
  /** Disable a specific comment by its id */
  disableComment: CommentResponse;
  /** Disabled Documents in bulk (move to trash). */
  disableDocuments: BulkDocumentActionResponse;
  /** Soft-delete a signature field. Uses disable instead of hard delete to support undo/redo. */
  disableSignatureField: SignatureField;
  /** Soft-delete (disable) storables, moving them to the trash */
  disableStorables: StorablesResponse;
  /** Disable DocumentVariable. Note we do not expose delete b/c DocumentVariables might be referenced in Document.documentJSON (or prior versions). */
  disableVariable: DocumentVariable;
  discardAgentSkillDraft: AgentSkillResponse;
  /** Soft-deletes the install row. Provider-side teardown is best-effort and logged. */
  disconnectChannelInstallation: Scalars['Boolean'];
  /** Disconnect the current user's external toolkit account. Grants stay and resume on reconnect. */
  disconnectExternalToolkit: Scalars['Boolean'];
  /** Dismiss failed files for a folder sync job. */
  dismissFailedFiles: FolderSyncJob;
  /** Hides a notification for the viewer only; returns the updated inbox. */
  dismissInboxNotification: InboxNotificationsResult;
  duplicateAgentSkill: AgentSkillResponse;
  /** Create an independent copy of a playbook including all of its rules. */
  duplicatePlaybook: Playbook;
  /** Duplicates the specified template and assigns it to a new owner - or the requester if unspecified. */
  duplicateTemplate: DocumentResponse;
  /** Toggle the favorite status for a set of storables */
  favoriteStorables: StorablesResponse;
  /** Find or create a label by text, relevant to the requestor. */
  findOrCreateLabel: Label;
  /** Requester finishes field actions in the active step, if any. */
  finishFieldActions: WorkflowResponse;
  /** Finish signing a workflow oustside Aline */
  finishSigningOutsideAline: WorkflowResponse;
  /** Forward a document. */
  forwardDocument: DocumentResponse;
  /** Forward a workflow to recipients. */
  forwardWorkflow: WorkflowResponse;
  /** Generate an AI text completion for a document based on the selected text and completion type. */
  generateAICompletion: CompletionResponse;
  generateMetadataImportTemplate: GenerateMetadataImportTemplateResult;
  /** Generate a short-lived CSRF token for use in an OAuth or integration auth flow */
  generateToken: CsrfToken;
  /** Get or create a template's launcher placeholder, which launch fills with the new workflow's owner. */
  getOrCreateWorkflowLauncherPermission: WorkflowPermission;
  /** Grant access to requested documents */
  grantAccessByRequest: Scalars['Boolean'];
  /** Imports a copy of the Community Workflow to the requester's account. */
  importCommunityWorkflow: WorkflowResponse;
  /** Convert a static file Document to an Aline Document. */
  importDocument: DocumentResponse;
  /** Import example NDA resources. */
  importExampleNDAResources: UserSettings;
  /** Use AI to improve a chat prompt for clarity and effectiveness */
  improvePrompt: ImprovePromptResponse;
  /** Initialize a workflow for a document */
  initializeWorkflow: WorkflowResponse;
  /** Initiate org-wide DocuSign integration using admin consent. Requires the DocuSign API account GUID. */
  integrateDocuSignForOrg: CsrfToken;
  /** Initiate individual DocuSign integration using personal consent. Requires the DocuSign API account GUID. */
  integrateDocuSignForUser: CsrfToken;
  /** Publicly launch a template workflow. */
  launchWorkflowViaConfig: LaunchWorkflowViaConfigResponse;
  /** Link a workflow to an opportunity */
  linkOpportunity: WorkflowResponse;
  /** Marks the given notifications as read for the viewer; returns the updated inbox. */
  markInboxNotificationsRead: InboxNotificationsResult;
  /** Marks the given notifications as unread again for the viewer; returns the updated inbox. */
  markInboxNotificationsUnread: InboxNotificationsResult;
  /** Admin-only: find or create the editable Org Chart seeded from a System preset. */
  materializeSystemInsightChart: InsightPinResponse;
  /** Combine multiple contract types into one, reassigning all affected documents to the target type */
  mergeContractTypes: ContractType;
  /** Merge parties. */
  mergeParties: Party;
  /** Merge one or more source roles into a target role, reassigning all references */
  mergeUserDefinedRoles: UserDefinedRoleResponse;
  /** Merge source variable configs into a target variable config. */
  mergeVariableConfigs: DocumentVariableConfig;
  moveColumn: Board;
  /**
   * Move a rule to a new position, optionally into a different category of the
   * same playbook.
   */
  movePlaybookRule: PlaybookRule;
  /**
   * Move one category to a new position among its playbook's categories. Prefer
   * this over reorderPlaybookRuleCategories for anything that describes a single
   * move: it names only what moved, so it does not overwrite a concurrent change
   * to the categories it left alone.
   */
  movePlaybookRuleCategory: PlaybookRuleCategory;
  /**
   * Move some of a rule's positions, leaving the rest where they are. Prefer this
   * over reorderPlaybookRulePositions for anything that describes a single move:
   * it names only what moved, so it does not overwrite a concurrent edit to the
   * positions it left alone.
   */
  movePlaybookRulePositions: PlaybookRule;
  /** Move storables into a new parent folder */
  moveStorables: StorablesResponse;
  /** Move actions from their origin WorkflowStep to a target WorkflowStep. */
  moveWorkflowStepActions: WorkflowResponse;
  /** After CRM Vault OAuth: pair the CRM tenant to this org. Salesforce also writes the signing key into the org. Re-pairing keeps the existing key. */
  pairCrmTenant: CrmPairing;
  publishAgentSkillDraft: AgentSkillResponse;
  /** Admin-only: publish a Personal Pin to Org Insights. */
  publishInsightPinToOrg: InsightPinResponse;
  /** Retries writing the current Salesforce signing key into the org. Admin and session only. */
  pushCrmSigningSecret: CrmPairing;
  /** Allows a recipient to reassign themselves to another person, even after workflow is sent for signature. */
  reassignRecipient: ReassignRecipientResult;
  /**
   * Re-create the Aline document a drafter node produced after it was
   * hard-deleted (CASCADE wiped the original join row). Re-runs the same
   * HTML to Document pipeline used at draft streaming time against the
   * client-held artifact HTML, writes a fresh drafted join row, and returns
   * the new artifact for the bar.
   */
  recreateAgentArtifactDocument: ThreadDocumentArtifact;
  /** Reject a document relationship suggested by AI. */
  rejectDocumentRelationship: DocumentRelationship;
  /** Reject and hard-delete a pending AI-generated reminder */
  rejectReminder: Scalars['UUID'];
  /** Batch-reject and hard-delete multiple pending AI-generated reminders */
  rejectReminders: Array<Scalars['UUID']>;
  /** As a required internal assignee, reject the task. Moves the workflow to its board's Cancelled column. */
  rejectTask: TaskResponse;
  /** Relocate a workflow and its phase homes to another board. */
  relocateWorkflowToBoard: WorkflowResponse;
  /** As a reviewer who requested changes, remind the task's subscribers you are still waiting. Changes nothing else. */
  remindTaskAssignees: TaskResponse;
  /** As an assignee, email a reminder to the reviewers who were asked and have not answered. Changes nothing else. */
  remindTaskReviewers: TaskResponse;
  /** Remove storables from a Workflow */
  removeDocumentsFromWorkflow: WorkflowResponse;
  /** Remove a Party from a Document. */
  removePartyFromDocument: Party;
  /** Remove one or more users from a group */
  removeUsersFromGroup: Group;
  /** Remove workflow assignments from a given workflow */
  removeWorkflowPermissions: Array<Scalars['UUID']>;
  /** Renotify assignments at active workflow step. */
  renotifyCurrentStep: WorkflowResponse;
  /** Reposition all phases within a workflow. The phaseIds array defines the new ordering. */
  reorderPhases: Array<Phase>;
  /** Reorder the categories within a playbook. Returns the playbook's categories in their new order. */
  reorderPlaybookRuleCategories: Array<PlaybookRuleCategory>;
  /**
   * Reorder a rule's positions. Whichever position ends up at index 0 becomes the
   * rule's starting position.
   */
  reorderPlaybookRulePositions: PlaybookRule;
  /** Reposition all fields within a task. The taskFieldIds array defines the new ordering. */
  reorderTaskFields: Array<TaskField>;
  /** Request access to a Document Workflow. */
  requestAccessToDocumentWorkflow: Scalars['UUID'];
  /** Request access to one or more storables. Returns the created access request info for each document. */
  requestAccessToStorable: Array<MyAccessRequestInfo>;
  /** Request User account activation */
  requestAccountActivation: Scalars['Boolean'];
  requestBulkExport: BulkExport;
  /** As a reviewer, send the task back to its assignees. The comment is required. An internal user who is not on the task joins as an optional reviewer. */
  requestTaskChanges: TaskResponse;
  /** As an assignee, ask the reviewers to review. One request speaks for every assignee. After a request for changes it asks those reviewers again and starts the next round. Does nothing while the reviewers are already reviewing. */
  requestTaskReview: TaskResponse;
  /** Request an upgrade from VIEWER to a paid org role. */
  requestUpgrade: UpgradeRequest;
  /** Resend a user invite to the org. */
  resendOrgInvite: OrgResponse;
  /**
   * Record the reviewer's resolution of a rule on a document. At most one
   * resolution exists per rule job; resolving again replaces it. Refused while
   * one of the rule's positions is mid-review, and never takes the Reviewed
   * kind — that one is set automatically by reviewPlaybookSuggestion.
   */
  resolvePlaybookRuleJob: PlaybookRuleJob;
  /** Approve or deny an upgrade request. Org admins only. */
  respondToUpgradeRequest: UpgradeRequest;
  /** Restore a reviewed document relationship to unreviewed state (clears the review) WITHOUT re-running AI. */
  restoreDocumentRelationship: DocumentRelationship;
  /** Restore Documents in bulk. */
  restoreDocuments: BulkDocumentActionResponse;
  /** Restore previously disabled storables back to an active state */
  restoreStorables: StorablesResponse;
  /** Process a draft file again after it failed. */
  retryAgentSkillFile: AgentSkillResponse;
  /** Retry relationship detection for all documents in the user's org that have a failed status. */
  retryFailedDocumentRelationships: Scalars['Int'];
  /** Retry failed files for a folder sync job. */
  retryFolderSyncFailedFiles: FolderSyncJob;
  /** Revert ExtractionJob to previous answer. */
  revertExtractionJob: ExtractionJob;
  /** Reverts a workflow to draft state. */
  revertWorkflowToDraft: WorkflowResponse;
  /**
   * Record one review decision on a suggestion: accept (the client has already
   * materialized its edits as the reviewer's own tracked changes), reject
   * (record-only), or undecided (clears a rejection). When the last reviewable
   * suggestion of the position is decided, the rule auto-resolves as Reviewed.
   * While one position has decisions, deciding on another position of the same
   * rule is refused.
   */
  reviewPlaybookSuggestion: PlaybookRuleJob;
  /**
   * Revoke one or more API keys by ID. Admin only.
   * Requires api-keys:manage permission when called via API key authentication.
   */
  revokeApiKeys: Array<Scalars['String']>;
  /** Issues a new signing key and writes it into Salesforce. The previous key stops verifying at once. Admin and session only. */
  rotateCrmSigningSecret: CrmPairing;
  /** Manually trigger an automation run for testing purposes */
  runAIReminderAutomation: AiReminderAutomation;
  /** Start or rerun Core AI (standard questions) for multiple Documents. */
  runCoreAiForDocuments: Array<Document>;
  /** Save a document. */
  saveDocument: SaveDocumentResponse;
  /** Send a prompt to the AI agent and begin streaming a response */
  sendAgentPrompt: AgentResponse;
  /** Send a document via email. */
  sendDocumentViaEmail: DocumentResponse;
  /** Send a preview email to the requester via email. */
  sendDocumentViaEmailTest: DocumentResponse;
  /** Send an entire report to a user in a specific format. */
  sendReportExport: ReportResponse;
  /** If possible, create an envelope for the workflow and send for signature. */
  sendWorkflowForSignature: WorkflowResponse;
  setAgentSkillScope: AgentSkillResponse;
  /** Add or remove a document from Community Templates. */
  setCommunityTemplate: DocumentResponse;
  /** Add or remove a workflow from Community Workflows. */
  setCommunityWorkflow: WorkflowResponse;
  /** Stores the app-level signing secret for a CRM. Support personnel and session only. */
  setCrmAppSecret: Scalars['Boolean'];
  /** Set the labels for a document. */
  setDocumentLabels: Document;
  /** Set Document Parties. */
  setDocumentParties: Document;
  /** Set the child document for an orphan parent relationship and auto-confirm it as the requester. */
  setDocumentRelationshipChildAndConfirm: DocumentRelationship;
  /** Set the parent document for an orphan child relationship and auto-confirm it as the requester. */
  setDocumentRelationshipParentAndConfirm: DocumentRelationship;
  /** Set the status of one document or every document matching the current filters. */
  setDocumentsStatus: SetDocumentsStatusResponse;
  /** Sets viewedAt timestamps for an envelope, if it exists for workflow. */
  setEnvelopeViewed: Maybe<Envelope>;
  /** Allow or revoke one provider action for the current user. */
  setExternalToolGrant: ExternalToolkit;
  /** Allow or revoke multiple provider actions for the current user in one atomic batch. */
  setExternalToolGrants: ExternalToolkit;
  /** Allow or deny an external toolkit for the current organization. */
  setExternalToolkitPolicy: ExternalToolkit;
  /** Set the allowed MIME types for a folder sync job. Empty array means all files. */
  setFolderSyncJobAllowedMimeTypes: FolderSyncJob;
  /** Set the labels for a folder sync job. */
  setFolderSyncJobLabels: FolderSyncJob;
  /** Replace the set of label-based permissions for a group, granting access to documents and workflows tagged with the specified labels */
  setGroupPermissions: Group;
  /** Enable or disable parent-child relationships for the org. Enabling stamps parentChildEnabledAt and triggers relationship detection for the org's repository; disabling clears parentChildEnabledAt without touching existing relationships or documents. */
  setParentChildRelationshipsEnabled: Org;
  /** Replace the set of contract types associated with a question. */
  setQuestionContractTypes: ExtractionQuestion;
  /** Replace the set of input questions and file fields that feed into this question. */
  setQuestionInputs: ExtractionQuestion;
  /** Mark a workflow signed outside of Aline platform */
  setSignOutsideAline: WorkflowResponse;
  /** Admin-only organization visibility toggle for a System Insights preset. */
  setSystemInsightChartHidden: Scalars['Boolean'];
  /** Mark one reviewer required or optional. Every required reviewer must approve before an assignee can complete the task. */
  setTaskAssigneeRequired: TaskResponse;
  /** Make one person on the task an assignee or a reviewer. Reviewers need at least one assignee or Aline AI. */
  setTaskAssigneeRole: TaskResponse;
  /** Replace a task's assignee list. The full desired list is sent; an empty list unassigns the task. */
  setTaskAssignees: TaskResponse;
  /** Delegate or undelegate Aline AI for a task without changing its human assignee. */
  setTaskDelegatedToAi: TaskResponse;
  /** Change a workflow file's document role (e.g., from General to Signing). */
  setWorkflowFileDocumentRole: WorkflowFile;
  /** Make a General document internal to the owner's org, or share it with every participant again. Making it internal removes the access people outside the org hold on it, except the document owner's. */
  setWorkflowFileInternal: WorkflowFile;
  /** Set the labels for a workflow. */
  setWorkflowLabels: WorkflowResponse;
  /** Set workflow parties. */
  setWorkflowParties: Workflow;
  /** Invoke Aline AI from a task/workflow activity composer: start an agent thread and record it as an AGENT_THREAD activity row on the parent */
  startActivityAgentThread: AgentResponse;
  /** Start or rerun all ExtractionJobs for a set of Documents. */
  startExtractionJobsForDocuments: StartExtractionJobsResponse;
  /** Start or rerun OCR for a list of documents. */
  startOCRForDocuments: DocumentsResponse;
  /**
   * Re-run one or more rules against a document — the remedy for stale
   * proposals without re-running the whole playbook. Replaces each rule's
   * results, proposals, and any resolution. All rules must belong to the same
   * playbook. A single-rule rerun is just a one-element list.
   */
  startPlaybookRuleJobs: Array<PlaybookRule>;
  /**
   * Run every rule of a playbook against a document. Each rule is evaluated
   * strongest position first, stopping at the first passing one, with a proposal
   * generated for every failing position before it. Replaces whatever a previous
   * run left behind, including any resolution.
   */
  startPlaybookRun: Playbook;
  /** Start a job to analyze a document and generate relevant extraction questions. */
  startQuestionGenerationJob: ExtractionQuestionGenerationJob;
  /** Start report extraction. */
  startReportExtraction: StartReportExtractionResponse;
  /** Start a task that has not started: invites its people, runs Aline AI and, on a phased workflow, asks its reviewers. The workflow does not have to be started; starting it stays a separate choice. */
  startTask: TaskResponse;
  /** Start the AI execution thread for an AI-delegated task, auto-starting the task if its phase is active. Errors with a UserInputError if an execution run is already in progress for the task. */
  startTaskAiExecution: TaskResponse;
  /** Start work on an unstarted workflow (sets startedAt, starts phase 1, moves to phase 1 home). A phaseless workflow may name the Started column to move to; it defaults to the board's first one. */
  startWorkflowWork: Workflow;
  /** Cancel the in-progress streaming response for a thread */
  stopChatMessageStream: AgentThread;
  /** Stop an active folder sync without deleting the job. Terminates the running Temporal workflow. */
  stopFolderSyncJob: FolderSyncJob;
  /** Record a participant's answer for a form field. */
  submitTaskFieldResponse: TaskFieldResponse;
  /** Subscribe a user (self by default, or anyone via input.userId) to a Task or Workflow activity thread */
  subscribeToActivity: ActivitySubscriptionToggleResult;
  /** Switches an envelope to the specified EnvelopeVariant, if allowed. */
  switchEnvelopeVariant: Envelope;
  /** Brings the pairing in line with the Apideck connection: pairs a callable connection, revokes the key when the connection is gone. Null when nothing is paired. */
  syncCrmPairing: Maybe<CrmPairing>;
  /** Name a version if needed, then schedule that selected version for CRM sync */
  syncFileVersionToCrm: FileVersionResponse;
  testAgentSkillDraft: TestAgentSkillDraftResponse;
  /** Toggle lock state for multiple extraction jobs. */
  toggleExtractionJobsLock: Array<ExtractionJob>;
  /** Publish/unpublish a template workflow */
  togglePublishTemplate: WorkflowResponse;
  /** Toggle completion order on/off for pre-signature WorkflowSteps. */
  toggleWorkflowOrder: WorkflowResponse;
  /** Trigger folder sync schedule. */
  triggerFolderSyncSchedule: FolderSyncJob;
  /** As an assignee or an internal workflow editor, take back the open review request, from every reviewer who has not answered or only from reviewerPermissionId. Answers already given stand. */
  undoTaskReviewRequest: TaskResponse;
  /** Unlink a workflow opportunity */
  unlinkOpportunity: WorkflowResponse;
  /** Unsubscribe (mute) a user (self by default, or anyone via input.userId) from a Task or Workflow activity thread */
  unsubscribeFromActivity: ActivitySubscriptionToggleResult;
  /** Update an existing AI reminder automation's configuration */
  updateAIReminderAutomation: AiReminderAutomation;
  /** Submit quality feedback (thumbs up/down) on an agent message */
  updateAgentMessageFeedback: AgentMessage;
  /** Batch-update the review status of AI-generated suggested edits */
  updateAgentMessageSuggestions: AgentMessage;
  updateAgentSkill: UpdateAgentSkillResponse;
  /** Manually update the title of an agent thread */
  updateAgentThreadTitle: AgentThread;
  /** Change an answer option's display text or trigger action. */
  updateAnswerOption: AnswerOptionResponse;
  /** Update an existing answer option set's title, preset status, or choices. */
  updateAnswerOptions: AnswerOptionsResponse;
  /** Update an existing board's name, icon, or color */
  updateBoard: Board;
  /** Update the persisted value on a canned field. */
  updateCannedField: CannedFieldResponse;
  /** Update an existing column's name, category, or color */
  updateColumn: Column;
  /** Update a comment's properties by id */
  updateComment: CommentResponse;
  /** Rename or update a contract type's display label */
  updateContractType: ContractType;
  /** Update document props. */
  updateDocumentProps: DocumentResponse;
  /** Update the relationship type for an already-confirmed relationship. */
  updateDocumentRelationshipType: DocumentRelationship;
  /** Change which contract type is assigned to a specific document */
  updateDocumentType: Document;
  /** Update Envelope props. */
  updateEnvelope: Envelope;
  /** Update ExtractionJob. */
  updateExtractionJob: ExtractionJob;
  /** Update an existing extraction question's properties. */
  updateExtractionQuestion: ExtractionQuestion;
  /** Update mutable fields on an existing file version (e.g. name) */
  updateFileVersion: FileVersionResponse;
  /** Update a group's properties (e.g. name, access settings) */
  updateGroup: Group;
  updateInsightPin: InsightPinResponse;
  /** Update an existing intake form template. */
  updateIntakeFormTemplate: IntakeFormTemplateResponse;
  /** Update collected values on a launched workflow's intake form. */
  updateIntakeFormValues: IntakeFormResponse;
  /** Update properties on an OnboardingTask. */
  updateOnboardingTask: OnboardingTaskResponse;
  /** Update an organization by updating members, name, size, type, website, or onboarding status. */
  updateOrg: OrgResponse;
  /** Update a Party. */
  updateParty: Party;
  /** Rename or re-describe an existing phase. */
  updatePhase: PhaseResponse;
  /** Update a playbook's title or description. */
  updatePlaybook: Playbook;
  /** Update a rule's title. */
  updatePlaybookRule: PlaybookRule;
  /** Rename a category. Use reorderPlaybookRuleCategories to change its position within its playbook. */
  updatePlaybookRuleCategory: PlaybookRuleCategory;
  /** Update the text or guidance of one of a rule's positions. */
  updatePlaybookRulePosition: PlaybookRule;
  /** Batch-move questions to a new category. */
  updateQuestionCategory: Array<ExtractionQuestion>;
  /** Update a selectable option's label, color, or order. */
  updateQuestionOption: QuestionOption;
  updateRecipientName: WorkflowRecipient;
  /** Update a Reminder. */
  updateReminder: Reminder;
  /** Update multiple Reminders in a single batch. */
  updateReminders: Array<Reminder>;
  /** Update report props. */
  updateReport: ReportResponse;
  /** Update an existing signature field's properties (e.g. reassign to a different recipient) */
  updateSignatureField: SignatureField;
  /** Update mutable fields on a single storable (e.g. name) */
  updateStorable: StorablesResponse;
  /** Update a task's editable properties (title, description, phase, optionality). */
  updateTask: TaskResponse;
  /** Update the Markdown description of a task. Persists the chat-editor-compatible body used to seed the AI execution. */
  updateTaskDescriptionMarkdown: TaskResponse;
  /** Update the Markdown instructions external assignees see on the task page. */
  updateTaskExternalDescriptionMarkdown: TaskResponse;
  /** Update an existing form field's label, type, or settings. */
  updateTaskField: TaskFieldResponse;
  /** Update a user's properties by id. */
  updateUser: UserResponse;
  /** Activate/Deactivate user account */
  updateUserActivation: UserResponse;
  /** Update properties of an existing user-defined role */
  updateUserDefinedRole: UserDefinedRoleResponse;
  /** Update user preferences such as onboarding visibility */
  updateUserSettings: UserSettingsResponse;
  /** Update simple props for DocumentVariable. */
  updateVariable: DocumentVariable;
  /** Update variable config. */
  updateVariableConfig: DocumentVariableConfig;
  /** Update Workflow props. */
  updateWorkflow: WorkflowResponse;
  /** Reorder workflow files by setting a new position. */
  updateWorkflowFileOrder: Array<WorkflowFile>;
  /** Update a workflow launch config. */
  updateWorkflowLaunchConfig: WorkflowLaunchConfig;
  /** Update properties of a given WorkflowPermission. */
  updateWorkflowPermission: WorkflowPermission;
  updateWorkflowView: WorkflowViewResponse;
  uploadMetadataImport: UploadMetadataImportResult;
  /** Upload a file as a draft new version of a workflow document, as a task assignee or on an external assignee's behalf. It becomes a version when the assignee's decision or review request sends it. */
  uploadTaskResponseVersion: TaskResponse;
  /** Create or update XFDF annotations for a file version */
  upsertAnnotations: AnnotationsXfdf;
  /** Upload or replace the organization's avatar image */
  upsertOrgAvatarImg: OrgResponse;
  /** Create or update permissions on a storable in bulk */
  upsertStorablePermissions: StorablePermissionsResponse;
  /** Upload or replace the user's signature and initials images */
  upsertUserSignatures: UserSettingsResponse;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAcceptGeneratedQuestionsArgs = {
  generationJobId: Scalars['UUID'];
  input: AcceptGeneratedQuestionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAcceptReminderArgs = {
  reminderId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAcceptRemindersArgs = {
  reminderIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddDocumentsToWorkflowArgs = {
  input: AddDocumentsToWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddOrgMemberArgs = {
  input: UpdateOrgMembership;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddPartyToDocumentArgs = {
  input: AddPartyToDocumentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddPlaybookRulePositionArgs = {
  input: AddPlaybookRulePositionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddQuestionOptionArgs = {
  input: AddQuestionOptionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddQuestionOptionsArgs = {
  input: AddQuestionOptionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddToRecentlyAccessedDocumentsArgs = {
  documentId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddTriageColumnArgs = {
  boardId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddUsersToGroupArgs = {
  input: AddUsersToGroupInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddWorkflowPermissionsArgs = {
  input: AddWorkflowPermissionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAddWorkflowViewChartArgs = {
  input: AddWorkflowViewChartInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationApplySignedVersionOutsideAlineArgs = {
  input: ApplySignedVersionOutsideAlineInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationApproveTaskArgs = {
  input: ApproveTaskInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAttachIntakeFormTemplateArgs = {
  input: AttachIntakeFormTemplateInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationAutoSaveAgentSkillDraftArgs = {
  input: AutoSaveAgentSkillDraftInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationBulkConfirmDocumentRelationshipsArgs = {
  input: BulkReviewRelationshipsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationBulkCreateDocumentRelationshipsArgs = {
  items: Array<BulkCreateDocumentRelationshipItem>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationBulkCreateFolderSyncJobsArgs = {
  input: BulkCreateFolderSyncJobInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationBulkDeletePartiesArgs = {
  input: BulkDeletePartiesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationBulkRejectDocumentRelationshipsArgs = {
  input: BulkReviewRelationshipsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationBulkSetDocumentLabelsArgs = {
  input: BulkSetDocumentLabelsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCancelBulkExportArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCancelDocumentStatusJobArgs = {
  jobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCancelExtractionJobsArgs = {
  extractionJobIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCancelPlaybookGenerationJobArgs = {
  jobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCancelPlaybookRuleJobsArgs = {
  documentId: Scalars['UUID'];
  playbookId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCancelQuestionGenerationJobArgs = {
  jobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCancelUpgradeRequestArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCancelWorkflowAiBuildArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationChangeCollaboratorAssignmentArgs = {
  input: ChangeCollaboratorAssignmentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationChangeDocumentsTypeArgs = {
  input: ChangeDocumentsTypeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationChangeRecipientActionArgs = {
  input: ChangeRecipientActionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationChangeRecipientAssignmentArgs = {
  input: ChangeRecipientAssignmentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationChangeTaskStatusArgs = {
  input: ChangeTaskStatusProps;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationChangeUserOrgRoleArgs = {
  newRole: OrgRole;
  userId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationClearPlaybookRuleJobResolutionArgs = {
  input: ClearPlaybookRuleJobResolutionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationClearTaskUploadArgs = {
  taskUploadId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationClearUnusedWorkflowActionsArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCompleteTaskForAssigneeArgs = {
  input: CompleteTaskForAssigneeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationConfirmDocumentRelationshipArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationConfirmMetadataImportArgs = {
  importId: Scalars['UUID'];
  overwriteQuestionIds?: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationConnectExternalToolkitArgs = {
  toolkit: ExternalToolkitSlug;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationContinueAgentChatArgs = {
  input: ContinueAgentChatInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCopyDocumentArgs = {
  documentId: Scalars['UUID'];
  documentProps: DuplicateDocument;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateAiReminderAutomationArgs = {
  input: CreateAiReminderAutomationInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateAgentSkillArgs = {
  input: CreateAgentSkillInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateAnswerOptionArgs = {
  input: CreateAnswerOptionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateAnswerOptionsArgs = {
  input: CreateAnswerOptionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateApiDeckSessionArgs = {
  unifiedApi?: ApiDeckUnifiedApi;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateBoardArgs = {
  input: CreateBoardInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateCannedFieldArgs = {
  input: CreateCannedFieldInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateCheckoutUrlArgs = {
  input: CreateCheckoutUrlInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateCloseOrderUrlArgs = {
  orderId: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateColumnArgs = {
  input: CreateColumnInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateCommentArgs = {
  input: NewCommentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateCommunityCategoryArgs = {
  input: CreateCommunityCategoryInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateContractTypesArgs = {
  input: Array<CreateContractTypeProps>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateDocFileArgs = {
  input: CreateDocFileLocationInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateDocumentArgs = {
  documentProps: NewDocument;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateDocumentRelationshipArgs = {
  childDocumentId: Scalars['UUID'];
  childRelationshipType: ChildRelationshipType;
  parentDocumentId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateDraftEnvelopeArgs = {
  input: CreateDraftEnvelopeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateExtractionJobArgs = {
  documentId: Scalars['UUID'];
  input: CreateExtractionJobInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateExtractionQuestionArgs = {
  input: CreateExtractionQuestionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateFileLocationsArgs = {
  input: CreateFileLocationsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateFilesArgs = {
  input: CreateFilesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateFilesViaLaunchConfigArgs = {
  input: CreateFilesViaLaunchConfigInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateInsightPinArgs = {
  input: CreateInsightPinInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateIntakeFormTemplateArgs = {
  input: CreateIntakeFormTemplateInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateOrgArgs = {
  input: NewOrgInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreatePartyArgs = {
  input: CreatePartyInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreatePhaseArgs = {
  input: CreatePhaseInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreatePlaybookArgs = {
  input: CreatePlaybookInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreatePlaybookRuleArgs = {
  input: CreatePlaybookRuleInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreatePlaybookRuleCategoryArgs = {
  input: CreatePlaybookRuleCategoryInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateReminderArgs = {
  input: CreateReminderInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateSignatureFieldArgs = {
  input: CreateSignatureFieldInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateStaticFileVersionArgs = {
  input: CreateStaticFileVersionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateStaticFileVersionsArgs = {
  input: CreateStaticFileVersionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateTaskFieldArgs = {
  input: CreateTaskFieldInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateUserArgs = {
  userProps: NewUser;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateUserDefinedRoleArgs = {
  input: CreateUserDefinedRoleInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateVariableArgs = {
  input: CreateDocumentVariableInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateVariableConfigArgs = {
  input: CreateVariableConfigInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateWorkflowInstanceArgs = {
  input: CreateWorkflowInstanceInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateWorkflowLaunchConfigArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateWorkflowRecipientArgs = {
  input: CreateWorkflowRecipientInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCreateWorkflowViewArgs = {
  input: CreateWorkflowViewInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationCrmLaunchWorkflowArgs = {
  input: CrmLaunchWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeclineSignatureRemindersArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteAiReminderAutomationArgs = {
  automationId: Scalars['UUID'];
  deleteReminders?: InputMaybe<Scalars['Boolean']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteAgentSkillArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteAgentThreadArgs = {
  threadId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteAnnotationsArgs = {
  input: DeleteAnnotationsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteAnswerOptionArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteAnswerOptionsArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteBoardArgs = {
  boardId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteCannedFieldArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteColumnArgs = {
  columnId: Scalars['UUID'];
  targetColumnId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteConsumerConnectionArgs = {
  serviceId: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteContractTypeArgs = {
  input: DeleteContractTypeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteDocumentRelationshipArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteDocumentsArgs = {
  input: DeleteDocumentsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteExtractionQuestionArgs = {
  extractionQuestionId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteFileVersionArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteFilesViaLaunchConfigArgs = {
  input: DeleteFilesViaLaunchConfigInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteFolderSyncJobsArgs = {
  ids: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteGroupArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteGroupPermissionArgs = {
  groupId: Scalars['UUID'];
  labelId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteInsightPinArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteIntakeFormTemplateArgs = {
  intakeFormTemplateId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteLabelArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteMetadataImportsArgs = {
  importIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteOrgArgs = {
  orgId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeletePartyArgs = {
  partyId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeletePhaseArgs = {
  phaseId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeletePlaybookArgs = {
  playbookId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeletePlaybookRuleArgs = {
  ruleId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeletePlaybookRuleCategoryArgs = {
  categoryId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeletePlaybookRulePositionArgs = {
  input: DeletePlaybookRulePositionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteQuestionOptionArgs = {
  optionId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteReminderArgs = {
  reminderId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteRemindersArgs = {
  reminderIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteReportsArgs = {
  input: DeleteReportsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteStorablePermissionArgs = {
  permissionId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteStorablesArgs = {
  deleteProps: DeleteStorables;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteTaskArgs = {
  taskId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteTaskFieldArgs = {
  taskFieldId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteUserDefinedRoleArgs = {
  input: DeleteUserDefinedRoleInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteUsersArgs = {
  userIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteVariableConfigArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteWorkflowArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteWorkflowActionsArgs = {
  input: DeleteWorkflowActionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteWorkflowLaunchConfigArgs = {
  launchConfigId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteWorkflowViewArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDeleteWorkflowViewChartArgs = {
  input: DeleteWorkflowViewChartInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDetachIntakeFormTemplateArgs = {
  input: DetachIntakeFormTemplateInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDisableCommentArgs = {
  input: DeleteCommentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDisableDocumentsArgs = {
  input: DisableDocumentsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDisableSignatureFieldArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDisableStorablesArgs = {
  disableProps: DeleteStorables;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDisableVariableArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDiscardAgentSkillDraftArgs = {
  input: DiscardAgentSkillDraftInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDisconnectChannelInstallationArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDisconnectExternalToolkitArgs = {
  toolkit: ExternalToolkitSlug;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDismissFailedFilesArgs = {
  fileIds: Array<Scalars['String']>;
  folderSyncJobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDismissInboxNotificationArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDuplicateAgentSkillArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDuplicatePlaybookArgs = {
  playbookId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationDuplicateTemplateArgs = {
  input: DuplicateTemplateInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationFavoriteStorablesArgs = {
  favoriteProps: FavoriteStorables;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationFindOrCreateLabelArgs = {
  labelText: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationFinishFieldActionsArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationFinishSigningOutsideAlineArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationForwardDocumentArgs = {
  input: ForwardDocumentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationForwardWorkflowArgs = {
  input: ForwardWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationGenerateAiCompletionArgs = {
  input: GenerateAiCompletionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationGenerateMetadataImportTemplateArgs = {
  displayName?: InputMaybe<Scalars['String']>;
  extractionQuestionIds: Array<Scalars['UUID']>;
  importId?: InputMaybe<Scalars['UUID']>;
  prefill?: InputMaybe<Scalars['Boolean']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationGenerateTokenArgs = {
  expiry: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationGetOrCreateWorkflowLauncherPermissionArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationGrantAccessByRequestArgs = {
  input: GrantAccessByRequestInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationImportCommunityWorkflowArgs = {
  input: ImportCommunityWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationImportDocumentArgs = {
  documentId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationImprovePromptArgs = {
  input: ImprovePromptInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationInitializeWorkflowArgs = {
  input: InitializeWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationIntegrateDocuSignForOrgArgs = {
  docuSignApiId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationIntegrateDocuSignForUserArgs = {
  docuSignApiId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationLaunchWorkflowViaConfigArgs = {
  input: LaunchWorkflowViaConfigInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationLinkOpportunityArgs = {
  input: LinkedOpportunityInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMarkInboxNotificationsReadArgs = {
  ids: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMarkInboxNotificationsUnreadArgs = {
  ids: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMaterializeSystemInsightChartArgs = {
  presetId: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMergeContractTypesArgs = {
  input: MergeTypesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMergePartiesArgs = {
  input: MergePartiesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMergeUserDefinedRolesArgs = {
  input: MergeRolesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMergeVariableConfigsArgs = {
  input: MergeVariableConfigsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMoveColumnArgs = {
  input: MoveColumnInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMovePlaybookRuleArgs = {
  input: MovePlaybookRuleInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMovePlaybookRuleCategoryArgs = {
  input: MovePlaybookRuleCategoryInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMovePlaybookRulePositionsArgs = {
  input: MovePlaybookRulePositionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMoveStorablesArgs = {
  moveProps: MoveStorables;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationMoveWorkflowStepActionsArgs = {
  input: MoveWorkflowStepActionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationPairCrmTenantArgs = {
  integration: Integration;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationPublishAgentSkillDraftArgs = {
  input: PublishAgentSkillDraftInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationPublishInsightPinToOrgArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationPushCrmSigningSecretArgs = {
  integration: Integration;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationReassignRecipientArgs = {
  input: ReassignRecipientInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRecreateAgentArtifactDocumentArgs = {
  documentId: Scalars['UUID'];
  html: Scalars['String'];
  messageId: Scalars['UUID'];
  title: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRejectDocumentRelationshipArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRejectReminderArgs = {
  reminderId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRejectRemindersArgs = {
  reminderIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRejectTaskArgs = {
  input: RejectTaskInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRelocateWorkflowToBoardArgs = {
  input: RelocateWorkflowToBoardInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRemindTaskAssigneesArgs = {
  input: RemindTaskAssigneesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRemindTaskReviewersArgs = {
  input: RemindTaskReviewersInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRemoveDocumentsFromWorkflowArgs = {
  input: RemoveDocumentsFromWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRemovePartyFromDocumentArgs = {
  input: RemovePartyFromDocumentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRemoveUsersFromGroupArgs = {
  input: RemoveUsersFromGroupInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRemoveWorkflowPermissionsArgs = {
  input: RemoveWorkflowPermissionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRenotifyCurrentStepArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationReorderPhasesArgs = {
  input: ReorderPhasesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationReorderPlaybookRuleCategoriesArgs = {
  input: ReorderPlaybookRuleCategoriesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationReorderPlaybookRulePositionsArgs = {
  input: ReorderPlaybookRulePositionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationReorderTaskFieldsArgs = {
  input: ReorderTaskFieldsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRequestAccessToDocumentWorkflowArgs = {
  input: RequestAccessToDocumentWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRequestAccessToStorableArgs = {
  input: RequestAccessToStorableInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRequestAccountActivationArgs = {
  msg?: InputMaybe<Scalars['String']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRequestBulkExportArgs = {
  input: RequestBulkExportInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRequestTaskChangesArgs = {
  input: RequestTaskChangesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRequestTaskReviewArgs = {
  input: RequestTaskReviewInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRequestUpgradeArgs = {
  input: RequestUpgradeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationResendOrgInviteArgs = {
  input: ResendOrgInvite;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationResolvePlaybookRuleJobArgs = {
  input: ResolvePlaybookRuleJobInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRespondToUpgradeRequestArgs = {
  input: RespondToUpgradeRequestInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRestoreDocumentRelationshipArgs = {
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRestoreDocumentsArgs = {
  input: RestoreDocumentsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRestoreStorablesArgs = {
  restoreProps: RestoreStorables;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRetryAgentSkillFileArgs = {
  input: RetryAgentSkillFileInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRetryFolderSyncFailedFilesArgs = {
  folderSyncJobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRevertExtractionJobArgs = {
  extractionJobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRevertWorkflowToDraftArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationReviewPlaybookSuggestionArgs = {
  input: ReviewPlaybookSuggestionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRevokeApiKeysArgs = {
  apiKeyIds: Array<Scalars['String']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRotateCrmSigningSecretArgs = {
  integration: Integration;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRunAiReminderAutomationArgs = {
  automationId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationRunCoreAiForDocumentsArgs = {
  input: RunCoreAiForDocumentsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSaveDocumentArgs = {
  input: SaveDocumentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSendAgentPromptArgs = {
  input: AgentPromptInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSendDocumentViaEmailArgs = {
  input: SendDocumentViaEmailInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSendDocumentViaEmailTestArgs = {
  input: SendDocumentViaEmailTestInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSendReportExportArgs = {
  format?: InputMaybe<ExportFormat>;
  reportId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSendWorkflowForSignatureArgs = {
  input: SendWorkflowForSignatureInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetAgentSkillScopeArgs = {
  input: SetAgentSkillScopeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetCommunityTemplateArgs = {
  input: SetCommunityTemplateInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetCommunityWorkflowArgs = {
  input: SetCommunityWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetCrmAppSecretArgs = {
  integration: Integration;
  secret: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetDocumentLabelsArgs = {
  documentId: Scalars['UUID'];
  labelIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetDocumentPartiesArgs = {
  input: SetDocumentPartiesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetDocumentRelationshipChildAndConfirmArgs = {
  childDocumentId: Scalars['UUID'];
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetDocumentRelationshipParentAndConfirmArgs = {
  id: Scalars['UUID'];
  parentDocumentId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetDocumentsStatusArgs = {
  input: SetDocumentsStatusInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetEnvelopeViewedArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetExternalToolGrantArgs = {
  enabled: Scalars['Boolean'];
  toolSlug: Scalars['String'];
  toolkit: ExternalToolkitSlug;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetExternalToolGrantsArgs = {
  enabled: Scalars['Boolean'];
  toolSlugs: Array<Scalars['String']>;
  toolkit: ExternalToolkitSlug;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetExternalToolkitPolicyArgs = {
  allowed: Scalars['Boolean'];
  toolkit: ExternalToolkitSlug;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetFolderSyncJobAllowedMimeTypesArgs = {
  allowedMimeTypes: Array<Scalars['String']>;
  folderSyncJobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetFolderSyncJobLabelsArgs = {
  folderSyncJobId: Scalars['UUID'];
  labelIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetGroupPermissionsArgs = {
  input: SetGroupPermissionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetParentChildRelationshipsEnabledArgs = {
  enabled: Scalars['Boolean'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetQuestionContractTypesArgs = {
  input: SetQuestionTypesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetQuestionInputsArgs = {
  input: SetQuestionInputsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetSignOutsideAlineArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetSystemInsightChartHiddenArgs = {
  hidden: Scalars['Boolean'];
  presetId: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetTaskAssigneeRequiredArgs = {
  input: SetTaskAssigneeRequiredInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetTaskAssigneeRoleArgs = {
  input: SetTaskAssigneeRoleInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetTaskAssigneesArgs = {
  input: SetTaskAssigneesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetTaskDelegatedToAiArgs = {
  delegated: Scalars['Boolean'];
  taskId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetWorkflowFileDocumentRoleArgs = {
  input: SetWorkflowFileDocumentRoleInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetWorkflowFileInternalArgs = {
  input: SetWorkflowFileInternalInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetWorkflowLabelsArgs = {
  labelIds: Array<Scalars['UUID']>;
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSetWorkflowPartiesArgs = {
  input: SetWorkflowPartiesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartActivityAgentThreadArgs = {
  input: StartActivityAgentThreadInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartExtractionJobsForDocumentsArgs = {
  input: StartExtractionJobsForDocumentsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartOcrForDocumentsArgs = {
  documentIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartPlaybookRuleJobsArgs = {
  documentId: Scalars['UUID'];
  ruleIds: Array<Scalars['UUID']>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartPlaybookRunArgs = {
  documentId: Scalars['UUID'];
  playbookId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartQuestionGenerationJobArgs = {
  documentId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartReportExtractionArgs = {
  input: StartReportExtractionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartTaskArgs = {
  input: StartTaskInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartTaskAiExecutionArgs = {
  taskId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStartWorkflowWorkArgs = {
  columnId?: InputMaybe<Scalars['UUID']>;
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStopChatMessageStreamArgs = {
  threadId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationStopFolderSyncJobArgs = {
  folderSyncJobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSubmitTaskFieldResponseArgs = {
  input: SubmitTaskFieldResponseInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSubscribeToActivityArgs = {
  input: ActivitySubscriptionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSwitchEnvelopeVariantArgs = {
  input: SwitchEnvelopeVariantInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSyncCrmPairingArgs = {
  integration: Integration;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationSyncFileVersionToCrmArgs = {
  input: SyncFileVersionToCrmInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationTestAgentSkillDraftArgs = {
  input: TestAgentSkillDraftInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationToggleExtractionJobsLockArgs = {
  input: BulkLockExtractionJobsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationTogglePublishTemplateArgs = {
  workflowId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationToggleWorkflowOrderArgs = {
  input: ToggleWorkflowOrderInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationTriggerFolderSyncScheduleArgs = {
  folderSyncJobId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUndoTaskReviewRequestArgs = {
  reviewerPermissionId?: InputMaybe<Scalars['UUID']>;
  taskId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUnlinkOpportunityArgs = {
  documentId?: InputMaybe<Scalars['UUID']>;
  linkedOpportunityId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUnsubscribeFromActivityArgs = {
  input: ActivitySubscriptionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateAiReminderAutomationArgs = {
  input: UpdateAiReminderAutomationInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateAgentMessageFeedbackArgs = {
  input: AgentMessageSuggestionFeedbackInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateAgentMessageSuggestionsArgs = {
  input: AgentMessageSuggestionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateAgentSkillArgs = {
  input: UpdateAgentSkillInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateAgentThreadTitleArgs = {
  threadId: Scalars['UUID'];
  title: Scalars['String'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateAnswerOptionArgs = {
  input: UpdateAnswerOptionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateAnswerOptionsArgs = {
  input: UpdateAnswerOptionsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateBoardArgs = {
  input: UpdateBoardInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateCannedFieldArgs = {
  input: UpdateCannedFieldInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateColumnArgs = {
  input: UpdateColumnInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateContractTypeArgs = {
  input: UpdateContractTypeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateDocumentPropsArgs = {
  input: UpdateDocumentInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateDocumentRelationshipTypeArgs = {
  childRelationshipType: ChildRelationshipType;
  id: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateDocumentTypeArgs = {
  input: UpdateDocumentTypeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateEnvelopeArgs = {
  input: UpdateEnvelopeInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateExtractionJobArgs = {
  input: UpdateExtractionJobInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateExtractionQuestionArgs = {
  input: UpdateExtractionQuestionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateFileVersionArgs = {
  input: UpdateFileVersionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateInsightPinArgs = {
  input: UpdateInsightPinInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateIntakeFormTemplateArgs = {
  input: UpdateIntakeFormTemplateInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateIntakeFormValuesArgs = {
  input: UpdateIntakeFormValuesInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateOnboardingTaskArgs = {
  input: UpdateOnboardingTaskInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateOrgArgs = {
  input: UpdateOrg;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdatePartyArgs = {
  input: UpdatePartyInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdatePhaseArgs = {
  input: UpdatePhaseInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdatePlaybookArgs = {
  input: UpdatePlaybookInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdatePlaybookRuleArgs = {
  input: UpdatePlaybookRuleInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdatePlaybookRuleCategoryArgs = {
  input: UpdatePlaybookRuleCategoryInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdatePlaybookRulePositionArgs = {
  input: UpdatePlaybookRulePositionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateQuestionCategoryArgs = {
  input: UpdateQuestionCategoryInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateQuestionOptionArgs = {
  input: UpdateQuestionOptionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateRecipientNameArgs = {
  input: UpdateRecipientNameInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateReminderArgs = {
  input: UpdateReminderInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateRemindersArgs = {
  inputs: Array<UpdateReminderInput>;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateSignatureFieldArgs = {
  input: UpdateSignatureFieldInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateStorableArgs = {
  updateProps: UpdateStorable;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateTaskDescriptionMarkdownArgs = {
  markdown: Scalars['String'];
  taskId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateTaskExternalDescriptionMarkdownArgs = {
  markdown: Scalars['String'];
  taskId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateTaskFieldArgs = {
  input: UpdateTaskFieldInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateUserArgs = {
  userId: Scalars['UUID'];
  userProps: UpdateUser;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateUserActivationArgs = {
  isDeactivated: Scalars['Boolean'];
  userId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateUserDefinedRoleArgs = {
  input: UpdateUserDefinedRoleInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateVariableArgs = {
  input: UpdateDocumentVariableInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateVariableConfigArgs = {
  input: UpdateVariableConfigInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateWorkflowArgs = {
  input: UpdateWorkflowInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateWorkflowFileOrderArgs = {
  input: UpdateWorkflowFileOrderInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateWorkflowLaunchConfigArgs = {
  input: UpdateWorkflowLaunchConfigInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateWorkflowPermissionArgs = {
  input: UpdateWorkflowPermissionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpdateWorkflowViewArgs = {
  input: UpdateWorkflowViewInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUploadMetadataImportArgs = {
  displayName: Scalars['String'];
  extractionQuestionIds: Array<Scalars['UUID']>;
  file: Scalars['Upload'];
  importId: Scalars['UUID'];
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUploadTaskResponseVersionArgs = {
  input: UploadTaskResponseVersionInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpsertAnnotationsArgs = {
  input: UpsertAnnotationsInput;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpsertOrgAvatarImgArgs = {
  input: FileLocationProps;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpsertStorablePermissionsArgs = {
  input: UpsertStorablePermissions;
};


/** Mutations for creating, updating, merging, and deleting variable configuration templates. */
export type MutationUpsertUserSignaturesArgs = {
  input: UpsertUserSignaturesInput;
};

/** Info about current user's access request for a document */
export type MyAccessRequestInfo = {
  __typename: 'MyAccessRequestInfo';
  /** Document ID */
  documentId: Scalars['UUID'];
  /** Status of the request */
  status: AccessRequestStatus;
};

/** Assignment properties for a new collaborator. */
export type NewAssignmentProps = {
  /** Role to assign. */
  assignedRoleId?: InputMaybe<Scalars['UUID']>;
  /** Internal user to assign. */
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  /** Used for creating new, external users.  Otherwise, use assignedUserId. */
  email?: InputMaybe<Scalars['EmailAddress']>;
};

/** Wrapper input for creating a new comment */
export type NewCommentInput = {
  /** Properties for the new comment */
  commentProps: NewCommentProps;
};

/** Properties for creating a new comment */
export type NewCommentProps = {
  /** Who sees the activity entry for a task or workflow comment. On a task, an author in the workflow owner's org defaults to INTERNAL; anyone else always posts EXTERNAL. On a workflow it defaults to EXTERNAL. @mentioning someone outside the workflow owner's org shares the comment as EXTERNAL. Ignored for document comments and replies. */
  audience?: InputMaybe<ActivityAudience>;
  /** ID of the user authoring the comment */
  authorId: Scalars['UUID'];
  /** ID of the document, task, or workflow being commented on */
  commentableId: Scalars['UUID'];
  /** Whether the target is a Document, Task, or Workflow */
  commentableType: CommentableType;
  /** When true, only users in the document owner organization can view the comment. Supported only on document comments. Must be omitted (null) for replies — reply privacy follows the root comment. */
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  /** Reference ID linking this comment to a text node in the editor; omit for replies and task comments */
  nodeRefId?: InputMaybe<Scalars['UUID']>;
  /** ID of the parent comment when creating a reply */
  parentCommentId?: InputMaybe<Scalars['UUID']>;
  /** Markdown body of the comment */
  text?: InputMaybe<Scalars['String']>;
};

/** Input for creating a new DocuSign envelope with a specific variant. */
export type NewDsEnvelopeInput = {
  /** IDs of the documents and files to include in the envelope. */
  storableIds: Array<Scalars['UUID']>;
  /** Display title for the envelope. */
  title: Scalars['String'];
  /** Signing provider to use for this envelope. */
  variant: EnvelopeVariant;
};

/** Input for creating a new document. */
export type NewDocument = {
  /** Initial Slate JSON content for the document body. */
  documentJSON?: InputMaybe<Scalars['JSON']>;
  /** FolderSyncJob that triggered this document creation, if any. */
  folderSyncJobId?: InputMaybe<Scalars['UUID']>;
  /** Optional client-generated ID for the document. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Name of the new document. */
  name: Scalars['String'];
  /** Contract type ID to assign to the new document. */
  typeId?: InputMaybe<Scalars['UUID']>;
  /** Whether the new document is a template or a concrete document. */
  variant: DocumentVariant;
};

/** Properties required when creating a new document instance from a template. */
export type NewInstanceProps = {
  /** Name for the new instance. */
  name: Scalars['String'];
};

/** Input for creating a new organization along with initial members */
export type NewOrgInput = {
  /** When true, the requesting user is also added as a member of the new org */
  addRequesterToOrg?: InputMaybe<Scalars['Boolean']>;
  /** Email addresses of users to invite as initial members */
  newMemberEmails: Array<Scalars['String']>;
  /** Core organization properties (name, size, type, website) */
  props: NewOrgProps;
};

/** Core properties required when creating a new organization */
export type NewOrgProps = {
  /** Mark the initial setup wizard as complete */
  isPreOnboardingCompleted?: InputMaybe<Scalars['Boolean']>;
  /** Display name for the organization (must be unique) */
  name: Scalars['String'];
  /** Headcount range */
  size?: InputMaybe<OrgSize>;
  /** Industry or category */
  type?: InputMaybe<OrgType>;
  /** Organization website URL */
  website?: InputMaybe<Scalars['String']>;
};

/** Core properties for a new task. */
export type NewTaskProps = {
  /** User who is creating the task. Defaults to the authenticated user if omitted. */
  authorId?: InputMaybe<Scalars['UUID']>;
  /** Markdown body explaining what the assignee needs to do. */
  description: Scalars['String'];
  /** Nest the new task one level under this task in the same workflow and phase. */
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  /** Phase to place this task in. */
  phaseId: Scalars['UUID'];
  /** Create the task already started, as its Start button would. The workflow does not have to be started. Ignored on a template. */
  startedAt?: InputMaybe<Scalars['DateTime']>;
  /** Short summary shown in task lists and notifications. */
  title: Scalars['String'];
  /** The workflow to attach this task to. */
  workflowId: Scalars['UUID'];
};

/** User fields needed when creating a new user. */
export type NewUser = {
  /** Avatar color as an RGB string (auto-generated if omitted) */
  avatarColor?: InputMaybe<Scalars['String']>;
  /** Email address for the new account (must be unique) */
  email: Scalars['EmailAddress'];
  /** User's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Whether this user authenticates only through passwordless magic links */
  isPasswordless?: InputMaybe<Scalars['Boolean']>;
  /** User's last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Organization to add the user to (defaults to requester's org if omitted) */
  orgId?: InputMaybe<Scalars['UUID']>;
  /** Role to assign within the organization */
  role: OrgRole;
};

/** Properties for creating a new workflow permission entry. */
export type NewWorkflowPermissionProps = {
  /** Workflow-level access to grant. */
  accessLevel?: InputMaybe<WorkflowAccessLevel>;
  /** Document-level access to grant. */
  docAccessLevel?: InputMaybe<PermissionRole>;
  /** External user email. Creates an external collaborator if not already known. */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Organization to grant access. Mutually exclusive with userId. */
  orgId?: InputMaybe<Scalars['UUID']>;
  /** Role to grant access. Mutually exclusive with userId. */
  roleId?: InputMaybe<Scalars['UUID']>;
  /** Whether the permission is active immediately or queued. */
  timeliness?: InputMaybe<WorkflowPermissionTimeliness>;
  /** Internal user to grant access. Mutually exclusive with orgId, roleId, and email. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Pre- or post-signature phase: work is modeled as tasks. */
export type NonSigningPhase = Phase & {
  __typename: 'NonSigningPhase';
  /** Started-category board column this phase homes to when it starts. */
  column: Column;
  /** When every task in this phase was finished; null if still in progress. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** When this phase record was created. */
  createdAt: Scalars['DateTime'];
  /** Longer explanation of the phase's purpose or instructions for participants. */
  description: Scalars['String'];
  /** Unique identifier for this phase. */
  id: Scalars['UUID'];
  /** Human-readable label shown in the workflow UI. */
  name: Scalars['String'];
  /** Zero-based position determining the sequence of phases within a workflow. */
  order: Scalars['Int'];
  /** When the first task in this phase was begun; null if not yet started. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** Ordered list of tasks that must be completed during this phase. */
  tasks: Array<Task>;
  /** When this phase record was last modified. */
  updatedAt: Scalars['DateTime'];
  /** The workflow this phase belongs to. */
  workflow: Workflow;
};

/** Reason why a document cannot be sent for signature. */
export enum NotReadyForSigReason {
  /** Document has already been sent for signature and is awaiting completion. */
  SentForSignature = 'SENT_FOR_SIGNATURE',
  /** Document has already been signed. */
  Signed = 'SIGNED',
  /** Document is a template; only instances can be signed. */
  Template = 'TEMPLATE',
  /** Document's workflow is template-level; instantiate the workflow first. */
  TemplateWorkflow = 'TEMPLATE_WORKFLOW',
  /** Document has unresolved tracked changes that must be accepted or rejected first. */
  UnresolvedTrackedChanges = 'UNRESOLVED_TRACKED_CHANGES',
  /** Document's workflow is currently paused. */
  WorkflowPaused = 'WORKFLOW_PAUSED',
  /** Document's workflow has not yet reached the signature phase. */
  WorkflowPreSignature = 'WORKFLOW_PRE_SIGNATURE'
}

/** A time offset defining when a notification should fire relative to a reminder's due date */
export type NotificationOffset = {
  __typename: 'NotificationOffset';
  /** Number of time units before or after the due date */
  amount: Scalars['Int'];
  /** Timestamp when this notification was actually sent, or null if not yet sent */
  notifiedAt: Maybe<Scalars['DateTime']>;
  /** Whether this notification fires before or after the due date */
  position: RelativeTimePosition;
  /** Unit of time (days, weeks, or months) */
  unit: RelativeTimeUnit;
};

/** Time offset for scheduling a notification relative to a reminder due date */
export type NotificationOffsetInput = {
  /** Number of time units before or after the due date */
  amount: Scalars['Int'];
  /** Timestamp when this notification was sent (used for re-imports) */
  notifiedAt?: InputMaybe<Scalars['DateTime']>;
  /** Whether this notification fires before or after the due date */
  position: RelativeTimePosition;
  /** Unit of time (days, weeks, or months) */
  unit: RelativeTimeUnit;
};

/** A single onboarding step assigned to a new user */
export type OnboardingTask = {
  __typename: 'OnboardingTask';
  /** The onboarding action this task represents */
  action: OnboardingTaskAction;
  /** Timestamp when the user completed this task, or null if not yet completed */
  completedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this onboarding task */
  id: Scalars['UUID'];
  /** Whether the user chose to skip this task */
  skipped: Scalars['Boolean'];
};

/** Actions a new user can complete during onboarding */
export enum OnboardingTaskAction {
  /** Generate an example AI-powered report */
  AlineAiExampleReport = 'AlineAiExampleReport',
  /** Watch the Aline platform introduction video */
  AlineIntroVideo = 'AlineIntroVideo',
  /** Create a playbook using the AI playbook generator */
  GenerateAiPlaybook = 'GenerateAiPlaybook',
  /** Import legacy documents into the repository */
  ImportLegacyIntoRepo = 'ImportLegacyIntoRepo',
  /** Launch the example NDA playbook to explore workflow features */
  LaunchExampleNdaPlaybook = 'LaunchExampleNDAPlaybook',
  /** Sign a sample PDF to try the e-signature flow */
  SignPdf = 'SignPDF'
}

/** Response returned after mutating an onboarding task, includes the updated task and a refetch entrypoint */
export type OnboardingTaskResponse = {
  __typename: 'OnboardingTaskResponse';
  /** The updated onboarding task */
  onboardingTask: OnboardingTask;
  /** Root query entrypoint for refetching related data after the mutation */
  refetch: Query;
};

/** Open order for a subscription */
export type OpenOrder = {
  __typename: 'OpenOrder';
  /** Order SKUs with quantities */
  currentOrderSkus: Array<OrderSku>;
  /** Order ID from Salesbricks */
  id: Scalars['String'];
  /** Order stage */
  stage: Scalars['String'];
};

/** Filter criteria for searching CRM opportunities. */
export type OpportunityFilterInput = {
  /** Case-insensitive title substring to filter opportunities by. */
  title: Scalars['String'];
};

/** Order SKU item */
export type OrderSku = {
  __typename: 'OrderSku';
  /** Quantity of this SKU */
  quantity: Scalars['Int'];
  /** SKU details */
  sku: Sku;
};

/** An organization account that groups users, manages billing, and owns shared resources */
export type Org = AccountInterface & {
  __typename: 'Org';
  /** Account's type - User or Org. */
  accountType: AccountType;
  /** Account subscription details. */
  alineSubscription: Maybe<AlineSubscription>;
  /** Org avatar color - rgb string. */
  avatarColor: Scalars['String'];
  /** Org avatar image. */
  avatarImg: Maybe<DocFile>;
  /** External people this organization has previously assigned on workflows. */
  contacts: Array<OrgContact>;
  /** Contract types available to members of this organization */
  contractTypes: Array<ContractType>;
  /** When this organization was created */
  createdAt: Scalars['DateTime'];
  /** Org's default board for workflows. */
  defaultBoard: Maybe<Board>;
  /** When this organization was soft-deleted (null if active) */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Permission groups defined within this organization */
  groups: Array<Group>;
  /** Unique identifier for the organization */
  id: Scalars['UUID'];
  /** Whether the org has completed the initial setup wizard */
  isPreOnboardingCompleted: Scalars['Boolean'];
  /** Users who belong to this organization. */
  members: Array<User>;
  /** Org's name. */
  name: Scalars['String'];
  /** Default role given to new members who join via SSO, and the role pre-selected when an admin invites a member. */
  orgDefaultRole: OrgRole;
  /** Whether this org has enabled parent-child relationships. */
  parentChildEnabled: Scalars['Boolean'];
  /** Salesbricks customer ID (CRM account ID) */
  salesbricksCustomerId: Maybe<Scalars['String']>;
  /** Days between automated signing reminders (null disables signing reminders). */
  signingReminderDays: Maybe<Scalars['Int']>;
  /** Headcount range for the organization */
  size: Maybe<OrgSize>;
  /** DateTime when org trial ends (14 days after creation by default). */
  trialEndAt: Scalars['DateTime'];
  /** DateTime when org trial started (same as createdAt). */
  trialStartedAt: Scalars['DateTime'];
  /** Industry or category of the organization (e.g. law firm, company) */
  type: Maybe<OrgType>;
  /** When this organization was last updated */
  updatedAt: Scalars['DateTime'];
  /** Org's website. */
  website: Maybe<Scalars['String']>;
  /** WorkOS Organization Id. */
  workosOrgId: Maybe<Scalars['String']>;
};


/** An organization account that groups users, manages billing, and owns shared resources */
export type OrgMembersArgs = {
  filter?: InputMaybe<OrgMemberFilter>;
};

/** An external person remembered by an organization, with an org-scoped display name. */
export type OrgContact = {
  __typename: 'OrgContact';
  /** Org-scoped label for this person (e.g. a signing recipient name). Null when unknown. */
  name: Maybe<Scalars['String']>;
  /** The underlying user account for this contact. */
  user: User;
};

/** Filter for listing organization members */
export enum OrgMemberFilter {
  /** Only include currently active members */
  Active = 'Active',
  /** Include all members (active and deactivated) */
  All = 'All'
}

/** Input for checking whether an org name is already taken */
export type OrgNameUniqueInput = {
  /** Prospective organization name to check */
  name: Scalars['String'];
};

/** Standard response for organization mutations, includes the updated org and a refetch entrypoint */
export type OrgResponse = {
  __typename: 'OrgResponse';
  /** The created or updated organization */
  org: Org;
  /** Entrypoint for refetching related queries after mutation */
  refetch: Query;
};

/** A user's role within an organization. */
export enum OrgRole {
  /** Full administrative access — can manage members, billing, and org settings */
  Admin = 'ADMIN',
  /** Limited access — can view and comment but has restricted editing capabilities */
  Basic = 'BASIC',
  /** Standard access to all features including document editing and AI */
  Full = 'FULL',
  /** Read-only access — can view documents but cannot edit or comment */
  Viewer = 'VIEWER'
}

/** Headcount range describing the size of an organization */
export enum OrgSize {
  /** 51–200 employees */
  FiftyToTwoHundred = 'FIFTY_TO_TWO_HUNDRED',
  /** 1–10 employees */
  OneToTen = 'ONE_TO_TEN',
  /** 11–50 employees */
  TenToFifty = 'TEN_TO_FIFTY',
  /** 201+ employees */
  TwoHundredPlus = 'TWO_HUNDRED_PLUS'
}

/** Industry or category classification for an organization */
export enum OrgType {
  /** Academic institution (university, research lab) */
  Academia = 'ACADEMIA',
  /** Commercial business or corporation */
  Company = 'COMPANY',
  /** Legal practice or law firm */
  LawFirm = 'LAW_FIRM',
  /** Does not fit the other categories */
  Other = 'OTHER'
}

/** Result of an org-name uniqueness check */
export type OrgUniqueResponse = {
  __typename: 'OrgUniqueResponse';
  /** True if no existing organization uses this name */
  unique: Scalars['Boolean'];
};

/** Properties for a user being added or invited to an organization */
export type OrgUserProps = {
  /** Avatar color as an RGB string (auto-generated if omitted) */
  avatarColor?: InputMaybe<Scalars['String']>;
  /** Email address of the user to add */
  email: Scalars['String'];
  /** User's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** User's job title */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** User's last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Role to assign within the organization */
  role: OrgRole;
};

/** An orphan relationship row where the linked document doesn't exist yet. */
export type OrphanRelationshipRow = {
  __typename: 'OrphanRelationshipRow';
  childRowCount: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** The orphaned relationship data. */
  orphanedRelationship: DocumentRelationship;
  /** Direction of the MISSING document relative to the existing one. */
  orphanedRelationshipDirection: RelationshipDirection;
  /** Always non-null at runtime (orphan rows only exist as children of an expanded parent), but ID must be nullable here to match union siblings (GQL limitation with unions). */
  parentTreeRowId: Maybe<Scalars['ID']>;
};

/** Aggregate metadata for a party list query. */
export type PartiesMeta = {
  __typename: 'PartiesMeta';
  /** Whether there are more results beyond the current page. Use cursor-based pagination to fetch the next page. */
  hasMore: Scalars['Boolean'];
  /** Total number of parties matching the filter. */
  totalCount: Scalars['Int'];
};

/** A counterparty or entity involved in contracts (e.g., a company, individual, or organization). */
export type Party = {
  __typename: 'Party';
  /** Timestamp when the party was created - ISO 8601. */
  createdAt: Scalars['DateTime'];
  /** Optional description or notes about this party. */
  description: Scalars['String'];
  /** Number of documents this party is associated with. */
  documentCount: Scalars['Int'];
  /** All documents this party is linked to. */
  documents: Array<Document>;
  /** Unique identifier for the party. */
  id: Scalars['UUID'];
  /** Display name of the party (e.g., company or individual name). */
  name: Scalars['String'];
  /** Timestamp when the party was last updated - ISO 8601. */
  updatedAt: Scalars['DateTime'];
  /** Workflows that involve this party. */
  workflows: Array<Workflow>;
};

/** Paginated list of parties with metadata. */
export type PartyRowsInfo = {
  __typename: 'PartyRowsInfo';
  /** Aggregate metadata about the result set. */
  meta: PartiesMeta;
  /** The parties matching the query. */
  rows: Array<Party>;
};

/** Invoice that is past due. */
export type PastDueInvoice = {
  __typename: 'PastDueInvoice';
  /** When invoice became due. */
  dueAt: Scalars['DateTime'];
  /** Invoice ID from Salesbricks. */
  id: Scalars['String'];
  /** Invoice number. */
  invoiceNumber: Scalars['String'];
};

/** How a permission was assigned to an account */
export enum PermissionOrigin {
  /** Permission inherited from a parent folder */
  Inherit = 'INHERIT',
  /** Permission explicitly assigned by a user */
  User = 'USER'
}

/** Access levels for storable permissions, ordered from least to most permissive */
export enum PermissionRole {
  /** Can view and add comments, but not edit content */
  Commenter = 'COMMENTER',
  /** Full editing access to the storable */
  Editor = 'EDITOR',
  /** Can view, comment, and suggest edits that require approval */
  Suggester = 'SUGGESTER',
  /** Can view the storable but not make any changes */
  Viewer = 'VIEWER'
}

/** A single permission entry to create or update */
export type PermissionUpdate = {
  /** ID of an existing account to grant permission to (provide this or email) */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Whether this permission targets a user or an organization */
  accountType: AccountType;
  /** Email address to grant permission to; a new invite is sent if no account exists */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Whether this permission is explicitly set or inherited */
  origin: PermissionOrigin;
  /** Access level to grant */
  role: PermissionRole;
};

/** Shared fields for every workflow phase (negotiation, signing, post-sign, etc.). */
export type Phase = {
  /** Started-category board column this phase homes to when it starts. */
  column: Column;
  /** When every task or step in this phase was finished; null if still in progress. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** When this phase record was created. */
  createdAt: Scalars['DateTime'];
  /** Longer explanation of the phase's purpose or instructions for participants. */
  description: Scalars['String'];
  /** Unique identifier for this phase. */
  id: Scalars['UUID'];
  /** Human-readable label shown in the workflow UI. */
  name: Scalars['String'];
  /** Zero-based position determining the sequence of phases within a workflow. */
  order: Scalars['Int'];
  /** When the first task or step in this phase was begun; null if not yet started. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** When this phase record was last modified. */
  updatedAt: Scalars['DateTime'];
  /** The workflow this phase belongs to. */
  workflow: Workflow;
};

/** Maps a phase home column on the source board to a column on the destination board. */
export type PhaseColumnRemapInput = {
  fromColumnId: Scalars['UUID'];
  toColumnId: Scalars['UUID'];
};

/** Wrapper returned by phase mutations, includes the affected phase and a refetch entry point. */
export type PhaseResponse = {
  __typename: 'PhaseResponse';
  /** The created or updated phase. */
  phase: Phase;
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
};

/** Maps a template placeholder role to the email of the person filling that role. */
export type PlaceholderAssignmentInput = {
  /** Email of the person who will fill this role. */
  email: Scalars['EmailAddress'];
  /** The template role to assign. */
  userDefinedRoleId: Scalars['UUID'];
};

/**
 * Streamed event carrying a chat-harness plan snapshot. Initially published
 * once at plan creation; later re-published after each node completes so
 * clients can render incremental nodeOutputs without an extra event type.
 */
export type PlanSnapshotEvent = {
  __typename: 'PlanSnapshotEvent';
  /** ID of the message the plan is associated with */
  messageId: Scalars['UUID'];
  /** Validated PlanState JSON. Shape matches @aline/common PlanStateSchema. */
  planJson: Scalars['JSON'];
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** ID of the user who initiated the agent prompt */
  userId: Scalars['UUID'];
};

/** Collection of compliance rules that can be run against documents to check adherence to legal or business standards. */
export type Playbook = {
  __typename: 'Playbook';
  /** The categories that group this playbook's rules, in rank order. */
  categories: Array<PlaybookRuleCategory>;
  /** When this playbook was created. */
  createdAt: Scalars['DateTime'];
  /** User who created this playbook, if known. */
  createdBy: Maybe<User>;
  /** Optional description of this playbook. */
  description: Scalars['String'];
  /** The AI run that produced this playbook, if it came from one. */
  generationJob: Maybe<PlaybookGenerationJob>;
  /** Unique identifier for this playbook. */
  id: Scalars['UUID'];
  /** Most recent time any of this playbook's rules was run, if ever. */
  lastRunAt: Maybe<Scalars['DateTime']>;
  /** Number of rules in this playbook. */
  ruleCount: Scalars['Int'];
  /** The rules that this playbook contains, each an ordered list of positions. */
  rules: Array<PlaybookRule>;
  /**
   * This playbook's rollup status against one document, over one run per rule.
   *
   * Answers the only question a list of playbook cards asks about a document, at
   * the cost of one enum per card. Reading the rules and their runs to derive it
   * in the client instead means every card carrying the run text and per-position
   * explanations of a playbook it only wants a chip for.
   *
   * Requires Viewer on the document: a playbook is an org-level object, and its
   * runs are state about a document that has permissions of its own.
   */
  runStatus: PlaybookRunStatus;
  /** Title of this playbook. */
  title: Scalars['String'];
  /** When this playbook was last modified. */
  updatedAt: Scalars['DateTime'];
  /** Number of distinct documents this playbook has been run against. */
  usedInDocumentCount: Scalars['Int'];
};


/** Collection of compliance rules that can be run against documents to check adherence to legal or business standards. */
export type PlaybookRunStatusArgs = {
  documentId: Scalars['UUID'];
};

/** A named category with the rules to create under it, used when seeding a new playbook. */
export type PlaybookCategoryInput = {
  /** Category name to group these rules under. */
  category: Scalars['String'];
  /**
   * Rules to create under this category, in order. Each rule's first position
   * becomes its Starting Position; any others become its fallbacks.
   */
  rules: Array<CreatePlaybookRuleProps>;
};

/** Background job that generates a playbook of compliance rules, from source documents when they were given and from intake alone when they were not. */
export type PlaybookGenerationJob = {
  __typename: 'PlaybookGenerationJob';
  /** When this job record was created. */
  createdAt: Scalars['DateTime'];
  /** Every document the playbook is read from. */
  documents: Array<Document>;
  /** When the job failed, if at all. */
  failedAt: Maybe<Scalars['DateTime']>;
  /** Why the job failed, if at all. */
  failedReason: Maybe<Scalars['String']>;
  /** The date at which this job finished executing against the document. */
  finishedAt: Maybe<Scalars['DateTime']>;
  /** How many categories have been written so far. */
  generatedCategoryCount: Scalars['Int'];
  /** Unique identifier for this generation job. */
  id: Scalars['UUID'];
  /**
   * The category this run is currently writing rules into, if any. Null
   * between categories and after the last one ends.
   */
  openCategory: Maybe<PlaybookRuleCategory>;
  /** Playbook generated. Nullable because playbook generation could fail. */
  playbook: Maybe<Playbook>;
  /** The date at which this job was started running against the document. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** When this job record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** Real-time event payload delivered when a playbook generation job's status changes. */
export type PlaybookGenerationJobUpdatedEvent = {
  __typename: 'PlaybookGenerationJobUpdatedEvent';
  /** The category created by this event, with an empty rules list until rules arrive. */
  createdCategory: Maybe<PlaybookRuleCategory>;
  /** The category created by this event, if the model just opened one. */
  createdCategoryId: Maybe<Scalars['UUID']>;
  /** The rule created by this event. */
  createdRule: Maybe<PlaybookRule>;
  /** The rule created by this event, if the model just finished one. */
  createdRuleId: Maybe<Scalars['UUID']>;
  /** The updated generation job. Null if the job was deleted. */
  generationJob: Maybe<PlaybookGenerationJob>;
  /** ID of the generation job that was updated. */
  generationJobId: Scalars['UUID'];
};

/** Result of checking playbook mention access. */
export type PlaybookMentionAccessResult = MentionAccessError | Playbook;

/** Whether a position satisfied the document it was evaluated against. */
export enum PlaybookPositionStatus {
  /** This position suggested changes to the document, or failed to evaluate. */
  Failing = 'Failing',
  /** The document already complies with this position — nothing to change. */
  Passing = 'Passing'
}

/** An individual compliance check, evaluated at one or more positions. */
export type PlaybookRule = {
  __typename: 'PlaybookRule';
  /** Category this rule is filed under. */
  category: PlaybookRuleCategory;
  /** When this rule was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier for this rule. */
  id: Scalars['UUID'];
  /** Playbook that this rule is a part of. */
  playbook: Playbook;
  /**
   * Ordered stances this rule can be evaluated at. Index 0 is the Starting
   * Position and indices 1..n are its fallbacks, in display order. Never empty.
   */
  positions: Array<PlaybookRulePosition>;
  /**
   * Fractional index ordering this rule within its category. Opaque — compare
   * ranks, never parse them, and never compare across categories.
   */
  rank: Scalars['String'];
  /** The job of this playbook rule in a given document. */
  ruleJob: Maybe<PlaybookRuleJob>;
  /**
   * Short name for the rule, e.g. 'Governing Law'. Empty until somebody names it,
   * which is the state a rule is created in — an empty title is how a client
   * tells an unnamed rule from a named one.
   */
  title: Scalars['String'];
  /** When this rule was last modified. */
  updatedAt: Scalars['DateTime'];
};


/** An individual compliance check, evaluated at one or more positions. */
export type PlaybookRuleRuleJobArgs = {
  documentId: Scalars['UUID'];
};

/** A named grouping of playbook rules within a playbook, used to organize and order related rules. */
export type PlaybookRuleCategory = {
  __typename: 'PlaybookRuleCategory';
  /** When this category was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier for this category. */
  id: Scalars['UUID'];
  /** Display name of the category (e.g. 'Liability', 'Payment Terms'). */
  name: Scalars['String'];
  /** Playbook this category belongs to. */
  playbook: Playbook;
  /**
   * Fractional index ordering this category within its playbook. Opaque — compare
   * ranks, never parse them, and never compare across playbooks.
   */
  rank: Scalars['String'];
  /** The rules filed under this category, in rank order. */
  rules: Array<PlaybookRule>;
  /** When this category was last modified. */
  updatedAt: Scalars['DateTime'];
};

/** The execution of a rule against a document. */
export type PlaybookRuleJob = {
  __typename: 'PlaybookRuleJob';
  /** When this rule job was created. */
  createdAt: Scalars['DateTime'];
  /** The date at which this rule failed to execute against the document. */
  failedAt: Maybe<Scalars['DateTime']>;
  /** The reason this rule failed to execute against the document. */
  failedReason: Maybe<Scalars['String']>;
  /** The date at which this rule finished executing against the document. */
  finishedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this rule job execution. */
  id: Scalars['UUID'];
  /**
   * One result per evaluated position, ordered by each result's snapshotted
   * rank. Evaluation stops at the first passing position, so weaker fallbacks
   * have no result. Empty until the rule has been run against the document.
   */
  positionResults: Array<PlaybookRuleJobPositionResult>;
  /** One proposal per failing position of the run. */
  proposals: Array<PlaybookRuleProposal>;
  /** The reviewer's resolution of this rule, if any. */
  resolution: Maybe<PlaybookRuleJobResolution>;
  /**
   * The rule this job ran. Null if that rule has since been deleted — the job
   * keeps its snapshotted results rather than disappearing with the template.
   */
  rule: Maybe<PlaybookRule>;
  /** The date at which this rule started executing against the document. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** When this rule job was last modified. */
  updatedAt: Scalars['DateTime'];
};

/**
 * The outcome of evaluating one of a rule's positions against a document. The
 * text is a snapshot taken at run time, so a stored result stays readable after
 * the position it came from is edited, reordered, or deleted.
 *
 * A run evaluates positions strongest to weakest and stops at the first passing
 * one, so there is one result per evaluated position — weaker fallbacks have no
 * result at all.
 */
export type PlaybookRuleJobPositionResult = {
  __typename: 'PlaybookRuleJobPositionResult';
  /** The position's AI guidance, as it read when the run happened. */
  aiGuidance: Maybe<Scalars['String']>;
  /** Explains at a high level why this position passes or what needs changing. */
  explanation: Scalars['String'];
  /** When this position failed to evaluate, if it did. */
  failedAt: Maybe<Scalars['DateTime']>;
  /** Why this position failed to evaluate, if it did. */
  failedReason: Maybe<Scalars['String']>;
  /** When this position finished evaluating, if it did. */
  finishedAt: Maybe<Scalars['DateTime']>;
  /** ID of the position that was evaluated. */
  positionId: Scalars['UUID'];
  /**
   * The position's rank, as it stood when the run happened. Orders the results
   * the way the rule read at run time, which is not necessarily how it reads now.
   */
  rank: Scalars['String'];
  /** The position's requirement text, as it read when the run happened. */
  ruleText: Scalars['String'];
  /** Whether this position passed against the document. */
  status: PlaybookPositionStatus;
};

/**
 * The reviewer's one recorded action on a reviewable rule. A rule is Resolved
 * iff this exists. Suggested edits materialized into the document are handled
 * (accept/keep/reject) there, not here.
 */
export type PlaybookRuleJobResolution = {
  __typename: 'PlaybookRuleJobResolution';
  /** When the rule was resolved. */
  at: Scalars['DateTime'];
  /** Which user resolved it. */
  by: User;
  /** Which action resolved the rule. */
  kind: PlaybookRuleResolutionKind;
  /**
   * The position the action was taken on: the failing position whose proposal
   * was materialized, or the accepted fallback. Null for Manual, which resolves
   * the rule as a whole.
   */
  positionId: Maybe<Scalars['UUID']>;
};

/** One stance a rule can take: the requirement text plus the guidance the AI uses when commenting on it. */
export type PlaybookRulePosition = {
  __typename: 'PlaybookRulePosition';
  /** Optional instructions that guide the AI when commenting on this position. */
  aiGuidance: Maybe<Scalars['String']>;
  /** Unique identifier for this position within its rule. */
  id: Scalars['UUID'];
  /**
   * Fractional index ordering this position within its rule: the lowest rank is
   * the Starting Position and the rest are its fallbacks. Opaque — compare ranks,
   * never parse them, and never compare across rules.
   */
  rank: Scalars['String'];
  /** The compliance requirement text the AI evaluates documents against. */
  ruleText: Scalars['String'];
};

/** Text and guidance for a rule position. */
export type PlaybookRulePositionProps = {
  /** Optional instructions to guide AI commenting on this position. */
  aiGuidance?: InputMaybe<Scalars['String']>;
  /** The compliance requirement text the AI will evaluate documents against. */
  ruleText: Scalars['String'];
};

/**
 * The ordered set of suggestions a rule job generated for one failing position,
 * plus the review decisions made on them.
 *
 * Each suggestion pairs the generated HtmlEdit (the only valid input to
 * materialization) with the preview cards it produced, under an id minted at
 * generation time — the unit the reviewer accepts or rejects, and the unit of
 * staleness. Both fields are opaque JSON parsed client-side with the zod schemas
 * in the common package (ProposalSuggestionsSchema, ProposalDecisionsSchema), so
 * the shape has one owner and cannot drift.
 */
export type PlaybookRuleProposal = {
  __typename: 'PlaybookRuleProposal';
  /** When this proposal was generated. */
  createdAt: Scalars['DateTime'];
  /**
   * Review decisions keyed by suggestion id (accepted or rejected); a missing
   * key means undecided. Accepted is immutable — those edits are already the
   * reviewer's own document changes.
   */
  decisions: Scalars['JSON'];
  /** Unique identifier for this proposal. */
  id: Scalars['UUID'];
  /** Which of the rule's failing positions this proposal would satisfy. */
  positionId: Scalars['UUID'];
  /** The suggestion units (ProposalSuggestions), in generation order. */
  suggestions: Scalars['JSON'];
};

/**
 * How a reviewer resolved a rule on a document. There are four kinds; at most
 * one resolution exists per rule job, and clearing it reopens the rule for
 * review.
 */
export enum PlaybookRuleResolutionKind {
  /** Accepted the passing fallback position for this document. */
  Fallback = 'Fallback',
  /** Manually accepted the rule without taking any proposal. */
  Manual = 'Manual',
  /**
   * Every suggestion of a failing position was reviewed (accepted or rejected).
   * Set automatically by the review mutation when the last decision lands —
   * never passed to resolvePlaybookRuleJob.
   */
  Reviewed = 'Reviewed',
  /** Materialized a failing position's proposal into the document as AI edits. */
  Suggest = 'Suggest'
}

/**
 * A playbook's rollup status against one document.
 *
 * There is deliberately no Failed: a run that errored still leaves the playbook
 * needing a person, and a playbook whose reviewable rules are all resolved reads
 * as Resolved even though that status is derived, never stored.
 */
export enum PlaybookRunStatus {
  /** No rule of this playbook has been run against the document. */
  NotRun = 'NotRun',
  /** Every rule has an outcome and none of them needed review. */
  Passed = 'Passed',
  /** Every rule has an outcome and every reviewable one is resolved. */
  Resolved = 'Resolved',
  /** A rule needs a person: an unresolved failing position, or a run that errored. */
  Review = 'Review',
  /** A review is underway — a decision is recorded on a rule that has not resolved. */
  Reviewing = 'Reviewing',
  /** At least one rule is running. */
  Running = 'Running'
}

/** One ranked playbook search result. */
export type PlaybookSearchResult = {
  __typename: 'PlaybookSearchResult';
  /** Human-readable explanation of why this playbook matched. */
  matchReason: Scalars['String'];
  /** Matched playbook. */
  playbook: Playbook;
  /** Number of rules in the matched playbook. */
  ruleCount: Scalars['Int'];
  /** Search ranking score. Higher scores are better matches. */
  score: Scalars['Int'];
};

/** The reviewer's decision on one suggestion. */
export enum PlaybookSuggestionReviewDecision {
  /** The suggestion's edits are in the document as the reviewer's own changes. Immutable. */
  Accepted = 'Accepted',
  /** The suggestion was declined without touching the document. Reversible. */
  Rejected = 'Rejected',
  /** Clears a rejection back to no decision. Only valid on a rejected suggestion. */
  Undecided = 'Undecided'
}

/** A skill with no draft is returned as it is, so a retried publish succeeds. */
export type PublishAgentSkillDraftInput = {
  expectedRevision: Scalars['Int'];
  id: Scalars['UUID'];
};

/** Queries for retrieving reusable variable configuration templates. */
export type Query = {
  __typename: 'Query';
  TEST_scalars: Test_Scalars;
  /** Get access requests by batch ID (for grant access page) */
  accessRequestsByBatchId: Maybe<AccessRequestByBatchResult>;
  /** Look up a single account by its ID and type. Returns null if not found. */
  account: Maybe<Account>;
  /** Retrieve users and organizations associated with a given document or workflow */
  accounts: Accounts;
  /** Get the ActiveWorkflowPermissions for a particular workflow. */
  activePermissions: Array<WorkflowPermission>;
  adminAiUsage: AdminAiUsage;
  adminAiUsageDetailRows: AdminAiUsageDetailRows;
  agentSkill: Maybe<AgentSkill>;
  agentSkillAttachment: AgentSkillAttachmentContent;
  /** A file of the author's draft, found by the hash of its bytes, so a rename keeps the same request. */
  agentSkillDraftAttachment: AgentSkillAttachmentContent;
  agentSkills: Array<AgentSkill>;
  /** Fetch a single agent thread by ID, including all messages */
  agentThread: AgentThread;
  /** Fetch all agent threads for the current user, ordered by most recent */
  agentThreads: Array<AgentThread>;
  /** Fetch a single AI reminder automation by its ID */
  aiReminderAutomation: AiReminderAutomation;
  /** Fetch the run history for a specific automation */
  aiReminderAutomationRuns: Array<AiReminderAutomationRun>;
  /** Fetch all AI reminder automations accessible to the current user */
  aiReminderAutomations: Array<AiReminderAutomation>;
  /** Fetch all AI reminder automations configured for a specific report */
  aiReminderAutomationsByReport: Array<AiReminderAutomation>;
  /** Get an Account's Aline subscription. */
  alineSubscription: Maybe<AlineSubscription>;
  /** Fetch the XFDF annotations for a given file version, or null if none exist */
  annotations: Maybe<AnnotationsXfdf>;
  /** Look up a single answer option set by ID. Returns null if not found or not accessible. */
  answerOptions: Maybe<AnswerOptions>;
  /** List all reusable answer option presets accessible to the current user. */
  answerOptionsPresets: Array<AnswerOptions>;
  /** List all CRM connections for the current user, including both configured and available services. */
  apiDeckConnections: Array<ApiDeckConnection>;
  /** Retrieve the ApiDeck consumer for the current org, including all available connections. */
  apiDeckConsumer: Maybe<ApiDeckConsumer>;
  /** Retrieve a single CRM opportunity by ID, including its mapped integration fields. */
  apiDeckOpportunity: Maybe<ApiDeckOpportunityWithRelations>;
  /** List all API keys for the authenticated organization. Requires authentication. */
  apiKeys: Array<ApiKey>;
  /** Returns the current server's expected client version */
  appVersion: AppVersion;
  /** Fetch a single board by its ID */
  board: Board;
  /** Fetch all boards accessible to the current user's organization */
  boards: Array<Board>;
  bulkExport: Maybe<BulkExport>;
  /** Fetch a single canned field by id. */
  cannedField: Maybe<CannedField>;
  /** Active channel installs for the current user's org, newest install first. */
  channelInstallations: Array<ChannelInstallation>;
  /** Fetch a single column by its ID. Returns null if the column does not exist. */
  column: Maybe<Column>;
  /** Get a comment by comment id */
  comment: Maybe<Comment>;
  /** Top-level comments for a commentable (excludes replies; use Comment.replies for threads) */
  comments: Array<Comment>;
  /** All top-level community categories, including their subcategories */
  communityCategories: Array<CommunityCategory>;
  /** Get all community templates for an account. */
  communityTemplates: Array<Document>;
  /** Get the community workflows the requester has access to. */
  communityWorkflows: Array<Workflow>;
  /** Compute pricing estimate for checkout configuration */
  computeCheckoutEstimate: CheckoutEstimate;
  /** Search files in a connection. */
  connectionFilesSearch: Array<FolderFile>;
  /** Get one page of files for a folder. */
  connectionFolderFiles: ConnectionFolderFilesPage;
  /** Count documents matching the given filter model. Used by the AI report approval card to show a live matching-document count without persisting a report. */
  countFilteredDocuments: Scalars['Int'];
  /** A short-lived download URL for a document's latest version. */
  crmDocumentDownloadUrl: Maybe<CrmDownloadUrlResponse>;
  /**
   * The whole launch form for one template: CRM fields, Aline-only fields, signer roles and documents.
   * Pass the record the form was opened on to get each CRM field's current and display value.
   */
  crmLaunchForm: Maybe<CrmLaunchFormResponse>;
  /** Active members of the caller's org, for the signer picker. A failed lookup yields an empty list. */
  crmOrgMembers: Maybe<Array<CrmOrgMember>>;
  /** The org's pairing for a CRM integration; null when never connected. */
  crmPairing: Maybe<CrmPairing>;
  /** Resolves HubSpot owner and user IDs to display names. Missing or ambiguous IDs are omitted. */
  crmResolveUsers: Array<CrmUser>;
  /** Published templates the caller's org can launch from its CRM, by name. */
  crmTemplates: Maybe<Array<Workflow>>;
  /** A short-lived download URL for one file version. */
  crmVersionDownloadUrl: Maybe<CrmDownloadUrlResponse>;
  /** Get current user if available. */
  currentUser: Maybe<User>;
  /** List all storables the current user has soft-deleted (disabled) */
  disabledStorables: Storables;
  /** Get a Document by ID. */
  document: Document;
  /** Get an asset associated with a given Document (e.g., an image in a Document). */
  documentAsset: DocFile;
  /** Get the state of all labels for a set of documents. */
  documentLabelStates: Array<LabelWithDocumentState>;
  documentMetadataImport: Maybe<DocumentMetadataImport>;
  documentMetadataImportPreview: DocumentMetadataImportPreview;
  documentMetadataImports: Array<DocumentMetadataImport>;
  /** Get document info (e.g., for exporting to DOCX client-side). */
  documentParts: DocumentParts;
  /** Get the zero-based row index of a document within a report's sorted/filtered rows. Returns -1 if not found. */
  documentRowIndex: Scalars['Int'];
  /** The current user's background status changes that are running or finished within the last 15 minutes. */
  documentStatusJobs: Array<DocumentStatusJob>;
  /** Get a user that is associated with a Document (e.g., made a comment, suggested edit, etc.). */
  documentUser: Maybe<User>;
  /** Get DocumentVariable by id. */
  documentVariable: Maybe<DocumentVariable>;
  /** Given a documentId, return all Workflows that contain the Document. */
  documentWorkflows: Array<Workflow>;
  /** Get Documents by id set. */
  documents: Array<Document>;
  /** Filestack tokens for downloading a file by filestack handle. */
  downloadSecurity: FilestackDownloadOptions;
  /** Get drives. */
  drives: Array<Drive>;
  /** Get a single envelope by its ID. */
  envelope: Maybe<Envelope>;
  /** Get all envelopes available to the user. */
  envelopes: Array<Envelope>;
  /** List organization policy rows. Organization administrators only. */
  externalToolkitPolicies: Array<ExternalToolkitPolicyRow>;
  /** List governed external toolkits for the current user. */
  externalToolkits: Array<ExternalToolkit>;
  /** Get an extraction job by id. */
  extractionJob: ExtractionJob;
  /** Get an ExtractionQuestion by ID. */
  extractionQuestion: Maybe<ExtractionQuestion>;
  /** Get an ExtractionQuestion with all its dependencies (input questions and questions that use it as an input). */
  extractionQuestionWithDependencies: Array<ExtractionQuestion>;
  /** Get ExtractionQuestions available to the current user. */
  extractionQuestions: Array<ExtractionQuestion>;
  /** Get ExtractionQuestions for a document. */
  extractionQuestionsForDocument: ExtractionQuestionForDocumentResponse;
  /** List all storables the current user has favorited */
  favoriteStorables: Storables;
  /** Fetch a field by its unique ID */
  field: Maybe<Field>;
  /** Fetch a field by its node reference ID within a specific document */
  fieldByNodeRefId: Maybe<Field>;
  /** Get a file by ID. */
  file: DocFile;
  /** Get all file storage connections for a user. */
  fileStorageConnections: Array<FileStorageConnection>;
  /** Fetch a single file version by ID */
  fileVersion: FileVersion;
  /** Retrieves a group of Files. */
  files: Array<DocFile>;
  /** Get a single folder sync job by ID. */
  folderSyncJob: Maybe<FolderSyncJob>;
  /** Get all folder sync jobs. */
  folderSyncJobs: Array<FolderSyncJob>;
  /** Get all folders for a connection. */
  folderSyncJobsForConnection: Array<FolderSyncJob>;
  /** Returns a short-lived Aline download URL for the latest version of a document. Static file versions redirect to Filestack; native editor documents download as DOCX. Supports API key auth with documents:read permission. */
  getDocumentDownloadURL: Maybe<Scalars['String']>;
  /** Returns a short-lived Aline download URL for a specific file version. Static file versions redirect to Filestack; native editor versions download as DOCX. Supports API key auth with documents:read permission. */
  getFileVersionDownloadURL: Maybe<Scalars['String']>;
  /** If the user has imported a workflow with a given sourceWorkflowId, return it. */
  getImportedWorkflow: Maybe<Workflow>;
  /** Get all reminders whose due date falls within the given date range. */
  getRemindersInRange: ReminderRowsResponse;
  /** Look up a single group by its ID */
  group: Group;
  /** List all groups in the current organization */
  groups: Array<Group>;
  /** Check whether the current account has an active DocuSign integration. */
  hasDocuSignAuth: DocuSignIntegratedResponse;
  /** The viewer's inbox: the org's active notifications minus the ones the viewer dismissed. */
  inboxNotifications: InboxNotificationsResult;
  insightPin: Maybe<InsightPin>;
  /** Insight Pins for the current user (personal + org). */
  insightPins: Array<InsightPin>;
  /** Fetch a single intake form template by id (org-scoped). */
  intakeFormTemplate: Maybe<IntakeFormTemplate>;
  /** List the intake form templates available to the authenticated org. */
  intakeFormTemplates: Array<IntakeFormTemplate>;
  /** Retrieve a single integration field value for a specific opportunity and service. */
  integrationField: Maybe<IntegrationField>;
  /** List CRM opportunities from a connected service with optional filtering and cursor-based pagination. */
  integrationOpportunities: ApiDeckOpportunitiesResponse;
  /** A single label. */
  label: Maybe<Label>;
  /** Attempts to find label with a given string relevant to the requester. */
  labelByName: Maybe<Label>;
  /** Workflow Labels accessible to the user. */
  labels: Array<Label>;
  /** Get a linked opportunity */
  linkedOpportunity: LinkedOpportunity;
  /** Find out the login type by email */
  loginTypeByEmail: LoginType;
  /** Determines whether a given template can be published to the community. */
  mayPublishTemplateToCommunity: MayPublishToCommunityResult;
  /** Determines whether a given workflow can be published to the community. */
  mayPublishWorkflowToCommunity: MayPublishToCommunityResult;
  /** Hydrate all entity mentions used by AI Chat in a single request. */
  mentionEntities: MentionEntitiesResult;
  /** Check if current user has pending requests for specific documents */
  myAccessRequestsForDocuments: Array<MyAccessRequestInfo>;
  myBulkExports: Array<BulkExport>;
  /** All contract types available to the authenticated user's account */
  myContractTypes: Array<ContractType>;
  /** All @-mentions of the authenticated user across all comments, ordered by most recent */
  myMentions: Array<Mention>;
  /** Get the requester's most-used template workflows. */
  myMostUsedTemplateWorkflows: Array<Workflow>;
  /** Get the requester's default repository view. */
  myRepository: Report;
  /** Get an organization. */
  org: Maybe<Org>;
  /** Determine if a prospective org name is unique. */
  orgNameUnique: OrgUniqueResponse;
  /** Get all available Orgs. */
  orgs: Array<Org>;
  /** Get all Parties the requester is authorized to view. */
  parties: Array<Party>;
  /** Get a party by id. */
  party: Maybe<Party>;
  /** Get a paginated, filtered, and sorted list of Parties the requester is authorized to view. */
  partyRows: PartyRowsInfo;
  /** Get the WorkflowPermissions for a particular workflow. */
  permissions: Array<WorkflowPermission>;
  /** Look up a single phase by its ID. Returns null if not found or not accessible. */
  phase: Maybe<Phase>;
  /**
   * Get a playbook by id. Null when no playbook has that id, which is how a page
   * left open on a playbook that was since deleted finds out; a playbook that
   * exists but is not accessible to the caller is refused.
   */
  playbook: Maybe<Playbook>;
  /**
   * Get one playbook generation job by id, for a caller holding a job id rather
   * than a document. Null when the job is gone, which is how a cancelled
   * generation reads: cancelling deletes the job.
   */
  playbookGenerationJob: Maybe<PlaybookGenerationJob>;
  /** List playbook generation jobs for the caller's organization. */
  playbookGenerationJobs: Array<PlaybookGenerationJob>;
  /** Get a rule by id. */
  playbookRule: Maybe<PlaybookRule>;
  /** Get the rules filed under a category, in rank order. */
  playbookRulesForCategory: Array<PlaybookRule>;
  /** Get all playbooks available to the current user. */
  playbooks: Array<Playbook>;
  /** Get popular template workflows accessible to the requester. */
  popularTemplateWorkflows: Array<Workflow>;
  /** List question generation jobs for a given document. */
  questionGenerationJobs: Array<ExtractionQuestionGenerationJob>;
  /** Get the QueuedWorkflowPermissions for a particular workflow. */
  queuedPermissions: Array<WorkflowPermission>;
  /** Get a single reminder by ID. */
  reminder: Reminder;
  /** List reminders with an optional completion-state filter. */
  reminders: ReminderRowsResponse;
  /** Get reminders that require a notification to be sent as of the given date. */
  remindersRequiringNotification: ReminderRowsResponse;
  /** Get a report by report ID */
  report: Maybe<Report>;
  /** Get all possible column options for reports */
  reportColumnOptions: Array<ReportColumnOption>;
  /** Get all available reports */
  reports: Array<Report>;
  /** Get aggregated relationship-pipeline counts for a repository. */
  repositoryMeta: RepositoryMeta;
  /** Who this request acts as, and which credential decided that. */
  requester: Requester;
  /** Fetch Salesforce record data for pre-populating a workflow launch form */
  salesforceRecordData: SalesforceRecordDataResponse;
  /** Fetch all storables the current user can access, used for search autocomplete */
  searchData: Storables;
  /** Discover mentionable entities for the unified mention picker. */
  searchMentionEntities: SearchMentionEntitiesResult;
  /** Search Parties the requester is authorized to view by name/description. Returns up to limit matches sorted by name, starting at offset. Optimized for paginated type-ahead pickers. */
  searchParties: Array<Party>;
  /** Search playbooks available to the current user. */
  searchPlaybooks: Array<PlaybookSearchResult>;
  /** List all storables shared with the current user and their associated permissions */
  sharedStorables: Array<StorablePermission>;
  /** Fetch lightweight metadata for a single storable by ID */
  storableMetadata: Storable;
  /** List all permission entries for a storable, showing who has access and at what role */
  storablePermissions: Array<StorablePermission>;
  /** Fetch the current user's permission for a specific storable, or null if no access */
  storableRole: Maybe<StorablePermission>;
  /** Fetch storables by a list of IDs */
  storables: Storables;
  /** Returns the open-source licenses supported for the Aline Community. */
  supportedLicenses: Array<SupportedLicense>;
  /** Look up a single task by ID. Returns null if not found or not accessible. */
  task: Maybe<Task>;
  /** List all tasks the current user has permission to view. */
  tasks: Array<Task>;
  /** Get template for an opportunity */
  templateOpportunityAttributes: Array<IntegrationField>;
  /** Get Salesforce field requirements for a template (supports API key auth with templates:read permission). */
  templateSalesforceFields: TemplateSalesforceFieldsResponse;
  /** Get workflow templates for the authenticated org (supports API key auth with templates:read permission). */
  templates: Array<Workflow>;
  /** Get top community contributors */
  topCommunityContributors: Array<Account>;
  /** Get the top community templates. */
  topCommunityTemplates: Array<Document>;
  /** Get the top community workflows. */
  topCommunityWorkflows: Array<Workflow>;
  /** List upgrade requests for the current user's organization. */
  upgradeRequests: Array<UpgradeRequest>;
  /** Retrieves a policy and security for filestack. */
  uploadSecurity: Maybe<FilestackUploadOptions>;
  /** Signed Filestack upload credentials for an enabled public launch config. */
  uploadSecurityViaLaunchConfig: Maybe<FilestackUploadOptions>;
  /** Get a user by user id. */
  user: Maybe<User>;
  /** Attempt to get the corresponding UserDefinedRole */
  userDefinedRole: Maybe<UserDefinedRole>;
  /** Get all user defined roles relevant to the requesting user */
  userDefinedRoles: Array<UserDefinedRole>;
  /** List incomplete tasks assigned to or accessible by the current user, useful for dashboard views. */
  userIncompleteTasks: Array<Task>;
  /** Get users viewable by the requester. */
  users: Array<User>;
  /** Get a variable config by id. */
  variableConfig: DocumentVariableConfig;
  /** Get all variable configs accessible to requester. */
  variableConfigs: Array<DocumentVariableConfig>;
  /** Verify a CSRF token is valid: exists, belongs to the requesting account, and has not expired */
  verifyToken: CsrfToken;
  /** Get a Workflow by id. */
  workflow: Maybe<Workflow>;
  /** Chart series datasets for Insights Pins and the Workflows Charts panel. */
  workflowChartSeries: WorkflowChartSeries;
  /** The access people outside the workflow owner's org hold on a workflow file's document, except the document owner's. Making the file internal removes exactly these. */
  workflowFileExternalAccess: Array<StorablePermission>;
  /** Get the workflows the requester has access to in the inbox. */
  workflowInboxWorkflows: WorkflowRowsInfo;
  /** Complete Insights dashboard for the current user, including Chart series. */
  workflowInsightsDashboard: WorkflowInsightsDashboard;
  /** Fetch a workflow launch config by its ID. */
  workflowLaunchConfig: Maybe<WorkflowLaunchConfig>;
  /** List the CRM connections that are linked to a specific workflow for data mapping. */
  workflowLinkedConnections: Array<ApiDeckConnection>;
  /** Get a specific WorkflowPermission. */
  workflowPermission: Maybe<WorkflowPermission>;
  /** List all phases belonging to a workflow, ordered by their position. */
  workflowPhases: Array<Phase>;
  /** Get WorkflowStep by id */
  workflowStep: Maybe<WorkflowStep>;
  /** Get unique workflow types used by workflows accessible to the requester. */
  workflowTypes: Array<WorkflowTypeOption>;
  workflowView: Maybe<WorkflowView>;
  /** Saved Workflow Views authored by the current user. */
  workflowViews: Array<WorkflowView>;
  /** Get the workflows the requester has access to. */
  workflows: WorkflowRowsInfo;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryTest_ScalarsArgs = {
  input: Test_ScalarsInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAccessRequestsByBatchIdArgs = {
  batchId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAccountArgs = {
  accountType: AccountType;
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAccountsArgs = {
  input: AccountsByInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryActivePermissionsArgs = {
  workflowId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAdminAiUsageArgs = {
  input: AdminAiUsageInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAdminAiUsageDetailRowsArgs = {
  input: AdminAiUsageDetailRowsInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAgentSkillArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAgentSkillAttachmentArgs = {
  path: Scalars['String'];
  skillId: Scalars['UUID'];
  versionId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAgentSkillDraftAttachmentArgs = {
  sha256: Scalars['String'];
  skillId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAgentSkillsArgs = {
  scope?: InputMaybe<AgentSkillScope>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAgentThreadArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAgentThreadsArgs = {
  filter?: AgentThreadHistoryFilter;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAiReminderAutomationArgs = {
  automationId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAiReminderAutomationRunsArgs = {
  automationId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAiReminderAutomationsByReportArgs = {
  reportId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAnnotationsArgs = {
  fileVersionId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryAnswerOptionsArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryApiDeckOpportunityArgs = {
  opportunityId: Scalars['String'];
  serviceId: Scalars['String'];
  workflowId?: InputMaybe<Scalars['UUID']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryBoardArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryBulkExportArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCannedFieldArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryColumnArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCommentArgs = {
  where: CommentWhereInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCommentsArgs = {
  where: CommentsWhereInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryComputeCheckoutEstimateArgs = {
  input: CreateCheckoutUrlInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryConnectionFilesSearchArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  driveId?: InputMaybe<Scalars['String']>;
  integration: FileStorageIntegration;
  query: Scalars['String'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryConnectionFolderFilesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  driveId: Scalars['String'];
  folderId?: InputMaybe<Scalars['String']>;
  integration: FileStorageIntegration;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCountFilteredDocumentsArgs = {
  filterModel: Scalars['JSON'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCrmDocumentDownloadUrlArgs = {
  alineDocumentId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCrmLaunchFormArgs = {
  integration: CrmIntegration;
  sourceRecordId?: InputMaybe<Scalars['ID']>;
  sourceRecordType?: InputMaybe<Scalars['String']>;
  templateId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCrmPairingArgs = {
  integration: Integration;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCrmResolveUsersArgs = {
  integration: CrmIntegration;
  userIds: Array<Scalars['String']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryCrmVersionDownloadUrlArgs = {
  alineVersionId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentArgs = {
  documentId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentAssetArgs = {
  input: DocumentAssetInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentLabelStatesArgs = {
  input: DocumentLabelStateInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentMetadataImportArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentMetadataImportPreviewArgs = {
  importId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentPartsArgs = {
  documentId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentRowIndexArgs = {
  documentId: Scalars['UUID'];
  filterModel?: InputMaybe<Scalars['JSON']>;
  filterTimeZone?: InputMaybe<Scalars['String']>;
  listFilter?: InputMaybe<DocumentListFilter>;
  reportId: Scalars['UUID'];
  sortModel?: InputMaybe<Scalars['JSON']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentUserArgs = {
  input: DocumentUserInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentVariableArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentWorkflowsArgs = {
  documentId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDocumentsArgs = {
  documentIds: Array<Scalars['UUID']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDownloadSecurityArgs = {
  docFileId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryDrivesArgs = {
  integration: FileStorageIntegration;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryEnvelopeArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryExtractionJobArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryExtractionQuestionArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryExtractionQuestionWithDependenciesArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryExtractionQuestionsForDocumentArgs = {
  documentId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryFieldArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryFieldByNodeRefIdArgs = {
  input: FieldInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryFileArgs = {
  fileId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryFileVersionArgs = {
  fileVersionId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryFilesArgs = {
  fileIds: Array<Scalars['UUID']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryFolderSyncJobArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryFolderSyncJobsForConnectionArgs = {
  integration: FileStorageIntegration;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryGetDocumentDownloadUrlArgs = {
  documentId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryGetFileVersionDownloadUrlArgs = {
  fileVersionId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryGetImportedWorkflowArgs = {
  sourceWorkflowId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryGetRemindersInRangeArgs = {
  endOfRange: Scalars['Date'];
  startOfRange: Scalars['Date'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryGroupArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryInsightPinArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryInsightPinsArgs = {
  scope?: InputMaybe<InsightScope>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryIntakeFormTemplateArgs = {
  intakeFormTemplateId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryIntegrationFieldArgs = {
  input: IntegrationFieldInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryIntegrationOpportunitiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OpportunityFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  serviceId: Scalars['String'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryLabelArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryLabelByNameArgs = {
  labelText: Scalars['String'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryLinkedOpportunityArgs = {
  linkOpportunityId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryLoginTypeByEmailArgs = {
  email: Scalars['EmailAddress'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryMayPublishTemplateToCommunityArgs = {
  templateId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryMayPublishWorkflowToCommunityArgs = {
  workflowId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryMentionEntitiesArgs = {
  input: MentionEntitiesInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryMyAccessRequestsForDocumentsArgs = {
  documentIds: Array<Scalars['UUID']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryMyBulkExportsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryMyMostUsedTemplateWorkflowsArgs = {
  num?: InputMaybe<Scalars['Int']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryOrgArgs = {
  orgId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryOrgNameUniqueArgs = {
  input: OrgNameUniqueInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPartyArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPartyRowsArgs = {
  cursor?: InputMaybe<Scalars['UUID']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortModel?: InputMaybe<Scalars['JSON']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPermissionsArgs = {
  workflowId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPhaseArgs = {
  phaseId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPlaybookArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPlaybookGenerationJobArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPlaybookRuleArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPlaybookRulesForCategoryArgs = {
  categoryId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryPopularTemplateWorkflowsArgs = {
  num?: InputMaybe<Scalars['Int']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryQuestionGenerationJobsArgs = {
  documentId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryQueuedPermissionsArgs = {
  workflowId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryReminderArgs = {
  reminderId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryRemindersArgs = {
  filter?: InputMaybe<ReminderFilter>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryRemindersRequiringNotificationArgs = {
  asOfDate: Scalars['Date'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryReportArgs = {
  reportId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryRepositoryMetaArgs = {
  repositoryId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QuerySalesforceRecordDataArgs = {
  input: SalesforceRecordDataInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QuerySearchMentionEntitiesArgs = {
  input: SearchMentionEntitiesInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QuerySearchPartiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QuerySearchPlaybooksArgs = {
  input: SearchPlaybooksInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryStorableMetadataArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryStorablePermissionsArgs = {
  storableId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryStorableRoleArgs = {
  storableId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryStorablesArgs = {
  ids: Array<Scalars['UUID']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryTaskArgs = {
  taskId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryTemplateOpportunityAttributesArgs = {
  serviceId: Scalars['String'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryTemplateSalesforceFieldsArgs = {
  templateId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryTopCommunityContributorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryTopCommunityTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryTopCommunityWorkflowsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryUpgradeRequestsArgs = {
  status?: InputMaybe<UpgradeRequestStatus>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryUploadSecurityViaLaunchConfigArgs = {
  launchConfigId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryUserArgs = {
  userId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryUserDefinedRoleArgs = {
  roleId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryVariableConfigArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryVerifyTokenArgs = {
  token: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowArgs = {
  workflowId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowChartSeriesArgs = {
  input: WorkflowChartSeriesInput;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowFileExternalAccessArgs = {
  workflowFileId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowInboxWorkflowsArgs = {
  cursor?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<WorkflowInboxFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowLaunchConfigArgs = {
  launchConfigId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowLinkedConnectionsArgs = {
  workflowId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowPermissionArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowPhasesArgs = {
  workflowId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowStepArgs = {
  stepId: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowViewArgs = {
  id: Scalars['UUID'];
};


/** Queries for retrieving reusable variable configuration templates. */
export type QueryWorkflowsArgs = {
  cursor?: InputMaybe<Scalars['UUID']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  grain?: InputMaybe<Scalars['String']>;
  groupFields?: InputMaybe<Array<Scalars['String']>>;
  groupKeys?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  listFilter?: InputMaybe<WorkflowListFilter>;
  sortModel?: InputMaybe<Scalars['JSON']>;
  workflowFilter?: InputMaybe<WorkflowFilterInput>;
};

/** Event payload when an AI question generation job status changes. */
export type QuestionGenerationJobUpdatedEvent = {
  __typename: 'QuestionGenerationJobUpdatedEvent';
  /** The generation job with its current state, or null if deleted. */
  generationJob: Maybe<ExtractionQuestionGenerationJob>;
  /** ID of the generation job that was updated. */
  generationJobId: Scalars['UUID'];
};

/** Aggregate state of locked extraction jobs across a report's documents for a single question. */
export enum QuestionLockState {
  /** All cells in scope are locked. */
  All = 'All',
  /** No cells exist in scope at all. */
  Empty = 'Empty',
  /** Cells exist in scope but none are locked. */
  None = 'None',
  /** Some cells in scope are locked, others are not. */
  Partial = 'Partial'
}

/** Aggregate lock counts for an extraction question within a report's document scope. */
export type QuestionLockStatus = {
  __typename: 'QuestionLockStatus';
  /** Number of locked ExtractionJobs. */
  lockedCount: Scalars['Int'];
  /** Aggregate state derived from the counts. */
  state: QuestionLockState;
  /** Total ExtractionJobs in scope (locked + unlocked). */
  totalCount: Scalars['Int'];
};

/** A selectable option for Single/Multi select extraction questions. */
export type QuestionOption = {
  __typename: 'QuestionOption';
  /** Hex color code used to visually distinguish this option in the UI. */
  color: Scalars['String'];
  /** Unique identifier for this option. */
  id: Scalars['UUID'];
  /** Display label for this option. */
  label: Scalars['String'];
  /** Sort position among sibling options (lower values appear first). */
  order: Scalars['Int'];
};

/** Properties for a question option (used when creating). */
export type QuestionOptionInput = {
  /** Hex color code for visual distinction. */
  color: Scalars['String'];
  /** Display label for the option. */
  label: Scalars['String'];
  /** Sort position among sibling options. */
  order: Scalars['Int'];
};

export type ReassignRecipientInput = {
  assignedRoleId?: InputMaybe<Scalars['UUID']>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  message?: InputMaybe<Scalars['String']>;
  permissionId?: InputMaybe<Scalars['UUID']>;
  recipientId: Scalars['UUID'];
};

export type ReassignRecipientResult = {
  __typename: 'ReassignRecipientResult';
  clearedSignatureFieldNodeIds: Array<Scalars['UUID']>;
  recipient: WorkflowRecipient;
};

/** Input for fetching a recipient's signing view URL. */
export type RecipientViewUrlInput = {
  /** The envelope to generate a view URL for. */
  envelopeId: Scalars['UUID'];
};

/** Input for rejecting a task. */
export type RejectTaskInput = {
  /** Why the task is rejected. Required. */
  reason: Scalars['String'];
  taskId: Scalars['UUID'];
};

/** Direction of a document in the relationship tree relative to the expanded document. */
export enum RelationshipDirection {
  /** The linked document is a child of the expanded document. */
  Child = 'CHILD',
  /** The linked document is a parent of the expanded document. */
  Parent = 'PARENT'
}

/** Whether a notification fires before or after a reminder's due date */
export enum RelativeTimePosition {
  /** Notify after the due date */
  After = 'After',
  /** Notify before the due date */
  Before = 'Before'
}

/** Time unit for scheduling notification offsets relative to a due date */
export enum RelativeTimeUnit {
  /** Offset measured in days */
  Days = 'Days',
  /** Offset measured in months */
  Months = 'Months',
  /** Offset measured in weeks */
  Weeks = 'Weeks'
}

/** Everything required to relocate a workflow to another board. */
export type RelocateWorkflowToBoardInput = {
  /** Mappings for every distinct non-signing phase home column. */
  phaseColumnRemaps: Array<PhaseColumnRemapInput>;
  targetBoardId: Scalars['UUID'];
  targetColumnId: Scalars['UUID'];
  targetDoneColumnId: Scalars['UUID'];
  workflowId: Scalars['UUID'];
};

/** Input for reminding a task's subscribers that you are waiting on your requested changes. */
export type RemindTaskAssigneesInput = {
  /** Optional note, shown on the reminder in the feed and in its email. */
  note?: InputMaybe<Scalars['String']>;
  taskId: Scalars['UUID'];
};

/** Input for reminding the reviewers who have not answered yet. */
export type RemindTaskReviewersInput = {
  /** Optional note, emailed to those reviewers and shown on the reminder in the feed. */
  note?: InputMaybe<Scalars['String']>;
  /** Remind only this reviewer. */
  reviewerPermissionId?: InputMaybe<Scalars['UUID']>;
  taskId: Scalars['UUID'];
};

/** A date-based reminder tied to a document, used to track obligations, renewals, and deadlines. */
export type Reminder = {
  __typename: 'Reminder';
  /** AI-generated explanation of why this reminder was created. */
  aiRationale: Maybe<Scalars['String']>;
  /** The AI automation rule that generated this reminder, if any. */
  aiReminderAutomation: Maybe<AiReminderAutomation>;
  /** Users assigned to be notified about this reminder. */
  assignees: Array<User>;
  /** When this reminder was marked complete, or null if still active. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** Created at - ISO 8601 */
  createdAt: Scalars['DateTime'];
  /** Detailed description of what this reminder is for. */
  description: Scalars['String'];
  /** The document this reminder is associated with. */
  document: Document;
  /** The date this reminder is due. */
  dueDate: Scalars['Date'];
  /** Primary identifier for this reminder. */
  id: Scalars['UUID'];
  /** Whether this reminder was automatically generated by AI analysis. */
  isAiGenerated: Scalars['Boolean'];
  /** Notification schedule — how many days before the due date to send alerts. */
  notificationOffsets: Array<NotificationOffset>;
  /** Review status for AI-generated reminders (accepted, rejected, or pending). */
  reviewStatus: ReminderReviewStatus;
  /** Short title summarizing the reminder. */
  title: Scalars['String'];
  /** Category of the reminder (milestone, obligation, renewal, or expiration). */
  type: ReminderType;
  /** Updated at - ISO 8601 */
  updatedAt: Scalars['DateTime'];
};

/** Filter for listing reminders by completion state. */
export enum ReminderFilter {
  /** Return all reminders regardless of status. */
  All = 'All',
  /** Return only completed reminders. */
  Completed = 'Completed',
  /** Return only reminders that have not been completed. */
  Incomplete = 'Incomplete',
  /** Return only AI-generated reminders awaiting user review. */
  PendingReview = 'PendingReview'
}

/** Aggregate metadata for a reminder list query. */
export type ReminderMeta = {
  __typename: 'ReminderMeta';
  /** Number of AI-generated reminders awaiting user review. */
  pendingReviewCount: Scalars['Int'];
  /** Total number of reminders matching the current filter. */
  totalCount: Scalars['Int'];
};

/** Mutable properties of a reminder. */
export type ReminderProps = {
  /** AI-generated explanation for this reminder. */
  aiRationale?: InputMaybe<Scalars['String']>;
  /** ID of the AI automation rule that generated this reminder. */
  aiReminderAutomationId?: InputMaybe<Scalars['UUID']>;
  /** When the reminder was completed, or null to mark as incomplete. */
  completedAt?: InputMaybe<Scalars['DateTime']>;
  /** Detailed description of the reminder. */
  description?: InputMaybe<Scalars['String']>;
  /** The date this reminder is due. */
  dueDate?: InputMaybe<Scalars['Date']>;
  /** Notification schedule — how many days before the due date to send alerts. */
  notificationOffsets?: InputMaybe<Array<NotificationOffsetInput>>;
  /** Review status for AI-generated reminders. */
  reviewStatus?: InputMaybe<ReminderReviewStatus>;
  /** Short title summarizing the reminder. */
  title?: InputMaybe<Scalars['String']>;
  /** Category of the reminder. */
  type?: InputMaybe<ReminderType>;
};

/** Review status of an AI-generated reminder before it becomes active */
export enum ReminderReviewStatus {
  /** Reminder was approved and is now active */
  Accepted = 'Accepted',
  /** Reminder is awaiting reviewer approval */
  PendingReview = 'PendingReview',
  /** Reminder was rejected and will not be created */
  Rejected = 'Rejected'
}

/** Paginated list of reminders with metadata. */
export type ReminderRowsResponse = {
  __typename: 'ReminderRowsResponse';
  /** Aggregate metadata about the result set. */
  meta: ReminderMeta;
  /** The reminders matching the query. */
  reminders: Array<Reminder>;
};

/** Category of a contract reminder, indicating what event it tracks. */
export enum ReminderType {
  /** A contract expiration date after which the agreement is no longer in effect. */
  Expiration = 'Expiration',
  /** A key date or deliverable deadline in the contract lifecycle. */
  Milestone = 'Milestone',
  /** A contractual obligation that must be fulfilled by a party. */
  Obligation = 'Obligation',
  /** A contract renewal date requiring action to extend or renegotiate. */
  Renewal = 'Renewal'
}

/** Real-time event emitted when reminders are created, updated, or deleted. */
export type RemindersUpdatedEvent = {
  __typename: 'RemindersUpdatedEvent';
  /** Updated aggregate metadata after the change. */
  meta: ReminderMeta;
  /** IDs of the reminders that changed. */
  reminderIds: Array<Scalars['UUID']>;
  /** Full reminder objects for the changed reminders. */
  reminders: Array<Reminder>;
};

/** Response returned when an action is removed from a workflow step. */
export type RemoveActionResponse = {
  __typename: 'RemoveActionResponse';
  /** Root query for refetching related data after removal. */
  refetch: Query;
};

/** Input for removing documents from a workflow. */
export type RemoveDocumentsFromWorkflowInput = {
  /** IDs of documents to remove. */
  documentIds: Array<Scalars['UUID']>;
  /** The workflow to remove documents from. */
  workflowId: Scalars['UUID'];
};

/** Input for removing a party from a document. */
export type RemovePartyFromDocumentInput = {
  /** ID of the document to remove the party from. */
  documentId: Scalars['UUID'];
  /** ID of the party to remove. */
  partyId: Scalars['UUID'];
};

/** Input for removing users from a group */
export type RemoveUsersFromGroupInput = {
  /** ID of the group to remove users from */
  id: Scalars['UUID'];
  /** IDs of the users to remove */
  userIds: Array<Scalars['UUID']>;
};

/** Input for removing collaborators from a workflow. */
export type RemoveWorkflowPermissionsInput = {
  /** The workflow to remove collaborators from. */
  workflowId: Scalars['UUID'];
  /** IDs of the permission entries to remove. */
  workflowPermissionIds: Array<Scalars['UUID']>;
};

/** Defines a new ordering for all phases in a workflow. */
export type ReorderPhasesInput = {
  /** Complete list of phase IDs in the desired order. Must include every phase in the workflow. */
  phaseIds: Array<Scalars['UUID']>;
  /** The workflow whose phases are being reordered. */
  workflowId: Scalars['UUID'];
};

/** Input for reordering the categories within a playbook. */
export type ReorderPlaybookRuleCategoriesInput = {
  /** All of the playbook's category IDs in their desired order. */
  orderedCategoryIds: Array<Scalars['UUID']>;
  /** ID of the playbook whose categories are being reordered. */
  playbookId: Scalars['UUID'];
};

/** Input for reordering a rule's positions. */
export type ReorderPlaybookRulePositionsInput = {
  /**
   * Every position ID of the rule, in the desired order, including the current
   * starting position. The entry at index 0 becomes the new starting position.
   */
  positionIds: Array<Scalars['UUID']>;
  /** ID of the rule whose positions are being reordered. */
  ruleId: Scalars['UUID'];
};

/** Defines a new ordering for all fields within a task. */
export type ReorderTaskFieldsInput = {
  /** Complete list of field IDs in the desired order. Must include every field on the task. */
  taskFieldIds: Array<Scalars['UUID']>;
  /** The task whose fields are being reordered. */
  taskId: Scalars['UUID'];
};

/** Maps a template document to a replacement file for the launched instance. */
export type ReplacementFilesInput = {
  /** The replacement file to use in the instance. */
  replacementFileId: Scalars['UUID'];
  /** The template document being replaced. */
  templateId: Scalars['UUID'];
};

/** Describes an Aline report. */
export type Report = {
  __typename: 'Report';
  /** User who created the report */
  author: User;
  /** Available column options. */
  columnOptions: Array<ReportColumnOption>;
  /** Report was created at */
  createdAt: Scalars['DateTime'];
  /** Report was soft deleted at */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Report ID - GUID */
  id: Scalars['UUID'];
  /** Report Name */
  name: Scalars['String'];
  /** Aggregate lock status of an extraction question's cells across all documents in the report. Pass filterModel and listFilter to scope counts to the rows the client is currently displaying (mirroring reportRows); when omitted, counts fall back to the persisted report.state filter. */
  questionLockStatus: QuestionLockStatus;
  /** Rows supporting flat, relationship, and grouped display modes. */
  reportRows: ReportRowsInfo;
  /** Rows for the report. */
  rows: RowsInfo;
  /** Per-status breakdown counts (AI/OCR status). Fired on demand (e.g., when the Status filter dropdown opens) so the expensive aggregate is not computed on every row fetch. Counts are scope-aware: the supplied filter/scope args are applied so the counts reflect the rows visible in the grid. */
  rowsMeta: RowsMeta;
  /** Report state (columns, filters, etc.). */
  state: Scalars['JSON'];
  /** Report was most recently updated at */
  updatedAt: Scalars['DateTime'];
};


/** Describes an Aline report. */
export type ReportQuestionLockStatusArgs = {
  filterModel?: InputMaybe<Scalars['JSON']>;
  listFilter?: InputMaybe<DocumentListFilter>;
  questionId: Scalars['UUID'];
};


/** Describes an Aline report. */
export type ReportReportRowsArgs = {
  cursor?: InputMaybe<Scalars['UUID']>;
  displayMode: DisplayMode;
  docVariant?: InputMaybe<DocumentVariant>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  filterTimeZone?: InputMaybe<Scalars['String']>;
  groupFieldIds?: InputMaybe<Array<Scalars['String']>>;
  groupFields?: InputMaybe<Array<GroupableField>>;
  groupKeys?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  listFilter?: InputMaybe<DocumentListFilter>;
  missingMatchesOnly?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  parentTreeRowId?: InputMaybe<Scalars['ID']>;
  sortModel?: InputMaybe<Scalars['JSON']>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  unconfirmedRelationshipsOnly?: InputMaybe<Scalars['Boolean']>;
};


/** Describes an Aline report. */
export type ReportRowsArgs = {
  cursor?: InputMaybe<Scalars['UUID']>;
  docVariant?: InputMaybe<DocumentVariant>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  filterTimeZone?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  listFilter?: InputMaybe<DocumentListFilter>;
  missingMatchesOnly?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  sortModel?: InputMaybe<Scalars['JSON']>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  unconfirmedRelationshipsOnly?: InputMaybe<Scalars['Boolean']>;
};


/** Describes an Aline report. */
export type ReportRowsMetaArgs = {
  displayMode?: InputMaybe<DisplayMode>;
  docVariant?: InputMaybe<DocumentVariant>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  filterTimeZone?: InputMaybe<Scalars['String']>;
  groupFieldIds?: InputMaybe<Array<Scalars['String']>>;
  groupFields?: InputMaybe<Array<GroupableField>>;
  groupKeys?: InputMaybe<Array<Scalars['String']>>;
  listFilter?: InputMaybe<DocumentListFilter>;
  missingMatchesOnly?: InputMaybe<Scalars['Boolean']>;
  parentTreeRowId?: InputMaybe<Scalars['ID']>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  unconfirmedRelationshipsOnly?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Streamed event fired when the report subagent creates a Report from a plan
 * the user approved in chat. Carries the join row's primitive fields so the
 * client can splice a fresh ThreadReportArtifact onto AgentThread.artifacts
 * without a refetch.
 */
export type ReportArtifactCreatedEvent = {
  __typename: 'ReportArtifactCreatedEvent';
  /** Assistant message whose plan produced this report */
  agentMessageId: Scalars['UUID'];
  /** When the join row was created — drives the artifacts bar's relative timestamps */
  artifactCreatedAt: Scalars['DateTime'];
  /** ID of the created report */
  reportId: Scalars['UUID'];
  /** Display name of the created report */
  reportName: Scalars['String'];
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** ID of the user who approved the plan */
  userId: Scalars['UUID'];
};

/** Data type of a report column, determines how values are filtered, sorted, and displayed in the grid. */
export enum ReportColumnDataType {
  /** True/false boolean value. */
  Boolean = 'boolean',
  /** Date-only value (no time component). */
  Date = 'date',
  /** Date with time component. */
  DateTime = 'dateTime',
  /** Numeric value (integer or decimal). */
  Number = 'number',
  /** Single value selected from a predefined list of options. */
  SingleSelect = 'singleSelect',
  /** Free-text string value. */
  String = 'string'
}

/** Built-in document properties that can be used as report columns. */
export enum ReportColumnFileField {
  /** Timestamp when the document was created. */
  CreatedAt = 'createdAt',
  /** Timestamp when the document was soft-deleted, or null if active. */
  DeletedAt = 'deletedAt',
  /** File format of the uploaded document (e.g., PDF, DOCX). */
  FileType = 'fileType',
  /** Document UUID. */
  Id = 'id',
  /** Labels applied to the document. */
  Labels = 'labels',
  /** Timestamp when the requesting user last viewed the document. */
  LastAccessedByRequesterAt = 'lastAccessedByRequesterAt',
  /** Document display name. */
  Name = 'name',
  /** User who owns the document. */
  Owner = 'owner',
  /** Counterparties associated with the document. */
  Parties = 'parties',
  /** Whether the requesting user has favorited this document. */
  RequesterFavorited = 'requesterFavorited',
  /** Timestamp when the document was signed. */
  SignedAt = 'signedAt',
  /** Document lifecycle status (e.g., Draft, Signed). */
  Status = 'status',
  /** Contract type classification. */
  Type = 'type',
  /** Timestamp when the document was last modified. */
  UpdatedAt = 'updatedAt'
}

/** A column that can be added to a report — either a built-in file field or an AI extraction question. */
export type ReportColumnOption = ExtractionReportColumn | FileFieldColumn;

/** Result of checking report mention access. */
export type ReportMentionAccessResult = MentionAccessError | Report;

/** A response for mutations of a single report */
export type ReportResponse = {
  __typename: 'ReportResponse';
  refetch: Query;
  /** The updated report */
  report: Report;
};

/** Union of all row types that can appear in a report DataGrid. */
export type ReportRow = DocumentRow | GroupHeaderRow | OrphanRelationshipRow | UrlRelationshipRow;

/** Response type for the report rows query. */
export type ReportRowsInfo = {
  __typename: 'ReportRowsInfo';
  /**
   * Number of direct child rows at the requested level, used as the grid's
   * per-level rowCount for native nested lazy loading. At the grouped root it is
   * the number of top-level groups; for an expanded group it is that group's
   * direct-child count. Null in flat/relationship modes (use totalCount).
   */
  groupCount: Maybe<Scalars['Int']>;
  rows: Array<ReportRow>;
  /** Total number of rows matching the current filters (before pagination). */
  totalCount: Scalars['Int'];
};

/** Event payload pushed to subscribers when a report's data or configuration changes. */
export type ReportUpdatedEvent = {
  __typename: 'ReportUpdatedEvent';
  /** The full updated report object. */
  report: Report;
  /** The ID of the report that was updated. */
  reportId: Scalars['UUID'];
};

/** A response for mutations of multiple reports */
export type ReportsResponse = {
  __typename: 'ReportsResponse';
  refetch: Query;
  /** The updated reports */
  reports: Array<Report>;
};

/** Aggregated relationship-pipeline counts for a repository. */
export type RepositoryMeta = {
  __typename: 'RepositoryMeta';
  /** Number of documents currently in the extraction/matching pipeline. */
  detectingRelationshipsCount: Scalars['Int'];
  /** Number of documents where the relationship pipeline failed after all retries. */
  failedRelationshipsCount: Scalars['Int'];
  /** Number of documents with at least one orphaned (unresolved) relationship. */
  missingMatchesCount: Scalars['Int'];
  /** Number of matched relationships that have not been reviewed yet. */
  unconfirmedRelationshipsCount: Scalars['Int'];
  /** Number of accessible, live documents that have not yet had relationship properties extracted. */
  unprocessedRelationshipDocumentsCount: Scalars['Int'];
};

/** Input for requesting access to a workflow via one of its documents. */
export type RequestAccessToDocumentWorkflowInput = {
  /** The document whose workflow the requester wants access to. */
  documentId: Scalars['UUID'];
  /** Optional message explaining why access is needed. */
  message?: InputMaybe<Scalars['String']>;
};

/** Input for requesting access to one or more storables */
export type RequestAccessToStorableInput = {
  /** Optional message from the requester explaining why they need access */
  message?: InputMaybe<Scalars['String']>;
  /** Desired permission role (defaults to Viewer if omitted) */
  permissionRole?: InputMaybe<PermissionRole>;
  /** When set, access should be granted to these emails instead of the requester */
  requestedForEmails?: InputMaybe<Array<Scalars['String']>>;
  /** IDs of the storables to request access to */
  storableIds: Array<Scalars['UUID']>;
};

export type RequestBulkExportInput = {
  documentIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** MUI X DataGrid filter model captured from the user's live grid view. Used for reportId exports so the server matches what the user sees in the grid. Ignored when documentIds is provided. */
  filterModel?: InputMaybe<Scalars['JSON']>;
  format: BulkExportFormat;
  reportId?: InputMaybe<Scalars['UUID']>;
};

/** Input for requesting changes on a task. */
export type RequestTaskChangesInput = {
  /** What needs to change. Required. */
  comment: Scalars['String'];
  /** Record the decision on behalf of this external assignee. Internal users only, for responses received outside Aline. */
  onBehalfOfPermissionId?: InputMaybe<Scalars['UUID']>;
  taskId: Scalars['UUID'];
};

/** Input for asking a task's reviewers to review. */
export type RequestTaskReviewInput = {
  /** Ask every reviewer not already reviewing, including those who approved, not only those who requested changes or were not asked yet. */
  askEveryone?: InputMaybe<Scalars['Boolean']>;
  /** Optional note for the reviewers, in their review email and shown on the request in the feed. */
  note?: InputMaybe<Scalars['String']>;
  /** Ask only these reviewers, whatever they answered before, in one request and at most one new round. Ignores askEveryone. */
  reviewerPermissionIds?: InputMaybe<Array<Scalars['UUID']>>;
  taskId: Scalars['UUID'];
};

/** Input for creating an upgrade request */
export type RequestUpgradeInput = {
  /** Optional note to admins */
  message?: InputMaybe<Scalars['String']>;
  /** Role the user wants; defaults to BASIC */
  requestedRole?: InputMaybe<OrgRole>;
};

/** How the current request was authenticated and which user it acts as. */
export type Requester = {
  __typename: 'Requester';
  authMode: RequesterAuthMode;
  /** True when the user is a stand-in (API key admin, or package installer fallback), not the caller. */
  isFallbackIdentity: Scalars['Boolean'];
  /** Null only when unauthenticated. */
  user: Maybe<User>;
};

export enum RequesterAuthMode {
  /** Runs as the org's oldest active admin, not the caller. */
  ApiKey = 'API_KEY',
  /** Authenticated with CRM HMAC, using either an app-wide or tenant-specific signing secret. */
  CrmHmac = 'CRM_HMAC',
  Session = 'SESSION',
  Unauthenticated = 'UNAUTHENTICATED'
}

/** Input for resending an organization invite email */
export type ResendOrgInvite = {
  /** ID of the invited user to re-notify */
  inviteeId: Scalars['UUID'];
};

/** Input for recording the reviewer's resolution of a rule job. */
export type ResolvePlaybookRuleJobInput = {
  /** ID of the rule job being resolved. */
  id: Scalars['UUID'];
  /** Which action resolves the rule. */
  kind: PlaybookRuleResolutionKind;
  /**
   * The position the action is taken on. Required for Suggest (a failing
   * position with a proposal) and Fallback (the passing fallback position);
   * must be omitted for Manual.
   */
  positionId?: InputMaybe<Scalars['UUID']>;
};

/** Input for admin response to an upgrade request */
export type RespondToUpgradeRequestInput = {
  /** Whether to approve or deny the request */
  approve: Scalars['Boolean'];
  /** Request ID */
  id: Scalars['UUID'];
  /** Optional response note sent to the requester */
  responseMessage?: InputMaybe<Scalars['String']>;
};

/** Input for restoring previously disabled (trashed) documents in bulk. */
export type RestoreDocumentsInput = {
  /** IDs of the documents to restore. Ignored when runAllDocs is true. */
  documentIds: Array<Scalars['UUID']>;
  /** AG Grid filter model to scope which documents are affected when runAllDocs is true. */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** Per-group select-all: restrict the action to documents in this group path. */
  groupSelection?: InputMaybe<GroupSelectionInput>;
  /** Report ID whose saved filters determine the document set when runAllDocs is true. */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** When true, restore all matching documents instead of only those in documentIds. */
  runAllDocs?: InputMaybe<Scalars['Boolean']>;
};

/** Input for restoring previously disabled storables */
export type RestoreStorables = {
  /** IDs of the storables to restore */
  storableIds: Array<Scalars['UUID']>;
};

export type RetryAgentSkillFileInput = {
  id: Scalars['UUID'];
  path: Scalars['String'];
};

/** The action a reviewer can take on an extraction job answer. */
export enum ReviewAction {
  /** Reviewer confirmed the extracted answer is correct. */
  Accepted = 'Accepted',
  /** Reviewer manually corrected the extracted answer. */
  Edited = 'Edited',
  /** Reviewer marked the extracted answer as incorrect. */
  Rejected = 'Rejected'
}

/** The outcome of a document relationship review. */
export enum ReviewOutcome {
  /** Reviewer verified the relationship is correct. */
  Confirmed = 'CONFIRMED',
  /** Reviewer determined the relationship is incorrect. */
  Rejected = 'REJECTED'
}

/** Input for recording one review decision on a suggestion. */
export type ReviewPlaybookSuggestionInput = {
  /** The decision to record. */
  decision: PlaybookSuggestionReviewDecision;
  /** ID of the rule job that holds the suggestion. */
  id: Scalars['UUID'];
  /** ID of the suggestion being decided. */
  suggestionId: Scalars['String'];
};

/** Processing status of a document row in a report, used for filtering and status indicators. */
export enum RowStatus {
  /** AI extraction failed for this document. */
  AiError = 'AiError',
  /** AI extraction has not been run on this document. */
  AiNotRun = 'AiNotRun',
  /** AI extraction is currently running on this document. */
  AiRunning = 'AiRunning',
  /** Extraction answers are stale because the document was modified after the last extraction. */
  AnswerStale = 'AnswerStale',
  /** OCR processing failed for this document. */
  OcrError = 'OCRError',
  /** OCR is currently running on this document. */
  OcrRunning = 'OCRRunning'
}

/** Paginated document list with totalCount for a report query. */
export type RowsInfo = {
  __typename: 'RowsInfo';
  /** The documents matching the current report filters, sort, and pagination. */
  docs: Array<Document>;
  /** Total number of documents matching the current filters (before pagination). */
  totalCount: Scalars['Int'];
};

/** Per-status breakdown counters describing the AI extraction and OCR status of documents in a report. */
export type RowsMeta = {
  __typename: 'RowsMeta';
  /** Number of documents where AI extraction failed with an error. */
  aiErrorCount: Scalars['Int'];
  /** Number of documents where AI extraction has not been run yet. */
  aiNotRunCount: Scalars['Int'];
  /** Number of documents currently being processed by AI extraction. */
  aiRunningCount: Scalars['Int'];
  /** Number of documents with stale answers (extraction was run but the document has since changed). */
  answerStaleCount: Scalars['Int'];
  /** Number of documents where OCR processing failed with an error. */
  ocrErrorCount: Scalars['Int'];
  /** Number of documents currently being processed by OCR. */
  ocrRunningCount: Scalars['Int'];
};

/** Input for running Core AI (built-in standard questions) across multiple documents. */
export type RunCoreAiForDocumentsInput = {
  /** IDs of the documents to run Core AI on. */
  documentIds: Array<Scalars['UUID']>;
  /** Optional report ID to scope the Core AI run to a specific report. */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** If true, run Core AI on all documents in the report regardless of documentIds. */
  runAllDocs?: InputMaybe<Scalars['Boolean']>;
};

/** Salesforce object types that can provide template field values. */
export enum SalesforceFieldObjectType {
  /** A Salesforce Account record representing a company or organization. */
  Account = 'Account',
  /** A Salesforce Opportunity record representing a potential deal. */
  Opportunity = 'Opportunity',
  /** A Salesforce User record representing an opportunity owner. */
  User = 'User'
}

/** Salesforce field requirement for a template */
export type SalesforceFieldRequirement = {
  __typename: 'SalesforceFieldRequirement';
  /** Salesforce field API name (e.g., Amount, CloseDate, Custom_Field__c) */
  fieldApiName: Scalars['String'];
  /** Human-readable label for the field */
  fieldLabel: Scalars['String'];
  /** Whether the field must be populated */
  isRequired: Scalars['Boolean'];
  /** Salesforce object type that owns the field */
  objectType: SalesforceFieldObjectType;
  /** IDs of the template documents that contain this field. Matches documentsList entries. */
  usedInDocuments: Array<Scalars['UUID']>;
};

/** Pre-populated field value from Salesforce */
export type SalesforceFieldValue = {
  __typename: 'SalesforceFieldValue';
  /** Salesforce field API name */
  fieldApiName: Scalars['String'];
  /** Human-readable label for the field */
  fieldLabel: Scalars['String'];
  /** Value from Salesforce record */
  value: Maybe<Scalars['String']>;
};

/** Supported Salesforce object types for launch */
export enum SalesforceObjectType {
  /** A Salesforce Account record representing a company or organization. */
  Account = 'Account',
  /** A Salesforce Opportunity record representing a potential deal. */
  Opportunity = 'Opportunity'
}

/** Input for fetching Salesforce record data for workflow launch */
export type SalesforceRecordDataInput = {
  /** The type of Salesforce object */
  objectType: SalesforceObjectType;
  /** The Salesforce record ID (Opportunity or Account) */
  salesforceRecordId: Scalars['String'];
  /** The template workflow ID to launch */
  templateId: Scalars['UUID'];
};

/** Response containing Salesforce record data for workflow launch */
export type SalesforceRecordDataResponse = {
  __typename: 'SalesforceRecordDataResponse';
  /** Pre-populated field values from the Salesforce record */
  fieldValues: Array<SalesforceFieldValue>;
  /** The Salesforce record name/title for display */
  recordName: Maybe<Scalars['String']>;
  /** Fields required by the template */
  requiredFields: Array<SalesforceFieldRequirement>;
  /** The template workflow to launch */
  template: Workflow;
};

/** Input for saving document content. */
export type SaveDocumentInput = {
  /** When true, creates a new version snapshot instead of overwriting the current version. */
  createNewVersion?: InputMaybe<Scalars['Boolean']>;
  /** ID of the document to save. */
  documentId: Scalars['UUID'];
  /** SHA-256 hash of the client's documentJSON, used to verify the client is editing the latest version. */
  documentJSONHash: Scalars['String'];
  /** Content payload containing the document JSON. */
  documentProps: SaveDocumentProps;
};

/** Document content payload for saving. */
export type SaveDocumentProps = {
  /** Slate JSON representation of the document body. */
  documentJSON: Scalars['JSON'];
};

/** Result of saving a document, including any variables whose values changed. */
export type SaveDocumentResponse = {
  __typename: 'SaveDocumentResponse';
  /** Variables whose values changed as a result of the save (e.g., updated via smart fields). */
  changedVariables: Array<DocumentVariable>;
  /** The saved document with updated content. */
  document: Document;
};

/** Input for discovering mentionable entities. */
export type SearchMentionEntitiesInput = {
  /** Cursor for single-type drill-down pagination. */
  cursor?: InputMaybe<MentionEntitySearchCursorInput>;
  /** Optional document scope for document-collaborator-aware Users results. */
  documentId?: InputMaybe<Scalars['UUID']>;
  /** Maximum number of results to return per requested type. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Search string after the @ trigger. Empty string is allowed for default lists. */
  query: Scalars['String'];
  /** Entity types to search. Clients should pass this explicitly for each picker mode. */
  types: Array<MentionEntitySearchType>;
  /** Optional workflow scope for workflow-aware Users results. */
  workflowId?: InputMaybe<Scalars['UUID']>;
};

/** Grouped mention search response. */
export type SearchMentionEntitiesResult = {
  __typename: 'SearchMentionEntitiesResult';
  /** One group per requested entity type with independent pagination. */
  groups: Array<MentionEntitySearchGroup>;
};

/** Input for searching playbooks. */
export type SearchPlaybooksInput = {
  /** Maximum number of search results to return. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Search query to match against playbook title, description, categories, rules, and AI guidance. */
  query: Scalars['String'];
};

/** Input for sending a document to recipients via email. */
export type SendDocumentViaEmailInput = {
  /** CC recipients and their permission role. */
  copyTo?: InputMaybe<SendToInput>;
  /** ID of the document to send. */
  documentId: Scalars['UUID'];
  /** Body of the email message. */
  message: Scalars['String'];
  /** Label for the version being sent (e.g., 'v2 - Final'). */
  nameVersion?: InputMaybe<Scalars['String']>;
  /** Primary recipients and their permission role. */
  sendTo: SendToInput;
  /** Email subject line. */
  subject: Scalars['String'];
};

/** Input for sending a test/preview email of a document to the requester. */
export type SendDocumentViaEmailTestInput = {
  /** ID of the document to preview. */
  documentId: Scalars['UUID'];
  /** Body of the test email message. */
  message: Scalars['String'];
  /** Email subject line for the test. */
  subject: Scalars['String'];
};

/** Recipient list with an associated permission role for email sending. */
export type SendToInput = {
  /** Permission role to grant each recipient on the document. */
  role: PermissionRole;
  /** Email addresses of the recipients. */
  to: Array<Scalars['EmailAddress']>;
};

/** Input for sending a workflow's documents for e-signature. */
export type SendWorkflowForSignatureInput = {
  /** Optional message to include in the signing notification. */
  message?: InputMaybe<Scalars['String']>;
  /** Optional title for the signing envelope. */
  title?: InputMaybe<Scalars['String']>;
  /** The workflow to send for signature. */
  workflowId: Scalars['UUID'];
};

/** Changes who a skill is shared with. Never creates a version. */
export type SetAgentSkillScopeInput = {
  /** The version whose files the author confirmed. Null for a skill that was never published. */
  expectedVersionId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  scope: AgentSkillScope;
};

/** Controls whether a template is published to or removed from the community */
export type SetCommunityTemplateInput = {
  /** Community categories to file this template under */
  categoryIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Set true to publish, false to unpublish */
  isCommunityTemplate: Scalars['Boolean'];
  /** Open-source license to attach when publishing */
  licenseId?: InputMaybe<Scalars['UUID']>;
  /** The template to publish or unpublish */
  templateId: Scalars['UUID'];
};

/** Controls whether a workflow is published to or removed from the community */
export type SetCommunityWorkflowInput = {
  /** Community categories to file this workflow under */
  categoryIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Set true to publish, false to unpublish */
  isCommunityWorkflow: Scalars['Boolean'];
  /** Open-source license to attach when publishing */
  licenseId?: InputMaybe<Scalars['String']>;
  /** The workflow to publish or unpublish */
  workflowId: Scalars['UUID'];
};

/** Input for replacing all parties on a document with the specified set. */
export type SetDocumentPartiesInput = {
  /** ID of the document to update. */
  documentId: Scalars['UUID'];
  /** IDs of the parties to set on the document (replaces existing). */
  partyIds: Array<Scalars['UUID']>;
};

/** Input for setting document status in bulk. One document or every document matching the filters. */
export type SetDocumentsStatusInput = {
  /** IDs of the documents to update. Ignored when runAllDocs is true. */
  documentIds: Array<Scalars['UUID']>;
  /** AG Grid filter model to scope which documents are affected when runAllDocs is true. */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** Per-group select-all: restrict the action to documents in this group path. */
  groupSelection?: InputMaybe<GroupSelectionInput>;
  /** Report ID whose saved filters determine the document set when runAllDocs is true. */
  reportId?: InputMaybe<Scalars['UUID']>;
  /** When true, apply to all documents matching the report/filter instead of documentIds. */
  runAllDocs?: InputMaybe<Scalars['Boolean']>;
  /** Status to apply. */
  status: DocumentStatus;
};

/** Ids and the status fields that were written, for a client cache patch. Not full documents. */
export type SetDocumentsStatusResponse = {
  __typename: 'SetDocumentsStatusResponse';
  /** Documents whose status changed. Already-matching documents are omitted. */
  documentIds: Array<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  /** Null for Expired, which does not rewrite isSigned. */
  isSigned: Maybe<Scalars['Boolean']>;
  /**
   * Set when the change runs in the background. documentIds, numSuccess, numSkipped and
   * skipCounts are then empty, and progress arrives on documentStatusJobProgress.
   */
  jobId: Maybe<Scalars['UUID']>;
  /** Documents in scope when the change started. */
  numQueued: Scalars['Int'];
  numSkipped: Scalars['Int'];
  numSuccess: Scalars['Int'];
  skipCounts: Array<DocumentStatusSkipCount>;
  status: DocumentStatus;
  /** Null for Expired, which does not rewrite variant. */
  variant: Maybe<DocumentVariant>;
};

/** Input for replacing all label-based permissions on a group */
export type SetGroupPermissionsInput = {
  /** ID of the group whose permissions are being set */
  groupId: Scalars['UUID'];
  /** Label IDs to grant access to — replaces any existing label permissions */
  labelIds: Array<Scalars['UUID']>;
};

/** Input for replacing the input dependencies of a question. */
export type SetQuestionInputsInput = {
  /** Built-in file fields that serve as additional inputs. */
  inputFileFields?: InputMaybe<Array<ReportColumnFileField>>;
  /** IDs of extraction questions whose answers feed into this question. */
  inputQuestionIds: Array<Scalars['UUID']>;
  /** ID of the question to update. */
  questionId: Scalars['UUID'];
};

/** Input for replacing the contract types associated with a question. */
export type SetQuestionTypesInput = {
  /** ID of the question to update. */
  questionId: Scalars['UUID'];
  /** Contract type IDs to associate (replaces existing associations). */
  typeIds: Array<Scalars['UUID']>;
};

/** Input for marking one reviewer required or optional. Assignees cannot be required. */
export type SetTaskAssigneeRequiredInput = {
  isRequired: Scalars['Boolean'];
  /** The assignee's workflow permission. */
  permissionId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** Input for changing one person's role on a task. */
export type SetTaskAssigneeRoleInput = {
  /** The person's workflow permission. */
  permissionId: Scalars['UUID'];
  role: TaskAssigneeRole;
  taskId: Scalars['UUID'];
};

/** Input for replacing a task's assignee list. */
export type SetTaskAssigneesInput = {
  /** The complete desired assignee list. An empty list unassigns the task. */
  assignees: Array<TaskAssigneeInput>;
  /** ID of the task to reassign. */
  taskId: Scalars['UUID'];
};

/** Input for changing the document role of a workflow file. */
export type SetWorkflowFileDocumentRoleInput = {
  /** The new role to assign (General or Signing). */
  documentRole: WorkflowFileDocumentRole;
  /** The workflow file to update. */
  workflowFileId: Scalars['UUID'];
};

/** Input for making a General workflow file internal or shared. */
export type SetWorkflowFileInternalInput = {
  /** True keeps the document within the owner's org; false shares it with every participant. */
  isInternal: Scalars['Boolean'];
  /** The General workflow file to update. */
  workflowFileId: Scalars['UUID'];
};

/** Input for replacing all parties on a workflow with the specified set. */
export type SetWorkflowPartiesInput = {
  /** IDs of the parties to set on the workflow (replaces existing). */
  partyIds: Array<Scalars['UUID']>;
  /** ID of the workflow to update. */
  workflowId: Scalars['UUID'];
};

/** A signature capture field placed in a document, linked to a workflow recipient who must sign it */
export type SignatureField = {
  __typename: 'SignatureField';
  /** Workflow recipient assigned to sign this field, or null if unassigned */
  action: Maybe<WorkflowRecipient>;
  /** Whether all instances of this signature field in the document have been signed */
  allSigned: Scalars['Boolean'];
  /** Timestamp when the field was created (ISO 8601) */
  createdAt: Scalars['DateTime'];
  /** Timestamp when the field was soft-deleted (ISO 8601), or null if active */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Document this signature field belongs to */
  document: Document;
  /** Unique identifier for the signature field */
  id: Scalars['UUID'];
  /** Reference ID linking this field to its node in the document JSON (stored on inputField.fieldId) */
  nodeId: Scalars['UUID'];
  /** Timestamp when the field was last updated (ISO 8601) */
  updatedAt: Scalars['DateTime'];
};

/** Signer name and email assignment for a template role on launch. */
export type SignerAssignmentInput = {
  /** Email address for this signer. */
  email: Scalars['String'];
  /** Full name for this signer. */
  name: Scalars['String'];
  /** Identifier from TemplateSignerRole.roleId. */
  roleId: Scalars['UUID'];
};

/** Signing phase: ordered steps with at least one action (same NonEmpty semantics as legacy Workflow.orderedSteps). */
export type SigningPhase = Phase & {
  __typename: 'SigningPhase';
  /** Started-category board column this phase homes to when it starts (board signing column). */
  column: Column;
  /** When every signing step in this phase was finished; null if still in progress. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** When this phase record was created. */
  createdAt: Scalars['DateTime'];
  /** Longer explanation of the phase's purpose or instructions for participants. */
  description: Scalars['String'];
  /** Unique identifier for this phase. */
  id: Scalars['UUID'];
  /** Human-readable label shown in the workflow UI. */
  name: Scalars['String'];
  /** Zero-based position determining the sequence of phases within a workflow. */
  order: Scalars['Int'];
  /** When the first signing step in this phase was begun; null if not yet started. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** Ordered signing steps (e.g., review, sign, countersign) that participants move through sequentially. */
  steps: Array<WorkflowStep>;
  /** When this phase record was last modified. */
  updatedAt: Scalars['DateTime'];
  /** The workflow this phase belongs to. */
  workflow: Workflow;
};

/**
 * Streamed event fired after the skill subagent saves a skill the user approved and links it
 * to the assistant message.
 */
export type SkillArtifactCreatedEvent = {
  __typename: 'SkillArtifactCreatedEvent';
  /** Assistant message that saved the skill */
  agentMessageId: Scalars['UUID'];
  /** When the skill join row was created */
  artifactCreatedAt: Scalars['DateTime'];
  /** How the skill relates to the message */
  kindList: Array<AgentMessageJoinKind>;
  /** ID of the saved skill */
  skillId: Scalars['UUID'];
  /** Name of the skill as it was saved */
  skillName: Scalars['String'];
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** ID of the user who approved the skill */
  userId: Scalars['UUID'];
};

export type SkillAttachmentRenameInput = {
  name: Scalars['String'];
  newPath: Scalars['String'];
  path: Scalars['String'];
};

/** A document from My documents. The save copies it as it reads then: an Aline document as a DOCX, a PDF as its bytes. */
export type SkillDocumentSnapshotInput = {
  documentId: Scalars['UUID'];
  folderPath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SkillPdfAttachmentInput = {
  base64: Scalars['String'];
  folderPath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

export type SkillTextFileInput = {
  content: Scalars['String'];
  /** The file's type: text/markdown, text/plain or application/json. Its path is only a label. */
  contentType: Scalars['String'];
  path: Scalars['String'];
};

/** Result of checking skill version mention access. */
export type SkillVersionMentionAccessResult = AgentSkillVersion | MentionAccessError;

/** SKU details */
export type Sku = {
  __typename: 'Sku';
  /** SKU code */
  code: Scalars['String'];
  /** SKU ID */
  id: Scalars['String'];
  /** SKU name */
  name: Scalars['String'];
};

/**
 * Input for invoking Aline AI from a task or workflow ActivityThread composer.
 * Exactly one of taskId / workflowId must be set (the parent the AI thread is
 * recorded against as an AGENT_THREAD activity row).
 */
export type StartActivityAgentThreadInput = {
  /** Immutable Skill versions pinned to this turn, as in AgentPromptInput.agentSkills */
  agentSkills?: InputMaybe<Array<AgentSkillReferenceInput>>;
  /** Client-generated id for the assistant message that will be streamed */
  assistantMessageId: Scalars['UUID'];
  /** The prompt text to send to the agent. May contain markdown mention links like AgentPromptInput.prompt */
  prompt: Scalars['String'];
  /** Parent task this AI thread is attached to (mutually exclusive with workflowId) */
  taskId?: InputMaybe<Scalars['UUID']>;
  /** Client-generated id for the new thread */
  threadId: Scalars['UUID'];
  /** Client-generated id for the user message */
  userMessageId: Scalars['UUID'];
  /** Parent workflow this AI thread is attached to (mutually exclusive with taskId) */
  workflowId?: InputMaybe<Scalars['UUID']>;
};

/** Input for starting extraction jobs across multiple documents. */
export type StartExtractionJobsForDocumentsInput = {
  /** IDs of the documents to run extraction on. */
  documentIds: Array<Scalars['UUID']>;
  /** If true, re-run extraction even if a completed job already exists. */
  force?: InputMaybe<Scalars['Boolean']>;
  /** IDs of the extraction questions to run against each document. */
  questionIds: Array<Scalars['UUID']>;
};

/** Result of a startExtractionJobsForDocuments mutation, including how many cells were skipped because they were locked. */
export type StartExtractionJobsResponse = {
  __typename: 'StartExtractionJobsResponse';
  /** Documents that had extraction work queued. */
  documents: Array<Document>;
  /** Number of (document, question) pairs that were skipped because the existing ExtractionJob is locked. */
  skippedCount: Scalars['Int'];
};

/** Input for starting AI extraction on documents within a report. */
export type StartReportExtractionInput = {
  /** Optional live grid filter model to scope the report run to the rows currently displayed. */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** IANA timezone (e.g. 'America/New_York') used to interpret date-only filters, matching the grid. */
  filterTimeZone?: InputMaybe<Scalars['String']>;
  /** When true, re-run extraction even on documents that already have answers. */
  force?: InputMaybe<Scalars['Boolean']>;
  /** If provided, only run extraction for this specific question. Otherwise, run all questions. */
  questionId?: InputMaybe<Scalars['UUID']>;
  /** The report whose documents should be extracted. */
  reportId: Scalars['UUID'];
  /** IDs of the documents currently visible in the report grid to run extraction on. */
  visibleDocumentIds: Array<Scalars['UUID']>;
};

/** Response from starting AI extraction, includes the report and per-document extraction status. */
export type StartReportExtractionResponse = {
  __typename: 'StartReportExtractionResponse';
  /** List of documents and the extraction questions currently running on each. Filtered to the documents currently visible in the grid to keep large responses small. */
  aiQuestionsRunningForDocs: Array<AiQuestionsRunningForDoc>;
  /** Total number of documents that had extraction queued (across the whole report, not just the visible rows). */
  queuedCount: Scalars['Int'];
  /** The report that extraction was started on. */
  report: Report;
  /** Number of (document, question) pairs skipped because the cell is locked or already up-to-date. */
  skippedCount: Scalars['Int'];
};

/** Input for starting a task. */
export type StartTaskInput = {
  taskId: Scalars['UUID'];
};

/** A file version backed by an uploaded file (PDF, DOCX, etc.) */
export type StaticFileVersion = FileVersionInterface & {
  __typename: 'StaticFileVersion';
  /** PDF annotations in XFDF format attached to this version */
  annotationsXFDF: Maybe<AnnotationsXfdf>;
  /** Users who have authored or edited this version */
  authors: Array<User>;
  /** Timestamp when this version was created */
  createdAt: Scalars['DateTime'];
  /** Timestamp when the file content was last modified, or null if unchanged since creation */
  fileContentChangedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when file extraction (conversion to editable content) failed */
  fileExtractionFailedAt: Maybe<Scalars['DateTime']>;
  /** Human-readable reason the file extraction failed */
  fileExtractionFailedReason: Maybe<Scalars['String']>;
  /** Timestamp when file extraction completed successfully */
  fileExtractionFinishedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when file extraction began */
  fileExtractionStartedAt: Maybe<Scalars['DateTime']>;
  /** Extracted JSON representation of the file content, used for rendering and editing */
  fileJSON: Maybe<Scalars['JSON']>;
  /** Reference to the uploaded file in cloud storage */
  fileLocation: DocFile;
  /** Unique identifier for this file version */
  id: Scalars['UUID'];
  /** Display name of this version */
  name: Scalars['String'];
  /** The task this version was uploaded for, or null when it was not uploaded through a task */
  taskUpload: Maybe<TaskUpload>;
  /** Timestamp of the most recent update to this version */
  updatedAt: Scalars['DateTime'];
  /** Timestamp when AI vector embedding generation failed, or null if not attempted or successful */
  vectorsFailedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when AI vector embeddings were successfully persisted */
  vectorsSavedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when AI vector embedding generation began */
  vectorsStartedAt: Maybe<Scalars['DateTime']>;
};

/** Body of a STATUS_UPDATE activity entry. May coalesce several events by the same actor. */
export type StatusUpdateActivity = {
  __typename: 'StatusUpdateActivity';
  /** All lifecycle events coalesced into this row, in chronological order */
  events: Array<ActivityStatusEvent>;
};

/** A content item that can be owned, shared, favorited, and organized */
export type Storable = Document;

/** Shared fields for all storable content types */
export type StorableInterface = {
  /** Timestamp when this storable was created */
  createdAt: Scalars['DateTime'];
  /** Timestamp when this storable was soft-deleted (disabled), or null if active */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier (GUID) */
  id: Scalars['UUID'];
  /** Display name of the storable */
  name: Scalars['String'];
  /** User who owns this storable */
  owner: User;
  /** Unique identifier of the owning user */
  ownerId: Scalars['UUID'];
  /** Whether the requesting user has favorited this storable */
  requesterFavorited: Scalars['Boolean'];
  /** Permission role of the requesting user on this storable, or null if no access */
  requesterRole: Maybe<PermissionRole>;
  /** Discriminator indicating the concrete storable type */
  storableType: StorableType;
  /** Timestamp of the most recent update to this storable */
  updatedAt: Scalars['DateTime'];
};

/** Associates an account with a storable at a specific permission role */
export type StorablePermission = {
  __typename: 'StorablePermission';
  /** Account (user or organization) that holds this permission */
  account: Account;
  /** Whether the account is an individual user or an organization */
  accountType: AccountType;
  /** Timestamp when this permission was created */
  createdAt: Scalars['DateTime'];
  /** Timestamp when this permission was soft-deleted, or null if active */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this permission record */
  id: Scalars['UUID'];
  /** Whether this permission was explicitly set or inherited from a parent folder */
  origin: PermissionOrigin;
  /** Access level granted by this permission */
  role: PermissionRole;
  /** The storable this permission grants access to */
  storable: Storable;
  /** Concrete type of the storable this permission applies to */
  storableType: StorableType;
  /** Timestamp of the most recent update to this permission */
  updatedAt: Scalars['DateTime'];
};

/** Response for a single storable permission mutation */
export type StorablePermissionResponse = {
  __typename: 'StorablePermissionResponse';
  /** Entry point to refetch related queries after the mutation */
  refetch: Query;
  /** The affected permission record, or null if it was deleted */
  storablePermission: Maybe<StorablePermission>;
};

/** Response for bulk storable permission mutations */
export type StorablePermissionsResponse = {
  __typename: 'StorablePermissionsResponse';
  /** Entry point to refetch related queries after the mutation */
  refetch: Query;
  /** The full set of permissions after the mutation */
  storablePermissions: Array<StorablePermission>;
};

/** Discriminator for concrete storable types */
export enum StorableType {
  /** An Aline document (contract, agreement, or other legal document) */
  Document = 'DOCUMENT'
}

/** A collection of storables grouped by concrete type */
export type Storables = {
  __typename: 'Storables';
  /** All documents in this collection */
  documents: Array<Document>;
};

/** Response wrapper for storable mutations, includes updated storables and a refetch entry point */
export type StorablesResponse = {
  __typename: 'StorablesResponse';
  /** Entry point to refetch related queries after the mutation */
  refetch: Query;
  /** The affected storables after the mutation */
  storables: Storables;
};

/** Union of all event types that can be delivered via the agent subscription */
export type StreamAgentPayload = ArtifactCreatedEvent | AssistantMessageEvent | LoadingEvent | PlanSnapshotEvent | ReportArtifactCreatedEvent | SkillArtifactCreatedEvent | TitleUpdateEvent | ToolStatusUpdateEvent | WorkflowArtifactCreatedEvent;

/** Lightweight message payload optimized for real-time streaming delivery */
export type StreamingAgentMessage = {
  __typename: 'StreamingAgentMessage';
  /** Unique identifier for the message */
  id: Scalars['UUID'];
  /** Current lifecycle status of the streaming message */
  status: AgentMessageStatus;
  /** Accumulated text content received so far */
  text: Scalars['String'];
};

/** Input for recording a participant's answer to a form field. */
export type SubmitTaskFieldResponseInput = {
  /** The participant's response data. Schema must match the field's type and config. */
  response: Scalars['JSON'];
  /** ID of the task field being answered. */
  taskFieldId: Scalars['UUID'];
};

/** Subscriptions for real-time document updates via WebSocket. */
export type Subscription = {
  __typename: 'Subscription';
  /** The author's draft changed outside the editor, such as a file finishing processing. */
  agentSkillDraftChanged: AgentSkill;
  /** Subscribe to real-time updates for AI reminder automations in the current user's organization */
  aiReminderAutomationUpdated: AiReminderAutomationUpdatedEvent;
  /** Subscribe to real-time annotation changes on a specific file version */
  annotationsChanged: AnnotationsChangedEvent;
  bulkExportUpdated: BulkExport;
  /** Subscribe to streamed AI completion chunks for a specific document. */
  completionReceived: CompletionEvent;
  /** Emitted when playbooks associated with a document change. */
  docPlaybooksUpdated: DocPlaybooksUpdatedEvent;
  documentMetadataImportProgress: Maybe<DocumentMetadataImport>;
  documentRelationshipUpdated: DocumentRelationship;
  /** Emitted as a background status change started by the current user makes progress. */
  documentStatusJobProgress: DocumentStatusJobProgressEvent;
  /** Emitted when a specific document is updated (content, properties, or AI extraction results). */
  documentUpdated: DocumentUpdatedEvent;
  /** Emitted when any documents in the user's repository are created, updated, or deleted. */
  documentsUpdated: DocumentsUpdatedEvent;
  /** Emitted when folder sync jobs are created, updated, or deleted for the current org. */
  folderSyncJobUpdate: FolderSyncJobUpdatedEvent;
  inboxNotificationsChanged: InboxNotificationsChangedEvent;
  /** Subscribe to real-time agent events (messages, loading indicators, tool updates, title changes) */
  onAgentEvent: StreamAgentPayload;
  /** Subscribe to receive the improved prompt result */
  onImprovedPrompt: ImprovedPromptEvent;
  /** Emitted when relationship-pipeline counts change for a repository (e.g., detection completes or a review is submitted). */
  onRepositoryMetaUpdated: RepositoryMeta;
  /** Emitted whenever a playbook generation job's status changes (started, completed, or failed). */
  playbookGenerationJobUpdated: PlaybookGenerationJobUpdatedEvent;
  /** Emitted whenever a question generation job's status changes (started, completed, or failed). */
  questionGenerationUpdated: QuestionGenerationJobUpdatedEvent;
  /** Subscribe to reminder changes in the current user's organization */
  remindersUpdated: RemindersUpdatedEvent;
  /** Subscribe to report updates. */
  reportUpdated: ReportUpdatedEvent;
  /** Fires when an activity-bearing change lands on a task feed. */
  taskActivityFeedChanged: ActivityFeedChangedEvent;
  /** Fires when an activity-bearing change lands on a workflow feed. */
  workflowActivityFeedChanged: ActivityFeedChangedEvent;
  /** Fires when phase order or phase/task data changes for a workflow. */
  workflowPhasesChanged: WorkflowPhasesChangedPayload;
  /** Emits when any workflow the current user can access is created, updated, or deleted. */
  workflowsUpdated: WorkflowsUpdatedEvent;
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionAgentSkillDraftChangedArgs = {
  skillId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionAnnotationsChangedArgs = {
  fileVersionId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionBulkExportUpdatedArgs = {
  id: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionCompletionReceivedArgs = {
  documentId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionDocPlaybooksUpdatedArgs = {
  documentId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionDocumentUpdatedArgs = {
  documentId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionOnImprovedPromptArgs = {
  requestId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionOnRepositoryMetaUpdatedArgs = {
  repositoryId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionReportUpdatedArgs = {
  reportId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionTaskActivityFeedChangedArgs = {
  taskId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionWorkflowActivityFeedChangedArgs = {
  workflowId: Scalars['UUID'];
};


/** Subscriptions for real-time document updates via WebSocket. */
export type SubscriptionWorkflowPhasesChangedArgs = {
  workflowId: Scalars['UUID'];
};

/** Billing cadence for a subscription plan */
export enum SubscriptionInterval {
  /** Billed every month */
  Monthly = 'MONTHLY',
  /** Billed once per year (discounted rate) */
  Yearly = 'YEARLY'
}

/** Whether a subscription is currently active or has lapsed */
export enum SubscriptionStatus {
  /** Subscription is paid and in good standing */
  Active = 'ACTIVE',
  /** Subscription has expired, been cancelled, or payment has failed */
  Inactive = 'INACTIVE'
}

/** Plan tier that determines available features and seat pricing */
export enum SubscriptionTier {
  /** Premium plan with advanced features, SSO, and dedicated support */
  Enterprise = 'ENTERPRISE',
  /** Standard plan for small-to-mid-size teams */
  Team = 'TEAM'
}

/** A user's support role, if any. */
export enum SupportRole {
  /** Internal support admin with full platform access */
  Admin = 'ADMIN',
  /** Support team member with limited diagnostic access */
  Support = 'SUPPORT'
}

/** An open-source license that can be applied to community-published templates and workflows */
export type SupportedLicense = {
  __typename: 'SupportedLicense';
  /** Unique identifier */
  id: Scalars['UUID'];
  /** Short display name (e.g. MIT, Apache 2.0) */
  name: Scalars['String'];
  /** Link to the full license text */
  url: Scalars['String'];
};

/** Input for switching an envelope's signing provider (e.g., from DocuSign to AlineSign). */
export type SwitchEnvelopeVariantInput = {
  /** ID of the envelope to switch. */
  envelopeId: Scalars['UUID'];
  /** The new signing provider variant. */
  variant: EnvelopeVariant;
};

/** Input for naming a version if needed, then scheduling CRM sync */
export type SyncFileVersionToCrmInput = {
  /** ID of the file version to sync */
  fileVersionId: Scalars['UUID'];
  /** CRM to sync this version to. Unsupported CRMs are rejected. */
  integration: Integration;
};

export type Test_Scalars = {
  __typename: 'TEST_Scalars';
  TEST_BigInt: Scalars['BigInt'];
  TEST_Date: Scalars['Date'];
  TEST_DateTime: Scalars['DateTime'];
  TEST_EmailAddress: Scalars['EmailAddress'];
  TEST_JSON: Scalars['JSON'];
  TEST_UUID: Scalars['UUID'];
};

export type Test_ScalarsInput = {
  TEST_BigInt?: InputMaybe<Scalars['BigInt']>;
  TEST_Date?: InputMaybe<Scalars['Date']>;
  TEST_DateTime?: InputMaybe<Scalars['DateTime']>;
  TEST_EmailAddress?: InputMaybe<Scalars['EmailAddress']>;
  TEST_JSON?: InputMaybe<Scalars['JSON']>;
  TEST_UUID?: InputMaybe<Scalars['UUID']>;
};

/** A unit of work assigned to a workflow participant, optionally containing form fields for structured data collection. */
export type Task = {
  __typename: 'Task';
  /**
   * Unified chronological timeline of comments, AI threads, and lifecycle events for this task.
   *
   * Rows come back oldest-first. With no arguments the newest page is returned, since the feed is
   * read from the bottom; set startAtOldest to open on the oldest page instead, for a feed read from
   * the top. Pass at most one of cursor, before, or anchor:
   * - cursor — page of items strictly newer than that row (forward pagination)
   * - before — page of items strictly older than that row (backward pagination)
   * - anchor — first page centered on that row (deep links)
   *
   * Pass audience to read one lane: INTERNAL for the owner org's own items, EXTERNAL for what external
   * assignees see. Readers outside the workflow owner's org always get EXTERNAL.
   */
  activity: ActivityItemRowsInfo;
  /** Assistant message for the first Aline AI execution run kicked off for this task, if any. */
  alineAiRunMessageId: Maybe<Scalars['UUID']>;
  /** Assignee slots with their required flags and current-round decisions, in assignment order. Empty means unassigned (unless delegated to Aline AI). */
  assignments: Array<TaskAssignment>;
  /** User who created this task, if it was created manually. */
  author: Maybe<User>;
  /** Discussion thread attached to this task. */
  comments: Array<Comment>;
  /** When this task was marked complete; null while in progress. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** User who marked this task complete. */
  completedBy: Maybe<User>;
  /** The external side's name for labels such as 'Message to Acme': their orgs, or their email domains. Null without external assignees. */
  counterpartyName: Maybe<Scalars['String']>;
  /** When this task was created. */
  createdAt: Scalars['DateTime'];
  /** Internal instructions and the Aline AI prompt, in Markdown. Empty for viewers outside the workflow owner's org. */
  description: Scalars['String'];
  /** Instructions for external assignees, in Markdown. Shown on the task page only, never sent to Aline AI or in email. */
  externalDescription: Scalars['String'];
  /** Structured form fields the assignee must fill out when completing this task. */
  fields: Array<TaskField>;
  /** When the assignee was first notified about this task. */
  firstSentAt: Maybe<Scalars['DateTime']>;
  /** Whether any assignee is outside the workflow owner's org. */
  hasExternalAssignees: Scalars['Boolean'];
  /** Unique identifier (UUID v4). */
  id: Scalars['UUID'];
  /** Whether Aline AI is delegated to work on this task in addition to any human assignee. */
  isDelegatedToAi: Scalars['Boolean'];
  /** When the most recent reminder was sent to the assignee. */
  lastSentAt: Maybe<Scalars['DateTime']>;
  /** The workflow owner's org name, or the owner's name without an org. */
  ownerName: Scalars['String'];
  /** The task this sub-task is nested under; null for a top-level task. */
  parentTask: Maybe<Task>;
  /** The phase this task belongs to. */
  phase: Phase;
  /** When a required internal assignee rejected the task. */
  rejectedAt: Maybe<Scalars['DateTime']>;
  /** Who rejected the task. */
  rejectedBy: Maybe<User>;
  /** Actions the current requester is not allowed to perform on this task, with explanations. */
  requesterDisallowedReason: DisallowedTaskReasons;
  /** Whether the requester is in the workflow owner's org, and so sees internal activity. */
  requesterIsInternal: Scalars['Boolean'];
  /** Current review round, starting at 1. Asking a reviewer who already answered starts the next one. */
  round: Scalars['Int'];
  /** When a participant first began working on this task. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** Current lifecycle state (not started, in progress, or completed). */
  status: TaskStatus;
  /** Subscriber picker rows: current subscribers plus a bounded, searchable slice of active org members, each with subscribed + locked state */
  subscriberOptions: Array<ActivitySubscriberOption>;
  /** Users who will be notified of activity on this task (assignee, mentioned, commenters, and manual subscribers, minus anyone who muted). Task creators are not auto-subscribed. */
  subscribers: Array<User>;
  /** Sub-tasks nested one level under this task, visible to the requester. */
  subtasks: Array<Task>;
  /** Short summary shown in task lists and notifications. */
  title: Scalars['String'];
  /** When this task was last modified. */
  updatedAt: Scalars['DateTime'];
  /** Whether this is a reusable template or a document-scoped instance. */
  variant: TaskVariant;
  /** Who the viewer's next primary action on this task would notify, by the same rule the emails use. */
  viewerActionRecipients: Array<User>;
  /** Whether the current viewer is subscribed to this task's activity */
  viewerSubscribed: Scalars['Boolean'];
  /** Whether the viewer's subscription is locked (they are an assignee and cannot unsubscribe) */
  viewerSubscriptionLocked: Scalars['Boolean'];
  /** What the viewer marked up in the workflow's documents since they were asked to review, not yet submitted. Null unless the viewer is an asked reviewer who hasn't decided. */
  viewerUnsubmittedReview: Maybe<TaskUnsubmittedReview>;
  /** The workflow this task belongs to. */
  workflow: Workflow;
};


/** A unit of work assigned to a workflow participant, optionally containing form fields for structured data collection. */
export type TaskActivityArgs = {
  anchor?: InputMaybe<Scalars['UUID']>;
  audience?: InputMaybe<ActivityAudience>;
  before?: InputMaybe<Scalars['UUID']>;
  cursor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
  startAtOldest?: InputMaybe<Scalars['Boolean']>;
};


/** A unit of work assigned to a workflow participant, optionally containing form fields for structured data collection. */
export type TaskSubscriberOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

/** One person's answer in a round. What it means depends on their role on the task. */
export enum TaskAssigneeDecision {
  /** A reviewer sent the task back to its assignees with a comment. */
  ChangesRequested = 'CHANGES_REQUESTED',
  /** An assignee completed their work on a task without reviewers; a reviewer approved it. */
  Completed = 'COMPLETED',
  /** An internal assignee or reviewer rejected the task. */
  Rejected = 'REJECTED'
}

/** One entry in a task's assignee list: a user, a role, an external participant by email, or the template's workflow launcher. */
export type TaskAssigneeInput = {
  /** Assign to a workflow role by ID. */
  assignedRoleId?: InputMaybe<Scalars['UUID']>;
  /** Assign to a specific user by ID. */
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  /** Assign to an external participant by email. */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Assign to whoever launches this template. Only valid on a template; the other assignment fields are ignored. */
  isLauncher?: InputMaybe<Scalars['Boolean']>;
  /** Whether an assignee waits for this reviewer's approval. New reviewers default to optional; ignored for assignees. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** Whether this person does the work or reviews it. New assignments default to ASSIGNEE; omitted keeps an existing role. */
  role?: InputMaybe<TaskAssigneeRole>;
  /** Display name for a new role created on the fly, used when assignedRoleId is not provided. */
  roleName?: InputMaybe<Scalars['String']>;
};

/** What a person on a task does. */
export enum TaskAssigneeRole {
  /** Does the work and marks it complete, or asks the reviewers to review it. */
  Assignee = 'ASSIGNEE',
  /** Checks the work, then approves it or requests changes. */
  Reviewer = 'REVIEWER'
}

/** One assignee of a task, with its required flag and its decision in the current round. */
export type TaskAssignment = {
  __typename: 'TaskAssignment';
  /** When the decision was made. */
  decidedAt: Maybe<Scalars['DateTime']>;
  /** The round the decision was made in. */
  decidedInRound: Maybe<Scalars['Int']>;
  /** This assignee's decision in the current round; null while undecided. */
  decision: Maybe<TaskAssigneeDecision>;
  /** Whether the assignee is outside the workflow owner's org. */
  isExternal: Scalars['Boolean'];
  /** Whether the task waits for this reviewer's approval before an assignee can complete it. Always false for an assignee. */
  isRequired: Scalars['Boolean'];
  /** The assignee. */
  permission: WorkflowPermission;
  /** When this reviewer was last asked to review; null while not asked. Asked with no decision means the task waits on them. */
  reviewRequestedAt: Maybe<Scalars['DateTime']>;
  /** Who asked this reviewer to review; null when the request was automatic (the phase started, or Aline AI finished). */
  reviewRequestedBy: Maybe<User>;
  /** Whether this person does the work or reviews it. */
  role: TaskAssigneeRole;
  /** Files this assignee uploaded through the task, oldest first. A PENDING upload is a draft that records no decision, so they still have to send one. */
  uploads: Array<TaskUpload>;
};

/** A form field attached to a task, allowing workflow participants to provide structured data (text, dates, files, selections) when completing the task. */
export type TaskField = {
  __typename: 'TaskField';
  /** When this field was answered; null if no response has been submitted. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** User who submitted the response for this field. */
  completedBy: Maybe<User>;
  /** Type-specific settings such as dropdown options or file size limits. Schema varies by field type. */
  config: Maybe<Scalars['JSON']>;
  /** When this field was created. */
  createdAt: Scalars['DateTime'];
  /** When this field was soft-deleted; null if active. */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this field. */
  id: Scalars['UUID'];
  /** Whether the participant must fill out this field before completing the task. */
  isRequired: Scalars['Boolean'];
  /** Prompt or question shown to the participant. */
  label: Scalars['String'];
  /** Zero-based position determining display order within the task's form. */
  order: Scalars['Int'];
  /** The participant's submitted answer. Schema varies by field type. */
  response: Maybe<Scalars['JSON']>;
  /** The task this field belongs to. */
  task: Task;
  /** Input control type (text, date, file upload, etc.). */
  type: TaskFieldType;
  /** When this field was last modified. */
  updatedAt: Scalars['DateTime'];
};

/** Wrapper returned by task field mutations, includes the affected field and a refetch entry point. */
export type TaskFieldResponse = {
  __typename: 'TaskFieldResponse';
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
  /** The created, updated, or responded-to task field. */
  taskField: TaskField;
};

/** Available input types for task form fields. */
export enum TaskFieldType {
  /** Boolean checkbox for yes/no or acknowledgment responses. */
  Checkbox = 'Checkbox',
  /** Date picker for selecting a calendar date. */
  Date = 'Date',
  /** Dropdown selector populated from config options. */
  Dropdown = 'Dropdown',
  /** File upload control that accepts one or more attachments. */
  FileUpload = 'FileUpload',
  /** Multi-line text input for longer responses. */
  TextArea = 'TextArea',
  /** Single-line text input. */
  TextField = 'TextField'
}

/** Result of checking task mention access. */
export type TaskMentionAccessResult = MentionAccessError | Task;

/** Wrapper returned by task mutations, includes the affected task and a refetch entry point. */
export type TaskResponse = {
  __typename: 'TaskResponse';
  /** Activity row created by the mutation, when the mutation directly creates one. */
  activityItem: Maybe<ActivityItem>;
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
  /** The created, updated, or reassigned task. */
  task: Task;
  /** A non-blocking warning for the requester, such as open sub-tasks when starting a new round. */
  warning: Maybe<Scalars['String']>;
};

/** Lifecycle state of a task within a workflow. */
export enum TaskStatus {
  /** A reviewer requested changes in the current round. The task is back with its assignees. */
  ChangesRequested = 'CHANGES_REQUESTED',
  /** The task has been marked done by a participant or system action. */
  Completed = 'COMPLETED',
  /** A reviewer was asked to review and has not answered yet. */
  InReview = 'IN_REVIEW',
  /** No participant has begun working on this task yet. */
  NotStarted = 'NOT_STARTED',
  /** A required internal assignee rejected the task and the workflow moved to Cancelled. */
  Rejected = 'REJECTED',
  /** A participant has begun but not yet finished this task. */
  Started = 'STARTED',
  /** A reusable blueprint that can be instantiated into live tasks. */
  Template = 'TEMPLATE'
}

/** A reviewer's own markup this round that they haven't submitted. Approve waits until it is. */
export type TaskUnsubmittedReview = {
  __typename: 'TaskUnsubmittedReview';
  /** Their comments and replies since they were asked to review, on threads still open. */
  commentCount: Scalars['Int'];
  /** Their tracked changes made or touched since they were asked to review. */
  trackedChangeCount: Scalars['Int'];
};

/** A file uploaded as part of a task. Sending it makes it the document's next version. */
export type TaskUpload = {
  __typename: 'TaskUpload';
  /** When the file was uploaded. */
  createdAt: Scalars['DateTime'];
  /** The document the file is a new version of. */
  documentId: Scalars['UUID'];
  /** The uploaded file's name. */
  fileName: Scalars['String'];
  /** The version made when the upload was sent; null while it is a draft or was withdrawn. */
  fileVersionId: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** The round the upload belongs to: the round it was sent in, or while pending or withdrawn, the round it was made in. */
  round: Scalars['Int'];
  status: TaskUploadStatus;
  /** When the upload was sent; null while pending. */
  submittedAt: Maybe<Scalars['DateTime']>;
  /** The task the file was uploaded for. */
  task: Task;
  /** Who clicked upload. Differs from the assignee when an internal editor recorded an external's response. */
  uploadedBy: Maybe<User>;
};

/** Where an upload made through a task stands. */
export enum TaskUploadStatus {
  /** A draft: uploaded but not sent, with no version yet. Nobody is notified until the uploader decides or asks for review. */
  Pending = 'PENDING',
  /** Sent with the uploader's decision or review request, which made it the document's next version. */
  Submitted = 'SUBMITTED',
  /** The uploader was taken off the task before sending it. It never became a version. */
  Withdrawn = 'WITHDRAWN'
}

/** Distinguishes between template-level task definitions and document-scoped task instances. */
export enum TaskVariant {
  /** A task instance scoped to a specific document within a workflow. */
  Document = 'DOCUMENT',
  /** A reusable task definition that can be applied across workflows. */
  Template = 'TEMPLATE'
}

/** A document belonging to a template, referenced by field usedInDocuments entries. */
export type TemplateDocument = {
  __typename: 'TemplateDocument';
  /** Stable identifier matching usedInDocuments entries. */
  documentId: Scalars['UUID'];
  /** Display name of the document. */
  name: Scalars['String'];
};

/** Response for templateSalesforceFields query */
export type TemplateSalesforceFieldsResponse = {
  __typename: 'TemplateSalesforceFieldsResponse';
  /** Template fields that are not linked to Salesforce (Aline-only). Empty when none. */
  alineFields: Array<AlineTemplateField>;
  /** Documents belonging to the template, referenced by usedInDocuments. Empty when none. */
  documentsList: Array<TemplateDocument>;
  salesforceFields: Array<SalesforceFieldRequirement>;
  /** Signer roles for the template, in signing order. Empty when none. */
  signerRoles: Array<TemplateSignerRole>;
  templateId: Scalars['UUID'];
};

/** A signer role for a template, used to collect a signer name and email per role on the launch form. */
export type TemplateSignerRole = {
  __typename: 'TemplateSignerRole';
  /** Display label (e.g. "Buyer"). */
  label: Scalars['String'];
  /** Signing-sequence position, 1-based. */
  order: Scalars['Int'];
  /** Whether a signer must be provided before launch. Always true: every signer role is required. */
  required: Scalars['Boolean'];
  /** Stable identifier. Round-trips back as createWorkflowInstance.instanceAssignments[*].userDefinedRoleId. */
  roleId: Scalars['UUID'];
  /** IDs of the template documents this role signs. Matches documentsList entries. */
  usedInDocuments: Array<Scalars['UUID']>;
};

export type TestAgentSkillDraftInput = {
  expectedRevision: Scalars['Int'];
  id: Scalars['UUID'];
};

export type TestAgentSkillDraftResponse = {
  __typename: 'TestAgentSkillDraftResponse';
  agentSkill: AgentSkill;
  refetch: Query;
  /** The version to pin in chat: a test version of the draft, or the published version when nothing changed. */
  version: AgentSkillVersion;
};

/** A thread artifact displayed in the chat artifact bar. */
export type ThreadArtifact = ThreadDocumentArtifact | ThreadReportArtifact | ThreadSkillArtifact | ThreadTaskArtifact | ThreadWorkflowArtifact;

/**
 * One row in the thread-wide artifacts bar. Backed by AgentMessageDocumentJoin
 * but already deduped by document — at most one row per documentId per thread,
 * picked by priority (drafted > edited > mentioned), then most-recent createdAt.
 */
export type ThreadDocumentArtifact = {
  __typename: 'ThreadDocumentArtifact';
  /** Message that owns the chosen join row — assistant message for edited / drafted rows, user message for mentioned. Needed to construct the suggestion-review deep link (which is scoped to a message id). */
  agentMessageId: Scalars['UUID'];
  /** When the chosen row was created — drives the artifacts bar's relative timestamps. */
  createdAt: Scalars['DateTime'];
  /** Linked document. */
  document: Document;
  /** All roles this document has played for the chosen message/document artifact link. */
  kindList: Array<AgentMessageJoinKind>;
};

/**
 * Report-typed counterpart to ThreadDocumentArtifact. Backed by AgentMessageReportJoin.
 * Surfaces in the thread's artifact bar alongside drafted/edited document rows
 * so reports created from chat previews are visible after the inline preview
 * card scrolls out of view. CASCADE on Report.id keeps the list honest when a
 * report is hard-deleted.
 */
export type ThreadReportArtifact = {
  __typename: 'ThreadReportArtifact';
  /** Assistant message that produced the preview which this report was created from. */
  agentMessageId: Scalars['UUID'];
  /** When the join row was created — drives the artifacts bar's relative timestamps. */
  createdAt: Scalars['DateTime'];
  /** Linked report. */
  report: Report;
};

/**
 * Skill-typed counterpart to ThreadDocumentArtifact. Backed by AgentMessageSkillJoin: a skill
 * the assistant created or changed after the user approved it. Only skills the viewer can open
 * are returned, and a deleted skill drops out.
 */
export type ThreadSkillArtifact = {
  __typename: 'ThreadSkillArtifact';
  /** Assistant message that saved the skill. */
  agentMessageId: Scalars['UUID'];
  /** When the join row was created — drives the artifacts bar's relative timestamps. */
  createdAt: Scalars['DateTime'];
  /** created for a new skill, edited for a change to an existing one. */
  kindList: Array<AgentMessageJoinKind>;
  /** Linked skill. */
  skill: AgentSkill;
};

/** Task-typed counterpart to ThreadDocumentArtifact. Backed by AgentMessageTaskJoin. */
export type ThreadTaskArtifact = {
  __typename: 'ThreadTaskArtifact';
  /** Message that owns the task context/artifact join. */
  agentMessageId: Scalars['UUID'];
  /** When the join row was created — drives the artifacts bar's relative timestamps. */
  createdAt: Scalars['DateTime'];
  /** Linked task. */
  task: Task;
};

/** Workflow-typed counterpart to ThreadDocumentArtifact. Backed by AgentMessageWorkflowJoin. */
export type ThreadWorkflowArtifact = {
  __typename: 'ThreadWorkflowArtifact';
  /** Message that owns the workflow context/artifact join. */
  agentMessageId: Scalars['UUID'];
  /** When the join row was created — drives the artifacts bar's relative timestamps. */
  createdAt: Scalars['DateTime'];
  /** How the workflow relates to the message. */
  kindList: Array<AgentMessageJoinKind>;
  /** Linked workflow. */
  workflow: Workflow;
};

/** Streamed event when the agent auto-generates or updates the thread title */
export type TitleUpdateEvent = {
  __typename: 'TitleUpdateEvent';
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** New title for the thread */
  title: Scalars['String'];
  /** ID of the user who initiated the agent prompt */
  userId: Scalars['UUID'];
};

/** Input for toggling ordered step completion on a workflow. */
export type ToggleWorkflowOrderInput = {
  /** The workflow whose step ordering to toggle. */
  workflowId: Scalars['UUID'];
};

/** Streamed event reporting progress of a tool the agent is executing */
export type ToolStatusUpdateEvent = {
  __typename: 'ToolStatusUpdateEvent';
  /** Structured tool status payload (tool name, progress, results) */
  data: Scalars['JSON'];
  /** ID of the message being generated */
  messageId: Scalars['UUID'];
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** ID of the user who initiated the agent prompt */
  userId: Scalars['UUID'];
};

/** What happens in the document when a participant selects an answer option. */
export enum TriggerAction {
  /** Inserts additional content at the designated location without replacing existing text. */
  InsertContent = 'INSERT_CONTENT',
  /** Merges conditional content into the document, replacing the placeholder region. */
  Merge = 'MERGE'
}

/** Summary of how many documents still have unanswered questions. */
export type UnansweredQuestionsInfo = {
  __typename: 'UnansweredQuestionsInfo';
  /** Number of documents with at least one unanswered question. */
  numDocuments: Scalars['Int'];
  /** Total number of unanswered question–document pairs. */
  numQuestions: Scalars['Int'];
};

/** Input for updating an existing AI reminder automation */
export type UpdateAiReminderAutomationInput = {
  /** Updated assignee user IDs */
  assigneeIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** ID of the automation to update */
  automationId: Scalars['UUID'];
  /** If true, deletes all existing reminders and re-runs the automation */
  deleteRemindersAndRerun?: InputMaybe<Scalars['Boolean']>;
  /** New property values to apply */
  props?: InputMaybe<AiReminderAutomationProps>;
  /** Updated reviewer user IDs */
  reviewerIds?: InputMaybe<Array<Scalars['UUID']>>;
};

/** A save whose content is already the current version's returns that version, so a retry succeeds. */
export type UpdateAgentSkillInput = {
  attachmentRenames?: InputMaybe<Array<SkillAttachmentRenameInput>>;
  /** The whole SKILL.md, frontmatter included. */
  content: Scalars['String'];
  documentSnapshots?: InputMaybe<Array<SkillDocumentSnapshotInput>>;
  /** The version the edit was made on. A save fails with OUTDATED_SKILL_VERSION when it is no longer current. */
  expectedVersionId: Scalars['UUID'];
  id: Scalars['UUID'];
  pdfAttachments?: InputMaybe<Array<SkillPdfAttachmentInput>>;
  retainedAttachmentPaths?: InputMaybe<Array<Scalars['String']>>;
  textFiles?: InputMaybe<Array<SkillTextFileInput>>;
};

export type UpdateAgentSkillResponse = {
  __typename: 'UpdateAgentSkillResponse';
  agentSkill: AgentSkill;
  /** The version committed by this save, which can precede the current version on a retry. */
  committedVersionId: Scalars['UUID'];
  refetch: Query;
};

/** Identifies an answer option and the properties to update. */
export type UpdateAnswerOptionInput = {
  /** ID of the answer option to update. */
  id: Scalars['UUID'];
  /** New property values to apply. */
  props: UpdateAnswerOptionProps;
};

/** Mutable properties of an answer option. Only provided fields are changed. */
export type UpdateAnswerOptionProps = {
  /** New display text for this option. */
  optionText?: InputMaybe<Scalars['String']>;
  /** New document action for this option. */
  triggerAction?: InputMaybe<TriggerAction>;
};

/** Input for updating an existing answer option set. */
export type UpdateAnswerOptionsInput = {
  /** ID of the answer option set to update. */
  answerOptionsId: Scalars['UUID'];
  /** New property values to apply. */
  props: AnswerOptionsProps;
};

/** Wrapper input identifying which board to update and the new property values */
export type UpdateBoardInput = {
  /** ID of the board to update */
  boardId: Scalars['UUID'];
  /** New property values to apply */
  props: UpdateBoardProps;
};

/** Editable properties of a board */
export type UpdateBoardProps = {
  /** New hex color code */
  color?: InputMaybe<Scalars['String']>;
  /** New icon identifier */
  icon?: InputMaybe<Scalars['String']>;
  /** New display name */
  name?: InputMaybe<Scalars['String']>;
};

/** Payload for editing an existing canned field. */
export type UpdateCannedFieldInput = {
  /** Reassign the canned field to a different workflow recipient (or null). Editable before signing by workflow editors. */
  assigneeId?: InputMaybe<Scalars['UUID']>;
  /** ID of the canned field to update. */
  id: Scalars['UUID'];
  /** New value; pass null to clear back to the default. Editable during signing by the assignee. */
  value?: InputMaybe<Scalars['String']>;
};

/** Wrapper input identifying which column to update and the new property values */
export type UpdateColumnInput = {
  /** ID of the column to update */
  columnId: Scalars['UUID'];
  /** New property values to apply */
  props: UpdateColumnProps;
};

/** Editable properties of a column */
export type UpdateColumnProps = {
  category?: InputMaybe<ColumnCategory>;
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Input for updating an existing comment */
export type UpdateCommentInput = {
  /** ID of the comment to update */
  id: Scalars['UUID'];
  /** Fields to update on the comment */
  props: UpdateCommentProps;
};

/** Mutable properties of a comment */
export type UpdateCommentProps = {
  /** When true, only users in the document owner organization can view the comment. Supported only on document comments. */
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to resolve or false to unresolve the comment */
  resolved?: InputMaybe<Scalars['Boolean']>;
  /** Updated markdown body */
  text?: InputMaybe<Scalars['String']>;
};

/** Input for updating an existing contract type */
export type UpdateContractTypeInput = {
  /** Contract type to update */
  id: Scalars['UUID'];
  /** Updated properties */
  props: UpdateContractTypeProps;
};

/** Fields that can be updated on a contract type */
export type UpdateContractTypeProps = {
  /** New display label for the contract type */
  value: Scalars['String'];
};

/** Input for updating document metadata (name, description, forwarding role). */
export type UpdateDocumentInput = {
  /** ID of the document to update. */
  documentId: Scalars['UUID'];
  /** New property values to apply. */
  documentProps: DocumentProps;
};

/** Input for changing a document's contract type assignment */
export type UpdateDocumentTypeInput = {
  /** New contract type, or null to remove the type assignment */
  contractTypeId?: InputMaybe<Scalars['UUID']>;
  /** Document to reassign */
  documentId: Scalars['UUID'];
};

/** Input for updating an existing document variable. */
export type UpdateDocumentVariableInput = {
  /** ID of the document variable to update. */
  id: Scalars['UUID'];
  /** Properties to update. */
  props?: InputMaybe<UpdateDocumentVariableProps>;
  /** Answer options to create or update. */
  upsertAnswerOptions?: InputMaybe<UpsertAnswerOptionsInput>;
};

/** Properties for updating an existing document variable. All fields are optional — only provided fields are updated. */
export type UpdateDocumentVariableProps = {
  /** Updated workflow action ID. */
  actionId?: InputMaybe<Scalars['UUID']>;
  /** Whether to include this field in the launch form. */
  addToLaunchForm?: InputMaybe<Scalars['Boolean']>;
  /** Set or change the default answer option by ID. */
  defaultAnswerId?: InputMaybe<Scalars['UUID']>;
  /** Updated display label. */
  label?: InputMaybe<Scalars['String']>;
  maxRequired?: InputMaybe<Scalars['Int']>;
  minRequired?: InputMaybe<Scalars['Int']>;
  /** Updated value prefix. */
  prefix?: InputMaybe<Scalars['String']>;
  /** Updated question prompt. */
  question?: InputMaybe<Scalars['String']>;
  /** Set the currently selected answer option by ID. */
  selectedAnswerId?: InputMaybe<Scalars['UUID']>;
  selectedAnswerIds?: InputMaybe<Array<Scalars['UUID']>>;
  skipped?: InputMaybe<Scalars['Boolean']>;
  /** Updated value for non-options variants. */
  value?: InputMaybe<Scalars['String']>;
};

/** Result of a bulk document update operation (e.g., changing type, signing, terminating). */
export type UpdateDocumentsResponse = {
  __typename: 'UpdateDocumentsResponse';
  /** Documents that were successfully updated. */
  documents: Array<Document>;
  /** Number of documents skipped due to authorization or state constraints. */
  numSkipped: Scalars['Int'];
  /** Number of documents that were successfully updated. */
  numSuccess: Scalars['Int'];
};

/** Input for updating an existing envelope. */
export type UpdateEnvelopeInput = {
  /** ID of the envelope to update. */
  envelopeId: Scalars['UUID'];
  /** The properties to update. */
  props: UpdateEnvelopeProps;
};

/** Properties for updating an existing envelope. */
export type UpdateEnvelopeProps = {
  /** Updated display title. */
  title?: InputMaybe<Scalars['String']>;
};

/** Input for updating an existing extraction job. */
export type UpdateExtractionJobInput = {
  /** ID of the extraction job to update. */
  extractionJobId: Scalars['UUID'];
  /** Fields to update on the extraction job. */
  props: UpdateExtractionJobProps;
  /** Updated selected option IDs for Single/Multi select questions. */
  selectedOptionIds?: InputMaybe<Array<Scalars['UUID']>>;
};

/** Mutable properties for updating an extraction job. */
export type UpdateExtractionJobProps = {
  /** Updated answer text. */
  answer?: InputMaybe<Scalars['String']>;
  /** Review action to record against this job. */
  reviewAction?: InputMaybe<ReviewAction>;
};

/** Input for updating an existing extraction question. */
export type UpdateExtractionQuestionInput = {
  /** Fields to update on the question. */
  props: UpdateExtractionQuestionProps;
  /** ID of the question to update. */
  questionId: Scalars['UUID'];
};

/** Mutable properties of an extraction question. Only provided fields are updated. */
export type UpdateExtractionQuestionProps = {
  /** New AI guidance instructions. */
  aiGuidance?: InputMaybe<Scalars['String']>;
  /** New category. */
  category?: InputMaybe<Scalars['String']>;
  /** New extraction mode. */
  mode?: InputMaybe<ExtractionQuestionMode>;
  /** New prompt text for AI extraction. */
  questionText?: InputMaybe<Scalars['String']>;
  /** New display title. */
  title?: InputMaybe<Scalars['String']>;
  /** New expected answer type. */
  type?: InputMaybe<ExtractionQuestionType>;
};

/** Input for updating an existing file version */
export type UpdateFileVersionInput = {
  /** ID of the file version to update */
  fileVersionId: Scalars['UUID'];
  /** Fields to update on the file version */
  props: UpdateFileVersionProps;
};

/** Mutable properties of a file version */
export type UpdateFileVersionProps = {
  /** New display name for the file version */
  name?: InputMaybe<Scalars['String']>;
};

/** Input for updating an existing group */
export type UpdateGroupInput = {
  /** ID of the group to update */
  id: Scalars['UUID'];
  /** Properties to change */
  props: UpdateGroupProps;
};

/** Mutable properties of a group */
export type UpdateGroupProps = {
  /** Whether members can access all documents and workflows regardless of labels */
  canAccessAllDocAndWorkflows?: InputMaybe<Scalars['Boolean']>;
  /** New display name for the group */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateInsightPinInput = {
  id: Scalars['UUID'];
  props: UpdateInsightPinProps;
};

export type UpdateInsightPinProps = {
  layout?: InputMaybe<Scalars['JSON']>;
  scope?: InputMaybe<InsightScope>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** Input for updating an existing intake form template. Only provided fields are changed. */
export type UpdateIntakeFormTemplateInput = {
  /** New default values. */
  defaultValues?: InputMaybe<Scalars['JSON']>;
  /** New description. */
  description?: InputMaybe<Scalars['String']>;
  /** New form definition (validated against the shared zod schema). */
  formDefinition?: InputMaybe<Scalars['JSON']>;
  /** The intake form template to update. */
  intakeFormTemplateId: Scalars['UUID'];
  /** New title. */
  title?: InputMaybe<Scalars['String']>;
};

/** Input for updating a launched intake form's values and/or title. Completion is recomputed when values are provided. */
export type UpdateIntakeFormValuesInput = {
  /** New title for the launched intake form. Optional. */
  title?: InputMaybe<Scalars['String']>;
  /** Collected values for the form, keyed by field name (validated against the snapshot). Omit for a title-only update. */
  values?: InputMaybe<Scalars['JSON']>;
  /** The launched (instance) workflow whose intake form to update. */
  workflowId: Scalars['UUID'];
};

/** Input for updating an onboarding task */
export type UpdateOnboardingTaskInput = {
  /** Properties to change on the task */
  props: UpdateOnboardingTaskProps;
  /** ID of the onboarding task to update */
  taskId: Scalars['UUID'];
};

/** Mutable properties of an onboarding task */
export type UpdateOnboardingTaskProps = {
  /** Mark the task as completed at this timestamp, or null to un-complete */
  completedAt?: InputMaybe<Scalars['DateTime']>;
  /** Set whether the task has been skipped */
  skipped?: InputMaybe<Scalars['Boolean']>;
};

/** Input for updating an existing organization */
export type UpdateOrg = {
  /** Email addresses of new users to invite */
  newMemberEmails: Array<Scalars['String']>;
  /** ID of the organization to update */
  orgId: Scalars['UUID'];
  /** Fields to update on the organization */
  props: UpdateOrgProps;
};

/** Input for adding or updating a member in an organization */
export type UpdateOrgMembership = {
  /** ID of the target organization */
  orgId: Scalars['UUID'];
  /** User properties and role for the membership */
  props: OrgUserProps;
};

/** Mutable organization properties (all optional — only provided fields are updated) */
export type UpdateOrgProps = {
  /** Mark the initial setup wizard as complete */
  isPreOnboardingCompleted?: InputMaybe<Scalars['Boolean']>;
  /** New display name for the organization */
  name?: InputMaybe<Scalars['String']>;
  /** Default role for new members who join via SSO, and the pre-selected role when inviting a member */
  orgDefaultRole?: InputMaybe<OrgRole>;
  /** Days between automated signing reminders (null disables signing reminders) */
  signingReminderDays?: InputMaybe<Scalars['Int']>;
  /** Updated headcount range */
  size?: InputMaybe<OrgSize>;
  /** Updated industry or category */
  type?: InputMaybe<OrgType>;
  /** Updated website URL */
  website?: InputMaybe<Scalars['String']>;
};

/** Input for updating an existing party. */
export type UpdatePartyInput = {
  /** ID of the party to update. */
  partyId: Scalars['UUID'];
  /** The properties to update. */
  props: UpdatePartyProps;
};

/** Properties for updating an existing party. All fields are optional — only provided fields are updated. */
export type UpdatePartyProps = {
  /** Updated description or notes. */
  description?: InputMaybe<Scalars['String']>;
  /** Updated display name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Identifies a phase and the properties to update. */
export type UpdatePhaseInput = {
  /** Allow moving the workflow out of a Paused or Cancelled column when the phase home column changes. */
  confirmUnpark?: InputMaybe<Scalars['Boolean']>;
  /** ID of the phase to update. */
  phaseId: Scalars['UUID'];
  /** New property values to apply. */
  props: UpdatePhaseProps;
};

/** Mutable properties of a phase. Only provided fields are changed. */
export type UpdatePhaseProps = {
  /** New Started-category home column for this phase. */
  columnId?: InputMaybe<Scalars['UUID']>;
  /** New description for the phase. */
  description?: InputMaybe<Scalars['String']>;
  /** New display name for the phase. */
  name?: InputMaybe<Scalars['String']>;
};

/** Input for updating an existing playbook. */
export type UpdatePlaybookInput = {
  /** ID of the playbook to update. */
  playbookId: Scalars['UUID'];
  /** Fields to update on the playbook. */
  props: UpdatePlaybookProps;
};

/** Mutable properties of a playbook. Only provided fields are updated. */
export type UpdatePlaybookProps = {
  /** New description for the playbook. */
  description?: InputMaybe<Scalars['String']>;
  /** New title for the playbook. */
  title?: InputMaybe<Scalars['String']>;
};

/** Input for updating an existing category. */
export type UpdatePlaybookRuleCategoryInput = {
  /** ID of the category to update. */
  categoryId: Scalars['UUID'];
  /** Fields to update on the category. */
  props: UpdatePlaybookRuleCategoryProps;
};

/** Mutable properties of a category. Only provided fields are updated. Use reorderPlaybookRuleCategories to change ordering. */
export type UpdatePlaybookRuleCategoryProps = {
  /** New display name for the category. */
  name?: InputMaybe<Scalars['String']>;
};

/** Input for updating a rule. */
export type UpdatePlaybookRuleInput = {
  /** Fields to update on the rule. */
  props: UpdatePlaybookRuleProps;
  /** ID of the rule to update. */
  ruleId: Scalars['UUID'];
};

/** Input for updating one of a rule's positions. */
export type UpdatePlaybookRulePositionInput = {
  /** ID of the position to update. */
  positionId: Scalars['UUID'];
  /** Fields to update on the position. */
  props: UpdatePlaybookRulePositionProps;
  /** ID of the rule that owns the position. */
  ruleId: Scalars['UUID'];
};

/** Mutable properties of a rule position. Only provided fields are updated. */
export type UpdatePlaybookRulePositionProps = {
  /** New AI guidance for this position. Pass null to clear it. */
  aiGuidance?: InputMaybe<Scalars['String']>;
  /** New requirement text for this position. */
  ruleText?: InputMaybe<Scalars['String']>;
};

/** Mutable properties of a rule. Only provided fields are updated. */
export type UpdatePlaybookRuleProps = {
  /**
   * New short name for the rule. Blank or null clears it, leaving the rule
   * unnamed — the state it was created in.
   */
  title?: InputMaybe<Scalars['String']>;
};

/** Input for batch-moving questions to a new category. */
export type UpdateQuestionCategoryInput = {
  /** The new category name to assign. */
  newCategory: Scalars['String'];
  /** IDs of the questions to recategorize. */
  questionIds: Array<Scalars['UUID']>;
};

/** Input for updating an existing question option. */
export type UpdateQuestionOptionInput = {
  /** ID of the option to update. */
  optionId: Scalars['UUID'];
  /** Fields to update on the option. */
  props: UpdateQuestionOptionProps;
};

/** Mutable properties of a question option. Only provided fields are updated. */
export type UpdateQuestionOptionProps = {
  /** New hex color code. */
  color?: InputMaybe<Scalars['String']>;
  /** New display label. */
  label?: InputMaybe<Scalars['String']>;
  /** New sort position. */
  order?: InputMaybe<Scalars['Int']>;
};

export type UpdateRecipientNameInput = {
  recipientId: Scalars['UUID'];
  recipientName?: InputMaybe<Scalars['String']>;
};

/** Input for updating an existing reminder. */
export type UpdateReminderInput = {
  /** Updated set of user IDs to notify. */
  assigneeIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Properties to change. */
  props?: InputMaybe<ReminderProps>;
  /** The reminder to update. */
  reminderId: Scalars['UUID'];
};

/** Input for updating an existing report. */
export type UpdateReportInput = {
  /** ID of the report to update. */
  reportId: Scalars['UUID'];
  /** The properties to update. */
  reportProps: UpdateReportProps;
};

/** Properties for updating an existing report. */
export type UpdateReportProps = {
  /** New display name for the report. */
  name?: InputMaybe<Scalars['String']>;
  /** Updated DataGrid state (columns, filters, sort order) serialized as JSON. */
  state?: InputMaybe<Scalars['JSON']>;
};

/** Wrapper input identifying which signature field to update and the new property values */
export type UpdateSignatureFieldInput = {
  /** ID of the signature field to update */
  id: Scalars['UUID'];
  /** New property values to apply */
  props: UpdateSignatureFieldProps;
};

/** Editable properties of a signature field */
export type UpdateSignatureFieldProps = {
  /** New workflow recipient ID, or null to unassign */
  actionId?: InputMaybe<Scalars['UUID']>;
};

/** Input for updating a single storable */
export type UpdateStorable = {
  /** New display name for the storable, or null to leave unchanged */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the storable to update */
  storableId: Scalars['UUID'];
};

/** Identifies a task field and the properties to update. */
export type UpdateTaskFieldInput = {
  /** New property values to apply. */
  props: UpdateTaskFieldProps;
  /** ID of the task field to update. */
  taskFieldId: Scalars['UUID'];
};

/** Mutable properties of a task field. Only provided fields are changed. */
export type UpdateTaskFieldProps = {
  /** Updated type-specific settings. */
  config?: InputMaybe<Scalars['JSON']>;
  /** Whether the participant must fill out this field. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** New prompt or question text. */
  label?: InputMaybe<Scalars['String']>;
  /** Change the input control type. */
  type?: InputMaybe<TaskFieldType>;
};

/** Identifies a task and the properties to update. */
export type UpdateTaskInput = {
  /** New property values to apply. */
  props: UpdateTaskProps;
  /** ID of the task to update. */
  taskId: Scalars['UUID'];
};

/** Mutable properties of a task. Only provided fields are changed. */
export type UpdateTaskProps = {
  /** New Markdown body for the task. */
  description?: InputMaybe<Scalars['String']>;
  /** New Markdown instructions for external assignees. */
  externalDescription?: InputMaybe<Scalars['String']>;
  /** Move the task to a different phase, or null to detach from any phase. */
  phaseId?: InputMaybe<Scalars['UUID']>;
  /** New short summary for the task. */
  title?: InputMaybe<Scalars['String']>;
};

/** User fields needed when updating an existing user. */
export type UpdateUser = {
  /** Updated email address */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Updated first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Updated job title */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Updated last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Organization to reassign the user to */
  orgId?: InputMaybe<Scalars['UUID']>;
  /** Updated role within the organization */
  role?: InputMaybe<OrgRole>;
};

/** Input for updating an existing user-defined role */
export type UpdateUserDefinedRoleInput = {
  /** Fields to update on the role */
  props: UserDefinedRoleProps;
  /** ID of the role to update */
  roleId: Scalars['UUID'];
};

/** Wrapper input for updating user settings */
export type UpdateUserSettingsInput = {
  /** Fields to update */
  props: UpdateUserSettingsProps;
};

/** Mutable user-settings fields (all optional — only provided fields are updated) */
export type UpdateUserSettingsProps = {
  /** Set to true to dismiss the onboarding walkthrough */
  hideOnboarding?: InputMaybe<Scalars['Boolean']>;
};

/** Input for updating an existing variable configuration template. */
export type UpdateVariableConfigInput = {
  /** ID of the config to update. */
  id: Scalars['UUID'];
  /** Properties to update on the config. */
  props?: InputMaybe<UpdateVariableConfigProps>;
  /** Answer options to create or update. */
  upsertAnswerOptions?: InputMaybe<UpsertAnswerOptionsInput>;
};

/** Properties for updating an existing variable configuration template. All fields are optional — only provided fields are updated. */
export type UpdateVariableConfigProps = {
  /** Set or change the default answer option by ID. */
  defaultAnswerId?: InputMaybe<Scalars['UUID']>;
  /** Updated display label. */
  label?: InputMaybe<Scalars['String']>;
  /** Updated usage notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Updated value prefix. */
  prefix?: InputMaybe<Scalars['String']>;
  /** Updated question prompt. */
  question?: InputMaybe<Scalars['String']>;
  /** Changed input type variant. */
  variant?: InputMaybe<MetadataVariant>;
};

/** Input for reordering a workflow file within its workflow. */
export type UpdateWorkflowFileOrderInput = {
  /** The workflow file to reorder. */
  fileId: Scalars['UUID'];
  /** New zero-based sort position. */
  orderId: Scalars['Int'];
};

/** Input for updating workflow properties. */
export type UpdateWorkflowInput = {
  /** Allow moving the workflow out of a Paused or Cancelled column. */
  confirmUnpark?: InputMaybe<Scalars['Boolean']>;
  /** Properties to update. */
  props: WorkflowProps;
  /** The workflow to update. */
  workflowId: Scalars['UUID'];
};

/** Input for updating an existing workflow launch config. */
export type UpdateWorkflowLaunchConfigInput = {
  /** The launch config to update. */
  launchConfigId: Scalars['UUID'];
  /** Updated set of placeholder role IDs that launchers must assign. */
  placeholderIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Properties to change. */
  props?: InputMaybe<UpdateWorkflowLaunchConfigProps>;
};

/** Mutable properties of a workflow launch config. */
export type UpdateWorkflowLaunchConfigProps = {
  /** Whether the launch config accepts submissions. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether launched workflows are automatically sent for signature. */
  isAutomaticS4SEnabled?: InputMaybe<Scalars['Boolean']>;
  /** User who will own launched workflow instances. */
  launchedWorkflowOwnerId?: InputMaybe<Scalars['UUID']>;
  /** Default title for launched workflow instances. */
  workflowTitle?: InputMaybe<Scalars['String']>;
};

/** Input for updating a single workflow permission. */
export type UpdateWorkflowPermissionInput = {
  /** Optional notification message sent to the collaborator. */
  message?: InputMaybe<Scalars['String']>;
  /** Properties to change. */
  props: UpdateWorkflowPermissionProps;
  /** The permission to update. */
  workflowPermissionId: Scalars['UUID'];
};

/** Mutable properties of a workflow permission. */
export type UpdateWorkflowPermissionProps = {
  /** New workflow-level access. */
  accessLevel?: InputMaybe<WorkflowAccessLevel>;
  /** New document-level access for all workflow documents. */
  docAccessLevel?: InputMaybe<PermissionRole>;
  /** Whether this collaborator is an assignee. */
  isAssignee?: InputMaybe<Scalars['Boolean']>;
  /** Whether the permission is active or queued. */
  timeliness?: InputMaybe<WorkflowPermissionTimeliness>;
};

export type UpdateWorkflowViewInput = {
  id: Scalars['UUID'];
  props: UpdateWorkflowViewProps;
};

export type UpdateWorkflowViewProps = {
  name?: InputMaybe<Scalars['String']>;
  showInSavedViews?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['JSON']>;
};

/** Request from a VIEWER user to upgrade to a paid org role */
export type UpgradeRequest = {
  __typename: 'UpgradeRequest';
  /** When the request was created */
  createdAt: Scalars['DateTime'];
  /** Request ID */
  id: Scalars['UUID'];
  /** Optional note from the requester */
  message: Maybe<Scalars['String']>;
  /** Organization that owns this request */
  org: Org;
  /** Role requested by the user */
  requestedRole: OrgRole;
  /** User requesting the role upgrade */
  requester: User;
  /** When an admin responded */
  respondedAt: Maybe<Scalars['DateTime']>;
  /** Admin who responded to the request */
  respondedBy: Maybe<User>;
  /** Optional admin response note */
  responseMessage: Maybe<Scalars['String']>;
  /** Current request status */
  status: UpgradeRequestStatus;
};

/** Status of an org-role upgrade request */
export enum UpgradeRequestStatus {
  /** Request was approved and the requester role was updated. */
  Approved = 'APPROVED',
  /** Request was cancelled before admin response. */
  Cancelled = 'CANCELLED',
  /** Request was denied by an org admin. */
  Denied = 'DENIED',
  /** Request is awaiting an org admin response. */
  Pending = 'PENDING'
}

export type UploadMetadataImportResult = {
  __typename: 'UploadMetadataImportResult';
  documentMetadataImport: DocumentMetadataImport;
};

/** Input for uploading a file in response to a task. */
export type UploadTaskResponseVersionInput = {
  /** Decision to record with the upload, if any. */
  decision?: InputMaybe<TaskAssigneeDecision>;
  /** The workflow document the redline replaces. */
  documentId: Scalars['UUID'];
  /** Uploaded .docx location. */
  fileLocation: FileLocationProps;
  /** Comment for the decision. Required when the decision is CHANGES_REQUESTED. */
  note?: InputMaybe<Scalars['String']>;
  /** Record the response on behalf of this external assignee. Internal users only. */
  onBehalfOfPermissionId?: InputMaybe<Scalars['UUID']>;
  taskId: Scalars['UUID'];
};

/** Input for creating or updating annotations */
export type UpsertAnnotationsInput = {
  /** When true, merges the XFDF annotation data into the underlying PDF file */
  mergeXFDFIntoFile?: InputMaybe<Scalars['Boolean']>;
  /** Annotation data to upsert */
  props: UpsertAnnotationsProps;
};

/** Properties for creating or updating annotations on a file version */
export type UpsertAnnotationsProps = {
  /** ID of the file version to attach annotations to */
  fileVersionId: Scalars['UUID'];
  /** XFDF XML string containing the annotation data */
  xfdf: Scalars['String'];
};

/** Input for upserting an answer option set, typically used inline within document editing. */
export type UpsertAnswerOptionsInput = {
  /** Zero-based index of the option that should be pre-selected as the default. */
  defaultAnswerIndex?: InputMaybe<Scalars['Int']>;
  /** Existing set ID to update; omit to create a new set. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Complete list of choices. Replaces all existing options when updating. */
  options: Array<AnswerOptionProps>;
};

/** Input for bulk-upserting permissions on a storable */
export type UpsertStorablePermissions = {
  /** Optional message included in the notification email */
  message?: InputMaybe<Scalars['String']>;
  /** Whether to send email notifications to affected recipients */
  notifyRecipients: Scalars['Boolean'];
  /** List of permission entries to create or update */
  permissions: Array<PermissionUpdate>;
  /** ID of the storable to modify permissions for */
  storableId: Scalars['UUID'];
};

/** Input for uploading signature and initials images */
export type UpsertUserSignaturesInput = {
  /** Initials image file */
  initialsFile: Scalars['Upload'];
  /** Full signature image file */
  signatureFile: Scalars['Upload'];
};

/** A URL relationship row where the child is a URL (not a document). */
export type UrlRelationshipRow = {
  __typename: 'UrlRelationshipRow';
  childRowCount: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Always non-null at runtime (URL rows only exist as children of an expanded parent), but ID must be nullable here to match union siblings (GQL limitation with unions). */
  parentTreeRowId: Maybe<Scalars['ID']>;
  /** The URL relationship data. */
  urlRelationship: DocumentRelationship;
};

/** A user account */
export type User = AccountInterface & {
  __typename: 'User';
  /** User's account status */
  accountStatus: AccountStatus;
  /** Account's type - User or Org */
  accountType: AccountType;
  /** User's postal address (auto-populated from canned-field entries). */
  address: Maybe<Scalars['String']>;
  /** Per-model AI token consumption for the current billing period */
  aiTokenUsage: Array<AiTokenUsage>;
  /** Aggregate AI usage summary and remaining quota */
  aiUsage: AiUsage;
  /** Avatar background color as an RGB hex string, used in comments and file explorer */
  avatarColor: Scalars['String'];
  /** User's company (auto-populated from canned-field entries). */
  companyName: Maybe<Scalars['String']>;
  /** Contract types available to the user through their organization */
  contractTypes: Array<ContractType>;
  /** When this user account was created */
  createdAt: Scalars['DateTime'];
  /** When this user was soft-deleted (null if active) */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Full display name (computed from first and last name) */
  displayName: Scalars['String'];
  /** User's email */
  email: Scalars['String'];
  /** User's first name */
  firstName: Maybe<Scalars['String']>;
  /** Groups this user belongs to. */
  groups: Array<Group>;
  /** Unique identifier for the user */
  id: Scalars['UUID'];
  /** Whether the user's account has been deactivated by an admin */
  isDeactivated: Scalars['Boolean'];
  /** User's job title */
  jobTitle: Maybe<Scalars['String']>;
  /** User's last name */
  lastName: Maybe<Scalars['String']>;
  /** The way the user logs in */
  loginType: LoginType;
  /** Documents recently accessed or created by the User. */
  myRecentDocuments: Array<Document>;
  /** ID of the user's personal default repository */
  myRepositoryId: Scalars['UUID'];
  /** Returns the number of workflows the user has created during the month. */
  numWorkflowsCreatedThisMonth: Scalars['Int'];
  /** Organization the user belongs to (Optional) */
  org: Org;
  /** Role within an organization. */
  role: OrgRole;
  /** Per-user preferences and onboarding state */
  settings: UserSettings;
  /** Exact name last used on a Name canned field. Independent of firstName and lastName. */
  signingName: Maybe<Scalars['String']>;
  /** Elevated support role for internal staff (null for regular users) */
  supportRole: Maybe<SupportRole>;
  /** When this user account was last modified */
  updatedAt: Scalars['DateTime'];
};


/** A user account */
export type UserMyRecentDocumentsArgs = {
  docVariant?: InputMaybe<DocumentVariant>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Roles defined by users for use in templates - e.g., the Attorney role must complete this input field */
export type UserDefinedRole = {
  __typename: 'UserDefinedRole';
  /** User who created this role */
  author: Maybe<User>;
  /** When the user-defined role was created */
  createdAt: Scalars['DateTime'];
  /** When the user-defined role was soft-deleted; null if active */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this role */
  id: Scalars['UUID'];
  /** Organization this role belongs to */
  org: Maybe<Org>;
  /** Role name defined by the user */
  roleName: Scalars['String'];
  /** When the user-defined role was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Mutable properties of a user-defined role */
export type UserDefinedRoleProps = {
  /** Display name for the role */
  roleName: Scalars['String'];
};

/** Response wrapping a single user-defined role after a mutation */
export type UserDefinedRoleResponse = {
  __typename: 'UserDefinedRoleResponse';
  refetch: Query;
  /** The created or updated role */
  userDefinedRole: UserDefinedRole;
};

/** Response to user mutations */
export type UserResponse = {
  __typename: 'UserResponse';
  /** Entrypoint for refetching related queries after mutation */
  refetch: Query;
  /** The updated user */
  user: Maybe<User>;
};

/** Per-user preferences, onboarding state, and saved example resources */
export type UserSettings = {
  __typename: 'UserSettings';
  /** Sample NDA document created during onboarding for the user to explore */
  exampleNDA: Maybe<Document>;
  /** Sample playbook created during onboarding to demonstrate AI review */
  exampleNDAPlaybook: Maybe<Playbook>;
  /** Sample report created during onboarding to demonstrate reporting features */
  exampleReport: Maybe<Report>;
  /** When true, the onboarding walkthrough is hidden from the UI */
  hideOnboarding: Scalars['Boolean'];
  /** Unique identifier for the settings record */
  id: Scalars['UUID'];
  /** Checklist of onboarding steps and their completion status */
  onboardingTasks: Array<OnboardingTask>;
  /** Uploaded image used as the user's signature in documents */
  signatureImg: Maybe<DocFile>;
  /** Uploaded image used as the user's initials in documents */
  signatureInitialsImg: Maybe<DocFile>;
};

/** Response wrapper for user-settings mutations */
export type UserSettingsResponse = {
  __typename: 'UserSettingsResponse';
  /** Entrypoint for refetching related queries after mutation */
  refetch: Query;
  /** The updated user settings */
  settings: UserSettings;
};

/** Response for bulk user operations */
export type UsersResponse = {
  __typename: 'UsersResponse';
  /** Entrypoint for refetching related queries after mutation */
  refetch: Query;
  /** The affected users */
  users: Array<User>;
};

/** Properties for a single answer option when creating variable answer options. */
export type VariableAnswerOptionProps = {
  /** The display text for this answer option. */
  optionText: Scalars['String'];
  /** The workflow action triggered when this option is selected. */
  triggerAction: TriggerAction;
};

/** A workflow orchestrating document review, approval, and signature processes. */
export type Workflow = {
  __typename: 'Workflow';
  /** The currently-active step in the workflow. */
  activeStep: Maybe<WorkflowStep>;
  /**
   * Unified chronological timeline of comments, AI threads, and lifecycle events for this workflow.
   *
   * Pass at most one of cursor, before, or anchor (see Task.activity).
   */
  activity: ActivityItemRowsInfo;
  /** When AI workflow generation was cancelled. */
  aiCancelledAt: Maybe<Scalars['DateTime']>;
  /** When AI workflow generation failed. */
  aiFailedAt: Maybe<Scalars['DateTime']>;
  /** Safe user-facing reason for an AI workflow generation failure. */
  aiFailureReason: Maybe<Scalars['String']>;
  /** When AI workflow generation finished successfully. */
  aiFinishedAt: Maybe<Scalars['DateTime']>;
  /** When AI workflow generation started. */
  aiStartedAt: Maybe<Scalars['DateTime']>;
  /** The board this workflow lives on (derived from its current column). */
  boardId: Scalars['UUID'];
  /**
   * Every canned field defined in this workflow, whichever of its documents
   * they are placed in. Reads are workflow-wide by design: a canned value is
   * contract content, and the counterparty is exactly who needs to see it.
   */
  cannedFields: Array<CannedField>;
  /** The board column this workflow is currently in. */
  column: Column;
  /** Count of comments. */
  commentCount: Scalars['Int'];
  /** Comments on the workflow. */
  comments: Array<Comment>;
  /** Categories if published to the Community. */
  communityCategories: Array<CommunityCategory>;
  /** Time of completion */
  completedAt: Maybe<Scalars['DateTime']>;
  /** Count of completed steps. */
  completedStepCount: Scalars['Int'];
  /** Created at - ISO 8601 */
  createdAt: Scalars['DateTime'];
  /** The CRMs this template is explicitly published to. Template Workflows only; empty means unpublished. */
  crmIntegrations: Array<Integration>;
  /** Optional description of the workflow. Useful for publishing to Community. */
  description: Scalars['String'];
  /** Done-category column the workflow moves to when all phases complete. */
  doneColumn: Column;
  /** Envelope created for signing the document associated with the Workflow. */
  envelope: Maybe<Envelope>;
  /** Optional message to use when sending out any Envelope associated with the Workflow. */
  envelopeMsg: Maybe<Scalars['String']>;
  /** Envelope status (formerly on envelope.status). */
  envelopeStatus: EnvelopeStatus;
  /** Workflow file count. */
  fileCount: Scalars['Int'];
  /** WorkflowFiles for this Workflow. */
  files: Array<WorkflowFile>;
  /** Workflow followers. */
  followers: Array<User>;
  /** Recipient forwarding for the workflow. */
  forwardingPermissionRole: Maybe<PermissionRole>;
  /** Primary identifier for the workflow. */
  id: Scalars['UUID'];
  /** Document fields opted into collection at template launch. Template workflows only. */
  intakeFields: Array<AlineTemplateField>;
  /** The intake form instance for this launched workflow, if any. Instance workflows only. */
  intakeForm: Maybe<IntakeForm>;
  /** The intake form template attached to this TEMPLATE workflow, if any. Template workflows only. */
  intakeFormTemplate: Maybe<IntakeFormTemplate>;
  /** Defines whether a workflow is a public Community Workflow. Template Workflows only. Defaults to False. */
  isCommunityWorkflow: Scalars['Boolean'];
  /** Whether the workflow is ready to be sent for signature. */
  isReadyForSignature: WorkflowReadyForSignature;
  /** Whether the workflow was signed outside of Aline platform */
  isSignedOutsideAline: Scalars['Boolean'];
  /** User-assigned labels for this Workflow */
  labels: Array<Label>;
  /** Workflow might have a launch config for publicly launching the workflow. */
  launchConfig: Maybe<WorkflowLaunchConfig>;
  /** The CRM opportunities linked to this workflow. */
  linkedOpportunities: Array<LinkedOpportunity>;
  /**
   * The CRMs this workflow's document fields actually pull from, derived from the
   * field mappings. Independent of crmIntegrations: a template can map fields
   * without being published, and can be published without mapping any field.
   */
  mappedCrmIntegrations: Array<Integration>;
  /** The actions/recipients that are missing from the Workflow. */
  missingActions: Scalars['Boolean'];
  /** The name of the workflow. */
  name: Scalars['String'];
  /** The number of times this workflow has been imported. Usually reserved for community template workflows. */
  numTimesImported: Scalars['Int'];
  /** The number of times this workflow has been used.  Usually reserved for community template workflows. */
  numTimesUsed: Scalars['Int'];
  /** Owner of the Workflow. */
  owner: User;
  /** Parties associated with the Workflow. */
  parties: Array<Party>;
  /** List of permissions for the Workflow governing access. */
  permissions: Array<WorkflowPermission>;
  /** Phases organizing tasks in this workflow. */
  phases: Array<Phase>;
  /** The priority level of the workflow. */
  priority: Maybe<WorkflowPriority>;
  /** Published at - ISO 8601 */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** Returns the ids of the imported copies of the workflow, if any. */
  requesterImportedWorkflowIds: Array<Scalars['UUID']>;
  /** Requester is in owner's org. */
  requesterInOwnerOrg: Scalars['Boolean'];
  /** When true, launch auto-starts work instead of landing in Triage (only applies when the board has Triage). */
  skipTriage: Scalars['Boolean'];
  /** The source workflow (e.g., template workflow). */
  sourceWorkflow: Maybe<Workflow>;
  /** Time of first play (or creation if started in Running state) */
  startedAt: Maybe<Scalars['DateTime']>;
  /** General state of the Workflow. */
  state: WorkflowState;
  /** Workflow's status */
  status: WorkflowStatus;
  /** Subscriber picker rows: current subscribers plus a bounded, searchable slice of active org members, each with subscribed + locked state */
  subscriberOptions: Array<ActivitySubscriberOption>;
  /** Users who will be notified of activity on this workflow (assignees, owner, mentioned, commenters, and manual subscribers, minus anyone who muted). Owners are auto-subscribed but can unsubscribe. */
  subscribers: Array<User>;
  /** Workflow tasks. */
  tasks: Array<Task>;
  /** Total steps count. */
  totalStepCount: Scalars['Int'];
  /**
   * Alias of variant, kept so the CRM packages that query type on crmTemplates still validate.
   * @deprecated Use variant instead
   */
  type: Maybe<WorkflowVariant>;
  /** The actions listed in workflow for which there is no corresponding variable in any workflow file. */
  unusedActions: Array<WorkflowRecipient>;
  /** Updated at - ISO 8601 */
  updatedAt: Scalars['DateTime'];
  /** Whether the workflow is a Contract or Template variant. */
  variant: WorkflowVariant;
  /** Whether the current viewer is subscribed to this workflow's activity */
  viewerSubscribed: Scalars['Boolean'];
  /** Whether the viewer's subscription is locked (they are an assignee and cannot unsubscribe) */
  viewerSubscriptionLocked: Scalars['Boolean'];
  /** Whether this workflow has been sent for signature. */
  wasSentForSig: Scalars['Boolean'];
  /** The reason why the workflow failed to send for signature automatically. */
  workflowAutomaticSendFailedReason: Maybe<Scalars['String']>;
};


/** A workflow orchestrating document review, approval, and signature processes. */
export type WorkflowActivityArgs = {
  anchor?: InputMaybe<Scalars['UUID']>;
  before?: InputMaybe<Scalars['UUID']>;
  cursor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** A workflow orchestrating document review, approval, and signature processes. */
export type WorkflowSubscriberOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Workflow-level access granted to a collaborator. */
export enum WorkflowAccessLevel {
  /** Collaborator is an active assignee who can act on workflow steps. */
  Assignee = 'Assignee',
  /** Permission has been revoked. */
  NoAccess = 'NoAccess',
  /** Read-only access to the workflow. */
  Viewer = 'Viewer'
}

/** An action a collaborator can perform in a workflow — either a recipient action or a task. */
export type WorkflowAction = Task | WorkflowRecipient;

/** Filter scope for which workflow actions to return. */
export enum WorkflowActionFilter {
  /** Return only actions from the currently-active step. */
  ActiveStep = 'ActiveStep',
  /** Return actions from all steps. */
  All = 'All'
}

/**
 * Streamed event fired after a workflow tool creates a draft or launches a
 * template and links the resulting workflow to the assistant message.
 */
export type WorkflowArtifactCreatedEvent = {
  __typename: 'WorkflowArtifactCreatedEvent';
  /** Assistant message that owns the workflow artifact */
  agentMessageId: Scalars['UUID'];
  /** When the workflow join row was created */
  artifactCreatedAt: Scalars['DateTime'];
  /** How the workflow relates to the message */
  kindList: Array<AgentMessageJoinKind>;
  /** ID of the conversation thread */
  threadId: Scalars['UUID'];
  /** ID of the user who initiated the workflow action */
  userId: Scalars['UUID'];
  /** ID of the created workflow */
  workflowId: Scalars['UUID'];
  /** Display name of the created workflow */
  workflowName: Scalars['String'];
};

/** A Dimension bucket available for selection, ranked by the Chart Measure. */
export type WorkflowChartCategory = {
  __typename: 'WorkflowChartCategory';
  /** Contributing Workflow count (sample size for average Measures). */
  count: Scalars['Int'];
  id: Scalars['String'];
  label: Scalars['String'];
  /** Tooltip copy. Status buckets always include the Board name. */
  tooltipLabel: Scalars['String'];
  /** Aggregate Measure across the full filtered Chart cohort. */
  value: Scalars['Float'];
};

/** Category labels for one Chart Dimension (parallel to value series). */
export type WorkflowChartDimensionSeries = {
  __typename: 'WorkflowChartDimensionSeries';
  /** Display labels for each bucket (axis ticks). */
  data: Array<Scalars['String']>;
  id: Scalars['String'];
  /** Stable bucket keys parallel to data (for drill-down filters). */
  keys: Array<Scalars['String']>;
  label: Scalars['String'];
};

/** Server-computed Chart series over the viewer's list-visible Workflows. */
export type WorkflowChartSeries = {
  __typename: 'WorkflowChartSeries';
  dimensions: Array<WorkflowChartDimensionSeries>;
  primaryCatalog: Array<WorkflowChartCategory>;
  secondaryCatalog: Array<WorkflowChartCategory>;
  totals: WorkflowChartTotalSeries;
  values: Array<WorkflowChartValueSeries>;
};

/** Request for Workflow Chart series (Dimensions + Measure + optional filters). */
export type WorkflowChartSeriesInput = {
  /** Bucket size for date Dimensions (default week). */
  dateBucket?: InputMaybe<Scalars['String']>;
  /** Ordered Dimensions (primary, optional secondary). Allowlisted field names. */
  dimensions: Array<Scalars['String']>;
  /** Optional DataGrid filterModel applied before grouping. */
  filterModel?: InputMaybe<Scalars['JSON']>;
  /** Row grain: workflow (default) or columnInterval. */
  grain?: InputMaybe<Scalars['String']>;
  /** Optional list scope (organization / assigned / etc.). */
  listFilter?: InputMaybe<WorkflowListFilter>;
  /** Aggregation Measure (count or medianDurationDays). */
  measure: Scalars['String'];
  /** Minimum samples before a median bucket is plotted (default 2). */
  minSampleSize?: InputMaybe<Scalars['Int']>;
  /** Exact primary bucket keys to return instead of automatic top ranking. */
  primaryKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Optional maximum primary buckets returned; catalog and totals remain complete. */
  primaryLimit?: InputMaybe<Scalars['Int']>;
  /** Exact secondary bucket keys to return instead of automatic top ranking. */
  secondaryKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Optional maximum secondary series returned; catalog and totals remain complete. */
  secondaryLimit?: InputMaybe<Scalars['Int']>;
  /** Optional per-value series (created vs completed). JSON WorkflowChartSeriesValue[]. */
  values?: InputMaybe<Scalars['JSON']>;
  /** Optional Workflow-level filters (variant, completed, published). */
  workflowFilter?: InputMaybe<WorkflowFilterInput>;
};

/** Full-cohort Measure totals parallel to the visible primary Dimension buckets. */
export type WorkflowChartTotalSeries = {
  __typename: 'WorkflowChartTotalSeries';
  counts: Array<Scalars['Int']>;
  data: Array<Maybe<Scalars['Float']>>;
};

/** Numeric Measure series for a Chart (one series, or one per secondary Dimension). */
export type WorkflowChartValueSeries = {
  __typename: 'WorkflowChartValueSeries';
  /** Per-bucket sample counts (for tooltips and median suppression). */
  counts: Array<Scalars['Int']>;
  data: Array<Maybe<Scalars['Float']>>;
  id: Scalars['String'];
  label: Scalars['String'];
};

/** Maps a template document ID to the display name for the launched instance. */
export type WorkflowDocumentName = {
  /** Template document ID. */
  documentId: Scalars['UUID'];
  /** Display name for this document in the launched instance. */
  instanceName: Scalars['String'];
};

/** Association between a workflow and a document, including its role and ordering. */
export type WorkflowFile = {
  __typename: 'WorkflowFile';
  /** Created at - ISO 8601 */
  createdAt: Scalars['DateTime'];
  /** The document attached to the workflow. */
  document: Document;
  /** Whether this document is a general reference file or a signing document. */
  documentRole: WorkflowFileDocumentRole;
  /** Primary identifier for this workflow-file association. */
  id: Scalars['UUID'];
  /** Whether this General document is only shared with the workflow owner's org. Always false on Signing files. */
  isInternal: Scalars['Boolean'];
  /** Sort position of this file within the workflow. */
  orderId: Scalars['String'];
  /** When documentRole is Signing, the signing phase this file is associated with. */
  phaseId: Maybe<Scalars['UUID']>;
  /** Updated at - ISO 8601 */
  updatedAt: Scalars['DateTime'];
};

/** Role a document plays within a workflow. */
export enum WorkflowFileDocumentRole {
  /** A reference or supporting document that does not require signatures. */
  General = 'General',
  /** A document that requires e-signatures from recipients. */
  Signing = 'Signing'
}

/** Filter criteria for listing workflows. */
export type WorkflowFilterInput = {
  /** Filter by completion status. */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Filter by published-to-community status (templates only). */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Filter by template or contract variant. */
  variant?: InputMaybe<WorkflowVariant>;
};

/** A server-side Workflow list group header (lazy DataGrid expansion). */
export type WorkflowGroupHeader = {
  __typename: 'WorkflowGroupHeader';
  /** Average cycle time in days for completed Workflows in this group. */
  avgCycleTime: Maybe<Scalars['Float']>;
  /**
   * Immediate child row count for skeleton padding. Subgroup count at intermediate
   * levels; omitted at the deepest group level (children are Workflows).
   */
  childRowCount: Maybe<Scalars['Int']>;
  /** Dimension field used for this group level. */
  groupField: Scalars['String'];
  /** Bucket key (stable; may be an id or sentinel). */
  groupKey: Scalars['String'];
  /** Display label for the bucket. */
  groupLabel: Scalars['String'];
  /** Stable group id (field:key or nested parent/field:key). */
  id: Scalars['String'];
  /** Always true for group headers. */
  isGroupRow: Scalars['Boolean'];
  /** Parent group id, or null for top-level groups. */
  parentGroupId: Maybe<Scalars['String']>;
  /** Number of Workflows in this group (leaf total). */
  workflowCount: Scalars['Int'];
};

/** Filter criteria for the workflow inbox view. */
export type WorkflowInboxFilterInput = {
  /** When true, return only workflows assigned to the current user. */
  assignedToMe?: InputMaybe<Scalars['Boolean']>;
};

/** All Insights Charts available to the current user, resolved in one request. */
export type WorkflowInsightsDashboard = {
  __typename: 'WorkflowInsightsDashboard';
  hiddenSystemPresetIds: Array<Scalars['String']>;
  org: Array<WorkflowInsightsDashboardChart>;
  personal: Array<WorkflowInsightsDashboardChart>;
};

/** One fully resolved Chart on the current user's Insights dashboard. */
export type WorkflowInsightsDashboardChart = {
  __typename: 'WorkflowInsightsDashboardChart';
  /** Unique dashboard-card identity (System preset or Pin). */
  id: Scalars['String'];
  /** Set for Org or Personal pinned Charts. */
  pin: Maybe<InsightPin>;
  /** Set for product-authored System Charts. */
  presetId: Maybe<Scalars['String']>;
  series: WorkflowChartSeries;
};

/** Properties for a new workflow instance created from a template. */
export type WorkflowInstanceProps = {
  /** Display names for each document in the instance. */
  documentNames: Array<WorkflowDocumentName>;
  /** Name for the launched workflow instance. */
  name: Scalars['String'];
};

/** An intake form was added to the workflow's quasi-phase process. */
export type WorkflowIntakeFormAddedEvent = WorkflowPhasesChangedEvent & {
  __typename: 'WorkflowIntakeFormAddedEvent';
  /** Latest intake form template attached to the workflow. */
  intakeFormTemplate: IntakeFormTemplate;
  /** Workflow whose phase/task list changed. */
  workflowId: Scalars['UUID'];
};

/** An intake form was removed from the workflow's quasi-phase process. */
export type WorkflowIntakeFormRemovedEvent = WorkflowPhasesChangedEvent & {
  __typename: 'WorkflowIntakeFormRemovedEvent';
  /** Removed intake form template id. */
  intakeFormTemplateId: Scalars['UUID'];
  /** Workflow whose phase/task list changed. */
  workflowId: Scalars['UUID'];
};

/** Wrapper returned by mutations affecting a workflow's attached intake form template. */
export type WorkflowIntakeFormTemplateResponse = {
  __typename: 'WorkflowIntakeFormTemplateResponse';
  /** Root query entry point for refetching related data after the mutation. */
  refetch: Query;
  /** The affected template workflow. */
  workflow: Workflow;
};

/** The workflow's quasi-phase intake form changed. */
export type WorkflowIntakeFormUpdatedEvent = WorkflowPhasesChangedEvent & {
  __typename: 'WorkflowIntakeFormUpdatedEvent';
  /** Latest intake form template attached to the workflow. */
  intakeFormTemplate: IntakeFormTemplate;
  /** Workflow whose phase/task list changed. */
  workflowId: Scalars['UUID'];
};

/** Configuration allowing external users to launch workflow instances from a template via a public link. */
export type WorkflowLaunchConfig = {
  __typename: 'WorkflowLaunchConfig';
  /** Whether this launch config is currently accepting submissions. */
  enabled: Scalars['Boolean'];
  /** Primary identifier for this launch config. */
  id: Scalars['UUID'];
  /** When true, the launched workflow is automatically sent for signature. */
  isAutomaticS4SEnabled: Scalars['Boolean'];
  /** Fields and intake form collected on the public launch page. */
  launchForm: LaunchConfigForm;
  /** The user who owns launched workflow instances. */
  launchedWorkflowOwner: User;
  /** Template roles that the external launcher must assign during submission. */
  placeholders: Array<WorkflowPermission>;
  /** The template workflow this config launches. */
  workflow: Workflow;
  /** Default title applied to launched workflow instances. */
  workflowTitle: Scalars['String'];
};

/** Root / footer Measure aggregates for the Workflows list dataSource. */
export type WorkflowListAggregates = {
  __typename: 'WorkflowListAggregates';
  /** Average cycle time in days over completed Workflows; null when none completed. */
  avgCycleTime: Maybe<Scalars['Float']>;
  /** Workflow count in the filtered cohort. */
  count: Scalars['Int'];
};

/** Filter scope for which workflows to list. */
export enum WorkflowListFilter {
  /** All workflows the requester can access. */
  All = 'All',
  /** Only workflows owned by members of the requester's organization. */
  Organization = 'Organization',
  /** Only workflows explicitly shared with the requester. */
  Shared = 'Shared'
}

/** Result of checking workflow mention access. */
export type WorkflowMentionAccessResult = MentionAccessError | Workflow;

/** Reasons a workflow cannot be sent for signature. */
export enum WorkflowNotReadyForSigReason {
  /** Fields exist but are not assigned to a signer recipient. */
  FieldsRequireSigner = 'FieldsRequireSigner',
  /** General (non-signing) documents contain fields that must be removed or moved. */
  GeneralDocumentsHaveFields = 'GeneralDocumentsHaveFields',
  /** The attached intake form has required fields that have not been completed. */
  IntakeFormIncomplete = 'IntakeFormIncomplete',
  /** Required actions are not yet assigned to collaborators. */
  MissingActions = 'MissingActions',
  /** No documents have been added to the workflow. */
  NoDocuments = 'NoDocuments',
  /** Pre-signature steps are still incomplete. */
  PreSigIncomplete = 'PreSigIncomplete',
  /** Some actions are unassigned to a user or role. */
  SomeActionsUnassigned = 'SomeActionsUnassigned',
  /** Workflow is a template and cannot be sent directly. */
  TemplateWorkflow = 'TemplateWorkflow',
  /** There are unresolved comments on workflow documents. */
  UnresolvedComments = 'UnresolvedComments',
  /** There are unresolved tracked changes on workflow documents. */
  UnresolvedTrackedChanges = 'UnresolvedTrackedChanges',
  /** Workflow has already been completed. */
  WorkflowComplete = 'WorkflowComplete'
}

/** A collaborator's permission entry on a workflow, controlling their access and role. */
export type WorkflowPermission = {
  __typename: 'WorkflowPermission';
  /** The access level this permission grants. */
  accessLevel: WorkflowAccessLevel;
  /** Account that pertains to this permission. */
  account: Maybe<Account>;
  /** Actions associated with this permission. */
  actions: Array<WorkflowAction>;
  /** Created at - ISO 8601 */
  createdAt: Scalars['DateTime'];
  /** The doc-level access to fall back to for all the docs in the workflow. */
  docAccessLevel: DocAccessLevel;
  id: Scalars['UUID'];
  /** Indicates whether the workflow collaborator is an assignee. */
  isAssignee: Scalars['Boolean'];
  /** Indicates whether the workflow collaborator is external. */
  isExternal: Scalars['Boolean'];
  /** On a template, launch fills this role placeholder with the new workflow's owner. */
  isLauncher: Scalars['Boolean'];
  /** Role assigned to this permission. */
  role: Maybe<UserDefinedRole>;
  /** Active or queued permission. */
  timeliness: WorkflowPermissionTimeliness;
  /** Updated at - ISO 8601 */
  updatedAt: Scalars['DateTime'];
  /** Associated workflow. */
  workflow: Workflow;
  /** Variant of the associated workflow. */
  workflowVariant: WorkflowVariant;
};

/** Whether a collaborator's permission is currently active or queued for a future step. */
export enum WorkflowPermissionTimeliness {
  /** Permission is currently active. */
  Active = 'Active',
  /** Permission is waiting to become active in a future step. */
  Queued = 'Queued'
}

/** A phase was created. */
export type WorkflowPhaseCreatedEvent = WorkflowPhasesChangedEvent & {
  __typename: 'WorkflowPhaseCreatedEvent';
  /** Created phase. */
  phase: Phase;
  /** Workflow whose phase/task list changed. */
  workflowId: Scalars['UUID'];
};

/** A phase was deleted. */
export type WorkflowPhaseDeletedEvent = WorkflowPhasesChangedEvent & {
  __typename: 'WorkflowPhaseDeletedEvent';
  /** Deleted phase id. */
  phaseId: Scalars['UUID'];
  /** Workflow whose phase/task list changed. */
  workflowId: Scalars['UUID'];
};

/** One or more phases changed, including nested task data. */
export type WorkflowPhaseUpdatedEvent = WorkflowPhasesChangedEvent & {
  __typename: 'WorkflowPhaseUpdatedEvent';
  /** Changed phase snapshots. */
  phases: Array<Phase>;
  /** The workflow, re-resolved because activating a phase moves it to that phase's home column. */
  workflow: Workflow;
  /** Workflow whose phase/task list changed. */
  workflowId: Scalars['UUID'];
};

/** Common workflow-scoped fields for phase/task-list subscription events. */
export type WorkflowPhasesChangedEvent = {
  /** Workflow whose phase/task list changed. */
  workflowId: Scalars['UUID'];
};

export type WorkflowPhasesChangedPayload = WorkflowIntakeFormAddedEvent | WorkflowIntakeFormRemovedEvent | WorkflowIntakeFormUpdatedEvent | WorkflowPhaseCreatedEvent | WorkflowPhaseDeletedEvent | WorkflowPhaseUpdatedEvent | WorkflowPhasesReorderedEvent;

/** The workflow's phases were reordered. */
export type WorkflowPhasesReorderedEvent = WorkflowPhasesChangedEvent & {
  __typename: 'WorkflowPhasesReorderedEvent';
  /** Reordered phase snapshots. */
  phases: Array<Phase>;
  /** Workflow whose phase/task list changed. */
  workflowId: Scalars['UUID'];
};

/** Priority level for a workflow, used for sorting and filtering. */
export enum WorkflowPriority {
  /** Highest priority — requires immediate attention. */
  High = 'High',
  /** Below-normal priority. */
  Low = 'Low',
  /** Default priority. */
  Medium = 'Medium',
  /** Critical priority — time-sensitive, overdue, or blocking. */
  Urgent = 'Urgent'
}

/** Mutable properties of a workflow. */
export type WorkflowProps = {
  /** Board column to move the workflow to. */
  columnId?: InputMaybe<Scalars['UUID']>;
  /** Workflow description. */
  description?: InputMaybe<Scalars['String']>;
  /** Done-category column for completion. */
  doneColumnId?: InputMaybe<Scalars['UUID']>;
  /** Message to include in the signature envelope. */
  envelopeMsg?: InputMaybe<Scalars['String']>;
  /** Permission role controlling who can forward the workflow. */
  forwardingPermissionRole?: InputMaybe<PermissionRole>;
  /** Workflow name. */
  name?: InputMaybe<Scalars['String']>;
  /** Priority level. */
  priority?: InputMaybe<WorkflowPriority>;
  /** The CRMs this template is published to. Replaces the whole set. Template Workflows only. */
  publishedCrmIntegrations?: InputMaybe<Array<Integration>>;
  /** Skip Triage on launch (templates). */
  skipTriage?: InputMaybe<Scalars['Boolean']>;
};

/** Result of checking whether a workflow is ready to be sent for signature. */
export type WorkflowReadyForSignature = {
  __typename: 'WorkflowReadyForSignature';
  /** List of reasons preventing signature send, empty when ready is true. */
  notReadyReasons: Array<WorkflowNotReadyForSigReason>;
  /** True if the workflow can be sent for signature right now. */
  ready: Scalars['Boolean'];
};

/** A recipient action within a workflow step, tracking signing status and assignment. */
export type WorkflowRecipient = {
  __typename: 'WorkflowRecipient';
  /** The user assigned to this recipient action, if any. */
  assignee: Maybe<User>;
  /** The role assigned to this recipient action, if any. */
  assigneeRole: Maybe<UserDefinedRole>;
  /** When the recipient completed all actions. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** Created at - ISO 8601 */
  createdAt: Scalars['DateTime'];
  /** Recipient ID in the e-signature provider (e.g., DocuSign). */
  docuSignRecipientId: Maybe<Scalars['String']>;
  /** The signing envelope this recipient belongs to. */
  envelope: Maybe<Envelope>;
  /** Signature and form fields assigned to this recipient. */
  fields: Array<Field>;
  /** When the signing notification was first sent. */
  firstSentAt: Maybe<Scalars['DateTime']>;
  /** When the recipient first viewed the documents. */
  firstViewedAt: Maybe<Scalars['DateTime']>;
  /** Primary identifier for this recipient action. */
  id: Scalars['UUID'];
  /** When the most recent signing notification was sent. */
  lastSentAt: Maybe<Scalars['DateTime']>;
  /** When the recipient most recently viewed the documents. */
  lastViewedAt: Maybe<Scalars['DateTime']>;
  /** The workflow permission entry for this recipient's collaborator. */
  permission: WorkflowPermission;
  /**
   * Display name for this recipient. External recipients use OrgContact.name for the workflow
   * owner's org; recipients inside that org have no contact row, so their User name is used.
   */
  recipientName: Maybe<Scalars['String']>;
  /** Order in which this recipient signs (1-based). */
  routingOrder: Scalars['Int'];
  /** IP address from which the recipient signed, if available. */
  signingIpAddress: Maybe<Scalars['String']>;
  /** When the recipient started reviewing the documents. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** Current signing status of this recipient. */
  status: WorkflowRecipientStatus;
  /** Whether the recipient is a signer or carbon copy. */
  type: WorkflowRecipientType;
  /** Updated at - ISO 8601 */
  updatedAt: Scalars['DateTime'];
};

/** Signing status of a recipient, aligned with the e-signature provider lifecycle. */
export enum WorkflowRecipientStatus {
  /** Recipient failed identity authentication. */
  Authenticationfailed = 'AUTHENTICATIONFAILED',
  /** Recipient's email system auto-responded (bounced). Only used when send-on-behalf-of is disabled. */
  Autoresponded = 'AUTORESPONDED',
  /** Recipient has completed all required actions (signing, form fields, etc.). */
  Completed = 'COMPLETED',
  /** Recipient declined to sign the document(s). */
  Declined = 'DECLINED',
  /** Recipient has viewed the document(s) via the signing portal. */
  Delivered = 'DELIVERED',
  /** Recipient has been sent an email notification that it is their turn to sign. */
  Sent = 'SENT',
  /** Recipient is in a draft state (envelope has not been sent yet). */
  Unsent = 'UNSENT'
}

/** The role a recipient plays in the signing process. */
export enum WorkflowRecipientType {
  /** Recipient receives a copy of the signed documents but does not sign. */
  CarbonCopy = 'CARBON_COPY',
  /** Recipient must sign the document(s). */
  Signer = 'SIGNER'
}

/** Response for Workflow mutations */
export type WorkflowResponse = {
  __typename: 'WorkflowResponse';
  refetch: Query;
  /** Updated or created Workflow */
  workflow: Workflow;
};

/** Paginated list of workflows with metadata. */
export type WorkflowRowsInfo = {
  __typename: 'WorkflowRowsInfo';
  /** Root-level Measure aggregates over the filtered cohort (DataGrid aggregateRow). */
  aggregates: Maybe<WorkflowListAggregates>;
  /**
   * Number of immediate child rows at this grouping level (group headers or leaf
   * Workflows). Used by DataGrid Premium rowCount when grouping.
   */
  groupCount: Maybe<Scalars['Int']>;
  /**
   * Group headers for the current expansion level when groupFields is set.
   * Empty when not grouping, or when fully expanded to leaf Workflows.
   */
  groupHeaders: Array<WorkflowGroupHeader>;
  /** Aggregate metadata about the result set. */
  meta: WorkflowsMeta;
  /** The workflows matching the query (leaf rows when grouping is fully expanded). */
  rows: Array<Workflow>;
};

/** High-level lifecycle stage of a workflow, from template through completion. */
export enum WorkflowState {
  /** Post-signature work is finished; workflow is fully closed. */
  Complete = 'Complete',
  /** Active negotiation — documents are being reviewed and edited. */
  Negotiating = 'Negotiating',
  /** All pre-signature work is done; awaiting send for signature. */
  ReadyForSignature = 'ReadyForSignature',
  /** All parties have signed the documents. */
  Signed = 'Signed',
  /** Envelope has been sent and signatures are being collected. */
  Signing = 'Signing',
  /** Workflow is an unstarted template definition. */
  Template = 'Template'
}

export enum WorkflowStatus {
  /** All workflow steps are complete. */
  Completed = 'COMPLETED',
  /** Workflow is currently active. */
  Running = 'RUNNING',
  /** Workflow is a template, can't be run. */
  Template = 'TEMPLATE'
}

/** A workflow step. */
export type WorkflowStep = {
  __typename: 'WorkflowStep';
  /** All actions associated with this workflow step. */
  actions: Array<WorkflowRecipient>;
  /** DateTime that this step was completed, if completed. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** DateTime that this step was created */
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  /** Whether this step is completed. */
  isCompleted: Scalars['Boolean'];
  /** Phase this step belongs to (signing steps use the workflow signing phase). */
  phaseId: Scalars['UUID'];
  /** Actions for the requester in this workflow step. */
  requesterActions: Array<WorkflowRecipient>;
  /** Timestamp for when step was started */
  startedAt: Maybe<Scalars['DateTime']>;
};

/** Response for WorkflowStep mutations */
export type WorkflowStepResponse = {
  __typename: 'WorkflowStepResponse';
  /** Root query for refetching related data. */
  refetch: Query;
  /** The created or updated workflow step. */
  step: WorkflowStep;
};

/** A source template option for filtering workflows by workflow type. */
export type WorkflowTypeOption = {
  __typename: 'WorkflowTypeOption';
  id: Scalars['UUID'];
  label: Scalars['String'];
};

/** Distinguishes template definitions from active contract instances. */
export enum WorkflowVariant {
  /** An active workflow instance created from a template. */
  Contract = 'Contract',
  /** A reusable workflow blueprint used to launch contract instances. */
  Template = 'Template'
}

/** A named Workflow list View that may own Charts. */
export type WorkflowView = {
  __typename: 'WorkflowView';
  /** Author of the View. */
  author: User;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** Owning organization. */
  org: Org;
  /** Pins that reference Charts on this View. */
  pins: Array<InsightPin>;
  /** Whether this chart source also appears in the Workflows Saved Views picker. */
  showInSavedViews: Scalars['Boolean'];
  /** Chart-relevant grid state (filter, grouping, aggregation, chartsIntegration). */
  state: Scalars['JSON'];
  updatedAt: Scalars['DateTime'];
};

export type WorkflowViewPinInput = {
  chartId: Scalars['String'];
  layout: Scalars['JSON'];
  scope?: InputMaybe<InsightScope>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type WorkflowViewResponse = {
  __typename: 'WorkflowViewResponse';
  workflowView: Maybe<WorkflowView>;
};

/** Aggregate metadata for a workflow list query. */
export type WorkflowsMeta = {
  __typename: 'WorkflowsMeta';
  /** Whether there are more results beyond the current page. Use cursor-based pagination to fetch the next page. */
  hasMore: Scalars['Boolean'];
  /** Total number of workflows matching the filter. */
  totalCount: Scalars['Int'];
};

/** Real-time event emitted when workflows are created, updated, or deleted. */
export type WorkflowsUpdatedEvent = {
  __typename: 'WorkflowsUpdatedEvent';
  /**
   * IDs of the workflows that changed.
   * @deprecated Select workflows instead. Kept so sessions started before a deploy keep working.
   */
  workflowIds: Array<Scalars['UUID']>;
  /** Workflows that changed. */
  workflows: Array<Workflow>;
};

export type GetDocumentNameQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentNameQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string } };

export type ObservedSkillDraftFragment = { __typename: 'AgentSkill', id: string, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string }> } | null };

export type DisplayNameUpdateFragment = { __typename: 'DocumentMetadataImport', displayName: string };

export type UpdateGroupGlobalAccessMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupGlobalAccessMutation = { __typename: 'Mutation', updateGroup: { __typename: 'Group', id: string, canAccessAllDocAndWorkflows: boolean } };

export type GetChatDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetChatDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } };

export type GetThreadTitleQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetThreadTitleQuery = { __typename: 'Query', agentThread: { __typename: 'AgentThread', id: string, title: string } };

export type GetSuggestionDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetSuggestionDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string } };

export type SkillArtifactThreadForTestFragment = { __typename: 'AgentThread', id: string, artifacts: Array<{ __typename: 'ThreadDocumentArtifact' } | { __typename: 'ThreadReportArtifact' } | { __typename: 'ThreadSkillArtifact', agentMessageId: string, createdAt: string, kindList: Array<AgentMessageJoinKind>, skill: { __typename: 'AgentSkill', id: string, name: string, scope: AgentSkillScope, isComplete: boolean, currentVersion: { __typename: 'AgentSkillVersion', id: string, name: string, description: string } | null } } | { __typename: 'ThreadTaskArtifact' } | { __typename: 'ThreadWorkflowArtifact' }> };

export type SkillForSkillArtifactTestFragment = { __typename: 'AgentSkill', id: string, name: string, scope: AgentSkillScope, isComplete: boolean, currentVersion: { __typename: 'AgentSkillVersion', id: string, name: string, description: string } | null };

export type WorkflowArtifactThreadForTestFragment = { __typename: 'AgentThread', id: string, artifacts: Array<{ __typename: 'ThreadDocumentArtifact' } | { __typename: 'ThreadReportArtifact' } | { __typename: 'ThreadSkillArtifact' } | { __typename: 'ThreadTaskArtifact' } | { __typename: 'ThreadWorkflowArtifact', agentMessageId: string, createdAt: string, kindList: Array<AgentMessageJoinKind>, workflow: { __typename: 'Workflow', id: string, name: string } }> };

export type SeedAgentThreadForTestFragment = { __typename: 'AgentThread', id: string, artifacts: Array<{ __typename: 'ThreadDocumentArtifact', agentMessageId: string, createdAt: string, kindList: Array<AgentMessageJoinKind>, document: { __typename: 'Document', id: string, name: string, deletedAt: string | null } } | { __typename: 'ThreadReportArtifact' } | { __typename: 'ThreadSkillArtifact' } | { __typename: 'ThreadTaskArtifact' } | { __typename: 'ThreadWorkflowArtifact' }> };

export type ArtifactDocumentFieldsForTestFragment = { __typename: 'Document', id: string, name: string, deletedAt: string | null };

export type ArtifactDocumentFieldsFragment = { __typename: 'Document', id: string, name: string, deletedAt: string | null };

export type ArtifactReportFieldsFragment = { __typename: 'Report', id: string, name: string };

export type AgentThreadIdProbeFragment = { __typename: 'AgentThread', id: string };

export type ArtifactSkillFieldsFragment = { __typename: 'AgentSkill', id: string, name: string, scope: AgentSkillScope, isComplete: boolean, currentVersion: { __typename: 'AgentSkillVersion', id: string, name: string, description: string } | null };

export type ArtifactWorkflowFieldsFragment = { __typename: 'Workflow', id: string, name: string };

export type AlineChatAdapterMessageDataFragment = { __typename: 'AgentMessage', id: string, data: { [key: string]: any } };

export type AgentMessageFieldsFragment = { __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, feedback: AgentMessageFeedback | null, planState: { [key: string]: any } | null, createdAt: string };

export type StreamingAgentMessageFieldsFragment = { __typename: 'AgentMessage', id: string, status: AgentMessageStatus, text: string };

export type StreamingMessageDataFragment = { __typename: 'AgentMessage', id: string, data: { [key: string]: any } };

export type StreamingMessagePlanStateFragment = { __typename: 'AgentMessage', id: string, planState: { [key: string]: any } | null };

export type ThreadTitleFragment = { __typename: 'AgentThread', id: string, title: string };

export type GetWorkflowWithCategoriesQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowWithCategoriesQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, description: string, name: string, communityCategories: Array<{ __typename: 'CommunityCategory', id: string, description: string, emoji: string, title: string }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null };

export type UpdateDocumentForwardingMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentForwardingMutation = { __typename: 'Mutation', updateDocumentProps: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string, forwardingPermissionRole: PermissionRole | null } | null } };

export type SelectedPartyFragment = { __typename: 'Party', id: string, name: string };

export type NewDocumentFragment = { __typename: 'Document', id: string };

export type GetWorkflowMessageQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowMessageQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, envelopeMsg: string | null } | null };

export type UpdateReminderTitleMutationVariables = Exact<{
  input: UpdateReminderInput;
}>;


export type UpdateReminderTitleMutation = { __typename: 'Mutation', updateReminder: { __typename: 'Reminder', id: string, title: string } };

export type UpdateReminderDescriptionMutationVariables = Exact<{
  input: UpdateReminderInput;
}>;


export type UpdateReminderDescriptionMutation = { __typename: 'Mutation', updateReminder: { __typename: 'Reminder', id: string, description: string } };

export type UpdateReminderDueDateMutationVariables = Exact<{
  input: UpdateReminderInput;
}>;


export type UpdateReminderDueDateMutation = { __typename: 'Mutation', updateReminder: { __typename: 'Reminder', id: string, dueDate: string } };

export type UpdateReminderTypeMutationVariables = Exact<{
  input: UpdateReminderInput;
}>;


export type UpdateReminderTypeMutation = { __typename: 'Mutation', updateReminder: { __typename: 'Reminder', id: string, type: ReminderType } };

export type UpdateReminderNotificationOffsetsMutationVariables = Exact<{
  input: UpdateReminderInput;
}>;


export type UpdateReminderNotificationOffsetsMutation = { __typename: 'Mutation', updateReminder: { __typename: 'Reminder', id: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }> } };

export type GetReportToRestoreQueryVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type GetReportToRestoreQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, name: string, state: { [key: string]: any }, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string, isGroupable: boolean } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField, dataType: ReportColumnDataType, isGroupable: boolean }> } | null };

export type UpdateQuestionTypeMutationVariables = Exact<{
  input: UpdateExtractionQuestionInput;
}>;


export type UpdateQuestionTypeMutation = { __typename: 'Mutation', updateExtractionQuestion: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, type: ExtractionQuestionType } };

export type UpdateQuestionModeMutationVariables = Exact<{
  input: UpdateExtractionQuestionInput;
}>;


export type UpdateQuestionModeMutation = { __typename: 'Mutation', updateExtractionQuestion: { __typename: 'ExtractionQuestion', id: string, mode: ExtractionQuestionMode } };

export type GetReportNameQueryVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type GetReportNameQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, name: string } | null };

export type RelationshipReviewStatusFragment = { __typename: 'DocumentRelationship', id: string, childRelationshipType: ChildRelationshipType, childDocumentId: string | null, parentDocumentId: string | null, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null };

export type CurrentFileVersionFragment = { __typename: 'StaticFileVersion', id: string, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string } | null };

export type UpdateWorkflowAssigneeMutationVariables = Exact<{
  input: UpdateWorkflowPermissionInput;
}>;


export type UpdateWorkflowAssigneeMutation = { __typename: 'Mutation', updateWorkflowPermission: { __typename: 'WorkflowPermission', id: string, isAssignee: boolean } };

export type MoveWorkflowToColumnMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type MoveWorkflowToColumnMutation = { __typename: 'Mutation', updateWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, column: { __typename: 'Column', id: string, category: ColumnCategory, color: string, name: string } } } };

export type UpdateWorkflowLaunchAutomaticS4SConfigMutationVariables = Exact<{
  input: UpdateWorkflowLaunchConfigInput;
}>;


export type UpdateWorkflowLaunchAutomaticS4SConfigMutation = { __typename: 'Mutation', updateWorkflowLaunchConfig: { __typename: 'WorkflowLaunchConfig', id: string, isAutomaticS4SEnabled: boolean } };

export type GetWorkflowWithOwnerQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowWithOwnerQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, owner: { __typename: 'User', id: string } } | null };

export type UpdateWorkflowForwardingMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type UpdateWorkflowForwardingMutation = { __typename: 'Mutation', updateWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, forwardingPermissionRole: PermissionRole | null } } };

export type GetWorkflowHeaderQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowHeaderQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', aiCancelledAt: string | null, aiFailedAt: string | null, aiFinishedAt: string | null, aiStartedAt: string | null, id: string, name: string, state: WorkflowState, startedAt: string | null, publishedAt: string | null, variant: WorkflowVariant, priority: WorkflowPriority | null, skipTriage: boolean, crmIntegrations: Array<Integration>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, board: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string } }, doneColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, phases: Array<{ __typename: 'NonSigningPhase', id: string, name: string, order: number, startedAt: string | null, completedAt: string | null, column: { __typename: 'Column', id: string } } | { __typename: 'SigningPhase', id: string, name: string, order: number, startedAt: string | null, completedAt: string | null, column: { __typename: 'Column', id: string } }> } | null };

export type UpdateWorkflowNameMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type UpdateWorkflowNameMutation = { __typename: 'Mutation', updateWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, name: string } } };

export type UpdatePhaseTitleMutationVariables = Exact<{
  input: UpdatePhaseInput;
}>;


export type UpdatePhaseTitleMutation = { __typename: 'Mutation', updatePhase: { __typename: 'PhaseResponse', phase: { __typename: 'NonSigningPhase', id: string, name: string } | { __typename: 'SigningPhase', id: string, name: string } } };

export type UpdateTaskTitleMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskTitleMutation = { __typename: 'Mutation', updateTask: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, title: string } } };

export type GetRequesterDocumentAccessQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetRequesterDocumentAccessQuery = { __typename: 'Query', document: { __typename: 'Document', id: string } };

export type UpdateExtractionJobAnswerMutationVariables = Exact<{
  input: UpdateExtractionJobInput;
}>;


export type UpdateExtractionJobAnswerMutation = { __typename: 'Mutation', updateExtractionJob: { __typename: 'ExtractionJob', id: string, answer: string, reasoning: string | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }> } };

export type UpdateExtractionJobSelectedOptionsMutationVariables = Exact<{
  input: UpdateExtractionJobInput;
}>;


export type UpdateExtractionJobSelectedOptionsMutation = { __typename: 'Mutation', updateExtractionJob: { __typename: 'ExtractionJob', id: string, reasoning: string | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, label: string }> } };

export type GetOcrDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetOcrDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string, vectorsFailedAt: string | null, vectorsSavedAt: string | null, vectorsStartedAt: string | null } | { __typename: 'StaticFileVersion', id: string, vectorsFailedAt: string | null, vectorsSavedAt: string | null, vectorsStartedAt: string | null, fileExtractionFailedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionStartedAt: string | null, fileLocation: { __typename: 'DocFile', id: string, mimetype: string } } } };

export type TestWorkflowChartSeriesCacheQueryVariables = Exact<{
  input: WorkflowChartSeriesInput;
}>;


export type TestWorkflowChartSeriesCacheQuery = { __typename: 'Query', workflowChartSeries: { __typename: 'WorkflowChartSeries', dimensions: Array<{ __typename: 'WorkflowChartDimensionSeries', id: string, label: string, data: Array<string>, keys: Array<string> }>, values: Array<{ __typename: 'WorkflowChartValueSeries', id: string, label: string, data: Array<number | null> }>, primaryCatalog: Array<{ __typename: 'WorkflowChartCategory', id: string, label: string, value: number, count: number }>, secondaryCatalog: Array<{ __typename: 'WorkflowChartCategory', id: string, label: string, value: number, count: number }>, totals: { __typename: 'WorkflowChartTotalSeries', data: Array<number | null>, counts: Array<number> } } };

export type NewAutomationFragment = { __typename: 'AIReminderAutomation', id: string };

export type ReportForTestQueryVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type ReportForTestQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, name: string } | null };

export type NewAnswerOptionsFragment = { __typename: 'AnswerOptions', id: string, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, optionText: string, triggerAction: TriggerAction }> };

export type NewBoardFragment = { __typename: 'Board', id: string };

export type NewCommentFragment = { __typename: 'Comment', id: string };

export type NewReplyFragment = { __typename: 'Comment', id: string };

export type NewContractTypeFragment = { __typename: 'ContractType', id: string };

export type UpdateDocumentFragment = { __typename: 'Document', id: string };

export type NewJobFragment = { __typename: 'ExtractionJob', id: string };

export type NewPlaybookFragment = { __typename: 'Playbook', id: string };

export type CreateDocumentFragment = { __typename: 'Document', id: string };

export type DuplicateTemplateFragment = { __typename: 'Document', id: string };

export type CopyDocumentFragment = { __typename: 'Document', id: string };

export type ReportColumnOptionsForTestFragment = { __typename: 'Report', id: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string, isGroupable: boolean } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField, dataType: ReportColumnDataType, isGroupable: boolean }> };

export type RootExtractionQuestionsForTestQueryVariables = Exact<{ [key: string]: never; }>;


export type RootExtractionQuestionsForTestQuery = { __typename: 'Query', extractionQuestions: Array<{ __typename: 'ExtractionQuestion', id: string }> };

export type NewExtractionJobFragment = { __typename: 'ExtractionJob', id: string };

export type NewExtractionQuestionGenerationJobFragment = { __typename: 'ExtractionQuestionGenerationJob', id: string };

export type NewQuestionOptionFragment = { __typename: 'QuestionOption', id: string };

export type NewExtractionQuestionFragment = { __typename: 'ExtractionQuestion', id: string };

export type NewSignatureFragment = { __typename: 'SignatureField', id: string };

export type NewVersion_DocumentVersion_Fragment = { __typename: 'DocumentVersion', id: string };

export type NewVersion_StaticFileVersion_Fragment = { __typename: 'StaticFileVersion', id: string };

export type NewVersionFragment = NewVersion_DocumentVersion_Fragment | NewVersion_StaticFileVersion_Fragment;

export type NewSignedVersion_DocumentVersion_Fragment = { __typename: 'DocumentVersion', id: string };

export type NewSignedVersion_StaticFileVersion_Fragment = { __typename: 'StaticFileVersion', id: string };

export type NewSignedVersionFragment = NewSignedVersion_DocumentVersion_Fragment | NewSignedVersion_StaticFileVersion_Fragment;

export type CreateFilesFragment = { __typename: 'Document', id: string };

export type NewFolderSyncJobFragment = { __typename: 'FolderSyncJob', id: string };

export type NewGroupFragment = { __typename: 'Group', id: string };

export type NewUserFragment = { __typename: 'User', id: string };

export type NewLabelFragment = { __typename: 'Label', id: string };

export type NewMemberFragment = { __typename: 'User', id: string };

export type NewPartyFragment = { __typename: 'Party', id: string };

export type GetWorkflowDocumentsBasicQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowDocumentsBasicQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, isCertificate: boolean } }> } | null };

export type NewPhase_NonSigningPhase_Fragment = { __typename: 'NonSigningPhase', id: string };

export type NewPhase_SigningPhase_Fragment = { __typename: 'SigningPhase', id: string };

export type NewPhaseFragment = NewPhase_NonSigningPhase_Fragment | NewPhase_SigningPhase_Fragment;

export type PhaseSigningFlag_NonSigningPhase_Fragment = { __typename: 'NonSigningPhase', id: string };

export type PhaseSigningFlag_SigningPhase_Fragment = { __typename: 'SigningPhase', id: string };

export type PhaseSigningFlagFragment = PhaseSigningFlag_NonSigningPhase_Fragment | PhaseSigningFlag_SigningPhase_Fragment;

export type PhaseRef_NonSigningPhase_Fragment = { __typename: 'NonSigningPhase', id: string };

export type PhaseRef_SigningPhase_Fragment = { __typename: 'SigningPhase', id: string };

export type PhaseRefFragment = PhaseRef_NonSigningPhase_Fragment | PhaseRef_SigningPhase_Fragment;

export type ReminderIdentityFragment = { __typename: 'Reminder', id: string, reviewStatus: ReminderReviewStatus };

export type GetPendingReviewCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingReviewCountQuery = { __typename: 'Query', reminders: { __typename: 'ReminderRowsResponse', meta: { __typename: 'ReminderMeta', pendingReviewCount: number } } };

export type NewReminderFragment = { __typename: 'Reminder', id: string, completedAt: string | null, reviewStatus: ReminderReviewStatus };

export type NewReportFragment = { __typename: 'Report', id: string, name: string, createdAt: string };

export type NewRoleFragment = { __typename: 'UserDefinedRole', id: string };

export type NewPermissionFragment = { __typename: 'StorablePermission', id: string };

export type NewTaskFragment = { __typename: 'Task', id: string };

export type NewTaskPermissionFragment = { __typename: 'WorkflowPermission', id: string };

export type NewVariableFragment = { __typename: 'DocumentVariable', id: string };

export type NewWorkflowPermissionFragment = { __typename: 'WorkflowPermission', id: string };

export type GetWorkflowNameQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowNameQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, name: string } | null };

export type NewWorkflowFragment = { __typename: 'Workflow', id: string };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['UUID'];
  accountType: AccountType;
}>;


export type GetAccountQuery = { __typename: 'Query', account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null };

export type GetAccountsByQueryVariables = Exact<{
  input: AccountsByInput;
}>;


export type GetAccountsByQuery = { __typename: 'Query', accounts: { __typename: 'Accounts', users: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, orgs: Array<{ __typename: 'Org', id: string, accountType: AccountType, avatarColor: string, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } };

export type AccountBase_Org_Fragment = { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> };

export type AccountBase_User_Fragment = { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } };

export type AccountBaseFragment = AccountBase_Org_Fragment | AccountBase_User_Fragment;

export type GetMyAlineSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAlineSubscriptionQuery = { __typename: 'Query', currentUser: { __typename: 'User', id: string, org: { __typename: 'Org', id: string, trialStartedAt: string, trialEndAt: string, alineSubscription: { __typename: 'AlineSubscription', id: string, status: SubscriptionStatus, numFullSeats: number, numBasicSeats: number, tier: SubscriptionTier, subscriptionStartedAt: string, subscriptionEndsAt: string, salesbricksSubscriptionId: string, openOrders: Array<{ __typename: 'OpenOrder', id: string, stage: string }>, pastDueInvoices: Array<{ __typename: 'PastDueInvoice', id: string, invoiceNumber: string, dueAt: string }> } | null } } | null };

export type CreateBillingSessionUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateBillingSessionUrlMutation = { __typename: 'Mutation', createBillingSessionUrl: string };

export type CreateCheckoutUrlMutationVariables = Exact<{
  input: CreateCheckoutUrlInput;
}>;


export type CreateCheckoutUrlMutation = { __typename: 'Mutation', createCheckoutUrl: string };

export type CreateCloseOrderUrlMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type CreateCloseOrderUrlMutation = { __typename: 'Mutation', createCloseOrderUrl: string };

export type ComputeCheckoutEstimateQueryVariables = Exact<{
  input: CreateCheckoutUrlInput;
}>;


export type ComputeCheckoutEstimateQuery = { __typename: 'Query', computeCheckoutEstimate: { __typename: 'CheckoutEstimate', basicSeatUnitCost: number, fullSeatUnitCost: number, basicSeatTotal: number, fullSeatTotal: number, total: number } };

export type AlineSubscriptionSimpleFragment = { __typename: 'AlineSubscription', id: string, status: SubscriptionStatus, numFullSeats: number, numBasicSeats: number, tier: SubscriptionTier, subscriptionStartedAt: string, subscriptionEndsAt: string, salesbricksSubscriptionId: string, openOrders: Array<{ __typename: 'OpenOrder', id: string, stage: string }>, pastDueInvoices: Array<{ __typename: 'PastDueInvoice', id: string, invoiceNumber: string, dueAt: string }> };

export type GetDocumentGroupPermissionsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentGroupPermissionsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, requesterInOwnerOrg: boolean, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, groups: Array<{ __typename: 'Group', id: string, avatarColor: string, name: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> }> } };

export type SetGroupPermissionsMutationVariables = Exact<{
  input: SetGroupPermissionsInput;
}>;


export type SetGroupPermissionsMutation = { __typename: 'Mutation', setGroupPermissions: { __typename: 'Group', id: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type DeleteGroupPermissionMutationVariables = Exact<{
  groupId: Scalars['UUID'];
  labelId: Scalars['UUID'];
}>;


export type DeleteGroupPermissionMutation = { __typename: 'Mutation', deleteGroupPermission: { __typename: 'Group', id: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type GetGroupWithUsersQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetGroupWithUsersQuery = { __typename: 'Query', group: { __typename: 'Group', id: string, avatarColor: string, name: string, createdAt: string, updatedAt: string, users: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } };

export type GetGroupPermissionsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetGroupPermissionsQuery = { __typename: 'Query', group: { __typename: 'Group', id: string, avatarColor: string, name: string, canAccessAllDocAndWorkflows: boolean, createdAt: string, updatedAt: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type GetGroupQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetGroupQuery = { __typename: 'Query', group: { __typename: 'Group', id: string, avatarColor: string, name: string, canAccessAllDocAndWorkflows: boolean, createdAt: string, updatedAt: string } };

export type GetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = { __typename: 'Query', groups: Array<{ __typename: 'Group', id: string, avatarColor: string, name: string, userCount: number, canAccessAllDocAndWorkflows: boolean, createdAt: string, updatedAt: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> }> };

export type AddUsersToGroupMutationVariables = Exact<{
  input: AddUsersToGroupInput;
}>;


export type AddUsersToGroupMutation = { __typename: 'Mutation', addUsersToGroup: { __typename: 'Group', id: string, avatarColor: string, name: string, createdAt: string, updatedAt: string, users: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename: 'Mutation', createGroup: { __typename: 'Group', id: string, avatarColor: string, name: string, createdAt: string, updatedAt: string, users: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteGroupMutation = { __typename: 'Mutation', deleteGroup: string };

export type RemoveUsersFromGroupMutationVariables = Exact<{
  input: RemoveUsersFromGroupInput;
}>;


export type RemoveUsersFromGroupMutation = { __typename: 'Mutation', removeUsersFromGroup: { __typename: 'Group', id: string, avatarColor: string, name: string, createdAt: string, updatedAt: string, users: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename: 'Mutation', updateGroup: { __typename: 'Group', id: string, name: string, canAccessAllDocAndWorkflows: boolean } };

export type GroupSimpleFragment = { __typename: 'Group', id: string, avatarColor: string, name: string, canAccessAllDocAndWorkflows: boolean, createdAt: string, updatedAt: string };

export type GroupWithUsersFragment = { __typename: 'Group', id: string, avatarColor: string, name: string, createdAt: string, updatedAt: string, users: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> };

export type UpdateOnboardingTaskMutationVariables = Exact<{
  input: UpdateOnboardingTaskInput;
}>;


export type UpdateOnboardingTaskMutation = { __typename: 'Mutation', updateOnboardingTask: { __typename: 'OnboardingTaskResponse', onboardingTask: { __typename: 'OnboardingTask', id: string, action: OnboardingTaskAction, completedAt: string | null, skipped: boolean } } };

export type ImportExampleNdaResourcesMutationVariables = Exact<{ [key: string]: never; }>;


export type ImportExampleNdaResourcesMutation = { __typename: 'Mutation', importExampleNDAResources: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, exampleNDA: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string } | null } | null, exampleNDAPlaybook: { __typename: 'Playbook', id: string } | null, signatureImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, signatureInitialsImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, exampleReport: { __typename: 'Report', id: string } | null } };

export type CreateExampleReportMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateExampleReportMutation = { __typename: 'Mutation', createExampleReport: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, exampleNDA: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string } | null } | null, exampleNDAPlaybook: { __typename: 'Playbook', id: string } | null, signatureImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, signatureInitialsImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, exampleReport: { __typename: 'Report', id: string } | null } };

export type OnboardingTaskSimpleFragment = { __typename: 'OnboardingTask', id: string, action: OnboardingTaskAction, completedAt: string | null, skipped: boolean };

export type GetOrgQueryVariables = Exact<{
  orgId: Scalars['UUID'];
}>;


export type GetOrgQuery = { __typename: 'Query', org: { __typename: 'Org', id: string, accountType: AccountType, avatarColor: string, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | null };

export type GetOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgsQuery = { __typename: 'Query', orgs: Array<{ __typename: 'Org', id: string, accountType: AccountType, avatarColor: string, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> };

export type OrgNameUniqueQueryVariables = Exact<{
  input: OrgNameUniqueInput;
}>;


export type OrgNameUniqueQuery = { __typename: 'Query', orgNameUnique: { __typename: 'OrgUniqueResponse', unique: boolean } };

export type UpdateOrgMutationVariables = Exact<{
  input: UpdateOrg;
}>;


export type UpdateOrgMutation = { __typename: 'Mutation', updateOrg: { __typename: 'OrgResponse', org: { __typename: 'Org', id: string, accountType: AccountType, avatarColor: string, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type CreateOrgMutationVariables = Exact<{
  input: NewOrgInput;
}>;


export type CreateOrgMutation = { __typename: 'Mutation', createOrg: { __typename: 'OrgResponse', org: { __typename: 'Org', id: string, accountType: AccountType, avatarColor: string, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type AddOrgMemberMutationVariables = Exact<{
  input: UpdateOrgMembership;
}>;


export type AddOrgMemberMutation = { __typename: 'Mutation', addOrgMember: { __typename: 'UserResponse', user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } };

export type DeleteOrgMutationVariables = Exact<{
  orgId: Scalars['UUID'];
}>;


export type DeleteOrgMutation = { __typename: 'Mutation', deleteOrg: { __typename: 'OrgResponse', org: { __typename: 'Org', id: string, accountType: AccountType, avatarColor: string, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type ResendOrgInviteMutationVariables = Exact<{
  input: ResendOrgInvite;
}>;


export type ResendOrgInviteMutation = { __typename: 'Mutation', resendOrgInvite: { __typename: 'OrgResponse', org: { __typename: 'Org', id: string, accountType: AccountType, avatarColor: string, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type UpsertOrgAvatarImgMutationVariables = Exact<{
  input: FileLocationProps;
}>;


export type UpsertOrgAvatarImgMutation = { __typename: 'Mutation', upsertOrgAvatarImg: { __typename: 'OrgResponse', org: { __typename: 'Org', id: string, avatarImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null } } };

export type OrgBaseFragment = { __typename: 'Org', id: string, accountType: AccountType, avatarColor: string, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> };

export type GetUpgradeRequestsQueryVariables = Exact<{
  status?: InputMaybe<UpgradeRequestStatus>;
}>;


export type GetUpgradeRequestsQuery = { __typename: 'Query', upgradeRequests: Array<{ __typename: 'UpgradeRequest', id: string, requestedRole: OrgRole, message: string | null, status: UpgradeRequestStatus, respondedAt: string | null, responseMessage: string | null, createdAt: string, requester: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, org: { __typename: 'Org', id: string, name: string }, respondedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> };

export type RequestUpgradeMutationVariables = Exact<{
  input: RequestUpgradeInput;
}>;


export type RequestUpgradeMutation = { __typename: 'Mutation', requestUpgrade: { __typename: 'UpgradeRequest', id: string, requestedRole: OrgRole, message: string | null, status: UpgradeRequestStatus, respondedAt: string | null, responseMessage: string | null, createdAt: string, requester: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, org: { __typename: 'Org', id: string, name: string }, respondedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } };

export type CancelUpgradeRequestMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CancelUpgradeRequestMutation = { __typename: 'Mutation', cancelUpgradeRequest: { __typename: 'UpgradeRequest', id: string, requestedRole: OrgRole, message: string | null, status: UpgradeRequestStatus, respondedAt: string | null, responseMessage: string | null, createdAt: string, requester: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, org: { __typename: 'Org', id: string, name: string }, respondedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } };

export type RespondToUpgradeRequestMutationVariables = Exact<{
  input: RespondToUpgradeRequestInput;
}>;


export type RespondToUpgradeRequestMutation = { __typename: 'Mutation', respondToUpgradeRequest: { __typename: 'UpgradeRequest', id: string, requestedRole: OrgRole, message: string | null, status: UpgradeRequestStatus, respondedAt: string | null, responseMessage: string | null, createdAt: string, requester: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, org: { __typename: 'Org', id: string, name: string }, respondedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } };

export type UpgradeRequestBaseFragment = { __typename: 'UpgradeRequest', id: string, requestedRole: OrgRole, message: string | null, status: UpgradeRequestStatus, respondedAt: string | null, responseMessage: string | null, createdAt: string, requester: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, org: { __typename: 'Org', id: string, name: string }, respondedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null };

export type UpdateUserSettingsPropsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsPropsMutation = { __typename: 'Mutation', updateUserSettings: { __typename: 'UserSettingsResponse', settings: { __typename: 'UserSettings', id: string, hideOnboarding: boolean } } };

export type UpsertUserSignaturesMutationVariables = Exact<{
  input: UpsertUserSignaturesInput;
}>;


export type UpsertUserSignaturesMutation = { __typename: 'Mutation', upsertUserSignatures: { __typename: 'UserSettingsResponse', settings: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, exampleNDA: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string } | null } | null, exampleNDAPlaybook: { __typename: 'Playbook', id: string } | null, signatureImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, signatureInitialsImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, exampleReport: { __typename: 'Report', id: string } | null } } };

export type UserSettingsSimpleFragment = { __typename: 'UserSettings', id: string, hideOnboarding: boolean, exampleNDA: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string } | null } | null, exampleNDAPlaybook: { __typename: 'Playbook', id: string } | null, signatureImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, signatureInitialsImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, exampleReport: { __typename: 'Report', id: string } | null };

export type UserOnboardingInfoFragment = { __typename: 'UserSettings', id: string, hideOnboarding: boolean, onboardingTasks: Array<{ __typename: 'OnboardingTask', id: string, action: OnboardingTaskAction, completedAt: string | null, skipped: boolean }> };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type GetUserQuery = { __typename: 'Query', user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null };

export type GetDocumentUserQueryVariables = Exact<{
  input: DocumentUserInput;
}>;


export type GetDocumentUserQuery = { __typename: 'Query', documentUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null };

export type GetMyOnboardingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOnboardingInfoQuery = { __typename: 'Query', currentUser: { __typename: 'User', id: string, settings: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, onboardingTasks: Array<{ __typename: 'OnboardingTask', id: string, action: OnboardingTaskAction, completedAt: string | null, skipped: boolean }> } } | null };

export type GetMyRecentDocumentsQueryVariables = Exact<{
  docVariant?: InputMaybe<DocumentVariant>;
}>;


export type GetMyRecentDocumentsQuery = { __typename: 'Query', currentUser: { __typename: 'User', id: string, myRecentDocuments: Array<{ __typename: 'Document', id: string, createdAt: string, lastAccessedByRequesterAt: string | null, name: string, variant: DocumentVariant, status: DocumentStatus | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } }> } | null };

export type GetFullUserQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type GetFullUserQuery = { __typename: 'Query', user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, myRepositoryId: string, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, deletedAt: string | null, org: { __typename: 'Org', avatarColor: string, id: string, name: string }, settings: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, exampleNDA: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string } | null } | null, exampleNDAPlaybook: { __typename: 'Playbook', id: string } | null, signatureImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, signatureInitialsImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, exampleReport: { __typename: 'Report', id: string } | null } } | null };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename: 'Query', users: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename: 'Query', currentUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, loginType: LoginType, myRepositoryId: string, role: OrgRole, supportRole: SupportRole | null, createdAt: string, updatedAt: string, deletedAt: string | null, isDeactivated: boolean, aiUsage: { __typename: 'AiUsage', usedTokens: number, totalAvailableTokens: number, usedMicrodollars: number, includedMicrodollars: number, totalTokensUsed: number, resetsAt: string }, org: { __typename: 'Org', avatarColor: string, parentChildEnabled: boolean, id: string, name: string, workosOrgId: string | null, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, trialStartedAt: string, trialEndAt: string, alineSubscription: { __typename: 'AlineSubscription', id: string, status: SubscriptionStatus, numFullSeats: number, numBasicSeats: number, tier: SubscriptionTier, subscriptionStartedAt: string, subscriptionEndsAt: string, salesbricksSubscriptionId: string, openOrders: Array<{ __typename: 'OpenOrder', id: string, stage: string }>, pastDueInvoices: Array<{ __typename: 'PastDueInvoice', id: string, invoiceNumber: string, dueAt: string }> } | null, avatarImg: { __typename: 'DocFile', filestackUrl: string } | null, defaultBoard: { __typename: 'Board', id: string } | null }, settings: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, exampleNDA: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string } | null } | null, exampleNDAPlaybook: { __typename: 'Playbook', id: string } | null, signatureImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, signatureInitialsImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, exampleReport: { __typename: 'Report', id: string } | null } } | null };

export type GetCurrentUserOnboardingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserOnboardingInfoQuery = { __typename: 'Query', currentUser: { __typename: 'User', id: string, settings: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, onboardingTasks: Array<{ __typename: 'OnboardingTask', id: string, action: OnboardingTaskAction, completedAt: string | null, skipped: boolean }> } } | null };

export type GetMyOrgMembersQueryVariables = Exact<{
  filter: OrgMemberFilter;
}>;


export type GetMyOrgMembersQuery = { __typename: 'Query', currentUser: { __typename: 'User', id: string, accountStatus: AccountStatus, avatarColor: string, displayName: string, email: string, firstName: string | null, jobTitle: string | null, lastName: string | null, role: OrgRole, isDeactivated: boolean, createdAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, avatarColor: string, name: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, contacts: Array<{ __typename: 'OrgContact', name: string | null, user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } } | null };

export type GetUserAccessLevelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccessLevelQuery = { __typename: 'Query', currentUser: { __typename: 'User', id: string, numWorkflowsCreatedThisMonth: number, org: { __typename: 'Org', id: string, trialStartedAt: string, trialEndAt: string, alineSubscription: { __typename: 'AlineSubscription', id: string, status: SubscriptionStatus, numFullSeats: number, numBasicSeats: number, tier: SubscriptionTier, subscriptionStartedAt: string, subscriptionEndsAt: string, salesbricksSubscriptionId: string, openOrders: Array<{ __typename: 'OpenOrder', id: string, stage: string }>, pastDueInvoices: Array<{ __typename: 'PastDueInvoice', id: string, invoiceNumber: string, dueAt: string }> } | null } } | null };

export type GetLoginTypeQueryVariables = Exact<{
  email: Scalars['EmailAddress'];
}>;


export type GetLoginTypeQuery = { __typename: 'Query', loginTypeByEmail: LoginType };

export type AdminAiUsageQueryVariables = Exact<{
  input: AdminAiUsageInput;
}>;


export type AdminAiUsageQuery = { __typename: 'Query', adminAiUsage: { __typename: 'AdminAiUsage', summary: { __typename: 'AdminAiUsageSummary', inputTokensUsed: number, outputTokensUsed: number, totalTokensUsed: number, totalCostMicrodollars: number, includedMicrodollars: number }, series: Array<{ __typename: 'AdminAiUsageSeriesPoint', bucketStartDate: string, groupKey: string, groupLabel: string, inputTokensUsed: number, outputTokensUsed: number, totalTokensUsed: number, totalCostMicrodollars: number }>, dimensionOptions: { __typename: 'AdminAiUsageDimensionOptions', modelKeys: Array<string>, sources: Array<AiUsageSource>, users: Array<{ __typename: 'AdminAiUsageUserOption', id: string, label: string }> } } };

export type AdminAiUsageDetailRowsQueryVariables = Exact<{
  input: AdminAiUsageDetailRowsInput;
}>;


export type AdminAiUsageDetailRowsQuery = { __typename: 'Query', adminAiUsageDetailRows: { __typename: 'AdminAiUsageDetailRows', totalCount: number, rows: Array<{ __typename: 'AdminAiUsageDetailRow', id: string, createdAt: string, modelKey: string, source: AiUsageSource, inputTokensUsed: number, outputTokensUsed: number, totalTokensUsed: number, totalCostMicrodollars: number, user: { __typename: 'User', id: string, displayName: string, email: string } }> } };

export type AddToRecentlyAccessedDocumentsMutationVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type AddToRecentlyAccessedDocumentsMutation = { __typename: 'Mutation', addToRecentlyAccessedDocuments: { __typename: 'UserResponse', user: { __typename: 'User', id: string, myRecentDocuments: Array<{ __typename: 'Document', id: string, createdAt: string, lastAccessedByRequesterAt: string | null, name: string, variant: DocumentVariant, status: DocumentStatus | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } }> } | null } };

export type CreateUserMutationVariables = Exact<{
  userProps: NewUser;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createUser: { __typename: 'UserResponse', user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, myRepositoryId: string, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, deletedAt: string | null, org: { __typename: 'Org', avatarColor: string, id: string, name: string }, settings: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, exampleNDA: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string } | null } | null, exampleNDAPlaybook: { __typename: 'Playbook', id: string } | null, signatureImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, signatureInitialsImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, exampleReport: { __typename: 'Report', id: string } | null } } | null } };

export type DeleteUsersMutationVariables = Exact<{
  userIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type DeleteUsersMutation = { __typename: 'Mutation', deleteUsers: { __typename: 'UsersResponse', users: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  userProps: UpdateUser;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateUser: { __typename: 'UserResponse', user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } };

export type UpdateUserActivationMutationVariables = Exact<{
  userId: Scalars['UUID'];
  isDeactivated: Scalars['Boolean'];
}>;


export type UpdateUserActivationMutation = { __typename: 'Mutation', updateUserActivation: { __typename: 'UserResponse', user: { __typename: 'User', id: string, isDeactivated: boolean } | null } };

export type RequestAccountActivationMutationVariables = Exact<{
  msg?: InputMaybe<Scalars['String']>;
}>;


export type RequestAccountActivationMutation = { __typename: 'Mutation', requestAccountActivation: boolean };

export type MinimalUserFragment = { __typename: 'User', id: string, displayName: string };

export type UserBaseFragment = { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } };

export type UserFullFragment = { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, myRepositoryId: string, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, deletedAt: string | null, org: { __typename: 'Org', avatarColor: string, id: string, name: string }, settings: { __typename: 'UserSettings', id: string, hideOnboarding: boolean, exampleNDA: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string } | null } | null, exampleNDAPlaybook: { __typename: 'Playbook', id: string } | null, signatureImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, signatureInitialsImg: { __typename: 'DocFile', id: string, filestackUrl: string } | null, exampleReport: { __typename: 'Report', id: string } | null } };

export type AssigneeSimpleFragment = { __typename: 'User', id: string, avatarColor: string, displayName: string, email: string, firstName: string | null, lastName: string | null, org: { __typename: 'Org', id: string } };

export type UserWithRecentDocumentsFragment = { __typename: 'User', id: string, myRecentDocuments: Array<{ __typename: 'Document', id: string, createdAt: string, lastAccessedByRequesterAt: string | null, name: string, variant: DocumentVariant, status: DocumentStatus | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } }> };

export type WithRecentDocumentsFragment = { __typename: 'Document', id: string, createdAt: string, lastAccessedByRequesterAt: string | null, name: string, variant: DocumentVariant, status: DocumentStatus | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } };

export type ActivityItemFieldsFragment = { __typename: 'ActivityItem', id: string, itemType: ActivityItemType, sourceType: ActivitySourceType, audience: ActivityAudience, createdAt: string, channelThread: { __typename: 'ChannelThread', id: string, provider: ChannelProvider, externalChannelId: string, externalThreadId: string, webUrl: string | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, body: { __typename: 'AgentThreadActivity', agentThread: { __typename: 'AgentThread', id: string, ownerUserId: string, title: string, createdAt: string, updatedAt: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null }> } | null } | { __typename: 'CommentActivity', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } | { __typename: 'StatusUpdateActivity', events: Array<{ __typename: 'ActivityStatusEvent', eventType: ActivityStatusEventType, data: { [key: string]: any } | null, assignmentChange: ActivityAssignmentChange | null, targetCount: number, removedCount: number, reviewerIds: Array<string>, targetReviewerCount: number, removedReviewerCount: number, movedCount: number, movedReviewerCount: number, movedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, movedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, targetUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, targetRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, removedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, removedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, onBehalfOfUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, reviewRequestUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } };

export type ActivityPageFieldsFragment = { __typename: 'ActivityItemRowsInfo', rows: Array<{ __typename: 'ActivityItem', id: string, itemType: ActivityItemType, sourceType: ActivitySourceType, audience: ActivityAudience, createdAt: string, channelThread: { __typename: 'ChannelThread', id: string, provider: ChannelProvider, externalChannelId: string, externalThreadId: string, webUrl: string | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, body: { __typename: 'AgentThreadActivity', agentThread: { __typename: 'AgentThread', id: string, ownerUserId: string, title: string, createdAt: string, updatedAt: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null }> } | null } | { __typename: 'CommentActivity', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } | { __typename: 'StatusUpdateActivity', events: Array<{ __typename: 'ActivityStatusEvent', eventType: ActivityStatusEventType, data: { [key: string]: any } | null, assignmentChange: ActivityAssignmentChange | null, targetCount: number, removedCount: number, reviewerIds: Array<string>, targetReviewerCount: number, removedReviewerCount: number, movedCount: number, movedReviewerCount: number, movedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, movedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, targetUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, targetRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, removedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, removedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, onBehalfOfUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, reviewRequestUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } }>, meta: { __typename: 'ActivityItemsMeta', totalCount: number, hasMore: boolean, nextCursor: string | null, hasPrevious: boolean, previousCursor: string | null } };

export type GetTaskActivityQueryVariables = Exact<{
  taskId: Scalars['UUID'];
  cursor?: InputMaybe<Scalars['UUID']>;
  before?: InputMaybe<Scalars['UUID']>;
  anchor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
  audience?: InputMaybe<ActivityAudience>;
  startAtOldest?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetTaskActivityQuery = { __typename: 'Query', task: { __typename: 'Task', id: string, workflow: { __typename: 'Workflow', id: string }, activity: { __typename: 'ActivityItemRowsInfo', rows: Array<{ __typename: 'ActivityItem', id: string, itemType: ActivityItemType, sourceType: ActivitySourceType, audience: ActivityAudience, createdAt: string, channelThread: { __typename: 'ChannelThread', id: string, provider: ChannelProvider, externalChannelId: string, externalThreadId: string, webUrl: string | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, body: { __typename: 'AgentThreadActivity', agentThread: { __typename: 'AgentThread', id: string, ownerUserId: string, title: string, createdAt: string, updatedAt: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null }> } | null } | { __typename: 'CommentActivity', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } | { __typename: 'StatusUpdateActivity', events: Array<{ __typename: 'ActivityStatusEvent', eventType: ActivityStatusEventType, data: { [key: string]: any } | null, assignmentChange: ActivityAssignmentChange | null, targetCount: number, removedCount: number, reviewerIds: Array<string>, targetReviewerCount: number, removedReviewerCount: number, movedCount: number, movedReviewerCount: number, movedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, movedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, targetUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, targetRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, removedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, removedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, onBehalfOfUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, reviewRequestUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } }>, meta: { __typename: 'ActivityItemsMeta', totalCount: number, hasMore: boolean, nextCursor: string | null, hasPrevious: boolean, previousCursor: string | null } } } | null };

export type GetWorkflowActivityQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
  cursor?: InputMaybe<Scalars['UUID']>;
  before?: InputMaybe<Scalars['UUID']>;
  anchor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetWorkflowActivityQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, activity: { __typename: 'ActivityItemRowsInfo', rows: Array<{ __typename: 'ActivityItem', id: string, itemType: ActivityItemType, sourceType: ActivitySourceType, audience: ActivityAudience, createdAt: string, channelThread: { __typename: 'ChannelThread', id: string, provider: ChannelProvider, externalChannelId: string, externalThreadId: string, webUrl: string | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, body: { __typename: 'AgentThreadActivity', agentThread: { __typename: 'AgentThread', id: string, ownerUserId: string, title: string, createdAt: string, updatedAt: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null }> } | null } | { __typename: 'CommentActivity', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } | { __typename: 'StatusUpdateActivity', events: Array<{ __typename: 'ActivityStatusEvent', eventType: ActivityStatusEventType, data: { [key: string]: any } | null, assignmentChange: ActivityAssignmentChange | null, targetCount: number, removedCount: number, reviewerIds: Array<string>, targetReviewerCount: number, removedReviewerCount: number, movedCount: number, movedReviewerCount: number, movedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, movedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, targetUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, targetRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, removedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, removedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, onBehalfOfUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, reviewRequestUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } }>, meta: { __typename: 'ActivityItemsMeta', totalCount: number, hasMore: boolean, nextCursor: string | null, hasPrevious: boolean, previousCursor: string | null } } } | null };

export type OnTaskActivityFeedChangedSubscriptionVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type OnTaskActivityFeedChangedSubscription = { __typename: 'Subscription', taskActivityFeedChanged: { __typename: 'ActivityFeedChangedEvent', activityItemId: string, changeType: ActivityFeedChangeType, activityItem: { __typename: 'ActivityItem', id: string, itemType: ActivityItemType, sourceType: ActivitySourceType, audience: ActivityAudience, createdAt: string, channelThread: { __typename: 'ChannelThread', id: string, provider: ChannelProvider, externalChannelId: string, externalThreadId: string, webUrl: string | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, body: { __typename: 'AgentThreadActivity', agentThread: { __typename: 'AgentThread', id: string, ownerUserId: string, title: string, createdAt: string, updatedAt: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null }> } | null } | { __typename: 'CommentActivity', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } | { __typename: 'StatusUpdateActivity', events: Array<{ __typename: 'ActivityStatusEvent', eventType: ActivityStatusEventType, data: { [key: string]: any } | null, assignmentChange: ActivityAssignmentChange | null, targetCount: number, removedCount: number, reviewerIds: Array<string>, targetReviewerCount: number, removedReviewerCount: number, movedCount: number, movedReviewerCount: number, movedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, movedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, targetUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, targetRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, removedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, removedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, onBehalfOfUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, reviewRequestUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } } | null, task: { __typename: 'Task', id: string, viewerSubscribed: boolean, viewerSubscriptionLocked: boolean, subscribers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | null } };

export type OnWorkflowActivityFeedChangedSubscriptionVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type OnWorkflowActivityFeedChangedSubscription = { __typename: 'Subscription', workflowActivityFeedChanged: { __typename: 'ActivityFeedChangedEvent', activityItemId: string, changeType: ActivityFeedChangeType, activityItem: { __typename: 'ActivityItem', id: string, itemType: ActivityItemType, sourceType: ActivitySourceType, audience: ActivityAudience, createdAt: string, channelThread: { __typename: 'ChannelThread', id: string, provider: ChannelProvider, externalChannelId: string, externalThreadId: string, webUrl: string | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, body: { __typename: 'AgentThreadActivity', agentThread: { __typename: 'AgentThread', id: string, ownerUserId: string, title: string, createdAt: string, updatedAt: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null }> } | null } | { __typename: 'CommentActivity', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } | { __typename: 'StatusUpdateActivity', events: Array<{ __typename: 'ActivityStatusEvent', eventType: ActivityStatusEventType, data: { [key: string]: any } | null, assignmentChange: ActivityAssignmentChange | null, targetCount: number, removedCount: number, reviewerIds: Array<string>, targetReviewerCount: number, removedReviewerCount: number, movedCount: number, movedReviewerCount: number, movedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, movedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, targetUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, targetRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, removedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, removedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, onBehalfOfUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, reviewRequestUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } } | null, workflow: { __typename: 'Workflow', id: string, viewerSubscribed: boolean, viewerSubscriptionLocked: boolean, subscribers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | null } };

export type GetAgentSkillsQueryVariables = Exact<{
  scope?: InputMaybe<AgentSkillScope>;
}>;


export type GetAgentSkillsQuery = { __typename: 'Query', agentSkills: Array<{ __typename: 'AgentSkill', id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } }> };

export type GetAgentSkillQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAgentSkillQuery = { __typename: 'Query', agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } | null };

export type CreateAgentSkillMutationVariables = Exact<{
  input: CreateAgentSkillInput;
}>;


export type CreateAgentSkillMutation = { __typename: 'Mutation', createAgentSkill: { __typename: 'AgentSkillResponse', agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } } };

export type UpdateAgentSkillMutationVariables = Exact<{
  input: UpdateAgentSkillInput;
}>;


export type UpdateAgentSkillMutation = { __typename: 'Mutation', updateAgentSkill: { __typename: 'UpdateAgentSkillResponse', committedVersionId: string, agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } } };

export type SetAgentSkillScopeMutationVariables = Exact<{
  input: SetAgentSkillScopeInput;
}>;


export type SetAgentSkillScopeMutation = { __typename: 'Mutation', setAgentSkillScope: { __typename: 'AgentSkillResponse', agentSkill: { __typename: 'AgentSkill', id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } } };

export type DeleteAgentSkillMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteAgentSkillMutation = { __typename: 'Mutation', deleteAgentSkill: { __typename: 'DeleteAgentSkillResponse', agentSkillId: string } };

export type AgentSkillListItemFragment = { __typename: 'AgentSkill', id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } };

export type AgentSkillAttachmentFieldsFragment = { __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null };

export type AgentSkillSimpleFragment = { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } };

export type AutoSaveAgentSkillDraftMutationVariables = Exact<{
  input: AutoSaveAgentSkillDraftInput;
}>;


export type AutoSaveAgentSkillDraftMutation = { __typename: 'Mutation', autoSaveAgentSkillDraft: { __typename: 'AgentSkillResponse', agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } } };

export type TestAgentSkillDraftMutationVariables = Exact<{
  input: TestAgentSkillDraftInput;
}>;


export type TestAgentSkillDraftMutation = { __typename: 'Mutation', testAgentSkillDraft: { __typename: 'TestAgentSkillDraftResponse', agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } }, version: { __typename: 'AgentSkillVersion', id: string, name: string, description: string, publishedAt: string | null } } };

export type PublishAgentSkillDraftMutationVariables = Exact<{
  input: PublishAgentSkillDraftInput;
}>;


export type PublishAgentSkillDraftMutation = { __typename: 'Mutation', publishAgentSkillDraft: { __typename: 'AgentSkillResponse', agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } } };

export type DiscardAgentSkillDraftMutationVariables = Exact<{
  input: DiscardAgentSkillDraftInput;
}>;


export type DiscardAgentSkillDraftMutation = { __typename: 'Mutation', discardAgentSkillDraft: { __typename: 'AgentSkillResponse', agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } } };

export type RetryAgentSkillFileMutationVariables = Exact<{
  input: RetryAgentSkillFileInput;
}>;


export type RetryAgentSkillFileMutation = { __typename: 'Mutation', retryAgentSkillFile: { __typename: 'AgentSkillResponse', agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } } };

export type AgentSkillDraftChangedSubscriptionVariables = Exact<{
  skillId: Scalars['UUID'];
}>;


export type AgentSkillDraftChangedSubscription = { __typename: 'Subscription', agentSkillDraftChanged: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } };

export type GetAgentSkillDraftAttachmentQueryVariables = Exact<{
  skillId: Scalars['UUID'];
  sha256: Scalars['String'];
}>;


export type GetAgentSkillDraftAttachmentQuery = { __typename: 'Query', agentSkillDraftAttachment: { __typename: 'AgentSkillAttachmentContent', base64: string, contentType: string, name: string } };

export type GetAgentSkillAttachmentQueryVariables = Exact<{
  skillId: Scalars['UUID'];
  versionId: Scalars['UUID'];
  path: Scalars['String'];
}>;


export type GetAgentSkillAttachmentQuery = { __typename: 'Query', agentSkillAttachment: { __typename: 'AgentSkillAttachmentContent', base64: string, contentType: string, name: string } };

export type DuplicateAgentSkillMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DuplicateAgentSkillMutation = { __typename: 'Mutation', duplicateAgentSkill: { __typename: 'AgentSkillResponse', agentSkill: { __typename: 'AgentSkill', content: string, id: string, scope: AgentSkillScope, name: string, description: string, isComplete: boolean, isPublished: boolean, hasUnpublishedChanges: boolean, createdAt: string, updatedAt: string, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }>, draft: { __typename: 'AgentSkillDraft', revision: number, content: string, name: string, description: string, isComplete: boolean, filesReady: boolean, updatedAt: string | null, attachments: Array<{ __typename: 'AgentSkillAttachment', path: string, name: string, contentType: string, sha256: string, sourceDocumentId: string | null, capturedAt: string | null, sourceStatus: AgentSkillAttachmentSourceStatus, processing: AgentSkillFileProcessing, processingError: string | null }> } | null, currentVersion: { __typename: 'AgentSkillVersion', id: string, number: number, name: string, description: string } | null, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null } } } };

export type SendAgentPromptMutationVariables = Exact<{
  input: AgentPromptInput;
}>;


export type SendAgentPromptMutation = { __typename: 'Mutation', sendAgentPrompt: { __typename: 'AgentResponse', threadId: string, messageId: string, prompt: string, agentSkillVersions: Array<{ __typename: 'AgentSkillVersion', description: string, id: string, name: string, skillId: string }> } };

export type ContinueAgentChatMutationVariables = Exact<{
  input: ContinueAgentChatInput;
}>;


export type ContinueAgentChatMutation = { __typename: 'Mutation', continueAgentChat: { __typename: 'AgentResponse', threadId: string, messageId: string, prompt: string } };

export type StartActivityAgentThreadMutationVariables = Exact<{
  input: StartActivityAgentThreadInput;
}>;


export type StartActivityAgentThreadMutation = { __typename: 'Mutation', startActivityAgentThread: { __typename: 'AgentResponse', threadId: string, messageId: string, prompt: string, agentSkillVersions: Array<{ __typename: 'AgentSkillVersion', description: string, id: string, name: string, skillId: string }> } };

export type UpdateAgentMessageSuggestionsMutationVariables = Exact<{
  input: AgentMessageSuggestionsInput;
}>;


export type UpdateAgentMessageSuggestionsMutation = { __typename: 'Mutation', updateAgentMessageSuggestions: { __typename: 'AgentMessage', id: string, data: { [key: string]: any } } };

export type UpdateAgentMessageFeedbackMutationVariables = Exact<{
  input: AgentMessageSuggestionFeedbackInput;
}>;


export type UpdateAgentMessageFeedbackMutation = { __typename: 'Mutation', updateAgentMessageFeedback: { __typename: 'AgentMessage', id: string, feedback: AgentMessageFeedback | null } };

export type DeleteAgentThreadMutationVariables = Exact<{
  threadId: Scalars['UUID'];
}>;


export type DeleteAgentThreadMutation = { __typename: 'Mutation', deleteAgentThread: string };

export type GetMentionEntitiesQueryVariables = Exact<{
  input: MentionEntitiesInput;
}>;


export type GetMentionEntitiesQuery = { __typename: 'Query', mentionEntities: { __typename: 'MentionEntitiesResult', documents: Array<{ __typename: 'Document', id: string, isSavePending: boolean, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string, vectorsFailedAt: string | null, vectorsSavedAt: string | null, vectorsStartedAt: string | null } | { __typename: 'StaticFileVersion', id: string, vectorsFailedAt: string | null, vectorsSavedAt: string | null, vectorsStartedAt: string | null, fileExtractionFailedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionStartedAt: string | null, fileLocation: { __typename: 'DocFile', id: string, mimetype: string } } } | { __typename: 'MentionAccessError', id: string, reason: MentionAccessErrorReason }>, playbooks: Array<{ __typename: 'MentionAccessError', id: string, reason: MentionAccessErrorReason } | { __typename: 'Playbook', id: string, title: string, description: string }>, tasks: Array<{ __typename: 'MentionAccessError', id: string, reason: MentionAccessErrorReason } | { __typename: 'Task', id: string, title: string, workflow: { __typename: 'Workflow', id: string, name: string } }>, workflows: Array<{ __typename: 'MentionAccessError', id: string, reason: MentionAccessErrorReason } | { __typename: 'Workflow', id: string, name: string }>, reports: Array<{ __typename: 'MentionAccessError', id: string, reason: MentionAccessErrorReason } | { __typename: 'Report', id: string, name: string }>, skillVersions: Array<{ __typename: 'AgentSkillVersion', description: string, id: string, name: string, skillId: string } | { __typename: 'MentionAccessError', id: string, reason: MentionAccessErrorReason }> } };

export type SearchMentionEntitiesQueryVariables = Exact<{
  input: SearchMentionEntitiesInput;
}>;


export type SearchMentionEntitiesQuery = { __typename: 'Query', searchMentionEntities: { __typename: 'SearchMentionEntitiesResult', groups: Array<{ __typename: 'MentionEntitySearchGroup', type: MentionEntitySearchType, totalCount: number, pageInfo: { __typename: 'MentionEntitySearchPageInfo', hasMore: boolean, nextCursor: { __typename: 'MentionEntitySearchCursor', type: MentionEntitySearchType, id: string } | null }, results: Array<{ __typename: 'Document', id: string, name: string, isSavePending: boolean, status: DocumentStatus | null, variant: DocumentVariant, storableType: StorableType, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } } | { __typename: 'Playbook', id: string, title: string, description: string } | { __typename: 'Report', id: string, name: string } | { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | { __typename: 'Workflow', id: string, name: string }> }> } };

export type UpdateAgentThreadTitleMutationVariables = Exact<{
  threadId: Scalars['UUID'];
  title: Scalars['String'];
}>;


export type UpdateAgentThreadTitleMutation = { __typename: 'Mutation', updateAgentThreadTitle: { __typename: 'AgentThread', id: string, title: string } };

export type RecreateAgentArtifactDocumentMutationVariables = Exact<{
  messageId: Scalars['UUID'];
  documentId: Scalars['UUID'];
  html: Scalars['String'];
  title: Scalars['String'];
}>;


export type RecreateAgentArtifactDocumentMutation = { __typename: 'Mutation', recreateAgentArtifactDocument: { __typename: 'ThreadDocumentArtifact', agentMessageId: string, kindList: Array<AgentMessageJoinKind>, createdAt: string, document: { __typename: 'Document', id: string, name: string, deletedAt: string | null } } };

export type StopChatMessageStreamMutationVariables = Exact<{
  threadId: Scalars['UUID'];
}>;


export type StopChatMessageStreamMutation = { __typename: 'Mutation', stopChatMessageStream: { __typename: 'AgentThread', id: string, messages: Array<{ __typename: 'AgentMessage', id: string, status: AgentMessageStatus, text: string }> } };

export type GetAgentThreadSkillAudienceQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAgentThreadSkillAudienceQuery = { __typename: 'Query', agentThread: { __typename: 'AgentThread', id: string, usesSharedSkills: boolean } };

export type GetAgentThreadQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAgentThreadQuery = { __typename: 'Query', agentThread: { __typename: 'AgentThread', id: string, title: string, context: Array<{ __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } }>, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, feedback: AgentMessageFeedback | null, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null, createdAt: string }>, artifacts: Array<{ __typename: 'ThreadDocumentArtifact', agentMessageId: string, kindList: Array<AgentMessageJoinKind>, createdAt: string, document: { __typename: 'Document', id: string, name: string, deletedAt: string | null } } | { __typename: 'ThreadReportArtifact', agentMessageId: string, createdAt: string, report: { __typename: 'Report', id: string, name: string } } | { __typename: 'ThreadSkillArtifact', agentMessageId: string, createdAt: string, kindList: Array<AgentMessageJoinKind>, skill: { __typename: 'AgentSkill', id: string, name: string, scope: AgentSkillScope, isComplete: boolean, currentVersion: { __typename: 'AgentSkillVersion', id: string, name: string, description: string } | null } } | { __typename: 'ThreadTaskArtifact', agentMessageId: string, createdAt: string, task: { __typename: 'Task', id: string, title: string } } | { __typename: 'ThreadWorkflowArtifact', agentMessageId: string, createdAt: string, kindList: Array<AgentMessageJoinKind>, workflow: { __typename: 'Workflow', id: string, name: string } }> } };

export type GetAgentThreadsQueryVariables = Exact<{
  filter: AgentThreadHistoryFilter;
}>;


export type GetAgentThreadsQuery = { __typename: 'Query', agentThreads: Array<{ __typename: 'AgentThread', id: string, title: string, createdAt: string }> };

export type OnAgentEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAgentEventSubscription = { __typename: 'Subscription', onAgentEvent: { __typename: 'ArtifactCreatedEvent', threadId: string, userId: string, messageId: string, agentMessageId: string, kindList: Array<AgentMessageJoinKind>, artifactCreatedAt: string, documentId: string, documentName: string, documentDeletedAt: string | null } | { __typename: 'AssistantMessageEvent', threadId: string, userId: string, message: { __typename: 'StreamingAgentMessage', id: string, status: AgentMessageStatus, text: string } } | { __typename: 'LoadingEvent', threadId: string, userId: string, messageId: string, thinkingMessage: string } | { __typename: 'PlanSnapshotEvent', threadId: string, userId: string, messageId: string, planJson: { [key: string]: any } } | { __typename: 'ReportArtifactCreatedEvent', threadId: string, userId: string, agentMessageId: string, reportId: string, reportName: string, artifactCreatedAt: string } | { __typename: 'SkillArtifactCreatedEvent', threadId: string, userId: string, agentMessageId: string, skillId: string, skillName: string, artifactCreatedAt: string, kindList: Array<AgentMessageJoinKind> } | { __typename: 'TitleUpdateEvent', threadId: string, userId: string, title: string } | { __typename: 'ToolStatusUpdateEvent', threadId: string, userId: string, messageId: string, data: { [key: string]: any } } | { __typename: 'WorkflowArtifactCreatedEvent', threadId: string, userId: string, agentMessageId: string, workflowId: string, workflowName: string, artifactCreatedAt: string, kindList: Array<AgentMessageJoinKind> } };

export type AiReminderAutomationSimpleFragment = { __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> };

export type AiReminderAutomationWithRelationsFragment = { __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, report: { __typename: 'Report', id: string, name: string }, assignees: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, reviewers: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> };

export type AiReminderAutomationRunSimpleFragment = { __typename: 'AIReminderAutomationRun', status: AiReminderAutomationRunStatus, remindersGenerated: number, errorMessage: string | null, processedAt: string | null, createdAt: string, updatedAt: string };

export type GetAiReminderAutomationQueryVariables = Exact<{
  automationId: Scalars['UUID'];
}>;


export type GetAiReminderAutomationQuery = { __typename: 'Query', aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, runs: Array<{ __typename: 'AIReminderAutomationRun', status: AiReminderAutomationRunStatus, remindersGenerated: number, errorMessage: string | null, processedAt: string | null, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string } }>, report: { __typename: 'Report', id: string, name: string }, assignees: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, reviewers: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> } };

export type GetAiReminderAutomationsByReportQueryVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type GetAiReminderAutomationsByReportQuery = { __typename: 'Query', aiReminderAutomationsByReport: Array<{ __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, report: { __typename: 'Report', id: string, name: string }, assignees: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, reviewers: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> }> };

export type GetAiReminderAutomationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiReminderAutomationsQuery = { __typename: 'Query', aiReminderAutomations: Array<{ __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, report: { __typename: 'Report', id: string, name: string }, assignees: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, reviewers: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> }> };

export type GetAiReminderAutomationRunsQueryVariables = Exact<{
  automationId: Scalars['UUID'];
}>;


export type GetAiReminderAutomationRunsQuery = { __typename: 'Query', aiReminderAutomationRuns: Array<{ __typename: 'AIReminderAutomationRun', status: AiReminderAutomationRunStatus, remindersGenerated: number, errorMessage: string | null, processedAt: string | null, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string } }> };

export type CreateAiReminderAutomationMutationVariables = Exact<{
  input: CreateAiReminderAutomationInput;
}>;


export type CreateAiReminderAutomationMutation = { __typename: 'Mutation', createAIReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, report: { __typename: 'Report', id: string, name: string }, assignees: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, reviewers: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> } };

export type UpdateAiReminderAutomationMutationVariables = Exact<{
  input: UpdateAiReminderAutomationInput;
}>;


export type UpdateAiReminderAutomationMutation = { __typename: 'Mutation', updateAIReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, report: { __typename: 'Report', id: string, name: string }, assignees: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, reviewers: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> } };

export type DeleteAiReminderAutomationMutationVariables = Exact<{
  automationId: Scalars['UUID'];
  deleteReminders?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteAiReminderAutomationMutation = { __typename: 'Mutation', deleteAIReminderAutomation: string };

export type RunAiReminderAutomationMutationVariables = Exact<{
  automationId: Scalars['UUID'];
}>;


export type RunAiReminderAutomationMutation = { __typename: 'Mutation', runAIReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, report: { __typename: 'Report', id: string, name: string }, assignees: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, reviewers: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> } };

export type AcceptReminderMutationVariables = Exact<{
  reminderId: Scalars['UUID'];
}>;


export type AcceptReminderMutation = { __typename: 'Mutation', acceptReminder: { __typename: 'Reminder', id: string, reviewStatus: ReminderReviewStatus } };

export type RejectReminderMutationVariables = Exact<{
  reminderId: Scalars['UUID'];
}>;


export type RejectReminderMutation = { __typename: 'Mutation', rejectReminder: string };

export type AcceptRemindersMutationVariables = Exact<{
  reminderIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type AcceptRemindersMutation = { __typename: 'Mutation', acceptReminders: Array<{ __typename: 'Reminder', id: string, reviewStatus: ReminderReviewStatus }> };

export type RejectRemindersMutationVariables = Exact<{
  reminderIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type RejectRemindersMutation = { __typename: 'Mutation', rejectReminders: Array<string> };

export type OnAiReminderAutomationUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAiReminderAutomationUpdatedSubscription = { __typename: 'Subscription', aiReminderAutomationUpdated: { __typename: 'AIReminderAutomationUpdatedEvent', automationId: string, automation: { __typename: 'AIReminderAutomation', id: string, title: string, prompt: string, selectedColumnIds: Array<string>, selectedBuiltInFields: Array<string>, status: AiReminderAutomationStatus, pendingRemindersCount: number, activeRemindersCount: number, lastRunAt: string | null, lastTriggeredAt: string | null, lastCompletedAt: string | null, nextRunAt: string | null, isRunning: boolean, totalRemindersGenerated: number, createdAt: string, updatedAt: string, deletedAt: string | null, report: { __typename: 'Report', id: string, name: string }, assignees: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, reviewers: Array<{ __typename: 'User', id: string, avatarColor: string, displayName: string, email: string }>, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, position: RelativeTimePosition, unit: RelativeTimeUnit }> } } };

export type CreateAnswerOptionMutationVariables = Exact<{
  input: CreateAnswerOptionInput;
}>;


export type CreateAnswerOptionMutation = { __typename: 'Mutation', createAnswerOption: { __typename: 'AnswerOptionResponse', answerOption: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } } };

export type DeleteAnswerOptionMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteAnswerOptionMutation = { __typename: 'Mutation', deleteAnswerOption: string };

export type UpdateAnswerOptionMutationVariables = Exact<{
  input: UpdateAnswerOptionInput;
}>;


export type UpdateAnswerOptionMutation = { __typename: 'Mutation', updateAnswerOption: { __typename: 'AnswerOptionResponse', answerOption: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } } };

export type AnswerOptionBaseFragment = { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction };

export type GetAnswerOptionsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAnswerOptionsQuery = { __typename: 'Query', answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> } | null };

export type GetAnswerOptionsPresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnswerOptionsPresetsQuery = { __typename: 'Query', answerOptionsPresets: Array<{ __typename: 'AnswerOptions', id: string, title: string | null, documentsUsing: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> };

export type CreateAnswerOptionsMutationVariables = Exact<{
  input: CreateAnswerOptionsInput;
}>;


export type CreateAnswerOptionsMutation = { __typename: 'Mutation', createAnswerOptions: { __typename: 'AnswerOptionsResponse', answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> } } };

export type UpdateAnswerOptionsMutationVariables = Exact<{
  input: UpdateAnswerOptionsInput;
}>;


export type UpdateAnswerOptionsMutation = { __typename: 'Mutation', updateAnswerOptions: { __typename: 'AnswerOptionsResponse', answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> } } };

export type DeleteAnswerOptionsMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteAnswerOptionsMutation = { __typename: 'Mutation', deleteAnswerOptions: string };

export type AnswerOptionsBaseFragment = { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename: 'Query', apiKeys: Array<{ __typename: 'ApiKey', id: string, name: string, obfuscatedValue: string, permissions: Array<string>, createdAt: string, lastUsedAt: string | null }> };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename: 'Mutation', createApiKey: { __typename: 'CreateApiKeyResponse', value: string, apiKey: { __typename: 'ApiKey', id: string, name: string, obfuscatedValue: string, permissions: Array<string>, createdAt: string, lastUsedAt: string | null } } };

export type RevokeApiKeysMutationVariables = Exact<{
  apiKeyIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type RevokeApiKeysMutation = { __typename: 'Mutation', revokeApiKeys: Array<string> };

export type ApiKeyBaseFragment = { __typename: 'ApiKey', id: string, name: string, obfuscatedValue: string, permissions: Array<string>, createdAt: string, lastUsedAt: string | null };

export type GetAppVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppVersionQuery = { __typename: 'Query', appVersion: { __typename: 'AppVersion', version: string, buildDate: string } };

export type GetBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoardsQuery = { __typename: 'Query', boards: Array<{ __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, triageColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }> }> };

export type GetBoardQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetBoardQuery = { __typename: 'Query', board: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, workflows: Array<{ __typename: 'Workflow', id: string, name: string, envelopeStatus: EnvelopeStatus, state: WorkflowState, variant: WorkflowVariant, createdAt: string, updatedAt: string }> }> } };

export type GetBoardColumnsQueryVariables = Exact<{
  boardId: Scalars['UUID'];
}>;


export type GetBoardColumnsQuery = { __typename: 'Query', board: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, triageColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }> } };

export type GetColumnQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetColumnQuery = { __typename: 'Query', column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, workflows: Array<{ __typename: 'Workflow', id: string, name: string, envelopeStatus: EnvelopeStatus, state: WorkflowState, variant: WorkflowVariant, createdAt: string, updatedAt: string }> } | null };

export type CreateBoardMutationVariables = Exact<{
  input: CreateBoardInput;
}>;


export type CreateBoardMutation = { __typename: 'Mutation', createBoard: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string } };

export type UpdateBoardMutationVariables = Exact<{
  input: UpdateBoardInput;
}>;


export type UpdateBoardMutation = { __typename: 'Mutation', updateBoard: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string } };

export type DeleteBoardMutationVariables = Exact<{
  boardId: Scalars['UUID'];
}>;


export type DeleteBoardMutation = { __typename: 'Mutation', deleteBoard: string };

export type CreateColumnMutationVariables = Exact<{
  input: CreateColumnInput;
}>;


export type CreateColumnMutation = { __typename: 'Mutation', createColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } };

export type UpdateColumnMutationVariables = Exact<{
  input: UpdateColumnInput;
}>;


export type UpdateColumnMutation = { __typename: 'Mutation', updateColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } };

export type DeleteColumnMutationVariables = Exact<{
  columnId: Scalars['UUID'];
  targetColumnId: Scalars['UUID'];
}>;


export type DeleteColumnMutation = { __typename: 'Mutation', deleteColumn: string };

export type MoveColumnMutationVariables = Exact<{
  input: MoveColumnInput;
}>;


export type MoveColumnMutation = { __typename: 'Mutation', moveColumn: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, workflows: Array<{ __typename: 'Workflow', id: string, name: string, envelopeStatus: EnvelopeStatus, state: WorkflowState, variant: WorkflowVariant, createdAt: string, updatedAt: string }> }> } };

export type AddTriageColumnMutationVariables = Exact<{
  boardId: Scalars['UUID'];
}>;


export type AddTriageColumnMutation = { __typename: 'Mutation', addTriageColumn: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, workflows: Array<{ __typename: 'Workflow', id: string, name: string, envelopeStatus: EnvelopeStatus, state: WorkflowState, variant: WorkflowVariant, createdAt: string, updatedAt: string }> }> } };

export type BoardBaseFragment = { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string };

export type BoardWithColumnsFragment = { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, triageColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }> };

export type BoardFullFragment = { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, workflows: Array<{ __typename: 'Workflow', id: string, name: string, envelopeStatus: EnvelopeStatus, state: WorkflowState, variant: WorkflowVariant, createdAt: string, updatedAt: string }> }> };

export type ColumnBaseFragment = { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string };

export type ColumnWithBoardFragment = { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, board: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string } };

export type ColumnWithWorkflowsFragment = { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, workflows: Array<{ __typename: 'Workflow', id: string, name: string, envelopeStatus: EnvelopeStatus, state: WorkflowState, variant: WorkflowVariant, createdAt: string, updatedAt: string }> };

export type RequestBulkExportMutationVariables = Exact<{
  input: RequestBulkExportInput;
}>;


export type RequestBulkExportMutation = { __typename: 'Mutation', requestBulkExport: { __typename: 'BulkExport', id: string, status: BulkExportStatus, format: BulkExportFormat, documentCount: number, processedCount: number, skippedCount: number, createdAt: string } };

export type CancelBulkExportMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CancelBulkExportMutation = { __typename: 'Mutation', cancelBulkExport: { __typename: 'BulkExport', id: string, status: BulkExportStatus, errorMessage: string | null } };

export type BulkExportQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type BulkExportQuery = { __typename: 'Query', bulkExport: { __typename: 'BulkExport', id: string, status: BulkExportStatus, format: BulkExportFormat, documentCount: number, processedCount: number, packagedCount: number, skippedCount: number, fileSizeBytes: number | null, errorMessage: string | null, expiresAt: string | null, downloadUrl: string | null, createdAt: string, updatedAt: string, skippedDocuments: Array<{ __typename: 'BulkExportSkippedDocument', documentId: string, entryName: string, reason: string }>, parts: Array<{ __typename: 'BulkExportPart', partNumber: number, sizeBytes: number, downloadUrl: string }> } | null };

export type MyBulkExportsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type MyBulkExportsQuery = { __typename: 'Query', myBulkExports: Array<{ __typename: 'BulkExport', id: string, status: BulkExportStatus, format: BulkExportFormat, documentCount: number, processedCount: number, skippedCount: number, fileSizeBytes: number | null, downloadUrl: string | null, expiresAt: string | null, createdAt: string, parts: Array<{ __typename: 'BulkExportPart', partNumber: number, sizeBytes: number, downloadUrl: string }> }> };

export type BulkExportUpdatedSubscriptionVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type BulkExportUpdatedSubscription = { __typename: 'Subscription', bulkExportUpdated: { __typename: 'BulkExport', id: string, status: BulkExportStatus, format: BulkExportFormat, documentCount: number, processedCount: number, packagedCount: number, skippedCount: number, fileSizeBytes: number | null, downloadUrl: string | null, errorMessage: string | null, expiresAt: string | null, createdAt: string, updatedAt: string, skippedDocuments: Array<{ __typename: 'BulkExportSkippedDocument', documentId: string, entryName: string, reason: string }>, parts: Array<{ __typename: 'BulkExportPart', partNumber: number, sizeBytes: number, downloadUrl: string }> } };

export type GetCommentQueryVariables = Exact<{
  where: CommentWhereInput;
}>;


export type GetCommentQuery = { __typename: 'Query', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null };

export type GetCommentRepliesQueryVariables = Exact<{
  where: CommentWhereInput;
}>;


export type GetCommentRepliesQuery = { __typename: 'Query', comment: { __typename: 'Comment', id: string, isPrivate: boolean, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null };

export type GetCommentsQueryVariables = Exact<{
  where: CommentsWhereInput;
}>;


export type GetCommentsQuery = { __typename: 'Query', comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }> };

export type CreateCommentMutationVariables = Exact<{
  input: NewCommentInput;
}>;


export type CreateCommentMutation = { __typename: 'Mutation', createComment: { __typename: 'CommentResponse', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename: 'Mutation', updateComment: { __typename: 'CommentResponse', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } };

export type DisableCommentMutationVariables = Exact<{
  input: DeleteCommentInput;
}>;


export type DisableCommentMutation = { __typename: 'Mutation', disableComment: { __typename: 'CommentResponse', comment: { __typename: 'Comment', id: string } | null } };

export type DeleteCommentMutationVariables = Exact<{
  input: DeleteCommentInput;
}>;


export type DeleteCommentMutation = { __typename: 'Mutation', deleteComment: { __typename: 'CommentResponse', comment: { __typename: 'Comment', id: string } | null } };

export type CommentFieldsFragment = { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null };

export type CommentFieldsBaseFragment = { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null };

export type CommentSimpleFragment = { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> };

export type ReplySimpleFragment = { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null };

export type GetCommunityCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityCategoriesQuery = { __typename: 'Query', communityCategories: Array<{ __typename: 'CommunityCategory', id: string, description: string, emoji: string, title: string, createdAt: string, updatedAt: string }> };

export type CreateCommunityCategoryMutationVariables = Exact<{
  input: CreateCommunityCategoryInput;
}>;


export type CreateCommunityCategoryMutation = { __typename: 'Mutation', createCommunityCategory: { __typename: 'CommunityCategory', id: string, description: string, emoji: string, title: string, createdAt: string, updatedAt: string } };

export type CommunityCategorySimpleFragment = { __typename: 'CommunityCategory', id: string, description: string, emoji: string, title: string, createdAt: string, updatedAt: string };

export type GetSupportedLicensesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedLicensesQuery = { __typename: 'Query', supportedLicenses: Array<{ __typename: 'SupportedLicense', id: string, name: string, url: string }> };

export type TopCommunityWorkflowsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TopCommunityWorkflowsQuery = { __typename: 'Query', topCommunityWorkflows: Array<{ __typename: 'Workflow', id: string, name: string, description: string }> };

export type TopCommunityTemplatesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TopCommunityTemplatesQuery = { __typename: 'Query', topCommunityTemplates: Array<{ __typename: 'Document', id: string, name: string, description: string | null }> };

export type TopCommunityContributorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TopCommunityContributorsQuery = { __typename: 'Query', topCommunityContributors: Array<{ __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> };

export type GetCommunityTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityTemplatesQuery = { __typename: 'Query', communityTemplates: Array<{ __typename: 'Document', id: string, name: string, description: string | null, isCommunityTemplate: boolean, numTimesImported: number, requesterImportedDocumentIds: Array<string>, variant: DocumentVariant, communityCategories: Array<{ __typename: 'CommunityCategory', id: string, description: string, emoji: string, title: string, createdAt: string, updatedAt: string }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null }> };

export type GetCommunityTemplateQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetCommunityTemplateQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, description: string | null, isCommunityTemplate: boolean, requesterImportedDocumentIds: Array<string>, storableType: StorableType, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null } };

export type GetCommunityWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityWorkflowsQuery = { __typename: 'Query', communityWorkflows: Array<{ __typename: 'Workflow', id: string, name: string, description: string, isCommunityWorkflow: boolean, numTimesImported: number, requesterImportedWorkflowIds: Array<string>, createdAt: string, updatedAt: string, communityCategories: Array<{ __typename: 'CommunityCategory', id: string, description: string, emoji: string, title: string, createdAt: string, updatedAt: string }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type GetCommunityWorkflowQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetCommunityWorkflowQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', requesterImportedWorkflowIds: Array<string>, id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null };

export type GetCommunityInfoBoxWorkflowQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetCommunityInfoBoxWorkflowQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, description: string, variant: WorkflowVariant, requesterImportedWorkflowIds: Array<string>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null };

export type GetCommunityWorkflowMetricsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetCommunityWorkflowMetricsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', requesterImportedWorkflowIds: Array<string>, id: string, variant: WorkflowVariant, fileCount: number, numTimesImported: number, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null } }> } | null };

export type GetImportedWorkflowQueryVariables = Exact<{
  sourceWorkflowId: Scalars['UUID'];
}>;


export type GetImportedWorkflowQuery = { __typename: 'Query', getImportedWorkflow: { __typename: 'Workflow', requesterImportedWorkflowIds: Array<string>, id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null };

export type MayPublishWorkflowToCommunityQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type MayPublishWorkflowToCommunityQuery = { __typename: 'Query', mayPublishWorkflowToCommunity: { __typename: 'MayPublishToCommunityResult', ok: boolean, errorMsgs: Array<string> } };

export type SetCommunityWorkflowMutationVariables = Exact<{
  input: SetCommunityWorkflowInput;
}>;


export type SetCommunityWorkflowMutation = { __typename: 'Mutation', setCommunityWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, isCommunityWorkflow: boolean, communityCategories: Array<{ __typename: 'CommunityCategory', id: string, description: string, emoji: string, title: string, createdAt: string, updatedAt: string }> } } };

export type SetCommunityTemplateMutationVariables = Exact<{
  input: SetCommunityTemplateInput;
}>;


export type SetCommunityTemplateMutation = { __typename: 'Mutation', setCommunityTemplate: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string, description: string | null, isCommunityTemplate: boolean, communityCategories: Array<{ __typename: 'CommunityCategory', id: string, description: string, emoji: string, title: string, createdAt: string, updatedAt: string }>, workflow: { __typename: 'Workflow', id: string } | null } | null } };

export type ImportCommunityWorkflowMutationVariables = Exact<{
  input: ImportCommunityWorkflowInput;
}>;


export type ImportCommunityWorkflowMutation = { __typename: 'Mutation', importCommunityWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, isCommunityWorkflow: boolean, requesterImportedWorkflowIds: Array<string> } } };

export type GetMyContractTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyContractTypesQuery = { __typename: 'Query', myContractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> };

export type GetMyContractTypesWithDocumentCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyContractTypesWithDocumentCountQuery = { __typename: 'Query', myContractTypes: Array<{ __typename: 'ContractType', documentCount: number, id: string, value: string }> };

export type GetDocumentTypeQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentTypeQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, type: { __typename: 'ContractType', id: string, value: string } | null } };

export type CreateContractTypesMutationVariables = Exact<{
  input: Array<CreateContractTypeProps> | CreateContractTypeProps;
}>;


export type CreateContractTypesMutation = { __typename: 'Mutation', createContractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> };

export type MergeContractTypesMutationVariables = Exact<{
  input: MergeTypesInput;
}>;


export type MergeContractTypesMutation = { __typename: 'Mutation', mergeContractTypes: { __typename: 'ContractType', id: string, value: string, documentCount: number } };

export type UpdateContractTypeMutationVariables = Exact<{
  input: UpdateContractTypeInput;
}>;


export type UpdateContractTypeMutation = { __typename: 'Mutation', updateContractType: { __typename: 'ContractType', id: string, value: string } };

export type DeleteContractTypeMutationVariables = Exact<{
  input: DeleteContractTypeInput;
}>;


export type DeleteContractTypeMutation = { __typename: 'Mutation', deleteContractType: { __typename: 'ContractType', documentCount: number, id: string, value: string } };

export type UpdateDocumentTypeMutationVariables = Exact<{
  input: UpdateDocumentTypeInput;
}>;


export type UpdateDocumentTypeMutation = { __typename: 'Mutation', updateDocumentType: { __typename: 'Document', id: string, type: { __typename: 'ContractType', id: string, value: string } | null } };

export type ContractTypeSimpleFragment = { __typename: 'ContractType', id: string, value: string };

export type DocumentMetadataImportSummaryFieldsFragment = { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number };

export type DocumentMetadataImportHistoryFieldsFragment = { __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null };

export type DocumentMetadataImportFieldsFragment = { __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, questions: Array<{ __typename: 'ExtractionQuestion', id: string, questionText: string, title: string, type: ExtractionQuestionType }>, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null };

export type DocumentMetadataImportPreviewFieldsFragment = { __typename: 'DocumentMetadataImportPreview', conflictRows: number, errorRows: number, totalRows: number, columns: Array<{ __typename: 'DocumentMetadataImportPreviewColumn', canOverwrite: boolean, errorCount: number, questionId: string, title: string, type: ExtractionQuestionType, warningCount: number }> };

export type DocumentMetadataImportsQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentMetadataImportsQuery = { __typename: 'Query', documentMetadataImports: Array<{ __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null }> };

export type DocumentMetadataImportQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentMetadataImportQuery = { __typename: 'Query', documentMetadataImport: { __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, questions: Array<{ __typename: 'ExtractionQuestion', id: string, questionText: string, title: string, type: ExtractionQuestionType }>, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null } | null };

export type DocumentMetadataImportPreviewQueryVariables = Exact<{
  importId: Scalars['UUID'];
}>;


export type DocumentMetadataImportPreviewQuery = { __typename: 'Query', documentMetadataImportPreview: { __typename: 'DocumentMetadataImportPreview', conflictRows: number, errorRows: number, totalRows: number, columns: Array<{ __typename: 'DocumentMetadataImportPreviewColumn', canOverwrite: boolean, errorCount: number, questionId: string, title: string, type: ExtractionQuestionType, warningCount: number }> } };

export type DocumentMetadataImportHistoryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentMetadataImportHistoryQuery = { __typename: 'Query', documentMetadataImport: { __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null } | null };

export type GenerateMetadataImportTemplateMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']>;
  extractionQuestionIds: Array<Scalars['UUID']> | Scalars['UUID'];
  importId?: InputMaybe<Scalars['UUID']>;
  prefill?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateMetadataImportTemplateMutation = { __typename: 'Mutation', generateMetadataImportTemplate: { __typename: 'GenerateMetadataImportTemplateResult', fileContent: string, fileName: string, templateVersion: string, documentMetadataImport: { __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, questions: Array<{ __typename: 'ExtractionQuestion', id: string, questionText: string, title: string, type: ExtractionQuestionType }>, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null } } };

export type UploadMetadataImportMutationVariables = Exact<{
  displayName: Scalars['String'];
  file: Scalars['Upload'];
  extractionQuestionIds: Array<Scalars['UUID']> | Scalars['UUID'];
  importId: Scalars['UUID'];
}>;


export type UploadMetadataImportMutation = { __typename: 'Mutation', uploadMetadataImport: { __typename: 'UploadMetadataImportResult', documentMetadataImport: { __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, questions: Array<{ __typename: 'ExtractionQuestion', id: string, questionText: string, title: string, type: ExtractionQuestionType }>, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null } } };

export type ConfirmMetadataImportMutationVariables = Exact<{
  importId: Scalars['UUID'];
  overwriteQuestionIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type ConfirmMetadataImportMutation = { __typename: 'Mutation', confirmMetadataImport: { __typename: 'MetadataImportOperationResult', documentMetadataImport: { __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null } } };

export type DeleteMetadataImportsMutationVariables = Exact<{
  importIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type DeleteMetadataImportsMutation = { __typename: 'Mutation', deleteMetadataImports: { __typename: 'DeleteMetadataImportsResult', deletedIds: Array<string> } };

export type OnDocumentMetadataImportProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDocumentMetadataImportProgressSubscription = { __typename: 'Subscription', documentMetadataImportProgress: { __typename: 'DocumentMetadataImport', id: string, createdAt: string, displayName: string, failedReason: string | null, finishedAt: string | null, startedAt: string | null, sourceFileName: string | null, status: DocumentMetadataImportStatus, templateVersion: string, updatedAt: string, createdBy: { __typename: 'User', id: string, displayName: string }, summary: { __typename: 'DocumentMetadataImportSummary', createdJobs: number, emptyColumns: Array<string>, errorRows: number, processedRowCount: number, skippedCells: number, totalRows: number, updatedJobs: number, validRows: number } | null } | null };

export type GetEnvelopesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnvelopesQuery = { __typename: 'Query', envelopes: Array<{ __typename: 'Envelope', id: string, completedAt: string | null, variant: EnvelopeVariant, title: string, statusDateTime: string, docuSignEnvelopeId: string | null, docuSignUri: string | null, createdAt: string, updatedAt: string, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus, files: Array<{ __typename: 'WorkflowFile', id: string }> }, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, status: WorkflowRecipientStatus, type: WorkflowRecipientType }> }> };

export type GetEnvelopeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEnvelopeQuery = { __typename: 'Query', envelope: { __typename: 'Envelope', id: string, completedAt: string | null, docuSignEnvelopeId: string | null, docuSignUri: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant, createdAt: string, updatedAt: string, workflow: { __typename: 'Workflow', id: string, createdAt: string, envelopeMsg: string | null, envelopeStatus: EnvelopeStatus, name: string, requesterInOwnerOrg: boolean, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, column: { __typename: 'Column', id: string, name: string }, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, envelope: { __typename: 'Envelope', id: string, completedAt: string | null, docuSignEnvelopeId: string | null, variant: EnvelopeVariant } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, owner: { __typename: 'User', id: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } | null };

export type GetEnvelopeWithRecipientsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEnvelopeWithRecipientsQuery = { __typename: 'Query', envelope: { __typename: 'Envelope', id: string, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus }, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null }> } | null };

export type GetSignatureDocsDetailsQueryVariables = Exact<{
  documentIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetSignatureDocsDetailsQuery = { __typename: 'Query', documents: Array<{ __typename: 'Document', name: string, id: string, storableType: StorableType, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, comments: Array<{ __typename: 'Comment', id: string }>, workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string } | null } | null }> };

export type RefreshDocAfterEnvelopeActionQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type RefreshDocAfterEnvelopeActionQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, isSigned: boolean, status: DocumentStatus | null, requesterRole: PermissionRole | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, title: string, statusDateTime: string, variant: EnvelopeVariant, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string }, owner: { __typename: 'User', id: string }, workflow: { __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null } };

export type RevertWorkflowToDraftMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type RevertWorkflowToDraftMutation = { __typename: 'Mutation', revertWorkflowToDraft: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, column: { __typename: 'Column', id: string, name: string }, envelope: { __typename: 'Envelope', id: string, completedAt: string | null, variant: EnvelopeVariant, title: string, statusDateTime: string, docuSignEnvelopeId: string | null, docuSignUri: string | null, createdAt: string, updatedAt: string, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus, files: Array<{ __typename: 'WorkflowFile', id: string }> }, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, status: WorkflowRecipientStatus, type: WorkflowRecipientType }> } | null, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type SetEnvelopeViewedMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type SetEnvelopeViewedMutation = { __typename: 'Mutation', setEnvelopeViewed: { __typename: 'Envelope', id: string, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus }, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, firstViewedAt: string | null, lastViewedAt: string | null }> } | null };

export type SwitchEnvelopeVariantMutationVariables = Exact<{
  input: SwitchEnvelopeVariantInput;
}>;


export type SwitchEnvelopeVariantMutation = { __typename: 'Mutation', switchEnvelopeVariant: { __typename: 'Envelope', id: string, variant: EnvelopeVariant, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } } };

export type UpdateEnvelopeMutationVariables = Exact<{
  input: UpdateEnvelopeInput;
}>;


export type UpdateEnvelopeMutation = { __typename: 'Mutation', updateEnvelope: { __typename: 'Envelope', id: string, completedAt: string | null, variant: EnvelopeVariant, title: string, statusDateTime: string, docuSignEnvelopeId: string | null, docuSignUri: string | null, createdAt: string, updatedAt: string, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus, files: Array<{ __typename: 'WorkflowFile', id: string }> }, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, status: WorkflowRecipientStatus, type: WorkflowRecipientType }> } };

export type DocumentForSignatureFragment = { __typename: 'Document', id: string, storableType: StorableType, workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string } | null } | null };

export type EnvelopeSimpleFragment = { __typename: 'Envelope', id: string, completedAt: string | null, variant: EnvelopeVariant, title: string, statusDateTime: string, docuSignEnvelopeId: string | null, docuSignUri: string | null, createdAt: string, updatedAt: string, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus, files: Array<{ __typename: 'WorkflowFile', id: string }> }, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, status: WorkflowRecipientStatus, type: WorkflowRecipientType }> };

export type EnvelopeWithFilesFragment = { __typename: 'Envelope', id: string, completedAt: string | null, docuSignEnvelopeId: string | null, docuSignUri: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant, createdAt: string, updatedAt: string, workflow: { __typename: 'Workflow', id: string, createdAt: string, envelopeMsg: string | null, envelopeStatus: EnvelopeStatus, name: string, requesterInOwnerOrg: boolean, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, column: { __typename: 'Column', id: string, name: string }, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, envelope: { __typename: 'Envelope', id: string, completedAt: string | null, docuSignEnvelopeId: string | null, variant: EnvelopeVariant } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, owner: { __typename: 'User', id: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } };

export type GetExtractionJobQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExtractionJobQuery = { __typename: 'Query', extractionJob: { __typename: 'ExtractionJob', id: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, createdAt: string, updatedAt: string, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, review: { __typename: 'ExtractionQuestionReview', reviewedAt: string, reviewAction: ReviewAction, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } };

export type CreateExtractionJobMutationVariables = Exact<{
  documentId: Scalars['UUID'];
  input: CreateExtractionJobInput;
}>;


export type CreateExtractionJobMutation = { __typename: 'Mutation', createExtractionJob: { __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, extractionJob: { __typename: 'ExtractionJob', id: string, createdAt: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null } | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, question: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant }, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }> } | null, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> } };

export type StartExtractionJobsForDocumentsMutationVariables = Exact<{
  input: StartExtractionJobsForDocumentsInput;
}>;


export type StartExtractionJobsForDocumentsMutation = { __typename: 'Mutation', startExtractionJobsForDocuments: { __typename: 'StartExtractionJobsResponse', skippedCount: number, documents: Array<{ __typename: 'Document', id: string, aiQuestionIdsQueueing: Array<string>, createdAt: string, deletedAt: string | null, lastAccessedByRequesterAt: string | null, name: string, requesterFavorited: boolean, requesterRole: PermissionRole | null, status: DocumentStatus | null, signedAt: string | null, updatedAt: string, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, relationshipPropertiesExtractionHash: string | null, relationshipMatchingStartedAt: string | null, relationshipMatchingFinishedAt: string | null, relationshipMatchingFailedReason: string | null, workflowFileRole: WorkflowFileDocumentRole | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, questionJobs: Array<{ __typename: 'ExtractionJob', id: string, createdAt: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null } | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, question: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant }, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }> }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, type: { __typename: 'ContractType', id: string, value: string } | null, workflow: { __typename: 'Workflow', id: string, envelopeStatus: EnvelopeStatus, isSignedOutsideAline: boolean, wasSentForSig: boolean } | null }> } };

export type RunCoreAiForDocumentsMutationVariables = Exact<{
  input: RunCoreAiForDocumentsInput;
}>;


export type RunCoreAiForDocumentsMutation = { __typename: 'Mutation', runCoreAiForDocuments: Array<{ __typename: 'Document', id: string, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null }> };

export type CancelExtractionJobsMutationVariables = Exact<{
  extractionJobIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type CancelExtractionJobsMutation = { __typename: 'Mutation', cancelExtractionJobs: Array<{ __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> }> };

export type UpdateExtractionJobMutationVariables = Exact<{
  input: UpdateExtractionJobInput;
}>;


export type UpdateExtractionJobMutation = { __typename: 'Mutation', updateExtractionJob: { __typename: 'ExtractionJob', id: string, answer: string, lockedAt: string | null, previousAnswer: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }> } };

export type RevertExtractionJobMutationVariables = Exact<{
  extractionJobId: Scalars['UUID'];
}>;


export type RevertExtractionJobMutation = { __typename: 'Mutation', revertExtractionJob: { __typename: 'ExtractionJob', id: string, answer: string, previousAnswer: string | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }> } };

export type ToggleExtractionJobsLockMutationVariables = Exact<{
  input: BulkLockExtractionJobsInput;
}>;


export type ToggleExtractionJobsLockMutation = { __typename: 'Mutation', toggleExtractionJobsLock: Array<{ __typename: 'ExtractionJob', id: string, lockedAt: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> };

export type ExtractionJobSimpleFragment = { __typename: 'ExtractionJob', id: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, createdAt: string, updatedAt: string, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, review: { __typename: 'ExtractionQuestionReview', reviewedAt: string, reviewAction: ReviewAction, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null };

export type DocLocationSimple_AlineLocation_Fragment = { __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string };

export type DocLocationSimple_FileLocation_Fragment = { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string };

export type DocLocationSimpleFragment = DocLocationSimple_AlineLocation_Fragment | DocLocationSimple_FileLocation_Fragment;

export type GetQuestionGenerationJobsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetQuestionGenerationJobsQuery = { __typename: 'Query', questionGenerationJobs: Array<{ __typename: 'ExtractionQuestionGenerationJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, extractionQuestions: Array<{ __typename: 'ExtractionQuestion', id: string, isActive: boolean, aiGenerated: boolean }> }> };

export type StartQuestionGenerationJobMutationVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type StartQuestionGenerationJobMutation = { __typename: 'Mutation', startQuestionGenerationJob: { __typename: 'ExtractionQuestionGenerationJob', id: string } };

export type CancelQuestionGenerationJobMutationVariables = Exact<{
  jobId: Scalars['UUID'];
}>;


export type CancelQuestionGenerationJobMutation = { __typename: 'Mutation', cancelQuestionGenerationJob: string };

export type AcceptGeneratedQuestionsMutationVariables = Exact<{
  generationJobId: Scalars['UUID'];
  input: AcceptGeneratedQuestionInput;
}>;


export type AcceptGeneratedQuestionsMutation = { __typename: 'Mutation', acceptGeneratedQuestions: { __typename: 'ExtractionQuestionGenerationJob', id: string } };

export type QuestionGenerationJobSimpleFragment = { __typename: 'ExtractionQuestionGenerationJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, extractionQuestions: Array<{ __typename: 'ExtractionQuestion', id: string, isActive: boolean, aiGenerated: boolean }> };

export type GetExtractionQuestionQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExtractionQuestionQuery = { __typename: 'Query', extractionQuestion: { __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> } | null };

export type GetExtractionQuestionWithInputsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExtractionQuestionWithInputsQuery = { __typename: 'Query', extractionQuestion: { __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, createdAt: string, updatedAt: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, inputs: Array<{ __typename: 'ExtractionQuestion', id: string, title: string }> } | null };

export type GetExtractionQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExtractionQuestionsQuery = { __typename: 'Query', extractionQuestions: Array<{ __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> }> };

export type GetDocExtractionQuestionQueryVariables = Exact<{
  extractionQuestionId: Scalars['UUID'];
  documentId: Scalars['UUID'];
}>;


export type GetDocExtractionQuestionQuery = { __typename: 'Query', extractionQuestion: { __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }>, extractionJob: { __typename: 'ExtractionJob', id: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, createdAt: string, updatedAt: string, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, review: { __typename: 'ExtractionQuestionReview', reviewedAt: string, reviewAction: ReviewAction, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }> } | null };

export type GetExtractionQuestionWithOptionsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExtractionQuestionWithOptionsQuery = { __typename: 'Query', extractionQuestion: { __typename: 'ExtractionQuestion', id: string, questionText: string, type: ExtractionQuestionType, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }> } | null };

export type GetExtractionQuestionWithDependenciesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExtractionQuestionWithDependenciesQuery = { __typename: 'Query', extractionQuestionWithDependencies: Array<{ __typename: 'ExtractionQuestion', id: string, contentHash: string | null }> };

export type GetExtractionQuestionsForDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetExtractionQuestionsForDocumentQuery = { __typename: 'Query', extractionQuestionsForDocument: { __typename: 'ExtractionQuestionForDocumentResponse', document: { __typename: 'Document', id: string, aiQuestionIdsQueueing: Array<string>, coreAiPropertiesExtractionFailedAt: string | null, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } }, extractionQuestions: Array<{ __typename: 'ExtractionQuestion', isActive: boolean, aiGenerated: boolean, id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, createdAt: string, updatedAt: string, extractionJob: { __typename: 'ExtractionJob', id: string, createdAt: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null } | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, question: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant }, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }> } | null, inputs: Array<{ __typename: 'ExtractionQuestion', id: string, title: string }>, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> }> } };

export type AddQuestionOptionsMutationVariables = Exact<{
  input: AddQuestionOptionsInput;
}>;


export type AddQuestionOptionsMutation = { __typename: 'Mutation', addQuestionOptions: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }> };

export type CreateExtractionQuestionMutationVariables = Exact<{
  input: CreateExtractionQuestionInput;
}>;


export type CreateExtractionQuestionMutation = { __typename: 'Mutation', createExtractionQuestion: { __typename: 'ExtractionQuestion', aiGenerated: boolean, isActive: boolean, id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, createdAt: string, updatedAt: string, inputs: Array<{ __typename: 'ExtractionQuestion', id: string, title: string }>, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> } };

export type DeleteQuestionOptionMutationVariables = Exact<{
  optionId: Scalars['UUID'];
}>;


export type DeleteQuestionOptionMutation = { __typename: 'Mutation', deleteQuestionOption: string };

export type DeleteExtractionQuestionMutationVariables = Exact<{
  extractionQuestionId: Scalars['UUID'];
}>;


export type DeleteExtractionQuestionMutation = { __typename: 'Mutation', deleteExtractionQuestion: string };

export type SetQuestionInputsMutationVariables = Exact<{
  input: SetQuestionInputsInput;
}>;


export type SetQuestionInputsMutation = { __typename: 'Mutation', setQuestionInputs: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, inputs: Array<{ __typename: 'ExtractionQuestion', id: string }> } };

export type SetQuestionContractTypesMutationVariables = Exact<{
  input: SetQuestionTypesInput;
}>;


export type SetQuestionContractTypesMutation = { __typename: 'Mutation', setQuestionContractTypes: { __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> } };

export type UpdateQuestionOptionMutationVariables = Exact<{
  input: UpdateQuestionOptionInput;
}>;


export type UpdateQuestionOptionMutation = { __typename: 'Mutation', updateQuestionOption: { __typename: 'QuestionOption', id: string, label: string, color: string, order: number } };

export type UpdateExtractionQuestionMutationVariables = Exact<{
  input: UpdateExtractionQuestionInput;
}>;


export type UpdateExtractionQuestionMutation = { __typename: 'Mutation', updateExtractionQuestion: { __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> } };

export type UpdateQuestionCategoryMutationVariables = Exact<{
  input: UpdateQuestionCategoryInput;
}>;


export type UpdateQuestionCategoryMutation = { __typename: 'Mutation', updateQuestionCategory: Array<{ __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> }> };

export type ExtractionQuestionSimpleFragment = { __typename: 'ExtractionQuestion', id: string, aiGuidance: string | null, category: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, title: string, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant, isActive: boolean, createdAt: string, updatedAt: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }>, contractTypes: Array<{ __typename: 'ContractType', id: string, value: string }> };

export type QuestionOptionSimpleFragment = { __typename: 'QuestionOption', id: string, label: string, color: string, order: number };

export type GetReportQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportQuestionsQuery = { __typename: 'Query', extractionQuestions: Array<{ __typename: 'ExtractionQuestion', id: string, contentHash: string | null, inputFileFields: Array<ReportColumnFileField>, mode: ExtractionQuestionMode, questionText: string, type: ExtractionQuestionType, variant: ExtractionQuestionVariant, inputs: Array<{ __typename: 'ExtractionQuestion', id: string }> }> };

export type GetFieldQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetFieldQuery = { __typename: 'Query', field: { __typename: 'DocumentVariable', label: string, question: string, id: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } } | { __typename: 'SignatureField', id: string, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null } | null };

export type GetDbFieldsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDbFieldsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, variables: Array<{ __typename: 'DocumentVariable', id: string, isField: boolean, label: string, nodeId: string, question: string, minRequired: number, maxRequired: number | null, skipped: boolean, value: string | null, variant: MetadataVariant, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null }, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null }>, signatureFields: Array<{ __typename: 'SignatureField', id: string, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }> } };

export type GetFieldWithActionQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetFieldWithActionQuery = { __typename: 'Query', field: { __typename: 'DocumentVariable', id: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null } | { __typename: 'SignatureField', id: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null } | null };

export type FieldActionSimple_DocumentVariable_Fragment = { __typename: 'DocumentVariable', action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null };

export type FieldActionSimple_SignatureField_Fragment = { __typename: 'SignatureField', action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null };

export type FieldActionSimpleFragment = FieldActionSimple_DocumentVariable_Fragment | FieldActionSimple_SignatureField_Fragment;

export type FieldSimple_DocumentVariable_Fragment = { __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null };

export type FieldSimple_SignatureField_Fragment = { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null };

export type FieldSimpleFragment = FieldSimple_DocumentVariable_Fragment | FieldSimple_SignatureField_Fragment;

export type FieldInfo_DocumentVariable_Fragment = { __typename: 'DocumentVariable', id: string, isField: boolean, nodeId: string, variant: MetadataVariant, label: string, question: string, minRequired: number, maxRequired: number | null, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null };

export type FieldInfo_SignatureField_Fragment = { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null };

export type FieldInfoFragment = FieldInfo_DocumentVariable_Fragment | FieldInfo_SignatureField_Fragment;

export type CreateSignatureFieldMutationVariables = Exact<{
  input: CreateSignatureFieldInput;
}>;


export type CreateSignatureFieldMutation = { __typename: 'Mutation', createSignatureField: { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null } };

export type DisableSignatureFieldMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DisableSignatureFieldMutation = { __typename: 'Mutation', disableSignatureField: { __typename: 'SignatureField', id: string, deletedAt: string | null } };

export type UpdateSignatureFieldMutationVariables = Exact<{
  input: UpdateSignatureFieldInput;
}>;


export type UpdateSignatureFieldMutation = { __typename: 'Mutation', updateSignatureField: { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null } };

export type SignatureFieldSimpleFragment = { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null };

export type SignatureFieldBaseFragment = { __typename: 'SignatureField', id: string, nodeId: string, createdAt: string, updatedAt: string, deletedAt: string | null, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, document: { __typename: 'Document', id: string } };

export type InboxNotificationSimpleFragment = { __typename: 'InboxNotification', id: string, kind: InboxNotificationKind, severity: InboxNotificationSeverity, payload: { [key: string]: any }, read: boolean, createdAt: string };

export type InboxNotificationsResultSimpleFragment = { __typename: 'InboxNotificationsResult', unreadCount: number, items: Array<{ __typename: 'InboxNotification', id: string, kind: InboxNotificationKind, severity: InboxNotificationSeverity, payload: { [key: string]: any }, read: boolean, createdAt: string }> };

export type GetInboxNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInboxNotificationsQuery = { __typename: 'Query', inboxNotifications: { __typename: 'InboxNotificationsResult', unreadCount: number, items: Array<{ __typename: 'InboxNotification', id: string, kind: InboxNotificationKind, severity: InboxNotificationSeverity, payload: { [key: string]: any }, read: boolean, createdAt: string }> } };

export type MarkInboxNotificationsReadMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type MarkInboxNotificationsReadMutation = { __typename: 'Mutation', markInboxNotificationsRead: { __typename: 'InboxNotificationsResult', unreadCount: number, items: Array<{ __typename: 'InboxNotification', id: string, kind: InboxNotificationKind, severity: InboxNotificationSeverity, payload: { [key: string]: any }, read: boolean, createdAt: string }> } };

export type MarkInboxNotificationsUnreadMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type MarkInboxNotificationsUnreadMutation = { __typename: 'Mutation', markInboxNotificationsUnread: { __typename: 'InboxNotificationsResult', unreadCount: number, items: Array<{ __typename: 'InboxNotification', id: string, kind: InboxNotificationKind, severity: InboxNotificationSeverity, payload: { [key: string]: any }, read: boolean, createdAt: string }> } };

export type DismissInboxNotificationMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DismissInboxNotificationMutation = { __typename: 'Mutation', dismissInboxNotification: { __typename: 'InboxNotificationsResult', unreadCount: number, items: Array<{ __typename: 'InboxNotification', id: string, kind: InboxNotificationKind, severity: InboxNotificationSeverity, payload: { [key: string]: any }, read: boolean, createdAt: string }> } };

export type OnInboxNotificationsChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnInboxNotificationsChangedSubscription = { __typename: 'Subscription', inboxNotificationsChanged: { __typename: 'InboxNotificationsChangedEvent', orgId: string } };

export type IntakeFormTemplateFullFragment = { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } };

export type IntakeFormFullFragment = { __typename: 'IntakeForm', id: string, workflowId: string, sourceIntakeFormTemplateId: string | null, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, values: { [key: string]: any }, missingFileDocumentIds: Array<string>, completedAt: string | null, completedBy: { __typename: 'User', id: string } | null };

export type IntakeFormTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type IntakeFormTemplatesQuery = { __typename: 'Query', intakeFormTemplates: Array<{ __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } }> };

export type IntakeFormTemplateQueryVariables = Exact<{
  intakeFormTemplateId: Scalars['UUID'];
}>;


export type IntakeFormTemplateQuery = { __typename: 'Query', intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } | null };

export type IntakeFormTemplateAttachedWorkflowsQueryVariables = Exact<{
  intakeFormTemplateId: Scalars['UUID'];
}>;


export type IntakeFormTemplateAttachedWorkflowsQuery = { __typename: 'Query', intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, attachedWorkflows: Array<{ __typename: 'Workflow', id: string, name: string }> } | null };

export type WorkflowIntakeFormQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type WorkflowIntakeFormQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, state: WorkflowState, isReadyForSignature: { __typename: 'WorkflowReadyForSignature', ready: boolean, notReadyReasons: Array<WorkflowNotReadyForSigReason> }, intakeForm: { __typename: 'IntakeForm', id: string, workflowId: string, sourceIntakeFormTemplateId: string | null, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, values: { [key: string]: any }, missingFileDocumentIds: Array<string>, completedAt: string | null, completedBy: { __typename: 'User', id: string } | null } | null, intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } | null, intakeFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, type: AlineFieldType, required: boolean, order: number, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }>, files: Array<{ __typename: 'WorkflowFile', document: { __typename: 'Document', id: string, name: string } }> } | null };

export type CreateIntakeFormTemplateMutationVariables = Exact<{
  input: CreateIntakeFormTemplateInput;
}>;


export type CreateIntakeFormTemplateMutation = { __typename: 'Mutation', createIntakeFormTemplate: { __typename: 'IntakeFormTemplateResponse', intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } } };

export type UpdateIntakeFormTemplateMutationVariables = Exact<{
  input: UpdateIntakeFormTemplateInput;
}>;


export type UpdateIntakeFormTemplateMutation = { __typename: 'Mutation', updateIntakeFormTemplate: { __typename: 'IntakeFormTemplateResponse', intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } } };

export type DeleteIntakeFormTemplateMutationVariables = Exact<{
  intakeFormTemplateId: Scalars['UUID'];
}>;


export type DeleteIntakeFormTemplateMutation = { __typename: 'Mutation', deleteIntakeFormTemplate: string };

export type AttachIntakeFormTemplateMutationVariables = Exact<{
  input: AttachIntakeFormTemplateInput;
}>;


export type AttachIntakeFormTemplateMutation = { __typename: 'Mutation', attachIntakeFormTemplate: { __typename: 'WorkflowIntakeFormTemplateResponse', workflow: { __typename: 'Workflow', id: string, intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } | null } } };

export type DetachIntakeFormTemplateMutationVariables = Exact<{
  input: DetachIntakeFormTemplateInput;
}>;


export type DetachIntakeFormTemplateMutation = { __typename: 'Mutation', detachIntakeFormTemplate: { __typename: 'WorkflowIntakeFormTemplateResponse', workflow: { __typename: 'Workflow', id: string, intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } | null } } };

export type UpdateIntakeFormValuesMutationVariables = Exact<{
  input: UpdateIntakeFormValuesInput;
  refreshReadiness?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateIntakeFormValuesMutation = { __typename: 'Mutation', updateIntakeFormValues: { __typename: 'IntakeFormResponse', intakeForm: { __typename: 'IntakeForm', id: string, workflowId: string, sourceIntakeFormTemplateId: string | null, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, values: { [key: string]: any }, missingFileDocumentIds: Array<string>, completedAt: string | null, completedBy: { __typename: 'User', id: string } | null }, workflow: { __typename: 'Workflow', id: string, isReadyForSignature?: { __typename: 'WorkflowReadyForSignature', ready: boolean, notReadyReasons: Array<WorkflowNotReadyForSigReason> }, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }> } } };

export type GetCrmConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCrmConnectionsQuery = { __typename: 'Query', apiDeckConnections: Array<{ __typename: 'ApiDeckConnection', id: string, integration: Integration, icon: string, name: string | null, tagLine: string | null, enabled: boolean | null, state: ApiDeckConnectionState | null }> };

export type GetIntegrationOpportunitiesQueryVariables = Exact<{
  serviceId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OpportunityFilterInput>;
}>;


export type GetIntegrationOpportunitiesQuery = { __typename: 'Query', integrationOpportunities: { __typename: 'ApiDeckOpportunitiesResponse', nextCursor: string | null, opportunities: Array<{ __typename: 'ApiDeckOpportunity', id: string, type: string | null, title: string | null }> } };

export type GetOpportunityQueryVariables = Exact<{
  opportunityId: Scalars['String'];
  serviceId: Scalars['String'];
  workflowId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetOpportunityQuery = { __typename: 'Query', apiDeckOpportunity: { __typename: 'ApiDeckOpportunityWithRelations', id: string, title: string | null, type: string | null, tags: Array<string> | null, fields: Array<{ __typename: 'IntegrationField', category: CrmIntegrationCategory, fieldApiName: string | null, groupDisplayName: string, groupSortIndex: number, isCustom: boolean, objectType: SalesforceFieldObjectType | null, path: string, recordId: string | null, title: string, type: IntegrationFieldType, value: string | null, valueStatus: IntegrationFieldValueStatus, variant: IntegrationFieldVariant }> } | null };

export type GetOpportunitySimpleQueryVariables = Exact<{
  opportunityId: Scalars['String'];
  serviceId: Scalars['String'];
}>;


export type GetOpportunitySimpleQuery = { __typename: 'Query', apiDeckOpportunity: { __typename: 'ApiDeckOpportunityWithRelations', id: string, title: string | null } | null };

export type GetConsumerConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConsumerConnectionsQuery = { __typename: 'Query', apiDeckConsumer: { __typename: 'ApiDeckConsumer', apiDeckConnections: Array<{ __typename: 'ApiDeckConnection', id: string, integration: Integration, icon: string, name: string | null, tagLine: string | null, enabled: boolean | null, state: ApiDeckConnectionState | null }> } | null };

export type GetIntegrationFieldQueryVariables = Exact<{
  input: IntegrationFieldInput;
}>;


export type GetIntegrationFieldQuery = { __typename: 'Query', integrationField: { __typename: 'IntegrationField', category: CrmIntegrationCategory, fieldApiName: string | null, groupDisplayName: string, groupSortIndex: number, isCustom: boolean, objectType: SalesforceFieldObjectType | null, path: string, recordId: string | null, title: string, type: IntegrationFieldType, value: string | null, valueStatus: IntegrationFieldValueStatus, variant: IntegrationFieldVariant } | null };

export type CreateApideckSessionMutationVariables = Exact<{
  unifiedApi?: ApiDeckUnifiedApi;
}>;


export type CreateApideckSessionMutation = { __typename: 'Mutation', createApiDeckSession: { __typename: 'ApiDeckSession', expiresAt: string, sessionToken: string } };

export type PairCrmTenantMutationVariables = Exact<{
  integration: Integration;
}>;


export type PairCrmTenantMutation = { __typename: 'Mutation', pairCrmTenant: { __typename: 'CrmPairing', id: string } };

export type SyncCrmPairingMutationVariables = Exact<{
  integration: Integration;
}>;


export type SyncCrmPairingMutation = { __typename: 'Mutation', syncCrmPairing: { __typename: 'CrmPairing', id: string } | null };

export type RotateCrmSigningSecretMutationVariables = Exact<{
  integration: Integration;
}>;


export type RotateCrmSigningSecretMutation = { __typename: 'Mutation', rotateCrmSigningSecret: { __typename: 'CrmPairing', id: string, integration: Integration, crmTenantId: string, secretScope: CrmSecretScope, lastRejectedRequestAt: string | null, lastVerifiedRequestAt: string | null, secretDeliveredAt: string | null, secretDeliveryError: string | null } };

export type PushCrmSigningSecretMutationVariables = Exact<{
  integration: Integration;
}>;


export type PushCrmSigningSecretMutation = { __typename: 'Mutation', pushCrmSigningSecret: { __typename: 'CrmPairing', id: string, integration: Integration, crmTenantId: string, secretScope: CrmSecretScope, lastRejectedRequestAt: string | null, lastVerifiedRequestAt: string | null, secretDeliveredAt: string | null, secretDeliveryError: string | null } };

export type SetCrmAppSecretMutationVariables = Exact<{
  integration: Integration;
  secret: Scalars['String'];
}>;


export type SetCrmAppSecretMutation = { __typename: 'Mutation', setCrmAppSecret: boolean };

export type CrmPairingKeyStatusFragment = { __typename: 'CrmPairing', id: string, integration: Integration, crmTenantId: string, secretScope: CrmSecretScope, lastRejectedRequestAt: string | null, lastVerifiedRequestAt: string | null, secretDeliveredAt: string | null, secretDeliveryError: string | null };

export type ApiDeckConnectionSimpleFragment = { __typename: 'ApiDeckConnection', id: string, integration: Integration, icon: string, name: string | null, tagLine: string | null, enabled: boolean | null, state: ApiDeckConnectionState | null };

export type IntegrationFieldSimpleFragment = { __typename: 'IntegrationField', category: CrmIntegrationCategory, fieldApiName: string | null, groupDisplayName: string, groupSortIndex: number, isCustom: boolean, objectType: SalesforceFieldObjectType | null, path: string, recordId: string | null, title: string, type: IntegrationFieldType, value: string | null, valueStatus: IntegrationFieldValueStatus, variant: IntegrationFieldVariant };

export type GetChannelInstallationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChannelInstallationsQuery = { __typename: 'Query', channelInstallations: Array<{ __typename: 'ChannelInstallation', id: string, orgId: string, provider: ChannelProvider, externalAccountId: string, displayName: string | null, installedAt: string | null, status: ChannelInstallationStatus, createdAt: string, appInstallUrl: string | null, requiresReauthorization: boolean }> };

export type DisconnectChannelInstallationMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DisconnectChannelInstallationMutation = { __typename: 'Mutation', disconnectChannelInstallation: boolean };

export type ChannelInstallationSimpleFragment = { __typename: 'ChannelInstallation', id: string, orgId: string, provider: ChannelProvider, externalAccountId: string, displayName: string | null, installedAt: string | null, status: ChannelInstallationStatus, createdAt: string, appInstallUrl: string | null, requiresReauthorization: boolean };

export type HasDocuSignAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type HasDocuSignAuthQuery = { __typename: 'Query', hasDocuSignAuth: { __typename: 'DocuSignIntegratedResponse', hasDocuSignIntegration: boolean } };

export type IntegrateDocuSignForOrgMutationVariables = Exact<{
  docuSignApiId: Scalars['UUID'];
}>;


export type IntegrateDocuSignForOrgMutation = { __typename: 'Mutation', integrateDocuSignForOrg: { __typename: 'CSRFToken', token: string, expiresAt: string } };

export type IntegrateDocuSignForUserMutationVariables = Exact<{
  docuSignApiId: Scalars['UUID'];
}>;


export type IntegrateDocuSignForUserMutation = { __typename: 'Mutation', integrateDocuSignForUser: { __typename: 'CSRFToken', token: string, expiresAt: string } };

export type DeleteDocuSignIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteDocuSignIntegrationMutation = { __typename: 'Mutation', deleteDocuSignIntegration: { __typename: 'DocuSignIntegratedResponse', hasDocuSignIntegration: boolean } };

export type CreateDraftEnvelopeMutationVariables = Exact<{
  input: CreateDraftEnvelopeInput;
}>;


export type CreateDraftEnvelopeMutation = { __typename: 'Mutation', createDraftEnvelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, docuSignUri: string | null, title: string, statusDateTime: string, variant: EnvelopeVariant, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, workflow: { __typename: 'Workflow', id: string, createdAt: string, envelopeMsg: string | null, envelopeStatus: EnvelopeStatus, name: string, requesterInOwnerOrg: boolean, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, column: { __typename: 'Column', id: string, name: string }, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, envelope: { __typename: 'Envelope', id: string, completedAt: string | null, docuSignEnvelopeId: string | null, variant: EnvelopeVariant } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, owner: { __typename: 'User', id: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type GetExternalToolkitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalToolkitsQuery = { __typename: 'Query', externalToolkits: Array<{ __typename: 'ExternalToolkit', environmentAvailable: boolean, accountLabel: string | null, allowedByOrg: boolean, catalogueAvailable: boolean, enabledCount: number, name: string, slug: ExternalToolkitSlug, status: ExternalToolkitConnectionStatus, tools: Array<{ __typename: 'ExternalTool', description: string | null, enabled: boolean, mutates: boolean, name: string, slug: string }> }> };

export type GetExternalToolkitPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalToolkitPoliciesQuery = { __typename: 'Query', externalToolkitPolicies: Array<{ __typename: 'ExternalToolkitPolicyRow', allowed: boolean, name: string, slug: ExternalToolkitSlug, usersWithGrants: number }> };

export type ConnectExternalToolkitMutationVariables = Exact<{
  toolkit: ExternalToolkitSlug;
}>;


export type ConnectExternalToolkitMutation = { __typename: 'Mutation', connectExternalToolkit: { __typename: 'ExternalToolkitConnectRequest', redirectUrl: string } };

export type DisconnectExternalToolkitMutationVariables = Exact<{
  toolkit: ExternalToolkitSlug;
}>;


export type DisconnectExternalToolkitMutation = { __typename: 'Mutation', disconnectExternalToolkit: boolean };

export type SetExternalToolkitPolicyMutationVariables = Exact<{
  toolkit: ExternalToolkitSlug;
  allowed: Scalars['Boolean'];
}>;


export type SetExternalToolkitPolicyMutation = { __typename: 'Mutation', setExternalToolkitPolicy: { __typename: 'ExternalToolkit', environmentAvailable: boolean, accountLabel: string | null, allowedByOrg: boolean, catalogueAvailable: boolean, enabledCount: number, name: string, slug: ExternalToolkitSlug, status: ExternalToolkitConnectionStatus, tools: Array<{ __typename: 'ExternalTool', description: string | null, enabled: boolean, mutates: boolean, name: string, slug: string }> } };

export type SetExternalToolGrantMutationVariables = Exact<{
  toolkit: ExternalToolkitSlug;
  toolSlug: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type SetExternalToolGrantMutation = { __typename: 'Mutation', setExternalToolGrant: { __typename: 'ExternalToolkit', environmentAvailable: boolean, accountLabel: string | null, allowedByOrg: boolean, catalogueAvailable: boolean, enabledCount: number, name: string, slug: ExternalToolkitSlug, status: ExternalToolkitConnectionStatus, tools: Array<{ __typename: 'ExternalTool', description: string | null, enabled: boolean, mutates: boolean, name: string, slug: string }> } };

export type SetExternalToolGrantsMutationVariables = Exact<{
  toolkit: ExternalToolkitSlug;
  toolSlugs: Array<Scalars['String']> | Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type SetExternalToolGrantsMutation = { __typename: 'Mutation', setExternalToolGrants: { __typename: 'ExternalToolkit', environmentAvailable: boolean, accountLabel: string | null, allowedByOrg: boolean, catalogueAvailable: boolean, enabledCount: number, name: string, slug: ExternalToolkitSlug, status: ExternalToolkitConnectionStatus, tools: Array<{ __typename: 'ExternalTool', description: string | null, enabled: boolean, mutates: boolean, name: string, slug: string }> } };

export type ExternalToolkitSimpleFragment = { __typename: 'ExternalToolkit', environmentAvailable: boolean, accountLabel: string | null, allowedByOrg: boolean, catalogueAvailable: boolean, enabledCount: number, name: string, slug: ExternalToolkitSlug, status: ExternalToolkitConnectionStatus, tools: Array<{ __typename: 'ExternalTool', description: string | null, enabled: boolean, mutates: boolean, name: string, slug: string }> };

export type ExternalToolkitPolicyRowSimpleFragment = { __typename: 'ExternalToolkitPolicyRow', allowed: boolean, name: string, slug: ExternalToolkitSlug, usersWithGrants: number };

export type GetFolderSyncJobQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetFolderSyncJobQuery = { __typename: 'Query', folderSyncJob: { __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } | null };

export type GetFolderSyncJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFolderSyncJobsQuery = { __typename: 'Query', folderSyncJobs: Array<{ __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> }> };

export type GetDrivesQueryVariables = Exact<{
  integration: FileStorageIntegration;
}>;


export type GetDrivesQuery = { __typename: 'Query', drives: Array<{ __typename: 'Drive', id: string, name: string, integration: FileStorageIntegration }> };

export type GetFileStorageConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFileStorageConnectionsQuery = { __typename: 'Query', fileStorageConnections: Array<{ __typename: 'FileStorageConnection', id: string, name: string, state: ApiDeckConnectionState | null, serviceId: FileStorageIntegration, description: string | null, imageUrl: string }> };

export type GetConnectionFolderFilesQueryVariables = Exact<{
  integration: FileStorageIntegration;
  driveId: Scalars['String'];
  folderId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetConnectionFolderFilesQuery = { __typename: 'Query', connectionFolderFiles: { __typename: 'ConnectionFolderFilesPage', files: Array<{ __typename: 'FolderFile', id: string, name: string, path: string | null, size: number | null, type: FileType | null, mimeType: string | null }>, meta: { __typename: 'ConnectionFolderFilesMeta', hasMore: boolean, nextCursor: string | null } } };

export type GetConnectionFilesSearchQueryVariables = Exact<{
  integration: FileStorageIntegration;
  query: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  driveId?: InputMaybe<Scalars['String']>;
}>;


export type GetConnectionFilesSearchQuery = { __typename: 'Query', connectionFilesSearch: Array<{ __typename: 'FolderFile', id: string, name: string, path: string | null, size: number | null, type: FileType | null, mimeType: string | null }> };

export type GetIntegrationFolderSyncJobsQueryVariables = Exact<{
  integration: FileStorageIntegration;
}>;


export type GetIntegrationFolderSyncJobsQuery = { __typename: 'Query', folderSyncJobsForConnection: Array<{ __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, driveId: string, driveName: string, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> }> };

export type BulkCreateFolderSyncJobsMutationVariables = Exact<{
  input: BulkCreateFolderSyncJobInput;
}>;


export type BulkCreateFolderSyncJobsMutation = { __typename: 'Mutation', bulkCreateFolderSyncJobs: { __typename: 'BulkCreateFolderSyncJobResult', deletedFolderSyncJobIds: Array<string>, createdJobs: Array<{ __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> }> } };

export type DeleteFolderSyncJobsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type DeleteFolderSyncJobsMutation = { __typename: 'Mutation', deleteFolderSyncJobs: Array<string> };

export type DismissFailedFilesMutationVariables = Exact<{
  folderSyncJobId: Scalars['UUID'];
  fileIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type DismissFailedFilesMutation = { __typename: 'Mutation', dismissFailedFiles: { __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type TriggerFolderSyncScheduleMutationVariables = Exact<{
  folderSyncJobId: Scalars['UUID'];
}>;


export type TriggerFolderSyncScheduleMutation = { __typename: 'Mutation', triggerFolderSyncSchedule: { __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type RetryFolderSyncFailedFilesMutationVariables = Exact<{
  folderSyncJobId: Scalars['UUID'];
}>;


export type RetryFolderSyncFailedFilesMutation = { __typename: 'Mutation', retryFolderSyncFailedFiles: { __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type SetFolderSyncJobLabelsMutationVariables = Exact<{
  folderSyncJobId: Scalars['UUID'];
  labelIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type SetFolderSyncJobLabelsMutation = { __typename: 'Mutation', setFolderSyncJobLabels: { __typename: 'FolderSyncJob', id: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type SetFolderSyncJobAllowedMimeTypesMutationVariables = Exact<{
  folderSyncJobId: Scalars['UUID'];
  allowedMimeTypes: Array<Scalars['String']> | Scalars['String'];
}>;


export type SetFolderSyncJobAllowedMimeTypesMutation = { __typename: 'Mutation', setFolderSyncJobAllowedMimeTypes: { __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type StopFolderSyncJobMutationVariables = Exact<{
  folderSyncJobId: Scalars['UUID'];
}>;


export type StopFolderSyncJobMutation = { __typename: 'Mutation', stopFolderSyncJob: { __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type OnFolderSyncJobUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnFolderSyncJobUpdateSubscription = { __typename: 'Subscription', folderSyncJobUpdate: { __typename: 'FolderSyncJobUpdatedEvent', folderSyncJobIds: Array<string>, deletedFolderSyncJobIds: Array<string>, folderSyncJobs: Array<{ __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> }> } };

export type FolderSyncJobSimpleFragment = { __typename: 'FolderSyncJob', id: string, folderId: string, folderName: string | null, integration: FileStorageIntegration, syncStartedAt: string, syncFinishedAt: string | null, completedIds: Array<string>, driveId: string, driveName: string, storageIntegrationIds: Array<string>, allowedMimeTypes: Array<string>, createdAt: string | null, failedFiles: Array<{ __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> };

export type DriveSimpleFragment = { __typename: 'Drive', id: string, name: string, integration: FileStorageIntegration };

export type FolderFileSimpleFragment = { __typename: 'FolderFile', id: string, name: string, path: string | null, size: number | null, type: FileType | null, mimeType: string | null };

export type FailedFileSimpleFragment = { __typename: 'FailedFile', fileId: string, fileName: string, failedReason: string, failedAt: string, isDimissed: boolean, mimeType: string | null };

export type GenerateAiCompletionMutationVariables = Exact<{
  input: GenerateAiCompletionInput;
}>;


export type GenerateAiCompletionMutation = { __typename: 'Mutation', generateAICompletion: { __typename: 'CompletionResponse', succeeded: boolean } };

export type OnCompletionReceivedSubscriptionVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type OnCompletionReceivedSubscription = { __typename: 'Subscription', completionReceived: { __typename: 'CompletionEvent', documentId: string, position: CompletionPosition, completion: { __typename: 'Completion', id: string, text: string, prompt: string, completionType: AiCompletionType } } };

export type CompletionFullFragment = { __typename: 'Completion', id: string, text: string, prompt: string, completionType: AiCompletionType };

export type ImprovePromptMutationVariables = Exact<{
  input: ImprovePromptInput;
}>;


export type ImprovePromptMutation = { __typename: 'Mutation', improvePrompt: { __typename: 'ImprovePromptResponse', requestId: string } };

export type OnImprovedPromptSubscriptionVariables = Exact<{
  requestId: Scalars['UUID'];
}>;


export type OnImprovedPromptSubscription = { __typename: 'Subscription', onImprovedPrompt: { __typename: 'ImprovedPromptEvent', requestId: string, improvedText: string, userId: string, position: CompletionPosition } };

export type GetLabelQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetLabelQuery = { __typename: 'Query', label: { __typename: 'Label', id: string, labelText: string } | null };

export type GetWorkflowLabelsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowLabelsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } | null };

export type GetDocumentLabelsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentLabelsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type GetUserLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLabelsQuery = { __typename: 'Query', labels: Array<{ __typename: 'Label', id: string, labelText: string }> };

export type GetLabelByNameQueryVariables = Exact<{
  labelText: Scalars['String'];
}>;


export type GetLabelByNameQuery = { __typename: 'Query', labelByName: { __typename: 'Label', id: string, labelText: string } | null };

export type GetDocumentLabelStateQueryVariables = Exact<{
  input: DocumentLabelStateInput;
}>;


export type GetDocumentLabelStateQuery = { __typename: 'Query', documentLabelStates: Array<{ __typename: 'LabelWithDocumentState', id: string, labelText: string, state: DocumentLabelState }> };

export type FindOrCreateLabelMutationVariables = Exact<{
  labelText: Scalars['String'];
}>;


export type FindOrCreateLabelMutation = { __typename: 'Mutation', findOrCreateLabel: { __typename: 'Label', id: string, labelText: string } };

export type SetWorkflowLabelsMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
  labelIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type SetWorkflowLabelsMutation = { __typename: 'Mutation', setWorkflowLabels: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } } };

export type SetDocumentLabelsMutationVariables = Exact<{
  documentId: Scalars['UUID'];
  labelIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type SetDocumentLabelsMutation = { __typename: 'Mutation', setDocumentLabels: { __typename: 'Document', id: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type BulkSetDocumentLabelsMutationVariables = Exact<{
  input: BulkSetDocumentLabelsInput;
}>;


export type BulkSetDocumentLabelsMutation = { __typename: 'Mutation', bulkSetDocumentLabels: { __typename: 'UpdateDocumentsResponse', numSuccess: number, numSkipped: number, documents: Array<{ __typename: 'Document', id: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> }> } };

export type DeleteLabelMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteLabelMutation = { __typename: 'Mutation', deleteLabel: string };

export type LabelSimpleFragment = { __typename: 'Label', id: string, labelText: string };

export type WorkflowLabelFullFragment = { __typename: 'Label', id: string, labelText: string, workflows: Array<{ __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> }> };

export type GetMyMentionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyMentionsQuery = { __typename: 'Query', myMentions: Array<{ __typename: 'Mention', id: string, notifiedAt: string | null, notificationRead: boolean, comment: { __typename: 'Comment', id: string, text: string }, mentionedUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type ActivitySubscribersFieldsFragment = { __typename: 'ActivitySubscriptionToggleResult', viewerSubscribed: boolean, subscribers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> };

export type GetTaskSubscribersQueryVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type GetTaskSubscribersQuery = { __typename: 'Query', task: { __typename: 'Task', id: string, viewerSubscribed: boolean, viewerSubscriptionLocked: boolean, subscribers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | null };

export type GetWorkflowSubscribersQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowSubscribersQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, viewerSubscribed: boolean, viewerSubscriptionLocked: boolean, subscribers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | null };

export type ActivitySubscriberOptionFieldsFragment = { __typename: 'ActivitySubscriberOption', subscribed: boolean, lockReason: ActivitySubscriberLockReason | null, user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } };

export type GetTaskSubscriberOptionsQueryVariables = Exact<{
  taskId: Scalars['UUID'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTaskSubscriberOptionsQuery = { __typename: 'Query', task: { __typename: 'Task', id: string, subscriberOptions: Array<{ __typename: 'ActivitySubscriberOption', subscribed: boolean, lockReason: ActivitySubscriberLockReason | null, user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } | null };

export type GetWorkflowSubscriberOptionsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkflowSubscriberOptionsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, subscriberOptions: Array<{ __typename: 'ActivitySubscriberOption', subscribed: boolean, lockReason: ActivitySubscriberLockReason | null, user: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } | null };

export type SubscribeToActivityMutationVariables = Exact<{
  input: ActivitySubscriptionInput;
}>;


export type SubscribeToActivityMutation = { __typename: 'Mutation', subscribeToActivity: { __typename: 'ActivitySubscriptionToggleResult', viewerSubscribed: boolean, subscribers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } };

export type UnsubscribeFromActivityMutationVariables = Exact<{
  input: ActivitySubscriptionInput;
}>;


export type UnsubscribeFromActivityMutation = { __typename: 'Mutation', unsubscribeFromActivity: { __typename: 'ActivitySubscriptionToggleResult', viewerSubscribed: boolean, subscribers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } };

export type GetPartiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartiesQuery = { __typename: 'Query', parties: Array<{ __typename: 'Party', documentCount: number, id: string, description: string, name: string }> };

export type GetPartyRowsQueryVariables = Exact<{
  sortModel?: InputMaybe<Scalars['JSON']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  cursor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPartyRowsQuery = { __typename: 'Query', partyRows: { __typename: 'PartyRowsInfo', rows: Array<{ __typename: 'Party', documentCount: number, id: string, description: string, name: string }>, meta: { __typename: 'PartiesMeta', totalCount: number, hasMore: boolean } } };

export type SearchPartiesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchPartiesQuery = { __typename: 'Query', searchParties: Array<{ __typename: 'Party', id: string, name: string }> };

export type GetPartyQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPartyQuery = { __typename: 'Query', party: { __typename: 'Party', id: string, description: string, name: string } | null };

export type GetPartyWithDocumentCountQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPartyWithDocumentCountQuery = { __typename: 'Query', party: { __typename: 'Party', id: string, name: string, description: string, documentCount: number } | null };

export type GetDocumentWithPartiesQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentWithPartiesQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }> } };

export type GetWorkflowWithPartiesQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowWithPartiesQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }>, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }> } | null };

export type GetPartyDocumentsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPartyDocumentsQuery = { __typename: 'Query', party: { __typename: 'Party', id: string, description: string, name: string, documents: Array<{ __typename: 'Document', id: string, name: string, requesterFavorited: boolean, requesterRole: PermissionRole | null, status: DocumentStatus | null, variant: DocumentVariant, isCommunityTemplate: boolean, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, type: { __typename: 'ContractType', id: string, value: string } | null, workflow: { __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant } | null }> } | null };

export type GetPartyWorkflowsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPartyWorkflowsQuery = { __typename: 'Query', party: { __typename: 'Party', id: string, description: string, name: string, workflows: Array<{ __typename: 'Workflow', id: string, fileCount: number, name: string, state: WorkflowState, variant: WorkflowVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } | null };

export type CreatePartyMutationVariables = Exact<{
  input: CreatePartyInput;
}>;


export type CreatePartyMutation = { __typename: 'Mutation', createParty: { __typename: 'Party', id: string, description: string, name: string } };

export type DeletePartyMutationVariables = Exact<{
  partyId: Scalars['UUID'];
}>;


export type DeletePartyMutation = { __typename: 'Mutation', deleteParty: string };

export type UpdatePartyMutationVariables = Exact<{
  input: UpdatePartyInput;
}>;


export type UpdatePartyMutation = { __typename: 'Mutation', updateParty: { __typename: 'Party', id: string, description: string, name: string } };

export type AddPartyToDocumentMutationVariables = Exact<{
  input: AddPartyToDocumentInput;
}>;


export type AddPartyToDocumentMutation = { __typename: 'Mutation', addPartyToDocument: { __typename: 'Party', id: string, description: string, name: string } };

export type RemovePartyFromDocumentMutationVariables = Exact<{
  input: RemovePartyFromDocumentInput;
}>;


export type RemovePartyFromDocumentMutation = { __typename: 'Mutation', removePartyFromDocument: { __typename: 'Party', id: string, description: string, name: string } };

export type SetWorkflowPartiesMutationVariables = Exact<{
  input: SetWorkflowPartiesInput;
}>;


export type SetWorkflowPartiesMutation = { __typename: 'Mutation', setWorkflowParties: { __typename: 'Workflow', id: string, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, parties: Array<{ __typename: 'Party', id: string, name: string }> } }>, parties: Array<{ __typename: 'Party', id: string, name: string }> } };

export type SetDocumentPartiesMutationVariables = Exact<{
  input: SetDocumentPartiesInput;
}>;


export type SetDocumentPartiesMutation = { __typename: 'Mutation', setDocumentParties: { __typename: 'Document', id: string, parties: Array<{ __typename: 'Party', id: string, name: string }> } };

export type BulkDeletePartiesMutationVariables = Exact<{
  input: BulkDeletePartiesInput;
}>;


export type BulkDeletePartiesMutation = { __typename: 'Mutation', bulkDeleteParties: Array<string> };

export type MergePartiesMutationVariables = Exact<{
  input: MergePartiesInput;
}>;


export type MergePartiesMutation = { __typename: 'Mutation', mergeParties: { __typename: 'Party', id: string, name: string, documentCount: number } };

export type PartySimpleFragment = { __typename: 'Party', id: string, description: string, name: string };

export type GetPhaseQueryVariables = Exact<{
  phaseId: Scalars['UUID'];
}>;


export type GetPhaseQuery = { __typename: 'Query', phase: { __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | null };

export type GetWorkflowPhasesQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowPhasesQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, aiCancelledAt: string | null, aiFailedAt: string | null, aiFailureReason: string | null, aiFinishedAt: string | null, aiStartedAt: string | null, state: WorkflowState, variant: WorkflowVariant, createdAt: string, startedAt: string | null, completedAt: string | null, boardId: string, intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } | null, intakeForm: { __typename: 'IntakeForm', id: string, workflowId: string, sourceIntakeFormTemplateId: string | null, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, values: { [key: string]: any }, missingFileDocumentIds: Array<string>, completedAt: string | null, completedBy: { __typename: 'User', id: string } | null } | null, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory }, phases: Array<{ __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } }> } | null };

export type OnWorkflowPhasesChangedSubscriptionVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type OnWorkflowPhasesChangedSubscription = { __typename: 'Subscription', workflowPhasesChanged: { __typename: 'WorkflowIntakeFormAddedEvent', workflowId: string, intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } } | { __typename: 'WorkflowIntakeFormRemovedEvent', workflowId: string, intakeFormTemplateId: string } | { __typename: 'WorkflowIntakeFormUpdatedEvent', workflowId: string, intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } } | { __typename: 'WorkflowPhaseCreatedEvent', workflowId: string, phase: { __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } } | { __typename: 'WorkflowPhaseDeletedEvent', workflowId: string, phaseId: string } | { __typename: 'WorkflowPhaseUpdatedEvent', workflowId: string, phases: Array<{ __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } }>, workflow: { __typename: 'Workflow', id: string, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, board: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string } } } } | { __typename: 'WorkflowPhasesReorderedEvent', workflowId: string, phases: Array<{ __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } }> } };

export type CreatePhaseMutationVariables = Exact<{
  input: CreatePhaseInput;
}>;


export type CreatePhaseMutation = { __typename: 'Mutation', createPhase: { __typename: 'PhaseResponse', phase: { __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, board: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, triageColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }> } }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string, board: { __typename: 'Board', id: string, name: string, icon: string, color: string, createdAt: string, updatedAt: string, org: { __typename: 'Org', id: string, name: string }, triageColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, signingColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }> } }, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } } };

export type UpdatePhaseMutationVariables = Exact<{
  input: UpdatePhaseInput;
}>;


export type UpdatePhaseMutation = { __typename: 'Mutation', updatePhase: { __typename: 'PhaseResponse', phase: { __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } } };

export type DeletePhaseMutationVariables = Exact<{
  phaseId: Scalars['UUID'];
}>;


export type DeletePhaseMutation = { __typename: 'Mutation', deletePhase: string };

export type ReorderPhasesMutationVariables = Exact<{
  input: ReorderPhasesInput;
}>;


export type ReorderPhasesMutation = { __typename: 'Mutation', reorderPhases: Array<{ __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } } | { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } }> };

export type PhaseSimple_NonSigningPhase_Fragment = { __typename: 'NonSigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, title: string, description: string, status: TaskStatus, completedAt: string | null, rejectedAt: string | null, startedAt: string | null, isDelegatedToAi: boolean, variant: TaskVariant, parentTask: { __typename: 'Task', id: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, resolved: boolean, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } };

export type PhaseSimple_SigningPhase_Fragment = { __typename: 'SigningPhase', id: string, name: string, description: string, order: number, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, variant: WorkflowVariant, isSignedOutsideAline: boolean, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole }> } };

export type PhaseSimpleFragment = PhaseSimple_NonSigningPhase_Fragment | PhaseSimple_SigningPhase_Fragment;

export type GetPlaybookGenerationJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlaybookGenerationJobsQuery = { __typename: 'Query', playbookGenerationJobs: Array<{ __typename: 'PlaybookGenerationJob', id: string, startedAt: string | null, finishedAt: string | null, failedReason: string | null, failedAt: string | null }> };

export type GetPlaybookGenerationJobQueryVariables = Exact<{
  jobId: Scalars['UUID'];
}>;


export type GetPlaybookGenerationJobQuery = { __typename: 'Query', playbookGenerationJob: { __typename: 'PlaybookGenerationJob', id: string, startedAt: string | null, finishedAt: string | null, failedReason: string | null, failedAt: string | null, generatedCategoryCount: number, documents: Array<{ __typename: 'Document', id: string }>, openCategory: { __typename: 'PlaybookRuleCategory', id: string, name: string } | null, playbook: { __typename: 'Playbook', ruleCount: number, id: string, title: string, description: string, createdAt: string, updatedAt: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string }> } | null } | null };

export type PlaybookGenerationProgressFragment = { __typename: 'PlaybookGenerationJob', id: string, startedAt: string | null, finishedAt: string | null, failedReason: string | null, failedAt: string | null, generatedCategoryCount: number, openCategory: { __typename: 'PlaybookRuleCategory', id: string, name: string } | null, playbook: { __typename: 'Playbook', ruleCount: number, id: string, title: string, description: string, createdAt: string, updatedAt: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string }> } | null };

export type CancelPlaybookGenerationJobMutationVariables = Exact<{
  jobId: Scalars['UUID'];
}>;


export type CancelPlaybookGenerationJobMutation = { __typename: 'Mutation', cancelPlaybookGenerationJob: string };

export type GetPlaybookRuleJobQueryVariables = Exact<{
  ruleId: Scalars['UUID'];
  documentId: Scalars['UUID'];
}>;


export type GetPlaybookRuleJobQuery = { __typename: 'Query', playbookRule: { __typename: 'PlaybookRule', id: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null } | null };

export type GetDocPlaybookQueryVariables = Exact<{
  playbookId: Scalars['UUID'];
  documentId: Scalars['UUID'];
}>;


export type GetDocPlaybookQuery = { __typename: 'Query', playbook: { __typename: 'Playbook', id: string, title: string, description: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> }> } | null };

export type GetDocPlaybookSummaryQueryVariables = Exact<{
  playbookId: Scalars['UUID'];
  documentId: Scalars['UUID'];
}>;


export type GetDocPlaybookSummaryQuery = { __typename: 'Query', playbook: { __typename: 'Playbook', id: string, title: string, description: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any } }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> }> } | null };

export type StartPlaybookRunMutationVariables = Exact<{
  playbookId: Scalars['UUID'];
  documentId: Scalars['UUID'];
}>;


export type StartPlaybookRunMutation = { __typename: 'Mutation', startPlaybookRun: { __typename: 'Playbook', id: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> }> } };

export type StartPlaybookRuleJobsMutationVariables = Exact<{
  ruleIds: Array<Scalars['UUID']> | Scalars['UUID'];
  documentId: Scalars['UUID'];
}>;


export type StartPlaybookRuleJobsMutation = { __typename: 'Mutation', startPlaybookRuleJobs: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> };

export type CancelPlaybookRuleJobsMutationVariables = Exact<{
  playbookId: Scalars['UUID'];
  documentId: Scalars['UUID'];
}>;


export type CancelPlaybookRuleJobsMutation = { __typename: 'Mutation', cancelPlaybookRuleJobs: { __typename: 'Playbook', id: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> }> } };

export type ResolvePlaybookRuleJobMutationVariables = Exact<{
  input: ResolvePlaybookRuleJobInput;
}>;


export type ResolvePlaybookRuleJobMutation = { __typename: 'Mutation', resolvePlaybookRuleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } };

export type ClearPlaybookRuleJobResolutionMutationVariables = Exact<{
  input: ClearPlaybookRuleJobResolutionInput;
}>;


export type ClearPlaybookRuleJobResolutionMutation = { __typename: 'Mutation', clearPlaybookRuleJobResolution: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } };

export type ReviewPlaybookSuggestionMutationVariables = Exact<{
  input: ReviewPlaybookSuggestionInput;
}>;


export type ReviewPlaybookSuggestionMutation = { __typename: 'Mutation', reviewPlaybookSuggestion: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } };

export type PlaybookRuleWithJobFragment = { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> };

export type PlaybookRuleCategoryWithRuleJobsFragment = { __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> };

export type PlaybookRuleJobPositionResultSimpleFragment = { __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null };

export type PlaybookRuleProposalSimpleFragment = { __typename: 'PlaybookRuleProposal', id: string, positionId: string, suggestions: { [key: string]: any }, decisions: { [key: string]: any }, createdAt: string };

export type PlaybookRuleJobSimpleFragment = { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any } }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null };

export type PlaybookRuleJobWithProposalsFragment = { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null };

export type CreatePlaybookRuleCategoryMutationVariables = Exact<{
  input: CreatePlaybookRuleCategoryInput;
}>;


export type CreatePlaybookRuleCategoryMutation = { __typename: 'Mutation', createPlaybookRuleCategory: { __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string } };

export type UpdatePlaybookRuleCategoryMutationVariables = Exact<{
  input: UpdatePlaybookRuleCategoryInput;
}>;


export type UpdatePlaybookRuleCategoryMutation = { __typename: 'Mutation', updatePlaybookRuleCategory: { __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string } };

export type DeletePlaybookRuleCategoryMutationVariables = Exact<{
  categoryId: Scalars['UUID'];
}>;


export type DeletePlaybookRuleCategoryMutation = { __typename: 'Mutation', deletePlaybookRuleCategory: { __typename: 'Playbook', id: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> }> } };

export type ReorderPlaybookRuleCategoriesMutationVariables = Exact<{
  input: ReorderPlaybookRuleCategoriesInput;
}>;


export type ReorderPlaybookRuleCategoriesMutation = { __typename: 'Mutation', reorderPlaybookRuleCategories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string }> };

export type MovePlaybookRuleCategoryMutationVariables = Exact<{
  input: MovePlaybookRuleCategoryInput;
}>;


export type MovePlaybookRuleCategoryMutation = { __typename: 'Mutation', movePlaybookRuleCategory: { __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string } };

export type PlaybookWithCategoriesFragment = { __typename: 'Playbook', id: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> }> };

export type PlaybookRuleCategorySimpleFragment = { __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string };

export type GetPlaybookRuleQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPlaybookRuleQuery = { __typename: 'Query', playbookRule: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } | null };

export type GetPlaybookRulesForCategoryQueryVariables = Exact<{
  categoryId: Scalars['UUID'];
}>;


export type GetPlaybookRulesForCategoryQuery = { __typename: 'Query', playbookRulesForCategory: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> };

export type CreatePlaybookRuleMutationVariables = Exact<{
  input: CreatePlaybookRuleInput;
}>;


export type CreatePlaybookRuleMutation = { __typename: 'Mutation', createPlaybookRule: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } };

export type UpdatePlaybookRuleMutationVariables = Exact<{
  input: UpdatePlaybookRuleInput;
}>;


export type UpdatePlaybookRuleMutation = { __typename: 'Mutation', updatePlaybookRule: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } };

export type MovePlaybookRuleMutationVariables = Exact<{
  input: MovePlaybookRuleInput;
}>;


export type MovePlaybookRuleMutation = { __typename: 'Mutation', movePlaybookRule: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } };

export type DeletePlaybookRuleMutationVariables = Exact<{
  ruleId: Scalars['UUID'];
}>;


export type DeletePlaybookRuleMutation = { __typename: 'Mutation', deletePlaybookRule: string };

export type AddPlaybookRulePositionMutationVariables = Exact<{
  input: AddPlaybookRulePositionInput;
}>;


export type AddPlaybookRulePositionMutation = { __typename: 'Mutation', addPlaybookRulePosition: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } };

export type UpdatePlaybookRulePositionMutationVariables = Exact<{
  input: UpdatePlaybookRulePositionInput;
}>;


export type UpdatePlaybookRulePositionMutation = { __typename: 'Mutation', updatePlaybookRulePosition: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } };

export type DeletePlaybookRulePositionMutationVariables = Exact<{
  input: DeletePlaybookRulePositionInput;
}>;


export type DeletePlaybookRulePositionMutation = { __typename: 'Mutation', deletePlaybookRulePosition: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } };

export type ReorderPlaybookRulePositionsMutationVariables = Exact<{
  input: ReorderPlaybookRulePositionsInput;
}>;


export type ReorderPlaybookRulePositionsMutation = { __typename: 'Mutation', reorderPlaybookRulePositions: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } };

export type MovePlaybookRulePositionsMutationVariables = Exact<{
  input: MovePlaybookRulePositionsInput;
}>;


export type MovePlaybookRulePositionsMutation = { __typename: 'Mutation', movePlaybookRulePositions: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } };

export type PlaybookRulePositionSimpleFragment = { __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null };

export type PlaybookRuleSimpleFragment = { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> };

export type PlaybookRuleCategoryWithRulesFragment = { __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> };

export type GetPlaybookDetailQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPlaybookDetailQuery = { __typename: 'Query', playbook: { __typename: 'Playbook', id: string, title: string, description: string, createdAt: string, updatedAt: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> }>, generationJob: { __typename: 'PlaybookGenerationJob', id: string, startedAt: string | null, finishedAt: string | null, failedReason: string | null, failedAt: string | null, generatedCategoryCount: number, openCategory: { __typename: 'PlaybookRuleCategory', id: string, name: string } | null, playbook: { __typename: 'Playbook', ruleCount: number, id: string, title: string, description: string, createdAt: string, updatedAt: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string }> } | null } | null, createdBy: { __typename: 'User', id: string } | null } | null };

export type GetPlaybooksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlaybooksQuery = { __typename: 'Query', playbooks: Array<{ __typename: 'Playbook', id: string, title: string, createdAt: string, ruleCount: number, usedInDocumentCount: number, createdBy: { __typename: 'User', id: string, avatarColor: string, displayName: string } | null }> };

export type PlaybookListItemFragment = { __typename: 'Playbook', id: string, title: string, createdAt: string, ruleCount: number, usedInDocumentCount: number, createdBy: { __typename: 'User', id: string, avatarColor: string, displayName: string } | null };

export type GetPlaybooksListQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetPlaybooksListQuery = { __typename: 'Query', playbooks: Array<{ __typename: 'Playbook', id: string, title: string, description: string, runStatus: PlaybookRunStatus, createdAt: string, updatedAt: string, createdBy: { __typename: 'User', id: string } | null }> };

export type SearchPlaybooksQueryVariables = Exact<{
  input: SearchPlaybooksInput;
}>;


export type SearchPlaybooksQuery = { __typename: 'Query', searchPlaybooks: Array<{ __typename: 'PlaybookSearchResult', matchReason: string, ruleCount: number, score: number, playbook: { __typename: 'Playbook', id: string, title: string, description: string } }> };

export type CreatePlaybookMutationVariables = Exact<{
  input: CreatePlaybookInput;
}>;


export type CreatePlaybookMutation = { __typename: 'Mutation', createPlaybook: { __typename: 'Playbook', id: string, title: string, description: string, createdAt: string, updatedAt: string, ruleCount: number, usedInDocumentCount: number, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string }>, createdBy: { __typename: 'User', id: string, avatarColor: string, displayName: string } | null } };

export type UpdatePlaybookMutationVariables = Exact<{
  input: UpdatePlaybookInput;
}>;


export type UpdatePlaybookMutation = { __typename: 'Mutation', updatePlaybook: { __typename: 'Playbook', id: string, description: string, title: string, createdAt: string, updatedAt: string } };

export type DeletePlaybookMutationVariables = Exact<{
  playbookId: Scalars['UUID'];
}>;


export type DeletePlaybookMutation = { __typename: 'Mutation', deletePlaybook: string };

export type DuplicatePlaybookMutationVariables = Exact<{
  playbookId: Scalars['UUID'];
}>;


export type DuplicatePlaybookMutation = { __typename: 'Mutation', duplicatePlaybook: { __typename: 'Playbook', id: string, title: string, createdAt: string, ruleCount: number, usedInDocumentCount: number, createdBy: { __typename: 'User', id: string, avatarColor: string, displayName: string } | null } };

export type PlaybookSimpleFragment = { __typename: 'Playbook', id: string, title: string, description: string, createdAt: string, updatedAt: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string }> };

export type GetReminderQueryVariables = Exact<{
  reminderId: Scalars['UUID'];
}>;


export type GetReminderQuery = { __typename: 'Query', reminder: { __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } } };

export type GetRemindersQueryVariables = Exact<{
  filter?: InputMaybe<ReminderFilter>;
}>;


export type GetRemindersQuery = { __typename: 'Query', reminders: { __typename: 'ReminderRowsResponse', meta: { __typename: 'ReminderMeta', totalCount: number, pendingReviewCount: number }, reminders: Array<{ __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }> } };

export type GetRemindersInRangeQueryVariables = Exact<{
  startOfRange: Scalars['Date'];
  endOfRange: Scalars['Date'];
}>;


export type GetRemindersInRangeQuery = { __typename: 'Query', getRemindersInRange: { __typename: 'ReminderRowsResponse', meta: { __typename: 'ReminderMeta', totalCount: number, pendingReviewCount: number }, reminders: Array<{ __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }> } };

export type GetRemindersRequiringNotificationQueryVariables = Exact<{
  asOfDate: Scalars['Date'];
}>;


export type GetRemindersRequiringNotificationQuery = { __typename: 'Query', remindersRequiringNotification: { __typename: 'ReminderRowsResponse', meta: { __typename: 'ReminderMeta', totalCount: number, pendingReviewCount: number }, reminders: Array<{ __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }> } };

export type CreateReminderMutationVariables = Exact<{
  input: CreateReminderInput;
}>;


export type CreateReminderMutation = { __typename: 'Mutation', createReminder: { __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } } };

export type UpdateReminderMutationVariables = Exact<{
  input: UpdateReminderInput;
}>;


export type UpdateReminderMutation = { __typename: 'Mutation', updateReminder: { __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } } };

export type UpdateRemindersMutationVariables = Exact<{
  inputs: Array<UpdateReminderInput> | UpdateReminderInput;
}>;


export type UpdateRemindersMutation = { __typename: 'Mutation', updateReminders: Array<{ __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }> };

export type DeleteReminderMutationVariables = Exact<{
  reminderId: Scalars['UUID'];
}>;


export type DeleteReminderMutation = { __typename: 'Mutation', deleteReminder: string };

export type DeleteRemindersMutationVariables = Exact<{
  reminderIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type DeleteRemindersMutation = { __typename: 'Mutation', deleteReminders: Array<string> };

export type OnRemindersUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnRemindersUpdatedSubscription = { __typename: 'Subscription', remindersUpdated: { __typename: 'RemindersUpdatedEvent', reminderIds: Array<string>, meta: { __typename: 'ReminderMeta', totalCount: number, pendingReviewCount: number }, reminders: Array<{ __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }> } };

export type ReminderSimpleFragment = { __typename: 'Reminder', id: string, title: string, description: string, type: ReminderType, dueDate: string, completedAt: string | null, reviewStatus: ReminderReviewStatus, aiRationale: string | null, isAiGenerated: boolean, createdAt: string, updatedAt: string, notificationOffsets: Array<{ __typename: 'NotificationOffset', amount: number, unit: RelativeTimeUnit, position: RelativeTimePosition, notifiedAt: string | null }>, aiReminderAutomation: { __typename: 'AIReminderAutomation', id: string, title: string, report: { __typename: 'Report', id: string, name: string, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField }> } } | null, assignees: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } };

export type ReminderMetaFragment = { __typename: 'ReminderMeta', totalCount: number, pendingReviewCount: number };

export type GetReportColumnOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportColumnOptionsQuery = { __typename: 'Query', reportColumnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string, isGroupable: boolean, question: { __typename: 'ExtractionQuestion', id: string, mode: ExtractionQuestionMode, questionText: string, title: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }> } } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField, dataType: ReportColumnDataType, isGroupable: boolean }> };

export type ReportColumnOptionBase_ExtractionReportColumn_Fragment = { __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string, isGroupable: boolean, question: { __typename: 'ExtractionQuestion', id: string, mode: ExtractionQuestionMode, questionText: string, title: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }> } };

export type ReportColumnOptionBase_FileFieldColumn_Fragment = { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField, dataType: ReportColumnDataType, isGroupable: boolean };

export type ReportColumnOptionBaseFragment = ReportColumnOptionBase_ExtractionReportColumn_Fragment | ReportColumnOptionBase_FileFieldColumn_Fragment;

export type GetReportRowsQueryVariables = Exact<{
  reportId: Scalars['UUID'];
  displayMode: DisplayMode;
  cursor?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortModel?: InputMaybe<Scalars['JSON']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  filterTimeZone?: InputMaybe<Scalars['String']>;
  listFilter?: InputMaybe<DocumentListFilter>;
  docVariant?: InputMaybe<DocumentVariant>;
  parentTreeRowId?: InputMaybe<Scalars['ID']>;
  groupFieldIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  groupKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  unconfirmedRelationshipsOnly?: InputMaybe<Scalars['Boolean']>;
  missingMatchesOnly?: InputMaybe<Scalars['Boolean']>;
  trashed?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetReportRowsQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, reportRows: { __typename: 'ReportRowsInfo', totalCount: number, groupCount: number | null, rows: Array<{ __typename: 'DocumentRow', id: string, parentTreeRowId: string | null, childRowCount: number | null, documentId: string, relationshipDirection: RelationshipDirection | null, relationship: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, sourceAgreementName: string | null, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } | null, document: { __typename: 'Document', id: string, aiQuestionIdsQueueing: Array<string>, createdAt: string, deletedAt: string | null, lastAccessedByRequesterAt: string | null, name: string, requesterFavorited: boolean, requesterRole: PermissionRole | null, status: DocumentStatus | null, signedAt: string | null, updatedAt: string, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, relationshipPropertiesExtractionHash: string | null, relationshipMatchingStartedAt: string | null, relationshipMatchingFinishedAt: string | null, relationshipMatchingFailedReason: string | null, workflowFileRole: WorkflowFileDocumentRole | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, questionJobs: Array<{ __typename: 'ExtractionJob', id: string, createdAt: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null } | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, question: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant }, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }> }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, type: { __typename: 'ContractType', id: string, value: string } | null, workflow: { __typename: 'Workflow', id: string, envelopeStatus: EnvelopeStatus, isSignedOutsideAline: boolean, wasSentForSig: boolean } | null } } | { __typename: 'GroupHeaderRow', id: string, parentTreeRowId: string | null, documentCount: number, childRowCount: number | null, groupKey: string, groupFieldId: string } | { __typename: 'OrphanRelationshipRow', id: string, parentTreeRowId: string | null, childRowCount: number | null, orphanedRelationshipDirection: RelationshipDirection, orphanedRelationship: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, expectedDocumentName: string | null, expectedDocumentAgreementDate: string | null, sourceAgreementName: string | null, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } } | { __typename: 'UrlRelationshipRow', id: string, parentTreeRowId: string | null, childRowCount: number | null, urlRelationship: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, childUrl: string | null, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } }> } } | null };

export type GetReportQueryVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type GetReportQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, createdAt: string, name: string, state: { [key: string]: any }, rows: { __typename: 'RowsInfo', docs: Array<{ __typename: 'Document', id: string }> } } | null };

export type GetReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsQuery = { __typename: 'Query', reports: Array<{ __typename: 'Report', id: string, createdAt: string, updatedAt: string, name: string, state: { [key: string]: any }, author: { __typename: 'User', id: string, avatarColor: string, displayName: string, email: string, firstName: string | null, lastName: string | null } }> };

export type GetReportsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsCountQuery = { __typename: 'Query', reports: Array<{ __typename: 'Report', id: string }> };

export type GetDocumentReportRowsQueryVariables = Exact<{
  reportId: Scalars['UUID'];
  sortModel?: InputMaybe<Scalars['JSON']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  filterTimeZone?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  listFilter?: InputMaybe<DocumentListFilter>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  docVariant?: InputMaybe<DocumentVariant>;
  parentId?: InputMaybe<Scalars['UUID']>;
  unconfirmedRelationshipsOnly?: InputMaybe<Scalars['Boolean']>;
  missingMatchesOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDocumentReportRowsQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, name: string, rows: { __typename: 'RowsInfo', totalCount: number, docs: Array<{ __typename: 'Document', id: string, aiQuestionIdsQueueing: Array<string>, createdAt: string, deletedAt: string | null, lastAccessedByRequesterAt: string | null, name: string, requesterFavorited: boolean, requesterRole: PermissionRole | null, status: DocumentStatus | null, signedAt: string | null, updatedAt: string, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, relationshipPropertiesExtractionHash: string | null, relationshipMatchingStartedAt: string | null, relationshipMatchingFinishedAt: string | null, relationshipMatchingFailedReason: string | null, workflowFileRole: WorkflowFileDocumentRole | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, questionJobs: Array<{ __typename: 'ExtractionJob', id: string, createdAt: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null } | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, question: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant }, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }> }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, type: { __typename: 'ContractType', id: string, value: string } | null, workflow: { __typename: 'Workflow', id: string, envelopeStatus: EnvelopeStatus, isSignedOutsideAline: boolean, wasSentForSig: boolean } | null }> } } | null };

export type GetReportInitialStateQueryVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type GetReportInitialStateQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, name: string, state: { [key: string]: any }, columnOptions: Array<{ __typename: 'ExtractionReportColumn', questionId: string, dataType: ReportColumnDataType, displayName: string, isGroupable: boolean, question: { __typename: 'ExtractionQuestion', id: string, mode: ExtractionQuestionMode, questionText: string, title: string, options: Array<{ __typename: 'QuestionOption', id: string, label: string, color: string, order: number }> } } | { __typename: 'FileFieldColumn', displayName: string, field: ReportColumnFileField, dataType: ReportColumnDataType, isGroupable: boolean }> } | null };

export type GetReportStateQueryVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type GetReportStateQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, name: string, state: { [key: string]: any } } | null };

export type GetDocumentRowIndexQueryVariables = Exact<{
  reportId: Scalars['UUID'];
  documentId: Scalars['UUID'];
  sortModel?: InputMaybe<Scalars['JSON']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  filterTimeZone?: InputMaybe<Scalars['String']>;
  listFilter?: InputMaybe<DocumentListFilter>;
}>;


export type GetDocumentRowIndexQuery = { __typename: 'Query', documentRowIndex: number };

export type GetQuestionLockStatusQueryVariables = Exact<{
  reportId: Scalars['UUID'];
  questionId: Scalars['UUID'];
  filterModel?: InputMaybe<Scalars['JSON']>;
  listFilter?: InputMaybe<DocumentListFilter>;
}>;


export type GetQuestionLockStatusQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, questionLockStatus: { __typename: 'QuestionLockStatus', state: QuestionLockState, lockedCount: number, totalCount: number } } | null };

export type GetEditorReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEditorReportsQuery = { __typename: 'Query', reports: Array<{ __typename: 'Report', createdAt: string, id: string, name: string, state: { [key: string]: any } }> };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename: 'Mutation', createReport: { __typename: 'ReportResponse', report: { __typename: 'Report', id: string, createdAt: string, updatedAt: string, name: string, state: { [key: string]: any }, author: { __typename: 'User', id: string, avatarColor: string, displayName: string, email: string, firstName: string | null, lastName: string | null } } } };

export type DeleteReportsMutationVariables = Exact<{
  input: DeleteReportsInput;
}>;


export type DeleteReportsMutation = { __typename: 'Mutation', deleteReports: Array<string> };

export type StartReportExtractionMutationVariables = Exact<{
  input: StartReportExtractionInput;
}>;


export type StartReportExtractionMutation = { __typename: 'Mutation', startReportExtraction: { __typename: 'StartReportExtractionResponse', queuedCount: number, skippedCount: number, report: { __typename: 'Report', id: string, name: string }, aiQuestionsRunningForDocs: Array<{ __typename: 'AiQuestionsRunningForDoc', documentId: string, questionIds: Array<string> }> } };

export type UpdateReportMutationVariables = Exact<{
  input: UpdateReportInput;
}>;


export type UpdateReportMutation = { __typename: 'Mutation', updateReport: { __typename: 'ReportResponse', report: { __typename: 'Report', id: string, name: string, state: { [key: string]: any } } } };

export type UpdateReportStateMutationVariables = Exact<{
  reportId: Scalars['UUID'];
  state: Scalars['JSON'];
}>;


export type UpdateReportStateMutation = { __typename: 'Mutation', updateReport: { __typename: 'ReportResponse', report: { __typename: 'Report', id: string, name: string, state: { [key: string]: any } } } };

export type SendReportExportMutationVariables = Exact<{
  reportId: Scalars['UUID'];
  format?: InputMaybe<ExportFormat>;
}>;


export type SendReportExportMutation = { __typename: 'Mutation', sendReportExport: { __typename: 'ReportResponse', report: { __typename: 'Report', id: string } } };

export type ReportBaseFragment = { __typename: 'Report', id: string, createdAt: string, updatedAt: string, name: string, state: { [key: string]: any }, author: { __typename: 'User', id: string, avatarColor: string, displayName: string, email: string, firstName: string | null, lastName: string | null } };

export type ReportFullDataFragment = { __typename: 'Report', id: string, createdAt: string, updatedAt: string, name: string, state: { [key: string]: any }, rows: { __typename: 'RowsInfo', docs: Array<{ __typename: 'Document', id: string }> }, author: { __typename: 'User', id: string, avatarColor: string, displayName: string, email: string, firstName: string | null, lastName: string | null } };

export type DocumentExtractionStatusFragment = { __typename: 'Document', id: string, aiQuestionIdsQueueing: Array<string>, questionJobs: Array<{ __typename: 'ExtractionJob', id: string, answer: string, reasoning: string | null, lockedAt: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, questionContentHashAtRun: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, question: { __typename: 'ExtractionQuestion', id: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, contentHash: string | null }, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, fileVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string } | null }> };

export type DocumentReportRowFragment = { __typename: 'Document', id: string, aiQuestionIdsQueueing: Array<string>, createdAt: string, deletedAt: string | null, lastAccessedByRequesterAt: string | null, name: string, requesterFavorited: boolean, requesterRole: PermissionRole | null, status: DocumentStatus | null, signedAt: string | null, updatedAt: string, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, relationshipPropertiesExtractionHash: string | null, relationshipMatchingStartedAt: string | null, relationshipMatchingFinishedAt: string | null, relationshipMatchingFailedReason: string | null, workflowFileRole: WorkflowFileDocumentRole | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, questionJobs: Array<{ __typename: 'ExtractionJob', id: string, createdAt: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null } | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, question: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant }, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }> }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, type: { __typename: 'ContractType', id: string, value: string } | null, workflow: { __typename: 'Workflow', id: string, envelopeStatus: EnvelopeStatus, isSignedOutsideAline: boolean, wasSentForSig: boolean } | null };

export type DocumentReportRowQuestionJobFragment = { __typename: 'ExtractionJob', id: string, createdAt: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null } | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, question: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant }, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }> };

export type ReportUpdatedSubscriptionVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type ReportUpdatedSubscription = { __typename: 'Subscription', reportUpdated: { __typename: 'ReportUpdatedEvent', reportId: string, report: { __typename: 'Report', id: string, name: string, state: { [key: string]: any }, createdAt: string, updatedAt: string } } };

export type UpdateReportFragmentFragment = { __typename: 'Report', id: string, name: string, state: { [key: string]: any } };

export type CountFilteredDocumentsQueryVariables = Exact<{
  filterModel: Scalars['JSON'];
}>;


export type CountFilteredDocumentsQuery = { __typename: 'Query', countFilteredDocuments: number };

export type GetRowsMetaQueryVariables = Exact<{
  reportId: Scalars['UUID'];
  displayMode?: InputMaybe<DisplayMode>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  filterTimeZone?: InputMaybe<Scalars['String']>;
  listFilter?: InputMaybe<DocumentListFilter>;
  docVariant?: InputMaybe<DocumentVariant>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  parentTreeRowId?: InputMaybe<Scalars['ID']>;
  groupFieldIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  groupKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  unconfirmedRelationshipsOnly?: InputMaybe<Scalars['Boolean']>;
  missingMatchesOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRowsMetaQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, rowsMeta: { __typename: 'RowsMeta', aiRunningCount: number, answerStaleCount: number, aiNotRunCount: number, aiErrorCount: number, ocrErrorCount: number, ocrRunningCount: number } } | null };

export type GetRepositoryMetaQueryVariables = Exact<{
  repositoryId: Scalars['UUID'];
}>;


export type GetRepositoryMetaQuery = { __typename: 'Query', repositoryMeta: { __typename: 'RepositoryMeta', detectingRelationshipsCount: number, failedRelationshipsCount: number, unconfirmedRelationshipsCount: number, missingMatchesCount: number, unprocessedRelationshipDocumentsCount: number } };

export type OnRepositoryMetaUpdatedSubscriptionVariables = Exact<{
  repositoryId: Scalars['UUID'];
}>;


export type OnRepositoryMetaUpdatedSubscription = { __typename: 'Subscription', onRepositoryMetaUpdated: { __typename: 'RepositoryMeta', detectingRelationshipsCount: number, failedRelationshipsCount: number, unconfirmedRelationshipsCount: number, missingMatchesCount: number, unprocessedRelationshipDocumentsCount: number } };

export type GetMyDefaultRepositoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyDefaultRepositoryQuery = { __typename: 'Query', myRepository: { __typename: 'Report', id: string, name: string, rows: { __typename: 'RowsInfo', docs: Array<{ __typename: 'Document', id: string }> } } };

export type RepositoryViewFragment = { __typename: 'Report', id: string, name: string, rows: { __typename: 'RowsInfo', docs: Array<{ __typename: 'Document', id: string }> } };

export type VerifyCsrfTokenQueryVariables = Exact<{
  token: Scalars['UUID'];
}>;


export type VerifyCsrfTokenQuery = { __typename: 'Query', verifyToken: { __typename: 'CSRFToken', token: string, expiresAt: string } };

export type GenerateCsrfTokenMutationVariables = Exact<{
  expiry: Scalars['String'];
}>;


export type GenerateCsrfTokenMutation = { __typename: 'Mutation', generateToken: { __typename: 'CSRFToken', token: string, expiresAt: string } };

export type TokenResponseFragment = { __typename: 'CSRFToken', token: string, expiresAt: string };

export type GetAccessRequestsByBatchIdQueryVariables = Exact<{
  batchId: Scalars['UUID'];
}>;


export type GetAccessRequestsByBatchIdQuery = { __typename: 'Query', accessRequestsByBatchId: { __typename: 'AccessRequestByBatchResult', errorReason: AccessRequestByBatchErrorReason | null, accessRequests: Array<{ __typename: 'AccessRequest', id: string, batchId: string, status: AccessRequestStatus, requestedRole: PermissionRole | null, grantedRole: PermissionRole | null, message: string | null, requestedForEmails: Array<string> | null, respondedAt: string | null, createdAt: string, document: { __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null } | null, requester: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, recipient: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } | null };

export type GetMyAccessRequestsForDocumentsQueryVariables = Exact<{
  documentIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetMyAccessRequestsForDocumentsQuery = { __typename: 'Query', myAccessRequestsForDocuments: Array<{ __typename: 'MyAccessRequestInfo', documentId: string, status: AccessRequestStatus }> };

export type GrantAccessByRequestMutationVariables = Exact<{
  input: GrantAccessByRequestInput;
}>;


export type GrantAccessByRequestMutation = { __typename: 'Mutation', grantAccessByRequest: boolean };

export type GetAnnotationsQueryVariables = Exact<{
  fileVersionId: Scalars['UUID'];
}>;


export type GetAnnotationsQuery = { __typename: 'Query', annotations: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null };

export type DeleteAnnotationsMutationVariables = Exact<{
  input: DeleteAnnotationsInput;
}>;


export type DeleteAnnotationsMutation = { __typename: 'Mutation', deleteAnnotations: string };

export type UpsertAnnotationsMutationVariables = Exact<{
  input: UpsertAnnotationsInput;
}>;


export type UpsertAnnotationsMutation = { __typename: 'Mutation', upsertAnnotations: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } };

export type OnAnnotationsChangedSubscriptionVariables = Exact<{
  fileVersionId: Scalars['UUID'];
}>;


export type OnAnnotationsChangedSubscription = { __typename: 'Subscription', annotationsChanged: { __typename: 'AnnotationsChangedEvent', annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, user: { __typename: 'User', id: string, displayName: string } } };

export type GetFileQueryVariables = Exact<{
  fileId: Scalars['UUID'];
}>;


export type GetFileQuery = { __typename: 'Query', file: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, name: string, size: number | null, createdAt: string, deletedAt: string | null, updatedAt: string } };

export type GetDocumentAssetUrlQueryVariables = Exact<{
  input: DocumentAssetInput;
}>;


export type GetDocumentAssetUrlQuery = { __typename: 'Query', documentAsset: { __typename: 'DocFile', id: string, filestackUrl: string, handle: string } };

export type GetFilesQueryVariables = Exact<{
  fileIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetFilesQuery = { __typename: 'Query', files: Array<{ __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, name: string, size: number | null, createdAt: string, deletedAt: string | null, updatedAt: string }> };

export type GetUploadSecurityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUploadSecurityQuery = { __typename: 'Query', uploadSecurity: { __typename: 'FilestackUploadOptions', bucket: string, security: { __typename: 'FilestackSecurity', policy: string, signature: string } } | null };

export type GetDownloadSecurityQueryVariables = Exact<{
  docFileId: Scalars['UUID'];
}>;


export type GetDownloadSecurityQuery = { __typename: 'Query', downloadSecurity: { __typename: 'FilestackDownloadOptions', docFileId: string, handle: string, security: { __typename: 'FilestackSecurity', policy: string, signature: string } } };

export type GetDocumentDownloadUrlQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentDownloadUrlQuery = { __typename: 'Query', getDocumentDownloadURL: string | null };

export type GetFileVersionDownloadUrlQueryVariables = Exact<{
  fileVersionId: Scalars['UUID'];
}>;


export type GetFileVersionDownloadUrlQuery = { __typename: 'Query', getFileVersionDownloadURL: string | null };

export type CreateDocFileMutationVariables = Exact<{
  input: CreateDocFileLocationInput;
}>;


export type CreateDocFileMutation = { __typename: 'Mutation', createDocFile: { __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null } };

export type CreateFilesMutationVariables = Exact<{
  input: CreateFilesInput;
}>;


export type CreateFilesMutation = { __typename: 'Mutation', createFiles: Array<{ __typename: 'Document', id: string, variant: DocumentVariant, name: string, isSigned: boolean, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } }> };

export type CreateFileLocationsMutationVariables = Exact<{
  input: CreateFileLocationsInput;
}>;


export type CreateFileLocationsMutation = { __typename: 'Mutation', createFileLocations: Array<{ __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, name: string, size: number | null, createdAt: string, deletedAt: string | null, updatedAt: string }> };

export type FileSimpleFragment = { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, name: string, size: number | null, createdAt: string, deletedAt: string | null, updatedAt: string };

export type FilestackUploadOptionsBaseFragment = { __typename: 'FilestackUploadOptions', bucket: string, security: { __typename: 'FilestackSecurity', policy: string, signature: string } };

export type FilestackDownloadOptionsBaseFragment = { __typename: 'FilestackDownloadOptions', docFileId: string, handle: string, security: { __typename: 'FilestackSecurity', policy: string, signature: string } };

export type FilestackSecurityBaseFragment = { __typename: 'FilestackSecurity', policy: string, signature: string };

export type DocFileSimpleFragment = { __typename: 'DocFile', id: string, filestackUrl: string, name: string, mimetype: string, updatedAt: string, deletedAt: string | null };

export type RelationshipCacheFieldsFragment = { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null };

export type ConfirmDocumentRelationshipMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ConfirmDocumentRelationshipMutation = { __typename: 'Mutation', confirmDocumentRelationship: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } };

export type OnDocumentRelationshipUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDocumentRelationshipUpdatedSubscription = { __typename: 'Subscription', documentRelationshipUpdated: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } };

export type BulkCreateDocumentRelationshipsMutationVariables = Exact<{
  items: Array<BulkCreateDocumentRelationshipItem> | BulkCreateDocumentRelationshipItem;
}>;


export type BulkCreateDocumentRelationshipsMutation = { __typename: 'Mutation', bulkCreateDocumentRelationships: Array<{ __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childType: ChildType, childUrl: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, expectedDocumentName: string | null, expectedDocumentAgreementDate: string | null, sourceAgreementName: string | null, createdAt: string, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null, childDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null, parentDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null }> };

export type CreateDocumentRelationshipMutationVariables = Exact<{
  parentDocumentId: Scalars['UUID'];
  childDocumentId: Scalars['UUID'];
  childRelationshipType: ChildRelationshipType;
}>;


export type CreateDocumentRelationshipMutation = { __typename: 'Mutation', createDocumentRelationship: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, createdAt: string, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null, parentDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null, childDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null } };

export type RejectDocumentRelationshipMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RejectDocumentRelationshipMutation = { __typename: 'Mutation', rejectDocumentRelationship: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } };

export type DeleteDocumentRelationshipMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteDocumentRelationshipMutation = { __typename: 'Mutation', deleteDocumentRelationship: string };

export type SetDocumentRelationshipParentAndConfirmMutationVariables = Exact<{
  id: Scalars['UUID'];
  parentDocumentId: Scalars['UUID'];
}>;


export type SetDocumentRelationshipParentAndConfirmMutation = { __typename: 'Mutation', setDocumentRelationshipParentAndConfirm: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, parentDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } };

export type SetDocumentRelationshipChildAndConfirmMutationVariables = Exact<{
  id: Scalars['UUID'];
  childDocumentId: Scalars['UUID'];
}>;


export type SetDocumentRelationshipChildAndConfirmMutation = { __typename: 'Mutation', setDocumentRelationshipChildAndConfirm: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, childDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } };

export type UpdateDocumentRelationshipTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
  childRelationshipType: ChildRelationshipType;
}>;


export type UpdateDocumentRelationshipTypeMutation = { __typename: 'Mutation', updateDocumentRelationshipType: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } };

export type RestoreDocumentRelationshipMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RestoreDocumentRelationshipMutation = { __typename: 'Mutation', restoreDocumentRelationship: { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null } };

export type BulkConfirmDocumentRelationshipsMutationVariables = Exact<{
  input: BulkReviewRelationshipsInput;
}>;


export type BulkConfirmDocumentRelationshipsMutation = { __typename: 'Mutation', bulkConfirmDocumentRelationships: { __typename: 'BulkReviewRelationshipsResponse', skippedCount: number, updatedRelationships: Array<{ __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null }> } };

export type BulkRejectDocumentRelationshipsMutationVariables = Exact<{
  input: BulkReviewRelationshipsInput;
}>;


export type BulkRejectDocumentRelationshipsMutation = { __typename: 'Mutation', bulkRejectDocumentRelationships: { __typename: 'BulkReviewRelationshipsResponse', skippedCount: number, updatedRelationships: Array<{ __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null }> } };

export type SetParentChildRelationshipsEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
}>;


export type SetParentChildRelationshipsEnabledMutation = { __typename: 'Mutation', setParentChildRelationshipsEnabled: { __typename: 'Org', id: string, parentChildEnabled: boolean } };

export type RetryFailedDocumentRelationshipsMutationVariables = Exact<{ [key: string]: never; }>;


export type RetryFailedDocumentRelationshipsMutation = { __typename: 'Mutation', retryFailedDocumentRelationships: number };

export type DuplicateTemplateMutationVariables = Exact<{
  input: DuplicateTemplateInput;
}>;


export type DuplicateTemplateMutation = { __typename: 'Mutation', duplicateTemplate: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string, name: string, isCommunityTemplate: boolean, owner: { __typename: 'User', id: string, email: string } } | null } };

export type GetDocumentIsInternalOnWorkflowQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentIsInternalOnWorkflowQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, isInternalOnWorkflow: boolean } };

export type GetDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, description: string | null, forwardingPermissionRole: PermissionRole | null, requesterFavorited: boolean, name: string, status: DocumentStatus | null, requesterRole: PermissionRole | null, storableType: StorableType, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, latestVersion: { __typename: 'DocumentVersion', documentJSON: { [key: string]: any }, id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, type: { __typename: 'ContractType', id: string, value: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, workflow: { __typename: 'Workflow', name: string, id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null } };

export type GetEditorDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetEditorDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, isCertificate: boolean, isSigned: boolean, requesterRole: PermissionRole | null, variant: DocumentVariant, name: string, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, linkedOpportunities: Array<{ __typename: 'LinkedOpportunity', id: string, integration: Integration }> } | null, envelope: { __typename: 'Envelope', id: string, variant: EnvelopeVariant, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, status: WorkflowRecipientStatus, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string } | null }> } | null, owner: { __typename: 'User', id: string } } };

export type GetDocumentSimpleQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentSimpleQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, description: string | null, variant: DocumentVariant, isCommunityTemplate: boolean, forwardingPermissionRole: PermissionRole | null, requesterRole: PermissionRole | null, requesterFavorited: boolean, status: DocumentStatus | null, owner: { __typename: 'User', id: string } } };

export type GetReportDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetReportDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', createdAt: string, deletedAt: string | null, id: string, name: string, requesterFavorited: boolean, status: DocumentStatus | null, signedAt: string | null, updatedAt: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, type: { __typename: 'ContractType', id: string, value: string } | null } };

export type GetDocumentPartsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentPartsQuery = { __typename: 'Query', documentParts: { __typename: 'DocumentParts', assets: Array<{ __typename: 'DocFile', id: string, filestackUrl: string }>, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }> } };

export type GetSignedDocumentSimpleQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetSignedDocumentSimpleQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, isSigned: boolean, variant: DocumentVariant, status: DocumentStatus | null, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, linkedOpportunities: Array<{ __typename: 'LinkedOpportunity', id: string, integration: Integration }> } | null } };

export type GetSignedDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetSignedDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, isSigned: boolean, variant: DocumentVariant, requesterRole: PermissionRole | null, envelope: { __typename: 'Envelope', id: string, completedAt: string | null } | null, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string } } };

export type GetDocumentForwardSettingsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentForwardSettingsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, forwardingPermissionRole: PermissionRole | null, name: string, requesterRole: PermissionRole | null, variant: DocumentVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, forwardingPermissionRole: PermissionRole | null, state: WorkflowState, envelopeStatus: EnvelopeStatus, variant: WorkflowVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } };

export type GetDocumentWithWorkflowStateQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentWithWorkflowStateQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, isSigned: boolean, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null } };

export type GetDocxUploadTargetDocumentQueryVariables = Exact<{
  documentIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetDocxUploadTargetDocumentQuery = { __typename: 'Query', documents: Array<{ __typename: 'Document', id: string, name: string, isSigned: boolean, requesterRole: PermissionRole | null, owner: { __typename: 'User', id: string }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null }> };

export type GetDocumentBasicMetaQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentBasicMetaQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, description: string | null, status: DocumentStatus | null, variant: DocumentVariant, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, workflowFileRole: WorkflowFileDocumentRole | null, createdAt: string, updatedAt: string, deletedAt: string | null, type: { __typename: 'ContractType', id: string, value: string } | null, workflow: { __typename: 'Workflow', id: string, envelopeStatus: EnvelopeStatus, isSignedOutsideAline: boolean, wasSentForSig: boolean, state: WorkflowState, status: WorkflowStatus, variant: WorkflowVariant, linkedOpportunities: Array<{ __typename: 'LinkedOpportunity', id: string, integration: Integration }> } | null, envelope: { __typename: 'Envelope', id: string, createdAt: string, completedAt: string | null, docuSignEnvelopeId: string | null, title: string, variant: EnvelopeVariant } | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, vectorsSavedAt: string | null, vectorsStartedAt: string | null, vectorsFailedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFailedAt: string | null, fileExtractionFinishedAt: string | null, name: string, createdAt: string, vectorsSavedAt: string | null, vectorsStartedAt: string | null, vectorsFailedAt: string | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string } }, owner: { __typename: 'User', id: string, org: { __typename: 'Org', id: string } } } };

export type GetDocumentStatusQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentStatusQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, status: DocumentStatus | null } };

export type GetDocumentWorkflowMetaQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentWorkflowMetaQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, envelopeStatus: EnvelopeStatus } | null } };

export type GetDocumentWithWorkflowQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentWithWorkflowQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, variant: DocumentVariant, workflow: { __typename: 'Workflow', id: string, name: string, state: WorkflowState, status: WorkflowStatus, envelopeStatus: EnvelopeStatus, variant: WorkflowVariant, activeStep: { __typename: 'WorkflowStep', id: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } };

export type GetDocumentWithFullWorkflowQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentWithFullWorkflowQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, hasWorkflow: boolean, variant: DocumentVariant, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, workflow: { __typename: 'Workflow', id: string, name: string, state: WorkflowState, status: WorkflowStatus, envelopeStatus: EnvelopeStatus, variant: WorkflowVariant, startedAt: string | null, createdAt: string, completedAt: string | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> } | null } };

export type GetContractSummaryQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetContractSummaryQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, description: string | null, name: string, createdAt: string, updatedAt: string, deletedAt: string | null, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }> } };

export type GetDocumentWithAssetsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentWithAssetsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, assets: Array<{ __typename: 'DocFile', id: string, filestackUrl: string }>, latestVersion: { __typename: 'DocumentVersion', id: string, documentJSON: { [key: string]: any }, name: string, createdAt: string } | { __typename: 'StaticFileVersion', id: string, name: string, createdAt: string, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string } } } };

export type GetDocumentsWithAssetsQueryVariables = Exact<{
  documentIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetDocumentsWithAssetsQuery = { __typename: 'Query', documents: Array<{ __typename: 'Document', id: string, name: string, assets: Array<{ __typename: 'DocFile', id: string, filestackUrl: string }>, latestVersion: { __typename: 'DocumentVersion', id: string, documentJSON: { [key: string]: any }, name: string, createdAt: string } | { __typename: 'StaticFileVersion', id: string, name: string, createdAt: string, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string } } }> };

export type LoadDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type LoadDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', requesterRole: PermissionRole | null, id: string, description: string | null, forwardingPermissionRole: PermissionRole | null, requesterFavorited: boolean, name: string, status: DocumentStatus | null, storableType: StorableType, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, isSavePending: boolean, ownerId: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, envelope: { __typename: 'Envelope', id: string, variant: EnvelopeVariant, recipients: Array<{ __typename: 'WorkflowRecipient', id: string, status: WorkflowRecipientStatus, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string } | null }> } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } };

export type GetDocumentsQueryVariables = Exact<{
  documentIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetDocumentsQuery = { __typename: 'Query', documents: Array<{ __typename: 'Document', ownerId: string, requesterRole: PermissionRole | null, id: string, description: string | null, forwardingPermissionRole: PermissionRole | null, requesterFavorited: boolean, name: string, status: DocumentStatus | null, storableType: StorableType, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, isSavePending: boolean, updatedAt: string, deletedAt: string | null, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type GetDocumentsSimpleQueryVariables = Exact<{
  documentIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetDocumentsSimpleQuery = { __typename: 'Query', documents: Array<{ __typename: 'Document', id: string, hasWorkflow: boolean, isSigned: boolean, name: string, requesterRole: PermissionRole | null, variant: DocumentVariant, requesterFavorited: boolean, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, name: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null } | { __typename: 'StaticFileVersion', id: string, name: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionFailedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFinishedAt: string | null, fileExtractionStartedAt: string | null, fileLocation: { __typename: 'DocFile', id: string, mimetype: string } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, name: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null }> };

export type GetDocumentMetricsQueryVariables = Exact<{
  reportId: Scalars['UUID'];
}>;


export type GetDocumentMetricsQuery = { __typename: 'Query', report: { __typename: 'Report', id: string, rows: { __typename: 'RowsInfo', totalCount: number } } | null };

export type GetDocumentsLabelsQueryVariables = Exact<{
  documentIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetDocumentsLabelsQuery = { __typename: 'Query', documents: Array<{ __typename: 'Document', id: string, labels: Array<{ __typename: 'Label', id: string, labelText: string }> }> };

export type GetDocumentFieldsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentFieldsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, isSavePending: boolean, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }> } };

export type GetDocumentVersionsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentVersionsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, isSigned: boolean, name: string, requesterRole: PermissionRole | null, variant: DocumentVariant, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, workflow: { __typename: 'Workflow', id: string, variant: WorkflowVariant, state: WorkflowState } | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string }, orderedVersions: Array<{ __typename: 'DocumentVersion', documentJSON: { [key: string]: any }, id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, taskUpload: { __typename: 'TaskUpload', id: string, createdAt: string, task: { __typename: 'Task', id: string, title: string }, uploadedBy: { __typename: 'User', id: string, displayName: string } | null } | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, taskUpload: { __typename: 'TaskUpload', id: string, createdAt: string, task: { __typename: 'Task', id: string, title: string }, uploadedBy: { __typename: 'User', id: string, displayName: string } | null } | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }>, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }> } };

export type GetDocumentCommentsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentCommentsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }> } };

export type GetDocumentLatestVersionQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentLatestVersionQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, requesterRole: PermissionRole | null, status: DocumentStatus | null, variant: DocumentVariant, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, type: { __typename: 'ContractType', id: string, value: string } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }> } };

export type ChangeDocumentsTypeMutationVariables = Exact<{
  input: ChangeDocumentsTypeInput;
}>;


export type ChangeDocumentsTypeMutation = { __typename: 'Mutation', changeDocumentsType: { __typename: 'UpdateDocumentsResponse', numSuccess: number, numSkipped: number, documents: Array<{ __typename: 'Document', id: string, type: { __typename: 'ContractType', id: string, value: string } | null }> } };

export type CreateDocumentMutationVariables = Exact<{
  documentProps: NewDocument;
}>;


export type CreateDocumentMutation = { __typename: 'Mutation', createDocument: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', documentJSON: { [key: string]: any }, id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, type: { __typename: 'ContractType', id: string, value: string } | null } | null } };

export type DeleteDocumentsMutationVariables = Exact<{
  input: DeleteDocumentsInput;
}>;


export type DeleteDocumentsMutation = { __typename: 'Mutation', deleteDocuments: { __typename: 'BulkDocumentActionResponse', documentIds: Array<string>, numSkipped: number, skippedDocumentIds: Array<string> } };

export type DisableDocumentsMutationVariables = Exact<{
  input: DisableDocumentsInput;
}>;


export type DisableDocumentsMutation = { __typename: 'Mutation', disableDocuments: { __typename: 'BulkDocumentActionResponse', documentIds: Array<string>, numSkipped: number, skippedDocumentIds: Array<string>, affectedRelationshipParents: Array<{ __typename: 'AffectedRelationshipParent', documentId: string, trashedChildCount: number }> | null } };

export type ForwardDocumentMutationVariables = Exact<{
  input: ForwardDocumentInput;
}>;


export type ForwardDocumentMutation = { __typename: 'Mutation', forwardDocument: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string, permissions: Array<{ __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } | null } };

export type SendDocumentViaEmailMutationVariables = Exact<{
  input: SendDocumentViaEmailInput;
}>;


export type SendDocumentViaEmailMutation = { __typename: 'Mutation', sendDocumentViaEmail: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string, permissions: Array<{ __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } | null } };

export type SendDocumentViaEmailTestMutationVariables = Exact<{
  input: SendDocumentViaEmailTestInput;
}>;


export type SendDocumentViaEmailTestMutation = { __typename: 'Mutation', sendDocumentViaEmailTest: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string } | null } };

export type StartOcrForDocumentsMutationVariables = Exact<{
  documentIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type StartOcrForDocumentsMutation = { __typename: 'Mutation', startOCRForDocuments: { __typename: 'DocumentsResponse', documents: Array<{ __typename: 'Document', id: string, latestVersion: { __typename: 'DocumentVersion' } | { __typename: 'StaticFileVersion', id: string, fileExtractionFailedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFinishedAt: string | null, fileExtractionStartedAt: string | null } }> } };

export type RestoreDocumentsMutationVariables = Exact<{
  input: RestoreDocumentsInput;
}>;


export type RestoreDocumentsMutation = { __typename: 'Mutation', restoreDocuments: { __typename: 'BulkDocumentActionResponse', documentIds: Array<string>, numSkipped: number, skippedDocumentIds: Array<string> } };

export type SaveDocumentMutationVariables = Exact<{
  input: SaveDocumentInput;
}>;


export type SaveDocumentMutation = { __typename: 'Mutation', saveDocument: { __typename: 'SaveDocumentResponse', document: { __typename: 'Document', id: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string, documentJSON: { [key: string]: any } } | { __typename: 'StaticFileVersion', id: string } }, changedVariables: Array<{ __typename: 'DocumentVariable', deletedAt: string | null, id: string, value: string | null, selectedAnswer: { __typename: 'AnswerOption', id: string, optionText: string } | null }> } };

export type UpdateDocumentPropsMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentPropsMutation = { __typename: 'Mutation', updateDocumentProps: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string, description: string | null, forwardingPermissionRole: PermissionRole | null, name: string, status: DocumentStatus | null } | null } };

export type SetDocumentsStatusMutationVariables = Exact<{
  input: SetDocumentsStatusInput;
}>;


export type SetDocumentsStatusMutation = { __typename: 'Mutation', setDocumentsStatus: { __typename: 'SetDocumentsStatusResponse', documentIds: Array<string>, status: DocumentStatus, isActive: boolean, isSigned: boolean | null, variant: DocumentVariant | null, numSuccess: number, numSkipped: number, numQueued: number, jobId: string | null, skipCounts: Array<{ __typename: 'DocumentStatusSkipCount', reason: DocumentStatusSkipReason, count: number }> } };

export type DocumentStatusJobFieldsFragment = { __typename: 'DocumentStatusJob', id: string, status: DocumentStatus, numQueued: number, batches: Array<{ __typename: 'DocumentStatusJobBatch', index: number, state: DocumentStatusJobState, numQueued: number, numProcessed: number, numSuccess: number, numFailed: number, numNotRun: number, skipCounts: Array<{ __typename: 'DocumentStatusSkipCount', reason: DocumentStatusSkipReason, count: number }> }> };

export type GetDocumentStatusJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentStatusJobsQuery = { __typename: 'Query', documentStatusJobs: Array<{ __typename: 'DocumentStatusJob', id: string, status: DocumentStatus, numQueued: number, batches: Array<{ __typename: 'DocumentStatusJobBatch', index: number, state: DocumentStatusJobState, numQueued: number, numProcessed: number, numSuccess: number, numFailed: number, numNotRun: number, skipCounts: Array<{ __typename: 'DocumentStatusSkipCount', reason: DocumentStatusSkipReason, count: number }> }> }> };

export type CancelDocumentStatusJobMutationVariables = Exact<{
  jobId: Scalars['UUID'];
}>;


export type CancelDocumentStatusJobMutation = { __typename: 'Mutation', cancelDocumentStatusJob: boolean };

export type OnDocumentStatusJobProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDocumentStatusJobProgressSubscription = { __typename: 'Subscription', documentStatusJobProgress: { __typename: 'DocumentStatusJobProgressEvent', documentIds: Array<string>, isActive: boolean, isSigned: boolean | null, variant: DocumentVariant | null, job: { __typename: 'DocumentStatusJob', id: string, status: DocumentStatus, numQueued: number, batches: Array<{ __typename: 'DocumentStatusJobBatch', index: number, state: DocumentStatusJobState, numQueued: number, numProcessed: number, numSuccess: number, numFailed: number, numNotRun: number, skipCounts: Array<{ __typename: 'DocumentStatusSkipCount', reason: DocumentStatusSkipReason, count: number }> }> } } };

export type CopyDocumentMutationVariables = Exact<{
  documentId: Scalars['UUID'];
  documentProps: DuplicateDocument;
}>;


export type CopyDocumentMutation = { __typename: 'Mutation', copyDocument: { __typename: 'DocumentResponse', document: { __typename: 'Document', ownerId: string, requesterRole: PermissionRole | null, id: string, description: string | null, forwardingPermissionRole: PermissionRole | null, requesterFavorited: boolean, name: string, status: DocumentStatus | null, storableType: StorableType, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, isSavePending: boolean, updatedAt: string, deletedAt: string | null, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } };

export type ImportDocumentMutationVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type ImportDocumentMutation = { __typename: 'Mutation', importDocument: { __typename: 'DocumentResponse', document: { __typename: 'Document', id: string, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } } | null } };

export type DocumentMetadataFragment = { __typename: 'Document', id: string, description: string | null, forwardingPermissionRole: PermissionRole | null, requesterFavorited: boolean, name: string, status: DocumentStatus | null, requesterRole: PermissionRole | null, storableType: StorableType, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, isSavePending: boolean, ownerId: string, updatedAt: string, deletedAt: string | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null };

export type DocumentFieldsBaseFragment = { __typename: 'Document', ownerId: string, requesterRole: PermissionRole | null, id: string, description: string | null, forwardingPermissionRole: PermissionRole | null, requesterFavorited: boolean, name: string, status: DocumentStatus | null, storableType: StorableType, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, isSavePending: boolean, updatedAt: string, deletedAt: string | null, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, parent: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, commentableType: CommentableType, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } };

export type DocumentSimpleFragment = { __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null };

export type DocumentWithFieldsFragment = { __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null };

export type OnDocumentUpdatedSubscriptionVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type OnDocumentUpdatedSubscription = { __typename: 'Subscription', documentUpdated: { __typename: 'DocumentUpdatedEvent', commentsChanged: boolean, document: { __typename: 'Document', id: string, name: string, isSavePending: boolean, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, vectorsFailedAt: string | null, vectorsSavedAt: string | null, vectorsStartedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, fileExtractionFailedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }> }, questions: Array<{ __typename: 'ExtractionQuestion', id: string, title: string, questionText: string, createdAt: string, updatedAt: string, extractionJob: { __typename: 'ExtractionJob', id: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, createdAt: string, updatedAt: string, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, review: { __typename: 'ExtractionQuestionReview', reviewedAt: string, reviewAction: ReviewAction, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null }> } };

export type OnDocumentsUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDocumentsUpdatedSubscription = { __typename: 'Subscription', documentsUpdated: { __typename: 'DocumentsUpdatedEvent', documents: Array<{ __typename: 'Document', id: string, aiQuestionIdsQueueing: Array<string>, createdAt: string, deletedAt: string | null, lastAccessedByRequesterAt: string | null, name: string, requesterFavorited: boolean, requesterRole: PermissionRole | null, status: DocumentStatus | null, signedAt: string | null, updatedAt: string, variant: DocumentVariant, isCommunityTemplate: boolean, isCertificate: boolean, isSigned: boolean, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, relationshipPropertiesExtractionHash: string | null, relationshipMatchingStartedAt: string | null, relationshipMatchingFinishedAt: string | null, relationshipMatchingFailedReason: string | null, workflowFileRole: WorkflowFileDocumentRole | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, questionJobs: Array<{ __typename: 'ExtractionJob', id: string, createdAt: string, answer: string, previousAnswer: string | null, startedAt: string | null, finishedAt: string | null, failedAt: string | null, failedReason: string | null, lockedAt: string | null, questionContentHashAtRun: string | null, reasoning: string | null, lockedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, locations: Array<{ __typename: 'AlineLocation', locationPath: Array<number>, referenceText: string } | { __typename: 'FileLocation', pageNum: number, rect: Array<number>, referenceText: string }>, fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null } | null, previousSelectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }>, question: { __typename: 'ExtractionQuestion', id: string, contentHash: string | null, questionText: string, type: ExtractionQuestionType, mode: ExtractionQuestionMode, variant: ExtractionQuestionVariant }, review: { __typename: 'ExtractionQuestionReview', reviewAction: ReviewAction, reviewedAt: string, reviewedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null, selectedOptions: Array<{ __typename: 'QuestionOption', id: string, color: string, label: string, order: number }> }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, type: { __typename: 'ContractType', id: string, value: string } | null, workflow: { __typename: 'Workflow', id: string, envelopeStatus: EnvelopeStatus, isSignedOutsideAline: boolean, wasSentForSig: boolean } | null }> } };

export type OnDocPlaybooksUpdatedSubscriptionVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type OnDocPlaybooksUpdatedSubscription = { __typename: 'Subscription', docPlaybooksUpdated: { __typename: 'DocPlaybooksUpdatedEvent', documentId: string, playbooks: Array<{ __typename: 'Playbook', id: string, title: string, description: string, runStatus: PlaybookRunStatus, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> }> }> | null, ruleJob: { __typename: 'PlaybookRuleJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, createdAt: string, updatedAt: string, rule: { __typename: 'PlaybookRule', id: string, ruleJob: { __typename: 'PlaybookRuleJob', id: string } | null } | null, proposals: Array<{ __typename: 'PlaybookRuleProposal', id: string, positionId: string, decisions: { [key: string]: any }, suggestions: { [key: string]: any }, createdAt: string }>, positionResults: Array<{ __typename: 'PlaybookRuleJobPositionResult', positionId: string, rank: string, ruleText: string, aiGuidance: string | null, explanation: string, status: PlaybookPositionStatus, finishedAt: string | null, failedAt: string | null, failedReason: string | null }>, resolution: { __typename: 'PlaybookRuleJobResolution', kind: PlaybookRuleResolutionKind, positionId: string | null, at: string, by: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } | null, playbook: { __typename: 'Playbook', id: string, runStatus: PlaybookRunStatus } | null } };

export type OnPlaybookGenerationJobUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPlaybookGenerationJobUpdatedSubscription = { __typename: 'Subscription', playbookGenerationJobUpdated: { __typename: 'PlaybookGenerationJobUpdatedEvent', generationJobId: string, createdCategoryId: string | null, createdRuleId: string | null, createdCategory: { __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string, rules: Array<{ __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> }> } | null, createdRule: { __typename: 'PlaybookRule', id: string, title: string, rank: string, createdAt: string, updatedAt: string, category: { __typename: 'PlaybookRuleCategory', id: string }, positions: Array<{ __typename: 'PlaybookRulePosition', id: string, rank: string, ruleText: string, aiGuidance: string | null }> } | null, generationJob: { __typename: 'PlaybookGenerationJob', id: string, startedAt: string | null, finishedAt: string | null, failedReason: string | null, failedAt: string | null, generatedCategoryCount: number, openCategory: { __typename: 'PlaybookRuleCategory', id: string, name: string } | null, playbook: { __typename: 'Playbook', ruleCount: number, id: string, title: string, description: string, createdAt: string, updatedAt: string, categories: Array<{ __typename: 'PlaybookRuleCategory', id: string, name: string, rank: string, createdAt: string, updatedAt: string }> } | null } | null } };

export type OnQuestionGenerationUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnQuestionGenerationUpdatedSubscription = { __typename: 'Subscription', questionGenerationUpdated: { __typename: 'QuestionGenerationJobUpdatedEvent', generationJob: { __typename: 'ExtractionQuestionGenerationJob', id: string, startedAt: string | null, failedAt: string | null, failedReason: string | null, finishedAt: string | null, extractionQuestions: Array<{ __typename: 'ExtractionQuestion', isActive: boolean, aiGenerated: boolean }> } | null } };

export type GetDocumentHeaderQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentHeaderQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, createdAt: string, requesterRole: PermissionRole | null, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', id: string, mimetype: string } }, workflow: { __typename: 'Workflow', id: string, name: string, state: WorkflowState, status: WorkflowStatus, envelopeStatus: EnvelopeStatus, variant: WorkflowVariant, startedAt: string | null, createdAt: string, completedAt: string | null, publishedAt: string | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> } | null } };

export type DocumentFileDetailsRelatedDocumentFragment = { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } };

export type DocumentFileDetailsRelationshipFragment = { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childType: ChildType, childUrl: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, expectedDocumentName: string | null, expectedDocumentAgreementDate: string | null, sourceAgreementName: string | null, createdAt: string, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null, childDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null, parentDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null };

export type DocumentFileDetailsUrlRelationshipFragment = { __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childUrl: string | null, childType: ChildType, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, reason: string | null, citations: Array<string>, createdAt: string, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null };

export type GetDocumentFileDetailsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentFileDetailsQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, conversionStartedAt: string | null, conversionFinishedAt: string | null, conversionFailedAt: string | null, name: string, requesterRole: PermissionRole | null, relationshipMatchingStartedAt: string | null, relationshipMatchingFinishedAt: string | null, relationshipMatchingFailedReason: string | null, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, type: { __typename: 'ContractType', id: string, value: string } | null, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, workflow: { __typename: 'Workflow', id: string, owner: { __typename: 'User', id: string, displayName: string } } | null, parentRelationships: Array<{ __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childType: ChildType, childUrl: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, expectedDocumentName: string | null, expectedDocumentAgreementDate: string | null, sourceAgreementName: string | null, createdAt: string, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null, childDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null, parentDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null }>, childRelationships: Array<{ __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childDocumentId: string | null, childType: ChildType, childUrl: string | null, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, expectedDocumentName: string | null, expectedDocumentAgreementDate: string | null, sourceAgreementName: string | null, createdAt: string, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null, childDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null, parentDocument: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } | null }>, urlRelationships: Array<{ __typename: 'DocumentRelationship', id: string, parentDocumentId: string | null, childUrl: string | null, childType: ChildType, childRelationshipType: ChildRelationshipType, source: DocumentRelationshipSource, llmReasonsMarkdown: string | null, reason: string | null, citations: Array<string>, createdAt: string, review: { __typename: 'DocumentRelationshipReview', outcome: ReviewOutcome, reviewedBy: { __typename: 'User', id: string, displayName: string } | null } | null }> } };

export type GetFileVersionQueryVariables = Exact<{
  fileVersionId: Scalars['UUID'];
}>;


export type GetFileVersionQuery = { __typename: 'Query', fileVersion: { __typename: 'DocumentVersion', documentJSON: { [key: string]: any }, id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } };

export type CreateStaticFileVersionMutationVariables = Exact<{
  input: CreateStaticFileVersionInput;
}>;


export type CreateStaticFileVersionMutation = { __typename: 'Mutation', createStaticFileVersion: { __typename: 'FileVersionResponse', fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } } };

export type CreateStaticFileVersionsMutationVariables = Exact<{
  input: CreateStaticFileVersionsInput;
}>;


export type CreateStaticFileVersionsMutation = { __typename: 'Mutation', createStaticFileVersions: Array<{ __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }> };

export type DeleteFileVersionMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteFileVersionMutation = { __typename: 'Mutation', deleteFileVersion: string };

export type SyncFileVersionToCrmMutationVariables = Exact<{
  input: SyncFileVersionToCrmInput;
}>;


export type SyncFileVersionToCrmMutation = { __typename: 'Mutation', syncFileVersionToCrm: { __typename: 'FileVersionResponse', fileVersion: { __typename: 'DocumentVersion', id: string, name: string } | { __typename: 'StaticFileVersion', id: string, name: string } } };

export type UpdateFileVersionMutationVariables = Exact<{
  input: UpdateFileVersionInput;
}>;


export type UpdateFileVersionMutation = { __typename: 'Mutation', updateFileVersion: { __typename: 'FileVersionResponse', fileVersion: { __typename: 'DocumentVersion', id: string, name: string } | { __typename: 'StaticFileVersion', id: string, name: string } } };

export type FileVersionSimple_DocumentVersion_Fragment = { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> };

export type FileVersionSimple_StaticFileVersion_Fragment = { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } };

export type FileVersionSimpleFragment = FileVersionSimple_DocumentVersion_Fragment | FileVersionSimple_StaticFileVersion_Fragment;

export type GetStorableRoleQueryVariables = Exact<{
  storableId: Scalars['UUID'];
}>;


export type GetStorableRoleQuery = { __typename: 'Query', storableRole: { __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, storable: { __typename: 'Document', id: string }, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null };

export type GetSharedStorablesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSharedStorablesQuery = { __typename: 'Query', sharedStorables: Array<{ __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, storable: { __typename: 'Document', id: string, name: string, requesterRole: PermissionRole | null, requesterFavorited: boolean, storableType: StorableType, createdAt: string, updatedAt: string, variant: DocumentVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState } | null }, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type GetStorablePermissionsQueryVariables = Exact<{
  storableId: Scalars['UUID'];
}>;


export type GetStorablePermissionsQuery = { __typename: 'Query', storablePermissions: Array<{ __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, storable: { __typename: 'Document', id: string }, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type GetStorablePermissionsWithStorableQueryVariables = Exact<{
  storableId: Scalars['UUID'];
}>;


export type GetStorablePermissionsWithStorableQuery = { __typename: 'Query', storablePermissions: Array<{ __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, storable: { __typename: 'Document', id: string, name: string, requesterRole: PermissionRole | null, requesterFavorited: boolean, storableType: StorableType, createdAt: string, updatedAt: string, variant: DocumentVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState } | null }, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type DeleteStorablePermissionMutationVariables = Exact<{
  permissionId: Scalars['UUID'];
}>;


export type DeleteStorablePermissionMutation = { __typename: 'Mutation', deleteStorablePermission: { __typename: 'StorablePermissionResponse', storablePermission: { __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, storable: { __typename: 'Document', id: string }, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null } };

export type UpsertStorablePermissionsMutationVariables = Exact<{
  input: UpsertStorablePermissions;
}>;


export type UpsertStorablePermissionsMutation = { __typename: 'Mutation', upsertStorablePermissions: { __typename: 'StorablePermissionsResponse', storablePermissions: Array<{ __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, storable: { __typename: 'Document', id: string }, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } };

export type PermissionWithStorableFragment = { __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, storable: { __typename: 'Document', id: string, name: string, requesterRole: PermissionRole | null, requesterFavorited: boolean, storableType: StorableType, createdAt: string, updatedAt: string, variant: DocumentVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState } | null }, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } };

export type PermissionSimpleFragment = { __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } };

export type GetStorablesQueryVariables = Exact<{
  storableIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetStorablesQuery = { __typename: 'Query', storables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null }> } };

export type StorableMetadataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type StorableMetadataQuery = { __typename: 'Query', storableMetadata: { __typename: 'Document', variant: DocumentVariant, id: string, name: string, storableType: StorableType, requesterFavorited: boolean, requesterRole: PermissionRole | null, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } };

export type GetFavoriteStorablesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFavoriteStorablesQuery = { __typename: 'Query', favoriteStorables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null }> } };

export type SearchDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchDataQuery = { __typename: 'Query', searchData: { __typename: 'Storables', documents: Array<{ __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null }> } };

export type DisabledStorablesQueryVariables = Exact<{ [key: string]: never; }>;


export type DisabledStorablesQuery = { __typename: 'Query', disabledStorables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null }> } };

export type DeleteStorablesMutationVariables = Exact<{
  deleteProps: DeleteStorables;
}>;


export type DeleteStorablesMutation = { __typename: 'Mutation', deleteStorables: Array<string> };

export type DisableStorablesMutationVariables = Exact<{
  disableProps: DeleteStorables;
}>;


export type DisableStorablesMutation = { __typename: 'Mutation', disableStorables: { __typename: 'StorablesResponse', storables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', variant: DocumentVariant, id: string, requesterFavorited: boolean, name: string, ownerId: string, requesterRole: PermissionRole | null, storableType: StorableType, updatedAt: string, deletedAt: string | null, workflow: { __typename: 'Workflow', id: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } } };

export type FavoriteStorablesMutationVariables = Exact<{
  favoriteProps: FavoriteStorables;
}>;


export type FavoriteStorablesMutation = { __typename: 'Mutation', favoriteStorables: { __typename: 'StorablesResponse', storables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', variant: DocumentVariant, id: string, requesterFavorited: boolean, name: string, ownerId: string, requesterRole: PermissionRole | null, storableType: StorableType, updatedAt: string, deletedAt: string | null, workflow: { __typename: 'Workflow', id: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } } };

export type MoveStorablesMutationVariables = Exact<{
  moveProps: MoveStorables;
}>;


export type MoveStorablesMutation = { __typename: 'Mutation', moveStorables: { __typename: 'StorablesResponse', storables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', variant: DocumentVariant, id: string, name: string, ownerId: string, requesterFavorited: boolean, requesterRole: PermissionRole | null, storableType: StorableType, updatedAt: string, deletedAt: string | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } } };

export type MoveStorablesSimpleMutationVariables = Exact<{
  moveProps: MoveStorables;
}>;


export type MoveStorablesSimpleMutation = { __typename: 'Mutation', moveStorables: { __typename: 'StorablesResponse', storables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', id: string }> } } };

export type RestoreStorablesMutationVariables = Exact<{
  restoreProps: RestoreStorables;
}>;


export type RestoreStorablesMutation = { __typename: 'Mutation', restoreStorables: { __typename: 'StorablesResponse', storables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', variant: DocumentVariant, id: string, requesterFavorited: boolean, name: string, ownerId: string, requesterRole: PermissionRole | null, storableType: StorableType, updatedAt: string, deletedAt: string | null, workflow: { __typename: 'Workflow', id: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } } };

export type UpdateStorableMutationVariables = Exact<{
  updateProps: UpdateStorable;
}>;


export type UpdateStorableMutation = { __typename: 'Mutation', updateStorable: { __typename: 'StorablesResponse', storables: { __typename: 'Storables', documents: Array<{ __typename: 'Document', variant: DocumentVariant, id: string, requesterFavorited: boolean, name: string, ownerId: string, requesterRole: PermissionRole | null, storableType: StorableType, updatedAt: string, deletedAt: string | null, workflow: { __typename: 'Workflow', id: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> } } };

export type RequestAccessToStorableMutationVariables = Exact<{
  input: RequestAccessToStorableInput;
}>;


export type RequestAccessToStorableMutation = { __typename: 'Mutation', requestAccessToStorable: Array<{ __typename: 'MyAccessRequestInfo', documentId: string, status: AccessRequestStatus }> };

export type MoveStorableFieldsFragment = { __typename: 'Document', variant: DocumentVariant, id: string, name: string, ownerId: string, requesterFavorited: boolean, requesterRole: PermissionRole | null, storableType: StorableType, updatedAt: string, deletedAt: string | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } };

export type StorableFieldsFragment = { __typename: 'Document', variant: DocumentVariant, id: string, requesterFavorited: boolean, name: string, ownerId: string, requesterRole: PermissionRole | null, storableType: StorableType, updatedAt: string, deletedAt: string | null, workflow: { __typename: 'Workflow', id: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } };

export type StorableSimpleFragment = { __typename: 'Document', variant: DocumentVariant, id: string, name: string, storableType: StorableType, requesterFavorited: boolean, requesterRole: PermissionRole | null, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } };

export type CreateTaskFieldMutationVariables = Exact<{
  input: CreateTaskFieldInput;
}>;


export type CreateTaskFieldMutation = { __typename: 'Mutation', createTaskField: { __typename: 'TaskFieldResponse', taskField: { __typename: 'TaskField', id: string, label: string, type: TaskFieldType, isRequired: boolean, order: number, config: { [key: string]: any } | null, response: { [key: string]: any } | null, completedAt: string | null, createdAt: string, updatedAt: string, completedBy: { __typename: 'User', id: string } | null, task: { __typename: 'Task', id: string } } } };

export type UpdateTaskFieldMutationVariables = Exact<{
  input: UpdateTaskFieldInput;
}>;


export type UpdateTaskFieldMutation = { __typename: 'Mutation', updateTaskField: { __typename: 'TaskFieldResponse', taskField: { __typename: 'TaskField', id: string, label: string, type: TaskFieldType, isRequired: boolean, order: number, config: { [key: string]: any } | null, response: { [key: string]: any } | null, completedAt: string | null, createdAt: string, updatedAt: string, completedBy: { __typename: 'User', id: string } | null, task: { __typename: 'Task', id: string } } } };

export type DeleteTaskFieldMutationVariables = Exact<{
  taskFieldId: Scalars['UUID'];
}>;


export type DeleteTaskFieldMutation = { __typename: 'Mutation', deleteTaskField: string };

export type SubmitTaskFieldResponseMutationVariables = Exact<{
  input: SubmitTaskFieldResponseInput;
}>;


export type SubmitTaskFieldResponseMutation = { __typename: 'Mutation', submitTaskFieldResponse: { __typename: 'TaskFieldResponse', taskField: { __typename: 'TaskField', id: string, label: string, type: TaskFieldType, isRequired: boolean, order: number, config: { [key: string]: any } | null, response: { [key: string]: any } | null, completedAt: string | null, createdAt: string, updatedAt: string, completedBy: { __typename: 'User', id: string } | null, task: { __typename: 'Task', id: string } } } };

export type ReorderTaskFieldsMutationVariables = Exact<{
  input: ReorderTaskFieldsInput;
}>;


export type ReorderTaskFieldsMutation = { __typename: 'Mutation', reorderTaskFields: Array<{ __typename: 'TaskField', id: string, label: string, type: TaskFieldType, isRequired: boolean, order: number, config: { [key: string]: any } | null, response: { [key: string]: any } | null, completedAt: string | null, createdAt: string, updatedAt: string, completedBy: { __typename: 'User', id: string } | null, task: { __typename: 'Task', id: string } }> };

export type TaskFieldSimpleFragment = { __typename: 'TaskField', id: string, label: string, type: TaskFieldType, isRequired: boolean, order: number, config: { [key: string]: any } | null, response: { [key: string]: any } | null, completedAt: string | null, createdAt: string, updatedAt: string, completedBy: { __typename: 'User', id: string } | null, task: { __typename: 'Task', id: string } };

export type GetTaskQueryVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type GetTaskQuery = { __typename: 'Query', task: { __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> } | null };

export type GetTaskStatusQueryVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type GetTaskStatusQuery = { __typename: 'Query', task: { __typename: 'Task', id: string, status: TaskStatus, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null } } | null };

export type GetTaskWithCommentsQueryVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type GetTaskWithCommentsQuery = { __typename: 'Query', task: { __typename: 'Task', id: string, alineAiRunMessageId: string | null, completedAt: string | null, description: string, externalDescription: string, isDelegatedToAi: boolean, status: TaskStatus, title: string, startedAt: string | null, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, phase: { __typename: 'NonSigningPhase', id: string, completedAt: string | null, name: string, startedAt: string | null } | { __typename: 'SigningPhase', id: string, completedAt: string | null, name: string, startedAt: string | null }, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, createdAt: string, text: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, boardId: string, name: string, requesterInOwnerOrg: boolean, startedAt: string | null, variant: WorkflowVariant, owner: { __typename: 'User', id: string }, column: { __typename: 'Column', category: ColumnCategory, id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string }>, files: Array<{ __typename: 'WorkflowFile', id: string, orderId: string, document: { __typename: 'Document', id: string, name: string, requesterRole: PermissionRole | null, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', id: string, mimetype: string } } } }> }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | null };

export type GetTaskDocumentDownloadQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetTaskDocumentDownloadQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, isSigned: boolean, latestVersion: { __typename: 'DocumentVersion', documentJSON: { [key: string]: any }, id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } } };

export type GetTaskLandingQueryVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type GetTaskLandingQuery = { __typename: 'Query', task: { __typename: 'Task', id: string, requesterIsInternal: boolean, title: string, workflow: { __typename: 'Workflow', id: string } } | null };

export type GetTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTasksQuery = { __typename: 'Query', tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }> };

export type GetUserTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTasksQuery = { __typename: 'Query', userIncompleteTasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, description: string, status: TaskStatus, title: string, parentTask: { __typename: 'Task', id: string, title: string } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant } }> };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename: 'Mutation', createTask: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> } } };

export type SetTaskAssigneesMutationVariables = Exact<{
  input: SetTaskAssigneesInput;
}>;


export type SetTaskAssigneesMutation = { __typename: 'Mutation', setTaskAssignees: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, alineAiRunMessageId: string | null, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename: 'Mutation', updateTask: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> } } };

export type StartTaskAiExecutionMutationVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type StartTaskAiExecutionMutation = { __typename: 'Mutation', startTaskAiExecution: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, alineAiRunMessageId: string | null, isDelegatedToAi: boolean, startedAt: string | null, status: TaskStatus }, activityItem: { __typename: 'ActivityItem', id: string, itemType: ActivityItemType, sourceType: ActivitySourceType, audience: ActivityAudience, createdAt: string, channelThread: { __typename: 'ChannelThread', id: string, provider: ChannelProvider, externalChannelId: string, externalThreadId: string, webUrl: string | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, body: { __typename: 'AgentThreadActivity', agentThread: { __typename: 'AgentThread', id: string, ownerUserId: string, title: string, createdAt: string, updatedAt: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null }> } | null } | { __typename: 'CommentActivity', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } | { __typename: 'StatusUpdateActivity', events: Array<{ __typename: 'ActivityStatusEvent', eventType: ActivityStatusEventType, data: { [key: string]: any } | null, assignmentChange: ActivityAssignmentChange | null, targetCount: number, removedCount: number, reviewerIds: Array<string>, targetReviewerCount: number, removedReviewerCount: number, movedCount: number, movedReviewerCount: number, movedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, movedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, targetUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, targetRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, removedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, removedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, onBehalfOfUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, reviewRequestUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } } | null } };

export type SetTaskDelegatedToAiMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  delegated: Scalars['Boolean'];
}>;


export type SetTaskDelegatedToAiMutation = { __typename: 'Mutation', setTaskDelegatedToAi: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, alineAiRunMessageId: string | null, isDelegatedToAi: boolean, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }, activityItem: { __typename: 'ActivityItem', id: string, itemType: ActivityItemType, sourceType: ActivitySourceType, audience: ActivityAudience, createdAt: string, channelThread: { __typename: 'ChannelThread', id: string, provider: ChannelProvider, externalChannelId: string, externalThreadId: string, webUrl: string | null } | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, body: { __typename: 'AgentThreadActivity', agentThread: { __typename: 'AgentThread', id: string, ownerUserId: string, title: string, createdAt: string, updatedAt: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: AgentMessageRole, status: AgentMessageStatus, text: string, data: { [key: string]: any }, planState: { [key: string]: any } | null }> } | null } | { __typename: 'CommentActivity', comment: { __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> } | null } | { __typename: 'StatusUpdateActivity', events: Array<{ __typename: 'ActivityStatusEvent', eventType: ActivityStatusEventType, data: { [key: string]: any } | null, assignmentChange: ActivityAssignmentChange | null, targetCount: number, removedCount: number, reviewerIds: Array<string>, targetReviewerCount: number, removedReviewerCount: number, movedCount: number, movedReviewerCount: number, movedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, movedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, targetUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, targetRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, removedUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, removedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string }>, onBehalfOfUser: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, reviewRequestUsers: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> }> } } | null } };

export type UpdateTaskDescriptionMarkdownMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  markdown: Scalars['String'];
}>;


export type UpdateTaskDescriptionMarkdownMutation = { __typename: 'Mutation', updateTaskDescriptionMarkdown: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, description: string } } };

export type UpdateTaskExternalDescriptionMarkdownMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  markdown: Scalars['String'];
}>;


export type UpdateTaskExternalDescriptionMarkdownMutation = { __typename: 'Mutation', updateTaskExternalDescriptionMarkdown: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, externalDescription: string } } };

export type ChangeTaskStatusMutationVariables = Exact<{
  input: ChangeTaskStatusProps;
}>;


export type ChangeTaskStatusMutation = { __typename: 'Mutation', changeTaskStatus: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, completedAt: string | null, status: TaskStatus, startedAt: string | null, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, phase: { __typename: 'NonSigningPhase', id: string, completedAt: string | null, startedAt: string | null } | { __typename: 'SigningPhase', id: string, completedAt: string | null, startedAt: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, status: WorkflowStatus, state: WorkflowState }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type DeleteTaskMutationVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type DeleteTaskMutation = { __typename: 'Mutation', deleteTask: string };

export type TaskSimpleFragment = { __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> };

export type TaskAssignmentFieldsFragment = { __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> };

export type VersionTaskUploadFragment = { __typename: 'TaskUpload', id: string, createdAt: string, task: { __typename: 'Task', id: string, title: string }, uploadedBy: { __typename: 'User', id: string, displayName: string } | null };

export type TaskUploadFieldsFragment = { __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null };

export type TaskReviewFieldsFragment = { __typename: 'Task', id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> };

export type TaskViewerActionFieldsFragment = { __typename: 'Task', id: string, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> };

export type TaskUnsubmittedReviewFieldsFragment = { __typename: 'Task', id: string, viewerUnsubmittedReview: { __typename: 'TaskUnsubmittedReview', commentCount: number, trackedChangeCount: number } | null };

export type GetTaskUnsubmittedReviewQueryVariables = Exact<{
  taskId: Scalars['UUID'];
}>;


export type GetTaskUnsubmittedReviewQuery = { __typename: 'Query', task: { __typename: 'Task', id: string, viewerUnsubmittedReview: { __typename: 'TaskUnsubmittedReview', commentCount: number, trackedChangeCount: number } | null } | null };

export type SetTaskAssigneeRequiredMutationVariables = Exact<{
  input: SetTaskAssigneeRequiredInput;
}>;


export type SetTaskAssigneeRequiredMutation = { __typename: 'Mutation', setTaskAssigneeRequired: { __typename: 'TaskResponse', task: { __typename: 'Task', completedAt: string | null, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type SetTaskAssigneeRoleMutationVariables = Exact<{
  input: SetTaskAssigneeRoleInput;
}>;


export type SetTaskAssigneeRoleMutation = { __typename: 'Mutation', setTaskAssigneeRole: { __typename: 'TaskResponse', task: { __typename: 'Task', completedAt: string | null, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type RequestTaskReviewMutationVariables = Exact<{
  input: RequestTaskReviewInput;
}>;


export type RequestTaskReviewMutation = { __typename: 'Mutation', requestTaskReview: { __typename: 'TaskResponse', warning: string | null, task: { __typename: 'Task', completedAt: string | null, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type UndoTaskReviewRequestMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  reviewerPermissionId?: InputMaybe<Scalars['UUID']>;
}>;


export type UndoTaskReviewRequestMutation = { __typename: 'Mutation', undoTaskReviewRequest: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type ApproveTaskMutationVariables = Exact<{
  input: ApproveTaskInput;
}>;


export type ApproveTaskMutation = { __typename: 'Mutation', approveTask: { __typename: 'TaskResponse', task: { __typename: 'Task', completedAt: string | null, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type StartTaskMutationVariables = Exact<{
  input: StartTaskInput;
}>;


export type StartTaskMutation = { __typename: 'Mutation', startTask: { __typename: 'TaskResponse', task: { __typename: 'Task', completedAt: string | null, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type RequestTaskChangesMutationVariables = Exact<{
  input: RequestTaskChangesInput;
}>;


export type RequestTaskChangesMutation = { __typename: 'Mutation', requestTaskChanges: { __typename: 'TaskResponse', task: { __typename: 'Task', completedAt: string | null, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type CompleteTaskForAssigneeMutationVariables = Exact<{
  input: CompleteTaskForAssigneeInput;
}>;


export type CompleteTaskForAssigneeMutation = { __typename: 'Mutation', completeTaskForAssignee: { __typename: 'TaskResponse', task: { __typename: 'Task', completedAt: string | null, status: TaskStatus, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type RemindTaskAssigneesMutationVariables = Exact<{
  input: RemindTaskAssigneesInput;
}>;


export type RemindTaskAssigneesMutation = { __typename: 'Mutation', remindTaskAssignees: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type RemindTaskReviewersMutationVariables = Exact<{
  input: RemindTaskReviewersInput;
}>;


export type RemindTaskReviewersMutation = { __typename: 'Mutation', remindTaskReviewers: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }>, viewerActionRecipients: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } } };

export type RejectTaskMutationVariables = Exact<{
  input: RejectTaskInput;
}>;


export type RejectTaskMutation = { __typename: 'Mutation', rejectTask: { __typename: 'TaskResponse', task: { __typename: 'Task', completedAt: string | null, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> } } };

export type UploadTaskResponseVersionMutationVariables = Exact<{
  input: UploadTaskResponseVersionInput;
}>;


export type UploadTaskResponseVersionMutation = { __typename: 'Mutation', uploadTaskResponseVersion: { __typename: 'TaskResponse', task: { __typename: 'Task', completedAt: string | null, id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> } } };

export type ClearTaskUploadMutationVariables = Exact<{
  taskUploadId: Scalars['UUID'];
}>;


export type ClearTaskUploadMutation = { __typename: 'Mutation', clearTaskUpload: { __typename: 'TaskResponse', task: { __typename: 'Task', id: string, counterpartyName: string | null, hasExternalAssignees: boolean, isDelegatedToAi: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, startedAt: string | null, status: TaskStatus, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> } } };

export type DisallowedTaskReasonsSimpleFragment = { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null };

export type GetUserDefinedRoleQueryVariables = Exact<{
  roleId: Scalars['UUID'];
}>;


export type GetUserDefinedRoleQuery = { __typename: 'Query', userDefinedRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null };

export type GetUserDefinedRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDefinedRolesQuery = { __typename: 'Query', userDefinedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null }> };

export type GetRequesterUserDefinedRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequesterUserDefinedRolesQuery = { __typename: 'Query', userDefinedRoles: Array<{ __typename: 'UserDefinedRole', id: string, roleName: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, org: { __typename: 'Org', id: string } | null }> };

export type CreateUserDefinedRoleMutationVariables = Exact<{
  input: CreateUserDefinedRoleInput;
}>;


export type CreateUserDefinedRoleMutation = { __typename: 'Mutation', createUserDefinedRole: { __typename: 'UserDefinedRoleResponse', userDefinedRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } } };

export type DeleteUserDefinedRoleMutationVariables = Exact<{
  input: DeleteUserDefinedRoleInput;
}>;


export type DeleteUserDefinedRoleMutation = { __typename: 'Mutation', deleteUserDefinedRole: string };

export type MergeRolesMutationVariables = Exact<{
  input: MergeRolesInput;
}>;


export type MergeRolesMutation = { __typename: 'Mutation', mergeUserDefinedRoles: { __typename: 'UserDefinedRoleResponse', userDefinedRole: { __typename: 'UserDefinedRole', id: string, roleName: string } } };

export type UpdateUserDefinedRoleMutationVariables = Exact<{
  input: UpdateUserDefinedRoleInput;
}>;


export type UpdateUserDefinedRoleMutation = { __typename: 'Mutation', updateUserDefinedRole: { __typename: 'UserDefinedRoleResponse', userDefinedRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } } };

export type UserDefinedRoleSimpleFragment = { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null };

export type CannedFieldFullFragment = { __typename: 'CannedField', id: string, nodeId: string, variant: CannedFieldVariant, workflowId: string, value: string | null, defaultValue: string | null, assigneeId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, assignee: { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType, status: WorkflowRecipientStatus, recipientName: string | null, assignee: { __typename: 'User', id: string, displayName: string, avatarColor: string, accountType: AccountType, email: string, firstName: string | null, lastName: string | null } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string } | null, permission: { __typename: 'WorkflowPermission', id: string, isLauncher: boolean } } | null, placements: Array<{ __typename: 'CannedFieldPlacement', id: string, cannedFieldId: string, documentId: string }> };

export type GetWorkflowCannedFieldsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowCannedFieldsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, cannedFields: Array<{ __typename: 'CannedField', id: string, nodeId: string, variant: CannedFieldVariant, workflowId: string, value: string | null, defaultValue: string | null, assigneeId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, assignee: { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType, status: WorkflowRecipientStatus, recipientName: string | null, assignee: { __typename: 'User', id: string, displayName: string, avatarColor: string, accountType: AccountType, email: string, firstName: string | null, lastName: string | null } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string } | null, permission: { __typename: 'WorkflowPermission', id: string, isLauncher: boolean } } | null, placements: Array<{ __typename: 'CannedFieldPlacement', id: string, cannedFieldId: string, documentId: string }> }> } | null };

export type GetCannedFieldQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCannedFieldQuery = { __typename: 'Query', cannedField: { __typename: 'CannedField', id: string, nodeId: string, variant: CannedFieldVariant, workflowId: string, value: string | null, defaultValue: string | null, assigneeId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, assignee: { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType, status: WorkflowRecipientStatus, recipientName: string | null, assignee: { __typename: 'User', id: string, displayName: string, avatarColor: string, accountType: AccountType, email: string, firstName: string | null, lastName: string | null } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string } | null, permission: { __typename: 'WorkflowPermission', id: string, isLauncher: boolean } } | null, placements: Array<{ __typename: 'CannedFieldPlacement', id: string, cannedFieldId: string, documentId: string }> } | null };

export type CreateCannedFieldMutationVariables = Exact<{
  input: CreateCannedFieldInput;
}>;


export type CreateCannedFieldMutation = { __typename: 'Mutation', createCannedField: { __typename: 'CannedFieldResponse', cannedField: { __typename: 'CannedField', id: string, nodeId: string, variant: CannedFieldVariant, workflowId: string, value: string | null, defaultValue: string | null, assigneeId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, assignee: { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType, status: WorkflowRecipientStatus, recipientName: string | null, assignee: { __typename: 'User', id: string, displayName: string, avatarColor: string, accountType: AccountType, email: string, firstName: string | null, lastName: string | null } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string } | null, permission: { __typename: 'WorkflowPermission', id: string, isLauncher: boolean } } | null, placements: Array<{ __typename: 'CannedFieldPlacement', id: string, cannedFieldId: string, documentId: string }> } } };

export type UpdateCannedFieldMutationVariables = Exact<{
  input: UpdateCannedFieldInput;
}>;


export type UpdateCannedFieldMutation = { __typename: 'Mutation', updateCannedField: { __typename: 'CannedFieldResponse', cannedField: { __typename: 'CannedField', id: string, nodeId: string, variant: CannedFieldVariant, workflowId: string, value: string | null, defaultValue: string | null, assigneeId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, assignee: { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType, status: WorkflowRecipientStatus, recipientName: string | null, assignee: { __typename: 'User', id: string, displayName: string, avatarColor: string, accountType: AccountType, email: string, firstName: string | null, lastName: string | null } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string } | null, permission: { __typename: 'WorkflowPermission', id: string, isLauncher: boolean } } | null, placements: Array<{ __typename: 'CannedFieldPlacement', id: string, cannedFieldId: string, documentId: string }> } } };

export type DeleteCannedFieldMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteCannedFieldMutation = { __typename: 'Mutation', deleteCannedField: { __typename: 'CannedFieldResponse', cannedField: { __typename: 'CannedField', id: string, nodeId: string, variant: CannedFieldVariant, workflowId: string, value: string | null, defaultValue: string | null, assigneeId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, assignee: { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType, status: WorkflowRecipientStatus, recipientName: string | null, assignee: { __typename: 'User', id: string, displayName: string, avatarColor: string, accountType: AccountType, email: string, firstName: string | null, lastName: string | null } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string } | null, permission: { __typename: 'WorkflowPermission', id: string, isLauncher: boolean } } | null, placements: Array<{ __typename: 'CannedFieldPlacement', id: string, cannedFieldId: string, documentId: string }> } } };

export type GetVariablesForDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetVariablesForDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, variables: Array<{ __typename: 'DocumentVariable', deletedAt: string | null, id: string, isField: boolean, addToLaunchForm: boolean, label: string, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, value: string | null, variant: MetadataVariant, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }> } };

export type GetDocumentVariableQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetDocumentVariableQuery = { __typename: 'Query', documentVariable: { __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } } | null };

export type GetVariableWithActionQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetVariableWithActionQuery = { __typename: 'Query', documentVariable: { __typename: 'DocumentVariable', id: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null } | null };

export type CreateDocumentVariableMutationVariables = Exact<{
  input: CreateDocumentVariableInput;
}>;


export type CreateDocumentVariableMutation = { __typename: 'Mutation', createVariable: { __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } } };

export type DisableDocumentVariableMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DisableDocumentVariableMutation = { __typename: 'Mutation', disableVariable: { __typename: 'DocumentVariable', id: string, deletedAt: string | null } };

export type UpdateDocumentVariableMutationVariables = Exact<{
  input: UpdateDocumentVariableInput;
}>;


export type UpdateDocumentVariableMutation = { __typename: 'Mutation', updateVariable: { __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } } };

export type DocumentVariableFullFragment = { __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } };

export type DocumentVariableSimpleFragment = { __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null };

export type GetVariableConfigQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetVariableConfigQuery = { __typename: 'Query', variableConfig: { __typename: 'DocumentVariableConfig', id: string, label: string, notes: string, prefix: string | null, question: string, variant: MetadataVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null } };

export type GetVariableConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVariableConfigsQuery = { __typename: 'Query', variableConfigs: Array<{ __typename: 'DocumentVariableConfig', id: string, label: string, notes: string, numTimesUsed: number, prefix: string | null, question: string, variant: MetadataVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type CreateVariableConfigMutationVariables = Exact<{
  input: CreateVariableConfigInput;
}>;


export type CreateVariableConfigMutation = { __typename: 'Mutation', createVariableConfig: { __typename: 'DocumentVariableConfig', id: string, label: string, notes: string, prefix: string | null, question: string, variant: MetadataVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null } };

export type DeleteVariableConfigMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteVariableConfigMutation = { __typename: 'Mutation', deleteVariableConfig: string };

export type UpdateVariableConfigMutationVariables = Exact<{
  input: UpdateVariableConfigInput;
}>;


export type UpdateVariableConfigMutation = { __typename: 'Mutation', updateVariableConfig: { __typename: 'DocumentVariableConfig', id: string, label: string, notes: string, prefix: string | null, question: string, variant: MetadataVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null } };

export type MergeVariableConfigsMutationVariables = Exact<{
  input: MergeVariableConfigsInput;
}>;


export type MergeVariableConfigsMutation = { __typename: 'Mutation', mergeVariableConfigs: { __typename: 'DocumentVariableConfig', id: string } };

export type VariableConfigSimpleFragment = { __typename: 'DocumentVariableConfig', id: string, label: string, notes: string, numTimesUsed: number, prefix: string | null, question: string, variant: MetadataVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } };

export type VariableConfigFullFragment = { __typename: 'DocumentVariableConfig', id: string, label: string, notes: string, prefix: string | null, question: string, variant: MetadataVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null };

export type GetWorkflowLinkedOpportunitiesQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowLinkedOpportunitiesQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, linkedOpportunities: Array<{ __typename: 'LinkedOpportunity', id: string, integration: Integration, opportunityId: string }> } | null };

export type GetLinkedOpportunityQueryVariables = Exact<{
  linkOpportunityId: Scalars['UUID'];
}>;


export type GetLinkedOpportunityQuery = { __typename: 'Query', linkedOpportunity: { __typename: 'LinkedOpportunity', id: string, integration: Integration, opportunityId: string } };

export type TemplateOpportunityAttributesQueryVariables = Exact<{
  serviceId: Scalars['String'];
}>;


export type TemplateOpportunityAttributesQuery = { __typename: 'Query', templateOpportunityAttributes: Array<{ __typename: 'IntegrationField', category: CrmIntegrationCategory, fieldApiName: string | null, groupDisplayName: string, groupSortIndex: number, isCustom: boolean, objectType: SalesforceFieldObjectType | null, path: string, recordId: string | null, title: string, type: IntegrationFieldType, value: string | null, valueStatus: IntegrationFieldValueStatus, variant: IntegrationFieldVariant }> };

export type GetWorkflowMappedCrmIntegrationsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowMappedCrmIntegrationsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, mappedCrmIntegrations: Array<Integration> } | null };

export type LinkWorkflowOpportunityMutationVariables = Exact<{
  input: LinkedOpportunityInput;
}>;


export type LinkWorkflowOpportunityMutation = { __typename: 'Mutation', linkOpportunity: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, linkedOpportunities: Array<{ __typename: 'LinkedOpportunity', id: string, integration: Integration, opportunityId: string }> } } };

export type UnlinkWorkflowOpportunityMutationVariables = Exact<{
  linkedOpportunityId: Scalars['UUID'];
  documentId?: InputMaybe<Scalars['UUID']>;
}>;


export type UnlinkWorkflowOpportunityMutation = { __typename: 'Mutation', unlinkOpportunity: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, linkedOpportunities: Array<{ __typename: 'LinkedOpportunity', id: string, integration: Integration, opportunityId: string }> } } };

export type GetSalesforceRecordDataQueryVariables = Exact<{
  input: SalesforceRecordDataInput;
}>;


export type GetSalesforceRecordDataQuery = { __typename: 'Query', salesforceRecordData: { __typename: 'SalesforceRecordDataResponse', recordName: string | null, template: { __typename: 'Workflow', id: string, name: string, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, name: string } }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> }, fieldValues: Array<{ __typename: 'SalesforceFieldValue', fieldApiName: string, fieldLabel: string, value: string | null }>, requiredFields: Array<{ __typename: 'SalesforceFieldRequirement', fieldApiName: string, fieldLabel: string, objectType: SalesforceFieldObjectType, isRequired: boolean }> } };

export type CreateWorkflowFromSalesforceMutationVariables = Exact<{
  input: CreateWorkflowInstanceInput;
}>;


export type CreateWorkflowFromSalesforceMutation = { __typename: 'Mutation', createWorkflowInstance: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, name: string, state: WorkflowState } } };

export type GetStepQueryVariables = Exact<{
  stepId: Scalars['UUID'];
}>;


export type GetStepQuery = { __typename: 'Query', workflowStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null };

export type GetWorkflowSigningStepsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowSigningStepsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null };

export type ClearUnusedWorkflowActionsMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type ClearUnusedWorkflowActionsMutation = { __typename: 'Mutation', clearUnusedWorkflowActions: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState, missingActions: boolean, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type WorkflowStepFragmentFragment = { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> };

export type TaskActionSimpleFragment = { __typename: 'Task', id: string, completedAt: string | null, description: string, firstSentAt: string | null, lastSentAt: string | null, createdAt: string, title: string, startedAt: string | null, variant: TaskVariant, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null } };

export type TemplateSalesforceFieldsQueryVariables = Exact<{
  templateId: Scalars['UUID'];
}>;


export type TemplateSalesforceFieldsQuery = { __typename: 'Query', templateSalesforceFields: { __typename: 'TemplateSalesforceFieldsResponse', templateId: string, salesforceFields: Array<{ __typename: 'SalesforceFieldRequirement', fieldApiName: string, fieldLabel: string, objectType: SalesforceFieldObjectType, isRequired: boolean, usedInDocuments: Array<string> }>, alineFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, type: AlineFieldType, required: boolean, order: number, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }>, signerRoles: Array<{ __typename: 'TemplateSignerRole', roleId: string, label: string, order: number, required: boolean, usedInDocuments: Array<string> }>, documentsList: Array<{ __typename: 'TemplateDocument', documentId: string, name: string }> } };

export type GetWalkthroughWorkflowQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWalkthroughWorkflowQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, state: WorkflowState, activeStep: { __typename: 'WorkflowStep', id: string, requesterActions: Array<{ __typename: 'WorkflowRecipient', id: string, completedAt: string | null, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, document: { __typename: 'Document', id: string, createdAt: string }, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, document: { __typename: 'Document', id: string, createdAt: string }, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }> }> } | null, files: Array<{ __typename: 'WorkflowFile', orderId: string, document: { __typename: 'Document', id: string, isSavePending: boolean } }> } | null };

export type RequesterWorkflowRecipientFragment = { __typename: 'WorkflowRecipient', id: string, completedAt: string | null, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, document: { __typename: 'Document', id: string, createdAt: string }, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, document: { __typename: 'Document', id: string, createdAt: string }, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }> };

export type SetWorkflowFileDocumentRoleMutationVariables = Exact<{
  input: SetWorkflowFileDocumentRoleInput;
}>;


export type SetWorkflowFileDocumentRoleMutation = { __typename: 'Mutation', setWorkflowFileDocumentRole: { __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } } };

export type UpdateWorkflowFileOrderMutationVariables = Exact<{
  input: UpdateWorkflowFileOrderInput;
}>;


export type UpdateWorkflowFileOrderMutation = { __typename: 'Mutation', updateWorkflowFileOrder: Array<{ __typename: 'WorkflowFile', id: string, orderId: string }> };

export type SetWorkflowFileInternalMutationVariables = Exact<{
  input: SetWorkflowFileInternalInput;
}>;


export type SetWorkflowFileInternalMutation = { __typename: 'Mutation', setWorkflowFileInternal: { __typename: 'WorkflowFile', id: string, isInternal: boolean, document: { __typename: 'Document', id: string, isInternalOnWorkflow: boolean } } };

export type GetWorkflowFileExternalAccessQueryVariables = Exact<{
  workflowFileId: Scalars['UUID'];
}>;


export type GetWorkflowFileExternalAccessQuery = { __typename: 'Query', workflowFileExternalAccess: Array<{ __typename: 'StorablePermission', id: string, accountType: AccountType, origin: PermissionOrigin, role: PermissionRole, storableType: StorableType, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type WorkflowFileSimpleFragment = { __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } };

export type WorkflowFileWithFieldsFragment = { __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null } };

export type GetInsightPinsQueryVariables = Exact<{
  scope?: InputMaybe<InsightScope>;
}>;


export type GetInsightPinsQuery = { __typename: 'Query', insightPins: Array<{ __typename: 'InsightPin', id: string, chartId: string, sourceSystemPresetId: string | null, sortOrder: number, scope: InsightScope, layout: { [key: string]: any }, owner: { __typename: 'User', avatarColor: string, displayName: string, id: string }, view: { __typename: 'WorkflowView', id: string, name: string, showInSavedViews: boolean, state: { [key: string]: any } } }> };

export type GetWorkflowViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowViewsQuery = { __typename: 'Query', workflowViews: Array<{ __typename: 'WorkflowView', id: string, name: string, showInSavedViews: boolean, state: { [key: string]: any }, updatedAt: string }> };

export type GetWorkflowViewQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetWorkflowViewQuery = { __typename: 'Query', workflowView: { __typename: 'WorkflowView', id: string, name: string, showInSavedViews: boolean, state: { [key: string]: any }, updatedAt: string, author: { __typename: 'User', id: string }, pins: Array<{ __typename: 'InsightPin', id: string, chartId: string, scope: InsightScope }> } | null };

export type GetWorkflowChartSeriesQueryVariables = Exact<{
  input: WorkflowChartSeriesInput;
}>;


export type GetWorkflowChartSeriesQuery = { __typename: 'Query', workflowChartSeries: { __typename: 'WorkflowChartSeries', dimensions: Array<{ __typename: 'WorkflowChartDimensionSeries', id: string, label: string, data: Array<string>, keys: Array<string> }>, values: Array<{ __typename: 'WorkflowChartValueSeries', id: string, label: string, data: Array<number | null>, counts: Array<number> }>, primaryCatalog: Array<{ __typename: 'WorkflowChartCategory', id: string, label: string, tooltipLabel: string, value: number, count: number }>, secondaryCatalog: Array<{ __typename: 'WorkflowChartCategory', id: string, label: string, tooltipLabel: string, value: number, count: number }>, totals: { __typename: 'WorkflowChartTotalSeries', data: Array<number | null>, counts: Array<number> } } };

export type GetWorkflowInsightsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowInsightsDashboardQuery = { __typename: 'Query', workflowInsightsDashboard: { __typename: 'WorkflowInsightsDashboard', hiddenSystemPresetIds: Array<string>, org: Array<{ __typename: 'WorkflowInsightsDashboardChart', id: string, presetId: string | null, pin: { __typename: 'InsightPin', id: string, chartId: string, sourceSystemPresetId: string | null, scope: InsightScope, owner: { __typename: 'User', avatarColor: string, displayName: string, id: string }, view: { __typename: 'WorkflowView', id: string, name: string, state: { [key: string]: any } } } | null, series: { __typename: 'WorkflowChartSeries', dimensions: Array<{ __typename: 'WorkflowChartDimensionSeries', id: string, label: string, data: Array<string>, keys: Array<string> }>, values: Array<{ __typename: 'WorkflowChartValueSeries', id: string, label: string, data: Array<number | null>, counts: Array<number> }>, primaryCatalog: Array<{ __typename: 'WorkflowChartCategory', id: string, label: string, tooltipLabel: string, value: number, count: number }>, secondaryCatalog: Array<{ __typename: 'WorkflowChartCategory', id: string, label: string, tooltipLabel: string, value: number, count: number }>, totals: { __typename: 'WorkflowChartTotalSeries', data: Array<number | null>, counts: Array<number> } } }>, personal: Array<{ __typename: 'WorkflowInsightsDashboardChart', id: string, presetId: string | null, pin: { __typename: 'InsightPin', id: string, chartId: string, sourceSystemPresetId: string | null, scope: InsightScope, owner: { __typename: 'User', avatarColor: string, displayName: string, id: string }, view: { __typename: 'WorkflowView', id: string, name: string, state: { [key: string]: any } } } | null, series: { __typename: 'WorkflowChartSeries', dimensions: Array<{ __typename: 'WorkflowChartDimensionSeries', id: string, label: string, data: Array<string>, keys: Array<string> }>, values: Array<{ __typename: 'WorkflowChartValueSeries', id: string, label: string, data: Array<number | null>, counts: Array<number> }>, primaryCatalog: Array<{ __typename: 'WorkflowChartCategory', id: string, label: string, tooltipLabel: string, value: number, count: number }>, secondaryCatalog: Array<{ __typename: 'WorkflowChartCategory', id: string, label: string, tooltipLabel: string, value: number, count: number }>, totals: { __typename: 'WorkflowChartTotalSeries', data: Array<number | null>, counts: Array<number> } } }> } };

export type CreateWorkflowViewMutationVariables = Exact<{
  input: CreateWorkflowViewInput;
}>;


export type CreateWorkflowViewMutation = { __typename: 'Mutation', createWorkflowView: { __typename: 'WorkflowViewResponse', workflowView: { __typename: 'WorkflowView', id: string, name: string, showInSavedViews: boolean, state: { [key: string]: any }, updatedAt: string, pins: Array<{ __typename: 'InsightPin', id: string, chartId: string, scope: InsightScope }> } | null } };

export type MaterializeSystemInsightChartMutationVariables = Exact<{
  presetId: Scalars['String'];
}>;


export type MaterializeSystemInsightChartMutation = { __typename: 'Mutation', materializeSystemInsightChart: { __typename: 'InsightPinResponse', insightPin: { __typename: 'InsightPin', id: string, chartId: string, sourceSystemPresetId: string | null, scope: InsightScope, view: { __typename: 'WorkflowView', id: string } } | null } };

export type UpdateWorkflowViewMutationVariables = Exact<{
  input: UpdateWorkflowViewInput;
}>;


export type UpdateWorkflowViewMutation = { __typename: 'Mutation', updateWorkflowView: { __typename: 'WorkflowViewResponse', workflowView: { __typename: 'WorkflowView', id: string, name: string, showInSavedViews: boolean, state: { [key: string]: any }, updatedAt: string } | null } };

export type AddWorkflowViewChartMutationVariables = Exact<{
  input: AddWorkflowViewChartInput;
}>;


export type AddWorkflowViewChartMutation = { __typename: 'Mutation', addWorkflowViewChart: { __typename: 'WorkflowViewResponse', workflowView: { __typename: 'WorkflowView', id: string, name: string, state: { [key: string]: any }, updatedAt: string, pins: Array<{ __typename: 'InsightPin', id: string, chartId: string, scope: InsightScope }> } | null } };

export type DeleteWorkflowViewChartMutationVariables = Exact<{
  input: DeleteWorkflowViewChartInput;
}>;


export type DeleteWorkflowViewChartMutation = { __typename: 'Mutation', deleteWorkflowViewChart: { __typename: 'WorkflowViewResponse', workflowView: { __typename: 'WorkflowView', id: string, name: string, state: { [key: string]: any }, updatedAt: string, pins: Array<{ __typename: 'InsightPin', id: string, chartId: string, scope: InsightScope }> } | null } };

export type CreateInsightPinMutationVariables = Exact<{
  input: CreateInsightPinInput;
}>;


export type CreateInsightPinMutation = { __typename: 'Mutation', createInsightPin: { __typename: 'InsightPinResponse', insightPin: { __typename: 'InsightPin', id: string, chartId: string, scope: InsightScope, sortOrder: number, layout: { [key: string]: any }, view: { __typename: 'WorkflowView', id: string, name: string } } | null } };

export type UpdateInsightPinMutationVariables = Exact<{
  input: UpdateInsightPinInput;
}>;


export type UpdateInsightPinMutation = { __typename: 'Mutation', updateInsightPin: { __typename: 'InsightPinResponse', insightPin: { __typename: 'InsightPin', id: string, chartId: string, scope: InsightScope, sortOrder: number, layout: { [key: string]: any }, view: { __typename: 'WorkflowView', id: string, name: string } } | null } };

export type PublishInsightPinToOrgMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PublishInsightPinToOrgMutation = { __typename: 'Mutation', publishInsightPinToOrg: { __typename: 'InsightPinResponse', insightPin: { __typename: 'InsightPin', id: string, chartId: string, scope: InsightScope, sortOrder: number, layout: { [key: string]: any }, view: { __typename: 'WorkflowView', id: string, name: string } } | null } };

export type DeleteInsightPinMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteInsightPinMutation = { __typename: 'Mutation', deleteInsightPin: { __typename: 'DeleteInsightPinResponse', id: string } };

export type DeleteWorkflowViewMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteWorkflowViewMutation = { __typename: 'Mutation', deleteWorkflowView: { __typename: 'DeleteWorkflowViewResponse', id: string } };

export type SetSystemInsightChartHiddenMutationVariables = Exact<{
  presetId: Scalars['String'];
  hidden: Scalars['Boolean'];
}>;


export type SetSystemInsightChartHiddenMutation = { __typename: 'Mutation', setSystemInsightChartHidden: boolean };

export type GetWorkflowIntakeFieldsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowIntakeFieldsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, intakeFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, type: AlineFieldType, required: boolean, order: number, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }>, files: Array<{ __typename: 'WorkflowFile', document: { __typename: 'Document', id: string, name: string } }> } | null };

export type GetWorkflowLaunchConfigQueryVariables = Exact<{
  launchConfigId: Scalars['UUID'];
}>;


export type GetWorkflowLaunchConfigQuery = { __typename: 'Query', workflowLaunchConfig: { __typename: 'WorkflowLaunchConfig', id: string, enabled: boolean, workflowTitle: string, isAutomaticS4SEnabled: boolean, launchedWorkflowOwner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, placeholders: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, launchForm: { __typename: 'LaunchConfigForm', alineFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, order: number, required: boolean, type: AlineFieldType, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }>, documentsList: Array<{ __typename: 'TemplateDocument', documentId: string, name: string }>, intakeForm: { __typename: 'LaunchConfigIntakeForm', defaultValues: { [key: string]: any }, formDefinition: { [key: string]: any }, title: string } | null } } | null };

export type GetLaunchConfigWorkflowQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetLaunchConfigWorkflowQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, launchConfig: { __typename: 'WorkflowLaunchConfig', id: string, enabled: boolean, workflowTitle: string, isAutomaticS4SEnabled: boolean, launchedWorkflowOwner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, placeholders: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, launchForm: { __typename: 'LaunchConfigForm', alineFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, order: number, required: boolean, type: AlineFieldType, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }>, documentsList: Array<{ __typename: 'TemplateDocument', documentId: string, name: string }>, intakeForm: { __typename: 'LaunchConfigIntakeForm', defaultValues: { [key: string]: any }, formDefinition: { [key: string]: any }, title: string } | null } } | null } | null };

export type CreateWorkflowLaunchConfigMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type CreateWorkflowLaunchConfigMutation = { __typename: 'Mutation', createWorkflowLaunchConfig: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, launchConfig: { __typename: 'WorkflowLaunchConfig', id: string, enabled: boolean, workflowTitle: string, isAutomaticS4SEnabled: boolean, launchedWorkflowOwner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, placeholders: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, launchForm: { __typename: 'LaunchConfigForm', alineFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, order: number, required: boolean, type: AlineFieldType, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }>, documentsList: Array<{ __typename: 'TemplateDocument', documentId: string, name: string }>, intakeForm: { __typename: 'LaunchConfigIntakeForm', defaultValues: { [key: string]: any }, formDefinition: { [key: string]: any }, title: string } | null } } | null } } };

export type UpdateWorkflowLaunchConfigMutationVariables = Exact<{
  input: UpdateWorkflowLaunchConfigInput;
}>;


export type UpdateWorkflowLaunchConfigMutation = { __typename: 'Mutation', updateWorkflowLaunchConfig: { __typename: 'WorkflowLaunchConfig', id: string, enabled: boolean, workflowTitle: string, isAutomaticS4SEnabled: boolean, launchedWorkflowOwner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, placeholders: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, launchForm: { __typename: 'LaunchConfigForm', alineFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, order: number, required: boolean, type: AlineFieldType, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }>, documentsList: Array<{ __typename: 'TemplateDocument', documentId: string, name: string }>, intakeForm: { __typename: 'LaunchConfigIntakeForm', defaultValues: { [key: string]: any }, formDefinition: { [key: string]: any }, title: string } | null } } };

export type DeleteWorkflowLaunchConfigMutationVariables = Exact<{
  launchConfigId: Scalars['UUID'];
}>;


export type DeleteWorkflowLaunchConfigMutation = { __typename: 'Mutation', deleteWorkflowLaunchConfig: string };

export type LaunchWorkflowViaConfigMutationVariables = Exact<{
  input: LaunchWorkflowViaConfigInput;
}>;


export type LaunchWorkflowViaConfigMutation = { __typename: 'Mutation', launchWorkflowViaConfig: { __typename: 'LaunchWorkflowViaConfigResponse', workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelope: { __typename: 'Envelope', id: string } | null, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> } } };

export type CreateFilesViaLaunchConfigMutationVariables = Exact<{
  input: CreateFilesViaLaunchConfigInput;
}>;


export type CreateFilesViaLaunchConfigMutation = { __typename: 'Mutation', createFilesViaLaunchConfig: Array<{ __typename: 'LaunchConfigFile', documentId: string, name: string }> };

export type DeleteFilesViaLaunchConfigMutationVariables = Exact<{
  input: DeleteFilesViaLaunchConfigInput;
}>;


export type DeleteFilesViaLaunchConfigMutation = { __typename: 'Mutation', deleteFilesViaLaunchConfig: Array<string> };

export type GetUploadSecurityViaLaunchConfigQueryVariables = Exact<{
  launchConfigId: Scalars['UUID'];
}>;


export type GetUploadSecurityViaLaunchConfigQuery = { __typename: 'Query', uploadSecurityViaLaunchConfig: { __typename: 'FilestackUploadOptions', bucket: string, security: { __typename: 'FilestackSecurity', policy: string, signature: string } } | null };

export type LaunchConfigSimpleFragment = { __typename: 'WorkflowLaunchConfig', id: string, enabled: boolean, workflowTitle: string, isAutomaticS4SEnabled: boolean, launchedWorkflowOwner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, placeholders: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, launchForm: { __typename: 'LaunchConfigForm', alineFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, order: number, required: boolean, type: AlineFieldType, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }>, documentsList: Array<{ __typename: 'TemplateDocument', documentId: string, name: string }>, intakeForm: { __typename: 'LaunchConfigIntakeForm', defaultValues: { [key: string]: any }, formDefinition: { [key: string]: any }, title: string } | null } };

export type GetWorkflowPermissionQueryVariables = Exact<{
  workflowPermissionId: Scalars['UUID'];
}>;


export type GetWorkflowPermissionQuery = { __typename: 'Query', workflowPermission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } | null };

export type GetWorkflowPermissionsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowPermissionsQuery = { __typename: 'Query', permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, actions: Array<{ __typename: 'Task', id: string } | { __typename: 'WorkflowRecipient', id: string }>, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> };

export type GetActiveWorkflowPermissionsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetActiveWorkflowPermissionsQuery = { __typename: 'Query', activePermissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> };

export type GetQueuedWorkflowPermissionsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetQueuedWorkflowPermissionsQuery = { __typename: 'Query', queuedPermissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> };

export type GetWorkflowPermissionsForWorkflowQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowPermissionsForWorkflowQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, variant: WorkflowVariant, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, actions: Array<{ __typename: 'Task', id: string } | { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType }>, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> } | null };

export type GetWorkflowPermissionsWithStepsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowPermissionsWithStepsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, variant: WorkflowVariant, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, actions: Array<{ __typename: 'Task', id: string } | { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType }>, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null };

export type AddWorkflowPermissionsMutationVariables = Exact<{
  input: AddWorkflowPermissionsInput;
}>;


export type AddWorkflowPermissionsMutation = { __typename: 'Mutation', addWorkflowPermissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, actions: Array<{ __typename: 'Task', id: string } | { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType }>, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> };

export type RemoveWorkflowPermissionsMutationVariables = Exact<{
  input: RemoveWorkflowPermissionsInput;
}>;


export type RemoveWorkflowPermissionsMutation = { __typename: 'Mutation', removeWorkflowPermissions: Array<string> };

export type GetOrCreateWorkflowLauncherPermissionMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetOrCreateWorkflowLauncherPermissionMutation = { __typename: 'Mutation', getOrCreateWorkflowLauncherPermission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, actions: Array<{ __typename: 'Task', id: string } | { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType }>, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } };

export type UpdateWorkflowPermissionMutationVariables = Exact<{
  input: UpdateWorkflowPermissionInput;
}>;


export type UpdateWorkflowPermissionMutation = { __typename: 'Mutation', updateWorkflowPermission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } };

export type WorkflowPermissionSimpleFragment = { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null };

export type WorkflowPermissionWithActionsFragment = { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, actions: Array<{ __typename: 'Task', id: string } | { __typename: 'WorkflowRecipient', id: string, type: WorkflowRecipientType }>, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null };

export type CreateWorkflowRecipientMutationVariables = Exact<{
  input: CreateWorkflowRecipientInput;
}>;


export type CreateWorkflowRecipientMutation = { __typename: 'Mutation', createWorkflowRecipient: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type ChangeRecipientActionMutationVariables = Exact<{
  input: ChangeRecipientActionInput;
}>;


export type ChangeRecipientActionMutation = { __typename: 'Mutation', changeRecipientAction: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } };

export type ReassignRecipientMutationVariables = Exact<{
  input: ReassignRecipientInput;
}>;


export type ReassignRecipientMutation = { __typename: 'Mutation', reassignRecipient: { __typename: 'ReassignRecipientResult', clearedSignatureFieldNodeIds: Array<string>, recipient: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } } };

export type DeclineSignatureRemindersMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type DeclineSignatureRemindersMutation = { __typename: 'Mutation', declineSignatureReminders: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } };

export type UpdateRecipientNameMutationVariables = Exact<{
  input: UpdateRecipientNameInput;
}>;


export type UpdateRecipientNameMutation = { __typename: 'Mutation', updateRecipientName: { __typename: 'WorkflowRecipient', id: string, recipientName: string | null } };

export type WorkflowRecipientSimpleFragment = { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } };

export type WorkflowRecipientWithFieldsFragment = { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } };

export type GetWorkflowQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null };

export type WorkflowSigningPhaseStepsFragment = { __typename: 'Workflow', phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> };

export type WorkflowSigningPhaseStepsSummaryFragment = { __typename: 'Workflow', phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null }> }> };

export type GetWorkflowSigningStatusQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowSigningStatusQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, state: WorkflowState } | null };

export type GetWorkflowsQueryVariables = Exact<{
  workflowFilter?: InputMaybe<WorkflowFilterInput>;
  sortModel?: InputMaybe<Scalars['JSON']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  cursor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
  listFilter?: InputMaybe<WorkflowListFilter>;
  groupFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  groupKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  grain?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkflowsQuery = { __typename: 'Query', workflows: { __typename: 'WorkflowRowsInfo', groupCount: number | null, aggregates: { __typename: 'WorkflowListAggregates', count: number, avgCycleTime: number | null } | null, groupHeaders: Array<{ __typename: 'WorkflowGroupHeader', id: string, isGroupRow: boolean, groupField: string, groupKey: string, groupLabel: string, workflowCount: number, avgCycleTime: number | null, childRowCount: number | null, parentGroupId: string | null }>, rows: Array<{ __typename: 'Workflow', id: string, completedAt: string | null, createdAt: string, envelopeStatus: EnvelopeStatus, name: string, priority: WorkflowPriority | null, startedAt: string | null, status: WorkflowStatus, state: WorkflowState, updatedAt: string, variant: WorkflowVariant, numTimesUsed: number, publishedAt: string | null, crmIntegrations: Array<Integration>, linkedOpportunities: Array<{ __typename: 'LinkedOpportunity', id: string, integration: Integration, opportunityName: string | null }>, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, name: string } }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, sourceWorkflow: { __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, column: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string, name: string, order: number, startedAt: string | null, completedAt: string | null, column: { __typename: 'Column', id: string } } | { __typename: 'SigningPhase', id: string, name: string, order: number, startedAt: string | null, completedAt: string | null, column: { __typename: 'Column', id: string } }>, doneColumn: { __typename: 'Column', id: string } }>, meta: { __typename: 'WorkflowsMeta', totalCount: number, hasMore: boolean } } };

export type GetWorkflowsCountQueryVariables = Exact<{
  workflowFilter?: InputMaybe<WorkflowFilterInput>;
  sortModel?: InputMaybe<Scalars['JSON']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  listFilter?: InputMaybe<WorkflowListFilter>;
}>;


export type GetWorkflowsCountQuery = { __typename: 'Query', workflows: { __typename: 'WorkflowRowsInfo', rows: Array<{ __typename: 'Workflow', id: string, name: string, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant }>, meta: { __typename: 'WorkflowsMeta', totalCount: number } } };

export type GetWorkflowsWithFilesQueryVariables = Exact<{
  workflowFilter?: InputMaybe<WorkflowFilterInput>;
  sortModel?: InputMaybe<Scalars['JSON']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  cursor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
  listFilter?: InputMaybe<WorkflowListFilter>;
}>;


export type GetWorkflowsWithFilesQuery = { __typename: 'Query', workflows: { __typename: 'WorkflowRowsInfo', rows: Array<{ __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant, publishedAt: string | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, name: string } }> }>, meta: { __typename: 'WorkflowsMeta', totalCount: number } } };

export type GetWorkflowTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowTypesQuery = { __typename: 'Query', workflowTypes: Array<{ __typename: 'WorkflowTypeOption', id: string, label: string }> };

export type GetBoardWorkflowsQueryVariables = Exact<{
  workflowFilter?: InputMaybe<WorkflowFilterInput>;
  sortModel?: InputMaybe<Scalars['JSON']>;
  filterModel?: InputMaybe<Scalars['JSON']>;
  listFilter?: InputMaybe<WorkflowListFilter>;
  cursor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetBoardWorkflowsQuery = { __typename: 'Query', workflows: { __typename: 'WorkflowRowsInfo', rows: Array<{ __typename: 'Workflow', id: string, commentCount: number, completedAt: string | null, completedStepCount: number, createdAt: string, envelopeStatus: EnvelopeStatus, name: string, priority: WorkflowPriority | null, startedAt: string | null, state: WorkflowState, status: WorkflowStatus, totalStepCount: number, updatedAt: string, variant: WorkflowVariant, column: { __typename: 'Column', id: string, category: ColumnCategory, color: string, name: string, sortKey: string }, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, name: string, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } } }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, sourceWorkflow: { __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant } | null, phases: Array<{ __typename: 'NonSigningPhase', id: string, name: string, order: number, startedAt: string | null, completedAt: string | null, column: { __typename: 'Column', id: string } } | { __typename: 'SigningPhase', id: string, name: string, order: number, startedAt: string | null, completedAt: string | null, column: { __typename: 'Column', id: string } }>, tasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, status: TaskStatus, parentTask: { __typename: 'Task', id: string } | null }>, doneColumn: { __typename: 'Column', id: string } }>, meta: { __typename: 'WorkflowsMeta', totalCount: number } } };

export type GetWorkflowSimpleQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowSimpleQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, aiCancelledAt: string | null, aiFailedAt: string | null, aiFailureReason: string | null, aiFinishedAt: string | null, aiStartedAt: string | null, createdAt: string, completedAt: string | null, crmIntegrations: Array<Integration>, envelopeMsg: string | null, fileCount: number, name: string, description: string, numTimesUsed: number, numTimesImported: number, isCommunityWorkflow: boolean, isSignedOutsideAline: boolean, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, totalStepCount: number, requesterInOwnerOrg: boolean, startedAt: string | null, publishedAt: string | null, variant: WorkflowVariant, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string, avatarColor: string, displayName: string, email: string, supportRole: SupportRole | null, org: { __typename: 'Org', id: string, avatarColor: string, avatarImg: { __typename: 'DocFile', filestackUrl: string } | null } }, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null } | null };

export type GetWorkflowCommentsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowCommentsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }> } | null };

export type GetWorkflowDocumentQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowDocumentQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, requesterInOwnerOrg: boolean, createdAt: string, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }> } | null };

export type GetWorkflowByDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetWorkflowByDocumentQuery = { __typename: 'Query', document: { __typename: 'Document', id: string, name: string, requesterRole: PermissionRole | null, status: DocumentStatus | null, variant: DocumentVariant, latestVersion: { __typename: 'DocumentVersion', id: string } | { __typename: 'StaticFileVersion', id: string }, owner: { __typename: 'User', id: string }, workflow: { __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null } };

export type GetWorkflowActiveStepQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowActiveStepQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null } | null };

export type GetWorkflowFilesQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowFilesQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, createdAt: string, envelopeMsg: string | null, envelopeStatus: EnvelopeStatus, name: string, requesterInOwnerOrg: boolean, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, column: { __typename: 'Column', id: string, name: string }, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, envelope: { __typename: 'Envelope', id: string, completedAt: string | null, docuSignEnvelopeId: string | null, variant: EnvelopeVariant } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, owner: { __typename: 'User', id: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null };

export type GetWorkflowPreviewDetailsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowPreviewDetailsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, completedAt: string | null, createdAt: string, name: string, requesterInOwnerOrg: boolean, startedAt: string | null, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null };

export type GetWorkflowFilesWithPartiesQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowFilesWithPartiesQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, createdAt: string, name: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, updatedAt: string, isCommunityWorkflow: boolean, envelope: { __typename: 'Envelope', id: string } | null, files: Array<{ __typename: 'WorkflowFile', id: string, orderId: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, isCertificate: boolean, isCommunityTemplate: boolean, requesterFavorited: boolean, requesterRole: PermissionRole | null, coreAiPropertiesExtractionStartedAt: string | null, coreAiPropertiesExtractionFinishedAt: string | null, coreAiPropertiesExtractionFailedAt: string | null, updatedAt: string, deletedAt: string | null, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, type: { __typename: 'ContractType', id: string, value: string } | null } }> } | null };

export type GetWorkflowFilesWithFieldsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowFilesWithFieldsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, requesterInOwnerOrg: boolean, createdAt: string, envelope: { __typename: 'Envelope', id: string } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, storableType: StorableType, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, signatureFields: Array<{ __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, variables: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, answerOptions: { __typename: 'AnswerOptions', id: string, isPreset: boolean, title: string | null, options: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> }, config: { __typename: 'DocumentVariableConfig', id: string, label: string, question: string } | null, defaultAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null, integrationLink: { __typename: 'IntegrationLink', attributePath: string | null, integration: Integration | null } }>, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string, state: WorkflowState, envelopeStatus: EnvelopeStatus } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }> } | null };

export type GetWorkflowWithReadyCheckQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowWithReadyCheckQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, status: WorkflowStatus, state: WorkflowState, isReadyForSignature: { __typename: 'WorkflowReadyForSignature', ready: boolean, notReadyReasons: Array<WorkflowNotReadyForSigReason> }, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null };

export type GetWorkflowTasksQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowTasksQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, createdAt: string, name: string, requesterInOwnerOrg: boolean, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, phases: Array<{ __typename: 'NonSigningPhase', id: string, order: number, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, comments: Array<{ __typename: 'Comment', id: string, text: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }> } | { __typename: 'SigningPhase', id: string, order: number }> } | null };

export type GetWorkflowAssignmentsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowAssignmentsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> } | null };

export type LaunchTemplateDataQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type LaunchTemplateDataQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, name: string, publishedAt: string | null, mappedCrmIntegrations: Array<Integration>, files: Array<{ __typename: 'WorkflowFile', id: string, orderId: string, document: { __typename: 'Document', id: string, name: string } }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, intakeFormTemplate: { __typename: 'IntakeFormTemplate', id: string, orgId: string, title: string, description: string, schemaVersion: number, formDefinition: { [key: string]: any }, defaultValues: { [key: string]: any }, createdAt: string, updatedAt: string, owner: { __typename: 'User', id: string } } | null, intakeFields: Array<{ __typename: 'AlineTemplateField', fieldId: string, label: string, question: string | null, type: AlineFieldType, required: boolean, order: number, usedInDocuments: Array<string>, picklistOptions: Array<{ __typename: 'AlinePicklistOption', label: string, value: string }> | null }> } | null, apiDeckConnections: Array<{ __typename: 'ApiDeckConnection', id: string, integration: Integration, icon: string, name: string | null, tagLine: string | null, enabled: boolean | null, state: ApiDeckConnectionState | null }> };

export type GetWorkflowInboxQueryVariables = Exact<{
  filter?: InputMaybe<WorkflowInboxFilterInput>;
  cursor?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetWorkflowInboxQuery = { __typename: 'Query', workflowInboxWorkflows: { __typename: 'WorkflowRowsInfo', rows: Array<{ __typename: 'Workflow', id: string, aiCancelledAt: string | null, aiFailedAt: string | null, aiFailureReason: string | null, aiFinishedAt: string | null, aiStartedAt: string | null, createdAt: string, startedAt: string | null, completedAt: string | null, isSignedOutsideAline: boolean, name: string, publishedAt: string | null, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, missingActions: boolean, activeStep: { __typename: 'WorkflowStep', id: string, createdAt: string, startedAt: string | null, completedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, createdAt: string, completedAt: string | null, firstSentAt: string | null, lastSentAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null }> } | null, files: Array<{ __typename: 'WorkflowFile', id: string, orderId: string, document: { __typename: 'Document', id: string, createdAt: string, name: string, variant: DocumentVariant, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, latestVersion: { __typename: 'DocumentVersion', id: string, documentJSON: { [key: string]: any } } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, phases: Array<{ __typename: 'NonSigningPhase', id: string, order: number } | { __typename: 'SigningPhase', id: string, order: number }>, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }>, meta: { __typename: 'WorkflowsMeta', totalCount: number } } };

export type GetWorkflowInboxWorkflowQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowInboxWorkflowQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, aiCancelledAt: string | null, aiFailedAt: string | null, aiFailureReason: string | null, aiFinishedAt: string | null, aiStartedAt: string | null, createdAt: string, startedAt: string | null, completedAt: string | null, isSignedOutsideAline: boolean, name: string, publishedAt: string | null, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, missingActions: boolean, activeStep: { __typename: 'WorkflowStep', id: string, createdAt: string, startedAt: string | null, completedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, createdAt: string, completedAt: string | null, firstSentAt: string | null, lastSentAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null }> } | null, files: Array<{ __typename: 'WorkflowFile', id: string, orderId: string, document: { __typename: 'Document', id: string, createdAt: string, name: string, variant: DocumentVariant, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, latestVersion: { __typename: 'DocumentVersion', id: string, documentJSON: { [key: string]: any } } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, phases: Array<{ __typename: 'NonSigningPhase', id: string, order: number } | { __typename: 'SigningPhase', id: string, order: number }>, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null };

export type GetDocumentWorkflowsQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type GetDocumentWorkflowsQuery = { __typename: 'Query', documentWorkflows: Array<{ __typename: 'Workflow', id: string, envelopeMsg: string | null, name: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, variant: WorkflowVariant, requesterInOwnerOrg: boolean, startedAt: string | null, completedAt: string | null, createdAt: string, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, variant: EnvelopeVariant } | null }> };

export type GetMissingWorkflowActionsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetMissingWorkflowActionsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, requesterInOwnerOrg: boolean, createdAt: string, missingActions: boolean } | null };

export type GetUnusedWorkflowActionsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetUnusedWorkflowActionsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, requesterInOwnerOrg: boolean, createdAt: string, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null };

export type GetPopularTemplateWorkflowsQueryVariables = Exact<{
  num?: InputMaybe<Scalars['Int']>;
}>;


export type GetPopularTemplateWorkflowsQuery = { __typename: 'Query', popularTemplateWorkflows: Array<{ __typename: 'Workflow', id: string, name: string, numTimesUsed: number, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type GetMyMostUsedTemplateWorkflowsQueryVariables = Exact<{
  num?: InputMaybe<Scalars['Int']>;
}>;


export type GetMyMostUsedTemplateWorkflowsQuery = { __typename: 'Query', myMostUsedTemplateWorkflows: Array<{ __typename: 'Workflow', id: string, name: string, numTimesUsed: number, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } }> };

export type GetWorkflowForwardSettingsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowForwardSettingsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, forwardingPermissionRole: PermissionRole | null, variant: WorkflowVariant, state: WorkflowState, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } } | null };

export type GetWorkflowWithBoardQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowWithBoardQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, skipTriage: boolean, variant: WorkflowVariant, column: { __typename: 'Column', id: string, board: { __typename: 'Board', id: string, triageColumn: { __typename: 'Column', id: string } | null, columns: Array<{ __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string }> } }, doneColumn: { __typename: 'Column', id: string, name: string, category: ColumnCategory, color: string, sortKey: string, createdAt: string, updatedAt: string } } | null };

export type GetWorkflowBlockersQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowBlockersQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, missingActions: boolean, envelope: { __typename: 'Envelope', id: string, createdAt: string } | null, activeStep: { __typename: 'WorkflowStep', id: string, createdAt: string, startedAt: string | null, completedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, completedAt: string | null, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null }>, requesterActions: Array<{ __typename: 'WorkflowRecipient', id: string, completedAt: string | null, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null }> } | null, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null }> }> } | null };

export type AddDocumentsToWorkflowMutationVariables = Exact<{
  input: AddDocumentsToWorkflowInput;
}>;


export type AddDocumentsToWorkflowMutation = { __typename: 'Mutation', addDocumentsToWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, missingActions: boolean, activeStep: { __typename: 'WorkflowStep', id: string } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type RemoveDocumentsFromWorkflowMutationVariables = Exact<{
  input: RemoveDocumentsFromWorkflowInput;
}>;


export type RemoveDocumentsFromWorkflowMutation = { __typename: 'Mutation', removeDocumentsFromWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, missingActions: boolean, activeStep: { __typename: 'WorkflowStep', id: string } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type InitializeWorkflowMutationVariables = Exact<{
  input: InitializeWorkflowInput;
}>;


export type InitializeWorkflowMutation = { __typename: 'Mutation', initializeWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant, state: WorkflowState, envelopeStatus: EnvelopeStatus, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, envelope: { __typename: 'Envelope', id: string } | null, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, createdAt: string } }>, column: { __typename: 'Column', id: string, name: string } }, refetch: { __typename: 'Query', currentUser: { __typename: 'User', id: string, numWorkflowsCreatedThisMonth: number } | null } } };

export type CreateWorkflowForDocumentsMutationVariables = Exact<{
  input: InitializeWorkflowInput;
}>;


export type CreateWorkflowForDocumentsMutation = { __typename: 'Mutation', initializeWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant, state: WorkflowState, envelopeStatus: EnvelopeStatus, publishedAt: string | null, envelope: { __typename: 'Envelope', id: string, variant: EnvelopeVariant } | null, files: Array<{ __typename: 'WorkflowFile', id: string, document: { __typename: 'Document', id: string, createdAt: string } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> }, refetch: { __typename: 'Query', currentUser: { __typename: 'User', id: string, numWorkflowsCreatedThisMonth: number } | null } } };

export type ChangeRecipientAssignmentMutationVariables = Exact<{
  input: ChangeRecipientAssignmentInput;
}>;


export type ChangeRecipientAssignmentMutation = { __typename: 'Mutation', changeRecipientAssignment: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } };

export type ChangeCollaboratorAssignmentMutationVariables = Exact<{
  input: ChangeCollaboratorAssignmentInput;
}>;


export type ChangeCollaboratorAssignmentMutation = { __typename: 'Mutation', changeCollaboratorAssignment: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } };

export type CreateWorkflowInstanceMutationVariables = Exact<{
  input: CreateWorkflowInstanceInput;
}>;


export type CreateWorkflowInstanceMutation = { __typename: 'Mutation', createWorkflowInstance: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, createdAt: string, forwardingPermissionRole: PermissionRole | null, state: WorkflowState, envelopeStatus: EnvelopeStatus, linkedOpportunities: Array<{ __typename: 'LinkedOpportunity', id: string, integration: Integration }>, envelope: { __typename: 'Envelope', id: string, variant: EnvelopeVariant } | null, files: Array<{ __typename: 'WorkflowFile', id: string, orderId: string, document: { __typename: 'Document', id: string, createdAt: string } }>, column: { __typename: 'Column', id: string, name: string } }, refetch: { __typename: 'Query', currentUser: { __typename: 'User', id: string, numWorkflowsCreatedThisMonth: number } | null } } };

export type DeleteWorkflowMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type DeleteWorkflowMutation = { __typename: 'Mutation', deleteWorkflow: string };

export type CancelWorkflowAiBuildMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type CancelWorkflowAiBuildMutation = { __typename: 'Mutation', cancelWorkflowAiBuild: { __typename: 'Workflow', id: string, aiStartedAt: string | null, aiFinishedAt: string | null, aiFailedAt: string | null, aiCancelledAt: string | null, aiFailureReason: string | null } };

export type DeleteWorkflowActionsMutationVariables = Exact<{
  input: DeleteWorkflowActionsInput;
}>;


export type DeleteWorkflowActionsMutation = { __typename: 'Mutation', deleteWorkflowActions: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, activeStep: { __typename: 'WorkflowStep', id: string } | null, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type FinishFieldActionsMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type FinishFieldActionsMutation = { __typename: 'Mutation', finishFieldActions: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState, createdAt: string, updatedAt: string, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type ForwardWorkflowMutationVariables = Exact<{
  input: ForwardWorkflowInput;
}>;


export type ForwardWorkflowMutation = { __typename: 'Mutation', forwardWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }> } } };

export type MoveWorkflowStepActionsMutationVariables = Exact<{
  input: MoveWorkflowStepActionsInput;
}>;


export type MoveWorkflowStepActionsMutation = { __typename: 'Mutation', moveWorkflowStepActions: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type ToggleWorkflowOrderMutationVariables = Exact<{
  input: ToggleWorkflowOrderInput;
}>;


export type ToggleWorkflowOrderMutation = { __typename: 'Mutation', toggleWorkflowOrder: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type RequestAccessToDocumentWorkflowMutationVariables = Exact<{
  input: RequestAccessToDocumentWorkflowInput;
}>;


export type RequestAccessToDocumentWorkflowMutation = { __typename: 'Mutation', requestAccessToDocumentWorkflow: string };

export type RelocateWorkflowToBoardMutationVariables = Exact<{
  input: RelocateWorkflowToBoardInput;
}>;


export type RelocateWorkflowToBoardMutation = { __typename: 'Mutation', relocateWorkflowToBoard: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, boardId: string, column: { __typename: 'Column', id: string, category: ColumnCategory, color: string, name: string, sortKey: string, board: { __typename: 'Board', id: string } }, doneColumn: { __typename: 'Column', id: string, category: ColumnCategory, color: string, name: string, sortKey: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string, column: { __typename: 'Column', id: string } } | { __typename: 'SigningPhase', id: string, column: { __typename: 'Column', id: string } }> } } };

export type UpdateWorkflowMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type UpdateWorkflowMutation = { __typename: 'Mutation', updateWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, description: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, name: string, priority: WorkflowPriority | null, skipTriage: boolean, startedAt: string | null, column: { __typename: 'Column', id: string, category: ColumnCategory, color: string, name: string, sortKey: string }, doneColumn: { __typename: 'Column', id: string, category: ColumnCategory, color: string, name: string, sortKey: string } } } };

export type SetWorkflowCrmPublishMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type SetWorkflowCrmPublishMutation = { __typename: 'Mutation', updateWorkflow: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, crmIntegrations: Array<Integration> } } };

export type StartWorkflowWorkMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
  columnId?: InputMaybe<Scalars['UUID']>;
}>;


export type StartWorkflowWorkMutation = { __typename: 'Mutation', startWorkflowWork: { __typename: 'Workflow', id: string, startedAt: string | null, state: WorkflowState, column: { __typename: 'Column', id: string, category: ColumnCategory, color: string, name: string, sortKey: string } } };

export type RenotifyCurrentStepMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type RenotifyCurrentStepMutation = { __typename: 'Mutation', renotifyCurrentStep: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type SendWorkflowForSignatureMutationVariables = Exact<{
  input: SendWorkflowForSignatureInput;
}>;


export type SendWorkflowForSignatureMutation = { __typename: 'Mutation', sendWorkflowForSignature: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, createdAt: string, envelopeMsg: string | null, envelopeStatus: EnvelopeStatus, name: string, requesterInOwnerOrg: boolean, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, column: { __typename: 'Column', id: string, name: string }, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, envelope: { __typename: 'Envelope', id: string, completedAt: string | null, docuSignEnvelopeId: string | null, variant: EnvelopeVariant } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, owner: { __typename: 'User', id: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } } };

export type FinishSigningOutsideAlineMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type FinishSigningOutsideAlineMutation = { __typename: 'Mutation', finishSigningOutsideAline: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, isSignedOutsideAline: boolean, state: WorkflowState, status: WorkflowStatus, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null } } };

export type SetSignOutsideAlineMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type SetSignOutsideAlineMutation = { __typename: 'Mutation', setSignOutsideAline: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, isSignedOutsideAline: boolean, state: WorkflowState } } };

export type ApplySignedVersionOutsideAlineMutationVariables = Exact<{
  input: ApplySignedVersionOutsideAlineInput;
}>;


export type ApplySignedVersionOutsideAlineMutation = { __typename: 'Mutation', applySignedVersionOutsideAline: { __typename: 'FileVersionResponse', fileVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } } } };

export type WorkflowFragmentFragment = { __typename: 'Workflow', id: string, envelopeMsg: string | null, forwardingPermissionRole: PermissionRole | null, isSignedOutsideAline: boolean, name: string, description: string, status: WorkflowStatus, state: WorkflowState, envelopeStatus: EnvelopeStatus, isCommunityWorkflow: boolean, requesterInOwnerOrg: boolean, createdAt: string, variant: WorkflowVariant, missingActions: boolean, publishedAt: string | null, sourceWorkflow: { __typename: 'Workflow', id: string, name: string } | null, activeStep: { __typename: 'WorkflowStep', id: string } | null, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, statusDateTime: string, title: string, variant: EnvelopeVariant } | null, labels: Array<{ __typename: 'Label', id: string, labelText: string }>, owner: { __typename: 'User', id: string }, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, column: { __typename: 'Column', id: string, name: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> };

export type WorkflowWithFilesFragment = { __typename: 'Workflow', id: string, createdAt: string, envelopeMsg: string | null, envelopeStatus: EnvelopeStatus, name: string, requesterInOwnerOrg: boolean, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, column: { __typename: 'Column', id: string, name: string }, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, envelope: { __typename: 'Envelope', id: string, completedAt: string | null, docuSignEnvelopeId: string | null, variant: EnvelopeVariant } | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }>, owner: { __typename: 'User', id: string }, phases: Array<{ __typename: 'NonSigningPhase', id: string } | { __typename: 'SigningPhase', id: string, steps: Array<{ __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> };

export type WorkflowInboxWorkflowFragment = { __typename: 'Workflow', id: string, aiCancelledAt: string | null, aiFailedAt: string | null, aiFailureReason: string | null, aiFinishedAt: string | null, aiStartedAt: string | null, createdAt: string, startedAt: string | null, completedAt: string | null, isSignedOutsideAline: boolean, name: string, publishedAt: string | null, status: WorkflowStatus, state: WorkflowState, variant: WorkflowVariant, missingActions: boolean, activeStep: { __typename: 'WorkflowStep', id: string, createdAt: string, startedAt: string | null, completedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, createdAt: string, completedAt: string | null, firstSentAt: string | null, lastSentAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null }> } | null, files: Array<{ __typename: 'WorkflowFile', id: string, orderId: string, document: { __typename: 'Document', id: string, createdAt: string, name: string, variant: DocumentVariant, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, latestVersion: { __typename: 'DocumentVersion', id: string, documentJSON: { [key: string]: any } } | { __typename: 'StaticFileVersion', id: string, fileLocation: { __typename: 'DocFile', mimetype: string } } } }>, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, phases: Array<{ __typename: 'NonSigningPhase', id: string, order: number } | { __typename: 'SigningPhase', id: string, order: number }>, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> };

export type WorkBlockerWorkflowRecipientFragment = { __typename: 'WorkflowRecipient', id: string, completedAt: string | null, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null };

export type TogglePublishTemplateMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type TogglePublishTemplateMutation = { __typename: 'Mutation', togglePublishTemplate: { __typename: 'WorkflowResponse', workflow: { __typename: 'Workflow', id: string, publishedAt: string | null } } };

export type OnWorkflowsUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnWorkflowsUpdatedSubscription = { __typename: 'Subscription', workflowsUpdated: { __typename: 'WorkflowsUpdatedEvent', workflows: Array<{ __typename: 'Workflow', id: string, aiCancelledAt: string | null, aiFailedAt: string | null, aiFailureReason: string | null, aiFinishedAt: string | null, aiStartedAt: string | null, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, updatedAt: string, deletedAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, workflow: { __typename: 'Workflow', id: string } | null, type: { __typename: 'ContractType', id: string, value: string } | null } }> }> } };

export type GetTestScalarsQueryVariables = Exact<{
  input: Test_ScalarsInput;
}>;


export type GetTestScalarsQuery = { __typename: 'Query', TEST_scalars: { __typename: 'TEST_Scalars', TEST_BigInt: number, TEST_Date: string, TEST_DateTime: string, TEST_EmailAddress: string, TEST_JSON: { [key: string]: any }, TEST_UUID: string } };

export type GetWorkflowAllPropsQueryVariables = Exact<{
  workflowId: Scalars['UUID'];
}>;


export type GetWorkflowAllPropsQuery = { __typename: 'Query', workflow: { __typename: 'Workflow', id: string, commentCount: number, completedStepCount: number, envelopeMsg: string | null, fileCount: number, isCommunityWorkflow: boolean, name: string, numTimesUsed: number, requesterInOwnerOrg: boolean, status: WorkflowStatus, totalStepCount: number, variant: WorkflowVariant, startedAt: string | null, completedAt: string | null, createdAt: string, updatedAt: string, missingActions: boolean, publishedAt: string | null, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, activeStep: { __typename: 'WorkflowStep', id: string, phaseId: string, isCompleted: boolean, completedAt: string | null, startedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> } | null, permissions: Array<{ __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }>, files: Array<{ __typename: 'WorkflowFile', id: string, documentRole: WorkflowFileDocumentRole, isInternal: boolean, phaseId: string | null, orderId: string, createdAt: string, updatedAt: string, document: { __typename: 'Document', id: string, name: string, status: DocumentStatus | null, variant: DocumentVariant, requesterFavorited: boolean, updatedAt: string, deletedAt: string | null, requesterRole: PermissionRole | null, isCertificate: boolean, isCommunityTemplate: boolean, isSigned: boolean, lastAccessedByRequesterAt: string | null, createdAt: string, latestVersion: { __typename: 'DocumentVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'StaticFileVersion', id: string, fileContentChangedAt: string | null, name: string, createdAt: string, updatedAt: string, vectorsStartedAt: string | null, vectorsSavedAt: string | null, vectorsFailedAt: string | null, fileExtractionStartedAt: string | null, fileExtractionFinishedAt: string | null, fileExtractionFailedReason: string | null, fileExtractionFailedAt: string | null, authors: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }>, annotationsXFDF: { __typename: 'AnnotationsXFDF', id: string, xfdf: string } | null, fileLocation: { __typename: 'DocFile', id: string, filestackUrl: string, mimetype: string, size: number | null } }, owner: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, type: { __typename: 'ContractType', id: string, value: string } | null, license: { __typename: 'SupportedLicense', id: string, name: string, url: string } | null, workflow: { __typename: 'Workflow', id: string } | null } }>, comments: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, deletedAt: string | null, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, commentable: { __typename: 'Document', id: string } | { __typename: 'Task', id: string } | { __typename: 'Workflow', id: string }, parent: { __typename: 'Comment', id: string } | null, replies: Array<{ __typename: 'Comment', id: string, nodeRefId: string | null, importedAuthorName: string | null, isPrivate: boolean, resolved: boolean, text: string, createdAt: string, updatedAt: string, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null }> }>, parties: Array<{ __typename: 'Party', id: string, description: string, name: string }>, unusedActions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }>, sourceWorkflow: { __typename: 'Workflow', id: string, name: string, variant: WorkflowVariant } | null, tasks: Array<{ __typename: 'Task', id: string, alineAiRunMessageId: string | null, createdAt: string, completedAt: string | null, description: string, isDelegatedToAi: boolean, status: TaskStatus, startedAt: string | null, title: string, updatedAt: string, variant: TaskVariant, counterpartyName: string | null, hasExternalAssignees: boolean, ownerName: string, requesterIsInternal: boolean, rejectedAt: string | null, round: number, author: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, comments: Array<{ __typename: 'Comment', id: string, text: string }>, completedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, requesterDisallowedReason: { __typename: 'DisallowedTaskReasons', edit: string | null, changeStatus: string | null }, workflow: { __typename: 'Workflow', id: string, completedAt: string | null, variant: WorkflowVariant, status: WorkflowStatus, state: WorkflowState }, phase: { __typename: 'NonSigningPhase', id: string, name: string, order: number } | { __typename: 'SigningPhase', id: string, name: string, order: number }, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }>, parentTask: { __typename: 'Task', id: string, title: string } | null, rejectedBy: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, subtasks: Array<{ __typename: 'Task', id: string, completedAt: string | null, rejectedAt: string | null, status: TaskStatus, title: string, assignments: Array<{ __typename: 'TaskAssignment', decidedAt: string | null, decidedInRound: number | null, decision: TaskAssigneeDecision | null, isExternal: boolean, isRequired: boolean, reviewRequestedAt: string | null, role: TaskAssigneeRole, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null }, reviewRequestedBy: { __typename: 'User', id: string, displayName: string } | null, uploads: Array<{ __typename: 'TaskUpload', id: string, createdAt: string, documentId: string, fileName: string, fileVersionId: string | null, round: number, status: TaskUploadStatus, submittedAt: string | null }> }> }> }>, envelope: { __typename: 'Envelope', id: string, docuSignEnvelopeId: string | null, variant: EnvelopeVariant } | null, phases: Array<{ __typename: 'NonSigningPhase' } | { __typename: 'SigningPhase', steps: Array<{ __typename: 'WorkflowStep', id: string, startedAt: string | null, isCompleted: boolean, completedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> } | null };

export type WorkflowStepAllPropsFragmentFragment = { __typename: 'WorkflowStep', id: string, startedAt: string | null, isCompleted: boolean, completedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> };

export type WorkflowSigningPhaseStepsAllPropsFragment = { __typename: 'Workflow', phases: Array<{ __typename: 'NonSigningPhase' } | { __typename: 'SigningPhase', steps: Array<{ __typename: 'WorkflowStep', id: string, startedAt: string | null, isCompleted: boolean, completedAt: string | null, actions: Array<{ __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, fields: Array<{ __typename: 'DocumentVariable', id: string, deletedAt: string | null, label: string, isField: boolean, addToLaunchForm: boolean, nodeId: string, prefix: string | null, question: string, minRequired: number, maxRequired: number | null, variant: MetadataVariant, value: string | null, skipped: boolean, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null, selectedAnswer: { __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction } | null, selectedAnswers: Array<{ __typename: 'AnswerOption', id: string, choiceRefId: string, optionText: string, triggerAction: TriggerAction }> | null } | { __typename: 'SignatureField', id: string, allSigned: boolean, deletedAt: string | null, nodeId: string, action: { __typename: 'WorkflowRecipient', id: string, firstSentAt: string | null, firstViewedAt: string | null, createdAt: string, lastSentAt: string | null, lastViewedAt: string | null, routingOrder: number, completedAt: string | null, recipientName: string | null, signingIpAddress: string | null, status: WorkflowRecipientStatus, startedAt: string | null, type: WorkflowRecipientType, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } } | null }>, assignee: { __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, assigneeRole: { __typename: 'UserDefinedRole', id: string, roleName: string, org: { __typename: 'Org', id: string } | null, author: { __typename: 'User', id: string } | null } | null, permission: { __typename: 'WorkflowPermission', id: string, accessLevel: WorkflowAccessLevel, docAccessLevel: DocAccessLevel, isAssignee: boolean, isExternal: boolean, isLauncher: boolean, workflowVariant: WorkflowVariant, timeliness: WorkflowPermissionTimeliness, createdAt: string, updatedAt: string, account: { __typename: 'Org', id: string, avatarColor: string, accountType: AccountType, parentChildEnabled: boolean, name: string, website: string | null, type: OrgType | null, size: OrgSize | null, orgDefaultRole: OrgRole, signingReminderDays: number | null, isPreOnboardingCompleted: boolean, trialStartedAt: string, trialEndAt: string, createdAt: string, updatedAt: string, members: Array<{ __typename: 'User', id: string, accountStatus: AccountStatus, accountType: AccountType, avatarColor: string, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } }> } | { __typename: 'User', id: string, avatarColor: string, accountType: AccountType, accountStatus: AccountStatus, displayName: string, firstName: string | null, lastName: string | null, email: string, jobTitle: string | null, role: OrgRole, supportRole: SupportRole | null, isDeactivated: boolean, createdAt: string, updatedAt: string, deletedAt: string | null, org: { __typename: 'Org', id: string, name: string } } | null, role: { __typename: 'UserDefinedRole', id: string, roleName: string } | null } }> }> }> };

export const ObservedSkillDraftFragmentDoc = gql`
    fragment ObservedSkillDraft on AgentSkill {
  id
  draft {
    revision
    content
    name
    description
    isComplete
    filesReady
    updatedAt
    attachments {
      path
    }
  }
}
    `;
export const DisplayNameUpdateFragmentDoc = gql`
    fragment DisplayNameUpdate on DocumentMetadataImport {
  displayName
}
    `;
export const SkillArtifactThreadForTestFragmentDoc = gql`
    fragment SkillArtifactThreadForTest on AgentThread {
  id
  artifacts {
    __typename
    ... on ThreadSkillArtifact {
      agentMessageId
      createdAt
      kindList
      skill {
        id
        name
        scope
        isComplete
        currentVersion {
          id
          name
          description
        }
      }
    }
  }
}
    `;
export const SkillForSkillArtifactTestFragmentDoc = gql`
    fragment SkillForSkillArtifactTest on AgentSkill {
  id
  name
  scope
  isComplete
  currentVersion {
    id
    name
    description
  }
}
    `;
export const WorkflowArtifactThreadForTestFragmentDoc = gql`
    fragment WorkflowArtifactThreadForTest on AgentThread {
  id
  artifacts {
    __typename
    ... on ThreadWorkflowArtifact {
      agentMessageId
      createdAt
      kindList
      workflow {
        id
        name
      }
    }
  }
}
    `;
export const SeedAgentThreadForTestFragmentDoc = gql`
    fragment SeedAgentThreadForTest on AgentThread {
  id
  artifacts {
    __typename
    ... on ThreadDocumentArtifact {
      agentMessageId
      createdAt
      kindList
      document {
        __typename
        id
        name
        deletedAt
      }
    }
  }
}
    `;
export const ArtifactDocumentFieldsForTestFragmentDoc = gql`
    fragment ArtifactDocumentFieldsForTest on Document {
  id
  name
  deletedAt
}
    `;
export const ArtifactDocumentFieldsFragmentDoc = gql`
    fragment ArtifactDocumentFields on Document {
  id
  name
  deletedAt
}
    `;
export const ArtifactReportFieldsFragmentDoc = gql`
    fragment ArtifactReportFields on Report {
  id
  name
}
    `;
export const AgentThreadIdProbeFragmentDoc = gql`
    fragment AgentThreadIdProbe on AgentThread {
  id
}
    `;
export const ArtifactSkillFieldsFragmentDoc = gql`
    fragment ArtifactSkillFields on AgentSkill {
  id
  name
  scope
  isComplete
  currentVersion {
    id
    name
    description
  }
}
    `;
export const ArtifactWorkflowFieldsFragmentDoc = gql`
    fragment ArtifactWorkflowFields on Workflow {
  id
  name
}
    `;
export const AlineChatAdapterMessageDataFragmentDoc = gql`
    fragment AlineChatAdapterMessageData on AgentMessage {
  id
  data
}
    `;
export const AgentMessageFieldsFragmentDoc = gql`
    fragment AgentMessageFields on AgentMessage {
  id
  __typename
  role
  status
  text
  data
  feedback
  planState
  createdAt
}
    `;
export const StreamingAgentMessageFieldsFragmentDoc = gql`
    fragment StreamingAgentMessageFields on AgentMessage {
  id
  status
  text
}
    `;
export const StreamingMessageDataFragmentDoc = gql`
    fragment StreamingMessageData on AgentMessage {
  id
  data
}
    `;
export const StreamingMessagePlanStateFragmentDoc = gql`
    fragment StreamingMessagePlanState on AgentMessage {
  id
  planState
}
    `;
export const ThreadTitleFragmentDoc = gql`
    fragment ThreadTitle on AgentThread {
  id
  title
}
    `;
export const SelectedPartyFragmentDoc = gql`
    fragment SelectedParty on Party {
  __typename
  id
  name
}
    `;
export const NewDocumentFragmentDoc = gql`
    fragment NewDocument on Document {
  __typename
  id
}
    `;
export const RelationshipReviewStatusFragmentDoc = gql`
    fragment RelationshipReviewStatus on DocumentRelationship {
  id
  childRelationshipType
  childDocumentId
  parentDocumentId
  review {
    __typename
    outcome
    reviewedBy {
      id
      displayName
    }
  }
}
    `;
export const CurrentFileVersionFragmentDoc = gql`
    fragment CurrentFileVersion on StaticFileVersion {
  __typename
  id
  annotationsXFDF {
    __typename
    id
  }
}
    `;
export const NewAutomationFragmentDoc = gql`
    fragment NewAutomation on AIReminderAutomation {
  __typename
  id
}
    `;
export const NewAnswerOptionsFragmentDoc = gql`
    fragment NewAnswerOptions on AnswerOptions {
  __typename
  id
  title
  options {
    __typename
    id
    optionText
    triggerAction
  }
}
    `;
export const NewBoardFragmentDoc = gql`
    fragment NewBoard on Board {
  __typename
  id
}
    `;
export const NewCommentFragmentDoc = gql`
    fragment NewComment on Comment {
  __typename
  id
}
    `;
export const NewReplyFragmentDoc = gql`
    fragment NewReply on Comment {
  __typename
  id
}
    `;
export const NewContractTypeFragmentDoc = gql`
    fragment NewContractType on ContractType {
  __typename
  id
}
    `;
export const UpdateDocumentFragmentDoc = gql`
    fragment UpdateDocument on Document {
  __typename
  id
}
    `;
export const NewJobFragmentDoc = gql`
    fragment NewJob on ExtractionJob {
  __typename
  id
}
    `;
export const NewPlaybookFragmentDoc = gql`
    fragment NewPlaybook on Playbook {
  __typename
  id
}
    `;
export const CreateDocumentFragmentDoc = gql`
    fragment CreateDocument on Document {
  __typename
  id
}
    `;
export const DuplicateTemplateFragmentDoc = gql`
    fragment DuplicateTemplate on Document {
  __typename
  id
}
    `;
export const CopyDocumentFragmentDoc = gql`
    fragment CopyDocument on Document {
  __typename
  id
}
    `;
export const ReportColumnOptionsForTestFragmentDoc = gql`
    fragment ReportColumnOptionsForTest on Report {
  id
  columnOptions {
    ... on FileFieldColumn {
      displayName
      field
      dataType
      isGroupable
    }
    ... on ExtractionReportColumn {
      questionId
      dataType
      displayName
      isGroupable
    }
  }
}
    `;
export const NewExtractionJobFragmentDoc = gql`
    fragment NewExtractionJob on ExtractionJob {
  __typename
  id
}
    `;
export const NewExtractionQuestionGenerationJobFragmentDoc = gql`
    fragment NewExtractionQuestionGenerationJob on ExtractionQuestionGenerationJob {
  __typename
  id
}
    `;
export const NewQuestionOptionFragmentDoc = gql`
    fragment NewQuestionOption on QuestionOption {
  __typename
  id
}
    `;
export const NewExtractionQuestionFragmentDoc = gql`
    fragment NewExtractionQuestion on ExtractionQuestion {
  __typename
  id
}
    `;
export const NewSignatureFragmentDoc = gql`
    fragment NewSignature on SignatureField {
  __typename
  id
}
    `;
export const NewVersionFragmentDoc = gql`
    fragment NewVersion on FileVersionInterface {
  __typename
  id
}
    `;
export const NewSignedVersionFragmentDoc = gql`
    fragment NewSignedVersion on FileVersionInterface {
  __typename
  id
}
    `;
export const CreateFilesFragmentDoc = gql`
    fragment CreateFiles on Document {
  __typename
  id
}
    `;
export const NewFolderSyncJobFragmentDoc = gql`
    fragment NewFolderSyncJob on FolderSyncJob {
  __typename
  id
}
    `;
export const NewGroupFragmentDoc = gql`
    fragment NewGroup on Group {
  __typename
  id
}
    `;
export const NewUserFragmentDoc = gql`
    fragment NewUser on User {
  __typename
  id
}
    `;
export const NewLabelFragmentDoc = gql`
    fragment NewLabel on Label {
  __typename
  id
}
    `;
export const NewMemberFragmentDoc = gql`
    fragment NewMember on User {
  __typename
  id
}
    `;
export const NewPartyFragmentDoc = gql`
    fragment NewParty on Party {
  __typename
  id
}
    `;
export const NewPhaseFragmentDoc = gql`
    fragment NewPhase on Phase {
  __typename
  id
}
    `;
export const PhaseSigningFlagFragmentDoc = gql`
    fragment PhaseSigningFlag on Phase {
  __typename
  id
}
    `;
export const PhaseRefFragmentDoc = gql`
    fragment PhaseRef on Phase {
  __typename
  id
}
    `;
export const ReminderIdentityFragmentDoc = gql`
    fragment ReminderIdentity on Reminder {
  __typename
  id
  reviewStatus
}
    `;
export const NewReminderFragmentDoc = gql`
    fragment NewReminder on Reminder {
  __typename
  id
  completedAt
  reviewStatus
}
    `;
export const NewReportFragmentDoc = gql`
    fragment NewReport on Report {
  __typename
  id
  name
  createdAt
}
    `;
export const NewRoleFragmentDoc = gql`
    fragment NewRole on UserDefinedRole {
  __typename
  id
}
    `;
export const NewPermissionFragmentDoc = gql`
    fragment NewPermission on StorablePermission {
  __typename
  id
}
    `;
export const NewTaskFragmentDoc = gql`
    fragment NewTask on Task {
  __typename
  id
}
    `;
export const NewTaskPermissionFragmentDoc = gql`
    fragment NewTaskPermission on WorkflowPermission {
  __typename
  id
}
    `;
export const NewVariableFragmentDoc = gql`
    fragment NewVariable on DocumentVariable {
  __typename
  id
}
    `;
export const NewWorkflowPermissionFragmentDoc = gql`
    fragment NewWorkflowPermission on WorkflowPermission {
  __typename
  id
}
    `;
export const NewWorkflowFragmentDoc = gql`
    fragment NewWorkflow on Workflow {
  __typename
  id
}
    `;
export const AlineSubscriptionSimpleFragmentDoc = gql`
    fragment AlineSubscriptionSimple on AlineSubscription {
  __typename
  id
  status
  numFullSeats
  numBasicSeats
  tier
  subscriptionStartedAt
  subscriptionEndsAt
  salesbricksSubscriptionId
  openOrders {
    __typename
    id
    stage
  }
  pastDueInvoices {
    __typename
    id
    invoiceNumber
    dueAt
  }
}
    `;
export const GroupSimpleFragmentDoc = gql`
    fragment GroupSimple on Group {
  __typename
  id
  avatarColor
  name
  canAccessAllDocAndWorkflows
  createdAt
  updatedAt
}
    `;
export const UserBaseFragmentDoc = gql`
    fragment UserBase on User {
  __typename
  id
  accountStatus
  accountType
  avatarColor
  displayName
  firstName
  lastName
  email
  jobTitle
  role
  supportRole
  isDeactivated
  org {
    __typename
    id
    name
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const GroupWithUsersFragmentDoc = gql`
    fragment GroupWithUsers on Group {
  __typename
  id
  avatarColor
  name
  users {
    ...UserBase
  }
  createdAt
  updatedAt
}
    ${UserBaseFragmentDoc}`;
export const UpgradeRequestBaseFragmentDoc = gql`
    fragment UpgradeRequestBase on UpgradeRequest {
  __typename
  id
  requestedRole
  message
  status
  respondedAt
  responseMessage
  createdAt
  requester {
    ...UserBase
  }
  org {
    __typename
    id
    name
  }
  respondedBy {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;
export const OnboardingTaskSimpleFragmentDoc = gql`
    fragment OnboardingTaskSimple on OnboardingTask {
  __typename
  id
  action
  completedAt
  skipped
}
    `;
export const UserOnboardingInfoFragmentDoc = gql`
    fragment UserOnboardingInfo on UserSettings {
  __typename
  id
  hideOnboarding
  onboardingTasks {
    ...OnboardingTaskSimple
  }
}
    ${OnboardingTaskSimpleFragmentDoc}`;
export const UserSettingsSimpleFragmentDoc = gql`
    fragment UserSettingsSimple on UserSettings {
  __typename
  id
  exampleNDA {
    __typename
    id
    workflow {
      __typename
      id
    }
  }
  exampleNDAPlaybook {
    __typename
    id
  }
  hideOnboarding
  signatureImg {
    __typename
    id
    filestackUrl
  }
  signatureInitialsImg {
    __typename
    id
    filestackUrl
  }
  exampleReport {
    __typename
    id
  }
}
    `;
export const UserFullFragmentDoc = gql`
    fragment UserFull on User {
  __typename
  id
  accountStatus
  accountType
  avatarColor
  displayName
  firstName
  lastName
  email
  jobTitle
  myRepositoryId
  role
  supportRole
  isDeactivated
  createdAt
  deletedAt
  org {
    __typename
    avatarColor
    id
    name
  }
  settings {
    ...UserSettingsSimple
  }
}
    ${UserSettingsSimpleFragmentDoc}`;
export const AssigneeSimpleFragmentDoc = gql`
    fragment AssigneeSimple on User {
  __typename
  id
  avatarColor
  displayName
  email
  firstName
  lastName
  org {
    __typename
    id
  }
}
    `;
export const FileVersionSimpleFragmentDoc = gql`
    fragment FileVersionSimple on FileVersion {
  ... on FileVersionInterface {
    __typename
    id
    fileContentChangedAt
    name
    createdAt
    updatedAt
    vectorsStartedAt
    vectorsSavedAt
    vectorsFailedAt
    authors {
      ...UserBase
    }
  }
  ... on StaticFileVersion {
    fileExtractionStartedAt
    fileExtractionFinishedAt
    fileExtractionFailedReason
    fileExtractionFailedAt
    annotationsXFDF {
      __typename
      id
      xfdf
    }
    fileLocation {
      __typename
      id
      filestackUrl
      mimetype
      size
    }
  }
}
    ${UserBaseFragmentDoc}`;
export const WithRecentDocumentsFragmentDoc = gql`
    fragment WithRecentDocuments on Document {
  __typename
  id
  createdAt
  lastAccessedByRequesterAt
  name
  variant
  status
  latestVersion {
    ...FileVersionSimple
  }
}
    ${FileVersionSimpleFragmentDoc}`;
export const UserWithRecentDocumentsFragmentDoc = gql`
    fragment UserWithRecentDocuments on User {
  __typename
  id
  myRecentDocuments {
    ...WithRecentDocuments
  }
}
    ${WithRecentDocumentsFragmentDoc}`;
export const ReplySimpleFragmentDoc = gql`
    fragment ReplySimple on Comment {
  __typename
  id
  nodeRefId
  importedAuthorName
  isPrivate
  resolved
  text
  author {
    ...UserBase
  }
  createdAt
  updatedAt
}
    ${UserBaseFragmentDoc}`;
export const CommentSimpleFragmentDoc = gql`
    fragment CommentSimple on Comment {
  __typename
  id
  nodeRefId
  importedAuthorName
  isPrivate
  resolved
  text
  createdAt
  updatedAt
  deletedAt
  author {
    ...UserBase
  }
  commentable {
    ... on Document {
      __typename
      id
    }
    ... on Task {
      __typename
      id
    }
    ... on Workflow {
      __typename
      id
    }
  }
  parent {
    __typename
    id
  }
  replies {
    ...ReplySimple
  }
}
    ${UserBaseFragmentDoc}
${ReplySimpleFragmentDoc}`;
export const ActivityItemFieldsFragmentDoc = gql`
    fragment ActivityItemFields on ActivityItem {
  __typename
  id
  itemType
  sourceType
  audience
  createdAt
  channelThread {
    __typename
    id
    provider
    externalChannelId
    externalThreadId
    webUrl
  }
  author {
    ...UserBase
  }
  body {
    __typename
    ... on CommentActivity {
      comment {
        ...CommentSimple
      }
    }
    ... on AgentThreadActivity {
      agentThread {
        __typename
        id
        ownerUserId
        title
        createdAt
        updatedAt
        messages {
          __typename
          id
          role
          status
          text
          data
          planState
        }
      }
    }
    ... on StatusUpdateActivity {
      events {
        eventType
        data
        assignmentChange
        targetCount
        removedCount
        reviewerIds
        targetReviewerCount
        removedReviewerCount
        movedCount
        movedReviewerCount
        movedUsers {
          ...UserBase
        }
        movedRoles {
          __typename
          id
          roleName
        }
        targetUsers {
          ...UserBase
        }
        targetRoles {
          __typename
          id
          roleName
        }
        removedUsers {
          ...UserBase
        }
        removedRoles {
          __typename
          id
          roleName
        }
        onBehalfOfUser {
          ...UserBase
        }
        reviewRequestUsers {
          ...UserBase
        }
      }
    }
  }
}
    ${UserBaseFragmentDoc}
${CommentSimpleFragmentDoc}`;
export const ActivityPageFieldsFragmentDoc = gql`
    fragment ActivityPageFields on ActivityItemRowsInfo {
  __typename
  rows {
    ...ActivityItemFields
  }
  meta {
    __typename
    totalCount
    hasMore
    nextCursor
    hasPrevious
    previousCursor
  }
}
    ${ActivityItemFieldsFragmentDoc}`;
export const AgentSkillListItemFragmentDoc = gql`
    fragment AgentSkillListItem on AgentSkill {
  id
  scope
  name
  description
  isComplete
  isPublished
  hasUnpublishedChanges
  createdAt
  updatedAt
  currentVersion {
    id
    number
    name
    description
  }
  owner {
    __typename
    id
    avatarColor
    displayName
    firstName
    lastName
  }
}
    `;
export const AgentSkillAttachmentFieldsFragmentDoc = gql`
    fragment AgentSkillAttachmentFields on AgentSkillAttachment {
  path
  name
  contentType
  sha256
  sourceDocumentId
  capturedAt
  sourceStatus
  processing
  processingError
}
    `;
export const AgentSkillSimpleFragmentDoc = gql`
    fragment AgentSkillSimple on AgentSkill {
  ...AgentSkillListItem
  content
  attachments {
    ...AgentSkillAttachmentFields
  }
  draft {
    revision
    content
    name
    description
    isComplete
    filesReady
    updatedAt
    attachments {
      ...AgentSkillAttachmentFields
    }
  }
}
    ${AgentSkillListItemFragmentDoc}
${AgentSkillAttachmentFieldsFragmentDoc}`;
export const AiReminderAutomationSimpleFragmentDoc = gql`
    fragment AIReminderAutomationSimple on AIReminderAutomation {
  __typename
  id
  title
  prompt
  notificationOffsets {
    amount
    position
    unit
  }
  selectedColumnIds
  selectedBuiltInFields
  status
  pendingRemindersCount
  activeRemindersCount
  lastRunAt
  lastTriggeredAt
  lastCompletedAt
  nextRunAt
  isRunning
  totalRemindersGenerated
  createdAt
  updatedAt
  deletedAt
}
    `;
export const AiReminderAutomationWithRelationsFragmentDoc = gql`
    fragment AIReminderAutomationWithRelations on AIReminderAutomation {
  ...AIReminderAutomationSimple
  report {
    __typename
    id
    name
  }
  assignees {
    __typename
    id
    avatarColor
    displayName
    email
  }
  reviewers {
    __typename
    id
    avatarColor
    displayName
    email
  }
}
    ${AiReminderAutomationSimpleFragmentDoc}`;
export const AiReminderAutomationRunSimpleFragmentDoc = gql`
    fragment AIReminderAutomationRunSimple on AIReminderAutomationRun {
  __typename
  status
  remindersGenerated
  errorMessage
  processedAt
  createdAt
  updatedAt
}
    `;
export const ApiKeyBaseFragmentDoc = gql`
    fragment ApiKeyBase on ApiKey {
  __typename
  id
  name
  obfuscatedValue
  permissions
  createdAt
  lastUsedAt
}
    `;
export const BoardBaseFragmentDoc = gql`
    fragment BoardBase on Board {
  id
  name
  icon
  color
  createdAt
  updatedAt
}
    `;
export const ColumnBaseFragmentDoc = gql`
    fragment ColumnBase on Column {
  id
  name
  category
  color
  sortKey
  createdAt
  updatedAt
}
    `;
export const BoardWithColumnsFragmentDoc = gql`
    fragment BoardWithColumns on Board {
  ...BoardBase
  org {
    id
    name
  }
  triageColumn {
    ...ColumnBase
  }
  signingColumn {
    ...ColumnBase
  }
  columns {
    ...ColumnBase
  }
}
    ${BoardBaseFragmentDoc}
${ColumnBaseFragmentDoc}`;
export const ColumnWithWorkflowsFragmentDoc = gql`
    fragment ColumnWithWorkflows on Column {
  ...ColumnBase
  workflows {
    id
    name
    envelopeStatus
    state
    variant
    createdAt
    updatedAt
  }
}
    ${ColumnBaseFragmentDoc}`;
export const BoardFullFragmentDoc = gql`
    fragment BoardFull on Board {
  ...BoardBase
  org {
    id
    name
  }
  signingColumn {
    ...ColumnBase
  }
  columns {
    ...ColumnWithWorkflows
  }
}
    ${BoardBaseFragmentDoc}
${ColumnBaseFragmentDoc}
${ColumnWithWorkflowsFragmentDoc}`;
export const ColumnWithBoardFragmentDoc = gql`
    fragment ColumnWithBoard on Column {
  ...ColumnBase
  board {
    ...BoardBase
  }
}
    ${ColumnBaseFragmentDoc}
${BoardBaseFragmentDoc}`;
export const CommunityCategorySimpleFragmentDoc = gql`
    fragment CommunityCategorySimple on CommunityCategory {
  __typename
  id
  description
  emoji
  title
  createdAt
  updatedAt
}
    `;
export const DocumentMetadataImportSummaryFieldsFragmentDoc = gql`
    fragment DocumentMetadataImportSummaryFields on DocumentMetadataImportSummary {
  createdJobs
  emptyColumns
  errorRows
  processedRowCount
  skippedCells
  totalRows
  updatedJobs
  validRows
}
    `;
export const DocumentMetadataImportHistoryFieldsFragmentDoc = gql`
    fragment DocumentMetadataImportHistoryFields on DocumentMetadataImport {
  id
  createdAt
  createdBy {
    id
    displayName
  }
  displayName
  failedReason
  finishedAt
  startedAt
  sourceFileName
  status
  summary {
    ...DocumentMetadataImportSummaryFields
  }
  templateVersion
  updatedAt
}
    ${DocumentMetadataImportSummaryFieldsFragmentDoc}`;
export const DocumentMetadataImportFieldsFragmentDoc = gql`
    fragment DocumentMetadataImportFields on DocumentMetadataImport {
  ...DocumentMetadataImportHistoryFields
  questions {
    id
    questionText
    title
    type
  }
}
    ${DocumentMetadataImportHistoryFieldsFragmentDoc}`;
export const DocumentMetadataImportPreviewFieldsFragmentDoc = gql`
    fragment DocumentMetadataImportPreviewFields on DocumentMetadataImportPreview {
  conflictRows
  errorRows
  totalRows
  columns {
    canOverwrite
    errorCount
    questionId
    title
    type
    warningCount
  }
}
    `;
export const DocumentForSignatureFragmentDoc = gql`
    fragment DocumentForSignature on Document {
  __typename
  id
  storableType
  workflow {
    __typename
    id
    status
    state
    envelopeStatus
    activeStep {
      __typename
      id
    }
    envelope {
      __typename
      id
    }
  }
}
    `;
export const EnvelopeSimpleFragmentDoc = gql`
    fragment EnvelopeSimple on Envelope {
  __typename
  id
  completedAt
  variant
  title
  statusDateTime
  docuSignEnvelopeId
  docuSignUri
  workflow {
    __typename
    id
    state
    envelopeStatus
    files {
      __typename
      id
    }
  }
  recipients {
    __typename
    id
    status
    type
  }
  createdAt
  updatedAt
}
    `;
export const UserDefinedRoleSimpleFragmentDoc = gql`
    fragment UserDefinedRoleSimple on UserDefinedRole {
  __typename
  id
  roleName
  org {
    __typename
    id
  }
  author {
    __typename
    id
  }
}
    `;
export const OrgBaseFragmentDoc = gql`
    fragment OrgBase on Org {
  __typename
  id
  accountType
  avatarColor
  parentChildEnabled
  name
  website
  type
  size
  orgDefaultRole
  signingReminderDays
  isPreOnboardingCompleted
  trialStartedAt
  trialEndAt
  createdAt
  updatedAt
  members {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;
export const AccountBaseFragmentDoc = gql`
    fragment AccountBase on AccountInterface {
  __typename
  id
  avatarColor
  accountType
  ... on User {
    ...UserBase
  }
  ... on Org {
    ...OrgBase
  }
}
    ${UserBaseFragmentDoc}
${OrgBaseFragmentDoc}`;
export const WorkflowPermissionSimpleFragmentDoc = gql`
    fragment WorkflowPermissionSimple on WorkflowPermission {
  __typename
  id
  accessLevel
  docAccessLevel
  isAssignee
  isExternal
  isLauncher
  workflowVariant
  timeliness
  account {
    ...AccountBase
  }
  role {
    __typename
    id
    roleName
  }
  createdAt
  updatedAt
}
    ${AccountBaseFragmentDoc}`;
export const WorkflowRecipientSimpleFragmentDoc = gql`
    fragment WorkflowRecipientSimple on WorkflowRecipient {
  __typename
  id
  firstSentAt
  firstViewedAt
  createdAt
  lastSentAt
  lastViewedAt
  routingOrder
  completedAt
  recipientName
  signingIpAddress
  status
  startedAt
  type
  assignee {
    ...UserBase
  }
  assigneeRole {
    ...UserDefinedRoleSimple
  }
  permission {
    ...WorkflowPermissionSimple
  }
}
    ${UserBaseFragmentDoc}
${UserDefinedRoleSimpleFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}`;
export const AnswerOptionBaseFragmentDoc = gql`
    fragment AnswerOptionBase on AnswerOption {
  __typename
  id
  choiceRefId
  optionText
  triggerAction
}
    `;
export const DocumentVariableSimpleFragmentDoc = gql`
    fragment DocumentVariableSimple on DocumentVariable {
  __typename
  id
  deletedAt
  label
  isField
  addToLaunchForm
  nodeId
  prefix
  question
  minRequired
  maxRequired
  variant
  value
  skipped
  action {
    ...WorkflowRecipientSimple
  }
  selectedAnswer {
    ...AnswerOptionBase
  }
  selectedAnswers {
    ...AnswerOptionBase
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}
${AnswerOptionBaseFragmentDoc}`;
export const SignatureFieldSimpleFragmentDoc = gql`
    fragment SignatureFieldSimple on SignatureField {
  __typename
  id
  allSigned
  deletedAt
  nodeId
  action {
    ...WorkflowRecipientSimple
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}`;
export const FieldSimpleFragmentDoc = gql`
    fragment FieldSimple on Field {
  ... on DocumentVariable {
    ...DocumentVariableSimple
  }
  ... on SignatureField {
    ...SignatureFieldSimple
  }
}
    ${DocumentVariableSimpleFragmentDoc}
${SignatureFieldSimpleFragmentDoc}`;
export const WorkflowRecipientWithFieldsFragmentDoc = gql`
    fragment WorkflowRecipientWithFields on WorkflowRecipient {
  ...WorkflowRecipientSimple
  fields {
    ...FieldSimple
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}
${FieldSimpleFragmentDoc}`;
export const WorkflowStepFragmentFragmentDoc = gql`
    fragment WorkflowStepFragment on WorkflowStep {
  __typename
  id
  phaseId
  isCompleted
  completedAt
  startedAt
  actions {
    ...WorkflowRecipientWithFields
  }
}
    ${WorkflowRecipientWithFieldsFragmentDoc}`;
export const WorkflowFileSimpleFragmentDoc = gql`
    fragment WorkflowFileSimple on WorkflowFile {
  __typename
  id
  documentRole
  isInternal
  phaseId
  orderId
  document {
    __typename
    id
    name
    status
    variant
    requesterFavorited
    requesterRole
    isCertificate
    isCommunityTemplate
    isSigned
    lastAccessedByRequesterAt
    latestVersion {
      ...FileVersionSimple
    }
    license {
      __typename
      id
      name
      url
    }
    owner {
      ...UserBase
    }
    workflow {
      __typename
      id
    }
    type {
      __typename
      id
      value
    }
    updatedAt
    deletedAt
    createdAt
  }
  createdAt
  updatedAt
}
    ${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}`;
export const WorkflowSigningPhaseStepsFragmentDoc = gql`
    "Signing-phase steps (NonEmpty), replacing legacy Workflow.orderedSteps."
fragment WorkflowSigningPhaseSteps on Workflow {
  phases {
    __typename
    id
    ... on SigningPhase {
      steps {
        ...WorkflowStepFragment
      }
    }
  }
}
    ${WorkflowStepFragmentFragmentDoc}`;
export const WorkflowWithFilesFragmentDoc = gql`
    fragment WorkflowWithFiles on Workflow {
  __typename
  id
  createdAt
  column {
    id
    name
  }
  envelopeMsg
  envelopeStatus
  name
  requesterInOwnerOrg
  status
  state
  variant
  activeStep {
    ...WorkflowStepFragment
  }
  envelope {
    __typename
    id
    completedAt
    docuSignEnvelopeId
    variant
  }
  files {
    ...WorkflowFileSimple
  }
  ...WorkflowSigningPhaseSteps
  owner {
    __typename
    id
  }
}
    ${WorkflowStepFragmentFragmentDoc}
${WorkflowFileSimpleFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}`;
export const EnvelopeWithFilesFragmentDoc = gql`
    fragment EnvelopeWithFiles on Envelope {
  __typename
  id
  completedAt
  docuSignEnvelopeId
  docuSignUri
  statusDateTime
  title
  variant
  workflow {
    ...WorkflowWithFiles
  }
  createdAt
  updatedAt
}
    ${WorkflowWithFilesFragmentDoc}`;
export const DocLocationSimpleFragmentDoc = gql`
    fragment DocLocationSimple on DocLocation {
  ... on AlineLocation {
    __typename
    locationPath
    referenceText
  }
  ... on FileLocation {
    __typename
    pageNum
    rect
    referenceText
  }
}
    `;
export const ExtractionJobSimpleFragmentDoc = gql`
    fragment ExtractionJobSimple on ExtractionJob {
  id
  answer
  previousAnswer
  startedAt
  finishedAt
  failedAt
  failedReason
  lockedAt
  lockedBy {
    ...UserBase
  }
  createdAt
  updatedAt
  questionContentHashAtRun
  reasoning
  fileVersion {
    ...FileVersionSimple
  }
  locations {
    ...DocLocationSimple
  }
  review {
    __typename
    reviewedAt
    reviewAction
    reviewedBy {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}
${FileVersionSimpleFragmentDoc}
${DocLocationSimpleFragmentDoc}`;
export const QuestionGenerationJobSimpleFragmentDoc = gql`
    fragment QuestionGenerationJobSimple on ExtractionQuestionGenerationJob {
  __typename
  id
  startedAt
  failedAt
  failedReason
  finishedAt
  extractionQuestions {
    id
    isActive
    aiGenerated
  }
}
    `;
export const QuestionOptionSimpleFragmentDoc = gql`
    fragment QuestionOptionSimple on QuestionOption {
  __typename
  id
  label
  color
  order
}
    `;
export const ContractTypeSimpleFragmentDoc = gql`
    fragment ContractTypeSimple on ContractType {
  __typename
  id
  value
}
    `;
export const ExtractionQuestionSimpleFragmentDoc = gql`
    fragment ExtractionQuestionSimple on ExtractionQuestion {
  id
  aiGuidance
  category
  contentHash
  inputFileFields
  title
  questionText
  type
  mode
  variant
  isActive
  createdAt
  updatedAt
  options {
    ...QuestionOptionSimple
  }
  contractTypes {
    ...ContractTypeSimple
  }
}
    ${QuestionOptionSimpleFragmentDoc}
${ContractTypeSimpleFragmentDoc}`;
export const FieldActionSimpleFragmentDoc = gql`
    fragment FieldActionSimple on Field {
  ... on DocumentVariable {
    __typename
    action {
      ...WorkflowRecipientSimple
    }
  }
  ... on SignatureField {
    __typename
    action {
      ...WorkflowRecipientSimple
    }
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}`;
export const AnswerOptionsBaseFragmentDoc = gql`
    fragment AnswerOptionsBase on AnswerOptions {
  __typename
  id
  isPreset
  title
  options {
    ...AnswerOptionBase
  }
}
    ${AnswerOptionBaseFragmentDoc}`;
export const FieldInfoFragmentDoc = gql`
    fragment FieldInfo on Field {
  ... on DocumentVariable {
    __typename
    id
    isField
    nodeId
    variant
    label
    question
    minRequired
    maxRequired
    value
    skipped
    action {
      ...WorkflowRecipientSimple
    }
    answerOptions {
      ...AnswerOptionsBase
    }
    defaultAnswer {
      ...AnswerOptionBase
    }
    selectedAnswer {
      ...AnswerOptionBase
    }
    selectedAnswers {
      ...AnswerOptionBase
    }
  }
  ... on SignatureField {
    ...SignatureFieldSimple
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}
${AnswerOptionsBaseFragmentDoc}
${AnswerOptionBaseFragmentDoc}
${SignatureFieldSimpleFragmentDoc}`;
export const SignatureFieldBaseFragmentDoc = gql`
    fragment SignatureFieldBase on SignatureField {
  __typename
  id
  nodeId
  action {
    ...WorkflowRecipientSimple
  }
  document {
    __typename
    id
  }
  createdAt
  updatedAt
  deletedAt
}
    ${WorkflowRecipientSimpleFragmentDoc}`;
export const InboxNotificationSimpleFragmentDoc = gql`
    fragment InboxNotificationSimple on InboxNotification {
  __typename
  id
  kind
  severity
  payload
  read
  createdAt
}
    `;
export const InboxNotificationsResultSimpleFragmentDoc = gql`
    fragment InboxNotificationsResultSimple on InboxNotificationsResult {
  __typename
  items {
    ...InboxNotificationSimple
  }
  unreadCount
}
    ${InboxNotificationSimpleFragmentDoc}`;
export const IntakeFormTemplateFullFragmentDoc = gql`
    fragment IntakeFormTemplateFull on IntakeFormTemplate {
  __typename
  id
  orgId
  owner {
    id
  }
  title
  description
  schemaVersion
  formDefinition
  defaultValues
  createdAt
  updatedAt
}
    `;
export const IntakeFormFullFragmentDoc = gql`
    fragment IntakeFormFull on IntakeForm {
  __typename
  id
  workflowId
  sourceIntakeFormTemplateId
  title
  description
  schemaVersion
  formDefinition
  defaultValues
  values
  missingFileDocumentIds
  completedAt
  completedBy {
    id
  }
}
    `;
export const CrmPairingKeyStatusFragmentDoc = gql`
    fragment CrmPairingKeyStatus on CrmPairing {
  __typename
  id
  integration
  crmTenantId
  secretScope
  lastRejectedRequestAt
  lastVerifiedRequestAt
  secretDeliveredAt
  secretDeliveryError
}
    `;
export const ApiDeckConnectionSimpleFragmentDoc = gql`
    fragment ApiDeckConnectionSimple on ApiDeckConnection {
  __typename
  id
  integration
  icon
  name
  tagLine
  enabled
  state
}
    `;
export const IntegrationFieldSimpleFragmentDoc = gql`
    fragment IntegrationFieldSimple on IntegrationField {
  __typename
  category
  fieldApiName
  groupDisplayName
  groupSortIndex
  isCustom
  objectType
  path
  recordId
  title
  type
  value
  valueStatus
  variant
}
    `;
export const ChannelInstallationSimpleFragmentDoc = gql`
    fragment ChannelInstallationSimple on ChannelInstallation {
  __typename
  id
  orgId
  provider
  externalAccountId
  displayName
  installedAt
  status
  createdAt
  appInstallUrl
  requiresReauthorization
}
    `;
export const ExternalToolkitSimpleFragmentDoc = gql`
    fragment ExternalToolkitSimple on ExternalToolkit {
  environmentAvailable
  __typename
  accountLabel
  allowedByOrg
  catalogueAvailable
  enabledCount
  name
  slug
  status
  tools {
    __typename
    description
    enabled
    mutates
    name
    slug
  }
}
    `;
export const ExternalToolkitPolicyRowSimpleFragmentDoc = gql`
    fragment ExternalToolkitPolicyRowSimple on ExternalToolkitPolicyRow {
  __typename
  allowed
  name
  slug
  usersWithGrants
}
    `;
export const FailedFileSimpleFragmentDoc = gql`
    fragment FailedFileSimple on FailedFile {
  __typename
  fileId
  fileName
  failedReason
  failedAt
  isDimissed
  mimeType
}
    `;
export const LabelSimpleFragmentDoc = gql`
    fragment LabelSimple on Label {
  id
  labelText
}
    `;
export const FolderSyncJobSimpleFragmentDoc = gql`
    fragment FolderSyncJobSimple on FolderSyncJob {
  __typename
  id
  folderId
  folderName
  integration
  syncStartedAt
  syncFinishedAt
  completedIds
  driveId
  driveName
  storageIntegrationIds
  allowedMimeTypes
  failedFiles {
    ...FailedFileSimple
  }
  createdAt
  labels {
    ...LabelSimple
  }
}
    ${FailedFileSimpleFragmentDoc}
${LabelSimpleFragmentDoc}`;
export const DriveSimpleFragmentDoc = gql`
    fragment DriveSimple on Drive {
  __typename
  id
  name
  integration
}
    `;
export const FolderFileSimpleFragmentDoc = gql`
    fragment FolderFileSimple on FolderFile {
  __typename
  id
  name
  path
  size
  type
  mimeType
}
    `;
export const CompletionFullFragmentDoc = gql`
    fragment CompletionFull on Completion {
  id
  text
  prompt
  completionType
}
    `;
export const DisallowedTaskReasonsSimpleFragmentDoc = gql`
    fragment DisallowedTaskReasonsSimple on DisallowedTaskReasons {
  __typename
  edit
  changeStatus
}
    `;
export const MinimalUserFragmentDoc = gql`
    fragment MinimalUser on User {
  __typename
  id
  displayName
}
    `;
export const TaskUploadFieldsFragmentDoc = gql`
    fragment TaskUploadFields on TaskUpload {
  __typename
  id
  createdAt
  documentId
  fileName
  fileVersionId
  round
  status
  submittedAt
}
    `;
export const TaskAssignmentFieldsFragmentDoc = gql`
    fragment TaskAssignmentFields on TaskAssignment {
  __typename
  decidedAt
  decidedInRound
  decision
  isExternal
  isRequired
  reviewRequestedAt
  role
  permission {
    ...WorkflowPermissionSimple
  }
  reviewRequestedBy {
    ...MinimalUser
  }
  uploads {
    ...TaskUploadFields
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}
${MinimalUserFragmentDoc}
${TaskUploadFieldsFragmentDoc}`;
export const TaskReviewFieldsFragmentDoc = gql`
    fragment TaskReviewFields on Task {
  __typename
  id
  counterpartyName
  hasExternalAssignees
  isDelegatedToAi
  ownerName
  requesterIsInternal
  rejectedAt
  round
  startedAt
  status
  assignments {
    ...TaskAssignmentFields
  }
  parentTask {
    __typename
    id
    title
  }
  rejectedBy {
    ...UserBase
  }
  subtasks {
    __typename
    id
    completedAt
    rejectedAt
    status
    title
    assignments {
      ...TaskAssignmentFields
    }
  }
}
    ${TaskAssignmentFieldsFragmentDoc}
${UserBaseFragmentDoc}`;
export const TaskSimpleFragmentDoc = gql`
    fragment TaskSimple on Task {
  __typename
  id
  alineAiRunMessageId
  createdAt
  completedAt
  description
  isDelegatedToAi
  status
  startedAt
  title
  updatedAt
  variant
  author {
    ...UserBase
  }
  comments {
    __typename
    id
    text
  }
  completedBy {
    ...UserBase
  }
  requesterDisallowedReason {
    ...DisallowedTaskReasonsSimple
  }
  workflow {
    __typename
    id
    completedAt
    variant
    status
    state
  }
  phase {
    __typename
    id
    name
    order
  }
  ...TaskReviewFields
}
    ${UserBaseFragmentDoc}
${DisallowedTaskReasonsSimpleFragmentDoc}
${TaskReviewFieldsFragmentDoc}`;
export const WorkflowFragmentFragmentDoc = gql`
    fragment WorkflowFragment on Workflow {
  __typename
  id
  envelopeMsg
  forwardingPermissionRole
  isSignedOutsideAline
  name
  description
  status
  state
  envelopeStatus
  isCommunityWorkflow
  requesterInOwnerOrg
  createdAt
  variant
  missingActions
  publishedAt
  sourceWorkflow {
    id
    name
  }
  activeStep {
    __typename
    id
  }
  envelope {
    __typename
    id
    docuSignEnvelopeId
    statusDateTime
    title
    variant
  }
  labels {
    ...LabelSimple
  }
  ...WorkflowSigningPhaseSteps
  owner {
    __typename
    id
  }
  tasks {
    ...TaskSimple
  }
  unusedActions {
    ...WorkflowRecipientSimple
  }
  column {
    __typename
    id
    name
  }
}
    ${LabelSimpleFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}
${TaskSimpleFragmentDoc}
${WorkflowRecipientSimpleFragmentDoc}`;
export const WorkflowLabelFullFragmentDoc = gql`
    fragment WorkflowLabelFull on Label {
  ...LabelSimple
  workflows {
    ...WorkflowFragment
  }
}
    ${LabelSimpleFragmentDoc}
${WorkflowFragmentFragmentDoc}`;
export const ActivitySubscribersFieldsFragmentDoc = gql`
    fragment ActivitySubscribersFields on ActivitySubscriptionToggleResult {
  __typename
  viewerSubscribed
  subscribers {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;
export const ActivitySubscriberOptionFieldsFragmentDoc = gql`
    fragment ActivitySubscriberOptionFields on ActivitySubscriberOption {
  __typename
  subscribed
  lockReason
  user {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;
export const PhaseSimpleFragmentDoc = gql`
    fragment PhaseSimple on Phase {
  __typename
  id
  name
  description
  order
  startedAt
  completedAt
  createdAt
  updatedAt
  column {
    ...ColumnBase
  }
  workflow {
    __typename
    id
    state
    variant
    isSignedOutsideAline
    files {
      __typename
      id
      documentRole
    }
  }
  ... on NonSigningPhase {
    tasks {
      __typename
      id
      alineAiRunMessageId
      createdAt
      title
      description
      status
      completedAt
      rejectedAt
      startedAt
      isDelegatedToAi
      variant
      parentTask {
        __typename
        id
      }
      assignments {
        ...TaskAssignmentFields
      }
      requesterDisallowedReason {
        edit
        changeStatus
      }
      comments {
        id
        author {
          ...UserBase
        }
        createdAt
        text
        updatedAt
        resolved
      }
    }
  }
  ... on SigningPhase {
    steps {
      ...WorkflowStepFragment
    }
  }
}
    ${ColumnBaseFragmentDoc}
${TaskAssignmentFieldsFragmentDoc}
${UserBaseFragmentDoc}
${WorkflowStepFragmentFragmentDoc}`;
export const PlaybookRuleCategorySimpleFragmentDoc = gql`
    fragment PlaybookRuleCategorySimple on PlaybookRuleCategory {
  __typename
  id
  name
  rank
  createdAt
  updatedAt
}
    `;
export const PlaybookSimpleFragmentDoc = gql`
    fragment PlaybookSimple on Playbook {
  id
  title
  description
  categories {
    ...PlaybookRuleCategorySimple
  }
  createdAt
  updatedAt
}
    ${PlaybookRuleCategorySimpleFragmentDoc}`;
export const PlaybookGenerationProgressFragmentDoc = gql`
    fragment PlaybookGenerationProgress on PlaybookGenerationJob {
  __typename
  id
  startedAt
  finishedAt
  failedReason
  failedAt
  generatedCategoryCount
  openCategory {
    __typename
    id
    name
  }
  playbook {
    ...PlaybookSimple
    ruleCount
  }
}
    ${PlaybookSimpleFragmentDoc}`;
export const PlaybookRulePositionSimpleFragmentDoc = gql`
    fragment PlaybookRulePositionSimple on PlaybookRulePosition {
  __typename
  id
  rank
  ruleText
  aiGuidance
}
    `;
export const PlaybookRuleSimpleFragmentDoc = gql`
    fragment PlaybookRuleSimple on PlaybookRule {
  __typename
  id
  title
  rank
  positions {
    ...PlaybookRulePositionSimple
  }
  createdAt
  updatedAt
}
    ${PlaybookRulePositionSimpleFragmentDoc}`;
export const PlaybookRuleJobPositionResultSimpleFragmentDoc = gql`
    fragment PlaybookRuleJobPositionResultSimple on PlaybookRuleJobPositionResult {
  __typename
  positionId
  rank
  ruleText
  aiGuidance
  explanation
  status
  finishedAt
  failedAt
  failedReason
}
    `;
export const PlaybookRuleJobSimpleFragmentDoc = gql`
    fragment PlaybookRuleJobSimple on PlaybookRuleJob {
  __typename
  id
  startedAt
  failedAt
  failedReason
  finishedAt
  proposals {
    __typename
    id
    positionId
    decisions
  }
  positionResults {
    ...PlaybookRuleJobPositionResultSimple
  }
  resolution {
    __typename
    kind
    positionId
    at
    by {
      ...UserBase
    }
  }
  createdAt
  updatedAt
}
    ${PlaybookRuleJobPositionResultSimpleFragmentDoc}
${UserBaseFragmentDoc}`;
export const PlaybookRuleProposalSimpleFragmentDoc = gql`
    fragment PlaybookRuleProposalSimple on PlaybookRuleProposal {
  __typename
  id
  positionId
  suggestions
  decisions
  createdAt
}
    `;
export const PlaybookRuleJobWithProposalsFragmentDoc = gql`
    fragment PlaybookRuleJobWithProposals on PlaybookRuleJob {
  ...PlaybookRuleJobSimple
  proposals {
    ...PlaybookRuleProposalSimple
  }
}
    ${PlaybookRuleJobSimpleFragmentDoc}
${PlaybookRuleProposalSimpleFragmentDoc}`;
export const PlaybookRuleWithJobFragmentDoc = gql`
    fragment PlaybookRuleWithJob on PlaybookRule {
  ...PlaybookRuleSimple
  ruleJob(documentId: $documentId) {
    ...PlaybookRuleJobWithProposals
  }
}
    ${PlaybookRuleSimpleFragmentDoc}
${PlaybookRuleJobWithProposalsFragmentDoc}`;
export const PlaybookRuleCategoryWithRuleJobsFragmentDoc = gql`
    fragment PlaybookRuleCategoryWithRuleJobs on PlaybookRuleCategory {
  ...PlaybookRuleCategorySimple
  rules {
    ...PlaybookRuleWithJob
  }
}
    ${PlaybookRuleCategorySimpleFragmentDoc}
${PlaybookRuleWithJobFragmentDoc}`;
export const PlaybookRuleCategoryWithRulesFragmentDoc = gql`
    fragment PlaybookRuleCategoryWithRules on PlaybookRuleCategory {
  ...PlaybookRuleCategorySimple
  rules {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleCategorySimpleFragmentDoc}
${PlaybookRuleSimpleFragmentDoc}`;
export const PlaybookWithCategoriesFragmentDoc = gql`
    """
The shape a mutation that removes a category returns. Deleting one removes its
rules too, so the whole playbook's category list comes back and Apollo
renormalizes it — selecting only the entity that changed would leave the rest of
the cache stale.
"""
fragment PlaybookWithCategories on Playbook {
  __typename
  id
  categories {
    ...PlaybookRuleCategoryWithRules
  }
}
    ${PlaybookRuleCategoryWithRulesFragmentDoc}`;
export const PlaybookListItemFragmentDoc = gql`
    fragment PlaybookListItem on Playbook {
  __typename
  id
  title
  createdAt
  ruleCount
  usedInDocumentCount
  createdBy {
    __typename
    id
    avatarColor
    displayName
  }
}
    `;
export const ReminderSimpleFragmentDoc = gql`
    fragment ReminderSimple on Reminder {
  id
  title
  description
  type
  dueDate
  completedAt
  reviewStatus
  aiRationale
  isAiGenerated
  notificationOffsets {
    amount
    unit
    position
    notifiedAt
  }
  aiReminderAutomation {
    id
    title
    report {
      id
      name
      columnOptions {
        ... on FileFieldColumn {
          __typename
          displayName
          field
        }
        ... on ExtractionReportColumn {
          __typename
          questionId
          dataType
          displayName
        }
      }
    }
  }
  assignees {
    ...UserBase
  }
  document {
    __typename
    id
    name
    variant
    latestVersion {
      ... on DocumentVersion {
        id
        __typename
      }
      ... on StaticFileVersion {
        id
        __typename
        fileLocation {
          mimetype
          __typename
        }
      }
    }
  }
  createdAt
  updatedAt
}
    ${UserBaseFragmentDoc}`;
export const ReminderMetaFragmentDoc = gql`
    fragment ReminderMeta on ReminderMeta {
  totalCount
  pendingReviewCount
}
    `;
export const ReportColumnOptionBaseFragmentDoc = gql`
    fragment ReportColumnOptionBase on ReportColumnOption {
  ... on FileFieldColumn {
    displayName
    field
    dataType
    isGroupable
  }
  ... on ExtractionReportColumn {
    questionId
    dataType
    displayName
    isGroupable
    question {
      __typename
      id
      mode
      questionText
      title
      options {
        ...QuestionOptionSimple
      }
    }
  }
}
    ${QuestionOptionSimpleFragmentDoc}`;
export const ReportBaseFragmentDoc = gql`
    fragment ReportBase on Report {
  __typename
  id
  createdAt
  updatedAt
  name
  state
  author {
    __typename
    id
    avatarColor
    displayName
    email
    firstName
    lastName
  }
}
    `;
export const ReportFullDataFragmentDoc = gql`
    fragment ReportFullData on Report {
  ...ReportBase
  rows {
    docs {
      __typename
      id
    }
  }
}
    ${ReportBaseFragmentDoc}`;
export const DocumentExtractionStatusFragmentDoc = gql`
    fragment DocumentExtractionStatus on Document {
  __typename
  id
  aiQuestionIdsQueueing
  questionJobs {
    __typename
    id
    answer
    reasoning
    lockedAt
    lockedBy {
      ...UserBase
    }
    startedAt
    finishedAt
    failedAt
    questionContentHashAtRun
    question {
      __typename
      id
      type
      mode
      contentHash
    }
    selectedOptions {
      __typename
      id
      color
      label
      order
    }
    fileVersion {
      ... on FileVersionInterface {
        __typename
        id
      }
    }
  }
}
    ${UserBaseFragmentDoc}`;
export const DocumentReportRowQuestionJobFragmentDoc = gql`
    fragment DocumentReportRowQuestionJob on ExtractionJob {
  id
  createdAt
  answer
  previousAnswer
  startedAt
  finishedAt
  failedAt
  failedReason
  lockedAt
  lockedBy {
    ...UserBase
  }
  questionContentHashAtRun
  reasoning
  locations {
    ...DocLocationSimple
  }
  fileVersion {
    ... on FileVersionInterface {
      __typename
      id
      fileContentChangedAt
    }
  }
  previousSelectedOptions {
    __typename
    id
    color
    label
    order
  }
  question {
    __typename
    id
    contentHash
    questionText
    type
    mode
    variant
  }
  review {
    __typename
    reviewAction
    reviewedAt
    reviewedBy {
      ...UserBase
    }
  }
  selectedOptions {
    __typename
    id
    color
    label
    order
  }
}
    ${UserBaseFragmentDoc}
${DocLocationSimpleFragmentDoc}`;
export const PartySimpleFragmentDoc = gql`
    fragment PartySimple on Party {
  __typename
  id
  description
  name
}
    `;
export const DocumentReportRowFragmentDoc = gql`
    fragment DocumentReportRow on Document {
  __typename
  id
  aiQuestionIdsQueueing
  createdAt
  deletedAt
  lastAccessedByRequesterAt
  name
  requesterFavorited
  requesterRole
  status
  signedAt
  updatedAt
  variant
  isCommunityTemplate
  isCertificate
  isSigned
  conversionStartedAt
  conversionFinishedAt
  conversionFailedAt
  coreAiPropertiesExtractionStartedAt
  coreAiPropertiesExtractionFinishedAt
  coreAiPropertiesExtractionFailedAt
  relationshipPropertiesExtractionHash
  relationshipMatchingStartedAt
  relationshipMatchingFinishedAt
  relationshipMatchingFailedReason
  latestVersion {
    ...FileVersionSimple
  }
  labels {
    ...LabelSimple
  }
  questionJobs {
    ...DocumentReportRowQuestionJob
  }
  owner {
    ...UserBase
  }
  parties {
    ...PartySimple
  }
  type {
    ...ContractTypeSimple
  }
  workflow {
    __typename
    id
    envelopeStatus
    isSignedOutsideAline
    wasSentForSig
  }
  workflowFileRole
}
    ${FileVersionSimpleFragmentDoc}
${LabelSimpleFragmentDoc}
${DocumentReportRowQuestionJobFragmentDoc}
${UserBaseFragmentDoc}
${PartySimpleFragmentDoc}
${ContractTypeSimpleFragmentDoc}`;
export const UpdateReportFragmentFragmentDoc = gql`
    fragment UpdateReportFragment on Report {
  __typename
  id
  name
  state
}
    `;
export const RepositoryViewFragmentDoc = gql`
    fragment RepositoryView on Report {
  __typename
  id
  name
  rows {
    docs {
      __typename
      id
    }
  }
}
    `;
export const TokenResponseFragmentDoc = gql`
    fragment TokenResponse on CSRFToken {
  token
  expiresAt
}
    `;
export const FileSimpleFragmentDoc = gql`
    fragment FileSimple on DocFile {
  __typename
  id
  filestackUrl
  mimetype
  name
  size
  createdAt
  deletedAt
  updatedAt
}
    `;
export const FilestackSecurityBaseFragmentDoc = gql`
    fragment FilestackSecurityBase on FilestackSecurity {
  __typename
  policy
  signature
}
    `;
export const FilestackUploadOptionsBaseFragmentDoc = gql`
    fragment FilestackUploadOptionsBase on FilestackUploadOptions {
  __typename
  bucket
  security {
    ...FilestackSecurityBase
  }
}
    ${FilestackSecurityBaseFragmentDoc}`;
export const FilestackDownloadOptionsBaseFragmentDoc = gql`
    fragment FilestackDownloadOptionsBase on FilestackDownloadOptions {
  __typename
  docFileId
  handle
  security {
    ...FilestackSecurityBase
  }
}
    ${FilestackSecurityBaseFragmentDoc}`;
export const DocFileSimpleFragmentDoc = gql`
    fragment DocFileSimple on DocFile {
  __typename
  id
  filestackUrl
  name
  mimetype
  updatedAt
  deletedAt
}
    `;
export const RelationshipCacheFieldsFragmentDoc = gql`
    fragment RelationshipCacheFields on DocumentRelationship {
  id
  parentDocumentId
  childDocumentId
  childRelationshipType
  source
  review {
    __typename
    outcome
    reviewedBy {
      id
      displayName
    }
  }
}
    `;
export const DocumentStatusJobFieldsFragmentDoc = gql`
    fragment DocumentStatusJobFields on DocumentStatusJob {
  __typename
  id
  status
  numQueued
  batches {
    __typename
    index
    state
    numQueued
    numProcessed
    numSuccess
    numFailed
    numNotRun
    skipCounts {
      reason
      count
    }
  }
}
    `;
export const DocumentMetadataFragmentDoc = gql`
    fragment DocumentMetadata on Document {
  __typename
  id
  description
  forwardingPermissionRole
  requesterFavorited
  name
  status
  requesterRole
  storableType
  variant
  isCommunityTemplate
  isCertificate
  isSigned
  isSavePending
  owner {
    ...UserBase
  }
  ownerId
  workflow {
    __typename
    id
    state
    envelopeStatus
  }
  updatedAt
  deletedAt
}
    ${UserBaseFragmentDoc}`;
export const CommentFieldsFragmentDoc = gql`
    fragment CommentFields on Comment {
  __typename
  id
  nodeRefId
  importedAuthorName
  isPrivate
  resolved
  text
  commentableType
  author {
    ...UserBase
  }
  createdAt
  updatedAt
}
    ${UserBaseFragmentDoc}`;
export const CommentFieldsBaseFragmentDoc = gql`
    fragment CommentFieldsBase on Comment {
  ...CommentFields
  parent {
    ...CommentFields
  }
  replies {
    ...CommentFields
    parent {
      ...CommentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;
export const DocumentVariableFullFragmentDoc = gql`
    fragment DocumentVariableFull on DocumentVariable {
  __typename
  id
  deletedAt
  label
  isField
  addToLaunchForm
  nodeId
  prefix
  question
  minRequired
  maxRequired
  variant
  value
  skipped
  action {
    ...WorkflowRecipientSimple
  }
  answerOptions {
    ...AnswerOptionsBase
  }
  action {
    ...WorkflowRecipientSimple
  }
  config {
    __typename
    id
    label
    question
  }
  defaultAnswer {
    ...AnswerOptionBase
  }
  selectedAnswer {
    ...AnswerOptionBase
  }
  selectedAnswers {
    ...AnswerOptionBase
  }
  integrationLink {
    attributePath
    integration
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}
${AnswerOptionsBaseFragmentDoc}
${AnswerOptionBaseFragmentDoc}`;
export const DocumentFieldsBaseFragmentDoc = gql`
    fragment DocumentFieldsBase on Document {
  ...DocumentMetadata
  ownerId
  requesterRole
  comments {
    ...CommentFieldsBase
  }
  latestVersion {
    ...FileVersionSimple
  }
  signatureFields {
    ...SignatureFieldSimple
  }
  variables {
    ...DocumentVariableFull
  }
  workflow {
    __typename
    id
    state
    envelopeStatus
  }
}
    ${DocumentMetadataFragmentDoc}
${CommentFieldsBaseFragmentDoc}
${FileVersionSimpleFragmentDoc}
${SignatureFieldSimpleFragmentDoc}
${DocumentVariableFullFragmentDoc}`;
export const DocumentFileDetailsRelatedDocumentFragmentDoc = gql`
    "Document row nested under a relationship in GetDocumentFileDetails (parent or child side)."
fragment DocumentFileDetailsRelatedDocument on Document {
  __typename
  id
  name
  variant
  latestVersion {
    ... on FileVersionInterface {
      __typename
      id
    }
    ... on StaticFileVersion {
      fileLocation {
        mimetype
      }
    }
  }
}
    `;
export const DocumentFileDetailsRelationshipFragmentDoc = gql`
    fragment DocumentFileDetailsRelationship on DocumentRelationship {
  id
  parentDocumentId
  childDocumentId
  childType
  childUrl
  childRelationshipType
  source
  llmReasonsMarkdown
  expectedDocumentName
  expectedDocumentAgreementDate
  sourceAgreementName
  review {
    __typename
    outcome
    reviewedBy {
      id
      displayName
    }
  }
  childDocument {
    ...DocumentFileDetailsRelatedDocument
  }
  parentDocument {
    ...DocumentFileDetailsRelatedDocument
  }
  createdAt
}
    ${DocumentFileDetailsRelatedDocumentFragmentDoc}`;
export const DocumentFileDetailsUrlRelationshipFragmentDoc = gql`
    fragment DocumentFileDetailsUrlRelationship on DocumentRelationship {
  id
  parentDocumentId
  childUrl
  childType
  childRelationshipType
  source
  review {
    __typename
    outcome
    reviewedBy {
      id
      displayName
    }
  }
  llmReasonsMarkdown
  reason
  citations
  createdAt
}
    `;
export const PermissionSimpleFragmentDoc = gql`
    fragment PermissionSimple on StorablePermission {
  __typename
  id
  accountType
  origin
  role
  storableType
  account {
    ...AccountBase
  }
  createdAt
  updatedAt
}
    ${AccountBaseFragmentDoc}`;
export const PermissionWithStorableFragmentDoc = gql`
    fragment PermissionWithStorable on StorablePermission {
  ...PermissionSimple
  storable {
    ... on StorableInterface {
      __typename
      id
      name
      requesterRole
      requesterFavorited
      storableType
      owner {
        ...UserBase
      }
      ... on Document {
        variant
        latestVersion {
          ...FileVersionSimple
        }
        workflow {
          __typename
          id
          status
          state
        }
      }
      createdAt
      updatedAt
    }
  }
}
    ${PermissionSimpleFragmentDoc}
${UserBaseFragmentDoc}
${FileVersionSimpleFragmentDoc}`;
export const MoveStorableFieldsFragmentDoc = gql`
    fragment MoveStorableFields on StorableInterface {
  __typename
  id
  name
  owner {
    ...UserBase
  }
  ownerId
  requesterFavorited
  requesterRole
  storableType
  ... on Document {
    variant
  }
  updatedAt
  deletedAt
}
    ${UserBaseFragmentDoc}`;
export const StorableFieldsFragmentDoc = gql`
    fragment StorableFields on StorableInterface {
  __typename
  id
  requesterFavorited
  name
  owner {
    ...UserBase
  }
  ownerId
  requesterRole
  storableType
  ... on Document {
    variant
    workflow {
      __typename
      id
    }
  }
  updatedAt
  deletedAt
}
    ${UserBaseFragmentDoc}`;
export const StorableSimpleFragmentDoc = gql`
    fragment StorableSimple on StorableInterface {
  __typename
  id
  name
  storableType
  requesterFavorited
  requesterRole
  createdAt
  updatedAt
  owner {
    ...UserBase
  }
  ... on Document {
    variant
  }
}
    ${UserBaseFragmentDoc}`;
export const TaskFieldSimpleFragmentDoc = gql`
    fragment TaskFieldSimple on TaskField {
  __typename
  id
  label
  type
  isRequired
  order
  config
  response
  completedAt
  completedBy {
    id
  }
  createdAt
  updatedAt
  task {
    __typename
    id
  }
}
    `;
export const VersionTaskUploadFragmentDoc = gql`
    fragment VersionTaskUpload on TaskUpload {
  __typename
  id
  createdAt
  task {
    __typename
    id
    title
  }
  uploadedBy {
    ...MinimalUser
  }
}
    ${MinimalUserFragmentDoc}`;
export const TaskViewerActionFieldsFragmentDoc = gql`
    fragment TaskViewerActionFields on Task {
  __typename
  id
  viewerActionRecipients {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;
export const TaskUnsubmittedReviewFieldsFragmentDoc = gql`
    fragment TaskUnsubmittedReviewFields on Task {
  __typename
  id
  viewerUnsubmittedReview {
    __typename
    commentCount
    trackedChangeCount
  }
}
    `;
export const CannedFieldFullFragmentDoc = gql`
    fragment CannedFieldFull on CannedField {
  __typename
  id
  nodeId
  variant
  workflowId
  value
  defaultValue
  assigneeId
  assignee {
    __typename
    id
    type
    status
    recipientName
    assignee {
      __typename
      id
      displayName
      avatarColor
      accountType
      email
      firstName
      lastName
    }
    assigneeRole {
      __typename
      id
      roleName
    }
    permission {
      __typename
      id
      isLauncher
    }
  }
  placements {
    __typename
    id
    cannedFieldId
    documentId
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const VariableConfigSimpleFragmentDoc = gql`
    fragment VariableConfigSimple on DocumentVariableConfig {
  __typename
  id
  label
  notes
  numTimesUsed
  prefix
  question
  variant
  owner {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;
export const VariableConfigFullFragmentDoc = gql`
    fragment VariableConfigFull on DocumentVariableConfig {
  __typename
  id
  label
  notes
  prefix
  question
  variant
  owner {
    ...UserBase
  }
  answerOptions {
    ...AnswerOptionsBase
  }
  defaultAnswer {
    ...AnswerOptionBase
  }
}
    ${UserBaseFragmentDoc}
${AnswerOptionsBaseFragmentDoc}
${AnswerOptionBaseFragmentDoc}`;
export const TaskActionSimpleFragmentDoc = gql`
    fragment TaskActionSimple on Task {
  __typename
  id
  completedAt
  description
  firstSentAt
  lastSentAt
  createdAt
  title
  startedAt
  variant
  author {
    ...UserBase
  }
  comments {
    ...CommentSimple
  }
  completedBy {
    ...UserBase
  }
  assignments {
    ...TaskAssignmentFields
  }
  requesterDisallowedReason {
    ...DisallowedTaskReasonsSimple
  }
}
    ${UserBaseFragmentDoc}
${CommentSimpleFragmentDoc}
${TaskAssignmentFieldsFragmentDoc}
${DisallowedTaskReasonsSimpleFragmentDoc}`;
export const RequesterWorkflowRecipientFragmentDoc = gql`
    fragment RequesterWorkflowRecipient on WorkflowRecipient {
  __typename
  id
  completedAt
  fields {
    ... on DocumentVariable {
      ...DocumentVariableSimple
      document {
        __typename
        id
        createdAt
      }
    }
    ... on SignatureField {
      ...SignatureFieldSimple
      document {
        __typename
        id
        createdAt
      }
    }
  }
}
    ${DocumentVariableSimpleFragmentDoc}
${SignatureFieldSimpleFragmentDoc}`;
export const DocumentSimpleFragmentDoc = gql`
    fragment DocumentSimple on Document {
  __typename
  id
  name
  storableType
  status
  variant
  requesterFavorited
  requesterRole
  isCertificate
  isCommunityTemplate
  latestVersion {
    ...FileVersionSimple
  }
  owner {
    ...UserBase
  }
  workflow {
    __typename
    id
    state
    envelopeStatus
  }
  type {
    ...ContractTypeSimple
  }
  createdAt
  updatedAt
  deletedAt
}
    ${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}
${ContractTypeSimpleFragmentDoc}`;
export const DocumentWithFieldsFragmentDoc = gql`
    fragment DocumentWithFields on Document {
  ...DocumentSimple
  signatureFields {
    ...SignatureFieldSimple
  }
  variables {
    ...DocumentVariableFull
  }
}
    ${DocumentSimpleFragmentDoc}
${SignatureFieldSimpleFragmentDoc}
${DocumentVariableFullFragmentDoc}`;
export const WorkflowFileWithFieldsFragmentDoc = gql`
    fragment WorkflowFileWithFields on WorkflowFile {
  __typename
  id
  documentRole
  isInternal
  orderId
  document {
    ...DocumentWithFields
  }
  createdAt
  updatedAt
}
    ${DocumentWithFieldsFragmentDoc}`;
export const LaunchConfigSimpleFragmentDoc = gql`
    fragment LaunchConfigSimple on WorkflowLaunchConfig {
  id
  enabled
  workflowTitle
  isAutomaticS4SEnabled
  launchedWorkflowOwner {
    ...UserBase
  }
  placeholders {
    ...WorkflowPermissionSimple
  }
  launchForm {
    alineFields {
      fieldId
      label
      question
      order
      picklistOptions {
        label
        value
      }
      required
      type
      usedInDocuments
    }
    documentsList {
      documentId
      name
    }
    intakeForm {
      defaultValues
      formDefinition
      title
    }
  }
}
    ${UserBaseFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}`;
export const WorkflowPermissionWithActionsFragmentDoc = gql`
    fragment WorkflowPermissionWithActions on WorkflowPermission {
  ...WorkflowPermissionSimple
  actions {
    ... on WorkflowRecipient {
      __typename
      id
      type
    }
    ... on Task {
      __typename
      id
    }
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;
export const WorkflowSigningPhaseStepsSummaryFragmentDoc = gql`
    fragment WorkflowSigningPhaseStepsSummary on Workflow {
  phases {
    __typename
    id
    ... on SigningPhase {
      steps {
        __typename
        id
        isCompleted
        completedAt
        startedAt
      }
    }
  }
}
    `;
export const WorkflowInboxWorkflowFragmentDoc = gql`
    fragment WorkflowInboxWorkflow on Workflow {
  __typename
  id
  aiCancelledAt
  aiFailedAt
  aiFailureReason
  aiFinishedAt
  aiStartedAt
  createdAt
  startedAt
  completedAt
  isSignedOutsideAline
  name
  publishedAt
  status
  state
  variant
  missingActions
  activeStep {
    __typename
    id
    createdAt
    startedAt
    completedAt
    actions {
      __typename
      id
      createdAt
      completedAt
      firstSentAt
      lastSentAt
      type
      assignee {
        ...UserBase
      }
      assigneeRole {
        ...UserDefinedRoleSimple
      }
    }
  }
  files {
    __typename
    id
    orderId
    document {
      __typename
      id
      createdAt
      name
      variant
      comments {
        ...CommentSimple
      }
      latestVersion {
        ... on FileVersionInterface {
          __typename
          id
        }
        ... on DocumentVersion {
          documentJSON
        }
        ... on StaticFileVersion {
          fileLocation {
            __typename
            mimetype
          }
        }
      }
    }
  }
  owner {
    ...UserBase
  }
  parties {
    ...PartySimple
  }
  permissions {
    ...WorkflowPermissionSimple
  }
  phases {
    __typename
    id
    order
  }
  tasks {
    ...TaskSimple
  }
  unusedActions {
    ...WorkflowRecipientSimple
  }
}
    ${UserBaseFragmentDoc}
${UserDefinedRoleSimpleFragmentDoc}
${CommentSimpleFragmentDoc}
${PartySimpleFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}
${TaskSimpleFragmentDoc}
${WorkflowRecipientSimpleFragmentDoc}`;
export const WorkBlockerWorkflowRecipientFragmentDoc = gql`
    fragment WorkBlockerWorkflowRecipient on WorkflowRecipient {
  __typename
  id
  completedAt
  assignee {
    ...UserBase
  }
  assigneeRole {
    ...UserDefinedRoleSimple
  }
}
    ${UserBaseFragmentDoc}
${UserDefinedRoleSimpleFragmentDoc}`;
export const WorkflowStepAllPropsFragmentFragmentDoc = gql`
    fragment WorkflowStepAllPropsFragment on WorkflowStep {
  __typename
  id
  startedAt
  isCompleted
  completedAt
  actions {
    ...WorkflowRecipientWithFields
  }
}
    ${WorkflowRecipientWithFieldsFragmentDoc}`;
export const WorkflowSigningPhaseStepsAllPropsFragmentDoc = gql`
    fragment WorkflowSigningPhaseStepsAllProps on Workflow {
  phases {
    __typename
    ... on SigningPhase {
      steps {
        ...WorkflowStepAllPropsFragment
      }
    }
  }
}
    ${WorkflowStepAllPropsFragmentFragmentDoc}`;
export const GetDocumentNameDocument = gql`
    query GetDocumentName($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
  }
}
    `;

/**
 * __useGetDocumentNameQuery__
 *
 * To run a query within a React component, call `useGetDocumentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentNameQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentNameQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentNameQuery, GetDocumentNameQueryVariables> & ({ variables: GetDocumentNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentNameQuery, GetDocumentNameQueryVariables>(GetDocumentNameDocument, options);
      }
export function useGetDocumentNameLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentNameQuery, GetDocumentNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentNameQuery, GetDocumentNameQueryVariables>(GetDocumentNameDocument, options);
        }
export function useGetDocumentNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentNameQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentNameQuery, GetDocumentNameQueryVariables>(GetDocumentNameDocument, options);
        }
export type GetDocumentNameQueryHookResult = ReturnType<typeof useGetDocumentNameQuery>;
export type GetDocumentNameLazyQueryHookResult = ReturnType<typeof useGetDocumentNameLazyQuery>;
export type GetDocumentNameSuspenseQueryHookResult = ReturnType<typeof useGetDocumentNameSuspenseQuery>;
export type GetDocumentNameQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentNameQuery, GetDocumentNameQueryVariables>;
export const UpdateGroupGlobalAccessDocument = gql`
    mutation UpdateGroupGlobalAccess($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    __typename
    id
    canAccessAllDocAndWorkflows
  }
}
    `;
export type UpdateGroupGlobalAccessMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateGroupGlobalAccessMutation, UpdateGroupGlobalAccessMutationVariables>;

/**
 * __useUpdateGroupGlobalAccessMutation__
 *
 * To run a mutation, you first call `useUpdateGroupGlobalAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupGlobalAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupGlobalAccessMutation, { data, loading, error }] = useUpdateGroupGlobalAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupGlobalAccessMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateGroupGlobalAccessMutation, UpdateGroupGlobalAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGroupGlobalAccessMutation, UpdateGroupGlobalAccessMutationVariables>(UpdateGroupGlobalAccessDocument, options);
      }
export type UpdateGroupGlobalAccessMutationHookResult = ReturnType<typeof useUpdateGroupGlobalAccessMutation>;
export type UpdateGroupGlobalAccessMutationResult = ApolloReactHooks.useMutation.Result<UpdateGroupGlobalAccessMutation>;
export type UpdateGroupGlobalAccessMutationOptions = ApolloReactHooks.useMutation.Options<UpdateGroupGlobalAccessMutation, UpdateGroupGlobalAccessMutationVariables>;
export const GetChatDocumentDocument = gql`
    query GetChatDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    latestVersion {
      ... on DocumentVersion {
        __typename
        id
      }
      ... on StaticFileVersion {
        __typename
        id
        fileLocation {
          __typename
          mimetype
        }
      }
    }
  }
}
    `;

/**
 * __useGetChatDocumentQuery__
 *
 * To run a query within a React component, call `useGetChatDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetChatDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetChatDocumentQuery, GetChatDocumentQueryVariables> & ({ variables: GetChatDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChatDocumentQuery, GetChatDocumentQueryVariables>(GetChatDocumentDocument, options);
      }
export function useGetChatDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetChatDocumentQuery, GetChatDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChatDocumentQuery, GetChatDocumentQueryVariables>(GetChatDocumentDocument, options);
        }
export function useGetChatDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetChatDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetChatDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetChatDocumentQuery, GetChatDocumentQueryVariables>(GetChatDocumentDocument, options);
        }
export type GetChatDocumentQueryHookResult = ReturnType<typeof useGetChatDocumentQuery>;
export type GetChatDocumentLazyQueryHookResult = ReturnType<typeof useGetChatDocumentLazyQuery>;
export type GetChatDocumentSuspenseQueryHookResult = ReturnType<typeof useGetChatDocumentSuspenseQuery>;
export type GetChatDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetChatDocumentQuery, GetChatDocumentQueryVariables>;
export const GetThreadTitleDocument = gql`
    query GetThreadTitle($id: UUID!) {
  agentThread(id: $id) {
    __typename
    id
    title
  }
}
    `;

/**
 * __useGetThreadTitleQuery__
 *
 * To run a query within a React component, call `useGetThreadTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadTitleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetThreadTitleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetThreadTitleQuery, GetThreadTitleQueryVariables> & ({ variables: GetThreadTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetThreadTitleQuery, GetThreadTitleQueryVariables>(GetThreadTitleDocument, options);
      }
export function useGetThreadTitleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetThreadTitleQuery, GetThreadTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetThreadTitleQuery, GetThreadTitleQueryVariables>(GetThreadTitleDocument, options);
        }
export function useGetThreadTitleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetThreadTitleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetThreadTitleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetThreadTitleQuery, GetThreadTitleQueryVariables>(GetThreadTitleDocument, options);
        }
export type GetThreadTitleQueryHookResult = ReturnType<typeof useGetThreadTitleQuery>;
export type GetThreadTitleLazyQueryHookResult = ReturnType<typeof useGetThreadTitleLazyQuery>;
export type GetThreadTitleSuspenseQueryHookResult = ReturnType<typeof useGetThreadTitleSuspenseQuery>;
export type GetThreadTitleQueryResult = ApolloReactHooks.useQuery.Result<GetThreadTitleQuery, GetThreadTitleQueryVariables>;
export const GetSuggestionDocumentDocument = gql`
    query GetSuggestionDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
  }
}
    `;

/**
 * __useGetSuggestionDocumentQuery__
 *
 * To run a query within a React component, call `useGetSuggestionDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetSuggestionDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetSuggestionDocumentQuery, GetSuggestionDocumentQueryVariables> & ({ variables: GetSuggestionDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSuggestionDocumentQuery, GetSuggestionDocumentQueryVariables>(GetSuggestionDocumentDocument, options);
      }
export function useGetSuggestionDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetSuggestionDocumentQuery, GetSuggestionDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSuggestionDocumentQuery, GetSuggestionDocumentQueryVariables>(GetSuggestionDocumentDocument, options);
        }
export function useGetSuggestionDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetSuggestionDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetSuggestionDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetSuggestionDocumentQuery, GetSuggestionDocumentQueryVariables>(GetSuggestionDocumentDocument, options);
        }
export type GetSuggestionDocumentQueryHookResult = ReturnType<typeof useGetSuggestionDocumentQuery>;
export type GetSuggestionDocumentLazyQueryHookResult = ReturnType<typeof useGetSuggestionDocumentLazyQuery>;
export type GetSuggestionDocumentSuspenseQueryHookResult = ReturnType<typeof useGetSuggestionDocumentSuspenseQuery>;
export type GetSuggestionDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetSuggestionDocumentQuery, GetSuggestionDocumentQueryVariables>;
export const GetWorkflowWithCategoriesDocument = gql`
    query GetWorkflowWithCategories($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    description
    name
    communityCategories {
      __typename
      id
      description
      emoji
      title
    }
    owner {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetWorkflowWithCategoriesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowWithCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowWithCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowWithCategoriesQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowWithCategoriesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowWithCategoriesQuery, GetWorkflowWithCategoriesQueryVariables> & ({ variables: GetWorkflowWithCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowWithCategoriesQuery, GetWorkflowWithCategoriesQueryVariables>(GetWorkflowWithCategoriesDocument, options);
      }
export function useGetWorkflowWithCategoriesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowWithCategoriesQuery, GetWorkflowWithCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowWithCategoriesQuery, GetWorkflowWithCategoriesQueryVariables>(GetWorkflowWithCategoriesDocument, options);
        }
export function useGetWorkflowWithCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithCategoriesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowWithCategoriesQuery, GetWorkflowWithCategoriesQueryVariables>(GetWorkflowWithCategoriesDocument, options);
        }
export type GetWorkflowWithCategoriesQueryHookResult = ReturnType<typeof useGetWorkflowWithCategoriesQuery>;
export type GetWorkflowWithCategoriesLazyQueryHookResult = ReturnType<typeof useGetWorkflowWithCategoriesLazyQuery>;
export type GetWorkflowWithCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowWithCategoriesSuspenseQuery>;
export type GetWorkflowWithCategoriesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowWithCategoriesQuery, GetWorkflowWithCategoriesQueryVariables>;
export const UpdateDocumentForwardingDocument = gql`
    mutation UpdateDocumentForwarding($input: UpdateDocumentInput!) {
  updateDocumentProps(input: $input) {
    document {
      __typename
      id
      forwardingPermissionRole
    }
  }
}
    `;
export type UpdateDocumentForwardingMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateDocumentForwardingMutation, UpdateDocumentForwardingMutationVariables>;

/**
 * __useUpdateDocumentForwardingMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentForwardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentForwardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentForwardingMutation, { data, loading, error }] = useUpdateDocumentForwardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentForwardingMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateDocumentForwardingMutation, UpdateDocumentForwardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentForwardingMutation, UpdateDocumentForwardingMutationVariables>(UpdateDocumentForwardingDocument, options);
      }
export type UpdateDocumentForwardingMutationHookResult = ReturnType<typeof useUpdateDocumentForwardingMutation>;
export type UpdateDocumentForwardingMutationResult = ApolloReactHooks.useMutation.Result<UpdateDocumentForwardingMutation>;
export type UpdateDocumentForwardingMutationOptions = ApolloReactHooks.useMutation.Options<UpdateDocumentForwardingMutation, UpdateDocumentForwardingMutationVariables>;
export const GetWorkflowMessageDocument = gql`
    query GetWorkflowMessage($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    envelopeMsg
  }
}
    `;

/**
 * __useGetWorkflowMessageQuery__
 *
 * To run a query within a React component, call `useGetWorkflowMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowMessageQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowMessageQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowMessageQuery, GetWorkflowMessageQueryVariables> & ({ variables: GetWorkflowMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowMessageQuery, GetWorkflowMessageQueryVariables>(GetWorkflowMessageDocument, options);
      }
export function useGetWorkflowMessageLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowMessageQuery, GetWorkflowMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowMessageQuery, GetWorkflowMessageQueryVariables>(GetWorkflowMessageDocument, options);
        }
export function useGetWorkflowMessageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowMessageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowMessageQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowMessageQuery, GetWorkflowMessageQueryVariables>(GetWorkflowMessageDocument, options);
        }
export type GetWorkflowMessageQueryHookResult = ReturnType<typeof useGetWorkflowMessageQuery>;
export type GetWorkflowMessageLazyQueryHookResult = ReturnType<typeof useGetWorkflowMessageLazyQuery>;
export type GetWorkflowMessageSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowMessageSuspenseQuery>;
export type GetWorkflowMessageQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowMessageQuery, GetWorkflowMessageQueryVariables>;
export const UpdateReminderTitleDocument = gql`
    mutation UpdateReminderTitle($input: UpdateReminderInput!) {
  updateReminder(input: $input) {
    id
    title
  }
}
    `;
export type UpdateReminderTitleMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateReminderTitleMutation, UpdateReminderTitleMutationVariables>;

/**
 * __useUpdateReminderTitleMutation__
 *
 * To run a mutation, you first call `useUpdateReminderTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderTitleMutation, { data, loading, error }] = useUpdateReminderTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReminderTitleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateReminderTitleMutation, UpdateReminderTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReminderTitleMutation, UpdateReminderTitleMutationVariables>(UpdateReminderTitleDocument, options);
      }
export type UpdateReminderTitleMutationHookResult = ReturnType<typeof useUpdateReminderTitleMutation>;
export type UpdateReminderTitleMutationResult = ApolloReactHooks.useMutation.Result<UpdateReminderTitleMutation>;
export type UpdateReminderTitleMutationOptions = ApolloReactHooks.useMutation.Options<UpdateReminderTitleMutation, UpdateReminderTitleMutationVariables>;
export const UpdateReminderDescriptionDocument = gql`
    mutation UpdateReminderDescription($input: UpdateReminderInput!) {
  updateReminder(input: $input) {
    id
    description
  }
}
    `;
export type UpdateReminderDescriptionMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateReminderDescriptionMutation, UpdateReminderDescriptionMutationVariables>;

/**
 * __useUpdateReminderDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateReminderDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderDescriptionMutation, { data, loading, error }] = useUpdateReminderDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReminderDescriptionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateReminderDescriptionMutation, UpdateReminderDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReminderDescriptionMutation, UpdateReminderDescriptionMutationVariables>(UpdateReminderDescriptionDocument, options);
      }
export type UpdateReminderDescriptionMutationHookResult = ReturnType<typeof useUpdateReminderDescriptionMutation>;
export type UpdateReminderDescriptionMutationResult = ApolloReactHooks.useMutation.Result<UpdateReminderDescriptionMutation>;
export type UpdateReminderDescriptionMutationOptions = ApolloReactHooks.useMutation.Options<UpdateReminderDescriptionMutation, UpdateReminderDescriptionMutationVariables>;
export const UpdateReminderDueDateDocument = gql`
    mutation UpdateReminderDueDate($input: UpdateReminderInput!) {
  updateReminder(input: $input) {
    id
    dueDate
  }
}
    `;
export type UpdateReminderDueDateMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateReminderDueDateMutation, UpdateReminderDueDateMutationVariables>;

/**
 * __useUpdateReminderDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateReminderDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderDueDateMutation, { data, loading, error }] = useUpdateReminderDueDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReminderDueDateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateReminderDueDateMutation, UpdateReminderDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReminderDueDateMutation, UpdateReminderDueDateMutationVariables>(UpdateReminderDueDateDocument, options);
      }
export type UpdateReminderDueDateMutationHookResult = ReturnType<typeof useUpdateReminderDueDateMutation>;
export type UpdateReminderDueDateMutationResult = ApolloReactHooks.useMutation.Result<UpdateReminderDueDateMutation>;
export type UpdateReminderDueDateMutationOptions = ApolloReactHooks.useMutation.Options<UpdateReminderDueDateMutation, UpdateReminderDueDateMutationVariables>;
export const UpdateReminderTypeDocument = gql`
    mutation UpdateReminderType($input: UpdateReminderInput!) {
  updateReminder(input: $input) {
    id
    type
  }
}
    `;
export type UpdateReminderTypeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateReminderTypeMutation, UpdateReminderTypeMutationVariables>;

/**
 * __useUpdateReminderTypeMutation__
 *
 * To run a mutation, you first call `useUpdateReminderTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderTypeMutation, { data, loading, error }] = useUpdateReminderTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReminderTypeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateReminderTypeMutation, UpdateReminderTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReminderTypeMutation, UpdateReminderTypeMutationVariables>(UpdateReminderTypeDocument, options);
      }
export type UpdateReminderTypeMutationHookResult = ReturnType<typeof useUpdateReminderTypeMutation>;
export type UpdateReminderTypeMutationResult = ApolloReactHooks.useMutation.Result<UpdateReminderTypeMutation>;
export type UpdateReminderTypeMutationOptions = ApolloReactHooks.useMutation.Options<UpdateReminderTypeMutation, UpdateReminderTypeMutationVariables>;
export const UpdateReminderNotificationOffsetsDocument = gql`
    mutation UpdateReminderNotificationOffsets($input: UpdateReminderInput!) {
  updateReminder(input: $input) {
    id
    notificationOffsets {
      amount
      unit
      position
      notifiedAt
    }
  }
}
    `;
export type UpdateReminderNotificationOffsetsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateReminderNotificationOffsetsMutation, UpdateReminderNotificationOffsetsMutationVariables>;

/**
 * __useUpdateReminderNotificationOffsetsMutation__
 *
 * To run a mutation, you first call `useUpdateReminderNotificationOffsetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderNotificationOffsetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderNotificationOffsetsMutation, { data, loading, error }] = useUpdateReminderNotificationOffsetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReminderNotificationOffsetsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateReminderNotificationOffsetsMutation, UpdateReminderNotificationOffsetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReminderNotificationOffsetsMutation, UpdateReminderNotificationOffsetsMutationVariables>(UpdateReminderNotificationOffsetsDocument, options);
      }
export type UpdateReminderNotificationOffsetsMutationHookResult = ReturnType<typeof useUpdateReminderNotificationOffsetsMutation>;
export type UpdateReminderNotificationOffsetsMutationResult = ApolloReactHooks.useMutation.Result<UpdateReminderNotificationOffsetsMutation>;
export type UpdateReminderNotificationOffsetsMutationOptions = ApolloReactHooks.useMutation.Options<UpdateReminderNotificationOffsetsMutation, UpdateReminderNotificationOffsetsMutationVariables>;
export const GetReportToRestoreDocument = gql`
    query GetReportToRestore($reportId: UUID!) {
  report(reportId: $reportId) {
    __typename
    id
    name
    state
    columnOptions {
      ... on FileFieldColumn {
        displayName
        field
        dataType
        isGroupable
      }
      ... on ExtractionReportColumn {
        questionId
        dataType
        displayName
        isGroupable
      }
    }
  }
}
    `;

/**
 * __useGetReportToRestoreQuery__
 *
 * To run a query within a React component, call `useGetReportToRestoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportToRestoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportToRestoreQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetReportToRestoreQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetReportToRestoreQuery, GetReportToRestoreQueryVariables> & ({ variables: GetReportToRestoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportToRestoreQuery, GetReportToRestoreQueryVariables>(GetReportToRestoreDocument, options);
      }
export function useGetReportToRestoreLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportToRestoreQuery, GetReportToRestoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportToRestoreQuery, GetReportToRestoreQueryVariables>(GetReportToRestoreDocument, options);
        }
export function useGetReportToRestoreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportToRestoreQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportToRestoreQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportToRestoreQuery, GetReportToRestoreQueryVariables>(GetReportToRestoreDocument, options);
        }
export type GetReportToRestoreQueryHookResult = ReturnType<typeof useGetReportToRestoreQuery>;
export type GetReportToRestoreLazyQueryHookResult = ReturnType<typeof useGetReportToRestoreLazyQuery>;
export type GetReportToRestoreSuspenseQueryHookResult = ReturnType<typeof useGetReportToRestoreSuspenseQuery>;
export type GetReportToRestoreQueryResult = ApolloReactHooks.useQuery.Result<GetReportToRestoreQuery, GetReportToRestoreQueryVariables>;
export const UpdateQuestionTypeDocument = gql`
    mutation UpdateQuestionType($input: UpdateExtractionQuestionInput!) {
  updateExtractionQuestion(input: $input) {
    __typename
    id
    contentHash
    type
  }
}
    `;
export type UpdateQuestionTypeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateQuestionTypeMutation, UpdateQuestionTypeMutationVariables>;

/**
 * __useUpdateQuestionTypeMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionTypeMutation, { data, loading, error }] = useUpdateQuestionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionTypeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateQuestionTypeMutation, UpdateQuestionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateQuestionTypeMutation, UpdateQuestionTypeMutationVariables>(UpdateQuestionTypeDocument, options);
      }
export type UpdateQuestionTypeMutationHookResult = ReturnType<typeof useUpdateQuestionTypeMutation>;
export type UpdateQuestionTypeMutationResult = ApolloReactHooks.useMutation.Result<UpdateQuestionTypeMutation>;
export type UpdateQuestionTypeMutationOptions = ApolloReactHooks.useMutation.Options<UpdateQuestionTypeMutation, UpdateQuestionTypeMutationVariables>;
export const UpdateQuestionModeDocument = gql`
    mutation UpdateQuestionMode($input: UpdateExtractionQuestionInput!) {
  updateExtractionQuestion(input: $input) {
    __typename
    id
    mode
  }
}
    `;
export type UpdateQuestionModeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateQuestionModeMutation, UpdateQuestionModeMutationVariables>;

/**
 * __useUpdateQuestionModeMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionModeMutation, { data, loading, error }] = useUpdateQuestionModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionModeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateQuestionModeMutation, UpdateQuestionModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateQuestionModeMutation, UpdateQuestionModeMutationVariables>(UpdateQuestionModeDocument, options);
      }
export type UpdateQuestionModeMutationHookResult = ReturnType<typeof useUpdateQuestionModeMutation>;
export type UpdateQuestionModeMutationResult = ApolloReactHooks.useMutation.Result<UpdateQuestionModeMutation>;
export type UpdateQuestionModeMutationOptions = ApolloReactHooks.useMutation.Options<UpdateQuestionModeMutation, UpdateQuestionModeMutationVariables>;
export const GetReportNameDocument = gql`
    query GetReportName($reportId: UUID!) {
  report(reportId: $reportId) {
    __typename
    id
    name
  }
}
    `;

/**
 * __useGetReportNameQuery__
 *
 * To run a query within a React component, call `useGetReportNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportNameQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetReportNameQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetReportNameQuery, GetReportNameQueryVariables> & ({ variables: GetReportNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportNameQuery, GetReportNameQueryVariables>(GetReportNameDocument, options);
      }
export function useGetReportNameLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportNameQuery, GetReportNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportNameQuery, GetReportNameQueryVariables>(GetReportNameDocument, options);
        }
export function useGetReportNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportNameQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportNameQuery, GetReportNameQueryVariables>(GetReportNameDocument, options);
        }
export type GetReportNameQueryHookResult = ReturnType<typeof useGetReportNameQuery>;
export type GetReportNameLazyQueryHookResult = ReturnType<typeof useGetReportNameLazyQuery>;
export type GetReportNameSuspenseQueryHookResult = ReturnType<typeof useGetReportNameSuspenseQuery>;
export type GetReportNameQueryResult = ApolloReactHooks.useQuery.Result<GetReportNameQuery, GetReportNameQueryVariables>;
export const UpdateWorkflowAssigneeDocument = gql`
    mutation UpdateWorkflowAssignee($input: UpdateWorkflowPermissionInput!) {
  updateWorkflowPermission(input: $input) {
    __typename
    id
    isAssignee
  }
}
    `;
export type UpdateWorkflowAssigneeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowAssigneeMutation, UpdateWorkflowAssigneeMutationVariables>;

/**
 * __useUpdateWorkflowAssigneeMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowAssigneeMutation, { data, loading, error }] = useUpdateWorkflowAssigneeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowAssigneeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowAssigneeMutation, UpdateWorkflowAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowAssigneeMutation, UpdateWorkflowAssigneeMutationVariables>(UpdateWorkflowAssigneeDocument, options);
      }
export type UpdateWorkflowAssigneeMutationHookResult = ReturnType<typeof useUpdateWorkflowAssigneeMutation>;
export type UpdateWorkflowAssigneeMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowAssigneeMutation>;
export type UpdateWorkflowAssigneeMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowAssigneeMutation, UpdateWorkflowAssigneeMutationVariables>;
export const MoveWorkflowToColumnDocument = gql`
    mutation MoveWorkflowToColumn($input: UpdateWorkflowInput!) {
  updateWorkflow(input: $input) {
    workflow {
      __typename
      id
      column {
        __typename
        id
        category
        color
        name
      }
    }
  }
}
    `;
export type MoveWorkflowToColumnMutationFn = ApolloReactHooks.useMutation.MutationFunction<MoveWorkflowToColumnMutation, MoveWorkflowToColumnMutationVariables>;

/**
 * __useMoveWorkflowToColumnMutation__
 *
 * To run a mutation, you first call `useMoveWorkflowToColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveWorkflowToColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveWorkflowToColumnMutation, { data, loading, error }] = useMoveWorkflowToColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveWorkflowToColumnMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MoveWorkflowToColumnMutation, MoveWorkflowToColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveWorkflowToColumnMutation, MoveWorkflowToColumnMutationVariables>(MoveWorkflowToColumnDocument, options);
      }
export type MoveWorkflowToColumnMutationHookResult = ReturnType<typeof useMoveWorkflowToColumnMutation>;
export type MoveWorkflowToColumnMutationResult = ApolloReactHooks.useMutation.Result<MoveWorkflowToColumnMutation>;
export type MoveWorkflowToColumnMutationOptions = ApolloReactHooks.useMutation.Options<MoveWorkflowToColumnMutation, MoveWorkflowToColumnMutationVariables>;
export const UpdateWorkflowLaunchAutomaticS4SConfigDocument = gql`
    mutation UpdateWorkflowLaunchAutomaticS4SConfig($input: UpdateWorkflowLaunchConfigInput!) {
  updateWorkflowLaunchConfig(input: $input) {
    __typename
    id
    isAutomaticS4SEnabled
  }
}
    `;
export type UpdateWorkflowLaunchAutomaticS4SConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowLaunchAutomaticS4SConfigMutation, UpdateWorkflowLaunchAutomaticS4SConfigMutationVariables>;

/**
 * __useUpdateWorkflowLaunchAutomaticS4SConfigMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowLaunchAutomaticS4SConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowLaunchAutomaticS4SConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowLaunchAutomaticS4SConfigMutation, { data, loading, error }] = useUpdateWorkflowLaunchAutomaticS4SConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowLaunchAutomaticS4SConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowLaunchAutomaticS4SConfigMutation, UpdateWorkflowLaunchAutomaticS4SConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowLaunchAutomaticS4SConfigMutation, UpdateWorkflowLaunchAutomaticS4SConfigMutationVariables>(UpdateWorkflowLaunchAutomaticS4SConfigDocument, options);
      }
export type UpdateWorkflowLaunchAutomaticS4SConfigMutationHookResult = ReturnType<typeof useUpdateWorkflowLaunchAutomaticS4SConfigMutation>;
export type UpdateWorkflowLaunchAutomaticS4SConfigMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowLaunchAutomaticS4SConfigMutation>;
export type UpdateWorkflowLaunchAutomaticS4SConfigMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowLaunchAutomaticS4SConfigMutation, UpdateWorkflowLaunchAutomaticS4SConfigMutationVariables>;
export const GetWorkflowWithOwnerDocument = gql`
    query GetWorkflowWithOwner($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    owner {
      __typename
      id
    }
  }
}
    `;

/**
 * __useGetWorkflowWithOwnerQuery__
 *
 * To run a query within a React component, call `useGetWorkflowWithOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowWithOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowWithOwnerQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowWithOwnerQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowWithOwnerQuery, GetWorkflowWithOwnerQueryVariables> & ({ variables: GetWorkflowWithOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowWithOwnerQuery, GetWorkflowWithOwnerQueryVariables>(GetWorkflowWithOwnerDocument, options);
      }
export function useGetWorkflowWithOwnerLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowWithOwnerQuery, GetWorkflowWithOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowWithOwnerQuery, GetWorkflowWithOwnerQueryVariables>(GetWorkflowWithOwnerDocument, options);
        }
export function useGetWorkflowWithOwnerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithOwnerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithOwnerQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowWithOwnerQuery, GetWorkflowWithOwnerQueryVariables>(GetWorkflowWithOwnerDocument, options);
        }
export type GetWorkflowWithOwnerQueryHookResult = ReturnType<typeof useGetWorkflowWithOwnerQuery>;
export type GetWorkflowWithOwnerLazyQueryHookResult = ReturnType<typeof useGetWorkflowWithOwnerLazyQuery>;
export type GetWorkflowWithOwnerSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowWithOwnerSuspenseQuery>;
export type GetWorkflowWithOwnerQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowWithOwnerQuery, GetWorkflowWithOwnerQueryVariables>;
export const UpdateWorkflowForwardingDocument = gql`
    mutation UpdateWorkflowForwarding($input: UpdateWorkflowInput!) {
  updateWorkflow(input: $input) {
    workflow {
      __typename
      id
      forwardingPermissionRole
    }
  }
}
    `;
export type UpdateWorkflowForwardingMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowForwardingMutation, UpdateWorkflowForwardingMutationVariables>;

/**
 * __useUpdateWorkflowForwardingMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowForwardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowForwardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowForwardingMutation, { data, loading, error }] = useUpdateWorkflowForwardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowForwardingMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowForwardingMutation, UpdateWorkflowForwardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowForwardingMutation, UpdateWorkflowForwardingMutationVariables>(UpdateWorkflowForwardingDocument, options);
      }
export type UpdateWorkflowForwardingMutationHookResult = ReturnType<typeof useUpdateWorkflowForwardingMutation>;
export type UpdateWorkflowForwardingMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowForwardingMutation>;
export type UpdateWorkflowForwardingMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowForwardingMutation, UpdateWorkflowForwardingMutationVariables>;
export const GetWorkflowHeaderDocument = gql`
    query GetWorkflowHeader($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    aiCancelledAt
    aiFailedAt
    aiFinishedAt
    aiStartedAt
    id
    name
    state
    startedAt
    publishedAt
    variant
    priority
    skipTriage
    column {
      ...ColumnWithBoard
    }
    doneColumn {
      ...ColumnBase
    }
    labels {
      ...LabelSimple
    }
    owner {
      ...UserBase
    }
    permissions {
      ...WorkflowPermissionSimple
    }
    files {
      ...WorkflowFileSimple
    }
    comments {
      ...CommentSimple
    }
    crmIntegrations
    phases {
      __typename
      id
      name
      order
      startedAt
      completedAt
      column {
        id
      }
    }
  }
}
    ${ColumnWithBoardFragmentDoc}
${ColumnBaseFragmentDoc}
${LabelSimpleFragmentDoc}
${UserBaseFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}
${WorkflowFileSimpleFragmentDoc}
${CommentSimpleFragmentDoc}`;

/**
 * __useGetWorkflowHeaderQuery__
 *
 * To run a query within a React component, call `useGetWorkflowHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowHeaderQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowHeaderQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowHeaderQuery, GetWorkflowHeaderQueryVariables> & ({ variables: GetWorkflowHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowHeaderQuery, GetWorkflowHeaderQueryVariables>(GetWorkflowHeaderDocument, options);
      }
export function useGetWorkflowHeaderLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowHeaderQuery, GetWorkflowHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowHeaderQuery, GetWorkflowHeaderQueryVariables>(GetWorkflowHeaderDocument, options);
        }
export function useGetWorkflowHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowHeaderQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowHeaderQuery, GetWorkflowHeaderQueryVariables>(GetWorkflowHeaderDocument, options);
        }
export type GetWorkflowHeaderQueryHookResult = ReturnType<typeof useGetWorkflowHeaderQuery>;
export type GetWorkflowHeaderLazyQueryHookResult = ReturnType<typeof useGetWorkflowHeaderLazyQuery>;
export type GetWorkflowHeaderSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowHeaderSuspenseQuery>;
export type GetWorkflowHeaderQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowHeaderQuery, GetWorkflowHeaderQueryVariables>;
export const UpdateWorkflowNameDocument = gql`
    mutation UpdateWorkflowName($input: UpdateWorkflowInput!) {
  updateWorkflow(input: $input) {
    workflow {
      __typename
      id
      name
    }
  }
}
    `;
export type UpdateWorkflowNameMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowNameMutation, UpdateWorkflowNameMutationVariables>;

/**
 * __useUpdateWorkflowNameMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowNameMutation, { data, loading, error }] = useUpdateWorkflowNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowNameMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowNameMutation, UpdateWorkflowNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowNameMutation, UpdateWorkflowNameMutationVariables>(UpdateWorkflowNameDocument, options);
      }
export type UpdateWorkflowNameMutationHookResult = ReturnType<typeof useUpdateWorkflowNameMutation>;
export type UpdateWorkflowNameMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowNameMutation>;
export type UpdateWorkflowNameMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowNameMutation, UpdateWorkflowNameMutationVariables>;
export const UpdatePhaseTitleDocument = gql`
    mutation UpdatePhaseTitle($input: UpdatePhaseInput!) {
  updatePhase(input: $input) {
    phase {
      __typename
      id
      name
    }
  }
}
    `;
export type UpdatePhaseTitleMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdatePhaseTitleMutation, UpdatePhaseTitleMutationVariables>;

/**
 * __useUpdatePhaseTitleMutation__
 *
 * To run a mutation, you first call `useUpdatePhaseTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhaseTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhaseTitleMutation, { data, loading, error }] = useUpdatePhaseTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePhaseTitleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdatePhaseTitleMutation, UpdatePhaseTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePhaseTitleMutation, UpdatePhaseTitleMutationVariables>(UpdatePhaseTitleDocument, options);
      }
export type UpdatePhaseTitleMutationHookResult = ReturnType<typeof useUpdatePhaseTitleMutation>;
export type UpdatePhaseTitleMutationResult = ApolloReactHooks.useMutation.Result<UpdatePhaseTitleMutation>;
export type UpdatePhaseTitleMutationOptions = ApolloReactHooks.useMutation.Options<UpdatePhaseTitleMutation, UpdatePhaseTitleMutationVariables>;
export const UpdateTaskTitleDocument = gql`
    mutation UpdateTaskTitle($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    task {
      __typename
      id
      title
    }
  }
}
    `;
export type UpdateTaskTitleMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateTaskTitleMutation, UpdateTaskTitleMutationVariables>;

/**
 * __useUpdateTaskTitleMutation__
 *
 * To run a mutation, you first call `useUpdateTaskTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTitleMutation, { data, loading, error }] = useUpdateTaskTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskTitleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateTaskTitleMutation, UpdateTaskTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskTitleMutation, UpdateTaskTitleMutationVariables>(UpdateTaskTitleDocument, options);
      }
export type UpdateTaskTitleMutationHookResult = ReturnType<typeof useUpdateTaskTitleMutation>;
export type UpdateTaskTitleMutationResult = ApolloReactHooks.useMutation.Result<UpdateTaskTitleMutation>;
export type UpdateTaskTitleMutationOptions = ApolloReactHooks.useMutation.Options<UpdateTaskTitleMutation, UpdateTaskTitleMutationVariables>;
export const GetRequesterDocumentAccessDocument = gql`
    query GetRequesterDocumentAccess($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
  }
}
    `;

/**
 * __useGetRequesterDocumentAccessQuery__
 *
 * To run a query within a React component, call `useGetRequesterDocumentAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequesterDocumentAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequesterDocumentAccessQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetRequesterDocumentAccessQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetRequesterDocumentAccessQuery, GetRequesterDocumentAccessQueryVariables> & ({ variables: GetRequesterDocumentAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRequesterDocumentAccessQuery, GetRequesterDocumentAccessQueryVariables>(GetRequesterDocumentAccessDocument, options);
      }
export function useGetRequesterDocumentAccessLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetRequesterDocumentAccessQuery, GetRequesterDocumentAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRequesterDocumentAccessQuery, GetRequesterDocumentAccessQueryVariables>(GetRequesterDocumentAccessDocument, options);
        }
export function useGetRequesterDocumentAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetRequesterDocumentAccessQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetRequesterDocumentAccessQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetRequesterDocumentAccessQuery, GetRequesterDocumentAccessQueryVariables>(GetRequesterDocumentAccessDocument, options);
        }
export type GetRequesterDocumentAccessQueryHookResult = ReturnType<typeof useGetRequesterDocumentAccessQuery>;
export type GetRequesterDocumentAccessLazyQueryHookResult = ReturnType<typeof useGetRequesterDocumentAccessLazyQuery>;
export type GetRequesterDocumentAccessSuspenseQueryHookResult = ReturnType<typeof useGetRequesterDocumentAccessSuspenseQuery>;
export type GetRequesterDocumentAccessQueryResult = ApolloReactHooks.useQuery.Result<GetRequesterDocumentAccessQuery, GetRequesterDocumentAccessQueryVariables>;
export const UpdateExtractionJobAnswerDocument = gql`
    mutation UpdateExtractionJobAnswer($input: UpdateExtractionJobInput!) {
  updateExtractionJob(input: $input) {
    __typename
    id
    answer
    reasoning
    locations {
      ...DocLocationSimple
    }
  }
}
    ${DocLocationSimpleFragmentDoc}`;
export type UpdateExtractionJobAnswerMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateExtractionJobAnswerMutation, UpdateExtractionJobAnswerMutationVariables>;

/**
 * __useUpdateExtractionJobAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateExtractionJobAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtractionJobAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtractionJobAnswerMutation, { data, loading, error }] = useUpdateExtractionJobAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExtractionJobAnswerMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateExtractionJobAnswerMutation, UpdateExtractionJobAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExtractionJobAnswerMutation, UpdateExtractionJobAnswerMutationVariables>(UpdateExtractionJobAnswerDocument, options);
      }
export type UpdateExtractionJobAnswerMutationHookResult = ReturnType<typeof useUpdateExtractionJobAnswerMutation>;
export type UpdateExtractionJobAnswerMutationResult = ApolloReactHooks.useMutation.Result<UpdateExtractionJobAnswerMutation>;
export type UpdateExtractionJobAnswerMutationOptions = ApolloReactHooks.useMutation.Options<UpdateExtractionJobAnswerMutation, UpdateExtractionJobAnswerMutationVariables>;
export const UpdateExtractionJobSelectedOptionsDocument = gql`
    mutation UpdateExtractionJobSelectedOptions($input: UpdateExtractionJobInput!) {
  updateExtractionJob(input: $input) {
    __typename
    id
    locations {
      ...DocLocationSimple
    }
    reasoning
    selectedOptions {
      __typename
      id
      label
    }
  }
}
    ${DocLocationSimpleFragmentDoc}`;
export type UpdateExtractionJobSelectedOptionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateExtractionJobSelectedOptionsMutation, UpdateExtractionJobSelectedOptionsMutationVariables>;

/**
 * __useUpdateExtractionJobSelectedOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateExtractionJobSelectedOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtractionJobSelectedOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtractionJobSelectedOptionsMutation, { data, loading, error }] = useUpdateExtractionJobSelectedOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExtractionJobSelectedOptionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateExtractionJobSelectedOptionsMutation, UpdateExtractionJobSelectedOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExtractionJobSelectedOptionsMutation, UpdateExtractionJobSelectedOptionsMutationVariables>(UpdateExtractionJobSelectedOptionsDocument, options);
      }
export type UpdateExtractionJobSelectedOptionsMutationHookResult = ReturnType<typeof useUpdateExtractionJobSelectedOptionsMutation>;
export type UpdateExtractionJobSelectedOptionsMutationResult = ApolloReactHooks.useMutation.Result<UpdateExtractionJobSelectedOptionsMutation>;
export type UpdateExtractionJobSelectedOptionsMutationOptions = ApolloReactHooks.useMutation.Options<UpdateExtractionJobSelectedOptionsMutation, UpdateExtractionJobSelectedOptionsMutationVariables>;
export const GetOcrDocumentDocument = gql`
    query GetOCRDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    variant
    latestVersion {
      ... on FileVersionInterface {
        __typename
        id
        vectorsFailedAt
        vectorsSavedAt
        vectorsStartedAt
      }
      ... on StaticFileVersion {
        __typename
        id
        fileExtractionFailedAt
        fileExtractionFinishedAt
        fileExtractionStartedAt
        fileLocation {
          __typename
          id
          mimetype
        }
      }
    }
  }
}
    `;

/**
 * __useGetOcrDocumentQuery__
 *
 * To run a query within a React component, call `useGetOcrDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOcrDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOcrDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetOcrDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetOcrDocumentQuery, GetOcrDocumentQueryVariables> & ({ variables: GetOcrDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOcrDocumentQuery, GetOcrDocumentQueryVariables>(GetOcrDocumentDocument, options);
      }
export function useGetOcrDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetOcrDocumentQuery, GetOcrDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOcrDocumentQuery, GetOcrDocumentQueryVariables>(GetOcrDocumentDocument, options);
        }
export function useGetOcrDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetOcrDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetOcrDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetOcrDocumentQuery, GetOcrDocumentQueryVariables>(GetOcrDocumentDocument, options);
        }
export type GetOcrDocumentQueryHookResult = ReturnType<typeof useGetOcrDocumentQuery>;
export type GetOcrDocumentLazyQueryHookResult = ReturnType<typeof useGetOcrDocumentLazyQuery>;
export type GetOcrDocumentSuspenseQueryHookResult = ReturnType<typeof useGetOcrDocumentSuspenseQuery>;
export type GetOcrDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetOcrDocumentQuery, GetOcrDocumentQueryVariables>;
export const TestWorkflowChartSeriesCacheDocument = gql`
    query TestWorkflowChartSeriesCache($input: WorkflowChartSeriesInput!) {
  workflowChartSeries(input: $input) {
    dimensions {
      id
      label
      data
      keys
    }
    values {
      id
      label
      data
    }
    primaryCatalog {
      id
      label
      value
      count
    }
    secondaryCatalog {
      id
      label
      value
      count
    }
    totals {
      data
      counts
    }
  }
}
    `;

/**
 * __useTestWorkflowChartSeriesCacheQuery__
 *
 * To run a query within a React component, call `useTestWorkflowChartSeriesCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestWorkflowChartSeriesCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestWorkflowChartSeriesCacheQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestWorkflowChartSeriesCacheQuery(baseOptions: ApolloReactHooks.useQuery.Options<TestWorkflowChartSeriesCacheQuery, TestWorkflowChartSeriesCacheQueryVariables> & ({ variables: TestWorkflowChartSeriesCacheQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TestWorkflowChartSeriesCacheQuery, TestWorkflowChartSeriesCacheQueryVariables>(TestWorkflowChartSeriesCacheDocument, options);
      }
export function useTestWorkflowChartSeriesCacheLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<TestWorkflowChartSeriesCacheQuery, TestWorkflowChartSeriesCacheQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TestWorkflowChartSeriesCacheQuery, TestWorkflowChartSeriesCacheQueryVariables>(TestWorkflowChartSeriesCacheDocument, options);
        }
export function useTestWorkflowChartSeriesCacheSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<TestWorkflowChartSeriesCacheQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<TestWorkflowChartSeriesCacheQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<TestWorkflowChartSeriesCacheQuery, TestWorkflowChartSeriesCacheQueryVariables>(TestWorkflowChartSeriesCacheDocument, options);
        }
export type TestWorkflowChartSeriesCacheQueryHookResult = ReturnType<typeof useTestWorkflowChartSeriesCacheQuery>;
export type TestWorkflowChartSeriesCacheLazyQueryHookResult = ReturnType<typeof useTestWorkflowChartSeriesCacheLazyQuery>;
export type TestWorkflowChartSeriesCacheSuspenseQueryHookResult = ReturnType<typeof useTestWorkflowChartSeriesCacheSuspenseQuery>;
export type TestWorkflowChartSeriesCacheQueryResult = ApolloReactHooks.useQuery.Result<TestWorkflowChartSeriesCacheQuery, TestWorkflowChartSeriesCacheQueryVariables>;
export const ReportForTestDocument = gql`
    query ReportForTest($reportId: UUID!) {
  report(reportId: $reportId) {
    __typename
    id
    name
  }
}
    `;

/**
 * __useReportForTestQuery__
 *
 * To run a query within a React component, call `useReportForTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportForTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportForTestQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportForTestQuery(baseOptions: ApolloReactHooks.useQuery.Options<ReportForTestQuery, ReportForTestQueryVariables> & ({ variables: ReportForTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReportForTestQuery, ReportForTestQueryVariables>(ReportForTestDocument, options);
      }
export function useReportForTestLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<ReportForTestQuery, ReportForTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReportForTestQuery, ReportForTestQueryVariables>(ReportForTestDocument, options);
        }
export function useReportForTestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<ReportForTestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<ReportForTestQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<ReportForTestQuery, ReportForTestQueryVariables>(ReportForTestDocument, options);
        }
export type ReportForTestQueryHookResult = ReturnType<typeof useReportForTestQuery>;
export type ReportForTestLazyQueryHookResult = ReturnType<typeof useReportForTestLazyQuery>;
export type ReportForTestSuspenseQueryHookResult = ReturnType<typeof useReportForTestSuspenseQuery>;
export type ReportForTestQueryResult = ApolloReactHooks.useQuery.Result<ReportForTestQuery, ReportForTestQueryVariables>;
export const RootExtractionQuestionsForTestDocument = gql`
    query RootExtractionQuestionsForTest {
  extractionQuestions {
    id
  }
}
    `;

/**
 * __useRootExtractionQuestionsForTestQuery__
 *
 * To run a query within a React component, call `useRootExtractionQuestionsForTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootExtractionQuestionsForTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootExtractionQuestionsForTestQuery({
 *   variables: {
 *   },
 * });
 */
export function useRootExtractionQuestionsForTestQuery(baseOptions?: ApolloReactHooks.useQuery.Options<RootExtractionQuestionsForTestQuery, RootExtractionQuestionsForTestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RootExtractionQuestionsForTestQuery, RootExtractionQuestionsForTestQueryVariables>(RootExtractionQuestionsForTestDocument, options);
      }
export function useRootExtractionQuestionsForTestLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<RootExtractionQuestionsForTestQuery, RootExtractionQuestionsForTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RootExtractionQuestionsForTestQuery, RootExtractionQuestionsForTestQueryVariables>(RootExtractionQuestionsForTestDocument, options);
        }
export function useRootExtractionQuestionsForTestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<RootExtractionQuestionsForTestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<RootExtractionQuestionsForTestQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<RootExtractionQuestionsForTestQuery, RootExtractionQuestionsForTestQueryVariables>(RootExtractionQuestionsForTestDocument, options);
        }
export type RootExtractionQuestionsForTestQueryHookResult = ReturnType<typeof useRootExtractionQuestionsForTestQuery>;
export type RootExtractionQuestionsForTestLazyQueryHookResult = ReturnType<typeof useRootExtractionQuestionsForTestLazyQuery>;
export type RootExtractionQuestionsForTestSuspenseQueryHookResult = ReturnType<typeof useRootExtractionQuestionsForTestSuspenseQuery>;
export type RootExtractionQuestionsForTestQueryResult = ApolloReactHooks.useQuery.Result<RootExtractionQuestionsForTestQuery, RootExtractionQuestionsForTestQueryVariables>;
export const GetWorkflowDocumentsBasicDocument = gql`
    query GetWorkflowDocumentsBasic($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    files {
      __typename
      id
      document {
        __typename
        id
        isCertificate
      }
    }
  }
}
    `;

/**
 * __useGetWorkflowDocumentsBasicQuery__
 *
 * To run a query within a React component, call `useGetWorkflowDocumentsBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowDocumentsBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowDocumentsBasicQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowDocumentsBasicQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowDocumentsBasicQuery, GetWorkflowDocumentsBasicQueryVariables> & ({ variables: GetWorkflowDocumentsBasicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowDocumentsBasicQuery, GetWorkflowDocumentsBasicQueryVariables>(GetWorkflowDocumentsBasicDocument, options);
      }
export function useGetWorkflowDocumentsBasicLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowDocumentsBasicQuery, GetWorkflowDocumentsBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowDocumentsBasicQuery, GetWorkflowDocumentsBasicQueryVariables>(GetWorkflowDocumentsBasicDocument, options);
        }
export function useGetWorkflowDocumentsBasicSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowDocumentsBasicQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowDocumentsBasicQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowDocumentsBasicQuery, GetWorkflowDocumentsBasicQueryVariables>(GetWorkflowDocumentsBasicDocument, options);
        }
export type GetWorkflowDocumentsBasicQueryHookResult = ReturnType<typeof useGetWorkflowDocumentsBasicQuery>;
export type GetWorkflowDocumentsBasicLazyQueryHookResult = ReturnType<typeof useGetWorkflowDocumentsBasicLazyQuery>;
export type GetWorkflowDocumentsBasicSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowDocumentsBasicSuspenseQuery>;
export type GetWorkflowDocumentsBasicQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowDocumentsBasicQuery, GetWorkflowDocumentsBasicQueryVariables>;
export const GetPendingReviewCountDocument = gql`
    query GetPendingReviewCount {
  reminders {
    meta {
      __typename
      pendingReviewCount
    }
  }
}
    `;

/**
 * __useGetPendingReviewCountQuery__
 *
 * To run a query within a React component, call `useGetPendingReviewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingReviewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingReviewCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingReviewCountQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetPendingReviewCountQuery, GetPendingReviewCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPendingReviewCountQuery, GetPendingReviewCountQueryVariables>(GetPendingReviewCountDocument, options);
      }
export function useGetPendingReviewCountLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPendingReviewCountQuery, GetPendingReviewCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPendingReviewCountQuery, GetPendingReviewCountQueryVariables>(GetPendingReviewCountDocument, options);
        }
export function useGetPendingReviewCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPendingReviewCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPendingReviewCountQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPendingReviewCountQuery, GetPendingReviewCountQueryVariables>(GetPendingReviewCountDocument, options);
        }
export type GetPendingReviewCountQueryHookResult = ReturnType<typeof useGetPendingReviewCountQuery>;
export type GetPendingReviewCountLazyQueryHookResult = ReturnType<typeof useGetPendingReviewCountLazyQuery>;
export type GetPendingReviewCountSuspenseQueryHookResult = ReturnType<typeof useGetPendingReviewCountSuspenseQuery>;
export type GetPendingReviewCountQueryResult = ApolloReactHooks.useQuery.Result<GetPendingReviewCountQuery, GetPendingReviewCountQueryVariables>;
export const GetWorkflowNameDocument = gql`
    query GetWorkflowName($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    name
  }
}
    `;

/**
 * __useGetWorkflowNameQuery__
 *
 * To run a query within a React component, call `useGetWorkflowNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowNameQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowNameQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowNameQuery, GetWorkflowNameQueryVariables> & ({ variables: GetWorkflowNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>(GetWorkflowNameDocument, options);
      }
export function useGetWorkflowNameLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>(GetWorkflowNameDocument, options);
        }
export function useGetWorkflowNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowNameQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>(GetWorkflowNameDocument, options);
        }
export type GetWorkflowNameQueryHookResult = ReturnType<typeof useGetWorkflowNameQuery>;
export type GetWorkflowNameLazyQueryHookResult = ReturnType<typeof useGetWorkflowNameLazyQuery>;
export type GetWorkflowNameSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowNameSuspenseQuery>;
export type GetWorkflowNameQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>;
export const GetAccountDocument = gql`
    query GetAccount($id: UUID!, $accountType: AccountType!) {
  account(id: $id, accountType: $accountType) {
    ...AccountBase
  }
}
    ${AccountBaseFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountType: // value for 'accountType'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAccountQuery, GetAccountQueryVariables> & ({ variables: GetAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export function useGetAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAccountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAccountQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = ApolloReactHooks.useQuery.Result<GetAccountQuery, GetAccountQueryVariables>;
export const GetAccountsByDocument = gql`
    query GetAccountsBy($input: AccountsByInput!) {
  accounts(input: $input) {
    users {
      ...UserBase
    }
    orgs {
      ...OrgBase
    }
  }
}
    ${UserBaseFragmentDoc}
${OrgBaseFragmentDoc}`;

/**
 * __useGetAccountsByQuery__
 *
 * To run a query within a React component, call `useGetAccountsByQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsByQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAccountsByQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAccountsByQuery, GetAccountsByQueryVariables> & ({ variables: GetAccountsByQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountsByQuery, GetAccountsByQueryVariables>(GetAccountsByDocument, options);
      }
export function useGetAccountsByLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAccountsByQuery, GetAccountsByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountsByQuery, GetAccountsByQueryVariables>(GetAccountsByDocument, options);
        }
export function useGetAccountsBySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAccountsByQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAccountsByQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAccountsByQuery, GetAccountsByQueryVariables>(GetAccountsByDocument, options);
        }
export type GetAccountsByQueryHookResult = ReturnType<typeof useGetAccountsByQuery>;
export type GetAccountsByLazyQueryHookResult = ReturnType<typeof useGetAccountsByLazyQuery>;
export type GetAccountsBySuspenseQueryHookResult = ReturnType<typeof useGetAccountsBySuspenseQuery>;
export type GetAccountsByQueryResult = ApolloReactHooks.useQuery.Result<GetAccountsByQuery, GetAccountsByQueryVariables>;
export const GetMyAlineSubscriptionDocument = gql`
    query GetMyAlineSubscription {
  currentUser {
    __typename
    id
    org {
      __typename
      id
      alineSubscription {
        ...AlineSubscriptionSimple
      }
      trialStartedAt
      trialEndAt
    }
  }
}
    ${AlineSubscriptionSimpleFragmentDoc}`;

/**
 * __useGetMyAlineSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetMyAlineSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAlineSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAlineSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAlineSubscriptionQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetMyAlineSubscriptionQuery, GetMyAlineSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyAlineSubscriptionQuery, GetMyAlineSubscriptionQueryVariables>(GetMyAlineSubscriptionDocument, options);
      }
export function useGetMyAlineSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyAlineSubscriptionQuery, GetMyAlineSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyAlineSubscriptionQuery, GetMyAlineSubscriptionQueryVariables>(GetMyAlineSubscriptionDocument, options);
        }
export function useGetMyAlineSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyAlineSubscriptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyAlineSubscriptionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyAlineSubscriptionQuery, GetMyAlineSubscriptionQueryVariables>(GetMyAlineSubscriptionDocument, options);
        }
export type GetMyAlineSubscriptionQueryHookResult = ReturnType<typeof useGetMyAlineSubscriptionQuery>;
export type GetMyAlineSubscriptionLazyQueryHookResult = ReturnType<typeof useGetMyAlineSubscriptionLazyQuery>;
export type GetMyAlineSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetMyAlineSubscriptionSuspenseQuery>;
export type GetMyAlineSubscriptionQueryResult = ApolloReactHooks.useQuery.Result<GetMyAlineSubscriptionQuery, GetMyAlineSubscriptionQueryVariables>;
export const CreateBillingSessionUrlDocument = gql`
    mutation CreateBillingSessionUrl {
  createBillingSessionUrl
}
    `;
export type CreateBillingSessionUrlMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateBillingSessionUrlMutation, CreateBillingSessionUrlMutationVariables>;

/**
 * __useCreateBillingSessionUrlMutation__
 *
 * To run a mutation, you first call `useCreateBillingSessionUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingSessionUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingSessionUrlMutation, { data, loading, error }] = useCreateBillingSessionUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateBillingSessionUrlMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateBillingSessionUrlMutation, CreateBillingSessionUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBillingSessionUrlMutation, CreateBillingSessionUrlMutationVariables>(CreateBillingSessionUrlDocument, options);
      }
export type CreateBillingSessionUrlMutationHookResult = ReturnType<typeof useCreateBillingSessionUrlMutation>;
export type CreateBillingSessionUrlMutationResult = ApolloReactHooks.useMutation.Result<CreateBillingSessionUrlMutation>;
export type CreateBillingSessionUrlMutationOptions = ApolloReactHooks.useMutation.Options<CreateBillingSessionUrlMutation, CreateBillingSessionUrlMutationVariables>;
export const CreateCheckoutUrlDocument = gql`
    mutation CreateCheckoutUrl($input: CreateCheckoutUrlInput!) {
  createCheckoutUrl(input: $input)
}
    `;
export type CreateCheckoutUrlMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateCheckoutUrlMutation, CreateCheckoutUrlMutationVariables>;

/**
 * __useCreateCheckoutUrlMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutUrlMutation, { data, loading, error }] = useCreateCheckoutUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutUrlMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateCheckoutUrlMutation, CreateCheckoutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCheckoutUrlMutation, CreateCheckoutUrlMutationVariables>(CreateCheckoutUrlDocument, options);
      }
export type CreateCheckoutUrlMutationHookResult = ReturnType<typeof useCreateCheckoutUrlMutation>;
export type CreateCheckoutUrlMutationResult = ApolloReactHooks.useMutation.Result<CreateCheckoutUrlMutation>;
export type CreateCheckoutUrlMutationOptions = ApolloReactHooks.useMutation.Options<CreateCheckoutUrlMutation, CreateCheckoutUrlMutationVariables>;
export const CreateCloseOrderUrlDocument = gql`
    mutation CreateCloseOrderUrl($orderId: String!) {
  createCloseOrderUrl(orderId: $orderId)
}
    `;
export type CreateCloseOrderUrlMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateCloseOrderUrlMutation, CreateCloseOrderUrlMutationVariables>;

/**
 * __useCreateCloseOrderUrlMutation__
 *
 * To run a mutation, you first call `useCreateCloseOrderUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCloseOrderUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCloseOrderUrlMutation, { data, loading, error }] = useCreateCloseOrderUrlMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCreateCloseOrderUrlMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateCloseOrderUrlMutation, CreateCloseOrderUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCloseOrderUrlMutation, CreateCloseOrderUrlMutationVariables>(CreateCloseOrderUrlDocument, options);
      }
export type CreateCloseOrderUrlMutationHookResult = ReturnType<typeof useCreateCloseOrderUrlMutation>;
export type CreateCloseOrderUrlMutationResult = ApolloReactHooks.useMutation.Result<CreateCloseOrderUrlMutation>;
export type CreateCloseOrderUrlMutationOptions = ApolloReactHooks.useMutation.Options<CreateCloseOrderUrlMutation, CreateCloseOrderUrlMutationVariables>;
export const ComputeCheckoutEstimateDocument = gql`
    query ComputeCheckoutEstimate($input: CreateCheckoutUrlInput!) {
  computeCheckoutEstimate(input: $input) {
    basicSeatUnitCost
    fullSeatUnitCost
    basicSeatTotal
    fullSeatTotal
    total
  }
}
    `;

/**
 * __useComputeCheckoutEstimateQuery__
 *
 * To run a query within a React component, call `useComputeCheckoutEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeCheckoutEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeCheckoutEstimateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useComputeCheckoutEstimateQuery(baseOptions: ApolloReactHooks.useQuery.Options<ComputeCheckoutEstimateQuery, ComputeCheckoutEstimateQueryVariables> & ({ variables: ComputeCheckoutEstimateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ComputeCheckoutEstimateQuery, ComputeCheckoutEstimateQueryVariables>(ComputeCheckoutEstimateDocument, options);
      }
export function useComputeCheckoutEstimateLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<ComputeCheckoutEstimateQuery, ComputeCheckoutEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ComputeCheckoutEstimateQuery, ComputeCheckoutEstimateQueryVariables>(ComputeCheckoutEstimateDocument, options);
        }
export function useComputeCheckoutEstimateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<ComputeCheckoutEstimateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<ComputeCheckoutEstimateQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<ComputeCheckoutEstimateQuery, ComputeCheckoutEstimateQueryVariables>(ComputeCheckoutEstimateDocument, options);
        }
export type ComputeCheckoutEstimateQueryHookResult = ReturnType<typeof useComputeCheckoutEstimateQuery>;
export type ComputeCheckoutEstimateLazyQueryHookResult = ReturnType<typeof useComputeCheckoutEstimateLazyQuery>;
export type ComputeCheckoutEstimateSuspenseQueryHookResult = ReturnType<typeof useComputeCheckoutEstimateSuspenseQuery>;
export type ComputeCheckoutEstimateQueryResult = ApolloReactHooks.useQuery.Result<ComputeCheckoutEstimateQuery, ComputeCheckoutEstimateQueryVariables>;
export const GetDocumentGroupPermissionsDocument = gql`
    query GetDocumentGroupPermissions($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    requesterInOwnerOrg
    owner {
      ...UserBase
    }
    groups {
      __typename
      id
      avatarColor
      name
      labels {
        __typename
        id
        labelText
      }
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetDocumentGroupPermissionsQuery__
 *
 * To run a query within a React component, call `useGetDocumentGroupPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentGroupPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentGroupPermissionsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentGroupPermissionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentGroupPermissionsQuery, GetDocumentGroupPermissionsQueryVariables> & ({ variables: GetDocumentGroupPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentGroupPermissionsQuery, GetDocumentGroupPermissionsQueryVariables>(GetDocumentGroupPermissionsDocument, options);
      }
export function useGetDocumentGroupPermissionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentGroupPermissionsQuery, GetDocumentGroupPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentGroupPermissionsQuery, GetDocumentGroupPermissionsQueryVariables>(GetDocumentGroupPermissionsDocument, options);
        }
export function useGetDocumentGroupPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentGroupPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentGroupPermissionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentGroupPermissionsQuery, GetDocumentGroupPermissionsQueryVariables>(GetDocumentGroupPermissionsDocument, options);
        }
export type GetDocumentGroupPermissionsQueryHookResult = ReturnType<typeof useGetDocumentGroupPermissionsQuery>;
export type GetDocumentGroupPermissionsLazyQueryHookResult = ReturnType<typeof useGetDocumentGroupPermissionsLazyQuery>;
export type GetDocumentGroupPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentGroupPermissionsSuspenseQuery>;
export type GetDocumentGroupPermissionsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentGroupPermissionsQuery, GetDocumentGroupPermissionsQueryVariables>;
export const SetGroupPermissionsDocument = gql`
    mutation SetGroupPermissions($input: SetGroupPermissionsInput!) {
  setGroupPermissions(input: $input) {
    __typename
    id
    labels {
      __typename
      id
      labelText
    }
  }
}
    `;
export type SetGroupPermissionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetGroupPermissionsMutation, SetGroupPermissionsMutationVariables>;

/**
 * __useSetGroupPermissionsMutation__
 *
 * To run a mutation, you first call `useSetGroupPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGroupPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGroupPermissionsMutation, { data, loading, error }] = useSetGroupPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGroupPermissionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetGroupPermissionsMutation, SetGroupPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetGroupPermissionsMutation, SetGroupPermissionsMutationVariables>(SetGroupPermissionsDocument, options);
      }
export type SetGroupPermissionsMutationHookResult = ReturnType<typeof useSetGroupPermissionsMutation>;
export type SetGroupPermissionsMutationResult = ApolloReactHooks.useMutation.Result<SetGroupPermissionsMutation>;
export type SetGroupPermissionsMutationOptions = ApolloReactHooks.useMutation.Options<SetGroupPermissionsMutation, SetGroupPermissionsMutationVariables>;
export const DeleteGroupPermissionDocument = gql`
    mutation DeleteGroupPermission($groupId: UUID!, $labelId: UUID!) {
  deleteGroupPermission(groupId: $groupId, labelId: $labelId) {
    __typename
    id
    labels {
      ...LabelSimple
    }
  }
}
    ${LabelSimpleFragmentDoc}`;
export type DeleteGroupPermissionMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteGroupPermissionMutation, DeleteGroupPermissionMutationVariables>;

/**
 * __useDeleteGroupPermissionMutation__
 *
 * To run a mutation, you first call `useDeleteGroupPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupPermissionMutation, { data, loading, error }] = useDeleteGroupPermissionMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useDeleteGroupPermissionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteGroupPermissionMutation, DeleteGroupPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteGroupPermissionMutation, DeleteGroupPermissionMutationVariables>(DeleteGroupPermissionDocument, options);
      }
export type DeleteGroupPermissionMutationHookResult = ReturnType<typeof useDeleteGroupPermissionMutation>;
export type DeleteGroupPermissionMutationResult = ApolloReactHooks.useMutation.Result<DeleteGroupPermissionMutation>;
export type DeleteGroupPermissionMutationOptions = ApolloReactHooks.useMutation.Options<DeleteGroupPermissionMutation, DeleteGroupPermissionMutationVariables>;
export const GetGroupWithUsersDocument = gql`
    query GetGroupWithUsers($id: UUID!) {
  group(id: $id) {
    ...GroupWithUsers
  }
}
    ${GroupWithUsersFragmentDoc}`;

/**
 * __useGetGroupWithUsersQuery__
 *
 * To run a query within a React component, call `useGetGroupWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupWithUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupWithUsersQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetGroupWithUsersQuery, GetGroupWithUsersQueryVariables> & ({ variables: GetGroupWithUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGroupWithUsersQuery, GetGroupWithUsersQueryVariables>(GetGroupWithUsersDocument, options);
      }
export function useGetGroupWithUsersLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetGroupWithUsersQuery, GetGroupWithUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGroupWithUsersQuery, GetGroupWithUsersQueryVariables>(GetGroupWithUsersDocument, options);
        }
export function useGetGroupWithUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetGroupWithUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetGroupWithUsersQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetGroupWithUsersQuery, GetGroupWithUsersQueryVariables>(GetGroupWithUsersDocument, options);
        }
export type GetGroupWithUsersQueryHookResult = ReturnType<typeof useGetGroupWithUsersQuery>;
export type GetGroupWithUsersLazyQueryHookResult = ReturnType<typeof useGetGroupWithUsersLazyQuery>;
export type GetGroupWithUsersSuspenseQueryHookResult = ReturnType<typeof useGetGroupWithUsersSuspenseQuery>;
export type GetGroupWithUsersQueryResult = ApolloReactHooks.useQuery.Result<GetGroupWithUsersQuery, GetGroupWithUsersQueryVariables>;
export const GetGroupPermissionsDocument = gql`
    query GetGroupPermissions($id: UUID!) {
  group(id: $id) {
    ...GroupSimple
    labels {
      ...LabelSimple
    }
  }
}
    ${GroupSimpleFragmentDoc}
${LabelSimpleFragmentDoc}`;

/**
 * __useGetGroupPermissionsQuery__
 *
 * To run a query within a React component, call `useGetGroupPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupPermissionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetGroupPermissionsQuery, GetGroupPermissionsQueryVariables> & ({ variables: GetGroupPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGroupPermissionsQuery, GetGroupPermissionsQueryVariables>(GetGroupPermissionsDocument, options);
      }
export function useGetGroupPermissionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetGroupPermissionsQuery, GetGroupPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGroupPermissionsQuery, GetGroupPermissionsQueryVariables>(GetGroupPermissionsDocument, options);
        }
export function useGetGroupPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetGroupPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetGroupPermissionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetGroupPermissionsQuery, GetGroupPermissionsQueryVariables>(GetGroupPermissionsDocument, options);
        }
export type GetGroupPermissionsQueryHookResult = ReturnType<typeof useGetGroupPermissionsQuery>;
export type GetGroupPermissionsLazyQueryHookResult = ReturnType<typeof useGetGroupPermissionsLazyQuery>;
export type GetGroupPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetGroupPermissionsSuspenseQuery>;
export type GetGroupPermissionsQueryResult = ApolloReactHooks.useQuery.Result<GetGroupPermissionsQuery, GetGroupPermissionsQueryVariables>;
export const GetGroupDocument = gql`
    query GetGroup($id: UUID!) {
  group(id: $id) {
    ...GroupSimple
  }
}
    ${GroupSimpleFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetGroupQuery, GetGroupQueryVariables> & ({ variables: GetGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export function useGetGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetGroupQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupSuspenseQueryHookResult = ReturnType<typeof useGetGroupSuspenseQuery>;
export type GetGroupQueryResult = ApolloReactHooks.useQuery.Result<GetGroupQuery, GetGroupQueryVariables>;
export const GetGroupsDocument = gql`
    query GetGroups {
  groups {
    __typename
    id
    avatarColor
    name
    userCount
    canAccessAllDocAndWorkflows
    labels {
      ...LabelSimple
    }
    createdAt
    updatedAt
  }
}
    ${LabelSimpleFragmentDoc}`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export function useGetGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetGroupsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsSuspenseQuery>;
export type GetGroupsQueryResult = ApolloReactHooks.useQuery.Result<GetGroupsQuery, GetGroupsQueryVariables>;
export const AddUsersToGroupDocument = gql`
    mutation AddUsersToGroup($input: AddUsersToGroupInput!) {
  addUsersToGroup(input: $input) {
    ...GroupWithUsers
  }
}
    ${GroupWithUsersFragmentDoc}`;
export type AddUsersToGroupMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>;

/**
 * __useAddUsersToGroupMutation__
 *
 * To run a mutation, you first call `useAddUsersToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToGroupMutation, { data, loading, error }] = useAddUsersToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUsersToGroupMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>(AddUsersToGroupDocument, options);
      }
export type AddUsersToGroupMutationHookResult = ReturnType<typeof useAddUsersToGroupMutation>;
export type AddUsersToGroupMutationResult = ApolloReactHooks.useMutation.Result<AddUsersToGroupMutation>;
export type AddUsersToGroupMutationOptions = ApolloReactHooks.useMutation.Options<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    ...GroupWithUsers
  }
}
    ${GroupWithUsersFragmentDoc}`;
export type CreateGroupMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = ApolloReactHooks.useMutation.Result<CreateGroupMutation>;
export type CreateGroupMutationOptions = ApolloReactHooks.useMutation.Options<CreateGroupMutation, CreateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($id: UUID!) {
  deleteGroup(id: $id)
}
    `;
export type DeleteGroupMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = ApolloReactHooks.useMutation.Result<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = ApolloReactHooks.useMutation.Options<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const RemoveUsersFromGroupDocument = gql`
    mutation RemoveUsersFromGroup($input: RemoveUsersFromGroupInput!) {
  removeUsersFromGroup(input: $input) {
    ...GroupWithUsers
  }
}
    ${GroupWithUsersFragmentDoc}`;
export type RemoveUsersFromGroupMutationFn = ApolloReactHooks.useMutation.MutationFunction<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>;

/**
 * __useRemoveUsersFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromGroupMutation, { data, loading, error }] = useRemoveUsersFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUsersFromGroupMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>(RemoveUsersFromGroupDocument, options);
      }
export type RemoveUsersFromGroupMutationHookResult = ReturnType<typeof useRemoveUsersFromGroupMutation>;
export type RemoveUsersFromGroupMutationResult = ApolloReactHooks.useMutation.Result<RemoveUsersFromGroupMutation>;
export type RemoveUsersFromGroupMutationOptions = ApolloReactHooks.useMutation.Options<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    __typename
    id
    name
    canAccessAllDocAndWorkflows
  }
}
    `;
export type UpdateGroupMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = ApolloReactHooks.useMutation.Result<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = ApolloReactHooks.useMutation.Options<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateOnboardingTaskDocument = gql`
    mutation UpdateOnboardingTask($input: UpdateOnboardingTaskInput!) {
  updateOnboardingTask(input: $input) {
    onboardingTask {
      ...OnboardingTaskSimple
    }
  }
}
    ${OnboardingTaskSimpleFragmentDoc}`;
export type UpdateOnboardingTaskMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateOnboardingTaskMutation, UpdateOnboardingTaskMutationVariables>;

/**
 * __useUpdateOnboardingTaskMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingTaskMutation, { data, loading, error }] = useUpdateOnboardingTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOnboardingTaskMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateOnboardingTaskMutation, UpdateOnboardingTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOnboardingTaskMutation, UpdateOnboardingTaskMutationVariables>(UpdateOnboardingTaskDocument, options);
      }
export type UpdateOnboardingTaskMutationHookResult = ReturnType<typeof useUpdateOnboardingTaskMutation>;
export type UpdateOnboardingTaskMutationResult = ApolloReactHooks.useMutation.Result<UpdateOnboardingTaskMutation>;
export type UpdateOnboardingTaskMutationOptions = ApolloReactHooks.useMutation.Options<UpdateOnboardingTaskMutation, UpdateOnboardingTaskMutationVariables>;
export const ImportExampleNdaResourcesDocument = gql`
    mutation ImportExampleNDAResources {
  importExampleNDAResources {
    ...UserSettingsSimple
  }
}
    ${UserSettingsSimpleFragmentDoc}`;
export type ImportExampleNdaResourcesMutationFn = ApolloReactHooks.useMutation.MutationFunction<ImportExampleNdaResourcesMutation, ImportExampleNdaResourcesMutationVariables>;

/**
 * __useImportExampleNdaResourcesMutation__
 *
 * To run a mutation, you first call `useImportExampleNdaResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportExampleNdaResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importExampleNdaResourcesMutation, { data, loading, error }] = useImportExampleNdaResourcesMutation({
 *   variables: {
 *   },
 * });
 */
export function useImportExampleNdaResourcesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ImportExampleNdaResourcesMutation, ImportExampleNdaResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImportExampleNdaResourcesMutation, ImportExampleNdaResourcesMutationVariables>(ImportExampleNdaResourcesDocument, options);
      }
export type ImportExampleNdaResourcesMutationHookResult = ReturnType<typeof useImportExampleNdaResourcesMutation>;
export type ImportExampleNdaResourcesMutationResult = ApolloReactHooks.useMutation.Result<ImportExampleNdaResourcesMutation>;
export type ImportExampleNdaResourcesMutationOptions = ApolloReactHooks.useMutation.Options<ImportExampleNdaResourcesMutation, ImportExampleNdaResourcesMutationVariables>;
export const CreateExampleReportDocument = gql`
    mutation CreateExampleReport {
  createExampleReport {
    ...UserSettingsSimple
  }
}
    ${UserSettingsSimpleFragmentDoc}`;
export type CreateExampleReportMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateExampleReportMutation, CreateExampleReportMutationVariables>;

/**
 * __useCreateExampleReportMutation__
 *
 * To run a mutation, you first call `useCreateExampleReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExampleReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExampleReportMutation, { data, loading, error }] = useCreateExampleReportMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateExampleReportMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateExampleReportMutation, CreateExampleReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateExampleReportMutation, CreateExampleReportMutationVariables>(CreateExampleReportDocument, options);
      }
export type CreateExampleReportMutationHookResult = ReturnType<typeof useCreateExampleReportMutation>;
export type CreateExampleReportMutationResult = ApolloReactHooks.useMutation.Result<CreateExampleReportMutation>;
export type CreateExampleReportMutationOptions = ApolloReactHooks.useMutation.Options<CreateExampleReportMutation, CreateExampleReportMutationVariables>;
export const GetOrgDocument = gql`
    query GetOrg($orgId: UUID!) {
  org(orgId: $orgId) {
    ...OrgBase
  }
}
    ${OrgBaseFragmentDoc}`;

/**
 * __useGetOrgQuery__
 *
 * To run a query within a React component, call `useGetOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetOrgQuery, GetOrgQueryVariables> & ({ variables: GetOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrgQuery, GetOrgQueryVariables>(GetOrgDocument, options);
      }
export function useGetOrgLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetOrgQuery, GetOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrgQuery, GetOrgQueryVariables>(GetOrgDocument, options);
        }
export function useGetOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetOrgQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetOrgQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetOrgQuery, GetOrgQueryVariables>(GetOrgDocument, options);
        }
export type GetOrgQueryHookResult = ReturnType<typeof useGetOrgQuery>;
export type GetOrgLazyQueryHookResult = ReturnType<typeof useGetOrgLazyQuery>;
export type GetOrgSuspenseQueryHookResult = ReturnType<typeof useGetOrgSuspenseQuery>;
export type GetOrgQueryResult = ApolloReactHooks.useQuery.Result<GetOrgQuery, GetOrgQueryVariables>;
export const GetOrgsDocument = gql`
    query GetOrgs {
  orgs {
    ...OrgBase
  }
}
    ${OrgBaseFragmentDoc}`;

/**
 * __useGetOrgsQuery__
 *
 * To run a query within a React component, call `useGetOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetOrgsQuery, GetOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrgsQuery, GetOrgsQueryVariables>(GetOrgsDocument, options);
      }
export function useGetOrgsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetOrgsQuery, GetOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrgsQuery, GetOrgsQueryVariables>(GetOrgsDocument, options);
        }
export function useGetOrgsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetOrgsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetOrgsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetOrgsQuery, GetOrgsQueryVariables>(GetOrgsDocument, options);
        }
export type GetOrgsQueryHookResult = ReturnType<typeof useGetOrgsQuery>;
export type GetOrgsLazyQueryHookResult = ReturnType<typeof useGetOrgsLazyQuery>;
export type GetOrgsSuspenseQueryHookResult = ReturnType<typeof useGetOrgsSuspenseQuery>;
export type GetOrgsQueryResult = ApolloReactHooks.useQuery.Result<GetOrgsQuery, GetOrgsQueryVariables>;
export const OrgNameUniqueDocument = gql`
    query OrgNameUnique($input: OrgNameUniqueInput!) {
  orgNameUnique(input: $input) {
    __typename
    unique
  }
}
    `;

/**
 * __useOrgNameUniqueQuery__
 *
 * To run a query within a React component, call `useOrgNameUniqueQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgNameUniqueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgNameUniqueQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgNameUniqueQuery(baseOptions: ApolloReactHooks.useQuery.Options<OrgNameUniqueQuery, OrgNameUniqueQueryVariables> & ({ variables: OrgNameUniqueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgNameUniqueQuery, OrgNameUniqueQueryVariables>(OrgNameUniqueDocument, options);
      }
export function useOrgNameUniqueLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<OrgNameUniqueQuery, OrgNameUniqueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgNameUniqueQuery, OrgNameUniqueQueryVariables>(OrgNameUniqueDocument, options);
        }
export function useOrgNameUniqueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<OrgNameUniqueQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<OrgNameUniqueQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<OrgNameUniqueQuery, OrgNameUniqueQueryVariables>(OrgNameUniqueDocument, options);
        }
export type OrgNameUniqueQueryHookResult = ReturnType<typeof useOrgNameUniqueQuery>;
export type OrgNameUniqueLazyQueryHookResult = ReturnType<typeof useOrgNameUniqueLazyQuery>;
export type OrgNameUniqueSuspenseQueryHookResult = ReturnType<typeof useOrgNameUniqueSuspenseQuery>;
export type OrgNameUniqueQueryResult = ApolloReactHooks.useQuery.Result<OrgNameUniqueQuery, OrgNameUniqueQueryVariables>;
export const UpdateOrgDocument = gql`
    mutation UpdateOrg($input: UpdateOrg!) {
  updateOrg(input: $input) {
    org {
      ...OrgBase
    }
  }
}
    ${OrgBaseFragmentDoc}`;
export type UpdateOrgMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateOrgMutation, UpdateOrgMutationVariables>;

/**
 * __useUpdateOrgMutation__
 *
 * To run a mutation, you first call `useUpdateOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgMutation, { data, loading, error }] = useUpdateOrgMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateOrgMutation, UpdateOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrgMutation, UpdateOrgMutationVariables>(UpdateOrgDocument, options);
      }
export type UpdateOrgMutationHookResult = ReturnType<typeof useUpdateOrgMutation>;
export type UpdateOrgMutationResult = ApolloReactHooks.useMutation.Result<UpdateOrgMutation>;
export type UpdateOrgMutationOptions = ApolloReactHooks.useMutation.Options<UpdateOrgMutation, UpdateOrgMutationVariables>;
export const CreateOrgDocument = gql`
    mutation CreateOrg($input: NewOrgInput!) {
  createOrg(input: $input) {
    org {
      ...OrgBase
    }
  }
}
    ${OrgBaseFragmentDoc}`;
export type CreateOrgMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateOrgMutation, CreateOrgMutationVariables>;

/**
 * __useCreateOrgMutation__
 *
 * To run a mutation, you first call `useCreateOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgMutation, { data, loading, error }] = useCreateOrgMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrgMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateOrgMutation, CreateOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrgMutation, CreateOrgMutationVariables>(CreateOrgDocument, options);
      }
export type CreateOrgMutationHookResult = ReturnType<typeof useCreateOrgMutation>;
export type CreateOrgMutationResult = ApolloReactHooks.useMutation.Result<CreateOrgMutation>;
export type CreateOrgMutationOptions = ApolloReactHooks.useMutation.Options<CreateOrgMutation, CreateOrgMutationVariables>;
export const AddOrgMemberDocument = gql`
    mutation AddOrgMember($input: UpdateOrgMembership!) {
  addOrgMember(input: $input) {
    user {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;
export type AddOrgMemberMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddOrgMemberMutation, AddOrgMemberMutationVariables>;

/**
 * __useAddOrgMemberMutation__
 *
 * To run a mutation, you first call `useAddOrgMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrgMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrgMemberMutation, { data, loading, error }] = useAddOrgMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrgMemberMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddOrgMemberMutation, AddOrgMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddOrgMemberMutation, AddOrgMemberMutationVariables>(AddOrgMemberDocument, options);
      }
export type AddOrgMemberMutationHookResult = ReturnType<typeof useAddOrgMemberMutation>;
export type AddOrgMemberMutationResult = ApolloReactHooks.useMutation.Result<AddOrgMemberMutation>;
export type AddOrgMemberMutationOptions = ApolloReactHooks.useMutation.Options<AddOrgMemberMutation, AddOrgMemberMutationVariables>;
export const DeleteOrgDocument = gql`
    mutation DeleteOrg($orgId: UUID!) {
  deleteOrg(orgId: $orgId) {
    org {
      ...OrgBase
    }
  }
}
    ${OrgBaseFragmentDoc}`;
export type DeleteOrgMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteOrgMutation, DeleteOrgMutationVariables>;

/**
 * __useDeleteOrgMutation__
 *
 * To run a mutation, you first call `useDeleteOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrgMutation, { data, loading, error }] = useDeleteOrgMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDeleteOrgMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteOrgMutation, DeleteOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOrgMutation, DeleteOrgMutationVariables>(DeleteOrgDocument, options);
      }
export type DeleteOrgMutationHookResult = ReturnType<typeof useDeleteOrgMutation>;
export type DeleteOrgMutationResult = ApolloReactHooks.useMutation.Result<DeleteOrgMutation>;
export type DeleteOrgMutationOptions = ApolloReactHooks.useMutation.Options<DeleteOrgMutation, DeleteOrgMutationVariables>;
export const ResendOrgInviteDocument = gql`
    mutation ResendOrgInvite($input: ResendOrgInvite!) {
  resendOrgInvite(input: $input) {
    org {
      ...OrgBase
    }
  }
}
    ${OrgBaseFragmentDoc}`;
export type ResendOrgInviteMutationFn = ApolloReactHooks.useMutation.MutationFunction<ResendOrgInviteMutation, ResendOrgInviteMutationVariables>;

/**
 * __useResendOrgInviteMutation__
 *
 * To run a mutation, you first call `useResendOrgInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOrgInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOrgInviteMutation, { data, loading, error }] = useResendOrgInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendOrgInviteMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ResendOrgInviteMutation, ResendOrgInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendOrgInviteMutation, ResendOrgInviteMutationVariables>(ResendOrgInviteDocument, options);
      }
export type ResendOrgInviteMutationHookResult = ReturnType<typeof useResendOrgInviteMutation>;
export type ResendOrgInviteMutationResult = ApolloReactHooks.useMutation.Result<ResendOrgInviteMutation>;
export type ResendOrgInviteMutationOptions = ApolloReactHooks.useMutation.Options<ResendOrgInviteMutation, ResendOrgInviteMutationVariables>;
export const UpsertOrgAvatarImgDocument = gql`
    mutation UpsertOrgAvatarImg($input: FileLocationProps!) {
  upsertOrgAvatarImg(input: $input) {
    org {
      __typename
      id
      avatarImg {
        __typename
        id
        filestackUrl
      }
    }
  }
}
    `;
export type UpsertOrgAvatarImgMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpsertOrgAvatarImgMutation, UpsertOrgAvatarImgMutationVariables>;

/**
 * __useUpsertOrgAvatarImgMutation__
 *
 * To run a mutation, you first call `useUpsertOrgAvatarImgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrgAvatarImgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrgAvatarImgMutation, { data, loading, error }] = useUpsertOrgAvatarImgMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOrgAvatarImgMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpsertOrgAvatarImgMutation, UpsertOrgAvatarImgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertOrgAvatarImgMutation, UpsertOrgAvatarImgMutationVariables>(UpsertOrgAvatarImgDocument, options);
      }
export type UpsertOrgAvatarImgMutationHookResult = ReturnType<typeof useUpsertOrgAvatarImgMutation>;
export type UpsertOrgAvatarImgMutationResult = ApolloReactHooks.useMutation.Result<UpsertOrgAvatarImgMutation>;
export type UpsertOrgAvatarImgMutationOptions = ApolloReactHooks.useMutation.Options<UpsertOrgAvatarImgMutation, UpsertOrgAvatarImgMutationVariables>;
export const GetUpgradeRequestsDocument = gql`
    query GetUpgradeRequests($status: UpgradeRequestStatus) {
  upgradeRequests(status: $status) {
    ...UpgradeRequestBase
  }
}
    ${UpgradeRequestBaseFragmentDoc}`;

/**
 * __useGetUpgradeRequestsQuery__
 *
 * To run a query within a React component, call `useGetUpgradeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpgradeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpgradeRequestsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetUpgradeRequestsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetUpgradeRequestsQuery, GetUpgradeRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUpgradeRequestsQuery, GetUpgradeRequestsQueryVariables>(GetUpgradeRequestsDocument, options);
      }
export function useGetUpgradeRequestsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUpgradeRequestsQuery, GetUpgradeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUpgradeRequestsQuery, GetUpgradeRequestsQueryVariables>(GetUpgradeRequestsDocument, options);
        }
export function useGetUpgradeRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUpgradeRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUpgradeRequestsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUpgradeRequestsQuery, GetUpgradeRequestsQueryVariables>(GetUpgradeRequestsDocument, options);
        }
export type GetUpgradeRequestsQueryHookResult = ReturnType<typeof useGetUpgradeRequestsQuery>;
export type GetUpgradeRequestsLazyQueryHookResult = ReturnType<typeof useGetUpgradeRequestsLazyQuery>;
export type GetUpgradeRequestsSuspenseQueryHookResult = ReturnType<typeof useGetUpgradeRequestsSuspenseQuery>;
export type GetUpgradeRequestsQueryResult = ApolloReactHooks.useQuery.Result<GetUpgradeRequestsQuery, GetUpgradeRequestsQueryVariables>;
export const RequestUpgradeDocument = gql`
    mutation RequestUpgrade($input: RequestUpgradeInput!) {
  requestUpgrade(input: $input) {
    ...UpgradeRequestBase
  }
}
    ${UpgradeRequestBaseFragmentDoc}`;
export type RequestUpgradeMutationFn = ApolloReactHooks.useMutation.MutationFunction<RequestUpgradeMutation, RequestUpgradeMutationVariables>;

/**
 * __useRequestUpgradeMutation__
 *
 * To run a mutation, you first call `useRequestUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUpgradeMutation, { data, loading, error }] = useRequestUpgradeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestUpgradeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RequestUpgradeMutation, RequestUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestUpgradeMutation, RequestUpgradeMutationVariables>(RequestUpgradeDocument, options);
      }
export type RequestUpgradeMutationHookResult = ReturnType<typeof useRequestUpgradeMutation>;
export type RequestUpgradeMutationResult = ApolloReactHooks.useMutation.Result<RequestUpgradeMutation>;
export type RequestUpgradeMutationOptions = ApolloReactHooks.useMutation.Options<RequestUpgradeMutation, RequestUpgradeMutationVariables>;
export const CancelUpgradeRequestDocument = gql`
    mutation CancelUpgradeRequest($id: UUID!) {
  cancelUpgradeRequest(id: $id) {
    ...UpgradeRequestBase
  }
}
    ${UpgradeRequestBaseFragmentDoc}`;
export type CancelUpgradeRequestMutationFn = ApolloReactHooks.useMutation.MutationFunction<CancelUpgradeRequestMutation, CancelUpgradeRequestMutationVariables>;

/**
 * __useCancelUpgradeRequestMutation__
 *
 * To run a mutation, you first call `useCancelUpgradeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUpgradeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUpgradeRequestMutation, { data, loading, error }] = useCancelUpgradeRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelUpgradeRequestMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CancelUpgradeRequestMutation, CancelUpgradeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelUpgradeRequestMutation, CancelUpgradeRequestMutationVariables>(CancelUpgradeRequestDocument, options);
      }
export type CancelUpgradeRequestMutationHookResult = ReturnType<typeof useCancelUpgradeRequestMutation>;
export type CancelUpgradeRequestMutationResult = ApolloReactHooks.useMutation.Result<CancelUpgradeRequestMutation>;
export type CancelUpgradeRequestMutationOptions = ApolloReactHooks.useMutation.Options<CancelUpgradeRequestMutation, CancelUpgradeRequestMutationVariables>;
export const RespondToUpgradeRequestDocument = gql`
    mutation RespondToUpgradeRequest($input: RespondToUpgradeRequestInput!) {
  respondToUpgradeRequest(input: $input) {
    ...UpgradeRequestBase
  }
}
    ${UpgradeRequestBaseFragmentDoc}`;
export type RespondToUpgradeRequestMutationFn = ApolloReactHooks.useMutation.MutationFunction<RespondToUpgradeRequestMutation, RespondToUpgradeRequestMutationVariables>;

/**
 * __useRespondToUpgradeRequestMutation__
 *
 * To run a mutation, you first call `useRespondToUpgradeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToUpgradeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToUpgradeRequestMutation, { data, loading, error }] = useRespondToUpgradeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToUpgradeRequestMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RespondToUpgradeRequestMutation, RespondToUpgradeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RespondToUpgradeRequestMutation, RespondToUpgradeRequestMutationVariables>(RespondToUpgradeRequestDocument, options);
      }
export type RespondToUpgradeRequestMutationHookResult = ReturnType<typeof useRespondToUpgradeRequestMutation>;
export type RespondToUpgradeRequestMutationResult = ApolloReactHooks.useMutation.Result<RespondToUpgradeRequestMutation>;
export type RespondToUpgradeRequestMutationOptions = ApolloReactHooks.useMutation.Options<RespondToUpgradeRequestMutation, RespondToUpgradeRequestMutationVariables>;
export const UpdateUserSettingsPropsDocument = gql`
    mutation UpdateUserSettingsProps($input: UpdateUserSettingsInput!) {
  updateUserSettings(input: $input) {
    settings {
      __typename
      id
      hideOnboarding
    }
  }
}
    `;
export type UpdateUserSettingsPropsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateUserSettingsPropsMutation, UpdateUserSettingsPropsMutationVariables>;

/**
 * __useUpdateUserSettingsPropsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsPropsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsPropsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsPropsMutation, { data, loading, error }] = useUpdateUserSettingsPropsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsPropsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateUserSettingsPropsMutation, UpdateUserSettingsPropsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserSettingsPropsMutation, UpdateUserSettingsPropsMutationVariables>(UpdateUserSettingsPropsDocument, options);
      }
export type UpdateUserSettingsPropsMutationHookResult = ReturnType<typeof useUpdateUserSettingsPropsMutation>;
export type UpdateUserSettingsPropsMutationResult = ApolloReactHooks.useMutation.Result<UpdateUserSettingsPropsMutation>;
export type UpdateUserSettingsPropsMutationOptions = ApolloReactHooks.useMutation.Options<UpdateUserSettingsPropsMutation, UpdateUserSettingsPropsMutationVariables>;
export const UpsertUserSignaturesDocument = gql`
    mutation UpsertUserSignatures($input: UpsertUserSignaturesInput!) {
  upsertUserSignatures(input: $input) {
    settings {
      ...UserSettingsSimple
    }
  }
}
    ${UserSettingsSimpleFragmentDoc}`;
export type UpsertUserSignaturesMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpsertUserSignaturesMutation, UpsertUserSignaturesMutationVariables>;

/**
 * __useUpsertUserSignaturesMutation__
 *
 * To run a mutation, you first call `useUpsertUserSignaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserSignaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserSignaturesMutation, { data, loading, error }] = useUpsertUserSignaturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUserSignaturesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpsertUserSignaturesMutation, UpsertUserSignaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertUserSignaturesMutation, UpsertUserSignaturesMutationVariables>(UpsertUserSignaturesDocument, options);
      }
export type UpsertUserSignaturesMutationHookResult = ReturnType<typeof useUpsertUserSignaturesMutation>;
export type UpsertUserSignaturesMutationResult = ApolloReactHooks.useMutation.Result<UpsertUserSignaturesMutation>;
export type UpsertUserSignaturesMutationOptions = ApolloReactHooks.useMutation.Options<UpsertUserSignaturesMutation, UpsertUserSignaturesMutationVariables>;
export const GetUserDocument = gql`
    query GetUser($userId: UUID!) {
  user(userId: $userId) {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUserQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = ApolloReactHooks.useQuery.Result<GetUserQuery, GetUserQueryVariables>;
export const GetDocumentUserDocument = gql`
    query GetDocumentUser($input: DocumentUserInput!) {
  documentUser(input: $input) {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetDocumentUserQuery__
 *
 * To run a query within a React component, call `useGetDocumentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDocumentUserQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentUserQuery, GetDocumentUserQueryVariables> & ({ variables: GetDocumentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentUserQuery, GetDocumentUserQueryVariables>(GetDocumentUserDocument, options);
      }
export function useGetDocumentUserLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentUserQuery, GetDocumentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentUserQuery, GetDocumentUserQueryVariables>(GetDocumentUserDocument, options);
        }
export function useGetDocumentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentUserQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentUserQuery, GetDocumentUserQueryVariables>(GetDocumentUserDocument, options);
        }
export type GetDocumentUserQueryHookResult = ReturnType<typeof useGetDocumentUserQuery>;
export type GetDocumentUserLazyQueryHookResult = ReturnType<typeof useGetDocumentUserLazyQuery>;
export type GetDocumentUserSuspenseQueryHookResult = ReturnType<typeof useGetDocumentUserSuspenseQuery>;
export type GetDocumentUserQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentUserQuery, GetDocumentUserQueryVariables>;
export const GetMyOnboardingInfoDocument = gql`
    query GetMyOnboardingInfo {
  currentUser {
    __typename
    id
    settings {
      ...UserOnboardingInfo
    }
  }
}
    ${UserOnboardingInfoFragmentDoc}`;

/**
 * __useGetMyOnboardingInfoQuery__
 *
 * To run a query within a React component, call `useGetMyOnboardingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOnboardingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOnboardingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOnboardingInfoQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetMyOnboardingInfoQuery, GetMyOnboardingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyOnboardingInfoQuery, GetMyOnboardingInfoQueryVariables>(GetMyOnboardingInfoDocument, options);
      }
export function useGetMyOnboardingInfoLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyOnboardingInfoQuery, GetMyOnboardingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyOnboardingInfoQuery, GetMyOnboardingInfoQueryVariables>(GetMyOnboardingInfoDocument, options);
        }
export function useGetMyOnboardingInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyOnboardingInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyOnboardingInfoQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyOnboardingInfoQuery, GetMyOnboardingInfoQueryVariables>(GetMyOnboardingInfoDocument, options);
        }
export type GetMyOnboardingInfoQueryHookResult = ReturnType<typeof useGetMyOnboardingInfoQuery>;
export type GetMyOnboardingInfoLazyQueryHookResult = ReturnType<typeof useGetMyOnboardingInfoLazyQuery>;
export type GetMyOnboardingInfoSuspenseQueryHookResult = ReturnType<typeof useGetMyOnboardingInfoSuspenseQuery>;
export type GetMyOnboardingInfoQueryResult = ApolloReactHooks.useQuery.Result<GetMyOnboardingInfoQuery, GetMyOnboardingInfoQueryVariables>;
export const GetMyRecentDocumentsDocument = gql`
    query GetMyRecentDocuments($docVariant: DocumentVariant) {
  currentUser {
    __typename
    id
    myRecentDocuments(docVariant: $docVariant) {
      ...WithRecentDocuments
    }
  }
}
    ${WithRecentDocumentsFragmentDoc}`;

/**
 * __useGetMyRecentDocumentsQuery__
 *
 * To run a query within a React component, call `useGetMyRecentDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRecentDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRecentDocumentsQuery({
 *   variables: {
 *      docVariant: // value for 'docVariant'
 *   },
 * });
 */
export function useGetMyRecentDocumentsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetMyRecentDocumentsQuery, GetMyRecentDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyRecentDocumentsQuery, GetMyRecentDocumentsQueryVariables>(GetMyRecentDocumentsDocument, options);
      }
export function useGetMyRecentDocumentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyRecentDocumentsQuery, GetMyRecentDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyRecentDocumentsQuery, GetMyRecentDocumentsQueryVariables>(GetMyRecentDocumentsDocument, options);
        }
export function useGetMyRecentDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyRecentDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyRecentDocumentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyRecentDocumentsQuery, GetMyRecentDocumentsQueryVariables>(GetMyRecentDocumentsDocument, options);
        }
export type GetMyRecentDocumentsQueryHookResult = ReturnType<typeof useGetMyRecentDocumentsQuery>;
export type GetMyRecentDocumentsLazyQueryHookResult = ReturnType<typeof useGetMyRecentDocumentsLazyQuery>;
export type GetMyRecentDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetMyRecentDocumentsSuspenseQuery>;
export type GetMyRecentDocumentsQueryResult = ApolloReactHooks.useQuery.Result<GetMyRecentDocumentsQuery, GetMyRecentDocumentsQueryVariables>;
export const GetFullUserDocument = gql`
    query GetFullUser($userId: UUID!) {
  user(userId: $userId) {
    ...UserFull
  }
}
    ${UserFullFragmentDoc}`;

/**
 * __useGetFullUserQuery__
 *
 * To run a query within a React component, call `useGetFullUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetFullUserQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetFullUserQuery, GetFullUserQueryVariables> & ({ variables: GetFullUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
      }
export function useGetFullUserLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFullUserQuery, GetFullUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
        }
export function useGetFullUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFullUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFullUserQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
        }
export type GetFullUserQueryHookResult = ReturnType<typeof useGetFullUserQuery>;
export type GetFullUserLazyQueryHookResult = ReturnType<typeof useGetFullUserLazyQuery>;
export type GetFullUserSuspenseQueryHookResult = ReturnType<typeof useGetFullUserSuspenseQuery>;
export type GetFullUserQueryResult = ApolloReactHooks.useQuery.Result<GetFullUserQuery, GetFullUserQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers {
  users {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUsersQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = ApolloReactHooks.useQuery.Result<GetUsersQuery, GetUsersQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    __typename
    id
    accountStatus
    accountType
    avatarColor
    displayName
    firstName
    lastName
    email
    jobTitle
    loginType
    myRepositoryId
    role
    supportRole
    createdAt
    updatedAt
    deletedAt
    isDeactivated
    aiUsage {
      usedTokens
      totalAvailableTokens
      usedMicrodollars
      includedMicrodollars
      totalTokensUsed
      resetsAt
    }
    org {
      __typename
      avatarColor
      parentChildEnabled
      id
      name
      workosOrgId
      website
      type
      size
      orgDefaultRole
      signingReminderDays
      trialStartedAt
      trialEndAt
      alineSubscription {
        ...AlineSubscriptionSimple
      }
      avatarImg {
        __typename
        filestackUrl
      }
      defaultBoard {
        __typename
        id
      }
    }
    settings {
      ...UserSettingsSimple
    }
  }
}
    ${AlineSubscriptionSimpleFragmentDoc}
${UserSettingsSimpleFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.useQuery.Options<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<CurrentUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<CurrentUserQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = ApolloReactHooks.useQuery.Result<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetCurrentUserOnboardingInfoDocument = gql`
    query GetCurrentUserOnboardingInfo {
  currentUser {
    __typename
    id
    settings {
      ...UserOnboardingInfo
    }
  }
}
    ${UserOnboardingInfoFragmentDoc}`;

/**
 * __useGetCurrentUserOnboardingInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserOnboardingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserOnboardingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserOnboardingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserOnboardingInfoQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetCurrentUserOnboardingInfoQuery, GetCurrentUserOnboardingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurrentUserOnboardingInfoQuery, GetCurrentUserOnboardingInfoQueryVariables>(GetCurrentUserOnboardingInfoDocument, options);
      }
export function useGetCurrentUserOnboardingInfoLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCurrentUserOnboardingInfoQuery, GetCurrentUserOnboardingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurrentUserOnboardingInfoQuery, GetCurrentUserOnboardingInfoQueryVariables>(GetCurrentUserOnboardingInfoDocument, options);
        }
export function useGetCurrentUserOnboardingInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCurrentUserOnboardingInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCurrentUserOnboardingInfoQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCurrentUserOnboardingInfoQuery, GetCurrentUserOnboardingInfoQueryVariables>(GetCurrentUserOnboardingInfoDocument, options);
        }
export type GetCurrentUserOnboardingInfoQueryHookResult = ReturnType<typeof useGetCurrentUserOnboardingInfoQuery>;
export type GetCurrentUserOnboardingInfoLazyQueryHookResult = ReturnType<typeof useGetCurrentUserOnboardingInfoLazyQuery>;
export type GetCurrentUserOnboardingInfoSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserOnboardingInfoSuspenseQuery>;
export type GetCurrentUserOnboardingInfoQueryResult = ApolloReactHooks.useQuery.Result<GetCurrentUserOnboardingInfoQuery, GetCurrentUserOnboardingInfoQueryVariables>;
export const GetMyOrgMembersDocument = gql`
    query GetMyOrgMembers($filter: OrgMemberFilter!) {
  currentUser {
    __typename
    id
    accountStatus
    avatarColor
    displayName
    email
    firstName
    jobTitle
    lastName
    role
    isDeactivated
    org {
      __typename
      id
      avatarColor
      name
      members(filter: $filter) {
        ...UserBase
      }
      contacts {
        name
        user {
          ...UserBase
        }
      }
    }
    createdAt
    deletedAt
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetMyOrgMembersQuery__
 *
 * To run a query within a React component, call `useGetMyOrgMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrgMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrgMembersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMyOrgMembersQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetMyOrgMembersQuery, GetMyOrgMembersQueryVariables> & ({ variables: GetMyOrgMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyOrgMembersQuery, GetMyOrgMembersQueryVariables>(GetMyOrgMembersDocument, options);
      }
export function useGetMyOrgMembersLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyOrgMembersQuery, GetMyOrgMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyOrgMembersQuery, GetMyOrgMembersQueryVariables>(GetMyOrgMembersDocument, options);
        }
export function useGetMyOrgMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyOrgMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyOrgMembersQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyOrgMembersQuery, GetMyOrgMembersQueryVariables>(GetMyOrgMembersDocument, options);
        }
export type GetMyOrgMembersQueryHookResult = ReturnType<typeof useGetMyOrgMembersQuery>;
export type GetMyOrgMembersLazyQueryHookResult = ReturnType<typeof useGetMyOrgMembersLazyQuery>;
export type GetMyOrgMembersSuspenseQueryHookResult = ReturnType<typeof useGetMyOrgMembersSuspenseQuery>;
export type GetMyOrgMembersQueryResult = ApolloReactHooks.useQuery.Result<GetMyOrgMembersQuery, GetMyOrgMembersQueryVariables>;
export const GetUserAccessLevelDocument = gql`
    query GetUserAccessLevel {
  currentUser {
    id
    numWorkflowsCreatedThisMonth
    org {
      __typename
      id
      trialStartedAt
      trialEndAt
      alineSubscription {
        ...AlineSubscriptionSimple
      }
    }
  }
}
    ${AlineSubscriptionSimpleFragmentDoc}`;

/**
 * __useGetUserAccessLevelQuery__
 *
 * To run a query within a React component, call `useGetUserAccessLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccessLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccessLevelQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAccessLevelQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetUserAccessLevelQuery, GetUserAccessLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserAccessLevelQuery, GetUserAccessLevelQueryVariables>(GetUserAccessLevelDocument, options);
      }
export function useGetUserAccessLevelLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUserAccessLevelQuery, GetUserAccessLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserAccessLevelQuery, GetUserAccessLevelQueryVariables>(GetUserAccessLevelDocument, options);
        }
export function useGetUserAccessLevelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUserAccessLevelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUserAccessLevelQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUserAccessLevelQuery, GetUserAccessLevelQueryVariables>(GetUserAccessLevelDocument, options);
        }
export type GetUserAccessLevelQueryHookResult = ReturnType<typeof useGetUserAccessLevelQuery>;
export type GetUserAccessLevelLazyQueryHookResult = ReturnType<typeof useGetUserAccessLevelLazyQuery>;
export type GetUserAccessLevelSuspenseQueryHookResult = ReturnType<typeof useGetUserAccessLevelSuspenseQuery>;
export type GetUserAccessLevelQueryResult = ApolloReactHooks.useQuery.Result<GetUserAccessLevelQuery, GetUserAccessLevelQueryVariables>;
export const GetLoginTypeDocument = gql`
    query GetLoginType($email: EmailAddress!) {
  loginTypeByEmail(email: $email)
}
    `;

/**
 * __useGetLoginTypeQuery__
 *
 * To run a query within a React component, call `useGetLoginTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoginTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoginTypeQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetLoginTypeQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetLoginTypeQuery, GetLoginTypeQueryVariables> & ({ variables: GetLoginTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLoginTypeQuery, GetLoginTypeQueryVariables>(GetLoginTypeDocument, options);
      }
export function useGetLoginTypeLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetLoginTypeQuery, GetLoginTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLoginTypeQuery, GetLoginTypeQueryVariables>(GetLoginTypeDocument, options);
        }
export function useGetLoginTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetLoginTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetLoginTypeQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetLoginTypeQuery, GetLoginTypeQueryVariables>(GetLoginTypeDocument, options);
        }
export type GetLoginTypeQueryHookResult = ReturnType<typeof useGetLoginTypeQuery>;
export type GetLoginTypeLazyQueryHookResult = ReturnType<typeof useGetLoginTypeLazyQuery>;
export type GetLoginTypeSuspenseQueryHookResult = ReturnType<typeof useGetLoginTypeSuspenseQuery>;
export type GetLoginTypeQueryResult = ApolloReactHooks.useQuery.Result<GetLoginTypeQuery, GetLoginTypeQueryVariables>;
export const AdminAiUsageDocument = gql`
    query AdminAiUsage($input: AdminAiUsageInput!) {
  adminAiUsage(input: $input) {
    summary {
      inputTokensUsed
      outputTokensUsed
      totalTokensUsed
      totalCostMicrodollars
      includedMicrodollars
    }
    series {
      bucketStartDate
      groupKey
      groupLabel
      inputTokensUsed
      outputTokensUsed
      totalTokensUsed
      totalCostMicrodollars
    }
    dimensionOptions {
      users {
        id
        label
      }
      modelKeys
      sources
    }
  }
}
    `;

/**
 * __useAdminAiUsageQuery__
 *
 * To run a query within a React component, call `useAdminAiUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAiUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAiUsageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAiUsageQuery(baseOptions: ApolloReactHooks.useQuery.Options<AdminAiUsageQuery, AdminAiUsageQueryVariables> & ({ variables: AdminAiUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminAiUsageQuery, AdminAiUsageQueryVariables>(AdminAiUsageDocument, options);
      }
export function useAdminAiUsageLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<AdminAiUsageQuery, AdminAiUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminAiUsageQuery, AdminAiUsageQueryVariables>(AdminAiUsageDocument, options);
        }
export function useAdminAiUsageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<AdminAiUsageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<AdminAiUsageQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<AdminAiUsageQuery, AdminAiUsageQueryVariables>(AdminAiUsageDocument, options);
        }
export type AdminAiUsageQueryHookResult = ReturnType<typeof useAdminAiUsageQuery>;
export type AdminAiUsageLazyQueryHookResult = ReturnType<typeof useAdminAiUsageLazyQuery>;
export type AdminAiUsageSuspenseQueryHookResult = ReturnType<typeof useAdminAiUsageSuspenseQuery>;
export type AdminAiUsageQueryResult = ApolloReactHooks.useQuery.Result<AdminAiUsageQuery, AdminAiUsageQueryVariables>;
export const AdminAiUsageDetailRowsDocument = gql`
    query AdminAiUsageDetailRows($input: AdminAiUsageDetailRowsInput!) {
  adminAiUsageDetailRows(input: $input) {
    totalCount
    rows {
      id
      createdAt
      modelKey
      source
      inputTokensUsed
      outputTokensUsed
      totalTokensUsed
      totalCostMicrodollars
      user {
        id
        displayName
        email
      }
    }
  }
}
    `;

/**
 * __useAdminAiUsageDetailRowsQuery__
 *
 * To run a query within a React component, call `useAdminAiUsageDetailRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAiUsageDetailRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAiUsageDetailRowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAiUsageDetailRowsQuery(baseOptions: ApolloReactHooks.useQuery.Options<AdminAiUsageDetailRowsQuery, AdminAiUsageDetailRowsQueryVariables> & ({ variables: AdminAiUsageDetailRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminAiUsageDetailRowsQuery, AdminAiUsageDetailRowsQueryVariables>(AdminAiUsageDetailRowsDocument, options);
      }
export function useAdminAiUsageDetailRowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<AdminAiUsageDetailRowsQuery, AdminAiUsageDetailRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminAiUsageDetailRowsQuery, AdminAiUsageDetailRowsQueryVariables>(AdminAiUsageDetailRowsDocument, options);
        }
export function useAdminAiUsageDetailRowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<AdminAiUsageDetailRowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<AdminAiUsageDetailRowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<AdminAiUsageDetailRowsQuery, AdminAiUsageDetailRowsQueryVariables>(AdminAiUsageDetailRowsDocument, options);
        }
export type AdminAiUsageDetailRowsQueryHookResult = ReturnType<typeof useAdminAiUsageDetailRowsQuery>;
export type AdminAiUsageDetailRowsLazyQueryHookResult = ReturnType<typeof useAdminAiUsageDetailRowsLazyQuery>;
export type AdminAiUsageDetailRowsSuspenseQueryHookResult = ReturnType<typeof useAdminAiUsageDetailRowsSuspenseQuery>;
export type AdminAiUsageDetailRowsQueryResult = ApolloReactHooks.useQuery.Result<AdminAiUsageDetailRowsQuery, AdminAiUsageDetailRowsQueryVariables>;
export const AddToRecentlyAccessedDocumentsDocument = gql`
    mutation AddToRecentlyAccessedDocuments($documentId: UUID!) {
  addToRecentlyAccessedDocuments(documentId: $documentId) {
    user {
      ...UserWithRecentDocuments
    }
  }
}
    ${UserWithRecentDocumentsFragmentDoc}`;
export type AddToRecentlyAccessedDocumentsMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddToRecentlyAccessedDocumentsMutation, AddToRecentlyAccessedDocumentsMutationVariables>;

/**
 * __useAddToRecentlyAccessedDocumentsMutation__
 *
 * To run a mutation, you first call `useAddToRecentlyAccessedDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToRecentlyAccessedDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToRecentlyAccessedDocumentsMutation, { data, loading, error }] = useAddToRecentlyAccessedDocumentsMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useAddToRecentlyAccessedDocumentsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddToRecentlyAccessedDocumentsMutation, AddToRecentlyAccessedDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddToRecentlyAccessedDocumentsMutation, AddToRecentlyAccessedDocumentsMutationVariables>(AddToRecentlyAccessedDocumentsDocument, options);
      }
export type AddToRecentlyAccessedDocumentsMutationHookResult = ReturnType<typeof useAddToRecentlyAccessedDocumentsMutation>;
export type AddToRecentlyAccessedDocumentsMutationResult = ApolloReactHooks.useMutation.Result<AddToRecentlyAccessedDocumentsMutation>;
export type AddToRecentlyAccessedDocumentsMutationOptions = ApolloReactHooks.useMutation.Options<AddToRecentlyAccessedDocumentsMutation, AddToRecentlyAccessedDocumentsMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($userProps: NewUser!) {
  createUser(userProps: $userProps) {
    user {
      ...UserFull
    }
  }
}
    ${UserFullFragmentDoc}`;
export type CreateUserMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      userProps: // value for 'userProps'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactHooks.useMutation.Result<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactHooks.useMutation.Options<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteUsersDocument = gql`
    mutation DeleteUsers($userIds: [UUID!]!) {
  deleteUsers(userIds: $userIds) {
    users {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;
export type DeleteUsersMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteUsersMutation, DeleteUsersMutationVariables>;

/**
 * __useDeleteUsersMutation__
 *
 * To run a mutation, you first call `useDeleteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUsersMutation, { data, loading, error }] = useDeleteUsersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useDeleteUsersMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteUsersMutation, DeleteUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUsersMutation, DeleteUsersMutationVariables>(DeleteUsersDocument, options);
      }
export type DeleteUsersMutationHookResult = ReturnType<typeof useDeleteUsersMutation>;
export type DeleteUsersMutationResult = ApolloReactHooks.useMutation.Result<DeleteUsersMutation>;
export type DeleteUsersMutationOptions = ApolloReactHooks.useMutation.Options<DeleteUsersMutation, DeleteUsersMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: UUID!, $userProps: UpdateUser!) {
  updateUser(userId: $userId, userProps: $userProps) {
    user {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;
export type UpdateUserMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userProps: // value for 'userProps'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactHooks.useMutation.Result<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactHooks.useMutation.Options<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserActivationDocument = gql`
    mutation UpdateUserActivation($userId: UUID!, $isDeactivated: Boolean!) {
  updateUserActivation(userId: $userId, isDeactivated: $isDeactivated) {
    user {
      __typename
      id
      isDeactivated
    }
  }
}
    `;
export type UpdateUserActivationMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateUserActivationMutation, UpdateUserActivationMutationVariables>;

/**
 * __useUpdateUserActivationMutation__
 *
 * To run a mutation, you first call `useUpdateUserActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserActivationMutation, { data, loading, error }] = useUpdateUserActivationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isDeactivated: // value for 'isDeactivated'
 *   },
 * });
 */
export function useUpdateUserActivationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateUserActivationMutation, UpdateUserActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserActivationMutation, UpdateUserActivationMutationVariables>(UpdateUserActivationDocument, options);
      }
export type UpdateUserActivationMutationHookResult = ReturnType<typeof useUpdateUserActivationMutation>;
export type UpdateUserActivationMutationResult = ApolloReactHooks.useMutation.Result<UpdateUserActivationMutation>;
export type UpdateUserActivationMutationOptions = ApolloReactHooks.useMutation.Options<UpdateUserActivationMutation, UpdateUserActivationMutationVariables>;
export const RequestAccountActivationDocument = gql`
    mutation RequestAccountActivation($msg: String) {
  requestAccountActivation(msg: $msg)
}
    `;
export type RequestAccountActivationMutationFn = ApolloReactHooks.useMutation.MutationFunction<RequestAccountActivationMutation, RequestAccountActivationMutationVariables>;

/**
 * __useRequestAccountActivationMutation__
 *
 * To run a mutation, you first call `useRequestAccountActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountActivationMutation, { data, loading, error }] = useRequestAccountActivationMutation({
 *   variables: {
 *      msg: // value for 'msg'
 *   },
 * });
 */
export function useRequestAccountActivationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RequestAccountActivationMutation, RequestAccountActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestAccountActivationMutation, RequestAccountActivationMutationVariables>(RequestAccountActivationDocument, options);
      }
export type RequestAccountActivationMutationHookResult = ReturnType<typeof useRequestAccountActivationMutation>;
export type RequestAccountActivationMutationResult = ApolloReactHooks.useMutation.Result<RequestAccountActivationMutation>;
export type RequestAccountActivationMutationOptions = ApolloReactHooks.useMutation.Options<RequestAccountActivationMutation, RequestAccountActivationMutationVariables>;
export const GetTaskActivityDocument = gql`
    query GetTaskActivity($taskId: UUID!, $cursor: UUID, $before: UUID, $anchor: UUID, $limit: Int, $audience: ActivityAudience, $startAtOldest: Boolean) {
  task(taskId: $taskId) {
    __typename
    id
    workflow {
      __typename
      id
    }
    activity(
      cursor: $cursor
      before: $before
      anchor: $anchor
      limit: $limit
      audience: $audience
      startAtOldest: $startAtOldest
    ) {
      ...ActivityPageFields
    }
  }
}
    ${ActivityPageFieldsFragmentDoc}`;

/**
 * __useGetTaskActivityQuery__
 *
 * To run a query within a React component, call `useGetTaskActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskActivityQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      cursor: // value for 'cursor'
 *      before: // value for 'before'
 *      anchor: // value for 'anchor'
 *      limit: // value for 'limit'
 *      audience: // value for 'audience'
 *      startAtOldest: // value for 'startAtOldest'
 *   },
 * });
 */
export function useGetTaskActivityQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskActivityQuery, GetTaskActivityQueryVariables> & ({ variables: GetTaskActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskActivityQuery, GetTaskActivityQueryVariables>(GetTaskActivityDocument, options);
      }
export function useGetTaskActivityLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskActivityQuery, GetTaskActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskActivityQuery, GetTaskActivityQueryVariables>(GetTaskActivityDocument, options);
        }
export function useGetTaskActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskActivityQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskActivityQuery, GetTaskActivityQueryVariables>(GetTaskActivityDocument, options);
        }
export type GetTaskActivityQueryHookResult = ReturnType<typeof useGetTaskActivityQuery>;
export type GetTaskActivityLazyQueryHookResult = ReturnType<typeof useGetTaskActivityLazyQuery>;
export type GetTaskActivitySuspenseQueryHookResult = ReturnType<typeof useGetTaskActivitySuspenseQuery>;
export type GetTaskActivityQueryResult = ApolloReactHooks.useQuery.Result<GetTaskActivityQuery, GetTaskActivityQueryVariables>;
export const GetWorkflowActivityDocument = gql`
    query GetWorkflowActivity($workflowId: UUID!, $cursor: UUID, $before: UUID, $anchor: UUID, $limit: Int) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    activity(cursor: $cursor, before: $before, anchor: $anchor, limit: $limit) {
      ...ActivityPageFields
    }
  }
}
    ${ActivityPageFieldsFragmentDoc}`;

/**
 * __useGetWorkflowActivityQuery__
 *
 * To run a query within a React component, call `useGetWorkflowActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowActivityQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      cursor: // value for 'cursor'
 *      before: // value for 'before'
 *      anchor: // value for 'anchor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWorkflowActivityQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowActivityQuery, GetWorkflowActivityQueryVariables> & ({ variables: GetWorkflowActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowActivityQuery, GetWorkflowActivityQueryVariables>(GetWorkflowActivityDocument, options);
      }
export function useGetWorkflowActivityLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowActivityQuery, GetWorkflowActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowActivityQuery, GetWorkflowActivityQueryVariables>(GetWorkflowActivityDocument, options);
        }
export function useGetWorkflowActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowActivityQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowActivityQuery, GetWorkflowActivityQueryVariables>(GetWorkflowActivityDocument, options);
        }
export type GetWorkflowActivityQueryHookResult = ReturnType<typeof useGetWorkflowActivityQuery>;
export type GetWorkflowActivityLazyQueryHookResult = ReturnType<typeof useGetWorkflowActivityLazyQuery>;
export type GetWorkflowActivitySuspenseQueryHookResult = ReturnType<typeof useGetWorkflowActivitySuspenseQuery>;
export type GetWorkflowActivityQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowActivityQuery, GetWorkflowActivityQueryVariables>;
export const OnTaskActivityFeedChangedDocument = gql`
    subscription OnTaskActivityFeedChanged($taskId: UUID!) {
  taskActivityFeedChanged(taskId: $taskId) {
    activityItemId
    changeType
    activityItem {
      ...ActivityItemFields
    }
    task {
      __typename
      id
      viewerSubscribed
      viewerSubscriptionLocked
      subscribers {
        ...UserBase
      }
    }
  }
}
    ${ActivityItemFieldsFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useOnTaskActivityFeedChangedSubscription__
 *
 * To run a query within a React component, call `useOnTaskActivityFeedChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTaskActivityFeedChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTaskActivityFeedChangedSubscription({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useOnTaskActivityFeedChangedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnTaskActivityFeedChangedSubscription, OnTaskActivityFeedChangedSubscriptionVariables> & ({ variables: OnTaskActivityFeedChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnTaskActivityFeedChangedSubscription, OnTaskActivityFeedChangedSubscriptionVariables>(OnTaskActivityFeedChangedDocument, options);
      }
export type OnTaskActivityFeedChangedSubscriptionHookResult = ReturnType<typeof useOnTaskActivityFeedChangedSubscription>;
export type OnTaskActivityFeedChangedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnTaskActivityFeedChangedSubscription>;
export const OnWorkflowActivityFeedChangedDocument = gql`
    subscription OnWorkflowActivityFeedChanged($workflowId: UUID!) {
  workflowActivityFeedChanged(workflowId: $workflowId) {
    activityItemId
    changeType
    activityItem {
      ...ActivityItemFields
    }
    workflow {
      __typename
      id
      viewerSubscribed
      viewerSubscriptionLocked
      subscribers {
        ...UserBase
      }
    }
  }
}
    ${ActivityItemFieldsFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useOnWorkflowActivityFeedChangedSubscription__
 *
 * To run a query within a React component, call `useOnWorkflowActivityFeedChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkflowActivityFeedChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkflowActivityFeedChangedSubscription({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useOnWorkflowActivityFeedChangedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnWorkflowActivityFeedChangedSubscription, OnWorkflowActivityFeedChangedSubscriptionVariables> & ({ variables: OnWorkflowActivityFeedChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnWorkflowActivityFeedChangedSubscription, OnWorkflowActivityFeedChangedSubscriptionVariables>(OnWorkflowActivityFeedChangedDocument, options);
      }
export type OnWorkflowActivityFeedChangedSubscriptionHookResult = ReturnType<typeof useOnWorkflowActivityFeedChangedSubscription>;
export type OnWorkflowActivityFeedChangedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnWorkflowActivityFeedChangedSubscription>;
export const GetAgentSkillsDocument = gql`
    query GetAgentSkills($scope: AgentSkillScope) {
  agentSkills(scope: $scope) {
    ...AgentSkillListItem
  }
}
    ${AgentSkillListItemFragmentDoc}`;

/**
 * __useGetAgentSkillsQuery__
 *
 * To run a query within a React component, call `useGetAgentSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentSkillsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetAgentSkillsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetAgentSkillsQuery, GetAgentSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentSkillsQuery, GetAgentSkillsQueryVariables>(GetAgentSkillsDocument, options);
      }
export function useGetAgentSkillsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAgentSkillsQuery, GetAgentSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentSkillsQuery, GetAgentSkillsQueryVariables>(GetAgentSkillsDocument, options);
        }
export function useGetAgentSkillsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAgentSkillsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAgentSkillsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAgentSkillsQuery, GetAgentSkillsQueryVariables>(GetAgentSkillsDocument, options);
        }
export type GetAgentSkillsQueryHookResult = ReturnType<typeof useGetAgentSkillsQuery>;
export type GetAgentSkillsLazyQueryHookResult = ReturnType<typeof useGetAgentSkillsLazyQuery>;
export type GetAgentSkillsSuspenseQueryHookResult = ReturnType<typeof useGetAgentSkillsSuspenseQuery>;
export type GetAgentSkillsQueryResult = ApolloReactHooks.useQuery.Result<GetAgentSkillsQuery, GetAgentSkillsQueryVariables>;
export const GetAgentSkillDocument = gql`
    query GetAgentSkill($id: UUID!) {
  agentSkill(id: $id) {
    ...AgentSkillSimple
  }
}
    ${AgentSkillSimpleFragmentDoc}`;

/**
 * __useGetAgentSkillQuery__
 *
 * To run a query within a React component, call `useGetAgentSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentSkillQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentSkillQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAgentSkillQuery, GetAgentSkillQueryVariables> & ({ variables: GetAgentSkillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentSkillQuery, GetAgentSkillQueryVariables>(GetAgentSkillDocument, options);
      }
export function useGetAgentSkillLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAgentSkillQuery, GetAgentSkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentSkillQuery, GetAgentSkillQueryVariables>(GetAgentSkillDocument, options);
        }
export function useGetAgentSkillSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAgentSkillQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAgentSkillQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAgentSkillQuery, GetAgentSkillQueryVariables>(GetAgentSkillDocument, options);
        }
export type GetAgentSkillQueryHookResult = ReturnType<typeof useGetAgentSkillQuery>;
export type GetAgentSkillLazyQueryHookResult = ReturnType<typeof useGetAgentSkillLazyQuery>;
export type GetAgentSkillSuspenseQueryHookResult = ReturnType<typeof useGetAgentSkillSuspenseQuery>;
export type GetAgentSkillQueryResult = ApolloReactHooks.useQuery.Result<GetAgentSkillQuery, GetAgentSkillQueryVariables>;
export const CreateAgentSkillDocument = gql`
    mutation CreateAgentSkill($input: CreateAgentSkillInput!) {
  createAgentSkill(input: $input) {
    agentSkill {
      ...AgentSkillSimple
    }
  }
}
    ${AgentSkillSimpleFragmentDoc}`;
export type CreateAgentSkillMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAgentSkillMutation, CreateAgentSkillMutationVariables>;

/**
 * __useCreateAgentSkillMutation__
 *
 * To run a mutation, you first call `useCreateAgentSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentSkillMutation, { data, loading, error }] = useCreateAgentSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentSkillMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateAgentSkillMutation, CreateAgentSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAgentSkillMutation, CreateAgentSkillMutationVariables>(CreateAgentSkillDocument, options);
      }
export type CreateAgentSkillMutationHookResult = ReturnType<typeof useCreateAgentSkillMutation>;
export type CreateAgentSkillMutationResult = ApolloReactHooks.useMutation.Result<CreateAgentSkillMutation>;
export type CreateAgentSkillMutationOptions = ApolloReactHooks.useMutation.Options<CreateAgentSkillMutation, CreateAgentSkillMutationVariables>;
export const UpdateAgentSkillDocument = gql`
    mutation UpdateAgentSkill($input: UpdateAgentSkillInput!) {
  updateAgentSkill(input: $input) {
    committedVersionId
    agentSkill {
      ...AgentSkillSimple
    }
  }
}
    ${AgentSkillSimpleFragmentDoc}`;
export type UpdateAgentSkillMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAgentSkillMutation, UpdateAgentSkillMutationVariables>;

/**
 * __useUpdateAgentSkillMutation__
 *
 * To run a mutation, you first call `useUpdateAgentSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentSkillMutation, { data, loading, error }] = useUpdateAgentSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentSkillMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateAgentSkillMutation, UpdateAgentSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentSkillMutation, UpdateAgentSkillMutationVariables>(UpdateAgentSkillDocument, options);
      }
export type UpdateAgentSkillMutationHookResult = ReturnType<typeof useUpdateAgentSkillMutation>;
export type UpdateAgentSkillMutationResult = ApolloReactHooks.useMutation.Result<UpdateAgentSkillMutation>;
export type UpdateAgentSkillMutationOptions = ApolloReactHooks.useMutation.Options<UpdateAgentSkillMutation, UpdateAgentSkillMutationVariables>;
export const SetAgentSkillScopeDocument = gql`
    mutation SetAgentSkillScope($input: SetAgentSkillScopeInput!) {
  setAgentSkillScope(input: $input) {
    agentSkill {
      ...AgentSkillListItem
    }
  }
}
    ${AgentSkillListItemFragmentDoc}`;
export type SetAgentSkillScopeMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetAgentSkillScopeMutation, SetAgentSkillScopeMutationVariables>;

/**
 * __useSetAgentSkillScopeMutation__
 *
 * To run a mutation, you first call `useSetAgentSkillScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAgentSkillScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAgentSkillScopeMutation, { data, loading, error }] = useSetAgentSkillScopeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAgentSkillScopeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetAgentSkillScopeMutation, SetAgentSkillScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetAgentSkillScopeMutation, SetAgentSkillScopeMutationVariables>(SetAgentSkillScopeDocument, options);
      }
export type SetAgentSkillScopeMutationHookResult = ReturnType<typeof useSetAgentSkillScopeMutation>;
export type SetAgentSkillScopeMutationResult = ApolloReactHooks.useMutation.Result<SetAgentSkillScopeMutation>;
export type SetAgentSkillScopeMutationOptions = ApolloReactHooks.useMutation.Options<SetAgentSkillScopeMutation, SetAgentSkillScopeMutationVariables>;
export const DeleteAgentSkillDocument = gql`
    mutation DeleteAgentSkill($id: UUID!) {
  deleteAgentSkill(id: $id) {
    agentSkillId
  }
}
    `;
export type DeleteAgentSkillMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAgentSkillMutation, DeleteAgentSkillMutationVariables>;

/**
 * __useDeleteAgentSkillMutation__
 *
 * To run a mutation, you first call `useDeleteAgentSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentSkillMutation, { data, loading, error }] = useDeleteAgentSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgentSkillMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteAgentSkillMutation, DeleteAgentSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAgentSkillMutation, DeleteAgentSkillMutationVariables>(DeleteAgentSkillDocument, options);
      }
export type DeleteAgentSkillMutationHookResult = ReturnType<typeof useDeleteAgentSkillMutation>;
export type DeleteAgentSkillMutationResult = ApolloReactHooks.useMutation.Result<DeleteAgentSkillMutation>;
export type DeleteAgentSkillMutationOptions = ApolloReactHooks.useMutation.Options<DeleteAgentSkillMutation, DeleteAgentSkillMutationVariables>;
export const AutoSaveAgentSkillDraftDocument = gql`
    mutation AutoSaveAgentSkillDraft($input: AutoSaveAgentSkillDraftInput!) {
  autoSaveAgentSkillDraft(input: $input) {
    agentSkill {
      ...AgentSkillSimple
    }
  }
}
    ${AgentSkillSimpleFragmentDoc}`;
export type AutoSaveAgentSkillDraftMutationFn = ApolloReactHooks.useMutation.MutationFunction<AutoSaveAgentSkillDraftMutation, AutoSaveAgentSkillDraftMutationVariables>;

/**
 * __useAutoSaveAgentSkillDraftMutation__
 *
 * To run a mutation, you first call `useAutoSaveAgentSkillDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoSaveAgentSkillDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoSaveAgentSkillDraftMutation, { data, loading, error }] = useAutoSaveAgentSkillDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutoSaveAgentSkillDraftMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AutoSaveAgentSkillDraftMutation, AutoSaveAgentSkillDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AutoSaveAgentSkillDraftMutation, AutoSaveAgentSkillDraftMutationVariables>(AutoSaveAgentSkillDraftDocument, options);
      }
export type AutoSaveAgentSkillDraftMutationHookResult = ReturnType<typeof useAutoSaveAgentSkillDraftMutation>;
export type AutoSaveAgentSkillDraftMutationResult = ApolloReactHooks.useMutation.Result<AutoSaveAgentSkillDraftMutation>;
export type AutoSaveAgentSkillDraftMutationOptions = ApolloReactHooks.useMutation.Options<AutoSaveAgentSkillDraftMutation, AutoSaveAgentSkillDraftMutationVariables>;
export const TestAgentSkillDraftDocument = gql`
    mutation TestAgentSkillDraft($input: TestAgentSkillDraftInput!) {
  testAgentSkillDraft(input: $input) {
    agentSkill {
      ...AgentSkillSimple
    }
    version {
      id
      name
      description
      publishedAt
    }
  }
}
    ${AgentSkillSimpleFragmentDoc}`;
export type TestAgentSkillDraftMutationFn = ApolloReactHooks.useMutation.MutationFunction<TestAgentSkillDraftMutation, TestAgentSkillDraftMutationVariables>;

/**
 * __useTestAgentSkillDraftMutation__
 *
 * To run a mutation, you first call `useTestAgentSkillDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAgentSkillDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAgentSkillDraftMutation, { data, loading, error }] = useTestAgentSkillDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestAgentSkillDraftMutation(baseOptions?: ApolloReactHooks.useMutation.Options<TestAgentSkillDraftMutation, TestAgentSkillDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestAgentSkillDraftMutation, TestAgentSkillDraftMutationVariables>(TestAgentSkillDraftDocument, options);
      }
export type TestAgentSkillDraftMutationHookResult = ReturnType<typeof useTestAgentSkillDraftMutation>;
export type TestAgentSkillDraftMutationResult = ApolloReactHooks.useMutation.Result<TestAgentSkillDraftMutation>;
export type TestAgentSkillDraftMutationOptions = ApolloReactHooks.useMutation.Options<TestAgentSkillDraftMutation, TestAgentSkillDraftMutationVariables>;
export const PublishAgentSkillDraftDocument = gql`
    mutation PublishAgentSkillDraft($input: PublishAgentSkillDraftInput!) {
  publishAgentSkillDraft(input: $input) {
    agentSkill {
      ...AgentSkillSimple
    }
  }
}
    ${AgentSkillSimpleFragmentDoc}`;
export type PublishAgentSkillDraftMutationFn = ApolloReactHooks.useMutation.MutationFunction<PublishAgentSkillDraftMutation, PublishAgentSkillDraftMutationVariables>;

/**
 * __usePublishAgentSkillDraftMutation__
 *
 * To run a mutation, you first call `usePublishAgentSkillDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAgentSkillDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAgentSkillDraftMutation, { data, loading, error }] = usePublishAgentSkillDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishAgentSkillDraftMutation(baseOptions?: ApolloReactHooks.useMutation.Options<PublishAgentSkillDraftMutation, PublishAgentSkillDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishAgentSkillDraftMutation, PublishAgentSkillDraftMutationVariables>(PublishAgentSkillDraftDocument, options);
      }
export type PublishAgentSkillDraftMutationHookResult = ReturnType<typeof usePublishAgentSkillDraftMutation>;
export type PublishAgentSkillDraftMutationResult = ApolloReactHooks.useMutation.Result<PublishAgentSkillDraftMutation>;
export type PublishAgentSkillDraftMutationOptions = ApolloReactHooks.useMutation.Options<PublishAgentSkillDraftMutation, PublishAgentSkillDraftMutationVariables>;
export const DiscardAgentSkillDraftDocument = gql`
    mutation DiscardAgentSkillDraft($input: DiscardAgentSkillDraftInput!) {
  discardAgentSkillDraft(input: $input) {
    agentSkill {
      ...AgentSkillSimple
    }
  }
}
    ${AgentSkillSimpleFragmentDoc}`;
export type DiscardAgentSkillDraftMutationFn = ApolloReactHooks.useMutation.MutationFunction<DiscardAgentSkillDraftMutation, DiscardAgentSkillDraftMutationVariables>;

/**
 * __useDiscardAgentSkillDraftMutation__
 *
 * To run a mutation, you first call `useDiscardAgentSkillDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardAgentSkillDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardAgentSkillDraftMutation, { data, loading, error }] = useDiscardAgentSkillDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardAgentSkillDraftMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DiscardAgentSkillDraftMutation, DiscardAgentSkillDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DiscardAgentSkillDraftMutation, DiscardAgentSkillDraftMutationVariables>(DiscardAgentSkillDraftDocument, options);
      }
export type DiscardAgentSkillDraftMutationHookResult = ReturnType<typeof useDiscardAgentSkillDraftMutation>;
export type DiscardAgentSkillDraftMutationResult = ApolloReactHooks.useMutation.Result<DiscardAgentSkillDraftMutation>;
export type DiscardAgentSkillDraftMutationOptions = ApolloReactHooks.useMutation.Options<DiscardAgentSkillDraftMutation, DiscardAgentSkillDraftMutationVariables>;
export const RetryAgentSkillFileDocument = gql`
    mutation RetryAgentSkillFile($input: RetryAgentSkillFileInput!) {
  retryAgentSkillFile(input: $input) {
    agentSkill {
      ...AgentSkillSimple
    }
  }
}
    ${AgentSkillSimpleFragmentDoc}`;
export type RetryAgentSkillFileMutationFn = ApolloReactHooks.useMutation.MutationFunction<RetryAgentSkillFileMutation, RetryAgentSkillFileMutationVariables>;

/**
 * __useRetryAgentSkillFileMutation__
 *
 * To run a mutation, you first call `useRetryAgentSkillFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryAgentSkillFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryAgentSkillFileMutation, { data, loading, error }] = useRetryAgentSkillFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryAgentSkillFileMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RetryAgentSkillFileMutation, RetryAgentSkillFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RetryAgentSkillFileMutation, RetryAgentSkillFileMutationVariables>(RetryAgentSkillFileDocument, options);
      }
export type RetryAgentSkillFileMutationHookResult = ReturnType<typeof useRetryAgentSkillFileMutation>;
export type RetryAgentSkillFileMutationResult = ApolloReactHooks.useMutation.Result<RetryAgentSkillFileMutation>;
export type RetryAgentSkillFileMutationOptions = ApolloReactHooks.useMutation.Options<RetryAgentSkillFileMutation, RetryAgentSkillFileMutationVariables>;
export const AgentSkillDraftChangedDocument = gql`
    subscription AgentSkillDraftChanged($skillId: UUID!) {
  agentSkillDraftChanged(skillId: $skillId) {
    ...AgentSkillSimple
  }
}
    ${AgentSkillSimpleFragmentDoc}`;

/**
 * __useAgentSkillDraftChangedSubscription__
 *
 * To run a query within a React component, call `useAgentSkillDraftChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentSkillDraftChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentSkillDraftChangedSubscription({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useAgentSkillDraftChangedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<AgentSkillDraftChangedSubscription, AgentSkillDraftChangedSubscriptionVariables> & ({ variables: AgentSkillDraftChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<AgentSkillDraftChangedSubscription, AgentSkillDraftChangedSubscriptionVariables>(AgentSkillDraftChangedDocument, options);
      }
export type AgentSkillDraftChangedSubscriptionHookResult = ReturnType<typeof useAgentSkillDraftChangedSubscription>;
export type AgentSkillDraftChangedSubscriptionResult = ApolloReactHooks.useSubscription.Result<AgentSkillDraftChangedSubscription>;
export const GetAgentSkillDraftAttachmentDocument = gql`
    query GetAgentSkillDraftAttachment($skillId: UUID!, $sha256: String!) {
  agentSkillDraftAttachment(skillId: $skillId, sha256: $sha256) {
    base64
    contentType
    name
  }
}
    `;

/**
 * __useGetAgentSkillDraftAttachmentQuery__
 *
 * To run a query within a React component, call `useGetAgentSkillDraftAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentSkillDraftAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentSkillDraftAttachmentQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      sha256: // value for 'sha256'
 *   },
 * });
 */
export function useGetAgentSkillDraftAttachmentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAgentSkillDraftAttachmentQuery, GetAgentSkillDraftAttachmentQueryVariables> & ({ variables: GetAgentSkillDraftAttachmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentSkillDraftAttachmentQuery, GetAgentSkillDraftAttachmentQueryVariables>(GetAgentSkillDraftAttachmentDocument, options);
      }
export function useGetAgentSkillDraftAttachmentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAgentSkillDraftAttachmentQuery, GetAgentSkillDraftAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentSkillDraftAttachmentQuery, GetAgentSkillDraftAttachmentQueryVariables>(GetAgentSkillDraftAttachmentDocument, options);
        }
export function useGetAgentSkillDraftAttachmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAgentSkillDraftAttachmentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAgentSkillDraftAttachmentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAgentSkillDraftAttachmentQuery, GetAgentSkillDraftAttachmentQueryVariables>(GetAgentSkillDraftAttachmentDocument, options);
        }
export type GetAgentSkillDraftAttachmentQueryHookResult = ReturnType<typeof useGetAgentSkillDraftAttachmentQuery>;
export type GetAgentSkillDraftAttachmentLazyQueryHookResult = ReturnType<typeof useGetAgentSkillDraftAttachmentLazyQuery>;
export type GetAgentSkillDraftAttachmentSuspenseQueryHookResult = ReturnType<typeof useGetAgentSkillDraftAttachmentSuspenseQuery>;
export type GetAgentSkillDraftAttachmentQueryResult = ApolloReactHooks.useQuery.Result<GetAgentSkillDraftAttachmentQuery, GetAgentSkillDraftAttachmentQueryVariables>;
export const GetAgentSkillAttachmentDocument = gql`
    query GetAgentSkillAttachment($skillId: UUID!, $versionId: UUID!, $path: String!) {
  agentSkillAttachment(skillId: $skillId, versionId: $versionId, path: $path) {
    base64
    contentType
    name
  }
}
    `;

/**
 * __useGetAgentSkillAttachmentQuery__
 *
 * To run a query within a React component, call `useGetAgentSkillAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentSkillAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentSkillAttachmentQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      versionId: // value for 'versionId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetAgentSkillAttachmentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAgentSkillAttachmentQuery, GetAgentSkillAttachmentQueryVariables> & ({ variables: GetAgentSkillAttachmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentSkillAttachmentQuery, GetAgentSkillAttachmentQueryVariables>(GetAgentSkillAttachmentDocument, options);
      }
export function useGetAgentSkillAttachmentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAgentSkillAttachmentQuery, GetAgentSkillAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentSkillAttachmentQuery, GetAgentSkillAttachmentQueryVariables>(GetAgentSkillAttachmentDocument, options);
        }
export function useGetAgentSkillAttachmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAgentSkillAttachmentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAgentSkillAttachmentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAgentSkillAttachmentQuery, GetAgentSkillAttachmentQueryVariables>(GetAgentSkillAttachmentDocument, options);
        }
export type GetAgentSkillAttachmentQueryHookResult = ReturnType<typeof useGetAgentSkillAttachmentQuery>;
export type GetAgentSkillAttachmentLazyQueryHookResult = ReturnType<typeof useGetAgentSkillAttachmentLazyQuery>;
export type GetAgentSkillAttachmentSuspenseQueryHookResult = ReturnType<typeof useGetAgentSkillAttachmentSuspenseQuery>;
export type GetAgentSkillAttachmentQueryResult = ApolloReactHooks.useQuery.Result<GetAgentSkillAttachmentQuery, GetAgentSkillAttachmentQueryVariables>;
export const DuplicateAgentSkillDocument = gql`
    mutation DuplicateAgentSkill($id: UUID!) {
  duplicateAgentSkill(id: $id) {
    agentSkill {
      ...AgentSkillSimple
    }
  }
}
    ${AgentSkillSimpleFragmentDoc}`;
export type DuplicateAgentSkillMutationFn = ApolloReactHooks.useMutation.MutationFunction<DuplicateAgentSkillMutation, DuplicateAgentSkillMutationVariables>;

/**
 * __useDuplicateAgentSkillMutation__
 *
 * To run a mutation, you first call `useDuplicateAgentSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateAgentSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateAgentSkillMutation, { data, loading, error }] = useDuplicateAgentSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateAgentSkillMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DuplicateAgentSkillMutation, DuplicateAgentSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateAgentSkillMutation, DuplicateAgentSkillMutationVariables>(DuplicateAgentSkillDocument, options);
      }
export type DuplicateAgentSkillMutationHookResult = ReturnType<typeof useDuplicateAgentSkillMutation>;
export type DuplicateAgentSkillMutationResult = ApolloReactHooks.useMutation.Result<DuplicateAgentSkillMutation>;
export type DuplicateAgentSkillMutationOptions = ApolloReactHooks.useMutation.Options<DuplicateAgentSkillMutation, DuplicateAgentSkillMutationVariables>;
export const SendAgentPromptDocument = gql`
    mutation SendAgentPrompt($input: AgentPromptInput!) {
  sendAgentPrompt(input: $input) {
    __typename
    threadId
    messageId
    prompt
    agentSkillVersions {
      __typename
      description
      id
      name
      skillId
    }
  }
}
    `;
export type SendAgentPromptMutationFn = ApolloReactHooks.useMutation.MutationFunction<SendAgentPromptMutation, SendAgentPromptMutationVariables>;

/**
 * __useSendAgentPromptMutation__
 *
 * To run a mutation, you first call `useSendAgentPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAgentPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAgentPromptMutation, { data, loading, error }] = useSendAgentPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAgentPromptMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SendAgentPromptMutation, SendAgentPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendAgentPromptMutation, SendAgentPromptMutationVariables>(SendAgentPromptDocument, options);
      }
export type SendAgentPromptMutationHookResult = ReturnType<typeof useSendAgentPromptMutation>;
export type SendAgentPromptMutationResult = ApolloReactHooks.useMutation.Result<SendAgentPromptMutation>;
export type SendAgentPromptMutationOptions = ApolloReactHooks.useMutation.Options<SendAgentPromptMutation, SendAgentPromptMutationVariables>;
export const ContinueAgentChatDocument = gql`
    mutation ContinueAgentChat($input: ContinueAgentChatInput!) {
  continueAgentChat(input: $input) {
    __typename
    threadId
    messageId
    prompt
  }
}
    `;
export type ContinueAgentChatMutationFn = ApolloReactHooks.useMutation.MutationFunction<ContinueAgentChatMutation, ContinueAgentChatMutationVariables>;

/**
 * __useContinueAgentChatMutation__
 *
 * To run a mutation, you first call `useContinueAgentChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueAgentChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueAgentChatMutation, { data, loading, error }] = useContinueAgentChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContinueAgentChatMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ContinueAgentChatMutation, ContinueAgentChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ContinueAgentChatMutation, ContinueAgentChatMutationVariables>(ContinueAgentChatDocument, options);
      }
export type ContinueAgentChatMutationHookResult = ReturnType<typeof useContinueAgentChatMutation>;
export type ContinueAgentChatMutationResult = ApolloReactHooks.useMutation.Result<ContinueAgentChatMutation>;
export type ContinueAgentChatMutationOptions = ApolloReactHooks.useMutation.Options<ContinueAgentChatMutation, ContinueAgentChatMutationVariables>;
export const StartActivityAgentThreadDocument = gql`
    mutation StartActivityAgentThread($input: StartActivityAgentThreadInput!) {
  startActivityAgentThread(input: $input) {
    __typename
    threadId
    messageId
    prompt
    agentSkillVersions {
      __typename
      description
      id
      name
      skillId
    }
  }
}
    `;
export type StartActivityAgentThreadMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartActivityAgentThreadMutation, StartActivityAgentThreadMutationVariables>;

/**
 * __useStartActivityAgentThreadMutation__
 *
 * To run a mutation, you first call `useStartActivityAgentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartActivityAgentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startActivityAgentThreadMutation, { data, loading, error }] = useStartActivityAgentThreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartActivityAgentThreadMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartActivityAgentThreadMutation, StartActivityAgentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartActivityAgentThreadMutation, StartActivityAgentThreadMutationVariables>(StartActivityAgentThreadDocument, options);
      }
export type StartActivityAgentThreadMutationHookResult = ReturnType<typeof useStartActivityAgentThreadMutation>;
export type StartActivityAgentThreadMutationResult = ApolloReactHooks.useMutation.Result<StartActivityAgentThreadMutation>;
export type StartActivityAgentThreadMutationOptions = ApolloReactHooks.useMutation.Options<StartActivityAgentThreadMutation, StartActivityAgentThreadMutationVariables>;
export const UpdateAgentMessageSuggestionsDocument = gql`
    mutation UpdateAgentMessageSuggestions($input: AgentMessageSuggestionsInput!) {
  updateAgentMessageSuggestions(input: $input) {
    __typename
    id
    data
  }
}
    `;
export type UpdateAgentMessageSuggestionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAgentMessageSuggestionsMutation, UpdateAgentMessageSuggestionsMutationVariables>;

/**
 * __useUpdateAgentMessageSuggestionsMutation__
 *
 * To run a mutation, you first call `useUpdateAgentMessageSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentMessageSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentMessageSuggestionsMutation, { data, loading, error }] = useUpdateAgentMessageSuggestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentMessageSuggestionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateAgentMessageSuggestionsMutation, UpdateAgentMessageSuggestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentMessageSuggestionsMutation, UpdateAgentMessageSuggestionsMutationVariables>(UpdateAgentMessageSuggestionsDocument, options);
      }
export type UpdateAgentMessageSuggestionsMutationHookResult = ReturnType<typeof useUpdateAgentMessageSuggestionsMutation>;
export type UpdateAgentMessageSuggestionsMutationResult = ApolloReactHooks.useMutation.Result<UpdateAgentMessageSuggestionsMutation>;
export type UpdateAgentMessageSuggestionsMutationOptions = ApolloReactHooks.useMutation.Options<UpdateAgentMessageSuggestionsMutation, UpdateAgentMessageSuggestionsMutationVariables>;
export const UpdateAgentMessageFeedbackDocument = gql`
    mutation UpdateAgentMessageFeedback($input: AgentMessageSuggestionFeedbackInput!) {
  updateAgentMessageFeedback(input: $input) {
    __typename
    id
    feedback
  }
}
    `;
export type UpdateAgentMessageFeedbackMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAgentMessageFeedbackMutation, UpdateAgentMessageFeedbackMutationVariables>;

/**
 * __useUpdateAgentMessageFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateAgentMessageFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentMessageFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentMessageFeedbackMutation, { data, loading, error }] = useUpdateAgentMessageFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentMessageFeedbackMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateAgentMessageFeedbackMutation, UpdateAgentMessageFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentMessageFeedbackMutation, UpdateAgentMessageFeedbackMutationVariables>(UpdateAgentMessageFeedbackDocument, options);
      }
export type UpdateAgentMessageFeedbackMutationHookResult = ReturnType<typeof useUpdateAgentMessageFeedbackMutation>;
export type UpdateAgentMessageFeedbackMutationResult = ApolloReactHooks.useMutation.Result<UpdateAgentMessageFeedbackMutation>;
export type UpdateAgentMessageFeedbackMutationOptions = ApolloReactHooks.useMutation.Options<UpdateAgentMessageFeedbackMutation, UpdateAgentMessageFeedbackMutationVariables>;
export const DeleteAgentThreadDocument = gql`
    mutation DeleteAgentThread($threadId: UUID!) {
  deleteAgentThread(threadId: $threadId)
}
    `;
export type DeleteAgentThreadMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAgentThreadMutation, DeleteAgentThreadMutationVariables>;

/**
 * __useDeleteAgentThreadMutation__
 *
 * To run a mutation, you first call `useDeleteAgentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentThreadMutation, { data, loading, error }] = useDeleteAgentThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteAgentThreadMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteAgentThreadMutation, DeleteAgentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAgentThreadMutation, DeleteAgentThreadMutationVariables>(DeleteAgentThreadDocument, options);
      }
export type DeleteAgentThreadMutationHookResult = ReturnType<typeof useDeleteAgentThreadMutation>;
export type DeleteAgentThreadMutationResult = ApolloReactHooks.useMutation.Result<DeleteAgentThreadMutation>;
export type DeleteAgentThreadMutationOptions = ApolloReactHooks.useMutation.Options<DeleteAgentThreadMutation, DeleteAgentThreadMutationVariables>;
export const GetMentionEntitiesDocument = gql`
    query GetMentionEntities($input: MentionEntitiesInput!) {
  mentionEntities(input: $input) {
    __typename
    documents {
      ... on Document {
        __typename
        id
        isSavePending
        name
        variant
        latestVersion {
          ... on FileVersionInterface {
            __typename
            id
            vectorsFailedAt
            vectorsSavedAt
            vectorsStartedAt
          }
          ... on StaticFileVersion {
            fileExtractionFailedAt
            fileExtractionFinishedAt
            fileExtractionStartedAt
            fileLocation {
              __typename
              id
              mimetype
            }
          }
        }
      }
      ... on MentionAccessError {
        __typename
        id
        reason
      }
    }
    playbooks {
      ... on Playbook {
        __typename
        id
        title
        description
      }
      ... on MentionAccessError {
        __typename
        id
        reason
      }
    }
    tasks {
      ... on Task {
        __typename
        id
        title
        workflow {
          __typename
          id
          name
        }
      }
      ... on MentionAccessError {
        __typename
        id
        reason
      }
    }
    workflows {
      ... on Workflow {
        __typename
        id
        name
      }
      ... on MentionAccessError {
        __typename
        id
        reason
      }
    }
    reports {
      ... on Report {
        __typename
        id
        name
      }
      ... on MentionAccessError {
        __typename
        id
        reason
      }
    }
    skillVersions {
      ... on AgentSkillVersion {
        __typename
        description
        id
        name
        skillId
      }
      ... on MentionAccessError {
        __typename
        id
        reason
      }
    }
  }
}
    `;

/**
 * __useGetMentionEntitiesQuery__
 *
 * To run a query within a React component, call `useGetMentionEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentionEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentionEntitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMentionEntitiesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetMentionEntitiesQuery, GetMentionEntitiesQueryVariables> & ({ variables: GetMentionEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMentionEntitiesQuery, GetMentionEntitiesQueryVariables>(GetMentionEntitiesDocument, options);
      }
export function useGetMentionEntitiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMentionEntitiesQuery, GetMentionEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMentionEntitiesQuery, GetMentionEntitiesQueryVariables>(GetMentionEntitiesDocument, options);
        }
export function useGetMentionEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMentionEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMentionEntitiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMentionEntitiesQuery, GetMentionEntitiesQueryVariables>(GetMentionEntitiesDocument, options);
        }
export type GetMentionEntitiesQueryHookResult = ReturnType<typeof useGetMentionEntitiesQuery>;
export type GetMentionEntitiesLazyQueryHookResult = ReturnType<typeof useGetMentionEntitiesLazyQuery>;
export type GetMentionEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetMentionEntitiesSuspenseQuery>;
export type GetMentionEntitiesQueryResult = ApolloReactHooks.useQuery.Result<GetMentionEntitiesQuery, GetMentionEntitiesQueryVariables>;
export const SearchMentionEntitiesDocument = gql`
    query SearchMentionEntities($input: SearchMentionEntitiesInput!) {
  searchMentionEntities(input: $input) {
    groups {
      type
      totalCount
      pageInfo {
        hasMore
        nextCursor {
          type
          id
        }
      }
      results {
        __typename
        ... on Document {
          id
          name
          isSavePending
          status
          variant
          latestVersion {
            ...FileVersionSimple
          }
          storableType
        }
        ... on Playbook {
          id
          title
          description
        }
        ... on Report {
          id
          name
        }
        ... on User {
          ...UserBase
        }
        ... on Workflow {
          id
          name
        }
      }
    }
  }
}
    ${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useSearchMentionEntitiesQuery__
 *
 * To run a query within a React component, call `useSearchMentionEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMentionEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMentionEntitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchMentionEntitiesQuery(baseOptions: ApolloReactHooks.useQuery.Options<SearchMentionEntitiesQuery, SearchMentionEntitiesQueryVariables> & ({ variables: SearchMentionEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchMentionEntitiesQuery, SearchMentionEntitiesQueryVariables>(SearchMentionEntitiesDocument, options);
      }
export function useSearchMentionEntitiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<SearchMentionEntitiesQuery, SearchMentionEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchMentionEntitiesQuery, SearchMentionEntitiesQueryVariables>(SearchMentionEntitiesDocument, options);
        }
export function useSearchMentionEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<SearchMentionEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<SearchMentionEntitiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<SearchMentionEntitiesQuery, SearchMentionEntitiesQueryVariables>(SearchMentionEntitiesDocument, options);
        }
export type SearchMentionEntitiesQueryHookResult = ReturnType<typeof useSearchMentionEntitiesQuery>;
export type SearchMentionEntitiesLazyQueryHookResult = ReturnType<typeof useSearchMentionEntitiesLazyQuery>;
export type SearchMentionEntitiesSuspenseQueryHookResult = ReturnType<typeof useSearchMentionEntitiesSuspenseQuery>;
export type SearchMentionEntitiesQueryResult = ApolloReactHooks.useQuery.Result<SearchMentionEntitiesQuery, SearchMentionEntitiesQueryVariables>;
export const UpdateAgentThreadTitleDocument = gql`
    mutation UpdateAgentThreadTitle($threadId: UUID!, $title: String!) {
  updateAgentThreadTitle(threadId: $threadId, title: $title) {
    __typename
    id
    title
  }
}
    `;
export type UpdateAgentThreadTitleMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAgentThreadTitleMutation, UpdateAgentThreadTitleMutationVariables>;

/**
 * __useUpdateAgentThreadTitleMutation__
 *
 * To run a mutation, you first call `useUpdateAgentThreadTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentThreadTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentThreadTitleMutation, { data, loading, error }] = useUpdateAgentThreadTitleMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateAgentThreadTitleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateAgentThreadTitleMutation, UpdateAgentThreadTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentThreadTitleMutation, UpdateAgentThreadTitleMutationVariables>(UpdateAgentThreadTitleDocument, options);
      }
export type UpdateAgentThreadTitleMutationHookResult = ReturnType<typeof useUpdateAgentThreadTitleMutation>;
export type UpdateAgentThreadTitleMutationResult = ApolloReactHooks.useMutation.Result<UpdateAgentThreadTitleMutation>;
export type UpdateAgentThreadTitleMutationOptions = ApolloReactHooks.useMutation.Options<UpdateAgentThreadTitleMutation, UpdateAgentThreadTitleMutationVariables>;
export const RecreateAgentArtifactDocumentDocument = gql`
    mutation RecreateAgentArtifactDocument($messageId: UUID!, $documentId: UUID!, $html: String!, $title: String!) {
  recreateAgentArtifactDocument(
    messageId: $messageId
    documentId: $documentId
    html: $html
    title: $title
  ) {
    __typename
    agentMessageId
    kindList
    createdAt
    document {
      __typename
      id
      name
      deletedAt
    }
  }
}
    `;
export type RecreateAgentArtifactDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<RecreateAgentArtifactDocumentMutation, RecreateAgentArtifactDocumentMutationVariables>;

/**
 * __useRecreateAgentArtifactDocumentMutation__
 *
 * To run a mutation, you first call `useRecreateAgentArtifactDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecreateAgentArtifactDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recreateAgentArtifactDocumentMutation, { data, loading, error }] = useRecreateAgentArtifactDocumentMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      documentId: // value for 'documentId'
 *      html: // value for 'html'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRecreateAgentArtifactDocumentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RecreateAgentArtifactDocumentMutation, RecreateAgentArtifactDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecreateAgentArtifactDocumentMutation, RecreateAgentArtifactDocumentMutationVariables>(RecreateAgentArtifactDocumentDocument, options);
      }
export type RecreateAgentArtifactDocumentMutationHookResult = ReturnType<typeof useRecreateAgentArtifactDocumentMutation>;
export type RecreateAgentArtifactDocumentMutationResult = ApolloReactHooks.useMutation.Result<RecreateAgentArtifactDocumentMutation>;
export type RecreateAgentArtifactDocumentMutationOptions = ApolloReactHooks.useMutation.Options<RecreateAgentArtifactDocumentMutation, RecreateAgentArtifactDocumentMutationVariables>;
export const StopChatMessageStreamDocument = gql`
    mutation StopChatMessageStream($threadId: UUID!) {
  stopChatMessageStream(threadId: $threadId) {
    __typename
    id
    messages {
      __typename
      id
      status
      text
    }
  }
}
    `;
export type StopChatMessageStreamMutationFn = ApolloReactHooks.useMutation.MutationFunction<StopChatMessageStreamMutation, StopChatMessageStreamMutationVariables>;

/**
 * __useStopChatMessageStreamMutation__
 *
 * To run a mutation, you first call `useStopChatMessageStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopChatMessageStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopChatMessageStreamMutation, { data, loading, error }] = useStopChatMessageStreamMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useStopChatMessageStreamMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StopChatMessageStreamMutation, StopChatMessageStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopChatMessageStreamMutation, StopChatMessageStreamMutationVariables>(StopChatMessageStreamDocument, options);
      }
export type StopChatMessageStreamMutationHookResult = ReturnType<typeof useStopChatMessageStreamMutation>;
export type StopChatMessageStreamMutationResult = ApolloReactHooks.useMutation.Result<StopChatMessageStreamMutation>;
export type StopChatMessageStreamMutationOptions = ApolloReactHooks.useMutation.Options<StopChatMessageStreamMutation, StopChatMessageStreamMutationVariables>;
export const GetAgentThreadSkillAudienceDocument = gql`
    query GetAgentThreadSkillAudience($id: UUID!) {
  agentThread(id: $id) {
    __typename
    id
    usesSharedSkills
  }
}
    `;

/**
 * __useGetAgentThreadSkillAudienceQuery__
 *
 * To run a query within a React component, call `useGetAgentThreadSkillAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentThreadSkillAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentThreadSkillAudienceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentThreadSkillAudienceQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAgentThreadSkillAudienceQuery, GetAgentThreadSkillAudienceQueryVariables> & ({ variables: GetAgentThreadSkillAudienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentThreadSkillAudienceQuery, GetAgentThreadSkillAudienceQueryVariables>(GetAgentThreadSkillAudienceDocument, options);
      }
export function useGetAgentThreadSkillAudienceLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAgentThreadSkillAudienceQuery, GetAgentThreadSkillAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentThreadSkillAudienceQuery, GetAgentThreadSkillAudienceQueryVariables>(GetAgentThreadSkillAudienceDocument, options);
        }
export function useGetAgentThreadSkillAudienceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAgentThreadSkillAudienceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAgentThreadSkillAudienceQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAgentThreadSkillAudienceQuery, GetAgentThreadSkillAudienceQueryVariables>(GetAgentThreadSkillAudienceDocument, options);
        }
export type GetAgentThreadSkillAudienceQueryHookResult = ReturnType<typeof useGetAgentThreadSkillAudienceQuery>;
export type GetAgentThreadSkillAudienceLazyQueryHookResult = ReturnType<typeof useGetAgentThreadSkillAudienceLazyQuery>;
export type GetAgentThreadSkillAudienceSuspenseQueryHookResult = ReturnType<typeof useGetAgentThreadSkillAudienceSuspenseQuery>;
export type GetAgentThreadSkillAudienceQueryResult = ApolloReactHooks.useQuery.Result<GetAgentThreadSkillAudienceQuery, GetAgentThreadSkillAudienceQueryVariables>;
export const GetAgentThreadDocument = gql`
    query GetAgentThread($id: UUID!) {
  agentThread(id: $id) {
    __typename
    id
    title
    context {
      __typename
      id
      name
      variant
      latestVersion {
        ... on FileVersionInterface {
          __typename
          id
        }
        ... on StaticFileVersion {
          fileLocation {
            __typename
            mimetype
          }
        }
      }
    }
    messages {
      __typename
      id
      role
      status
      feedback
      text
      data
      planState
      createdAt
    }
    artifacts {
      __typename
      ... on ThreadDocumentArtifact {
        agentMessageId
        kindList
        createdAt
        document {
          __typename
          id
          name
          deletedAt
        }
      }
      ... on ThreadReportArtifact {
        agentMessageId
        createdAt
        report {
          __typename
          id
          name
        }
      }
      ... on ThreadSkillArtifact {
        agentMessageId
        createdAt
        kindList
        skill {
          __typename
          id
          name
          scope
          isComplete
          currentVersion {
            id
            name
            description
          }
        }
      }
      ... on ThreadTaskArtifact {
        agentMessageId
        createdAt
        task {
          __typename
          id
          title
        }
      }
      ... on ThreadWorkflowArtifact {
        agentMessageId
        createdAt
        kindList
        workflow {
          __typename
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetAgentThreadQuery__
 *
 * To run a query within a React component, call `useGetAgentThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentThreadQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAgentThreadQuery, GetAgentThreadQueryVariables> & ({ variables: GetAgentThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentThreadQuery, GetAgentThreadQueryVariables>(GetAgentThreadDocument, options);
      }
export function useGetAgentThreadLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAgentThreadQuery, GetAgentThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentThreadQuery, GetAgentThreadQueryVariables>(GetAgentThreadDocument, options);
        }
export function useGetAgentThreadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAgentThreadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAgentThreadQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAgentThreadQuery, GetAgentThreadQueryVariables>(GetAgentThreadDocument, options);
        }
export type GetAgentThreadQueryHookResult = ReturnType<typeof useGetAgentThreadQuery>;
export type GetAgentThreadLazyQueryHookResult = ReturnType<typeof useGetAgentThreadLazyQuery>;
export type GetAgentThreadSuspenseQueryHookResult = ReturnType<typeof useGetAgentThreadSuspenseQuery>;
export type GetAgentThreadQueryResult = ApolloReactHooks.useQuery.Result<GetAgentThreadQuery, GetAgentThreadQueryVariables>;
export const GetAgentThreadsDocument = gql`
    query GetAgentThreads($filter: AgentThreadHistoryFilter!) {
  agentThreads(filter: $filter) {
    __typename
    id
    title
    createdAt
  }
}
    `;

/**
 * __useGetAgentThreadsQuery__
 *
 * To run a query within a React component, call `useGetAgentThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentThreadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAgentThreadsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAgentThreadsQuery, GetAgentThreadsQueryVariables> & ({ variables: GetAgentThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentThreadsQuery, GetAgentThreadsQueryVariables>(GetAgentThreadsDocument, options);
      }
export function useGetAgentThreadsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAgentThreadsQuery, GetAgentThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentThreadsQuery, GetAgentThreadsQueryVariables>(GetAgentThreadsDocument, options);
        }
export function useGetAgentThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAgentThreadsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAgentThreadsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAgentThreadsQuery, GetAgentThreadsQueryVariables>(GetAgentThreadsDocument, options);
        }
export type GetAgentThreadsQueryHookResult = ReturnType<typeof useGetAgentThreadsQuery>;
export type GetAgentThreadsLazyQueryHookResult = ReturnType<typeof useGetAgentThreadsLazyQuery>;
export type GetAgentThreadsSuspenseQueryHookResult = ReturnType<typeof useGetAgentThreadsSuspenseQuery>;
export type GetAgentThreadsQueryResult = ApolloReactHooks.useQuery.Result<GetAgentThreadsQuery, GetAgentThreadsQueryVariables>;
export const OnAgentEventDocument = gql`
    subscription OnAgentEvent {
  onAgentEvent {
    __typename
    ... on AssistantMessageEvent {
      threadId
      userId
      message {
        __typename
        id
        status
        text
      }
    }
    ... on LoadingEvent {
      threadId
      userId
      messageId
      thinkingMessage
    }
    ... on ToolStatusUpdateEvent {
      threadId
      userId
      messageId
      data
    }
    ... on TitleUpdateEvent {
      threadId
      userId
      title
    }
    ... on PlanSnapshotEvent {
      threadId
      userId
      messageId
      planJson
    }
    ... on ArtifactCreatedEvent {
      threadId
      userId
      messageId
      agentMessageId
      kindList
      artifactCreatedAt
      documentId
      documentName
      documentDeletedAt
    }
    ... on ReportArtifactCreatedEvent {
      threadId
      userId
      agentMessageId
      reportId
      reportName
      artifactCreatedAt
    }
    ... on SkillArtifactCreatedEvent {
      threadId
      userId
      agentMessageId
      skillId
      skillName
      artifactCreatedAt
      kindList
    }
    ... on WorkflowArtifactCreatedEvent {
      threadId
      userId
      agentMessageId
      workflowId
      workflowName
      artifactCreatedAt
      kindList
    }
  }
}
    `;

/**
 * __useOnAgentEventSubscription__
 *
 * To run a query within a React component, call `useOnAgentEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAgentEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAgentEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAgentEventSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnAgentEventSubscription, OnAgentEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnAgentEventSubscription, OnAgentEventSubscriptionVariables>(OnAgentEventDocument, options);
      }
export type OnAgentEventSubscriptionHookResult = ReturnType<typeof useOnAgentEventSubscription>;
export type OnAgentEventSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnAgentEventSubscription>;
export const GetAiReminderAutomationDocument = gql`
    query GetAIReminderAutomation($automationId: UUID!) {
  aiReminderAutomation(automationId: $automationId) {
    ...AIReminderAutomationWithRelations
    runs {
      ...AIReminderAutomationRunSimple
      document {
        __typename
        id
        name
      }
    }
  }
}
    ${AiReminderAutomationWithRelationsFragmentDoc}
${AiReminderAutomationRunSimpleFragmentDoc}`;

/**
 * __useGetAiReminderAutomationQuery__
 *
 * To run a query within a React component, call `useGetAiReminderAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiReminderAutomationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiReminderAutomationQuery({
 *   variables: {
 *      automationId: // value for 'automationId'
 *   },
 * });
 */
export function useGetAiReminderAutomationQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAiReminderAutomationQuery, GetAiReminderAutomationQueryVariables> & ({ variables: GetAiReminderAutomationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAiReminderAutomationQuery, GetAiReminderAutomationQueryVariables>(GetAiReminderAutomationDocument, options);
      }
export function useGetAiReminderAutomationLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAiReminderAutomationQuery, GetAiReminderAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAiReminderAutomationQuery, GetAiReminderAutomationQueryVariables>(GetAiReminderAutomationDocument, options);
        }
export function useGetAiReminderAutomationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAiReminderAutomationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAiReminderAutomationQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAiReminderAutomationQuery, GetAiReminderAutomationQueryVariables>(GetAiReminderAutomationDocument, options);
        }
export type GetAiReminderAutomationQueryHookResult = ReturnType<typeof useGetAiReminderAutomationQuery>;
export type GetAiReminderAutomationLazyQueryHookResult = ReturnType<typeof useGetAiReminderAutomationLazyQuery>;
export type GetAiReminderAutomationSuspenseQueryHookResult = ReturnType<typeof useGetAiReminderAutomationSuspenseQuery>;
export type GetAiReminderAutomationQueryResult = ApolloReactHooks.useQuery.Result<GetAiReminderAutomationQuery, GetAiReminderAutomationQueryVariables>;
export const GetAiReminderAutomationsByReportDocument = gql`
    query GetAIReminderAutomationsByReport($reportId: UUID!) {
  aiReminderAutomationsByReport(reportId: $reportId) {
    ...AIReminderAutomationWithRelations
  }
}
    ${AiReminderAutomationWithRelationsFragmentDoc}`;

/**
 * __useGetAiReminderAutomationsByReportQuery__
 *
 * To run a query within a React component, call `useGetAiReminderAutomationsByReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiReminderAutomationsByReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiReminderAutomationsByReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetAiReminderAutomationsByReportQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAiReminderAutomationsByReportQuery, GetAiReminderAutomationsByReportQueryVariables> & ({ variables: GetAiReminderAutomationsByReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAiReminderAutomationsByReportQuery, GetAiReminderAutomationsByReportQueryVariables>(GetAiReminderAutomationsByReportDocument, options);
      }
export function useGetAiReminderAutomationsByReportLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAiReminderAutomationsByReportQuery, GetAiReminderAutomationsByReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAiReminderAutomationsByReportQuery, GetAiReminderAutomationsByReportQueryVariables>(GetAiReminderAutomationsByReportDocument, options);
        }
export function useGetAiReminderAutomationsByReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAiReminderAutomationsByReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAiReminderAutomationsByReportQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAiReminderAutomationsByReportQuery, GetAiReminderAutomationsByReportQueryVariables>(GetAiReminderAutomationsByReportDocument, options);
        }
export type GetAiReminderAutomationsByReportQueryHookResult = ReturnType<typeof useGetAiReminderAutomationsByReportQuery>;
export type GetAiReminderAutomationsByReportLazyQueryHookResult = ReturnType<typeof useGetAiReminderAutomationsByReportLazyQuery>;
export type GetAiReminderAutomationsByReportSuspenseQueryHookResult = ReturnType<typeof useGetAiReminderAutomationsByReportSuspenseQuery>;
export type GetAiReminderAutomationsByReportQueryResult = ApolloReactHooks.useQuery.Result<GetAiReminderAutomationsByReportQuery, GetAiReminderAutomationsByReportQueryVariables>;
export const GetAiReminderAutomationsDocument = gql`
    query GetAIReminderAutomations {
  aiReminderAutomations {
    ...AIReminderAutomationWithRelations
  }
}
    ${AiReminderAutomationWithRelationsFragmentDoc}`;

/**
 * __useGetAiReminderAutomationsQuery__
 *
 * To run a query within a React component, call `useGetAiReminderAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiReminderAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiReminderAutomationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiReminderAutomationsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetAiReminderAutomationsQuery, GetAiReminderAutomationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAiReminderAutomationsQuery, GetAiReminderAutomationsQueryVariables>(GetAiReminderAutomationsDocument, options);
      }
export function useGetAiReminderAutomationsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAiReminderAutomationsQuery, GetAiReminderAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAiReminderAutomationsQuery, GetAiReminderAutomationsQueryVariables>(GetAiReminderAutomationsDocument, options);
        }
export function useGetAiReminderAutomationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAiReminderAutomationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAiReminderAutomationsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAiReminderAutomationsQuery, GetAiReminderAutomationsQueryVariables>(GetAiReminderAutomationsDocument, options);
        }
export type GetAiReminderAutomationsQueryHookResult = ReturnType<typeof useGetAiReminderAutomationsQuery>;
export type GetAiReminderAutomationsLazyQueryHookResult = ReturnType<typeof useGetAiReminderAutomationsLazyQuery>;
export type GetAiReminderAutomationsSuspenseQueryHookResult = ReturnType<typeof useGetAiReminderAutomationsSuspenseQuery>;
export type GetAiReminderAutomationsQueryResult = ApolloReactHooks.useQuery.Result<GetAiReminderAutomationsQuery, GetAiReminderAutomationsQueryVariables>;
export const GetAiReminderAutomationRunsDocument = gql`
    query GetAIReminderAutomationRuns($automationId: UUID!) {
  aiReminderAutomationRuns(automationId: $automationId) {
    ...AIReminderAutomationRunSimple
    document {
      __typename
      id
      name
    }
  }
}
    ${AiReminderAutomationRunSimpleFragmentDoc}`;

/**
 * __useGetAiReminderAutomationRunsQuery__
 *
 * To run a query within a React component, call `useGetAiReminderAutomationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiReminderAutomationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiReminderAutomationRunsQuery({
 *   variables: {
 *      automationId: // value for 'automationId'
 *   },
 * });
 */
export function useGetAiReminderAutomationRunsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAiReminderAutomationRunsQuery, GetAiReminderAutomationRunsQueryVariables> & ({ variables: GetAiReminderAutomationRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAiReminderAutomationRunsQuery, GetAiReminderAutomationRunsQueryVariables>(GetAiReminderAutomationRunsDocument, options);
      }
export function useGetAiReminderAutomationRunsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAiReminderAutomationRunsQuery, GetAiReminderAutomationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAiReminderAutomationRunsQuery, GetAiReminderAutomationRunsQueryVariables>(GetAiReminderAutomationRunsDocument, options);
        }
export function useGetAiReminderAutomationRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAiReminderAutomationRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAiReminderAutomationRunsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAiReminderAutomationRunsQuery, GetAiReminderAutomationRunsQueryVariables>(GetAiReminderAutomationRunsDocument, options);
        }
export type GetAiReminderAutomationRunsQueryHookResult = ReturnType<typeof useGetAiReminderAutomationRunsQuery>;
export type GetAiReminderAutomationRunsLazyQueryHookResult = ReturnType<typeof useGetAiReminderAutomationRunsLazyQuery>;
export type GetAiReminderAutomationRunsSuspenseQueryHookResult = ReturnType<typeof useGetAiReminderAutomationRunsSuspenseQuery>;
export type GetAiReminderAutomationRunsQueryResult = ApolloReactHooks.useQuery.Result<GetAiReminderAutomationRunsQuery, GetAiReminderAutomationRunsQueryVariables>;
export const CreateAiReminderAutomationDocument = gql`
    mutation CreateAIReminderAutomation($input: CreateAIReminderAutomationInput!) {
  createAIReminderAutomation(input: $input) {
    ...AIReminderAutomationWithRelations
  }
}
    ${AiReminderAutomationWithRelationsFragmentDoc}`;
export type CreateAiReminderAutomationMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAiReminderAutomationMutation, CreateAiReminderAutomationMutationVariables>;

/**
 * __useCreateAiReminderAutomationMutation__
 *
 * To run a mutation, you first call `useCreateAiReminderAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiReminderAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiReminderAutomationMutation, { data, loading, error }] = useCreateAiReminderAutomationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiReminderAutomationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateAiReminderAutomationMutation, CreateAiReminderAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAiReminderAutomationMutation, CreateAiReminderAutomationMutationVariables>(CreateAiReminderAutomationDocument, options);
      }
export type CreateAiReminderAutomationMutationHookResult = ReturnType<typeof useCreateAiReminderAutomationMutation>;
export type CreateAiReminderAutomationMutationResult = ApolloReactHooks.useMutation.Result<CreateAiReminderAutomationMutation>;
export type CreateAiReminderAutomationMutationOptions = ApolloReactHooks.useMutation.Options<CreateAiReminderAutomationMutation, CreateAiReminderAutomationMutationVariables>;
export const UpdateAiReminderAutomationDocument = gql`
    mutation UpdateAIReminderAutomation($input: UpdateAIReminderAutomationInput!) {
  updateAIReminderAutomation(input: $input) {
    ...AIReminderAutomationWithRelations
  }
}
    ${AiReminderAutomationWithRelationsFragmentDoc}`;
export type UpdateAiReminderAutomationMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAiReminderAutomationMutation, UpdateAiReminderAutomationMutationVariables>;

/**
 * __useUpdateAiReminderAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateAiReminderAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiReminderAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiReminderAutomationMutation, { data, loading, error }] = useUpdateAiReminderAutomationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAiReminderAutomationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateAiReminderAutomationMutation, UpdateAiReminderAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAiReminderAutomationMutation, UpdateAiReminderAutomationMutationVariables>(UpdateAiReminderAutomationDocument, options);
      }
export type UpdateAiReminderAutomationMutationHookResult = ReturnType<typeof useUpdateAiReminderAutomationMutation>;
export type UpdateAiReminderAutomationMutationResult = ApolloReactHooks.useMutation.Result<UpdateAiReminderAutomationMutation>;
export type UpdateAiReminderAutomationMutationOptions = ApolloReactHooks.useMutation.Options<UpdateAiReminderAutomationMutation, UpdateAiReminderAutomationMutationVariables>;
export const DeleteAiReminderAutomationDocument = gql`
    mutation DeleteAIReminderAutomation($automationId: UUID!, $deleteReminders: Boolean) {
  deleteAIReminderAutomation(
    automationId: $automationId
    deleteReminders: $deleteReminders
  )
}
    `;
export type DeleteAiReminderAutomationMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAiReminderAutomationMutation, DeleteAiReminderAutomationMutationVariables>;

/**
 * __useDeleteAiReminderAutomationMutation__
 *
 * To run a mutation, you first call `useDeleteAiReminderAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiReminderAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiReminderAutomationMutation, { data, loading, error }] = useDeleteAiReminderAutomationMutation({
 *   variables: {
 *      automationId: // value for 'automationId'
 *      deleteReminders: // value for 'deleteReminders'
 *   },
 * });
 */
export function useDeleteAiReminderAutomationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteAiReminderAutomationMutation, DeleteAiReminderAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAiReminderAutomationMutation, DeleteAiReminderAutomationMutationVariables>(DeleteAiReminderAutomationDocument, options);
      }
export type DeleteAiReminderAutomationMutationHookResult = ReturnType<typeof useDeleteAiReminderAutomationMutation>;
export type DeleteAiReminderAutomationMutationResult = ApolloReactHooks.useMutation.Result<DeleteAiReminderAutomationMutation>;
export type DeleteAiReminderAutomationMutationOptions = ApolloReactHooks.useMutation.Options<DeleteAiReminderAutomationMutation, DeleteAiReminderAutomationMutationVariables>;
export const RunAiReminderAutomationDocument = gql`
    mutation RunAIReminderAutomation($automationId: UUID!) {
  runAIReminderAutomation(automationId: $automationId) {
    ...AIReminderAutomationWithRelations
  }
}
    ${AiReminderAutomationWithRelationsFragmentDoc}`;
export type RunAiReminderAutomationMutationFn = ApolloReactHooks.useMutation.MutationFunction<RunAiReminderAutomationMutation, RunAiReminderAutomationMutationVariables>;

/**
 * __useRunAiReminderAutomationMutation__
 *
 * To run a mutation, you first call `useRunAiReminderAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiReminderAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiReminderAutomationMutation, { data, loading, error }] = useRunAiReminderAutomationMutation({
 *   variables: {
 *      automationId: // value for 'automationId'
 *   },
 * });
 */
export function useRunAiReminderAutomationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RunAiReminderAutomationMutation, RunAiReminderAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RunAiReminderAutomationMutation, RunAiReminderAutomationMutationVariables>(RunAiReminderAutomationDocument, options);
      }
export type RunAiReminderAutomationMutationHookResult = ReturnType<typeof useRunAiReminderAutomationMutation>;
export type RunAiReminderAutomationMutationResult = ApolloReactHooks.useMutation.Result<RunAiReminderAutomationMutation>;
export type RunAiReminderAutomationMutationOptions = ApolloReactHooks.useMutation.Options<RunAiReminderAutomationMutation, RunAiReminderAutomationMutationVariables>;
export const AcceptReminderDocument = gql`
    mutation AcceptReminder($reminderId: UUID!) {
  acceptReminder(reminderId: $reminderId) {
    __typename
    id
    reviewStatus
  }
}
    `;
export type AcceptReminderMutationFn = ApolloReactHooks.useMutation.MutationFunction<AcceptReminderMutation, AcceptReminderMutationVariables>;

/**
 * __useAcceptReminderMutation__
 *
 * To run a mutation, you first call `useAcceptReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptReminderMutation, { data, loading, error }] = useAcceptReminderMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useAcceptReminderMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AcceptReminderMutation, AcceptReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptReminderMutation, AcceptReminderMutationVariables>(AcceptReminderDocument, options);
      }
export type AcceptReminderMutationHookResult = ReturnType<typeof useAcceptReminderMutation>;
export type AcceptReminderMutationResult = ApolloReactHooks.useMutation.Result<AcceptReminderMutation>;
export type AcceptReminderMutationOptions = ApolloReactHooks.useMutation.Options<AcceptReminderMutation, AcceptReminderMutationVariables>;
export const RejectReminderDocument = gql`
    mutation RejectReminder($reminderId: UUID!) {
  rejectReminder(reminderId: $reminderId)
}
    `;
export type RejectReminderMutationFn = ApolloReactHooks.useMutation.MutationFunction<RejectReminderMutation, RejectReminderMutationVariables>;

/**
 * __useRejectReminderMutation__
 *
 * To run a mutation, you first call `useRejectReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectReminderMutation, { data, loading, error }] = useRejectReminderMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useRejectReminderMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RejectReminderMutation, RejectReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectReminderMutation, RejectReminderMutationVariables>(RejectReminderDocument, options);
      }
export type RejectReminderMutationHookResult = ReturnType<typeof useRejectReminderMutation>;
export type RejectReminderMutationResult = ApolloReactHooks.useMutation.Result<RejectReminderMutation>;
export type RejectReminderMutationOptions = ApolloReactHooks.useMutation.Options<RejectReminderMutation, RejectReminderMutationVariables>;
export const AcceptRemindersDocument = gql`
    mutation AcceptReminders($reminderIds: [UUID!]!) {
  acceptReminders(reminderIds: $reminderIds) {
    __typename
    id
    reviewStatus
  }
}
    `;
export type AcceptRemindersMutationFn = ApolloReactHooks.useMutation.MutationFunction<AcceptRemindersMutation, AcceptRemindersMutationVariables>;

/**
 * __useAcceptRemindersMutation__
 *
 * To run a mutation, you first call `useAcceptRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRemindersMutation, { data, loading, error }] = useAcceptRemindersMutation({
 *   variables: {
 *      reminderIds: // value for 'reminderIds'
 *   },
 * });
 */
export function useAcceptRemindersMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AcceptRemindersMutation, AcceptRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptRemindersMutation, AcceptRemindersMutationVariables>(AcceptRemindersDocument, options);
      }
export type AcceptRemindersMutationHookResult = ReturnType<typeof useAcceptRemindersMutation>;
export type AcceptRemindersMutationResult = ApolloReactHooks.useMutation.Result<AcceptRemindersMutation>;
export type AcceptRemindersMutationOptions = ApolloReactHooks.useMutation.Options<AcceptRemindersMutation, AcceptRemindersMutationVariables>;
export const RejectRemindersDocument = gql`
    mutation RejectReminders($reminderIds: [UUID!]!) {
  rejectReminders(reminderIds: $reminderIds)
}
    `;
export type RejectRemindersMutationFn = ApolloReactHooks.useMutation.MutationFunction<RejectRemindersMutation, RejectRemindersMutationVariables>;

/**
 * __useRejectRemindersMutation__
 *
 * To run a mutation, you first call `useRejectRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRemindersMutation, { data, loading, error }] = useRejectRemindersMutation({
 *   variables: {
 *      reminderIds: // value for 'reminderIds'
 *   },
 * });
 */
export function useRejectRemindersMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RejectRemindersMutation, RejectRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectRemindersMutation, RejectRemindersMutationVariables>(RejectRemindersDocument, options);
      }
export type RejectRemindersMutationHookResult = ReturnType<typeof useRejectRemindersMutation>;
export type RejectRemindersMutationResult = ApolloReactHooks.useMutation.Result<RejectRemindersMutation>;
export type RejectRemindersMutationOptions = ApolloReactHooks.useMutation.Options<RejectRemindersMutation, RejectRemindersMutationVariables>;
export const OnAiReminderAutomationUpdatedDocument = gql`
    subscription OnAIReminderAutomationUpdated {
  aiReminderAutomationUpdated {
    automationId
    automation {
      ...AIReminderAutomationWithRelations
    }
  }
}
    ${AiReminderAutomationWithRelationsFragmentDoc}`;

/**
 * __useOnAiReminderAutomationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnAiReminderAutomationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAiReminderAutomationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAiReminderAutomationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAiReminderAutomationUpdatedSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnAiReminderAutomationUpdatedSubscription, OnAiReminderAutomationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnAiReminderAutomationUpdatedSubscription, OnAiReminderAutomationUpdatedSubscriptionVariables>(OnAiReminderAutomationUpdatedDocument, options);
      }
export type OnAiReminderAutomationUpdatedSubscriptionHookResult = ReturnType<typeof useOnAiReminderAutomationUpdatedSubscription>;
export type OnAiReminderAutomationUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnAiReminderAutomationUpdatedSubscription>;
export const CreateAnswerOptionDocument = gql`
    mutation CreateAnswerOption($input: CreateAnswerOptionInput!) {
  createAnswerOption(input: $input) {
    answerOption {
      ...AnswerOptionBase
    }
  }
}
    ${AnswerOptionBaseFragmentDoc}`;
export type CreateAnswerOptionMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAnswerOptionMutation, CreateAnswerOptionMutationVariables>;

/**
 * __useCreateAnswerOptionMutation__
 *
 * To run a mutation, you first call `useCreateAnswerOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerOptionMutation, { data, loading, error }] = useCreateAnswerOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnswerOptionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateAnswerOptionMutation, CreateAnswerOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAnswerOptionMutation, CreateAnswerOptionMutationVariables>(CreateAnswerOptionDocument, options);
      }
export type CreateAnswerOptionMutationHookResult = ReturnType<typeof useCreateAnswerOptionMutation>;
export type CreateAnswerOptionMutationResult = ApolloReactHooks.useMutation.Result<CreateAnswerOptionMutation>;
export type CreateAnswerOptionMutationOptions = ApolloReactHooks.useMutation.Options<CreateAnswerOptionMutation, CreateAnswerOptionMutationVariables>;
export const DeleteAnswerOptionDocument = gql`
    mutation DeleteAnswerOption($id: UUID!) {
  deleteAnswerOption(id: $id)
}
    `;
export type DeleteAnswerOptionMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAnswerOptionMutation, DeleteAnswerOptionMutationVariables>;

/**
 * __useDeleteAnswerOptionMutation__
 *
 * To run a mutation, you first call `useDeleteAnswerOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswerOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswerOptionMutation, { data, loading, error }] = useDeleteAnswerOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnswerOptionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteAnswerOptionMutation, DeleteAnswerOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAnswerOptionMutation, DeleteAnswerOptionMutationVariables>(DeleteAnswerOptionDocument, options);
      }
export type DeleteAnswerOptionMutationHookResult = ReturnType<typeof useDeleteAnswerOptionMutation>;
export type DeleteAnswerOptionMutationResult = ApolloReactHooks.useMutation.Result<DeleteAnswerOptionMutation>;
export type DeleteAnswerOptionMutationOptions = ApolloReactHooks.useMutation.Options<DeleteAnswerOptionMutation, DeleteAnswerOptionMutationVariables>;
export const UpdateAnswerOptionDocument = gql`
    mutation UpdateAnswerOption($input: UpdateAnswerOptionInput!) {
  updateAnswerOption(input: $input) {
    answerOption {
      ...AnswerOptionBase
    }
  }
}
    ${AnswerOptionBaseFragmentDoc}`;
export type UpdateAnswerOptionMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAnswerOptionMutation, UpdateAnswerOptionMutationVariables>;

/**
 * __useUpdateAnswerOptionMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerOptionMutation, { data, loading, error }] = useUpdateAnswerOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnswerOptionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateAnswerOptionMutation, UpdateAnswerOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAnswerOptionMutation, UpdateAnswerOptionMutationVariables>(UpdateAnswerOptionDocument, options);
      }
export type UpdateAnswerOptionMutationHookResult = ReturnType<typeof useUpdateAnswerOptionMutation>;
export type UpdateAnswerOptionMutationResult = ApolloReactHooks.useMutation.Result<UpdateAnswerOptionMutation>;
export type UpdateAnswerOptionMutationOptions = ApolloReactHooks.useMutation.Options<UpdateAnswerOptionMutation, UpdateAnswerOptionMutationVariables>;
export const GetAnswerOptionsDocument = gql`
    query GetAnswerOptions($id: UUID!) {
  answerOptions(id: $id) {
    ...AnswerOptionsBase
  }
}
    ${AnswerOptionsBaseFragmentDoc}`;

/**
 * __useGetAnswerOptionsQuery__
 *
 * To run a query within a React component, call `useGetAnswerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswerOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnswerOptionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAnswerOptionsQuery, GetAnswerOptionsQueryVariables> & ({ variables: GetAnswerOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnswerOptionsQuery, GetAnswerOptionsQueryVariables>(GetAnswerOptionsDocument, options);
      }
export function useGetAnswerOptionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAnswerOptionsQuery, GetAnswerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnswerOptionsQuery, GetAnswerOptionsQueryVariables>(GetAnswerOptionsDocument, options);
        }
export function useGetAnswerOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAnswerOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAnswerOptionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAnswerOptionsQuery, GetAnswerOptionsQueryVariables>(GetAnswerOptionsDocument, options);
        }
export type GetAnswerOptionsQueryHookResult = ReturnType<typeof useGetAnswerOptionsQuery>;
export type GetAnswerOptionsLazyQueryHookResult = ReturnType<typeof useGetAnswerOptionsLazyQuery>;
export type GetAnswerOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAnswerOptionsSuspenseQuery>;
export type GetAnswerOptionsQueryResult = ApolloReactHooks.useQuery.Result<GetAnswerOptionsQuery, GetAnswerOptionsQueryVariables>;
export const GetAnswerOptionsPresetsDocument = gql`
    query GetAnswerOptionsPresets {
  answerOptionsPresets {
    __typename
    id
    title
    documentsUsing
    author {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetAnswerOptionsPresetsQuery__
 *
 * To run a query within a React component, call `useGetAnswerOptionsPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswerOptionsPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswerOptionsPresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnswerOptionsPresetsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetAnswerOptionsPresetsQuery, GetAnswerOptionsPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnswerOptionsPresetsQuery, GetAnswerOptionsPresetsQueryVariables>(GetAnswerOptionsPresetsDocument, options);
      }
export function useGetAnswerOptionsPresetsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAnswerOptionsPresetsQuery, GetAnswerOptionsPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnswerOptionsPresetsQuery, GetAnswerOptionsPresetsQueryVariables>(GetAnswerOptionsPresetsDocument, options);
        }
export function useGetAnswerOptionsPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAnswerOptionsPresetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAnswerOptionsPresetsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAnswerOptionsPresetsQuery, GetAnswerOptionsPresetsQueryVariables>(GetAnswerOptionsPresetsDocument, options);
        }
export type GetAnswerOptionsPresetsQueryHookResult = ReturnType<typeof useGetAnswerOptionsPresetsQuery>;
export type GetAnswerOptionsPresetsLazyQueryHookResult = ReturnType<typeof useGetAnswerOptionsPresetsLazyQuery>;
export type GetAnswerOptionsPresetsSuspenseQueryHookResult = ReturnType<typeof useGetAnswerOptionsPresetsSuspenseQuery>;
export type GetAnswerOptionsPresetsQueryResult = ApolloReactHooks.useQuery.Result<GetAnswerOptionsPresetsQuery, GetAnswerOptionsPresetsQueryVariables>;
export const CreateAnswerOptionsDocument = gql`
    mutation CreateAnswerOptions($input: CreateAnswerOptionsInput!) {
  createAnswerOptions(input: $input) {
    answerOptions {
      ...AnswerOptionsBase
    }
  }
}
    ${AnswerOptionsBaseFragmentDoc}`;
export type CreateAnswerOptionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAnswerOptionsMutation, CreateAnswerOptionsMutationVariables>;

/**
 * __useCreateAnswerOptionsMutation__
 *
 * To run a mutation, you first call `useCreateAnswerOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerOptionsMutation, { data, loading, error }] = useCreateAnswerOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnswerOptionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateAnswerOptionsMutation, CreateAnswerOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAnswerOptionsMutation, CreateAnswerOptionsMutationVariables>(CreateAnswerOptionsDocument, options);
      }
export type CreateAnswerOptionsMutationHookResult = ReturnType<typeof useCreateAnswerOptionsMutation>;
export type CreateAnswerOptionsMutationResult = ApolloReactHooks.useMutation.Result<CreateAnswerOptionsMutation>;
export type CreateAnswerOptionsMutationOptions = ApolloReactHooks.useMutation.Options<CreateAnswerOptionsMutation, CreateAnswerOptionsMutationVariables>;
export const UpdateAnswerOptionsDocument = gql`
    mutation UpdateAnswerOptions($input: UpdateAnswerOptionsInput!) {
  updateAnswerOptions(input: $input) {
    answerOptions {
      ...AnswerOptionsBase
    }
  }
}
    ${AnswerOptionsBaseFragmentDoc}`;
export type UpdateAnswerOptionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAnswerOptionsMutation, UpdateAnswerOptionsMutationVariables>;

/**
 * __useUpdateAnswerOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerOptionsMutation, { data, loading, error }] = useUpdateAnswerOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnswerOptionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateAnswerOptionsMutation, UpdateAnswerOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAnswerOptionsMutation, UpdateAnswerOptionsMutationVariables>(UpdateAnswerOptionsDocument, options);
      }
export type UpdateAnswerOptionsMutationHookResult = ReturnType<typeof useUpdateAnswerOptionsMutation>;
export type UpdateAnswerOptionsMutationResult = ApolloReactHooks.useMutation.Result<UpdateAnswerOptionsMutation>;
export type UpdateAnswerOptionsMutationOptions = ApolloReactHooks.useMutation.Options<UpdateAnswerOptionsMutation, UpdateAnswerOptionsMutationVariables>;
export const DeleteAnswerOptionsDocument = gql`
    mutation DeleteAnswerOptions($id: UUID!) {
  deleteAnswerOptions(id: $id)
}
    `;
export type DeleteAnswerOptionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAnswerOptionsMutation, DeleteAnswerOptionsMutationVariables>;

/**
 * __useDeleteAnswerOptionsMutation__
 *
 * To run a mutation, you first call `useDeleteAnswerOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswerOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswerOptionsMutation, { data, loading, error }] = useDeleteAnswerOptionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnswerOptionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteAnswerOptionsMutation, DeleteAnswerOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAnswerOptionsMutation, DeleteAnswerOptionsMutationVariables>(DeleteAnswerOptionsDocument, options);
      }
export type DeleteAnswerOptionsMutationHookResult = ReturnType<typeof useDeleteAnswerOptionsMutation>;
export type DeleteAnswerOptionsMutationResult = ApolloReactHooks.useMutation.Result<DeleteAnswerOptionsMutation>;
export type DeleteAnswerOptionsMutationOptions = ApolloReactHooks.useMutation.Options<DeleteAnswerOptionsMutation, DeleteAnswerOptionsMutationVariables>;
export const ApiKeysDocument = gql`
    query ApiKeys {
  apiKeys {
    ...ApiKeyBase
  }
}
    ${ApiKeyBaseFragmentDoc}`;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions?: ApolloReactHooks.useQuery.Options<ApiKeysQuery, ApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export function useApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<ApiKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<ApiKeysQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysSuspenseQueryHookResult = ReturnType<typeof useApiKeysSuspenseQuery>;
export type ApiKeysQueryResult = ApolloReactHooks.useQuery.Result<ApiKeysQuery, ApiKeysQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($input: CreateApiKeyInput!) {
  createApiKey(input: $input) {
    apiKey {
      ...ApiKeyBase
    }
    value
  }
}
    ${ApiKeyBaseFragmentDoc}`;
export type CreateApiKeyMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = ApolloReactHooks.useMutation.Result<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = ApolloReactHooks.useMutation.Options<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const RevokeApiKeysDocument = gql`
    mutation RevokeApiKeys($apiKeyIds: [String!]!) {
  revokeApiKeys(apiKeyIds: $apiKeyIds)
}
    `;
export type RevokeApiKeysMutationFn = ApolloReactHooks.useMutation.MutationFunction<RevokeApiKeysMutation, RevokeApiKeysMutationVariables>;

/**
 * __useRevokeApiKeysMutation__
 *
 * To run a mutation, you first call `useRevokeApiKeysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiKeysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiKeysMutation, { data, loading, error }] = useRevokeApiKeysMutation({
 *   variables: {
 *      apiKeyIds: // value for 'apiKeyIds'
 *   },
 * });
 */
export function useRevokeApiKeysMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RevokeApiKeysMutation, RevokeApiKeysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokeApiKeysMutation, RevokeApiKeysMutationVariables>(RevokeApiKeysDocument, options);
      }
export type RevokeApiKeysMutationHookResult = ReturnType<typeof useRevokeApiKeysMutation>;
export type RevokeApiKeysMutationResult = ApolloReactHooks.useMutation.Result<RevokeApiKeysMutation>;
export type RevokeApiKeysMutationOptions = ApolloReactHooks.useMutation.Options<RevokeApiKeysMutation, RevokeApiKeysMutationVariables>;
export const GetAppVersionDocument = gql`
    query GetAppVersion {
  appVersion {
    version
    buildDate
  }
}
    `;

/**
 * __useGetAppVersionQuery__
 *
 * To run a query within a React component, call `useGetAppVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppVersionQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetAppVersionQuery, GetAppVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAppVersionQuery, GetAppVersionQueryVariables>(GetAppVersionDocument, options);
      }
export function useGetAppVersionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAppVersionQuery, GetAppVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAppVersionQuery, GetAppVersionQueryVariables>(GetAppVersionDocument, options);
        }
export function useGetAppVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAppVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAppVersionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAppVersionQuery, GetAppVersionQueryVariables>(GetAppVersionDocument, options);
        }
export type GetAppVersionQueryHookResult = ReturnType<typeof useGetAppVersionQuery>;
export type GetAppVersionLazyQueryHookResult = ReturnType<typeof useGetAppVersionLazyQuery>;
export type GetAppVersionSuspenseQueryHookResult = ReturnType<typeof useGetAppVersionSuspenseQuery>;
export type GetAppVersionQueryResult = ApolloReactHooks.useQuery.Result<GetAppVersionQuery, GetAppVersionQueryVariables>;
export const GetBoardsDocument = gql`
    query GetBoards {
  boards {
    ...BoardWithColumns
  }
}
    ${BoardWithColumnsFragmentDoc}`;

/**
 * __useGetBoardsQuery__
 *
 * To run a query within a React component, call `useGetBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBoardsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetBoardsQuery, GetBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBoardsQuery, GetBoardsQueryVariables>(GetBoardsDocument, options);
      }
export function useGetBoardsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetBoardsQuery, GetBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBoardsQuery, GetBoardsQueryVariables>(GetBoardsDocument, options);
        }
export function useGetBoardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetBoardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetBoardsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetBoardsQuery, GetBoardsQueryVariables>(GetBoardsDocument, options);
        }
export type GetBoardsQueryHookResult = ReturnType<typeof useGetBoardsQuery>;
export type GetBoardsLazyQueryHookResult = ReturnType<typeof useGetBoardsLazyQuery>;
export type GetBoardsSuspenseQueryHookResult = ReturnType<typeof useGetBoardsSuspenseQuery>;
export type GetBoardsQueryResult = ApolloReactHooks.useQuery.Result<GetBoardsQuery, GetBoardsQueryVariables>;
export const GetBoardDocument = gql`
    query GetBoard($id: UUID!) {
  board(id: $id) {
    ...BoardFull
  }
}
    ${BoardFullFragmentDoc}`;

/**
 * __useGetBoardQuery__
 *
 * To run a query within a React component, call `useGetBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBoardQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetBoardQuery, GetBoardQueryVariables> & ({ variables: GetBoardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBoardQuery, GetBoardQueryVariables>(GetBoardDocument, options);
      }
export function useGetBoardLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetBoardQuery, GetBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBoardQuery, GetBoardQueryVariables>(GetBoardDocument, options);
        }
export function useGetBoardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetBoardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetBoardQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetBoardQuery, GetBoardQueryVariables>(GetBoardDocument, options);
        }
export type GetBoardQueryHookResult = ReturnType<typeof useGetBoardQuery>;
export type GetBoardLazyQueryHookResult = ReturnType<typeof useGetBoardLazyQuery>;
export type GetBoardSuspenseQueryHookResult = ReturnType<typeof useGetBoardSuspenseQuery>;
export type GetBoardQueryResult = ApolloReactHooks.useQuery.Result<GetBoardQuery, GetBoardQueryVariables>;
export const GetBoardColumnsDocument = gql`
    query GetBoardColumns($boardId: UUID!) {
  board(id: $boardId) {
    ...BoardWithColumns
  }
}
    ${BoardWithColumnsFragmentDoc}`;

/**
 * __useGetBoardColumnsQuery__
 *
 * To run a query within a React component, call `useGetBoardColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardColumnsQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useGetBoardColumnsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetBoardColumnsQuery, GetBoardColumnsQueryVariables> & ({ variables: GetBoardColumnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBoardColumnsQuery, GetBoardColumnsQueryVariables>(GetBoardColumnsDocument, options);
      }
export function useGetBoardColumnsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetBoardColumnsQuery, GetBoardColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBoardColumnsQuery, GetBoardColumnsQueryVariables>(GetBoardColumnsDocument, options);
        }
export function useGetBoardColumnsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetBoardColumnsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetBoardColumnsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetBoardColumnsQuery, GetBoardColumnsQueryVariables>(GetBoardColumnsDocument, options);
        }
export type GetBoardColumnsQueryHookResult = ReturnType<typeof useGetBoardColumnsQuery>;
export type GetBoardColumnsLazyQueryHookResult = ReturnType<typeof useGetBoardColumnsLazyQuery>;
export type GetBoardColumnsSuspenseQueryHookResult = ReturnType<typeof useGetBoardColumnsSuspenseQuery>;
export type GetBoardColumnsQueryResult = ApolloReactHooks.useQuery.Result<GetBoardColumnsQuery, GetBoardColumnsQueryVariables>;
export const GetColumnDocument = gql`
    query GetColumn($id: UUID!) {
  column(id: $id) {
    ...ColumnWithWorkflows
  }
}
    ${ColumnWithWorkflowsFragmentDoc}`;

/**
 * __useGetColumnQuery__
 *
 * To run a query within a React component, call `useGetColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetColumnQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetColumnQuery, GetColumnQueryVariables> & ({ variables: GetColumnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetColumnQuery, GetColumnQueryVariables>(GetColumnDocument, options);
      }
export function useGetColumnLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetColumnQuery, GetColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetColumnQuery, GetColumnQueryVariables>(GetColumnDocument, options);
        }
export function useGetColumnSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetColumnQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetColumnQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetColumnQuery, GetColumnQueryVariables>(GetColumnDocument, options);
        }
export type GetColumnQueryHookResult = ReturnType<typeof useGetColumnQuery>;
export type GetColumnLazyQueryHookResult = ReturnType<typeof useGetColumnLazyQuery>;
export type GetColumnSuspenseQueryHookResult = ReturnType<typeof useGetColumnSuspenseQuery>;
export type GetColumnQueryResult = ApolloReactHooks.useQuery.Result<GetColumnQuery, GetColumnQueryVariables>;
export const CreateBoardDocument = gql`
    mutation CreateBoard($input: CreateBoardInput!) {
  createBoard(input: $input) {
    ...BoardBase
  }
}
    ${BoardBaseFragmentDoc}`;
export type CreateBoardMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateBoardMutation, CreateBoardMutationVariables>;

/**
 * __useCreateBoardMutation__
 *
 * To run a mutation, you first call `useCreateBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBoardMutation, { data, loading, error }] = useCreateBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBoardMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateBoardMutation, CreateBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBoardMutation, CreateBoardMutationVariables>(CreateBoardDocument, options);
      }
export type CreateBoardMutationHookResult = ReturnType<typeof useCreateBoardMutation>;
export type CreateBoardMutationResult = ApolloReactHooks.useMutation.Result<CreateBoardMutation>;
export type CreateBoardMutationOptions = ApolloReactHooks.useMutation.Options<CreateBoardMutation, CreateBoardMutationVariables>;
export const UpdateBoardDocument = gql`
    mutation UpdateBoard($input: UpdateBoardInput!) {
  updateBoard(input: $input) {
    ...BoardBase
  }
}
    ${BoardBaseFragmentDoc}`;
export type UpdateBoardMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateBoardMutation, UpdateBoardMutationVariables>;

/**
 * __useUpdateBoardMutation__
 *
 * To run a mutation, you first call `useUpdateBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoardMutation, { data, loading, error }] = useUpdateBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBoardMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateBoardMutation, UpdateBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBoardMutation, UpdateBoardMutationVariables>(UpdateBoardDocument, options);
      }
export type UpdateBoardMutationHookResult = ReturnType<typeof useUpdateBoardMutation>;
export type UpdateBoardMutationResult = ApolloReactHooks.useMutation.Result<UpdateBoardMutation>;
export type UpdateBoardMutationOptions = ApolloReactHooks.useMutation.Options<UpdateBoardMutation, UpdateBoardMutationVariables>;
export const DeleteBoardDocument = gql`
    mutation DeleteBoard($boardId: UUID!) {
  deleteBoard(boardId: $boardId)
}
    `;
export type DeleteBoardMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteBoardMutation, DeleteBoardMutationVariables>;

/**
 * __useDeleteBoardMutation__
 *
 * To run a mutation, you first call `useDeleteBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBoardMutation, { data, loading, error }] = useDeleteBoardMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useDeleteBoardMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteBoardMutation, DeleteBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBoardMutation, DeleteBoardMutationVariables>(DeleteBoardDocument, options);
      }
export type DeleteBoardMutationHookResult = ReturnType<typeof useDeleteBoardMutation>;
export type DeleteBoardMutationResult = ApolloReactHooks.useMutation.Result<DeleteBoardMutation>;
export type DeleteBoardMutationOptions = ApolloReactHooks.useMutation.Options<DeleteBoardMutation, DeleteBoardMutationVariables>;
export const CreateColumnDocument = gql`
    mutation CreateColumn($input: CreateColumnInput!) {
  createColumn(input: $input) {
    ...ColumnBase
  }
}
    ${ColumnBaseFragmentDoc}`;
export type CreateColumnMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateColumnMutation, CreateColumnMutationVariables>;

/**
 * __useCreateColumnMutation__
 *
 * To run a mutation, you first call `useCreateColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createColumnMutation, { data, loading, error }] = useCreateColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateColumnMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateColumnMutation, CreateColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateColumnMutation, CreateColumnMutationVariables>(CreateColumnDocument, options);
      }
export type CreateColumnMutationHookResult = ReturnType<typeof useCreateColumnMutation>;
export type CreateColumnMutationResult = ApolloReactHooks.useMutation.Result<CreateColumnMutation>;
export type CreateColumnMutationOptions = ApolloReactHooks.useMutation.Options<CreateColumnMutation, CreateColumnMutationVariables>;
export const UpdateColumnDocument = gql`
    mutation UpdateColumn($input: UpdateColumnInput!) {
  updateColumn(input: $input) {
    ...ColumnBase
  }
}
    ${ColumnBaseFragmentDoc}`;
export type UpdateColumnMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateColumnMutation, UpdateColumnMutationVariables>;

/**
 * __useUpdateColumnMutation__
 *
 * To run a mutation, you first call `useUpdateColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateColumnMutation, { data, loading, error }] = useUpdateColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateColumnMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateColumnMutation, UpdateColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateColumnMutation, UpdateColumnMutationVariables>(UpdateColumnDocument, options);
      }
export type UpdateColumnMutationHookResult = ReturnType<typeof useUpdateColumnMutation>;
export type UpdateColumnMutationResult = ApolloReactHooks.useMutation.Result<UpdateColumnMutation>;
export type UpdateColumnMutationOptions = ApolloReactHooks.useMutation.Options<UpdateColumnMutation, UpdateColumnMutationVariables>;
export const DeleteColumnDocument = gql`
    mutation DeleteColumn($columnId: UUID!, $targetColumnId: UUID!) {
  deleteColumn(columnId: $columnId, targetColumnId: $targetColumnId)
}
    `;
export type DeleteColumnMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteColumnMutation, DeleteColumnMutationVariables>;

/**
 * __useDeleteColumnMutation__
 *
 * To run a mutation, you first call `useDeleteColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteColumnMutation, { data, loading, error }] = useDeleteColumnMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      targetColumnId: // value for 'targetColumnId'
 *   },
 * });
 */
export function useDeleteColumnMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteColumnMutation, DeleteColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteColumnMutation, DeleteColumnMutationVariables>(DeleteColumnDocument, options);
      }
export type DeleteColumnMutationHookResult = ReturnType<typeof useDeleteColumnMutation>;
export type DeleteColumnMutationResult = ApolloReactHooks.useMutation.Result<DeleteColumnMutation>;
export type DeleteColumnMutationOptions = ApolloReactHooks.useMutation.Options<DeleteColumnMutation, DeleteColumnMutationVariables>;
export const MoveColumnDocument = gql`
    mutation MoveColumn($input: MoveColumnInput!) {
  moveColumn(input: $input) {
    ...BoardFull
  }
}
    ${BoardFullFragmentDoc}`;
export type MoveColumnMutationFn = ApolloReactHooks.useMutation.MutationFunction<MoveColumnMutation, MoveColumnMutationVariables>;

/**
 * __useMoveColumnMutation__
 *
 * To run a mutation, you first call `useMoveColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveColumnMutation, { data, loading, error }] = useMoveColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveColumnMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MoveColumnMutation, MoveColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveColumnMutation, MoveColumnMutationVariables>(MoveColumnDocument, options);
      }
export type MoveColumnMutationHookResult = ReturnType<typeof useMoveColumnMutation>;
export type MoveColumnMutationResult = ApolloReactHooks.useMutation.Result<MoveColumnMutation>;
export type MoveColumnMutationOptions = ApolloReactHooks.useMutation.Options<MoveColumnMutation, MoveColumnMutationVariables>;
export const AddTriageColumnDocument = gql`
    mutation AddTriageColumn($boardId: UUID!) {
  addTriageColumn(boardId: $boardId) {
    ...BoardFull
  }
}
    ${BoardFullFragmentDoc}`;
export type AddTriageColumnMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddTriageColumnMutation, AddTriageColumnMutationVariables>;

/**
 * __useAddTriageColumnMutation__
 *
 * To run a mutation, you first call `useAddTriageColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTriageColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTriageColumnMutation, { data, loading, error }] = useAddTriageColumnMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useAddTriageColumnMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddTriageColumnMutation, AddTriageColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTriageColumnMutation, AddTriageColumnMutationVariables>(AddTriageColumnDocument, options);
      }
export type AddTriageColumnMutationHookResult = ReturnType<typeof useAddTriageColumnMutation>;
export type AddTriageColumnMutationResult = ApolloReactHooks.useMutation.Result<AddTriageColumnMutation>;
export type AddTriageColumnMutationOptions = ApolloReactHooks.useMutation.Options<AddTriageColumnMutation, AddTriageColumnMutationVariables>;
export const RequestBulkExportDocument = gql`
    mutation RequestBulkExport($input: RequestBulkExportInput!) {
  requestBulkExport(input: $input) {
    id
    status
    format
    documentCount
    processedCount
    skippedCount
    createdAt
  }
}
    `;
export type RequestBulkExportMutationFn = ApolloReactHooks.useMutation.MutationFunction<RequestBulkExportMutation, RequestBulkExportMutationVariables>;

/**
 * __useRequestBulkExportMutation__
 *
 * To run a mutation, you first call `useRequestBulkExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBulkExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBulkExportMutation, { data, loading, error }] = useRequestBulkExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestBulkExportMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RequestBulkExportMutation, RequestBulkExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestBulkExportMutation, RequestBulkExportMutationVariables>(RequestBulkExportDocument, options);
      }
export type RequestBulkExportMutationHookResult = ReturnType<typeof useRequestBulkExportMutation>;
export type RequestBulkExportMutationResult = ApolloReactHooks.useMutation.Result<RequestBulkExportMutation>;
export type RequestBulkExportMutationOptions = ApolloReactHooks.useMutation.Options<RequestBulkExportMutation, RequestBulkExportMutationVariables>;
export const CancelBulkExportDocument = gql`
    mutation CancelBulkExport($id: UUID!) {
  cancelBulkExport(id: $id) {
    id
    status
    errorMessage
  }
}
    `;
export type CancelBulkExportMutationFn = ApolloReactHooks.useMutation.MutationFunction<CancelBulkExportMutation, CancelBulkExportMutationVariables>;

/**
 * __useCancelBulkExportMutation__
 *
 * To run a mutation, you first call `useCancelBulkExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBulkExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBulkExportMutation, { data, loading, error }] = useCancelBulkExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelBulkExportMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CancelBulkExportMutation, CancelBulkExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelBulkExportMutation, CancelBulkExportMutationVariables>(CancelBulkExportDocument, options);
      }
export type CancelBulkExportMutationHookResult = ReturnType<typeof useCancelBulkExportMutation>;
export type CancelBulkExportMutationResult = ApolloReactHooks.useMutation.Result<CancelBulkExportMutation>;
export type CancelBulkExportMutationOptions = ApolloReactHooks.useMutation.Options<CancelBulkExportMutation, CancelBulkExportMutationVariables>;
export const BulkExportDocument = gql`
    query BulkExport($id: UUID!) {
  bulkExport(id: $id) {
    id
    status
    format
    documentCount
    processedCount
    packagedCount
    skippedCount
    skippedDocuments {
      documentId
      entryName
      reason
    }
    fileSizeBytes
    errorMessage
    expiresAt
    downloadUrl
    parts {
      partNumber
      sizeBytes
      downloadUrl
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useBulkExportQuery__
 *
 * To run a query within a React component, call `useBulkExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBulkExportQuery(baseOptions: ApolloReactHooks.useQuery.Options<BulkExportQuery, BulkExportQueryVariables> & ({ variables: BulkExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkExportQuery, BulkExportQueryVariables>(BulkExportDocument, options);
      }
export function useBulkExportLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<BulkExportQuery, BulkExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkExportQuery, BulkExportQueryVariables>(BulkExportDocument, options);
        }
export function useBulkExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<BulkExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<BulkExportQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<BulkExportQuery, BulkExportQueryVariables>(BulkExportDocument, options);
        }
export type BulkExportQueryHookResult = ReturnType<typeof useBulkExportQuery>;
export type BulkExportLazyQueryHookResult = ReturnType<typeof useBulkExportLazyQuery>;
export type BulkExportSuspenseQueryHookResult = ReturnType<typeof useBulkExportSuspenseQuery>;
export type BulkExportQueryResult = ApolloReactHooks.useQuery.Result<BulkExportQuery, BulkExportQueryVariables>;
export const MyBulkExportsDocument = gql`
    query MyBulkExports($limit: Int) {
  myBulkExports(limit: $limit) {
    id
    status
    format
    documentCount
    processedCount
    skippedCount
    fileSizeBytes
    downloadUrl
    parts {
      partNumber
      sizeBytes
      downloadUrl
    }
    expiresAt
    createdAt
  }
}
    `;

/**
 * __useMyBulkExportsQuery__
 *
 * To run a query within a React component, call `useMyBulkExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBulkExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBulkExportsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyBulkExportsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<MyBulkExportsQuery, MyBulkExportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyBulkExportsQuery, MyBulkExportsQueryVariables>(MyBulkExportsDocument, options);
      }
export function useMyBulkExportsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<MyBulkExportsQuery, MyBulkExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyBulkExportsQuery, MyBulkExportsQueryVariables>(MyBulkExportsDocument, options);
        }
export function useMyBulkExportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<MyBulkExportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<MyBulkExportsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<MyBulkExportsQuery, MyBulkExportsQueryVariables>(MyBulkExportsDocument, options);
        }
export type MyBulkExportsQueryHookResult = ReturnType<typeof useMyBulkExportsQuery>;
export type MyBulkExportsLazyQueryHookResult = ReturnType<typeof useMyBulkExportsLazyQuery>;
export type MyBulkExportsSuspenseQueryHookResult = ReturnType<typeof useMyBulkExportsSuspenseQuery>;
export type MyBulkExportsQueryResult = ApolloReactHooks.useQuery.Result<MyBulkExportsQuery, MyBulkExportsQueryVariables>;
export const BulkExportUpdatedDocument = gql`
    subscription BulkExportUpdated($id: UUID!) {
  bulkExportUpdated(id: $id) {
    id
    status
    format
    documentCount
    processedCount
    packagedCount
    skippedCount
    skippedDocuments {
      documentId
      entryName
      reason
    }
    fileSizeBytes
    downloadUrl
    parts {
      partNumber
      sizeBytes
      downloadUrl
    }
    errorMessage
    expiresAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useBulkExportUpdatedSubscription__
 *
 * To run a query within a React component, call `useBulkExportUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBulkExportUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkExportUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBulkExportUpdatedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<BulkExportUpdatedSubscription, BulkExportUpdatedSubscriptionVariables> & ({ variables: BulkExportUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<BulkExportUpdatedSubscription, BulkExportUpdatedSubscriptionVariables>(BulkExportUpdatedDocument, options);
      }
export type BulkExportUpdatedSubscriptionHookResult = ReturnType<typeof useBulkExportUpdatedSubscription>;
export type BulkExportUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<BulkExportUpdatedSubscription>;
export const GetCommentDocument = gql`
    query GetComment($where: CommentWhereInput!) {
  comment(where: $where) {
    ...CommentSimple
  }
}
    ${CommentSimpleFragmentDoc}`;

/**
 * __useGetCommentQuery__
 *
 * To run a query within a React component, call `useGetCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCommentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetCommentQuery, GetCommentQueryVariables> & ({ variables: GetCommentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, options);
      }
export function useGetCommentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommentQuery, GetCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, options);
        }
export function useGetCommentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, options);
        }
export type GetCommentQueryHookResult = ReturnType<typeof useGetCommentQuery>;
export type GetCommentLazyQueryHookResult = ReturnType<typeof useGetCommentLazyQuery>;
export type GetCommentSuspenseQueryHookResult = ReturnType<typeof useGetCommentSuspenseQuery>;
export type GetCommentQueryResult = ApolloReactHooks.useQuery.Result<GetCommentQuery, GetCommentQueryVariables>;
export const GetCommentRepliesDocument = gql`
    query GetCommentReplies($where: CommentWhereInput!) {
  comment(where: $where) {
    __typename
    id
    isPrivate
    replies {
      ...ReplySimple
      parent {
        __typename
        id
      }
    }
  }
}
    ${ReplySimpleFragmentDoc}`;

/**
 * __useGetCommentRepliesQuery__
 *
 * To run a query within a React component, call `useGetCommentRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentRepliesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCommentRepliesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetCommentRepliesQuery, GetCommentRepliesQueryVariables> & ({ variables: GetCommentRepliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>(GetCommentRepliesDocument, options);
      }
export function useGetCommentRepliesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>(GetCommentRepliesDocument, options);
        }
export function useGetCommentRepliesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommentRepliesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommentRepliesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>(GetCommentRepliesDocument, options);
        }
export type GetCommentRepliesQueryHookResult = ReturnType<typeof useGetCommentRepliesQuery>;
export type GetCommentRepliesLazyQueryHookResult = ReturnType<typeof useGetCommentRepliesLazyQuery>;
export type GetCommentRepliesSuspenseQueryHookResult = ReturnType<typeof useGetCommentRepliesSuspenseQuery>;
export type GetCommentRepliesQueryResult = ApolloReactHooks.useQuery.Result<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>;
export const GetCommentsDocument = gql`
    query GetComments($where: CommentsWhereInput!) {
  comments(where: $where) {
    ...CommentSimple
  }
}
    ${CommentSimpleFragmentDoc}`;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetCommentsQuery, GetCommentsQueryVariables> & ({ variables: GetCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export function useGetCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsSuspenseQueryHookResult = ReturnType<typeof useGetCommentsSuspenseQuery>;
export type GetCommentsQueryResult = ApolloReactHooks.useQuery.Result<GetCommentsQuery, GetCommentsQueryVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: NewCommentInput!) {
  createComment(input: $input) {
    comment {
      ...CommentSimple
    }
  }
}
    ${CommentSimpleFragmentDoc}`;
export type CreateCommentMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = ApolloReactHooks.useMutation.Result<CreateCommentMutation>;
export type CreateCommentMutationOptions = ApolloReactHooks.useMutation.Options<CreateCommentMutation, CreateCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    comment {
      ...CommentSimple
    }
  }
}
    ${CommentSimpleFragmentDoc}`;
export type UpdateCommentMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = ApolloReactHooks.useMutation.Result<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = ApolloReactHooks.useMutation.Options<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const DisableCommentDocument = gql`
    mutation DisableComment($input: DeleteCommentInput!) {
  disableComment(input: $input) {
    comment {
      id
    }
  }
}
    `;
export type DisableCommentMutationFn = ApolloReactHooks.useMutation.MutationFunction<DisableCommentMutation, DisableCommentMutationVariables>;

/**
 * __useDisableCommentMutation__
 *
 * To run a mutation, you first call `useDisableCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableCommentMutation, { data, loading, error }] = useDisableCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableCommentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DisableCommentMutation, DisableCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableCommentMutation, DisableCommentMutationVariables>(DisableCommentDocument, options);
      }
export type DisableCommentMutationHookResult = ReturnType<typeof useDisableCommentMutation>;
export type DisableCommentMutationResult = ApolloReactHooks.useMutation.Result<DisableCommentMutation>;
export type DisableCommentMutationOptions = ApolloReactHooks.useMutation.Options<DisableCommentMutation, DisableCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($input: DeleteCommentInput!) {
  deleteComment(input: $input) {
    comment {
      __typename
      id
    }
  }
}
    `;
export type DeleteCommentMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = ApolloReactHooks.useMutation.Result<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = ApolloReactHooks.useMutation.Options<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const GetCommunityCategoriesDocument = gql`
    query GetCommunityCategories {
  communityCategories {
    ...CommunityCategorySimple
  }
}
    ${CommunityCategorySimpleFragmentDoc}`;

/**
 * __useGetCommunityCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCommunityCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunityCategoriesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>(GetCommunityCategoriesDocument, options);
      }
export function useGetCommunityCategoriesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>(GetCommunityCategoriesDocument, options);
        }
export function useGetCommunityCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommunityCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommunityCategoriesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>(GetCommunityCategoriesDocument, options);
        }
export type GetCommunityCategoriesQueryHookResult = ReturnType<typeof useGetCommunityCategoriesQuery>;
export type GetCommunityCategoriesLazyQueryHookResult = ReturnType<typeof useGetCommunityCategoriesLazyQuery>;
export type GetCommunityCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCommunityCategoriesSuspenseQuery>;
export type GetCommunityCategoriesQueryResult = ApolloReactHooks.useQuery.Result<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>;
export const CreateCommunityCategoryDocument = gql`
    mutation CreateCommunityCategory($input: CreateCommunityCategoryInput!) {
  createCommunityCategory(input: $input) {
    ...CommunityCategorySimple
  }
}
    ${CommunityCategorySimpleFragmentDoc}`;
export type CreateCommunityCategoryMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateCommunityCategoryMutation, CreateCommunityCategoryMutationVariables>;

/**
 * __useCreateCommunityCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCommunityCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityCategoryMutation, { data, loading, error }] = useCreateCommunityCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityCategoryMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateCommunityCategoryMutation, CreateCommunityCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCommunityCategoryMutation, CreateCommunityCategoryMutationVariables>(CreateCommunityCategoryDocument, options);
      }
export type CreateCommunityCategoryMutationHookResult = ReturnType<typeof useCreateCommunityCategoryMutation>;
export type CreateCommunityCategoryMutationResult = ApolloReactHooks.useMutation.Result<CreateCommunityCategoryMutation>;
export type CreateCommunityCategoryMutationOptions = ApolloReactHooks.useMutation.Options<CreateCommunityCategoryMutation, CreateCommunityCategoryMutationVariables>;
export const GetSupportedLicensesDocument = gql`
    query GetSupportedLicenses {
  supportedLicenses {
    __typename
    id
    name
    url
  }
}
    `;

/**
 * __useGetSupportedLicensesQuery__
 *
 * To run a query within a React component, call `useGetSupportedLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedLicensesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportedLicensesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetSupportedLicensesQuery, GetSupportedLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSupportedLicensesQuery, GetSupportedLicensesQueryVariables>(GetSupportedLicensesDocument, options);
      }
export function useGetSupportedLicensesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetSupportedLicensesQuery, GetSupportedLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSupportedLicensesQuery, GetSupportedLicensesQueryVariables>(GetSupportedLicensesDocument, options);
        }
export function useGetSupportedLicensesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetSupportedLicensesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetSupportedLicensesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetSupportedLicensesQuery, GetSupportedLicensesQueryVariables>(GetSupportedLicensesDocument, options);
        }
export type GetSupportedLicensesQueryHookResult = ReturnType<typeof useGetSupportedLicensesQuery>;
export type GetSupportedLicensesLazyQueryHookResult = ReturnType<typeof useGetSupportedLicensesLazyQuery>;
export type GetSupportedLicensesSuspenseQueryHookResult = ReturnType<typeof useGetSupportedLicensesSuspenseQuery>;
export type GetSupportedLicensesQueryResult = ApolloReactHooks.useQuery.Result<GetSupportedLicensesQuery, GetSupportedLicensesQueryVariables>;
export const TopCommunityWorkflowsDocument = gql`
    query TopCommunityWorkflows($limit: Int) {
  topCommunityWorkflows(limit: $limit) {
    id
    name
    description
  }
}
    `;

/**
 * __useTopCommunityWorkflowsQuery__
 *
 * To run a query within a React component, call `useTopCommunityWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopCommunityWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopCommunityWorkflowsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTopCommunityWorkflowsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<TopCommunityWorkflowsQuery, TopCommunityWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TopCommunityWorkflowsQuery, TopCommunityWorkflowsQueryVariables>(TopCommunityWorkflowsDocument, options);
      }
export function useTopCommunityWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<TopCommunityWorkflowsQuery, TopCommunityWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TopCommunityWorkflowsQuery, TopCommunityWorkflowsQueryVariables>(TopCommunityWorkflowsDocument, options);
        }
export function useTopCommunityWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<TopCommunityWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<TopCommunityWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<TopCommunityWorkflowsQuery, TopCommunityWorkflowsQueryVariables>(TopCommunityWorkflowsDocument, options);
        }
export type TopCommunityWorkflowsQueryHookResult = ReturnType<typeof useTopCommunityWorkflowsQuery>;
export type TopCommunityWorkflowsLazyQueryHookResult = ReturnType<typeof useTopCommunityWorkflowsLazyQuery>;
export type TopCommunityWorkflowsSuspenseQueryHookResult = ReturnType<typeof useTopCommunityWorkflowsSuspenseQuery>;
export type TopCommunityWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<TopCommunityWorkflowsQuery, TopCommunityWorkflowsQueryVariables>;
export const TopCommunityTemplatesDocument = gql`
    query TopCommunityTemplates($limit: Int) {
  topCommunityTemplates(limit: $limit) {
    id
    name
    description
  }
}
    `;

/**
 * __useTopCommunityTemplatesQuery__
 *
 * To run a query within a React component, call `useTopCommunityTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopCommunityTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopCommunityTemplatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTopCommunityTemplatesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<TopCommunityTemplatesQuery, TopCommunityTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TopCommunityTemplatesQuery, TopCommunityTemplatesQueryVariables>(TopCommunityTemplatesDocument, options);
      }
export function useTopCommunityTemplatesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<TopCommunityTemplatesQuery, TopCommunityTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TopCommunityTemplatesQuery, TopCommunityTemplatesQueryVariables>(TopCommunityTemplatesDocument, options);
        }
export function useTopCommunityTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<TopCommunityTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<TopCommunityTemplatesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<TopCommunityTemplatesQuery, TopCommunityTemplatesQueryVariables>(TopCommunityTemplatesDocument, options);
        }
export type TopCommunityTemplatesQueryHookResult = ReturnType<typeof useTopCommunityTemplatesQuery>;
export type TopCommunityTemplatesLazyQueryHookResult = ReturnType<typeof useTopCommunityTemplatesLazyQuery>;
export type TopCommunityTemplatesSuspenseQueryHookResult = ReturnType<typeof useTopCommunityTemplatesSuspenseQuery>;
export type TopCommunityTemplatesQueryResult = ApolloReactHooks.useQuery.Result<TopCommunityTemplatesQuery, TopCommunityTemplatesQueryVariables>;
export const TopCommunityContributorsDocument = gql`
    query TopCommunityContributors($limit: Int) {
  topCommunityContributors(limit: $limit) {
    ...AccountBase
  }
}
    ${AccountBaseFragmentDoc}`;

/**
 * __useTopCommunityContributorsQuery__
 *
 * To run a query within a React component, call `useTopCommunityContributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopCommunityContributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopCommunityContributorsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTopCommunityContributorsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<TopCommunityContributorsQuery, TopCommunityContributorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TopCommunityContributorsQuery, TopCommunityContributorsQueryVariables>(TopCommunityContributorsDocument, options);
      }
export function useTopCommunityContributorsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<TopCommunityContributorsQuery, TopCommunityContributorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TopCommunityContributorsQuery, TopCommunityContributorsQueryVariables>(TopCommunityContributorsDocument, options);
        }
export function useTopCommunityContributorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<TopCommunityContributorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<TopCommunityContributorsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<TopCommunityContributorsQuery, TopCommunityContributorsQueryVariables>(TopCommunityContributorsDocument, options);
        }
export type TopCommunityContributorsQueryHookResult = ReturnType<typeof useTopCommunityContributorsQuery>;
export type TopCommunityContributorsLazyQueryHookResult = ReturnType<typeof useTopCommunityContributorsLazyQuery>;
export type TopCommunityContributorsSuspenseQueryHookResult = ReturnType<typeof useTopCommunityContributorsSuspenseQuery>;
export type TopCommunityContributorsQueryResult = ApolloReactHooks.useQuery.Result<TopCommunityContributorsQuery, TopCommunityContributorsQueryVariables>;
export const GetCommunityTemplatesDocument = gql`
    query GetCommunityTemplates {
  communityTemplates {
    __typename
    id
    name
    description
    isCommunityTemplate
    numTimesImported
    requesterImportedDocumentIds
    variant
    communityCategories {
      ...CommunityCategorySimple
    }
    owner {
      ...UserBase
    }
    workflow {
      __typename
      id
    }
  }
}
    ${CommunityCategorySimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useGetCommunityTemplatesQuery__
 *
 * To run a query within a React component, call `useGetCommunityTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunityTemplatesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetCommunityTemplatesQuery, GetCommunityTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommunityTemplatesQuery, GetCommunityTemplatesQueryVariables>(GetCommunityTemplatesDocument, options);
      }
export function useGetCommunityTemplatesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommunityTemplatesQuery, GetCommunityTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommunityTemplatesQuery, GetCommunityTemplatesQueryVariables>(GetCommunityTemplatesDocument, options);
        }
export function useGetCommunityTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommunityTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommunityTemplatesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommunityTemplatesQuery, GetCommunityTemplatesQueryVariables>(GetCommunityTemplatesDocument, options);
        }
export type GetCommunityTemplatesQueryHookResult = ReturnType<typeof useGetCommunityTemplatesQuery>;
export type GetCommunityTemplatesLazyQueryHookResult = ReturnType<typeof useGetCommunityTemplatesLazyQuery>;
export type GetCommunityTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetCommunityTemplatesSuspenseQuery>;
export type GetCommunityTemplatesQueryResult = ApolloReactHooks.useQuery.Result<GetCommunityTemplatesQuery, GetCommunityTemplatesQueryVariables>;
export const GetCommunityTemplateDocument = gql`
    query GetCommunityTemplate($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    description
    isCommunityTemplate
    requesterImportedDocumentIds
    storableType
    variant
    latestVersion {
      ...FileVersionSimple
    }
    license {
      __typename
      id
      name
      url
    }
    owner {
      ...UserBase
    }
    workflow {
      id
    }
  }
}
    ${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useGetCommunityTemplateQuery__
 *
 * To run a query within a React component, call `useGetCommunityTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityTemplateQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCommunityTemplateQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetCommunityTemplateQuery, GetCommunityTemplateQueryVariables> & ({ variables: GetCommunityTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommunityTemplateQuery, GetCommunityTemplateQueryVariables>(GetCommunityTemplateDocument, options);
      }
export function useGetCommunityTemplateLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommunityTemplateQuery, GetCommunityTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommunityTemplateQuery, GetCommunityTemplateQueryVariables>(GetCommunityTemplateDocument, options);
        }
export function useGetCommunityTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommunityTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommunityTemplateQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommunityTemplateQuery, GetCommunityTemplateQueryVariables>(GetCommunityTemplateDocument, options);
        }
export type GetCommunityTemplateQueryHookResult = ReturnType<typeof useGetCommunityTemplateQuery>;
export type GetCommunityTemplateLazyQueryHookResult = ReturnType<typeof useGetCommunityTemplateLazyQuery>;
export type GetCommunityTemplateSuspenseQueryHookResult = ReturnType<typeof useGetCommunityTemplateSuspenseQuery>;
export type GetCommunityTemplateQueryResult = ApolloReactHooks.useQuery.Result<GetCommunityTemplateQuery, GetCommunityTemplateQueryVariables>;
export const GetCommunityWorkflowsDocument = gql`
    query GetCommunityWorkflows {
  communityWorkflows {
    __typename
    id
    name
    description
    isCommunityWorkflow
    numTimesImported
    requesterImportedWorkflowIds
    communityCategories {
      ...CommunityCategorySimple
    }
    owner {
      ...UserBase
    }
    createdAt
    updatedAt
  }
}
    ${CommunityCategorySimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useGetCommunityWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetCommunityWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunityWorkflowsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetCommunityWorkflowsQuery, GetCommunityWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommunityWorkflowsQuery, GetCommunityWorkflowsQueryVariables>(GetCommunityWorkflowsDocument, options);
      }
export function useGetCommunityWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommunityWorkflowsQuery, GetCommunityWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommunityWorkflowsQuery, GetCommunityWorkflowsQueryVariables>(GetCommunityWorkflowsDocument, options);
        }
export function useGetCommunityWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommunityWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommunityWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommunityWorkflowsQuery, GetCommunityWorkflowsQueryVariables>(GetCommunityWorkflowsDocument, options);
        }
export type GetCommunityWorkflowsQueryHookResult = ReturnType<typeof useGetCommunityWorkflowsQuery>;
export type GetCommunityWorkflowsLazyQueryHookResult = ReturnType<typeof useGetCommunityWorkflowsLazyQuery>;
export type GetCommunityWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetCommunityWorkflowsSuspenseQuery>;
export type GetCommunityWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<GetCommunityWorkflowsQuery, GetCommunityWorkflowsQueryVariables>;
export const GetCommunityWorkflowDocument = gql`
    query GetCommunityWorkflow($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    ...WorkflowFragment
    requesterImportedWorkflowIds
    owner {
      ...UserBase
    }
    files {
      ...WorkflowFileSimple
    }
  }
}
    ${WorkflowFragmentFragmentDoc}
${UserBaseFragmentDoc}
${WorkflowFileSimpleFragmentDoc}`;

/**
 * __useGetCommunityWorkflowQuery__
 *
 * To run a query within a React component, call `useGetCommunityWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetCommunityWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetCommunityWorkflowQuery, GetCommunityWorkflowQueryVariables> & ({ variables: GetCommunityWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommunityWorkflowQuery, GetCommunityWorkflowQueryVariables>(GetCommunityWorkflowDocument, options);
      }
export function useGetCommunityWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommunityWorkflowQuery, GetCommunityWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommunityWorkflowQuery, GetCommunityWorkflowQueryVariables>(GetCommunityWorkflowDocument, options);
        }
export function useGetCommunityWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommunityWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommunityWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommunityWorkflowQuery, GetCommunityWorkflowQueryVariables>(GetCommunityWorkflowDocument, options);
        }
export type GetCommunityWorkflowQueryHookResult = ReturnType<typeof useGetCommunityWorkflowQuery>;
export type GetCommunityWorkflowLazyQueryHookResult = ReturnType<typeof useGetCommunityWorkflowLazyQuery>;
export type GetCommunityWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetCommunityWorkflowSuspenseQuery>;
export type GetCommunityWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetCommunityWorkflowQuery, GetCommunityWorkflowQueryVariables>;
export const GetCommunityInfoBoxWorkflowDocument = gql`
    query GetCommunityInfoBoxWorkflow($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    description
    variant
    requesterImportedWorkflowIds
    owner {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetCommunityInfoBoxWorkflowQuery__
 *
 * To run a query within a React component, call `useGetCommunityInfoBoxWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityInfoBoxWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityInfoBoxWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetCommunityInfoBoxWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetCommunityInfoBoxWorkflowQuery, GetCommunityInfoBoxWorkflowQueryVariables> & ({ variables: GetCommunityInfoBoxWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommunityInfoBoxWorkflowQuery, GetCommunityInfoBoxWorkflowQueryVariables>(GetCommunityInfoBoxWorkflowDocument, options);
      }
export function useGetCommunityInfoBoxWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommunityInfoBoxWorkflowQuery, GetCommunityInfoBoxWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommunityInfoBoxWorkflowQuery, GetCommunityInfoBoxWorkflowQueryVariables>(GetCommunityInfoBoxWorkflowDocument, options);
        }
export function useGetCommunityInfoBoxWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommunityInfoBoxWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommunityInfoBoxWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommunityInfoBoxWorkflowQuery, GetCommunityInfoBoxWorkflowQueryVariables>(GetCommunityInfoBoxWorkflowDocument, options);
        }
export type GetCommunityInfoBoxWorkflowQueryHookResult = ReturnType<typeof useGetCommunityInfoBoxWorkflowQuery>;
export type GetCommunityInfoBoxWorkflowLazyQueryHookResult = ReturnType<typeof useGetCommunityInfoBoxWorkflowLazyQuery>;
export type GetCommunityInfoBoxWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetCommunityInfoBoxWorkflowSuspenseQuery>;
export type GetCommunityInfoBoxWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetCommunityInfoBoxWorkflowQuery, GetCommunityInfoBoxWorkflowQueryVariables>;
export const GetCommunityWorkflowMetricsDocument = gql`
    query GetCommunityWorkflowMetrics($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    requesterImportedWorkflowIds
    id
    variant
    fileCount
    numTimesImported
    files {
      __typename
      id
      document {
        __typename
        id
        license {
          __typename
          id
          name
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommunityWorkflowMetricsQuery__
 *
 * To run a query within a React component, call `useGetCommunityWorkflowMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityWorkflowMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityWorkflowMetricsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetCommunityWorkflowMetricsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetCommunityWorkflowMetricsQuery, GetCommunityWorkflowMetricsQueryVariables> & ({ variables: GetCommunityWorkflowMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommunityWorkflowMetricsQuery, GetCommunityWorkflowMetricsQueryVariables>(GetCommunityWorkflowMetricsDocument, options);
      }
export function useGetCommunityWorkflowMetricsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCommunityWorkflowMetricsQuery, GetCommunityWorkflowMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommunityWorkflowMetricsQuery, GetCommunityWorkflowMetricsQueryVariables>(GetCommunityWorkflowMetricsDocument, options);
        }
export function useGetCommunityWorkflowMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCommunityWorkflowMetricsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCommunityWorkflowMetricsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCommunityWorkflowMetricsQuery, GetCommunityWorkflowMetricsQueryVariables>(GetCommunityWorkflowMetricsDocument, options);
        }
export type GetCommunityWorkflowMetricsQueryHookResult = ReturnType<typeof useGetCommunityWorkflowMetricsQuery>;
export type GetCommunityWorkflowMetricsLazyQueryHookResult = ReturnType<typeof useGetCommunityWorkflowMetricsLazyQuery>;
export type GetCommunityWorkflowMetricsSuspenseQueryHookResult = ReturnType<typeof useGetCommunityWorkflowMetricsSuspenseQuery>;
export type GetCommunityWorkflowMetricsQueryResult = ApolloReactHooks.useQuery.Result<GetCommunityWorkflowMetricsQuery, GetCommunityWorkflowMetricsQueryVariables>;
export const GetImportedWorkflowDocument = gql`
    query GetImportedWorkflow($sourceWorkflowId: UUID!) {
  getImportedWorkflow(sourceWorkflowId: $sourceWorkflowId) {
    ...WorkflowFragment
    requesterImportedWorkflowIds
    owner {
      ...UserBase
    }
    files {
      ...WorkflowFileSimple
    }
  }
}
    ${WorkflowFragmentFragmentDoc}
${UserBaseFragmentDoc}
${WorkflowFileSimpleFragmentDoc}`;

/**
 * __useGetImportedWorkflowQuery__
 *
 * To run a query within a React component, call `useGetImportedWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportedWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportedWorkflowQuery({
 *   variables: {
 *      sourceWorkflowId: // value for 'sourceWorkflowId'
 *   },
 * });
 */
export function useGetImportedWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetImportedWorkflowQuery, GetImportedWorkflowQueryVariables> & ({ variables: GetImportedWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetImportedWorkflowQuery, GetImportedWorkflowQueryVariables>(GetImportedWorkflowDocument, options);
      }
export function useGetImportedWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetImportedWorkflowQuery, GetImportedWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetImportedWorkflowQuery, GetImportedWorkflowQueryVariables>(GetImportedWorkflowDocument, options);
        }
export function useGetImportedWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetImportedWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetImportedWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetImportedWorkflowQuery, GetImportedWorkflowQueryVariables>(GetImportedWorkflowDocument, options);
        }
export type GetImportedWorkflowQueryHookResult = ReturnType<typeof useGetImportedWorkflowQuery>;
export type GetImportedWorkflowLazyQueryHookResult = ReturnType<typeof useGetImportedWorkflowLazyQuery>;
export type GetImportedWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetImportedWorkflowSuspenseQuery>;
export type GetImportedWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetImportedWorkflowQuery, GetImportedWorkflowQueryVariables>;
export const MayPublishWorkflowToCommunityDocument = gql`
    query MayPublishWorkflowToCommunity($workflowId: UUID!) {
  mayPublishWorkflowToCommunity(workflowId: $workflowId) {
    ok
    errorMsgs
  }
}
    `;

/**
 * __useMayPublishWorkflowToCommunityQuery__
 *
 * To run a query within a React component, call `useMayPublishWorkflowToCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useMayPublishWorkflowToCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMayPublishWorkflowToCommunityQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useMayPublishWorkflowToCommunityQuery(baseOptions: ApolloReactHooks.useQuery.Options<MayPublishWorkflowToCommunityQuery, MayPublishWorkflowToCommunityQueryVariables> & ({ variables: MayPublishWorkflowToCommunityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MayPublishWorkflowToCommunityQuery, MayPublishWorkflowToCommunityQueryVariables>(MayPublishWorkflowToCommunityDocument, options);
      }
export function useMayPublishWorkflowToCommunityLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<MayPublishWorkflowToCommunityQuery, MayPublishWorkflowToCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MayPublishWorkflowToCommunityQuery, MayPublishWorkflowToCommunityQueryVariables>(MayPublishWorkflowToCommunityDocument, options);
        }
export function useMayPublishWorkflowToCommunitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<MayPublishWorkflowToCommunityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<MayPublishWorkflowToCommunityQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<MayPublishWorkflowToCommunityQuery, MayPublishWorkflowToCommunityQueryVariables>(MayPublishWorkflowToCommunityDocument, options);
        }
export type MayPublishWorkflowToCommunityQueryHookResult = ReturnType<typeof useMayPublishWorkflowToCommunityQuery>;
export type MayPublishWorkflowToCommunityLazyQueryHookResult = ReturnType<typeof useMayPublishWorkflowToCommunityLazyQuery>;
export type MayPublishWorkflowToCommunitySuspenseQueryHookResult = ReturnType<typeof useMayPublishWorkflowToCommunitySuspenseQuery>;
export type MayPublishWorkflowToCommunityQueryResult = ApolloReactHooks.useQuery.Result<MayPublishWorkflowToCommunityQuery, MayPublishWorkflowToCommunityQueryVariables>;
export const SetCommunityWorkflowDocument = gql`
    mutation SetCommunityWorkflow($input: SetCommunityWorkflowInput!) {
  setCommunityWorkflow(input: $input) {
    workflow {
      id
      isCommunityWorkflow
      communityCategories {
        ...CommunityCategorySimple
      }
    }
  }
}
    ${CommunityCategorySimpleFragmentDoc}`;
export type SetCommunityWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetCommunityWorkflowMutation, SetCommunityWorkflowMutationVariables>;

/**
 * __useSetCommunityWorkflowMutation__
 *
 * To run a mutation, you first call `useSetCommunityWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCommunityWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCommunityWorkflowMutation, { data, loading, error }] = useSetCommunityWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCommunityWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetCommunityWorkflowMutation, SetCommunityWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCommunityWorkflowMutation, SetCommunityWorkflowMutationVariables>(SetCommunityWorkflowDocument, options);
      }
export type SetCommunityWorkflowMutationHookResult = ReturnType<typeof useSetCommunityWorkflowMutation>;
export type SetCommunityWorkflowMutationResult = ApolloReactHooks.useMutation.Result<SetCommunityWorkflowMutation>;
export type SetCommunityWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<SetCommunityWorkflowMutation, SetCommunityWorkflowMutationVariables>;
export const SetCommunityTemplateDocument = gql`
    mutation SetCommunityTemplate($input: SetCommunityTemplateInput!) {
  setCommunityTemplate(input: $input) {
    document {
      id
      description
      isCommunityTemplate
      communityCategories {
        ...CommunityCategorySimple
      }
      workflow {
        __typename
        id
      }
    }
  }
}
    ${CommunityCategorySimpleFragmentDoc}`;
export type SetCommunityTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetCommunityTemplateMutation, SetCommunityTemplateMutationVariables>;

/**
 * __useSetCommunityTemplateMutation__
 *
 * To run a mutation, you first call `useSetCommunityTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCommunityTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCommunityTemplateMutation, { data, loading, error }] = useSetCommunityTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCommunityTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetCommunityTemplateMutation, SetCommunityTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCommunityTemplateMutation, SetCommunityTemplateMutationVariables>(SetCommunityTemplateDocument, options);
      }
export type SetCommunityTemplateMutationHookResult = ReturnType<typeof useSetCommunityTemplateMutation>;
export type SetCommunityTemplateMutationResult = ApolloReactHooks.useMutation.Result<SetCommunityTemplateMutation>;
export type SetCommunityTemplateMutationOptions = ApolloReactHooks.useMutation.Options<SetCommunityTemplateMutation, SetCommunityTemplateMutationVariables>;
export const ImportCommunityWorkflowDocument = gql`
    mutation ImportCommunityWorkflow($input: ImportCommunityWorkflowInput!) {
  importCommunityWorkflow(input: $input) {
    workflow {
      id
      isCommunityWorkflow
      requesterImportedWorkflowIds
    }
  }
}
    `;
export type ImportCommunityWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<ImportCommunityWorkflowMutation, ImportCommunityWorkflowMutationVariables>;

/**
 * __useImportCommunityWorkflowMutation__
 *
 * To run a mutation, you first call `useImportCommunityWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCommunityWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCommunityWorkflowMutation, { data, loading, error }] = useImportCommunityWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportCommunityWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ImportCommunityWorkflowMutation, ImportCommunityWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImportCommunityWorkflowMutation, ImportCommunityWorkflowMutationVariables>(ImportCommunityWorkflowDocument, options);
      }
export type ImportCommunityWorkflowMutationHookResult = ReturnType<typeof useImportCommunityWorkflowMutation>;
export type ImportCommunityWorkflowMutationResult = ApolloReactHooks.useMutation.Result<ImportCommunityWorkflowMutation>;
export type ImportCommunityWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<ImportCommunityWorkflowMutation, ImportCommunityWorkflowMutationVariables>;
export const GetMyContractTypesDocument = gql`
    query GetMyContractTypes {
  myContractTypes {
    ...ContractTypeSimple
  }
}
    ${ContractTypeSimpleFragmentDoc}`;

/**
 * __useGetMyContractTypesQuery__
 *
 * To run a query within a React component, call `useGetMyContractTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContractTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContractTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyContractTypesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetMyContractTypesQuery, GetMyContractTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyContractTypesQuery, GetMyContractTypesQueryVariables>(GetMyContractTypesDocument, options);
      }
export function useGetMyContractTypesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyContractTypesQuery, GetMyContractTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyContractTypesQuery, GetMyContractTypesQueryVariables>(GetMyContractTypesDocument, options);
        }
export function useGetMyContractTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyContractTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyContractTypesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyContractTypesQuery, GetMyContractTypesQueryVariables>(GetMyContractTypesDocument, options);
        }
export type GetMyContractTypesQueryHookResult = ReturnType<typeof useGetMyContractTypesQuery>;
export type GetMyContractTypesLazyQueryHookResult = ReturnType<typeof useGetMyContractTypesLazyQuery>;
export type GetMyContractTypesSuspenseQueryHookResult = ReturnType<typeof useGetMyContractTypesSuspenseQuery>;
export type GetMyContractTypesQueryResult = ApolloReactHooks.useQuery.Result<GetMyContractTypesQuery, GetMyContractTypesQueryVariables>;
export const GetMyContractTypesWithDocumentCountDocument = gql`
    query GetMyContractTypesWithDocumentCount {
  myContractTypes {
    ...ContractTypeSimple
    documentCount
  }
}
    ${ContractTypeSimpleFragmentDoc}`;

/**
 * __useGetMyContractTypesWithDocumentCountQuery__
 *
 * To run a query within a React component, call `useGetMyContractTypesWithDocumentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContractTypesWithDocumentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContractTypesWithDocumentCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyContractTypesWithDocumentCountQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetMyContractTypesWithDocumentCountQuery, GetMyContractTypesWithDocumentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyContractTypesWithDocumentCountQuery, GetMyContractTypesWithDocumentCountQueryVariables>(GetMyContractTypesWithDocumentCountDocument, options);
      }
export function useGetMyContractTypesWithDocumentCountLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyContractTypesWithDocumentCountQuery, GetMyContractTypesWithDocumentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyContractTypesWithDocumentCountQuery, GetMyContractTypesWithDocumentCountQueryVariables>(GetMyContractTypesWithDocumentCountDocument, options);
        }
export function useGetMyContractTypesWithDocumentCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyContractTypesWithDocumentCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyContractTypesWithDocumentCountQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyContractTypesWithDocumentCountQuery, GetMyContractTypesWithDocumentCountQueryVariables>(GetMyContractTypesWithDocumentCountDocument, options);
        }
export type GetMyContractTypesWithDocumentCountQueryHookResult = ReturnType<typeof useGetMyContractTypesWithDocumentCountQuery>;
export type GetMyContractTypesWithDocumentCountLazyQueryHookResult = ReturnType<typeof useGetMyContractTypesWithDocumentCountLazyQuery>;
export type GetMyContractTypesWithDocumentCountSuspenseQueryHookResult = ReturnType<typeof useGetMyContractTypesWithDocumentCountSuspenseQuery>;
export type GetMyContractTypesWithDocumentCountQueryResult = ApolloReactHooks.useQuery.Result<GetMyContractTypesWithDocumentCountQuery, GetMyContractTypesWithDocumentCountQueryVariables>;
export const GetDocumentTypeDocument = gql`
    query GetDocumentType($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    type {
      __typename
      id
      value
    }
  }
}
    `;

/**
 * __useGetDocumentTypeQuery__
 *
 * To run a query within a React component, call `useGetDocumentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentTypeQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentTypeQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentTypeQuery, GetDocumentTypeQueryVariables> & ({ variables: GetDocumentTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>(GetDocumentTypeDocument, options);
      }
export function useGetDocumentTypeLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>(GetDocumentTypeDocument, options);
        }
export function useGetDocumentTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentTypeQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>(GetDocumentTypeDocument, options);
        }
export type GetDocumentTypeQueryHookResult = ReturnType<typeof useGetDocumentTypeQuery>;
export type GetDocumentTypeLazyQueryHookResult = ReturnType<typeof useGetDocumentTypeLazyQuery>;
export type GetDocumentTypeSuspenseQueryHookResult = ReturnType<typeof useGetDocumentTypeSuspenseQuery>;
export type GetDocumentTypeQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>;
export const CreateContractTypesDocument = gql`
    mutation CreateContractTypes($input: [CreateContractTypeProps!]!) {
  createContractTypes(input: $input) {
    ...ContractTypeSimple
  }
}
    ${ContractTypeSimpleFragmentDoc}`;
export type CreateContractTypesMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateContractTypesMutation, CreateContractTypesMutationVariables>;

/**
 * __useCreateContractTypesMutation__
 *
 * To run a mutation, you first call `useCreateContractTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractTypesMutation, { data, loading, error }] = useCreateContractTypesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractTypesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateContractTypesMutation, CreateContractTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateContractTypesMutation, CreateContractTypesMutationVariables>(CreateContractTypesDocument, options);
      }
export type CreateContractTypesMutationHookResult = ReturnType<typeof useCreateContractTypesMutation>;
export type CreateContractTypesMutationResult = ApolloReactHooks.useMutation.Result<CreateContractTypesMutation>;
export type CreateContractTypesMutationOptions = ApolloReactHooks.useMutation.Options<CreateContractTypesMutation, CreateContractTypesMutationVariables>;
export const MergeContractTypesDocument = gql`
    mutation MergeContractTypes($input: MergeTypesInput!) {
  mergeContractTypes(input: $input) {
    __typename
    id
    value
    documentCount
  }
}
    `;
export type MergeContractTypesMutationFn = ApolloReactHooks.useMutation.MutationFunction<MergeContractTypesMutation, MergeContractTypesMutationVariables>;

/**
 * __useMergeContractTypesMutation__
 *
 * To run a mutation, you first call `useMergeContractTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeContractTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeContractTypesMutation, { data, loading, error }] = useMergeContractTypesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeContractTypesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MergeContractTypesMutation, MergeContractTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeContractTypesMutation, MergeContractTypesMutationVariables>(MergeContractTypesDocument, options);
      }
export type MergeContractTypesMutationHookResult = ReturnType<typeof useMergeContractTypesMutation>;
export type MergeContractTypesMutationResult = ApolloReactHooks.useMutation.Result<MergeContractTypesMutation>;
export type MergeContractTypesMutationOptions = ApolloReactHooks.useMutation.Options<MergeContractTypesMutation, MergeContractTypesMutationVariables>;
export const UpdateContractTypeDocument = gql`
    mutation UpdateContractType($input: UpdateContractTypeInput!) {
  updateContractType(input: $input) {
    ...ContractTypeSimple
  }
}
    ${ContractTypeSimpleFragmentDoc}`;
export type UpdateContractTypeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateContractTypeMutation, UpdateContractTypeMutationVariables>;

/**
 * __useUpdateContractTypeMutation__
 *
 * To run a mutation, you first call `useUpdateContractTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractTypeMutation, { data, loading, error }] = useUpdateContractTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractTypeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateContractTypeMutation, UpdateContractTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContractTypeMutation, UpdateContractTypeMutationVariables>(UpdateContractTypeDocument, options);
      }
export type UpdateContractTypeMutationHookResult = ReturnType<typeof useUpdateContractTypeMutation>;
export type UpdateContractTypeMutationResult = ApolloReactHooks.useMutation.Result<UpdateContractTypeMutation>;
export type UpdateContractTypeMutationOptions = ApolloReactHooks.useMutation.Options<UpdateContractTypeMutation, UpdateContractTypeMutationVariables>;
export const DeleteContractTypeDocument = gql`
    mutation DeleteContractType($input: DeleteContractTypeInput!) {
  deleteContractType(input: $input) {
    ...ContractTypeSimple
    documentCount
  }
}
    ${ContractTypeSimpleFragmentDoc}`;
export type DeleteContractTypeMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteContractTypeMutation, DeleteContractTypeMutationVariables>;

/**
 * __useDeleteContractTypeMutation__
 *
 * To run a mutation, you first call `useDeleteContractTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractTypeMutation, { data, loading, error }] = useDeleteContractTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContractTypeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteContractTypeMutation, DeleteContractTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteContractTypeMutation, DeleteContractTypeMutationVariables>(DeleteContractTypeDocument, options);
      }
export type DeleteContractTypeMutationHookResult = ReturnType<typeof useDeleteContractTypeMutation>;
export type DeleteContractTypeMutationResult = ApolloReactHooks.useMutation.Result<DeleteContractTypeMutation>;
export type DeleteContractTypeMutationOptions = ApolloReactHooks.useMutation.Options<DeleteContractTypeMutation, DeleteContractTypeMutationVariables>;
export const UpdateDocumentTypeDocument = gql`
    mutation UpdateDocumentType($input: UpdateDocumentTypeInput!) {
  updateDocumentType(input: $input) {
    __typename
    id
    type {
      __typename
      id
      value
    }
  }
}
    `;
export type UpdateDocumentTypeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>;

/**
 * __useUpdateDocumentTypeMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentTypeMutation, { data, loading, error }] = useUpdateDocumentTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentTypeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>(UpdateDocumentTypeDocument, options);
      }
export type UpdateDocumentTypeMutationHookResult = ReturnType<typeof useUpdateDocumentTypeMutation>;
export type UpdateDocumentTypeMutationResult = ApolloReactHooks.useMutation.Result<UpdateDocumentTypeMutation>;
export type UpdateDocumentTypeMutationOptions = ApolloReactHooks.useMutation.Options<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>;
export const DocumentMetadataImportsDocument = gql`
    query DocumentMetadataImports {
  documentMetadataImports {
    ...DocumentMetadataImportHistoryFields
  }
}
    ${DocumentMetadataImportHistoryFieldsFragmentDoc}`;

/**
 * __useDocumentMetadataImportsQuery__
 *
 * To run a query within a React component, call `useDocumentMetadataImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentMetadataImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentMetadataImportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentMetadataImportsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<DocumentMetadataImportsQuery, DocumentMetadataImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentMetadataImportsQuery, DocumentMetadataImportsQueryVariables>(DocumentMetadataImportsDocument, options);
      }
export function useDocumentMetadataImportsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<DocumentMetadataImportsQuery, DocumentMetadataImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentMetadataImportsQuery, DocumentMetadataImportsQueryVariables>(DocumentMetadataImportsDocument, options);
        }
export function useDocumentMetadataImportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<DocumentMetadataImportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<DocumentMetadataImportsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<DocumentMetadataImportsQuery, DocumentMetadataImportsQueryVariables>(DocumentMetadataImportsDocument, options);
        }
export type DocumentMetadataImportsQueryHookResult = ReturnType<typeof useDocumentMetadataImportsQuery>;
export type DocumentMetadataImportsLazyQueryHookResult = ReturnType<typeof useDocumentMetadataImportsLazyQuery>;
export type DocumentMetadataImportsSuspenseQueryHookResult = ReturnType<typeof useDocumentMetadataImportsSuspenseQuery>;
export type DocumentMetadataImportsQueryResult = ApolloReactHooks.useQuery.Result<DocumentMetadataImportsQuery, DocumentMetadataImportsQueryVariables>;
export const DocumentMetadataImportDocument = gql`
    query DocumentMetadataImport($id: UUID!) {
  documentMetadataImport(id: $id) {
    ...DocumentMetadataImportFields
  }
}
    ${DocumentMetadataImportFieldsFragmentDoc}`;

/**
 * __useDocumentMetadataImportQuery__
 *
 * To run a query within a React component, call `useDocumentMetadataImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentMetadataImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentMetadataImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentMetadataImportQuery(baseOptions: ApolloReactHooks.useQuery.Options<DocumentMetadataImportQuery, DocumentMetadataImportQueryVariables> & ({ variables: DocumentMetadataImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentMetadataImportQuery, DocumentMetadataImportQueryVariables>(DocumentMetadataImportDocument, options);
      }
export function useDocumentMetadataImportLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<DocumentMetadataImportQuery, DocumentMetadataImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentMetadataImportQuery, DocumentMetadataImportQueryVariables>(DocumentMetadataImportDocument, options);
        }
export function useDocumentMetadataImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<DocumentMetadataImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<DocumentMetadataImportQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<DocumentMetadataImportQuery, DocumentMetadataImportQueryVariables>(DocumentMetadataImportDocument, options);
        }
export type DocumentMetadataImportQueryHookResult = ReturnType<typeof useDocumentMetadataImportQuery>;
export type DocumentMetadataImportLazyQueryHookResult = ReturnType<typeof useDocumentMetadataImportLazyQuery>;
export type DocumentMetadataImportSuspenseQueryHookResult = ReturnType<typeof useDocumentMetadataImportSuspenseQuery>;
export type DocumentMetadataImportQueryResult = ApolloReactHooks.useQuery.Result<DocumentMetadataImportQuery, DocumentMetadataImportQueryVariables>;
export const DocumentMetadataImportPreviewDocument = gql`
    query DocumentMetadataImportPreview($importId: UUID!) {
  documentMetadataImportPreview(importId: $importId) {
    ...DocumentMetadataImportPreviewFields
  }
}
    ${DocumentMetadataImportPreviewFieldsFragmentDoc}`;

/**
 * __useDocumentMetadataImportPreviewQuery__
 *
 * To run a query within a React component, call `useDocumentMetadataImportPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentMetadataImportPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentMetadataImportPreviewQuery({
 *   variables: {
 *      importId: // value for 'importId'
 *   },
 * });
 */
export function useDocumentMetadataImportPreviewQuery(baseOptions: ApolloReactHooks.useQuery.Options<DocumentMetadataImportPreviewQuery, DocumentMetadataImportPreviewQueryVariables> & ({ variables: DocumentMetadataImportPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentMetadataImportPreviewQuery, DocumentMetadataImportPreviewQueryVariables>(DocumentMetadataImportPreviewDocument, options);
      }
export function useDocumentMetadataImportPreviewLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<DocumentMetadataImportPreviewQuery, DocumentMetadataImportPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentMetadataImportPreviewQuery, DocumentMetadataImportPreviewQueryVariables>(DocumentMetadataImportPreviewDocument, options);
        }
export function useDocumentMetadataImportPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<DocumentMetadataImportPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<DocumentMetadataImportPreviewQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<DocumentMetadataImportPreviewQuery, DocumentMetadataImportPreviewQueryVariables>(DocumentMetadataImportPreviewDocument, options);
        }
export type DocumentMetadataImportPreviewQueryHookResult = ReturnType<typeof useDocumentMetadataImportPreviewQuery>;
export type DocumentMetadataImportPreviewLazyQueryHookResult = ReturnType<typeof useDocumentMetadataImportPreviewLazyQuery>;
export type DocumentMetadataImportPreviewSuspenseQueryHookResult = ReturnType<typeof useDocumentMetadataImportPreviewSuspenseQuery>;
export type DocumentMetadataImportPreviewQueryResult = ApolloReactHooks.useQuery.Result<DocumentMetadataImportPreviewQuery, DocumentMetadataImportPreviewQueryVariables>;
export const DocumentMetadataImportHistoryDocument = gql`
    query DocumentMetadataImportHistory($id: UUID!) {
  documentMetadataImport(id: $id) {
    ...DocumentMetadataImportHistoryFields
  }
}
    ${DocumentMetadataImportHistoryFieldsFragmentDoc}`;

/**
 * __useDocumentMetadataImportHistoryQuery__
 *
 * To run a query within a React component, call `useDocumentMetadataImportHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentMetadataImportHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentMetadataImportHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentMetadataImportHistoryQuery(baseOptions: ApolloReactHooks.useQuery.Options<DocumentMetadataImportHistoryQuery, DocumentMetadataImportHistoryQueryVariables> & ({ variables: DocumentMetadataImportHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentMetadataImportHistoryQuery, DocumentMetadataImportHistoryQueryVariables>(DocumentMetadataImportHistoryDocument, options);
      }
export function useDocumentMetadataImportHistoryLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<DocumentMetadataImportHistoryQuery, DocumentMetadataImportHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentMetadataImportHistoryQuery, DocumentMetadataImportHistoryQueryVariables>(DocumentMetadataImportHistoryDocument, options);
        }
export function useDocumentMetadataImportHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<DocumentMetadataImportHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<DocumentMetadataImportHistoryQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<DocumentMetadataImportHistoryQuery, DocumentMetadataImportHistoryQueryVariables>(DocumentMetadataImportHistoryDocument, options);
        }
export type DocumentMetadataImportHistoryQueryHookResult = ReturnType<typeof useDocumentMetadataImportHistoryQuery>;
export type DocumentMetadataImportHistoryLazyQueryHookResult = ReturnType<typeof useDocumentMetadataImportHistoryLazyQuery>;
export type DocumentMetadataImportHistorySuspenseQueryHookResult = ReturnType<typeof useDocumentMetadataImportHistorySuspenseQuery>;
export type DocumentMetadataImportHistoryQueryResult = ApolloReactHooks.useQuery.Result<DocumentMetadataImportHistoryQuery, DocumentMetadataImportHistoryQueryVariables>;
export const GenerateMetadataImportTemplateDocument = gql`
    mutation GenerateMetadataImportTemplate($displayName: String, $extractionQuestionIds: [UUID!]!, $importId: UUID, $prefill: Boolean) {
  generateMetadataImportTemplate(
    displayName: $displayName
    extractionQuestionIds: $extractionQuestionIds
    importId: $importId
    prefill: $prefill
  ) {
    documentMetadataImport {
      ...DocumentMetadataImportFields
    }
    fileContent
    fileName
    templateVersion
  }
}
    ${DocumentMetadataImportFieldsFragmentDoc}`;
export type GenerateMetadataImportTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<GenerateMetadataImportTemplateMutation, GenerateMetadataImportTemplateMutationVariables>;

/**
 * __useGenerateMetadataImportTemplateMutation__
 *
 * To run a mutation, you first call `useGenerateMetadataImportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMetadataImportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMetadataImportTemplateMutation, { data, loading, error }] = useGenerateMetadataImportTemplateMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      extractionQuestionIds: // value for 'extractionQuestionIds'
 *      importId: // value for 'importId'
 *      prefill: // value for 'prefill'
 *   },
 * });
 */
export function useGenerateMetadataImportTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<GenerateMetadataImportTemplateMutation, GenerateMetadataImportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateMetadataImportTemplateMutation, GenerateMetadataImportTemplateMutationVariables>(GenerateMetadataImportTemplateDocument, options);
      }
export type GenerateMetadataImportTemplateMutationHookResult = ReturnType<typeof useGenerateMetadataImportTemplateMutation>;
export type GenerateMetadataImportTemplateMutationResult = ApolloReactHooks.useMutation.Result<GenerateMetadataImportTemplateMutation>;
export type GenerateMetadataImportTemplateMutationOptions = ApolloReactHooks.useMutation.Options<GenerateMetadataImportTemplateMutation, GenerateMetadataImportTemplateMutationVariables>;
export const UploadMetadataImportDocument = gql`
    mutation UploadMetadataImport($displayName: String!, $file: Upload!, $extractionQuestionIds: [UUID!]!, $importId: UUID!) {
  uploadMetadataImport(
    displayName: $displayName
    file: $file
    extractionQuestionIds: $extractionQuestionIds
    importId: $importId
  ) {
    documentMetadataImport {
      ...DocumentMetadataImportFields
    }
  }
}
    ${DocumentMetadataImportFieldsFragmentDoc}`;
export type UploadMetadataImportMutationFn = ApolloReactHooks.useMutation.MutationFunction<UploadMetadataImportMutation, UploadMetadataImportMutationVariables>;

/**
 * __useUploadMetadataImportMutation__
 *
 * To run a mutation, you first call `useUploadMetadataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMetadataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMetadataImportMutation, { data, loading, error }] = useUploadMetadataImportMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      file: // value for 'file'
 *      extractionQuestionIds: // value for 'extractionQuestionIds'
 *      importId: // value for 'importId'
 *   },
 * });
 */
export function useUploadMetadataImportMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UploadMetadataImportMutation, UploadMetadataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadMetadataImportMutation, UploadMetadataImportMutationVariables>(UploadMetadataImportDocument, options);
      }
export type UploadMetadataImportMutationHookResult = ReturnType<typeof useUploadMetadataImportMutation>;
export type UploadMetadataImportMutationResult = ApolloReactHooks.useMutation.Result<UploadMetadataImportMutation>;
export type UploadMetadataImportMutationOptions = ApolloReactHooks.useMutation.Options<UploadMetadataImportMutation, UploadMetadataImportMutationVariables>;
export const ConfirmMetadataImportDocument = gql`
    mutation ConfirmMetadataImport($importId: UUID!, $overwriteQuestionIds: [UUID!]!) {
  confirmMetadataImport(
    importId: $importId
    overwriteQuestionIds: $overwriteQuestionIds
  ) {
    documentMetadataImport {
      ...DocumentMetadataImportHistoryFields
    }
  }
}
    ${DocumentMetadataImportHistoryFieldsFragmentDoc}`;
export type ConfirmMetadataImportMutationFn = ApolloReactHooks.useMutation.MutationFunction<ConfirmMetadataImportMutation, ConfirmMetadataImportMutationVariables>;

/**
 * __useConfirmMetadataImportMutation__
 *
 * To run a mutation, you first call `useConfirmMetadataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMetadataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMetadataImportMutation, { data, loading, error }] = useConfirmMetadataImportMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *      overwriteQuestionIds: // value for 'overwriteQuestionIds'
 *   },
 * });
 */
export function useConfirmMetadataImportMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ConfirmMetadataImportMutation, ConfirmMetadataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmMetadataImportMutation, ConfirmMetadataImportMutationVariables>(ConfirmMetadataImportDocument, options);
      }
export type ConfirmMetadataImportMutationHookResult = ReturnType<typeof useConfirmMetadataImportMutation>;
export type ConfirmMetadataImportMutationResult = ApolloReactHooks.useMutation.Result<ConfirmMetadataImportMutation>;
export type ConfirmMetadataImportMutationOptions = ApolloReactHooks.useMutation.Options<ConfirmMetadataImportMutation, ConfirmMetadataImportMutationVariables>;
export const DeleteMetadataImportsDocument = gql`
    mutation DeleteMetadataImports($importIds: [UUID!]!) {
  deleteMetadataImports(importIds: $importIds) {
    deletedIds
  }
}
    `;
export type DeleteMetadataImportsMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteMetadataImportsMutation, DeleteMetadataImportsMutationVariables>;

/**
 * __useDeleteMetadataImportsMutation__
 *
 * To run a mutation, you first call `useDeleteMetadataImportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetadataImportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetadataImportsMutation, { data, loading, error }] = useDeleteMetadataImportsMutation({
 *   variables: {
 *      importIds: // value for 'importIds'
 *   },
 * });
 */
export function useDeleteMetadataImportsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteMetadataImportsMutation, DeleteMetadataImportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMetadataImportsMutation, DeleteMetadataImportsMutationVariables>(DeleteMetadataImportsDocument, options);
      }
export type DeleteMetadataImportsMutationHookResult = ReturnType<typeof useDeleteMetadataImportsMutation>;
export type DeleteMetadataImportsMutationResult = ApolloReactHooks.useMutation.Result<DeleteMetadataImportsMutation>;
export type DeleteMetadataImportsMutationOptions = ApolloReactHooks.useMutation.Options<DeleteMetadataImportsMutation, DeleteMetadataImportsMutationVariables>;
export const OnDocumentMetadataImportProgressDocument = gql`
    subscription OnDocumentMetadataImportProgress {
  documentMetadataImportProgress {
    ...DocumentMetadataImportHistoryFields
  }
}
    ${DocumentMetadataImportHistoryFieldsFragmentDoc}`;

/**
 * __useOnDocumentMetadataImportProgressSubscription__
 *
 * To run a query within a React component, call `useOnDocumentMetadataImportProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDocumentMetadataImportProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDocumentMetadataImportProgressSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDocumentMetadataImportProgressSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnDocumentMetadataImportProgressSubscription, OnDocumentMetadataImportProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnDocumentMetadataImportProgressSubscription, OnDocumentMetadataImportProgressSubscriptionVariables>(OnDocumentMetadataImportProgressDocument, options);
      }
export type OnDocumentMetadataImportProgressSubscriptionHookResult = ReturnType<typeof useOnDocumentMetadataImportProgressSubscription>;
export type OnDocumentMetadataImportProgressSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnDocumentMetadataImportProgressSubscription>;
export const GetEnvelopesDocument = gql`
    query GetEnvelopes {
  envelopes {
    ...EnvelopeSimple
  }
}
    ${EnvelopeSimpleFragmentDoc}`;

/**
 * __useGetEnvelopesQuery__
 *
 * To run a query within a React component, call `useGetEnvelopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvelopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvelopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnvelopesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetEnvelopesQuery, GetEnvelopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEnvelopesQuery, GetEnvelopesQueryVariables>(GetEnvelopesDocument, options);
      }
export function useGetEnvelopesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetEnvelopesQuery, GetEnvelopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEnvelopesQuery, GetEnvelopesQueryVariables>(GetEnvelopesDocument, options);
        }
export function useGetEnvelopesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetEnvelopesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetEnvelopesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetEnvelopesQuery, GetEnvelopesQueryVariables>(GetEnvelopesDocument, options);
        }
export type GetEnvelopesQueryHookResult = ReturnType<typeof useGetEnvelopesQuery>;
export type GetEnvelopesLazyQueryHookResult = ReturnType<typeof useGetEnvelopesLazyQuery>;
export type GetEnvelopesSuspenseQueryHookResult = ReturnType<typeof useGetEnvelopesSuspenseQuery>;
export type GetEnvelopesQueryResult = ApolloReactHooks.useQuery.Result<GetEnvelopesQuery, GetEnvelopesQueryVariables>;
export const GetEnvelopeDocument = gql`
    query GetEnvelope($id: UUID!) {
  envelope(id: $id) {
    ...EnvelopeWithFiles
  }
}
    ${EnvelopeWithFilesFragmentDoc}`;

/**
 * __useGetEnvelopeQuery__
 *
 * To run a query within a React component, call `useGetEnvelopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvelopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvelopeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEnvelopeQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetEnvelopeQuery, GetEnvelopeQueryVariables> & ({ variables: GetEnvelopeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEnvelopeQuery, GetEnvelopeQueryVariables>(GetEnvelopeDocument, options);
      }
export function useGetEnvelopeLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetEnvelopeQuery, GetEnvelopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEnvelopeQuery, GetEnvelopeQueryVariables>(GetEnvelopeDocument, options);
        }
export function useGetEnvelopeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetEnvelopeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetEnvelopeQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetEnvelopeQuery, GetEnvelopeQueryVariables>(GetEnvelopeDocument, options);
        }
export type GetEnvelopeQueryHookResult = ReturnType<typeof useGetEnvelopeQuery>;
export type GetEnvelopeLazyQueryHookResult = ReturnType<typeof useGetEnvelopeLazyQuery>;
export type GetEnvelopeSuspenseQueryHookResult = ReturnType<typeof useGetEnvelopeSuspenseQuery>;
export type GetEnvelopeQueryResult = ApolloReactHooks.useQuery.Result<GetEnvelopeQuery, GetEnvelopeQueryVariables>;
export const GetEnvelopeWithRecipientsDocument = gql`
    query GetEnvelopeWithRecipients($id: UUID!) {
  envelope(id: $id) {
    __typename
    id
    workflow {
      id
      state
      envelopeStatus
    }
    recipients {
      __typename
      id
      type
      assignee {
        ...UserBase
      }
      assigneeRole {
        ...UserDefinedRoleSimple
      }
    }
  }
}
    ${UserBaseFragmentDoc}
${UserDefinedRoleSimpleFragmentDoc}`;

/**
 * __useGetEnvelopeWithRecipientsQuery__
 *
 * To run a query within a React component, call `useGetEnvelopeWithRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvelopeWithRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvelopeWithRecipientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEnvelopeWithRecipientsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetEnvelopeWithRecipientsQuery, GetEnvelopeWithRecipientsQueryVariables> & ({ variables: GetEnvelopeWithRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEnvelopeWithRecipientsQuery, GetEnvelopeWithRecipientsQueryVariables>(GetEnvelopeWithRecipientsDocument, options);
      }
export function useGetEnvelopeWithRecipientsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetEnvelopeWithRecipientsQuery, GetEnvelopeWithRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEnvelopeWithRecipientsQuery, GetEnvelopeWithRecipientsQueryVariables>(GetEnvelopeWithRecipientsDocument, options);
        }
export function useGetEnvelopeWithRecipientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetEnvelopeWithRecipientsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetEnvelopeWithRecipientsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetEnvelopeWithRecipientsQuery, GetEnvelopeWithRecipientsQueryVariables>(GetEnvelopeWithRecipientsDocument, options);
        }
export type GetEnvelopeWithRecipientsQueryHookResult = ReturnType<typeof useGetEnvelopeWithRecipientsQuery>;
export type GetEnvelopeWithRecipientsLazyQueryHookResult = ReturnType<typeof useGetEnvelopeWithRecipientsLazyQuery>;
export type GetEnvelopeWithRecipientsSuspenseQueryHookResult = ReturnType<typeof useGetEnvelopeWithRecipientsSuspenseQuery>;
export type GetEnvelopeWithRecipientsQueryResult = ApolloReactHooks.useQuery.Result<GetEnvelopeWithRecipientsQuery, GetEnvelopeWithRecipientsQueryVariables>;
export const GetSignatureDocsDetailsDocument = gql`
    query GetSignatureDocsDetails($documentIds: [UUID!]!) {
  documents(documentIds: $documentIds) {
    ...DocumentForSignature
    latestVersion {
      ...FileVersionSimple
    }
    name
    comments {
      __typename
      id
    }
  }
}
    ${DocumentForSignatureFragmentDoc}
${FileVersionSimpleFragmentDoc}`;

/**
 * __useGetSignatureDocsDetailsQuery__
 *
 * To run a query within a React component, call `useGetSignatureDocsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignatureDocsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignatureDocsDetailsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetSignatureDocsDetailsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetSignatureDocsDetailsQuery, GetSignatureDocsDetailsQueryVariables> & ({ variables: GetSignatureDocsDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSignatureDocsDetailsQuery, GetSignatureDocsDetailsQueryVariables>(GetSignatureDocsDetailsDocument, options);
      }
export function useGetSignatureDocsDetailsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetSignatureDocsDetailsQuery, GetSignatureDocsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSignatureDocsDetailsQuery, GetSignatureDocsDetailsQueryVariables>(GetSignatureDocsDetailsDocument, options);
        }
export function useGetSignatureDocsDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetSignatureDocsDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetSignatureDocsDetailsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetSignatureDocsDetailsQuery, GetSignatureDocsDetailsQueryVariables>(GetSignatureDocsDetailsDocument, options);
        }
export type GetSignatureDocsDetailsQueryHookResult = ReturnType<typeof useGetSignatureDocsDetailsQuery>;
export type GetSignatureDocsDetailsLazyQueryHookResult = ReturnType<typeof useGetSignatureDocsDetailsLazyQuery>;
export type GetSignatureDocsDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSignatureDocsDetailsSuspenseQuery>;
export type GetSignatureDocsDetailsQueryResult = ApolloReactHooks.useQuery.Result<GetSignatureDocsDetailsQuery, GetSignatureDocsDetailsQueryVariables>;
export const RefreshDocAfterEnvelopeActionDocument = gql`
    query RefreshDocAfterEnvelopeAction($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    isSigned
    status
    requesterRole
    envelope {
      __typename
      id
      docuSignEnvelopeId
      title
      statusDateTime
      variant
      recipients {
        ...WorkflowRecipientSimple
      }
    }
    latestVersion {
      ... on FileVersionInterface {
        __typename
        id
      }
    }
    owner {
      __typename
      id
    }
    workflow {
      ...WorkflowFragment
    }
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}
${WorkflowFragmentFragmentDoc}`;

/**
 * __useRefreshDocAfterEnvelopeActionQuery__
 *
 * To run a query within a React component, call `useRefreshDocAfterEnvelopeActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshDocAfterEnvelopeActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshDocAfterEnvelopeActionQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRefreshDocAfterEnvelopeActionQuery(baseOptions: ApolloReactHooks.useQuery.Options<RefreshDocAfterEnvelopeActionQuery, RefreshDocAfterEnvelopeActionQueryVariables> & ({ variables: RefreshDocAfterEnvelopeActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RefreshDocAfterEnvelopeActionQuery, RefreshDocAfterEnvelopeActionQueryVariables>(RefreshDocAfterEnvelopeActionDocument, options);
      }
export function useRefreshDocAfterEnvelopeActionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<RefreshDocAfterEnvelopeActionQuery, RefreshDocAfterEnvelopeActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RefreshDocAfterEnvelopeActionQuery, RefreshDocAfterEnvelopeActionQueryVariables>(RefreshDocAfterEnvelopeActionDocument, options);
        }
export function useRefreshDocAfterEnvelopeActionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<RefreshDocAfterEnvelopeActionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<RefreshDocAfterEnvelopeActionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<RefreshDocAfterEnvelopeActionQuery, RefreshDocAfterEnvelopeActionQueryVariables>(RefreshDocAfterEnvelopeActionDocument, options);
        }
export type RefreshDocAfterEnvelopeActionQueryHookResult = ReturnType<typeof useRefreshDocAfterEnvelopeActionQuery>;
export type RefreshDocAfterEnvelopeActionLazyQueryHookResult = ReturnType<typeof useRefreshDocAfterEnvelopeActionLazyQuery>;
export type RefreshDocAfterEnvelopeActionSuspenseQueryHookResult = ReturnType<typeof useRefreshDocAfterEnvelopeActionSuspenseQuery>;
export type RefreshDocAfterEnvelopeActionQueryResult = ApolloReactHooks.useQuery.Result<RefreshDocAfterEnvelopeActionQuery, RefreshDocAfterEnvelopeActionQueryVariables>;
export const RevertWorkflowToDraftDocument = gql`
    mutation RevertWorkflowToDraft($workflowId: UUID!) {
  revertWorkflowToDraft(workflowId: $workflowId) {
    workflow {
      id
      column {
        id
        name
      }
      status
      state
      envelopeStatus
      envelope {
        ...EnvelopeSimple
      }
      ...WorkflowSigningPhaseSteps
    }
  }
}
    ${EnvelopeSimpleFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}`;
export type RevertWorkflowToDraftMutationFn = ApolloReactHooks.useMutation.MutationFunction<RevertWorkflowToDraftMutation, RevertWorkflowToDraftMutationVariables>;

/**
 * __useRevertWorkflowToDraftMutation__
 *
 * To run a mutation, you first call `useRevertWorkflowToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertWorkflowToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertWorkflowToDraftMutation, { data, loading, error }] = useRevertWorkflowToDraftMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useRevertWorkflowToDraftMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RevertWorkflowToDraftMutation, RevertWorkflowToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevertWorkflowToDraftMutation, RevertWorkflowToDraftMutationVariables>(RevertWorkflowToDraftDocument, options);
      }
export type RevertWorkflowToDraftMutationHookResult = ReturnType<typeof useRevertWorkflowToDraftMutation>;
export type RevertWorkflowToDraftMutationResult = ApolloReactHooks.useMutation.Result<RevertWorkflowToDraftMutation>;
export type RevertWorkflowToDraftMutationOptions = ApolloReactHooks.useMutation.Options<RevertWorkflowToDraftMutation, RevertWorkflowToDraftMutationVariables>;
export const SetEnvelopeViewedDocument = gql`
    mutation SetEnvelopeViewed($workflowId: UUID!) {
  setEnvelopeViewed(workflowId: $workflowId) {
    __typename
    id
    workflow {
      id
      state
      envelopeStatus
    }
    recipients {
      __typename
      id
      firstViewedAt
      lastViewedAt
    }
  }
}
    `;
export type SetEnvelopeViewedMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetEnvelopeViewedMutation, SetEnvelopeViewedMutationVariables>;

/**
 * __useSetEnvelopeViewedMutation__
 *
 * To run a mutation, you first call `useSetEnvelopeViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEnvelopeViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEnvelopeViewedMutation, { data, loading, error }] = useSetEnvelopeViewedMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useSetEnvelopeViewedMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetEnvelopeViewedMutation, SetEnvelopeViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetEnvelopeViewedMutation, SetEnvelopeViewedMutationVariables>(SetEnvelopeViewedDocument, options);
      }
export type SetEnvelopeViewedMutationHookResult = ReturnType<typeof useSetEnvelopeViewedMutation>;
export type SetEnvelopeViewedMutationResult = ApolloReactHooks.useMutation.Result<SetEnvelopeViewedMutation>;
export type SetEnvelopeViewedMutationOptions = ApolloReactHooks.useMutation.Options<SetEnvelopeViewedMutation, SetEnvelopeViewedMutationVariables>;
export const SwitchEnvelopeVariantDocument = gql`
    mutation SwitchEnvelopeVariant($input: SwitchEnvelopeVariantInput!) {
  switchEnvelopeVariant(input: $input) {
    __typename
    id
    variant
    workflow {
      id
      state
      envelopeStatus
    }
  }
}
    `;
export type SwitchEnvelopeVariantMutationFn = ApolloReactHooks.useMutation.MutationFunction<SwitchEnvelopeVariantMutation, SwitchEnvelopeVariantMutationVariables>;

/**
 * __useSwitchEnvelopeVariantMutation__
 *
 * To run a mutation, you first call `useSwitchEnvelopeVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchEnvelopeVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchEnvelopeVariantMutation, { data, loading, error }] = useSwitchEnvelopeVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchEnvelopeVariantMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SwitchEnvelopeVariantMutation, SwitchEnvelopeVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SwitchEnvelopeVariantMutation, SwitchEnvelopeVariantMutationVariables>(SwitchEnvelopeVariantDocument, options);
      }
export type SwitchEnvelopeVariantMutationHookResult = ReturnType<typeof useSwitchEnvelopeVariantMutation>;
export type SwitchEnvelopeVariantMutationResult = ApolloReactHooks.useMutation.Result<SwitchEnvelopeVariantMutation>;
export type SwitchEnvelopeVariantMutationOptions = ApolloReactHooks.useMutation.Options<SwitchEnvelopeVariantMutation, SwitchEnvelopeVariantMutationVariables>;
export const UpdateEnvelopeDocument = gql`
    mutation UpdateEnvelope($input: UpdateEnvelopeInput!) {
  updateEnvelope(input: $input) {
    ...EnvelopeSimple
    workflow {
      id
      state
      envelopeStatus
    }
  }
}
    ${EnvelopeSimpleFragmentDoc}`;
export type UpdateEnvelopeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateEnvelopeMutation, UpdateEnvelopeMutationVariables>;

/**
 * __useUpdateEnvelopeMutation__
 *
 * To run a mutation, you first call `useUpdateEnvelopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnvelopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnvelopeMutation, { data, loading, error }] = useUpdateEnvelopeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnvelopeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateEnvelopeMutation, UpdateEnvelopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEnvelopeMutation, UpdateEnvelopeMutationVariables>(UpdateEnvelopeDocument, options);
      }
export type UpdateEnvelopeMutationHookResult = ReturnType<typeof useUpdateEnvelopeMutation>;
export type UpdateEnvelopeMutationResult = ApolloReactHooks.useMutation.Result<UpdateEnvelopeMutation>;
export type UpdateEnvelopeMutationOptions = ApolloReactHooks.useMutation.Options<UpdateEnvelopeMutation, UpdateEnvelopeMutationVariables>;
export const GetExtractionJobDocument = gql`
    query GetExtractionJob($id: UUID!) {
  extractionJob(id: $id) {
    ...ExtractionJobSimple
  }
}
    ${ExtractionJobSimpleFragmentDoc}`;

/**
 * __useGetExtractionJobQuery__
 *
 * To run a query within a React component, call `useGetExtractionJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractionJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractionJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExtractionJobQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetExtractionJobQuery, GetExtractionJobQueryVariables> & ({ variables: GetExtractionJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExtractionJobQuery, GetExtractionJobQueryVariables>(GetExtractionJobDocument, options);
      }
export function useGetExtractionJobLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExtractionJobQuery, GetExtractionJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExtractionJobQuery, GetExtractionJobQueryVariables>(GetExtractionJobDocument, options);
        }
export function useGetExtractionJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExtractionJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExtractionJobQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExtractionJobQuery, GetExtractionJobQueryVariables>(GetExtractionJobDocument, options);
        }
export type GetExtractionJobQueryHookResult = ReturnType<typeof useGetExtractionJobQuery>;
export type GetExtractionJobLazyQueryHookResult = ReturnType<typeof useGetExtractionJobLazyQuery>;
export type GetExtractionJobSuspenseQueryHookResult = ReturnType<typeof useGetExtractionJobSuspenseQuery>;
export type GetExtractionJobQueryResult = ApolloReactHooks.useQuery.Result<GetExtractionJobQuery, GetExtractionJobQueryVariables>;
export const CreateExtractionJobDocument = gql`
    mutation CreateExtractionJob($documentId: UUID!, $input: CreateExtractionJobInput!) {
  createExtractionJob(documentId: $documentId, input: $input) {
    ...ExtractionQuestionSimple
    extractionJob(documentId: $documentId) {
      ...DocumentReportRowQuestionJob
    }
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}
${DocumentReportRowQuestionJobFragmentDoc}`;
export type CreateExtractionJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateExtractionJobMutation, CreateExtractionJobMutationVariables>;

/**
 * __useCreateExtractionJobMutation__
 *
 * To run a mutation, you first call `useCreateExtractionJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExtractionJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExtractionJobMutation, { data, loading, error }] = useCreateExtractionJobMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExtractionJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateExtractionJobMutation, CreateExtractionJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateExtractionJobMutation, CreateExtractionJobMutationVariables>(CreateExtractionJobDocument, options);
      }
export type CreateExtractionJobMutationHookResult = ReturnType<typeof useCreateExtractionJobMutation>;
export type CreateExtractionJobMutationResult = ApolloReactHooks.useMutation.Result<CreateExtractionJobMutation>;
export type CreateExtractionJobMutationOptions = ApolloReactHooks.useMutation.Options<CreateExtractionJobMutation, CreateExtractionJobMutationVariables>;
export const StartExtractionJobsForDocumentsDocument = gql`
    mutation StartExtractionJobsForDocuments($input: StartExtractionJobsForDocumentsInput!) {
  startExtractionJobsForDocuments(input: $input) {
    documents {
      ...DocumentReportRow
    }
    skippedCount
  }
}
    ${DocumentReportRowFragmentDoc}`;
export type StartExtractionJobsForDocumentsMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartExtractionJobsForDocumentsMutation, StartExtractionJobsForDocumentsMutationVariables>;

/**
 * __useStartExtractionJobsForDocumentsMutation__
 *
 * To run a mutation, you first call `useStartExtractionJobsForDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExtractionJobsForDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExtractionJobsForDocumentsMutation, { data, loading, error }] = useStartExtractionJobsForDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartExtractionJobsForDocumentsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartExtractionJobsForDocumentsMutation, StartExtractionJobsForDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartExtractionJobsForDocumentsMutation, StartExtractionJobsForDocumentsMutationVariables>(StartExtractionJobsForDocumentsDocument, options);
      }
export type StartExtractionJobsForDocumentsMutationHookResult = ReturnType<typeof useStartExtractionJobsForDocumentsMutation>;
export type StartExtractionJobsForDocumentsMutationResult = ApolloReactHooks.useMutation.Result<StartExtractionJobsForDocumentsMutation>;
export type StartExtractionJobsForDocumentsMutationOptions = ApolloReactHooks.useMutation.Options<StartExtractionJobsForDocumentsMutation, StartExtractionJobsForDocumentsMutationVariables>;
export const RunCoreAiForDocumentsDocument = gql`
    mutation RunCoreAiForDocuments($input: RunCoreAiForDocumentsInput!) {
  runCoreAiForDocuments(input: $input) {
    __typename
    id
    coreAiPropertiesExtractionStartedAt
    coreAiPropertiesExtractionFinishedAt
    coreAiPropertiesExtractionFailedAt
  }
}
    `;
export type RunCoreAiForDocumentsMutationFn = ApolloReactHooks.useMutation.MutationFunction<RunCoreAiForDocumentsMutation, RunCoreAiForDocumentsMutationVariables>;

/**
 * __useRunCoreAiForDocumentsMutation__
 *
 * To run a mutation, you first call `useRunCoreAiForDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunCoreAiForDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runCoreAiForDocumentsMutation, { data, loading, error }] = useRunCoreAiForDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunCoreAiForDocumentsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RunCoreAiForDocumentsMutation, RunCoreAiForDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RunCoreAiForDocumentsMutation, RunCoreAiForDocumentsMutationVariables>(RunCoreAiForDocumentsDocument, options);
      }
export type RunCoreAiForDocumentsMutationHookResult = ReturnType<typeof useRunCoreAiForDocumentsMutation>;
export type RunCoreAiForDocumentsMutationResult = ApolloReactHooks.useMutation.Result<RunCoreAiForDocumentsMutation>;
export type RunCoreAiForDocumentsMutationOptions = ApolloReactHooks.useMutation.Options<RunCoreAiForDocumentsMutation, RunCoreAiForDocumentsMutationVariables>;
export const CancelExtractionJobsDocument = gql`
    mutation CancelExtractionJobs($extractionJobIds: [UUID!]!) {
  cancelExtractionJobs(extractionJobIds: $extractionJobIds) {
    ...ExtractionQuestionSimple
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}`;
export type CancelExtractionJobsMutationFn = ApolloReactHooks.useMutation.MutationFunction<CancelExtractionJobsMutation, CancelExtractionJobsMutationVariables>;

/**
 * __useCancelExtractionJobsMutation__
 *
 * To run a mutation, you first call `useCancelExtractionJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelExtractionJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelExtractionJobsMutation, { data, loading, error }] = useCancelExtractionJobsMutation({
 *   variables: {
 *      extractionJobIds: // value for 'extractionJobIds'
 *   },
 * });
 */
export function useCancelExtractionJobsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CancelExtractionJobsMutation, CancelExtractionJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelExtractionJobsMutation, CancelExtractionJobsMutationVariables>(CancelExtractionJobsDocument, options);
      }
export type CancelExtractionJobsMutationHookResult = ReturnType<typeof useCancelExtractionJobsMutation>;
export type CancelExtractionJobsMutationResult = ApolloReactHooks.useMutation.Result<CancelExtractionJobsMutation>;
export type CancelExtractionJobsMutationOptions = ApolloReactHooks.useMutation.Options<CancelExtractionJobsMutation, CancelExtractionJobsMutationVariables>;
export const UpdateExtractionJobDocument = gql`
    mutation UpdateExtractionJob($input: UpdateExtractionJobInput!) {
  updateExtractionJob(input: $input) {
    __typename
    id
    answer
    lockedAt
    previousAnswer
    questionContentHashAtRun
    reasoning
    lockedBy {
      ...UserBase
    }
    locations {
      ...DocLocationSimple
    }
    previousSelectedOptions {
      ...QuestionOptionSimple
    }
    review {
      __typename
      reviewAction
      reviewedAt
      reviewedBy {
        ...UserBase
      }
    }
    selectedOptions {
      ...QuestionOptionSimple
    }
  }
}
    ${UserBaseFragmentDoc}
${DocLocationSimpleFragmentDoc}
${QuestionOptionSimpleFragmentDoc}`;
export type UpdateExtractionJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateExtractionJobMutation, UpdateExtractionJobMutationVariables>;

/**
 * __useUpdateExtractionJobMutation__
 *
 * To run a mutation, you first call `useUpdateExtractionJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtractionJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtractionJobMutation, { data, loading, error }] = useUpdateExtractionJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExtractionJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateExtractionJobMutation, UpdateExtractionJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExtractionJobMutation, UpdateExtractionJobMutationVariables>(UpdateExtractionJobDocument, options);
      }
export type UpdateExtractionJobMutationHookResult = ReturnType<typeof useUpdateExtractionJobMutation>;
export type UpdateExtractionJobMutationResult = ApolloReactHooks.useMutation.Result<UpdateExtractionJobMutation>;
export type UpdateExtractionJobMutationOptions = ApolloReactHooks.useMutation.Options<UpdateExtractionJobMutation, UpdateExtractionJobMutationVariables>;
export const RevertExtractionJobDocument = gql`
    mutation RevertExtractionJob($extractionJobId: UUID!) {
  revertExtractionJob(extractionJobId: $extractionJobId) {
    __typename
    id
    answer
    previousAnswer
    previousSelectedOptions {
      ...QuestionOptionSimple
    }
    review {
      __typename
      reviewAction
      reviewedAt
      reviewedBy {
        ...UserBase
      }
    }
    selectedOptions {
      ...QuestionOptionSimple
    }
  }
}
    ${QuestionOptionSimpleFragmentDoc}
${UserBaseFragmentDoc}`;
export type RevertExtractionJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<RevertExtractionJobMutation, RevertExtractionJobMutationVariables>;

/**
 * __useRevertExtractionJobMutation__
 *
 * To run a mutation, you first call `useRevertExtractionJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertExtractionJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertExtractionJobMutation, { data, loading, error }] = useRevertExtractionJobMutation({
 *   variables: {
 *      extractionJobId: // value for 'extractionJobId'
 *   },
 * });
 */
export function useRevertExtractionJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RevertExtractionJobMutation, RevertExtractionJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevertExtractionJobMutation, RevertExtractionJobMutationVariables>(RevertExtractionJobDocument, options);
      }
export type RevertExtractionJobMutationHookResult = ReturnType<typeof useRevertExtractionJobMutation>;
export type RevertExtractionJobMutationResult = ApolloReactHooks.useMutation.Result<RevertExtractionJobMutation>;
export type RevertExtractionJobMutationOptions = ApolloReactHooks.useMutation.Options<RevertExtractionJobMutation, RevertExtractionJobMutationVariables>;
export const ToggleExtractionJobsLockDocument = gql`
    mutation ToggleExtractionJobsLock($input: BulkLockExtractionJobsInput!) {
  toggleExtractionJobsLock(input: $input) {
    __typename
    id
    lockedAt
    lockedBy {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;
export type ToggleExtractionJobsLockMutationFn = ApolloReactHooks.useMutation.MutationFunction<ToggleExtractionJobsLockMutation, ToggleExtractionJobsLockMutationVariables>;

/**
 * __useToggleExtractionJobsLockMutation__
 *
 * To run a mutation, you first call `useToggleExtractionJobsLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleExtractionJobsLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleExtractionJobsLockMutation, { data, loading, error }] = useToggleExtractionJobsLockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleExtractionJobsLockMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ToggleExtractionJobsLockMutation, ToggleExtractionJobsLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleExtractionJobsLockMutation, ToggleExtractionJobsLockMutationVariables>(ToggleExtractionJobsLockDocument, options);
      }
export type ToggleExtractionJobsLockMutationHookResult = ReturnType<typeof useToggleExtractionJobsLockMutation>;
export type ToggleExtractionJobsLockMutationResult = ApolloReactHooks.useMutation.Result<ToggleExtractionJobsLockMutation>;
export type ToggleExtractionJobsLockMutationOptions = ApolloReactHooks.useMutation.Options<ToggleExtractionJobsLockMutation, ToggleExtractionJobsLockMutationVariables>;
export const GetQuestionGenerationJobsDocument = gql`
    query GetQuestionGenerationJobs($documentId: UUID!) {
  questionGenerationJobs(documentId: $documentId) {
    ...QuestionGenerationJobSimple
  }
}
    ${QuestionGenerationJobSimpleFragmentDoc}`;

/**
 * __useGetQuestionGenerationJobsQuery__
 *
 * To run a query within a React component, call `useGetQuestionGenerationJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionGenerationJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionGenerationJobsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetQuestionGenerationJobsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetQuestionGenerationJobsQuery, GetQuestionGenerationJobsQueryVariables> & ({ variables: GetQuestionGenerationJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuestionGenerationJobsQuery, GetQuestionGenerationJobsQueryVariables>(GetQuestionGenerationJobsDocument, options);
      }
export function useGetQuestionGenerationJobsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetQuestionGenerationJobsQuery, GetQuestionGenerationJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuestionGenerationJobsQuery, GetQuestionGenerationJobsQueryVariables>(GetQuestionGenerationJobsDocument, options);
        }
export function useGetQuestionGenerationJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetQuestionGenerationJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetQuestionGenerationJobsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetQuestionGenerationJobsQuery, GetQuestionGenerationJobsQueryVariables>(GetQuestionGenerationJobsDocument, options);
        }
export type GetQuestionGenerationJobsQueryHookResult = ReturnType<typeof useGetQuestionGenerationJobsQuery>;
export type GetQuestionGenerationJobsLazyQueryHookResult = ReturnType<typeof useGetQuestionGenerationJobsLazyQuery>;
export type GetQuestionGenerationJobsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionGenerationJobsSuspenseQuery>;
export type GetQuestionGenerationJobsQueryResult = ApolloReactHooks.useQuery.Result<GetQuestionGenerationJobsQuery, GetQuestionGenerationJobsQueryVariables>;
export const StartQuestionGenerationJobDocument = gql`
    mutation StartQuestionGenerationJob($documentId: UUID!) {
  startQuestionGenerationJob(documentId: $documentId) {
    __typename
    id
  }
}
    `;
export type StartQuestionGenerationJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartQuestionGenerationJobMutation, StartQuestionGenerationJobMutationVariables>;

/**
 * __useStartQuestionGenerationJobMutation__
 *
 * To run a mutation, you first call `useStartQuestionGenerationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartQuestionGenerationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startQuestionGenerationJobMutation, { data, loading, error }] = useStartQuestionGenerationJobMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useStartQuestionGenerationJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartQuestionGenerationJobMutation, StartQuestionGenerationJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartQuestionGenerationJobMutation, StartQuestionGenerationJobMutationVariables>(StartQuestionGenerationJobDocument, options);
      }
export type StartQuestionGenerationJobMutationHookResult = ReturnType<typeof useStartQuestionGenerationJobMutation>;
export type StartQuestionGenerationJobMutationResult = ApolloReactHooks.useMutation.Result<StartQuestionGenerationJobMutation>;
export type StartQuestionGenerationJobMutationOptions = ApolloReactHooks.useMutation.Options<StartQuestionGenerationJobMutation, StartQuestionGenerationJobMutationVariables>;
export const CancelQuestionGenerationJobDocument = gql`
    mutation CancelQuestionGenerationJob($jobId: UUID!) {
  cancelQuestionGenerationJob(jobId: $jobId)
}
    `;
export type CancelQuestionGenerationJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<CancelQuestionGenerationJobMutation, CancelQuestionGenerationJobMutationVariables>;

/**
 * __useCancelQuestionGenerationJobMutation__
 *
 * To run a mutation, you first call `useCancelQuestionGenerationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelQuestionGenerationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelQuestionGenerationJobMutation, { data, loading, error }] = useCancelQuestionGenerationJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelQuestionGenerationJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CancelQuestionGenerationJobMutation, CancelQuestionGenerationJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelQuestionGenerationJobMutation, CancelQuestionGenerationJobMutationVariables>(CancelQuestionGenerationJobDocument, options);
      }
export type CancelQuestionGenerationJobMutationHookResult = ReturnType<typeof useCancelQuestionGenerationJobMutation>;
export type CancelQuestionGenerationJobMutationResult = ApolloReactHooks.useMutation.Result<CancelQuestionGenerationJobMutation>;
export type CancelQuestionGenerationJobMutationOptions = ApolloReactHooks.useMutation.Options<CancelQuestionGenerationJobMutation, CancelQuestionGenerationJobMutationVariables>;
export const AcceptGeneratedQuestionsDocument = gql`
    mutation AcceptGeneratedQuestions($generationJobId: UUID!, $input: AcceptGeneratedQuestionInput!) {
  acceptGeneratedQuestions(generationJobId: $generationJobId, input: $input) {
    __typename
    id
  }
}
    `;
export type AcceptGeneratedQuestionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<AcceptGeneratedQuestionsMutation, AcceptGeneratedQuestionsMutationVariables>;

/**
 * __useAcceptGeneratedQuestionsMutation__
 *
 * To run a mutation, you first call `useAcceptGeneratedQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptGeneratedQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptGeneratedQuestionsMutation, { data, loading, error }] = useAcceptGeneratedQuestionsMutation({
 *   variables: {
 *      generationJobId: // value for 'generationJobId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptGeneratedQuestionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AcceptGeneratedQuestionsMutation, AcceptGeneratedQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptGeneratedQuestionsMutation, AcceptGeneratedQuestionsMutationVariables>(AcceptGeneratedQuestionsDocument, options);
      }
export type AcceptGeneratedQuestionsMutationHookResult = ReturnType<typeof useAcceptGeneratedQuestionsMutation>;
export type AcceptGeneratedQuestionsMutationResult = ApolloReactHooks.useMutation.Result<AcceptGeneratedQuestionsMutation>;
export type AcceptGeneratedQuestionsMutationOptions = ApolloReactHooks.useMutation.Options<AcceptGeneratedQuestionsMutation, AcceptGeneratedQuestionsMutationVariables>;
export const GetExtractionQuestionDocument = gql`
    query GetExtractionQuestion($id: UUID!) {
  extractionQuestion(id: $id) {
    ...ExtractionQuestionSimple
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}`;

/**
 * __useGetExtractionQuestionQuery__
 *
 * To run a query within a React component, call `useGetExtractionQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractionQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractionQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExtractionQuestionQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetExtractionQuestionQuery, GetExtractionQuestionQueryVariables> & ({ variables: GetExtractionQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExtractionQuestionQuery, GetExtractionQuestionQueryVariables>(GetExtractionQuestionDocument, options);
      }
export function useGetExtractionQuestionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExtractionQuestionQuery, GetExtractionQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExtractionQuestionQuery, GetExtractionQuestionQueryVariables>(GetExtractionQuestionDocument, options);
        }
export function useGetExtractionQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExtractionQuestionQuery, GetExtractionQuestionQueryVariables>(GetExtractionQuestionDocument, options);
        }
export type GetExtractionQuestionQueryHookResult = ReturnType<typeof useGetExtractionQuestionQuery>;
export type GetExtractionQuestionLazyQueryHookResult = ReturnType<typeof useGetExtractionQuestionLazyQuery>;
export type GetExtractionQuestionSuspenseQueryHookResult = ReturnType<typeof useGetExtractionQuestionSuspenseQuery>;
export type GetExtractionQuestionQueryResult = ApolloReactHooks.useQuery.Result<GetExtractionQuestionQuery, GetExtractionQuestionQueryVariables>;
export const GetExtractionQuestionWithInputsDocument = gql`
    query GetExtractionQuestionWithInputs($id: UUID!) {
  extractionQuestion(id: $id) {
    id
    aiGuidance
    category
    inputFileFields
    title
    questionText
    type
    mode
    variant
    options {
      ...QuestionOptionSimple
    }
    createdAt
    updatedAt
    inputs {
      __typename
      id
      title
    }
  }
}
    ${QuestionOptionSimpleFragmentDoc}`;

/**
 * __useGetExtractionQuestionWithInputsQuery__
 *
 * To run a query within a React component, call `useGetExtractionQuestionWithInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractionQuestionWithInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractionQuestionWithInputsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExtractionQuestionWithInputsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetExtractionQuestionWithInputsQuery, GetExtractionQuestionWithInputsQueryVariables> & ({ variables: GetExtractionQuestionWithInputsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExtractionQuestionWithInputsQuery, GetExtractionQuestionWithInputsQueryVariables>(GetExtractionQuestionWithInputsDocument, options);
      }
export function useGetExtractionQuestionWithInputsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExtractionQuestionWithInputsQuery, GetExtractionQuestionWithInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExtractionQuestionWithInputsQuery, GetExtractionQuestionWithInputsQueryVariables>(GetExtractionQuestionWithInputsDocument, options);
        }
export function useGetExtractionQuestionWithInputsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionWithInputsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionWithInputsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExtractionQuestionWithInputsQuery, GetExtractionQuestionWithInputsQueryVariables>(GetExtractionQuestionWithInputsDocument, options);
        }
export type GetExtractionQuestionWithInputsQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithInputsQuery>;
export type GetExtractionQuestionWithInputsLazyQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithInputsLazyQuery>;
export type GetExtractionQuestionWithInputsSuspenseQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithInputsSuspenseQuery>;
export type GetExtractionQuestionWithInputsQueryResult = ApolloReactHooks.useQuery.Result<GetExtractionQuestionWithInputsQuery, GetExtractionQuestionWithInputsQueryVariables>;
export const GetExtractionQuestionsDocument = gql`
    query GetExtractionQuestions {
  extractionQuestions {
    ...ExtractionQuestionSimple
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}`;

/**
 * __useGetExtractionQuestionsQuery__
 *
 * To run a query within a React component, call `useGetExtractionQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractionQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractionQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExtractionQuestionsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetExtractionQuestionsQuery, GetExtractionQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExtractionQuestionsQuery, GetExtractionQuestionsQueryVariables>(GetExtractionQuestionsDocument, options);
      }
export function useGetExtractionQuestionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExtractionQuestionsQuery, GetExtractionQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExtractionQuestionsQuery, GetExtractionQuestionsQueryVariables>(GetExtractionQuestionsDocument, options);
        }
export function useGetExtractionQuestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExtractionQuestionsQuery, GetExtractionQuestionsQueryVariables>(GetExtractionQuestionsDocument, options);
        }
export type GetExtractionQuestionsQueryHookResult = ReturnType<typeof useGetExtractionQuestionsQuery>;
export type GetExtractionQuestionsLazyQueryHookResult = ReturnType<typeof useGetExtractionQuestionsLazyQuery>;
export type GetExtractionQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetExtractionQuestionsSuspenseQuery>;
export type GetExtractionQuestionsQueryResult = ApolloReactHooks.useQuery.Result<GetExtractionQuestionsQuery, GetExtractionQuestionsQueryVariables>;
export const GetDocExtractionQuestionDocument = gql`
    query GetDocExtractionQuestion($extractionQuestionId: UUID!, $documentId: UUID!) {
  extractionQuestion(id: $extractionQuestionId) {
    ...ExtractionQuestionSimple
    contractTypes {
      ...ContractTypeSimple
    }
    extractionJob(documentId: $documentId) {
      ...ExtractionJobSimple
    }
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}
${ContractTypeSimpleFragmentDoc}
${ExtractionJobSimpleFragmentDoc}`;

/**
 * __useGetDocExtractionQuestionQuery__
 *
 * To run a query within a React component, call `useGetDocExtractionQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocExtractionQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocExtractionQuestionQuery({
 *   variables: {
 *      extractionQuestionId: // value for 'extractionQuestionId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocExtractionQuestionQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocExtractionQuestionQuery, GetDocExtractionQuestionQueryVariables> & ({ variables: GetDocExtractionQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocExtractionQuestionQuery, GetDocExtractionQuestionQueryVariables>(GetDocExtractionQuestionDocument, options);
      }
export function useGetDocExtractionQuestionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocExtractionQuestionQuery, GetDocExtractionQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocExtractionQuestionQuery, GetDocExtractionQuestionQueryVariables>(GetDocExtractionQuestionDocument, options);
        }
export function useGetDocExtractionQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocExtractionQuestionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocExtractionQuestionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocExtractionQuestionQuery, GetDocExtractionQuestionQueryVariables>(GetDocExtractionQuestionDocument, options);
        }
export type GetDocExtractionQuestionQueryHookResult = ReturnType<typeof useGetDocExtractionQuestionQuery>;
export type GetDocExtractionQuestionLazyQueryHookResult = ReturnType<typeof useGetDocExtractionQuestionLazyQuery>;
export type GetDocExtractionQuestionSuspenseQueryHookResult = ReturnType<typeof useGetDocExtractionQuestionSuspenseQuery>;
export type GetDocExtractionQuestionQueryResult = ApolloReactHooks.useQuery.Result<GetDocExtractionQuestionQuery, GetDocExtractionQuestionQueryVariables>;
export const GetExtractionQuestionWithOptionsDocument = gql`
    query GetExtractionQuestionWithOptions($id: UUID!) {
  extractionQuestion(id: $id) {
    __typename
    id
    questionText
    type
    options {
      ...QuestionOptionSimple
    }
  }
}
    ${QuestionOptionSimpleFragmentDoc}`;

/**
 * __useGetExtractionQuestionWithOptionsQuery__
 *
 * To run a query within a React component, call `useGetExtractionQuestionWithOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractionQuestionWithOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractionQuestionWithOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExtractionQuestionWithOptionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetExtractionQuestionWithOptionsQuery, GetExtractionQuestionWithOptionsQueryVariables> & ({ variables: GetExtractionQuestionWithOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExtractionQuestionWithOptionsQuery, GetExtractionQuestionWithOptionsQueryVariables>(GetExtractionQuestionWithOptionsDocument, options);
      }
export function useGetExtractionQuestionWithOptionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExtractionQuestionWithOptionsQuery, GetExtractionQuestionWithOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExtractionQuestionWithOptionsQuery, GetExtractionQuestionWithOptionsQueryVariables>(GetExtractionQuestionWithOptionsDocument, options);
        }
export function useGetExtractionQuestionWithOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionWithOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionWithOptionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExtractionQuestionWithOptionsQuery, GetExtractionQuestionWithOptionsQueryVariables>(GetExtractionQuestionWithOptionsDocument, options);
        }
export type GetExtractionQuestionWithOptionsQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithOptionsQuery>;
export type GetExtractionQuestionWithOptionsLazyQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithOptionsLazyQuery>;
export type GetExtractionQuestionWithOptionsSuspenseQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithOptionsSuspenseQuery>;
export type GetExtractionQuestionWithOptionsQueryResult = ApolloReactHooks.useQuery.Result<GetExtractionQuestionWithOptionsQuery, GetExtractionQuestionWithOptionsQueryVariables>;
export const GetExtractionQuestionWithDependenciesDocument = gql`
    query GetExtractionQuestionWithDependencies($id: UUID!) {
  extractionQuestionWithDependencies(id: $id) {
    __typename
    id
    contentHash
  }
}
    `;

/**
 * __useGetExtractionQuestionWithDependenciesQuery__
 *
 * To run a query within a React component, call `useGetExtractionQuestionWithDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractionQuestionWithDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractionQuestionWithDependenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExtractionQuestionWithDependenciesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetExtractionQuestionWithDependenciesQuery, GetExtractionQuestionWithDependenciesQueryVariables> & ({ variables: GetExtractionQuestionWithDependenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExtractionQuestionWithDependenciesQuery, GetExtractionQuestionWithDependenciesQueryVariables>(GetExtractionQuestionWithDependenciesDocument, options);
      }
export function useGetExtractionQuestionWithDependenciesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExtractionQuestionWithDependenciesQuery, GetExtractionQuestionWithDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExtractionQuestionWithDependenciesQuery, GetExtractionQuestionWithDependenciesQueryVariables>(GetExtractionQuestionWithDependenciesDocument, options);
        }
export function useGetExtractionQuestionWithDependenciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionWithDependenciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionWithDependenciesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExtractionQuestionWithDependenciesQuery, GetExtractionQuestionWithDependenciesQueryVariables>(GetExtractionQuestionWithDependenciesDocument, options);
        }
export type GetExtractionQuestionWithDependenciesQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithDependenciesQuery>;
export type GetExtractionQuestionWithDependenciesLazyQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithDependenciesLazyQuery>;
export type GetExtractionQuestionWithDependenciesSuspenseQueryHookResult = ReturnType<typeof useGetExtractionQuestionWithDependenciesSuspenseQuery>;
export type GetExtractionQuestionWithDependenciesQueryResult = ApolloReactHooks.useQuery.Result<GetExtractionQuestionWithDependenciesQuery, GetExtractionQuestionWithDependenciesQueryVariables>;
export const GetExtractionQuestionsForDocumentDocument = gql`
    query GetExtractionQuestionsForDocument($documentId: UUID!) {
  extractionQuestionsForDocument(documentId: $documentId) {
    document {
      __typename
      id
      aiQuestionIdsQueueing
      coreAiPropertiesExtractionFailedAt
      coreAiPropertiesExtractionStartedAt
      coreAiPropertiesExtractionFinishedAt
      latestVersion {
        ...FileVersionSimple
      }
    }
    extractionQuestions {
      ...ExtractionQuestionSimple
      isActive
      aiGenerated
      extractionJob(documentId: $documentId) {
        ...DocumentReportRowQuestionJob
      }
      inputs {
        __typename
        id
        title
      }
    }
  }
}
    ${FileVersionSimpleFragmentDoc}
${ExtractionQuestionSimpleFragmentDoc}
${DocumentReportRowQuestionJobFragmentDoc}`;

/**
 * __useGetExtractionQuestionsForDocumentQuery__
 *
 * To run a query within a React component, call `useGetExtractionQuestionsForDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractionQuestionsForDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractionQuestionsForDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetExtractionQuestionsForDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetExtractionQuestionsForDocumentQuery, GetExtractionQuestionsForDocumentQueryVariables> & ({ variables: GetExtractionQuestionsForDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExtractionQuestionsForDocumentQuery, GetExtractionQuestionsForDocumentQueryVariables>(GetExtractionQuestionsForDocumentDocument, options);
      }
export function useGetExtractionQuestionsForDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExtractionQuestionsForDocumentQuery, GetExtractionQuestionsForDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExtractionQuestionsForDocumentQuery, GetExtractionQuestionsForDocumentQueryVariables>(GetExtractionQuestionsForDocumentDocument, options);
        }
export function useGetExtractionQuestionsForDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionsForDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExtractionQuestionsForDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExtractionQuestionsForDocumentQuery, GetExtractionQuestionsForDocumentQueryVariables>(GetExtractionQuestionsForDocumentDocument, options);
        }
export type GetExtractionQuestionsForDocumentQueryHookResult = ReturnType<typeof useGetExtractionQuestionsForDocumentQuery>;
export type GetExtractionQuestionsForDocumentLazyQueryHookResult = ReturnType<typeof useGetExtractionQuestionsForDocumentLazyQuery>;
export type GetExtractionQuestionsForDocumentSuspenseQueryHookResult = ReturnType<typeof useGetExtractionQuestionsForDocumentSuspenseQuery>;
export type GetExtractionQuestionsForDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetExtractionQuestionsForDocumentQuery, GetExtractionQuestionsForDocumentQueryVariables>;
export const AddQuestionOptionsDocument = gql`
    mutation AddQuestionOptions($input: AddQuestionOptionsInput!) {
  addQuestionOptions(input: $input) {
    ...QuestionOptionSimple
  }
}
    ${QuestionOptionSimpleFragmentDoc}`;
export type AddQuestionOptionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddQuestionOptionsMutation, AddQuestionOptionsMutationVariables>;

/**
 * __useAddQuestionOptionsMutation__
 *
 * To run a mutation, you first call `useAddQuestionOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionOptionsMutation, { data, loading, error }] = useAddQuestionOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuestionOptionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddQuestionOptionsMutation, AddQuestionOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddQuestionOptionsMutation, AddQuestionOptionsMutationVariables>(AddQuestionOptionsDocument, options);
      }
export type AddQuestionOptionsMutationHookResult = ReturnType<typeof useAddQuestionOptionsMutation>;
export type AddQuestionOptionsMutationResult = ApolloReactHooks.useMutation.Result<AddQuestionOptionsMutation>;
export type AddQuestionOptionsMutationOptions = ApolloReactHooks.useMutation.Options<AddQuestionOptionsMutation, AddQuestionOptionsMutationVariables>;
export const CreateExtractionQuestionDocument = gql`
    mutation CreateExtractionQuestion($input: CreateExtractionQuestionInput!) {
  createExtractionQuestion(input: $input) {
    ...ExtractionQuestionSimple
    inputs {
      __typename
      id
      title
    }
    aiGenerated
    isActive
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}`;
export type CreateExtractionQuestionMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateExtractionQuestionMutation, CreateExtractionQuestionMutationVariables>;

/**
 * __useCreateExtractionQuestionMutation__
 *
 * To run a mutation, you first call `useCreateExtractionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExtractionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExtractionQuestionMutation, { data, loading, error }] = useCreateExtractionQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExtractionQuestionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateExtractionQuestionMutation, CreateExtractionQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateExtractionQuestionMutation, CreateExtractionQuestionMutationVariables>(CreateExtractionQuestionDocument, options);
      }
export type CreateExtractionQuestionMutationHookResult = ReturnType<typeof useCreateExtractionQuestionMutation>;
export type CreateExtractionQuestionMutationResult = ApolloReactHooks.useMutation.Result<CreateExtractionQuestionMutation>;
export type CreateExtractionQuestionMutationOptions = ApolloReactHooks.useMutation.Options<CreateExtractionQuestionMutation, CreateExtractionQuestionMutationVariables>;
export const DeleteQuestionOptionDocument = gql`
    mutation DeleteQuestionOption($optionId: UUID!) {
  deleteQuestionOption(optionId: $optionId)
}
    `;
export type DeleteQuestionOptionMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteQuestionOptionMutation, DeleteQuestionOptionMutationVariables>;

/**
 * __useDeleteQuestionOptionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionOptionMutation, { data, loading, error }] = useDeleteQuestionOptionMutation({
 *   variables: {
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useDeleteQuestionOptionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteQuestionOptionMutation, DeleteQuestionOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteQuestionOptionMutation, DeleteQuestionOptionMutationVariables>(DeleteQuestionOptionDocument, options);
      }
export type DeleteQuestionOptionMutationHookResult = ReturnType<typeof useDeleteQuestionOptionMutation>;
export type DeleteQuestionOptionMutationResult = ApolloReactHooks.useMutation.Result<DeleteQuestionOptionMutation>;
export type DeleteQuestionOptionMutationOptions = ApolloReactHooks.useMutation.Options<DeleteQuestionOptionMutation, DeleteQuestionOptionMutationVariables>;
export const DeleteExtractionQuestionDocument = gql`
    mutation DeleteExtractionQuestion($extractionQuestionId: UUID!) {
  deleteExtractionQuestion(extractionQuestionId: $extractionQuestionId)
}
    `;
export type DeleteExtractionQuestionMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteExtractionQuestionMutation, DeleteExtractionQuestionMutationVariables>;

/**
 * __useDeleteExtractionQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteExtractionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExtractionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExtractionQuestionMutation, { data, loading, error }] = useDeleteExtractionQuestionMutation({
 *   variables: {
 *      extractionQuestionId: // value for 'extractionQuestionId'
 *   },
 * });
 */
export function useDeleteExtractionQuestionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteExtractionQuestionMutation, DeleteExtractionQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteExtractionQuestionMutation, DeleteExtractionQuestionMutationVariables>(DeleteExtractionQuestionDocument, options);
      }
export type DeleteExtractionQuestionMutationHookResult = ReturnType<typeof useDeleteExtractionQuestionMutation>;
export type DeleteExtractionQuestionMutationResult = ApolloReactHooks.useMutation.Result<DeleteExtractionQuestionMutation>;
export type DeleteExtractionQuestionMutationOptions = ApolloReactHooks.useMutation.Options<DeleteExtractionQuestionMutation, DeleteExtractionQuestionMutationVariables>;
export const SetQuestionInputsDocument = gql`
    mutation SetQuestionInputs($input: SetQuestionInputsInput!) {
  setQuestionInputs(input: $input) {
    __typename
    id
    contentHash
    inputFileFields
    inputs {
      __typename
      id
    }
  }
}
    `;
export type SetQuestionInputsMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetQuestionInputsMutation, SetQuestionInputsMutationVariables>;

/**
 * __useSetQuestionInputsMutation__
 *
 * To run a mutation, you first call `useSetQuestionInputsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuestionInputsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuestionInputsMutation, { data, loading, error }] = useSetQuestionInputsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetQuestionInputsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetQuestionInputsMutation, SetQuestionInputsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetQuestionInputsMutation, SetQuestionInputsMutationVariables>(SetQuestionInputsDocument, options);
      }
export type SetQuestionInputsMutationHookResult = ReturnType<typeof useSetQuestionInputsMutation>;
export type SetQuestionInputsMutationResult = ApolloReactHooks.useMutation.Result<SetQuestionInputsMutation>;
export type SetQuestionInputsMutationOptions = ApolloReactHooks.useMutation.Options<SetQuestionInputsMutation, SetQuestionInputsMutationVariables>;
export const SetQuestionContractTypesDocument = gql`
    mutation SetQuestionContractTypes($input: SetQuestionTypesInput!) {
  setQuestionContractTypes(input: $input) {
    ...ExtractionQuestionSimple
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}`;
export type SetQuestionContractTypesMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetQuestionContractTypesMutation, SetQuestionContractTypesMutationVariables>;

/**
 * __useSetQuestionContractTypesMutation__
 *
 * To run a mutation, you first call `useSetQuestionContractTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuestionContractTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuestionContractTypesMutation, { data, loading, error }] = useSetQuestionContractTypesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetQuestionContractTypesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetQuestionContractTypesMutation, SetQuestionContractTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetQuestionContractTypesMutation, SetQuestionContractTypesMutationVariables>(SetQuestionContractTypesDocument, options);
      }
export type SetQuestionContractTypesMutationHookResult = ReturnType<typeof useSetQuestionContractTypesMutation>;
export type SetQuestionContractTypesMutationResult = ApolloReactHooks.useMutation.Result<SetQuestionContractTypesMutation>;
export type SetQuestionContractTypesMutationOptions = ApolloReactHooks.useMutation.Options<SetQuestionContractTypesMutation, SetQuestionContractTypesMutationVariables>;
export const UpdateQuestionOptionDocument = gql`
    mutation UpdateQuestionOption($input: UpdateQuestionOptionInput!) {
  updateQuestionOption(input: $input) {
    ...QuestionOptionSimple
  }
}
    ${QuestionOptionSimpleFragmentDoc}`;
export type UpdateQuestionOptionMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateQuestionOptionMutation, UpdateQuestionOptionMutationVariables>;

/**
 * __useUpdateQuestionOptionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionOptionMutation, { data, loading, error }] = useUpdateQuestionOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionOptionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateQuestionOptionMutation, UpdateQuestionOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateQuestionOptionMutation, UpdateQuestionOptionMutationVariables>(UpdateQuestionOptionDocument, options);
      }
export type UpdateQuestionOptionMutationHookResult = ReturnType<typeof useUpdateQuestionOptionMutation>;
export type UpdateQuestionOptionMutationResult = ApolloReactHooks.useMutation.Result<UpdateQuestionOptionMutation>;
export type UpdateQuestionOptionMutationOptions = ApolloReactHooks.useMutation.Options<UpdateQuestionOptionMutation, UpdateQuestionOptionMutationVariables>;
export const UpdateExtractionQuestionDocument = gql`
    mutation UpdateExtractionQuestion($input: UpdateExtractionQuestionInput!) {
  updateExtractionQuestion(input: $input) {
    ...ExtractionQuestionSimple
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}`;
export type UpdateExtractionQuestionMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateExtractionQuestionMutation, UpdateExtractionQuestionMutationVariables>;

/**
 * __useUpdateExtractionQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateExtractionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtractionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtractionQuestionMutation, { data, loading, error }] = useUpdateExtractionQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExtractionQuestionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateExtractionQuestionMutation, UpdateExtractionQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExtractionQuestionMutation, UpdateExtractionQuestionMutationVariables>(UpdateExtractionQuestionDocument, options);
      }
export type UpdateExtractionQuestionMutationHookResult = ReturnType<typeof useUpdateExtractionQuestionMutation>;
export type UpdateExtractionQuestionMutationResult = ApolloReactHooks.useMutation.Result<UpdateExtractionQuestionMutation>;
export type UpdateExtractionQuestionMutationOptions = ApolloReactHooks.useMutation.Options<UpdateExtractionQuestionMutation, UpdateExtractionQuestionMutationVariables>;
export const UpdateQuestionCategoryDocument = gql`
    mutation UpdateQuestionCategory($input: UpdateQuestionCategoryInput!) {
  updateQuestionCategory(input: $input) {
    ...ExtractionQuestionSimple
  }
}
    ${ExtractionQuestionSimpleFragmentDoc}`;
export type UpdateQuestionCategoryMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateQuestionCategoryMutation, UpdateQuestionCategoryMutationVariables>;

/**
 * __useUpdateQuestionCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionCategoryMutation, { data, loading, error }] = useUpdateQuestionCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionCategoryMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateQuestionCategoryMutation, UpdateQuestionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateQuestionCategoryMutation, UpdateQuestionCategoryMutationVariables>(UpdateQuestionCategoryDocument, options);
      }
export type UpdateQuestionCategoryMutationHookResult = ReturnType<typeof useUpdateQuestionCategoryMutation>;
export type UpdateQuestionCategoryMutationResult = ApolloReactHooks.useMutation.Result<UpdateQuestionCategoryMutation>;
export type UpdateQuestionCategoryMutationOptions = ApolloReactHooks.useMutation.Options<UpdateQuestionCategoryMutation, UpdateQuestionCategoryMutationVariables>;
export const GetReportQuestionsDocument = gql`
    query GetReportQuestions {
  extractionQuestions {
    __typename
    id
    contentHash
    inputFileFields
    inputs {
      __typename
      id
    }
    mode
    questionText
    type
    variant
  }
}
    `;

/**
 * __useGetReportQuestionsQuery__
 *
 * To run a query within a React component, call `useGetReportQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportQuestionsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetReportQuestionsQuery, GetReportQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportQuestionsQuery, GetReportQuestionsQueryVariables>(GetReportQuestionsDocument, options);
      }
export function useGetReportQuestionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportQuestionsQuery, GetReportQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportQuestionsQuery, GetReportQuestionsQueryVariables>(GetReportQuestionsDocument, options);
        }
export function useGetReportQuestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportQuestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportQuestionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportQuestionsQuery, GetReportQuestionsQueryVariables>(GetReportQuestionsDocument, options);
        }
export type GetReportQuestionsQueryHookResult = ReturnType<typeof useGetReportQuestionsQuery>;
export type GetReportQuestionsLazyQueryHookResult = ReturnType<typeof useGetReportQuestionsLazyQuery>;
export type GetReportQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetReportQuestionsSuspenseQuery>;
export type GetReportQuestionsQueryResult = ApolloReactHooks.useQuery.Result<GetReportQuestionsQuery, GetReportQuestionsQueryVariables>;
export const GetFieldDocument = gql`
    query GetField($id: UUID!) {
  field(id: $id) {
    ... on DocumentVariable {
      __typename
      label
      question
      id
      isField
      addToLaunchForm
      nodeId
      minRequired
      maxRequired
      variant
      value
      skipped
      answerOptions {
        ...AnswerOptionsBase
      }
      action {
        ...WorkflowRecipientSimple
      }
      defaultAnswer {
        ...AnswerOptionBase
      }
      selectedAnswer {
        ...AnswerOptionBase
      }
      selectedAnswers {
        ...AnswerOptionBase
      }
      integrationLink {
        attributePath
        integration
      }
    }
    ... on SignatureField {
      __typename
      id
      nodeId
      action {
        ...WorkflowRecipientSimple
      }
    }
  }
}
    ${AnswerOptionsBaseFragmentDoc}
${WorkflowRecipientSimpleFragmentDoc}
${AnswerOptionBaseFragmentDoc}`;

/**
 * __useGetFieldQuery__
 *
 * To run a query within a React component, call `useGetFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFieldQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetFieldQuery, GetFieldQueryVariables> & ({ variables: GetFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFieldQuery, GetFieldQueryVariables>(GetFieldDocument, options);
      }
export function useGetFieldLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFieldQuery, GetFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFieldQuery, GetFieldQueryVariables>(GetFieldDocument, options);
        }
export function useGetFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFieldQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFieldQuery, GetFieldQueryVariables>(GetFieldDocument, options);
        }
export type GetFieldQueryHookResult = ReturnType<typeof useGetFieldQuery>;
export type GetFieldLazyQueryHookResult = ReturnType<typeof useGetFieldLazyQuery>;
export type GetFieldSuspenseQueryHookResult = ReturnType<typeof useGetFieldSuspenseQuery>;
export type GetFieldQueryResult = ApolloReactHooks.useQuery.Result<GetFieldQuery, GetFieldQueryVariables>;
export const GetDbFieldsDocument = gql`
    query GetDBFields($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    variables {
      __typename
      action {
        ...WorkflowRecipientSimple
      }
      answerOptions {
        ...AnswerOptionsBase
      }
      defaultAnswer {
        ...AnswerOptionBase
      }
      id
      integrationLink {
        __typename
        attributePath
        integration
      }
      isField
      label
      nodeId
      question
      minRequired
      maxRequired
      selectedAnswer {
        ...AnswerOptionBase
      }
      selectedAnswers {
        ...AnswerOptionBase
      }
      skipped
      value
      variant
    }
    signatureFields {
      __typename
      action {
        ...WorkflowRecipientSimple
      }
      id
      nodeId
    }
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}
${AnswerOptionsBaseFragmentDoc}
${AnswerOptionBaseFragmentDoc}`;

/**
 * __useGetDbFieldsQuery__
 *
 * To run a query within a React component, call `useGetDbFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDbFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDbFieldsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDbFieldsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDbFieldsQuery, GetDbFieldsQueryVariables> & ({ variables: GetDbFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDbFieldsQuery, GetDbFieldsQueryVariables>(GetDbFieldsDocument, options);
      }
export function useGetDbFieldsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDbFieldsQuery, GetDbFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDbFieldsQuery, GetDbFieldsQueryVariables>(GetDbFieldsDocument, options);
        }
export function useGetDbFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDbFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDbFieldsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDbFieldsQuery, GetDbFieldsQueryVariables>(GetDbFieldsDocument, options);
        }
export type GetDbFieldsQueryHookResult = ReturnType<typeof useGetDbFieldsQuery>;
export type GetDbFieldsLazyQueryHookResult = ReturnType<typeof useGetDbFieldsLazyQuery>;
export type GetDbFieldsSuspenseQueryHookResult = ReturnType<typeof useGetDbFieldsSuspenseQuery>;
export type GetDbFieldsQueryResult = ApolloReactHooks.useQuery.Result<GetDbFieldsQuery, GetDbFieldsQueryVariables>;
export const GetFieldWithActionDocument = gql`
    query GetFieldWithAction($id: UUID!) {
  field(id: $id) {
    ... on DocumentVariable {
      __typename
      id
      action {
        ...WorkflowRecipientSimple
      }
    }
    ... on SignatureField {
      __typename
      id
      action {
        ...WorkflowRecipientSimple
      }
    }
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}`;

/**
 * __useGetFieldWithActionQuery__
 *
 * To run a query within a React component, call `useGetFieldWithActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldWithActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldWithActionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFieldWithActionQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetFieldWithActionQuery, GetFieldWithActionQueryVariables> & ({ variables: GetFieldWithActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFieldWithActionQuery, GetFieldWithActionQueryVariables>(GetFieldWithActionDocument, options);
      }
export function useGetFieldWithActionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFieldWithActionQuery, GetFieldWithActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFieldWithActionQuery, GetFieldWithActionQueryVariables>(GetFieldWithActionDocument, options);
        }
export function useGetFieldWithActionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFieldWithActionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFieldWithActionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFieldWithActionQuery, GetFieldWithActionQueryVariables>(GetFieldWithActionDocument, options);
        }
export type GetFieldWithActionQueryHookResult = ReturnType<typeof useGetFieldWithActionQuery>;
export type GetFieldWithActionLazyQueryHookResult = ReturnType<typeof useGetFieldWithActionLazyQuery>;
export type GetFieldWithActionSuspenseQueryHookResult = ReturnType<typeof useGetFieldWithActionSuspenseQuery>;
export type GetFieldWithActionQueryResult = ApolloReactHooks.useQuery.Result<GetFieldWithActionQuery, GetFieldWithActionQueryVariables>;
export const CreateSignatureFieldDocument = gql`
    mutation CreateSignatureField($input: CreateSignatureFieldInput!) {
  createSignatureField(input: $input) {
    ...SignatureFieldSimple
  }
}
    ${SignatureFieldSimpleFragmentDoc}`;
export type CreateSignatureFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateSignatureFieldMutation, CreateSignatureFieldMutationVariables>;

/**
 * __useCreateSignatureFieldMutation__
 *
 * To run a mutation, you first call `useCreateSignatureFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignatureFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignatureFieldMutation, { data, loading, error }] = useCreateSignatureFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSignatureFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateSignatureFieldMutation, CreateSignatureFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSignatureFieldMutation, CreateSignatureFieldMutationVariables>(CreateSignatureFieldDocument, options);
      }
export type CreateSignatureFieldMutationHookResult = ReturnType<typeof useCreateSignatureFieldMutation>;
export type CreateSignatureFieldMutationResult = ApolloReactHooks.useMutation.Result<CreateSignatureFieldMutation>;
export type CreateSignatureFieldMutationOptions = ApolloReactHooks.useMutation.Options<CreateSignatureFieldMutation, CreateSignatureFieldMutationVariables>;
export const DisableSignatureFieldDocument = gql`
    mutation DisableSignatureField($id: UUID!) {
  disableSignatureField(id: $id) {
    __typename
    id
    deletedAt
  }
}
    `;
export type DisableSignatureFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<DisableSignatureFieldMutation, DisableSignatureFieldMutationVariables>;

/**
 * __useDisableSignatureFieldMutation__
 *
 * To run a mutation, you first call `useDisableSignatureFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSignatureFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSignatureFieldMutation, { data, loading, error }] = useDisableSignatureFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableSignatureFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DisableSignatureFieldMutation, DisableSignatureFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableSignatureFieldMutation, DisableSignatureFieldMutationVariables>(DisableSignatureFieldDocument, options);
      }
export type DisableSignatureFieldMutationHookResult = ReturnType<typeof useDisableSignatureFieldMutation>;
export type DisableSignatureFieldMutationResult = ApolloReactHooks.useMutation.Result<DisableSignatureFieldMutation>;
export type DisableSignatureFieldMutationOptions = ApolloReactHooks.useMutation.Options<DisableSignatureFieldMutation, DisableSignatureFieldMutationVariables>;
export const UpdateSignatureFieldDocument = gql`
    mutation UpdateSignatureField($input: UpdateSignatureFieldInput!) {
  updateSignatureField(input: $input) {
    ...SignatureFieldSimple
  }
}
    ${SignatureFieldSimpleFragmentDoc}`;
export type UpdateSignatureFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateSignatureFieldMutation, UpdateSignatureFieldMutationVariables>;

/**
 * __useUpdateSignatureFieldMutation__
 *
 * To run a mutation, you first call `useUpdateSignatureFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignatureFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignatureFieldMutation, { data, loading, error }] = useUpdateSignatureFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSignatureFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateSignatureFieldMutation, UpdateSignatureFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSignatureFieldMutation, UpdateSignatureFieldMutationVariables>(UpdateSignatureFieldDocument, options);
      }
export type UpdateSignatureFieldMutationHookResult = ReturnType<typeof useUpdateSignatureFieldMutation>;
export type UpdateSignatureFieldMutationResult = ApolloReactHooks.useMutation.Result<UpdateSignatureFieldMutation>;
export type UpdateSignatureFieldMutationOptions = ApolloReactHooks.useMutation.Options<UpdateSignatureFieldMutation, UpdateSignatureFieldMutationVariables>;
export const GetInboxNotificationsDocument = gql`
    query GetInboxNotifications {
  inboxNotifications {
    ...InboxNotificationsResultSimple
  }
}
    ${InboxNotificationsResultSimpleFragmentDoc}`;

/**
 * __useGetInboxNotificationsQuery__
 *
 * To run a query within a React component, call `useGetInboxNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboxNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboxNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInboxNotificationsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetInboxNotificationsQuery, GetInboxNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInboxNotificationsQuery, GetInboxNotificationsQueryVariables>(GetInboxNotificationsDocument, options);
      }
export function useGetInboxNotificationsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetInboxNotificationsQuery, GetInboxNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInboxNotificationsQuery, GetInboxNotificationsQueryVariables>(GetInboxNotificationsDocument, options);
        }
export function useGetInboxNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetInboxNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetInboxNotificationsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetInboxNotificationsQuery, GetInboxNotificationsQueryVariables>(GetInboxNotificationsDocument, options);
        }
export type GetInboxNotificationsQueryHookResult = ReturnType<typeof useGetInboxNotificationsQuery>;
export type GetInboxNotificationsLazyQueryHookResult = ReturnType<typeof useGetInboxNotificationsLazyQuery>;
export type GetInboxNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetInboxNotificationsSuspenseQuery>;
export type GetInboxNotificationsQueryResult = ApolloReactHooks.useQuery.Result<GetInboxNotificationsQuery, GetInboxNotificationsQueryVariables>;
export const MarkInboxNotificationsReadDocument = gql`
    mutation MarkInboxNotificationsRead($ids: [UUID!]!) {
  markInboxNotificationsRead(ids: $ids) {
    ...InboxNotificationsResultSimple
  }
}
    ${InboxNotificationsResultSimpleFragmentDoc}`;
export type MarkInboxNotificationsReadMutationFn = ApolloReactHooks.useMutation.MutationFunction<MarkInboxNotificationsReadMutation, MarkInboxNotificationsReadMutationVariables>;

/**
 * __useMarkInboxNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkInboxNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInboxNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInboxNotificationsReadMutation, { data, loading, error }] = useMarkInboxNotificationsReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkInboxNotificationsReadMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MarkInboxNotificationsReadMutation, MarkInboxNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkInboxNotificationsReadMutation, MarkInboxNotificationsReadMutationVariables>(MarkInboxNotificationsReadDocument, options);
      }
export type MarkInboxNotificationsReadMutationHookResult = ReturnType<typeof useMarkInboxNotificationsReadMutation>;
export type MarkInboxNotificationsReadMutationResult = ApolloReactHooks.useMutation.Result<MarkInboxNotificationsReadMutation>;
export type MarkInboxNotificationsReadMutationOptions = ApolloReactHooks.useMutation.Options<MarkInboxNotificationsReadMutation, MarkInboxNotificationsReadMutationVariables>;
export const MarkInboxNotificationsUnreadDocument = gql`
    mutation MarkInboxNotificationsUnread($ids: [UUID!]!) {
  markInboxNotificationsUnread(ids: $ids) {
    ...InboxNotificationsResultSimple
  }
}
    ${InboxNotificationsResultSimpleFragmentDoc}`;
export type MarkInboxNotificationsUnreadMutationFn = ApolloReactHooks.useMutation.MutationFunction<MarkInboxNotificationsUnreadMutation, MarkInboxNotificationsUnreadMutationVariables>;

/**
 * __useMarkInboxNotificationsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkInboxNotificationsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInboxNotificationsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInboxNotificationsUnreadMutation, { data, loading, error }] = useMarkInboxNotificationsUnreadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkInboxNotificationsUnreadMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MarkInboxNotificationsUnreadMutation, MarkInboxNotificationsUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkInboxNotificationsUnreadMutation, MarkInboxNotificationsUnreadMutationVariables>(MarkInboxNotificationsUnreadDocument, options);
      }
export type MarkInboxNotificationsUnreadMutationHookResult = ReturnType<typeof useMarkInboxNotificationsUnreadMutation>;
export type MarkInboxNotificationsUnreadMutationResult = ApolloReactHooks.useMutation.Result<MarkInboxNotificationsUnreadMutation>;
export type MarkInboxNotificationsUnreadMutationOptions = ApolloReactHooks.useMutation.Options<MarkInboxNotificationsUnreadMutation, MarkInboxNotificationsUnreadMutationVariables>;
export const DismissInboxNotificationDocument = gql`
    mutation DismissInboxNotification($id: UUID!) {
  dismissInboxNotification(id: $id) {
    ...InboxNotificationsResultSimple
  }
}
    ${InboxNotificationsResultSimpleFragmentDoc}`;
export type DismissInboxNotificationMutationFn = ApolloReactHooks.useMutation.MutationFunction<DismissInboxNotificationMutation, DismissInboxNotificationMutationVariables>;

/**
 * __useDismissInboxNotificationMutation__
 *
 * To run a mutation, you first call `useDismissInboxNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissInboxNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissInboxNotificationMutation, { data, loading, error }] = useDismissInboxNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissInboxNotificationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DismissInboxNotificationMutation, DismissInboxNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DismissInboxNotificationMutation, DismissInboxNotificationMutationVariables>(DismissInboxNotificationDocument, options);
      }
export type DismissInboxNotificationMutationHookResult = ReturnType<typeof useDismissInboxNotificationMutation>;
export type DismissInboxNotificationMutationResult = ApolloReactHooks.useMutation.Result<DismissInboxNotificationMutation>;
export type DismissInboxNotificationMutationOptions = ApolloReactHooks.useMutation.Options<DismissInboxNotificationMutation, DismissInboxNotificationMutationVariables>;
export const OnInboxNotificationsChangedDocument = gql`
    subscription OnInboxNotificationsChanged {
  inboxNotificationsChanged {
    __typename
    orgId
  }
}
    `;

/**
 * __useOnInboxNotificationsChangedSubscription__
 *
 * To run a query within a React component, call `useOnInboxNotificationsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnInboxNotificationsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnInboxNotificationsChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnInboxNotificationsChangedSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnInboxNotificationsChangedSubscription, OnInboxNotificationsChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnInboxNotificationsChangedSubscription, OnInboxNotificationsChangedSubscriptionVariables>(OnInboxNotificationsChangedDocument, options);
      }
export type OnInboxNotificationsChangedSubscriptionHookResult = ReturnType<typeof useOnInboxNotificationsChangedSubscription>;
export type OnInboxNotificationsChangedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnInboxNotificationsChangedSubscription>;
export const IntakeFormTemplatesDocument = gql`
    query IntakeFormTemplates {
  intakeFormTemplates {
    ...IntakeFormTemplateFull
  }
}
    ${IntakeFormTemplateFullFragmentDoc}`;

/**
 * __useIntakeFormTemplatesQuery__
 *
 * To run a query within a React component, call `useIntakeFormTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntakeFormTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntakeFormTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntakeFormTemplatesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<IntakeFormTemplatesQuery, IntakeFormTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IntakeFormTemplatesQuery, IntakeFormTemplatesQueryVariables>(IntakeFormTemplatesDocument, options);
      }
export function useIntakeFormTemplatesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<IntakeFormTemplatesQuery, IntakeFormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IntakeFormTemplatesQuery, IntakeFormTemplatesQueryVariables>(IntakeFormTemplatesDocument, options);
        }
export function useIntakeFormTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<IntakeFormTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<IntakeFormTemplatesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<IntakeFormTemplatesQuery, IntakeFormTemplatesQueryVariables>(IntakeFormTemplatesDocument, options);
        }
export type IntakeFormTemplatesQueryHookResult = ReturnType<typeof useIntakeFormTemplatesQuery>;
export type IntakeFormTemplatesLazyQueryHookResult = ReturnType<typeof useIntakeFormTemplatesLazyQuery>;
export type IntakeFormTemplatesSuspenseQueryHookResult = ReturnType<typeof useIntakeFormTemplatesSuspenseQuery>;
export type IntakeFormTemplatesQueryResult = ApolloReactHooks.useQuery.Result<IntakeFormTemplatesQuery, IntakeFormTemplatesQueryVariables>;
export const IntakeFormTemplateDocument = gql`
    query IntakeFormTemplate($intakeFormTemplateId: UUID!) {
  intakeFormTemplate(intakeFormTemplateId: $intakeFormTemplateId) {
    ...IntakeFormTemplateFull
  }
}
    ${IntakeFormTemplateFullFragmentDoc}`;

/**
 * __useIntakeFormTemplateQuery__
 *
 * To run a query within a React component, call `useIntakeFormTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntakeFormTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntakeFormTemplateQuery({
 *   variables: {
 *      intakeFormTemplateId: // value for 'intakeFormTemplateId'
 *   },
 * });
 */
export function useIntakeFormTemplateQuery(baseOptions: ApolloReactHooks.useQuery.Options<IntakeFormTemplateQuery, IntakeFormTemplateQueryVariables> & ({ variables: IntakeFormTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IntakeFormTemplateQuery, IntakeFormTemplateQueryVariables>(IntakeFormTemplateDocument, options);
      }
export function useIntakeFormTemplateLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<IntakeFormTemplateQuery, IntakeFormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IntakeFormTemplateQuery, IntakeFormTemplateQueryVariables>(IntakeFormTemplateDocument, options);
        }
export function useIntakeFormTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<IntakeFormTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<IntakeFormTemplateQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<IntakeFormTemplateQuery, IntakeFormTemplateQueryVariables>(IntakeFormTemplateDocument, options);
        }
export type IntakeFormTemplateQueryHookResult = ReturnType<typeof useIntakeFormTemplateQuery>;
export type IntakeFormTemplateLazyQueryHookResult = ReturnType<typeof useIntakeFormTemplateLazyQuery>;
export type IntakeFormTemplateSuspenseQueryHookResult = ReturnType<typeof useIntakeFormTemplateSuspenseQuery>;
export type IntakeFormTemplateQueryResult = ApolloReactHooks.useQuery.Result<IntakeFormTemplateQuery, IntakeFormTemplateQueryVariables>;
export const IntakeFormTemplateAttachedWorkflowsDocument = gql`
    query IntakeFormTemplateAttachedWorkflows($intakeFormTemplateId: UUID!) {
  intakeFormTemplate(intakeFormTemplateId: $intakeFormTemplateId) {
    id
    attachedWorkflows {
      id
      name
    }
  }
}
    `;

/**
 * __useIntakeFormTemplateAttachedWorkflowsQuery__
 *
 * To run a query within a React component, call `useIntakeFormTemplateAttachedWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntakeFormTemplateAttachedWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntakeFormTemplateAttachedWorkflowsQuery({
 *   variables: {
 *      intakeFormTemplateId: // value for 'intakeFormTemplateId'
 *   },
 * });
 */
export function useIntakeFormTemplateAttachedWorkflowsQuery(baseOptions: ApolloReactHooks.useQuery.Options<IntakeFormTemplateAttachedWorkflowsQuery, IntakeFormTemplateAttachedWorkflowsQueryVariables> & ({ variables: IntakeFormTemplateAttachedWorkflowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IntakeFormTemplateAttachedWorkflowsQuery, IntakeFormTemplateAttachedWorkflowsQueryVariables>(IntakeFormTemplateAttachedWorkflowsDocument, options);
      }
export function useIntakeFormTemplateAttachedWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<IntakeFormTemplateAttachedWorkflowsQuery, IntakeFormTemplateAttachedWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IntakeFormTemplateAttachedWorkflowsQuery, IntakeFormTemplateAttachedWorkflowsQueryVariables>(IntakeFormTemplateAttachedWorkflowsDocument, options);
        }
export function useIntakeFormTemplateAttachedWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<IntakeFormTemplateAttachedWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<IntakeFormTemplateAttachedWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<IntakeFormTemplateAttachedWorkflowsQuery, IntakeFormTemplateAttachedWorkflowsQueryVariables>(IntakeFormTemplateAttachedWorkflowsDocument, options);
        }
export type IntakeFormTemplateAttachedWorkflowsQueryHookResult = ReturnType<typeof useIntakeFormTemplateAttachedWorkflowsQuery>;
export type IntakeFormTemplateAttachedWorkflowsLazyQueryHookResult = ReturnType<typeof useIntakeFormTemplateAttachedWorkflowsLazyQuery>;
export type IntakeFormTemplateAttachedWorkflowsSuspenseQueryHookResult = ReturnType<typeof useIntakeFormTemplateAttachedWorkflowsSuspenseQuery>;
export type IntakeFormTemplateAttachedWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<IntakeFormTemplateAttachedWorkflowsQuery, IntakeFormTemplateAttachedWorkflowsQueryVariables>;
export const WorkflowIntakeFormDocument = gql`
    query WorkflowIntakeForm($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    id
    state
    isReadyForSignature {
      ready
      notReadyReasons
    }
    intakeForm {
      ...IntakeFormFull
    }
    intakeFormTemplate {
      ...IntakeFormTemplateFull
    }
    intakeFields {
      __typename
      fieldId
      label
      question
      type
      required
      order
      picklistOptions {
        __typename
        label
        value
      }
      usedInDocuments
    }
    files {
      __typename
      document {
        __typename
        id
        name
      }
    }
  }
}
    ${IntakeFormFullFragmentDoc}
${IntakeFormTemplateFullFragmentDoc}`;

/**
 * __useWorkflowIntakeFormQuery__
 *
 * To run a query within a React component, call `useWorkflowIntakeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowIntakeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowIntakeFormQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useWorkflowIntakeFormQuery(baseOptions: ApolloReactHooks.useQuery.Options<WorkflowIntakeFormQuery, WorkflowIntakeFormQueryVariables> & ({ variables: WorkflowIntakeFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkflowIntakeFormQuery, WorkflowIntakeFormQueryVariables>(WorkflowIntakeFormDocument, options);
      }
export function useWorkflowIntakeFormLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<WorkflowIntakeFormQuery, WorkflowIntakeFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkflowIntakeFormQuery, WorkflowIntakeFormQueryVariables>(WorkflowIntakeFormDocument, options);
        }
export function useWorkflowIntakeFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<WorkflowIntakeFormQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<WorkflowIntakeFormQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<WorkflowIntakeFormQuery, WorkflowIntakeFormQueryVariables>(WorkflowIntakeFormDocument, options);
        }
export type WorkflowIntakeFormQueryHookResult = ReturnType<typeof useWorkflowIntakeFormQuery>;
export type WorkflowIntakeFormLazyQueryHookResult = ReturnType<typeof useWorkflowIntakeFormLazyQuery>;
export type WorkflowIntakeFormSuspenseQueryHookResult = ReturnType<typeof useWorkflowIntakeFormSuspenseQuery>;
export type WorkflowIntakeFormQueryResult = ApolloReactHooks.useQuery.Result<WorkflowIntakeFormQuery, WorkflowIntakeFormQueryVariables>;
export const CreateIntakeFormTemplateDocument = gql`
    mutation CreateIntakeFormTemplate($input: CreateIntakeFormTemplateInput!) {
  createIntakeFormTemplate(input: $input) {
    intakeFormTemplate {
      ...IntakeFormTemplateFull
    }
  }
}
    ${IntakeFormTemplateFullFragmentDoc}`;
export type CreateIntakeFormTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateIntakeFormTemplateMutation, CreateIntakeFormTemplateMutationVariables>;

/**
 * __useCreateIntakeFormTemplateMutation__
 *
 * To run a mutation, you first call `useCreateIntakeFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntakeFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntakeFormTemplateMutation, { data, loading, error }] = useCreateIntakeFormTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntakeFormTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateIntakeFormTemplateMutation, CreateIntakeFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateIntakeFormTemplateMutation, CreateIntakeFormTemplateMutationVariables>(CreateIntakeFormTemplateDocument, options);
      }
export type CreateIntakeFormTemplateMutationHookResult = ReturnType<typeof useCreateIntakeFormTemplateMutation>;
export type CreateIntakeFormTemplateMutationResult = ApolloReactHooks.useMutation.Result<CreateIntakeFormTemplateMutation>;
export type CreateIntakeFormTemplateMutationOptions = ApolloReactHooks.useMutation.Options<CreateIntakeFormTemplateMutation, CreateIntakeFormTemplateMutationVariables>;
export const UpdateIntakeFormTemplateDocument = gql`
    mutation UpdateIntakeFormTemplate($input: UpdateIntakeFormTemplateInput!) {
  updateIntakeFormTemplate(input: $input) {
    intakeFormTemplate {
      ...IntakeFormTemplateFull
    }
  }
}
    ${IntakeFormTemplateFullFragmentDoc}`;
export type UpdateIntakeFormTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateIntakeFormTemplateMutation, UpdateIntakeFormTemplateMutationVariables>;

/**
 * __useUpdateIntakeFormTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateIntakeFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntakeFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntakeFormTemplateMutation, { data, loading, error }] = useUpdateIntakeFormTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntakeFormTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateIntakeFormTemplateMutation, UpdateIntakeFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateIntakeFormTemplateMutation, UpdateIntakeFormTemplateMutationVariables>(UpdateIntakeFormTemplateDocument, options);
      }
export type UpdateIntakeFormTemplateMutationHookResult = ReturnType<typeof useUpdateIntakeFormTemplateMutation>;
export type UpdateIntakeFormTemplateMutationResult = ApolloReactHooks.useMutation.Result<UpdateIntakeFormTemplateMutation>;
export type UpdateIntakeFormTemplateMutationOptions = ApolloReactHooks.useMutation.Options<UpdateIntakeFormTemplateMutation, UpdateIntakeFormTemplateMutationVariables>;
export const DeleteIntakeFormTemplateDocument = gql`
    mutation DeleteIntakeFormTemplate($intakeFormTemplateId: UUID!) {
  deleteIntakeFormTemplate(intakeFormTemplateId: $intakeFormTemplateId)
}
    `;
export type DeleteIntakeFormTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteIntakeFormTemplateMutation, DeleteIntakeFormTemplateMutationVariables>;

/**
 * __useDeleteIntakeFormTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteIntakeFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntakeFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntakeFormTemplateMutation, { data, loading, error }] = useDeleteIntakeFormTemplateMutation({
 *   variables: {
 *      intakeFormTemplateId: // value for 'intakeFormTemplateId'
 *   },
 * });
 */
export function useDeleteIntakeFormTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteIntakeFormTemplateMutation, DeleteIntakeFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteIntakeFormTemplateMutation, DeleteIntakeFormTemplateMutationVariables>(DeleteIntakeFormTemplateDocument, options);
      }
export type DeleteIntakeFormTemplateMutationHookResult = ReturnType<typeof useDeleteIntakeFormTemplateMutation>;
export type DeleteIntakeFormTemplateMutationResult = ApolloReactHooks.useMutation.Result<DeleteIntakeFormTemplateMutation>;
export type DeleteIntakeFormTemplateMutationOptions = ApolloReactHooks.useMutation.Options<DeleteIntakeFormTemplateMutation, DeleteIntakeFormTemplateMutationVariables>;
export const AttachIntakeFormTemplateDocument = gql`
    mutation AttachIntakeFormTemplate($input: AttachIntakeFormTemplateInput!) {
  attachIntakeFormTemplate(input: $input) {
    workflow {
      id
      intakeFormTemplate {
        ...IntakeFormTemplateFull
      }
    }
  }
}
    ${IntakeFormTemplateFullFragmentDoc}`;
export type AttachIntakeFormTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<AttachIntakeFormTemplateMutation, AttachIntakeFormTemplateMutationVariables>;

/**
 * __useAttachIntakeFormTemplateMutation__
 *
 * To run a mutation, you first call `useAttachIntakeFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachIntakeFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachIntakeFormTemplateMutation, { data, loading, error }] = useAttachIntakeFormTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachIntakeFormTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AttachIntakeFormTemplateMutation, AttachIntakeFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AttachIntakeFormTemplateMutation, AttachIntakeFormTemplateMutationVariables>(AttachIntakeFormTemplateDocument, options);
      }
export type AttachIntakeFormTemplateMutationHookResult = ReturnType<typeof useAttachIntakeFormTemplateMutation>;
export type AttachIntakeFormTemplateMutationResult = ApolloReactHooks.useMutation.Result<AttachIntakeFormTemplateMutation>;
export type AttachIntakeFormTemplateMutationOptions = ApolloReactHooks.useMutation.Options<AttachIntakeFormTemplateMutation, AttachIntakeFormTemplateMutationVariables>;
export const DetachIntakeFormTemplateDocument = gql`
    mutation DetachIntakeFormTemplate($input: DetachIntakeFormTemplateInput!) {
  detachIntakeFormTemplate(input: $input) {
    workflow {
      id
      intakeFormTemplate {
        ...IntakeFormTemplateFull
      }
    }
  }
}
    ${IntakeFormTemplateFullFragmentDoc}`;
export type DetachIntakeFormTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<DetachIntakeFormTemplateMutation, DetachIntakeFormTemplateMutationVariables>;

/**
 * __useDetachIntakeFormTemplateMutation__
 *
 * To run a mutation, you first call `useDetachIntakeFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachIntakeFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachIntakeFormTemplateMutation, { data, loading, error }] = useDetachIntakeFormTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetachIntakeFormTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DetachIntakeFormTemplateMutation, DetachIntakeFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DetachIntakeFormTemplateMutation, DetachIntakeFormTemplateMutationVariables>(DetachIntakeFormTemplateDocument, options);
      }
export type DetachIntakeFormTemplateMutationHookResult = ReturnType<typeof useDetachIntakeFormTemplateMutation>;
export type DetachIntakeFormTemplateMutationResult = ApolloReactHooks.useMutation.Result<DetachIntakeFormTemplateMutation>;
export type DetachIntakeFormTemplateMutationOptions = ApolloReactHooks.useMutation.Options<DetachIntakeFormTemplateMutation, DetachIntakeFormTemplateMutationVariables>;
export const UpdateIntakeFormValuesDocument = gql`
    mutation UpdateIntakeFormValues($input: UpdateIntakeFormValuesInput!, $refreshReadiness: Boolean = false) {
  updateIntakeFormValues(input: $input) {
    intakeForm {
      ...IntakeFormFull
    }
    workflow {
      id
      isReadyForSignature @include(if: $refreshReadiness) {
        ready
        notReadyReasons
      }
      files {
        ...WorkflowFileSimple
      }
    }
  }
}
    ${IntakeFormFullFragmentDoc}
${WorkflowFileSimpleFragmentDoc}`;
export type UpdateIntakeFormValuesMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateIntakeFormValuesMutation, UpdateIntakeFormValuesMutationVariables>;

/**
 * __useUpdateIntakeFormValuesMutation__
 *
 * To run a mutation, you first call `useUpdateIntakeFormValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntakeFormValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntakeFormValuesMutation, { data, loading, error }] = useUpdateIntakeFormValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      refreshReadiness: // value for 'refreshReadiness'
 *   },
 * });
 */
export function useUpdateIntakeFormValuesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateIntakeFormValuesMutation, UpdateIntakeFormValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateIntakeFormValuesMutation, UpdateIntakeFormValuesMutationVariables>(UpdateIntakeFormValuesDocument, options);
      }
export type UpdateIntakeFormValuesMutationHookResult = ReturnType<typeof useUpdateIntakeFormValuesMutation>;
export type UpdateIntakeFormValuesMutationResult = ApolloReactHooks.useMutation.Result<UpdateIntakeFormValuesMutation>;
export type UpdateIntakeFormValuesMutationOptions = ApolloReactHooks.useMutation.Options<UpdateIntakeFormValuesMutation, UpdateIntakeFormValuesMutationVariables>;
export const GetCrmConnectionsDocument = gql`
    query GetCRMConnections {
  apiDeckConnections {
    ...ApiDeckConnectionSimple
  }
}
    ${ApiDeckConnectionSimpleFragmentDoc}`;

/**
 * __useGetCrmConnectionsQuery__
 *
 * To run a query within a React component, call `useGetCrmConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCrmConnectionsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetCrmConnectionsQuery, GetCrmConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmConnectionsQuery, GetCrmConnectionsQueryVariables>(GetCrmConnectionsDocument, options);
      }
export function useGetCrmConnectionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCrmConnectionsQuery, GetCrmConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmConnectionsQuery, GetCrmConnectionsQueryVariables>(GetCrmConnectionsDocument, options);
        }
export function useGetCrmConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCrmConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCrmConnectionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCrmConnectionsQuery, GetCrmConnectionsQueryVariables>(GetCrmConnectionsDocument, options);
        }
export type GetCrmConnectionsQueryHookResult = ReturnType<typeof useGetCrmConnectionsQuery>;
export type GetCrmConnectionsLazyQueryHookResult = ReturnType<typeof useGetCrmConnectionsLazyQuery>;
export type GetCrmConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetCrmConnectionsSuspenseQuery>;
export type GetCrmConnectionsQueryResult = ApolloReactHooks.useQuery.Result<GetCrmConnectionsQuery, GetCrmConnectionsQueryVariables>;
export const GetIntegrationOpportunitiesDocument = gql`
    query GetIntegrationOpportunities($serviceId: String!, $limit: Int, $cursor: String, $filter: OpportunityFilterInput) {
  integrationOpportunities(
    serviceId: $serviceId
    limit: $limit
    cursor: $cursor
    filter: $filter
  ) {
    __typename
    nextCursor
    opportunities {
      __typename
      id
      type
      title
    }
  }
}
    `;

/**
 * __useGetIntegrationOpportunitiesQuery__
 *
 * To run a query within a React component, call `useGetIntegrationOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationOpportunitiesQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetIntegrationOpportunitiesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetIntegrationOpportunitiesQuery, GetIntegrationOpportunitiesQueryVariables> & ({ variables: GetIntegrationOpportunitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationOpportunitiesQuery, GetIntegrationOpportunitiesQueryVariables>(GetIntegrationOpportunitiesDocument, options);
      }
export function useGetIntegrationOpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetIntegrationOpportunitiesQuery, GetIntegrationOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationOpportunitiesQuery, GetIntegrationOpportunitiesQueryVariables>(GetIntegrationOpportunitiesDocument, options);
        }
export function useGetIntegrationOpportunitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetIntegrationOpportunitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetIntegrationOpportunitiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationOpportunitiesQuery, GetIntegrationOpportunitiesQueryVariables>(GetIntegrationOpportunitiesDocument, options);
        }
export type GetIntegrationOpportunitiesQueryHookResult = ReturnType<typeof useGetIntegrationOpportunitiesQuery>;
export type GetIntegrationOpportunitiesLazyQueryHookResult = ReturnType<typeof useGetIntegrationOpportunitiesLazyQuery>;
export type GetIntegrationOpportunitiesSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationOpportunitiesSuspenseQuery>;
export type GetIntegrationOpportunitiesQueryResult = ApolloReactHooks.useQuery.Result<GetIntegrationOpportunitiesQuery, GetIntegrationOpportunitiesQueryVariables>;
export const GetOpportunityDocument = gql`
    query GetOpportunity($opportunityId: String!, $serviceId: String!, $workflowId: UUID) {
  apiDeckOpportunity(
    opportunityId: $opportunityId
    serviceId: $serviceId
    workflowId: $workflowId
  ) {
    __typename
    id
    title
    type
    tags
    fields {
      ...IntegrationFieldSimple
    }
  }
}
    ${IntegrationFieldSimpleFragmentDoc}`;

/**
 * __useGetOpportunityQuery__
 *
 * To run a query within a React component, call `useGetOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      serviceId: // value for 'serviceId'
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetOpportunityQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetOpportunityQuery, GetOpportunityQueryVariables> & ({ variables: GetOpportunityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
      }
export function useGetOpportunityLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetOpportunityQuery, GetOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
        }
export function useGetOpportunitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetOpportunityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetOpportunityQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
        }
export type GetOpportunityQueryHookResult = ReturnType<typeof useGetOpportunityQuery>;
export type GetOpportunityLazyQueryHookResult = ReturnType<typeof useGetOpportunityLazyQuery>;
export type GetOpportunitySuspenseQueryHookResult = ReturnType<typeof useGetOpportunitySuspenseQuery>;
export type GetOpportunityQueryResult = ApolloReactHooks.useQuery.Result<GetOpportunityQuery, GetOpportunityQueryVariables>;
export const GetOpportunitySimpleDocument = gql`
    query GetOpportunitySimple($opportunityId: String!, $serviceId: String!) {
  apiDeckOpportunity(opportunityId: $opportunityId, serviceId: $serviceId) {
    __typename
    id
    title
  }
}
    `;

/**
 * __useGetOpportunitySimpleQuery__
 *
 * To run a query within a React component, call `useGetOpportunitySimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunitySimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunitySimpleQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetOpportunitySimpleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetOpportunitySimpleQuery, GetOpportunitySimpleQueryVariables> & ({ variables: GetOpportunitySimpleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOpportunitySimpleQuery, GetOpportunitySimpleQueryVariables>(GetOpportunitySimpleDocument, options);
      }
export function useGetOpportunitySimpleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetOpportunitySimpleQuery, GetOpportunitySimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOpportunitySimpleQuery, GetOpportunitySimpleQueryVariables>(GetOpportunitySimpleDocument, options);
        }
export function useGetOpportunitySimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetOpportunitySimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetOpportunitySimpleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetOpportunitySimpleQuery, GetOpportunitySimpleQueryVariables>(GetOpportunitySimpleDocument, options);
        }
export type GetOpportunitySimpleQueryHookResult = ReturnType<typeof useGetOpportunitySimpleQuery>;
export type GetOpportunitySimpleLazyQueryHookResult = ReturnType<typeof useGetOpportunitySimpleLazyQuery>;
export type GetOpportunitySimpleSuspenseQueryHookResult = ReturnType<typeof useGetOpportunitySimpleSuspenseQuery>;
export type GetOpportunitySimpleQueryResult = ApolloReactHooks.useQuery.Result<GetOpportunitySimpleQuery, GetOpportunitySimpleQueryVariables>;
export const GetConsumerConnectionsDocument = gql`
    query GetConsumerConnections {
  apiDeckConsumer {
    apiDeckConnections {
      ...ApiDeckConnectionSimple
    }
  }
}
    ${ApiDeckConnectionSimpleFragmentDoc}`;

/**
 * __useGetConsumerConnectionsQuery__
 *
 * To run a query within a React component, call `useGetConsumerConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConsumerConnectionsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetConsumerConnectionsQuery, GetConsumerConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetConsumerConnectionsQuery, GetConsumerConnectionsQueryVariables>(GetConsumerConnectionsDocument, options);
      }
export function useGetConsumerConnectionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetConsumerConnectionsQuery, GetConsumerConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetConsumerConnectionsQuery, GetConsumerConnectionsQueryVariables>(GetConsumerConnectionsDocument, options);
        }
export function useGetConsumerConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetConsumerConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetConsumerConnectionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetConsumerConnectionsQuery, GetConsumerConnectionsQueryVariables>(GetConsumerConnectionsDocument, options);
        }
export type GetConsumerConnectionsQueryHookResult = ReturnType<typeof useGetConsumerConnectionsQuery>;
export type GetConsumerConnectionsLazyQueryHookResult = ReturnType<typeof useGetConsumerConnectionsLazyQuery>;
export type GetConsumerConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetConsumerConnectionsSuspenseQuery>;
export type GetConsumerConnectionsQueryResult = ApolloReactHooks.useQuery.Result<GetConsumerConnectionsQuery, GetConsumerConnectionsQueryVariables>;
export const GetIntegrationFieldDocument = gql`
    query GetIntegrationField($input: IntegrationFieldInput!) {
  integrationField(input: $input) {
    ...IntegrationFieldSimple
  }
}
    ${IntegrationFieldSimpleFragmentDoc}`;

/**
 * __useGetIntegrationFieldQuery__
 *
 * To run a query within a React component, call `useGetIntegrationFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIntegrationFieldQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetIntegrationFieldQuery, GetIntegrationFieldQueryVariables> & ({ variables: GetIntegrationFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationFieldQuery, GetIntegrationFieldQueryVariables>(GetIntegrationFieldDocument, options);
      }
export function useGetIntegrationFieldLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetIntegrationFieldQuery, GetIntegrationFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationFieldQuery, GetIntegrationFieldQueryVariables>(GetIntegrationFieldDocument, options);
        }
export function useGetIntegrationFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetIntegrationFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetIntegrationFieldQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationFieldQuery, GetIntegrationFieldQueryVariables>(GetIntegrationFieldDocument, options);
        }
export type GetIntegrationFieldQueryHookResult = ReturnType<typeof useGetIntegrationFieldQuery>;
export type GetIntegrationFieldLazyQueryHookResult = ReturnType<typeof useGetIntegrationFieldLazyQuery>;
export type GetIntegrationFieldSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationFieldSuspenseQuery>;
export type GetIntegrationFieldQueryResult = ApolloReactHooks.useQuery.Result<GetIntegrationFieldQuery, GetIntegrationFieldQueryVariables>;
export const CreateApideckSessionDocument = gql`
    mutation CreateApideckSession($unifiedApi: ApiDeckUnifiedApi! = Crm) {
  createApiDeckSession(unifiedApi: $unifiedApi) {
    __typename
    expiresAt
    sessionToken
  }
}
    `;
export type CreateApideckSessionMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateApideckSessionMutation, CreateApideckSessionMutationVariables>;

/**
 * __useCreateApideckSessionMutation__
 *
 * To run a mutation, you first call `useCreateApideckSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApideckSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApideckSessionMutation, { data, loading, error }] = useCreateApideckSessionMutation({
 *   variables: {
 *      unifiedApi: // value for 'unifiedApi'
 *   },
 * });
 */
export function useCreateApideckSessionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateApideckSessionMutation, CreateApideckSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateApideckSessionMutation, CreateApideckSessionMutationVariables>(CreateApideckSessionDocument, options);
      }
export type CreateApideckSessionMutationHookResult = ReturnType<typeof useCreateApideckSessionMutation>;
export type CreateApideckSessionMutationResult = ApolloReactHooks.useMutation.Result<CreateApideckSessionMutation>;
export type CreateApideckSessionMutationOptions = ApolloReactHooks.useMutation.Options<CreateApideckSessionMutation, CreateApideckSessionMutationVariables>;
export const PairCrmTenantDocument = gql`
    mutation PairCrmTenant($integration: Integration!) {
  pairCrmTenant(integration: $integration) {
    __typename
    id
  }
}
    `;
export type PairCrmTenantMutationFn = ApolloReactHooks.useMutation.MutationFunction<PairCrmTenantMutation, PairCrmTenantMutationVariables>;

/**
 * __usePairCrmTenantMutation__
 *
 * To run a mutation, you first call `usePairCrmTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePairCrmTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pairCrmTenantMutation, { data, loading, error }] = usePairCrmTenantMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function usePairCrmTenantMutation(baseOptions?: ApolloReactHooks.useMutation.Options<PairCrmTenantMutation, PairCrmTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PairCrmTenantMutation, PairCrmTenantMutationVariables>(PairCrmTenantDocument, options);
      }
export type PairCrmTenantMutationHookResult = ReturnType<typeof usePairCrmTenantMutation>;
export type PairCrmTenantMutationResult = ApolloReactHooks.useMutation.Result<PairCrmTenantMutation>;
export type PairCrmTenantMutationOptions = ApolloReactHooks.useMutation.Options<PairCrmTenantMutation, PairCrmTenantMutationVariables>;
export const SyncCrmPairingDocument = gql`
    mutation SyncCrmPairing($integration: Integration!) {
  syncCrmPairing(integration: $integration) {
    __typename
    id
  }
}
    `;
export type SyncCrmPairingMutationFn = ApolloReactHooks.useMutation.MutationFunction<SyncCrmPairingMutation, SyncCrmPairingMutationVariables>;

/**
 * __useSyncCrmPairingMutation__
 *
 * To run a mutation, you first call `useSyncCrmPairingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCrmPairingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCrmPairingMutation, { data, loading, error }] = useSyncCrmPairingMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useSyncCrmPairingMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SyncCrmPairingMutation, SyncCrmPairingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncCrmPairingMutation, SyncCrmPairingMutationVariables>(SyncCrmPairingDocument, options);
      }
export type SyncCrmPairingMutationHookResult = ReturnType<typeof useSyncCrmPairingMutation>;
export type SyncCrmPairingMutationResult = ApolloReactHooks.useMutation.Result<SyncCrmPairingMutation>;
export type SyncCrmPairingMutationOptions = ApolloReactHooks.useMutation.Options<SyncCrmPairingMutation, SyncCrmPairingMutationVariables>;
export const RotateCrmSigningSecretDocument = gql`
    mutation RotateCrmSigningSecret($integration: Integration!) {
  rotateCrmSigningSecret(integration: $integration) {
    ...CrmPairingKeyStatus
  }
}
    ${CrmPairingKeyStatusFragmentDoc}`;
export type RotateCrmSigningSecretMutationFn = ApolloReactHooks.useMutation.MutationFunction<RotateCrmSigningSecretMutation, RotateCrmSigningSecretMutationVariables>;

/**
 * __useRotateCrmSigningSecretMutation__
 *
 * To run a mutation, you first call `useRotateCrmSigningSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateCrmSigningSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateCrmSigningSecretMutation, { data, loading, error }] = useRotateCrmSigningSecretMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useRotateCrmSigningSecretMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RotateCrmSigningSecretMutation, RotateCrmSigningSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RotateCrmSigningSecretMutation, RotateCrmSigningSecretMutationVariables>(RotateCrmSigningSecretDocument, options);
      }
export type RotateCrmSigningSecretMutationHookResult = ReturnType<typeof useRotateCrmSigningSecretMutation>;
export type RotateCrmSigningSecretMutationResult = ApolloReactHooks.useMutation.Result<RotateCrmSigningSecretMutation>;
export type RotateCrmSigningSecretMutationOptions = ApolloReactHooks.useMutation.Options<RotateCrmSigningSecretMutation, RotateCrmSigningSecretMutationVariables>;
export const PushCrmSigningSecretDocument = gql`
    mutation PushCrmSigningSecret($integration: Integration!) {
  pushCrmSigningSecret(integration: $integration) {
    ...CrmPairingKeyStatus
  }
}
    ${CrmPairingKeyStatusFragmentDoc}`;
export type PushCrmSigningSecretMutationFn = ApolloReactHooks.useMutation.MutationFunction<PushCrmSigningSecretMutation, PushCrmSigningSecretMutationVariables>;

/**
 * __usePushCrmSigningSecretMutation__
 *
 * To run a mutation, you first call `usePushCrmSigningSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushCrmSigningSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushCrmSigningSecretMutation, { data, loading, error }] = usePushCrmSigningSecretMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function usePushCrmSigningSecretMutation(baseOptions?: ApolloReactHooks.useMutation.Options<PushCrmSigningSecretMutation, PushCrmSigningSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PushCrmSigningSecretMutation, PushCrmSigningSecretMutationVariables>(PushCrmSigningSecretDocument, options);
      }
export type PushCrmSigningSecretMutationHookResult = ReturnType<typeof usePushCrmSigningSecretMutation>;
export type PushCrmSigningSecretMutationResult = ApolloReactHooks.useMutation.Result<PushCrmSigningSecretMutation>;
export type PushCrmSigningSecretMutationOptions = ApolloReactHooks.useMutation.Options<PushCrmSigningSecretMutation, PushCrmSigningSecretMutationVariables>;
export const SetCrmAppSecretDocument = gql`
    mutation SetCrmAppSecret($integration: Integration!, $secret: String!) {
  setCrmAppSecret(integration: $integration, secret: $secret)
}
    `;
export type SetCrmAppSecretMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetCrmAppSecretMutation, SetCrmAppSecretMutationVariables>;

/**
 * __useSetCrmAppSecretMutation__
 *
 * To run a mutation, you first call `useSetCrmAppSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCrmAppSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCrmAppSecretMutation, { data, loading, error }] = useSetCrmAppSecretMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useSetCrmAppSecretMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetCrmAppSecretMutation, SetCrmAppSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCrmAppSecretMutation, SetCrmAppSecretMutationVariables>(SetCrmAppSecretDocument, options);
      }
export type SetCrmAppSecretMutationHookResult = ReturnType<typeof useSetCrmAppSecretMutation>;
export type SetCrmAppSecretMutationResult = ApolloReactHooks.useMutation.Result<SetCrmAppSecretMutation>;
export type SetCrmAppSecretMutationOptions = ApolloReactHooks.useMutation.Options<SetCrmAppSecretMutation, SetCrmAppSecretMutationVariables>;
export const GetChannelInstallationsDocument = gql`
    query GetChannelInstallations {
  channelInstallations {
    ...ChannelInstallationSimple
  }
}
    ${ChannelInstallationSimpleFragmentDoc}`;

/**
 * __useGetChannelInstallationsQuery__
 *
 * To run a query within a React component, call `useGetChannelInstallationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelInstallationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelInstallationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChannelInstallationsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetChannelInstallationsQuery, GetChannelInstallationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChannelInstallationsQuery, GetChannelInstallationsQueryVariables>(GetChannelInstallationsDocument, options);
      }
export function useGetChannelInstallationsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetChannelInstallationsQuery, GetChannelInstallationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChannelInstallationsQuery, GetChannelInstallationsQueryVariables>(GetChannelInstallationsDocument, options);
        }
export function useGetChannelInstallationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetChannelInstallationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetChannelInstallationsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetChannelInstallationsQuery, GetChannelInstallationsQueryVariables>(GetChannelInstallationsDocument, options);
        }
export type GetChannelInstallationsQueryHookResult = ReturnType<typeof useGetChannelInstallationsQuery>;
export type GetChannelInstallationsLazyQueryHookResult = ReturnType<typeof useGetChannelInstallationsLazyQuery>;
export type GetChannelInstallationsSuspenseQueryHookResult = ReturnType<typeof useGetChannelInstallationsSuspenseQuery>;
export type GetChannelInstallationsQueryResult = ApolloReactHooks.useQuery.Result<GetChannelInstallationsQuery, GetChannelInstallationsQueryVariables>;
export const DisconnectChannelInstallationDocument = gql`
    mutation DisconnectChannelInstallation($id: UUID!) {
  disconnectChannelInstallation(id: $id)
}
    `;
export type DisconnectChannelInstallationMutationFn = ApolloReactHooks.useMutation.MutationFunction<DisconnectChannelInstallationMutation, DisconnectChannelInstallationMutationVariables>;

/**
 * __useDisconnectChannelInstallationMutation__
 *
 * To run a mutation, you first call `useDisconnectChannelInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectChannelInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectChannelInstallationMutation, { data, loading, error }] = useDisconnectChannelInstallationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisconnectChannelInstallationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DisconnectChannelInstallationMutation, DisconnectChannelInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectChannelInstallationMutation, DisconnectChannelInstallationMutationVariables>(DisconnectChannelInstallationDocument, options);
      }
export type DisconnectChannelInstallationMutationHookResult = ReturnType<typeof useDisconnectChannelInstallationMutation>;
export type DisconnectChannelInstallationMutationResult = ApolloReactHooks.useMutation.Result<DisconnectChannelInstallationMutation>;
export type DisconnectChannelInstallationMutationOptions = ApolloReactHooks.useMutation.Options<DisconnectChannelInstallationMutation, DisconnectChannelInstallationMutationVariables>;
export const HasDocuSignAuthDocument = gql`
    query HasDocuSignAuth {
  hasDocuSignAuth {
    hasDocuSignIntegration
  }
}
    `;

/**
 * __useHasDocuSignAuthQuery__
 *
 * To run a query within a React component, call `useHasDocuSignAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasDocuSignAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasDocuSignAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasDocuSignAuthQuery(baseOptions?: ApolloReactHooks.useQuery.Options<HasDocuSignAuthQuery, HasDocuSignAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HasDocuSignAuthQuery, HasDocuSignAuthQueryVariables>(HasDocuSignAuthDocument, options);
      }
export function useHasDocuSignAuthLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<HasDocuSignAuthQuery, HasDocuSignAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HasDocuSignAuthQuery, HasDocuSignAuthQueryVariables>(HasDocuSignAuthDocument, options);
        }
export function useHasDocuSignAuthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<HasDocuSignAuthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<HasDocuSignAuthQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<HasDocuSignAuthQuery, HasDocuSignAuthQueryVariables>(HasDocuSignAuthDocument, options);
        }
export type HasDocuSignAuthQueryHookResult = ReturnType<typeof useHasDocuSignAuthQuery>;
export type HasDocuSignAuthLazyQueryHookResult = ReturnType<typeof useHasDocuSignAuthLazyQuery>;
export type HasDocuSignAuthSuspenseQueryHookResult = ReturnType<typeof useHasDocuSignAuthSuspenseQuery>;
export type HasDocuSignAuthQueryResult = ApolloReactHooks.useQuery.Result<HasDocuSignAuthQuery, HasDocuSignAuthQueryVariables>;
export const IntegrateDocuSignForOrgDocument = gql`
    mutation IntegrateDocuSignForOrg($docuSignApiId: UUID!) {
  integrateDocuSignForOrg(docuSignApiId: $docuSignApiId) {
    ...TokenResponse
  }
}
    ${TokenResponseFragmentDoc}`;
export type IntegrateDocuSignForOrgMutationFn = ApolloReactHooks.useMutation.MutationFunction<IntegrateDocuSignForOrgMutation, IntegrateDocuSignForOrgMutationVariables>;

/**
 * __useIntegrateDocuSignForOrgMutation__
 *
 * To run a mutation, you first call `useIntegrateDocuSignForOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrateDocuSignForOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrateDocuSignForOrgMutation, { data, loading, error }] = useIntegrateDocuSignForOrgMutation({
 *   variables: {
 *      docuSignApiId: // value for 'docuSignApiId'
 *   },
 * });
 */
export function useIntegrateDocuSignForOrgMutation(baseOptions?: ApolloReactHooks.useMutation.Options<IntegrateDocuSignForOrgMutation, IntegrateDocuSignForOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IntegrateDocuSignForOrgMutation, IntegrateDocuSignForOrgMutationVariables>(IntegrateDocuSignForOrgDocument, options);
      }
export type IntegrateDocuSignForOrgMutationHookResult = ReturnType<typeof useIntegrateDocuSignForOrgMutation>;
export type IntegrateDocuSignForOrgMutationResult = ApolloReactHooks.useMutation.Result<IntegrateDocuSignForOrgMutation>;
export type IntegrateDocuSignForOrgMutationOptions = ApolloReactHooks.useMutation.Options<IntegrateDocuSignForOrgMutation, IntegrateDocuSignForOrgMutationVariables>;
export const IntegrateDocuSignForUserDocument = gql`
    mutation IntegrateDocuSignForUser($docuSignApiId: UUID!) {
  integrateDocuSignForUser(docuSignApiId: $docuSignApiId) {
    ...TokenResponse
  }
}
    ${TokenResponseFragmentDoc}`;
export type IntegrateDocuSignForUserMutationFn = ApolloReactHooks.useMutation.MutationFunction<IntegrateDocuSignForUserMutation, IntegrateDocuSignForUserMutationVariables>;

/**
 * __useIntegrateDocuSignForUserMutation__
 *
 * To run a mutation, you first call `useIntegrateDocuSignForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrateDocuSignForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrateDocuSignForUserMutation, { data, loading, error }] = useIntegrateDocuSignForUserMutation({
 *   variables: {
 *      docuSignApiId: // value for 'docuSignApiId'
 *   },
 * });
 */
export function useIntegrateDocuSignForUserMutation(baseOptions?: ApolloReactHooks.useMutation.Options<IntegrateDocuSignForUserMutation, IntegrateDocuSignForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IntegrateDocuSignForUserMutation, IntegrateDocuSignForUserMutationVariables>(IntegrateDocuSignForUserDocument, options);
      }
export type IntegrateDocuSignForUserMutationHookResult = ReturnType<typeof useIntegrateDocuSignForUserMutation>;
export type IntegrateDocuSignForUserMutationResult = ApolloReactHooks.useMutation.Result<IntegrateDocuSignForUserMutation>;
export type IntegrateDocuSignForUserMutationOptions = ApolloReactHooks.useMutation.Options<IntegrateDocuSignForUserMutation, IntegrateDocuSignForUserMutationVariables>;
export const DeleteDocuSignIntegrationDocument = gql`
    mutation DeleteDocuSignIntegration {
  deleteDocuSignIntegration {
    hasDocuSignIntegration
  }
}
    `;
export type DeleteDocuSignIntegrationMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteDocuSignIntegrationMutation, DeleteDocuSignIntegrationMutationVariables>;

/**
 * __useDeleteDocuSignIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteDocuSignIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocuSignIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocuSignIntegrationMutation, { data, loading, error }] = useDeleteDocuSignIntegrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteDocuSignIntegrationMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteDocuSignIntegrationMutation, DeleteDocuSignIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDocuSignIntegrationMutation, DeleteDocuSignIntegrationMutationVariables>(DeleteDocuSignIntegrationDocument, options);
      }
export type DeleteDocuSignIntegrationMutationHookResult = ReturnType<typeof useDeleteDocuSignIntegrationMutation>;
export type DeleteDocuSignIntegrationMutationResult = ApolloReactHooks.useMutation.Result<DeleteDocuSignIntegrationMutation>;
export type DeleteDocuSignIntegrationMutationOptions = ApolloReactHooks.useMutation.Options<DeleteDocuSignIntegrationMutation, DeleteDocuSignIntegrationMutationVariables>;
export const CreateDraftEnvelopeDocument = gql`
    mutation CreateDraftEnvelope($input: CreateDraftEnvelopeInput!) {
  createDraftEnvelope(input: $input) {
    __typename
    id
    docuSignEnvelopeId
    docuSignUri
    title
    statusDateTime
    variant
    recipients {
      ...WorkflowRecipientSimple
    }
    workflow {
      ...WorkflowWithFiles
    }
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}
${WorkflowWithFilesFragmentDoc}`;
export type CreateDraftEnvelopeMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateDraftEnvelopeMutation, CreateDraftEnvelopeMutationVariables>;

/**
 * __useCreateDraftEnvelopeMutation__
 *
 * To run a mutation, you first call `useCreateDraftEnvelopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftEnvelopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftEnvelopeMutation, { data, loading, error }] = useCreateDraftEnvelopeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDraftEnvelopeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateDraftEnvelopeMutation, CreateDraftEnvelopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDraftEnvelopeMutation, CreateDraftEnvelopeMutationVariables>(CreateDraftEnvelopeDocument, options);
      }
export type CreateDraftEnvelopeMutationHookResult = ReturnType<typeof useCreateDraftEnvelopeMutation>;
export type CreateDraftEnvelopeMutationResult = ApolloReactHooks.useMutation.Result<CreateDraftEnvelopeMutation>;
export type CreateDraftEnvelopeMutationOptions = ApolloReactHooks.useMutation.Options<CreateDraftEnvelopeMutation, CreateDraftEnvelopeMutationVariables>;
export const GetExternalToolkitsDocument = gql`
    query GetExternalToolkits {
  externalToolkits {
    ...ExternalToolkitSimple
  }
}
    ${ExternalToolkitSimpleFragmentDoc}`;

/**
 * __useGetExternalToolkitsQuery__
 *
 * To run a query within a React component, call `useGetExternalToolkitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalToolkitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalToolkitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalToolkitsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetExternalToolkitsQuery, GetExternalToolkitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExternalToolkitsQuery, GetExternalToolkitsQueryVariables>(GetExternalToolkitsDocument, options);
      }
export function useGetExternalToolkitsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExternalToolkitsQuery, GetExternalToolkitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExternalToolkitsQuery, GetExternalToolkitsQueryVariables>(GetExternalToolkitsDocument, options);
        }
export function useGetExternalToolkitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExternalToolkitsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExternalToolkitsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExternalToolkitsQuery, GetExternalToolkitsQueryVariables>(GetExternalToolkitsDocument, options);
        }
export type GetExternalToolkitsQueryHookResult = ReturnType<typeof useGetExternalToolkitsQuery>;
export type GetExternalToolkitsLazyQueryHookResult = ReturnType<typeof useGetExternalToolkitsLazyQuery>;
export type GetExternalToolkitsSuspenseQueryHookResult = ReturnType<typeof useGetExternalToolkitsSuspenseQuery>;
export type GetExternalToolkitsQueryResult = ApolloReactHooks.useQuery.Result<GetExternalToolkitsQuery, GetExternalToolkitsQueryVariables>;
export const GetExternalToolkitPoliciesDocument = gql`
    query GetExternalToolkitPolicies {
  externalToolkitPolicies {
    ...ExternalToolkitPolicyRowSimple
  }
}
    ${ExternalToolkitPolicyRowSimpleFragmentDoc}`;

/**
 * __useGetExternalToolkitPoliciesQuery__
 *
 * To run a query within a React component, call `useGetExternalToolkitPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalToolkitPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalToolkitPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalToolkitPoliciesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetExternalToolkitPoliciesQuery, GetExternalToolkitPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExternalToolkitPoliciesQuery, GetExternalToolkitPoliciesQueryVariables>(GetExternalToolkitPoliciesDocument, options);
      }
export function useGetExternalToolkitPoliciesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetExternalToolkitPoliciesQuery, GetExternalToolkitPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExternalToolkitPoliciesQuery, GetExternalToolkitPoliciesQueryVariables>(GetExternalToolkitPoliciesDocument, options);
        }
export function useGetExternalToolkitPoliciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetExternalToolkitPoliciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetExternalToolkitPoliciesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetExternalToolkitPoliciesQuery, GetExternalToolkitPoliciesQueryVariables>(GetExternalToolkitPoliciesDocument, options);
        }
export type GetExternalToolkitPoliciesQueryHookResult = ReturnType<typeof useGetExternalToolkitPoliciesQuery>;
export type GetExternalToolkitPoliciesLazyQueryHookResult = ReturnType<typeof useGetExternalToolkitPoliciesLazyQuery>;
export type GetExternalToolkitPoliciesSuspenseQueryHookResult = ReturnType<typeof useGetExternalToolkitPoliciesSuspenseQuery>;
export type GetExternalToolkitPoliciesQueryResult = ApolloReactHooks.useQuery.Result<GetExternalToolkitPoliciesQuery, GetExternalToolkitPoliciesQueryVariables>;
export const ConnectExternalToolkitDocument = gql`
    mutation ConnectExternalToolkit($toolkit: ExternalToolkitSlug!) {
  connectExternalToolkit(toolkit: $toolkit) {
    __typename
    redirectUrl
  }
}
    `;
export type ConnectExternalToolkitMutationFn = ApolloReactHooks.useMutation.MutationFunction<ConnectExternalToolkitMutation, ConnectExternalToolkitMutationVariables>;

/**
 * __useConnectExternalToolkitMutation__
 *
 * To run a mutation, you first call `useConnectExternalToolkitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectExternalToolkitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectExternalToolkitMutation, { data, loading, error }] = useConnectExternalToolkitMutation({
 *   variables: {
 *      toolkit: // value for 'toolkit'
 *   },
 * });
 */
export function useConnectExternalToolkitMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ConnectExternalToolkitMutation, ConnectExternalToolkitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConnectExternalToolkitMutation, ConnectExternalToolkitMutationVariables>(ConnectExternalToolkitDocument, options);
      }
export type ConnectExternalToolkitMutationHookResult = ReturnType<typeof useConnectExternalToolkitMutation>;
export type ConnectExternalToolkitMutationResult = ApolloReactHooks.useMutation.Result<ConnectExternalToolkitMutation>;
export type ConnectExternalToolkitMutationOptions = ApolloReactHooks.useMutation.Options<ConnectExternalToolkitMutation, ConnectExternalToolkitMutationVariables>;
export const DisconnectExternalToolkitDocument = gql`
    mutation DisconnectExternalToolkit($toolkit: ExternalToolkitSlug!) {
  disconnectExternalToolkit(toolkit: $toolkit)
}
    `;
export type DisconnectExternalToolkitMutationFn = ApolloReactHooks.useMutation.MutationFunction<DisconnectExternalToolkitMutation, DisconnectExternalToolkitMutationVariables>;

/**
 * __useDisconnectExternalToolkitMutation__
 *
 * To run a mutation, you first call `useDisconnectExternalToolkitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectExternalToolkitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectExternalToolkitMutation, { data, loading, error }] = useDisconnectExternalToolkitMutation({
 *   variables: {
 *      toolkit: // value for 'toolkit'
 *   },
 * });
 */
export function useDisconnectExternalToolkitMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DisconnectExternalToolkitMutation, DisconnectExternalToolkitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectExternalToolkitMutation, DisconnectExternalToolkitMutationVariables>(DisconnectExternalToolkitDocument, options);
      }
export type DisconnectExternalToolkitMutationHookResult = ReturnType<typeof useDisconnectExternalToolkitMutation>;
export type DisconnectExternalToolkitMutationResult = ApolloReactHooks.useMutation.Result<DisconnectExternalToolkitMutation>;
export type DisconnectExternalToolkitMutationOptions = ApolloReactHooks.useMutation.Options<DisconnectExternalToolkitMutation, DisconnectExternalToolkitMutationVariables>;
export const SetExternalToolkitPolicyDocument = gql`
    mutation SetExternalToolkitPolicy($toolkit: ExternalToolkitSlug!, $allowed: Boolean!) {
  setExternalToolkitPolicy(toolkit: $toolkit, allowed: $allowed) {
    ...ExternalToolkitSimple
  }
}
    ${ExternalToolkitSimpleFragmentDoc}`;
export type SetExternalToolkitPolicyMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetExternalToolkitPolicyMutation, SetExternalToolkitPolicyMutationVariables>;

/**
 * __useSetExternalToolkitPolicyMutation__
 *
 * To run a mutation, you first call `useSetExternalToolkitPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalToolkitPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExternalToolkitPolicyMutation, { data, loading, error }] = useSetExternalToolkitPolicyMutation({
 *   variables: {
 *      toolkit: // value for 'toolkit'
 *      allowed: // value for 'allowed'
 *   },
 * });
 */
export function useSetExternalToolkitPolicyMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetExternalToolkitPolicyMutation, SetExternalToolkitPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetExternalToolkitPolicyMutation, SetExternalToolkitPolicyMutationVariables>(SetExternalToolkitPolicyDocument, options);
      }
export type SetExternalToolkitPolicyMutationHookResult = ReturnType<typeof useSetExternalToolkitPolicyMutation>;
export type SetExternalToolkitPolicyMutationResult = ApolloReactHooks.useMutation.Result<SetExternalToolkitPolicyMutation>;
export type SetExternalToolkitPolicyMutationOptions = ApolloReactHooks.useMutation.Options<SetExternalToolkitPolicyMutation, SetExternalToolkitPolicyMutationVariables>;
export const SetExternalToolGrantDocument = gql`
    mutation SetExternalToolGrant($toolkit: ExternalToolkitSlug!, $toolSlug: String!, $enabled: Boolean!) {
  setExternalToolGrant(toolkit: $toolkit, toolSlug: $toolSlug, enabled: $enabled) {
    ...ExternalToolkitSimple
  }
}
    ${ExternalToolkitSimpleFragmentDoc}`;
export type SetExternalToolGrantMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetExternalToolGrantMutation, SetExternalToolGrantMutationVariables>;

/**
 * __useSetExternalToolGrantMutation__
 *
 * To run a mutation, you first call `useSetExternalToolGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalToolGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExternalToolGrantMutation, { data, loading, error }] = useSetExternalToolGrantMutation({
 *   variables: {
 *      toolkit: // value for 'toolkit'
 *      toolSlug: // value for 'toolSlug'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetExternalToolGrantMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetExternalToolGrantMutation, SetExternalToolGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetExternalToolGrantMutation, SetExternalToolGrantMutationVariables>(SetExternalToolGrantDocument, options);
      }
export type SetExternalToolGrantMutationHookResult = ReturnType<typeof useSetExternalToolGrantMutation>;
export type SetExternalToolGrantMutationResult = ApolloReactHooks.useMutation.Result<SetExternalToolGrantMutation>;
export type SetExternalToolGrantMutationOptions = ApolloReactHooks.useMutation.Options<SetExternalToolGrantMutation, SetExternalToolGrantMutationVariables>;
export const SetExternalToolGrantsDocument = gql`
    mutation SetExternalToolGrants($toolkit: ExternalToolkitSlug!, $toolSlugs: [String!]!, $enabled: Boolean!) {
  setExternalToolGrants(
    toolkit: $toolkit
    toolSlugs: $toolSlugs
    enabled: $enabled
  ) {
    ...ExternalToolkitSimple
  }
}
    ${ExternalToolkitSimpleFragmentDoc}`;
export type SetExternalToolGrantsMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetExternalToolGrantsMutation, SetExternalToolGrantsMutationVariables>;

/**
 * __useSetExternalToolGrantsMutation__
 *
 * To run a mutation, you first call `useSetExternalToolGrantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalToolGrantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExternalToolGrantsMutation, { data, loading, error }] = useSetExternalToolGrantsMutation({
 *   variables: {
 *      toolkit: // value for 'toolkit'
 *      toolSlugs: // value for 'toolSlugs'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetExternalToolGrantsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetExternalToolGrantsMutation, SetExternalToolGrantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetExternalToolGrantsMutation, SetExternalToolGrantsMutationVariables>(SetExternalToolGrantsDocument, options);
      }
export type SetExternalToolGrantsMutationHookResult = ReturnType<typeof useSetExternalToolGrantsMutation>;
export type SetExternalToolGrantsMutationResult = ApolloReactHooks.useMutation.Result<SetExternalToolGrantsMutation>;
export type SetExternalToolGrantsMutationOptions = ApolloReactHooks.useMutation.Options<SetExternalToolGrantsMutation, SetExternalToolGrantsMutationVariables>;
export const GetFolderSyncJobDocument = gql`
    query GetFolderSyncJob($id: UUID!) {
  folderSyncJob(id: $id) {
    ...FolderSyncJobSimple
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;

/**
 * __useGetFolderSyncJobQuery__
 *
 * To run a query within a React component, call `useGetFolderSyncJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFolderSyncJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFolderSyncJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFolderSyncJobQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetFolderSyncJobQuery, GetFolderSyncJobQueryVariables> & ({ variables: GetFolderSyncJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFolderSyncJobQuery, GetFolderSyncJobQueryVariables>(GetFolderSyncJobDocument, options);
      }
export function useGetFolderSyncJobLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFolderSyncJobQuery, GetFolderSyncJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFolderSyncJobQuery, GetFolderSyncJobQueryVariables>(GetFolderSyncJobDocument, options);
        }
export function useGetFolderSyncJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFolderSyncJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFolderSyncJobQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFolderSyncJobQuery, GetFolderSyncJobQueryVariables>(GetFolderSyncJobDocument, options);
        }
export type GetFolderSyncJobQueryHookResult = ReturnType<typeof useGetFolderSyncJobQuery>;
export type GetFolderSyncJobLazyQueryHookResult = ReturnType<typeof useGetFolderSyncJobLazyQuery>;
export type GetFolderSyncJobSuspenseQueryHookResult = ReturnType<typeof useGetFolderSyncJobSuspenseQuery>;
export type GetFolderSyncJobQueryResult = ApolloReactHooks.useQuery.Result<GetFolderSyncJobQuery, GetFolderSyncJobQueryVariables>;
export const GetFolderSyncJobsDocument = gql`
    query GetFolderSyncJobs {
  folderSyncJobs {
    ...FolderSyncJobSimple
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;

/**
 * __useGetFolderSyncJobsQuery__
 *
 * To run a query within a React component, call `useGetFolderSyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFolderSyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFolderSyncJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFolderSyncJobsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetFolderSyncJobsQuery, GetFolderSyncJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFolderSyncJobsQuery, GetFolderSyncJobsQueryVariables>(GetFolderSyncJobsDocument, options);
      }
export function useGetFolderSyncJobsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFolderSyncJobsQuery, GetFolderSyncJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFolderSyncJobsQuery, GetFolderSyncJobsQueryVariables>(GetFolderSyncJobsDocument, options);
        }
export function useGetFolderSyncJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFolderSyncJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFolderSyncJobsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFolderSyncJobsQuery, GetFolderSyncJobsQueryVariables>(GetFolderSyncJobsDocument, options);
        }
export type GetFolderSyncJobsQueryHookResult = ReturnType<typeof useGetFolderSyncJobsQuery>;
export type GetFolderSyncJobsLazyQueryHookResult = ReturnType<typeof useGetFolderSyncJobsLazyQuery>;
export type GetFolderSyncJobsSuspenseQueryHookResult = ReturnType<typeof useGetFolderSyncJobsSuspenseQuery>;
export type GetFolderSyncJobsQueryResult = ApolloReactHooks.useQuery.Result<GetFolderSyncJobsQuery, GetFolderSyncJobsQueryVariables>;
export const GetDrivesDocument = gql`
    query GetDrives($integration: FileStorageIntegration!) {
  drives(integration: $integration) {
    ...DriveSimple
  }
}
    ${DriveSimpleFragmentDoc}`;

/**
 * __useGetDrivesQuery__
 *
 * To run a query within a React component, call `useGetDrivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivesQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useGetDrivesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDrivesQuery, GetDrivesQueryVariables> & ({ variables: GetDrivesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDrivesQuery, GetDrivesQueryVariables>(GetDrivesDocument, options);
      }
export function useGetDrivesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDrivesQuery, GetDrivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDrivesQuery, GetDrivesQueryVariables>(GetDrivesDocument, options);
        }
export function useGetDrivesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDrivesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDrivesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDrivesQuery, GetDrivesQueryVariables>(GetDrivesDocument, options);
        }
export type GetDrivesQueryHookResult = ReturnType<typeof useGetDrivesQuery>;
export type GetDrivesLazyQueryHookResult = ReturnType<typeof useGetDrivesLazyQuery>;
export type GetDrivesSuspenseQueryHookResult = ReturnType<typeof useGetDrivesSuspenseQuery>;
export type GetDrivesQueryResult = ApolloReactHooks.useQuery.Result<GetDrivesQuery, GetDrivesQueryVariables>;
export const GetFileStorageConnectionsDocument = gql`
    query GetFileStorageConnections {
  fileStorageConnections {
    id
    name
    state
    serviceId
    description
    imageUrl
  }
}
    `;

/**
 * __useGetFileStorageConnectionsQuery__
 *
 * To run a query within a React component, call `useGetFileStorageConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileStorageConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileStorageConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFileStorageConnectionsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetFileStorageConnectionsQuery, GetFileStorageConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFileStorageConnectionsQuery, GetFileStorageConnectionsQueryVariables>(GetFileStorageConnectionsDocument, options);
      }
export function useGetFileStorageConnectionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFileStorageConnectionsQuery, GetFileStorageConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFileStorageConnectionsQuery, GetFileStorageConnectionsQueryVariables>(GetFileStorageConnectionsDocument, options);
        }
export function useGetFileStorageConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFileStorageConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFileStorageConnectionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFileStorageConnectionsQuery, GetFileStorageConnectionsQueryVariables>(GetFileStorageConnectionsDocument, options);
        }
export type GetFileStorageConnectionsQueryHookResult = ReturnType<typeof useGetFileStorageConnectionsQuery>;
export type GetFileStorageConnectionsLazyQueryHookResult = ReturnType<typeof useGetFileStorageConnectionsLazyQuery>;
export type GetFileStorageConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetFileStorageConnectionsSuspenseQuery>;
export type GetFileStorageConnectionsQueryResult = ApolloReactHooks.useQuery.Result<GetFileStorageConnectionsQuery, GetFileStorageConnectionsQueryVariables>;
export const GetConnectionFolderFilesDocument = gql`
    query GetConnectionFolderFiles($integration: FileStorageIntegration!, $driveId: String!, $folderId: String, $cursor: String) {
  connectionFolderFiles(
    integration: $integration
    driveId: $driveId
    folderId: $folderId
    cursor: $cursor
  ) {
    files {
      ...FolderFileSimple
    }
    meta {
      hasMore
      nextCursor
    }
  }
}
    ${FolderFileSimpleFragmentDoc}`;

/**
 * __useGetConnectionFolderFilesQuery__
 *
 * To run a query within a React component, call `useGetConnectionFolderFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionFolderFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionFolderFilesQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *      driveId: // value for 'driveId'
 *      folderId: // value for 'folderId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetConnectionFolderFilesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetConnectionFolderFilesQuery, GetConnectionFolderFilesQueryVariables> & ({ variables: GetConnectionFolderFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetConnectionFolderFilesQuery, GetConnectionFolderFilesQueryVariables>(GetConnectionFolderFilesDocument, options);
      }
export function useGetConnectionFolderFilesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetConnectionFolderFilesQuery, GetConnectionFolderFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetConnectionFolderFilesQuery, GetConnectionFolderFilesQueryVariables>(GetConnectionFolderFilesDocument, options);
        }
export function useGetConnectionFolderFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetConnectionFolderFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetConnectionFolderFilesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetConnectionFolderFilesQuery, GetConnectionFolderFilesQueryVariables>(GetConnectionFolderFilesDocument, options);
        }
export type GetConnectionFolderFilesQueryHookResult = ReturnType<typeof useGetConnectionFolderFilesQuery>;
export type GetConnectionFolderFilesLazyQueryHookResult = ReturnType<typeof useGetConnectionFolderFilesLazyQuery>;
export type GetConnectionFolderFilesSuspenseQueryHookResult = ReturnType<typeof useGetConnectionFolderFilesSuspenseQuery>;
export type GetConnectionFolderFilesQueryResult = ApolloReactHooks.useQuery.Result<GetConnectionFolderFilesQuery, GetConnectionFolderFilesQueryVariables>;
export const GetConnectionFilesSearchDocument = gql`
    query GetConnectionFilesSearch($integration: FileStorageIntegration!, $query: String!, $cursor: String, $driveId: String) {
  connectionFilesSearch(
    integration: $integration
    query: $query
    cursor: $cursor
    driveId: $driveId
  ) {
    ...FolderFileSimple
  }
}
    ${FolderFileSimpleFragmentDoc}`;

/**
 * __useGetConnectionFilesSearchQuery__
 *
 * To run a query within a React component, call `useGetConnectionFilesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionFilesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionFilesSearchQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *      query: // value for 'query'
 *      cursor: // value for 'cursor'
 *      driveId: // value for 'driveId'
 *   },
 * });
 */
export function useGetConnectionFilesSearchQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetConnectionFilesSearchQuery, GetConnectionFilesSearchQueryVariables> & ({ variables: GetConnectionFilesSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetConnectionFilesSearchQuery, GetConnectionFilesSearchQueryVariables>(GetConnectionFilesSearchDocument, options);
      }
export function useGetConnectionFilesSearchLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetConnectionFilesSearchQuery, GetConnectionFilesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetConnectionFilesSearchQuery, GetConnectionFilesSearchQueryVariables>(GetConnectionFilesSearchDocument, options);
        }
export function useGetConnectionFilesSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetConnectionFilesSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetConnectionFilesSearchQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetConnectionFilesSearchQuery, GetConnectionFilesSearchQueryVariables>(GetConnectionFilesSearchDocument, options);
        }
export type GetConnectionFilesSearchQueryHookResult = ReturnType<typeof useGetConnectionFilesSearchQuery>;
export type GetConnectionFilesSearchLazyQueryHookResult = ReturnType<typeof useGetConnectionFilesSearchLazyQuery>;
export type GetConnectionFilesSearchSuspenseQueryHookResult = ReturnType<typeof useGetConnectionFilesSearchSuspenseQuery>;
export type GetConnectionFilesSearchQueryResult = ApolloReactHooks.useQuery.Result<GetConnectionFilesSearchQuery, GetConnectionFilesSearchQueryVariables>;
export const GetIntegrationFolderSyncJobsDocument = gql`
    query GetIntegrationFolderSyncJobs($integration: FileStorageIntegration!) {
  folderSyncJobsForConnection(integration: $integration) {
    id
    folderId
    folderName
    integration
    driveId
    driveName
    syncStartedAt
    syncFinishedAt
    completedIds
    storageIntegrationIds
    allowedMimeTypes
    failedFiles {
      ...FailedFileSimple
    }
    labels {
      ...LabelSimple
    }
  }
}
    ${FailedFileSimpleFragmentDoc}
${LabelSimpleFragmentDoc}`;

/**
 * __useGetIntegrationFolderSyncJobsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationFolderSyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationFolderSyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationFolderSyncJobsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useGetIntegrationFolderSyncJobsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetIntegrationFolderSyncJobsQuery, GetIntegrationFolderSyncJobsQueryVariables> & ({ variables: GetIntegrationFolderSyncJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationFolderSyncJobsQuery, GetIntegrationFolderSyncJobsQueryVariables>(GetIntegrationFolderSyncJobsDocument, options);
      }
export function useGetIntegrationFolderSyncJobsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetIntegrationFolderSyncJobsQuery, GetIntegrationFolderSyncJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationFolderSyncJobsQuery, GetIntegrationFolderSyncJobsQueryVariables>(GetIntegrationFolderSyncJobsDocument, options);
        }
export function useGetIntegrationFolderSyncJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetIntegrationFolderSyncJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetIntegrationFolderSyncJobsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationFolderSyncJobsQuery, GetIntegrationFolderSyncJobsQueryVariables>(GetIntegrationFolderSyncJobsDocument, options);
        }
export type GetIntegrationFolderSyncJobsQueryHookResult = ReturnType<typeof useGetIntegrationFolderSyncJobsQuery>;
export type GetIntegrationFolderSyncJobsLazyQueryHookResult = ReturnType<typeof useGetIntegrationFolderSyncJobsLazyQuery>;
export type GetIntegrationFolderSyncJobsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationFolderSyncJobsSuspenseQuery>;
export type GetIntegrationFolderSyncJobsQueryResult = ApolloReactHooks.useQuery.Result<GetIntegrationFolderSyncJobsQuery, GetIntegrationFolderSyncJobsQueryVariables>;
export const BulkCreateFolderSyncJobsDocument = gql`
    mutation BulkCreateFolderSyncJobs($input: BulkCreateFolderSyncJobInput!) {
  bulkCreateFolderSyncJobs(input: $input) {
    createdJobs {
      ...FolderSyncJobSimple
    }
    deletedFolderSyncJobIds
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;
export type BulkCreateFolderSyncJobsMutationFn = ApolloReactHooks.useMutation.MutationFunction<BulkCreateFolderSyncJobsMutation, BulkCreateFolderSyncJobsMutationVariables>;

/**
 * __useBulkCreateFolderSyncJobsMutation__
 *
 * To run a mutation, you first call `useBulkCreateFolderSyncJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateFolderSyncJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateFolderSyncJobsMutation, { data, loading, error }] = useBulkCreateFolderSyncJobsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateFolderSyncJobsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<BulkCreateFolderSyncJobsMutation, BulkCreateFolderSyncJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkCreateFolderSyncJobsMutation, BulkCreateFolderSyncJobsMutationVariables>(BulkCreateFolderSyncJobsDocument, options);
      }
export type BulkCreateFolderSyncJobsMutationHookResult = ReturnType<typeof useBulkCreateFolderSyncJobsMutation>;
export type BulkCreateFolderSyncJobsMutationResult = ApolloReactHooks.useMutation.Result<BulkCreateFolderSyncJobsMutation>;
export type BulkCreateFolderSyncJobsMutationOptions = ApolloReactHooks.useMutation.Options<BulkCreateFolderSyncJobsMutation, BulkCreateFolderSyncJobsMutationVariables>;
export const DeleteFolderSyncJobsDocument = gql`
    mutation DeleteFolderSyncJobs($ids: [UUID!]!) {
  deleteFolderSyncJobs(ids: $ids)
}
    `;
export type DeleteFolderSyncJobsMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteFolderSyncJobsMutation, DeleteFolderSyncJobsMutationVariables>;

/**
 * __useDeleteFolderSyncJobsMutation__
 *
 * To run a mutation, you first call `useDeleteFolderSyncJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderSyncJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderSyncJobsMutation, { data, loading, error }] = useDeleteFolderSyncJobsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteFolderSyncJobsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteFolderSyncJobsMutation, DeleteFolderSyncJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFolderSyncJobsMutation, DeleteFolderSyncJobsMutationVariables>(DeleteFolderSyncJobsDocument, options);
      }
export type DeleteFolderSyncJobsMutationHookResult = ReturnType<typeof useDeleteFolderSyncJobsMutation>;
export type DeleteFolderSyncJobsMutationResult = ApolloReactHooks.useMutation.Result<DeleteFolderSyncJobsMutation>;
export type DeleteFolderSyncJobsMutationOptions = ApolloReactHooks.useMutation.Options<DeleteFolderSyncJobsMutation, DeleteFolderSyncJobsMutationVariables>;
export const DismissFailedFilesDocument = gql`
    mutation DismissFailedFiles($folderSyncJobId: UUID!, $fileIds: [String!]!) {
  dismissFailedFiles(folderSyncJobId: $folderSyncJobId, fileIds: $fileIds) {
    ...FolderSyncJobSimple
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;
export type DismissFailedFilesMutationFn = ApolloReactHooks.useMutation.MutationFunction<DismissFailedFilesMutation, DismissFailedFilesMutationVariables>;

/**
 * __useDismissFailedFilesMutation__
 *
 * To run a mutation, you first call `useDismissFailedFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissFailedFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissFailedFilesMutation, { data, loading, error }] = useDismissFailedFilesMutation({
 *   variables: {
 *      folderSyncJobId: // value for 'folderSyncJobId'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useDismissFailedFilesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DismissFailedFilesMutation, DismissFailedFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DismissFailedFilesMutation, DismissFailedFilesMutationVariables>(DismissFailedFilesDocument, options);
      }
export type DismissFailedFilesMutationHookResult = ReturnType<typeof useDismissFailedFilesMutation>;
export type DismissFailedFilesMutationResult = ApolloReactHooks.useMutation.Result<DismissFailedFilesMutation>;
export type DismissFailedFilesMutationOptions = ApolloReactHooks.useMutation.Options<DismissFailedFilesMutation, DismissFailedFilesMutationVariables>;
export const TriggerFolderSyncScheduleDocument = gql`
    mutation TriggerFolderSyncSchedule($folderSyncJobId: UUID!) {
  triggerFolderSyncSchedule(folderSyncJobId: $folderSyncJobId) {
    ...FolderSyncJobSimple
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;
export type TriggerFolderSyncScheduleMutationFn = ApolloReactHooks.useMutation.MutationFunction<TriggerFolderSyncScheduleMutation, TriggerFolderSyncScheduleMutationVariables>;

/**
 * __useTriggerFolderSyncScheduleMutation__
 *
 * To run a mutation, you first call `useTriggerFolderSyncScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerFolderSyncScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerFolderSyncScheduleMutation, { data, loading, error }] = useTriggerFolderSyncScheduleMutation({
 *   variables: {
 *      folderSyncJobId: // value for 'folderSyncJobId'
 *   },
 * });
 */
export function useTriggerFolderSyncScheduleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<TriggerFolderSyncScheduleMutation, TriggerFolderSyncScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerFolderSyncScheduleMutation, TriggerFolderSyncScheduleMutationVariables>(TriggerFolderSyncScheduleDocument, options);
      }
export type TriggerFolderSyncScheduleMutationHookResult = ReturnType<typeof useTriggerFolderSyncScheduleMutation>;
export type TriggerFolderSyncScheduleMutationResult = ApolloReactHooks.useMutation.Result<TriggerFolderSyncScheduleMutation>;
export type TriggerFolderSyncScheduleMutationOptions = ApolloReactHooks.useMutation.Options<TriggerFolderSyncScheduleMutation, TriggerFolderSyncScheduleMutationVariables>;
export const RetryFolderSyncFailedFilesDocument = gql`
    mutation RetryFolderSyncFailedFiles($folderSyncJobId: UUID!) {
  retryFolderSyncFailedFiles(folderSyncJobId: $folderSyncJobId) {
    ...FolderSyncJobSimple
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;
export type RetryFolderSyncFailedFilesMutationFn = ApolloReactHooks.useMutation.MutationFunction<RetryFolderSyncFailedFilesMutation, RetryFolderSyncFailedFilesMutationVariables>;

/**
 * __useRetryFolderSyncFailedFilesMutation__
 *
 * To run a mutation, you first call `useRetryFolderSyncFailedFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFolderSyncFailedFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFolderSyncFailedFilesMutation, { data, loading, error }] = useRetryFolderSyncFailedFilesMutation({
 *   variables: {
 *      folderSyncJobId: // value for 'folderSyncJobId'
 *   },
 * });
 */
export function useRetryFolderSyncFailedFilesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RetryFolderSyncFailedFilesMutation, RetryFolderSyncFailedFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RetryFolderSyncFailedFilesMutation, RetryFolderSyncFailedFilesMutationVariables>(RetryFolderSyncFailedFilesDocument, options);
      }
export type RetryFolderSyncFailedFilesMutationHookResult = ReturnType<typeof useRetryFolderSyncFailedFilesMutation>;
export type RetryFolderSyncFailedFilesMutationResult = ApolloReactHooks.useMutation.Result<RetryFolderSyncFailedFilesMutation>;
export type RetryFolderSyncFailedFilesMutationOptions = ApolloReactHooks.useMutation.Options<RetryFolderSyncFailedFilesMutation, RetryFolderSyncFailedFilesMutationVariables>;
export const SetFolderSyncJobLabelsDocument = gql`
    mutation SetFolderSyncJobLabels($folderSyncJobId: UUID!, $labelIds: [UUID!]!) {
  setFolderSyncJobLabels(folderSyncJobId: $folderSyncJobId, labelIds: $labelIds) {
    __typename
    id
    labels {
      __typename
      id
      labelText
    }
  }
}
    `;
export type SetFolderSyncJobLabelsMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetFolderSyncJobLabelsMutation, SetFolderSyncJobLabelsMutationVariables>;

/**
 * __useSetFolderSyncJobLabelsMutation__
 *
 * To run a mutation, you first call `useSetFolderSyncJobLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFolderSyncJobLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFolderSyncJobLabelsMutation, { data, loading, error }] = useSetFolderSyncJobLabelsMutation({
 *   variables: {
 *      folderSyncJobId: // value for 'folderSyncJobId'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useSetFolderSyncJobLabelsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetFolderSyncJobLabelsMutation, SetFolderSyncJobLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetFolderSyncJobLabelsMutation, SetFolderSyncJobLabelsMutationVariables>(SetFolderSyncJobLabelsDocument, options);
      }
export type SetFolderSyncJobLabelsMutationHookResult = ReturnType<typeof useSetFolderSyncJobLabelsMutation>;
export type SetFolderSyncJobLabelsMutationResult = ApolloReactHooks.useMutation.Result<SetFolderSyncJobLabelsMutation>;
export type SetFolderSyncJobLabelsMutationOptions = ApolloReactHooks.useMutation.Options<SetFolderSyncJobLabelsMutation, SetFolderSyncJobLabelsMutationVariables>;
export const SetFolderSyncJobAllowedMimeTypesDocument = gql`
    mutation SetFolderSyncJobAllowedMimeTypes($folderSyncJobId: UUID!, $allowedMimeTypes: [String!]!) {
  setFolderSyncJobAllowedMimeTypes(
    folderSyncJobId: $folderSyncJobId
    allowedMimeTypes: $allowedMimeTypes
  ) {
    ...FolderSyncJobSimple
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;
export type SetFolderSyncJobAllowedMimeTypesMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetFolderSyncJobAllowedMimeTypesMutation, SetFolderSyncJobAllowedMimeTypesMutationVariables>;

/**
 * __useSetFolderSyncJobAllowedMimeTypesMutation__
 *
 * To run a mutation, you first call `useSetFolderSyncJobAllowedMimeTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFolderSyncJobAllowedMimeTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFolderSyncJobAllowedMimeTypesMutation, { data, loading, error }] = useSetFolderSyncJobAllowedMimeTypesMutation({
 *   variables: {
 *      folderSyncJobId: // value for 'folderSyncJobId'
 *      allowedMimeTypes: // value for 'allowedMimeTypes'
 *   },
 * });
 */
export function useSetFolderSyncJobAllowedMimeTypesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetFolderSyncJobAllowedMimeTypesMutation, SetFolderSyncJobAllowedMimeTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetFolderSyncJobAllowedMimeTypesMutation, SetFolderSyncJobAllowedMimeTypesMutationVariables>(SetFolderSyncJobAllowedMimeTypesDocument, options);
      }
export type SetFolderSyncJobAllowedMimeTypesMutationHookResult = ReturnType<typeof useSetFolderSyncJobAllowedMimeTypesMutation>;
export type SetFolderSyncJobAllowedMimeTypesMutationResult = ApolloReactHooks.useMutation.Result<SetFolderSyncJobAllowedMimeTypesMutation>;
export type SetFolderSyncJobAllowedMimeTypesMutationOptions = ApolloReactHooks.useMutation.Options<SetFolderSyncJobAllowedMimeTypesMutation, SetFolderSyncJobAllowedMimeTypesMutationVariables>;
export const StopFolderSyncJobDocument = gql`
    mutation StopFolderSyncJob($folderSyncJobId: UUID!) {
  stopFolderSyncJob(folderSyncJobId: $folderSyncJobId) {
    ...FolderSyncJobSimple
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;
export type StopFolderSyncJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<StopFolderSyncJobMutation, StopFolderSyncJobMutationVariables>;

/**
 * __useStopFolderSyncJobMutation__
 *
 * To run a mutation, you first call `useStopFolderSyncJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopFolderSyncJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopFolderSyncJobMutation, { data, loading, error }] = useStopFolderSyncJobMutation({
 *   variables: {
 *      folderSyncJobId: // value for 'folderSyncJobId'
 *   },
 * });
 */
export function useStopFolderSyncJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StopFolderSyncJobMutation, StopFolderSyncJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopFolderSyncJobMutation, StopFolderSyncJobMutationVariables>(StopFolderSyncJobDocument, options);
      }
export type StopFolderSyncJobMutationHookResult = ReturnType<typeof useStopFolderSyncJobMutation>;
export type StopFolderSyncJobMutationResult = ApolloReactHooks.useMutation.Result<StopFolderSyncJobMutation>;
export type StopFolderSyncJobMutationOptions = ApolloReactHooks.useMutation.Options<StopFolderSyncJobMutation, StopFolderSyncJobMutationVariables>;
export const OnFolderSyncJobUpdateDocument = gql`
    subscription OnFolderSyncJobUpdate {
  folderSyncJobUpdate {
    folderSyncJobIds
    deletedFolderSyncJobIds
    folderSyncJobs {
      ...FolderSyncJobSimple
    }
  }
}
    ${FolderSyncJobSimpleFragmentDoc}`;

/**
 * __useOnFolderSyncJobUpdateSubscription__
 *
 * To run a query within a React component, call `useOnFolderSyncJobUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFolderSyncJobUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFolderSyncJobUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnFolderSyncJobUpdateSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnFolderSyncJobUpdateSubscription, OnFolderSyncJobUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnFolderSyncJobUpdateSubscription, OnFolderSyncJobUpdateSubscriptionVariables>(OnFolderSyncJobUpdateDocument, options);
      }
export type OnFolderSyncJobUpdateSubscriptionHookResult = ReturnType<typeof useOnFolderSyncJobUpdateSubscription>;
export type OnFolderSyncJobUpdateSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnFolderSyncJobUpdateSubscription>;
export const GenerateAiCompletionDocument = gql`
    mutation GenerateAICompletion($input: GenerateAICompletionInput!) {
  generateAICompletion(input: $input) {
    __typename
    succeeded
  }
}
    `;
export type GenerateAiCompletionMutationFn = ApolloReactHooks.useMutation.MutationFunction<GenerateAiCompletionMutation, GenerateAiCompletionMutationVariables>;

/**
 * __useGenerateAiCompletionMutation__
 *
 * To run a mutation, you first call `useGenerateAiCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiCompletionMutation, { data, loading, error }] = useGenerateAiCompletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAiCompletionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<GenerateAiCompletionMutation, GenerateAiCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateAiCompletionMutation, GenerateAiCompletionMutationVariables>(GenerateAiCompletionDocument, options);
      }
export type GenerateAiCompletionMutationHookResult = ReturnType<typeof useGenerateAiCompletionMutation>;
export type GenerateAiCompletionMutationResult = ApolloReactHooks.useMutation.Result<GenerateAiCompletionMutation>;
export type GenerateAiCompletionMutationOptions = ApolloReactHooks.useMutation.Options<GenerateAiCompletionMutation, GenerateAiCompletionMutationVariables>;
export const OnCompletionReceivedDocument = gql`
    subscription OnCompletionReceived($documentId: UUID!) {
  completionReceived(documentId: $documentId) {
    documentId
    position
    completion {
      ...CompletionFull
    }
  }
}
    ${CompletionFullFragmentDoc}`;

/**
 * __useOnCompletionReceivedSubscription__
 *
 * To run a query within a React component, call `useOnCompletionReceivedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompletionReceivedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompletionReceivedSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useOnCompletionReceivedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnCompletionReceivedSubscription, OnCompletionReceivedSubscriptionVariables> & ({ variables: OnCompletionReceivedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnCompletionReceivedSubscription, OnCompletionReceivedSubscriptionVariables>(OnCompletionReceivedDocument, options);
      }
export type OnCompletionReceivedSubscriptionHookResult = ReturnType<typeof useOnCompletionReceivedSubscription>;
export type OnCompletionReceivedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnCompletionReceivedSubscription>;
export const ImprovePromptDocument = gql`
    mutation ImprovePrompt($input: ImprovePromptInput!) {
  improvePrompt(input: $input) {
    requestId
  }
}
    `;
export type ImprovePromptMutationFn = ApolloReactHooks.useMutation.MutationFunction<ImprovePromptMutation, ImprovePromptMutationVariables>;

/**
 * __useImprovePromptMutation__
 *
 * To run a mutation, you first call `useImprovePromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImprovePromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [improvePromptMutation, { data, loading, error }] = useImprovePromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImprovePromptMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ImprovePromptMutation, ImprovePromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImprovePromptMutation, ImprovePromptMutationVariables>(ImprovePromptDocument, options);
      }
export type ImprovePromptMutationHookResult = ReturnType<typeof useImprovePromptMutation>;
export type ImprovePromptMutationResult = ApolloReactHooks.useMutation.Result<ImprovePromptMutation>;
export type ImprovePromptMutationOptions = ApolloReactHooks.useMutation.Options<ImprovePromptMutation, ImprovePromptMutationVariables>;
export const OnImprovedPromptDocument = gql`
    subscription OnImprovedPrompt($requestId: UUID!) {
  onImprovedPrompt(requestId: $requestId) {
    requestId
    improvedText
    userId
    position
  }
}
    `;

/**
 * __useOnImprovedPromptSubscription__
 *
 * To run a query within a React component, call `useOnImprovedPromptSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnImprovedPromptSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnImprovedPromptSubscription({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useOnImprovedPromptSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnImprovedPromptSubscription, OnImprovedPromptSubscriptionVariables> & ({ variables: OnImprovedPromptSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnImprovedPromptSubscription, OnImprovedPromptSubscriptionVariables>(OnImprovedPromptDocument, options);
      }
export type OnImprovedPromptSubscriptionHookResult = ReturnType<typeof useOnImprovedPromptSubscription>;
export type OnImprovedPromptSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnImprovedPromptSubscription>;
export const GetLabelDocument = gql`
    query GetLabel($id: UUID!) {
  label(id: $id) {
    ...LabelSimple
  }
}
    ${LabelSimpleFragmentDoc}`;

/**
 * __useGetLabelQuery__
 *
 * To run a query within a React component, call `useGetLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLabelQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetLabelQuery, GetLabelQueryVariables> & ({ variables: GetLabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLabelQuery, GetLabelQueryVariables>(GetLabelDocument, options);
      }
export function useGetLabelLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetLabelQuery, GetLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLabelQuery, GetLabelQueryVariables>(GetLabelDocument, options);
        }
export function useGetLabelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetLabelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetLabelQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetLabelQuery, GetLabelQueryVariables>(GetLabelDocument, options);
        }
export type GetLabelQueryHookResult = ReturnType<typeof useGetLabelQuery>;
export type GetLabelLazyQueryHookResult = ReturnType<typeof useGetLabelLazyQuery>;
export type GetLabelSuspenseQueryHookResult = ReturnType<typeof useGetLabelSuspenseQuery>;
export type GetLabelQueryResult = ApolloReactHooks.useQuery.Result<GetLabelQuery, GetLabelQueryVariables>;
export const GetWorkflowLabelsDocument = gql`
    query GetWorkflowLabels($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    id
    owner {
      ...UserBase
    }
    files {
      ...WorkflowFileSimple
    }
    permissions {
      ...WorkflowPermissionSimple
    }
    labels {
      ...LabelSimple
    }
  }
}
    ${UserBaseFragmentDoc}
${WorkflowFileSimpleFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}
${LabelSimpleFragmentDoc}`;

/**
 * __useGetWorkflowLabelsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowLabelsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowLabelsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowLabelsQuery, GetWorkflowLabelsQueryVariables> & ({ variables: GetWorkflowLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowLabelsQuery, GetWorkflowLabelsQueryVariables>(GetWorkflowLabelsDocument, options);
      }
export function useGetWorkflowLabelsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowLabelsQuery, GetWorkflowLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowLabelsQuery, GetWorkflowLabelsQueryVariables>(GetWorkflowLabelsDocument, options);
        }
export function useGetWorkflowLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowLabelsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowLabelsQuery, GetWorkflowLabelsQueryVariables>(GetWorkflowLabelsDocument, options);
        }
export type GetWorkflowLabelsQueryHookResult = ReturnType<typeof useGetWorkflowLabelsQuery>;
export type GetWorkflowLabelsLazyQueryHookResult = ReturnType<typeof useGetWorkflowLabelsLazyQuery>;
export type GetWorkflowLabelsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowLabelsSuspenseQuery>;
export type GetWorkflowLabelsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowLabelsQuery, GetWorkflowLabelsQueryVariables>;
export const GetDocumentLabelsDocument = gql`
    query GetDocumentLabels($documentId: UUID!) {
  document(documentId: $documentId) {
    id
    labels {
      ...LabelSimple
    }
  }
}
    ${LabelSimpleFragmentDoc}`;

/**
 * __useGetDocumentLabelsQuery__
 *
 * To run a query within a React component, call `useGetDocumentLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentLabelsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentLabelsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentLabelsQuery, GetDocumentLabelsQueryVariables> & ({ variables: GetDocumentLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentLabelsQuery, GetDocumentLabelsQueryVariables>(GetDocumentLabelsDocument, options);
      }
export function useGetDocumentLabelsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentLabelsQuery, GetDocumentLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentLabelsQuery, GetDocumentLabelsQueryVariables>(GetDocumentLabelsDocument, options);
        }
export function useGetDocumentLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentLabelsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentLabelsQuery, GetDocumentLabelsQueryVariables>(GetDocumentLabelsDocument, options);
        }
export type GetDocumentLabelsQueryHookResult = ReturnType<typeof useGetDocumentLabelsQuery>;
export type GetDocumentLabelsLazyQueryHookResult = ReturnType<typeof useGetDocumentLabelsLazyQuery>;
export type GetDocumentLabelsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentLabelsSuspenseQuery>;
export type GetDocumentLabelsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentLabelsQuery, GetDocumentLabelsQueryVariables>;
export const GetUserLabelsDocument = gql`
    query GetUserLabels {
  labels {
    ...LabelSimple
  }
}
    ${LabelSimpleFragmentDoc}`;

/**
 * __useGetUserLabelsQuery__
 *
 * To run a query within a React component, call `useGetUserLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLabelsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetUserLabelsQuery, GetUserLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserLabelsQuery, GetUserLabelsQueryVariables>(GetUserLabelsDocument, options);
      }
export function useGetUserLabelsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUserLabelsQuery, GetUserLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserLabelsQuery, GetUserLabelsQueryVariables>(GetUserLabelsDocument, options);
        }
export function useGetUserLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUserLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUserLabelsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUserLabelsQuery, GetUserLabelsQueryVariables>(GetUserLabelsDocument, options);
        }
export type GetUserLabelsQueryHookResult = ReturnType<typeof useGetUserLabelsQuery>;
export type GetUserLabelsLazyQueryHookResult = ReturnType<typeof useGetUserLabelsLazyQuery>;
export type GetUserLabelsSuspenseQueryHookResult = ReturnType<typeof useGetUserLabelsSuspenseQuery>;
export type GetUserLabelsQueryResult = ApolloReactHooks.useQuery.Result<GetUserLabelsQuery, GetUserLabelsQueryVariables>;
export const GetLabelByNameDocument = gql`
    query GetLabelByName($labelText: String!) {
  labelByName(labelText: $labelText) {
    ...LabelSimple
  }
}
    ${LabelSimpleFragmentDoc}`;

/**
 * __useGetLabelByNameQuery__
 *
 * To run a query within a React component, call `useGetLabelByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelByNameQuery({
 *   variables: {
 *      labelText: // value for 'labelText'
 *   },
 * });
 */
export function useGetLabelByNameQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetLabelByNameQuery, GetLabelByNameQueryVariables> & ({ variables: GetLabelByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLabelByNameQuery, GetLabelByNameQueryVariables>(GetLabelByNameDocument, options);
      }
export function useGetLabelByNameLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetLabelByNameQuery, GetLabelByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLabelByNameQuery, GetLabelByNameQueryVariables>(GetLabelByNameDocument, options);
        }
export function useGetLabelByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetLabelByNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetLabelByNameQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetLabelByNameQuery, GetLabelByNameQueryVariables>(GetLabelByNameDocument, options);
        }
export type GetLabelByNameQueryHookResult = ReturnType<typeof useGetLabelByNameQuery>;
export type GetLabelByNameLazyQueryHookResult = ReturnType<typeof useGetLabelByNameLazyQuery>;
export type GetLabelByNameSuspenseQueryHookResult = ReturnType<typeof useGetLabelByNameSuspenseQuery>;
export type GetLabelByNameQueryResult = ApolloReactHooks.useQuery.Result<GetLabelByNameQuery, GetLabelByNameQueryVariables>;
export const GetDocumentLabelStateDocument = gql`
    query GetDocumentLabelState($input: DocumentLabelStateInput!) {
  documentLabelStates(input: $input) {
    id
    labelText
    state
  }
}
    `;

/**
 * __useGetDocumentLabelStateQuery__
 *
 * To run a query within a React component, call `useGetDocumentLabelStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentLabelStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentLabelStateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDocumentLabelStateQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentLabelStateQuery, GetDocumentLabelStateQueryVariables> & ({ variables: GetDocumentLabelStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentLabelStateQuery, GetDocumentLabelStateQueryVariables>(GetDocumentLabelStateDocument, options);
      }
export function useGetDocumentLabelStateLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentLabelStateQuery, GetDocumentLabelStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentLabelStateQuery, GetDocumentLabelStateQueryVariables>(GetDocumentLabelStateDocument, options);
        }
export function useGetDocumentLabelStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentLabelStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentLabelStateQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentLabelStateQuery, GetDocumentLabelStateQueryVariables>(GetDocumentLabelStateDocument, options);
        }
export type GetDocumentLabelStateQueryHookResult = ReturnType<typeof useGetDocumentLabelStateQuery>;
export type GetDocumentLabelStateLazyQueryHookResult = ReturnType<typeof useGetDocumentLabelStateLazyQuery>;
export type GetDocumentLabelStateSuspenseQueryHookResult = ReturnType<typeof useGetDocumentLabelStateSuspenseQuery>;
export type GetDocumentLabelStateQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentLabelStateQuery, GetDocumentLabelStateQueryVariables>;
export const FindOrCreateLabelDocument = gql`
    mutation FindOrCreateLabel($labelText: String!) {
  findOrCreateLabel(labelText: $labelText) {
    ...LabelSimple
  }
}
    ${LabelSimpleFragmentDoc}`;
export type FindOrCreateLabelMutationFn = ApolloReactHooks.useMutation.MutationFunction<FindOrCreateLabelMutation, FindOrCreateLabelMutationVariables>;

/**
 * __useFindOrCreateLabelMutation__
 *
 * To run a mutation, you first call `useFindOrCreateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateLabelMutation, { data, loading, error }] = useFindOrCreateLabelMutation({
 *   variables: {
 *      labelText: // value for 'labelText'
 *   },
 * });
 */
export function useFindOrCreateLabelMutation(baseOptions?: ApolloReactHooks.useMutation.Options<FindOrCreateLabelMutation, FindOrCreateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FindOrCreateLabelMutation, FindOrCreateLabelMutationVariables>(FindOrCreateLabelDocument, options);
      }
export type FindOrCreateLabelMutationHookResult = ReturnType<typeof useFindOrCreateLabelMutation>;
export type FindOrCreateLabelMutationResult = ApolloReactHooks.useMutation.Result<FindOrCreateLabelMutation>;
export type FindOrCreateLabelMutationOptions = ApolloReactHooks.useMutation.Options<FindOrCreateLabelMutation, FindOrCreateLabelMutationVariables>;
export const SetWorkflowLabelsDocument = gql`
    mutation SetWorkflowLabels($workflowId: UUID!, $labelIds: [UUID!]!) {
  setWorkflowLabels(workflowId: $workflowId, labelIds: $labelIds) {
    workflow {
      __typename
      id
      labels {
        ...LabelSimple
      }
    }
  }
}
    ${LabelSimpleFragmentDoc}`;
export type SetWorkflowLabelsMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetWorkflowLabelsMutation, SetWorkflowLabelsMutationVariables>;

/**
 * __useSetWorkflowLabelsMutation__
 *
 * To run a mutation, you first call `useSetWorkflowLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkflowLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkflowLabelsMutation, { data, loading, error }] = useSetWorkflowLabelsMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useSetWorkflowLabelsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetWorkflowLabelsMutation, SetWorkflowLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkflowLabelsMutation, SetWorkflowLabelsMutationVariables>(SetWorkflowLabelsDocument, options);
      }
export type SetWorkflowLabelsMutationHookResult = ReturnType<typeof useSetWorkflowLabelsMutation>;
export type SetWorkflowLabelsMutationResult = ApolloReactHooks.useMutation.Result<SetWorkflowLabelsMutation>;
export type SetWorkflowLabelsMutationOptions = ApolloReactHooks.useMutation.Options<SetWorkflowLabelsMutation, SetWorkflowLabelsMutationVariables>;
export const SetDocumentLabelsDocument = gql`
    mutation SetDocumentLabels($documentId: UUID!, $labelIds: [UUID!]!) {
  setDocumentLabels(documentId: $documentId, labelIds: $labelIds) {
    __typename
    id
    labels {
      ...LabelSimple
    }
  }
}
    ${LabelSimpleFragmentDoc}`;
export type SetDocumentLabelsMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetDocumentLabelsMutation, SetDocumentLabelsMutationVariables>;

/**
 * __useSetDocumentLabelsMutation__
 *
 * To run a mutation, you first call `useSetDocumentLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentLabelsMutation, { data, loading, error }] = useSetDocumentLabelsMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useSetDocumentLabelsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetDocumentLabelsMutation, SetDocumentLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDocumentLabelsMutation, SetDocumentLabelsMutationVariables>(SetDocumentLabelsDocument, options);
      }
export type SetDocumentLabelsMutationHookResult = ReturnType<typeof useSetDocumentLabelsMutation>;
export type SetDocumentLabelsMutationResult = ApolloReactHooks.useMutation.Result<SetDocumentLabelsMutation>;
export type SetDocumentLabelsMutationOptions = ApolloReactHooks.useMutation.Options<SetDocumentLabelsMutation, SetDocumentLabelsMutationVariables>;
export const BulkSetDocumentLabelsDocument = gql`
    mutation BulkSetDocumentLabels($input: BulkSetDocumentLabelsInput!) {
  bulkSetDocumentLabels(input: $input) {
    documents {
      __typename
      id
      labels {
        ...LabelSimple
      }
    }
    numSuccess
    numSkipped
  }
}
    ${LabelSimpleFragmentDoc}`;
export type BulkSetDocumentLabelsMutationFn = ApolloReactHooks.useMutation.MutationFunction<BulkSetDocumentLabelsMutation, BulkSetDocumentLabelsMutationVariables>;

/**
 * __useBulkSetDocumentLabelsMutation__
 *
 * To run a mutation, you first call `useBulkSetDocumentLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSetDocumentLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSetDocumentLabelsMutation, { data, loading, error }] = useBulkSetDocumentLabelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkSetDocumentLabelsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<BulkSetDocumentLabelsMutation, BulkSetDocumentLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkSetDocumentLabelsMutation, BulkSetDocumentLabelsMutationVariables>(BulkSetDocumentLabelsDocument, options);
      }
export type BulkSetDocumentLabelsMutationHookResult = ReturnType<typeof useBulkSetDocumentLabelsMutation>;
export type BulkSetDocumentLabelsMutationResult = ApolloReactHooks.useMutation.Result<BulkSetDocumentLabelsMutation>;
export type BulkSetDocumentLabelsMutationOptions = ApolloReactHooks.useMutation.Options<BulkSetDocumentLabelsMutation, BulkSetDocumentLabelsMutationVariables>;
export const DeleteLabelDocument = gql`
    mutation DeleteLabel($id: UUID!) {
  deleteLabel(id: $id)
}
    `;
export type DeleteLabelMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteLabelMutation, DeleteLabelMutationVariables>;

/**
 * __useDeleteLabelMutation__
 *
 * To run a mutation, you first call `useDeleteLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLabelMutation, { data, loading, error }] = useDeleteLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLabelMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteLabelMutation, DeleteLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLabelMutation, DeleteLabelMutationVariables>(DeleteLabelDocument, options);
      }
export type DeleteLabelMutationHookResult = ReturnType<typeof useDeleteLabelMutation>;
export type DeleteLabelMutationResult = ApolloReactHooks.useMutation.Result<DeleteLabelMutation>;
export type DeleteLabelMutationOptions = ApolloReactHooks.useMutation.Options<DeleteLabelMutation, DeleteLabelMutationVariables>;
export const GetMyMentionsDocument = gql`
    query GetMyMentions {
  myMentions {
    __typename
    id
    notifiedAt
    notificationRead
    comment {
      __typename
      id
      text
    }
    mentionedUser {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetMyMentionsQuery__
 *
 * To run a query within a React component, call `useGetMyMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMentionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyMentionsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetMyMentionsQuery, GetMyMentionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyMentionsQuery, GetMyMentionsQueryVariables>(GetMyMentionsDocument, options);
      }
export function useGetMyMentionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyMentionsQuery, GetMyMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyMentionsQuery, GetMyMentionsQueryVariables>(GetMyMentionsDocument, options);
        }
export function useGetMyMentionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyMentionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyMentionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyMentionsQuery, GetMyMentionsQueryVariables>(GetMyMentionsDocument, options);
        }
export type GetMyMentionsQueryHookResult = ReturnType<typeof useGetMyMentionsQuery>;
export type GetMyMentionsLazyQueryHookResult = ReturnType<typeof useGetMyMentionsLazyQuery>;
export type GetMyMentionsSuspenseQueryHookResult = ReturnType<typeof useGetMyMentionsSuspenseQuery>;
export type GetMyMentionsQueryResult = ApolloReactHooks.useQuery.Result<GetMyMentionsQuery, GetMyMentionsQueryVariables>;
export const GetTaskSubscribersDocument = gql`
    query GetTaskSubscribers($taskId: UUID!) {
  task(taskId: $taskId) {
    __typename
    id
    viewerSubscribed
    viewerSubscriptionLocked
    subscribers {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetTaskSubscribersQuery__
 *
 * To run a query within a React component, call `useGetTaskSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskSubscribersQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskSubscribersQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskSubscribersQuery, GetTaskSubscribersQueryVariables> & ({ variables: GetTaskSubscribersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskSubscribersQuery, GetTaskSubscribersQueryVariables>(GetTaskSubscribersDocument, options);
      }
export function useGetTaskSubscribersLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskSubscribersQuery, GetTaskSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskSubscribersQuery, GetTaskSubscribersQueryVariables>(GetTaskSubscribersDocument, options);
        }
export function useGetTaskSubscribersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskSubscribersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskSubscribersQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskSubscribersQuery, GetTaskSubscribersQueryVariables>(GetTaskSubscribersDocument, options);
        }
export type GetTaskSubscribersQueryHookResult = ReturnType<typeof useGetTaskSubscribersQuery>;
export type GetTaskSubscribersLazyQueryHookResult = ReturnType<typeof useGetTaskSubscribersLazyQuery>;
export type GetTaskSubscribersSuspenseQueryHookResult = ReturnType<typeof useGetTaskSubscribersSuspenseQuery>;
export type GetTaskSubscribersQueryResult = ApolloReactHooks.useQuery.Result<GetTaskSubscribersQuery, GetTaskSubscribersQueryVariables>;
export const GetWorkflowSubscribersDocument = gql`
    query GetWorkflowSubscribers($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    viewerSubscribed
    viewerSubscriptionLocked
    subscribers {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetWorkflowSubscribersQuery__
 *
 * To run a query within a React component, call `useGetWorkflowSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowSubscribersQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowSubscribersQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowSubscribersQuery, GetWorkflowSubscribersQueryVariables> & ({ variables: GetWorkflowSubscribersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowSubscribersQuery, GetWorkflowSubscribersQueryVariables>(GetWorkflowSubscribersDocument, options);
      }
export function useGetWorkflowSubscribersLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowSubscribersQuery, GetWorkflowSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowSubscribersQuery, GetWorkflowSubscribersQueryVariables>(GetWorkflowSubscribersDocument, options);
        }
export function useGetWorkflowSubscribersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSubscribersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSubscribersQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowSubscribersQuery, GetWorkflowSubscribersQueryVariables>(GetWorkflowSubscribersDocument, options);
        }
export type GetWorkflowSubscribersQueryHookResult = ReturnType<typeof useGetWorkflowSubscribersQuery>;
export type GetWorkflowSubscribersLazyQueryHookResult = ReturnType<typeof useGetWorkflowSubscribersLazyQuery>;
export type GetWorkflowSubscribersSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSubscribersSuspenseQuery>;
export type GetWorkflowSubscribersQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowSubscribersQuery, GetWorkflowSubscribersQueryVariables>;
export const GetTaskSubscriberOptionsDocument = gql`
    query GetTaskSubscriberOptions($taskId: UUID!, $search: String) {
  task(taskId: $taskId) {
    __typename
    id
    subscriberOptions(search: $search) {
      ...ActivitySubscriberOptionFields
    }
  }
}
    ${ActivitySubscriberOptionFieldsFragmentDoc}`;

/**
 * __useGetTaskSubscriberOptionsQuery__
 *
 * To run a query within a React component, call `useGetTaskSubscriberOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskSubscriberOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskSubscriberOptionsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTaskSubscriberOptionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskSubscriberOptionsQuery, GetTaskSubscriberOptionsQueryVariables> & ({ variables: GetTaskSubscriberOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskSubscriberOptionsQuery, GetTaskSubscriberOptionsQueryVariables>(GetTaskSubscriberOptionsDocument, options);
      }
export function useGetTaskSubscriberOptionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskSubscriberOptionsQuery, GetTaskSubscriberOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskSubscriberOptionsQuery, GetTaskSubscriberOptionsQueryVariables>(GetTaskSubscriberOptionsDocument, options);
        }
export function useGetTaskSubscriberOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskSubscriberOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskSubscriberOptionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskSubscriberOptionsQuery, GetTaskSubscriberOptionsQueryVariables>(GetTaskSubscriberOptionsDocument, options);
        }
export type GetTaskSubscriberOptionsQueryHookResult = ReturnType<typeof useGetTaskSubscriberOptionsQuery>;
export type GetTaskSubscriberOptionsLazyQueryHookResult = ReturnType<typeof useGetTaskSubscriberOptionsLazyQuery>;
export type GetTaskSubscriberOptionsSuspenseQueryHookResult = ReturnType<typeof useGetTaskSubscriberOptionsSuspenseQuery>;
export type GetTaskSubscriberOptionsQueryResult = ApolloReactHooks.useQuery.Result<GetTaskSubscriberOptionsQuery, GetTaskSubscriberOptionsQueryVariables>;
export const GetWorkflowSubscriberOptionsDocument = gql`
    query GetWorkflowSubscriberOptions($workflowId: UUID!, $search: String) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    subscriberOptions(search: $search) {
      ...ActivitySubscriberOptionFields
    }
  }
}
    ${ActivitySubscriberOptionFieldsFragmentDoc}`;

/**
 * __useGetWorkflowSubscriberOptionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowSubscriberOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowSubscriberOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowSubscriberOptionsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkflowSubscriberOptionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowSubscriberOptionsQuery, GetWorkflowSubscriberOptionsQueryVariables> & ({ variables: GetWorkflowSubscriberOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowSubscriberOptionsQuery, GetWorkflowSubscriberOptionsQueryVariables>(GetWorkflowSubscriberOptionsDocument, options);
      }
export function useGetWorkflowSubscriberOptionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowSubscriberOptionsQuery, GetWorkflowSubscriberOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowSubscriberOptionsQuery, GetWorkflowSubscriberOptionsQueryVariables>(GetWorkflowSubscriberOptionsDocument, options);
        }
export function useGetWorkflowSubscriberOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSubscriberOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSubscriberOptionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowSubscriberOptionsQuery, GetWorkflowSubscriberOptionsQueryVariables>(GetWorkflowSubscriberOptionsDocument, options);
        }
export type GetWorkflowSubscriberOptionsQueryHookResult = ReturnType<typeof useGetWorkflowSubscriberOptionsQuery>;
export type GetWorkflowSubscriberOptionsLazyQueryHookResult = ReturnType<typeof useGetWorkflowSubscriberOptionsLazyQuery>;
export type GetWorkflowSubscriberOptionsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSubscriberOptionsSuspenseQuery>;
export type GetWorkflowSubscriberOptionsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowSubscriberOptionsQuery, GetWorkflowSubscriberOptionsQueryVariables>;
export const SubscribeToActivityDocument = gql`
    mutation SubscribeToActivity($input: ActivitySubscriptionInput!) {
  subscribeToActivity(input: $input) {
    ...ActivitySubscribersFields
  }
}
    ${ActivitySubscribersFieldsFragmentDoc}`;
export type SubscribeToActivityMutationFn = ApolloReactHooks.useMutation.MutationFunction<SubscribeToActivityMutation, SubscribeToActivityMutationVariables>;

/**
 * __useSubscribeToActivityMutation__
 *
 * To run a mutation, you first call `useSubscribeToActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToActivityMutation, { data, loading, error }] = useSubscribeToActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToActivityMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SubscribeToActivityMutation, SubscribeToActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubscribeToActivityMutation, SubscribeToActivityMutationVariables>(SubscribeToActivityDocument, options);
      }
export type SubscribeToActivityMutationHookResult = ReturnType<typeof useSubscribeToActivityMutation>;
export type SubscribeToActivityMutationResult = ApolloReactHooks.useMutation.Result<SubscribeToActivityMutation>;
export type SubscribeToActivityMutationOptions = ApolloReactHooks.useMutation.Options<SubscribeToActivityMutation, SubscribeToActivityMutationVariables>;
export const UnsubscribeFromActivityDocument = gql`
    mutation UnsubscribeFromActivity($input: ActivitySubscriptionInput!) {
  unsubscribeFromActivity(input: $input) {
    ...ActivitySubscribersFields
  }
}
    ${ActivitySubscribersFieldsFragmentDoc}`;
export type UnsubscribeFromActivityMutationFn = ApolloReactHooks.useMutation.MutationFunction<UnsubscribeFromActivityMutation, UnsubscribeFromActivityMutationVariables>;

/**
 * __useUnsubscribeFromActivityMutation__
 *
 * To run a mutation, you first call `useUnsubscribeFromActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromActivityMutation, { data, loading, error }] = useUnsubscribeFromActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsubscribeFromActivityMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UnsubscribeFromActivityMutation, UnsubscribeFromActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnsubscribeFromActivityMutation, UnsubscribeFromActivityMutationVariables>(UnsubscribeFromActivityDocument, options);
      }
export type UnsubscribeFromActivityMutationHookResult = ReturnType<typeof useUnsubscribeFromActivityMutation>;
export type UnsubscribeFromActivityMutationResult = ApolloReactHooks.useMutation.Result<UnsubscribeFromActivityMutation>;
export type UnsubscribeFromActivityMutationOptions = ApolloReactHooks.useMutation.Options<UnsubscribeFromActivityMutation, UnsubscribeFromActivityMutationVariables>;
export const GetPartiesDocument = gql`
    query GetParties {
  parties {
    ...PartySimple
    documentCount
  }
}
    ${PartySimpleFragmentDoc}`;

/**
 * __useGetPartiesQuery__
 *
 * To run a query within a React component, call `useGetPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartiesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetPartiesQuery, GetPartiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartiesQuery, GetPartiesQueryVariables>(GetPartiesDocument, options);
      }
export function useGetPartiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPartiesQuery, GetPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartiesQuery, GetPartiesQueryVariables>(GetPartiesDocument, options);
        }
export function useGetPartiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPartiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPartiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPartiesQuery, GetPartiesQueryVariables>(GetPartiesDocument, options);
        }
export type GetPartiesQueryHookResult = ReturnType<typeof useGetPartiesQuery>;
export type GetPartiesLazyQueryHookResult = ReturnType<typeof useGetPartiesLazyQuery>;
export type GetPartiesSuspenseQueryHookResult = ReturnType<typeof useGetPartiesSuspenseQuery>;
export type GetPartiesQueryResult = ApolloReactHooks.useQuery.Result<GetPartiesQuery, GetPartiesQueryVariables>;
export const GetPartyRowsDocument = gql`
    query GetPartyRows($sortModel: JSON, $filterModel: JSON, $cursor: UUID, $limit: Int) {
  partyRows(
    sortModel: $sortModel
    filterModel: $filterModel
    cursor: $cursor
    limit: $limit
  ) {
    rows {
      ...PartySimple
      documentCount
    }
    meta {
      __typename
      totalCount
      hasMore
    }
  }
}
    ${PartySimpleFragmentDoc}`;

/**
 * __useGetPartyRowsQuery__
 *
 * To run a query within a React component, call `useGetPartyRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartyRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartyRowsQuery({
 *   variables: {
 *      sortModel: // value for 'sortModel'
 *      filterModel: // value for 'filterModel'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPartyRowsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetPartyRowsQuery, GetPartyRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartyRowsQuery, GetPartyRowsQueryVariables>(GetPartyRowsDocument, options);
      }
export function useGetPartyRowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPartyRowsQuery, GetPartyRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartyRowsQuery, GetPartyRowsQueryVariables>(GetPartyRowsDocument, options);
        }
export function useGetPartyRowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPartyRowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPartyRowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPartyRowsQuery, GetPartyRowsQueryVariables>(GetPartyRowsDocument, options);
        }
export type GetPartyRowsQueryHookResult = ReturnType<typeof useGetPartyRowsQuery>;
export type GetPartyRowsLazyQueryHookResult = ReturnType<typeof useGetPartyRowsLazyQuery>;
export type GetPartyRowsSuspenseQueryHookResult = ReturnType<typeof useGetPartyRowsSuspenseQuery>;
export type GetPartyRowsQueryResult = ApolloReactHooks.useQuery.Result<GetPartyRowsQuery, GetPartyRowsQueryVariables>;
export const SearchPartiesDocument = gql`
    query SearchParties($query: String, $limit: Int, $offset: Int) {
  searchParties(query: $query, limit: $limit, offset: $offset) {
    __typename
    id
    name
  }
}
    `;

/**
 * __useSearchPartiesQuery__
 *
 * To run a query within a React component, call `useSearchPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPartiesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchPartiesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<SearchPartiesQuery, SearchPartiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchPartiesQuery, SearchPartiesQueryVariables>(SearchPartiesDocument, options);
      }
export function useSearchPartiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<SearchPartiesQuery, SearchPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchPartiesQuery, SearchPartiesQueryVariables>(SearchPartiesDocument, options);
        }
export function useSearchPartiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<SearchPartiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<SearchPartiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<SearchPartiesQuery, SearchPartiesQueryVariables>(SearchPartiesDocument, options);
        }
export type SearchPartiesQueryHookResult = ReturnType<typeof useSearchPartiesQuery>;
export type SearchPartiesLazyQueryHookResult = ReturnType<typeof useSearchPartiesLazyQuery>;
export type SearchPartiesSuspenseQueryHookResult = ReturnType<typeof useSearchPartiesSuspenseQuery>;
export type SearchPartiesQueryResult = ApolloReactHooks.useQuery.Result<SearchPartiesQuery, SearchPartiesQueryVariables>;
export const GetPartyDocument = gql`
    query GetParty($id: UUID!) {
  party(id: $id) {
    ...PartySimple
  }
}
    ${PartySimpleFragmentDoc}`;

/**
 * __useGetPartyQuery__
 *
 * To run a query within a React component, call `useGetPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartyQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPartyQuery, GetPartyQueryVariables> & ({ variables: GetPartyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartyQuery, GetPartyQueryVariables>(GetPartyDocument, options);
      }
export function useGetPartyLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPartyQuery, GetPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartyQuery, GetPartyQueryVariables>(GetPartyDocument, options);
        }
export function useGetPartySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPartyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPartyQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPartyQuery, GetPartyQueryVariables>(GetPartyDocument, options);
        }
export type GetPartyQueryHookResult = ReturnType<typeof useGetPartyQuery>;
export type GetPartyLazyQueryHookResult = ReturnType<typeof useGetPartyLazyQuery>;
export type GetPartySuspenseQueryHookResult = ReturnType<typeof useGetPartySuspenseQuery>;
export type GetPartyQueryResult = ApolloReactHooks.useQuery.Result<GetPartyQuery, GetPartyQueryVariables>;
export const GetPartyWithDocumentCountDocument = gql`
    query GetPartyWithDocumentCount($id: UUID!) {
  party(id: $id) {
    __typename
    id
    name
    description
    documentCount
  }
}
    `;

/**
 * __useGetPartyWithDocumentCountQuery__
 *
 * To run a query within a React component, call `useGetPartyWithDocumentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartyWithDocumentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartyWithDocumentCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartyWithDocumentCountQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPartyWithDocumentCountQuery, GetPartyWithDocumentCountQueryVariables> & ({ variables: GetPartyWithDocumentCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartyWithDocumentCountQuery, GetPartyWithDocumentCountQueryVariables>(GetPartyWithDocumentCountDocument, options);
      }
export function useGetPartyWithDocumentCountLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPartyWithDocumentCountQuery, GetPartyWithDocumentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartyWithDocumentCountQuery, GetPartyWithDocumentCountQueryVariables>(GetPartyWithDocumentCountDocument, options);
        }
export function useGetPartyWithDocumentCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPartyWithDocumentCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPartyWithDocumentCountQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPartyWithDocumentCountQuery, GetPartyWithDocumentCountQueryVariables>(GetPartyWithDocumentCountDocument, options);
        }
export type GetPartyWithDocumentCountQueryHookResult = ReturnType<typeof useGetPartyWithDocumentCountQuery>;
export type GetPartyWithDocumentCountLazyQueryHookResult = ReturnType<typeof useGetPartyWithDocumentCountLazyQuery>;
export type GetPartyWithDocumentCountSuspenseQueryHookResult = ReturnType<typeof useGetPartyWithDocumentCountSuspenseQuery>;
export type GetPartyWithDocumentCountQueryResult = ApolloReactHooks.useQuery.Result<GetPartyWithDocumentCountQuery, GetPartyWithDocumentCountQueryVariables>;
export const GetDocumentWithPartiesDocument = gql`
    query GetDocumentWithParties($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    parties {
      ...PartySimple
    }
  }
}
    ${PartySimpleFragmentDoc}`;

/**
 * __useGetDocumentWithPartiesQuery__
 *
 * To run a query within a React component, call `useGetDocumentWithPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentWithPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentWithPartiesQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentWithPartiesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentWithPartiesQuery, GetDocumentWithPartiesQueryVariables> & ({ variables: GetDocumentWithPartiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentWithPartiesQuery, GetDocumentWithPartiesQueryVariables>(GetDocumentWithPartiesDocument, options);
      }
export function useGetDocumentWithPartiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentWithPartiesQuery, GetDocumentWithPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentWithPartiesQuery, GetDocumentWithPartiesQueryVariables>(GetDocumentWithPartiesDocument, options);
        }
export function useGetDocumentWithPartiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithPartiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithPartiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentWithPartiesQuery, GetDocumentWithPartiesQueryVariables>(GetDocumentWithPartiesDocument, options);
        }
export type GetDocumentWithPartiesQueryHookResult = ReturnType<typeof useGetDocumentWithPartiesQuery>;
export type GetDocumentWithPartiesLazyQueryHookResult = ReturnType<typeof useGetDocumentWithPartiesLazyQuery>;
export type GetDocumentWithPartiesSuspenseQueryHookResult = ReturnType<typeof useGetDocumentWithPartiesSuspenseQuery>;
export type GetDocumentWithPartiesQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentWithPartiesQuery, GetDocumentWithPartiesQueryVariables>;
export const GetWorkflowWithPartiesDocument = gql`
    query GetWorkflowWithParties($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    status
    files {
      __typename
      id
      document {
        __typename
        id
        name
        variant
        parties {
          ...PartySimple
        }
        latestVersion {
          ... on FileVersionInterface {
            __typename
            id
          }
          ... on StaticFileVersion {
            fileLocation {
              __typename
              mimetype
            }
          }
        }
      }
    }
    parties {
      ...PartySimple
    }
  }
}
    ${PartySimpleFragmentDoc}`;

/**
 * __useGetWorkflowWithPartiesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowWithPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowWithPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowWithPartiesQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowWithPartiesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowWithPartiesQuery, GetWorkflowWithPartiesQueryVariables> & ({ variables: GetWorkflowWithPartiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowWithPartiesQuery, GetWorkflowWithPartiesQueryVariables>(GetWorkflowWithPartiesDocument, options);
      }
export function useGetWorkflowWithPartiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowWithPartiesQuery, GetWorkflowWithPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowWithPartiesQuery, GetWorkflowWithPartiesQueryVariables>(GetWorkflowWithPartiesDocument, options);
        }
export function useGetWorkflowWithPartiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithPartiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithPartiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowWithPartiesQuery, GetWorkflowWithPartiesQueryVariables>(GetWorkflowWithPartiesDocument, options);
        }
export type GetWorkflowWithPartiesQueryHookResult = ReturnType<typeof useGetWorkflowWithPartiesQuery>;
export type GetWorkflowWithPartiesLazyQueryHookResult = ReturnType<typeof useGetWorkflowWithPartiesLazyQuery>;
export type GetWorkflowWithPartiesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowWithPartiesSuspenseQuery>;
export type GetWorkflowWithPartiesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowWithPartiesQuery, GetWorkflowWithPartiesQueryVariables>;
export const GetPartyDocumentsDocument = gql`
    query GetPartyDocuments($id: UUID!) {
  party(id: $id) {
    ...PartySimple
    documents {
      __typename
      id
      name
      requesterFavorited
      requesterRole
      status
      variant
      isCommunityTemplate
      coreAiPropertiesExtractionStartedAt
      coreAiPropertiesExtractionFinishedAt
      coreAiPropertiesExtractionFailedAt
      labels {
        ...LabelSimple
      }
      latestVersion {
        ...FileVersionSimple
      }
      owner {
        ...UserBase
      }
      type {
        ...ContractTypeSimple
      }
      workflow {
        __typename
        id
        name
        variant
      }
    }
  }
}
    ${PartySimpleFragmentDoc}
${LabelSimpleFragmentDoc}
${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}
${ContractTypeSimpleFragmentDoc}`;

/**
 * __useGetPartyDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPartyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartyDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartyDocumentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPartyDocumentsQuery, GetPartyDocumentsQueryVariables> & ({ variables: GetPartyDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartyDocumentsQuery, GetPartyDocumentsQueryVariables>(GetPartyDocumentsDocument, options);
      }
export function useGetPartyDocumentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPartyDocumentsQuery, GetPartyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartyDocumentsQuery, GetPartyDocumentsQueryVariables>(GetPartyDocumentsDocument, options);
        }
export function useGetPartyDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPartyDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPartyDocumentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPartyDocumentsQuery, GetPartyDocumentsQueryVariables>(GetPartyDocumentsDocument, options);
        }
export type GetPartyDocumentsQueryHookResult = ReturnType<typeof useGetPartyDocumentsQuery>;
export type GetPartyDocumentsLazyQueryHookResult = ReturnType<typeof useGetPartyDocumentsLazyQuery>;
export type GetPartyDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetPartyDocumentsSuspenseQuery>;
export type GetPartyDocumentsQueryResult = ApolloReactHooks.useQuery.Result<GetPartyDocumentsQuery, GetPartyDocumentsQueryVariables>;
export const GetPartyWorkflowsDocument = gql`
    query GetPartyWorkflows($id: UUID!) {
  party(id: $id) {
    ...PartySimple
    workflows {
      __typename
      id
      fileCount
      name
      state
      variant
      owner {
        ...UserBase
      }
    }
  }
}
    ${PartySimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useGetPartyWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetPartyWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartyWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartyWorkflowsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartyWorkflowsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPartyWorkflowsQuery, GetPartyWorkflowsQueryVariables> & ({ variables: GetPartyWorkflowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartyWorkflowsQuery, GetPartyWorkflowsQueryVariables>(GetPartyWorkflowsDocument, options);
      }
export function useGetPartyWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPartyWorkflowsQuery, GetPartyWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartyWorkflowsQuery, GetPartyWorkflowsQueryVariables>(GetPartyWorkflowsDocument, options);
        }
export function useGetPartyWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPartyWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPartyWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPartyWorkflowsQuery, GetPartyWorkflowsQueryVariables>(GetPartyWorkflowsDocument, options);
        }
export type GetPartyWorkflowsQueryHookResult = ReturnType<typeof useGetPartyWorkflowsQuery>;
export type GetPartyWorkflowsLazyQueryHookResult = ReturnType<typeof useGetPartyWorkflowsLazyQuery>;
export type GetPartyWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetPartyWorkflowsSuspenseQuery>;
export type GetPartyWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<GetPartyWorkflowsQuery, GetPartyWorkflowsQueryVariables>;
export const CreatePartyDocument = gql`
    mutation CreateParty($input: CreatePartyInput!) {
  createParty(input: $input) {
    ...PartySimple
  }
}
    ${PartySimpleFragmentDoc}`;
export type CreatePartyMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreatePartyMutation, CreatePartyMutationVariables>;

/**
 * __useCreatePartyMutation__
 *
 * To run a mutation, you first call `useCreatePartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartyMutation, { data, loading, error }] = useCreatePartyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartyMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreatePartyMutation, CreatePartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePartyMutation, CreatePartyMutationVariables>(CreatePartyDocument, options);
      }
export type CreatePartyMutationHookResult = ReturnType<typeof useCreatePartyMutation>;
export type CreatePartyMutationResult = ApolloReactHooks.useMutation.Result<CreatePartyMutation>;
export type CreatePartyMutationOptions = ApolloReactHooks.useMutation.Options<CreatePartyMutation, CreatePartyMutationVariables>;
export const DeletePartyDocument = gql`
    mutation DeleteParty($partyId: UUID!) {
  deleteParty(partyId: $partyId)
}
    `;
export type DeletePartyMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeletePartyMutation, DeletePartyMutationVariables>;

/**
 * __useDeletePartyMutation__
 *
 * To run a mutation, you first call `useDeletePartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartyMutation, { data, loading, error }] = useDeletePartyMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *   },
 * });
 */
export function useDeletePartyMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeletePartyMutation, DeletePartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePartyMutation, DeletePartyMutationVariables>(DeletePartyDocument, options);
      }
export type DeletePartyMutationHookResult = ReturnType<typeof useDeletePartyMutation>;
export type DeletePartyMutationResult = ApolloReactHooks.useMutation.Result<DeletePartyMutation>;
export type DeletePartyMutationOptions = ApolloReactHooks.useMutation.Options<DeletePartyMutation, DeletePartyMutationVariables>;
export const UpdatePartyDocument = gql`
    mutation UpdateParty($input: UpdatePartyInput!) {
  updateParty(input: $input) {
    ...PartySimple
  }
}
    ${PartySimpleFragmentDoc}`;
export type UpdatePartyMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdatePartyMutation, UpdatePartyMutationVariables>;

/**
 * __useUpdatePartyMutation__
 *
 * To run a mutation, you first call `useUpdatePartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartyMutation, { data, loading, error }] = useUpdatePartyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartyMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdatePartyMutation, UpdatePartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePartyMutation, UpdatePartyMutationVariables>(UpdatePartyDocument, options);
      }
export type UpdatePartyMutationHookResult = ReturnType<typeof useUpdatePartyMutation>;
export type UpdatePartyMutationResult = ApolloReactHooks.useMutation.Result<UpdatePartyMutation>;
export type UpdatePartyMutationOptions = ApolloReactHooks.useMutation.Options<UpdatePartyMutation, UpdatePartyMutationVariables>;
export const AddPartyToDocumentDocument = gql`
    mutation AddPartyToDocument($input: AddPartyToDocumentInput!) {
  addPartyToDocument(input: $input) {
    ...PartySimple
  }
}
    ${PartySimpleFragmentDoc}`;
export type AddPartyToDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddPartyToDocumentMutation, AddPartyToDocumentMutationVariables>;

/**
 * __useAddPartyToDocumentMutation__
 *
 * To run a mutation, you first call `useAddPartyToDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartyToDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartyToDocumentMutation, { data, loading, error }] = useAddPartyToDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPartyToDocumentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddPartyToDocumentMutation, AddPartyToDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPartyToDocumentMutation, AddPartyToDocumentMutationVariables>(AddPartyToDocumentDocument, options);
      }
export type AddPartyToDocumentMutationHookResult = ReturnType<typeof useAddPartyToDocumentMutation>;
export type AddPartyToDocumentMutationResult = ApolloReactHooks.useMutation.Result<AddPartyToDocumentMutation>;
export type AddPartyToDocumentMutationOptions = ApolloReactHooks.useMutation.Options<AddPartyToDocumentMutation, AddPartyToDocumentMutationVariables>;
export const RemovePartyFromDocumentDocument = gql`
    mutation RemovePartyFromDocument($input: RemovePartyFromDocumentInput!) {
  removePartyFromDocument(input: $input) {
    ...PartySimple
  }
}
    ${PartySimpleFragmentDoc}`;
export type RemovePartyFromDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<RemovePartyFromDocumentMutation, RemovePartyFromDocumentMutationVariables>;

/**
 * __useRemovePartyFromDocumentMutation__
 *
 * To run a mutation, you first call `useRemovePartyFromDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePartyFromDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePartyFromDocumentMutation, { data, loading, error }] = useRemovePartyFromDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePartyFromDocumentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RemovePartyFromDocumentMutation, RemovePartyFromDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemovePartyFromDocumentMutation, RemovePartyFromDocumentMutationVariables>(RemovePartyFromDocumentDocument, options);
      }
export type RemovePartyFromDocumentMutationHookResult = ReturnType<typeof useRemovePartyFromDocumentMutation>;
export type RemovePartyFromDocumentMutationResult = ApolloReactHooks.useMutation.Result<RemovePartyFromDocumentMutation>;
export type RemovePartyFromDocumentMutationOptions = ApolloReactHooks.useMutation.Options<RemovePartyFromDocumentMutation, RemovePartyFromDocumentMutationVariables>;
export const SetWorkflowPartiesDocument = gql`
    mutation SetWorkflowParties($input: SetWorkflowPartiesInput!) {
  setWorkflowParties(input: $input) {
    __typename
    id
    files {
      __typename
      id
      document {
        __typename
        id
        parties {
          __typename
          id
          name
        }
      }
    }
    parties {
      __typename
      id
      name
    }
  }
}
    `;
export type SetWorkflowPartiesMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetWorkflowPartiesMutation, SetWorkflowPartiesMutationVariables>;

/**
 * __useSetWorkflowPartiesMutation__
 *
 * To run a mutation, you first call `useSetWorkflowPartiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkflowPartiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkflowPartiesMutation, { data, loading, error }] = useSetWorkflowPartiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkflowPartiesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetWorkflowPartiesMutation, SetWorkflowPartiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkflowPartiesMutation, SetWorkflowPartiesMutationVariables>(SetWorkflowPartiesDocument, options);
      }
export type SetWorkflowPartiesMutationHookResult = ReturnType<typeof useSetWorkflowPartiesMutation>;
export type SetWorkflowPartiesMutationResult = ApolloReactHooks.useMutation.Result<SetWorkflowPartiesMutation>;
export type SetWorkflowPartiesMutationOptions = ApolloReactHooks.useMutation.Options<SetWorkflowPartiesMutation, SetWorkflowPartiesMutationVariables>;
export const SetDocumentPartiesDocument = gql`
    mutation SetDocumentParties($input: SetDocumentPartiesInput!) {
  setDocumentParties(input: $input) {
    __typename
    id
    parties {
      __typename
      id
      name
    }
  }
}
    `;
export type SetDocumentPartiesMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetDocumentPartiesMutation, SetDocumentPartiesMutationVariables>;

/**
 * __useSetDocumentPartiesMutation__
 *
 * To run a mutation, you first call `useSetDocumentPartiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentPartiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentPartiesMutation, { data, loading, error }] = useSetDocumentPartiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDocumentPartiesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetDocumentPartiesMutation, SetDocumentPartiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDocumentPartiesMutation, SetDocumentPartiesMutationVariables>(SetDocumentPartiesDocument, options);
      }
export type SetDocumentPartiesMutationHookResult = ReturnType<typeof useSetDocumentPartiesMutation>;
export type SetDocumentPartiesMutationResult = ApolloReactHooks.useMutation.Result<SetDocumentPartiesMutation>;
export type SetDocumentPartiesMutationOptions = ApolloReactHooks.useMutation.Options<SetDocumentPartiesMutation, SetDocumentPartiesMutationVariables>;
export const BulkDeletePartiesDocument = gql`
    mutation BulkDeleteParties($input: BulkDeletePartiesInput!) {
  bulkDeleteParties(input: $input)
}
    `;
export type BulkDeletePartiesMutationFn = ApolloReactHooks.useMutation.MutationFunction<BulkDeletePartiesMutation, BulkDeletePartiesMutationVariables>;

/**
 * __useBulkDeletePartiesMutation__
 *
 * To run a mutation, you first call `useBulkDeletePartiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeletePartiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeletePartiesMutation, { data, loading, error }] = useBulkDeletePartiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkDeletePartiesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<BulkDeletePartiesMutation, BulkDeletePartiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkDeletePartiesMutation, BulkDeletePartiesMutationVariables>(BulkDeletePartiesDocument, options);
      }
export type BulkDeletePartiesMutationHookResult = ReturnType<typeof useBulkDeletePartiesMutation>;
export type BulkDeletePartiesMutationResult = ApolloReactHooks.useMutation.Result<BulkDeletePartiesMutation>;
export type BulkDeletePartiesMutationOptions = ApolloReactHooks.useMutation.Options<BulkDeletePartiesMutation, BulkDeletePartiesMutationVariables>;
export const MergePartiesDocument = gql`
    mutation MergeParties($input: MergePartiesInput!) {
  mergeParties(input: $input) {
    __typename
    id
    name
    documentCount
  }
}
    `;
export type MergePartiesMutationFn = ApolloReactHooks.useMutation.MutationFunction<MergePartiesMutation, MergePartiesMutationVariables>;

/**
 * __useMergePartiesMutation__
 *
 * To run a mutation, you first call `useMergePartiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergePartiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergePartiesMutation, { data, loading, error }] = useMergePartiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergePartiesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MergePartiesMutation, MergePartiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergePartiesMutation, MergePartiesMutationVariables>(MergePartiesDocument, options);
      }
export type MergePartiesMutationHookResult = ReturnType<typeof useMergePartiesMutation>;
export type MergePartiesMutationResult = ApolloReactHooks.useMutation.Result<MergePartiesMutation>;
export type MergePartiesMutationOptions = ApolloReactHooks.useMutation.Options<MergePartiesMutation, MergePartiesMutationVariables>;
export const GetPhaseDocument = gql`
    query GetPhase($phaseId: UUID!) {
  phase(phaseId: $phaseId) {
    ...PhaseSimple
  }
}
    ${PhaseSimpleFragmentDoc}`;

/**
 * __useGetPhaseQuery__
 *
 * To run a query within a React component, call `useGetPhaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhaseQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useGetPhaseQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPhaseQuery, GetPhaseQueryVariables> & ({ variables: GetPhaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPhaseQuery, GetPhaseQueryVariables>(GetPhaseDocument, options);
      }
export function useGetPhaseLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPhaseQuery, GetPhaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPhaseQuery, GetPhaseQueryVariables>(GetPhaseDocument, options);
        }
export function useGetPhaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPhaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPhaseQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPhaseQuery, GetPhaseQueryVariables>(GetPhaseDocument, options);
        }
export type GetPhaseQueryHookResult = ReturnType<typeof useGetPhaseQuery>;
export type GetPhaseLazyQueryHookResult = ReturnType<typeof useGetPhaseLazyQuery>;
export type GetPhaseSuspenseQueryHookResult = ReturnType<typeof useGetPhaseSuspenseQuery>;
export type GetPhaseQueryResult = ApolloReactHooks.useQuery.Result<GetPhaseQuery, GetPhaseQueryVariables>;
export const GetWorkflowPhasesDocument = gql`
    query GetWorkflowPhases($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    aiCancelledAt
    aiFailedAt
    aiFailureReason
    aiFinishedAt
    aiStartedAt
    state
    variant
    createdAt
    startedAt
    completedAt
    intakeFormTemplate {
      ...IntakeFormTemplateFull
    }
    intakeForm {
      ...IntakeFormFull
    }
    boardId
    column {
      id
      name
      category
    }
    phases {
      ...PhaseSimple
    }
  }
}
    ${IntakeFormTemplateFullFragmentDoc}
${IntakeFormFullFragmentDoc}
${PhaseSimpleFragmentDoc}`;

/**
 * __useGetWorkflowPhasesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowPhasesQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowPhasesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowPhasesQuery, GetWorkflowPhasesQueryVariables> & ({ variables: GetWorkflowPhasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowPhasesQuery, GetWorkflowPhasesQueryVariables>(GetWorkflowPhasesDocument, options);
      }
export function useGetWorkflowPhasesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowPhasesQuery, GetWorkflowPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowPhasesQuery, GetWorkflowPhasesQueryVariables>(GetWorkflowPhasesDocument, options);
        }
export function useGetWorkflowPhasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPhasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPhasesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowPhasesQuery, GetWorkflowPhasesQueryVariables>(GetWorkflowPhasesDocument, options);
        }
export type GetWorkflowPhasesQueryHookResult = ReturnType<typeof useGetWorkflowPhasesQuery>;
export type GetWorkflowPhasesLazyQueryHookResult = ReturnType<typeof useGetWorkflowPhasesLazyQuery>;
export type GetWorkflowPhasesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowPhasesSuspenseQuery>;
export type GetWorkflowPhasesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowPhasesQuery, GetWorkflowPhasesQueryVariables>;
export const OnWorkflowPhasesChangedDocument = gql`
    subscription OnWorkflowPhasesChanged($workflowId: UUID!) {
  workflowPhasesChanged(workflowId: $workflowId) {
    __typename
    ... on WorkflowPhasesChangedEvent {
      workflowId
    }
    ... on WorkflowPhaseCreatedEvent {
      phase {
        ...PhaseSimple
      }
    }
    ... on WorkflowPhaseUpdatedEvent {
      phases {
        ...PhaseSimple
      }
      workflow {
        id
        column {
          ...ColumnWithBoard
        }
      }
    }
    ... on WorkflowPhaseDeletedEvent {
      phaseId
    }
    ... on WorkflowPhasesReorderedEvent {
      phases {
        ...PhaseSimple
      }
    }
    ... on WorkflowIntakeFormAddedEvent {
      intakeFormTemplate {
        ...IntakeFormTemplateFull
      }
    }
    ... on WorkflowIntakeFormUpdatedEvent {
      intakeFormTemplate {
        ...IntakeFormTemplateFull
      }
    }
    ... on WorkflowIntakeFormRemovedEvent {
      intakeFormTemplateId
    }
  }
}
    ${PhaseSimpleFragmentDoc}
${ColumnWithBoardFragmentDoc}
${IntakeFormTemplateFullFragmentDoc}`;

/**
 * __useOnWorkflowPhasesChangedSubscription__
 *
 * To run a query within a React component, call `useOnWorkflowPhasesChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkflowPhasesChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkflowPhasesChangedSubscription({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useOnWorkflowPhasesChangedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnWorkflowPhasesChangedSubscription, OnWorkflowPhasesChangedSubscriptionVariables> & ({ variables: OnWorkflowPhasesChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnWorkflowPhasesChangedSubscription, OnWorkflowPhasesChangedSubscriptionVariables>(OnWorkflowPhasesChangedDocument, options);
      }
export type OnWorkflowPhasesChangedSubscriptionHookResult = ReturnType<typeof useOnWorkflowPhasesChangedSubscription>;
export type OnWorkflowPhasesChangedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnWorkflowPhasesChangedSubscription>;
export const CreatePhaseDocument = gql`
    mutation CreatePhase($input: CreatePhaseInput!) {
  createPhase(input: $input) {
    phase {
      ...PhaseSimple
      column {
        board {
          ...BoardWithColumns
        }
      }
    }
  }
}
    ${PhaseSimpleFragmentDoc}
${BoardWithColumnsFragmentDoc}`;
export type CreatePhaseMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreatePhaseMutation, CreatePhaseMutationVariables>;

/**
 * __useCreatePhaseMutation__
 *
 * To run a mutation, you first call `useCreatePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhaseMutation, { data, loading, error }] = useCreatePhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePhaseMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreatePhaseMutation, CreatePhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePhaseMutation, CreatePhaseMutationVariables>(CreatePhaseDocument, options);
      }
export type CreatePhaseMutationHookResult = ReturnType<typeof useCreatePhaseMutation>;
export type CreatePhaseMutationResult = ApolloReactHooks.useMutation.Result<CreatePhaseMutation>;
export type CreatePhaseMutationOptions = ApolloReactHooks.useMutation.Options<CreatePhaseMutation, CreatePhaseMutationVariables>;
export const UpdatePhaseDocument = gql`
    mutation UpdatePhase($input: UpdatePhaseInput!) {
  updatePhase(input: $input) {
    phase {
      ...PhaseSimple
    }
  }
}
    ${PhaseSimpleFragmentDoc}`;
export type UpdatePhaseMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdatePhaseMutation, UpdatePhaseMutationVariables>;

/**
 * __useUpdatePhaseMutation__
 *
 * To run a mutation, you first call `useUpdatePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhaseMutation, { data, loading, error }] = useUpdatePhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePhaseMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdatePhaseMutation, UpdatePhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePhaseMutation, UpdatePhaseMutationVariables>(UpdatePhaseDocument, options);
      }
export type UpdatePhaseMutationHookResult = ReturnType<typeof useUpdatePhaseMutation>;
export type UpdatePhaseMutationResult = ApolloReactHooks.useMutation.Result<UpdatePhaseMutation>;
export type UpdatePhaseMutationOptions = ApolloReactHooks.useMutation.Options<UpdatePhaseMutation, UpdatePhaseMutationVariables>;
export const DeletePhaseDocument = gql`
    mutation DeletePhase($phaseId: UUID!) {
  deletePhase(phaseId: $phaseId)
}
    `;
export type DeletePhaseMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeletePhaseMutation, DeletePhaseMutationVariables>;

/**
 * __useDeletePhaseMutation__
 *
 * To run a mutation, you first call `useDeletePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhaseMutation, { data, loading, error }] = useDeletePhaseMutation({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useDeletePhaseMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeletePhaseMutation, DeletePhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePhaseMutation, DeletePhaseMutationVariables>(DeletePhaseDocument, options);
      }
export type DeletePhaseMutationHookResult = ReturnType<typeof useDeletePhaseMutation>;
export type DeletePhaseMutationResult = ApolloReactHooks.useMutation.Result<DeletePhaseMutation>;
export type DeletePhaseMutationOptions = ApolloReactHooks.useMutation.Options<DeletePhaseMutation, DeletePhaseMutationVariables>;
export const ReorderPhasesDocument = gql`
    mutation ReorderPhases($input: ReorderPhasesInput!) {
  reorderPhases(input: $input) {
    ...PhaseSimple
  }
}
    ${PhaseSimpleFragmentDoc}`;
export type ReorderPhasesMutationFn = ApolloReactHooks.useMutation.MutationFunction<ReorderPhasesMutation, ReorderPhasesMutationVariables>;

/**
 * __useReorderPhasesMutation__
 *
 * To run a mutation, you first call `useReorderPhasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPhasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPhasesMutation, { data, loading, error }] = useReorderPhasesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderPhasesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ReorderPhasesMutation, ReorderPhasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderPhasesMutation, ReorderPhasesMutationVariables>(ReorderPhasesDocument, options);
      }
export type ReorderPhasesMutationHookResult = ReturnType<typeof useReorderPhasesMutation>;
export type ReorderPhasesMutationResult = ApolloReactHooks.useMutation.Result<ReorderPhasesMutation>;
export type ReorderPhasesMutationOptions = ApolloReactHooks.useMutation.Options<ReorderPhasesMutation, ReorderPhasesMutationVariables>;
export const GetPlaybookGenerationJobsDocument = gql`
    query GetPlaybookGenerationJobs {
  playbookGenerationJobs {
    __typename
    id
    startedAt
    finishedAt
    failedReason
    failedAt
  }
}
    `;

/**
 * __useGetPlaybookGenerationJobsQuery__
 *
 * To run a query within a React component, call `useGetPlaybookGenerationJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookGenerationJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookGenerationJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlaybookGenerationJobsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetPlaybookGenerationJobsQuery, GetPlaybookGenerationJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlaybookGenerationJobsQuery, GetPlaybookGenerationJobsQueryVariables>(GetPlaybookGenerationJobsDocument, options);
      }
export function useGetPlaybookGenerationJobsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPlaybookGenerationJobsQuery, GetPlaybookGenerationJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlaybookGenerationJobsQuery, GetPlaybookGenerationJobsQueryVariables>(GetPlaybookGenerationJobsDocument, options);
        }
export function useGetPlaybookGenerationJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookGenerationJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookGenerationJobsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPlaybookGenerationJobsQuery, GetPlaybookGenerationJobsQueryVariables>(GetPlaybookGenerationJobsDocument, options);
        }
export type GetPlaybookGenerationJobsQueryHookResult = ReturnType<typeof useGetPlaybookGenerationJobsQuery>;
export type GetPlaybookGenerationJobsLazyQueryHookResult = ReturnType<typeof useGetPlaybookGenerationJobsLazyQuery>;
export type GetPlaybookGenerationJobsSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookGenerationJobsSuspenseQuery>;
export type GetPlaybookGenerationJobsQueryResult = ApolloReactHooks.useQuery.Result<GetPlaybookGenerationJobsQuery, GetPlaybookGenerationJobsQueryVariables>;
export const GetPlaybookGenerationJobDocument = gql`
    query GetPlaybookGenerationJob($jobId: UUID!) {
  playbookGenerationJob(id: $jobId) {
    ...PlaybookGenerationProgress
    documents {
      __typename
      id
    }
  }
}
    ${PlaybookGenerationProgressFragmentDoc}`;

/**
 * __useGetPlaybookGenerationJobQuery__
 *
 * To run a query within a React component, call `useGetPlaybookGenerationJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookGenerationJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookGenerationJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetPlaybookGenerationJobQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPlaybookGenerationJobQuery, GetPlaybookGenerationJobQueryVariables> & ({ variables: GetPlaybookGenerationJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlaybookGenerationJobQuery, GetPlaybookGenerationJobQueryVariables>(GetPlaybookGenerationJobDocument, options);
      }
export function useGetPlaybookGenerationJobLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPlaybookGenerationJobQuery, GetPlaybookGenerationJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlaybookGenerationJobQuery, GetPlaybookGenerationJobQueryVariables>(GetPlaybookGenerationJobDocument, options);
        }
export function useGetPlaybookGenerationJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookGenerationJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookGenerationJobQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPlaybookGenerationJobQuery, GetPlaybookGenerationJobQueryVariables>(GetPlaybookGenerationJobDocument, options);
        }
export type GetPlaybookGenerationJobQueryHookResult = ReturnType<typeof useGetPlaybookGenerationJobQuery>;
export type GetPlaybookGenerationJobLazyQueryHookResult = ReturnType<typeof useGetPlaybookGenerationJobLazyQuery>;
export type GetPlaybookGenerationJobSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookGenerationJobSuspenseQuery>;
export type GetPlaybookGenerationJobQueryResult = ApolloReactHooks.useQuery.Result<GetPlaybookGenerationJobQuery, GetPlaybookGenerationJobQueryVariables>;
export const CancelPlaybookGenerationJobDocument = gql`
    mutation CancelPlaybookGenerationJob($jobId: UUID!) {
  cancelPlaybookGenerationJob(jobId: $jobId)
}
    `;
export type CancelPlaybookGenerationJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<CancelPlaybookGenerationJobMutation, CancelPlaybookGenerationJobMutationVariables>;

/**
 * __useCancelPlaybookGenerationJobMutation__
 *
 * To run a mutation, you first call `useCancelPlaybookGenerationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPlaybookGenerationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPlaybookGenerationJobMutation, { data, loading, error }] = useCancelPlaybookGenerationJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelPlaybookGenerationJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CancelPlaybookGenerationJobMutation, CancelPlaybookGenerationJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelPlaybookGenerationJobMutation, CancelPlaybookGenerationJobMutationVariables>(CancelPlaybookGenerationJobDocument, options);
      }
export type CancelPlaybookGenerationJobMutationHookResult = ReturnType<typeof useCancelPlaybookGenerationJobMutation>;
export type CancelPlaybookGenerationJobMutationResult = ApolloReactHooks.useMutation.Result<CancelPlaybookGenerationJobMutation>;
export type CancelPlaybookGenerationJobMutationOptions = ApolloReactHooks.useMutation.Options<CancelPlaybookGenerationJobMutation, CancelPlaybookGenerationJobMutationVariables>;
export const GetPlaybookRuleJobDocument = gql`
    query GetPlaybookRuleJob($ruleId: UUID!, $documentId: UUID!) {
  playbookRule(id: $ruleId) {
    __typename
    id
    ruleJob(documentId: $documentId) {
      ...PlaybookRuleJobWithProposals
    }
  }
}
    ${PlaybookRuleJobWithProposalsFragmentDoc}`;

/**
 * __useGetPlaybookRuleJobQuery__
 *
 * To run a query within a React component, call `useGetPlaybookRuleJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookRuleJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookRuleJobQuery({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetPlaybookRuleJobQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPlaybookRuleJobQuery, GetPlaybookRuleJobQueryVariables> & ({ variables: GetPlaybookRuleJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlaybookRuleJobQuery, GetPlaybookRuleJobQueryVariables>(GetPlaybookRuleJobDocument, options);
      }
export function useGetPlaybookRuleJobLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPlaybookRuleJobQuery, GetPlaybookRuleJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlaybookRuleJobQuery, GetPlaybookRuleJobQueryVariables>(GetPlaybookRuleJobDocument, options);
        }
export function useGetPlaybookRuleJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookRuleJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookRuleJobQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPlaybookRuleJobQuery, GetPlaybookRuleJobQueryVariables>(GetPlaybookRuleJobDocument, options);
        }
export type GetPlaybookRuleJobQueryHookResult = ReturnType<typeof useGetPlaybookRuleJobQuery>;
export type GetPlaybookRuleJobLazyQueryHookResult = ReturnType<typeof useGetPlaybookRuleJobLazyQuery>;
export type GetPlaybookRuleJobSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookRuleJobSuspenseQuery>;
export type GetPlaybookRuleJobQueryResult = ApolloReactHooks.useQuery.Result<GetPlaybookRuleJobQuery, GetPlaybookRuleJobQueryVariables>;
export const GetDocPlaybookDocument = gql`
    query GetDocPlaybook($playbookId: UUID!, $documentId: UUID!) {
  playbook(id: $playbookId) {
    __typename
    id
    title
    description
    categories {
      ...PlaybookRuleCategoryWithRuleJobs
    }
  }
}
    ${PlaybookRuleCategoryWithRuleJobsFragmentDoc}`;

/**
 * __useGetDocPlaybookQuery__
 *
 * To run a query within a React component, call `useGetDocPlaybookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocPlaybookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocPlaybookQuery({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocPlaybookQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocPlaybookQuery, GetDocPlaybookQueryVariables> & ({ variables: GetDocPlaybookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocPlaybookQuery, GetDocPlaybookQueryVariables>(GetDocPlaybookDocument, options);
      }
export function useGetDocPlaybookLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocPlaybookQuery, GetDocPlaybookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocPlaybookQuery, GetDocPlaybookQueryVariables>(GetDocPlaybookDocument, options);
        }
export function useGetDocPlaybookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocPlaybookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocPlaybookQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocPlaybookQuery, GetDocPlaybookQueryVariables>(GetDocPlaybookDocument, options);
        }
export type GetDocPlaybookQueryHookResult = ReturnType<typeof useGetDocPlaybookQuery>;
export type GetDocPlaybookLazyQueryHookResult = ReturnType<typeof useGetDocPlaybookLazyQuery>;
export type GetDocPlaybookSuspenseQueryHookResult = ReturnType<typeof useGetDocPlaybookSuspenseQuery>;
export type GetDocPlaybookQueryResult = ApolloReactHooks.useQuery.Result<GetDocPlaybookQuery, GetDocPlaybookQueryVariables>;
export const GetDocPlaybookSummaryDocument = gql`
    query GetDocPlaybookSummary($playbookId: UUID!, $documentId: UUID!) {
  playbook(id: $playbookId) {
    __typename
    id
    title
    description
    categories {
      ...PlaybookRuleCategorySimple
      rules {
        ...PlaybookRuleSimple
        ruleJob(documentId: $documentId) {
          ...PlaybookRuleJobSimple
        }
      }
    }
  }
}
    ${PlaybookRuleCategorySimpleFragmentDoc}
${PlaybookRuleSimpleFragmentDoc}
${PlaybookRuleJobSimpleFragmentDoc}`;

/**
 * __useGetDocPlaybookSummaryQuery__
 *
 * To run a query within a React component, call `useGetDocPlaybookSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocPlaybookSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocPlaybookSummaryQuery({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocPlaybookSummaryQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocPlaybookSummaryQuery, GetDocPlaybookSummaryQueryVariables> & ({ variables: GetDocPlaybookSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocPlaybookSummaryQuery, GetDocPlaybookSummaryQueryVariables>(GetDocPlaybookSummaryDocument, options);
      }
export function useGetDocPlaybookSummaryLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocPlaybookSummaryQuery, GetDocPlaybookSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocPlaybookSummaryQuery, GetDocPlaybookSummaryQueryVariables>(GetDocPlaybookSummaryDocument, options);
        }
export function useGetDocPlaybookSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocPlaybookSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocPlaybookSummaryQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocPlaybookSummaryQuery, GetDocPlaybookSummaryQueryVariables>(GetDocPlaybookSummaryDocument, options);
        }
export type GetDocPlaybookSummaryQueryHookResult = ReturnType<typeof useGetDocPlaybookSummaryQuery>;
export type GetDocPlaybookSummaryLazyQueryHookResult = ReturnType<typeof useGetDocPlaybookSummaryLazyQuery>;
export type GetDocPlaybookSummarySuspenseQueryHookResult = ReturnType<typeof useGetDocPlaybookSummarySuspenseQuery>;
export type GetDocPlaybookSummaryQueryResult = ApolloReactHooks.useQuery.Result<GetDocPlaybookSummaryQuery, GetDocPlaybookSummaryQueryVariables>;
export const StartPlaybookRunDocument = gql`
    mutation StartPlaybookRun($playbookId: UUID!, $documentId: UUID!) {
  startPlaybookRun(playbookId: $playbookId, documentId: $documentId) {
    __typename
    id
    categories {
      ...PlaybookRuleCategoryWithRuleJobs
    }
  }
}
    ${PlaybookRuleCategoryWithRuleJobsFragmentDoc}`;
export type StartPlaybookRunMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartPlaybookRunMutation, StartPlaybookRunMutationVariables>;

/**
 * __useStartPlaybookRunMutation__
 *
 * To run a mutation, you first call `useStartPlaybookRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPlaybookRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPlaybookRunMutation, { data, loading, error }] = useStartPlaybookRunMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useStartPlaybookRunMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartPlaybookRunMutation, StartPlaybookRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartPlaybookRunMutation, StartPlaybookRunMutationVariables>(StartPlaybookRunDocument, options);
      }
export type StartPlaybookRunMutationHookResult = ReturnType<typeof useStartPlaybookRunMutation>;
export type StartPlaybookRunMutationResult = ApolloReactHooks.useMutation.Result<StartPlaybookRunMutation>;
export type StartPlaybookRunMutationOptions = ApolloReactHooks.useMutation.Options<StartPlaybookRunMutation, StartPlaybookRunMutationVariables>;
export const StartPlaybookRuleJobsDocument = gql`
    mutation StartPlaybookRuleJobs($ruleIds: [UUID!]!, $documentId: UUID!) {
  startPlaybookRuleJobs(ruleIds: $ruleIds, documentId: $documentId) {
    ...PlaybookRuleWithJob
  }
}
    ${PlaybookRuleWithJobFragmentDoc}`;
export type StartPlaybookRuleJobsMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartPlaybookRuleJobsMutation, StartPlaybookRuleJobsMutationVariables>;

/**
 * __useStartPlaybookRuleJobsMutation__
 *
 * To run a mutation, you first call `useStartPlaybookRuleJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPlaybookRuleJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPlaybookRuleJobsMutation, { data, loading, error }] = useStartPlaybookRuleJobsMutation({
 *   variables: {
 *      ruleIds: // value for 'ruleIds'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useStartPlaybookRuleJobsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartPlaybookRuleJobsMutation, StartPlaybookRuleJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartPlaybookRuleJobsMutation, StartPlaybookRuleJobsMutationVariables>(StartPlaybookRuleJobsDocument, options);
      }
export type StartPlaybookRuleJobsMutationHookResult = ReturnType<typeof useStartPlaybookRuleJobsMutation>;
export type StartPlaybookRuleJobsMutationResult = ApolloReactHooks.useMutation.Result<StartPlaybookRuleJobsMutation>;
export type StartPlaybookRuleJobsMutationOptions = ApolloReactHooks.useMutation.Options<StartPlaybookRuleJobsMutation, StartPlaybookRuleJobsMutationVariables>;
export const CancelPlaybookRuleJobsDocument = gql`
    mutation CancelPlaybookRuleJobs($playbookId: UUID!, $documentId: UUID!) {
  cancelPlaybookRuleJobs(playbookId: $playbookId, documentId: $documentId) {
    __typename
    id
    categories {
      ...PlaybookRuleCategoryWithRuleJobs
    }
  }
}
    ${PlaybookRuleCategoryWithRuleJobsFragmentDoc}`;
export type CancelPlaybookRuleJobsMutationFn = ApolloReactHooks.useMutation.MutationFunction<CancelPlaybookRuleJobsMutation, CancelPlaybookRuleJobsMutationVariables>;

/**
 * __useCancelPlaybookRuleJobsMutation__
 *
 * To run a mutation, you first call `useCancelPlaybookRuleJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPlaybookRuleJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPlaybookRuleJobsMutation, { data, loading, error }] = useCancelPlaybookRuleJobsMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCancelPlaybookRuleJobsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CancelPlaybookRuleJobsMutation, CancelPlaybookRuleJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelPlaybookRuleJobsMutation, CancelPlaybookRuleJobsMutationVariables>(CancelPlaybookRuleJobsDocument, options);
      }
export type CancelPlaybookRuleJobsMutationHookResult = ReturnType<typeof useCancelPlaybookRuleJobsMutation>;
export type CancelPlaybookRuleJobsMutationResult = ApolloReactHooks.useMutation.Result<CancelPlaybookRuleJobsMutation>;
export type CancelPlaybookRuleJobsMutationOptions = ApolloReactHooks.useMutation.Options<CancelPlaybookRuleJobsMutation, CancelPlaybookRuleJobsMutationVariables>;
export const ResolvePlaybookRuleJobDocument = gql`
    mutation ResolvePlaybookRuleJob($input: ResolvePlaybookRuleJobInput!) {
  resolvePlaybookRuleJob(input: $input) {
    ...PlaybookRuleJobWithProposals
  }
}
    ${PlaybookRuleJobWithProposalsFragmentDoc}`;
export type ResolvePlaybookRuleJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<ResolvePlaybookRuleJobMutation, ResolvePlaybookRuleJobMutationVariables>;

/**
 * __useResolvePlaybookRuleJobMutation__
 *
 * To run a mutation, you first call `useResolvePlaybookRuleJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolvePlaybookRuleJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolvePlaybookRuleJobMutation, { data, loading, error }] = useResolvePlaybookRuleJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolvePlaybookRuleJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ResolvePlaybookRuleJobMutation, ResolvePlaybookRuleJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResolvePlaybookRuleJobMutation, ResolvePlaybookRuleJobMutationVariables>(ResolvePlaybookRuleJobDocument, options);
      }
export type ResolvePlaybookRuleJobMutationHookResult = ReturnType<typeof useResolvePlaybookRuleJobMutation>;
export type ResolvePlaybookRuleJobMutationResult = ApolloReactHooks.useMutation.Result<ResolvePlaybookRuleJobMutation>;
export type ResolvePlaybookRuleJobMutationOptions = ApolloReactHooks.useMutation.Options<ResolvePlaybookRuleJobMutation, ResolvePlaybookRuleJobMutationVariables>;
export const ClearPlaybookRuleJobResolutionDocument = gql`
    mutation ClearPlaybookRuleJobResolution($input: ClearPlaybookRuleJobResolutionInput!) {
  clearPlaybookRuleJobResolution(input: $input) {
    ...PlaybookRuleJobWithProposals
  }
}
    ${PlaybookRuleJobWithProposalsFragmentDoc}`;
export type ClearPlaybookRuleJobResolutionMutationFn = ApolloReactHooks.useMutation.MutationFunction<ClearPlaybookRuleJobResolutionMutation, ClearPlaybookRuleJobResolutionMutationVariables>;

/**
 * __useClearPlaybookRuleJobResolutionMutation__
 *
 * To run a mutation, you first call `useClearPlaybookRuleJobResolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearPlaybookRuleJobResolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearPlaybookRuleJobResolutionMutation, { data, loading, error }] = useClearPlaybookRuleJobResolutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearPlaybookRuleJobResolutionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ClearPlaybookRuleJobResolutionMutation, ClearPlaybookRuleJobResolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClearPlaybookRuleJobResolutionMutation, ClearPlaybookRuleJobResolutionMutationVariables>(ClearPlaybookRuleJobResolutionDocument, options);
      }
export type ClearPlaybookRuleJobResolutionMutationHookResult = ReturnType<typeof useClearPlaybookRuleJobResolutionMutation>;
export type ClearPlaybookRuleJobResolutionMutationResult = ApolloReactHooks.useMutation.Result<ClearPlaybookRuleJobResolutionMutation>;
export type ClearPlaybookRuleJobResolutionMutationOptions = ApolloReactHooks.useMutation.Options<ClearPlaybookRuleJobResolutionMutation, ClearPlaybookRuleJobResolutionMutationVariables>;
export const ReviewPlaybookSuggestionDocument = gql`
    mutation ReviewPlaybookSuggestion($input: ReviewPlaybookSuggestionInput!) {
  reviewPlaybookSuggestion(input: $input) {
    ...PlaybookRuleJobWithProposals
  }
}
    ${PlaybookRuleJobWithProposalsFragmentDoc}`;
export type ReviewPlaybookSuggestionMutationFn = ApolloReactHooks.useMutation.MutationFunction<ReviewPlaybookSuggestionMutation, ReviewPlaybookSuggestionMutationVariables>;

/**
 * __useReviewPlaybookSuggestionMutation__
 *
 * To run a mutation, you first call `useReviewPlaybookSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewPlaybookSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewPlaybookSuggestionMutation, { data, loading, error }] = useReviewPlaybookSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewPlaybookSuggestionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ReviewPlaybookSuggestionMutation, ReviewPlaybookSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReviewPlaybookSuggestionMutation, ReviewPlaybookSuggestionMutationVariables>(ReviewPlaybookSuggestionDocument, options);
      }
export type ReviewPlaybookSuggestionMutationHookResult = ReturnType<typeof useReviewPlaybookSuggestionMutation>;
export type ReviewPlaybookSuggestionMutationResult = ApolloReactHooks.useMutation.Result<ReviewPlaybookSuggestionMutation>;
export type ReviewPlaybookSuggestionMutationOptions = ApolloReactHooks.useMutation.Options<ReviewPlaybookSuggestionMutation, ReviewPlaybookSuggestionMutationVariables>;
export const CreatePlaybookRuleCategoryDocument = gql`
    mutation CreatePlaybookRuleCategory($input: CreatePlaybookRuleCategoryInput!) {
  createPlaybookRuleCategory(input: $input) {
    ...PlaybookRuleCategorySimple
  }
}
    ${PlaybookRuleCategorySimpleFragmentDoc}`;
export type CreatePlaybookRuleCategoryMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreatePlaybookRuleCategoryMutation, CreatePlaybookRuleCategoryMutationVariables>;

/**
 * __useCreatePlaybookRuleCategoryMutation__
 *
 * To run a mutation, you first call `useCreatePlaybookRuleCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaybookRuleCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaybookRuleCategoryMutation, { data, loading, error }] = useCreatePlaybookRuleCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaybookRuleCategoryMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreatePlaybookRuleCategoryMutation, CreatePlaybookRuleCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePlaybookRuleCategoryMutation, CreatePlaybookRuleCategoryMutationVariables>(CreatePlaybookRuleCategoryDocument, options);
      }
export type CreatePlaybookRuleCategoryMutationHookResult = ReturnType<typeof useCreatePlaybookRuleCategoryMutation>;
export type CreatePlaybookRuleCategoryMutationResult = ApolloReactHooks.useMutation.Result<CreatePlaybookRuleCategoryMutation>;
export type CreatePlaybookRuleCategoryMutationOptions = ApolloReactHooks.useMutation.Options<CreatePlaybookRuleCategoryMutation, CreatePlaybookRuleCategoryMutationVariables>;
export const UpdatePlaybookRuleCategoryDocument = gql`
    mutation UpdatePlaybookRuleCategory($input: UpdatePlaybookRuleCategoryInput!) {
  updatePlaybookRuleCategory(input: $input) {
    ...PlaybookRuleCategorySimple
  }
}
    ${PlaybookRuleCategorySimpleFragmentDoc}`;
export type UpdatePlaybookRuleCategoryMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdatePlaybookRuleCategoryMutation, UpdatePlaybookRuleCategoryMutationVariables>;

/**
 * __useUpdatePlaybookRuleCategoryMutation__
 *
 * To run a mutation, you first call `useUpdatePlaybookRuleCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaybookRuleCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaybookRuleCategoryMutation, { data, loading, error }] = useUpdatePlaybookRuleCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaybookRuleCategoryMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdatePlaybookRuleCategoryMutation, UpdatePlaybookRuleCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePlaybookRuleCategoryMutation, UpdatePlaybookRuleCategoryMutationVariables>(UpdatePlaybookRuleCategoryDocument, options);
      }
export type UpdatePlaybookRuleCategoryMutationHookResult = ReturnType<typeof useUpdatePlaybookRuleCategoryMutation>;
export type UpdatePlaybookRuleCategoryMutationResult = ApolloReactHooks.useMutation.Result<UpdatePlaybookRuleCategoryMutation>;
export type UpdatePlaybookRuleCategoryMutationOptions = ApolloReactHooks.useMutation.Options<UpdatePlaybookRuleCategoryMutation, UpdatePlaybookRuleCategoryMutationVariables>;
export const DeletePlaybookRuleCategoryDocument = gql`
    mutation DeletePlaybookRuleCategory($categoryId: UUID!) {
  deletePlaybookRuleCategory(categoryId: $categoryId) {
    ...PlaybookWithCategories
  }
}
    ${PlaybookWithCategoriesFragmentDoc}`;
export type DeletePlaybookRuleCategoryMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeletePlaybookRuleCategoryMutation, DeletePlaybookRuleCategoryMutationVariables>;

/**
 * __useDeletePlaybookRuleCategoryMutation__
 *
 * To run a mutation, you first call `useDeletePlaybookRuleCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaybookRuleCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaybookRuleCategoryMutation, { data, loading, error }] = useDeletePlaybookRuleCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeletePlaybookRuleCategoryMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeletePlaybookRuleCategoryMutation, DeletePlaybookRuleCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePlaybookRuleCategoryMutation, DeletePlaybookRuleCategoryMutationVariables>(DeletePlaybookRuleCategoryDocument, options);
      }
export type DeletePlaybookRuleCategoryMutationHookResult = ReturnType<typeof useDeletePlaybookRuleCategoryMutation>;
export type DeletePlaybookRuleCategoryMutationResult = ApolloReactHooks.useMutation.Result<DeletePlaybookRuleCategoryMutation>;
export type DeletePlaybookRuleCategoryMutationOptions = ApolloReactHooks.useMutation.Options<DeletePlaybookRuleCategoryMutation, DeletePlaybookRuleCategoryMutationVariables>;
export const ReorderPlaybookRuleCategoriesDocument = gql`
    mutation ReorderPlaybookRuleCategories($input: ReorderPlaybookRuleCategoriesInput!) {
  reorderPlaybookRuleCategories(input: $input) {
    ...PlaybookRuleCategorySimple
  }
}
    ${PlaybookRuleCategorySimpleFragmentDoc}`;
export type ReorderPlaybookRuleCategoriesMutationFn = ApolloReactHooks.useMutation.MutationFunction<ReorderPlaybookRuleCategoriesMutation, ReorderPlaybookRuleCategoriesMutationVariables>;

/**
 * __useReorderPlaybookRuleCategoriesMutation__
 *
 * To run a mutation, you first call `useReorderPlaybookRuleCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPlaybookRuleCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPlaybookRuleCategoriesMutation, { data, loading, error }] = useReorderPlaybookRuleCategoriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderPlaybookRuleCategoriesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ReorderPlaybookRuleCategoriesMutation, ReorderPlaybookRuleCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderPlaybookRuleCategoriesMutation, ReorderPlaybookRuleCategoriesMutationVariables>(ReorderPlaybookRuleCategoriesDocument, options);
      }
export type ReorderPlaybookRuleCategoriesMutationHookResult = ReturnType<typeof useReorderPlaybookRuleCategoriesMutation>;
export type ReorderPlaybookRuleCategoriesMutationResult = ApolloReactHooks.useMutation.Result<ReorderPlaybookRuleCategoriesMutation>;
export type ReorderPlaybookRuleCategoriesMutationOptions = ApolloReactHooks.useMutation.Options<ReorderPlaybookRuleCategoriesMutation, ReorderPlaybookRuleCategoriesMutationVariables>;
export const MovePlaybookRuleCategoryDocument = gql`
    mutation MovePlaybookRuleCategory($input: MovePlaybookRuleCategoryInput!) {
  movePlaybookRuleCategory(input: $input) {
    ...PlaybookRuleCategorySimple
  }
}
    ${PlaybookRuleCategorySimpleFragmentDoc}`;
export type MovePlaybookRuleCategoryMutationFn = ApolloReactHooks.useMutation.MutationFunction<MovePlaybookRuleCategoryMutation, MovePlaybookRuleCategoryMutationVariables>;

/**
 * __useMovePlaybookRuleCategoryMutation__
 *
 * To run a mutation, you first call `useMovePlaybookRuleCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePlaybookRuleCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePlaybookRuleCategoryMutation, { data, loading, error }] = useMovePlaybookRuleCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMovePlaybookRuleCategoryMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MovePlaybookRuleCategoryMutation, MovePlaybookRuleCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MovePlaybookRuleCategoryMutation, MovePlaybookRuleCategoryMutationVariables>(MovePlaybookRuleCategoryDocument, options);
      }
export type MovePlaybookRuleCategoryMutationHookResult = ReturnType<typeof useMovePlaybookRuleCategoryMutation>;
export type MovePlaybookRuleCategoryMutationResult = ApolloReactHooks.useMutation.Result<MovePlaybookRuleCategoryMutation>;
export type MovePlaybookRuleCategoryMutationOptions = ApolloReactHooks.useMutation.Options<MovePlaybookRuleCategoryMutation, MovePlaybookRuleCategoryMutationVariables>;
export const GetPlaybookRuleDocument = gql`
    query GetPlaybookRule($id: UUID!) {
  playbookRule(id: $id) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;

/**
 * __useGetPlaybookRuleQuery__
 *
 * To run a query within a React component, call `useGetPlaybookRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlaybookRuleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPlaybookRuleQuery, GetPlaybookRuleQueryVariables> & ({ variables: GetPlaybookRuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlaybookRuleQuery, GetPlaybookRuleQueryVariables>(GetPlaybookRuleDocument, options);
      }
export function useGetPlaybookRuleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPlaybookRuleQuery, GetPlaybookRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlaybookRuleQuery, GetPlaybookRuleQueryVariables>(GetPlaybookRuleDocument, options);
        }
export function useGetPlaybookRuleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookRuleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookRuleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPlaybookRuleQuery, GetPlaybookRuleQueryVariables>(GetPlaybookRuleDocument, options);
        }
export type GetPlaybookRuleQueryHookResult = ReturnType<typeof useGetPlaybookRuleQuery>;
export type GetPlaybookRuleLazyQueryHookResult = ReturnType<typeof useGetPlaybookRuleLazyQuery>;
export type GetPlaybookRuleSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookRuleSuspenseQuery>;
export type GetPlaybookRuleQueryResult = ApolloReactHooks.useQuery.Result<GetPlaybookRuleQuery, GetPlaybookRuleQueryVariables>;
export const GetPlaybookRulesForCategoryDocument = gql`
    query GetPlaybookRulesForCategory($categoryId: UUID!) {
  playbookRulesForCategory(categoryId: $categoryId) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;

/**
 * __useGetPlaybookRulesForCategoryQuery__
 *
 * To run a query within a React component, call `useGetPlaybookRulesForCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookRulesForCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookRulesForCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetPlaybookRulesForCategoryQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPlaybookRulesForCategoryQuery, GetPlaybookRulesForCategoryQueryVariables> & ({ variables: GetPlaybookRulesForCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlaybookRulesForCategoryQuery, GetPlaybookRulesForCategoryQueryVariables>(GetPlaybookRulesForCategoryDocument, options);
      }
export function useGetPlaybookRulesForCategoryLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPlaybookRulesForCategoryQuery, GetPlaybookRulesForCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlaybookRulesForCategoryQuery, GetPlaybookRulesForCategoryQueryVariables>(GetPlaybookRulesForCategoryDocument, options);
        }
export function useGetPlaybookRulesForCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookRulesForCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookRulesForCategoryQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPlaybookRulesForCategoryQuery, GetPlaybookRulesForCategoryQueryVariables>(GetPlaybookRulesForCategoryDocument, options);
        }
export type GetPlaybookRulesForCategoryQueryHookResult = ReturnType<typeof useGetPlaybookRulesForCategoryQuery>;
export type GetPlaybookRulesForCategoryLazyQueryHookResult = ReturnType<typeof useGetPlaybookRulesForCategoryLazyQuery>;
export type GetPlaybookRulesForCategorySuspenseQueryHookResult = ReturnType<typeof useGetPlaybookRulesForCategorySuspenseQuery>;
export type GetPlaybookRulesForCategoryQueryResult = ApolloReactHooks.useQuery.Result<GetPlaybookRulesForCategoryQuery, GetPlaybookRulesForCategoryQueryVariables>;
export const CreatePlaybookRuleDocument = gql`
    mutation CreatePlaybookRule($input: CreatePlaybookRuleInput!) {
  createPlaybookRule(input: $input) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;
export type CreatePlaybookRuleMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreatePlaybookRuleMutation, CreatePlaybookRuleMutationVariables>;

/**
 * __useCreatePlaybookRuleMutation__
 *
 * To run a mutation, you first call `useCreatePlaybookRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaybookRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaybookRuleMutation, { data, loading, error }] = useCreatePlaybookRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaybookRuleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreatePlaybookRuleMutation, CreatePlaybookRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePlaybookRuleMutation, CreatePlaybookRuleMutationVariables>(CreatePlaybookRuleDocument, options);
      }
export type CreatePlaybookRuleMutationHookResult = ReturnType<typeof useCreatePlaybookRuleMutation>;
export type CreatePlaybookRuleMutationResult = ApolloReactHooks.useMutation.Result<CreatePlaybookRuleMutation>;
export type CreatePlaybookRuleMutationOptions = ApolloReactHooks.useMutation.Options<CreatePlaybookRuleMutation, CreatePlaybookRuleMutationVariables>;
export const UpdatePlaybookRuleDocument = gql`
    mutation UpdatePlaybookRule($input: UpdatePlaybookRuleInput!) {
  updatePlaybookRule(input: $input) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;
export type UpdatePlaybookRuleMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdatePlaybookRuleMutation, UpdatePlaybookRuleMutationVariables>;

/**
 * __useUpdatePlaybookRuleMutation__
 *
 * To run a mutation, you first call `useUpdatePlaybookRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaybookRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaybookRuleMutation, { data, loading, error }] = useUpdatePlaybookRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaybookRuleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdatePlaybookRuleMutation, UpdatePlaybookRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePlaybookRuleMutation, UpdatePlaybookRuleMutationVariables>(UpdatePlaybookRuleDocument, options);
      }
export type UpdatePlaybookRuleMutationHookResult = ReturnType<typeof useUpdatePlaybookRuleMutation>;
export type UpdatePlaybookRuleMutationResult = ApolloReactHooks.useMutation.Result<UpdatePlaybookRuleMutation>;
export type UpdatePlaybookRuleMutationOptions = ApolloReactHooks.useMutation.Options<UpdatePlaybookRuleMutation, UpdatePlaybookRuleMutationVariables>;
export const MovePlaybookRuleDocument = gql`
    mutation MovePlaybookRule($input: MovePlaybookRuleInput!) {
  movePlaybookRule(input: $input) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;
export type MovePlaybookRuleMutationFn = ApolloReactHooks.useMutation.MutationFunction<MovePlaybookRuleMutation, MovePlaybookRuleMutationVariables>;

/**
 * __useMovePlaybookRuleMutation__
 *
 * To run a mutation, you first call `useMovePlaybookRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePlaybookRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePlaybookRuleMutation, { data, loading, error }] = useMovePlaybookRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMovePlaybookRuleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MovePlaybookRuleMutation, MovePlaybookRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MovePlaybookRuleMutation, MovePlaybookRuleMutationVariables>(MovePlaybookRuleDocument, options);
      }
export type MovePlaybookRuleMutationHookResult = ReturnType<typeof useMovePlaybookRuleMutation>;
export type MovePlaybookRuleMutationResult = ApolloReactHooks.useMutation.Result<MovePlaybookRuleMutation>;
export type MovePlaybookRuleMutationOptions = ApolloReactHooks.useMutation.Options<MovePlaybookRuleMutation, MovePlaybookRuleMutationVariables>;
export const DeletePlaybookRuleDocument = gql`
    mutation DeletePlaybookRule($ruleId: UUID!) {
  deletePlaybookRule(ruleId: $ruleId)
}
    `;
export type DeletePlaybookRuleMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeletePlaybookRuleMutation, DeletePlaybookRuleMutationVariables>;

/**
 * __useDeletePlaybookRuleMutation__
 *
 * To run a mutation, you first call `useDeletePlaybookRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaybookRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaybookRuleMutation, { data, loading, error }] = useDeletePlaybookRuleMutation({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useDeletePlaybookRuleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeletePlaybookRuleMutation, DeletePlaybookRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePlaybookRuleMutation, DeletePlaybookRuleMutationVariables>(DeletePlaybookRuleDocument, options);
      }
export type DeletePlaybookRuleMutationHookResult = ReturnType<typeof useDeletePlaybookRuleMutation>;
export type DeletePlaybookRuleMutationResult = ApolloReactHooks.useMutation.Result<DeletePlaybookRuleMutation>;
export type DeletePlaybookRuleMutationOptions = ApolloReactHooks.useMutation.Options<DeletePlaybookRuleMutation, DeletePlaybookRuleMutationVariables>;
export const AddPlaybookRulePositionDocument = gql`
    mutation AddPlaybookRulePosition($input: AddPlaybookRulePositionInput!) {
  addPlaybookRulePosition(input: $input) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;
export type AddPlaybookRulePositionMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddPlaybookRulePositionMutation, AddPlaybookRulePositionMutationVariables>;

/**
 * __useAddPlaybookRulePositionMutation__
 *
 * To run a mutation, you first call `useAddPlaybookRulePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlaybookRulePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlaybookRulePositionMutation, { data, loading, error }] = useAddPlaybookRulePositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlaybookRulePositionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddPlaybookRulePositionMutation, AddPlaybookRulePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPlaybookRulePositionMutation, AddPlaybookRulePositionMutationVariables>(AddPlaybookRulePositionDocument, options);
      }
export type AddPlaybookRulePositionMutationHookResult = ReturnType<typeof useAddPlaybookRulePositionMutation>;
export type AddPlaybookRulePositionMutationResult = ApolloReactHooks.useMutation.Result<AddPlaybookRulePositionMutation>;
export type AddPlaybookRulePositionMutationOptions = ApolloReactHooks.useMutation.Options<AddPlaybookRulePositionMutation, AddPlaybookRulePositionMutationVariables>;
export const UpdatePlaybookRulePositionDocument = gql`
    mutation UpdatePlaybookRulePosition($input: UpdatePlaybookRulePositionInput!) {
  updatePlaybookRulePosition(input: $input) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;
export type UpdatePlaybookRulePositionMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdatePlaybookRulePositionMutation, UpdatePlaybookRulePositionMutationVariables>;

/**
 * __useUpdatePlaybookRulePositionMutation__
 *
 * To run a mutation, you first call `useUpdatePlaybookRulePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaybookRulePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaybookRulePositionMutation, { data, loading, error }] = useUpdatePlaybookRulePositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaybookRulePositionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdatePlaybookRulePositionMutation, UpdatePlaybookRulePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePlaybookRulePositionMutation, UpdatePlaybookRulePositionMutationVariables>(UpdatePlaybookRulePositionDocument, options);
      }
export type UpdatePlaybookRulePositionMutationHookResult = ReturnType<typeof useUpdatePlaybookRulePositionMutation>;
export type UpdatePlaybookRulePositionMutationResult = ApolloReactHooks.useMutation.Result<UpdatePlaybookRulePositionMutation>;
export type UpdatePlaybookRulePositionMutationOptions = ApolloReactHooks.useMutation.Options<UpdatePlaybookRulePositionMutation, UpdatePlaybookRulePositionMutationVariables>;
export const DeletePlaybookRulePositionDocument = gql`
    mutation DeletePlaybookRulePosition($input: DeletePlaybookRulePositionInput!) {
  deletePlaybookRulePosition(input: $input) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;
export type DeletePlaybookRulePositionMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeletePlaybookRulePositionMutation, DeletePlaybookRulePositionMutationVariables>;

/**
 * __useDeletePlaybookRulePositionMutation__
 *
 * To run a mutation, you first call `useDeletePlaybookRulePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaybookRulePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaybookRulePositionMutation, { data, loading, error }] = useDeletePlaybookRulePositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlaybookRulePositionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeletePlaybookRulePositionMutation, DeletePlaybookRulePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePlaybookRulePositionMutation, DeletePlaybookRulePositionMutationVariables>(DeletePlaybookRulePositionDocument, options);
      }
export type DeletePlaybookRulePositionMutationHookResult = ReturnType<typeof useDeletePlaybookRulePositionMutation>;
export type DeletePlaybookRulePositionMutationResult = ApolloReactHooks.useMutation.Result<DeletePlaybookRulePositionMutation>;
export type DeletePlaybookRulePositionMutationOptions = ApolloReactHooks.useMutation.Options<DeletePlaybookRulePositionMutation, DeletePlaybookRulePositionMutationVariables>;
export const ReorderPlaybookRulePositionsDocument = gql`
    mutation ReorderPlaybookRulePositions($input: ReorderPlaybookRulePositionsInput!) {
  reorderPlaybookRulePositions(input: $input) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;
export type ReorderPlaybookRulePositionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<ReorderPlaybookRulePositionsMutation, ReorderPlaybookRulePositionsMutationVariables>;

/**
 * __useReorderPlaybookRulePositionsMutation__
 *
 * To run a mutation, you first call `useReorderPlaybookRulePositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPlaybookRulePositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPlaybookRulePositionsMutation, { data, loading, error }] = useReorderPlaybookRulePositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderPlaybookRulePositionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ReorderPlaybookRulePositionsMutation, ReorderPlaybookRulePositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderPlaybookRulePositionsMutation, ReorderPlaybookRulePositionsMutationVariables>(ReorderPlaybookRulePositionsDocument, options);
      }
export type ReorderPlaybookRulePositionsMutationHookResult = ReturnType<typeof useReorderPlaybookRulePositionsMutation>;
export type ReorderPlaybookRulePositionsMutationResult = ApolloReactHooks.useMutation.Result<ReorderPlaybookRulePositionsMutation>;
export type ReorderPlaybookRulePositionsMutationOptions = ApolloReactHooks.useMutation.Options<ReorderPlaybookRulePositionsMutation, ReorderPlaybookRulePositionsMutationVariables>;
export const MovePlaybookRulePositionsDocument = gql`
    mutation MovePlaybookRulePositions($input: MovePlaybookRulePositionsInput!) {
  movePlaybookRulePositions(input: $input) {
    ...PlaybookRuleSimple
  }
}
    ${PlaybookRuleSimpleFragmentDoc}`;
export type MovePlaybookRulePositionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<MovePlaybookRulePositionsMutation, MovePlaybookRulePositionsMutationVariables>;

/**
 * __useMovePlaybookRulePositionsMutation__
 *
 * To run a mutation, you first call `useMovePlaybookRulePositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePlaybookRulePositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePlaybookRulePositionsMutation, { data, loading, error }] = useMovePlaybookRulePositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMovePlaybookRulePositionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MovePlaybookRulePositionsMutation, MovePlaybookRulePositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MovePlaybookRulePositionsMutation, MovePlaybookRulePositionsMutationVariables>(MovePlaybookRulePositionsDocument, options);
      }
export type MovePlaybookRulePositionsMutationHookResult = ReturnType<typeof useMovePlaybookRulePositionsMutation>;
export type MovePlaybookRulePositionsMutationResult = ApolloReactHooks.useMutation.Result<MovePlaybookRulePositionsMutation>;
export type MovePlaybookRulePositionsMutationOptions = ApolloReactHooks.useMutation.Options<MovePlaybookRulePositionsMutation, MovePlaybookRulePositionsMutationVariables>;
export const GetPlaybookDetailDocument = gql`
    query GetPlaybookDetail($id: UUID!) {
  playbook(id: $id) {
    __typename
    id
    title
    description
    categories {
      ...PlaybookRuleCategoryWithRules
    }
    generationJob {
      ...PlaybookGenerationProgress
    }
    createdAt
    createdBy {
      __typename
      id
    }
    updatedAt
  }
}
    ${PlaybookRuleCategoryWithRulesFragmentDoc}
${PlaybookGenerationProgressFragmentDoc}`;

/**
 * __useGetPlaybookDetailQuery__
 *
 * To run a query within a React component, call `useGetPlaybookDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlaybookDetailQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPlaybookDetailQuery, GetPlaybookDetailQueryVariables> & ({ variables: GetPlaybookDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlaybookDetailQuery, GetPlaybookDetailQueryVariables>(GetPlaybookDetailDocument, options);
      }
export function useGetPlaybookDetailLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPlaybookDetailQuery, GetPlaybookDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlaybookDetailQuery, GetPlaybookDetailQueryVariables>(GetPlaybookDetailDocument, options);
        }
export function useGetPlaybookDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPlaybookDetailQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPlaybookDetailQuery, GetPlaybookDetailQueryVariables>(GetPlaybookDetailDocument, options);
        }
export type GetPlaybookDetailQueryHookResult = ReturnType<typeof useGetPlaybookDetailQuery>;
export type GetPlaybookDetailLazyQueryHookResult = ReturnType<typeof useGetPlaybookDetailLazyQuery>;
export type GetPlaybookDetailSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookDetailSuspenseQuery>;
export type GetPlaybookDetailQueryResult = ApolloReactHooks.useQuery.Result<GetPlaybookDetailQuery, GetPlaybookDetailQueryVariables>;
export const GetPlaybooksDocument = gql`
    query GetPlaybooks {
  playbooks {
    ...PlaybookListItem
  }
}
    ${PlaybookListItemFragmentDoc}`;

/**
 * __useGetPlaybooksQuery__
 *
 * To run a query within a React component, call `useGetPlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlaybooksQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetPlaybooksQuery, GetPlaybooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlaybooksQuery, GetPlaybooksQueryVariables>(GetPlaybooksDocument, options);
      }
export function useGetPlaybooksLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPlaybooksQuery, GetPlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlaybooksQuery, GetPlaybooksQueryVariables>(GetPlaybooksDocument, options);
        }
export function useGetPlaybooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPlaybooksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPlaybooksQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPlaybooksQuery, GetPlaybooksQueryVariables>(GetPlaybooksDocument, options);
        }
export type GetPlaybooksQueryHookResult = ReturnType<typeof useGetPlaybooksQuery>;
export type GetPlaybooksLazyQueryHookResult = ReturnType<typeof useGetPlaybooksLazyQuery>;
export type GetPlaybooksSuspenseQueryHookResult = ReturnType<typeof useGetPlaybooksSuspenseQuery>;
export type GetPlaybooksQueryResult = ApolloReactHooks.useQuery.Result<GetPlaybooksQuery, GetPlaybooksQueryVariables>;
export const GetPlaybooksListDocument = gql`
    query GetPlaybooksList($documentId: UUID!) {
  playbooks {
    id
    title
    description
    runStatus(documentId: $documentId)
    createdAt
    updatedAt
    createdBy {
      __typename
      id
    }
  }
}
    `;

/**
 * __useGetPlaybooksListQuery__
 *
 * To run a query within a React component, call `useGetPlaybooksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybooksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybooksListQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetPlaybooksListQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetPlaybooksListQuery, GetPlaybooksListQueryVariables> & ({ variables: GetPlaybooksListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlaybooksListQuery, GetPlaybooksListQueryVariables>(GetPlaybooksListDocument, options);
      }
export function useGetPlaybooksListLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPlaybooksListQuery, GetPlaybooksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlaybooksListQuery, GetPlaybooksListQueryVariables>(GetPlaybooksListDocument, options);
        }
export function useGetPlaybooksListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPlaybooksListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPlaybooksListQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPlaybooksListQuery, GetPlaybooksListQueryVariables>(GetPlaybooksListDocument, options);
        }
export type GetPlaybooksListQueryHookResult = ReturnType<typeof useGetPlaybooksListQuery>;
export type GetPlaybooksListLazyQueryHookResult = ReturnType<typeof useGetPlaybooksListLazyQuery>;
export type GetPlaybooksListSuspenseQueryHookResult = ReturnType<typeof useGetPlaybooksListSuspenseQuery>;
export type GetPlaybooksListQueryResult = ApolloReactHooks.useQuery.Result<GetPlaybooksListQuery, GetPlaybooksListQueryVariables>;
export const SearchPlaybooksDocument = gql`
    query SearchPlaybooks($input: SearchPlaybooksInput!) {
  searchPlaybooks(input: $input) {
    matchReason
    ruleCount
    score
    playbook {
      id
      title
      description
    }
  }
}
    `;

/**
 * __useSearchPlaybooksQuery__
 *
 * To run a query within a React component, call `useSearchPlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPlaybooksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchPlaybooksQuery(baseOptions: ApolloReactHooks.useQuery.Options<SearchPlaybooksQuery, SearchPlaybooksQueryVariables> & ({ variables: SearchPlaybooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchPlaybooksQuery, SearchPlaybooksQueryVariables>(SearchPlaybooksDocument, options);
      }
export function useSearchPlaybooksLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<SearchPlaybooksQuery, SearchPlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchPlaybooksQuery, SearchPlaybooksQueryVariables>(SearchPlaybooksDocument, options);
        }
export function useSearchPlaybooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<SearchPlaybooksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<SearchPlaybooksQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<SearchPlaybooksQuery, SearchPlaybooksQueryVariables>(SearchPlaybooksDocument, options);
        }
export type SearchPlaybooksQueryHookResult = ReturnType<typeof useSearchPlaybooksQuery>;
export type SearchPlaybooksLazyQueryHookResult = ReturnType<typeof useSearchPlaybooksLazyQuery>;
export type SearchPlaybooksSuspenseQueryHookResult = ReturnType<typeof useSearchPlaybooksSuspenseQuery>;
export type SearchPlaybooksQueryResult = ApolloReactHooks.useQuery.Result<SearchPlaybooksQuery, SearchPlaybooksQueryVariables>;
export const CreatePlaybookDocument = gql`
    mutation CreatePlaybook($input: CreatePlaybookInput!) {
  createPlaybook(input: $input) {
    ...PlaybookSimple
    ...PlaybookListItem
  }
}
    ${PlaybookSimpleFragmentDoc}
${PlaybookListItemFragmentDoc}`;
export type CreatePlaybookMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreatePlaybookMutation, CreatePlaybookMutationVariables>;

/**
 * __useCreatePlaybookMutation__
 *
 * To run a mutation, you first call `useCreatePlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaybookMutation, { data, loading, error }] = useCreatePlaybookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaybookMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreatePlaybookMutation, CreatePlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePlaybookMutation, CreatePlaybookMutationVariables>(CreatePlaybookDocument, options);
      }
export type CreatePlaybookMutationHookResult = ReturnType<typeof useCreatePlaybookMutation>;
export type CreatePlaybookMutationResult = ApolloReactHooks.useMutation.Result<CreatePlaybookMutation>;
export type CreatePlaybookMutationOptions = ApolloReactHooks.useMutation.Options<CreatePlaybookMutation, CreatePlaybookMutationVariables>;
export const UpdatePlaybookDocument = gql`
    mutation UpdatePlaybook($input: UpdatePlaybookInput!) {
  updatePlaybook(input: $input) {
    __typename
    id
    description
    title
    createdAt
    updatedAt
  }
}
    `;
export type UpdatePlaybookMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdatePlaybookMutation, UpdatePlaybookMutationVariables>;

/**
 * __useUpdatePlaybookMutation__
 *
 * To run a mutation, you first call `useUpdatePlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaybookMutation, { data, loading, error }] = useUpdatePlaybookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaybookMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdatePlaybookMutation, UpdatePlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePlaybookMutation, UpdatePlaybookMutationVariables>(UpdatePlaybookDocument, options);
      }
export type UpdatePlaybookMutationHookResult = ReturnType<typeof useUpdatePlaybookMutation>;
export type UpdatePlaybookMutationResult = ApolloReactHooks.useMutation.Result<UpdatePlaybookMutation>;
export type UpdatePlaybookMutationOptions = ApolloReactHooks.useMutation.Options<UpdatePlaybookMutation, UpdatePlaybookMutationVariables>;
export const DeletePlaybookDocument = gql`
    mutation DeletePlaybook($playbookId: UUID!) {
  deletePlaybook(playbookId: $playbookId)
}
    `;
export type DeletePlaybookMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeletePlaybookMutation, DeletePlaybookMutationVariables>;

/**
 * __useDeletePlaybookMutation__
 *
 * To run a mutation, you first call `useDeletePlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaybookMutation, { data, loading, error }] = useDeletePlaybookMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *   },
 * });
 */
export function useDeletePlaybookMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeletePlaybookMutation, DeletePlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePlaybookMutation, DeletePlaybookMutationVariables>(DeletePlaybookDocument, options);
      }
export type DeletePlaybookMutationHookResult = ReturnType<typeof useDeletePlaybookMutation>;
export type DeletePlaybookMutationResult = ApolloReactHooks.useMutation.Result<DeletePlaybookMutation>;
export type DeletePlaybookMutationOptions = ApolloReactHooks.useMutation.Options<DeletePlaybookMutation, DeletePlaybookMutationVariables>;
export const DuplicatePlaybookDocument = gql`
    mutation DuplicatePlaybook($playbookId: UUID!) {
  duplicatePlaybook(playbookId: $playbookId) {
    ...PlaybookListItem
  }
}
    ${PlaybookListItemFragmentDoc}`;
export type DuplicatePlaybookMutationFn = ApolloReactHooks.useMutation.MutationFunction<DuplicatePlaybookMutation, DuplicatePlaybookMutationVariables>;

/**
 * __useDuplicatePlaybookMutation__
 *
 * To run a mutation, you first call `useDuplicatePlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePlaybookMutation, { data, loading, error }] = useDuplicatePlaybookMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *   },
 * });
 */
export function useDuplicatePlaybookMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DuplicatePlaybookMutation, DuplicatePlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicatePlaybookMutation, DuplicatePlaybookMutationVariables>(DuplicatePlaybookDocument, options);
      }
export type DuplicatePlaybookMutationHookResult = ReturnType<typeof useDuplicatePlaybookMutation>;
export type DuplicatePlaybookMutationResult = ApolloReactHooks.useMutation.Result<DuplicatePlaybookMutation>;
export type DuplicatePlaybookMutationOptions = ApolloReactHooks.useMutation.Options<DuplicatePlaybookMutation, DuplicatePlaybookMutationVariables>;
export const GetReminderDocument = gql`
    query GetReminder($reminderId: UUID!) {
  reminder(reminderId: $reminderId) {
    ...ReminderSimple
  }
}
    ${ReminderSimpleFragmentDoc}`;

/**
 * __useGetReminderQuery__
 *
 * To run a query within a React component, call `useGetReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReminderQuery({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useGetReminderQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetReminderQuery, GetReminderQueryVariables> & ({ variables: GetReminderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReminderQuery, GetReminderQueryVariables>(GetReminderDocument, options);
      }
export function useGetReminderLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReminderQuery, GetReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReminderQuery, GetReminderQueryVariables>(GetReminderDocument, options);
        }
export function useGetReminderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReminderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReminderQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReminderQuery, GetReminderQueryVariables>(GetReminderDocument, options);
        }
export type GetReminderQueryHookResult = ReturnType<typeof useGetReminderQuery>;
export type GetReminderLazyQueryHookResult = ReturnType<typeof useGetReminderLazyQuery>;
export type GetReminderSuspenseQueryHookResult = ReturnType<typeof useGetReminderSuspenseQuery>;
export type GetReminderQueryResult = ApolloReactHooks.useQuery.Result<GetReminderQuery, GetReminderQueryVariables>;
export const GetRemindersDocument = gql`
    query GetReminders($filter: ReminderFilter) {
  reminders(filter: $filter) {
    meta {
      ...ReminderMeta
    }
    reminders {
      ...ReminderSimple
    }
  }
}
    ${ReminderMetaFragmentDoc}
${ReminderSimpleFragmentDoc}`;

/**
 * __useGetRemindersQuery__
 *
 * To run a query within a React component, call `useGetRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemindersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRemindersQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetRemindersQuery, GetRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRemindersQuery, GetRemindersQueryVariables>(GetRemindersDocument, options);
      }
export function useGetRemindersLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetRemindersQuery, GetRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRemindersQuery, GetRemindersQueryVariables>(GetRemindersDocument, options);
        }
export function useGetRemindersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetRemindersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetRemindersQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetRemindersQuery, GetRemindersQueryVariables>(GetRemindersDocument, options);
        }
export type GetRemindersQueryHookResult = ReturnType<typeof useGetRemindersQuery>;
export type GetRemindersLazyQueryHookResult = ReturnType<typeof useGetRemindersLazyQuery>;
export type GetRemindersSuspenseQueryHookResult = ReturnType<typeof useGetRemindersSuspenseQuery>;
export type GetRemindersQueryResult = ApolloReactHooks.useQuery.Result<GetRemindersQuery, GetRemindersQueryVariables>;
export const GetRemindersInRangeDocument = gql`
    query GetRemindersInRange($startOfRange: Date!, $endOfRange: Date!) {
  getRemindersInRange(startOfRange: $startOfRange, endOfRange: $endOfRange) {
    meta {
      ...ReminderMeta
    }
    reminders {
      ...ReminderSimple
    }
  }
}
    ${ReminderMetaFragmentDoc}
${ReminderSimpleFragmentDoc}`;

/**
 * __useGetRemindersInRangeQuery__
 *
 * To run a query within a React component, call `useGetRemindersInRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemindersInRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemindersInRangeQuery({
 *   variables: {
 *      startOfRange: // value for 'startOfRange'
 *      endOfRange: // value for 'endOfRange'
 *   },
 * });
 */
export function useGetRemindersInRangeQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetRemindersInRangeQuery, GetRemindersInRangeQueryVariables> & ({ variables: GetRemindersInRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRemindersInRangeQuery, GetRemindersInRangeQueryVariables>(GetRemindersInRangeDocument, options);
      }
export function useGetRemindersInRangeLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetRemindersInRangeQuery, GetRemindersInRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRemindersInRangeQuery, GetRemindersInRangeQueryVariables>(GetRemindersInRangeDocument, options);
        }
export function useGetRemindersInRangeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetRemindersInRangeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetRemindersInRangeQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetRemindersInRangeQuery, GetRemindersInRangeQueryVariables>(GetRemindersInRangeDocument, options);
        }
export type GetRemindersInRangeQueryHookResult = ReturnType<typeof useGetRemindersInRangeQuery>;
export type GetRemindersInRangeLazyQueryHookResult = ReturnType<typeof useGetRemindersInRangeLazyQuery>;
export type GetRemindersInRangeSuspenseQueryHookResult = ReturnType<typeof useGetRemindersInRangeSuspenseQuery>;
export type GetRemindersInRangeQueryResult = ApolloReactHooks.useQuery.Result<GetRemindersInRangeQuery, GetRemindersInRangeQueryVariables>;
export const GetRemindersRequiringNotificationDocument = gql`
    query GetRemindersRequiringNotification($asOfDate: Date!) {
  remindersRequiringNotification(asOfDate: $asOfDate) {
    meta {
      ...ReminderMeta
    }
    reminders {
      ...ReminderSimple
    }
  }
}
    ${ReminderMetaFragmentDoc}
${ReminderSimpleFragmentDoc}`;

/**
 * __useGetRemindersRequiringNotificationQuery__
 *
 * To run a query within a React component, call `useGetRemindersRequiringNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemindersRequiringNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemindersRequiringNotificationQuery({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetRemindersRequiringNotificationQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetRemindersRequiringNotificationQuery, GetRemindersRequiringNotificationQueryVariables> & ({ variables: GetRemindersRequiringNotificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRemindersRequiringNotificationQuery, GetRemindersRequiringNotificationQueryVariables>(GetRemindersRequiringNotificationDocument, options);
      }
export function useGetRemindersRequiringNotificationLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetRemindersRequiringNotificationQuery, GetRemindersRequiringNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRemindersRequiringNotificationQuery, GetRemindersRequiringNotificationQueryVariables>(GetRemindersRequiringNotificationDocument, options);
        }
export function useGetRemindersRequiringNotificationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetRemindersRequiringNotificationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetRemindersRequiringNotificationQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetRemindersRequiringNotificationQuery, GetRemindersRequiringNotificationQueryVariables>(GetRemindersRequiringNotificationDocument, options);
        }
export type GetRemindersRequiringNotificationQueryHookResult = ReturnType<typeof useGetRemindersRequiringNotificationQuery>;
export type GetRemindersRequiringNotificationLazyQueryHookResult = ReturnType<typeof useGetRemindersRequiringNotificationLazyQuery>;
export type GetRemindersRequiringNotificationSuspenseQueryHookResult = ReturnType<typeof useGetRemindersRequiringNotificationSuspenseQuery>;
export type GetRemindersRequiringNotificationQueryResult = ApolloReactHooks.useQuery.Result<GetRemindersRequiringNotificationQuery, GetRemindersRequiringNotificationQueryVariables>;
export const CreateReminderDocument = gql`
    mutation CreateReminder($input: CreateReminderInput!) {
  createReminder(input: $input) {
    ...ReminderSimple
  }
}
    ${ReminderSimpleFragmentDoc}`;
export type CreateReminderMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateReminderMutation, CreateReminderMutationVariables>;

/**
 * __useCreateReminderMutation__
 *
 * To run a mutation, you first call `useCreateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReminderMutation, { data, loading, error }] = useCreateReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReminderMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateReminderMutation, CreateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReminderMutation, CreateReminderMutationVariables>(CreateReminderDocument, options);
      }
export type CreateReminderMutationHookResult = ReturnType<typeof useCreateReminderMutation>;
export type CreateReminderMutationResult = ApolloReactHooks.useMutation.Result<CreateReminderMutation>;
export type CreateReminderMutationOptions = ApolloReactHooks.useMutation.Options<CreateReminderMutation, CreateReminderMutationVariables>;
export const UpdateReminderDocument = gql`
    mutation UpdateReminder($input: UpdateReminderInput!) {
  updateReminder(input: $input) {
    ...ReminderSimple
  }
}
    ${ReminderSimpleFragmentDoc}`;
export type UpdateReminderMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateReminderMutation, UpdateReminderMutationVariables>;

/**
 * __useUpdateReminderMutation__
 *
 * To run a mutation, you first call `useUpdateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderMutation, { data, loading, error }] = useUpdateReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReminderMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateReminderMutation, UpdateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReminderMutation, UpdateReminderMutationVariables>(UpdateReminderDocument, options);
      }
export type UpdateReminderMutationHookResult = ReturnType<typeof useUpdateReminderMutation>;
export type UpdateReminderMutationResult = ApolloReactHooks.useMutation.Result<UpdateReminderMutation>;
export type UpdateReminderMutationOptions = ApolloReactHooks.useMutation.Options<UpdateReminderMutation, UpdateReminderMutationVariables>;
export const UpdateRemindersDocument = gql`
    mutation UpdateReminders($inputs: [UpdateReminderInput!]!) {
  updateReminders(inputs: $inputs) {
    ...ReminderSimple
  }
}
    ${ReminderSimpleFragmentDoc}`;
export type UpdateRemindersMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateRemindersMutation, UpdateRemindersMutationVariables>;

/**
 * __useUpdateRemindersMutation__
 *
 * To run a mutation, you first call `useUpdateRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRemindersMutation, { data, loading, error }] = useUpdateRemindersMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateRemindersMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateRemindersMutation, UpdateRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRemindersMutation, UpdateRemindersMutationVariables>(UpdateRemindersDocument, options);
      }
export type UpdateRemindersMutationHookResult = ReturnType<typeof useUpdateRemindersMutation>;
export type UpdateRemindersMutationResult = ApolloReactHooks.useMutation.Result<UpdateRemindersMutation>;
export type UpdateRemindersMutationOptions = ApolloReactHooks.useMutation.Options<UpdateRemindersMutation, UpdateRemindersMutationVariables>;
export const DeleteReminderDocument = gql`
    mutation DeleteReminder($reminderId: UUID!) {
  deleteReminder(reminderId: $reminderId)
}
    `;
export type DeleteReminderMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteReminderMutation, DeleteReminderMutationVariables>;

/**
 * __useDeleteReminderMutation__
 *
 * To run a mutation, you first call `useDeleteReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReminderMutation, { data, loading, error }] = useDeleteReminderMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useDeleteReminderMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteReminderMutation, DeleteReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteReminderMutation, DeleteReminderMutationVariables>(DeleteReminderDocument, options);
      }
export type DeleteReminderMutationHookResult = ReturnType<typeof useDeleteReminderMutation>;
export type DeleteReminderMutationResult = ApolloReactHooks.useMutation.Result<DeleteReminderMutation>;
export type DeleteReminderMutationOptions = ApolloReactHooks.useMutation.Options<DeleteReminderMutation, DeleteReminderMutationVariables>;
export const DeleteRemindersDocument = gql`
    mutation DeleteReminders($reminderIds: [UUID!]!) {
  deleteReminders(reminderIds: $reminderIds)
}
    `;
export type DeleteRemindersMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteRemindersMutation, DeleteRemindersMutationVariables>;

/**
 * __useDeleteRemindersMutation__
 *
 * To run a mutation, you first call `useDeleteRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRemindersMutation, { data, loading, error }] = useDeleteRemindersMutation({
 *   variables: {
 *      reminderIds: // value for 'reminderIds'
 *   },
 * });
 */
export function useDeleteRemindersMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteRemindersMutation, DeleteRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRemindersMutation, DeleteRemindersMutationVariables>(DeleteRemindersDocument, options);
      }
export type DeleteRemindersMutationHookResult = ReturnType<typeof useDeleteRemindersMutation>;
export type DeleteRemindersMutationResult = ApolloReactHooks.useMutation.Result<DeleteRemindersMutation>;
export type DeleteRemindersMutationOptions = ApolloReactHooks.useMutation.Options<DeleteRemindersMutation, DeleteRemindersMutationVariables>;
export const OnRemindersUpdatedDocument = gql`
    subscription OnRemindersUpdated {
  remindersUpdated {
    meta {
      ...ReminderMeta
    }
    reminderIds
    reminders {
      ...ReminderSimple
    }
  }
}
    ${ReminderMetaFragmentDoc}
${ReminderSimpleFragmentDoc}`;

/**
 * __useOnRemindersUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnRemindersUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnRemindersUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnRemindersUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnRemindersUpdatedSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnRemindersUpdatedSubscription, OnRemindersUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnRemindersUpdatedSubscription, OnRemindersUpdatedSubscriptionVariables>(OnRemindersUpdatedDocument, options);
      }
export type OnRemindersUpdatedSubscriptionHookResult = ReturnType<typeof useOnRemindersUpdatedSubscription>;
export type OnRemindersUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnRemindersUpdatedSubscription>;
export const GetReportColumnOptionsDocument = gql`
    query GetReportColumnOptions {
  reportColumnOptions {
    ...ReportColumnOptionBase
  }
}
    ${ReportColumnOptionBaseFragmentDoc}`;

/**
 * __useGetReportColumnOptionsQuery__
 *
 * To run a query within a React component, call `useGetReportColumnOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportColumnOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportColumnOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportColumnOptionsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetReportColumnOptionsQuery, GetReportColumnOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportColumnOptionsQuery, GetReportColumnOptionsQueryVariables>(GetReportColumnOptionsDocument, options);
      }
export function useGetReportColumnOptionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportColumnOptionsQuery, GetReportColumnOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportColumnOptionsQuery, GetReportColumnOptionsQueryVariables>(GetReportColumnOptionsDocument, options);
        }
export function useGetReportColumnOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportColumnOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportColumnOptionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportColumnOptionsQuery, GetReportColumnOptionsQueryVariables>(GetReportColumnOptionsDocument, options);
        }
export type GetReportColumnOptionsQueryHookResult = ReturnType<typeof useGetReportColumnOptionsQuery>;
export type GetReportColumnOptionsLazyQueryHookResult = ReturnType<typeof useGetReportColumnOptionsLazyQuery>;
export type GetReportColumnOptionsSuspenseQueryHookResult = ReturnType<typeof useGetReportColumnOptionsSuspenseQuery>;
export type GetReportColumnOptionsQueryResult = ApolloReactHooks.useQuery.Result<GetReportColumnOptionsQuery, GetReportColumnOptionsQueryVariables>;
export const GetReportRowsDocument = gql`
    query GetReportRows($reportId: UUID!, $displayMode: DisplayMode!, $cursor: UUID, $offset: Int, $limit: Int, $sortModel: JSON, $filterModel: JSON, $filterTimeZone: String, $listFilter: DocumentListFilter, $docVariant: DocumentVariant, $parentTreeRowId: ID, $groupFieldIds: [String!], $groupKeys: [String!], $unconfirmedRelationshipsOnly: Boolean, $missingMatchesOnly: Boolean, $trashed: Boolean) {
  report(reportId: $reportId) {
    id
    reportRows(
      displayMode: $displayMode
      cursor: $cursor
      offset: $offset
      limit: $limit
      sortModel: $sortModel
      filterModel: $filterModel
      filterTimeZone: $filterTimeZone
      listFilter: $listFilter
      docVariant: $docVariant
      parentTreeRowId: $parentTreeRowId
      groupFieldIds: $groupFieldIds
      groupKeys: $groupKeys
      unconfirmedRelationshipsOnly: $unconfirmedRelationshipsOnly
      missingMatchesOnly: $missingMatchesOnly
      trashed: $trashed
    ) {
      totalCount
      groupCount
      rows {
        ... on DocumentRow {
          __typename
          id
          parentTreeRowId
          childRowCount
          documentId
          relationshipDirection
          relationship {
            id
            parentDocumentId
            childDocumentId
            childRelationshipType
            source
            llmReasonsMarkdown
            sourceAgreementName
            review {
              __typename
              outcome
              reviewedBy {
                id
                displayName
              }
            }
          }
          document {
            ...DocumentReportRow
          }
        }
        ... on OrphanRelationshipRow {
          __typename
          id
          parentTreeRowId
          childRowCount
          orphanedRelationshipDirection
          orphanedRelationship {
            id
            parentDocumentId
            childDocumentId
            childRelationshipType
            source
            llmReasonsMarkdown
            expectedDocumentName
            expectedDocumentAgreementDate
            sourceAgreementName
            review {
              __typename
              outcome
              reviewedBy {
                id
                displayName
              }
            }
          }
        }
        ... on UrlRelationshipRow {
          __typename
          id
          parentTreeRowId
          childRowCount
          urlRelationship {
            id
            parentDocumentId
            childDocumentId
            childRelationshipType
            childUrl
            source
            llmReasonsMarkdown
            review {
              __typename
              outcome
              reviewedBy {
                id
                displayName
              }
            }
          }
        }
        ... on GroupHeaderRow {
          __typename
          id
          parentTreeRowId
          documentCount
          childRowCount
          groupKey
          groupFieldId
        }
      }
    }
  }
}
    ${DocumentReportRowFragmentDoc}`;

/**
 * __useGetReportRowsQuery__
 *
 * To run a query within a React component, call `useGetReportRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRowsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      displayMode: // value for 'displayMode'
 *      cursor: // value for 'cursor'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortModel: // value for 'sortModel'
 *      filterModel: // value for 'filterModel'
 *      filterTimeZone: // value for 'filterTimeZone'
 *      listFilter: // value for 'listFilter'
 *      docVariant: // value for 'docVariant'
 *      parentTreeRowId: // value for 'parentTreeRowId'
 *      groupFieldIds: // value for 'groupFieldIds'
 *      groupKeys: // value for 'groupKeys'
 *      unconfirmedRelationshipsOnly: // value for 'unconfirmedRelationshipsOnly'
 *      missingMatchesOnly: // value for 'missingMatchesOnly'
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useGetReportRowsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetReportRowsQuery, GetReportRowsQueryVariables> & ({ variables: GetReportRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportRowsQuery, GetReportRowsQueryVariables>(GetReportRowsDocument, options);
      }
export function useGetReportRowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportRowsQuery, GetReportRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportRowsQuery, GetReportRowsQueryVariables>(GetReportRowsDocument, options);
        }
export function useGetReportRowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportRowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportRowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportRowsQuery, GetReportRowsQueryVariables>(GetReportRowsDocument, options);
        }
export type GetReportRowsQueryHookResult = ReturnType<typeof useGetReportRowsQuery>;
export type GetReportRowsLazyQueryHookResult = ReturnType<typeof useGetReportRowsLazyQuery>;
export type GetReportRowsSuspenseQueryHookResult = ReturnType<typeof useGetReportRowsSuspenseQuery>;
export type GetReportRowsQueryResult = ApolloReactHooks.useQuery.Result<GetReportRowsQuery, GetReportRowsQueryVariables>;
export const GetReportDocument = gql`
    query GetReport($reportId: UUID!) {
  report(reportId: $reportId) {
    __typename
    id
    createdAt
    name
    state
    rows {
      docs {
        __typename
        id
      }
    }
  }
}
    `;

/**
 * __useGetReportQuery__
 *
 * To run a query within a React component, call `useGetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetReportQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetReportQuery, GetReportQueryVariables> & ({ variables: GetReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
      }
export function useGetReportLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportQuery, GetReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
        }
export function useGetReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
        }
export type GetReportQueryHookResult = ReturnType<typeof useGetReportQuery>;
export type GetReportLazyQueryHookResult = ReturnType<typeof useGetReportLazyQuery>;
export type GetReportSuspenseQueryHookResult = ReturnType<typeof useGetReportSuspenseQuery>;
export type GetReportQueryResult = ApolloReactHooks.useQuery.Result<GetReportQuery, GetReportQueryVariables>;
export const GetReportsDocument = gql`
    query GetReports {
  reports {
    ...ReportBase
  }
}
    ${ReportBaseFragmentDoc}`;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetReportsQuery, GetReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
      }
export function useGetReportsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportsQuery, GetReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
        }
export function useGetReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
        }
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsSuspenseQueryHookResult = ReturnType<typeof useGetReportsSuspenseQuery>;
export type GetReportsQueryResult = ApolloReactHooks.useQuery.Result<GetReportsQuery, GetReportsQueryVariables>;
export const GetReportsCountDocument = gql`
    query GetReportsCount {
  reports {
    __typename
    id
  }
}
    `;

/**
 * __useGetReportsCountQuery__
 *
 * To run a query within a React component, call `useGetReportsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsCountQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetReportsCountQuery, GetReportsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportsCountQuery, GetReportsCountQueryVariables>(GetReportsCountDocument, options);
      }
export function useGetReportsCountLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportsCountQuery, GetReportsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportsCountQuery, GetReportsCountQueryVariables>(GetReportsCountDocument, options);
        }
export function useGetReportsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportsCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportsCountQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportsCountQuery, GetReportsCountQueryVariables>(GetReportsCountDocument, options);
        }
export type GetReportsCountQueryHookResult = ReturnType<typeof useGetReportsCountQuery>;
export type GetReportsCountLazyQueryHookResult = ReturnType<typeof useGetReportsCountLazyQuery>;
export type GetReportsCountSuspenseQueryHookResult = ReturnType<typeof useGetReportsCountSuspenseQuery>;
export type GetReportsCountQueryResult = ApolloReactHooks.useQuery.Result<GetReportsCountQuery, GetReportsCountQueryVariables>;
export const GetDocumentReportRowsDocument = gql`
    query GetDocumentReportRows($reportId: UUID!, $sortModel: JSON, $filterModel: JSON, $filterTimeZone: String, $offset: Int, $limit: Int, $listFilter: DocumentListFilter, $trashed: Boolean, $docVariant: DocumentVariant, $parentId: UUID, $unconfirmedRelationshipsOnly: Boolean, $missingMatchesOnly: Boolean) {
  report(reportId: $reportId) {
    __typename
    id
    name
    rows(
      offset: $offset
      filterModel: $filterModel
      filterTimeZone: $filterTimeZone
      limit: $limit
      listFilter: $listFilter
      docVariant: $docVariant
      sortModel: $sortModel
      trashed: $trashed
      parentId: $parentId
      unconfirmedRelationshipsOnly: $unconfirmedRelationshipsOnly
      missingMatchesOnly: $missingMatchesOnly
    ) {
      totalCount
      docs {
        ...DocumentReportRow
      }
    }
  }
}
    ${DocumentReportRowFragmentDoc}`;

/**
 * __useGetDocumentReportRowsQuery__
 *
 * To run a query within a React component, call `useGetDocumentReportRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentReportRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentReportRowsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      sortModel: // value for 'sortModel'
 *      filterModel: // value for 'filterModel'
 *      filterTimeZone: // value for 'filterTimeZone'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      listFilter: // value for 'listFilter'
 *      trashed: // value for 'trashed'
 *      docVariant: // value for 'docVariant'
 *      parentId: // value for 'parentId'
 *      unconfirmedRelationshipsOnly: // value for 'unconfirmedRelationshipsOnly'
 *      missingMatchesOnly: // value for 'missingMatchesOnly'
 *   },
 * });
 */
export function useGetDocumentReportRowsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentReportRowsQuery, GetDocumentReportRowsQueryVariables> & ({ variables: GetDocumentReportRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentReportRowsQuery, GetDocumentReportRowsQueryVariables>(GetDocumentReportRowsDocument, options);
      }
export function useGetDocumentReportRowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentReportRowsQuery, GetDocumentReportRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentReportRowsQuery, GetDocumentReportRowsQueryVariables>(GetDocumentReportRowsDocument, options);
        }
export function useGetDocumentReportRowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentReportRowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentReportRowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentReportRowsQuery, GetDocumentReportRowsQueryVariables>(GetDocumentReportRowsDocument, options);
        }
export type GetDocumentReportRowsQueryHookResult = ReturnType<typeof useGetDocumentReportRowsQuery>;
export type GetDocumentReportRowsLazyQueryHookResult = ReturnType<typeof useGetDocumentReportRowsLazyQuery>;
export type GetDocumentReportRowsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentReportRowsSuspenseQuery>;
export type GetDocumentReportRowsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentReportRowsQuery, GetDocumentReportRowsQueryVariables>;
export const GetReportInitialStateDocument = gql`
    query GetReportInitialState($reportId: UUID!) {
  report(reportId: $reportId) {
    __typename
    id
    name
    state
    columnOptions {
      ...ReportColumnOptionBase
    }
  }
}
    ${ReportColumnOptionBaseFragmentDoc}`;

/**
 * __useGetReportInitialStateQuery__
 *
 * To run a query within a React component, call `useGetReportInitialStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportInitialStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportInitialStateQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetReportInitialStateQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetReportInitialStateQuery, GetReportInitialStateQueryVariables> & ({ variables: GetReportInitialStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportInitialStateQuery, GetReportInitialStateQueryVariables>(GetReportInitialStateDocument, options);
      }
export function useGetReportInitialStateLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportInitialStateQuery, GetReportInitialStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportInitialStateQuery, GetReportInitialStateQueryVariables>(GetReportInitialStateDocument, options);
        }
export function useGetReportInitialStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportInitialStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportInitialStateQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportInitialStateQuery, GetReportInitialStateQueryVariables>(GetReportInitialStateDocument, options);
        }
export type GetReportInitialStateQueryHookResult = ReturnType<typeof useGetReportInitialStateQuery>;
export type GetReportInitialStateLazyQueryHookResult = ReturnType<typeof useGetReportInitialStateLazyQuery>;
export type GetReportInitialStateSuspenseQueryHookResult = ReturnType<typeof useGetReportInitialStateSuspenseQuery>;
export type GetReportInitialStateQueryResult = ApolloReactHooks.useQuery.Result<GetReportInitialStateQuery, GetReportInitialStateQueryVariables>;
export const GetReportStateDocument = gql`
    query GetReportState($reportId: UUID!) {
  report(reportId: $reportId) {
    __typename
    id
    name
    state
  }
}
    `;

/**
 * __useGetReportStateQuery__
 *
 * To run a query within a React component, call `useGetReportStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportStateQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetReportStateQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetReportStateQuery, GetReportStateQueryVariables> & ({ variables: GetReportStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportStateQuery, GetReportStateQueryVariables>(GetReportStateDocument, options);
      }
export function useGetReportStateLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportStateQuery, GetReportStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportStateQuery, GetReportStateQueryVariables>(GetReportStateDocument, options);
        }
export function useGetReportStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportStateQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportStateQuery, GetReportStateQueryVariables>(GetReportStateDocument, options);
        }
export type GetReportStateQueryHookResult = ReturnType<typeof useGetReportStateQuery>;
export type GetReportStateLazyQueryHookResult = ReturnType<typeof useGetReportStateLazyQuery>;
export type GetReportStateSuspenseQueryHookResult = ReturnType<typeof useGetReportStateSuspenseQuery>;
export type GetReportStateQueryResult = ApolloReactHooks.useQuery.Result<GetReportStateQuery, GetReportStateQueryVariables>;
export const GetDocumentRowIndexDocument = gql`
    query GetDocumentRowIndex($reportId: UUID!, $documentId: UUID!, $sortModel: JSON, $filterModel: JSON, $filterTimeZone: String, $listFilter: DocumentListFilter) {
  documentRowIndex(
    reportId: $reportId
    documentId: $documentId
    sortModel: $sortModel
    filterModel: $filterModel
    filterTimeZone: $filterTimeZone
    listFilter: $listFilter
  )
}
    `;

/**
 * __useGetDocumentRowIndexQuery__
 *
 * To run a query within a React component, call `useGetDocumentRowIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentRowIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentRowIndexQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      documentId: // value for 'documentId'
 *      sortModel: // value for 'sortModel'
 *      filterModel: // value for 'filterModel'
 *      filterTimeZone: // value for 'filterTimeZone'
 *      listFilter: // value for 'listFilter'
 *   },
 * });
 */
export function useGetDocumentRowIndexQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentRowIndexQuery, GetDocumentRowIndexQueryVariables> & ({ variables: GetDocumentRowIndexQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentRowIndexQuery, GetDocumentRowIndexQueryVariables>(GetDocumentRowIndexDocument, options);
      }
export function useGetDocumentRowIndexLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentRowIndexQuery, GetDocumentRowIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentRowIndexQuery, GetDocumentRowIndexQueryVariables>(GetDocumentRowIndexDocument, options);
        }
export function useGetDocumentRowIndexSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentRowIndexQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentRowIndexQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentRowIndexQuery, GetDocumentRowIndexQueryVariables>(GetDocumentRowIndexDocument, options);
        }
export type GetDocumentRowIndexQueryHookResult = ReturnType<typeof useGetDocumentRowIndexQuery>;
export type GetDocumentRowIndexLazyQueryHookResult = ReturnType<typeof useGetDocumentRowIndexLazyQuery>;
export type GetDocumentRowIndexSuspenseQueryHookResult = ReturnType<typeof useGetDocumentRowIndexSuspenseQuery>;
export type GetDocumentRowIndexQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentRowIndexQuery, GetDocumentRowIndexQueryVariables>;
export const GetQuestionLockStatusDocument = gql`
    query GetQuestionLockStatus($reportId: UUID!, $questionId: UUID!, $filterModel: JSON, $listFilter: DocumentListFilter) {
  report(reportId: $reportId) {
    __typename
    id
    questionLockStatus(
      questionId: $questionId
      filterModel: $filterModel
      listFilter: $listFilter
    ) {
      state
      lockedCount
      totalCount
    }
  }
}
    `;

/**
 * __useGetQuestionLockStatusQuery__
 *
 * To run a query within a React component, call `useGetQuestionLockStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionLockStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionLockStatusQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      questionId: // value for 'questionId'
 *      filterModel: // value for 'filterModel'
 *      listFilter: // value for 'listFilter'
 *   },
 * });
 */
export function useGetQuestionLockStatusQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetQuestionLockStatusQuery, GetQuestionLockStatusQueryVariables> & ({ variables: GetQuestionLockStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuestionLockStatusQuery, GetQuestionLockStatusQueryVariables>(GetQuestionLockStatusDocument, options);
      }
export function useGetQuestionLockStatusLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetQuestionLockStatusQuery, GetQuestionLockStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuestionLockStatusQuery, GetQuestionLockStatusQueryVariables>(GetQuestionLockStatusDocument, options);
        }
export function useGetQuestionLockStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetQuestionLockStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetQuestionLockStatusQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetQuestionLockStatusQuery, GetQuestionLockStatusQueryVariables>(GetQuestionLockStatusDocument, options);
        }
export type GetQuestionLockStatusQueryHookResult = ReturnType<typeof useGetQuestionLockStatusQuery>;
export type GetQuestionLockStatusLazyQueryHookResult = ReturnType<typeof useGetQuestionLockStatusLazyQuery>;
export type GetQuestionLockStatusSuspenseQueryHookResult = ReturnType<typeof useGetQuestionLockStatusSuspenseQuery>;
export type GetQuestionLockStatusQueryResult = ApolloReactHooks.useQuery.Result<GetQuestionLockStatusQuery, GetQuestionLockStatusQueryVariables>;
export const GetEditorReportsDocument = gql`
    query GetEditorReports {
  reports {
    __typename
    createdAt
    id
    name
    state
  }
}
    `;

/**
 * __useGetEditorReportsQuery__
 *
 * To run a query within a React component, call `useGetEditorReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditorReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditorReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEditorReportsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetEditorReportsQuery, GetEditorReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEditorReportsQuery, GetEditorReportsQueryVariables>(GetEditorReportsDocument, options);
      }
export function useGetEditorReportsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetEditorReportsQuery, GetEditorReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEditorReportsQuery, GetEditorReportsQueryVariables>(GetEditorReportsDocument, options);
        }
export function useGetEditorReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetEditorReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetEditorReportsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetEditorReportsQuery, GetEditorReportsQueryVariables>(GetEditorReportsDocument, options);
        }
export type GetEditorReportsQueryHookResult = ReturnType<typeof useGetEditorReportsQuery>;
export type GetEditorReportsLazyQueryHookResult = ReturnType<typeof useGetEditorReportsLazyQuery>;
export type GetEditorReportsSuspenseQueryHookResult = ReturnType<typeof useGetEditorReportsSuspenseQuery>;
export type GetEditorReportsQueryResult = ApolloReactHooks.useQuery.Result<GetEditorReportsQuery, GetEditorReportsQueryVariables>;
export const CreateReportDocument = gql`
    mutation CreateReport($input: CreateReportInput!) {
  createReport(input: $input) {
    report {
      ...ReportBase
    }
  }
}
    ${ReportBaseFragmentDoc}`;
export type CreateReportMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = ApolloReactHooks.useMutation.Result<CreateReportMutation>;
export type CreateReportMutationOptions = ApolloReactHooks.useMutation.Options<CreateReportMutation, CreateReportMutationVariables>;
export const DeleteReportsDocument = gql`
    mutation DeleteReports($input: DeleteReportsInput!) {
  deleteReports(input: $input)
}
    `;
export type DeleteReportsMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteReportsMutation, DeleteReportsMutationVariables>;

/**
 * __useDeleteReportsMutation__
 *
 * To run a mutation, you first call `useDeleteReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportsMutation, { data, loading, error }] = useDeleteReportsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteReportsMutation, DeleteReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteReportsMutation, DeleteReportsMutationVariables>(DeleteReportsDocument, options);
      }
export type DeleteReportsMutationHookResult = ReturnType<typeof useDeleteReportsMutation>;
export type DeleteReportsMutationResult = ApolloReactHooks.useMutation.Result<DeleteReportsMutation>;
export type DeleteReportsMutationOptions = ApolloReactHooks.useMutation.Options<DeleteReportsMutation, DeleteReportsMutationVariables>;
export const StartReportExtractionDocument = gql`
    mutation StartReportExtraction($input: StartReportExtractionInput!) {
  startReportExtraction(input: $input) {
    report {
      __typename
      id
      name
    }
    aiQuestionsRunningForDocs {
      __typename
      documentId
      questionIds
    }
    queuedCount
    skippedCount
  }
}
    `;
export type StartReportExtractionMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartReportExtractionMutation, StartReportExtractionMutationVariables>;

/**
 * __useStartReportExtractionMutation__
 *
 * To run a mutation, you first call `useStartReportExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartReportExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startReportExtractionMutation, { data, loading, error }] = useStartReportExtractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartReportExtractionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartReportExtractionMutation, StartReportExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartReportExtractionMutation, StartReportExtractionMutationVariables>(StartReportExtractionDocument, options);
      }
export type StartReportExtractionMutationHookResult = ReturnType<typeof useStartReportExtractionMutation>;
export type StartReportExtractionMutationResult = ApolloReactHooks.useMutation.Result<StartReportExtractionMutation>;
export type StartReportExtractionMutationOptions = ApolloReactHooks.useMutation.Options<StartReportExtractionMutation, StartReportExtractionMutationVariables>;
export const UpdateReportDocument = gql`
    mutation UpdateReport($input: UpdateReportInput!) {
  updateReport(input: $input) {
    report {
      ...UpdateReportFragment
    }
  }
}
    ${UpdateReportFragmentFragmentDoc}`;
export type UpdateReportMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = ApolloReactHooks.useMutation.Result<UpdateReportMutation>;
export type UpdateReportMutationOptions = ApolloReactHooks.useMutation.Options<UpdateReportMutation, UpdateReportMutationVariables>;
export const UpdateReportStateDocument = gql`
    mutation UpdateReportState($reportId: UUID!, $state: JSON!) {
  updateReport(input: {reportId: $reportId, reportProps: {state: $state}}) {
    report {
      ...UpdateReportFragment
    }
  }
}
    ${UpdateReportFragmentFragmentDoc}`;
export type UpdateReportStateMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateReportStateMutation, UpdateReportStateMutationVariables>;

/**
 * __useUpdateReportStateMutation__
 *
 * To run a mutation, you first call `useUpdateReportStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportStateMutation, { data, loading, error }] = useUpdateReportStateMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateReportStateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateReportStateMutation, UpdateReportStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReportStateMutation, UpdateReportStateMutationVariables>(UpdateReportStateDocument, options);
      }
export type UpdateReportStateMutationHookResult = ReturnType<typeof useUpdateReportStateMutation>;
export type UpdateReportStateMutationResult = ApolloReactHooks.useMutation.Result<UpdateReportStateMutation>;
export type UpdateReportStateMutationOptions = ApolloReactHooks.useMutation.Options<UpdateReportStateMutation, UpdateReportStateMutationVariables>;
export const SendReportExportDocument = gql`
    mutation SendReportExport($reportId: UUID!, $format: ExportFormat) {
  sendReportExport(reportId: $reportId, format: $format) {
    report {
      __typename
      id
    }
  }
}
    `;
export type SendReportExportMutationFn = ApolloReactHooks.useMutation.MutationFunction<SendReportExportMutation, SendReportExportMutationVariables>;

/**
 * __useSendReportExportMutation__
 *
 * To run a mutation, you first call `useSendReportExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReportExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReportExportMutation, { data, loading, error }] = useSendReportExportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useSendReportExportMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SendReportExportMutation, SendReportExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendReportExportMutation, SendReportExportMutationVariables>(SendReportExportDocument, options);
      }
export type SendReportExportMutationHookResult = ReturnType<typeof useSendReportExportMutation>;
export type SendReportExportMutationResult = ApolloReactHooks.useMutation.Result<SendReportExportMutation>;
export type SendReportExportMutationOptions = ApolloReactHooks.useMutation.Options<SendReportExportMutation, SendReportExportMutationVariables>;
export const ReportUpdatedDocument = gql`
    subscription ReportUpdated($reportId: UUID!) {
  reportUpdated(reportId: $reportId) {
    reportId
    report {
      __typename
      id
      name
      state
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useReportUpdatedSubscription__
 *
 * To run a query within a React component, call `useReportUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReportUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportUpdatedSubscription({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportUpdatedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<ReportUpdatedSubscription, ReportUpdatedSubscriptionVariables> & ({ variables: ReportUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<ReportUpdatedSubscription, ReportUpdatedSubscriptionVariables>(ReportUpdatedDocument, options);
      }
export type ReportUpdatedSubscriptionHookResult = ReturnType<typeof useReportUpdatedSubscription>;
export type ReportUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<ReportUpdatedSubscription>;
export const CountFilteredDocumentsDocument = gql`
    query CountFilteredDocuments($filterModel: JSON!) {
  countFilteredDocuments(filterModel: $filterModel)
}
    `;

/**
 * __useCountFilteredDocumentsQuery__
 *
 * To run a query within a React component, call `useCountFilteredDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountFilteredDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountFilteredDocumentsQuery({
 *   variables: {
 *      filterModel: // value for 'filterModel'
 *   },
 * });
 */
export function useCountFilteredDocumentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<CountFilteredDocumentsQuery, CountFilteredDocumentsQueryVariables> & ({ variables: CountFilteredDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CountFilteredDocumentsQuery, CountFilteredDocumentsQueryVariables>(CountFilteredDocumentsDocument, options);
      }
export function useCountFilteredDocumentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<CountFilteredDocumentsQuery, CountFilteredDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CountFilteredDocumentsQuery, CountFilteredDocumentsQueryVariables>(CountFilteredDocumentsDocument, options);
        }
export function useCountFilteredDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<CountFilteredDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<CountFilteredDocumentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<CountFilteredDocumentsQuery, CountFilteredDocumentsQueryVariables>(CountFilteredDocumentsDocument, options);
        }
export type CountFilteredDocumentsQueryHookResult = ReturnType<typeof useCountFilteredDocumentsQuery>;
export type CountFilteredDocumentsLazyQueryHookResult = ReturnType<typeof useCountFilteredDocumentsLazyQuery>;
export type CountFilteredDocumentsSuspenseQueryHookResult = ReturnType<typeof useCountFilteredDocumentsSuspenseQuery>;
export type CountFilteredDocumentsQueryResult = ApolloReactHooks.useQuery.Result<CountFilteredDocumentsQuery, CountFilteredDocumentsQueryVariables>;
export const GetRowsMetaDocument = gql`
    query GetRowsMeta($reportId: UUID!, $displayMode: DisplayMode = FLAT, $filterModel: JSON, $filterTimeZone: String, $listFilter: DocumentListFilter, $docVariant: DocumentVariant, $trashed: Boolean, $parentTreeRowId: ID, $groupFieldIds: [String!], $groupKeys: [String!], $unconfirmedRelationshipsOnly: Boolean, $missingMatchesOnly: Boolean) {
  report(reportId: $reportId) {
    __typename
    id
    rowsMeta(
      displayMode: $displayMode
      filterModel: $filterModel
      filterTimeZone: $filterTimeZone
      listFilter: $listFilter
      docVariant: $docVariant
      trashed: $trashed
      parentTreeRowId: $parentTreeRowId
      groupFieldIds: $groupFieldIds
      groupKeys: $groupKeys
      unconfirmedRelationshipsOnly: $unconfirmedRelationshipsOnly
      missingMatchesOnly: $missingMatchesOnly
    ) {
      __typename
      aiRunningCount
      answerStaleCount
      aiNotRunCount
      aiErrorCount
      ocrErrorCount
      ocrRunningCount
    }
  }
}
    `;

/**
 * __useGetRowsMetaQuery__
 *
 * To run a query within a React component, call `useGetRowsMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRowsMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRowsMetaQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      displayMode: // value for 'displayMode'
 *      filterModel: // value for 'filterModel'
 *      filterTimeZone: // value for 'filterTimeZone'
 *      listFilter: // value for 'listFilter'
 *      docVariant: // value for 'docVariant'
 *      trashed: // value for 'trashed'
 *      parentTreeRowId: // value for 'parentTreeRowId'
 *      groupFieldIds: // value for 'groupFieldIds'
 *      groupKeys: // value for 'groupKeys'
 *      unconfirmedRelationshipsOnly: // value for 'unconfirmedRelationshipsOnly'
 *      missingMatchesOnly: // value for 'missingMatchesOnly'
 *   },
 * });
 */
export function useGetRowsMetaQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetRowsMetaQuery, GetRowsMetaQueryVariables> & ({ variables: GetRowsMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRowsMetaQuery, GetRowsMetaQueryVariables>(GetRowsMetaDocument, options);
      }
export function useGetRowsMetaLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetRowsMetaQuery, GetRowsMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRowsMetaQuery, GetRowsMetaQueryVariables>(GetRowsMetaDocument, options);
        }
export function useGetRowsMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetRowsMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetRowsMetaQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetRowsMetaQuery, GetRowsMetaQueryVariables>(GetRowsMetaDocument, options);
        }
export type GetRowsMetaQueryHookResult = ReturnType<typeof useGetRowsMetaQuery>;
export type GetRowsMetaLazyQueryHookResult = ReturnType<typeof useGetRowsMetaLazyQuery>;
export type GetRowsMetaSuspenseQueryHookResult = ReturnType<typeof useGetRowsMetaSuspenseQuery>;
export type GetRowsMetaQueryResult = ApolloReactHooks.useQuery.Result<GetRowsMetaQuery, GetRowsMetaQueryVariables>;
export const GetRepositoryMetaDocument = gql`
    query GetRepositoryMeta($repositoryId: UUID!) {
  repositoryMeta(repositoryId: $repositoryId) {
    __typename
    detectingRelationshipsCount
    failedRelationshipsCount
    unconfirmedRelationshipsCount
    missingMatchesCount
    unprocessedRelationshipDocumentsCount
  }
}
    `;

/**
 * __useGetRepositoryMetaQuery__
 *
 * To run a query within a React component, call `useGetRepositoryMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepositoryMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepositoryMetaQuery({
 *   variables: {
 *      repositoryId: // value for 'repositoryId'
 *   },
 * });
 */
export function useGetRepositoryMetaQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetRepositoryMetaQuery, GetRepositoryMetaQueryVariables> & ({ variables: GetRepositoryMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRepositoryMetaQuery, GetRepositoryMetaQueryVariables>(GetRepositoryMetaDocument, options);
      }
export function useGetRepositoryMetaLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetRepositoryMetaQuery, GetRepositoryMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRepositoryMetaQuery, GetRepositoryMetaQueryVariables>(GetRepositoryMetaDocument, options);
        }
export function useGetRepositoryMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetRepositoryMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetRepositoryMetaQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetRepositoryMetaQuery, GetRepositoryMetaQueryVariables>(GetRepositoryMetaDocument, options);
        }
export type GetRepositoryMetaQueryHookResult = ReturnType<typeof useGetRepositoryMetaQuery>;
export type GetRepositoryMetaLazyQueryHookResult = ReturnType<typeof useGetRepositoryMetaLazyQuery>;
export type GetRepositoryMetaSuspenseQueryHookResult = ReturnType<typeof useGetRepositoryMetaSuspenseQuery>;
export type GetRepositoryMetaQueryResult = ApolloReactHooks.useQuery.Result<GetRepositoryMetaQuery, GetRepositoryMetaQueryVariables>;
export const OnRepositoryMetaUpdatedDocument = gql`
    subscription OnRepositoryMetaUpdated($repositoryId: UUID!) {
  onRepositoryMetaUpdated(repositoryId: $repositoryId) {
    __typename
    detectingRelationshipsCount
    failedRelationshipsCount
    unconfirmedRelationshipsCount
    missingMatchesCount
    unprocessedRelationshipDocumentsCount
  }
}
    `;

/**
 * __useOnRepositoryMetaUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnRepositoryMetaUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnRepositoryMetaUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnRepositoryMetaUpdatedSubscription({
 *   variables: {
 *      repositoryId: // value for 'repositoryId'
 *   },
 * });
 */
export function useOnRepositoryMetaUpdatedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnRepositoryMetaUpdatedSubscription, OnRepositoryMetaUpdatedSubscriptionVariables> & ({ variables: OnRepositoryMetaUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnRepositoryMetaUpdatedSubscription, OnRepositoryMetaUpdatedSubscriptionVariables>(OnRepositoryMetaUpdatedDocument, options);
      }
export type OnRepositoryMetaUpdatedSubscriptionHookResult = ReturnType<typeof useOnRepositoryMetaUpdatedSubscription>;
export type OnRepositoryMetaUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnRepositoryMetaUpdatedSubscription>;
export const GetMyDefaultRepositoryDocument = gql`
    query GetMyDefaultRepository {
  myRepository {
    ...RepositoryView
  }
}
    ${RepositoryViewFragmentDoc}`;

/**
 * __useGetMyDefaultRepositoryQuery__
 *
 * To run a query within a React component, call `useGetMyDefaultRepositoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDefaultRepositoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDefaultRepositoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyDefaultRepositoryQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetMyDefaultRepositoryQuery, GetMyDefaultRepositoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyDefaultRepositoryQuery, GetMyDefaultRepositoryQueryVariables>(GetMyDefaultRepositoryDocument, options);
      }
export function useGetMyDefaultRepositoryLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyDefaultRepositoryQuery, GetMyDefaultRepositoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyDefaultRepositoryQuery, GetMyDefaultRepositoryQueryVariables>(GetMyDefaultRepositoryDocument, options);
        }
export function useGetMyDefaultRepositorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyDefaultRepositoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyDefaultRepositoryQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyDefaultRepositoryQuery, GetMyDefaultRepositoryQueryVariables>(GetMyDefaultRepositoryDocument, options);
        }
export type GetMyDefaultRepositoryQueryHookResult = ReturnType<typeof useGetMyDefaultRepositoryQuery>;
export type GetMyDefaultRepositoryLazyQueryHookResult = ReturnType<typeof useGetMyDefaultRepositoryLazyQuery>;
export type GetMyDefaultRepositorySuspenseQueryHookResult = ReturnType<typeof useGetMyDefaultRepositorySuspenseQuery>;
export type GetMyDefaultRepositoryQueryResult = ApolloReactHooks.useQuery.Result<GetMyDefaultRepositoryQuery, GetMyDefaultRepositoryQueryVariables>;
export const VerifyCsrfTokenDocument = gql`
    query VerifyCSRFToken($token: UUID!) {
  verifyToken(token: $token) {
    ...TokenResponse
  }
}
    ${TokenResponseFragmentDoc}`;

/**
 * __useVerifyCsrfTokenQuery__
 *
 * To run a query within a React component, call `useVerifyCsrfTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyCsrfTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyCsrfTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyCsrfTokenQuery(baseOptions: ApolloReactHooks.useQuery.Options<VerifyCsrfTokenQuery, VerifyCsrfTokenQueryVariables> & ({ variables: VerifyCsrfTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VerifyCsrfTokenQuery, VerifyCsrfTokenQueryVariables>(VerifyCsrfTokenDocument, options);
      }
export function useVerifyCsrfTokenLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<VerifyCsrfTokenQuery, VerifyCsrfTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VerifyCsrfTokenQuery, VerifyCsrfTokenQueryVariables>(VerifyCsrfTokenDocument, options);
        }
export function useVerifyCsrfTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<VerifyCsrfTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<VerifyCsrfTokenQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<VerifyCsrfTokenQuery, VerifyCsrfTokenQueryVariables>(VerifyCsrfTokenDocument, options);
        }
export type VerifyCsrfTokenQueryHookResult = ReturnType<typeof useVerifyCsrfTokenQuery>;
export type VerifyCsrfTokenLazyQueryHookResult = ReturnType<typeof useVerifyCsrfTokenLazyQuery>;
export type VerifyCsrfTokenSuspenseQueryHookResult = ReturnType<typeof useVerifyCsrfTokenSuspenseQuery>;
export type VerifyCsrfTokenQueryResult = ApolloReactHooks.useQuery.Result<VerifyCsrfTokenQuery, VerifyCsrfTokenQueryVariables>;
export const GenerateCsrfTokenDocument = gql`
    mutation GenerateCSRFToken($expiry: String!) {
  generateToken(expiry: $expiry) {
    ...TokenResponse
  }
}
    ${TokenResponseFragmentDoc}`;
export type GenerateCsrfTokenMutationFn = ApolloReactHooks.useMutation.MutationFunction<GenerateCsrfTokenMutation, GenerateCsrfTokenMutationVariables>;

/**
 * __useGenerateCsrfTokenMutation__
 *
 * To run a mutation, you first call `useGenerateCsrfTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCsrfTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCsrfTokenMutation, { data, loading, error }] = useGenerateCsrfTokenMutation({
 *   variables: {
 *      expiry: // value for 'expiry'
 *   },
 * });
 */
export function useGenerateCsrfTokenMutation(baseOptions?: ApolloReactHooks.useMutation.Options<GenerateCsrfTokenMutation, GenerateCsrfTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateCsrfTokenMutation, GenerateCsrfTokenMutationVariables>(GenerateCsrfTokenDocument, options);
      }
export type GenerateCsrfTokenMutationHookResult = ReturnType<typeof useGenerateCsrfTokenMutation>;
export type GenerateCsrfTokenMutationResult = ApolloReactHooks.useMutation.Result<GenerateCsrfTokenMutation>;
export type GenerateCsrfTokenMutationOptions = ApolloReactHooks.useMutation.Options<GenerateCsrfTokenMutation, GenerateCsrfTokenMutationVariables>;
export const GetAccessRequestsByBatchIdDocument = gql`
    query GetAccessRequestsByBatchId($batchId: UUID!) {
  accessRequestsByBatchId(batchId: $batchId) {
    accessRequests {
      id
      batchId
      document {
        ...DocumentSimple
      }
      requester {
        ...UserBase
      }
      recipient {
        ...UserBase
      }
      status
      requestedRole
      grantedRole
      message
      requestedForEmails
      respondedAt
      createdAt
    }
    errorReason
  }
}
    ${DocumentSimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useGetAccessRequestsByBatchIdQuery__
 *
 * To run a query within a React component, call `useGetAccessRequestsByBatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessRequestsByBatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessRequestsByBatchIdQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useGetAccessRequestsByBatchIdQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAccessRequestsByBatchIdQuery, GetAccessRequestsByBatchIdQueryVariables> & ({ variables: GetAccessRequestsByBatchIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccessRequestsByBatchIdQuery, GetAccessRequestsByBatchIdQueryVariables>(GetAccessRequestsByBatchIdDocument, options);
      }
export function useGetAccessRequestsByBatchIdLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAccessRequestsByBatchIdQuery, GetAccessRequestsByBatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccessRequestsByBatchIdQuery, GetAccessRequestsByBatchIdQueryVariables>(GetAccessRequestsByBatchIdDocument, options);
        }
export function useGetAccessRequestsByBatchIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAccessRequestsByBatchIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAccessRequestsByBatchIdQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAccessRequestsByBatchIdQuery, GetAccessRequestsByBatchIdQueryVariables>(GetAccessRequestsByBatchIdDocument, options);
        }
export type GetAccessRequestsByBatchIdQueryHookResult = ReturnType<typeof useGetAccessRequestsByBatchIdQuery>;
export type GetAccessRequestsByBatchIdLazyQueryHookResult = ReturnType<typeof useGetAccessRequestsByBatchIdLazyQuery>;
export type GetAccessRequestsByBatchIdSuspenseQueryHookResult = ReturnType<typeof useGetAccessRequestsByBatchIdSuspenseQuery>;
export type GetAccessRequestsByBatchIdQueryResult = ApolloReactHooks.useQuery.Result<GetAccessRequestsByBatchIdQuery, GetAccessRequestsByBatchIdQueryVariables>;
export const GetMyAccessRequestsForDocumentsDocument = gql`
    query GetMyAccessRequestsForDocuments($documentIds: [UUID!]!) {
  myAccessRequestsForDocuments(documentIds: $documentIds) {
    documentId
    status
  }
}
    `;

/**
 * __useGetMyAccessRequestsForDocumentsQuery__
 *
 * To run a query within a React component, call `useGetMyAccessRequestsForDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAccessRequestsForDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAccessRequestsForDocumentsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetMyAccessRequestsForDocumentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetMyAccessRequestsForDocumentsQuery, GetMyAccessRequestsForDocumentsQueryVariables> & ({ variables: GetMyAccessRequestsForDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyAccessRequestsForDocumentsQuery, GetMyAccessRequestsForDocumentsQueryVariables>(GetMyAccessRequestsForDocumentsDocument, options);
      }
export function useGetMyAccessRequestsForDocumentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyAccessRequestsForDocumentsQuery, GetMyAccessRequestsForDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyAccessRequestsForDocumentsQuery, GetMyAccessRequestsForDocumentsQueryVariables>(GetMyAccessRequestsForDocumentsDocument, options);
        }
export function useGetMyAccessRequestsForDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyAccessRequestsForDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyAccessRequestsForDocumentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyAccessRequestsForDocumentsQuery, GetMyAccessRequestsForDocumentsQueryVariables>(GetMyAccessRequestsForDocumentsDocument, options);
        }
export type GetMyAccessRequestsForDocumentsQueryHookResult = ReturnType<typeof useGetMyAccessRequestsForDocumentsQuery>;
export type GetMyAccessRequestsForDocumentsLazyQueryHookResult = ReturnType<typeof useGetMyAccessRequestsForDocumentsLazyQuery>;
export type GetMyAccessRequestsForDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetMyAccessRequestsForDocumentsSuspenseQuery>;
export type GetMyAccessRequestsForDocumentsQueryResult = ApolloReactHooks.useQuery.Result<GetMyAccessRequestsForDocumentsQuery, GetMyAccessRequestsForDocumentsQueryVariables>;
export const GrantAccessByRequestDocument = gql`
    mutation GrantAccessByRequest($input: GrantAccessByRequestInput!) {
  grantAccessByRequest(input: $input)
}
    `;
export type GrantAccessByRequestMutationFn = ApolloReactHooks.useMutation.MutationFunction<GrantAccessByRequestMutation, GrantAccessByRequestMutationVariables>;

/**
 * __useGrantAccessByRequestMutation__
 *
 * To run a mutation, you first call `useGrantAccessByRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantAccessByRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantAccessByRequestMutation, { data, loading, error }] = useGrantAccessByRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantAccessByRequestMutation(baseOptions?: ApolloReactHooks.useMutation.Options<GrantAccessByRequestMutation, GrantAccessByRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GrantAccessByRequestMutation, GrantAccessByRequestMutationVariables>(GrantAccessByRequestDocument, options);
      }
export type GrantAccessByRequestMutationHookResult = ReturnType<typeof useGrantAccessByRequestMutation>;
export type GrantAccessByRequestMutationResult = ApolloReactHooks.useMutation.Result<GrantAccessByRequestMutation>;
export type GrantAccessByRequestMutationOptions = ApolloReactHooks.useMutation.Options<GrantAccessByRequestMutation, GrantAccessByRequestMutationVariables>;
export const GetAnnotationsDocument = gql`
    query GetAnnotations($fileVersionId: UUID!) {
  annotations(fileVersionId: $fileVersionId) {
    __typename
    id
    xfdf
  }
}
    `;

/**
 * __useGetAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationsQuery({
 *   variables: {
 *      fileVersionId: // value for 'fileVersionId'
 *   },
 * });
 */
export function useGetAnnotationsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetAnnotationsQuery, GetAnnotationsQueryVariables> & ({ variables: GetAnnotationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
      }
export function useGetAnnotationsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetAnnotationsQuery, GetAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
        }
export function useGetAnnotationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetAnnotationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetAnnotationsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
        }
export type GetAnnotationsQueryHookResult = ReturnType<typeof useGetAnnotationsQuery>;
export type GetAnnotationsLazyQueryHookResult = ReturnType<typeof useGetAnnotationsLazyQuery>;
export type GetAnnotationsSuspenseQueryHookResult = ReturnType<typeof useGetAnnotationsSuspenseQuery>;
export type GetAnnotationsQueryResult = ApolloReactHooks.useQuery.Result<GetAnnotationsQuery, GetAnnotationsQueryVariables>;
export const DeleteAnnotationsDocument = gql`
    mutation DeleteAnnotations($input: DeleteAnnotationsInput!) {
  deleteAnnotations(input: $input)
}
    `;
export type DeleteAnnotationsMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAnnotationsMutation, DeleteAnnotationsMutationVariables>;

/**
 * __useDeleteAnnotationsMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationsMutation, { data, loading, error }] = useDeleteAnnotationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnnotationsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteAnnotationsMutation, DeleteAnnotationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAnnotationsMutation, DeleteAnnotationsMutationVariables>(DeleteAnnotationsDocument, options);
      }
export type DeleteAnnotationsMutationHookResult = ReturnType<typeof useDeleteAnnotationsMutation>;
export type DeleteAnnotationsMutationResult = ApolloReactHooks.useMutation.Result<DeleteAnnotationsMutation>;
export type DeleteAnnotationsMutationOptions = ApolloReactHooks.useMutation.Options<DeleteAnnotationsMutation, DeleteAnnotationsMutationVariables>;
export const UpsertAnnotationsDocument = gql`
    mutation UpsertAnnotations($input: UpsertAnnotationsInput!) {
  upsertAnnotations(input: $input) {
    __typename
    id
    xfdf
  }
}
    `;
export type UpsertAnnotationsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpsertAnnotationsMutation, UpsertAnnotationsMutationVariables>;

/**
 * __useUpsertAnnotationsMutation__
 *
 * To run a mutation, you first call `useUpsertAnnotationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAnnotationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAnnotationsMutation, { data, loading, error }] = useUpsertAnnotationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAnnotationsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpsertAnnotationsMutation, UpsertAnnotationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertAnnotationsMutation, UpsertAnnotationsMutationVariables>(UpsertAnnotationsDocument, options);
      }
export type UpsertAnnotationsMutationHookResult = ReturnType<typeof useUpsertAnnotationsMutation>;
export type UpsertAnnotationsMutationResult = ApolloReactHooks.useMutation.Result<UpsertAnnotationsMutation>;
export type UpsertAnnotationsMutationOptions = ApolloReactHooks.useMutation.Options<UpsertAnnotationsMutation, UpsertAnnotationsMutationVariables>;
export const OnAnnotationsChangedDocument = gql`
    subscription OnAnnotationsChanged($fileVersionId: UUID!) {
  annotationsChanged(fileVersionId: $fileVersionId) {
    annotationsXFDF {
      __typename
      id
      xfdf
    }
    user {
      __typename
      id
      displayName
    }
  }
}
    `;

/**
 * __useOnAnnotationsChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnnotationsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnnotationsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnnotationsChangedSubscription({
 *   variables: {
 *      fileVersionId: // value for 'fileVersionId'
 *   },
 * });
 */
export function useOnAnnotationsChangedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnAnnotationsChangedSubscription, OnAnnotationsChangedSubscriptionVariables> & ({ variables: OnAnnotationsChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnAnnotationsChangedSubscription, OnAnnotationsChangedSubscriptionVariables>(OnAnnotationsChangedDocument, options);
      }
export type OnAnnotationsChangedSubscriptionHookResult = ReturnType<typeof useOnAnnotationsChangedSubscription>;
export type OnAnnotationsChangedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnAnnotationsChangedSubscription>;
export const GetFileDocument = gql`
    query GetFile($fileId: UUID!) {
  file(fileId: $fileId) {
    ...FileSimple
  }
}
    ${FileSimpleFragmentDoc}`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetFileQuery, GetFileQueryVariables> & ({ variables: GetFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
      }
export function useGetFileLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFileQuery, GetFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export function useGetFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFileQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileSuspenseQueryHookResult = ReturnType<typeof useGetFileSuspenseQuery>;
export type GetFileQueryResult = ApolloReactHooks.useQuery.Result<GetFileQuery, GetFileQueryVariables>;
export const GetDocumentAssetUrlDocument = gql`
    query GetDocumentAssetURL($input: DocumentAssetInput!) {
  documentAsset(input: $input) {
    __typename
    id
    filestackUrl
    handle
  }
}
    `;

/**
 * __useGetDocumentAssetUrlQuery__
 *
 * To run a query within a React component, call `useGetDocumentAssetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentAssetUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentAssetUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDocumentAssetUrlQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentAssetUrlQuery, GetDocumentAssetUrlQueryVariables> & ({ variables: GetDocumentAssetUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentAssetUrlQuery, GetDocumentAssetUrlQueryVariables>(GetDocumentAssetUrlDocument, options);
      }
export function useGetDocumentAssetUrlLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentAssetUrlQuery, GetDocumentAssetUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentAssetUrlQuery, GetDocumentAssetUrlQueryVariables>(GetDocumentAssetUrlDocument, options);
        }
export function useGetDocumentAssetUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentAssetUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentAssetUrlQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentAssetUrlQuery, GetDocumentAssetUrlQueryVariables>(GetDocumentAssetUrlDocument, options);
        }
export type GetDocumentAssetUrlQueryHookResult = ReturnType<typeof useGetDocumentAssetUrlQuery>;
export type GetDocumentAssetUrlLazyQueryHookResult = ReturnType<typeof useGetDocumentAssetUrlLazyQuery>;
export type GetDocumentAssetUrlSuspenseQueryHookResult = ReturnType<typeof useGetDocumentAssetUrlSuspenseQuery>;
export type GetDocumentAssetUrlQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentAssetUrlQuery, GetDocumentAssetUrlQueryVariables>;
export const GetFilesDocument = gql`
    query GetFiles($fileIds: [UUID!]!) {
  files(fileIds: $fileIds) {
    ...FileSimple
  }
}
    ${FileSimpleFragmentDoc}`;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useGetFilesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetFilesQuery, GetFilesQueryVariables> & ({ variables: GetFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
      }
export function useGetFilesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFilesQuery, GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
export function useGetFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFilesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<typeof useGetFilesLazyQuery>;
export type GetFilesSuspenseQueryHookResult = ReturnType<typeof useGetFilesSuspenseQuery>;
export type GetFilesQueryResult = ApolloReactHooks.useQuery.Result<GetFilesQuery, GetFilesQueryVariables>;
export const GetUploadSecurityDocument = gql`
    query GetUploadSecurity {
  uploadSecurity {
    ...FilestackUploadOptionsBase
  }
}
    ${FilestackUploadOptionsBaseFragmentDoc}`;

/**
 * __useGetUploadSecurityQuery__
 *
 * To run a query within a React component, call `useGetUploadSecurityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSecurityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSecurityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUploadSecurityQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetUploadSecurityQuery, GetUploadSecurityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadSecurityQuery, GetUploadSecurityQueryVariables>(GetUploadSecurityDocument, options);
      }
export function useGetUploadSecurityLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUploadSecurityQuery, GetUploadSecurityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadSecurityQuery, GetUploadSecurityQueryVariables>(GetUploadSecurityDocument, options);
        }
export function useGetUploadSecuritySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUploadSecurityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUploadSecurityQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUploadSecurityQuery, GetUploadSecurityQueryVariables>(GetUploadSecurityDocument, options);
        }
export type GetUploadSecurityQueryHookResult = ReturnType<typeof useGetUploadSecurityQuery>;
export type GetUploadSecurityLazyQueryHookResult = ReturnType<typeof useGetUploadSecurityLazyQuery>;
export type GetUploadSecuritySuspenseQueryHookResult = ReturnType<typeof useGetUploadSecuritySuspenseQuery>;
export type GetUploadSecurityQueryResult = ApolloReactHooks.useQuery.Result<GetUploadSecurityQuery, GetUploadSecurityQueryVariables>;
export const GetDownloadSecurityDocument = gql`
    query GetDownloadSecurity($docFileId: UUID!) {
  downloadSecurity(docFileId: $docFileId) {
    ...FilestackDownloadOptionsBase
  }
}
    ${FilestackDownloadOptionsBaseFragmentDoc}`;

/**
 * __useGetDownloadSecurityQuery__
 *
 * To run a query within a React component, call `useGetDownloadSecurityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSecurityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSecurityQuery({
 *   variables: {
 *      docFileId: // value for 'docFileId'
 *   },
 * });
 */
export function useGetDownloadSecurityQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDownloadSecurityQuery, GetDownloadSecurityQueryVariables> & ({ variables: GetDownloadSecurityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDownloadSecurityQuery, GetDownloadSecurityQueryVariables>(GetDownloadSecurityDocument, options);
      }
export function useGetDownloadSecurityLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDownloadSecurityQuery, GetDownloadSecurityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDownloadSecurityQuery, GetDownloadSecurityQueryVariables>(GetDownloadSecurityDocument, options);
        }
export function useGetDownloadSecuritySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDownloadSecurityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDownloadSecurityQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDownloadSecurityQuery, GetDownloadSecurityQueryVariables>(GetDownloadSecurityDocument, options);
        }
export type GetDownloadSecurityQueryHookResult = ReturnType<typeof useGetDownloadSecurityQuery>;
export type GetDownloadSecurityLazyQueryHookResult = ReturnType<typeof useGetDownloadSecurityLazyQuery>;
export type GetDownloadSecuritySuspenseQueryHookResult = ReturnType<typeof useGetDownloadSecuritySuspenseQuery>;
export type GetDownloadSecurityQueryResult = ApolloReactHooks.useQuery.Result<GetDownloadSecurityQuery, GetDownloadSecurityQueryVariables>;
export const GetDocumentDownloadUrlDocument = gql`
    query GetDocumentDownloadURL($documentId: UUID!) {
  getDocumentDownloadURL(documentId: $documentId)
}
    `;

/**
 * __useGetDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDownloadUrlQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentDownloadUrlQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables> & ({ variables: GetDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>(GetDocumentDownloadUrlDocument, options);
      }
export function useGetDocumentDownloadUrlLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>(GetDocumentDownloadUrlDocument, options);
        }
export function useGetDocumentDownloadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentDownloadUrlQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>(GetDocumentDownloadUrlDocument, options);
        }
export type GetDocumentDownloadUrlQueryHookResult = ReturnType<typeof useGetDocumentDownloadUrlQuery>;
export type GetDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetDocumentDownloadUrlLazyQuery>;
export type GetDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDownloadUrlSuspenseQuery>;
export type GetDocumentDownloadUrlQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>;
export const GetFileVersionDownloadUrlDocument = gql`
    query GetFileVersionDownloadURL($fileVersionId: UUID!) {
  getFileVersionDownloadURL(fileVersionId: $fileVersionId)
}
    `;

/**
 * __useGetFileVersionDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetFileVersionDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileVersionDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileVersionDownloadUrlQuery({
 *   variables: {
 *      fileVersionId: // value for 'fileVersionId'
 *   },
 * });
 */
export function useGetFileVersionDownloadUrlQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetFileVersionDownloadUrlQuery, GetFileVersionDownloadUrlQueryVariables> & ({ variables: GetFileVersionDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFileVersionDownloadUrlQuery, GetFileVersionDownloadUrlQueryVariables>(GetFileVersionDownloadUrlDocument, options);
      }
export function useGetFileVersionDownloadUrlLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFileVersionDownloadUrlQuery, GetFileVersionDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFileVersionDownloadUrlQuery, GetFileVersionDownloadUrlQueryVariables>(GetFileVersionDownloadUrlDocument, options);
        }
export function useGetFileVersionDownloadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFileVersionDownloadUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFileVersionDownloadUrlQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFileVersionDownloadUrlQuery, GetFileVersionDownloadUrlQueryVariables>(GetFileVersionDownloadUrlDocument, options);
        }
export type GetFileVersionDownloadUrlQueryHookResult = ReturnType<typeof useGetFileVersionDownloadUrlQuery>;
export type GetFileVersionDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetFileVersionDownloadUrlLazyQuery>;
export type GetFileVersionDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetFileVersionDownloadUrlSuspenseQuery>;
export type GetFileVersionDownloadUrlQueryResult = ApolloReactHooks.useQuery.Result<GetFileVersionDownloadUrlQuery, GetFileVersionDownloadUrlQueryVariables>;
export const CreateDocFileDocument = gql`
    mutation CreateDocFile($input: CreateDocFileLocationInput!) {
  createDocFile(input: $input) {
    ...DocumentSimple
  }
}
    ${DocumentSimpleFragmentDoc}`;
export type CreateDocFileMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateDocFileMutation, CreateDocFileMutationVariables>;

/**
 * __useCreateDocFileMutation__
 *
 * To run a mutation, you first call `useCreateDocFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocFileMutation, { data, loading, error }] = useCreateDocFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocFileMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateDocFileMutation, CreateDocFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocFileMutation, CreateDocFileMutationVariables>(CreateDocFileDocument, options);
      }
export type CreateDocFileMutationHookResult = ReturnType<typeof useCreateDocFileMutation>;
export type CreateDocFileMutationResult = ApolloReactHooks.useMutation.Result<CreateDocFileMutation>;
export type CreateDocFileMutationOptions = ApolloReactHooks.useMutation.Options<CreateDocFileMutation, CreateDocFileMutationVariables>;
export const CreateFilesDocument = gql`
    mutation CreateFiles($input: CreateFilesInput!) {
  createFiles(input: $input) {
    __typename
    id
    variant
    name
    isSigned
    latestVersion {
      __typename
      ... on StaticFileVersion {
        id
        fileLocation {
          mimetype
        }
      }
      ... on DocumentVersion {
        id
      }
    }
  }
}
    `;
export type CreateFilesMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateFilesMutation, CreateFilesMutationVariables>;

/**
 * __useCreateFilesMutation__
 *
 * To run a mutation, you first call `useCreateFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFilesMutation, { data, loading, error }] = useCreateFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFilesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateFilesMutation, CreateFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFilesMutation, CreateFilesMutationVariables>(CreateFilesDocument, options);
      }
export type CreateFilesMutationHookResult = ReturnType<typeof useCreateFilesMutation>;
export type CreateFilesMutationResult = ApolloReactHooks.useMutation.Result<CreateFilesMutation>;
export type CreateFilesMutationOptions = ApolloReactHooks.useMutation.Options<CreateFilesMutation, CreateFilesMutationVariables>;
export const CreateFileLocationsDocument = gql`
    mutation CreateFileLocations($input: CreateFileLocationsInput!) {
  createFileLocations(input: $input) {
    ...FileSimple
  }
}
    ${FileSimpleFragmentDoc}`;
export type CreateFileLocationsMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateFileLocationsMutation, CreateFileLocationsMutationVariables>;

/**
 * __useCreateFileLocationsMutation__
 *
 * To run a mutation, you first call `useCreateFileLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileLocationsMutation, { data, loading, error }] = useCreateFileLocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileLocationsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateFileLocationsMutation, CreateFileLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFileLocationsMutation, CreateFileLocationsMutationVariables>(CreateFileLocationsDocument, options);
      }
export type CreateFileLocationsMutationHookResult = ReturnType<typeof useCreateFileLocationsMutation>;
export type CreateFileLocationsMutationResult = ApolloReactHooks.useMutation.Result<CreateFileLocationsMutation>;
export type CreateFileLocationsMutationOptions = ApolloReactHooks.useMutation.Options<CreateFileLocationsMutation, CreateFileLocationsMutationVariables>;
export const ConfirmDocumentRelationshipDocument = gql`
    mutation ConfirmDocumentRelationship($id: UUID!) {
  confirmDocumentRelationship(id: $id) {
    ...RelationshipCacheFields
  }
}
    ${RelationshipCacheFieldsFragmentDoc}`;
export type ConfirmDocumentRelationshipMutationFn = ApolloReactHooks.useMutation.MutationFunction<ConfirmDocumentRelationshipMutation, ConfirmDocumentRelationshipMutationVariables>;

/**
 * __useConfirmDocumentRelationshipMutation__
 *
 * To run a mutation, you first call `useConfirmDocumentRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDocumentRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDocumentRelationshipMutation, { data, loading, error }] = useConfirmDocumentRelationshipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmDocumentRelationshipMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ConfirmDocumentRelationshipMutation, ConfirmDocumentRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmDocumentRelationshipMutation, ConfirmDocumentRelationshipMutationVariables>(ConfirmDocumentRelationshipDocument, options);
      }
export type ConfirmDocumentRelationshipMutationHookResult = ReturnType<typeof useConfirmDocumentRelationshipMutation>;
export type ConfirmDocumentRelationshipMutationResult = ApolloReactHooks.useMutation.Result<ConfirmDocumentRelationshipMutation>;
export type ConfirmDocumentRelationshipMutationOptions = ApolloReactHooks.useMutation.Options<ConfirmDocumentRelationshipMutation, ConfirmDocumentRelationshipMutationVariables>;
export const OnDocumentRelationshipUpdatedDocument = gql`
    subscription OnDocumentRelationshipUpdated {
  documentRelationshipUpdated {
    ...RelationshipCacheFields
  }
}
    ${RelationshipCacheFieldsFragmentDoc}`;

/**
 * __useOnDocumentRelationshipUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnDocumentRelationshipUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDocumentRelationshipUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDocumentRelationshipUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDocumentRelationshipUpdatedSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnDocumentRelationshipUpdatedSubscription, OnDocumentRelationshipUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnDocumentRelationshipUpdatedSubscription, OnDocumentRelationshipUpdatedSubscriptionVariables>(OnDocumentRelationshipUpdatedDocument, options);
      }
export type OnDocumentRelationshipUpdatedSubscriptionHookResult = ReturnType<typeof useOnDocumentRelationshipUpdatedSubscription>;
export type OnDocumentRelationshipUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnDocumentRelationshipUpdatedSubscription>;
export const BulkCreateDocumentRelationshipsDocument = gql`
    mutation BulkCreateDocumentRelationships($items: [BulkCreateDocumentRelationshipItem!]!) {
  bulkCreateDocumentRelationships(items: $items) {
    ...DocumentFileDetailsRelationship
  }
}
    ${DocumentFileDetailsRelationshipFragmentDoc}`;
export type BulkCreateDocumentRelationshipsMutationFn = ApolloReactHooks.useMutation.MutationFunction<BulkCreateDocumentRelationshipsMutation, BulkCreateDocumentRelationshipsMutationVariables>;

/**
 * __useBulkCreateDocumentRelationshipsMutation__
 *
 * To run a mutation, you first call `useBulkCreateDocumentRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateDocumentRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateDocumentRelationshipsMutation, { data, loading, error }] = useBulkCreateDocumentRelationshipsMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useBulkCreateDocumentRelationshipsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<BulkCreateDocumentRelationshipsMutation, BulkCreateDocumentRelationshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkCreateDocumentRelationshipsMutation, BulkCreateDocumentRelationshipsMutationVariables>(BulkCreateDocumentRelationshipsDocument, options);
      }
export type BulkCreateDocumentRelationshipsMutationHookResult = ReturnType<typeof useBulkCreateDocumentRelationshipsMutation>;
export type BulkCreateDocumentRelationshipsMutationResult = ApolloReactHooks.useMutation.Result<BulkCreateDocumentRelationshipsMutation>;
export type BulkCreateDocumentRelationshipsMutationOptions = ApolloReactHooks.useMutation.Options<BulkCreateDocumentRelationshipsMutation, BulkCreateDocumentRelationshipsMutationVariables>;
export const CreateDocumentRelationshipDocument = gql`
    mutation CreateDocumentRelationship($parentDocumentId: UUID!, $childDocumentId: UUID!, $childRelationshipType: ChildRelationshipType!) {
  createDocumentRelationship(
    parentDocumentId: $parentDocumentId
    childDocumentId: $childDocumentId
    childRelationshipType: $childRelationshipType
  ) {
    id
    parentDocumentId
    childDocumentId
    childRelationshipType
    source
    review {
      __typename
      outcome
      reviewedBy {
        id
        displayName
      }
    }
    llmReasonsMarkdown
    parentDocument {
      __typename
      id
      name
      variant
      latestVersion {
        __typename
        ... on StaticFileVersion {
          id
          fileLocation {
            mimetype
          }
        }
        ... on DocumentVersion {
          id
        }
      }
    }
    childDocument {
      __typename
      id
      name
      variant
      latestVersion {
        __typename
        ... on StaticFileVersion {
          id
          fileLocation {
            mimetype
          }
        }
        ... on DocumentVersion {
          id
        }
      }
    }
    createdAt
  }
}
    `;
export type CreateDocumentRelationshipMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateDocumentRelationshipMutation, CreateDocumentRelationshipMutationVariables>;

/**
 * __useCreateDocumentRelationshipMutation__
 *
 * To run a mutation, you first call `useCreateDocumentRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentRelationshipMutation, { data, loading, error }] = useCreateDocumentRelationshipMutation({
 *   variables: {
 *      parentDocumentId: // value for 'parentDocumentId'
 *      childDocumentId: // value for 'childDocumentId'
 *      childRelationshipType: // value for 'childRelationshipType'
 *   },
 * });
 */
export function useCreateDocumentRelationshipMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateDocumentRelationshipMutation, CreateDocumentRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocumentRelationshipMutation, CreateDocumentRelationshipMutationVariables>(CreateDocumentRelationshipDocument, options);
      }
export type CreateDocumentRelationshipMutationHookResult = ReturnType<typeof useCreateDocumentRelationshipMutation>;
export type CreateDocumentRelationshipMutationResult = ApolloReactHooks.useMutation.Result<CreateDocumentRelationshipMutation>;
export type CreateDocumentRelationshipMutationOptions = ApolloReactHooks.useMutation.Options<CreateDocumentRelationshipMutation, CreateDocumentRelationshipMutationVariables>;
export const RejectDocumentRelationshipDocument = gql`
    mutation RejectDocumentRelationship($id: UUID!) {
  rejectDocumentRelationship(id: $id) {
    ...RelationshipCacheFields
  }
}
    ${RelationshipCacheFieldsFragmentDoc}`;
export type RejectDocumentRelationshipMutationFn = ApolloReactHooks.useMutation.MutationFunction<RejectDocumentRelationshipMutation, RejectDocumentRelationshipMutationVariables>;

/**
 * __useRejectDocumentRelationshipMutation__
 *
 * To run a mutation, you first call `useRejectDocumentRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectDocumentRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectDocumentRelationshipMutation, { data, loading, error }] = useRejectDocumentRelationshipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectDocumentRelationshipMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RejectDocumentRelationshipMutation, RejectDocumentRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectDocumentRelationshipMutation, RejectDocumentRelationshipMutationVariables>(RejectDocumentRelationshipDocument, options);
      }
export type RejectDocumentRelationshipMutationHookResult = ReturnType<typeof useRejectDocumentRelationshipMutation>;
export type RejectDocumentRelationshipMutationResult = ApolloReactHooks.useMutation.Result<RejectDocumentRelationshipMutation>;
export type RejectDocumentRelationshipMutationOptions = ApolloReactHooks.useMutation.Options<RejectDocumentRelationshipMutation, RejectDocumentRelationshipMutationVariables>;
export const DeleteDocumentRelationshipDocument = gql`
    mutation DeleteDocumentRelationship($id: UUID!) {
  deleteDocumentRelationship(id: $id)
}
    `;
export type DeleteDocumentRelationshipMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteDocumentRelationshipMutation, DeleteDocumentRelationshipMutationVariables>;

/**
 * __useDeleteDocumentRelationshipMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentRelationshipMutation, { data, loading, error }] = useDeleteDocumentRelationshipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentRelationshipMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteDocumentRelationshipMutation, DeleteDocumentRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDocumentRelationshipMutation, DeleteDocumentRelationshipMutationVariables>(DeleteDocumentRelationshipDocument, options);
      }
export type DeleteDocumentRelationshipMutationHookResult = ReturnType<typeof useDeleteDocumentRelationshipMutation>;
export type DeleteDocumentRelationshipMutationResult = ApolloReactHooks.useMutation.Result<DeleteDocumentRelationshipMutation>;
export type DeleteDocumentRelationshipMutationOptions = ApolloReactHooks.useMutation.Options<DeleteDocumentRelationshipMutation, DeleteDocumentRelationshipMutationVariables>;
export const SetDocumentRelationshipParentAndConfirmDocument = gql`
    mutation SetDocumentRelationshipParentAndConfirm($id: UUID!, $parentDocumentId: UUID!) {
  setDocumentRelationshipParentAndConfirm(
    id: $id
    parentDocumentId: $parentDocumentId
  ) {
    ...RelationshipCacheFields
    parentDocument {
      ...DocumentFileDetailsRelatedDocument
    }
  }
}
    ${RelationshipCacheFieldsFragmentDoc}
${DocumentFileDetailsRelatedDocumentFragmentDoc}`;
export type SetDocumentRelationshipParentAndConfirmMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetDocumentRelationshipParentAndConfirmMutation, SetDocumentRelationshipParentAndConfirmMutationVariables>;

/**
 * __useSetDocumentRelationshipParentAndConfirmMutation__
 *
 * To run a mutation, you first call `useSetDocumentRelationshipParentAndConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentRelationshipParentAndConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentRelationshipParentAndConfirmMutation, { data, loading, error }] = useSetDocumentRelationshipParentAndConfirmMutation({
 *   variables: {
 *      id: // value for 'id'
 *      parentDocumentId: // value for 'parentDocumentId'
 *   },
 * });
 */
export function useSetDocumentRelationshipParentAndConfirmMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetDocumentRelationshipParentAndConfirmMutation, SetDocumentRelationshipParentAndConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDocumentRelationshipParentAndConfirmMutation, SetDocumentRelationshipParentAndConfirmMutationVariables>(SetDocumentRelationshipParentAndConfirmDocument, options);
      }
export type SetDocumentRelationshipParentAndConfirmMutationHookResult = ReturnType<typeof useSetDocumentRelationshipParentAndConfirmMutation>;
export type SetDocumentRelationshipParentAndConfirmMutationResult = ApolloReactHooks.useMutation.Result<SetDocumentRelationshipParentAndConfirmMutation>;
export type SetDocumentRelationshipParentAndConfirmMutationOptions = ApolloReactHooks.useMutation.Options<SetDocumentRelationshipParentAndConfirmMutation, SetDocumentRelationshipParentAndConfirmMutationVariables>;
export const SetDocumentRelationshipChildAndConfirmDocument = gql`
    mutation SetDocumentRelationshipChildAndConfirm($id: UUID!, $childDocumentId: UUID!) {
  setDocumentRelationshipChildAndConfirm(
    id: $id
    childDocumentId: $childDocumentId
  ) {
    ...RelationshipCacheFields
    childDocument {
      ...DocumentFileDetailsRelatedDocument
    }
  }
}
    ${RelationshipCacheFieldsFragmentDoc}
${DocumentFileDetailsRelatedDocumentFragmentDoc}`;
export type SetDocumentRelationshipChildAndConfirmMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetDocumentRelationshipChildAndConfirmMutation, SetDocumentRelationshipChildAndConfirmMutationVariables>;

/**
 * __useSetDocumentRelationshipChildAndConfirmMutation__
 *
 * To run a mutation, you first call `useSetDocumentRelationshipChildAndConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentRelationshipChildAndConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentRelationshipChildAndConfirmMutation, { data, loading, error }] = useSetDocumentRelationshipChildAndConfirmMutation({
 *   variables: {
 *      id: // value for 'id'
 *      childDocumentId: // value for 'childDocumentId'
 *   },
 * });
 */
export function useSetDocumentRelationshipChildAndConfirmMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetDocumentRelationshipChildAndConfirmMutation, SetDocumentRelationshipChildAndConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDocumentRelationshipChildAndConfirmMutation, SetDocumentRelationshipChildAndConfirmMutationVariables>(SetDocumentRelationshipChildAndConfirmDocument, options);
      }
export type SetDocumentRelationshipChildAndConfirmMutationHookResult = ReturnType<typeof useSetDocumentRelationshipChildAndConfirmMutation>;
export type SetDocumentRelationshipChildAndConfirmMutationResult = ApolloReactHooks.useMutation.Result<SetDocumentRelationshipChildAndConfirmMutation>;
export type SetDocumentRelationshipChildAndConfirmMutationOptions = ApolloReactHooks.useMutation.Options<SetDocumentRelationshipChildAndConfirmMutation, SetDocumentRelationshipChildAndConfirmMutationVariables>;
export const UpdateDocumentRelationshipTypeDocument = gql`
    mutation UpdateDocumentRelationshipType($id: UUID!, $childRelationshipType: ChildRelationshipType!) {
  updateDocumentRelationshipType(
    id: $id
    childRelationshipType: $childRelationshipType
  ) {
    ...RelationshipCacheFields
  }
}
    ${RelationshipCacheFieldsFragmentDoc}`;
export type UpdateDocumentRelationshipTypeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateDocumentRelationshipTypeMutation, UpdateDocumentRelationshipTypeMutationVariables>;

/**
 * __useUpdateDocumentRelationshipTypeMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentRelationshipTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentRelationshipTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentRelationshipTypeMutation, { data, loading, error }] = useUpdateDocumentRelationshipTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      childRelationshipType: // value for 'childRelationshipType'
 *   },
 * });
 */
export function useUpdateDocumentRelationshipTypeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateDocumentRelationshipTypeMutation, UpdateDocumentRelationshipTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentRelationshipTypeMutation, UpdateDocumentRelationshipTypeMutationVariables>(UpdateDocumentRelationshipTypeDocument, options);
      }
export type UpdateDocumentRelationshipTypeMutationHookResult = ReturnType<typeof useUpdateDocumentRelationshipTypeMutation>;
export type UpdateDocumentRelationshipTypeMutationResult = ApolloReactHooks.useMutation.Result<UpdateDocumentRelationshipTypeMutation>;
export type UpdateDocumentRelationshipTypeMutationOptions = ApolloReactHooks.useMutation.Options<UpdateDocumentRelationshipTypeMutation, UpdateDocumentRelationshipTypeMutationVariables>;
export const RestoreDocumentRelationshipDocument = gql`
    mutation RestoreDocumentRelationship($id: UUID!) {
  restoreDocumentRelationship(id: $id) {
    ...RelationshipCacheFields
  }
}
    ${RelationshipCacheFieldsFragmentDoc}`;
export type RestoreDocumentRelationshipMutationFn = ApolloReactHooks.useMutation.MutationFunction<RestoreDocumentRelationshipMutation, RestoreDocumentRelationshipMutationVariables>;

/**
 * __useRestoreDocumentRelationshipMutation__
 *
 * To run a mutation, you first call `useRestoreDocumentRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDocumentRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDocumentRelationshipMutation, { data, loading, error }] = useRestoreDocumentRelationshipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreDocumentRelationshipMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RestoreDocumentRelationshipMutation, RestoreDocumentRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreDocumentRelationshipMutation, RestoreDocumentRelationshipMutationVariables>(RestoreDocumentRelationshipDocument, options);
      }
export type RestoreDocumentRelationshipMutationHookResult = ReturnType<typeof useRestoreDocumentRelationshipMutation>;
export type RestoreDocumentRelationshipMutationResult = ApolloReactHooks.useMutation.Result<RestoreDocumentRelationshipMutation>;
export type RestoreDocumentRelationshipMutationOptions = ApolloReactHooks.useMutation.Options<RestoreDocumentRelationshipMutation, RestoreDocumentRelationshipMutationVariables>;
export const BulkConfirmDocumentRelationshipsDocument = gql`
    mutation BulkConfirmDocumentRelationships($input: BulkReviewRelationshipsInput!) {
  bulkConfirmDocumentRelationships(input: $input) {
    updatedRelationships {
      ...RelationshipCacheFields
    }
    skippedCount
  }
}
    ${RelationshipCacheFieldsFragmentDoc}`;
export type BulkConfirmDocumentRelationshipsMutationFn = ApolloReactHooks.useMutation.MutationFunction<BulkConfirmDocumentRelationshipsMutation, BulkConfirmDocumentRelationshipsMutationVariables>;

/**
 * __useBulkConfirmDocumentRelationshipsMutation__
 *
 * To run a mutation, you first call `useBulkConfirmDocumentRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkConfirmDocumentRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkConfirmDocumentRelationshipsMutation, { data, loading, error }] = useBulkConfirmDocumentRelationshipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkConfirmDocumentRelationshipsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<BulkConfirmDocumentRelationshipsMutation, BulkConfirmDocumentRelationshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkConfirmDocumentRelationshipsMutation, BulkConfirmDocumentRelationshipsMutationVariables>(BulkConfirmDocumentRelationshipsDocument, options);
      }
export type BulkConfirmDocumentRelationshipsMutationHookResult = ReturnType<typeof useBulkConfirmDocumentRelationshipsMutation>;
export type BulkConfirmDocumentRelationshipsMutationResult = ApolloReactHooks.useMutation.Result<BulkConfirmDocumentRelationshipsMutation>;
export type BulkConfirmDocumentRelationshipsMutationOptions = ApolloReactHooks.useMutation.Options<BulkConfirmDocumentRelationshipsMutation, BulkConfirmDocumentRelationshipsMutationVariables>;
export const BulkRejectDocumentRelationshipsDocument = gql`
    mutation BulkRejectDocumentRelationships($input: BulkReviewRelationshipsInput!) {
  bulkRejectDocumentRelationships(input: $input) {
    updatedRelationships {
      ...RelationshipCacheFields
    }
    skippedCount
  }
}
    ${RelationshipCacheFieldsFragmentDoc}`;
export type BulkRejectDocumentRelationshipsMutationFn = ApolloReactHooks.useMutation.MutationFunction<BulkRejectDocumentRelationshipsMutation, BulkRejectDocumentRelationshipsMutationVariables>;

/**
 * __useBulkRejectDocumentRelationshipsMutation__
 *
 * To run a mutation, you first call `useBulkRejectDocumentRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRejectDocumentRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRejectDocumentRelationshipsMutation, { data, loading, error }] = useBulkRejectDocumentRelationshipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkRejectDocumentRelationshipsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<BulkRejectDocumentRelationshipsMutation, BulkRejectDocumentRelationshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkRejectDocumentRelationshipsMutation, BulkRejectDocumentRelationshipsMutationVariables>(BulkRejectDocumentRelationshipsDocument, options);
      }
export type BulkRejectDocumentRelationshipsMutationHookResult = ReturnType<typeof useBulkRejectDocumentRelationshipsMutation>;
export type BulkRejectDocumentRelationshipsMutationResult = ApolloReactHooks.useMutation.Result<BulkRejectDocumentRelationshipsMutation>;
export type BulkRejectDocumentRelationshipsMutationOptions = ApolloReactHooks.useMutation.Options<BulkRejectDocumentRelationshipsMutation, BulkRejectDocumentRelationshipsMutationVariables>;
export const SetParentChildRelationshipsEnabledDocument = gql`
    mutation SetParentChildRelationshipsEnabled($enabled: Boolean!) {
  setParentChildRelationshipsEnabled(enabled: $enabled) {
    __typename
    id
    parentChildEnabled
  }
}
    `;
export type SetParentChildRelationshipsEnabledMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetParentChildRelationshipsEnabledMutation, SetParentChildRelationshipsEnabledMutationVariables>;

/**
 * __useSetParentChildRelationshipsEnabledMutation__
 *
 * To run a mutation, you first call `useSetParentChildRelationshipsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetParentChildRelationshipsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setParentChildRelationshipsEnabledMutation, { data, loading, error }] = useSetParentChildRelationshipsEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetParentChildRelationshipsEnabledMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetParentChildRelationshipsEnabledMutation, SetParentChildRelationshipsEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetParentChildRelationshipsEnabledMutation, SetParentChildRelationshipsEnabledMutationVariables>(SetParentChildRelationshipsEnabledDocument, options);
      }
export type SetParentChildRelationshipsEnabledMutationHookResult = ReturnType<typeof useSetParentChildRelationshipsEnabledMutation>;
export type SetParentChildRelationshipsEnabledMutationResult = ApolloReactHooks.useMutation.Result<SetParentChildRelationshipsEnabledMutation>;
export type SetParentChildRelationshipsEnabledMutationOptions = ApolloReactHooks.useMutation.Options<SetParentChildRelationshipsEnabledMutation, SetParentChildRelationshipsEnabledMutationVariables>;
export const RetryFailedDocumentRelationshipsDocument = gql`
    mutation RetryFailedDocumentRelationships {
  retryFailedDocumentRelationships
}
    `;
export type RetryFailedDocumentRelationshipsMutationFn = ApolloReactHooks.useMutation.MutationFunction<RetryFailedDocumentRelationshipsMutation, RetryFailedDocumentRelationshipsMutationVariables>;

/**
 * __useRetryFailedDocumentRelationshipsMutation__
 *
 * To run a mutation, you first call `useRetryFailedDocumentRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFailedDocumentRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFailedDocumentRelationshipsMutation, { data, loading, error }] = useRetryFailedDocumentRelationshipsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRetryFailedDocumentRelationshipsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RetryFailedDocumentRelationshipsMutation, RetryFailedDocumentRelationshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RetryFailedDocumentRelationshipsMutation, RetryFailedDocumentRelationshipsMutationVariables>(RetryFailedDocumentRelationshipsDocument, options);
      }
export type RetryFailedDocumentRelationshipsMutationHookResult = ReturnType<typeof useRetryFailedDocumentRelationshipsMutation>;
export type RetryFailedDocumentRelationshipsMutationResult = ApolloReactHooks.useMutation.Result<RetryFailedDocumentRelationshipsMutation>;
export type RetryFailedDocumentRelationshipsMutationOptions = ApolloReactHooks.useMutation.Options<RetryFailedDocumentRelationshipsMutation, RetryFailedDocumentRelationshipsMutationVariables>;
export const DuplicateTemplateDocument = gql`
    mutation DuplicateTemplate($input: DuplicateTemplateInput!) {
  duplicateTemplate(input: $input) {
    document {
      __typename
      id
      name
      isCommunityTemplate
      owner {
        __typename
        id
        email
      }
    }
  }
}
    `;
export type DuplicateTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<DuplicateTemplateMutation, DuplicateTemplateMutationVariables>;

/**
 * __useDuplicateTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTemplateMutation, { data, loading, error }] = useDuplicateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DuplicateTemplateMutation, DuplicateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateTemplateMutation, DuplicateTemplateMutationVariables>(DuplicateTemplateDocument, options);
      }
export type DuplicateTemplateMutationHookResult = ReturnType<typeof useDuplicateTemplateMutation>;
export type DuplicateTemplateMutationResult = ApolloReactHooks.useMutation.Result<DuplicateTemplateMutation>;
export type DuplicateTemplateMutationOptions = ApolloReactHooks.useMutation.Options<DuplicateTemplateMutation, DuplicateTemplateMutationVariables>;
export const GetDocumentIsInternalOnWorkflowDocument = gql`
    query GetDocumentIsInternalOnWorkflow($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    isInternalOnWorkflow
  }
}
    `;

/**
 * __useGetDocumentIsInternalOnWorkflowQuery__
 *
 * To run a query within a React component, call `useGetDocumentIsInternalOnWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentIsInternalOnWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentIsInternalOnWorkflowQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentIsInternalOnWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentIsInternalOnWorkflowQuery, GetDocumentIsInternalOnWorkflowQueryVariables> & ({ variables: GetDocumentIsInternalOnWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentIsInternalOnWorkflowQuery, GetDocumentIsInternalOnWorkflowQueryVariables>(GetDocumentIsInternalOnWorkflowDocument, options);
      }
export function useGetDocumentIsInternalOnWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentIsInternalOnWorkflowQuery, GetDocumentIsInternalOnWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentIsInternalOnWorkflowQuery, GetDocumentIsInternalOnWorkflowQueryVariables>(GetDocumentIsInternalOnWorkflowDocument, options);
        }
export function useGetDocumentIsInternalOnWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentIsInternalOnWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentIsInternalOnWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentIsInternalOnWorkflowQuery, GetDocumentIsInternalOnWorkflowQueryVariables>(GetDocumentIsInternalOnWorkflowDocument, options);
        }
export type GetDocumentIsInternalOnWorkflowQueryHookResult = ReturnType<typeof useGetDocumentIsInternalOnWorkflowQuery>;
export type GetDocumentIsInternalOnWorkflowLazyQueryHookResult = ReturnType<typeof useGetDocumentIsInternalOnWorkflowLazyQuery>;
export type GetDocumentIsInternalOnWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetDocumentIsInternalOnWorkflowSuspenseQuery>;
export type GetDocumentIsInternalOnWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentIsInternalOnWorkflowQuery, GetDocumentIsInternalOnWorkflowQueryVariables>;
export const GetDocumentDocument = gql`
    query GetDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    description
    forwardingPermissionRole
    requesterFavorited
    name
    status
    requesterRole
    storableType
    variant
    isCommunityTemplate
    isCertificate
    isSigned
    createdAt
    updatedAt
    deletedAt
    coreAiPropertiesExtractionStartedAt
    coreAiPropertiesExtractionFinishedAt
    coreAiPropertiesExtractionFailedAt
    conversionStartedAt
    conversionFinishedAt
    conversionFailedAt
    comments {
      ...CommentFieldsBase
    }
    latestVersion {
      ...FileVersionSimple
      ... on DocumentVersion {
        documentJSON
      }
    }
    type {
      __typename
      id
      value
    }
    owner {
      ...UserBase
    }
    parties {
      ...PartySimple
    }
    signatureFields {
      ...SignatureFieldSimple
    }
    variables {
      ...DocumentVariableFull
    }
    workflow {
      __typename
      name
      id
      state
      envelopeStatus
    }
  }
}
    ${CommentFieldsBaseFragmentDoc}
${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}
${PartySimpleFragmentDoc}
${SignatureFieldSimpleFragmentDoc}
${DocumentVariableFullFragmentDoc}`;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentQuery, GetDocumentQueryVariables> & ({ variables: GetDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
      }
export function useGetDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export function useGetDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocumentLazyQuery>;
export type GetDocumentSuspenseQueryHookResult = ReturnType<typeof useGetDocumentSuspenseQuery>;
export type GetDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentQuery, GetDocumentQueryVariables>;
export const GetEditorDocumentDocument = gql`
    query GetEditorDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    isCertificate
    isSigned
    requesterRole
    variant
    name
    latestVersion {
      __typename
      ... on DocumentVersion {
        id
      }
      ... on StaticFileVersion {
        id
        fileLocation {
          __typename
          mimetype
        }
      }
    }
    workflow {
      id
      linkedOpportunities {
        __typename
        id
        integration
      }
      state
    }
    envelope {
      __typename
      id
      variant
      recipients {
        __typename
        id
        status
        type
        assignee {
          __typename
          id
        }
      }
    }
    owner {
      __typename
      id
    }
  }
}
    `;

/**
 * __useGetEditorDocumentQuery__
 *
 * To run a query within a React component, call `useGetEditorDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditorDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditorDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditorDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetEditorDocumentQuery, GetEditorDocumentQueryVariables> & ({ variables: GetEditorDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEditorDocumentQuery, GetEditorDocumentQueryVariables>(GetEditorDocumentDocument, options);
      }
export function useGetEditorDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetEditorDocumentQuery, GetEditorDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEditorDocumentQuery, GetEditorDocumentQueryVariables>(GetEditorDocumentDocument, options);
        }
export function useGetEditorDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetEditorDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetEditorDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetEditorDocumentQuery, GetEditorDocumentQueryVariables>(GetEditorDocumentDocument, options);
        }
export type GetEditorDocumentQueryHookResult = ReturnType<typeof useGetEditorDocumentQuery>;
export type GetEditorDocumentLazyQueryHookResult = ReturnType<typeof useGetEditorDocumentLazyQuery>;
export type GetEditorDocumentSuspenseQueryHookResult = ReturnType<typeof useGetEditorDocumentSuspenseQuery>;
export type GetEditorDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetEditorDocumentQuery, GetEditorDocumentQueryVariables>;
export const GetDocumentSimpleDocument = gql`
    query GetDocumentSimple($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    description
    variant
    isCommunityTemplate
    forwardingPermissionRole
    requesterRole
    requesterFavorited
    status
    owner {
      __typename
      id
    }
  }
}
    `;

/**
 * __useGetDocumentSimpleQuery__
 *
 * To run a query within a React component, call `useGetDocumentSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentSimpleQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentSimpleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentSimpleQuery, GetDocumentSimpleQueryVariables> & ({ variables: GetDocumentSimpleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentSimpleQuery, GetDocumentSimpleQueryVariables>(GetDocumentSimpleDocument, options);
      }
export function useGetDocumentSimpleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentSimpleQuery, GetDocumentSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentSimpleQuery, GetDocumentSimpleQueryVariables>(GetDocumentSimpleDocument, options);
        }
export function useGetDocumentSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentSimpleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentSimpleQuery, GetDocumentSimpleQueryVariables>(GetDocumentSimpleDocument, options);
        }
export type GetDocumentSimpleQueryHookResult = ReturnType<typeof useGetDocumentSimpleQuery>;
export type GetDocumentSimpleLazyQueryHookResult = ReturnType<typeof useGetDocumentSimpleLazyQuery>;
export type GetDocumentSimpleSuspenseQueryHookResult = ReturnType<typeof useGetDocumentSimpleSuspenseQuery>;
export type GetDocumentSimpleQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentSimpleQuery, GetDocumentSimpleQueryVariables>;
export const GetReportDocumentDocument = gql`
    query GetReportDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    createdAt
    deletedAt
    id
    name
    requesterFavorited
    status
    signedAt
    updatedAt
    labels {
      ...LabelSimple
    }
    owner {
      ...UserBase
    }
    parties {
      ...PartySimple
    }
    type {
      ...ContractTypeSimple
    }
  }
}
    ${LabelSimpleFragmentDoc}
${UserBaseFragmentDoc}
${PartySimpleFragmentDoc}
${ContractTypeSimpleFragmentDoc}`;

/**
 * __useGetReportDocumentQuery__
 *
 * To run a query within a React component, call `useGetReportDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetReportDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetReportDocumentQuery, GetReportDocumentQueryVariables> & ({ variables: GetReportDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportDocumentQuery, GetReportDocumentQueryVariables>(GetReportDocumentDocument, options);
      }
export function useGetReportDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetReportDocumentQuery, GetReportDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportDocumentQuery, GetReportDocumentQueryVariables>(GetReportDocumentDocument, options);
        }
export function useGetReportDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetReportDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetReportDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetReportDocumentQuery, GetReportDocumentQueryVariables>(GetReportDocumentDocument, options);
        }
export type GetReportDocumentQueryHookResult = ReturnType<typeof useGetReportDocumentQuery>;
export type GetReportDocumentLazyQueryHookResult = ReturnType<typeof useGetReportDocumentLazyQuery>;
export type GetReportDocumentSuspenseQueryHookResult = ReturnType<typeof useGetReportDocumentSuspenseQuery>;
export type GetReportDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetReportDocumentQuery, GetReportDocumentQueryVariables>;
export const GetDocumentPartsDocument = gql`
    query GetDocumentParts($documentId: UUID!) {
  documentParts(documentId: $documentId) {
    __typename
    assets {
      __typename
      id
      filestackUrl
    }
    authors {
      ...UserBase
    }
    comments {
      ...CommentSimple
    }
  }
}
    ${UserBaseFragmentDoc}
${CommentSimpleFragmentDoc}`;

/**
 * __useGetDocumentPartsQuery__
 *
 * To run a query within a React component, call `useGetDocumentPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentPartsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentPartsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentPartsQuery, GetDocumentPartsQueryVariables> & ({ variables: GetDocumentPartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentPartsQuery, GetDocumentPartsQueryVariables>(GetDocumentPartsDocument, options);
      }
export function useGetDocumentPartsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentPartsQuery, GetDocumentPartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentPartsQuery, GetDocumentPartsQueryVariables>(GetDocumentPartsDocument, options);
        }
export function useGetDocumentPartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentPartsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentPartsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentPartsQuery, GetDocumentPartsQueryVariables>(GetDocumentPartsDocument, options);
        }
export type GetDocumentPartsQueryHookResult = ReturnType<typeof useGetDocumentPartsQuery>;
export type GetDocumentPartsLazyQueryHookResult = ReturnType<typeof useGetDocumentPartsLazyQuery>;
export type GetDocumentPartsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentPartsSuspenseQuery>;
export type GetDocumentPartsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentPartsQuery, GetDocumentPartsQueryVariables>;
export const GetSignedDocumentSimpleDocument = gql`
    query GetSignedDocumentSimple($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    isSigned
    variant
    status
    workflow {
      __typename
      id
      linkedOpportunities {
        __typename
        id
        integration
      }
      state
    }
  }
}
    `;

/**
 * __useGetSignedDocumentSimpleQuery__
 *
 * To run a query within a React component, call `useGetSignedDocumentSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedDocumentSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedDocumentSimpleQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetSignedDocumentSimpleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetSignedDocumentSimpleQuery, GetSignedDocumentSimpleQueryVariables> & ({ variables: GetSignedDocumentSimpleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSignedDocumentSimpleQuery, GetSignedDocumentSimpleQueryVariables>(GetSignedDocumentSimpleDocument, options);
      }
export function useGetSignedDocumentSimpleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetSignedDocumentSimpleQuery, GetSignedDocumentSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSignedDocumentSimpleQuery, GetSignedDocumentSimpleQueryVariables>(GetSignedDocumentSimpleDocument, options);
        }
export function useGetSignedDocumentSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetSignedDocumentSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetSignedDocumentSimpleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetSignedDocumentSimpleQuery, GetSignedDocumentSimpleQueryVariables>(GetSignedDocumentSimpleDocument, options);
        }
export type GetSignedDocumentSimpleQueryHookResult = ReturnType<typeof useGetSignedDocumentSimpleQuery>;
export type GetSignedDocumentSimpleLazyQueryHookResult = ReturnType<typeof useGetSignedDocumentSimpleLazyQuery>;
export type GetSignedDocumentSimpleSuspenseQueryHookResult = ReturnType<typeof useGetSignedDocumentSimpleSuspenseQuery>;
export type GetSignedDocumentSimpleQueryResult = ApolloReactHooks.useQuery.Result<GetSignedDocumentSimpleQuery, GetSignedDocumentSimpleQueryVariables>;
export const GetSignedDocumentDocument = gql`
    query GetSignedDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    isSigned
    variant
    requesterRole
    envelope {
      __typename
      id
      completedAt
    }
    workflow {
      id
      state
      envelopeStatus
    }
    latestVersion {
      ... on FileVersionInterface {
        __typename
        id
      }
    }
  }
}
    `;

/**
 * __useGetSignedDocumentQuery__
 *
 * To run a query within a React component, call `useGetSignedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetSignedDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetSignedDocumentQuery, GetSignedDocumentQueryVariables> & ({ variables: GetSignedDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSignedDocumentQuery, GetSignedDocumentQueryVariables>(GetSignedDocumentDocument, options);
      }
export function useGetSignedDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetSignedDocumentQuery, GetSignedDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSignedDocumentQuery, GetSignedDocumentQueryVariables>(GetSignedDocumentDocument, options);
        }
export function useGetSignedDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetSignedDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetSignedDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetSignedDocumentQuery, GetSignedDocumentQueryVariables>(GetSignedDocumentDocument, options);
        }
export type GetSignedDocumentQueryHookResult = ReturnType<typeof useGetSignedDocumentQuery>;
export type GetSignedDocumentLazyQueryHookResult = ReturnType<typeof useGetSignedDocumentLazyQuery>;
export type GetSignedDocumentSuspenseQueryHookResult = ReturnType<typeof useGetSignedDocumentSuspenseQuery>;
export type GetSignedDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetSignedDocumentQuery, GetSignedDocumentQueryVariables>;
export const GetDocumentForwardSettingsDocument = gql`
    query GetDocumentForwardSettings($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    forwardingPermissionRole
    name
    requesterRole
    variant
    owner {
      ...UserBase
    }
    workflow {
      __typename
      id
      forwardingPermissionRole
      state
      envelopeStatus
      variant
      owner {
        ...UserBase
      }
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetDocumentForwardSettingsQuery__
 *
 * To run a query within a React component, call `useGetDocumentForwardSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentForwardSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentForwardSettingsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentForwardSettingsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentForwardSettingsQuery, GetDocumentForwardSettingsQueryVariables> & ({ variables: GetDocumentForwardSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentForwardSettingsQuery, GetDocumentForwardSettingsQueryVariables>(GetDocumentForwardSettingsDocument, options);
      }
export function useGetDocumentForwardSettingsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentForwardSettingsQuery, GetDocumentForwardSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentForwardSettingsQuery, GetDocumentForwardSettingsQueryVariables>(GetDocumentForwardSettingsDocument, options);
        }
export function useGetDocumentForwardSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentForwardSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentForwardSettingsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentForwardSettingsQuery, GetDocumentForwardSettingsQueryVariables>(GetDocumentForwardSettingsDocument, options);
        }
export type GetDocumentForwardSettingsQueryHookResult = ReturnType<typeof useGetDocumentForwardSettingsQuery>;
export type GetDocumentForwardSettingsLazyQueryHookResult = ReturnType<typeof useGetDocumentForwardSettingsLazyQuery>;
export type GetDocumentForwardSettingsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentForwardSettingsSuspenseQuery>;
export type GetDocumentForwardSettingsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentForwardSettingsQuery, GetDocumentForwardSettingsQueryVariables>;
export const GetDocumentWithWorkflowStateDocument = gql`
    query GetDocumentWithWorkflowState($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    variant
    isSigned
    workflow {
      id
      state
      envelopeStatus
    }
  }
}
    `;

/**
 * __useGetDocumentWithWorkflowStateQuery__
 *
 * To run a query within a React component, call `useGetDocumentWithWorkflowStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentWithWorkflowStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentWithWorkflowStateQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentWithWorkflowStateQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentWithWorkflowStateQuery, GetDocumentWithWorkflowStateQueryVariables> & ({ variables: GetDocumentWithWorkflowStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentWithWorkflowStateQuery, GetDocumentWithWorkflowStateQueryVariables>(GetDocumentWithWorkflowStateDocument, options);
      }
export function useGetDocumentWithWorkflowStateLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentWithWorkflowStateQuery, GetDocumentWithWorkflowStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentWithWorkflowStateQuery, GetDocumentWithWorkflowStateQueryVariables>(GetDocumentWithWorkflowStateDocument, options);
        }
export function useGetDocumentWithWorkflowStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithWorkflowStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithWorkflowStateQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentWithWorkflowStateQuery, GetDocumentWithWorkflowStateQueryVariables>(GetDocumentWithWorkflowStateDocument, options);
        }
export type GetDocumentWithWorkflowStateQueryHookResult = ReturnType<typeof useGetDocumentWithWorkflowStateQuery>;
export type GetDocumentWithWorkflowStateLazyQueryHookResult = ReturnType<typeof useGetDocumentWithWorkflowStateLazyQuery>;
export type GetDocumentWithWorkflowStateSuspenseQueryHookResult = ReturnType<typeof useGetDocumentWithWorkflowStateSuspenseQuery>;
export type GetDocumentWithWorkflowStateQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentWithWorkflowStateQuery, GetDocumentWithWorkflowStateQueryVariables>;
export const GetDocxUploadTargetDocumentDocument = gql`
    query GetDocxUploadTargetDocument($documentIds: [UUID!]!) {
  documents(documentIds: $documentIds) {
    __typename
    id
    name
    isSigned
    requesterRole
    owner {
      __typename
      id
    }
    workflow {
      __typename
      id
      state
      envelopeStatus
    }
  }
}
    `;

/**
 * __useGetDocxUploadTargetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocxUploadTargetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocxUploadTargetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocxUploadTargetDocumentQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetDocxUploadTargetDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocxUploadTargetDocumentQuery, GetDocxUploadTargetDocumentQueryVariables> & ({ variables: GetDocxUploadTargetDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocxUploadTargetDocumentQuery, GetDocxUploadTargetDocumentQueryVariables>(GetDocxUploadTargetDocumentDocument, options);
      }
export function useGetDocxUploadTargetDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocxUploadTargetDocumentQuery, GetDocxUploadTargetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocxUploadTargetDocumentQuery, GetDocxUploadTargetDocumentQueryVariables>(GetDocxUploadTargetDocumentDocument, options);
        }
export function useGetDocxUploadTargetDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocxUploadTargetDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocxUploadTargetDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocxUploadTargetDocumentQuery, GetDocxUploadTargetDocumentQueryVariables>(GetDocxUploadTargetDocumentDocument, options);
        }
export type GetDocxUploadTargetDocumentQueryHookResult = ReturnType<typeof useGetDocxUploadTargetDocumentQuery>;
export type GetDocxUploadTargetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocxUploadTargetDocumentLazyQuery>;
export type GetDocxUploadTargetDocumentSuspenseQueryHookResult = ReturnType<typeof useGetDocxUploadTargetDocumentSuspenseQuery>;
export type GetDocxUploadTargetDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetDocxUploadTargetDocumentQuery, GetDocxUploadTargetDocumentQueryVariables>;
export const GetDocumentBasicMetaDocument = gql`
    query GetDocumentBasicMeta($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    description
    status
    variant
    requesterRole
    isCertificate
    isCommunityTemplate
    isSigned
    coreAiPropertiesExtractionStartedAt
    coreAiPropertiesExtractionFinishedAt
    coreAiPropertiesExtractionFailedAt
    conversionStartedAt
    conversionFinishedAt
    conversionFailedAt
    type {
      __typename
      id
      value
    }
    workflow {
      id
      envelopeStatus
      isSignedOutsideAline
      wasSentForSig
      linkedOpportunities {
        __typename
        id
        integration
      }
      state
      status
      variant
    }
    workflowFileRole
    envelope {
      __typename
      id
      createdAt
      completedAt
      docuSignEnvelopeId
      title
      variant
    }
    latestVersion {
      ... on DocumentVersion {
        __typename
        id
        fileContentChangedAt
        name
        createdAt
        vectorsSavedAt
        vectorsStartedAt
        vectorsFailedAt
      }
      ... on StaticFileVersion {
        __typename
        id
        fileContentChangedAt
        fileExtractionStartedAt
        fileExtractionFailedAt
        fileExtractionFinishedAt
        name
        createdAt
        vectorsSavedAt
        vectorsStartedAt
        vectorsFailedAt
        fileLocation {
          __typename
          id
          filestackUrl
          mimetype
        }
      }
    }
    owner {
      __typename
      id
      org {
        __typename
        id
      }
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useGetDocumentBasicMetaQuery__
 *
 * To run a query within a React component, call `useGetDocumentBasicMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentBasicMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentBasicMetaQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentBasicMetaQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentBasicMetaQuery, GetDocumentBasicMetaQueryVariables> & ({ variables: GetDocumentBasicMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentBasicMetaQuery, GetDocumentBasicMetaQueryVariables>(GetDocumentBasicMetaDocument, options);
      }
export function useGetDocumentBasicMetaLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentBasicMetaQuery, GetDocumentBasicMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentBasicMetaQuery, GetDocumentBasicMetaQueryVariables>(GetDocumentBasicMetaDocument, options);
        }
export function useGetDocumentBasicMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentBasicMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentBasicMetaQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentBasicMetaQuery, GetDocumentBasicMetaQueryVariables>(GetDocumentBasicMetaDocument, options);
        }
export type GetDocumentBasicMetaQueryHookResult = ReturnType<typeof useGetDocumentBasicMetaQuery>;
export type GetDocumentBasicMetaLazyQueryHookResult = ReturnType<typeof useGetDocumentBasicMetaLazyQuery>;
export type GetDocumentBasicMetaSuspenseQueryHookResult = ReturnType<typeof useGetDocumentBasicMetaSuspenseQuery>;
export type GetDocumentBasicMetaQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentBasicMetaQuery, GetDocumentBasicMetaQueryVariables>;
export const GetDocumentStatusDocument = gql`
    query GetDocumentStatus($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    status
  }
}
    `;

/**
 * __useGetDocumentStatusQuery__
 *
 * To run a query within a React component, call `useGetDocumentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentStatusQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentStatusQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentStatusQuery, GetDocumentStatusQueryVariables> & ({ variables: GetDocumentStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>(GetDocumentStatusDocument, options);
      }
export function useGetDocumentStatusLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>(GetDocumentStatusDocument, options);
        }
export function useGetDocumentStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentStatusQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>(GetDocumentStatusDocument, options);
        }
export type GetDocumentStatusQueryHookResult = ReturnType<typeof useGetDocumentStatusQuery>;
export type GetDocumentStatusLazyQueryHookResult = ReturnType<typeof useGetDocumentStatusLazyQuery>;
export type GetDocumentStatusSuspenseQueryHookResult = ReturnType<typeof useGetDocumentStatusSuspenseQuery>;
export type GetDocumentStatusQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>;
export const GetDocumentWorkflowMetaDocument = gql`
    query GetDocumentWorkflowMeta($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    workflow {
      __typename
      id
      status
      envelopeStatus
    }
  }
}
    `;

/**
 * __useGetDocumentWorkflowMetaQuery__
 *
 * To run a query within a React component, call `useGetDocumentWorkflowMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentWorkflowMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentWorkflowMetaQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentWorkflowMetaQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentWorkflowMetaQuery, GetDocumentWorkflowMetaQueryVariables> & ({ variables: GetDocumentWorkflowMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentWorkflowMetaQuery, GetDocumentWorkflowMetaQueryVariables>(GetDocumentWorkflowMetaDocument, options);
      }
export function useGetDocumentWorkflowMetaLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentWorkflowMetaQuery, GetDocumentWorkflowMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentWorkflowMetaQuery, GetDocumentWorkflowMetaQueryVariables>(GetDocumentWorkflowMetaDocument, options);
        }
export function useGetDocumentWorkflowMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWorkflowMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWorkflowMetaQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentWorkflowMetaQuery, GetDocumentWorkflowMetaQueryVariables>(GetDocumentWorkflowMetaDocument, options);
        }
export type GetDocumentWorkflowMetaQueryHookResult = ReturnType<typeof useGetDocumentWorkflowMetaQuery>;
export type GetDocumentWorkflowMetaLazyQueryHookResult = ReturnType<typeof useGetDocumentWorkflowMetaLazyQuery>;
export type GetDocumentWorkflowMetaSuspenseQueryHookResult = ReturnType<typeof useGetDocumentWorkflowMetaSuspenseQuery>;
export type GetDocumentWorkflowMetaQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentWorkflowMetaQuery, GetDocumentWorkflowMetaQueryVariables>;
export const GetDocumentWithWorkflowDocument = gql`
    query GetDocumentWithWorkflow($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    variant
    workflow {
      __typename
      id
      name
      state
      status
      envelopeStatus
      variant
      activeStep {
        __typename
        id
      }
      owner {
        ...UserBase
      }
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetDocumentWithWorkflowQuery__
 *
 * To run a query within a React component, call `useGetDocumentWithWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentWithWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentWithWorkflowQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentWithWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentWithWorkflowQuery, GetDocumentWithWorkflowQueryVariables> & ({ variables: GetDocumentWithWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentWithWorkflowQuery, GetDocumentWithWorkflowQueryVariables>(GetDocumentWithWorkflowDocument, options);
      }
export function useGetDocumentWithWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentWithWorkflowQuery, GetDocumentWithWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentWithWorkflowQuery, GetDocumentWithWorkflowQueryVariables>(GetDocumentWithWorkflowDocument, options);
        }
export function useGetDocumentWithWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentWithWorkflowQuery, GetDocumentWithWorkflowQueryVariables>(GetDocumentWithWorkflowDocument, options);
        }
export type GetDocumentWithWorkflowQueryHookResult = ReturnType<typeof useGetDocumentWithWorkflowQuery>;
export type GetDocumentWithWorkflowLazyQueryHookResult = ReturnType<typeof useGetDocumentWithWorkflowLazyQuery>;
export type GetDocumentWithWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetDocumentWithWorkflowSuspenseQuery>;
export type GetDocumentWithWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentWithWorkflowQuery, GetDocumentWithWorkflowQueryVariables>;
export const GetDocumentWithFullWorkflowDocument = gql`
    query GetDocumentWithFullWorkflow($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    hasWorkflow
    variant
    coreAiPropertiesExtractionStartedAt
    coreAiPropertiesExtractionFinishedAt
    coreAiPropertiesExtractionFailedAt
    conversionStartedAt
    conversionFinishedAt
    conversionFailedAt
    workflow {
      __typename
      id
      name
      state
      status
      envelopeStatus
      variant
      startedAt
      createdAt
      completedAt
      activeStep {
        __typename
        id
      }
      owner {
        ...UserBase
      }
      files {
        ...WorkflowFileSimple
      }
      permissions {
        ...WorkflowPermissionSimple
      }
    }
  }
}
    ${UserBaseFragmentDoc}
${WorkflowFileSimpleFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetDocumentWithFullWorkflowQuery__
 *
 * To run a query within a React component, call `useGetDocumentWithFullWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentWithFullWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentWithFullWorkflowQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentWithFullWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentWithFullWorkflowQuery, GetDocumentWithFullWorkflowQueryVariables> & ({ variables: GetDocumentWithFullWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentWithFullWorkflowQuery, GetDocumentWithFullWorkflowQueryVariables>(GetDocumentWithFullWorkflowDocument, options);
      }
export function useGetDocumentWithFullWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentWithFullWorkflowQuery, GetDocumentWithFullWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentWithFullWorkflowQuery, GetDocumentWithFullWorkflowQueryVariables>(GetDocumentWithFullWorkflowDocument, options);
        }
export function useGetDocumentWithFullWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithFullWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithFullWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentWithFullWorkflowQuery, GetDocumentWithFullWorkflowQueryVariables>(GetDocumentWithFullWorkflowDocument, options);
        }
export type GetDocumentWithFullWorkflowQueryHookResult = ReturnType<typeof useGetDocumentWithFullWorkflowQuery>;
export type GetDocumentWithFullWorkflowLazyQueryHookResult = ReturnType<typeof useGetDocumentWithFullWorkflowLazyQuery>;
export type GetDocumentWithFullWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetDocumentWithFullWorkflowSuspenseQuery>;
export type GetDocumentWithFullWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentWithFullWorkflowQuery, GetDocumentWithFullWorkflowQueryVariables>;
export const GetContractSummaryDocument = gql`
    query GetContractSummary($documentId: UUID!) {
  document(documentId: $documentId) {
    id
    description
    name
    comments {
      ...CommentSimple
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    ${CommentSimpleFragmentDoc}`;

/**
 * __useGetContractSummaryQuery__
 *
 * To run a query within a React component, call `useGetContractSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractSummaryQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetContractSummaryQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetContractSummaryQuery, GetContractSummaryQueryVariables> & ({ variables: GetContractSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractSummaryQuery, GetContractSummaryQueryVariables>(GetContractSummaryDocument, options);
      }
export function useGetContractSummaryLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetContractSummaryQuery, GetContractSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractSummaryQuery, GetContractSummaryQueryVariables>(GetContractSummaryDocument, options);
        }
export function useGetContractSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetContractSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetContractSummaryQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetContractSummaryQuery, GetContractSummaryQueryVariables>(GetContractSummaryDocument, options);
        }
export type GetContractSummaryQueryHookResult = ReturnType<typeof useGetContractSummaryQuery>;
export type GetContractSummaryLazyQueryHookResult = ReturnType<typeof useGetContractSummaryLazyQuery>;
export type GetContractSummarySuspenseQueryHookResult = ReturnType<typeof useGetContractSummarySuspenseQuery>;
export type GetContractSummaryQueryResult = ApolloReactHooks.useQuery.Result<GetContractSummaryQuery, GetContractSummaryQueryVariables>;
export const GetDocumentWithAssetsDocument = gql`
    query GetDocumentWithAssets($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    assets {
      __typename
      id
      filestackUrl
    }
    latestVersion {
      ... on DocumentVersion {
        __typename
        id
        documentJSON
        name
        createdAt
      }
      ... on StaticFileVersion {
        __typename
        id
        name
        createdAt
        fileLocation {
          __typename
          id
          filestackUrl
          mimetype
        }
      }
    }
  }
}
    `;

/**
 * __useGetDocumentWithAssetsQuery__
 *
 * To run a query within a React component, call `useGetDocumentWithAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentWithAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentWithAssetsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentWithAssetsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentWithAssetsQuery, GetDocumentWithAssetsQueryVariables> & ({ variables: GetDocumentWithAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentWithAssetsQuery, GetDocumentWithAssetsQueryVariables>(GetDocumentWithAssetsDocument, options);
      }
export function useGetDocumentWithAssetsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentWithAssetsQuery, GetDocumentWithAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentWithAssetsQuery, GetDocumentWithAssetsQueryVariables>(GetDocumentWithAssetsDocument, options);
        }
export function useGetDocumentWithAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithAssetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWithAssetsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentWithAssetsQuery, GetDocumentWithAssetsQueryVariables>(GetDocumentWithAssetsDocument, options);
        }
export type GetDocumentWithAssetsQueryHookResult = ReturnType<typeof useGetDocumentWithAssetsQuery>;
export type GetDocumentWithAssetsLazyQueryHookResult = ReturnType<typeof useGetDocumentWithAssetsLazyQuery>;
export type GetDocumentWithAssetsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentWithAssetsSuspenseQuery>;
export type GetDocumentWithAssetsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentWithAssetsQuery, GetDocumentWithAssetsQueryVariables>;
export const GetDocumentsWithAssetsDocument = gql`
    query GetDocumentsWithAssets($documentIds: [UUID!]!) {
  documents(documentIds: $documentIds) {
    __typename
    id
    name
    assets {
      __typename
      id
      filestackUrl
    }
    latestVersion {
      ... on DocumentVersion {
        __typename
        id
        documentJSON
        name
        createdAt
      }
      ... on StaticFileVersion {
        __typename
        id
        name
        createdAt
        fileLocation {
          __typename
          id
          filestackUrl
          mimetype
        }
      }
    }
  }
}
    `;

/**
 * __useGetDocumentsWithAssetsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsWithAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsWithAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsWithAssetsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetDocumentsWithAssetsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentsWithAssetsQuery, GetDocumentsWithAssetsQueryVariables> & ({ variables: GetDocumentsWithAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentsWithAssetsQuery, GetDocumentsWithAssetsQueryVariables>(GetDocumentsWithAssetsDocument, options);
      }
export function useGetDocumentsWithAssetsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentsWithAssetsQuery, GetDocumentsWithAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentsWithAssetsQuery, GetDocumentsWithAssetsQueryVariables>(GetDocumentsWithAssetsDocument, options);
        }
export function useGetDocumentsWithAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentsWithAssetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentsWithAssetsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentsWithAssetsQuery, GetDocumentsWithAssetsQueryVariables>(GetDocumentsWithAssetsDocument, options);
        }
export type GetDocumentsWithAssetsQueryHookResult = ReturnType<typeof useGetDocumentsWithAssetsQuery>;
export type GetDocumentsWithAssetsLazyQueryHookResult = ReturnType<typeof useGetDocumentsWithAssetsLazyQuery>;
export type GetDocumentsWithAssetsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsWithAssetsSuspenseQuery>;
export type GetDocumentsWithAssetsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentsWithAssetsQuery, GetDocumentsWithAssetsQueryVariables>;
export const LoadDocumentDocument = gql`
    query LoadDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    ...DocumentMetadata
    requesterRole
    latestVersion {
      ...FileVersionSimple
    }
    workflow {
      id
      state
      envelopeStatus
    }
    envelope {
      __typename
      id
      variant
      recipients {
        __typename
        id
        status
        type
        assignee {
          __typename
          id
        }
      }
    }
  }
}
    ${DocumentMetadataFragmentDoc}
${FileVersionSimpleFragmentDoc}`;

/**
 * __useLoadDocumentQuery__
 *
 * To run a query within a React component, call `useLoadDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useLoadDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<LoadDocumentQuery, LoadDocumentQueryVariables> & ({ variables: LoadDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LoadDocumentQuery, LoadDocumentQueryVariables>(LoadDocumentDocument, options);
      }
export function useLoadDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<LoadDocumentQuery, LoadDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LoadDocumentQuery, LoadDocumentQueryVariables>(LoadDocumentDocument, options);
        }
export function useLoadDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<LoadDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<LoadDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<LoadDocumentQuery, LoadDocumentQueryVariables>(LoadDocumentDocument, options);
        }
export type LoadDocumentQueryHookResult = ReturnType<typeof useLoadDocumentQuery>;
export type LoadDocumentLazyQueryHookResult = ReturnType<typeof useLoadDocumentLazyQuery>;
export type LoadDocumentSuspenseQueryHookResult = ReturnType<typeof useLoadDocumentSuspenseQuery>;
export type LoadDocumentQueryResult = ApolloReactHooks.useQuery.Result<LoadDocumentQuery, LoadDocumentQueryVariables>;
export const GetDocumentsDocument = gql`
    query GetDocuments($documentIds: [UUID!]!) {
  documents(documentIds: $documentIds) {
    ...DocumentFieldsBase
  }
}
    ${DocumentFieldsBaseFragmentDoc}`;

/**
 * __useGetDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetDocumentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentsQuery, GetDocumentsQueryVariables> & ({ variables: GetDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
      }
export function useGetDocumentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export function useGetDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export type GetDocumentsQueryHookResult = ReturnType<typeof useGetDocumentsQuery>;
export type GetDocumentsLazyQueryHookResult = ReturnType<typeof useGetDocumentsLazyQuery>;
export type GetDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsSuspenseQuery>;
export type GetDocumentsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const GetDocumentsSimpleDocument = gql`
    query GetDocumentsSimple($documentIds: [UUID!]!) {
  documents(documentIds: $documentIds) {
    __typename
    id
    hasWorkflow
    isSigned
    name
    requesterRole
    variant
    requesterFavorited
    conversionStartedAt
    conversionFinishedAt
    conversionFailedAt
    latestVersion {
      ... on FileVersionInterface {
        __typename
        id
        name
        vectorsStartedAt
        vectorsSavedAt
        vectorsFailedAt
      }
      ... on StaticFileVersion {
        fileExtractionFailedAt
        fileExtractionFailedReason
        fileExtractionFinishedAt
        fileExtractionStartedAt
        fileLocation {
          __typename
          id
          mimetype
        }
      }
    }
    owner {
      ...UserBase
    }
    workflow {
      __typename
      id
      name
      state
      envelopeStatus
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetDocumentsSimpleQuery__
 *
 * To run a query within a React component, call `useGetDocumentsSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsSimpleQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetDocumentsSimpleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentsSimpleQuery, GetDocumentsSimpleQueryVariables> & ({ variables: GetDocumentsSimpleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentsSimpleQuery, GetDocumentsSimpleQueryVariables>(GetDocumentsSimpleDocument, options);
      }
export function useGetDocumentsSimpleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentsSimpleQuery, GetDocumentsSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentsSimpleQuery, GetDocumentsSimpleQueryVariables>(GetDocumentsSimpleDocument, options);
        }
export function useGetDocumentsSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentsSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentsSimpleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentsSimpleQuery, GetDocumentsSimpleQueryVariables>(GetDocumentsSimpleDocument, options);
        }
export type GetDocumentsSimpleQueryHookResult = ReturnType<typeof useGetDocumentsSimpleQuery>;
export type GetDocumentsSimpleLazyQueryHookResult = ReturnType<typeof useGetDocumentsSimpleLazyQuery>;
export type GetDocumentsSimpleSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsSimpleSuspenseQuery>;
export type GetDocumentsSimpleQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentsSimpleQuery, GetDocumentsSimpleQueryVariables>;
export const GetDocumentMetricsDocument = gql`
    query GetDocumentMetrics($reportId: UUID!) {
  report(reportId: $reportId) {
    __typename
    id
    rows {
      totalCount
    }
  }
}
    `;

/**
 * __useGetDocumentMetricsQuery__
 *
 * To run a query within a React component, call `useGetDocumentMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentMetricsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetDocumentMetricsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentMetricsQuery, GetDocumentMetricsQueryVariables> & ({ variables: GetDocumentMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentMetricsQuery, GetDocumentMetricsQueryVariables>(GetDocumentMetricsDocument, options);
      }
export function useGetDocumentMetricsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentMetricsQuery, GetDocumentMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentMetricsQuery, GetDocumentMetricsQueryVariables>(GetDocumentMetricsDocument, options);
        }
export function useGetDocumentMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentMetricsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentMetricsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentMetricsQuery, GetDocumentMetricsQueryVariables>(GetDocumentMetricsDocument, options);
        }
export type GetDocumentMetricsQueryHookResult = ReturnType<typeof useGetDocumentMetricsQuery>;
export type GetDocumentMetricsLazyQueryHookResult = ReturnType<typeof useGetDocumentMetricsLazyQuery>;
export type GetDocumentMetricsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentMetricsSuspenseQuery>;
export type GetDocumentMetricsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentMetricsQuery, GetDocumentMetricsQueryVariables>;
export const GetDocumentsLabelsDocument = gql`
    query GetDocumentsLabels($documentIds: [UUID!]!) {
  documents(documentIds: $documentIds) {
    __typename
    id
    labels {
      ...LabelSimple
    }
  }
}
    ${LabelSimpleFragmentDoc}`;

/**
 * __useGetDocumentsLabelsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsLabelsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetDocumentsLabelsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentsLabelsQuery, GetDocumentsLabelsQueryVariables> & ({ variables: GetDocumentsLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentsLabelsQuery, GetDocumentsLabelsQueryVariables>(GetDocumentsLabelsDocument, options);
      }
export function useGetDocumentsLabelsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentsLabelsQuery, GetDocumentsLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentsLabelsQuery, GetDocumentsLabelsQueryVariables>(GetDocumentsLabelsDocument, options);
        }
export function useGetDocumentsLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentsLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentsLabelsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentsLabelsQuery, GetDocumentsLabelsQueryVariables>(GetDocumentsLabelsDocument, options);
        }
export type GetDocumentsLabelsQueryHookResult = ReturnType<typeof useGetDocumentsLabelsQuery>;
export type GetDocumentsLabelsLazyQueryHookResult = ReturnType<typeof useGetDocumentsLabelsLazyQuery>;
export type GetDocumentsLabelsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsLabelsSuspenseQuery>;
export type GetDocumentsLabelsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentsLabelsQuery, GetDocumentsLabelsQueryVariables>;
export const GetDocumentFieldsDocument = gql`
    query GetDocumentFields($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    isSavePending
    latestVersion {
      ...FileVersionSimple
    }
    variables {
      ...DocumentVariableFull
    }
    signatureFields {
      ...SignatureFieldSimple
    }
    createdAt
  }
}
    ${FileVersionSimpleFragmentDoc}
${DocumentVariableFullFragmentDoc}
${SignatureFieldSimpleFragmentDoc}`;

/**
 * __useGetDocumentFieldsQuery__
 *
 * To run a query within a React component, call `useGetDocumentFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentFieldsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentFieldsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentFieldsQuery, GetDocumentFieldsQueryVariables> & ({ variables: GetDocumentFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentFieldsQuery, GetDocumentFieldsQueryVariables>(GetDocumentFieldsDocument, options);
      }
export function useGetDocumentFieldsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentFieldsQuery, GetDocumentFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentFieldsQuery, GetDocumentFieldsQueryVariables>(GetDocumentFieldsDocument, options);
        }
export function useGetDocumentFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentFieldsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentFieldsQuery, GetDocumentFieldsQueryVariables>(GetDocumentFieldsDocument, options);
        }
export type GetDocumentFieldsQueryHookResult = ReturnType<typeof useGetDocumentFieldsQuery>;
export type GetDocumentFieldsLazyQueryHookResult = ReturnType<typeof useGetDocumentFieldsLazyQuery>;
export type GetDocumentFieldsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentFieldsSuspenseQuery>;
export type GetDocumentFieldsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentFieldsQuery, GetDocumentFieldsQueryVariables>;
export const GetDocumentVersionsDocument = gql`
    query GetDocumentVersions($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    isSigned
    name
    requesterRole
    variant
    conversionStartedAt
    conversionFinishedAt
    conversionFailedAt
    workflow {
      __typename
      id
      variant
      state
    }
    latestVersion {
      ...FileVersionSimple
    }
    owner {
      __typename
      id
    }
    orderedVersions {
      ...FileVersionSimple
      ... on DocumentVersion {
        documentJSON
        taskUpload {
          ...VersionTaskUpload
        }
      }
      ... on StaticFileVersion {
        taskUpload {
          ...VersionTaskUpload
        }
      }
    }
    variables {
      ...DocumentVariableFull
    }
    signatureFields {
      ...SignatureFieldSimple
    }
  }
}
    ${FileVersionSimpleFragmentDoc}
${VersionTaskUploadFragmentDoc}
${DocumentVariableFullFragmentDoc}
${SignatureFieldSimpleFragmentDoc}`;

/**
 * __useGetDocumentVersionsQuery__
 *
 * To run a query within a React component, call `useGetDocumentVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVersionsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentVersionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentVersionsQuery, GetDocumentVersionsQueryVariables> & ({ variables: GetDocumentVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentVersionsQuery, GetDocumentVersionsQueryVariables>(GetDocumentVersionsDocument, options);
      }
export function useGetDocumentVersionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentVersionsQuery, GetDocumentVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentVersionsQuery, GetDocumentVersionsQueryVariables>(GetDocumentVersionsDocument, options);
        }
export function useGetDocumentVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentVersionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentVersionsQuery, GetDocumentVersionsQueryVariables>(GetDocumentVersionsDocument, options);
        }
export type GetDocumentVersionsQueryHookResult = ReturnType<typeof useGetDocumentVersionsQuery>;
export type GetDocumentVersionsLazyQueryHookResult = ReturnType<typeof useGetDocumentVersionsLazyQuery>;
export type GetDocumentVersionsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentVersionsSuspenseQuery>;
export type GetDocumentVersionsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentVersionsQuery, GetDocumentVersionsQueryVariables>;
export const GetDocumentCommentsDocument = gql`
    query GetDocumentComments($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    comments {
      ...CommentSimple
    }
  }
}
    ${CommentSimpleFragmentDoc}`;

/**
 * __useGetDocumentCommentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentCommentsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentCommentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentCommentsQuery, GetDocumentCommentsQueryVariables> & ({ variables: GetDocumentCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentCommentsQuery, GetDocumentCommentsQueryVariables>(GetDocumentCommentsDocument, options);
      }
export function useGetDocumentCommentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentCommentsQuery, GetDocumentCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentCommentsQuery, GetDocumentCommentsQueryVariables>(GetDocumentCommentsDocument, options);
        }
export function useGetDocumentCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentCommentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentCommentsQuery, GetDocumentCommentsQueryVariables>(GetDocumentCommentsDocument, options);
        }
export type GetDocumentCommentsQueryHookResult = ReturnType<typeof useGetDocumentCommentsQuery>;
export type GetDocumentCommentsLazyQueryHookResult = ReturnType<typeof useGetDocumentCommentsLazyQuery>;
export type GetDocumentCommentsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentCommentsSuspenseQuery>;
export type GetDocumentCommentsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentCommentsQuery, GetDocumentCommentsQueryVariables>;
export const GetDocumentLatestVersionDocument = gql`
    query GetDocumentLatestVersion($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    requesterRole
    status
    variant
    coreAiPropertiesExtractionStartedAt
    coreAiPropertiesExtractionFinishedAt
    coreAiPropertiesExtractionFailedAt
    conversionStartedAt
    conversionFinishedAt
    conversionFailedAt
    owner {
      ...UserBase
    }
    latestVersion {
      ...FileVersionSimple
    }
    type {
      __typename
      id
      value
    }
    labels {
      ...LabelSimple
    }
    createdAt
    updatedAt
  }
}
    ${UserBaseFragmentDoc}
${FileVersionSimpleFragmentDoc}
${LabelSimpleFragmentDoc}`;

/**
 * __useGetDocumentLatestVersionQuery__
 *
 * To run a query within a React component, call `useGetDocumentLatestVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentLatestVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentLatestVersionQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentLatestVersionQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentLatestVersionQuery, GetDocumentLatestVersionQueryVariables> & ({ variables: GetDocumentLatestVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentLatestVersionQuery, GetDocumentLatestVersionQueryVariables>(GetDocumentLatestVersionDocument, options);
      }
export function useGetDocumentLatestVersionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentLatestVersionQuery, GetDocumentLatestVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentLatestVersionQuery, GetDocumentLatestVersionQueryVariables>(GetDocumentLatestVersionDocument, options);
        }
export function useGetDocumentLatestVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentLatestVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentLatestVersionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentLatestVersionQuery, GetDocumentLatestVersionQueryVariables>(GetDocumentLatestVersionDocument, options);
        }
export type GetDocumentLatestVersionQueryHookResult = ReturnType<typeof useGetDocumentLatestVersionQuery>;
export type GetDocumentLatestVersionLazyQueryHookResult = ReturnType<typeof useGetDocumentLatestVersionLazyQuery>;
export type GetDocumentLatestVersionSuspenseQueryHookResult = ReturnType<typeof useGetDocumentLatestVersionSuspenseQuery>;
export type GetDocumentLatestVersionQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentLatestVersionQuery, GetDocumentLatestVersionQueryVariables>;
export const ChangeDocumentsTypeDocument = gql`
    mutation ChangeDocumentsType($input: ChangeDocumentsTypeInput!) {
  changeDocumentsType(input: $input) {
    documents {
      __typename
      id
      type {
        ...ContractTypeSimple
      }
    }
    numSuccess
    numSkipped
  }
}
    ${ContractTypeSimpleFragmentDoc}`;
export type ChangeDocumentsTypeMutationFn = ApolloReactHooks.useMutation.MutationFunction<ChangeDocumentsTypeMutation, ChangeDocumentsTypeMutationVariables>;

/**
 * __useChangeDocumentsTypeMutation__
 *
 * To run a mutation, you first call `useChangeDocumentsTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDocumentsTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDocumentsTypeMutation, { data, loading, error }] = useChangeDocumentsTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeDocumentsTypeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ChangeDocumentsTypeMutation, ChangeDocumentsTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeDocumentsTypeMutation, ChangeDocumentsTypeMutationVariables>(ChangeDocumentsTypeDocument, options);
      }
export type ChangeDocumentsTypeMutationHookResult = ReturnType<typeof useChangeDocumentsTypeMutation>;
export type ChangeDocumentsTypeMutationResult = ApolloReactHooks.useMutation.Result<ChangeDocumentsTypeMutation>;
export type ChangeDocumentsTypeMutationOptions = ApolloReactHooks.useMutation.Options<ChangeDocumentsTypeMutation, ChangeDocumentsTypeMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation CreateDocument($documentProps: NewDocument!) {
  createDocument(documentProps: $documentProps) {
    document {
      __typename
      id
      name
      status
      variant
      requesterFavorited
      requesterRole
      isCertificate
      isCommunityTemplate
      latestVersion {
        ...FileVersionSimple
        ... on DocumentVersion {
          documentJSON
        }
      }
      owner {
        ...UserBase
      }
      type {
        ...ContractTypeSimple
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    ${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}
${ContractTypeSimpleFragmentDoc}`;
export type CreateDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      documentProps: // value for 'documentProps'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = ApolloReactHooks.useMutation.Result<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = ApolloReactHooks.useMutation.Options<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const DeleteDocumentsDocument = gql`
    mutation DeleteDocuments($input: DeleteDocumentsInput!) {
  deleteDocuments(input: $input) {
    documentIds
    numSkipped
    skippedDocumentIds
  }
}
    `;
export type DeleteDocumentsMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteDocumentsMutation, DeleteDocumentsMutationVariables>;

/**
 * __useDeleteDocumentsMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentsMutation, { data, loading, error }] = useDeleteDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDocumentsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteDocumentsMutation, DeleteDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDocumentsMutation, DeleteDocumentsMutationVariables>(DeleteDocumentsDocument, options);
      }
export type DeleteDocumentsMutationHookResult = ReturnType<typeof useDeleteDocumentsMutation>;
export type DeleteDocumentsMutationResult = ApolloReactHooks.useMutation.Result<DeleteDocumentsMutation>;
export type DeleteDocumentsMutationOptions = ApolloReactHooks.useMutation.Options<DeleteDocumentsMutation, DeleteDocumentsMutationVariables>;
export const DisableDocumentsDocument = gql`
    mutation DisableDocuments($input: DisableDocumentsInput!) {
  disableDocuments(input: $input) {
    documentIds
    numSkipped
    skippedDocumentIds
    affectedRelationshipParents {
      documentId
      trashedChildCount
    }
  }
}
    `;
export type DisableDocumentsMutationFn = ApolloReactHooks.useMutation.MutationFunction<DisableDocumentsMutation, DisableDocumentsMutationVariables>;

/**
 * __useDisableDocumentsMutation__
 *
 * To run a mutation, you first call `useDisableDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableDocumentsMutation, { data, loading, error }] = useDisableDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableDocumentsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DisableDocumentsMutation, DisableDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableDocumentsMutation, DisableDocumentsMutationVariables>(DisableDocumentsDocument, options);
      }
export type DisableDocumentsMutationHookResult = ReturnType<typeof useDisableDocumentsMutation>;
export type DisableDocumentsMutationResult = ApolloReactHooks.useMutation.Result<DisableDocumentsMutation>;
export type DisableDocumentsMutationOptions = ApolloReactHooks.useMutation.Options<DisableDocumentsMutation, DisableDocumentsMutationVariables>;
export const ForwardDocumentDocument = gql`
    mutation ForwardDocument($input: ForwardDocumentInput!) {
  forwardDocument(input: $input) {
    document {
      __typename
      id
      permissions {
        ...PermissionSimple
      }
    }
  }
}
    ${PermissionSimpleFragmentDoc}`;
export type ForwardDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<ForwardDocumentMutation, ForwardDocumentMutationVariables>;

/**
 * __useForwardDocumentMutation__
 *
 * To run a mutation, you first call `useForwardDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForwardDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forwardDocumentMutation, { data, loading, error }] = useForwardDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForwardDocumentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ForwardDocumentMutation, ForwardDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ForwardDocumentMutation, ForwardDocumentMutationVariables>(ForwardDocumentDocument, options);
      }
export type ForwardDocumentMutationHookResult = ReturnType<typeof useForwardDocumentMutation>;
export type ForwardDocumentMutationResult = ApolloReactHooks.useMutation.Result<ForwardDocumentMutation>;
export type ForwardDocumentMutationOptions = ApolloReactHooks.useMutation.Options<ForwardDocumentMutation, ForwardDocumentMutationVariables>;
export const SendDocumentViaEmailDocument = gql`
    mutation SendDocumentViaEmail($input: SendDocumentViaEmailInput!) {
  sendDocumentViaEmail(input: $input) {
    document {
      __typename
      id
      permissions {
        ...PermissionSimple
      }
    }
  }
}
    ${PermissionSimpleFragmentDoc}`;
export type SendDocumentViaEmailMutationFn = ApolloReactHooks.useMutation.MutationFunction<SendDocumentViaEmailMutation, SendDocumentViaEmailMutationVariables>;

/**
 * __useSendDocumentViaEmailMutation__
 *
 * To run a mutation, you first call `useSendDocumentViaEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentViaEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDocumentViaEmailMutation, { data, loading, error }] = useSendDocumentViaEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendDocumentViaEmailMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SendDocumentViaEmailMutation, SendDocumentViaEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendDocumentViaEmailMutation, SendDocumentViaEmailMutationVariables>(SendDocumentViaEmailDocument, options);
      }
export type SendDocumentViaEmailMutationHookResult = ReturnType<typeof useSendDocumentViaEmailMutation>;
export type SendDocumentViaEmailMutationResult = ApolloReactHooks.useMutation.Result<SendDocumentViaEmailMutation>;
export type SendDocumentViaEmailMutationOptions = ApolloReactHooks.useMutation.Options<SendDocumentViaEmailMutation, SendDocumentViaEmailMutationVariables>;
export const SendDocumentViaEmailTestDocument = gql`
    mutation SendDocumentViaEmailTest($input: SendDocumentViaEmailTestInput!) {
  sendDocumentViaEmailTest(input: $input) {
    document {
      __typename
      id
    }
  }
}
    `;
export type SendDocumentViaEmailTestMutationFn = ApolloReactHooks.useMutation.MutationFunction<SendDocumentViaEmailTestMutation, SendDocumentViaEmailTestMutationVariables>;

/**
 * __useSendDocumentViaEmailTestMutation__
 *
 * To run a mutation, you first call `useSendDocumentViaEmailTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentViaEmailTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDocumentViaEmailTestMutation, { data, loading, error }] = useSendDocumentViaEmailTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendDocumentViaEmailTestMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SendDocumentViaEmailTestMutation, SendDocumentViaEmailTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendDocumentViaEmailTestMutation, SendDocumentViaEmailTestMutationVariables>(SendDocumentViaEmailTestDocument, options);
      }
export type SendDocumentViaEmailTestMutationHookResult = ReturnType<typeof useSendDocumentViaEmailTestMutation>;
export type SendDocumentViaEmailTestMutationResult = ApolloReactHooks.useMutation.Result<SendDocumentViaEmailTestMutation>;
export type SendDocumentViaEmailTestMutationOptions = ApolloReactHooks.useMutation.Options<SendDocumentViaEmailTestMutation, SendDocumentViaEmailTestMutationVariables>;
export const StartOcrForDocumentsDocument = gql`
    mutation StartOCRForDocuments($documentIds: [UUID!]!) {
  startOCRForDocuments(documentIds: $documentIds) {
    documents {
      __typename
      id
      latestVersion {
        ... on StaticFileVersion {
          __typename
          id
          fileExtractionFailedAt
          fileExtractionFailedReason
          fileExtractionFinishedAt
          fileExtractionStartedAt
        }
      }
    }
  }
}
    `;
export type StartOcrForDocumentsMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartOcrForDocumentsMutation, StartOcrForDocumentsMutationVariables>;

/**
 * __useStartOcrForDocumentsMutation__
 *
 * To run a mutation, you first call `useStartOcrForDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOcrForDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOcrForDocumentsMutation, { data, loading, error }] = useStartOcrForDocumentsMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useStartOcrForDocumentsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartOcrForDocumentsMutation, StartOcrForDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartOcrForDocumentsMutation, StartOcrForDocumentsMutationVariables>(StartOcrForDocumentsDocument, options);
      }
export type StartOcrForDocumentsMutationHookResult = ReturnType<typeof useStartOcrForDocumentsMutation>;
export type StartOcrForDocumentsMutationResult = ApolloReactHooks.useMutation.Result<StartOcrForDocumentsMutation>;
export type StartOcrForDocumentsMutationOptions = ApolloReactHooks.useMutation.Options<StartOcrForDocumentsMutation, StartOcrForDocumentsMutationVariables>;
export const RestoreDocumentsDocument = gql`
    mutation RestoreDocuments($input: RestoreDocumentsInput!) {
  restoreDocuments(input: $input) {
    documentIds
    numSkipped
    skippedDocumentIds
  }
}
    `;
export type RestoreDocumentsMutationFn = ApolloReactHooks.useMutation.MutationFunction<RestoreDocumentsMutation, RestoreDocumentsMutationVariables>;

/**
 * __useRestoreDocumentsMutation__
 *
 * To run a mutation, you first call `useRestoreDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDocumentsMutation, { data, loading, error }] = useRestoreDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreDocumentsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RestoreDocumentsMutation, RestoreDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreDocumentsMutation, RestoreDocumentsMutationVariables>(RestoreDocumentsDocument, options);
      }
export type RestoreDocumentsMutationHookResult = ReturnType<typeof useRestoreDocumentsMutation>;
export type RestoreDocumentsMutationResult = ApolloReactHooks.useMutation.Result<RestoreDocumentsMutation>;
export type RestoreDocumentsMutationOptions = ApolloReactHooks.useMutation.Options<RestoreDocumentsMutation, RestoreDocumentsMutationVariables>;
export const SaveDocumentDocument = gql`
    mutation SaveDocument($input: SaveDocumentInput!) {
  saveDocument(input: $input) {
    document {
      __typename
      id
      variant
      latestVersion {
        ... on FileVersionInterface {
          __typename
          id
        }
        ... on DocumentVersion {
          documentJSON
        }
      }
    }
    changedVariables {
      __typename
      deletedAt
      id
      value
      selectedAnswer {
        __typename
        id
        optionText
      }
    }
  }
}
    `;
export type SaveDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<SaveDocumentMutation, SaveDocumentMutationVariables>;

/**
 * __useSaveDocumentMutation__
 *
 * To run a mutation, you first call `useSaveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocumentMutation, { data, loading, error }] = useSaveDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDocumentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SaveDocumentMutation, SaveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDocumentMutation, SaveDocumentMutationVariables>(SaveDocumentDocument, options);
      }
export type SaveDocumentMutationHookResult = ReturnType<typeof useSaveDocumentMutation>;
export type SaveDocumentMutationResult = ApolloReactHooks.useMutation.Result<SaveDocumentMutation>;
export type SaveDocumentMutationOptions = ApolloReactHooks.useMutation.Options<SaveDocumentMutation, SaveDocumentMutationVariables>;
export const UpdateDocumentPropsDocument = gql`
    mutation UpdateDocumentProps($input: UpdateDocumentInput!) {
  updateDocumentProps(input: $input) {
    document {
      __typename
      id
      description
      forwardingPermissionRole
      name
      status
    }
  }
}
    `;
export type UpdateDocumentPropsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateDocumentPropsMutation, UpdateDocumentPropsMutationVariables>;

/**
 * __useUpdateDocumentPropsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentPropsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentPropsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentPropsMutation, { data, loading, error }] = useUpdateDocumentPropsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentPropsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateDocumentPropsMutation, UpdateDocumentPropsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentPropsMutation, UpdateDocumentPropsMutationVariables>(UpdateDocumentPropsDocument, options);
      }
export type UpdateDocumentPropsMutationHookResult = ReturnType<typeof useUpdateDocumentPropsMutation>;
export type UpdateDocumentPropsMutationResult = ApolloReactHooks.useMutation.Result<UpdateDocumentPropsMutation>;
export type UpdateDocumentPropsMutationOptions = ApolloReactHooks.useMutation.Options<UpdateDocumentPropsMutation, UpdateDocumentPropsMutationVariables>;
export const SetDocumentsStatusDocument = gql`
    mutation SetDocumentsStatus($input: SetDocumentsStatusInput!) {
  setDocumentsStatus(input: $input) {
    documentIds
    status
    isActive
    isSigned
    variant
    numSuccess
    numSkipped
    skipCounts {
      reason
      count
    }
    numQueued
    jobId
  }
}
    `;
export type SetDocumentsStatusMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetDocumentsStatusMutation, SetDocumentsStatusMutationVariables>;

/**
 * __useSetDocumentsStatusMutation__
 *
 * To run a mutation, you first call `useSetDocumentsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentsStatusMutation, { data, loading, error }] = useSetDocumentsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDocumentsStatusMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetDocumentsStatusMutation, SetDocumentsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDocumentsStatusMutation, SetDocumentsStatusMutationVariables>(SetDocumentsStatusDocument, options);
      }
export type SetDocumentsStatusMutationHookResult = ReturnType<typeof useSetDocumentsStatusMutation>;
export type SetDocumentsStatusMutationResult = ApolloReactHooks.useMutation.Result<SetDocumentsStatusMutation>;
export type SetDocumentsStatusMutationOptions = ApolloReactHooks.useMutation.Options<SetDocumentsStatusMutation, SetDocumentsStatusMutationVariables>;
export const GetDocumentStatusJobsDocument = gql`
    query GetDocumentStatusJobs {
  documentStatusJobs {
    ...DocumentStatusJobFields
  }
}
    ${DocumentStatusJobFieldsFragmentDoc}`;

/**
 * __useGetDocumentStatusJobsQuery__
 *
 * To run a query within a React component, call `useGetDocumentStatusJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentStatusJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentStatusJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentStatusJobsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetDocumentStatusJobsQuery, GetDocumentStatusJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentStatusJobsQuery, GetDocumentStatusJobsQueryVariables>(GetDocumentStatusJobsDocument, options);
      }
export function useGetDocumentStatusJobsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentStatusJobsQuery, GetDocumentStatusJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentStatusJobsQuery, GetDocumentStatusJobsQueryVariables>(GetDocumentStatusJobsDocument, options);
        }
export function useGetDocumentStatusJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentStatusJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentStatusJobsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentStatusJobsQuery, GetDocumentStatusJobsQueryVariables>(GetDocumentStatusJobsDocument, options);
        }
export type GetDocumentStatusJobsQueryHookResult = ReturnType<typeof useGetDocumentStatusJobsQuery>;
export type GetDocumentStatusJobsLazyQueryHookResult = ReturnType<typeof useGetDocumentStatusJobsLazyQuery>;
export type GetDocumentStatusJobsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentStatusJobsSuspenseQuery>;
export type GetDocumentStatusJobsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentStatusJobsQuery, GetDocumentStatusJobsQueryVariables>;
export const CancelDocumentStatusJobDocument = gql`
    mutation CancelDocumentStatusJob($jobId: UUID!) {
  cancelDocumentStatusJob(jobId: $jobId)
}
    `;
export type CancelDocumentStatusJobMutationFn = ApolloReactHooks.useMutation.MutationFunction<CancelDocumentStatusJobMutation, CancelDocumentStatusJobMutationVariables>;

/**
 * __useCancelDocumentStatusJobMutation__
 *
 * To run a mutation, you first call `useCancelDocumentStatusJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDocumentStatusJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDocumentStatusJobMutation, { data, loading, error }] = useCancelDocumentStatusJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelDocumentStatusJobMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CancelDocumentStatusJobMutation, CancelDocumentStatusJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelDocumentStatusJobMutation, CancelDocumentStatusJobMutationVariables>(CancelDocumentStatusJobDocument, options);
      }
export type CancelDocumentStatusJobMutationHookResult = ReturnType<typeof useCancelDocumentStatusJobMutation>;
export type CancelDocumentStatusJobMutationResult = ApolloReactHooks.useMutation.Result<CancelDocumentStatusJobMutation>;
export type CancelDocumentStatusJobMutationOptions = ApolloReactHooks.useMutation.Options<CancelDocumentStatusJobMutation, CancelDocumentStatusJobMutationVariables>;
export const OnDocumentStatusJobProgressDocument = gql`
    subscription OnDocumentStatusJobProgress {
  documentStatusJobProgress {
    job {
      ...DocumentStatusJobFields
    }
    documentIds
    isActive
    isSigned
    variant
  }
}
    ${DocumentStatusJobFieldsFragmentDoc}`;

/**
 * __useOnDocumentStatusJobProgressSubscription__
 *
 * To run a query within a React component, call `useOnDocumentStatusJobProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDocumentStatusJobProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDocumentStatusJobProgressSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDocumentStatusJobProgressSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnDocumentStatusJobProgressSubscription, OnDocumentStatusJobProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnDocumentStatusJobProgressSubscription, OnDocumentStatusJobProgressSubscriptionVariables>(OnDocumentStatusJobProgressDocument, options);
      }
export type OnDocumentStatusJobProgressSubscriptionHookResult = ReturnType<typeof useOnDocumentStatusJobProgressSubscription>;
export type OnDocumentStatusJobProgressSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnDocumentStatusJobProgressSubscription>;
export const CopyDocumentDocument = gql`
    mutation CopyDocument($documentId: UUID!, $documentProps: DuplicateDocument!) {
  copyDocument(documentId: $documentId, documentProps: $documentProps) {
    document {
      ...DocumentFieldsBase
    }
  }
}
    ${DocumentFieldsBaseFragmentDoc}`;
export type CopyDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<CopyDocumentMutation, CopyDocumentMutationVariables>;

/**
 * __useCopyDocumentMutation__
 *
 * To run a mutation, you first call `useCopyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyDocumentMutation, { data, loading, error }] = useCopyDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      documentProps: // value for 'documentProps'
 *   },
 * });
 */
export function useCopyDocumentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CopyDocumentMutation, CopyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyDocumentMutation, CopyDocumentMutationVariables>(CopyDocumentDocument, options);
      }
export type CopyDocumentMutationHookResult = ReturnType<typeof useCopyDocumentMutation>;
export type CopyDocumentMutationResult = ApolloReactHooks.useMutation.Result<CopyDocumentMutation>;
export type CopyDocumentMutationOptions = ApolloReactHooks.useMutation.Options<CopyDocumentMutation, CopyDocumentMutationVariables>;
export const ImportDocumentDocument = gql`
    mutation ImportDocument($documentId: UUID!) {
  importDocument(documentId: $documentId) {
    document {
      __typename
      id
      conversionStartedAt
      conversionFinishedAt
      conversionFailedAt
      latestVersion {
        ...FileVersionSimple
      }
    }
  }
}
    ${FileVersionSimpleFragmentDoc}`;
export type ImportDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<ImportDocumentMutation, ImportDocumentMutationVariables>;

/**
 * __useImportDocumentMutation__
 *
 * To run a mutation, you first call `useImportDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDocumentMutation, { data, loading, error }] = useImportDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useImportDocumentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ImportDocumentMutation, ImportDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImportDocumentMutation, ImportDocumentMutationVariables>(ImportDocumentDocument, options);
      }
export type ImportDocumentMutationHookResult = ReturnType<typeof useImportDocumentMutation>;
export type ImportDocumentMutationResult = ApolloReactHooks.useMutation.Result<ImportDocumentMutation>;
export type ImportDocumentMutationOptions = ApolloReactHooks.useMutation.Options<ImportDocumentMutation, ImportDocumentMutationVariables>;
export const OnDocumentUpdatedDocument = gql`
    subscription OnDocumentUpdated($documentId: UUID!) {
  documentUpdated(documentId: $documentId) {
    commentsChanged
    document {
      __typename
      id
      name
      isSavePending
      conversionStartedAt
      conversionFinishedAt
      conversionFailedAt
      latestVersion {
        ... on DocumentVersion {
          __typename
          id
          fileContentChangedAt
          vectorsFailedAt
          vectorsSavedAt
          vectorsStartedAt
        }
        ... on StaticFileVersion {
          __typename
          id
          fileContentChangedAt
          fileExtractionFailedAt
          fileExtractionFinishedAt
          fileExtractionFinishedAt
          fileExtractionFailedReason
          vectorsStartedAt
          vectorsSavedAt
          vectorsFailedAt
          fileLocation {
            __typename
            id
            filestackUrl
            mimetype
            size
          }
        }
      }
      variables {
        ...DocumentVariableFull
      }
      signatureFields {
        ...SignatureFieldSimple
      }
    }
    questions {
      id
      title
      questionText
      extractionJob(documentId: $documentId) {
        ...ExtractionJobSimple
      }
      createdAt
      updatedAt
    }
  }
}
    ${DocumentVariableFullFragmentDoc}
${SignatureFieldSimpleFragmentDoc}
${ExtractionJobSimpleFragmentDoc}`;

/**
 * __useOnDocumentUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnDocumentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDocumentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDocumentUpdatedSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useOnDocumentUpdatedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnDocumentUpdatedSubscription, OnDocumentUpdatedSubscriptionVariables> & ({ variables: OnDocumentUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnDocumentUpdatedSubscription, OnDocumentUpdatedSubscriptionVariables>(OnDocumentUpdatedDocument, options);
      }
export type OnDocumentUpdatedSubscriptionHookResult = ReturnType<typeof useOnDocumentUpdatedSubscription>;
export type OnDocumentUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnDocumentUpdatedSubscription>;
export const OnDocumentsUpdatedDocument = gql`
    subscription OnDocumentsUpdated {
  documentsUpdated {
    documents {
      ...DocumentReportRow
    }
  }
}
    ${DocumentReportRowFragmentDoc}`;

/**
 * __useOnDocumentsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnDocumentsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDocumentsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDocumentsUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDocumentsUpdatedSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnDocumentsUpdatedSubscription, OnDocumentsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnDocumentsUpdatedSubscription, OnDocumentsUpdatedSubscriptionVariables>(OnDocumentsUpdatedDocument, options);
      }
export type OnDocumentsUpdatedSubscriptionHookResult = ReturnType<typeof useOnDocumentsUpdatedSubscription>;
export type OnDocumentsUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnDocumentsUpdatedSubscription>;
export const OnDocPlaybooksUpdatedDocument = gql`
    subscription OnDocPlaybooksUpdated($documentId: UUID!) {
  docPlaybooksUpdated(documentId: $documentId) {
    documentId
    playbooks {
      __typename
      id
      title
      description
      runStatus(documentId: $documentId)
      categories {
        ...PlaybookRuleCategoryWithRuleJobs
      }
    }
    ruleJob {
      ...PlaybookRuleJobWithProposals
      rule {
        __typename
        id
        ruleJob(documentId: $documentId) {
          __typename
          id
        }
      }
    }
    playbook {
      __typename
      id
      runStatus(documentId: $documentId)
    }
  }
}
    ${PlaybookRuleCategoryWithRuleJobsFragmentDoc}
${PlaybookRuleJobWithProposalsFragmentDoc}`;

/**
 * __useOnDocPlaybooksUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnDocPlaybooksUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDocPlaybooksUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDocPlaybooksUpdatedSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useOnDocPlaybooksUpdatedSubscription(baseOptions: ApolloReactHooks.useSubscription.Options<OnDocPlaybooksUpdatedSubscription, OnDocPlaybooksUpdatedSubscriptionVariables> & ({ variables: OnDocPlaybooksUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnDocPlaybooksUpdatedSubscription, OnDocPlaybooksUpdatedSubscriptionVariables>(OnDocPlaybooksUpdatedDocument, options);
      }
export type OnDocPlaybooksUpdatedSubscriptionHookResult = ReturnType<typeof useOnDocPlaybooksUpdatedSubscription>;
export type OnDocPlaybooksUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnDocPlaybooksUpdatedSubscription>;
export const OnPlaybookGenerationJobUpdatedDocument = gql`
    subscription OnPlaybookGenerationJobUpdated {
  playbookGenerationJobUpdated {
    generationJobId
    createdCategoryId
    createdCategory {
      ...PlaybookRuleCategoryWithRules
    }
    createdRuleId
    createdRule {
      ...PlaybookRuleSimple
      category {
        __typename
        id
      }
    }
    generationJob {
      ...PlaybookGenerationProgress
    }
  }
}
    ${PlaybookRuleCategoryWithRulesFragmentDoc}
${PlaybookRuleSimpleFragmentDoc}
${PlaybookGenerationProgressFragmentDoc}`;

/**
 * __useOnPlaybookGenerationJobUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnPlaybookGenerationJobUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPlaybookGenerationJobUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPlaybookGenerationJobUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnPlaybookGenerationJobUpdatedSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnPlaybookGenerationJobUpdatedSubscription, OnPlaybookGenerationJobUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnPlaybookGenerationJobUpdatedSubscription, OnPlaybookGenerationJobUpdatedSubscriptionVariables>(OnPlaybookGenerationJobUpdatedDocument, options);
      }
export type OnPlaybookGenerationJobUpdatedSubscriptionHookResult = ReturnType<typeof useOnPlaybookGenerationJobUpdatedSubscription>;
export type OnPlaybookGenerationJobUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnPlaybookGenerationJobUpdatedSubscription>;
export const OnQuestionGenerationUpdatedDocument = gql`
    subscription OnQuestionGenerationUpdated {
  questionGenerationUpdated {
    generationJob {
      id
      startedAt
      failedAt
      failedReason
      finishedAt
      extractionQuestions {
        isActive
        aiGenerated
      }
    }
  }
}
    `;

/**
 * __useOnQuestionGenerationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnQuestionGenerationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnQuestionGenerationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnQuestionGenerationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnQuestionGenerationUpdatedSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnQuestionGenerationUpdatedSubscription, OnQuestionGenerationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnQuestionGenerationUpdatedSubscription, OnQuestionGenerationUpdatedSubscriptionVariables>(OnQuestionGenerationUpdatedDocument, options);
      }
export type OnQuestionGenerationUpdatedSubscriptionHookResult = ReturnType<typeof useOnQuestionGenerationUpdatedSubscription>;
export type OnQuestionGenerationUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnQuestionGenerationUpdatedSubscription>;
export const GetDocumentHeaderDocument = gql`
    query GetDocumentHeader($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    createdAt
    requesterRole
    latestVersion {
      __typename
      ... on DocumentVersion {
        __typename
        id
      }
      ... on StaticFileVersion {
        __typename
        id
        fileLocation {
          __typename
          id
          mimetype
        }
      }
    }
    workflow {
      __typename
      id
      name
      state
      status
      envelopeStatus
      variant
      startedAt
      createdAt
      completedAt
      publishedAt
      activeStep {
        __typename
        id
      }
      owner {
        ...UserBase
      }
      files {
        ...WorkflowFileSimple
      }
      permissions {
        ...WorkflowPermissionSimple
      }
    }
  }
}
    ${UserBaseFragmentDoc}
${WorkflowFileSimpleFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetDocumentHeaderQuery__
 *
 * To run a query within a React component, call `useGetDocumentHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentHeaderQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentHeaderQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentHeaderQuery, GetDocumentHeaderQueryVariables> & ({ variables: GetDocumentHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentHeaderQuery, GetDocumentHeaderQueryVariables>(GetDocumentHeaderDocument, options);
      }
export function useGetDocumentHeaderLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentHeaderQuery, GetDocumentHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentHeaderQuery, GetDocumentHeaderQueryVariables>(GetDocumentHeaderDocument, options);
        }
export function useGetDocumentHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentHeaderQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentHeaderQuery, GetDocumentHeaderQueryVariables>(GetDocumentHeaderDocument, options);
        }
export type GetDocumentHeaderQueryHookResult = ReturnType<typeof useGetDocumentHeaderQuery>;
export type GetDocumentHeaderLazyQueryHookResult = ReturnType<typeof useGetDocumentHeaderLazyQuery>;
export type GetDocumentHeaderSuspenseQueryHookResult = ReturnType<typeof useGetDocumentHeaderSuspenseQuery>;
export type GetDocumentHeaderQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentHeaderQuery, GetDocumentHeaderQueryVariables>;
export const GetDocumentFileDetailsDocument = gql`
    query GetDocumentFileDetails($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    coreAiPropertiesExtractionStartedAt
    coreAiPropertiesExtractionFinishedAt
    coreAiPropertiesExtractionFailedAt
    conversionStartedAt
    conversionFinishedAt
    conversionFailedAt
    name
    requesterRole
    relationshipMatchingStartedAt
    relationshipMatchingFinishedAt
    relationshipMatchingFailedReason
    variant
    latestVersion {
      ...FileVersionSimple
    }
    owner {
      ...UserBase
    }
    type {
      ...ContractTypeSimple
    }
    parties {
      ...PartySimple
    }
    workflow {
      __typename
      id
      owner {
        __typename
        id
        displayName
      }
    }
    parentRelationships {
      ...DocumentFileDetailsRelationship
    }
    childRelationships {
      ...DocumentFileDetailsRelationship
    }
    urlRelationships {
      ...DocumentFileDetailsUrlRelationship
    }
  }
}
    ${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}
${ContractTypeSimpleFragmentDoc}
${PartySimpleFragmentDoc}
${DocumentFileDetailsRelationshipFragmentDoc}
${DocumentFileDetailsUrlRelationshipFragmentDoc}`;

/**
 * __useGetDocumentFileDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentFileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentFileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentFileDetailsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentFileDetailsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentFileDetailsQuery, GetDocumentFileDetailsQueryVariables> & ({ variables: GetDocumentFileDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentFileDetailsQuery, GetDocumentFileDetailsQueryVariables>(GetDocumentFileDetailsDocument, options);
      }
export function useGetDocumentFileDetailsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentFileDetailsQuery, GetDocumentFileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentFileDetailsQuery, GetDocumentFileDetailsQueryVariables>(GetDocumentFileDetailsDocument, options);
        }
export function useGetDocumentFileDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentFileDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentFileDetailsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentFileDetailsQuery, GetDocumentFileDetailsQueryVariables>(GetDocumentFileDetailsDocument, options);
        }
export type GetDocumentFileDetailsQueryHookResult = ReturnType<typeof useGetDocumentFileDetailsQuery>;
export type GetDocumentFileDetailsLazyQueryHookResult = ReturnType<typeof useGetDocumentFileDetailsLazyQuery>;
export type GetDocumentFileDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentFileDetailsSuspenseQuery>;
export type GetDocumentFileDetailsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentFileDetailsQuery, GetDocumentFileDetailsQueryVariables>;
export const GetFileVersionDocument = gql`
    query GetFileVersion($fileVersionId: UUID!) {
  fileVersion(fileVersionId: $fileVersionId) {
    ...FileVersionSimple
    ... on DocumentVersion {
      documentJSON
    }
  }
}
    ${FileVersionSimpleFragmentDoc}`;

/**
 * __useGetFileVersionQuery__
 *
 * To run a query within a React component, call `useGetFileVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileVersionQuery({
 *   variables: {
 *      fileVersionId: // value for 'fileVersionId'
 *   },
 * });
 */
export function useGetFileVersionQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetFileVersionQuery, GetFileVersionQueryVariables> & ({ variables: GetFileVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFileVersionQuery, GetFileVersionQueryVariables>(GetFileVersionDocument, options);
      }
export function useGetFileVersionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFileVersionQuery, GetFileVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFileVersionQuery, GetFileVersionQueryVariables>(GetFileVersionDocument, options);
        }
export function useGetFileVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFileVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFileVersionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFileVersionQuery, GetFileVersionQueryVariables>(GetFileVersionDocument, options);
        }
export type GetFileVersionQueryHookResult = ReturnType<typeof useGetFileVersionQuery>;
export type GetFileVersionLazyQueryHookResult = ReturnType<typeof useGetFileVersionLazyQuery>;
export type GetFileVersionSuspenseQueryHookResult = ReturnType<typeof useGetFileVersionSuspenseQuery>;
export type GetFileVersionQueryResult = ApolloReactHooks.useQuery.Result<GetFileVersionQuery, GetFileVersionQueryVariables>;
export const CreateStaticFileVersionDocument = gql`
    mutation CreateStaticFileVersion($input: CreateStaticFileVersionInput!) {
  createStaticFileVersion(input: $input) {
    fileVersion {
      ...FileVersionSimple
    }
  }
}
    ${FileVersionSimpleFragmentDoc}`;
export type CreateStaticFileVersionMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateStaticFileVersionMutation, CreateStaticFileVersionMutationVariables>;

/**
 * __useCreateStaticFileVersionMutation__
 *
 * To run a mutation, you first call `useCreateStaticFileVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaticFileVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaticFileVersionMutation, { data, loading, error }] = useCreateStaticFileVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStaticFileVersionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateStaticFileVersionMutation, CreateStaticFileVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStaticFileVersionMutation, CreateStaticFileVersionMutationVariables>(CreateStaticFileVersionDocument, options);
      }
export type CreateStaticFileVersionMutationHookResult = ReturnType<typeof useCreateStaticFileVersionMutation>;
export type CreateStaticFileVersionMutationResult = ApolloReactHooks.useMutation.Result<CreateStaticFileVersionMutation>;
export type CreateStaticFileVersionMutationOptions = ApolloReactHooks.useMutation.Options<CreateStaticFileVersionMutation, CreateStaticFileVersionMutationVariables>;
export const CreateStaticFileVersionsDocument = gql`
    mutation CreateStaticFileVersions($input: CreateStaticFileVersionsInput!) {
  createStaticFileVersions(input: $input) {
    ...FileVersionSimple
  }
}
    ${FileVersionSimpleFragmentDoc}`;
export type CreateStaticFileVersionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateStaticFileVersionsMutation, CreateStaticFileVersionsMutationVariables>;

/**
 * __useCreateStaticFileVersionsMutation__
 *
 * To run a mutation, you first call `useCreateStaticFileVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaticFileVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaticFileVersionsMutation, { data, loading, error }] = useCreateStaticFileVersionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStaticFileVersionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateStaticFileVersionsMutation, CreateStaticFileVersionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStaticFileVersionsMutation, CreateStaticFileVersionsMutationVariables>(CreateStaticFileVersionsDocument, options);
      }
export type CreateStaticFileVersionsMutationHookResult = ReturnType<typeof useCreateStaticFileVersionsMutation>;
export type CreateStaticFileVersionsMutationResult = ApolloReactHooks.useMutation.Result<CreateStaticFileVersionsMutation>;
export type CreateStaticFileVersionsMutationOptions = ApolloReactHooks.useMutation.Options<CreateStaticFileVersionsMutation, CreateStaticFileVersionsMutationVariables>;
export const DeleteFileVersionDocument = gql`
    mutation DeleteFileVersion($id: UUID!) {
  deleteFileVersion(id: $id)
}
    `;
export type DeleteFileVersionMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteFileVersionMutation, DeleteFileVersionMutationVariables>;

/**
 * __useDeleteFileVersionMutation__
 *
 * To run a mutation, you first call `useDeleteFileVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileVersionMutation, { data, loading, error }] = useDeleteFileVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileVersionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteFileVersionMutation, DeleteFileVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFileVersionMutation, DeleteFileVersionMutationVariables>(DeleteFileVersionDocument, options);
      }
export type DeleteFileVersionMutationHookResult = ReturnType<typeof useDeleteFileVersionMutation>;
export type DeleteFileVersionMutationResult = ApolloReactHooks.useMutation.Result<DeleteFileVersionMutation>;
export type DeleteFileVersionMutationOptions = ApolloReactHooks.useMutation.Options<DeleteFileVersionMutation, DeleteFileVersionMutationVariables>;
export const SyncFileVersionToCrmDocument = gql`
    mutation SyncFileVersionToCrm($input: SyncFileVersionToCrmInput!) {
  syncFileVersionToCrm(input: $input) {
    fileVersion {
      ... on FileVersionInterface {
        __typename
        id
        name
      }
    }
  }
}
    `;
export type SyncFileVersionToCrmMutationFn = ApolloReactHooks.useMutation.MutationFunction<SyncFileVersionToCrmMutation, SyncFileVersionToCrmMutationVariables>;

/**
 * __useSyncFileVersionToCrmMutation__
 *
 * To run a mutation, you first call `useSyncFileVersionToCrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFileVersionToCrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFileVersionToCrmMutation, { data, loading, error }] = useSyncFileVersionToCrmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncFileVersionToCrmMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SyncFileVersionToCrmMutation, SyncFileVersionToCrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncFileVersionToCrmMutation, SyncFileVersionToCrmMutationVariables>(SyncFileVersionToCrmDocument, options);
      }
export type SyncFileVersionToCrmMutationHookResult = ReturnType<typeof useSyncFileVersionToCrmMutation>;
export type SyncFileVersionToCrmMutationResult = ApolloReactHooks.useMutation.Result<SyncFileVersionToCrmMutation>;
export type SyncFileVersionToCrmMutationOptions = ApolloReactHooks.useMutation.Options<SyncFileVersionToCrmMutation, SyncFileVersionToCrmMutationVariables>;
export const UpdateFileVersionDocument = gql`
    mutation UpdateFileVersion($input: UpdateFileVersionInput!) {
  updateFileVersion(input: $input) {
    fileVersion {
      ... on FileVersionInterface {
        __typename
        id
        name
      }
    }
  }
}
    `;
export type UpdateFileVersionMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateFileVersionMutation, UpdateFileVersionMutationVariables>;

/**
 * __useUpdateFileVersionMutation__
 *
 * To run a mutation, you first call `useUpdateFileVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileVersionMutation, { data, loading, error }] = useUpdateFileVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileVersionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateFileVersionMutation, UpdateFileVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFileVersionMutation, UpdateFileVersionMutationVariables>(UpdateFileVersionDocument, options);
      }
export type UpdateFileVersionMutationHookResult = ReturnType<typeof useUpdateFileVersionMutation>;
export type UpdateFileVersionMutationResult = ApolloReactHooks.useMutation.Result<UpdateFileVersionMutation>;
export type UpdateFileVersionMutationOptions = ApolloReactHooks.useMutation.Options<UpdateFileVersionMutation, UpdateFileVersionMutationVariables>;
export const GetStorableRoleDocument = gql`
    query GetStorableRole($storableId: UUID!) {
  storableRole(storableId: $storableId) {
    ...PermissionSimple
    storable {
      ... on StorableInterface {
        __typename
        id
      }
    }
  }
}
    ${PermissionSimpleFragmentDoc}`;

/**
 * __useGetStorableRoleQuery__
 *
 * To run a query within a React component, call `useGetStorableRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorableRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorableRoleQuery({
 *   variables: {
 *      storableId: // value for 'storableId'
 *   },
 * });
 */
export function useGetStorableRoleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetStorableRoleQuery, GetStorableRoleQueryVariables> & ({ variables: GetStorableRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStorableRoleQuery, GetStorableRoleQueryVariables>(GetStorableRoleDocument, options);
      }
export function useGetStorableRoleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetStorableRoleQuery, GetStorableRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStorableRoleQuery, GetStorableRoleQueryVariables>(GetStorableRoleDocument, options);
        }
export function useGetStorableRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetStorableRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetStorableRoleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetStorableRoleQuery, GetStorableRoleQueryVariables>(GetStorableRoleDocument, options);
        }
export type GetStorableRoleQueryHookResult = ReturnType<typeof useGetStorableRoleQuery>;
export type GetStorableRoleLazyQueryHookResult = ReturnType<typeof useGetStorableRoleLazyQuery>;
export type GetStorableRoleSuspenseQueryHookResult = ReturnType<typeof useGetStorableRoleSuspenseQuery>;
export type GetStorableRoleQueryResult = ApolloReactHooks.useQuery.Result<GetStorableRoleQuery, GetStorableRoleQueryVariables>;
export const GetSharedStorablesDocument = gql`
    query GetSharedStorables {
  sharedStorables {
    ...PermissionWithStorable
  }
}
    ${PermissionWithStorableFragmentDoc}`;

/**
 * __useGetSharedStorablesQuery__
 *
 * To run a query within a React component, call `useGetSharedStorablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedStorablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedStorablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSharedStorablesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetSharedStorablesQuery, GetSharedStorablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSharedStorablesQuery, GetSharedStorablesQueryVariables>(GetSharedStorablesDocument, options);
      }
export function useGetSharedStorablesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetSharedStorablesQuery, GetSharedStorablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSharedStorablesQuery, GetSharedStorablesQueryVariables>(GetSharedStorablesDocument, options);
        }
export function useGetSharedStorablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetSharedStorablesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetSharedStorablesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetSharedStorablesQuery, GetSharedStorablesQueryVariables>(GetSharedStorablesDocument, options);
        }
export type GetSharedStorablesQueryHookResult = ReturnType<typeof useGetSharedStorablesQuery>;
export type GetSharedStorablesLazyQueryHookResult = ReturnType<typeof useGetSharedStorablesLazyQuery>;
export type GetSharedStorablesSuspenseQueryHookResult = ReturnType<typeof useGetSharedStorablesSuspenseQuery>;
export type GetSharedStorablesQueryResult = ApolloReactHooks.useQuery.Result<GetSharedStorablesQuery, GetSharedStorablesQueryVariables>;
export const GetStorablePermissionsDocument = gql`
    query GetStorablePermissions($storableId: UUID!) {
  storablePermissions(storableId: $storableId) {
    ...PermissionSimple
    storable {
      ... on StorableInterface {
        __typename
        id
      }
    }
  }
}
    ${PermissionSimpleFragmentDoc}`;

/**
 * __useGetStorablePermissionsQuery__
 *
 * To run a query within a React component, call `useGetStorablePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorablePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorablePermissionsQuery({
 *   variables: {
 *      storableId: // value for 'storableId'
 *   },
 * });
 */
export function useGetStorablePermissionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetStorablePermissionsQuery, GetStorablePermissionsQueryVariables> & ({ variables: GetStorablePermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStorablePermissionsQuery, GetStorablePermissionsQueryVariables>(GetStorablePermissionsDocument, options);
      }
export function useGetStorablePermissionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetStorablePermissionsQuery, GetStorablePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStorablePermissionsQuery, GetStorablePermissionsQueryVariables>(GetStorablePermissionsDocument, options);
        }
export function useGetStorablePermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetStorablePermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetStorablePermissionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetStorablePermissionsQuery, GetStorablePermissionsQueryVariables>(GetStorablePermissionsDocument, options);
        }
export type GetStorablePermissionsQueryHookResult = ReturnType<typeof useGetStorablePermissionsQuery>;
export type GetStorablePermissionsLazyQueryHookResult = ReturnType<typeof useGetStorablePermissionsLazyQuery>;
export type GetStorablePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetStorablePermissionsSuspenseQuery>;
export type GetStorablePermissionsQueryResult = ApolloReactHooks.useQuery.Result<GetStorablePermissionsQuery, GetStorablePermissionsQueryVariables>;
export const GetStorablePermissionsWithStorableDocument = gql`
    query GetStorablePermissionsWithStorable($storableId: UUID!) {
  storablePermissions(storableId: $storableId) {
    ...PermissionWithStorable
  }
}
    ${PermissionWithStorableFragmentDoc}`;

/**
 * __useGetStorablePermissionsWithStorableQuery__
 *
 * To run a query within a React component, call `useGetStorablePermissionsWithStorableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorablePermissionsWithStorableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorablePermissionsWithStorableQuery({
 *   variables: {
 *      storableId: // value for 'storableId'
 *   },
 * });
 */
export function useGetStorablePermissionsWithStorableQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetStorablePermissionsWithStorableQuery, GetStorablePermissionsWithStorableQueryVariables> & ({ variables: GetStorablePermissionsWithStorableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStorablePermissionsWithStorableQuery, GetStorablePermissionsWithStorableQueryVariables>(GetStorablePermissionsWithStorableDocument, options);
      }
export function useGetStorablePermissionsWithStorableLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetStorablePermissionsWithStorableQuery, GetStorablePermissionsWithStorableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStorablePermissionsWithStorableQuery, GetStorablePermissionsWithStorableQueryVariables>(GetStorablePermissionsWithStorableDocument, options);
        }
export function useGetStorablePermissionsWithStorableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetStorablePermissionsWithStorableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetStorablePermissionsWithStorableQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetStorablePermissionsWithStorableQuery, GetStorablePermissionsWithStorableQueryVariables>(GetStorablePermissionsWithStorableDocument, options);
        }
export type GetStorablePermissionsWithStorableQueryHookResult = ReturnType<typeof useGetStorablePermissionsWithStorableQuery>;
export type GetStorablePermissionsWithStorableLazyQueryHookResult = ReturnType<typeof useGetStorablePermissionsWithStorableLazyQuery>;
export type GetStorablePermissionsWithStorableSuspenseQueryHookResult = ReturnType<typeof useGetStorablePermissionsWithStorableSuspenseQuery>;
export type GetStorablePermissionsWithStorableQueryResult = ApolloReactHooks.useQuery.Result<GetStorablePermissionsWithStorableQuery, GetStorablePermissionsWithStorableQueryVariables>;
export const DeleteStorablePermissionDocument = gql`
    mutation DeleteStorablePermission($permissionId: UUID!) {
  deleteStorablePermission(permissionId: $permissionId) {
    storablePermission {
      ...PermissionSimple
      storable {
        ... on StorableInterface {
          __typename
          id
        }
      }
    }
  }
}
    ${PermissionSimpleFragmentDoc}`;
export type DeleteStorablePermissionMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteStorablePermissionMutation, DeleteStorablePermissionMutationVariables>;

/**
 * __useDeleteStorablePermissionMutation__
 *
 * To run a mutation, you first call `useDeleteStorablePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStorablePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStorablePermissionMutation, { data, loading, error }] = useDeleteStorablePermissionMutation({
 *   variables: {
 *      permissionId: // value for 'permissionId'
 *   },
 * });
 */
export function useDeleteStorablePermissionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteStorablePermissionMutation, DeleteStorablePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteStorablePermissionMutation, DeleteStorablePermissionMutationVariables>(DeleteStorablePermissionDocument, options);
      }
export type DeleteStorablePermissionMutationHookResult = ReturnType<typeof useDeleteStorablePermissionMutation>;
export type DeleteStorablePermissionMutationResult = ApolloReactHooks.useMutation.Result<DeleteStorablePermissionMutation>;
export type DeleteStorablePermissionMutationOptions = ApolloReactHooks.useMutation.Options<DeleteStorablePermissionMutation, DeleteStorablePermissionMutationVariables>;
export const UpsertStorablePermissionsDocument = gql`
    mutation UpsertStorablePermissions($input: UpsertStorablePermissions!) {
  upsertStorablePermissions(input: $input) {
    storablePermissions {
      ...PermissionSimple
      storable {
        ... on StorableInterface {
          __typename
          id
        }
      }
    }
  }
}
    ${PermissionSimpleFragmentDoc}`;
export type UpsertStorablePermissionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpsertStorablePermissionsMutation, UpsertStorablePermissionsMutationVariables>;

/**
 * __useUpsertStorablePermissionsMutation__
 *
 * To run a mutation, you first call `useUpsertStorablePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStorablePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStorablePermissionsMutation, { data, loading, error }] = useUpsertStorablePermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertStorablePermissionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpsertStorablePermissionsMutation, UpsertStorablePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertStorablePermissionsMutation, UpsertStorablePermissionsMutationVariables>(UpsertStorablePermissionsDocument, options);
      }
export type UpsertStorablePermissionsMutationHookResult = ReturnType<typeof useUpsertStorablePermissionsMutation>;
export type UpsertStorablePermissionsMutationResult = ApolloReactHooks.useMutation.Result<UpsertStorablePermissionsMutation>;
export type UpsertStorablePermissionsMutationOptions = ApolloReactHooks.useMutation.Options<UpsertStorablePermissionsMutation, UpsertStorablePermissionsMutationVariables>;
export const GetStorablesDocument = gql`
    query GetStorables($storableIds: [UUID!]!) {
  storables(ids: $storableIds) {
    documents {
      ...DocumentSimple
    }
  }
}
    ${DocumentSimpleFragmentDoc}`;

/**
 * __useGetStorablesQuery__
 *
 * To run a query within a React component, call `useGetStorablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorablesQuery({
 *   variables: {
 *      storableIds: // value for 'storableIds'
 *   },
 * });
 */
export function useGetStorablesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetStorablesQuery, GetStorablesQueryVariables> & ({ variables: GetStorablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStorablesQuery, GetStorablesQueryVariables>(GetStorablesDocument, options);
      }
export function useGetStorablesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetStorablesQuery, GetStorablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStorablesQuery, GetStorablesQueryVariables>(GetStorablesDocument, options);
        }
export function useGetStorablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetStorablesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetStorablesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetStorablesQuery, GetStorablesQueryVariables>(GetStorablesDocument, options);
        }
export type GetStorablesQueryHookResult = ReturnType<typeof useGetStorablesQuery>;
export type GetStorablesLazyQueryHookResult = ReturnType<typeof useGetStorablesLazyQuery>;
export type GetStorablesSuspenseQueryHookResult = ReturnType<typeof useGetStorablesSuspenseQuery>;
export type GetStorablesQueryResult = ApolloReactHooks.useQuery.Result<GetStorablesQuery, GetStorablesQueryVariables>;
export const StorableMetadataDocument = gql`
    query StorableMetadata($id: UUID!) {
  storableMetadata(id: $id) {
    ...StorableSimple
  }
}
    ${StorableSimpleFragmentDoc}`;

/**
 * __useStorableMetadataQuery__
 *
 * To run a query within a React component, call `useStorableMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorableMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorableMetadataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStorableMetadataQuery(baseOptions: ApolloReactHooks.useQuery.Options<StorableMetadataQuery, StorableMetadataQueryVariables> & ({ variables: StorableMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorableMetadataQuery, StorableMetadataQueryVariables>(StorableMetadataDocument, options);
      }
export function useStorableMetadataLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<StorableMetadataQuery, StorableMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorableMetadataQuery, StorableMetadataQueryVariables>(StorableMetadataDocument, options);
        }
export function useStorableMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<StorableMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<StorableMetadataQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<StorableMetadataQuery, StorableMetadataQueryVariables>(StorableMetadataDocument, options);
        }
export type StorableMetadataQueryHookResult = ReturnType<typeof useStorableMetadataQuery>;
export type StorableMetadataLazyQueryHookResult = ReturnType<typeof useStorableMetadataLazyQuery>;
export type StorableMetadataSuspenseQueryHookResult = ReturnType<typeof useStorableMetadataSuspenseQuery>;
export type StorableMetadataQueryResult = ApolloReactHooks.useQuery.Result<StorableMetadataQuery, StorableMetadataQueryVariables>;
export const GetFavoriteStorablesDocument = gql`
    query GetFavoriteStorables {
  favoriteStorables {
    documents {
      ...DocumentSimple
    }
  }
}
    ${DocumentSimpleFragmentDoc}`;

/**
 * __useGetFavoriteStorablesQuery__
 *
 * To run a query within a React component, call `useGetFavoriteStorablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteStorablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteStorablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavoriteStorablesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetFavoriteStorablesQuery, GetFavoriteStorablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFavoriteStorablesQuery, GetFavoriteStorablesQueryVariables>(GetFavoriteStorablesDocument, options);
      }
export function useGetFavoriteStorablesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetFavoriteStorablesQuery, GetFavoriteStorablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFavoriteStorablesQuery, GetFavoriteStorablesQueryVariables>(GetFavoriteStorablesDocument, options);
        }
export function useGetFavoriteStorablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFavoriteStorablesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetFavoriteStorablesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetFavoriteStorablesQuery, GetFavoriteStorablesQueryVariables>(GetFavoriteStorablesDocument, options);
        }
export type GetFavoriteStorablesQueryHookResult = ReturnType<typeof useGetFavoriteStorablesQuery>;
export type GetFavoriteStorablesLazyQueryHookResult = ReturnType<typeof useGetFavoriteStorablesLazyQuery>;
export type GetFavoriteStorablesSuspenseQueryHookResult = ReturnType<typeof useGetFavoriteStorablesSuspenseQuery>;
export type GetFavoriteStorablesQueryResult = ApolloReactHooks.useQuery.Result<GetFavoriteStorablesQuery, GetFavoriteStorablesQueryVariables>;
export const SearchDataDocument = gql`
    query SearchData {
  searchData {
    __typename
    documents {
      ...DocumentSimple
    }
  }
}
    ${DocumentSimpleFragmentDoc}`;

/**
 * __useSearchDataQuery__
 *
 * To run a query within a React component, call `useSearchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchDataQuery(baseOptions?: ApolloReactHooks.useQuery.Options<SearchDataQuery, SearchDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchDataQuery, SearchDataQueryVariables>(SearchDataDocument, options);
      }
export function useSearchDataLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<SearchDataQuery, SearchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchDataQuery, SearchDataQueryVariables>(SearchDataDocument, options);
        }
export function useSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<SearchDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<SearchDataQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<SearchDataQuery, SearchDataQueryVariables>(SearchDataDocument, options);
        }
export type SearchDataQueryHookResult = ReturnType<typeof useSearchDataQuery>;
export type SearchDataLazyQueryHookResult = ReturnType<typeof useSearchDataLazyQuery>;
export type SearchDataSuspenseQueryHookResult = ReturnType<typeof useSearchDataSuspenseQuery>;
export type SearchDataQueryResult = ApolloReactHooks.useQuery.Result<SearchDataQuery, SearchDataQueryVariables>;
export const DisabledStorablesDocument = gql`
    query DisabledStorables {
  disabledStorables {
    documents {
      ...DocumentSimple
    }
  }
}
    ${DocumentSimpleFragmentDoc}`;

/**
 * __useDisabledStorablesQuery__
 *
 * To run a query within a React component, call `useDisabledStorablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisabledStorablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisabledStorablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDisabledStorablesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<DisabledStorablesQuery, DisabledStorablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DisabledStorablesQuery, DisabledStorablesQueryVariables>(DisabledStorablesDocument, options);
      }
export function useDisabledStorablesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<DisabledStorablesQuery, DisabledStorablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DisabledStorablesQuery, DisabledStorablesQueryVariables>(DisabledStorablesDocument, options);
        }
export function useDisabledStorablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<DisabledStorablesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<DisabledStorablesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<DisabledStorablesQuery, DisabledStorablesQueryVariables>(DisabledStorablesDocument, options);
        }
export type DisabledStorablesQueryHookResult = ReturnType<typeof useDisabledStorablesQuery>;
export type DisabledStorablesLazyQueryHookResult = ReturnType<typeof useDisabledStorablesLazyQuery>;
export type DisabledStorablesSuspenseQueryHookResult = ReturnType<typeof useDisabledStorablesSuspenseQuery>;
export type DisabledStorablesQueryResult = ApolloReactHooks.useQuery.Result<DisabledStorablesQuery, DisabledStorablesQueryVariables>;
export const DeleteStorablesDocument = gql`
    mutation DeleteStorables($deleteProps: DeleteStorables!) {
  deleteStorables(deleteProps: $deleteProps)
}
    `;
export type DeleteStorablesMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteStorablesMutation, DeleteStorablesMutationVariables>;

/**
 * __useDeleteStorablesMutation__
 *
 * To run a mutation, you first call `useDeleteStorablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStorablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStorablesMutation, { data, loading, error }] = useDeleteStorablesMutation({
 *   variables: {
 *      deleteProps: // value for 'deleteProps'
 *   },
 * });
 */
export function useDeleteStorablesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteStorablesMutation, DeleteStorablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteStorablesMutation, DeleteStorablesMutationVariables>(DeleteStorablesDocument, options);
      }
export type DeleteStorablesMutationHookResult = ReturnType<typeof useDeleteStorablesMutation>;
export type DeleteStorablesMutationResult = ApolloReactHooks.useMutation.Result<DeleteStorablesMutation>;
export type DeleteStorablesMutationOptions = ApolloReactHooks.useMutation.Options<DeleteStorablesMutation, DeleteStorablesMutationVariables>;
export const DisableStorablesDocument = gql`
    mutation DisableStorables($disableProps: DeleteStorables!) {
  disableStorables(disableProps: $disableProps) {
    storables {
      documents {
        ...StorableFields
      }
    }
  }
}
    ${StorableFieldsFragmentDoc}`;
export type DisableStorablesMutationFn = ApolloReactHooks.useMutation.MutationFunction<DisableStorablesMutation, DisableStorablesMutationVariables>;

/**
 * __useDisableStorablesMutation__
 *
 * To run a mutation, you first call `useDisableStorablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableStorablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableStorablesMutation, { data, loading, error }] = useDisableStorablesMutation({
 *   variables: {
 *      disableProps: // value for 'disableProps'
 *   },
 * });
 */
export function useDisableStorablesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DisableStorablesMutation, DisableStorablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableStorablesMutation, DisableStorablesMutationVariables>(DisableStorablesDocument, options);
      }
export type DisableStorablesMutationHookResult = ReturnType<typeof useDisableStorablesMutation>;
export type DisableStorablesMutationResult = ApolloReactHooks.useMutation.Result<DisableStorablesMutation>;
export type DisableStorablesMutationOptions = ApolloReactHooks.useMutation.Options<DisableStorablesMutation, DisableStorablesMutationVariables>;
export const FavoriteStorablesDocument = gql`
    mutation FavoriteStorables($favoriteProps: FavoriteStorables!) {
  favoriteStorables(favoriteProps: $favoriteProps) {
    storables {
      documents {
        ...StorableFields
      }
    }
  }
}
    ${StorableFieldsFragmentDoc}`;
export type FavoriteStorablesMutationFn = ApolloReactHooks.useMutation.MutationFunction<FavoriteStorablesMutation, FavoriteStorablesMutationVariables>;

/**
 * __useFavoriteStorablesMutation__
 *
 * To run a mutation, you first call `useFavoriteStorablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavoriteStorablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favoriteStorablesMutation, { data, loading, error }] = useFavoriteStorablesMutation({
 *   variables: {
 *      favoriteProps: // value for 'favoriteProps'
 *   },
 * });
 */
export function useFavoriteStorablesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<FavoriteStorablesMutation, FavoriteStorablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FavoriteStorablesMutation, FavoriteStorablesMutationVariables>(FavoriteStorablesDocument, options);
      }
export type FavoriteStorablesMutationHookResult = ReturnType<typeof useFavoriteStorablesMutation>;
export type FavoriteStorablesMutationResult = ApolloReactHooks.useMutation.Result<FavoriteStorablesMutation>;
export type FavoriteStorablesMutationOptions = ApolloReactHooks.useMutation.Options<FavoriteStorablesMutation, FavoriteStorablesMutationVariables>;
export const MoveStorablesDocument = gql`
    mutation MoveStorables($moveProps: MoveStorables!) {
  moveStorables(moveProps: $moveProps) {
    storables {
      documents {
        ...MoveStorableFields
      }
    }
  }
}
    ${MoveStorableFieldsFragmentDoc}`;
export type MoveStorablesMutationFn = ApolloReactHooks.useMutation.MutationFunction<MoveStorablesMutation, MoveStorablesMutationVariables>;

/**
 * __useMoveStorablesMutation__
 *
 * To run a mutation, you first call `useMoveStorablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveStorablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveStorablesMutation, { data, loading, error }] = useMoveStorablesMutation({
 *   variables: {
 *      moveProps: // value for 'moveProps'
 *   },
 * });
 */
export function useMoveStorablesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MoveStorablesMutation, MoveStorablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveStorablesMutation, MoveStorablesMutationVariables>(MoveStorablesDocument, options);
      }
export type MoveStorablesMutationHookResult = ReturnType<typeof useMoveStorablesMutation>;
export type MoveStorablesMutationResult = ApolloReactHooks.useMutation.Result<MoveStorablesMutation>;
export type MoveStorablesMutationOptions = ApolloReactHooks.useMutation.Options<MoveStorablesMutation, MoveStorablesMutationVariables>;
export const MoveStorablesSimpleDocument = gql`
    mutation MoveStorablesSimple($moveProps: MoveStorables!) {
  moveStorables(moveProps: $moveProps) {
    storables {
      documents {
        __typename
        id
      }
    }
  }
}
    `;
export type MoveStorablesSimpleMutationFn = ApolloReactHooks.useMutation.MutationFunction<MoveStorablesSimpleMutation, MoveStorablesSimpleMutationVariables>;

/**
 * __useMoveStorablesSimpleMutation__
 *
 * To run a mutation, you first call `useMoveStorablesSimpleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveStorablesSimpleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveStorablesSimpleMutation, { data, loading, error }] = useMoveStorablesSimpleMutation({
 *   variables: {
 *      moveProps: // value for 'moveProps'
 *   },
 * });
 */
export function useMoveStorablesSimpleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MoveStorablesSimpleMutation, MoveStorablesSimpleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveStorablesSimpleMutation, MoveStorablesSimpleMutationVariables>(MoveStorablesSimpleDocument, options);
      }
export type MoveStorablesSimpleMutationHookResult = ReturnType<typeof useMoveStorablesSimpleMutation>;
export type MoveStorablesSimpleMutationResult = ApolloReactHooks.useMutation.Result<MoveStorablesSimpleMutation>;
export type MoveStorablesSimpleMutationOptions = ApolloReactHooks.useMutation.Options<MoveStorablesSimpleMutation, MoveStorablesSimpleMutationVariables>;
export const RestoreStorablesDocument = gql`
    mutation RestoreStorables($restoreProps: RestoreStorables!) {
  restoreStorables(restoreProps: $restoreProps) {
    storables {
      documents {
        ...StorableFields
      }
    }
  }
}
    ${StorableFieldsFragmentDoc}`;
export type RestoreStorablesMutationFn = ApolloReactHooks.useMutation.MutationFunction<RestoreStorablesMutation, RestoreStorablesMutationVariables>;

/**
 * __useRestoreStorablesMutation__
 *
 * To run a mutation, you first call `useRestoreStorablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreStorablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreStorablesMutation, { data, loading, error }] = useRestoreStorablesMutation({
 *   variables: {
 *      restoreProps: // value for 'restoreProps'
 *   },
 * });
 */
export function useRestoreStorablesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RestoreStorablesMutation, RestoreStorablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreStorablesMutation, RestoreStorablesMutationVariables>(RestoreStorablesDocument, options);
      }
export type RestoreStorablesMutationHookResult = ReturnType<typeof useRestoreStorablesMutation>;
export type RestoreStorablesMutationResult = ApolloReactHooks.useMutation.Result<RestoreStorablesMutation>;
export type RestoreStorablesMutationOptions = ApolloReactHooks.useMutation.Options<RestoreStorablesMutation, RestoreStorablesMutationVariables>;
export const UpdateStorableDocument = gql`
    mutation UpdateStorable($updateProps: UpdateStorable!) {
  updateStorable(updateProps: $updateProps) {
    storables {
      documents {
        ...StorableFields
      }
    }
  }
}
    ${StorableFieldsFragmentDoc}`;
export type UpdateStorableMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateStorableMutation, UpdateStorableMutationVariables>;

/**
 * __useUpdateStorableMutation__
 *
 * To run a mutation, you first call `useUpdateStorableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStorableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStorableMutation, { data, loading, error }] = useUpdateStorableMutation({
 *   variables: {
 *      updateProps: // value for 'updateProps'
 *   },
 * });
 */
export function useUpdateStorableMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateStorableMutation, UpdateStorableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStorableMutation, UpdateStorableMutationVariables>(UpdateStorableDocument, options);
      }
export type UpdateStorableMutationHookResult = ReturnType<typeof useUpdateStorableMutation>;
export type UpdateStorableMutationResult = ApolloReactHooks.useMutation.Result<UpdateStorableMutation>;
export type UpdateStorableMutationOptions = ApolloReactHooks.useMutation.Options<UpdateStorableMutation, UpdateStorableMutationVariables>;
export const RequestAccessToStorableDocument = gql`
    mutation RequestAccessToStorable($input: RequestAccessToStorableInput!) {
  requestAccessToStorable(input: $input) {
    documentId
    status
  }
}
    `;
export type RequestAccessToStorableMutationFn = ApolloReactHooks.useMutation.MutationFunction<RequestAccessToStorableMutation, RequestAccessToStorableMutationVariables>;

/**
 * __useRequestAccessToStorableMutation__
 *
 * To run a mutation, you first call `useRequestAccessToStorableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessToStorableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccessToStorableMutation, { data, loading, error }] = useRequestAccessToStorableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestAccessToStorableMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RequestAccessToStorableMutation, RequestAccessToStorableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestAccessToStorableMutation, RequestAccessToStorableMutationVariables>(RequestAccessToStorableDocument, options);
      }
export type RequestAccessToStorableMutationHookResult = ReturnType<typeof useRequestAccessToStorableMutation>;
export type RequestAccessToStorableMutationResult = ApolloReactHooks.useMutation.Result<RequestAccessToStorableMutation>;
export type RequestAccessToStorableMutationOptions = ApolloReactHooks.useMutation.Options<RequestAccessToStorableMutation, RequestAccessToStorableMutationVariables>;
export const CreateTaskFieldDocument = gql`
    mutation CreateTaskField($input: CreateTaskFieldInput!) {
  createTaskField(input: $input) {
    taskField {
      ...TaskFieldSimple
    }
  }
}
    ${TaskFieldSimpleFragmentDoc}`;
export type CreateTaskFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateTaskFieldMutation, CreateTaskFieldMutationVariables>;

/**
 * __useCreateTaskFieldMutation__
 *
 * To run a mutation, you first call `useCreateTaskFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskFieldMutation, { data, loading, error }] = useCreateTaskFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateTaskFieldMutation, CreateTaskFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTaskFieldMutation, CreateTaskFieldMutationVariables>(CreateTaskFieldDocument, options);
      }
export type CreateTaskFieldMutationHookResult = ReturnType<typeof useCreateTaskFieldMutation>;
export type CreateTaskFieldMutationResult = ApolloReactHooks.useMutation.Result<CreateTaskFieldMutation>;
export type CreateTaskFieldMutationOptions = ApolloReactHooks.useMutation.Options<CreateTaskFieldMutation, CreateTaskFieldMutationVariables>;
export const UpdateTaskFieldDocument = gql`
    mutation UpdateTaskField($input: UpdateTaskFieldInput!) {
  updateTaskField(input: $input) {
    taskField {
      ...TaskFieldSimple
    }
  }
}
    ${TaskFieldSimpleFragmentDoc}`;
export type UpdateTaskFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateTaskFieldMutation, UpdateTaskFieldMutationVariables>;

/**
 * __useUpdateTaskFieldMutation__
 *
 * To run a mutation, you first call `useUpdateTaskFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskFieldMutation, { data, loading, error }] = useUpdateTaskFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateTaskFieldMutation, UpdateTaskFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskFieldMutation, UpdateTaskFieldMutationVariables>(UpdateTaskFieldDocument, options);
      }
export type UpdateTaskFieldMutationHookResult = ReturnType<typeof useUpdateTaskFieldMutation>;
export type UpdateTaskFieldMutationResult = ApolloReactHooks.useMutation.Result<UpdateTaskFieldMutation>;
export type UpdateTaskFieldMutationOptions = ApolloReactHooks.useMutation.Options<UpdateTaskFieldMutation, UpdateTaskFieldMutationVariables>;
export const DeleteTaskFieldDocument = gql`
    mutation DeleteTaskField($taskFieldId: UUID!) {
  deleteTaskField(taskFieldId: $taskFieldId)
}
    `;
export type DeleteTaskFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteTaskFieldMutation, DeleteTaskFieldMutationVariables>;

/**
 * __useDeleteTaskFieldMutation__
 *
 * To run a mutation, you first call `useDeleteTaskFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskFieldMutation, { data, loading, error }] = useDeleteTaskFieldMutation({
 *   variables: {
 *      taskFieldId: // value for 'taskFieldId'
 *   },
 * });
 */
export function useDeleteTaskFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteTaskFieldMutation, DeleteTaskFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTaskFieldMutation, DeleteTaskFieldMutationVariables>(DeleteTaskFieldDocument, options);
      }
export type DeleteTaskFieldMutationHookResult = ReturnType<typeof useDeleteTaskFieldMutation>;
export type DeleteTaskFieldMutationResult = ApolloReactHooks.useMutation.Result<DeleteTaskFieldMutation>;
export type DeleteTaskFieldMutationOptions = ApolloReactHooks.useMutation.Options<DeleteTaskFieldMutation, DeleteTaskFieldMutationVariables>;
export const SubmitTaskFieldResponseDocument = gql`
    mutation SubmitTaskFieldResponse($input: SubmitTaskFieldResponseInput!) {
  submitTaskFieldResponse(input: $input) {
    taskField {
      ...TaskFieldSimple
    }
  }
}
    ${TaskFieldSimpleFragmentDoc}`;
export type SubmitTaskFieldResponseMutationFn = ApolloReactHooks.useMutation.MutationFunction<SubmitTaskFieldResponseMutation, SubmitTaskFieldResponseMutationVariables>;

/**
 * __useSubmitTaskFieldResponseMutation__
 *
 * To run a mutation, you first call `useSubmitTaskFieldResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTaskFieldResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTaskFieldResponseMutation, { data, loading, error }] = useSubmitTaskFieldResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTaskFieldResponseMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SubmitTaskFieldResponseMutation, SubmitTaskFieldResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitTaskFieldResponseMutation, SubmitTaskFieldResponseMutationVariables>(SubmitTaskFieldResponseDocument, options);
      }
export type SubmitTaskFieldResponseMutationHookResult = ReturnType<typeof useSubmitTaskFieldResponseMutation>;
export type SubmitTaskFieldResponseMutationResult = ApolloReactHooks.useMutation.Result<SubmitTaskFieldResponseMutation>;
export type SubmitTaskFieldResponseMutationOptions = ApolloReactHooks.useMutation.Options<SubmitTaskFieldResponseMutation, SubmitTaskFieldResponseMutationVariables>;
export const ReorderTaskFieldsDocument = gql`
    mutation ReorderTaskFields($input: ReorderTaskFieldsInput!) {
  reorderTaskFields(input: $input) {
    ...TaskFieldSimple
  }
}
    ${TaskFieldSimpleFragmentDoc}`;
export type ReorderTaskFieldsMutationFn = ApolloReactHooks.useMutation.MutationFunction<ReorderTaskFieldsMutation, ReorderTaskFieldsMutationVariables>;

/**
 * __useReorderTaskFieldsMutation__
 *
 * To run a mutation, you first call `useReorderTaskFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTaskFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTaskFieldsMutation, { data, loading, error }] = useReorderTaskFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderTaskFieldsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ReorderTaskFieldsMutation, ReorderTaskFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderTaskFieldsMutation, ReorderTaskFieldsMutationVariables>(ReorderTaskFieldsDocument, options);
      }
export type ReorderTaskFieldsMutationHookResult = ReturnType<typeof useReorderTaskFieldsMutation>;
export type ReorderTaskFieldsMutationResult = ApolloReactHooks.useMutation.Result<ReorderTaskFieldsMutation>;
export type ReorderTaskFieldsMutationOptions = ApolloReactHooks.useMutation.Options<ReorderTaskFieldsMutation, ReorderTaskFieldsMutationVariables>;
export const GetTaskDocument = gql`
    query GetTask($taskId: UUID!) {
  task(taskId: $taskId) {
    ...TaskSimple
  }
}
    ${TaskSimpleFragmentDoc}`;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskQuery, GetTaskQueryVariables> & ({ variables: GetTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = ApolloReactHooks.useQuery.Result<GetTaskQuery, GetTaskQueryVariables>;
export const GetTaskStatusDocument = gql`
    query GetTaskStatus($taskId: UUID!) {
  task(taskId: $taskId) {
    __typename
    id
    status
    requesterDisallowedReason {
      ...DisallowedTaskReasonsSimple
    }
  }
}
    ${DisallowedTaskReasonsSimpleFragmentDoc}`;

/**
 * __useGetTaskStatusQuery__
 *
 * To run a query within a React component, call `useGetTaskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskStatusQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskStatusQuery, GetTaskStatusQueryVariables> & ({ variables: GetTaskStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskStatusQuery, GetTaskStatusQueryVariables>(GetTaskStatusDocument, options);
      }
export function useGetTaskStatusLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskStatusQuery, GetTaskStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskStatusQuery, GetTaskStatusQueryVariables>(GetTaskStatusDocument, options);
        }
export function useGetTaskStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskStatusQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskStatusQuery, GetTaskStatusQueryVariables>(GetTaskStatusDocument, options);
        }
export type GetTaskStatusQueryHookResult = ReturnType<typeof useGetTaskStatusQuery>;
export type GetTaskStatusLazyQueryHookResult = ReturnType<typeof useGetTaskStatusLazyQuery>;
export type GetTaskStatusSuspenseQueryHookResult = ReturnType<typeof useGetTaskStatusSuspenseQuery>;
export type GetTaskStatusQueryResult = ApolloReactHooks.useQuery.Result<GetTaskStatusQuery, GetTaskStatusQueryVariables>;
export const GetTaskWithCommentsDocument = gql`
    query GetTaskWithComments($taskId: UUID!) {
  task(taskId: $taskId) {
    __typename
    id
    alineAiRunMessageId
    completedAt
    description
    externalDescription
    isDelegatedToAi
    status
    title
    startedAt
    variant
    phase {
      __typename
      id
      completedAt
      name
      startedAt
    }
    author {
      ...UserBase
    }
    comments {
      __typename
      id
      createdAt
      text
      updatedAt
      author {
        ...UserBase
      }
    }
    completedBy {
      ...UserBase
    }
    requesterDisallowedReason {
      ...DisallowedTaskReasonsSimple
    }
    ...TaskReviewFields
    ...TaskViewerActionFields
    workflow {
      __typename
      id
      boardId
      name
      owner {
        __typename
        id
      }
      requesterInOwnerOrg
      startedAt
      variant
      column {
        __typename
        category
        id
        name
      }
      phases {
        __typename
        id
      }
      files {
        __typename
        id
        orderId
        document {
          __typename
          id
          name
          requesterRole
          variant
          latestVersion {
            ... on FileVersionInterface {
              __typename
              id
            }
            ... on StaticFileVersion {
              fileLocation {
                __typename
                id
                mimetype
              }
            }
          }
        }
      }
    }
  }
}
    ${UserBaseFragmentDoc}
${DisallowedTaskReasonsSimpleFragmentDoc}
${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;

/**
 * __useGetTaskWithCommentsQuery__
 *
 * To run a query within a React component, call `useGetTaskWithCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskWithCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskWithCommentsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskWithCommentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskWithCommentsQuery, GetTaskWithCommentsQueryVariables> & ({ variables: GetTaskWithCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskWithCommentsQuery, GetTaskWithCommentsQueryVariables>(GetTaskWithCommentsDocument, options);
      }
export function useGetTaskWithCommentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskWithCommentsQuery, GetTaskWithCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskWithCommentsQuery, GetTaskWithCommentsQueryVariables>(GetTaskWithCommentsDocument, options);
        }
export function useGetTaskWithCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskWithCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskWithCommentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskWithCommentsQuery, GetTaskWithCommentsQueryVariables>(GetTaskWithCommentsDocument, options);
        }
export type GetTaskWithCommentsQueryHookResult = ReturnType<typeof useGetTaskWithCommentsQuery>;
export type GetTaskWithCommentsLazyQueryHookResult = ReturnType<typeof useGetTaskWithCommentsLazyQuery>;
export type GetTaskWithCommentsSuspenseQueryHookResult = ReturnType<typeof useGetTaskWithCommentsSuspenseQuery>;
export type GetTaskWithCommentsQueryResult = ApolloReactHooks.useQuery.Result<GetTaskWithCommentsQuery, GetTaskWithCommentsQueryVariables>;
export const GetTaskDocumentDownloadDocument = gql`
    query GetTaskDocumentDownload($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    isSigned
    latestVersion {
      ...FileVersionSimple
      ... on DocumentVersion {
        documentJSON
      }
    }
  }
}
    ${FileVersionSimpleFragmentDoc}`;

/**
 * __useGetTaskDocumentDownloadQuery__
 *
 * To run a query within a React component, call `useGetTaskDocumentDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskDocumentDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskDocumentDownloadQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetTaskDocumentDownloadQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskDocumentDownloadQuery, GetTaskDocumentDownloadQueryVariables> & ({ variables: GetTaskDocumentDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskDocumentDownloadQuery, GetTaskDocumentDownloadQueryVariables>(GetTaskDocumentDownloadDocument, options);
      }
export function useGetTaskDocumentDownloadLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskDocumentDownloadQuery, GetTaskDocumentDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskDocumentDownloadQuery, GetTaskDocumentDownloadQueryVariables>(GetTaskDocumentDownloadDocument, options);
        }
export function useGetTaskDocumentDownloadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskDocumentDownloadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskDocumentDownloadQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskDocumentDownloadQuery, GetTaskDocumentDownloadQueryVariables>(GetTaskDocumentDownloadDocument, options);
        }
export type GetTaskDocumentDownloadQueryHookResult = ReturnType<typeof useGetTaskDocumentDownloadQuery>;
export type GetTaskDocumentDownloadLazyQueryHookResult = ReturnType<typeof useGetTaskDocumentDownloadLazyQuery>;
export type GetTaskDocumentDownloadSuspenseQueryHookResult = ReturnType<typeof useGetTaskDocumentDownloadSuspenseQuery>;
export type GetTaskDocumentDownloadQueryResult = ApolloReactHooks.useQuery.Result<GetTaskDocumentDownloadQuery, GetTaskDocumentDownloadQueryVariables>;
export const GetTaskLandingDocument = gql`
    query GetTaskLanding($taskId: UUID!) {
  task(taskId: $taskId) {
    __typename
    id
    requesterIsInternal
    title
    workflow {
      __typename
      id
    }
  }
}
    `;

/**
 * __useGetTaskLandingQuery__
 *
 * To run a query within a React component, call `useGetTaskLandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskLandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskLandingQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskLandingQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskLandingQuery, GetTaskLandingQueryVariables> & ({ variables: GetTaskLandingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskLandingQuery, GetTaskLandingQueryVariables>(GetTaskLandingDocument, options);
      }
export function useGetTaskLandingLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskLandingQuery, GetTaskLandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskLandingQuery, GetTaskLandingQueryVariables>(GetTaskLandingDocument, options);
        }
export function useGetTaskLandingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskLandingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskLandingQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskLandingQuery, GetTaskLandingQueryVariables>(GetTaskLandingDocument, options);
        }
export type GetTaskLandingQueryHookResult = ReturnType<typeof useGetTaskLandingQuery>;
export type GetTaskLandingLazyQueryHookResult = ReturnType<typeof useGetTaskLandingLazyQuery>;
export type GetTaskLandingSuspenseQueryHookResult = ReturnType<typeof useGetTaskLandingSuspenseQuery>;
export type GetTaskLandingQueryResult = ApolloReactHooks.useQuery.Result<GetTaskLandingQuery, GetTaskLandingQueryVariables>;
export const GetTasksDocument = gql`
    query GetTasks {
  tasks {
    ...TaskSimple
  }
}
    ${TaskSimpleFragmentDoc}`;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetTasksQuery, GetTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export function useGetTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTasksQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksSuspenseQueryHookResult = ReturnType<typeof useGetTasksSuspenseQuery>;
export type GetTasksQueryResult = ApolloReactHooks.useQuery.Result<GetTasksQuery, GetTasksQueryVariables>;
export const GetUserTasksDocument = gql`
    query GetUserTasks {
  userIncompleteTasks {
    __typename
    id
    completedAt
    description
    status
    title
    parentTask {
      __typename
      id
      title
    }
    assignments {
      ...TaskAssignmentFields
    }
    requesterDisallowedReason {
      ...DisallowedTaskReasonsSimple
    }
    workflow {
      __typename
      id
      name
      variant
    }
  }
}
    ${TaskAssignmentFieldsFragmentDoc}
${DisallowedTaskReasonsSimpleFragmentDoc}`;

/**
 * __useGetUserTasksQuery__
 *
 * To run a query within a React component, call `useGetUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTasksQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetUserTasksQuery, GetUserTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserTasksQuery, GetUserTasksQueryVariables>(GetUserTasksDocument, options);
      }
export function useGetUserTasksLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUserTasksQuery, GetUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserTasksQuery, GetUserTasksQueryVariables>(GetUserTasksDocument, options);
        }
export function useGetUserTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUserTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUserTasksQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUserTasksQuery, GetUserTasksQueryVariables>(GetUserTasksDocument, options);
        }
export type GetUserTasksQueryHookResult = ReturnType<typeof useGetUserTasksQuery>;
export type GetUserTasksLazyQueryHookResult = ReturnType<typeof useGetUserTasksLazyQuery>;
export type GetUserTasksSuspenseQueryHookResult = ReturnType<typeof useGetUserTasksSuspenseQuery>;
export type GetUserTasksQueryResult = ApolloReactHooks.useQuery.Result<GetUserTasksQuery, GetUserTasksQueryVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    task {
      ...TaskSimple
    }
  }
}
    ${TaskSimpleFragmentDoc}`;
export type CreateTaskMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = ApolloReactHooks.useMutation.Result<CreateTaskMutation>;
export type CreateTaskMutationOptions = ApolloReactHooks.useMutation.Options<CreateTaskMutation, CreateTaskMutationVariables>;
export const SetTaskAssigneesDocument = gql`
    mutation SetTaskAssignees($input: SetTaskAssigneesInput!) {
  setTaskAssignees(input: $input) {
    task {
      __typename
      id
      alineAiRunMessageId
      counterpartyName
      hasExternalAssignees
      isDelegatedToAi
      startedAt
      status
      assignments {
        ...TaskAssignmentFields
      }
      ...TaskViewerActionFields
    }
  }
}
    ${TaskAssignmentFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type SetTaskAssigneesMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetTaskAssigneesMutation, SetTaskAssigneesMutationVariables>;

/**
 * __useSetTaskAssigneesMutation__
 *
 * To run a mutation, you first call `useSetTaskAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskAssigneesMutation, { data, loading, error }] = useSetTaskAssigneesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTaskAssigneesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetTaskAssigneesMutation, SetTaskAssigneesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetTaskAssigneesMutation, SetTaskAssigneesMutationVariables>(SetTaskAssigneesDocument, options);
      }
export type SetTaskAssigneesMutationHookResult = ReturnType<typeof useSetTaskAssigneesMutation>;
export type SetTaskAssigneesMutationResult = ApolloReactHooks.useMutation.Result<SetTaskAssigneesMutation>;
export type SetTaskAssigneesMutationOptions = ApolloReactHooks.useMutation.Options<SetTaskAssigneesMutation, SetTaskAssigneesMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    task {
      ...TaskSimple
    }
  }
}
    ${TaskSimpleFragmentDoc}`;
export type UpdateTaskMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = ApolloReactHooks.useMutation.Result<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = ApolloReactHooks.useMutation.Options<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const StartTaskAiExecutionDocument = gql`
    mutation StartTaskAiExecution($taskId: UUID!) {
  startTaskAiExecution(taskId: $taskId) {
    task {
      __typename
      id
      alineAiRunMessageId
      isDelegatedToAi
      startedAt
      status
    }
    activityItem {
      ...ActivityItemFields
    }
  }
}
    ${ActivityItemFieldsFragmentDoc}`;
export type StartTaskAiExecutionMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartTaskAiExecutionMutation, StartTaskAiExecutionMutationVariables>;

/**
 * __useStartTaskAiExecutionMutation__
 *
 * To run a mutation, you first call `useStartTaskAiExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTaskAiExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTaskAiExecutionMutation, { data, loading, error }] = useStartTaskAiExecutionMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useStartTaskAiExecutionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartTaskAiExecutionMutation, StartTaskAiExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartTaskAiExecutionMutation, StartTaskAiExecutionMutationVariables>(StartTaskAiExecutionDocument, options);
      }
export type StartTaskAiExecutionMutationHookResult = ReturnType<typeof useStartTaskAiExecutionMutation>;
export type StartTaskAiExecutionMutationResult = ApolloReactHooks.useMutation.Result<StartTaskAiExecutionMutation>;
export type StartTaskAiExecutionMutationOptions = ApolloReactHooks.useMutation.Options<StartTaskAiExecutionMutation, StartTaskAiExecutionMutationVariables>;
export const SetTaskDelegatedToAiDocument = gql`
    mutation SetTaskDelegatedToAi($taskId: UUID!, $delegated: Boolean!) {
  setTaskDelegatedToAi(taskId: $taskId, delegated: $delegated) {
    task {
      __typename
      id
      alineAiRunMessageId
      isDelegatedToAi
      startedAt
      status
      assignments {
        ...TaskAssignmentFields
      }
    }
    activityItem {
      ...ActivityItemFields
    }
  }
}
    ${TaskAssignmentFieldsFragmentDoc}
${ActivityItemFieldsFragmentDoc}`;
export type SetTaskDelegatedToAiMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetTaskDelegatedToAiMutation, SetTaskDelegatedToAiMutationVariables>;

/**
 * __useSetTaskDelegatedToAiMutation__
 *
 * To run a mutation, you first call `useSetTaskDelegatedToAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskDelegatedToAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskDelegatedToAiMutation, { data, loading, error }] = useSetTaskDelegatedToAiMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      delegated: // value for 'delegated'
 *   },
 * });
 */
export function useSetTaskDelegatedToAiMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetTaskDelegatedToAiMutation, SetTaskDelegatedToAiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetTaskDelegatedToAiMutation, SetTaskDelegatedToAiMutationVariables>(SetTaskDelegatedToAiDocument, options);
      }
export type SetTaskDelegatedToAiMutationHookResult = ReturnType<typeof useSetTaskDelegatedToAiMutation>;
export type SetTaskDelegatedToAiMutationResult = ApolloReactHooks.useMutation.Result<SetTaskDelegatedToAiMutation>;
export type SetTaskDelegatedToAiMutationOptions = ApolloReactHooks.useMutation.Options<SetTaskDelegatedToAiMutation, SetTaskDelegatedToAiMutationVariables>;
export const UpdateTaskDescriptionMarkdownDocument = gql`
    mutation UpdateTaskDescriptionMarkdown($taskId: UUID!, $markdown: String!) {
  updateTaskDescriptionMarkdown(taskId: $taskId, markdown: $markdown) {
    task {
      __typename
      id
      description
    }
  }
}
    `;
export type UpdateTaskDescriptionMarkdownMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateTaskDescriptionMarkdownMutation, UpdateTaskDescriptionMarkdownMutationVariables>;

/**
 * __useUpdateTaskDescriptionMarkdownMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDescriptionMarkdownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDescriptionMarkdownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDescriptionMarkdownMutation, { data, loading, error }] = useUpdateTaskDescriptionMarkdownMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      markdown: // value for 'markdown'
 *   },
 * });
 */
export function useUpdateTaskDescriptionMarkdownMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateTaskDescriptionMarkdownMutation, UpdateTaskDescriptionMarkdownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskDescriptionMarkdownMutation, UpdateTaskDescriptionMarkdownMutationVariables>(UpdateTaskDescriptionMarkdownDocument, options);
      }
export type UpdateTaskDescriptionMarkdownMutationHookResult = ReturnType<typeof useUpdateTaskDescriptionMarkdownMutation>;
export type UpdateTaskDescriptionMarkdownMutationResult = ApolloReactHooks.useMutation.Result<UpdateTaskDescriptionMarkdownMutation>;
export type UpdateTaskDescriptionMarkdownMutationOptions = ApolloReactHooks.useMutation.Options<UpdateTaskDescriptionMarkdownMutation, UpdateTaskDescriptionMarkdownMutationVariables>;
export const UpdateTaskExternalDescriptionMarkdownDocument = gql`
    mutation UpdateTaskExternalDescriptionMarkdown($taskId: UUID!, $markdown: String!) {
  updateTaskExternalDescriptionMarkdown(taskId: $taskId, markdown: $markdown) {
    task {
      __typename
      id
      externalDescription
    }
  }
}
    `;
export type UpdateTaskExternalDescriptionMarkdownMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateTaskExternalDescriptionMarkdownMutation, UpdateTaskExternalDescriptionMarkdownMutationVariables>;

/**
 * __useUpdateTaskExternalDescriptionMarkdownMutation__
 *
 * To run a mutation, you first call `useUpdateTaskExternalDescriptionMarkdownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskExternalDescriptionMarkdownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskExternalDescriptionMarkdownMutation, { data, loading, error }] = useUpdateTaskExternalDescriptionMarkdownMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      markdown: // value for 'markdown'
 *   },
 * });
 */
export function useUpdateTaskExternalDescriptionMarkdownMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateTaskExternalDescriptionMarkdownMutation, UpdateTaskExternalDescriptionMarkdownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTaskExternalDescriptionMarkdownMutation, UpdateTaskExternalDescriptionMarkdownMutationVariables>(UpdateTaskExternalDescriptionMarkdownDocument, options);
      }
export type UpdateTaskExternalDescriptionMarkdownMutationHookResult = ReturnType<typeof useUpdateTaskExternalDescriptionMarkdownMutation>;
export type UpdateTaskExternalDescriptionMarkdownMutationResult = ApolloReactHooks.useMutation.Result<UpdateTaskExternalDescriptionMarkdownMutation>;
export type UpdateTaskExternalDescriptionMarkdownMutationOptions = ApolloReactHooks.useMutation.Options<UpdateTaskExternalDescriptionMarkdownMutation, UpdateTaskExternalDescriptionMarkdownMutationVariables>;
export const ChangeTaskStatusDocument = gql`
    mutation ChangeTaskStatus($input: ChangeTaskStatusProps!) {
  changeTaskStatus(input: $input) {
    task {
      __typename
      id
      completedAt
      status
      startedAt
      completedBy {
        ...UserBase
      }
      requesterDisallowedReason {
        ...DisallowedTaskReasonsSimple
      }
      ...TaskReviewFields
      ...TaskViewerActionFields
      phase {
        __typename
        id
        completedAt
        startedAt
      }
      workflow {
        __typename
        id
        completedAt
        status
        state
      }
    }
  }
}
    ${UserBaseFragmentDoc}
${DisallowedTaskReasonsSimpleFragmentDoc}
${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type ChangeTaskStatusMutationFn = ApolloReactHooks.useMutation.MutationFunction<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>;

/**
 * __useChangeTaskStatusMutation__
 *
 * To run a mutation, you first call `useChangeTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTaskStatusMutation, { data, loading, error }] = useChangeTaskStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeTaskStatusMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>(ChangeTaskStatusDocument, options);
      }
export type ChangeTaskStatusMutationHookResult = ReturnType<typeof useChangeTaskStatusMutation>;
export type ChangeTaskStatusMutationResult = ApolloReactHooks.useMutation.Result<ChangeTaskStatusMutation>;
export type ChangeTaskStatusMutationOptions = ApolloReactHooks.useMutation.Options<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($taskId: UUID!) {
  deleteTask(taskId: $taskId)
}
    `;
export type DeleteTaskMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = ApolloReactHooks.useMutation.Result<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = ApolloReactHooks.useMutation.Options<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const GetTaskUnsubmittedReviewDocument = gql`
    query GetTaskUnsubmittedReview($taskId: UUID!) {
  task(taskId: $taskId) {
    ...TaskUnsubmittedReviewFields
  }
}
    ${TaskUnsubmittedReviewFieldsFragmentDoc}`;

/**
 * __useGetTaskUnsubmittedReviewQuery__
 *
 * To run a query within a React component, call `useGetTaskUnsubmittedReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskUnsubmittedReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskUnsubmittedReviewQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskUnsubmittedReviewQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTaskUnsubmittedReviewQuery, GetTaskUnsubmittedReviewQueryVariables> & ({ variables: GetTaskUnsubmittedReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskUnsubmittedReviewQuery, GetTaskUnsubmittedReviewQueryVariables>(GetTaskUnsubmittedReviewDocument, options);
      }
export function useGetTaskUnsubmittedReviewLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTaskUnsubmittedReviewQuery, GetTaskUnsubmittedReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskUnsubmittedReviewQuery, GetTaskUnsubmittedReviewQueryVariables>(GetTaskUnsubmittedReviewDocument, options);
        }
export function useGetTaskUnsubmittedReviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTaskUnsubmittedReviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTaskUnsubmittedReviewQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTaskUnsubmittedReviewQuery, GetTaskUnsubmittedReviewQueryVariables>(GetTaskUnsubmittedReviewDocument, options);
        }
export type GetTaskUnsubmittedReviewQueryHookResult = ReturnType<typeof useGetTaskUnsubmittedReviewQuery>;
export type GetTaskUnsubmittedReviewLazyQueryHookResult = ReturnType<typeof useGetTaskUnsubmittedReviewLazyQuery>;
export type GetTaskUnsubmittedReviewSuspenseQueryHookResult = ReturnType<typeof useGetTaskUnsubmittedReviewSuspenseQuery>;
export type GetTaskUnsubmittedReviewQueryResult = ApolloReactHooks.useQuery.Result<GetTaskUnsubmittedReviewQuery, GetTaskUnsubmittedReviewQueryVariables>;
export const SetTaskAssigneeRequiredDocument = gql`
    mutation SetTaskAssigneeRequired($input: SetTaskAssigneeRequiredInput!) {
  setTaskAssigneeRequired(input: $input) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
      completedAt
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type SetTaskAssigneeRequiredMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetTaskAssigneeRequiredMutation, SetTaskAssigneeRequiredMutationVariables>;

/**
 * __useSetTaskAssigneeRequiredMutation__
 *
 * To run a mutation, you first call `useSetTaskAssigneeRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskAssigneeRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskAssigneeRequiredMutation, { data, loading, error }] = useSetTaskAssigneeRequiredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTaskAssigneeRequiredMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetTaskAssigneeRequiredMutation, SetTaskAssigneeRequiredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetTaskAssigneeRequiredMutation, SetTaskAssigneeRequiredMutationVariables>(SetTaskAssigneeRequiredDocument, options);
      }
export type SetTaskAssigneeRequiredMutationHookResult = ReturnType<typeof useSetTaskAssigneeRequiredMutation>;
export type SetTaskAssigneeRequiredMutationResult = ApolloReactHooks.useMutation.Result<SetTaskAssigneeRequiredMutation>;
export type SetTaskAssigneeRequiredMutationOptions = ApolloReactHooks.useMutation.Options<SetTaskAssigneeRequiredMutation, SetTaskAssigneeRequiredMutationVariables>;
export const SetTaskAssigneeRoleDocument = gql`
    mutation SetTaskAssigneeRole($input: SetTaskAssigneeRoleInput!) {
  setTaskAssigneeRole(input: $input) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
      completedAt
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type SetTaskAssigneeRoleMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetTaskAssigneeRoleMutation, SetTaskAssigneeRoleMutationVariables>;

/**
 * __useSetTaskAssigneeRoleMutation__
 *
 * To run a mutation, you first call `useSetTaskAssigneeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskAssigneeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskAssigneeRoleMutation, { data, loading, error }] = useSetTaskAssigneeRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTaskAssigneeRoleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetTaskAssigneeRoleMutation, SetTaskAssigneeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetTaskAssigneeRoleMutation, SetTaskAssigneeRoleMutationVariables>(SetTaskAssigneeRoleDocument, options);
      }
export type SetTaskAssigneeRoleMutationHookResult = ReturnType<typeof useSetTaskAssigneeRoleMutation>;
export type SetTaskAssigneeRoleMutationResult = ApolloReactHooks.useMutation.Result<SetTaskAssigneeRoleMutation>;
export type SetTaskAssigneeRoleMutationOptions = ApolloReactHooks.useMutation.Options<SetTaskAssigneeRoleMutation, SetTaskAssigneeRoleMutationVariables>;
export const RequestTaskReviewDocument = gql`
    mutation RequestTaskReview($input: RequestTaskReviewInput!) {
  requestTaskReview(input: $input) {
    warning
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
      completedAt
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type RequestTaskReviewMutationFn = ApolloReactHooks.useMutation.MutationFunction<RequestTaskReviewMutation, RequestTaskReviewMutationVariables>;

/**
 * __useRequestTaskReviewMutation__
 *
 * To run a mutation, you first call `useRequestTaskReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTaskReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTaskReviewMutation, { data, loading, error }] = useRequestTaskReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestTaskReviewMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RequestTaskReviewMutation, RequestTaskReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestTaskReviewMutation, RequestTaskReviewMutationVariables>(RequestTaskReviewDocument, options);
      }
export type RequestTaskReviewMutationHookResult = ReturnType<typeof useRequestTaskReviewMutation>;
export type RequestTaskReviewMutationResult = ApolloReactHooks.useMutation.Result<RequestTaskReviewMutation>;
export type RequestTaskReviewMutationOptions = ApolloReactHooks.useMutation.Options<RequestTaskReviewMutation, RequestTaskReviewMutationVariables>;
export const UndoTaskReviewRequestDocument = gql`
    mutation UndoTaskReviewRequest($taskId: UUID!, $reviewerPermissionId: UUID) {
  undoTaskReviewRequest(
    taskId: $taskId
    reviewerPermissionId: $reviewerPermissionId
  ) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type UndoTaskReviewRequestMutationFn = ApolloReactHooks.useMutation.MutationFunction<UndoTaskReviewRequestMutation, UndoTaskReviewRequestMutationVariables>;

/**
 * __useUndoTaskReviewRequestMutation__
 *
 * To run a mutation, you first call `useUndoTaskReviewRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoTaskReviewRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoTaskReviewRequestMutation, { data, loading, error }] = useUndoTaskReviewRequestMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      reviewerPermissionId: // value for 'reviewerPermissionId'
 *   },
 * });
 */
export function useUndoTaskReviewRequestMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UndoTaskReviewRequestMutation, UndoTaskReviewRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UndoTaskReviewRequestMutation, UndoTaskReviewRequestMutationVariables>(UndoTaskReviewRequestDocument, options);
      }
export type UndoTaskReviewRequestMutationHookResult = ReturnType<typeof useUndoTaskReviewRequestMutation>;
export type UndoTaskReviewRequestMutationResult = ApolloReactHooks.useMutation.Result<UndoTaskReviewRequestMutation>;
export type UndoTaskReviewRequestMutationOptions = ApolloReactHooks.useMutation.Options<UndoTaskReviewRequestMutation, UndoTaskReviewRequestMutationVariables>;
export const ApproveTaskDocument = gql`
    mutation ApproveTask($input: ApproveTaskInput!) {
  approveTask(input: $input) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
      completedAt
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type ApproveTaskMutationFn = ApolloReactHooks.useMutation.MutationFunction<ApproveTaskMutation, ApproveTaskMutationVariables>;

/**
 * __useApproveTaskMutation__
 *
 * To run a mutation, you first call `useApproveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTaskMutation, { data, loading, error }] = useApproveTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveTaskMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ApproveTaskMutation, ApproveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApproveTaskMutation, ApproveTaskMutationVariables>(ApproveTaskDocument, options);
      }
export type ApproveTaskMutationHookResult = ReturnType<typeof useApproveTaskMutation>;
export type ApproveTaskMutationResult = ApolloReactHooks.useMutation.Result<ApproveTaskMutation>;
export type ApproveTaskMutationOptions = ApolloReactHooks.useMutation.Options<ApproveTaskMutation, ApproveTaskMutationVariables>;
export const StartTaskDocument = gql`
    mutation StartTask($input: StartTaskInput!) {
  startTask(input: $input) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
      completedAt
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type StartTaskMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartTaskMutation, StartTaskMutationVariables>;

/**
 * __useStartTaskMutation__
 *
 * To run a mutation, you first call `useStartTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTaskMutation, { data, loading, error }] = useStartTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartTaskMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartTaskMutation, StartTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartTaskMutation, StartTaskMutationVariables>(StartTaskDocument, options);
      }
export type StartTaskMutationHookResult = ReturnType<typeof useStartTaskMutation>;
export type StartTaskMutationResult = ApolloReactHooks.useMutation.Result<StartTaskMutation>;
export type StartTaskMutationOptions = ApolloReactHooks.useMutation.Options<StartTaskMutation, StartTaskMutationVariables>;
export const RequestTaskChangesDocument = gql`
    mutation RequestTaskChanges($input: RequestTaskChangesInput!) {
  requestTaskChanges(input: $input) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
      completedAt
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type RequestTaskChangesMutationFn = ApolloReactHooks.useMutation.MutationFunction<RequestTaskChangesMutation, RequestTaskChangesMutationVariables>;

/**
 * __useRequestTaskChangesMutation__
 *
 * To run a mutation, you first call `useRequestTaskChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTaskChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTaskChangesMutation, { data, loading, error }] = useRequestTaskChangesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestTaskChangesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RequestTaskChangesMutation, RequestTaskChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestTaskChangesMutation, RequestTaskChangesMutationVariables>(RequestTaskChangesDocument, options);
      }
export type RequestTaskChangesMutationHookResult = ReturnType<typeof useRequestTaskChangesMutation>;
export type RequestTaskChangesMutationResult = ApolloReactHooks.useMutation.Result<RequestTaskChangesMutation>;
export type RequestTaskChangesMutationOptions = ApolloReactHooks.useMutation.Options<RequestTaskChangesMutation, RequestTaskChangesMutationVariables>;
export const CompleteTaskForAssigneeDocument = gql`
    mutation CompleteTaskForAssignee($input: CompleteTaskForAssigneeInput!) {
  completeTaskForAssignee(input: $input) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
      completedAt
      status
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type CompleteTaskForAssigneeMutationFn = ApolloReactHooks.useMutation.MutationFunction<CompleteTaskForAssigneeMutation, CompleteTaskForAssigneeMutationVariables>;

/**
 * __useCompleteTaskForAssigneeMutation__
 *
 * To run a mutation, you first call `useCompleteTaskForAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskForAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTaskForAssigneeMutation, { data, loading, error }] = useCompleteTaskForAssigneeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteTaskForAssigneeMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CompleteTaskForAssigneeMutation, CompleteTaskForAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteTaskForAssigneeMutation, CompleteTaskForAssigneeMutationVariables>(CompleteTaskForAssigneeDocument, options);
      }
export type CompleteTaskForAssigneeMutationHookResult = ReturnType<typeof useCompleteTaskForAssigneeMutation>;
export type CompleteTaskForAssigneeMutationResult = ApolloReactHooks.useMutation.Result<CompleteTaskForAssigneeMutation>;
export type CompleteTaskForAssigneeMutationOptions = ApolloReactHooks.useMutation.Options<CompleteTaskForAssigneeMutation, CompleteTaskForAssigneeMutationVariables>;
export const RemindTaskAssigneesDocument = gql`
    mutation RemindTaskAssignees($input: RemindTaskAssigneesInput!) {
  remindTaskAssignees(input: $input) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type RemindTaskAssigneesMutationFn = ApolloReactHooks.useMutation.MutationFunction<RemindTaskAssigneesMutation, RemindTaskAssigneesMutationVariables>;

/**
 * __useRemindTaskAssigneesMutation__
 *
 * To run a mutation, you first call `useRemindTaskAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindTaskAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindTaskAssigneesMutation, { data, loading, error }] = useRemindTaskAssigneesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemindTaskAssigneesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RemindTaskAssigneesMutation, RemindTaskAssigneesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemindTaskAssigneesMutation, RemindTaskAssigneesMutationVariables>(RemindTaskAssigneesDocument, options);
      }
export type RemindTaskAssigneesMutationHookResult = ReturnType<typeof useRemindTaskAssigneesMutation>;
export type RemindTaskAssigneesMutationResult = ApolloReactHooks.useMutation.Result<RemindTaskAssigneesMutation>;
export type RemindTaskAssigneesMutationOptions = ApolloReactHooks.useMutation.Options<RemindTaskAssigneesMutation, RemindTaskAssigneesMutationVariables>;
export const RemindTaskReviewersDocument = gql`
    mutation RemindTaskReviewers($input: RemindTaskReviewersInput!) {
  remindTaskReviewers(input: $input) {
    task {
      ...TaskReviewFields
      ...TaskViewerActionFields
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}
${TaskViewerActionFieldsFragmentDoc}`;
export type RemindTaskReviewersMutationFn = ApolloReactHooks.useMutation.MutationFunction<RemindTaskReviewersMutation, RemindTaskReviewersMutationVariables>;

/**
 * __useRemindTaskReviewersMutation__
 *
 * To run a mutation, you first call `useRemindTaskReviewersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindTaskReviewersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindTaskReviewersMutation, { data, loading, error }] = useRemindTaskReviewersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemindTaskReviewersMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RemindTaskReviewersMutation, RemindTaskReviewersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemindTaskReviewersMutation, RemindTaskReviewersMutationVariables>(RemindTaskReviewersDocument, options);
      }
export type RemindTaskReviewersMutationHookResult = ReturnType<typeof useRemindTaskReviewersMutation>;
export type RemindTaskReviewersMutationResult = ApolloReactHooks.useMutation.Result<RemindTaskReviewersMutation>;
export type RemindTaskReviewersMutationOptions = ApolloReactHooks.useMutation.Options<RemindTaskReviewersMutation, RemindTaskReviewersMutationVariables>;
export const RejectTaskDocument = gql`
    mutation RejectTask($input: RejectTaskInput!) {
  rejectTask(input: $input) {
    task {
      ...TaskReviewFields
      completedAt
      workflow {
        __typename
        id
        status
        state
      }
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}`;
export type RejectTaskMutationFn = ApolloReactHooks.useMutation.MutationFunction<RejectTaskMutation, RejectTaskMutationVariables>;

/**
 * __useRejectTaskMutation__
 *
 * To run a mutation, you first call `useRejectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTaskMutation, { data, loading, error }] = useRejectTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectTaskMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RejectTaskMutation, RejectTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectTaskMutation, RejectTaskMutationVariables>(RejectTaskDocument, options);
      }
export type RejectTaskMutationHookResult = ReturnType<typeof useRejectTaskMutation>;
export type RejectTaskMutationResult = ApolloReactHooks.useMutation.Result<RejectTaskMutation>;
export type RejectTaskMutationOptions = ApolloReactHooks.useMutation.Options<RejectTaskMutation, RejectTaskMutationVariables>;
export const UploadTaskResponseVersionDocument = gql`
    mutation UploadTaskResponseVersion($input: UploadTaskResponseVersionInput!) {
  uploadTaskResponseVersion(input: $input) {
    task {
      ...TaskReviewFields
      completedAt
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}`;
export type UploadTaskResponseVersionMutationFn = ApolloReactHooks.useMutation.MutationFunction<UploadTaskResponseVersionMutation, UploadTaskResponseVersionMutationVariables>;

/**
 * __useUploadTaskResponseVersionMutation__
 *
 * To run a mutation, you first call `useUploadTaskResponseVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTaskResponseVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTaskResponseVersionMutation, { data, loading, error }] = useUploadTaskResponseVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadTaskResponseVersionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UploadTaskResponseVersionMutation, UploadTaskResponseVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadTaskResponseVersionMutation, UploadTaskResponseVersionMutationVariables>(UploadTaskResponseVersionDocument, options);
      }
export type UploadTaskResponseVersionMutationHookResult = ReturnType<typeof useUploadTaskResponseVersionMutation>;
export type UploadTaskResponseVersionMutationResult = ApolloReactHooks.useMutation.Result<UploadTaskResponseVersionMutation>;
export type UploadTaskResponseVersionMutationOptions = ApolloReactHooks.useMutation.Options<UploadTaskResponseVersionMutation, UploadTaskResponseVersionMutationVariables>;
export const ClearTaskUploadDocument = gql`
    mutation ClearTaskUpload($taskUploadId: UUID!) {
  clearTaskUpload(taskUploadId: $taskUploadId) {
    task {
      ...TaskReviewFields
    }
  }
}
    ${TaskReviewFieldsFragmentDoc}`;
export type ClearTaskUploadMutationFn = ApolloReactHooks.useMutation.MutationFunction<ClearTaskUploadMutation, ClearTaskUploadMutationVariables>;

/**
 * __useClearTaskUploadMutation__
 *
 * To run a mutation, you first call `useClearTaskUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearTaskUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearTaskUploadMutation, { data, loading, error }] = useClearTaskUploadMutation({
 *   variables: {
 *      taskUploadId: // value for 'taskUploadId'
 *   },
 * });
 */
export function useClearTaskUploadMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ClearTaskUploadMutation, ClearTaskUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClearTaskUploadMutation, ClearTaskUploadMutationVariables>(ClearTaskUploadDocument, options);
      }
export type ClearTaskUploadMutationHookResult = ReturnType<typeof useClearTaskUploadMutation>;
export type ClearTaskUploadMutationResult = ApolloReactHooks.useMutation.Result<ClearTaskUploadMutation>;
export type ClearTaskUploadMutationOptions = ApolloReactHooks.useMutation.Options<ClearTaskUploadMutation, ClearTaskUploadMutationVariables>;
export const GetUserDefinedRoleDocument = gql`
    query GetUserDefinedRole($roleId: UUID!) {
  userDefinedRole(roleId: $roleId) {
    ...UserDefinedRoleSimple
  }
}
    ${UserDefinedRoleSimpleFragmentDoc}`;

/**
 * __useGetUserDefinedRoleQuery__
 *
 * To run a query within a React component, call `useGetUserDefinedRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDefinedRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDefinedRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetUserDefinedRoleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetUserDefinedRoleQuery, GetUserDefinedRoleQueryVariables> & ({ variables: GetUserDefinedRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserDefinedRoleQuery, GetUserDefinedRoleQueryVariables>(GetUserDefinedRoleDocument, options);
      }
export function useGetUserDefinedRoleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUserDefinedRoleQuery, GetUserDefinedRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserDefinedRoleQuery, GetUserDefinedRoleQueryVariables>(GetUserDefinedRoleDocument, options);
        }
export function useGetUserDefinedRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUserDefinedRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUserDefinedRoleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUserDefinedRoleQuery, GetUserDefinedRoleQueryVariables>(GetUserDefinedRoleDocument, options);
        }
export type GetUserDefinedRoleQueryHookResult = ReturnType<typeof useGetUserDefinedRoleQuery>;
export type GetUserDefinedRoleLazyQueryHookResult = ReturnType<typeof useGetUserDefinedRoleLazyQuery>;
export type GetUserDefinedRoleSuspenseQueryHookResult = ReturnType<typeof useGetUserDefinedRoleSuspenseQuery>;
export type GetUserDefinedRoleQueryResult = ApolloReactHooks.useQuery.Result<GetUserDefinedRoleQuery, GetUserDefinedRoleQueryVariables>;
export const GetUserDefinedRolesDocument = gql`
    query GetUserDefinedRoles {
  userDefinedRoles {
    ...UserDefinedRoleSimple
  }
}
    ${UserDefinedRoleSimpleFragmentDoc}`;

/**
 * __useGetUserDefinedRolesQuery__
 *
 * To run a query within a React component, call `useGetUserDefinedRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDefinedRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDefinedRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDefinedRolesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetUserDefinedRolesQuery, GetUserDefinedRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserDefinedRolesQuery, GetUserDefinedRolesQueryVariables>(GetUserDefinedRolesDocument, options);
      }
export function useGetUserDefinedRolesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUserDefinedRolesQuery, GetUserDefinedRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserDefinedRolesQuery, GetUserDefinedRolesQueryVariables>(GetUserDefinedRolesDocument, options);
        }
export function useGetUserDefinedRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUserDefinedRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUserDefinedRolesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUserDefinedRolesQuery, GetUserDefinedRolesQueryVariables>(GetUserDefinedRolesDocument, options);
        }
export type GetUserDefinedRolesQueryHookResult = ReturnType<typeof useGetUserDefinedRolesQuery>;
export type GetUserDefinedRolesLazyQueryHookResult = ReturnType<typeof useGetUserDefinedRolesLazyQuery>;
export type GetUserDefinedRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserDefinedRolesSuspenseQuery>;
export type GetUserDefinedRolesQueryResult = ApolloReactHooks.useQuery.Result<GetUserDefinedRolesQuery, GetUserDefinedRolesQueryVariables>;
export const GetRequesterUserDefinedRolesDocument = gql`
    query GetRequesterUserDefinedRoles {
  userDefinedRoles {
    ...UserDefinedRoleSimple
    author {
      ...UserBase
    }
  }
}
    ${UserDefinedRoleSimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useGetRequesterUserDefinedRolesQuery__
 *
 * To run a query within a React component, call `useGetRequesterUserDefinedRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequesterUserDefinedRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequesterUserDefinedRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequesterUserDefinedRolesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetRequesterUserDefinedRolesQuery, GetRequesterUserDefinedRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRequesterUserDefinedRolesQuery, GetRequesterUserDefinedRolesQueryVariables>(GetRequesterUserDefinedRolesDocument, options);
      }
export function useGetRequesterUserDefinedRolesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetRequesterUserDefinedRolesQuery, GetRequesterUserDefinedRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRequesterUserDefinedRolesQuery, GetRequesterUserDefinedRolesQueryVariables>(GetRequesterUserDefinedRolesDocument, options);
        }
export function useGetRequesterUserDefinedRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetRequesterUserDefinedRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetRequesterUserDefinedRolesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetRequesterUserDefinedRolesQuery, GetRequesterUserDefinedRolesQueryVariables>(GetRequesterUserDefinedRolesDocument, options);
        }
export type GetRequesterUserDefinedRolesQueryHookResult = ReturnType<typeof useGetRequesterUserDefinedRolesQuery>;
export type GetRequesterUserDefinedRolesLazyQueryHookResult = ReturnType<typeof useGetRequesterUserDefinedRolesLazyQuery>;
export type GetRequesterUserDefinedRolesSuspenseQueryHookResult = ReturnType<typeof useGetRequesterUserDefinedRolesSuspenseQuery>;
export type GetRequesterUserDefinedRolesQueryResult = ApolloReactHooks.useQuery.Result<GetRequesterUserDefinedRolesQuery, GetRequesterUserDefinedRolesQueryVariables>;
export const CreateUserDefinedRoleDocument = gql`
    mutation CreateUserDefinedRole($input: CreateUserDefinedRoleInput!) {
  createUserDefinedRole(input: $input) {
    userDefinedRole {
      ...UserDefinedRoleSimple
    }
  }
}
    ${UserDefinedRoleSimpleFragmentDoc}`;
export type CreateUserDefinedRoleMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateUserDefinedRoleMutation, CreateUserDefinedRoleMutationVariables>;

/**
 * __useCreateUserDefinedRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserDefinedRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDefinedRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDefinedRoleMutation, { data, loading, error }] = useCreateUserDefinedRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserDefinedRoleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateUserDefinedRoleMutation, CreateUserDefinedRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserDefinedRoleMutation, CreateUserDefinedRoleMutationVariables>(CreateUserDefinedRoleDocument, options);
      }
export type CreateUserDefinedRoleMutationHookResult = ReturnType<typeof useCreateUserDefinedRoleMutation>;
export type CreateUserDefinedRoleMutationResult = ApolloReactHooks.useMutation.Result<CreateUserDefinedRoleMutation>;
export type CreateUserDefinedRoleMutationOptions = ApolloReactHooks.useMutation.Options<CreateUserDefinedRoleMutation, CreateUserDefinedRoleMutationVariables>;
export const DeleteUserDefinedRoleDocument = gql`
    mutation DeleteUserDefinedRole($input: DeleteUserDefinedRoleInput!) {
  deleteUserDefinedRole(input: $input)
}
    `;
export type DeleteUserDefinedRoleMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteUserDefinedRoleMutation, DeleteUserDefinedRoleMutationVariables>;

/**
 * __useDeleteUserDefinedRoleMutation__
 *
 * To run a mutation, you first call `useDeleteUserDefinedRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDefinedRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDefinedRoleMutation, { data, loading, error }] = useDeleteUserDefinedRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserDefinedRoleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteUserDefinedRoleMutation, DeleteUserDefinedRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserDefinedRoleMutation, DeleteUserDefinedRoleMutationVariables>(DeleteUserDefinedRoleDocument, options);
      }
export type DeleteUserDefinedRoleMutationHookResult = ReturnType<typeof useDeleteUserDefinedRoleMutation>;
export type DeleteUserDefinedRoleMutationResult = ApolloReactHooks.useMutation.Result<DeleteUserDefinedRoleMutation>;
export type DeleteUserDefinedRoleMutationOptions = ApolloReactHooks.useMutation.Options<DeleteUserDefinedRoleMutation, DeleteUserDefinedRoleMutationVariables>;
export const MergeRolesDocument = gql`
    mutation MergeRoles($input: MergeRolesInput!) {
  mergeUserDefinedRoles(input: $input) {
    userDefinedRole {
      __typename
      id
      roleName
    }
  }
}
    `;
export type MergeRolesMutationFn = ApolloReactHooks.useMutation.MutationFunction<MergeRolesMutation, MergeRolesMutationVariables>;

/**
 * __useMergeRolesMutation__
 *
 * To run a mutation, you first call `useMergeRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeRolesMutation, { data, loading, error }] = useMergeRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeRolesMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MergeRolesMutation, MergeRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeRolesMutation, MergeRolesMutationVariables>(MergeRolesDocument, options);
      }
export type MergeRolesMutationHookResult = ReturnType<typeof useMergeRolesMutation>;
export type MergeRolesMutationResult = ApolloReactHooks.useMutation.Result<MergeRolesMutation>;
export type MergeRolesMutationOptions = ApolloReactHooks.useMutation.Options<MergeRolesMutation, MergeRolesMutationVariables>;
export const UpdateUserDefinedRoleDocument = gql`
    mutation UpdateUserDefinedRole($input: UpdateUserDefinedRoleInput!) {
  updateUserDefinedRole(input: $input) {
    userDefinedRole {
      ...UserDefinedRoleSimple
    }
  }
}
    ${UserDefinedRoleSimpleFragmentDoc}`;
export type UpdateUserDefinedRoleMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateUserDefinedRoleMutation, UpdateUserDefinedRoleMutationVariables>;

/**
 * __useUpdateUserDefinedRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserDefinedRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDefinedRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDefinedRoleMutation, { data, loading, error }] = useUpdateUserDefinedRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDefinedRoleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateUserDefinedRoleMutation, UpdateUserDefinedRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserDefinedRoleMutation, UpdateUserDefinedRoleMutationVariables>(UpdateUserDefinedRoleDocument, options);
      }
export type UpdateUserDefinedRoleMutationHookResult = ReturnType<typeof useUpdateUserDefinedRoleMutation>;
export type UpdateUserDefinedRoleMutationResult = ApolloReactHooks.useMutation.Result<UpdateUserDefinedRoleMutation>;
export type UpdateUserDefinedRoleMutationOptions = ApolloReactHooks.useMutation.Options<UpdateUserDefinedRoleMutation, UpdateUserDefinedRoleMutationVariables>;
export const GetWorkflowCannedFieldsDocument = gql`
    query GetWorkflowCannedFields($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    cannedFields {
      ...CannedFieldFull
    }
  }
}
    ${CannedFieldFullFragmentDoc}`;

/**
 * __useGetWorkflowCannedFieldsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowCannedFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowCannedFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowCannedFieldsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowCannedFieldsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowCannedFieldsQuery, GetWorkflowCannedFieldsQueryVariables> & ({ variables: GetWorkflowCannedFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowCannedFieldsQuery, GetWorkflowCannedFieldsQueryVariables>(GetWorkflowCannedFieldsDocument, options);
      }
export function useGetWorkflowCannedFieldsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowCannedFieldsQuery, GetWorkflowCannedFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowCannedFieldsQuery, GetWorkflowCannedFieldsQueryVariables>(GetWorkflowCannedFieldsDocument, options);
        }
export function useGetWorkflowCannedFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowCannedFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowCannedFieldsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowCannedFieldsQuery, GetWorkflowCannedFieldsQueryVariables>(GetWorkflowCannedFieldsDocument, options);
        }
export type GetWorkflowCannedFieldsQueryHookResult = ReturnType<typeof useGetWorkflowCannedFieldsQuery>;
export type GetWorkflowCannedFieldsLazyQueryHookResult = ReturnType<typeof useGetWorkflowCannedFieldsLazyQuery>;
export type GetWorkflowCannedFieldsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowCannedFieldsSuspenseQuery>;
export type GetWorkflowCannedFieldsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowCannedFieldsQuery, GetWorkflowCannedFieldsQueryVariables>;
export const GetCannedFieldDocument = gql`
    query GetCannedField($id: UUID!) {
  cannedField(id: $id) {
    ...CannedFieldFull
  }
}
    ${CannedFieldFullFragmentDoc}`;

/**
 * __useGetCannedFieldQuery__
 *
 * To run a query within a React component, call `useGetCannedFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCannedFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCannedFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCannedFieldQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetCannedFieldQuery, GetCannedFieldQueryVariables> & ({ variables: GetCannedFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCannedFieldQuery, GetCannedFieldQueryVariables>(GetCannedFieldDocument, options);
      }
export function useGetCannedFieldLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetCannedFieldQuery, GetCannedFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCannedFieldQuery, GetCannedFieldQueryVariables>(GetCannedFieldDocument, options);
        }
export function useGetCannedFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetCannedFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetCannedFieldQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetCannedFieldQuery, GetCannedFieldQueryVariables>(GetCannedFieldDocument, options);
        }
export type GetCannedFieldQueryHookResult = ReturnType<typeof useGetCannedFieldQuery>;
export type GetCannedFieldLazyQueryHookResult = ReturnType<typeof useGetCannedFieldLazyQuery>;
export type GetCannedFieldSuspenseQueryHookResult = ReturnType<typeof useGetCannedFieldSuspenseQuery>;
export type GetCannedFieldQueryResult = ApolloReactHooks.useQuery.Result<GetCannedFieldQuery, GetCannedFieldQueryVariables>;
export const CreateCannedFieldDocument = gql`
    mutation CreateCannedField($input: CreateCannedFieldInput!) {
  createCannedField(input: $input) {
    cannedField {
      ...CannedFieldFull
    }
  }
}
    ${CannedFieldFullFragmentDoc}`;
export type CreateCannedFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateCannedFieldMutation, CreateCannedFieldMutationVariables>;

/**
 * __useCreateCannedFieldMutation__
 *
 * To run a mutation, you first call `useCreateCannedFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCannedFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCannedFieldMutation, { data, loading, error }] = useCreateCannedFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCannedFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateCannedFieldMutation, CreateCannedFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCannedFieldMutation, CreateCannedFieldMutationVariables>(CreateCannedFieldDocument, options);
      }
export type CreateCannedFieldMutationHookResult = ReturnType<typeof useCreateCannedFieldMutation>;
export type CreateCannedFieldMutationResult = ApolloReactHooks.useMutation.Result<CreateCannedFieldMutation>;
export type CreateCannedFieldMutationOptions = ApolloReactHooks.useMutation.Options<CreateCannedFieldMutation, CreateCannedFieldMutationVariables>;
export const UpdateCannedFieldDocument = gql`
    mutation UpdateCannedField($input: UpdateCannedFieldInput!) {
  updateCannedField(input: $input) {
    cannedField {
      ...CannedFieldFull
    }
  }
}
    ${CannedFieldFullFragmentDoc}`;
export type UpdateCannedFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateCannedFieldMutation, UpdateCannedFieldMutationVariables>;

/**
 * __useUpdateCannedFieldMutation__
 *
 * To run a mutation, you first call `useUpdateCannedFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCannedFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCannedFieldMutation, { data, loading, error }] = useUpdateCannedFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCannedFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateCannedFieldMutation, UpdateCannedFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCannedFieldMutation, UpdateCannedFieldMutationVariables>(UpdateCannedFieldDocument, options);
      }
export type UpdateCannedFieldMutationHookResult = ReturnType<typeof useUpdateCannedFieldMutation>;
export type UpdateCannedFieldMutationResult = ApolloReactHooks.useMutation.Result<UpdateCannedFieldMutation>;
export type UpdateCannedFieldMutationOptions = ApolloReactHooks.useMutation.Options<UpdateCannedFieldMutation, UpdateCannedFieldMutationVariables>;
export const DeleteCannedFieldDocument = gql`
    mutation DeleteCannedField($id: UUID!) {
  deleteCannedField(id: $id) {
    cannedField {
      ...CannedFieldFull
    }
  }
}
    ${CannedFieldFullFragmentDoc}`;
export type DeleteCannedFieldMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteCannedFieldMutation, DeleteCannedFieldMutationVariables>;

/**
 * __useDeleteCannedFieldMutation__
 *
 * To run a mutation, you first call `useDeleteCannedFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCannedFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCannedFieldMutation, { data, loading, error }] = useDeleteCannedFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCannedFieldMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteCannedFieldMutation, DeleteCannedFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCannedFieldMutation, DeleteCannedFieldMutationVariables>(DeleteCannedFieldDocument, options);
      }
export type DeleteCannedFieldMutationHookResult = ReturnType<typeof useDeleteCannedFieldMutation>;
export type DeleteCannedFieldMutationResult = ApolloReactHooks.useMutation.Result<DeleteCannedFieldMutation>;
export type DeleteCannedFieldMutationOptions = ApolloReactHooks.useMutation.Options<DeleteCannedFieldMutation, DeleteCannedFieldMutationVariables>;
export const GetVariablesForDocumentDocument = gql`
    query GetVariablesForDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    variables {
      __typename
      deletedAt
      id
      isField
      addToLaunchForm
      label
      nodeId
      prefix
      question
      minRequired
      maxRequired
      value
      variant
      skipped
      action {
        ...WorkflowRecipientSimple
      }
      answerOptions {
        ...AnswerOptionsBase
      }
      config {
        __typename
        id
      }
      defaultAnswer {
        ...AnswerOptionBase
      }
      selectedAnswer {
        ...AnswerOptionBase
      }
      selectedAnswers {
        ...AnswerOptionBase
      }
      integrationLink {
        attributePath
        integration
      }
    }
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}
${AnswerOptionsBaseFragmentDoc}
${AnswerOptionBaseFragmentDoc}`;

/**
 * __useGetVariablesForDocumentQuery__
 *
 * To run a query within a React component, call `useGetVariablesForDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVariablesForDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariablesForDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetVariablesForDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetVariablesForDocumentQuery, GetVariablesForDocumentQueryVariables> & ({ variables: GetVariablesForDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVariablesForDocumentQuery, GetVariablesForDocumentQueryVariables>(GetVariablesForDocumentDocument, options);
      }
export function useGetVariablesForDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetVariablesForDocumentQuery, GetVariablesForDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVariablesForDocumentQuery, GetVariablesForDocumentQueryVariables>(GetVariablesForDocumentDocument, options);
        }
export function useGetVariablesForDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetVariablesForDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetVariablesForDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetVariablesForDocumentQuery, GetVariablesForDocumentQueryVariables>(GetVariablesForDocumentDocument, options);
        }
export type GetVariablesForDocumentQueryHookResult = ReturnType<typeof useGetVariablesForDocumentQuery>;
export type GetVariablesForDocumentLazyQueryHookResult = ReturnType<typeof useGetVariablesForDocumentLazyQuery>;
export type GetVariablesForDocumentSuspenseQueryHookResult = ReturnType<typeof useGetVariablesForDocumentSuspenseQuery>;
export type GetVariablesForDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetVariablesForDocumentQuery, GetVariablesForDocumentQueryVariables>;
export const GetDocumentVariableDocument = gql`
    query GetDocumentVariable($id: UUID!) {
  documentVariable(id: $id) {
    ...DocumentVariableFull
  }
}
    ${DocumentVariableFullFragmentDoc}`;

/**
 * __useGetDocumentVariableQuery__
 *
 * To run a query within a React component, call `useGetDocumentVariableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVariableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVariableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDocumentVariableQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentVariableQuery, GetDocumentVariableQueryVariables> & ({ variables: GetDocumentVariableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentVariableQuery, GetDocumentVariableQueryVariables>(GetDocumentVariableDocument, options);
      }
export function useGetDocumentVariableLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentVariableQuery, GetDocumentVariableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentVariableQuery, GetDocumentVariableQueryVariables>(GetDocumentVariableDocument, options);
        }
export function useGetDocumentVariableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentVariableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentVariableQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentVariableQuery, GetDocumentVariableQueryVariables>(GetDocumentVariableDocument, options);
        }
export type GetDocumentVariableQueryHookResult = ReturnType<typeof useGetDocumentVariableQuery>;
export type GetDocumentVariableLazyQueryHookResult = ReturnType<typeof useGetDocumentVariableLazyQuery>;
export type GetDocumentVariableSuspenseQueryHookResult = ReturnType<typeof useGetDocumentVariableSuspenseQuery>;
export type GetDocumentVariableQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentVariableQuery, GetDocumentVariableQueryVariables>;
export const GetVariableWithActionDocument = gql`
    query GetVariableWithAction($id: UUID!) {
  documentVariable(id: $id) {
    __typename
    id
    action {
      ...WorkflowRecipientSimple
    }
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}`;

/**
 * __useGetVariableWithActionQuery__
 *
 * To run a query within a React component, call `useGetVariableWithActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVariableWithActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariableWithActionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVariableWithActionQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetVariableWithActionQuery, GetVariableWithActionQueryVariables> & ({ variables: GetVariableWithActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVariableWithActionQuery, GetVariableWithActionQueryVariables>(GetVariableWithActionDocument, options);
      }
export function useGetVariableWithActionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetVariableWithActionQuery, GetVariableWithActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVariableWithActionQuery, GetVariableWithActionQueryVariables>(GetVariableWithActionDocument, options);
        }
export function useGetVariableWithActionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetVariableWithActionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetVariableWithActionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetVariableWithActionQuery, GetVariableWithActionQueryVariables>(GetVariableWithActionDocument, options);
        }
export type GetVariableWithActionQueryHookResult = ReturnType<typeof useGetVariableWithActionQuery>;
export type GetVariableWithActionLazyQueryHookResult = ReturnType<typeof useGetVariableWithActionLazyQuery>;
export type GetVariableWithActionSuspenseQueryHookResult = ReturnType<typeof useGetVariableWithActionSuspenseQuery>;
export type GetVariableWithActionQueryResult = ApolloReactHooks.useQuery.Result<GetVariableWithActionQuery, GetVariableWithActionQueryVariables>;
export const CreateDocumentVariableDocument = gql`
    mutation CreateDocumentVariable($input: CreateDocumentVariableInput!) {
  createVariable(input: $input) {
    ...DocumentVariableFull
  }
}
    ${DocumentVariableFullFragmentDoc}`;
export type CreateDocumentVariableMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateDocumentVariableMutation, CreateDocumentVariableMutationVariables>;

/**
 * __useCreateDocumentVariableMutation__
 *
 * To run a mutation, you first call `useCreateDocumentVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentVariableMutation, { data, loading, error }] = useCreateDocumentVariableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentVariableMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateDocumentVariableMutation, CreateDocumentVariableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocumentVariableMutation, CreateDocumentVariableMutationVariables>(CreateDocumentVariableDocument, options);
      }
export type CreateDocumentVariableMutationHookResult = ReturnType<typeof useCreateDocumentVariableMutation>;
export type CreateDocumentVariableMutationResult = ApolloReactHooks.useMutation.Result<CreateDocumentVariableMutation>;
export type CreateDocumentVariableMutationOptions = ApolloReactHooks.useMutation.Options<CreateDocumentVariableMutation, CreateDocumentVariableMutationVariables>;
export const DisableDocumentVariableDocument = gql`
    mutation DisableDocumentVariable($id: UUID!) {
  disableVariable(id: $id) {
    __typename
    id
    deletedAt
  }
}
    `;
export type DisableDocumentVariableMutationFn = ApolloReactHooks.useMutation.MutationFunction<DisableDocumentVariableMutation, DisableDocumentVariableMutationVariables>;

/**
 * __useDisableDocumentVariableMutation__
 *
 * To run a mutation, you first call `useDisableDocumentVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableDocumentVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableDocumentVariableMutation, { data, loading, error }] = useDisableDocumentVariableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableDocumentVariableMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DisableDocumentVariableMutation, DisableDocumentVariableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableDocumentVariableMutation, DisableDocumentVariableMutationVariables>(DisableDocumentVariableDocument, options);
      }
export type DisableDocumentVariableMutationHookResult = ReturnType<typeof useDisableDocumentVariableMutation>;
export type DisableDocumentVariableMutationResult = ApolloReactHooks.useMutation.Result<DisableDocumentVariableMutation>;
export type DisableDocumentVariableMutationOptions = ApolloReactHooks.useMutation.Options<DisableDocumentVariableMutation, DisableDocumentVariableMutationVariables>;
export const UpdateDocumentVariableDocument = gql`
    mutation UpdateDocumentVariable($input: UpdateDocumentVariableInput!) {
  updateVariable(input: $input) {
    ...DocumentVariableFull
  }
}
    ${DocumentVariableFullFragmentDoc}`;
export type UpdateDocumentVariableMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateDocumentVariableMutation, UpdateDocumentVariableMutationVariables>;

/**
 * __useUpdateDocumentVariableMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentVariableMutation, { data, loading, error }] = useUpdateDocumentVariableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentVariableMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateDocumentVariableMutation, UpdateDocumentVariableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentVariableMutation, UpdateDocumentVariableMutationVariables>(UpdateDocumentVariableDocument, options);
      }
export type UpdateDocumentVariableMutationHookResult = ReturnType<typeof useUpdateDocumentVariableMutation>;
export type UpdateDocumentVariableMutationResult = ApolloReactHooks.useMutation.Result<UpdateDocumentVariableMutation>;
export type UpdateDocumentVariableMutationOptions = ApolloReactHooks.useMutation.Options<UpdateDocumentVariableMutation, UpdateDocumentVariableMutationVariables>;
export const GetVariableConfigDocument = gql`
    query GetVariableConfig($id: UUID!) {
  variableConfig(id: $id) {
    ...VariableConfigFull
  }
}
    ${VariableConfigFullFragmentDoc}`;

/**
 * __useGetVariableConfigQuery__
 *
 * To run a query within a React component, call `useGetVariableConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVariableConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariableConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVariableConfigQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetVariableConfigQuery, GetVariableConfigQueryVariables> & ({ variables: GetVariableConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVariableConfigQuery, GetVariableConfigQueryVariables>(GetVariableConfigDocument, options);
      }
export function useGetVariableConfigLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetVariableConfigQuery, GetVariableConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVariableConfigQuery, GetVariableConfigQueryVariables>(GetVariableConfigDocument, options);
        }
export function useGetVariableConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetVariableConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetVariableConfigQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetVariableConfigQuery, GetVariableConfigQueryVariables>(GetVariableConfigDocument, options);
        }
export type GetVariableConfigQueryHookResult = ReturnType<typeof useGetVariableConfigQuery>;
export type GetVariableConfigLazyQueryHookResult = ReturnType<typeof useGetVariableConfigLazyQuery>;
export type GetVariableConfigSuspenseQueryHookResult = ReturnType<typeof useGetVariableConfigSuspenseQuery>;
export type GetVariableConfigQueryResult = ApolloReactHooks.useQuery.Result<GetVariableConfigQuery, GetVariableConfigQueryVariables>;
export const GetVariableConfigsDocument = gql`
    query GetVariableConfigs {
  variableConfigs {
    ...VariableConfigSimple
  }
}
    ${VariableConfigSimpleFragmentDoc}`;

/**
 * __useGetVariableConfigsQuery__
 *
 * To run a query within a React component, call `useGetVariableConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVariableConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariableConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVariableConfigsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetVariableConfigsQuery, GetVariableConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVariableConfigsQuery, GetVariableConfigsQueryVariables>(GetVariableConfigsDocument, options);
      }
export function useGetVariableConfigsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetVariableConfigsQuery, GetVariableConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVariableConfigsQuery, GetVariableConfigsQueryVariables>(GetVariableConfigsDocument, options);
        }
export function useGetVariableConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetVariableConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetVariableConfigsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetVariableConfigsQuery, GetVariableConfigsQueryVariables>(GetVariableConfigsDocument, options);
        }
export type GetVariableConfigsQueryHookResult = ReturnType<typeof useGetVariableConfigsQuery>;
export type GetVariableConfigsLazyQueryHookResult = ReturnType<typeof useGetVariableConfigsLazyQuery>;
export type GetVariableConfigsSuspenseQueryHookResult = ReturnType<typeof useGetVariableConfigsSuspenseQuery>;
export type GetVariableConfigsQueryResult = ApolloReactHooks.useQuery.Result<GetVariableConfigsQuery, GetVariableConfigsQueryVariables>;
export const CreateVariableConfigDocument = gql`
    mutation CreateVariableConfig($input: CreateVariableConfigInput!) {
  createVariableConfig(input: $input) {
    ...VariableConfigFull
  }
}
    ${VariableConfigFullFragmentDoc}`;
export type CreateVariableConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateVariableConfigMutation, CreateVariableConfigMutationVariables>;

/**
 * __useCreateVariableConfigMutation__
 *
 * To run a mutation, you first call `useCreateVariableConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVariableConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVariableConfigMutation, { data, loading, error }] = useCreateVariableConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVariableConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateVariableConfigMutation, CreateVariableConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateVariableConfigMutation, CreateVariableConfigMutationVariables>(CreateVariableConfigDocument, options);
      }
export type CreateVariableConfigMutationHookResult = ReturnType<typeof useCreateVariableConfigMutation>;
export type CreateVariableConfigMutationResult = ApolloReactHooks.useMutation.Result<CreateVariableConfigMutation>;
export type CreateVariableConfigMutationOptions = ApolloReactHooks.useMutation.Options<CreateVariableConfigMutation, CreateVariableConfigMutationVariables>;
export const DeleteVariableConfigDocument = gql`
    mutation DeleteVariableConfig($id: UUID!) {
  deleteVariableConfig(id: $id)
}
    `;
export type DeleteVariableConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteVariableConfigMutation, DeleteVariableConfigMutationVariables>;

/**
 * __useDeleteVariableConfigMutation__
 *
 * To run a mutation, you first call `useDeleteVariableConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVariableConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVariableConfigMutation, { data, loading, error }] = useDeleteVariableConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVariableConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteVariableConfigMutation, DeleteVariableConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteVariableConfigMutation, DeleteVariableConfigMutationVariables>(DeleteVariableConfigDocument, options);
      }
export type DeleteVariableConfigMutationHookResult = ReturnType<typeof useDeleteVariableConfigMutation>;
export type DeleteVariableConfigMutationResult = ApolloReactHooks.useMutation.Result<DeleteVariableConfigMutation>;
export type DeleteVariableConfigMutationOptions = ApolloReactHooks.useMutation.Options<DeleteVariableConfigMutation, DeleteVariableConfigMutationVariables>;
export const UpdateVariableConfigDocument = gql`
    mutation UpdateVariableConfig($input: UpdateVariableConfigInput!) {
  updateVariableConfig(input: $input) {
    ...VariableConfigFull
  }
}
    ${VariableConfigFullFragmentDoc}`;
export type UpdateVariableConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateVariableConfigMutation, UpdateVariableConfigMutationVariables>;

/**
 * __useUpdateVariableConfigMutation__
 *
 * To run a mutation, you first call `useUpdateVariableConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVariableConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVariableConfigMutation, { data, loading, error }] = useUpdateVariableConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVariableConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateVariableConfigMutation, UpdateVariableConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateVariableConfigMutation, UpdateVariableConfigMutationVariables>(UpdateVariableConfigDocument, options);
      }
export type UpdateVariableConfigMutationHookResult = ReturnType<typeof useUpdateVariableConfigMutation>;
export type UpdateVariableConfigMutationResult = ApolloReactHooks.useMutation.Result<UpdateVariableConfigMutation>;
export type UpdateVariableConfigMutationOptions = ApolloReactHooks.useMutation.Options<UpdateVariableConfigMutation, UpdateVariableConfigMutationVariables>;
export const MergeVariableConfigsDocument = gql`
    mutation MergeVariableConfigs($input: MergeVariableConfigsInput!) {
  mergeVariableConfigs(input: $input) {
    __typename
    id
  }
}
    `;
export type MergeVariableConfigsMutationFn = ApolloReactHooks.useMutation.MutationFunction<MergeVariableConfigsMutation, MergeVariableConfigsMutationVariables>;

/**
 * __useMergeVariableConfigsMutation__
 *
 * To run a mutation, you first call `useMergeVariableConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeVariableConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeVariableConfigsMutation, { data, loading, error }] = useMergeVariableConfigsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeVariableConfigsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MergeVariableConfigsMutation, MergeVariableConfigsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeVariableConfigsMutation, MergeVariableConfigsMutationVariables>(MergeVariableConfigsDocument, options);
      }
export type MergeVariableConfigsMutationHookResult = ReturnType<typeof useMergeVariableConfigsMutation>;
export type MergeVariableConfigsMutationResult = ApolloReactHooks.useMutation.Result<MergeVariableConfigsMutation>;
export type MergeVariableConfigsMutationOptions = ApolloReactHooks.useMutation.Options<MergeVariableConfigsMutation, MergeVariableConfigsMutationVariables>;
export const GetWorkflowLinkedOpportunitiesDocument = gql`
    query GetWorkflowLinkedOpportunities($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    id
    linkedOpportunities {
      id
      integration
      opportunityId
    }
  }
}
    `;

/**
 * __useGetWorkflowLinkedOpportunitiesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowLinkedOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowLinkedOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowLinkedOpportunitiesQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowLinkedOpportunitiesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowLinkedOpportunitiesQuery, GetWorkflowLinkedOpportunitiesQueryVariables> & ({ variables: GetWorkflowLinkedOpportunitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowLinkedOpportunitiesQuery, GetWorkflowLinkedOpportunitiesQueryVariables>(GetWorkflowLinkedOpportunitiesDocument, options);
      }
export function useGetWorkflowLinkedOpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowLinkedOpportunitiesQuery, GetWorkflowLinkedOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowLinkedOpportunitiesQuery, GetWorkflowLinkedOpportunitiesQueryVariables>(GetWorkflowLinkedOpportunitiesDocument, options);
        }
export function useGetWorkflowLinkedOpportunitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowLinkedOpportunitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowLinkedOpportunitiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowLinkedOpportunitiesQuery, GetWorkflowLinkedOpportunitiesQueryVariables>(GetWorkflowLinkedOpportunitiesDocument, options);
        }
export type GetWorkflowLinkedOpportunitiesQueryHookResult = ReturnType<typeof useGetWorkflowLinkedOpportunitiesQuery>;
export type GetWorkflowLinkedOpportunitiesLazyQueryHookResult = ReturnType<typeof useGetWorkflowLinkedOpportunitiesLazyQuery>;
export type GetWorkflowLinkedOpportunitiesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowLinkedOpportunitiesSuspenseQuery>;
export type GetWorkflowLinkedOpportunitiesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowLinkedOpportunitiesQuery, GetWorkflowLinkedOpportunitiesQueryVariables>;
export const GetLinkedOpportunityDocument = gql`
    query GetLinkedOpportunity($linkOpportunityId: UUID!) {
  linkedOpportunity(linkOpportunityId: $linkOpportunityId) {
    id
    integration
    opportunityId
  }
}
    `;

/**
 * __useGetLinkedOpportunityQuery__
 *
 * To run a query within a React component, call `useGetLinkedOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedOpportunityQuery({
 *   variables: {
 *      linkOpportunityId: // value for 'linkOpportunityId'
 *   },
 * });
 */
export function useGetLinkedOpportunityQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetLinkedOpportunityQuery, GetLinkedOpportunityQueryVariables> & ({ variables: GetLinkedOpportunityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLinkedOpportunityQuery, GetLinkedOpportunityQueryVariables>(GetLinkedOpportunityDocument, options);
      }
export function useGetLinkedOpportunityLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetLinkedOpportunityQuery, GetLinkedOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLinkedOpportunityQuery, GetLinkedOpportunityQueryVariables>(GetLinkedOpportunityDocument, options);
        }
export function useGetLinkedOpportunitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetLinkedOpportunityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetLinkedOpportunityQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetLinkedOpportunityQuery, GetLinkedOpportunityQueryVariables>(GetLinkedOpportunityDocument, options);
        }
export type GetLinkedOpportunityQueryHookResult = ReturnType<typeof useGetLinkedOpportunityQuery>;
export type GetLinkedOpportunityLazyQueryHookResult = ReturnType<typeof useGetLinkedOpportunityLazyQuery>;
export type GetLinkedOpportunitySuspenseQueryHookResult = ReturnType<typeof useGetLinkedOpportunitySuspenseQuery>;
export type GetLinkedOpportunityQueryResult = ApolloReactHooks.useQuery.Result<GetLinkedOpportunityQuery, GetLinkedOpportunityQueryVariables>;
export const TemplateOpportunityAttributesDocument = gql`
    query TemplateOpportunityAttributes($serviceId: String!) {
  templateOpportunityAttributes(serviceId: $serviceId) {
    ...IntegrationFieldSimple
  }
}
    ${IntegrationFieldSimpleFragmentDoc}`;

/**
 * __useTemplateOpportunityAttributesQuery__
 *
 * To run a query within a React component, call `useTemplateOpportunityAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateOpportunityAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateOpportunityAttributesQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useTemplateOpportunityAttributesQuery(baseOptions: ApolloReactHooks.useQuery.Options<TemplateOpportunityAttributesQuery, TemplateOpportunityAttributesQueryVariables> & ({ variables: TemplateOpportunityAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TemplateOpportunityAttributesQuery, TemplateOpportunityAttributesQueryVariables>(TemplateOpportunityAttributesDocument, options);
      }
export function useTemplateOpportunityAttributesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<TemplateOpportunityAttributesQuery, TemplateOpportunityAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TemplateOpportunityAttributesQuery, TemplateOpportunityAttributesQueryVariables>(TemplateOpportunityAttributesDocument, options);
        }
export function useTemplateOpportunityAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<TemplateOpportunityAttributesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<TemplateOpportunityAttributesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<TemplateOpportunityAttributesQuery, TemplateOpportunityAttributesQueryVariables>(TemplateOpportunityAttributesDocument, options);
        }
export type TemplateOpportunityAttributesQueryHookResult = ReturnType<typeof useTemplateOpportunityAttributesQuery>;
export type TemplateOpportunityAttributesLazyQueryHookResult = ReturnType<typeof useTemplateOpportunityAttributesLazyQuery>;
export type TemplateOpportunityAttributesSuspenseQueryHookResult = ReturnType<typeof useTemplateOpportunityAttributesSuspenseQuery>;
export type TemplateOpportunityAttributesQueryResult = ApolloReactHooks.useQuery.Result<TemplateOpportunityAttributesQuery, TemplateOpportunityAttributesQueryVariables>;
export const GetWorkflowMappedCrmIntegrationsDocument = gql`
    query GetWorkflowMappedCrmIntegrations($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    id
    mappedCrmIntegrations
  }
}
    `;

/**
 * __useGetWorkflowMappedCrmIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowMappedCrmIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowMappedCrmIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowMappedCrmIntegrationsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowMappedCrmIntegrationsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowMappedCrmIntegrationsQuery, GetWorkflowMappedCrmIntegrationsQueryVariables> & ({ variables: GetWorkflowMappedCrmIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowMappedCrmIntegrationsQuery, GetWorkflowMappedCrmIntegrationsQueryVariables>(GetWorkflowMappedCrmIntegrationsDocument, options);
      }
export function useGetWorkflowMappedCrmIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowMappedCrmIntegrationsQuery, GetWorkflowMappedCrmIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowMappedCrmIntegrationsQuery, GetWorkflowMappedCrmIntegrationsQueryVariables>(GetWorkflowMappedCrmIntegrationsDocument, options);
        }
export function useGetWorkflowMappedCrmIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowMappedCrmIntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowMappedCrmIntegrationsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowMappedCrmIntegrationsQuery, GetWorkflowMappedCrmIntegrationsQueryVariables>(GetWorkflowMappedCrmIntegrationsDocument, options);
        }
export type GetWorkflowMappedCrmIntegrationsQueryHookResult = ReturnType<typeof useGetWorkflowMappedCrmIntegrationsQuery>;
export type GetWorkflowMappedCrmIntegrationsLazyQueryHookResult = ReturnType<typeof useGetWorkflowMappedCrmIntegrationsLazyQuery>;
export type GetWorkflowMappedCrmIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowMappedCrmIntegrationsSuspenseQuery>;
export type GetWorkflowMappedCrmIntegrationsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowMappedCrmIntegrationsQuery, GetWorkflowMappedCrmIntegrationsQueryVariables>;
export const LinkWorkflowOpportunityDocument = gql`
    mutation LinkWorkflowOpportunity($input: LinkedOpportunityInput!) {
  linkOpportunity(input: $input) {
    workflow {
      id
      linkedOpportunities {
        id
        integration
        opportunityId
      }
    }
  }
}
    `;
export type LinkWorkflowOpportunityMutationFn = ApolloReactHooks.useMutation.MutationFunction<LinkWorkflowOpportunityMutation, LinkWorkflowOpportunityMutationVariables>;

/**
 * __useLinkWorkflowOpportunityMutation__
 *
 * To run a mutation, you first call `useLinkWorkflowOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkWorkflowOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkWorkflowOpportunityMutation, { data, loading, error }] = useLinkWorkflowOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkWorkflowOpportunityMutation(baseOptions?: ApolloReactHooks.useMutation.Options<LinkWorkflowOpportunityMutation, LinkWorkflowOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkWorkflowOpportunityMutation, LinkWorkflowOpportunityMutationVariables>(LinkWorkflowOpportunityDocument, options);
      }
export type LinkWorkflowOpportunityMutationHookResult = ReturnType<typeof useLinkWorkflowOpportunityMutation>;
export type LinkWorkflowOpportunityMutationResult = ApolloReactHooks.useMutation.Result<LinkWorkflowOpportunityMutation>;
export type LinkWorkflowOpportunityMutationOptions = ApolloReactHooks.useMutation.Options<LinkWorkflowOpportunityMutation, LinkWorkflowOpportunityMutationVariables>;
export const UnlinkWorkflowOpportunityDocument = gql`
    mutation UnlinkWorkflowOpportunity($linkedOpportunityId: UUID!, $documentId: UUID) {
  unlinkOpportunity(
    linkedOpportunityId: $linkedOpportunityId
    documentId: $documentId
  ) {
    workflow {
      id
      linkedOpportunities {
        id
        integration
        opportunityId
      }
    }
  }
}
    `;
export type UnlinkWorkflowOpportunityMutationFn = ApolloReactHooks.useMutation.MutationFunction<UnlinkWorkflowOpportunityMutation, UnlinkWorkflowOpportunityMutationVariables>;

/**
 * __useUnlinkWorkflowOpportunityMutation__
 *
 * To run a mutation, you first call `useUnlinkWorkflowOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkWorkflowOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkWorkflowOpportunityMutation, { data, loading, error }] = useUnlinkWorkflowOpportunityMutation({
 *   variables: {
 *      linkedOpportunityId: // value for 'linkedOpportunityId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useUnlinkWorkflowOpportunityMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UnlinkWorkflowOpportunityMutation, UnlinkWorkflowOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlinkWorkflowOpportunityMutation, UnlinkWorkflowOpportunityMutationVariables>(UnlinkWorkflowOpportunityDocument, options);
      }
export type UnlinkWorkflowOpportunityMutationHookResult = ReturnType<typeof useUnlinkWorkflowOpportunityMutation>;
export type UnlinkWorkflowOpportunityMutationResult = ApolloReactHooks.useMutation.Result<UnlinkWorkflowOpportunityMutation>;
export type UnlinkWorkflowOpportunityMutationOptions = ApolloReactHooks.useMutation.Options<UnlinkWorkflowOpportunityMutation, UnlinkWorkflowOpportunityMutationVariables>;
export const GetSalesforceRecordDataDocument = gql`
    query GetSalesforceRecordData($input: SalesforceRecordDataInput!) {
  salesforceRecordData(input: $input) {
    template {
      __typename
      id
      name
      files {
        __typename
        id
        document {
          __typename
          id
          name
        }
      }
      permissions {
        ...WorkflowPermissionSimple
      }
    }
    fieldValues {
      __typename
      fieldApiName
      fieldLabel
      value
    }
    requiredFields {
      __typename
      fieldApiName
      fieldLabel
      objectType
      isRequired
    }
    recordName
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetSalesforceRecordDataQuery__
 *
 * To run a query within a React component, call `useGetSalesforceRecordDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesforceRecordDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesforceRecordDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSalesforceRecordDataQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetSalesforceRecordDataQuery, GetSalesforceRecordDataQueryVariables> & ({ variables: GetSalesforceRecordDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSalesforceRecordDataQuery, GetSalesforceRecordDataQueryVariables>(GetSalesforceRecordDataDocument, options);
      }
export function useGetSalesforceRecordDataLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetSalesforceRecordDataQuery, GetSalesforceRecordDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSalesforceRecordDataQuery, GetSalesforceRecordDataQueryVariables>(GetSalesforceRecordDataDocument, options);
        }
export function useGetSalesforceRecordDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetSalesforceRecordDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetSalesforceRecordDataQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetSalesforceRecordDataQuery, GetSalesforceRecordDataQueryVariables>(GetSalesforceRecordDataDocument, options);
        }
export type GetSalesforceRecordDataQueryHookResult = ReturnType<typeof useGetSalesforceRecordDataQuery>;
export type GetSalesforceRecordDataLazyQueryHookResult = ReturnType<typeof useGetSalesforceRecordDataLazyQuery>;
export type GetSalesforceRecordDataSuspenseQueryHookResult = ReturnType<typeof useGetSalesforceRecordDataSuspenseQuery>;
export type GetSalesforceRecordDataQueryResult = ApolloReactHooks.useQuery.Result<GetSalesforceRecordDataQuery, GetSalesforceRecordDataQueryVariables>;
export const CreateWorkflowFromSalesforceDocument = gql`
    mutation CreateWorkflowFromSalesforce($input: CreateWorkflowInstanceInput!) {
  createWorkflowInstance(input: $input) {
    workflow {
      __typename
      id
      name
      state
    }
  }
}
    `;
export type CreateWorkflowFromSalesforceMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateWorkflowFromSalesforceMutation, CreateWorkflowFromSalesforceMutationVariables>;

/**
 * __useCreateWorkflowFromSalesforceMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowFromSalesforceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowFromSalesforceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowFromSalesforceMutation, { data, loading, error }] = useCreateWorkflowFromSalesforceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowFromSalesforceMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateWorkflowFromSalesforceMutation, CreateWorkflowFromSalesforceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkflowFromSalesforceMutation, CreateWorkflowFromSalesforceMutationVariables>(CreateWorkflowFromSalesforceDocument, options);
      }
export type CreateWorkflowFromSalesforceMutationHookResult = ReturnType<typeof useCreateWorkflowFromSalesforceMutation>;
export type CreateWorkflowFromSalesforceMutationResult = ApolloReactHooks.useMutation.Result<CreateWorkflowFromSalesforceMutation>;
export type CreateWorkflowFromSalesforceMutationOptions = ApolloReactHooks.useMutation.Options<CreateWorkflowFromSalesforceMutation, CreateWorkflowFromSalesforceMutationVariables>;
export const GetStepDocument = gql`
    query GetStep($stepId: UUID!) {
  workflowStep(stepId: $stepId) {
    ...WorkflowStepFragment
  }
}
    ${WorkflowStepFragmentFragmentDoc}`;

/**
 * __useGetStepQuery__
 *
 * To run a query within a React component, call `useGetStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStepQuery({
 *   variables: {
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useGetStepQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetStepQuery, GetStepQueryVariables> & ({ variables: GetStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStepQuery, GetStepQueryVariables>(GetStepDocument, options);
      }
export function useGetStepLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetStepQuery, GetStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStepQuery, GetStepQueryVariables>(GetStepDocument, options);
        }
export function useGetStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetStepQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetStepQuery, GetStepQueryVariables>(GetStepDocument, options);
        }
export type GetStepQueryHookResult = ReturnType<typeof useGetStepQuery>;
export type GetStepLazyQueryHookResult = ReturnType<typeof useGetStepLazyQuery>;
export type GetStepSuspenseQueryHookResult = ReturnType<typeof useGetStepSuspenseQuery>;
export type GetStepQueryResult = ApolloReactHooks.useQuery.Result<GetStepQuery, GetStepQueryVariables>;
export const GetWorkflowSigningStepsDocument = gql`
    query GetWorkflowSigningSteps($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    ...WorkflowSigningPhaseSteps
  }
}
    ${WorkflowSigningPhaseStepsFragmentDoc}`;

/**
 * __useGetWorkflowSigningStepsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowSigningStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowSigningStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowSigningStepsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowSigningStepsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowSigningStepsQuery, GetWorkflowSigningStepsQueryVariables> & ({ variables: GetWorkflowSigningStepsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowSigningStepsQuery, GetWorkflowSigningStepsQueryVariables>(GetWorkflowSigningStepsDocument, options);
      }
export function useGetWorkflowSigningStepsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowSigningStepsQuery, GetWorkflowSigningStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowSigningStepsQuery, GetWorkflowSigningStepsQueryVariables>(GetWorkflowSigningStepsDocument, options);
        }
export function useGetWorkflowSigningStepsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSigningStepsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSigningStepsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowSigningStepsQuery, GetWorkflowSigningStepsQueryVariables>(GetWorkflowSigningStepsDocument, options);
        }
export type GetWorkflowSigningStepsQueryHookResult = ReturnType<typeof useGetWorkflowSigningStepsQuery>;
export type GetWorkflowSigningStepsLazyQueryHookResult = ReturnType<typeof useGetWorkflowSigningStepsLazyQuery>;
export type GetWorkflowSigningStepsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSigningStepsSuspenseQuery>;
export type GetWorkflowSigningStepsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowSigningStepsQuery, GetWorkflowSigningStepsQueryVariables>;
export const ClearUnusedWorkflowActionsDocument = gql`
    mutation ClearUnusedWorkflowActions($workflowId: UUID!) {
  clearUnusedWorkflowActions(workflowId: $workflowId) {
    workflow {
      __typename
      id
      status
      state
      missingActions
      activeStep {
        ...WorkflowStepFragment
      }
      unusedActions {
        ...WorkflowRecipientSimple
      }
      ...WorkflowSigningPhaseSteps
    }
  }
}
    ${WorkflowStepFragmentFragmentDoc}
${WorkflowRecipientSimpleFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}`;
export type ClearUnusedWorkflowActionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<ClearUnusedWorkflowActionsMutation, ClearUnusedWorkflowActionsMutationVariables>;

/**
 * __useClearUnusedWorkflowActionsMutation__
 *
 * To run a mutation, you first call `useClearUnusedWorkflowActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearUnusedWorkflowActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearUnusedWorkflowActionsMutation, { data, loading, error }] = useClearUnusedWorkflowActionsMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useClearUnusedWorkflowActionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ClearUnusedWorkflowActionsMutation, ClearUnusedWorkflowActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClearUnusedWorkflowActionsMutation, ClearUnusedWorkflowActionsMutationVariables>(ClearUnusedWorkflowActionsDocument, options);
      }
export type ClearUnusedWorkflowActionsMutationHookResult = ReturnType<typeof useClearUnusedWorkflowActionsMutation>;
export type ClearUnusedWorkflowActionsMutationResult = ApolloReactHooks.useMutation.Result<ClearUnusedWorkflowActionsMutation>;
export type ClearUnusedWorkflowActionsMutationOptions = ApolloReactHooks.useMutation.Options<ClearUnusedWorkflowActionsMutation, ClearUnusedWorkflowActionsMutationVariables>;
export const TemplateSalesforceFieldsDocument = gql`
    query TemplateSalesforceFields($templateId: UUID!) {
  templateSalesforceFields(templateId: $templateId) {
    __typename
    templateId
    salesforceFields {
      __typename
      fieldApiName
      fieldLabel
      objectType
      isRequired
      usedInDocuments
    }
    alineFields {
      __typename
      fieldId
      label
      question
      type
      required
      order
      picklistOptions {
        __typename
        label
        value
      }
      usedInDocuments
    }
    signerRoles {
      __typename
      roleId
      label
      order
      required
      usedInDocuments
    }
    documentsList {
      __typename
      documentId
      name
    }
  }
}
    `;

/**
 * __useTemplateSalesforceFieldsQuery__
 *
 * To run a query within a React component, call `useTemplateSalesforceFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateSalesforceFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateSalesforceFieldsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplateSalesforceFieldsQuery(baseOptions: ApolloReactHooks.useQuery.Options<TemplateSalesforceFieldsQuery, TemplateSalesforceFieldsQueryVariables> & ({ variables: TemplateSalesforceFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TemplateSalesforceFieldsQuery, TemplateSalesforceFieldsQueryVariables>(TemplateSalesforceFieldsDocument, options);
      }
export function useTemplateSalesforceFieldsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<TemplateSalesforceFieldsQuery, TemplateSalesforceFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TemplateSalesforceFieldsQuery, TemplateSalesforceFieldsQueryVariables>(TemplateSalesforceFieldsDocument, options);
        }
export function useTemplateSalesforceFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<TemplateSalesforceFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<TemplateSalesforceFieldsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<TemplateSalesforceFieldsQuery, TemplateSalesforceFieldsQueryVariables>(TemplateSalesforceFieldsDocument, options);
        }
export type TemplateSalesforceFieldsQueryHookResult = ReturnType<typeof useTemplateSalesforceFieldsQuery>;
export type TemplateSalesforceFieldsLazyQueryHookResult = ReturnType<typeof useTemplateSalesforceFieldsLazyQuery>;
export type TemplateSalesforceFieldsSuspenseQueryHookResult = ReturnType<typeof useTemplateSalesforceFieldsSuspenseQuery>;
export type TemplateSalesforceFieldsQueryResult = ApolloReactHooks.useQuery.Result<TemplateSalesforceFieldsQuery, TemplateSalesforceFieldsQueryVariables>;
export const GetWalkthroughWorkflowDocument = gql`
    query GetWalkthroughWorkflow($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    state
    activeStep {
      __typename
      id
      requesterActions {
        ...RequesterWorkflowRecipient
      }
    }
    files {
      __typename
      orderId
      document {
        __typename
        id
        isSavePending
      }
    }
  }
}
    ${RequesterWorkflowRecipientFragmentDoc}`;

/**
 * __useGetWalkthroughWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWalkthroughWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalkthroughWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalkthroughWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWalkthroughWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWalkthroughWorkflowQuery, GetWalkthroughWorkflowQueryVariables> & ({ variables: GetWalkthroughWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWalkthroughWorkflowQuery, GetWalkthroughWorkflowQueryVariables>(GetWalkthroughWorkflowDocument, options);
      }
export function useGetWalkthroughWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWalkthroughWorkflowQuery, GetWalkthroughWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWalkthroughWorkflowQuery, GetWalkthroughWorkflowQueryVariables>(GetWalkthroughWorkflowDocument, options);
        }
export function useGetWalkthroughWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWalkthroughWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWalkthroughWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWalkthroughWorkflowQuery, GetWalkthroughWorkflowQueryVariables>(GetWalkthroughWorkflowDocument, options);
        }
export type GetWalkthroughWorkflowQueryHookResult = ReturnType<typeof useGetWalkthroughWorkflowQuery>;
export type GetWalkthroughWorkflowLazyQueryHookResult = ReturnType<typeof useGetWalkthroughWorkflowLazyQuery>;
export type GetWalkthroughWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetWalkthroughWorkflowSuspenseQuery>;
export type GetWalkthroughWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetWalkthroughWorkflowQuery, GetWalkthroughWorkflowQueryVariables>;
export const SetWorkflowFileDocumentRoleDocument = gql`
    mutation SetWorkflowFileDocumentRole($input: SetWorkflowFileDocumentRoleInput!) {
  setWorkflowFileDocumentRole(input: $input) {
    ...WorkflowFileSimple
  }
}
    ${WorkflowFileSimpleFragmentDoc}`;
export type SetWorkflowFileDocumentRoleMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetWorkflowFileDocumentRoleMutation, SetWorkflowFileDocumentRoleMutationVariables>;

/**
 * __useSetWorkflowFileDocumentRoleMutation__
 *
 * To run a mutation, you first call `useSetWorkflowFileDocumentRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkflowFileDocumentRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkflowFileDocumentRoleMutation, { data, loading, error }] = useSetWorkflowFileDocumentRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkflowFileDocumentRoleMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetWorkflowFileDocumentRoleMutation, SetWorkflowFileDocumentRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkflowFileDocumentRoleMutation, SetWorkflowFileDocumentRoleMutationVariables>(SetWorkflowFileDocumentRoleDocument, options);
      }
export type SetWorkflowFileDocumentRoleMutationHookResult = ReturnType<typeof useSetWorkflowFileDocumentRoleMutation>;
export type SetWorkflowFileDocumentRoleMutationResult = ApolloReactHooks.useMutation.Result<SetWorkflowFileDocumentRoleMutation>;
export type SetWorkflowFileDocumentRoleMutationOptions = ApolloReactHooks.useMutation.Options<SetWorkflowFileDocumentRoleMutation, SetWorkflowFileDocumentRoleMutationVariables>;
export const UpdateWorkflowFileOrderDocument = gql`
    mutation UpdateWorkflowFileOrder($input: UpdateWorkflowFileOrderInput!) {
  updateWorkflowFileOrder(input: $input) {
    __typename
    id
    orderId
  }
}
    `;
export type UpdateWorkflowFileOrderMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowFileOrderMutation, UpdateWorkflowFileOrderMutationVariables>;

/**
 * __useUpdateWorkflowFileOrderMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowFileOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowFileOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowFileOrderMutation, { data, loading, error }] = useUpdateWorkflowFileOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowFileOrderMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowFileOrderMutation, UpdateWorkflowFileOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowFileOrderMutation, UpdateWorkflowFileOrderMutationVariables>(UpdateWorkflowFileOrderDocument, options);
      }
export type UpdateWorkflowFileOrderMutationHookResult = ReturnType<typeof useUpdateWorkflowFileOrderMutation>;
export type UpdateWorkflowFileOrderMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowFileOrderMutation>;
export type UpdateWorkflowFileOrderMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowFileOrderMutation, UpdateWorkflowFileOrderMutationVariables>;
export const SetWorkflowFileInternalDocument = gql`
    mutation SetWorkflowFileInternal($input: SetWorkflowFileInternalInput!) {
  setWorkflowFileInternal(input: $input) {
    __typename
    id
    isInternal
    document {
      __typename
      id
      isInternalOnWorkflow
    }
  }
}
    `;
export type SetWorkflowFileInternalMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetWorkflowFileInternalMutation, SetWorkflowFileInternalMutationVariables>;

/**
 * __useSetWorkflowFileInternalMutation__
 *
 * To run a mutation, you first call `useSetWorkflowFileInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkflowFileInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkflowFileInternalMutation, { data, loading, error }] = useSetWorkflowFileInternalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkflowFileInternalMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetWorkflowFileInternalMutation, SetWorkflowFileInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkflowFileInternalMutation, SetWorkflowFileInternalMutationVariables>(SetWorkflowFileInternalDocument, options);
      }
export type SetWorkflowFileInternalMutationHookResult = ReturnType<typeof useSetWorkflowFileInternalMutation>;
export type SetWorkflowFileInternalMutationResult = ApolloReactHooks.useMutation.Result<SetWorkflowFileInternalMutation>;
export type SetWorkflowFileInternalMutationOptions = ApolloReactHooks.useMutation.Options<SetWorkflowFileInternalMutation, SetWorkflowFileInternalMutationVariables>;
export const GetWorkflowFileExternalAccessDocument = gql`
    query GetWorkflowFileExternalAccess($workflowFileId: UUID!) {
  workflowFileExternalAccess(workflowFileId: $workflowFileId) {
    ...PermissionSimple
  }
}
    ${PermissionSimpleFragmentDoc}`;

/**
 * __useGetWorkflowFileExternalAccessQuery__
 *
 * To run a query within a React component, call `useGetWorkflowFileExternalAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowFileExternalAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowFileExternalAccessQuery({
 *   variables: {
 *      workflowFileId: // value for 'workflowFileId'
 *   },
 * });
 */
export function useGetWorkflowFileExternalAccessQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowFileExternalAccessQuery, GetWorkflowFileExternalAccessQueryVariables> & ({ variables: GetWorkflowFileExternalAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowFileExternalAccessQuery, GetWorkflowFileExternalAccessQueryVariables>(GetWorkflowFileExternalAccessDocument, options);
      }
export function useGetWorkflowFileExternalAccessLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowFileExternalAccessQuery, GetWorkflowFileExternalAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowFileExternalAccessQuery, GetWorkflowFileExternalAccessQueryVariables>(GetWorkflowFileExternalAccessDocument, options);
        }
export function useGetWorkflowFileExternalAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowFileExternalAccessQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowFileExternalAccessQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowFileExternalAccessQuery, GetWorkflowFileExternalAccessQueryVariables>(GetWorkflowFileExternalAccessDocument, options);
        }
export type GetWorkflowFileExternalAccessQueryHookResult = ReturnType<typeof useGetWorkflowFileExternalAccessQuery>;
export type GetWorkflowFileExternalAccessLazyQueryHookResult = ReturnType<typeof useGetWorkflowFileExternalAccessLazyQuery>;
export type GetWorkflowFileExternalAccessSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowFileExternalAccessSuspenseQuery>;
export type GetWorkflowFileExternalAccessQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowFileExternalAccessQuery, GetWorkflowFileExternalAccessQueryVariables>;
export const GetInsightPinsDocument = gql`
    query GetInsightPins($scope: InsightScope) {
  insightPins(scope: $scope) {
    id
    chartId
    sourceSystemPresetId
    sortOrder
    scope
    layout
    owner {
      avatarColor
      displayName
      id
    }
    view {
      id
      name
      showInSavedViews
      state
    }
  }
}
    `;

/**
 * __useGetInsightPinsQuery__
 *
 * To run a query within a React component, call `useGetInsightPinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightPinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightPinsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetInsightPinsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetInsightPinsQuery, GetInsightPinsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsightPinsQuery, GetInsightPinsQueryVariables>(GetInsightPinsDocument, options);
      }
export function useGetInsightPinsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetInsightPinsQuery, GetInsightPinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsightPinsQuery, GetInsightPinsQueryVariables>(GetInsightPinsDocument, options);
        }
export function useGetInsightPinsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetInsightPinsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetInsightPinsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetInsightPinsQuery, GetInsightPinsQueryVariables>(GetInsightPinsDocument, options);
        }
export type GetInsightPinsQueryHookResult = ReturnType<typeof useGetInsightPinsQuery>;
export type GetInsightPinsLazyQueryHookResult = ReturnType<typeof useGetInsightPinsLazyQuery>;
export type GetInsightPinsSuspenseQueryHookResult = ReturnType<typeof useGetInsightPinsSuspenseQuery>;
export type GetInsightPinsQueryResult = ApolloReactHooks.useQuery.Result<GetInsightPinsQuery, GetInsightPinsQueryVariables>;
export const GetWorkflowViewsDocument = gql`
    query GetWorkflowViews {
  workflowViews {
    id
    name
    showInSavedViews
    state
    updatedAt
  }
}
    `;

/**
 * __useGetWorkflowViewsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowViewsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetWorkflowViewsQuery, GetWorkflowViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowViewsQuery, GetWorkflowViewsQueryVariables>(GetWorkflowViewsDocument, options);
      }
export function useGetWorkflowViewsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowViewsQuery, GetWorkflowViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowViewsQuery, GetWorkflowViewsQueryVariables>(GetWorkflowViewsDocument, options);
        }
export function useGetWorkflowViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowViewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowViewsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowViewsQuery, GetWorkflowViewsQueryVariables>(GetWorkflowViewsDocument, options);
        }
export type GetWorkflowViewsQueryHookResult = ReturnType<typeof useGetWorkflowViewsQuery>;
export type GetWorkflowViewsLazyQueryHookResult = ReturnType<typeof useGetWorkflowViewsLazyQuery>;
export type GetWorkflowViewsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowViewsSuspenseQuery>;
export type GetWorkflowViewsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowViewsQuery, GetWorkflowViewsQueryVariables>;
export const GetWorkflowViewDocument = gql`
    query GetWorkflowView($id: UUID!) {
  workflowView(id: $id) {
    author {
      id
    }
    id
    name
    showInSavedViews
    state
    updatedAt
    pins {
      id
      chartId
      scope
    }
  }
}
    `;

/**
 * __useGetWorkflowViewQuery__
 *
 * To run a query within a React component, call `useGetWorkflowViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkflowViewQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowViewQuery, GetWorkflowViewQueryVariables> & ({ variables: GetWorkflowViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowViewQuery, GetWorkflowViewQueryVariables>(GetWorkflowViewDocument, options);
      }
export function useGetWorkflowViewLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowViewQuery, GetWorkflowViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowViewQuery, GetWorkflowViewQueryVariables>(GetWorkflowViewDocument, options);
        }
export function useGetWorkflowViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowViewQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowViewQuery, GetWorkflowViewQueryVariables>(GetWorkflowViewDocument, options);
        }
export type GetWorkflowViewQueryHookResult = ReturnType<typeof useGetWorkflowViewQuery>;
export type GetWorkflowViewLazyQueryHookResult = ReturnType<typeof useGetWorkflowViewLazyQuery>;
export type GetWorkflowViewSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowViewSuspenseQuery>;
export type GetWorkflowViewQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowViewQuery, GetWorkflowViewQueryVariables>;
export const GetWorkflowChartSeriesDocument = gql`
    query GetWorkflowChartSeries($input: WorkflowChartSeriesInput!) {
  workflowChartSeries(input: $input) {
    dimensions {
      id
      label
      data
      keys
    }
    values {
      id
      label
      data
      counts
    }
    primaryCatalog {
      id
      label
      tooltipLabel
      value
      count
    }
    secondaryCatalog {
      id
      label
      tooltipLabel
      value
      count
    }
    totals {
      data
      counts
    }
  }
}
    `;

/**
 * __useGetWorkflowChartSeriesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowChartSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowChartSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowChartSeriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkflowChartSeriesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowChartSeriesQuery, GetWorkflowChartSeriesQueryVariables> & ({ variables: GetWorkflowChartSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowChartSeriesQuery, GetWorkflowChartSeriesQueryVariables>(GetWorkflowChartSeriesDocument, options);
      }
export function useGetWorkflowChartSeriesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowChartSeriesQuery, GetWorkflowChartSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowChartSeriesQuery, GetWorkflowChartSeriesQueryVariables>(GetWorkflowChartSeriesDocument, options);
        }
export function useGetWorkflowChartSeriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowChartSeriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowChartSeriesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowChartSeriesQuery, GetWorkflowChartSeriesQueryVariables>(GetWorkflowChartSeriesDocument, options);
        }
export type GetWorkflowChartSeriesQueryHookResult = ReturnType<typeof useGetWorkflowChartSeriesQuery>;
export type GetWorkflowChartSeriesLazyQueryHookResult = ReturnType<typeof useGetWorkflowChartSeriesLazyQuery>;
export type GetWorkflowChartSeriesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowChartSeriesSuspenseQuery>;
export type GetWorkflowChartSeriesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowChartSeriesQuery, GetWorkflowChartSeriesQueryVariables>;
export const GetWorkflowInsightsDashboardDocument = gql`
    query GetWorkflowInsightsDashboard {
  workflowInsightsDashboard {
    hiddenSystemPresetIds
    org {
      id
      presetId
      pin {
        id
        chartId
        sourceSystemPresetId
        scope
        owner {
          avatarColor
          displayName
          id
        }
        view {
          id
          name
          state
        }
      }
      series {
        dimensions {
          id
          label
          data
          keys
        }
        values {
          id
          label
          data
          counts
        }
        primaryCatalog {
          id
          label
          tooltipLabel
          value
          count
        }
        secondaryCatalog {
          id
          label
          tooltipLabel
          value
          count
        }
        totals {
          data
          counts
        }
      }
    }
    personal {
      id
      presetId
      pin {
        id
        chartId
        sourceSystemPresetId
        scope
        owner {
          avatarColor
          displayName
          id
        }
        view {
          id
          name
          state
        }
      }
      series {
        dimensions {
          id
          label
          data
          keys
        }
        values {
          id
          label
          data
          counts
        }
        primaryCatalog {
          id
          label
          tooltipLabel
          value
          count
        }
        secondaryCatalog {
          id
          label
          tooltipLabel
          value
          count
        }
        totals {
          data
          counts
        }
      }
    }
  }
}
    `;

/**
 * __useGetWorkflowInsightsDashboardQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInsightsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInsightsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInsightsDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowInsightsDashboardQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetWorkflowInsightsDashboardQuery, GetWorkflowInsightsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowInsightsDashboardQuery, GetWorkflowInsightsDashboardQueryVariables>(GetWorkflowInsightsDashboardDocument, options);
      }
export function useGetWorkflowInsightsDashboardLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowInsightsDashboardQuery, GetWorkflowInsightsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowInsightsDashboardQuery, GetWorkflowInsightsDashboardQueryVariables>(GetWorkflowInsightsDashboardDocument, options);
        }
export function useGetWorkflowInsightsDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowInsightsDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowInsightsDashboardQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowInsightsDashboardQuery, GetWorkflowInsightsDashboardQueryVariables>(GetWorkflowInsightsDashboardDocument, options);
        }
export type GetWorkflowInsightsDashboardQueryHookResult = ReturnType<typeof useGetWorkflowInsightsDashboardQuery>;
export type GetWorkflowInsightsDashboardLazyQueryHookResult = ReturnType<typeof useGetWorkflowInsightsDashboardLazyQuery>;
export type GetWorkflowInsightsDashboardSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowInsightsDashboardSuspenseQuery>;
export type GetWorkflowInsightsDashboardQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowInsightsDashboardQuery, GetWorkflowInsightsDashboardQueryVariables>;
export const CreateWorkflowViewDocument = gql`
    mutation CreateWorkflowView($input: CreateWorkflowViewInput!) {
  createWorkflowView(input: $input) {
    workflowView {
      id
      name
      showInSavedViews
      state
      updatedAt
      pins {
        id
        chartId
        scope
      }
    }
  }
}
    `;
export type CreateWorkflowViewMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateWorkflowViewMutation, CreateWorkflowViewMutationVariables>;

/**
 * __useCreateWorkflowViewMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowViewMutation, { data, loading, error }] = useCreateWorkflowViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowViewMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateWorkflowViewMutation, CreateWorkflowViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkflowViewMutation, CreateWorkflowViewMutationVariables>(CreateWorkflowViewDocument, options);
      }
export type CreateWorkflowViewMutationHookResult = ReturnType<typeof useCreateWorkflowViewMutation>;
export type CreateWorkflowViewMutationResult = ApolloReactHooks.useMutation.Result<CreateWorkflowViewMutation>;
export type CreateWorkflowViewMutationOptions = ApolloReactHooks.useMutation.Options<CreateWorkflowViewMutation, CreateWorkflowViewMutationVariables>;
export const MaterializeSystemInsightChartDocument = gql`
    mutation MaterializeSystemInsightChart($presetId: String!) {
  materializeSystemInsightChart(presetId: $presetId) {
    insightPin {
      id
      chartId
      sourceSystemPresetId
      scope
      view {
        id
      }
    }
  }
}
    `;
export type MaterializeSystemInsightChartMutationFn = ApolloReactHooks.useMutation.MutationFunction<MaterializeSystemInsightChartMutation, MaterializeSystemInsightChartMutationVariables>;

/**
 * __useMaterializeSystemInsightChartMutation__
 *
 * To run a mutation, you first call `useMaterializeSystemInsightChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaterializeSystemInsightChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [materializeSystemInsightChartMutation, { data, loading, error }] = useMaterializeSystemInsightChartMutation({
 *   variables: {
 *      presetId: // value for 'presetId'
 *   },
 * });
 */
export function useMaterializeSystemInsightChartMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MaterializeSystemInsightChartMutation, MaterializeSystemInsightChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MaterializeSystemInsightChartMutation, MaterializeSystemInsightChartMutationVariables>(MaterializeSystemInsightChartDocument, options);
      }
export type MaterializeSystemInsightChartMutationHookResult = ReturnType<typeof useMaterializeSystemInsightChartMutation>;
export type MaterializeSystemInsightChartMutationResult = ApolloReactHooks.useMutation.Result<MaterializeSystemInsightChartMutation>;
export type MaterializeSystemInsightChartMutationOptions = ApolloReactHooks.useMutation.Options<MaterializeSystemInsightChartMutation, MaterializeSystemInsightChartMutationVariables>;
export const UpdateWorkflowViewDocument = gql`
    mutation UpdateWorkflowView($input: UpdateWorkflowViewInput!) {
  updateWorkflowView(input: $input) {
    workflowView {
      id
      name
      showInSavedViews
      state
      updatedAt
    }
  }
}
    `;
export type UpdateWorkflowViewMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowViewMutation, UpdateWorkflowViewMutationVariables>;

/**
 * __useUpdateWorkflowViewMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowViewMutation, { data, loading, error }] = useUpdateWorkflowViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowViewMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowViewMutation, UpdateWorkflowViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowViewMutation, UpdateWorkflowViewMutationVariables>(UpdateWorkflowViewDocument, options);
      }
export type UpdateWorkflowViewMutationHookResult = ReturnType<typeof useUpdateWorkflowViewMutation>;
export type UpdateWorkflowViewMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowViewMutation>;
export type UpdateWorkflowViewMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowViewMutation, UpdateWorkflowViewMutationVariables>;
export const AddWorkflowViewChartDocument = gql`
    mutation AddWorkflowViewChart($input: AddWorkflowViewChartInput!) {
  addWorkflowViewChart(input: $input) {
    workflowView {
      id
      name
      state
      updatedAt
      pins {
        id
        chartId
        scope
      }
    }
  }
}
    `;
export type AddWorkflowViewChartMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddWorkflowViewChartMutation, AddWorkflowViewChartMutationVariables>;

/**
 * __useAddWorkflowViewChartMutation__
 *
 * To run a mutation, you first call `useAddWorkflowViewChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkflowViewChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkflowViewChartMutation, { data, loading, error }] = useAddWorkflowViewChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWorkflowViewChartMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddWorkflowViewChartMutation, AddWorkflowViewChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddWorkflowViewChartMutation, AddWorkflowViewChartMutationVariables>(AddWorkflowViewChartDocument, options);
      }
export type AddWorkflowViewChartMutationHookResult = ReturnType<typeof useAddWorkflowViewChartMutation>;
export type AddWorkflowViewChartMutationResult = ApolloReactHooks.useMutation.Result<AddWorkflowViewChartMutation>;
export type AddWorkflowViewChartMutationOptions = ApolloReactHooks.useMutation.Options<AddWorkflowViewChartMutation, AddWorkflowViewChartMutationVariables>;
export const DeleteWorkflowViewChartDocument = gql`
    mutation DeleteWorkflowViewChart($input: DeleteWorkflowViewChartInput!) {
  deleteWorkflowViewChart(input: $input) {
    workflowView {
      id
      name
      state
      updatedAt
      pins {
        id
        chartId
        scope
      }
    }
  }
}
    `;
export type DeleteWorkflowViewChartMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteWorkflowViewChartMutation, DeleteWorkflowViewChartMutationVariables>;

/**
 * __useDeleteWorkflowViewChartMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowViewChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowViewChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowViewChartMutation, { data, loading, error }] = useDeleteWorkflowViewChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkflowViewChartMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteWorkflowViewChartMutation, DeleteWorkflowViewChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkflowViewChartMutation, DeleteWorkflowViewChartMutationVariables>(DeleteWorkflowViewChartDocument, options);
      }
export type DeleteWorkflowViewChartMutationHookResult = ReturnType<typeof useDeleteWorkflowViewChartMutation>;
export type DeleteWorkflowViewChartMutationResult = ApolloReactHooks.useMutation.Result<DeleteWorkflowViewChartMutation>;
export type DeleteWorkflowViewChartMutationOptions = ApolloReactHooks.useMutation.Options<DeleteWorkflowViewChartMutation, DeleteWorkflowViewChartMutationVariables>;
export const CreateInsightPinDocument = gql`
    mutation CreateInsightPin($input: CreateInsightPinInput!) {
  createInsightPin(input: $input) {
    insightPin {
      id
      chartId
      scope
      sortOrder
      layout
      view {
        id
        name
      }
    }
  }
}
    `;
export type CreateInsightPinMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateInsightPinMutation, CreateInsightPinMutationVariables>;

/**
 * __useCreateInsightPinMutation__
 *
 * To run a mutation, you first call `useCreateInsightPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightPinMutation, { data, loading, error }] = useCreateInsightPinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInsightPinMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateInsightPinMutation, CreateInsightPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInsightPinMutation, CreateInsightPinMutationVariables>(CreateInsightPinDocument, options);
      }
export type CreateInsightPinMutationHookResult = ReturnType<typeof useCreateInsightPinMutation>;
export type CreateInsightPinMutationResult = ApolloReactHooks.useMutation.Result<CreateInsightPinMutation>;
export type CreateInsightPinMutationOptions = ApolloReactHooks.useMutation.Options<CreateInsightPinMutation, CreateInsightPinMutationVariables>;
export const UpdateInsightPinDocument = gql`
    mutation UpdateInsightPin($input: UpdateInsightPinInput!) {
  updateInsightPin(input: $input) {
    insightPin {
      id
      chartId
      scope
      sortOrder
      layout
      view {
        id
        name
      }
    }
  }
}
    `;
export type UpdateInsightPinMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateInsightPinMutation, UpdateInsightPinMutationVariables>;

/**
 * __useUpdateInsightPinMutation__
 *
 * To run a mutation, you first call `useUpdateInsightPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightPinMutation, { data, loading, error }] = useUpdateInsightPinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInsightPinMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateInsightPinMutation, UpdateInsightPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateInsightPinMutation, UpdateInsightPinMutationVariables>(UpdateInsightPinDocument, options);
      }
export type UpdateInsightPinMutationHookResult = ReturnType<typeof useUpdateInsightPinMutation>;
export type UpdateInsightPinMutationResult = ApolloReactHooks.useMutation.Result<UpdateInsightPinMutation>;
export type UpdateInsightPinMutationOptions = ApolloReactHooks.useMutation.Options<UpdateInsightPinMutation, UpdateInsightPinMutationVariables>;
export const PublishInsightPinToOrgDocument = gql`
    mutation PublishInsightPinToOrg($id: UUID!) {
  publishInsightPinToOrg(id: $id) {
    insightPin {
      id
      chartId
      scope
      sortOrder
      layout
      view {
        id
        name
      }
    }
  }
}
    `;
export type PublishInsightPinToOrgMutationFn = ApolloReactHooks.useMutation.MutationFunction<PublishInsightPinToOrgMutation, PublishInsightPinToOrgMutationVariables>;

/**
 * __usePublishInsightPinToOrgMutation__
 *
 * To run a mutation, you first call `usePublishInsightPinToOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishInsightPinToOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishInsightPinToOrgMutation, { data, loading, error }] = usePublishInsightPinToOrgMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishInsightPinToOrgMutation(baseOptions?: ApolloReactHooks.useMutation.Options<PublishInsightPinToOrgMutation, PublishInsightPinToOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishInsightPinToOrgMutation, PublishInsightPinToOrgMutationVariables>(PublishInsightPinToOrgDocument, options);
      }
export type PublishInsightPinToOrgMutationHookResult = ReturnType<typeof usePublishInsightPinToOrgMutation>;
export type PublishInsightPinToOrgMutationResult = ApolloReactHooks.useMutation.Result<PublishInsightPinToOrgMutation>;
export type PublishInsightPinToOrgMutationOptions = ApolloReactHooks.useMutation.Options<PublishInsightPinToOrgMutation, PublishInsightPinToOrgMutationVariables>;
export const DeleteInsightPinDocument = gql`
    mutation DeleteInsightPin($id: UUID!) {
  deleteInsightPin(id: $id) {
    id
  }
}
    `;
export type DeleteInsightPinMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteInsightPinMutation, DeleteInsightPinMutationVariables>;

/**
 * __useDeleteInsightPinMutation__
 *
 * To run a mutation, you first call `useDeleteInsightPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightPinMutation, { data, loading, error }] = useDeleteInsightPinMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsightPinMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteInsightPinMutation, DeleteInsightPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteInsightPinMutation, DeleteInsightPinMutationVariables>(DeleteInsightPinDocument, options);
      }
export type DeleteInsightPinMutationHookResult = ReturnType<typeof useDeleteInsightPinMutation>;
export type DeleteInsightPinMutationResult = ApolloReactHooks.useMutation.Result<DeleteInsightPinMutation>;
export type DeleteInsightPinMutationOptions = ApolloReactHooks.useMutation.Options<DeleteInsightPinMutation, DeleteInsightPinMutationVariables>;
export const DeleteWorkflowViewDocument = gql`
    mutation DeleteWorkflowView($id: UUID!) {
  deleteWorkflowView(id: $id) {
    id
  }
}
    `;
export type DeleteWorkflowViewMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteWorkflowViewMutation, DeleteWorkflowViewMutationVariables>;

/**
 * __useDeleteWorkflowViewMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowViewMutation, { data, loading, error }] = useDeleteWorkflowViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkflowViewMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteWorkflowViewMutation, DeleteWorkflowViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkflowViewMutation, DeleteWorkflowViewMutationVariables>(DeleteWorkflowViewDocument, options);
      }
export type DeleteWorkflowViewMutationHookResult = ReturnType<typeof useDeleteWorkflowViewMutation>;
export type DeleteWorkflowViewMutationResult = ApolloReactHooks.useMutation.Result<DeleteWorkflowViewMutation>;
export type DeleteWorkflowViewMutationOptions = ApolloReactHooks.useMutation.Options<DeleteWorkflowViewMutation, DeleteWorkflowViewMutationVariables>;
export const SetSystemInsightChartHiddenDocument = gql`
    mutation SetSystemInsightChartHidden($presetId: String!, $hidden: Boolean!) {
  setSystemInsightChartHidden(presetId: $presetId, hidden: $hidden)
}
    `;
export type SetSystemInsightChartHiddenMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetSystemInsightChartHiddenMutation, SetSystemInsightChartHiddenMutationVariables>;

/**
 * __useSetSystemInsightChartHiddenMutation__
 *
 * To run a mutation, you first call `useSetSystemInsightChartHiddenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSystemInsightChartHiddenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSystemInsightChartHiddenMutation, { data, loading, error }] = useSetSystemInsightChartHiddenMutation({
 *   variables: {
 *      presetId: // value for 'presetId'
 *      hidden: // value for 'hidden'
 *   },
 * });
 */
export function useSetSystemInsightChartHiddenMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetSystemInsightChartHiddenMutation, SetSystemInsightChartHiddenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetSystemInsightChartHiddenMutation, SetSystemInsightChartHiddenMutationVariables>(SetSystemInsightChartHiddenDocument, options);
      }
export type SetSystemInsightChartHiddenMutationHookResult = ReturnType<typeof useSetSystemInsightChartHiddenMutation>;
export type SetSystemInsightChartHiddenMutationResult = ApolloReactHooks.useMutation.Result<SetSystemInsightChartHiddenMutation>;
export type SetSystemInsightChartHiddenMutationOptions = ApolloReactHooks.useMutation.Options<SetSystemInsightChartHiddenMutation, SetSystemInsightChartHiddenMutationVariables>;
export const GetWorkflowIntakeFieldsDocument = gql`
    query GetWorkflowIntakeFields($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    intakeFields {
      __typename
      fieldId
      label
      question
      type
      required
      order
      picklistOptions {
        __typename
        label
        value
      }
      usedInDocuments
    }
    files {
      __typename
      document {
        __typename
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetWorkflowIntakeFieldsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowIntakeFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowIntakeFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowIntakeFieldsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowIntakeFieldsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowIntakeFieldsQuery, GetWorkflowIntakeFieldsQueryVariables> & ({ variables: GetWorkflowIntakeFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowIntakeFieldsQuery, GetWorkflowIntakeFieldsQueryVariables>(GetWorkflowIntakeFieldsDocument, options);
      }
export function useGetWorkflowIntakeFieldsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowIntakeFieldsQuery, GetWorkflowIntakeFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowIntakeFieldsQuery, GetWorkflowIntakeFieldsQueryVariables>(GetWorkflowIntakeFieldsDocument, options);
        }
export function useGetWorkflowIntakeFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowIntakeFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowIntakeFieldsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowIntakeFieldsQuery, GetWorkflowIntakeFieldsQueryVariables>(GetWorkflowIntakeFieldsDocument, options);
        }
export type GetWorkflowIntakeFieldsQueryHookResult = ReturnType<typeof useGetWorkflowIntakeFieldsQuery>;
export type GetWorkflowIntakeFieldsLazyQueryHookResult = ReturnType<typeof useGetWorkflowIntakeFieldsLazyQuery>;
export type GetWorkflowIntakeFieldsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowIntakeFieldsSuspenseQuery>;
export type GetWorkflowIntakeFieldsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowIntakeFieldsQuery, GetWorkflowIntakeFieldsQueryVariables>;
export const GetWorkflowLaunchConfigDocument = gql`
    query GetWorkflowLaunchConfig($launchConfigId: UUID!) {
  workflowLaunchConfig(launchConfigId: $launchConfigId) {
    ...LaunchConfigSimple
  }
}
    ${LaunchConfigSimpleFragmentDoc}`;

/**
 * __useGetWorkflowLaunchConfigQuery__
 *
 * To run a query within a React component, call `useGetWorkflowLaunchConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowLaunchConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowLaunchConfigQuery({
 *   variables: {
 *      launchConfigId: // value for 'launchConfigId'
 *   },
 * });
 */
export function useGetWorkflowLaunchConfigQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowLaunchConfigQuery, GetWorkflowLaunchConfigQueryVariables> & ({ variables: GetWorkflowLaunchConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowLaunchConfigQuery, GetWorkflowLaunchConfigQueryVariables>(GetWorkflowLaunchConfigDocument, options);
      }
export function useGetWorkflowLaunchConfigLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowLaunchConfigQuery, GetWorkflowLaunchConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowLaunchConfigQuery, GetWorkflowLaunchConfigQueryVariables>(GetWorkflowLaunchConfigDocument, options);
        }
export function useGetWorkflowLaunchConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowLaunchConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowLaunchConfigQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowLaunchConfigQuery, GetWorkflowLaunchConfigQueryVariables>(GetWorkflowLaunchConfigDocument, options);
        }
export type GetWorkflowLaunchConfigQueryHookResult = ReturnType<typeof useGetWorkflowLaunchConfigQuery>;
export type GetWorkflowLaunchConfigLazyQueryHookResult = ReturnType<typeof useGetWorkflowLaunchConfigLazyQuery>;
export type GetWorkflowLaunchConfigSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowLaunchConfigSuspenseQuery>;
export type GetWorkflowLaunchConfigQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowLaunchConfigQuery, GetWorkflowLaunchConfigQueryVariables>;
export const GetLaunchConfigWorkflowDocument = gql`
    query GetLaunchConfigWorkflow($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    name
    variant
    permissions {
      ...WorkflowPermissionSimple
    }
    launchConfig {
      ...LaunchConfigSimple
    }
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}
${LaunchConfigSimpleFragmentDoc}`;

/**
 * __useGetLaunchConfigWorkflowQuery__
 *
 * To run a query within a React component, call `useGetLaunchConfigWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaunchConfigWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaunchConfigWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetLaunchConfigWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetLaunchConfigWorkflowQuery, GetLaunchConfigWorkflowQueryVariables> & ({ variables: GetLaunchConfigWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLaunchConfigWorkflowQuery, GetLaunchConfigWorkflowQueryVariables>(GetLaunchConfigWorkflowDocument, options);
      }
export function useGetLaunchConfigWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetLaunchConfigWorkflowQuery, GetLaunchConfigWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLaunchConfigWorkflowQuery, GetLaunchConfigWorkflowQueryVariables>(GetLaunchConfigWorkflowDocument, options);
        }
export function useGetLaunchConfigWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetLaunchConfigWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetLaunchConfigWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetLaunchConfigWorkflowQuery, GetLaunchConfigWorkflowQueryVariables>(GetLaunchConfigWorkflowDocument, options);
        }
export type GetLaunchConfigWorkflowQueryHookResult = ReturnType<typeof useGetLaunchConfigWorkflowQuery>;
export type GetLaunchConfigWorkflowLazyQueryHookResult = ReturnType<typeof useGetLaunchConfigWorkflowLazyQuery>;
export type GetLaunchConfigWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetLaunchConfigWorkflowSuspenseQuery>;
export type GetLaunchConfigWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetLaunchConfigWorkflowQuery, GetLaunchConfigWorkflowQueryVariables>;
export const CreateWorkflowLaunchConfigDocument = gql`
    mutation CreateWorkflowLaunchConfig($workflowId: UUID!) {
  createWorkflowLaunchConfig(workflowId: $workflowId) {
    workflow {
      __typename
      id
      launchConfig {
        ...LaunchConfigSimple
      }
    }
  }
}
    ${LaunchConfigSimpleFragmentDoc}`;
export type CreateWorkflowLaunchConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateWorkflowLaunchConfigMutation, CreateWorkflowLaunchConfigMutationVariables>;

/**
 * __useCreateWorkflowLaunchConfigMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowLaunchConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowLaunchConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowLaunchConfigMutation, { data, loading, error }] = useCreateWorkflowLaunchConfigMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useCreateWorkflowLaunchConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateWorkflowLaunchConfigMutation, CreateWorkflowLaunchConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkflowLaunchConfigMutation, CreateWorkflowLaunchConfigMutationVariables>(CreateWorkflowLaunchConfigDocument, options);
      }
export type CreateWorkflowLaunchConfigMutationHookResult = ReturnType<typeof useCreateWorkflowLaunchConfigMutation>;
export type CreateWorkflowLaunchConfigMutationResult = ApolloReactHooks.useMutation.Result<CreateWorkflowLaunchConfigMutation>;
export type CreateWorkflowLaunchConfigMutationOptions = ApolloReactHooks.useMutation.Options<CreateWorkflowLaunchConfigMutation, CreateWorkflowLaunchConfigMutationVariables>;
export const UpdateWorkflowLaunchConfigDocument = gql`
    mutation UpdateWorkflowLaunchConfig($input: UpdateWorkflowLaunchConfigInput!) {
  updateWorkflowLaunchConfig(input: $input) {
    ...LaunchConfigSimple
  }
}
    ${LaunchConfigSimpleFragmentDoc}`;
export type UpdateWorkflowLaunchConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowLaunchConfigMutation, UpdateWorkflowLaunchConfigMutationVariables>;

/**
 * __useUpdateWorkflowLaunchConfigMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowLaunchConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowLaunchConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowLaunchConfigMutation, { data, loading, error }] = useUpdateWorkflowLaunchConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowLaunchConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowLaunchConfigMutation, UpdateWorkflowLaunchConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowLaunchConfigMutation, UpdateWorkflowLaunchConfigMutationVariables>(UpdateWorkflowLaunchConfigDocument, options);
      }
export type UpdateWorkflowLaunchConfigMutationHookResult = ReturnType<typeof useUpdateWorkflowLaunchConfigMutation>;
export type UpdateWorkflowLaunchConfigMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowLaunchConfigMutation>;
export type UpdateWorkflowLaunchConfigMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowLaunchConfigMutation, UpdateWorkflowLaunchConfigMutationVariables>;
export const DeleteWorkflowLaunchConfigDocument = gql`
    mutation DeleteWorkflowLaunchConfig($launchConfigId: UUID!) {
  deleteWorkflowLaunchConfig(launchConfigId: $launchConfigId)
}
    `;
export type DeleteWorkflowLaunchConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteWorkflowLaunchConfigMutation, DeleteWorkflowLaunchConfigMutationVariables>;

/**
 * __useDeleteWorkflowLaunchConfigMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowLaunchConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowLaunchConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowLaunchConfigMutation, { data, loading, error }] = useDeleteWorkflowLaunchConfigMutation({
 *   variables: {
 *      launchConfigId: // value for 'launchConfigId'
 *   },
 * });
 */
export function useDeleteWorkflowLaunchConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteWorkflowLaunchConfigMutation, DeleteWorkflowLaunchConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkflowLaunchConfigMutation, DeleteWorkflowLaunchConfigMutationVariables>(DeleteWorkflowLaunchConfigDocument, options);
      }
export type DeleteWorkflowLaunchConfigMutationHookResult = ReturnType<typeof useDeleteWorkflowLaunchConfigMutation>;
export type DeleteWorkflowLaunchConfigMutationResult = ApolloReactHooks.useMutation.Result<DeleteWorkflowLaunchConfigMutation>;
export type DeleteWorkflowLaunchConfigMutationOptions = ApolloReactHooks.useMutation.Options<DeleteWorkflowLaunchConfigMutation, DeleteWorkflowLaunchConfigMutationVariables>;
export const LaunchWorkflowViaConfigDocument = gql`
    mutation LaunchWorkflowViaConfig($input: LaunchWorkflowViaConfigInput!) {
  launchWorkflowViaConfig(input: $input) {
    workflow {
      __typename
      id
      state
      envelope {
        __typename
        id
      }
      activeStep {
        ...WorkflowStepFragment
      }
      files {
        ...WorkflowFileSimple
      }
      permissions {
        ...WorkflowPermissionSimple
      }
    }
  }
}
    ${WorkflowStepFragmentFragmentDoc}
${WorkflowFileSimpleFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}`;
export type LaunchWorkflowViaConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<LaunchWorkflowViaConfigMutation, LaunchWorkflowViaConfigMutationVariables>;

/**
 * __useLaunchWorkflowViaConfigMutation__
 *
 * To run a mutation, you first call `useLaunchWorkflowViaConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchWorkflowViaConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchWorkflowViaConfigMutation, { data, loading, error }] = useLaunchWorkflowViaConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchWorkflowViaConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<LaunchWorkflowViaConfigMutation, LaunchWorkflowViaConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LaunchWorkflowViaConfigMutation, LaunchWorkflowViaConfigMutationVariables>(LaunchWorkflowViaConfigDocument, options);
      }
export type LaunchWorkflowViaConfigMutationHookResult = ReturnType<typeof useLaunchWorkflowViaConfigMutation>;
export type LaunchWorkflowViaConfigMutationResult = ApolloReactHooks.useMutation.Result<LaunchWorkflowViaConfigMutation>;
export type LaunchWorkflowViaConfigMutationOptions = ApolloReactHooks.useMutation.Options<LaunchWorkflowViaConfigMutation, LaunchWorkflowViaConfigMutationVariables>;
export const CreateFilesViaLaunchConfigDocument = gql`
    mutation CreateFilesViaLaunchConfig($input: CreateFilesViaLaunchConfigInput!) {
  createFilesViaLaunchConfig(input: $input) {
    documentId
    name
  }
}
    `;
export type CreateFilesViaLaunchConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateFilesViaLaunchConfigMutation, CreateFilesViaLaunchConfigMutationVariables>;

/**
 * __useCreateFilesViaLaunchConfigMutation__
 *
 * To run a mutation, you first call `useCreateFilesViaLaunchConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFilesViaLaunchConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFilesViaLaunchConfigMutation, { data, loading, error }] = useCreateFilesViaLaunchConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFilesViaLaunchConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateFilesViaLaunchConfigMutation, CreateFilesViaLaunchConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFilesViaLaunchConfigMutation, CreateFilesViaLaunchConfigMutationVariables>(CreateFilesViaLaunchConfigDocument, options);
      }
export type CreateFilesViaLaunchConfigMutationHookResult = ReturnType<typeof useCreateFilesViaLaunchConfigMutation>;
export type CreateFilesViaLaunchConfigMutationResult = ApolloReactHooks.useMutation.Result<CreateFilesViaLaunchConfigMutation>;
export type CreateFilesViaLaunchConfigMutationOptions = ApolloReactHooks.useMutation.Options<CreateFilesViaLaunchConfigMutation, CreateFilesViaLaunchConfigMutationVariables>;
export const DeleteFilesViaLaunchConfigDocument = gql`
    mutation DeleteFilesViaLaunchConfig($input: DeleteFilesViaLaunchConfigInput!) {
  deleteFilesViaLaunchConfig(input: $input)
}
    `;
export type DeleteFilesViaLaunchConfigMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteFilesViaLaunchConfigMutation, DeleteFilesViaLaunchConfigMutationVariables>;

/**
 * __useDeleteFilesViaLaunchConfigMutation__
 *
 * To run a mutation, you first call `useDeleteFilesViaLaunchConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesViaLaunchConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesViaLaunchConfigMutation, { data, loading, error }] = useDeleteFilesViaLaunchConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFilesViaLaunchConfigMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteFilesViaLaunchConfigMutation, DeleteFilesViaLaunchConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFilesViaLaunchConfigMutation, DeleteFilesViaLaunchConfigMutationVariables>(DeleteFilesViaLaunchConfigDocument, options);
      }
export type DeleteFilesViaLaunchConfigMutationHookResult = ReturnType<typeof useDeleteFilesViaLaunchConfigMutation>;
export type DeleteFilesViaLaunchConfigMutationResult = ApolloReactHooks.useMutation.Result<DeleteFilesViaLaunchConfigMutation>;
export type DeleteFilesViaLaunchConfigMutationOptions = ApolloReactHooks.useMutation.Options<DeleteFilesViaLaunchConfigMutation, DeleteFilesViaLaunchConfigMutationVariables>;
export const GetUploadSecurityViaLaunchConfigDocument = gql`
    query GetUploadSecurityViaLaunchConfig($launchConfigId: UUID!) {
  uploadSecurityViaLaunchConfig(launchConfigId: $launchConfigId) {
    ...FilestackUploadOptionsBase
  }
}
    ${FilestackUploadOptionsBaseFragmentDoc}`;

/**
 * __useGetUploadSecurityViaLaunchConfigQuery__
 *
 * To run a query within a React component, call `useGetUploadSecurityViaLaunchConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSecurityViaLaunchConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSecurityViaLaunchConfigQuery({
 *   variables: {
 *      launchConfigId: // value for 'launchConfigId'
 *   },
 * });
 */
export function useGetUploadSecurityViaLaunchConfigQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetUploadSecurityViaLaunchConfigQuery, GetUploadSecurityViaLaunchConfigQueryVariables> & ({ variables: GetUploadSecurityViaLaunchConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadSecurityViaLaunchConfigQuery, GetUploadSecurityViaLaunchConfigQueryVariables>(GetUploadSecurityViaLaunchConfigDocument, options);
      }
export function useGetUploadSecurityViaLaunchConfigLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUploadSecurityViaLaunchConfigQuery, GetUploadSecurityViaLaunchConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadSecurityViaLaunchConfigQuery, GetUploadSecurityViaLaunchConfigQueryVariables>(GetUploadSecurityViaLaunchConfigDocument, options);
        }
export function useGetUploadSecurityViaLaunchConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUploadSecurityViaLaunchConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUploadSecurityViaLaunchConfigQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUploadSecurityViaLaunchConfigQuery, GetUploadSecurityViaLaunchConfigQueryVariables>(GetUploadSecurityViaLaunchConfigDocument, options);
        }
export type GetUploadSecurityViaLaunchConfigQueryHookResult = ReturnType<typeof useGetUploadSecurityViaLaunchConfigQuery>;
export type GetUploadSecurityViaLaunchConfigLazyQueryHookResult = ReturnType<typeof useGetUploadSecurityViaLaunchConfigLazyQuery>;
export type GetUploadSecurityViaLaunchConfigSuspenseQueryHookResult = ReturnType<typeof useGetUploadSecurityViaLaunchConfigSuspenseQuery>;
export type GetUploadSecurityViaLaunchConfigQueryResult = ApolloReactHooks.useQuery.Result<GetUploadSecurityViaLaunchConfigQuery, GetUploadSecurityViaLaunchConfigQueryVariables>;
export const GetWorkflowPermissionDocument = gql`
    query GetWorkflowPermission($workflowPermissionId: UUID!) {
  workflowPermission(id: $workflowPermissionId) {
    ...WorkflowPermissionSimple
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetWorkflowPermissionQuery__
 *
 * To run a query within a React component, call `useGetWorkflowPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowPermissionQuery({
 *   variables: {
 *      workflowPermissionId: // value for 'workflowPermissionId'
 *   },
 * });
 */
export function useGetWorkflowPermissionQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowPermissionQuery, GetWorkflowPermissionQueryVariables> & ({ variables: GetWorkflowPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowPermissionQuery, GetWorkflowPermissionQueryVariables>(GetWorkflowPermissionDocument, options);
      }
export function useGetWorkflowPermissionLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowPermissionQuery, GetWorkflowPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowPermissionQuery, GetWorkflowPermissionQueryVariables>(GetWorkflowPermissionDocument, options);
        }
export function useGetWorkflowPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPermissionQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowPermissionQuery, GetWorkflowPermissionQueryVariables>(GetWorkflowPermissionDocument, options);
        }
export type GetWorkflowPermissionQueryHookResult = ReturnType<typeof useGetWorkflowPermissionQuery>;
export type GetWorkflowPermissionLazyQueryHookResult = ReturnType<typeof useGetWorkflowPermissionLazyQuery>;
export type GetWorkflowPermissionSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowPermissionSuspenseQuery>;
export type GetWorkflowPermissionQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowPermissionQuery, GetWorkflowPermissionQueryVariables>;
export const GetWorkflowPermissionsDocument = gql`
    query GetWorkflowPermissions($workflowId: UUID!) {
  permissions(workflowId: $workflowId) {
    ...WorkflowPermissionSimple
    actions {
      ... on WorkflowRecipient {
        __typename
        id
      }
      ... on Task {
        __typename
        id
      }
    }
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetWorkflowPermissionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowPermissionsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowPermissionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowPermissionsQuery, GetWorkflowPermissionsQueryVariables> & ({ variables: GetWorkflowPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowPermissionsQuery, GetWorkflowPermissionsQueryVariables>(GetWorkflowPermissionsDocument, options);
      }
export function useGetWorkflowPermissionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowPermissionsQuery, GetWorkflowPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowPermissionsQuery, GetWorkflowPermissionsQueryVariables>(GetWorkflowPermissionsDocument, options);
        }
export function useGetWorkflowPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPermissionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowPermissionsQuery, GetWorkflowPermissionsQueryVariables>(GetWorkflowPermissionsDocument, options);
        }
export type GetWorkflowPermissionsQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsQuery>;
export type GetWorkflowPermissionsLazyQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsLazyQuery>;
export type GetWorkflowPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsSuspenseQuery>;
export type GetWorkflowPermissionsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowPermissionsQuery, GetWorkflowPermissionsQueryVariables>;
export const GetActiveWorkflowPermissionsDocument = gql`
    query GetActiveWorkflowPermissions($workflowId: UUID!) {
  activePermissions(workflowId: $workflowId) {
    ...WorkflowPermissionSimple
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetActiveWorkflowPermissionsQuery__
 *
 * To run a query within a React component, call `useGetActiveWorkflowPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveWorkflowPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveWorkflowPermissionsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetActiveWorkflowPermissionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetActiveWorkflowPermissionsQuery, GetActiveWorkflowPermissionsQueryVariables> & ({ variables: GetActiveWorkflowPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActiveWorkflowPermissionsQuery, GetActiveWorkflowPermissionsQueryVariables>(GetActiveWorkflowPermissionsDocument, options);
      }
export function useGetActiveWorkflowPermissionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetActiveWorkflowPermissionsQuery, GetActiveWorkflowPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActiveWorkflowPermissionsQuery, GetActiveWorkflowPermissionsQueryVariables>(GetActiveWorkflowPermissionsDocument, options);
        }
export function useGetActiveWorkflowPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetActiveWorkflowPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetActiveWorkflowPermissionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetActiveWorkflowPermissionsQuery, GetActiveWorkflowPermissionsQueryVariables>(GetActiveWorkflowPermissionsDocument, options);
        }
export type GetActiveWorkflowPermissionsQueryHookResult = ReturnType<typeof useGetActiveWorkflowPermissionsQuery>;
export type GetActiveWorkflowPermissionsLazyQueryHookResult = ReturnType<typeof useGetActiveWorkflowPermissionsLazyQuery>;
export type GetActiveWorkflowPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetActiveWorkflowPermissionsSuspenseQuery>;
export type GetActiveWorkflowPermissionsQueryResult = ApolloReactHooks.useQuery.Result<GetActiveWorkflowPermissionsQuery, GetActiveWorkflowPermissionsQueryVariables>;
export const GetQueuedWorkflowPermissionsDocument = gql`
    query GetQueuedWorkflowPermissions($workflowId: UUID!) {
  queuedPermissions(workflowId: $workflowId) {
    ...WorkflowPermissionSimple
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetQueuedWorkflowPermissionsQuery__
 *
 * To run a query within a React component, call `useGetQueuedWorkflowPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueuedWorkflowPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueuedWorkflowPermissionsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetQueuedWorkflowPermissionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetQueuedWorkflowPermissionsQuery, GetQueuedWorkflowPermissionsQueryVariables> & ({ variables: GetQueuedWorkflowPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQueuedWorkflowPermissionsQuery, GetQueuedWorkflowPermissionsQueryVariables>(GetQueuedWorkflowPermissionsDocument, options);
      }
export function useGetQueuedWorkflowPermissionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetQueuedWorkflowPermissionsQuery, GetQueuedWorkflowPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQueuedWorkflowPermissionsQuery, GetQueuedWorkflowPermissionsQueryVariables>(GetQueuedWorkflowPermissionsDocument, options);
        }
export function useGetQueuedWorkflowPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetQueuedWorkflowPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetQueuedWorkflowPermissionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetQueuedWorkflowPermissionsQuery, GetQueuedWorkflowPermissionsQueryVariables>(GetQueuedWorkflowPermissionsDocument, options);
        }
export type GetQueuedWorkflowPermissionsQueryHookResult = ReturnType<typeof useGetQueuedWorkflowPermissionsQuery>;
export type GetQueuedWorkflowPermissionsLazyQueryHookResult = ReturnType<typeof useGetQueuedWorkflowPermissionsLazyQuery>;
export type GetQueuedWorkflowPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetQueuedWorkflowPermissionsSuspenseQuery>;
export type GetQueuedWorkflowPermissionsQueryResult = ApolloReactHooks.useQuery.Result<GetQueuedWorkflowPermissionsQuery, GetQueuedWorkflowPermissionsQueryVariables>;
export const GetWorkflowPermissionsForWorkflowDocument = gql`
    query GetWorkflowPermissionsForWorkflow($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    status
    variant
    owner {
      ...UserBase
    }
    permissions {
      ...WorkflowPermissionSimple
      actions {
        ... on WorkflowRecipient {
          __typename
          id
          type
        }
        ... on Task {
          __typename
          id
        }
      }
    }
  }
}
    ${UserBaseFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetWorkflowPermissionsForWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWorkflowPermissionsForWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowPermissionsForWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowPermissionsForWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowPermissionsForWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowPermissionsForWorkflowQuery, GetWorkflowPermissionsForWorkflowQueryVariables> & ({ variables: GetWorkflowPermissionsForWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowPermissionsForWorkflowQuery, GetWorkflowPermissionsForWorkflowQueryVariables>(GetWorkflowPermissionsForWorkflowDocument, options);
      }
export function useGetWorkflowPermissionsForWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowPermissionsForWorkflowQuery, GetWorkflowPermissionsForWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowPermissionsForWorkflowQuery, GetWorkflowPermissionsForWorkflowQueryVariables>(GetWorkflowPermissionsForWorkflowDocument, options);
        }
export function useGetWorkflowPermissionsForWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPermissionsForWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPermissionsForWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowPermissionsForWorkflowQuery, GetWorkflowPermissionsForWorkflowQueryVariables>(GetWorkflowPermissionsForWorkflowDocument, options);
        }
export type GetWorkflowPermissionsForWorkflowQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsForWorkflowQuery>;
export type GetWorkflowPermissionsForWorkflowLazyQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsForWorkflowLazyQuery>;
export type GetWorkflowPermissionsForWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsForWorkflowSuspenseQuery>;
export type GetWorkflowPermissionsForWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowPermissionsForWorkflowQuery, GetWorkflowPermissionsForWorkflowQueryVariables>;
export const GetWorkflowPermissionsWithStepsDocument = gql`
    query GetWorkflowPermissionsWithSteps($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    status
    variant
    permissions {
      ...WorkflowPermissionSimple
      actions {
        ... on WorkflowRecipient {
          __typename
          id
          type
        }
        ... on Task {
          __typename
          id
        }
      }
    }
    ...WorkflowSigningPhaseSteps
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}`;

/**
 * __useGetWorkflowPermissionsWithStepsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowPermissionsWithStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowPermissionsWithStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowPermissionsWithStepsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowPermissionsWithStepsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowPermissionsWithStepsQuery, GetWorkflowPermissionsWithStepsQueryVariables> & ({ variables: GetWorkflowPermissionsWithStepsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowPermissionsWithStepsQuery, GetWorkflowPermissionsWithStepsQueryVariables>(GetWorkflowPermissionsWithStepsDocument, options);
      }
export function useGetWorkflowPermissionsWithStepsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowPermissionsWithStepsQuery, GetWorkflowPermissionsWithStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowPermissionsWithStepsQuery, GetWorkflowPermissionsWithStepsQueryVariables>(GetWorkflowPermissionsWithStepsDocument, options);
        }
export function useGetWorkflowPermissionsWithStepsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPermissionsWithStepsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPermissionsWithStepsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowPermissionsWithStepsQuery, GetWorkflowPermissionsWithStepsQueryVariables>(GetWorkflowPermissionsWithStepsDocument, options);
        }
export type GetWorkflowPermissionsWithStepsQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsWithStepsQuery>;
export type GetWorkflowPermissionsWithStepsLazyQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsWithStepsLazyQuery>;
export type GetWorkflowPermissionsWithStepsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowPermissionsWithStepsSuspenseQuery>;
export type GetWorkflowPermissionsWithStepsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowPermissionsWithStepsQuery, GetWorkflowPermissionsWithStepsQueryVariables>;
export const AddWorkflowPermissionsDocument = gql`
    mutation AddWorkflowPermissions($input: AddWorkflowPermissionsInput!) {
  addWorkflowPermissions(input: $input) {
    ...WorkflowPermissionWithActions
  }
}
    ${WorkflowPermissionWithActionsFragmentDoc}`;
export type AddWorkflowPermissionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddWorkflowPermissionsMutation, AddWorkflowPermissionsMutationVariables>;

/**
 * __useAddWorkflowPermissionsMutation__
 *
 * To run a mutation, you first call `useAddWorkflowPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkflowPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkflowPermissionsMutation, { data, loading, error }] = useAddWorkflowPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWorkflowPermissionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddWorkflowPermissionsMutation, AddWorkflowPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddWorkflowPermissionsMutation, AddWorkflowPermissionsMutationVariables>(AddWorkflowPermissionsDocument, options);
      }
export type AddWorkflowPermissionsMutationHookResult = ReturnType<typeof useAddWorkflowPermissionsMutation>;
export type AddWorkflowPermissionsMutationResult = ApolloReactHooks.useMutation.Result<AddWorkflowPermissionsMutation>;
export type AddWorkflowPermissionsMutationOptions = ApolloReactHooks.useMutation.Options<AddWorkflowPermissionsMutation, AddWorkflowPermissionsMutationVariables>;
export const RemoveWorkflowPermissionsDocument = gql`
    mutation RemoveWorkflowPermissions($input: RemoveWorkflowPermissionsInput!) {
  removeWorkflowPermissions(input: $input)
}
    `;
export type RemoveWorkflowPermissionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<RemoveWorkflowPermissionsMutation, RemoveWorkflowPermissionsMutationVariables>;

/**
 * __useRemoveWorkflowPermissionsMutation__
 *
 * To run a mutation, you first call `useRemoveWorkflowPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkflowPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkflowPermissionsMutation, { data, loading, error }] = useRemoveWorkflowPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkflowPermissionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RemoveWorkflowPermissionsMutation, RemoveWorkflowPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveWorkflowPermissionsMutation, RemoveWorkflowPermissionsMutationVariables>(RemoveWorkflowPermissionsDocument, options);
      }
export type RemoveWorkflowPermissionsMutationHookResult = ReturnType<typeof useRemoveWorkflowPermissionsMutation>;
export type RemoveWorkflowPermissionsMutationResult = ApolloReactHooks.useMutation.Result<RemoveWorkflowPermissionsMutation>;
export type RemoveWorkflowPermissionsMutationOptions = ApolloReactHooks.useMutation.Options<RemoveWorkflowPermissionsMutation, RemoveWorkflowPermissionsMutationVariables>;
export const GetOrCreateWorkflowLauncherPermissionDocument = gql`
    mutation GetOrCreateWorkflowLauncherPermission($workflowId: UUID!) {
  getOrCreateWorkflowLauncherPermission(workflowId: $workflowId) {
    ...WorkflowPermissionWithActions
  }
}
    ${WorkflowPermissionWithActionsFragmentDoc}`;
export type GetOrCreateWorkflowLauncherPermissionMutationFn = ApolloReactHooks.useMutation.MutationFunction<GetOrCreateWorkflowLauncherPermissionMutation, GetOrCreateWorkflowLauncherPermissionMutationVariables>;

/**
 * __useGetOrCreateWorkflowLauncherPermissionMutation__
 *
 * To run a mutation, you first call `useGetOrCreateWorkflowLauncherPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateWorkflowLauncherPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateWorkflowLauncherPermissionMutation, { data, loading, error }] = useGetOrCreateWorkflowLauncherPermissionMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetOrCreateWorkflowLauncherPermissionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<GetOrCreateWorkflowLauncherPermissionMutation, GetOrCreateWorkflowLauncherPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetOrCreateWorkflowLauncherPermissionMutation, GetOrCreateWorkflowLauncherPermissionMutationVariables>(GetOrCreateWorkflowLauncherPermissionDocument, options);
      }
export type GetOrCreateWorkflowLauncherPermissionMutationHookResult = ReturnType<typeof useGetOrCreateWorkflowLauncherPermissionMutation>;
export type GetOrCreateWorkflowLauncherPermissionMutationResult = ApolloReactHooks.useMutation.Result<GetOrCreateWorkflowLauncherPermissionMutation>;
export type GetOrCreateWorkflowLauncherPermissionMutationOptions = ApolloReactHooks.useMutation.Options<GetOrCreateWorkflowLauncherPermissionMutation, GetOrCreateWorkflowLauncherPermissionMutationVariables>;
export const UpdateWorkflowPermissionDocument = gql`
    mutation UpdateWorkflowPermission($input: UpdateWorkflowPermissionInput!) {
  updateWorkflowPermission(input: $input) {
    ...WorkflowPermissionSimple
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;
export type UpdateWorkflowPermissionMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowPermissionMutation, UpdateWorkflowPermissionMutationVariables>;

/**
 * __useUpdateWorkflowPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowPermissionMutation, { data, loading, error }] = useUpdateWorkflowPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowPermissionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowPermissionMutation, UpdateWorkflowPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowPermissionMutation, UpdateWorkflowPermissionMutationVariables>(UpdateWorkflowPermissionDocument, options);
      }
export type UpdateWorkflowPermissionMutationHookResult = ReturnType<typeof useUpdateWorkflowPermissionMutation>;
export type UpdateWorkflowPermissionMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowPermissionMutation>;
export type UpdateWorkflowPermissionMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowPermissionMutation, UpdateWorkflowPermissionMutationVariables>;
export const CreateWorkflowRecipientDocument = gql`
    mutation CreateWorkflowRecipient($input: CreateWorkflowRecipientInput!) {
  createWorkflowRecipient(input: $input) {
    workflow {
      ...WorkflowFragment
    }
  }
}
    ${WorkflowFragmentFragmentDoc}`;
export type CreateWorkflowRecipientMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateWorkflowRecipientMutation, CreateWorkflowRecipientMutationVariables>;

/**
 * __useCreateWorkflowRecipientMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowRecipientMutation, { data, loading, error }] = useCreateWorkflowRecipientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowRecipientMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateWorkflowRecipientMutation, CreateWorkflowRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkflowRecipientMutation, CreateWorkflowRecipientMutationVariables>(CreateWorkflowRecipientDocument, options);
      }
export type CreateWorkflowRecipientMutationHookResult = ReturnType<typeof useCreateWorkflowRecipientMutation>;
export type CreateWorkflowRecipientMutationResult = ApolloReactHooks.useMutation.Result<CreateWorkflowRecipientMutation>;
export type CreateWorkflowRecipientMutationOptions = ApolloReactHooks.useMutation.Options<CreateWorkflowRecipientMutation, CreateWorkflowRecipientMutationVariables>;
export const ChangeRecipientActionDocument = gql`
    mutation ChangeRecipientAction($input: ChangeRecipientActionInput!) {
  changeRecipientAction(input: $input) {
    ...WorkflowRecipientSimple
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}`;
export type ChangeRecipientActionMutationFn = ApolloReactHooks.useMutation.MutationFunction<ChangeRecipientActionMutation, ChangeRecipientActionMutationVariables>;

/**
 * __useChangeRecipientActionMutation__
 *
 * To run a mutation, you first call `useChangeRecipientActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeRecipientActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeRecipientActionMutation, { data, loading, error }] = useChangeRecipientActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeRecipientActionMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ChangeRecipientActionMutation, ChangeRecipientActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeRecipientActionMutation, ChangeRecipientActionMutationVariables>(ChangeRecipientActionDocument, options);
      }
export type ChangeRecipientActionMutationHookResult = ReturnType<typeof useChangeRecipientActionMutation>;
export type ChangeRecipientActionMutationResult = ApolloReactHooks.useMutation.Result<ChangeRecipientActionMutation>;
export type ChangeRecipientActionMutationOptions = ApolloReactHooks.useMutation.Options<ChangeRecipientActionMutation, ChangeRecipientActionMutationVariables>;
export const ReassignRecipientDocument = gql`
    mutation ReassignRecipient($input: ReassignRecipientInput!) {
  reassignRecipient(input: $input) {
    recipient {
      ...WorkflowRecipientSimple
    }
    clearedSignatureFieldNodeIds
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}`;
export type ReassignRecipientMutationFn = ApolloReactHooks.useMutation.MutationFunction<ReassignRecipientMutation, ReassignRecipientMutationVariables>;

/**
 * __useReassignRecipientMutation__
 *
 * To run a mutation, you first call `useReassignRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignRecipientMutation, { data, loading, error }] = useReassignRecipientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignRecipientMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ReassignRecipientMutation, ReassignRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReassignRecipientMutation, ReassignRecipientMutationVariables>(ReassignRecipientDocument, options);
      }
export type ReassignRecipientMutationHookResult = ReturnType<typeof useReassignRecipientMutation>;
export type ReassignRecipientMutationResult = ApolloReactHooks.useMutation.Result<ReassignRecipientMutation>;
export type ReassignRecipientMutationOptions = ApolloReactHooks.useMutation.Options<ReassignRecipientMutation, ReassignRecipientMutationVariables>;
export const DeclineSignatureRemindersDocument = gql`
    mutation DeclineSignatureReminders($workflowId: UUID!) {
  declineSignatureReminders(workflowId: $workflowId) {
    ...WorkflowRecipientSimple
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}`;
export type DeclineSignatureRemindersMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeclineSignatureRemindersMutation, DeclineSignatureRemindersMutationVariables>;

/**
 * __useDeclineSignatureRemindersMutation__
 *
 * To run a mutation, you first call `useDeclineSignatureRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineSignatureRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineSignatureRemindersMutation, { data, loading, error }] = useDeclineSignatureRemindersMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useDeclineSignatureRemindersMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeclineSignatureRemindersMutation, DeclineSignatureRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeclineSignatureRemindersMutation, DeclineSignatureRemindersMutationVariables>(DeclineSignatureRemindersDocument, options);
      }
export type DeclineSignatureRemindersMutationHookResult = ReturnType<typeof useDeclineSignatureRemindersMutation>;
export type DeclineSignatureRemindersMutationResult = ApolloReactHooks.useMutation.Result<DeclineSignatureRemindersMutation>;
export type DeclineSignatureRemindersMutationOptions = ApolloReactHooks.useMutation.Options<DeclineSignatureRemindersMutation, DeclineSignatureRemindersMutationVariables>;
export const UpdateRecipientNameDocument = gql`
    mutation UpdateRecipientName($input: UpdateRecipientNameInput!) {
  updateRecipientName(input: $input) {
    id
    recipientName
  }
}
    `;
export type UpdateRecipientNameMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateRecipientNameMutation, UpdateRecipientNameMutationVariables>;

/**
 * __useUpdateRecipientNameMutation__
 *
 * To run a mutation, you first call `useUpdateRecipientNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecipientNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecipientNameMutation, { data, loading, error }] = useUpdateRecipientNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRecipientNameMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateRecipientNameMutation, UpdateRecipientNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRecipientNameMutation, UpdateRecipientNameMutationVariables>(UpdateRecipientNameDocument, options);
      }
export type UpdateRecipientNameMutationHookResult = ReturnType<typeof useUpdateRecipientNameMutation>;
export type UpdateRecipientNameMutationResult = ApolloReactHooks.useMutation.Result<UpdateRecipientNameMutation>;
export type UpdateRecipientNameMutationOptions = ApolloReactHooks.useMutation.Options<UpdateRecipientNameMutation, UpdateRecipientNameMutationVariables>;
export const GetWorkflowDocument = gql`
    query GetWorkflow($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    ...WorkflowFragment
  }
}
    ${WorkflowFragmentFragmentDoc}`;

/**
 * __useGetWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowQuery, GetWorkflowQueryVariables> & ({ variables: GetWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
      }
export function useGetWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowQuery, GetWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
        }
export function useGetWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
        }
export type GetWorkflowQueryHookResult = ReturnType<typeof useGetWorkflowQuery>;
export type GetWorkflowLazyQueryHookResult = ReturnType<typeof useGetWorkflowLazyQuery>;
export type GetWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSuspenseQuery>;
export type GetWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowQuery, GetWorkflowQueryVariables>;
export const GetWorkflowSigningStatusDocument = gql`
    query GetWorkflowSigningStatus($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    state
  }
}
    `;

/**
 * __useGetWorkflowSigningStatusQuery__
 *
 * To run a query within a React component, call `useGetWorkflowSigningStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowSigningStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowSigningStatusQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowSigningStatusQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowSigningStatusQuery, GetWorkflowSigningStatusQueryVariables> & ({ variables: GetWorkflowSigningStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowSigningStatusQuery, GetWorkflowSigningStatusQueryVariables>(GetWorkflowSigningStatusDocument, options);
      }
export function useGetWorkflowSigningStatusLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowSigningStatusQuery, GetWorkflowSigningStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowSigningStatusQuery, GetWorkflowSigningStatusQueryVariables>(GetWorkflowSigningStatusDocument, options);
        }
export function useGetWorkflowSigningStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSigningStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSigningStatusQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowSigningStatusQuery, GetWorkflowSigningStatusQueryVariables>(GetWorkflowSigningStatusDocument, options);
        }
export type GetWorkflowSigningStatusQueryHookResult = ReturnType<typeof useGetWorkflowSigningStatusQuery>;
export type GetWorkflowSigningStatusLazyQueryHookResult = ReturnType<typeof useGetWorkflowSigningStatusLazyQuery>;
export type GetWorkflowSigningStatusSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSigningStatusSuspenseQuery>;
export type GetWorkflowSigningStatusQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowSigningStatusQuery, GetWorkflowSigningStatusQueryVariables>;
export const GetWorkflowsDocument = gql`
    query GetWorkflows($workflowFilter: WorkflowFilterInput, $sortModel: JSON, $filterModel: JSON, $cursor: UUID, $limit: Int, $listFilter: WorkflowListFilter, $groupFields: [String!], $groupKeys: [String!], $grain: String) {
  workflows(
    workflowFilter: $workflowFilter
    sortModel: $sortModel
    filterModel: $filterModel
    cursor: $cursor
    limit: $limit
    listFilter: $listFilter
    groupFields: $groupFields
    groupKeys: $groupKeys
    grain: $grain
  ) {
    groupCount
    aggregates {
      count
      avgCycleTime
    }
    groupHeaders {
      __typename
      id
      isGroupRow
      groupField
      groupKey
      groupLabel
      workflowCount
      avgCycleTime
      childRowCount
      parentGroupId
    }
    rows {
      __typename
      id
      completedAt
      createdAt
      envelopeStatus
      name
      priority
      startedAt
      status
      state
      updatedAt
      variant
      numTimesUsed
      publishedAt
      crmIntegrations
      linkedOpportunities {
        __typename
        id
        integration
        opportunityName
      }
      files {
        __typename
        id
        document {
          __typename
          id
          name
        }
      }
      labels {
        ...LabelSimple
      }
      permissions {
        ...WorkflowPermissionSimple
      }
      parties {
        ...PartySimple
      }
      sourceWorkflow {
        __typename
        id
        name
        variant
      }
      owner {
        ...UserBase
      }
      column {
        __typename
        id
        name
        category
        color
        sortKey
      }
      phases {
        __typename
        id
        name
        order
        startedAt
        completedAt
        column {
          id
        }
      }
      doneColumn {
        __typename
        id
      }
    }
    meta {
      __typename
      totalCount
      hasMore
    }
  }
}
    ${LabelSimpleFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}
${PartySimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useGetWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsQuery({
 *   variables: {
 *      workflowFilter: // value for 'workflowFilter'
 *      sortModel: // value for 'sortModel'
 *      filterModel: // value for 'filterModel'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      listFilter: // value for 'listFilter'
 *      groupFields: // value for 'groupFields'
 *      groupKeys: // value for 'groupKeys'
 *      grain: // value for 'grain'
 *   },
 * });
 */
export function useGetWorkflowsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
      }
export function useGetWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
        }
export function useGetWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
        }
export type GetWorkflowsQueryHookResult = ReturnType<typeof useGetWorkflowsQuery>;
export type GetWorkflowsLazyQueryHookResult = ReturnType<typeof useGetWorkflowsLazyQuery>;
export type GetWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowsSuspenseQuery>;
export type GetWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowsQuery, GetWorkflowsQueryVariables>;
export const GetWorkflowsCountDocument = gql`
    query GetWorkflowsCount($workflowFilter: WorkflowFilterInput, $sortModel: JSON, $filterModel: JSON, $listFilter: WorkflowListFilter) {
  workflows(
    workflowFilter: $workflowFilter
    sortModel: $sortModel
    filterModel: $filterModel
    listFilter: $listFilter
  ) {
    rows {
      __typename
      id
      name
      status
      state
      variant
    }
    meta {
      __typename
      totalCount
    }
  }
}
    `;

/**
 * __useGetWorkflowsCountQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsCountQuery({
 *   variables: {
 *      workflowFilter: // value for 'workflowFilter'
 *      sortModel: // value for 'sortModel'
 *      filterModel: // value for 'filterModel'
 *      listFilter: // value for 'listFilter'
 *   },
 * });
 */
export function useGetWorkflowsCountQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetWorkflowsCountQuery, GetWorkflowsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowsCountQuery, GetWorkflowsCountQueryVariables>(GetWorkflowsCountDocument, options);
      }
export function useGetWorkflowsCountLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowsCountQuery, GetWorkflowsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowsCountQuery, GetWorkflowsCountQueryVariables>(GetWorkflowsCountDocument, options);
        }
export function useGetWorkflowsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowsCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowsCountQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowsCountQuery, GetWorkflowsCountQueryVariables>(GetWorkflowsCountDocument, options);
        }
export type GetWorkflowsCountQueryHookResult = ReturnType<typeof useGetWorkflowsCountQuery>;
export type GetWorkflowsCountLazyQueryHookResult = ReturnType<typeof useGetWorkflowsCountLazyQuery>;
export type GetWorkflowsCountSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowsCountSuspenseQuery>;
export type GetWorkflowsCountQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowsCountQuery, GetWorkflowsCountQueryVariables>;
export const GetWorkflowsWithFilesDocument = gql`
    query GetWorkflowsWithFiles($workflowFilter: WorkflowFilterInput, $sortModel: JSON, $filterModel: JSON, $cursor: UUID, $limit: Int, $listFilter: WorkflowListFilter) {
  workflows(
    workflowFilter: $workflowFilter
    sortModel: $sortModel
    filterModel: $filterModel
    cursor: $cursor
    limit: $limit
    listFilter: $listFilter
  ) {
    rows {
      __typename
      id
      name
      variant
      publishedAt
      owner {
        ...UserBase
      }
      files {
        __typename
        id
        document {
          __typename
          id
          name
        }
      }
    }
    meta {
      __typename
      totalCount
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetWorkflowsWithFilesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsWithFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsWithFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsWithFilesQuery({
 *   variables: {
 *      workflowFilter: // value for 'workflowFilter'
 *      sortModel: // value for 'sortModel'
 *      filterModel: // value for 'filterModel'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      listFilter: // value for 'listFilter'
 *   },
 * });
 */
export function useGetWorkflowsWithFilesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetWorkflowsWithFilesQuery, GetWorkflowsWithFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowsWithFilesQuery, GetWorkflowsWithFilesQueryVariables>(GetWorkflowsWithFilesDocument, options);
      }
export function useGetWorkflowsWithFilesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowsWithFilesQuery, GetWorkflowsWithFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowsWithFilesQuery, GetWorkflowsWithFilesQueryVariables>(GetWorkflowsWithFilesDocument, options);
        }
export function useGetWorkflowsWithFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowsWithFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowsWithFilesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowsWithFilesQuery, GetWorkflowsWithFilesQueryVariables>(GetWorkflowsWithFilesDocument, options);
        }
export type GetWorkflowsWithFilesQueryHookResult = ReturnType<typeof useGetWorkflowsWithFilesQuery>;
export type GetWorkflowsWithFilesLazyQueryHookResult = ReturnType<typeof useGetWorkflowsWithFilesLazyQuery>;
export type GetWorkflowsWithFilesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowsWithFilesSuspenseQuery>;
export type GetWorkflowsWithFilesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowsWithFilesQuery, GetWorkflowsWithFilesQueryVariables>;
export const GetWorkflowTypesDocument = gql`
    query GetWorkflowTypes {
  workflowTypes {
    __typename
    id
    label
  }
}
    `;

/**
 * __useGetWorkflowTypesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowTypesQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetWorkflowTypesQuery, GetWorkflowTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowTypesQuery, GetWorkflowTypesQueryVariables>(GetWorkflowTypesDocument, options);
      }
export function useGetWorkflowTypesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowTypesQuery, GetWorkflowTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowTypesQuery, GetWorkflowTypesQueryVariables>(GetWorkflowTypesDocument, options);
        }
export function useGetWorkflowTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowTypesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowTypesQuery, GetWorkflowTypesQueryVariables>(GetWorkflowTypesDocument, options);
        }
export type GetWorkflowTypesQueryHookResult = ReturnType<typeof useGetWorkflowTypesQuery>;
export type GetWorkflowTypesLazyQueryHookResult = ReturnType<typeof useGetWorkflowTypesLazyQuery>;
export type GetWorkflowTypesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowTypesSuspenseQuery>;
export type GetWorkflowTypesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowTypesQuery, GetWorkflowTypesQueryVariables>;
export const GetBoardWorkflowsDocument = gql`
    query GetBoardWorkflows($workflowFilter: WorkflowFilterInput, $sortModel: JSON, $filterModel: JSON, $listFilter: WorkflowListFilter, $cursor: UUID, $limit: Int) {
  workflows(
    workflowFilter: $workflowFilter
    sortModel: $sortModel
    filterModel: $filterModel
    listFilter: $listFilter
    cursor: $cursor
    limit: $limit
  ) {
    rows {
      __typename
      id
      commentCount
      completedAt
      completedStepCount
      createdAt
      envelopeStatus
      name
      priority
      startedAt
      state
      status
      totalStepCount
      updatedAt
      variant
      column {
        __typename
        id
        category
        color
        name
        sortKey
      }
      files {
        __typename
        id
        document {
          __typename
          id
          name
          variant
          latestVersion {
            ...FileVersionSimple
          }
        }
      }
      owner {
        ...UserBase
      }
      permissions {
        ...WorkflowPermissionSimple
      }
      labels {
        ...LabelSimple
      }
      sourceWorkflow {
        __typename
        id
        name
        variant
      }
      phases {
        __typename
        id
        name
        order
        startedAt
        completedAt
        column {
          id
        }
      }
      tasks {
        __typename
        id
        completedAt
        status
        parentTask {
          __typename
          id
        }
      }
      doneColumn {
        __typename
        id
      }
    }
    meta {
      __typename
      totalCount
    }
  }
}
    ${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}
${LabelSimpleFragmentDoc}`;

/**
 * __useGetBoardWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetBoardWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardWorkflowsQuery({
 *   variables: {
 *      workflowFilter: // value for 'workflowFilter'
 *      sortModel: // value for 'sortModel'
 *      filterModel: // value for 'filterModel'
 *      listFilter: // value for 'listFilter'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBoardWorkflowsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetBoardWorkflowsQuery, GetBoardWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBoardWorkflowsQuery, GetBoardWorkflowsQueryVariables>(GetBoardWorkflowsDocument, options);
      }
export function useGetBoardWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetBoardWorkflowsQuery, GetBoardWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBoardWorkflowsQuery, GetBoardWorkflowsQueryVariables>(GetBoardWorkflowsDocument, options);
        }
export function useGetBoardWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetBoardWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetBoardWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetBoardWorkflowsQuery, GetBoardWorkflowsQueryVariables>(GetBoardWorkflowsDocument, options);
        }
export type GetBoardWorkflowsQueryHookResult = ReturnType<typeof useGetBoardWorkflowsQuery>;
export type GetBoardWorkflowsLazyQueryHookResult = ReturnType<typeof useGetBoardWorkflowsLazyQuery>;
export type GetBoardWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetBoardWorkflowsSuspenseQuery>;
export type GetBoardWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<GetBoardWorkflowsQuery, GetBoardWorkflowsQueryVariables>;
export const GetWorkflowSimpleDocument = gql`
    query GetWorkflowSimple($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    aiCancelledAt
    aiFailedAt
    aiFailureReason
    aiFinishedAt
    aiStartedAt
    createdAt
    completedAt
    crmIntegrations
    envelopeMsg
    fileCount
    name
    description
    numTimesUsed
    numTimesImported
    isCommunityWorkflow
    isSignedOutsideAline
    status
    state
    envelopeStatus
    totalStepCount
    requesterInOwnerOrg
    startedAt
    publishedAt
    variant
    activeStep {
      __typename
      id
    }
    envelope {
      __typename
      id
      docuSignEnvelopeId
      title
      variant
    }
    labels {
      ...LabelSimple
    }
    owner {
      __typename
      id
      avatarColor
      displayName
      email
      supportRole
      org {
        __typename
        id
        avatarColor
        avatarImg {
          __typename
          filestackUrl
        }
      }
    }
    sourceWorkflow {
      id
      name
    }
  }
}
    ${LabelSimpleFragmentDoc}`;

/**
 * __useGetWorkflowSimpleQuery__
 *
 * To run a query within a React component, call `useGetWorkflowSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowSimpleQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowSimpleQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowSimpleQuery, GetWorkflowSimpleQueryVariables> & ({ variables: GetWorkflowSimpleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowSimpleQuery, GetWorkflowSimpleQueryVariables>(GetWorkflowSimpleDocument, options);
      }
export function useGetWorkflowSimpleLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowSimpleQuery, GetWorkflowSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowSimpleQuery, GetWorkflowSimpleQueryVariables>(GetWorkflowSimpleDocument, options);
        }
export function useGetWorkflowSimpleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSimpleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowSimpleQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowSimpleQuery, GetWorkflowSimpleQueryVariables>(GetWorkflowSimpleDocument, options);
        }
export type GetWorkflowSimpleQueryHookResult = ReturnType<typeof useGetWorkflowSimpleQuery>;
export type GetWorkflowSimpleLazyQueryHookResult = ReturnType<typeof useGetWorkflowSimpleLazyQuery>;
export type GetWorkflowSimpleSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSimpleSuspenseQuery>;
export type GetWorkflowSimpleQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowSimpleQuery, GetWorkflowSimpleQueryVariables>;
export const GetWorkflowCommentsDocument = gql`
    query GetWorkflowComments($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    comments {
      ...CommentSimple
    }
  }
}
    ${CommentSimpleFragmentDoc}`;

/**
 * __useGetWorkflowCommentsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowCommentsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowCommentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowCommentsQuery, GetWorkflowCommentsQueryVariables> & ({ variables: GetWorkflowCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowCommentsQuery, GetWorkflowCommentsQueryVariables>(GetWorkflowCommentsDocument, options);
      }
export function useGetWorkflowCommentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowCommentsQuery, GetWorkflowCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowCommentsQuery, GetWorkflowCommentsQueryVariables>(GetWorkflowCommentsDocument, options);
        }
export function useGetWorkflowCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowCommentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowCommentsQuery, GetWorkflowCommentsQueryVariables>(GetWorkflowCommentsDocument, options);
        }
export type GetWorkflowCommentsQueryHookResult = ReturnType<typeof useGetWorkflowCommentsQuery>;
export type GetWorkflowCommentsLazyQueryHookResult = ReturnType<typeof useGetWorkflowCommentsLazyQuery>;
export type GetWorkflowCommentsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowCommentsSuspenseQuery>;
export type GetWorkflowCommentsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowCommentsQuery, GetWorkflowCommentsQueryVariables>;
export const GetWorkflowDocumentDocument = gql`
    query GetWorkflowDocument($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    requesterInOwnerOrg
    createdAt
    files {
      __typename
      id
      document {
        ...DocumentSimple
      }
    }
  }
}
    ${DocumentSimpleFragmentDoc}`;

/**
 * __useGetWorkflowDocumentQuery__
 *
 * To run a query within a React component, call `useGetWorkflowDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowDocumentQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowDocumentQuery, GetWorkflowDocumentQueryVariables> & ({ variables: GetWorkflowDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowDocumentQuery, GetWorkflowDocumentQueryVariables>(GetWorkflowDocumentDocument, options);
      }
export function useGetWorkflowDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowDocumentQuery, GetWorkflowDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowDocumentQuery, GetWorkflowDocumentQueryVariables>(GetWorkflowDocumentDocument, options);
        }
export function useGetWorkflowDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowDocumentQuery, GetWorkflowDocumentQueryVariables>(GetWorkflowDocumentDocument, options);
        }
export type GetWorkflowDocumentQueryHookResult = ReturnType<typeof useGetWorkflowDocumentQuery>;
export type GetWorkflowDocumentLazyQueryHookResult = ReturnType<typeof useGetWorkflowDocumentLazyQuery>;
export type GetWorkflowDocumentSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowDocumentSuspenseQuery>;
export type GetWorkflowDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowDocumentQuery, GetWorkflowDocumentQueryVariables>;
export const GetWorkflowByDocumentDocument = gql`
    query GetWorkflowByDocument($documentId: UUID!) {
  document(documentId: $documentId) {
    __typename
    id
    name
    requesterRole
    status
    variant
    latestVersion {
      ... on FileVersionInterface {
        __typename
        id
      }
    }
    owner {
      __typename
      id
    }
    workflow {
      ...WorkflowFragment
    }
  }
}
    ${WorkflowFragmentFragmentDoc}`;

/**
 * __useGetWorkflowByDocumentQuery__
 *
 * To run a query within a React component, call `useGetWorkflowByDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowByDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowByDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetWorkflowByDocumentQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowByDocumentQuery, GetWorkflowByDocumentQueryVariables> & ({ variables: GetWorkflowByDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowByDocumentQuery, GetWorkflowByDocumentQueryVariables>(GetWorkflowByDocumentDocument, options);
      }
export function useGetWorkflowByDocumentLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowByDocumentQuery, GetWorkflowByDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowByDocumentQuery, GetWorkflowByDocumentQueryVariables>(GetWorkflowByDocumentDocument, options);
        }
export function useGetWorkflowByDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowByDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowByDocumentQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowByDocumentQuery, GetWorkflowByDocumentQueryVariables>(GetWorkflowByDocumentDocument, options);
        }
export type GetWorkflowByDocumentQueryHookResult = ReturnType<typeof useGetWorkflowByDocumentQuery>;
export type GetWorkflowByDocumentLazyQueryHookResult = ReturnType<typeof useGetWorkflowByDocumentLazyQuery>;
export type GetWorkflowByDocumentSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowByDocumentSuspenseQuery>;
export type GetWorkflowByDocumentQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowByDocumentQuery, GetWorkflowByDocumentQueryVariables>;
export const GetWorkflowActiveStepDocument = gql`
    query GetWorkflowActiveStep($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    activeStep {
      ...WorkflowStepFragment
    }
  }
}
    ${WorkflowStepFragmentFragmentDoc}`;

/**
 * __useGetWorkflowActiveStepQuery__
 *
 * To run a query within a React component, call `useGetWorkflowActiveStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowActiveStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowActiveStepQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowActiveStepQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowActiveStepQuery, GetWorkflowActiveStepQueryVariables> & ({ variables: GetWorkflowActiveStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowActiveStepQuery, GetWorkflowActiveStepQueryVariables>(GetWorkflowActiveStepDocument, options);
      }
export function useGetWorkflowActiveStepLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowActiveStepQuery, GetWorkflowActiveStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowActiveStepQuery, GetWorkflowActiveStepQueryVariables>(GetWorkflowActiveStepDocument, options);
        }
export function useGetWorkflowActiveStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowActiveStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowActiveStepQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowActiveStepQuery, GetWorkflowActiveStepQueryVariables>(GetWorkflowActiveStepDocument, options);
        }
export type GetWorkflowActiveStepQueryHookResult = ReturnType<typeof useGetWorkflowActiveStepQuery>;
export type GetWorkflowActiveStepLazyQueryHookResult = ReturnType<typeof useGetWorkflowActiveStepLazyQuery>;
export type GetWorkflowActiveStepSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowActiveStepSuspenseQuery>;
export type GetWorkflowActiveStepQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowActiveStepQuery, GetWorkflowActiveStepQueryVariables>;
export const GetWorkflowFilesDocument = gql`
    query GetWorkflowFiles($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    ...WorkflowWithFiles
  }
}
    ${WorkflowWithFilesFragmentDoc}`;

/**
 * __useGetWorkflowFilesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowFilesQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowFilesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowFilesQuery, GetWorkflowFilesQueryVariables> & ({ variables: GetWorkflowFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowFilesQuery, GetWorkflowFilesQueryVariables>(GetWorkflowFilesDocument, options);
      }
export function useGetWorkflowFilesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowFilesQuery, GetWorkflowFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowFilesQuery, GetWorkflowFilesQueryVariables>(GetWorkflowFilesDocument, options);
        }
export function useGetWorkflowFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowFilesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowFilesQuery, GetWorkflowFilesQueryVariables>(GetWorkflowFilesDocument, options);
        }
export type GetWorkflowFilesQueryHookResult = ReturnType<typeof useGetWorkflowFilesQuery>;
export type GetWorkflowFilesLazyQueryHookResult = ReturnType<typeof useGetWorkflowFilesLazyQuery>;
export type GetWorkflowFilesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowFilesSuspenseQuery>;
export type GetWorkflowFilesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowFilesQuery, GetWorkflowFilesQueryVariables>;
export const GetWorkflowPreviewDetailsDocument = gql`
    query GetWorkflowPreviewDetails($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    completedAt
    createdAt
    name
    requesterInOwnerOrg
    startedAt
    status
    state
    variant
    labels {
      ...LabelSimple
    }
    permissions {
      ...WorkflowPermissionSimple
    }
    activeStep {
      ...WorkflowStepFragment
    }
    files {
      ...WorkflowFileSimple
    }
    owner {
      ...UserBase
    }
  }
}
    ${LabelSimpleFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}
${WorkflowStepFragmentFragmentDoc}
${WorkflowFileSimpleFragmentDoc}
${UserBaseFragmentDoc}`;

/**
 * __useGetWorkflowPreviewDetailsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowPreviewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowPreviewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowPreviewDetailsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowPreviewDetailsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowPreviewDetailsQuery, GetWorkflowPreviewDetailsQueryVariables> & ({ variables: GetWorkflowPreviewDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowPreviewDetailsQuery, GetWorkflowPreviewDetailsQueryVariables>(GetWorkflowPreviewDetailsDocument, options);
      }
export function useGetWorkflowPreviewDetailsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowPreviewDetailsQuery, GetWorkflowPreviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowPreviewDetailsQuery, GetWorkflowPreviewDetailsQueryVariables>(GetWorkflowPreviewDetailsDocument, options);
        }
export function useGetWorkflowPreviewDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPreviewDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowPreviewDetailsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowPreviewDetailsQuery, GetWorkflowPreviewDetailsQueryVariables>(GetWorkflowPreviewDetailsDocument, options);
        }
export type GetWorkflowPreviewDetailsQueryHookResult = ReturnType<typeof useGetWorkflowPreviewDetailsQuery>;
export type GetWorkflowPreviewDetailsLazyQueryHookResult = ReturnType<typeof useGetWorkflowPreviewDetailsLazyQuery>;
export type GetWorkflowPreviewDetailsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowPreviewDetailsSuspenseQuery>;
export type GetWorkflowPreviewDetailsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowPreviewDetailsQuery, GetWorkflowPreviewDetailsQueryVariables>;
export const GetWorkflowFilesWithPartiesDocument = gql`
    query GetWorkflowFilesWithParties($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    createdAt
    name
    status
    state
    envelopeStatus
    updatedAt
    isCommunityWorkflow
    envelope {
      __typename
      id
    }
    files {
      __typename
      id
      orderId
      document {
        __typename
        id
        name
        status
        variant
        isCertificate
        isCommunityTemplate
        requesterFavorited
        requesterRole
        coreAiPropertiesExtractionStartedAt
        coreAiPropertiesExtractionFinishedAt
        coreAiPropertiesExtractionFailedAt
        latestVersion {
          ...FileVersionSimple
        }
        owner {
          ...UserBase
        }
        parties {
          ...PartySimple
        }
        type {
          ...ContractTypeSimple
        }
        updatedAt
        deletedAt
      }
    }
  }
}
    ${FileVersionSimpleFragmentDoc}
${UserBaseFragmentDoc}
${PartySimpleFragmentDoc}
${ContractTypeSimpleFragmentDoc}`;

/**
 * __useGetWorkflowFilesWithPartiesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowFilesWithPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowFilesWithPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowFilesWithPartiesQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowFilesWithPartiesQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowFilesWithPartiesQuery, GetWorkflowFilesWithPartiesQueryVariables> & ({ variables: GetWorkflowFilesWithPartiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowFilesWithPartiesQuery, GetWorkflowFilesWithPartiesQueryVariables>(GetWorkflowFilesWithPartiesDocument, options);
      }
export function useGetWorkflowFilesWithPartiesLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowFilesWithPartiesQuery, GetWorkflowFilesWithPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowFilesWithPartiesQuery, GetWorkflowFilesWithPartiesQueryVariables>(GetWorkflowFilesWithPartiesDocument, options);
        }
export function useGetWorkflowFilesWithPartiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowFilesWithPartiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowFilesWithPartiesQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowFilesWithPartiesQuery, GetWorkflowFilesWithPartiesQueryVariables>(GetWorkflowFilesWithPartiesDocument, options);
        }
export type GetWorkflowFilesWithPartiesQueryHookResult = ReturnType<typeof useGetWorkflowFilesWithPartiesQuery>;
export type GetWorkflowFilesWithPartiesLazyQueryHookResult = ReturnType<typeof useGetWorkflowFilesWithPartiesLazyQuery>;
export type GetWorkflowFilesWithPartiesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowFilesWithPartiesSuspenseQuery>;
export type GetWorkflowFilesWithPartiesQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowFilesWithPartiesQuery, GetWorkflowFilesWithPartiesQueryVariables>;
export const GetWorkflowFilesWithFieldsDocument = gql`
    query GetWorkflowFilesWithFields($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    status
    state
    envelopeStatus
    requesterInOwnerOrg
    createdAt
    envelope {
      __typename
      id
    }
    files {
      ...WorkflowFileWithFields
    }
  }
}
    ${WorkflowFileWithFieldsFragmentDoc}`;

/**
 * __useGetWorkflowFilesWithFieldsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowFilesWithFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowFilesWithFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowFilesWithFieldsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowFilesWithFieldsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowFilesWithFieldsQuery, GetWorkflowFilesWithFieldsQueryVariables> & ({ variables: GetWorkflowFilesWithFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowFilesWithFieldsQuery, GetWorkflowFilesWithFieldsQueryVariables>(GetWorkflowFilesWithFieldsDocument, options);
      }
export function useGetWorkflowFilesWithFieldsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowFilesWithFieldsQuery, GetWorkflowFilesWithFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowFilesWithFieldsQuery, GetWorkflowFilesWithFieldsQueryVariables>(GetWorkflowFilesWithFieldsDocument, options);
        }
export function useGetWorkflowFilesWithFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowFilesWithFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowFilesWithFieldsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowFilesWithFieldsQuery, GetWorkflowFilesWithFieldsQueryVariables>(GetWorkflowFilesWithFieldsDocument, options);
        }
export type GetWorkflowFilesWithFieldsQueryHookResult = ReturnType<typeof useGetWorkflowFilesWithFieldsQuery>;
export type GetWorkflowFilesWithFieldsLazyQueryHookResult = ReturnType<typeof useGetWorkflowFilesWithFieldsLazyQuery>;
export type GetWorkflowFilesWithFieldsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowFilesWithFieldsSuspenseQuery>;
export type GetWorkflowFilesWithFieldsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowFilesWithFieldsQuery, GetWorkflowFilesWithFieldsQueryVariables>;
export const GetWorkflowWithReadyCheckDocument = gql`
    query GetWorkflowWithReadyCheck($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    status
    state
    isReadyForSignature {
      __typename
      ready
      notReadyReasons
    }
    activeStep {
      ...WorkflowStepFragment
    }
    ...WorkflowSigningPhaseSteps
  }
}
    ${WorkflowStepFragmentFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}`;

/**
 * __useGetWorkflowWithReadyCheckQuery__
 *
 * To run a query within a React component, call `useGetWorkflowWithReadyCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowWithReadyCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowWithReadyCheckQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowWithReadyCheckQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowWithReadyCheckQuery, GetWorkflowWithReadyCheckQueryVariables> & ({ variables: GetWorkflowWithReadyCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowWithReadyCheckQuery, GetWorkflowWithReadyCheckQueryVariables>(GetWorkflowWithReadyCheckDocument, options);
      }
export function useGetWorkflowWithReadyCheckLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowWithReadyCheckQuery, GetWorkflowWithReadyCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowWithReadyCheckQuery, GetWorkflowWithReadyCheckQueryVariables>(GetWorkflowWithReadyCheckDocument, options);
        }
export function useGetWorkflowWithReadyCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithReadyCheckQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithReadyCheckQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowWithReadyCheckQuery, GetWorkflowWithReadyCheckQueryVariables>(GetWorkflowWithReadyCheckDocument, options);
        }
export type GetWorkflowWithReadyCheckQueryHookResult = ReturnType<typeof useGetWorkflowWithReadyCheckQuery>;
export type GetWorkflowWithReadyCheckLazyQueryHookResult = ReturnType<typeof useGetWorkflowWithReadyCheckLazyQuery>;
export type GetWorkflowWithReadyCheckSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowWithReadyCheckSuspenseQuery>;
export type GetWorkflowWithReadyCheckQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowWithReadyCheckQuery, GetWorkflowWithReadyCheckQueryVariables>;
export const GetWorkflowTasksDocument = gql`
    query GetWorkflowTasks($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    createdAt
    name
    requesterInOwnerOrg
    status
    state
    variant
    phases {
      __typename
      id
      order
      ... on NonSigningPhase {
        tasks {
          ...TaskSimple
          comments {
            ...CommentSimple
          }
        }
      }
    }
  }
}
    ${TaskSimpleFragmentDoc}
${CommentSimpleFragmentDoc}`;

/**
 * __useGetWorkflowTasksQuery__
 *
 * To run a query within a React component, call `useGetWorkflowTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowTasksQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowTasksQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowTasksQuery, GetWorkflowTasksQueryVariables> & ({ variables: GetWorkflowTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowTasksQuery, GetWorkflowTasksQueryVariables>(GetWorkflowTasksDocument, options);
      }
export function useGetWorkflowTasksLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowTasksQuery, GetWorkflowTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowTasksQuery, GetWorkflowTasksQueryVariables>(GetWorkflowTasksDocument, options);
        }
export function useGetWorkflowTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowTasksQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowTasksQuery, GetWorkflowTasksQueryVariables>(GetWorkflowTasksDocument, options);
        }
export type GetWorkflowTasksQueryHookResult = ReturnType<typeof useGetWorkflowTasksQuery>;
export type GetWorkflowTasksLazyQueryHookResult = ReturnType<typeof useGetWorkflowTasksLazyQuery>;
export type GetWorkflowTasksSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowTasksSuspenseQuery>;
export type GetWorkflowTasksQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowTasksQuery, GetWorkflowTasksQueryVariables>;
export const GetWorkflowAssignmentsDocument = gql`
    query GetWorkflowAssignments($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    permissions {
      ...WorkflowPermissionSimple
    }
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;

/**
 * __useGetWorkflowAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowAssignmentsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowAssignmentsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowAssignmentsQuery, GetWorkflowAssignmentsQueryVariables> & ({ variables: GetWorkflowAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowAssignmentsQuery, GetWorkflowAssignmentsQueryVariables>(GetWorkflowAssignmentsDocument, options);
      }
export function useGetWorkflowAssignmentsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowAssignmentsQuery, GetWorkflowAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowAssignmentsQuery, GetWorkflowAssignmentsQueryVariables>(GetWorkflowAssignmentsDocument, options);
        }
export function useGetWorkflowAssignmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowAssignmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowAssignmentsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowAssignmentsQuery, GetWorkflowAssignmentsQueryVariables>(GetWorkflowAssignmentsDocument, options);
        }
export type GetWorkflowAssignmentsQueryHookResult = ReturnType<typeof useGetWorkflowAssignmentsQuery>;
export type GetWorkflowAssignmentsLazyQueryHookResult = ReturnType<typeof useGetWorkflowAssignmentsLazyQuery>;
export type GetWorkflowAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowAssignmentsSuspenseQuery>;
export type GetWorkflowAssignmentsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowAssignmentsQuery, GetWorkflowAssignmentsQueryVariables>;
export const LaunchTemplateDataDocument = gql`
    query LaunchTemplateData($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    name
    publishedAt
    files {
      __typename
      id
      orderId
      document {
        __typename
        id
        name
      }
    }
    permissions {
      ...WorkflowPermissionSimple
    }
    intakeFormTemplate {
      ...IntakeFormTemplateFull
    }
    intakeFields {
      __typename
      fieldId
      label
      question
      type
      required
      order
      picklistOptions {
        __typename
        label
        value
      }
      usedInDocuments
    }
    mappedCrmIntegrations
  }
  apiDeckConnections {
    ...ApiDeckConnectionSimple
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}
${IntakeFormTemplateFullFragmentDoc}
${ApiDeckConnectionSimpleFragmentDoc}`;

/**
 * __useLaunchTemplateDataQuery__
 *
 * To run a query within a React component, call `useLaunchTemplateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchTemplateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchTemplateDataQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useLaunchTemplateDataQuery(baseOptions: ApolloReactHooks.useQuery.Options<LaunchTemplateDataQuery, LaunchTemplateDataQueryVariables> & ({ variables: LaunchTemplateDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LaunchTemplateDataQuery, LaunchTemplateDataQueryVariables>(LaunchTemplateDataDocument, options);
      }
export function useLaunchTemplateDataLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<LaunchTemplateDataQuery, LaunchTemplateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LaunchTemplateDataQuery, LaunchTemplateDataQueryVariables>(LaunchTemplateDataDocument, options);
        }
export function useLaunchTemplateDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<LaunchTemplateDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<LaunchTemplateDataQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<LaunchTemplateDataQuery, LaunchTemplateDataQueryVariables>(LaunchTemplateDataDocument, options);
        }
export type LaunchTemplateDataQueryHookResult = ReturnType<typeof useLaunchTemplateDataQuery>;
export type LaunchTemplateDataLazyQueryHookResult = ReturnType<typeof useLaunchTemplateDataLazyQuery>;
export type LaunchTemplateDataSuspenseQueryHookResult = ReturnType<typeof useLaunchTemplateDataSuspenseQuery>;
export type LaunchTemplateDataQueryResult = ApolloReactHooks.useQuery.Result<LaunchTemplateDataQuery, LaunchTemplateDataQueryVariables>;
export const GetWorkflowInboxDocument = gql`
    query GetWorkflowInbox($filter: WorkflowInboxFilterInput, $cursor: UUID, $limit: Int) {
  workflowInboxWorkflows(filter: $filter, cursor: $cursor, limit: $limit) {
    rows {
      ...WorkflowInboxWorkflow
    }
    meta {
      __typename
      totalCount
    }
  }
}
    ${WorkflowInboxWorkflowFragmentDoc}`;

/**
 * __useGetWorkflowInboxQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInboxQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWorkflowInboxQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetWorkflowInboxQuery, GetWorkflowInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowInboxQuery, GetWorkflowInboxQueryVariables>(GetWorkflowInboxDocument, options);
      }
export function useGetWorkflowInboxLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowInboxQuery, GetWorkflowInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowInboxQuery, GetWorkflowInboxQueryVariables>(GetWorkflowInboxDocument, options);
        }
export function useGetWorkflowInboxSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowInboxQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowInboxQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowInboxQuery, GetWorkflowInboxQueryVariables>(GetWorkflowInboxDocument, options);
        }
export type GetWorkflowInboxQueryHookResult = ReturnType<typeof useGetWorkflowInboxQuery>;
export type GetWorkflowInboxLazyQueryHookResult = ReturnType<typeof useGetWorkflowInboxLazyQuery>;
export type GetWorkflowInboxSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowInboxSuspenseQuery>;
export type GetWorkflowInboxQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowInboxQuery, GetWorkflowInboxQueryVariables>;
export const GetWorkflowInboxWorkflowDocument = gql`
    query GetWorkflowInboxWorkflow($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    ...WorkflowInboxWorkflow
  }
}
    ${WorkflowInboxWorkflowFragmentDoc}`;

/**
 * __useGetWorkflowInboxWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInboxWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInboxWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInboxWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowInboxWorkflowQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowInboxWorkflowQuery, GetWorkflowInboxWorkflowQueryVariables> & ({ variables: GetWorkflowInboxWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowInboxWorkflowQuery, GetWorkflowInboxWorkflowQueryVariables>(GetWorkflowInboxWorkflowDocument, options);
      }
export function useGetWorkflowInboxWorkflowLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowInboxWorkflowQuery, GetWorkflowInboxWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowInboxWorkflowQuery, GetWorkflowInboxWorkflowQueryVariables>(GetWorkflowInboxWorkflowDocument, options);
        }
export function useGetWorkflowInboxWorkflowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowInboxWorkflowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowInboxWorkflowQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowInboxWorkflowQuery, GetWorkflowInboxWorkflowQueryVariables>(GetWorkflowInboxWorkflowDocument, options);
        }
export type GetWorkflowInboxWorkflowQueryHookResult = ReturnType<typeof useGetWorkflowInboxWorkflowQuery>;
export type GetWorkflowInboxWorkflowLazyQueryHookResult = ReturnType<typeof useGetWorkflowInboxWorkflowLazyQuery>;
export type GetWorkflowInboxWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowInboxWorkflowSuspenseQuery>;
export type GetWorkflowInboxWorkflowQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowInboxWorkflowQuery, GetWorkflowInboxWorkflowQueryVariables>;
export const GetDocumentWorkflowsDocument = gql`
    query GetDocumentWorkflows($documentId: UUID!) {
  documentWorkflows(documentId: $documentId) {
    __typename
    id
    envelopeMsg
    name
    status
    state
    envelopeStatus
    variant
    requesterInOwnerOrg
    startedAt
    completedAt
    createdAt
    activeStep {
      __typename
      id
    }
    envelopeStatus
    envelope {
      __typename
      id
      docuSignEnvelopeId
      variant
    }
  }
}
    `;

/**
 * __useGetDocumentWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetDocumentWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentWorkflowsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentWorkflowsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetDocumentWorkflowsQuery, GetDocumentWorkflowsQueryVariables> & ({ variables: GetDocumentWorkflowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentWorkflowsQuery, GetDocumentWorkflowsQueryVariables>(GetDocumentWorkflowsDocument, options);
      }
export function useGetDocumentWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetDocumentWorkflowsQuery, GetDocumentWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentWorkflowsQuery, GetDocumentWorkflowsQueryVariables>(GetDocumentWorkflowsDocument, options);
        }
export function useGetDocumentWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetDocumentWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetDocumentWorkflowsQuery, GetDocumentWorkflowsQueryVariables>(GetDocumentWorkflowsDocument, options);
        }
export type GetDocumentWorkflowsQueryHookResult = ReturnType<typeof useGetDocumentWorkflowsQuery>;
export type GetDocumentWorkflowsLazyQueryHookResult = ReturnType<typeof useGetDocumentWorkflowsLazyQuery>;
export type GetDocumentWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentWorkflowsSuspenseQuery>;
export type GetDocumentWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<GetDocumentWorkflowsQuery, GetDocumentWorkflowsQueryVariables>;
export const GetMissingWorkflowActionsDocument = gql`
    query GetMissingWorkflowActions($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    requesterInOwnerOrg
    createdAt
    missingActions
  }
}
    `;

/**
 * __useGetMissingWorkflowActionsQuery__
 *
 * To run a query within a React component, call `useGetMissingWorkflowActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingWorkflowActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingWorkflowActionsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetMissingWorkflowActionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetMissingWorkflowActionsQuery, GetMissingWorkflowActionsQueryVariables> & ({ variables: GetMissingWorkflowActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMissingWorkflowActionsQuery, GetMissingWorkflowActionsQueryVariables>(GetMissingWorkflowActionsDocument, options);
      }
export function useGetMissingWorkflowActionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMissingWorkflowActionsQuery, GetMissingWorkflowActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMissingWorkflowActionsQuery, GetMissingWorkflowActionsQueryVariables>(GetMissingWorkflowActionsDocument, options);
        }
export function useGetMissingWorkflowActionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMissingWorkflowActionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMissingWorkflowActionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMissingWorkflowActionsQuery, GetMissingWorkflowActionsQueryVariables>(GetMissingWorkflowActionsDocument, options);
        }
export type GetMissingWorkflowActionsQueryHookResult = ReturnType<typeof useGetMissingWorkflowActionsQuery>;
export type GetMissingWorkflowActionsLazyQueryHookResult = ReturnType<typeof useGetMissingWorkflowActionsLazyQuery>;
export type GetMissingWorkflowActionsSuspenseQueryHookResult = ReturnType<typeof useGetMissingWorkflowActionsSuspenseQuery>;
export type GetMissingWorkflowActionsQueryResult = ApolloReactHooks.useQuery.Result<GetMissingWorkflowActionsQuery, GetMissingWorkflowActionsQueryVariables>;
export const GetUnusedWorkflowActionsDocument = gql`
    query GetUnusedWorkflowActions($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    requesterInOwnerOrg
    createdAt
    unusedActions {
      ...WorkflowRecipientSimple
    }
  }
}
    ${WorkflowRecipientSimpleFragmentDoc}`;

/**
 * __useGetUnusedWorkflowActionsQuery__
 *
 * To run a query within a React component, call `useGetUnusedWorkflowActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnusedWorkflowActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnusedWorkflowActionsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetUnusedWorkflowActionsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetUnusedWorkflowActionsQuery, GetUnusedWorkflowActionsQueryVariables> & ({ variables: GetUnusedWorkflowActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUnusedWorkflowActionsQuery, GetUnusedWorkflowActionsQueryVariables>(GetUnusedWorkflowActionsDocument, options);
      }
export function useGetUnusedWorkflowActionsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUnusedWorkflowActionsQuery, GetUnusedWorkflowActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUnusedWorkflowActionsQuery, GetUnusedWorkflowActionsQueryVariables>(GetUnusedWorkflowActionsDocument, options);
        }
export function useGetUnusedWorkflowActionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUnusedWorkflowActionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetUnusedWorkflowActionsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetUnusedWorkflowActionsQuery, GetUnusedWorkflowActionsQueryVariables>(GetUnusedWorkflowActionsDocument, options);
        }
export type GetUnusedWorkflowActionsQueryHookResult = ReturnType<typeof useGetUnusedWorkflowActionsQuery>;
export type GetUnusedWorkflowActionsLazyQueryHookResult = ReturnType<typeof useGetUnusedWorkflowActionsLazyQuery>;
export type GetUnusedWorkflowActionsSuspenseQueryHookResult = ReturnType<typeof useGetUnusedWorkflowActionsSuspenseQuery>;
export type GetUnusedWorkflowActionsQueryResult = ApolloReactHooks.useQuery.Result<GetUnusedWorkflowActionsQuery, GetUnusedWorkflowActionsQueryVariables>;
export const GetPopularTemplateWorkflowsDocument = gql`
    query GetPopularTemplateWorkflows($num: Int) {
  popularTemplateWorkflows(num: $num) {
    __typename
    id
    name
    numTimesUsed
    owner {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetPopularTemplateWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetPopularTemplateWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularTemplateWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularTemplateWorkflowsQuery({
 *   variables: {
 *      num: // value for 'num'
 *   },
 * });
 */
export function useGetPopularTemplateWorkflowsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetPopularTemplateWorkflowsQuery, GetPopularTemplateWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopularTemplateWorkflowsQuery, GetPopularTemplateWorkflowsQueryVariables>(GetPopularTemplateWorkflowsDocument, options);
      }
export function useGetPopularTemplateWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPopularTemplateWorkflowsQuery, GetPopularTemplateWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopularTemplateWorkflowsQuery, GetPopularTemplateWorkflowsQueryVariables>(GetPopularTemplateWorkflowsDocument, options);
        }
export function useGetPopularTemplateWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetPopularTemplateWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetPopularTemplateWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetPopularTemplateWorkflowsQuery, GetPopularTemplateWorkflowsQueryVariables>(GetPopularTemplateWorkflowsDocument, options);
        }
export type GetPopularTemplateWorkflowsQueryHookResult = ReturnType<typeof useGetPopularTemplateWorkflowsQuery>;
export type GetPopularTemplateWorkflowsLazyQueryHookResult = ReturnType<typeof useGetPopularTemplateWorkflowsLazyQuery>;
export type GetPopularTemplateWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetPopularTemplateWorkflowsSuspenseQuery>;
export type GetPopularTemplateWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<GetPopularTemplateWorkflowsQuery, GetPopularTemplateWorkflowsQueryVariables>;
export const GetMyMostUsedTemplateWorkflowsDocument = gql`
    query GetMyMostUsedTemplateWorkflows($num: Int) {
  myMostUsedTemplateWorkflows(num: $num) {
    __typename
    id
    name
    numTimesUsed
    owner {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetMyMostUsedTemplateWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetMyMostUsedTemplateWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMostUsedTemplateWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMostUsedTemplateWorkflowsQuery({
 *   variables: {
 *      num: // value for 'num'
 *   },
 * });
 */
export function useGetMyMostUsedTemplateWorkflowsQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetMyMostUsedTemplateWorkflowsQuery, GetMyMostUsedTemplateWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyMostUsedTemplateWorkflowsQuery, GetMyMostUsedTemplateWorkflowsQueryVariables>(GetMyMostUsedTemplateWorkflowsDocument, options);
      }
export function useGetMyMostUsedTemplateWorkflowsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetMyMostUsedTemplateWorkflowsQuery, GetMyMostUsedTemplateWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyMostUsedTemplateWorkflowsQuery, GetMyMostUsedTemplateWorkflowsQueryVariables>(GetMyMostUsedTemplateWorkflowsDocument, options);
        }
export function useGetMyMostUsedTemplateWorkflowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetMyMostUsedTemplateWorkflowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetMyMostUsedTemplateWorkflowsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetMyMostUsedTemplateWorkflowsQuery, GetMyMostUsedTemplateWorkflowsQueryVariables>(GetMyMostUsedTemplateWorkflowsDocument, options);
        }
export type GetMyMostUsedTemplateWorkflowsQueryHookResult = ReturnType<typeof useGetMyMostUsedTemplateWorkflowsQuery>;
export type GetMyMostUsedTemplateWorkflowsLazyQueryHookResult = ReturnType<typeof useGetMyMostUsedTemplateWorkflowsLazyQuery>;
export type GetMyMostUsedTemplateWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetMyMostUsedTemplateWorkflowsSuspenseQuery>;
export type GetMyMostUsedTemplateWorkflowsQueryResult = ApolloReactHooks.useQuery.Result<GetMyMostUsedTemplateWorkflowsQuery, GetMyMostUsedTemplateWorkflowsQueryVariables>;
export const GetWorkflowForwardSettingsDocument = gql`
    query GetWorkflowForwardSettings($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    forwardingPermissionRole
    variant
    state
    owner {
      ...UserBase
    }
  }
}
    ${UserBaseFragmentDoc}`;

/**
 * __useGetWorkflowForwardSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowForwardSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowForwardSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowForwardSettingsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowForwardSettingsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowForwardSettingsQuery, GetWorkflowForwardSettingsQueryVariables> & ({ variables: GetWorkflowForwardSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowForwardSettingsQuery, GetWorkflowForwardSettingsQueryVariables>(GetWorkflowForwardSettingsDocument, options);
      }
export function useGetWorkflowForwardSettingsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowForwardSettingsQuery, GetWorkflowForwardSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowForwardSettingsQuery, GetWorkflowForwardSettingsQueryVariables>(GetWorkflowForwardSettingsDocument, options);
        }
export function useGetWorkflowForwardSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowForwardSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowForwardSettingsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowForwardSettingsQuery, GetWorkflowForwardSettingsQueryVariables>(GetWorkflowForwardSettingsDocument, options);
        }
export type GetWorkflowForwardSettingsQueryHookResult = ReturnType<typeof useGetWorkflowForwardSettingsQuery>;
export type GetWorkflowForwardSettingsLazyQueryHookResult = ReturnType<typeof useGetWorkflowForwardSettingsLazyQuery>;
export type GetWorkflowForwardSettingsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowForwardSettingsSuspenseQuery>;
export type GetWorkflowForwardSettingsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowForwardSettingsQuery, GetWorkflowForwardSettingsQueryVariables>;
export const GetWorkflowWithBoardDocument = gql`
    query GetWorkflowWithBoard($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    skipTriage
    variant
    column {
      __typename
      id
      board {
        __typename
        id
        triageColumn {
          id
        }
        columns {
          ...ColumnBase
        }
      }
    }
    doneColumn {
      ...ColumnBase
    }
  }
}
    ${ColumnBaseFragmentDoc}`;

/**
 * __useGetWorkflowWithBoardQuery__
 *
 * To run a query within a React component, call `useGetWorkflowWithBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowWithBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowWithBoardQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowWithBoardQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowWithBoardQuery, GetWorkflowWithBoardQueryVariables> & ({ variables: GetWorkflowWithBoardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowWithBoardQuery, GetWorkflowWithBoardQueryVariables>(GetWorkflowWithBoardDocument, options);
      }
export function useGetWorkflowWithBoardLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowWithBoardQuery, GetWorkflowWithBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowWithBoardQuery, GetWorkflowWithBoardQueryVariables>(GetWorkflowWithBoardDocument, options);
        }
export function useGetWorkflowWithBoardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithBoardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowWithBoardQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowWithBoardQuery, GetWorkflowWithBoardQueryVariables>(GetWorkflowWithBoardDocument, options);
        }
export type GetWorkflowWithBoardQueryHookResult = ReturnType<typeof useGetWorkflowWithBoardQuery>;
export type GetWorkflowWithBoardLazyQueryHookResult = ReturnType<typeof useGetWorkflowWithBoardLazyQuery>;
export type GetWorkflowWithBoardSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowWithBoardSuspenseQuery>;
export type GetWorkflowWithBoardQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowWithBoardQuery, GetWorkflowWithBoardQueryVariables>;
export const GetWorkflowBlockersDocument = gql`
    query GetWorkflowBlockers($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    __typename
    id
    variant
    status
    state
    envelopeStatus
    missingActions
    envelope {
      __typename
      id
      createdAt
    }
    activeStep {
      __typename
      id
      createdAt
      startedAt
      completedAt
      actions {
        ...WorkBlockerWorkflowRecipient
      }
      requesterActions {
        ...WorkBlockerWorkflowRecipient
      }
    }
    ...WorkflowSigningPhaseStepsSummary
  }
}
    ${WorkBlockerWorkflowRecipientFragmentDoc}
${WorkflowSigningPhaseStepsSummaryFragmentDoc}`;

/**
 * __useGetWorkflowBlockersQuery__
 *
 * To run a query within a React component, call `useGetWorkflowBlockersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowBlockersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowBlockersQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowBlockersQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowBlockersQuery, GetWorkflowBlockersQueryVariables> & ({ variables: GetWorkflowBlockersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowBlockersQuery, GetWorkflowBlockersQueryVariables>(GetWorkflowBlockersDocument, options);
      }
export function useGetWorkflowBlockersLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowBlockersQuery, GetWorkflowBlockersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowBlockersQuery, GetWorkflowBlockersQueryVariables>(GetWorkflowBlockersDocument, options);
        }
export function useGetWorkflowBlockersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowBlockersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowBlockersQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowBlockersQuery, GetWorkflowBlockersQueryVariables>(GetWorkflowBlockersDocument, options);
        }
export type GetWorkflowBlockersQueryHookResult = ReturnType<typeof useGetWorkflowBlockersQuery>;
export type GetWorkflowBlockersLazyQueryHookResult = ReturnType<typeof useGetWorkflowBlockersLazyQuery>;
export type GetWorkflowBlockersSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowBlockersSuspenseQuery>;
export type GetWorkflowBlockersQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowBlockersQuery, GetWorkflowBlockersQueryVariables>;
export const AddDocumentsToWorkflowDocument = gql`
    mutation AddDocumentsToWorkflow($input: AddDocumentsToWorkflowInput!) {
  addDocumentsToWorkflow(input: $input) {
    workflow {
      __typename
      id
      missingActions
      activeStep {
        __typename
        id
      }
      files {
        ...WorkflowFileSimple
      }
      ...WorkflowSigningPhaseSteps
      parties {
        ...PartySimple
      }
    }
  }
}
    ${WorkflowFileSimpleFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}
${PartySimpleFragmentDoc}`;
export type AddDocumentsToWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddDocumentsToWorkflowMutation, AddDocumentsToWorkflowMutationVariables>;

/**
 * __useAddDocumentsToWorkflowMutation__
 *
 * To run a mutation, you first call `useAddDocumentsToWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentsToWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentsToWorkflowMutation, { data, loading, error }] = useAddDocumentsToWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDocumentsToWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<AddDocumentsToWorkflowMutation, AddDocumentsToWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddDocumentsToWorkflowMutation, AddDocumentsToWorkflowMutationVariables>(AddDocumentsToWorkflowDocument, options);
      }
export type AddDocumentsToWorkflowMutationHookResult = ReturnType<typeof useAddDocumentsToWorkflowMutation>;
export type AddDocumentsToWorkflowMutationResult = ApolloReactHooks.useMutation.Result<AddDocumentsToWorkflowMutation>;
export type AddDocumentsToWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<AddDocumentsToWorkflowMutation, AddDocumentsToWorkflowMutationVariables>;
export const RemoveDocumentsFromWorkflowDocument = gql`
    mutation RemoveDocumentsFromWorkflow($input: RemoveDocumentsFromWorkflowInput!) {
  removeDocumentsFromWorkflow(input: $input) {
    workflow {
      __typename
      id
      missingActions
      activeStep {
        __typename
        id
      }
      files {
        ...WorkflowFileSimple
      }
      ...WorkflowSigningPhaseSteps
      parties {
        ...PartySimple
      }
      tasks {
        ...TaskSimple
      }
    }
  }
}
    ${WorkflowFileSimpleFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}
${PartySimpleFragmentDoc}
${TaskSimpleFragmentDoc}`;
export type RemoveDocumentsFromWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<RemoveDocumentsFromWorkflowMutation, RemoveDocumentsFromWorkflowMutationVariables>;

/**
 * __useRemoveDocumentsFromWorkflowMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentsFromWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentsFromWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentsFromWorkflowMutation, { data, loading, error }] = useRemoveDocumentsFromWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDocumentsFromWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RemoveDocumentsFromWorkflowMutation, RemoveDocumentsFromWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveDocumentsFromWorkflowMutation, RemoveDocumentsFromWorkflowMutationVariables>(RemoveDocumentsFromWorkflowDocument, options);
      }
export type RemoveDocumentsFromWorkflowMutationHookResult = ReturnType<typeof useRemoveDocumentsFromWorkflowMutation>;
export type RemoveDocumentsFromWorkflowMutationResult = ApolloReactHooks.useMutation.Result<RemoveDocumentsFromWorkflowMutation>;
export type RemoveDocumentsFromWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<RemoveDocumentsFromWorkflowMutation, RemoveDocumentsFromWorkflowMutationVariables>;
export const InitializeWorkflowDocument = gql`
    mutation InitializeWorkflow($input: InitializeWorkflowInput!) {
  initializeWorkflow(input: $input) {
    workflow {
      __typename
      id
      name
      variant
      state
      envelopeStatus
      labels {
        ...LabelSimple
      }
      envelope {
        __typename
        id
      }
      files {
        __typename
        id
        document {
          __typename
          id
          createdAt
        }
      }
      column {
        __typename
        id
        name
      }
    }
    refetch {
      currentUser {
        id
        numWorkflowsCreatedThisMonth
      }
    }
  }
}
    ${LabelSimpleFragmentDoc}`;
export type InitializeWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<InitializeWorkflowMutation, InitializeWorkflowMutationVariables>;

/**
 * __useInitializeWorkflowMutation__
 *
 * To run a mutation, you first call `useInitializeWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeWorkflowMutation, { data, loading, error }] = useInitializeWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitializeWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<InitializeWorkflowMutation, InitializeWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InitializeWorkflowMutation, InitializeWorkflowMutationVariables>(InitializeWorkflowDocument, options);
      }
export type InitializeWorkflowMutationHookResult = ReturnType<typeof useInitializeWorkflowMutation>;
export type InitializeWorkflowMutationResult = ApolloReactHooks.useMutation.Result<InitializeWorkflowMutation>;
export type InitializeWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<InitializeWorkflowMutation, InitializeWorkflowMutationVariables>;
export const CreateWorkflowForDocumentsDocument = gql`
    mutation CreateWorkflowForDocuments($input: InitializeWorkflowInput!) {
  initializeWorkflow(input: $input) {
    workflow {
      __typename
      id
      name
      variant
      state
      envelopeStatus
      publishedAt
      envelope {
        __typename
        id
        variant
      }
      files {
        __typename
        id
        document {
          __typename
          id
          createdAt
        }
      }
      ...WorkflowSigningPhaseSteps
      column {
        __typename
        id
        name
      }
    }
    refetch {
      currentUser {
        id
        numWorkflowsCreatedThisMonth
      }
    }
  }
}
    ${WorkflowSigningPhaseStepsFragmentDoc}`;
export type CreateWorkflowForDocumentsMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateWorkflowForDocumentsMutation, CreateWorkflowForDocumentsMutationVariables>;

/**
 * __useCreateWorkflowForDocumentsMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowForDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowForDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowForDocumentsMutation, { data, loading, error }] = useCreateWorkflowForDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowForDocumentsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateWorkflowForDocumentsMutation, CreateWorkflowForDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkflowForDocumentsMutation, CreateWorkflowForDocumentsMutationVariables>(CreateWorkflowForDocumentsDocument, options);
      }
export type CreateWorkflowForDocumentsMutationHookResult = ReturnType<typeof useCreateWorkflowForDocumentsMutation>;
export type CreateWorkflowForDocumentsMutationResult = ApolloReactHooks.useMutation.Result<CreateWorkflowForDocumentsMutation>;
export type CreateWorkflowForDocumentsMutationOptions = ApolloReactHooks.useMutation.Options<CreateWorkflowForDocumentsMutation, CreateWorkflowForDocumentsMutationVariables>;
export const ChangeRecipientAssignmentDocument = gql`
    mutation ChangeRecipientAssignment($input: ChangeRecipientAssignmentInput!) {
  changeRecipientAssignment(input: $input) {
    ...WorkflowRecipientWithFields
  }
}
    ${WorkflowRecipientWithFieldsFragmentDoc}`;
export type ChangeRecipientAssignmentMutationFn = ApolloReactHooks.useMutation.MutationFunction<ChangeRecipientAssignmentMutation, ChangeRecipientAssignmentMutationVariables>;

/**
 * __useChangeRecipientAssignmentMutation__
 *
 * To run a mutation, you first call `useChangeRecipientAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeRecipientAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeRecipientAssignmentMutation, { data, loading, error }] = useChangeRecipientAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeRecipientAssignmentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ChangeRecipientAssignmentMutation, ChangeRecipientAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeRecipientAssignmentMutation, ChangeRecipientAssignmentMutationVariables>(ChangeRecipientAssignmentDocument, options);
      }
export type ChangeRecipientAssignmentMutationHookResult = ReturnType<typeof useChangeRecipientAssignmentMutation>;
export type ChangeRecipientAssignmentMutationResult = ApolloReactHooks.useMutation.Result<ChangeRecipientAssignmentMutation>;
export type ChangeRecipientAssignmentMutationOptions = ApolloReactHooks.useMutation.Options<ChangeRecipientAssignmentMutation, ChangeRecipientAssignmentMutationVariables>;
export const ChangeCollaboratorAssignmentDocument = gql`
    mutation ChangeCollaboratorAssignment($input: ChangeCollaboratorAssignmentInput!) {
  changeCollaboratorAssignment(input: $input) {
    ...WorkflowPermissionSimple
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;
export type ChangeCollaboratorAssignmentMutationFn = ApolloReactHooks.useMutation.MutationFunction<ChangeCollaboratorAssignmentMutation, ChangeCollaboratorAssignmentMutationVariables>;

/**
 * __useChangeCollaboratorAssignmentMutation__
 *
 * To run a mutation, you first call `useChangeCollaboratorAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCollaboratorAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCollaboratorAssignmentMutation, { data, loading, error }] = useChangeCollaboratorAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCollaboratorAssignmentMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ChangeCollaboratorAssignmentMutation, ChangeCollaboratorAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeCollaboratorAssignmentMutation, ChangeCollaboratorAssignmentMutationVariables>(ChangeCollaboratorAssignmentDocument, options);
      }
export type ChangeCollaboratorAssignmentMutationHookResult = ReturnType<typeof useChangeCollaboratorAssignmentMutation>;
export type ChangeCollaboratorAssignmentMutationResult = ApolloReactHooks.useMutation.Result<ChangeCollaboratorAssignmentMutation>;
export type ChangeCollaboratorAssignmentMutationOptions = ApolloReactHooks.useMutation.Options<ChangeCollaboratorAssignmentMutation, ChangeCollaboratorAssignmentMutationVariables>;
export const CreateWorkflowInstanceDocument = gql`
    mutation CreateWorkflowInstance($input: CreateWorkflowInstanceInput!) {
  createWorkflowInstance(input: $input) {
    workflow {
      __typename
      id
      createdAt
      forwardingPermissionRole
      state
      envelopeStatus
      linkedOpportunities {
        __typename
        id
        integration
      }
      envelope {
        __typename
        id
        variant
      }
      files {
        __typename
        id
        orderId
        document {
          __typename
          id
          createdAt
        }
      }
      column {
        __typename
        id
        name
      }
    }
    refetch {
      currentUser {
        id
        numWorkflowsCreatedThisMonth
      }
    }
  }
}
    `;
export type CreateWorkflowInstanceMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateWorkflowInstanceMutation, CreateWorkflowInstanceMutationVariables>;

/**
 * __useCreateWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowInstanceMutation, { data, loading, error }] = useCreateWorkflowInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowInstanceMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CreateWorkflowInstanceMutation, CreateWorkflowInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkflowInstanceMutation, CreateWorkflowInstanceMutationVariables>(CreateWorkflowInstanceDocument, options);
      }
export type CreateWorkflowInstanceMutationHookResult = ReturnType<typeof useCreateWorkflowInstanceMutation>;
export type CreateWorkflowInstanceMutationResult = ApolloReactHooks.useMutation.Result<CreateWorkflowInstanceMutation>;
export type CreateWorkflowInstanceMutationOptions = ApolloReactHooks.useMutation.Options<CreateWorkflowInstanceMutation, CreateWorkflowInstanceMutationVariables>;
export const DeleteWorkflowDocument = gql`
    mutation DeleteWorkflow($workflowId: UUID!) {
  deleteWorkflow(workflowId: $workflowId)
}
    `;
export type DeleteWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;

/**
 * __useDeleteWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowMutation, { data, loading, error }] = useDeleteWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useDeleteWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>(DeleteWorkflowDocument, options);
      }
export type DeleteWorkflowMutationHookResult = ReturnType<typeof useDeleteWorkflowMutation>;
export type DeleteWorkflowMutationResult = ApolloReactHooks.useMutation.Result<DeleteWorkflowMutation>;
export type DeleteWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;
export const CancelWorkflowAiBuildDocument = gql`
    mutation CancelWorkflowAiBuild($workflowId: UUID!) {
  cancelWorkflowAiBuild(workflowId: $workflowId) {
    id
    aiStartedAt
    aiFinishedAt
    aiFailedAt
    aiCancelledAt
    aiFailureReason
  }
}
    `;
export type CancelWorkflowAiBuildMutationFn = ApolloReactHooks.useMutation.MutationFunction<CancelWorkflowAiBuildMutation, CancelWorkflowAiBuildMutationVariables>;

/**
 * __useCancelWorkflowAiBuildMutation__
 *
 * To run a mutation, you first call `useCancelWorkflowAiBuildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWorkflowAiBuildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWorkflowAiBuildMutation, { data, loading, error }] = useCancelWorkflowAiBuildMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useCancelWorkflowAiBuildMutation(baseOptions?: ApolloReactHooks.useMutation.Options<CancelWorkflowAiBuildMutation, CancelWorkflowAiBuildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelWorkflowAiBuildMutation, CancelWorkflowAiBuildMutationVariables>(CancelWorkflowAiBuildDocument, options);
      }
export type CancelWorkflowAiBuildMutationHookResult = ReturnType<typeof useCancelWorkflowAiBuildMutation>;
export type CancelWorkflowAiBuildMutationResult = ApolloReactHooks.useMutation.Result<CancelWorkflowAiBuildMutation>;
export type CancelWorkflowAiBuildMutationOptions = ApolloReactHooks.useMutation.Options<CancelWorkflowAiBuildMutation, CancelWorkflowAiBuildMutationVariables>;
export const DeleteWorkflowActionsDocument = gql`
    mutation DeleteWorkflowActions($input: DeleteWorkflowActionsInput!) {
  deleteWorkflowActions(input: $input) {
    workflow {
      __typename
      id
      envelopeMsg
      forwardingPermissionRole
      name
      description
      status
      state
      envelopeStatus
      isCommunityWorkflow
      requesterInOwnerOrg
      createdAt
      variant
      missingActions
      activeStep {
        __typename
        id
      }
      ...WorkflowSigningPhaseSteps
      tasks {
        ...TaskSimple
      }
    }
  }
}
    ${WorkflowSigningPhaseStepsFragmentDoc}
${TaskSimpleFragmentDoc}`;
export type DeleteWorkflowActionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteWorkflowActionsMutation, DeleteWorkflowActionsMutationVariables>;

/**
 * __useDeleteWorkflowActionsMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowActionsMutation, { data, loading, error }] = useDeleteWorkflowActionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkflowActionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<DeleteWorkflowActionsMutation, DeleteWorkflowActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkflowActionsMutation, DeleteWorkflowActionsMutationVariables>(DeleteWorkflowActionsDocument, options);
      }
export type DeleteWorkflowActionsMutationHookResult = ReturnType<typeof useDeleteWorkflowActionsMutation>;
export type DeleteWorkflowActionsMutationResult = ApolloReactHooks.useMutation.Result<DeleteWorkflowActionsMutation>;
export type DeleteWorkflowActionsMutationOptions = ApolloReactHooks.useMutation.Options<DeleteWorkflowActionsMutation, DeleteWorkflowActionsMutationVariables>;
export const FinishFieldActionsDocument = gql`
    mutation FinishFieldActions($workflowId: UUID!) {
  finishFieldActions(workflowId: $workflowId) {
    workflow {
      __typename
      id
      completedAt
      variant
      status
      state
      activeStep {
        ...WorkflowStepFragment
      }
      ...WorkflowSigningPhaseSteps
      createdAt
      updatedAt
    }
  }
}
    ${WorkflowStepFragmentFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}`;
export type FinishFieldActionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<FinishFieldActionsMutation, FinishFieldActionsMutationVariables>;

/**
 * __useFinishFieldActionsMutation__
 *
 * To run a mutation, you first call `useFinishFieldActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishFieldActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishFieldActionsMutation, { data, loading, error }] = useFinishFieldActionsMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useFinishFieldActionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<FinishFieldActionsMutation, FinishFieldActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FinishFieldActionsMutation, FinishFieldActionsMutationVariables>(FinishFieldActionsDocument, options);
      }
export type FinishFieldActionsMutationHookResult = ReturnType<typeof useFinishFieldActionsMutation>;
export type FinishFieldActionsMutationResult = ApolloReactHooks.useMutation.Result<FinishFieldActionsMutation>;
export type FinishFieldActionsMutationOptions = ApolloReactHooks.useMutation.Options<FinishFieldActionsMutation, FinishFieldActionsMutationVariables>;
export const ForwardWorkflowDocument = gql`
    mutation ForwardWorkflow($input: ForwardWorkflowInput!) {
  forwardWorkflow(input: $input) {
    workflow {
      __typename
      id
      permissions {
        ...WorkflowPermissionSimple
      }
    }
  }
}
    ${WorkflowPermissionSimpleFragmentDoc}`;
export type ForwardWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<ForwardWorkflowMutation, ForwardWorkflowMutationVariables>;

/**
 * __useForwardWorkflowMutation__
 *
 * To run a mutation, you first call `useForwardWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForwardWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forwardWorkflowMutation, { data, loading, error }] = useForwardWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForwardWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ForwardWorkflowMutation, ForwardWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ForwardWorkflowMutation, ForwardWorkflowMutationVariables>(ForwardWorkflowDocument, options);
      }
export type ForwardWorkflowMutationHookResult = ReturnType<typeof useForwardWorkflowMutation>;
export type ForwardWorkflowMutationResult = ApolloReactHooks.useMutation.Result<ForwardWorkflowMutation>;
export type ForwardWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<ForwardWorkflowMutation, ForwardWorkflowMutationVariables>;
export const MoveWorkflowStepActionsDocument = gql`
    mutation MoveWorkflowStepActions($input: MoveWorkflowStepActionsInput!) {
  moveWorkflowStepActions(input: $input) {
    workflow {
      ...WorkflowFragment
    }
  }
}
    ${WorkflowFragmentFragmentDoc}`;
export type MoveWorkflowStepActionsMutationFn = ApolloReactHooks.useMutation.MutationFunction<MoveWorkflowStepActionsMutation, MoveWorkflowStepActionsMutationVariables>;

/**
 * __useMoveWorkflowStepActionsMutation__
 *
 * To run a mutation, you first call `useMoveWorkflowStepActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveWorkflowStepActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveWorkflowStepActionsMutation, { data, loading, error }] = useMoveWorkflowStepActionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveWorkflowStepActionsMutation(baseOptions?: ApolloReactHooks.useMutation.Options<MoveWorkflowStepActionsMutation, MoveWorkflowStepActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveWorkflowStepActionsMutation, MoveWorkflowStepActionsMutationVariables>(MoveWorkflowStepActionsDocument, options);
      }
export type MoveWorkflowStepActionsMutationHookResult = ReturnType<typeof useMoveWorkflowStepActionsMutation>;
export type MoveWorkflowStepActionsMutationResult = ApolloReactHooks.useMutation.Result<MoveWorkflowStepActionsMutation>;
export type MoveWorkflowStepActionsMutationOptions = ApolloReactHooks.useMutation.Options<MoveWorkflowStepActionsMutation, MoveWorkflowStepActionsMutationVariables>;
export const ToggleWorkflowOrderDocument = gql`
    mutation ToggleWorkflowOrder($input: ToggleWorkflowOrderInput!) {
  toggleWorkflowOrder(input: $input) {
    workflow {
      ...WorkflowFragment
    }
  }
}
    ${WorkflowFragmentFragmentDoc}`;
export type ToggleWorkflowOrderMutationFn = ApolloReactHooks.useMutation.MutationFunction<ToggleWorkflowOrderMutation, ToggleWorkflowOrderMutationVariables>;

/**
 * __useToggleWorkflowOrderMutation__
 *
 * To run a mutation, you first call `useToggleWorkflowOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWorkflowOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWorkflowOrderMutation, { data, loading, error }] = useToggleWorkflowOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleWorkflowOrderMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ToggleWorkflowOrderMutation, ToggleWorkflowOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleWorkflowOrderMutation, ToggleWorkflowOrderMutationVariables>(ToggleWorkflowOrderDocument, options);
      }
export type ToggleWorkflowOrderMutationHookResult = ReturnType<typeof useToggleWorkflowOrderMutation>;
export type ToggleWorkflowOrderMutationResult = ApolloReactHooks.useMutation.Result<ToggleWorkflowOrderMutation>;
export type ToggleWorkflowOrderMutationOptions = ApolloReactHooks.useMutation.Options<ToggleWorkflowOrderMutation, ToggleWorkflowOrderMutationVariables>;
export const RequestAccessToDocumentWorkflowDocument = gql`
    mutation RequestAccessToDocumentWorkflow($input: RequestAccessToDocumentWorkflowInput!) {
  requestAccessToDocumentWorkflow(input: $input)
}
    `;
export type RequestAccessToDocumentWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<RequestAccessToDocumentWorkflowMutation, RequestAccessToDocumentWorkflowMutationVariables>;

/**
 * __useRequestAccessToDocumentWorkflowMutation__
 *
 * To run a mutation, you first call `useRequestAccessToDocumentWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessToDocumentWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccessToDocumentWorkflowMutation, { data, loading, error }] = useRequestAccessToDocumentWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestAccessToDocumentWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RequestAccessToDocumentWorkflowMutation, RequestAccessToDocumentWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestAccessToDocumentWorkflowMutation, RequestAccessToDocumentWorkflowMutationVariables>(RequestAccessToDocumentWorkflowDocument, options);
      }
export type RequestAccessToDocumentWorkflowMutationHookResult = ReturnType<typeof useRequestAccessToDocumentWorkflowMutation>;
export type RequestAccessToDocumentWorkflowMutationResult = ApolloReactHooks.useMutation.Result<RequestAccessToDocumentWorkflowMutation>;
export type RequestAccessToDocumentWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<RequestAccessToDocumentWorkflowMutation, RequestAccessToDocumentWorkflowMutationVariables>;
export const RelocateWorkflowToBoardDocument = gql`
    mutation RelocateWorkflowToBoard($input: RelocateWorkflowToBoardInput!) {
  relocateWorkflowToBoard(input: $input) {
    workflow {
      __typename
      id
      boardId
      column {
        __typename
        id
        category
        color
        name
        sortKey
        board {
          id
        }
      }
      doneColumn {
        __typename
        id
        category
        color
        name
        sortKey
      }
      phases {
        __typename
        id
        column {
          id
        }
      }
    }
  }
}
    `;
export type RelocateWorkflowToBoardMutationFn = ApolloReactHooks.useMutation.MutationFunction<RelocateWorkflowToBoardMutation, RelocateWorkflowToBoardMutationVariables>;

/**
 * __useRelocateWorkflowToBoardMutation__
 *
 * To run a mutation, you first call `useRelocateWorkflowToBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelocateWorkflowToBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relocateWorkflowToBoardMutation, { data, loading, error }] = useRelocateWorkflowToBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRelocateWorkflowToBoardMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RelocateWorkflowToBoardMutation, RelocateWorkflowToBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RelocateWorkflowToBoardMutation, RelocateWorkflowToBoardMutationVariables>(RelocateWorkflowToBoardDocument, options);
      }
export type RelocateWorkflowToBoardMutationHookResult = ReturnType<typeof useRelocateWorkflowToBoardMutation>;
export type RelocateWorkflowToBoardMutationResult = ApolloReactHooks.useMutation.Result<RelocateWorkflowToBoardMutation>;
export type RelocateWorkflowToBoardMutationOptions = ApolloReactHooks.useMutation.Options<RelocateWorkflowToBoardMutation, RelocateWorkflowToBoardMutationVariables>;
export const UpdateWorkflowDocument = gql`
    mutation UpdateWorkflow($input: UpdateWorkflowInput!) {
  updateWorkflow(input: $input) {
    workflow {
      __typename
      id
      description
      envelopeMsg
      forwardingPermissionRole
      name
      priority
      skipTriage
      startedAt
      column {
        __typename
        id
        category
        color
        name
        sortKey
      }
      doneColumn {
        __typename
        id
        category
        color
        name
        sortKey
      }
    }
  }
}
    `;
export type UpdateWorkflowMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;

/**
 * __useUpdateWorkflowMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowMutation, { data, loading, error }] = useUpdateWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowMutation(baseOptions?: ApolloReactHooks.useMutation.Options<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>(UpdateWorkflowDocument, options);
      }
export type UpdateWorkflowMutationHookResult = ReturnType<typeof useUpdateWorkflowMutation>;
export type UpdateWorkflowMutationResult = ApolloReactHooks.useMutation.Result<UpdateWorkflowMutation>;
export type UpdateWorkflowMutationOptions = ApolloReactHooks.useMutation.Options<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const SetWorkflowCrmPublishDocument = gql`
    mutation SetWorkflowCrmPublish($input: UpdateWorkflowInput!) {
  updateWorkflow(input: $input) {
    workflow {
      __typename
      id
      crmIntegrations
    }
  }
}
    `;
export type SetWorkflowCrmPublishMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetWorkflowCrmPublishMutation, SetWorkflowCrmPublishMutationVariables>;

/**
 * __useSetWorkflowCrmPublishMutation__
 *
 * To run a mutation, you first call `useSetWorkflowCrmPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkflowCrmPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkflowCrmPublishMutation, { data, loading, error }] = useSetWorkflowCrmPublishMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkflowCrmPublishMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetWorkflowCrmPublishMutation, SetWorkflowCrmPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkflowCrmPublishMutation, SetWorkflowCrmPublishMutationVariables>(SetWorkflowCrmPublishDocument, options);
      }
export type SetWorkflowCrmPublishMutationHookResult = ReturnType<typeof useSetWorkflowCrmPublishMutation>;
export type SetWorkflowCrmPublishMutationResult = ApolloReactHooks.useMutation.Result<SetWorkflowCrmPublishMutation>;
export type SetWorkflowCrmPublishMutationOptions = ApolloReactHooks.useMutation.Options<SetWorkflowCrmPublishMutation, SetWorkflowCrmPublishMutationVariables>;
export const StartWorkflowWorkDocument = gql`
    mutation StartWorkflowWork($workflowId: UUID!, $columnId: UUID) {
  startWorkflowWork(workflowId: $workflowId, columnId: $columnId) {
    __typename
    id
    startedAt
    state
    column {
      __typename
      id
      category
      color
      name
      sortKey
    }
  }
}
    `;
export type StartWorkflowWorkMutationFn = ApolloReactHooks.useMutation.MutationFunction<StartWorkflowWorkMutation, StartWorkflowWorkMutationVariables>;

/**
 * __useStartWorkflowWorkMutation__
 *
 * To run a mutation, you first call `useStartWorkflowWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartWorkflowWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startWorkflowWorkMutation, { data, loading, error }] = useStartWorkflowWorkMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useStartWorkflowWorkMutation(baseOptions?: ApolloReactHooks.useMutation.Options<StartWorkflowWorkMutation, StartWorkflowWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartWorkflowWorkMutation, StartWorkflowWorkMutationVariables>(StartWorkflowWorkDocument, options);
      }
export type StartWorkflowWorkMutationHookResult = ReturnType<typeof useStartWorkflowWorkMutation>;
export type StartWorkflowWorkMutationResult = ApolloReactHooks.useMutation.Result<StartWorkflowWorkMutation>;
export type StartWorkflowWorkMutationOptions = ApolloReactHooks.useMutation.Options<StartWorkflowWorkMutation, StartWorkflowWorkMutationVariables>;
export const RenotifyCurrentStepDocument = gql`
    mutation RenotifyCurrentStep($workflowId: UUID!) {
  renotifyCurrentStep(workflowId: $workflowId) {
    workflow {
      __typename
      id
      activeStep {
        ...WorkflowStepFragment
      }
      ...WorkflowSigningPhaseSteps
    }
  }
}
    ${WorkflowStepFragmentFragmentDoc}
${WorkflowSigningPhaseStepsFragmentDoc}`;
export type RenotifyCurrentStepMutationFn = ApolloReactHooks.useMutation.MutationFunction<RenotifyCurrentStepMutation, RenotifyCurrentStepMutationVariables>;

/**
 * __useRenotifyCurrentStepMutation__
 *
 * To run a mutation, you first call `useRenotifyCurrentStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenotifyCurrentStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renotifyCurrentStepMutation, { data, loading, error }] = useRenotifyCurrentStepMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useRenotifyCurrentStepMutation(baseOptions?: ApolloReactHooks.useMutation.Options<RenotifyCurrentStepMutation, RenotifyCurrentStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenotifyCurrentStepMutation, RenotifyCurrentStepMutationVariables>(RenotifyCurrentStepDocument, options);
      }
export type RenotifyCurrentStepMutationHookResult = ReturnType<typeof useRenotifyCurrentStepMutation>;
export type RenotifyCurrentStepMutationResult = ApolloReactHooks.useMutation.Result<RenotifyCurrentStepMutation>;
export type RenotifyCurrentStepMutationOptions = ApolloReactHooks.useMutation.Options<RenotifyCurrentStepMutation, RenotifyCurrentStepMutationVariables>;
export const SendWorkflowForSignatureDocument = gql`
    mutation SendWorkflowForSignature($input: SendWorkflowForSignatureInput!) {
  sendWorkflowForSignature(input: $input) {
    workflow {
      ...WorkflowWithFiles
    }
  }
}
    ${WorkflowWithFilesFragmentDoc}`;
export type SendWorkflowForSignatureMutationFn = ApolloReactHooks.useMutation.MutationFunction<SendWorkflowForSignatureMutation, SendWorkflowForSignatureMutationVariables>;

/**
 * __useSendWorkflowForSignatureMutation__
 *
 * To run a mutation, you first call `useSendWorkflowForSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendWorkflowForSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendWorkflowForSignatureMutation, { data, loading, error }] = useSendWorkflowForSignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendWorkflowForSignatureMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SendWorkflowForSignatureMutation, SendWorkflowForSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendWorkflowForSignatureMutation, SendWorkflowForSignatureMutationVariables>(SendWorkflowForSignatureDocument, options);
      }
export type SendWorkflowForSignatureMutationHookResult = ReturnType<typeof useSendWorkflowForSignatureMutation>;
export type SendWorkflowForSignatureMutationResult = ApolloReactHooks.useMutation.Result<SendWorkflowForSignatureMutation>;
export type SendWorkflowForSignatureMutationOptions = ApolloReactHooks.useMutation.Options<SendWorkflowForSignatureMutation, SendWorkflowForSignatureMutationVariables>;
export const FinishSigningOutsideAlineDocument = gql`
    mutation FinishSigningOutsideAline($workflowId: UUID!) {
  finishSigningOutsideAline(workflowId: $workflowId) {
    workflow {
      __typename
      id
      isSignedOutsideAline
      state
      status
      activeStep {
        ...WorkflowStepFragment
      }
    }
  }
}
    ${WorkflowStepFragmentFragmentDoc}`;
export type FinishSigningOutsideAlineMutationFn = ApolloReactHooks.useMutation.MutationFunction<FinishSigningOutsideAlineMutation, FinishSigningOutsideAlineMutationVariables>;

/**
 * __useFinishSigningOutsideAlineMutation__
 *
 * To run a mutation, you first call `useFinishSigningOutsideAlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSigningOutsideAlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSigningOutsideAlineMutation, { data, loading, error }] = useFinishSigningOutsideAlineMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useFinishSigningOutsideAlineMutation(baseOptions?: ApolloReactHooks.useMutation.Options<FinishSigningOutsideAlineMutation, FinishSigningOutsideAlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FinishSigningOutsideAlineMutation, FinishSigningOutsideAlineMutationVariables>(FinishSigningOutsideAlineDocument, options);
      }
export type FinishSigningOutsideAlineMutationHookResult = ReturnType<typeof useFinishSigningOutsideAlineMutation>;
export type FinishSigningOutsideAlineMutationResult = ApolloReactHooks.useMutation.Result<FinishSigningOutsideAlineMutation>;
export type FinishSigningOutsideAlineMutationOptions = ApolloReactHooks.useMutation.Options<FinishSigningOutsideAlineMutation, FinishSigningOutsideAlineMutationVariables>;
export const SetSignOutsideAlineDocument = gql`
    mutation SetSignOutsideAline($workflowId: UUID!) {
  setSignOutsideAline(workflowId: $workflowId) {
    workflow {
      __typename
      id
      isSignedOutsideAline
      state
    }
  }
}
    `;
export type SetSignOutsideAlineMutationFn = ApolloReactHooks.useMutation.MutationFunction<SetSignOutsideAlineMutation, SetSignOutsideAlineMutationVariables>;

/**
 * __useSetSignOutsideAlineMutation__
 *
 * To run a mutation, you first call `useSetSignOutsideAlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignOutsideAlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignOutsideAlineMutation, { data, loading, error }] = useSetSignOutsideAlineMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useSetSignOutsideAlineMutation(baseOptions?: ApolloReactHooks.useMutation.Options<SetSignOutsideAlineMutation, SetSignOutsideAlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetSignOutsideAlineMutation, SetSignOutsideAlineMutationVariables>(SetSignOutsideAlineDocument, options);
      }
export type SetSignOutsideAlineMutationHookResult = ReturnType<typeof useSetSignOutsideAlineMutation>;
export type SetSignOutsideAlineMutationResult = ApolloReactHooks.useMutation.Result<SetSignOutsideAlineMutation>;
export type SetSignOutsideAlineMutationOptions = ApolloReactHooks.useMutation.Options<SetSignOutsideAlineMutation, SetSignOutsideAlineMutationVariables>;
export const ApplySignedVersionOutsideAlineDocument = gql`
    mutation ApplySignedVersionOutsideAline($input: ApplySignedVersionOutsideAlineInput!) {
  applySignedVersionOutsideAline(input: $input) {
    fileVersion {
      ...FileVersionSimple
    }
  }
}
    ${FileVersionSimpleFragmentDoc}`;
export type ApplySignedVersionOutsideAlineMutationFn = ApolloReactHooks.useMutation.MutationFunction<ApplySignedVersionOutsideAlineMutation, ApplySignedVersionOutsideAlineMutationVariables>;

/**
 * __useApplySignedVersionOutsideAlineMutation__
 *
 * To run a mutation, you first call `useApplySignedVersionOutsideAlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplySignedVersionOutsideAlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applySignedVersionOutsideAlineMutation, { data, loading, error }] = useApplySignedVersionOutsideAlineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplySignedVersionOutsideAlineMutation(baseOptions?: ApolloReactHooks.useMutation.Options<ApplySignedVersionOutsideAlineMutation, ApplySignedVersionOutsideAlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplySignedVersionOutsideAlineMutation, ApplySignedVersionOutsideAlineMutationVariables>(ApplySignedVersionOutsideAlineDocument, options);
      }
export type ApplySignedVersionOutsideAlineMutationHookResult = ReturnType<typeof useApplySignedVersionOutsideAlineMutation>;
export type ApplySignedVersionOutsideAlineMutationResult = ApolloReactHooks.useMutation.Result<ApplySignedVersionOutsideAlineMutation>;
export type ApplySignedVersionOutsideAlineMutationOptions = ApolloReactHooks.useMutation.Options<ApplySignedVersionOutsideAlineMutation, ApplySignedVersionOutsideAlineMutationVariables>;
export const TogglePublishTemplateDocument = gql`
    mutation TogglePublishTemplate($workflowId: UUID!) {
  togglePublishTemplate(workflowId: $workflowId) {
    workflow {
      __typename
      id
      publishedAt
    }
  }
}
    `;
export type TogglePublishTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<TogglePublishTemplateMutation, TogglePublishTemplateMutationVariables>;

/**
 * __useTogglePublishTemplateMutation__
 *
 * To run a mutation, you first call `useTogglePublishTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePublishTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePublishTemplateMutation, { data, loading, error }] = useTogglePublishTemplateMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useTogglePublishTemplateMutation(baseOptions?: ApolloReactHooks.useMutation.Options<TogglePublishTemplateMutation, TogglePublishTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TogglePublishTemplateMutation, TogglePublishTemplateMutationVariables>(TogglePublishTemplateDocument, options);
      }
export type TogglePublishTemplateMutationHookResult = ReturnType<typeof useTogglePublishTemplateMutation>;
export type TogglePublishTemplateMutationResult = ApolloReactHooks.useMutation.Result<TogglePublishTemplateMutation>;
export type TogglePublishTemplateMutationOptions = ApolloReactHooks.useMutation.Options<TogglePublishTemplateMutation, TogglePublishTemplateMutationVariables>;
export const OnWorkflowsUpdatedDocument = gql`
    subscription OnWorkflowsUpdated {
  workflowsUpdated {
    workflows {
      __typename
      id
      aiCancelledAt
      aiFailedAt
      aiFailureReason
      aiFinishedAt
      aiStartedAt
      files {
        ...WorkflowFileSimple
      }
    }
  }
}
    ${WorkflowFileSimpleFragmentDoc}`;

/**
 * __useOnWorkflowsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnWorkflowsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkflowsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkflowsUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnWorkflowsUpdatedSubscription(baseOptions?: ApolloReactHooks.useSubscription.Options<OnWorkflowsUpdatedSubscription, OnWorkflowsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnWorkflowsUpdatedSubscription, OnWorkflowsUpdatedSubscriptionVariables>(OnWorkflowsUpdatedDocument, options);
      }
export type OnWorkflowsUpdatedSubscriptionHookResult = ReturnType<typeof useOnWorkflowsUpdatedSubscription>;
export type OnWorkflowsUpdatedSubscriptionResult = ApolloReactHooks.useSubscription.Result<OnWorkflowsUpdatedSubscription>;
export const GetTestScalarsDocument = gql`
    query GetTestScalars($input: TEST_ScalarsInput!) {
  TEST_scalars(input: $input) {
    TEST_BigInt
    TEST_Date
    TEST_DateTime
    TEST_EmailAddress
    TEST_JSON
    TEST_UUID
  }
}
    `;

/**
 * __useGetTestScalarsQuery__
 *
 * To run a query within a React component, call `useGetTestScalarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestScalarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestScalarsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTestScalarsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetTestScalarsQuery, GetTestScalarsQueryVariables> & ({ variables: GetTestScalarsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTestScalarsQuery, GetTestScalarsQueryVariables>(GetTestScalarsDocument, options);
      }
export function useGetTestScalarsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetTestScalarsQuery, GetTestScalarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTestScalarsQuery, GetTestScalarsQueryVariables>(GetTestScalarsDocument, options);
        }
export function useGetTestScalarsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetTestScalarsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetTestScalarsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetTestScalarsQuery, GetTestScalarsQueryVariables>(GetTestScalarsDocument, options);
        }
export type GetTestScalarsQueryHookResult = ReturnType<typeof useGetTestScalarsQuery>;
export type GetTestScalarsLazyQueryHookResult = ReturnType<typeof useGetTestScalarsLazyQuery>;
export type GetTestScalarsSuspenseQueryHookResult = ReturnType<typeof useGetTestScalarsSuspenseQuery>;
export type GetTestScalarsQueryResult = ApolloReactHooks.useQuery.Result<GetTestScalarsQuery, GetTestScalarsQueryVariables>;
export const GetWorkflowAllPropsDocument = gql`
    query GetWorkflowAllProps($workflowId: UUID!) {
  workflow(workflowId: $workflowId) {
    id
    commentCount
    completedStepCount
    envelopeMsg
    fileCount
    isCommunityWorkflow
    name
    numTimesUsed
    requesterInOwnerOrg
    status
    totalStepCount
    variant
    startedAt
    completedAt
    createdAt
    updatedAt
    missingActions
    publishedAt
    owner {
      ...UserBase
    }
    activeStep {
      ...WorkflowStepFragment
    }
    permissions {
      ...WorkflowPermissionSimple
    }
    files {
      ...WorkflowFileSimple
    }
    files {
      __typename
      id
      document {
        __typename
        id
        name
        status
        variant
        requesterFavorited
        latestVersion {
          ...FileVersionSimple
        }
        owner {
          ...UserBase
        }
        parties {
          ...PartySimple
        }
        type {
          ...ContractTypeSimple
        }
        updatedAt
        deletedAt
      }
    }
    comments {
      ...CommentSimple
    }
    parties {
      ...PartySimple
    }
    ...WorkflowSigningPhaseStepsAllProps
    unusedActions {
      ...WorkflowRecipientSimple
    }
    sourceWorkflow {
      __typename
      id
      name
      variant
    }
    tasks {
      ...TaskSimple
    }
    envelope {
      __typename
      id
      docuSignEnvelopeId
      variant
    }
  }
}
    ${UserBaseFragmentDoc}
${WorkflowStepFragmentFragmentDoc}
${WorkflowPermissionSimpleFragmentDoc}
${WorkflowFileSimpleFragmentDoc}
${FileVersionSimpleFragmentDoc}
${PartySimpleFragmentDoc}
${ContractTypeSimpleFragmentDoc}
${CommentSimpleFragmentDoc}
${WorkflowSigningPhaseStepsAllPropsFragmentDoc}
${WorkflowRecipientSimpleFragmentDoc}
${TaskSimpleFragmentDoc}`;

/**
 * __useGetWorkflowAllPropsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowAllPropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowAllPropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowAllPropsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowAllPropsQuery(baseOptions: ApolloReactHooks.useQuery.Options<GetWorkflowAllPropsQuery, GetWorkflowAllPropsQueryVariables> & ({ variables: GetWorkflowAllPropsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowAllPropsQuery, GetWorkflowAllPropsQueryVariables>(GetWorkflowAllPropsDocument, options);
      }
export function useGetWorkflowAllPropsLazyQuery(baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWorkflowAllPropsQuery, GetWorkflowAllPropsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowAllPropsQuery, GetWorkflowAllPropsQueryVariables>(GetWorkflowAllPropsDocument, options);
        }
export function useGetWorkflowAllPropsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowAllPropsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions} as ApolloReactHooks.useSuspenseQuery.Options<GetWorkflowAllPropsQueryVariables>;
          return ApolloReactHooks.useSuspenseQuery<GetWorkflowAllPropsQuery, GetWorkflowAllPropsQueryVariables>(GetWorkflowAllPropsDocument, options);
        }
export type GetWorkflowAllPropsQueryHookResult = ReturnType<typeof useGetWorkflowAllPropsQuery>;
export type GetWorkflowAllPropsLazyQueryHookResult = ReturnType<typeof useGetWorkflowAllPropsLazyQuery>;
export type GetWorkflowAllPropsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowAllPropsSuspenseQuery>;
export type GetWorkflowAllPropsQueryResult = ApolloReactHooks.useQuery.Result<GetWorkflowAllPropsQuery, GetWorkflowAllPropsQueryVariables>;
export const namedOperations = {
  Query: {
    GetDocumentName: 'GetDocumentName',
    GetChatDocument: 'GetChatDocument',
    GetThreadTitle: 'GetThreadTitle',
    GetSuggestionDocument: 'GetSuggestionDocument',
    GetWorkflowWithCategories: 'GetWorkflowWithCategories',
    GetWorkflowMessage: 'GetWorkflowMessage',
    GetReportToRestore: 'GetReportToRestore',
    GetReportName: 'GetReportName',
    GetWorkflowWithOwner: 'GetWorkflowWithOwner',
    GetWorkflowHeader: 'GetWorkflowHeader',
    GetRequesterDocumentAccess: 'GetRequesterDocumentAccess',
    GetOCRDocument: 'GetOCRDocument',
    TestWorkflowChartSeriesCache: 'TestWorkflowChartSeriesCache',
    ReportForTest: 'ReportForTest',
    RootExtractionQuestionsForTest: 'RootExtractionQuestionsForTest',
    GetWorkflowDocumentsBasic: 'GetWorkflowDocumentsBasic',
    GetPendingReviewCount: 'GetPendingReviewCount',
    GetWorkflowName: 'GetWorkflowName',
    GetAccount: 'GetAccount',
    GetAccountsBy: 'GetAccountsBy',
    GetMyAlineSubscription: 'GetMyAlineSubscription',
    ComputeCheckoutEstimate: 'ComputeCheckoutEstimate',
    GetDocumentGroupPermissions: 'GetDocumentGroupPermissions',
    GetGroupWithUsers: 'GetGroupWithUsers',
    GetGroupPermissions: 'GetGroupPermissions',
    GetGroup: 'GetGroup',
    GetGroups: 'GetGroups',
    GetOrg: 'GetOrg',
    GetOrgs: 'GetOrgs',
    OrgNameUnique: 'OrgNameUnique',
    GetUpgradeRequests: 'GetUpgradeRequests',
    GetUser: 'GetUser',
    GetDocumentUser: 'GetDocumentUser',
    GetMyOnboardingInfo: 'GetMyOnboardingInfo',
    GetMyRecentDocuments: 'GetMyRecentDocuments',
    GetFullUser: 'GetFullUser',
    GetUsers: 'GetUsers',
    CurrentUser: 'CurrentUser',
    GetCurrentUserOnboardingInfo: 'GetCurrentUserOnboardingInfo',
    GetMyOrgMembers: 'GetMyOrgMembers',
    GetUserAccessLevel: 'GetUserAccessLevel',
    GetLoginType: 'GetLoginType',
    AdminAiUsage: 'AdminAiUsage',
    AdminAiUsageDetailRows: 'AdminAiUsageDetailRows',
    GetTaskActivity: 'GetTaskActivity',
    GetWorkflowActivity: 'GetWorkflowActivity',
    GetAgentSkills: 'GetAgentSkills',
    GetAgentSkill: 'GetAgentSkill',
    GetAgentSkillDraftAttachment: 'GetAgentSkillDraftAttachment',
    GetAgentSkillAttachment: 'GetAgentSkillAttachment',
    GetMentionEntities: 'GetMentionEntities',
    SearchMentionEntities: 'SearchMentionEntities',
    GetAgentThreadSkillAudience: 'GetAgentThreadSkillAudience',
    GetAgentThread: 'GetAgentThread',
    GetAgentThreads: 'GetAgentThreads',
    GetAIReminderAutomation: 'GetAIReminderAutomation',
    GetAIReminderAutomationsByReport: 'GetAIReminderAutomationsByReport',
    GetAIReminderAutomations: 'GetAIReminderAutomations',
    GetAIReminderAutomationRuns: 'GetAIReminderAutomationRuns',
    GetAnswerOptions: 'GetAnswerOptions',
    GetAnswerOptionsPresets: 'GetAnswerOptionsPresets',
    ApiKeys: 'ApiKeys',
    GetAppVersion: 'GetAppVersion',
    GetBoards: 'GetBoards',
    GetBoard: 'GetBoard',
    GetBoardColumns: 'GetBoardColumns',
    GetColumn: 'GetColumn',
    BulkExport: 'BulkExport',
    MyBulkExports: 'MyBulkExports',
    GetComment: 'GetComment',
    GetCommentReplies: 'GetCommentReplies',
    GetComments: 'GetComments',
    GetCommunityCategories: 'GetCommunityCategories',
    GetSupportedLicenses: 'GetSupportedLicenses',
    TopCommunityWorkflows: 'TopCommunityWorkflows',
    TopCommunityTemplates: 'TopCommunityTemplates',
    TopCommunityContributors: 'TopCommunityContributors',
    GetCommunityTemplates: 'GetCommunityTemplates',
    GetCommunityTemplate: 'GetCommunityTemplate',
    GetCommunityWorkflows: 'GetCommunityWorkflows',
    GetCommunityWorkflow: 'GetCommunityWorkflow',
    GetCommunityInfoBoxWorkflow: 'GetCommunityInfoBoxWorkflow',
    GetCommunityWorkflowMetrics: 'GetCommunityWorkflowMetrics',
    GetImportedWorkflow: 'GetImportedWorkflow',
    MayPublishWorkflowToCommunity: 'MayPublishWorkflowToCommunity',
    GetMyContractTypes: 'GetMyContractTypes',
    GetMyContractTypesWithDocumentCount: 'GetMyContractTypesWithDocumentCount',
    GetDocumentType: 'GetDocumentType',
    DocumentMetadataImports: 'DocumentMetadataImports',
    DocumentMetadataImport: 'DocumentMetadataImport',
    DocumentMetadataImportPreview: 'DocumentMetadataImportPreview',
    DocumentMetadataImportHistory: 'DocumentMetadataImportHistory',
    GetEnvelopes: 'GetEnvelopes',
    GetEnvelope: 'GetEnvelope',
    GetEnvelopeWithRecipients: 'GetEnvelopeWithRecipients',
    GetSignatureDocsDetails: 'GetSignatureDocsDetails',
    RefreshDocAfterEnvelopeAction: 'RefreshDocAfterEnvelopeAction',
    GetExtractionJob: 'GetExtractionJob',
    GetQuestionGenerationJobs: 'GetQuestionGenerationJobs',
    GetExtractionQuestion: 'GetExtractionQuestion',
    GetExtractionQuestionWithInputs: 'GetExtractionQuestionWithInputs',
    GetExtractionQuestions: 'GetExtractionQuestions',
    GetDocExtractionQuestion: 'GetDocExtractionQuestion',
    GetExtractionQuestionWithOptions: 'GetExtractionQuestionWithOptions',
    GetExtractionQuestionWithDependencies: 'GetExtractionQuestionWithDependencies',
    GetExtractionQuestionsForDocument: 'GetExtractionQuestionsForDocument',
    GetReportQuestions: 'GetReportQuestions',
    GetField: 'GetField',
    GetDBFields: 'GetDBFields',
    GetFieldWithAction: 'GetFieldWithAction',
    GetInboxNotifications: 'GetInboxNotifications',
    IntakeFormTemplates: 'IntakeFormTemplates',
    IntakeFormTemplate: 'IntakeFormTemplate',
    IntakeFormTemplateAttachedWorkflows: 'IntakeFormTemplateAttachedWorkflows',
    WorkflowIntakeForm: 'WorkflowIntakeForm',
    GetCRMConnections: 'GetCRMConnections',
    GetIntegrationOpportunities: 'GetIntegrationOpportunities',
    GetOpportunity: 'GetOpportunity',
    GetOpportunitySimple: 'GetOpportunitySimple',
    GetConsumerConnections: 'GetConsumerConnections',
    GetIntegrationField: 'GetIntegrationField',
    GetChannelInstallations: 'GetChannelInstallations',
    HasDocuSignAuth: 'HasDocuSignAuth',
    GetExternalToolkits: 'GetExternalToolkits',
    GetExternalToolkitPolicies: 'GetExternalToolkitPolicies',
    GetFolderSyncJob: 'GetFolderSyncJob',
    GetFolderSyncJobs: 'GetFolderSyncJobs',
    GetDrives: 'GetDrives',
    GetFileStorageConnections: 'GetFileStorageConnections',
    GetConnectionFolderFiles: 'GetConnectionFolderFiles',
    GetConnectionFilesSearch: 'GetConnectionFilesSearch',
    GetIntegrationFolderSyncJobs: 'GetIntegrationFolderSyncJobs',
    GetLabel: 'GetLabel',
    GetWorkflowLabels: 'GetWorkflowLabels',
    GetDocumentLabels: 'GetDocumentLabels',
    GetUserLabels: 'GetUserLabels',
    GetLabelByName: 'GetLabelByName',
    GetDocumentLabelState: 'GetDocumentLabelState',
    GetMyMentions: 'GetMyMentions',
    GetTaskSubscribers: 'GetTaskSubscribers',
    GetWorkflowSubscribers: 'GetWorkflowSubscribers',
    GetTaskSubscriberOptions: 'GetTaskSubscriberOptions',
    GetWorkflowSubscriberOptions: 'GetWorkflowSubscriberOptions',
    GetParties: 'GetParties',
    GetPartyRows: 'GetPartyRows',
    SearchParties: 'SearchParties',
    GetParty: 'GetParty',
    GetPartyWithDocumentCount: 'GetPartyWithDocumentCount',
    GetDocumentWithParties: 'GetDocumentWithParties',
    GetWorkflowWithParties: 'GetWorkflowWithParties',
    GetPartyDocuments: 'GetPartyDocuments',
    GetPartyWorkflows: 'GetPartyWorkflows',
    GetPhase: 'GetPhase',
    GetWorkflowPhases: 'GetWorkflowPhases',
    GetPlaybookGenerationJobs: 'GetPlaybookGenerationJobs',
    GetPlaybookGenerationJob: 'GetPlaybookGenerationJob',
    GetPlaybookRuleJob: 'GetPlaybookRuleJob',
    GetDocPlaybook: 'GetDocPlaybook',
    GetDocPlaybookSummary: 'GetDocPlaybookSummary',
    GetPlaybookRule: 'GetPlaybookRule',
    GetPlaybookRulesForCategory: 'GetPlaybookRulesForCategory',
    GetPlaybookDetail: 'GetPlaybookDetail',
    GetPlaybooks: 'GetPlaybooks',
    GetPlaybooksList: 'GetPlaybooksList',
    SearchPlaybooks: 'SearchPlaybooks',
    GetReminder: 'GetReminder',
    GetReminders: 'GetReminders',
    GetRemindersInRange: 'GetRemindersInRange',
    GetRemindersRequiringNotification: 'GetRemindersRequiringNotification',
    GetReportColumnOptions: 'GetReportColumnOptions',
    GetReportRows: 'GetReportRows',
    GetReport: 'GetReport',
    GetReports: 'GetReports',
    GetReportsCount: 'GetReportsCount',
    GetDocumentReportRows: 'GetDocumentReportRows',
    GetReportInitialState: 'GetReportInitialState',
    GetReportState: 'GetReportState',
    GetDocumentRowIndex: 'GetDocumentRowIndex',
    GetQuestionLockStatus: 'GetQuestionLockStatus',
    GetEditorReports: 'GetEditorReports',
    CountFilteredDocuments: 'CountFilteredDocuments',
    GetRowsMeta: 'GetRowsMeta',
    GetRepositoryMeta: 'GetRepositoryMeta',
    GetMyDefaultRepository: 'GetMyDefaultRepository',
    VerifyCSRFToken: 'VerifyCSRFToken',
    GetAccessRequestsByBatchId: 'GetAccessRequestsByBatchId',
    GetMyAccessRequestsForDocuments: 'GetMyAccessRequestsForDocuments',
    GetAnnotations: 'GetAnnotations',
    GetFile: 'GetFile',
    GetDocumentAssetURL: 'GetDocumentAssetURL',
    GetFiles: 'GetFiles',
    GetUploadSecurity: 'GetUploadSecurity',
    GetDownloadSecurity: 'GetDownloadSecurity',
    GetDocumentDownloadURL: 'GetDocumentDownloadURL',
    GetFileVersionDownloadURL: 'GetFileVersionDownloadURL',
    GetDocumentIsInternalOnWorkflow: 'GetDocumentIsInternalOnWorkflow',
    GetDocument: 'GetDocument',
    GetEditorDocument: 'GetEditorDocument',
    GetDocumentSimple: 'GetDocumentSimple',
    GetReportDocument: 'GetReportDocument',
    GetDocumentParts: 'GetDocumentParts',
    GetSignedDocumentSimple: 'GetSignedDocumentSimple',
    GetSignedDocument: 'GetSignedDocument',
    GetDocumentForwardSettings: 'GetDocumentForwardSettings',
    GetDocumentWithWorkflowState: 'GetDocumentWithWorkflowState',
    GetDocxUploadTargetDocument: 'GetDocxUploadTargetDocument',
    GetDocumentBasicMeta: 'GetDocumentBasicMeta',
    GetDocumentStatus: 'GetDocumentStatus',
    GetDocumentWorkflowMeta: 'GetDocumentWorkflowMeta',
    GetDocumentWithWorkflow: 'GetDocumentWithWorkflow',
    GetDocumentWithFullWorkflow: 'GetDocumentWithFullWorkflow',
    GetContractSummary: 'GetContractSummary',
    GetDocumentWithAssets: 'GetDocumentWithAssets',
    GetDocumentsWithAssets: 'GetDocumentsWithAssets',
    LoadDocument: 'LoadDocument',
    GetDocuments: 'GetDocuments',
    GetDocumentsSimple: 'GetDocumentsSimple',
    GetDocumentMetrics: 'GetDocumentMetrics',
    GetDocumentsLabels: 'GetDocumentsLabels',
    GetDocumentFields: 'GetDocumentFields',
    GetDocumentVersions: 'GetDocumentVersions',
    GetDocumentComments: 'GetDocumentComments',
    GetDocumentLatestVersion: 'GetDocumentLatestVersion',
    GetDocumentStatusJobs: 'GetDocumentStatusJobs',
    GetDocumentHeader: 'GetDocumentHeader',
    GetDocumentFileDetails: 'GetDocumentFileDetails',
    GetFileVersion: 'GetFileVersion',
    GetStorableRole: 'GetStorableRole',
    GetSharedStorables: 'GetSharedStorables',
    GetStorablePermissions: 'GetStorablePermissions',
    GetStorablePermissionsWithStorable: 'GetStorablePermissionsWithStorable',
    GetStorables: 'GetStorables',
    StorableMetadata: 'StorableMetadata',
    GetFavoriteStorables: 'GetFavoriteStorables',
    SearchData: 'SearchData',
    DisabledStorables: 'DisabledStorables',
    GetTask: 'GetTask',
    GetTaskStatus: 'GetTaskStatus',
    GetTaskWithComments: 'GetTaskWithComments',
    GetTaskDocumentDownload: 'GetTaskDocumentDownload',
    GetTaskLanding: 'GetTaskLanding',
    GetTasks: 'GetTasks',
    GetUserTasks: 'GetUserTasks',
    GetTaskUnsubmittedReview: 'GetTaskUnsubmittedReview',
    GetUserDefinedRole: 'GetUserDefinedRole',
    GetUserDefinedRoles: 'GetUserDefinedRoles',
    GetRequesterUserDefinedRoles: 'GetRequesterUserDefinedRoles',
    GetWorkflowCannedFields: 'GetWorkflowCannedFields',
    GetCannedField: 'GetCannedField',
    GetVariablesForDocument: 'GetVariablesForDocument',
    GetDocumentVariable: 'GetDocumentVariable',
    GetVariableWithAction: 'GetVariableWithAction',
    GetVariableConfig: 'GetVariableConfig',
    GetVariableConfigs: 'GetVariableConfigs',
    GetWorkflowLinkedOpportunities: 'GetWorkflowLinkedOpportunities',
    GetLinkedOpportunity: 'GetLinkedOpportunity',
    TemplateOpportunityAttributes: 'TemplateOpportunityAttributes',
    GetWorkflowMappedCrmIntegrations: 'GetWorkflowMappedCrmIntegrations',
    GetSalesforceRecordData: 'GetSalesforceRecordData',
    GetStep: 'GetStep',
    GetWorkflowSigningSteps: 'GetWorkflowSigningSteps',
    TemplateSalesforceFields: 'TemplateSalesforceFields',
    GetWalkthroughWorkflow: 'GetWalkthroughWorkflow',
    GetWorkflowFileExternalAccess: 'GetWorkflowFileExternalAccess',
    GetInsightPins: 'GetInsightPins',
    GetWorkflowViews: 'GetWorkflowViews',
    GetWorkflowView: 'GetWorkflowView',
    GetWorkflowChartSeries: 'GetWorkflowChartSeries',
    GetWorkflowInsightsDashboard: 'GetWorkflowInsightsDashboard',
    GetWorkflowIntakeFields: 'GetWorkflowIntakeFields',
    GetWorkflowLaunchConfig: 'GetWorkflowLaunchConfig',
    GetLaunchConfigWorkflow: 'GetLaunchConfigWorkflow',
    GetUploadSecurityViaLaunchConfig: 'GetUploadSecurityViaLaunchConfig',
    GetWorkflowPermission: 'GetWorkflowPermission',
    GetWorkflowPermissions: 'GetWorkflowPermissions',
    GetActiveWorkflowPermissions: 'GetActiveWorkflowPermissions',
    GetQueuedWorkflowPermissions: 'GetQueuedWorkflowPermissions',
    GetWorkflowPermissionsForWorkflow: 'GetWorkflowPermissionsForWorkflow',
    GetWorkflowPermissionsWithSteps: 'GetWorkflowPermissionsWithSteps',
    GetWorkflow: 'GetWorkflow',
    GetWorkflowSigningStatus: 'GetWorkflowSigningStatus',
    GetWorkflows: 'GetWorkflows',
    GetWorkflowsCount: 'GetWorkflowsCount',
    GetWorkflowsWithFiles: 'GetWorkflowsWithFiles',
    GetWorkflowTypes: 'GetWorkflowTypes',
    GetBoardWorkflows: 'GetBoardWorkflows',
    GetWorkflowSimple: 'GetWorkflowSimple',
    GetWorkflowComments: 'GetWorkflowComments',
    GetWorkflowDocument: 'GetWorkflowDocument',
    GetWorkflowByDocument: 'GetWorkflowByDocument',
    GetWorkflowActiveStep: 'GetWorkflowActiveStep',
    GetWorkflowFiles: 'GetWorkflowFiles',
    GetWorkflowPreviewDetails: 'GetWorkflowPreviewDetails',
    GetWorkflowFilesWithParties: 'GetWorkflowFilesWithParties',
    GetWorkflowFilesWithFields: 'GetWorkflowFilesWithFields',
    GetWorkflowWithReadyCheck: 'GetWorkflowWithReadyCheck',
    GetWorkflowTasks: 'GetWorkflowTasks',
    GetWorkflowAssignments: 'GetWorkflowAssignments',
    LaunchTemplateData: 'LaunchTemplateData',
    GetWorkflowInbox: 'GetWorkflowInbox',
    GetWorkflowInboxWorkflow: 'GetWorkflowInboxWorkflow',
    GetDocumentWorkflows: 'GetDocumentWorkflows',
    GetMissingWorkflowActions: 'GetMissingWorkflowActions',
    GetUnusedWorkflowActions: 'GetUnusedWorkflowActions',
    GetPopularTemplateWorkflows: 'GetPopularTemplateWorkflows',
    GetMyMostUsedTemplateWorkflows: 'GetMyMostUsedTemplateWorkflows',
    GetWorkflowForwardSettings: 'GetWorkflowForwardSettings',
    GetWorkflowWithBoard: 'GetWorkflowWithBoard',
    GetWorkflowBlockers: 'GetWorkflowBlockers',
    GetTestScalars: 'GetTestScalars',
    GetWorkflowAllProps: 'GetWorkflowAllProps'
  },
  Mutation: {
    UpdateGroupGlobalAccess: 'UpdateGroupGlobalAccess',
    UpdateDocumentForwarding: 'UpdateDocumentForwarding',
    UpdateReminderTitle: 'UpdateReminderTitle',
    UpdateReminderDescription: 'UpdateReminderDescription',
    UpdateReminderDueDate: 'UpdateReminderDueDate',
    UpdateReminderType: 'UpdateReminderType',
    UpdateReminderNotificationOffsets: 'UpdateReminderNotificationOffsets',
    UpdateQuestionType: 'UpdateQuestionType',
    UpdateQuestionMode: 'UpdateQuestionMode',
    UpdateWorkflowAssignee: 'UpdateWorkflowAssignee',
    MoveWorkflowToColumn: 'MoveWorkflowToColumn',
    UpdateWorkflowLaunchAutomaticS4SConfig: 'UpdateWorkflowLaunchAutomaticS4SConfig',
    UpdateWorkflowForwarding: 'UpdateWorkflowForwarding',
    UpdateWorkflowName: 'UpdateWorkflowName',
    UpdatePhaseTitle: 'UpdatePhaseTitle',
    UpdateTaskTitle: 'UpdateTaskTitle',
    UpdateExtractionJobAnswer: 'UpdateExtractionJobAnswer',
    UpdateExtractionJobSelectedOptions: 'UpdateExtractionJobSelectedOptions',
    CreateBillingSessionUrl: 'CreateBillingSessionUrl',
    CreateCheckoutUrl: 'CreateCheckoutUrl',
    CreateCloseOrderUrl: 'CreateCloseOrderUrl',
    SetGroupPermissions: 'SetGroupPermissions',
    DeleteGroupPermission: 'DeleteGroupPermission',
    AddUsersToGroup: 'AddUsersToGroup',
    CreateGroup: 'CreateGroup',
    DeleteGroup: 'DeleteGroup',
    RemoveUsersFromGroup: 'RemoveUsersFromGroup',
    UpdateGroup: 'UpdateGroup',
    UpdateOnboardingTask: 'UpdateOnboardingTask',
    ImportExampleNDAResources: 'ImportExampleNDAResources',
    CreateExampleReport: 'CreateExampleReport',
    UpdateOrg: 'UpdateOrg',
    CreateOrg: 'CreateOrg',
    AddOrgMember: 'AddOrgMember',
    DeleteOrg: 'DeleteOrg',
    ResendOrgInvite: 'ResendOrgInvite',
    UpsertOrgAvatarImg: 'UpsertOrgAvatarImg',
    RequestUpgrade: 'RequestUpgrade',
    CancelUpgradeRequest: 'CancelUpgradeRequest',
    RespondToUpgradeRequest: 'RespondToUpgradeRequest',
    UpdateUserSettingsProps: 'UpdateUserSettingsProps',
    UpsertUserSignatures: 'UpsertUserSignatures',
    AddToRecentlyAccessedDocuments: 'AddToRecentlyAccessedDocuments',
    CreateUser: 'CreateUser',
    DeleteUsers: 'DeleteUsers',
    UpdateUser: 'UpdateUser',
    UpdateUserActivation: 'UpdateUserActivation',
    RequestAccountActivation: 'RequestAccountActivation',
    CreateAgentSkill: 'CreateAgentSkill',
    UpdateAgentSkill: 'UpdateAgentSkill',
    SetAgentSkillScope: 'SetAgentSkillScope',
    DeleteAgentSkill: 'DeleteAgentSkill',
    AutoSaveAgentSkillDraft: 'AutoSaveAgentSkillDraft',
    TestAgentSkillDraft: 'TestAgentSkillDraft',
    PublishAgentSkillDraft: 'PublishAgentSkillDraft',
    DiscardAgentSkillDraft: 'DiscardAgentSkillDraft',
    RetryAgentSkillFile: 'RetryAgentSkillFile',
    DuplicateAgentSkill: 'DuplicateAgentSkill',
    SendAgentPrompt: 'SendAgentPrompt',
    ContinueAgentChat: 'ContinueAgentChat',
    StartActivityAgentThread: 'StartActivityAgentThread',
    UpdateAgentMessageSuggestions: 'UpdateAgentMessageSuggestions',
    UpdateAgentMessageFeedback: 'UpdateAgentMessageFeedback',
    DeleteAgentThread: 'DeleteAgentThread',
    UpdateAgentThreadTitle: 'UpdateAgentThreadTitle',
    RecreateAgentArtifactDocument: 'RecreateAgentArtifactDocument',
    StopChatMessageStream: 'StopChatMessageStream',
    CreateAIReminderAutomation: 'CreateAIReminderAutomation',
    UpdateAIReminderAutomation: 'UpdateAIReminderAutomation',
    DeleteAIReminderAutomation: 'DeleteAIReminderAutomation',
    RunAIReminderAutomation: 'RunAIReminderAutomation',
    AcceptReminder: 'AcceptReminder',
    RejectReminder: 'RejectReminder',
    AcceptReminders: 'AcceptReminders',
    RejectReminders: 'RejectReminders',
    CreateAnswerOption: 'CreateAnswerOption',
    DeleteAnswerOption: 'DeleteAnswerOption',
    UpdateAnswerOption: 'UpdateAnswerOption',
    CreateAnswerOptions: 'CreateAnswerOptions',
    UpdateAnswerOptions: 'UpdateAnswerOptions',
    DeleteAnswerOptions: 'DeleteAnswerOptions',
    CreateApiKey: 'CreateApiKey',
    RevokeApiKeys: 'RevokeApiKeys',
    CreateBoard: 'CreateBoard',
    UpdateBoard: 'UpdateBoard',
    DeleteBoard: 'DeleteBoard',
    CreateColumn: 'CreateColumn',
    UpdateColumn: 'UpdateColumn',
    DeleteColumn: 'DeleteColumn',
    MoveColumn: 'MoveColumn',
    AddTriageColumn: 'AddTriageColumn',
    RequestBulkExport: 'RequestBulkExport',
    CancelBulkExport: 'CancelBulkExport',
    CreateComment: 'CreateComment',
    UpdateComment: 'UpdateComment',
    DisableComment: 'DisableComment',
    DeleteComment: 'DeleteComment',
    CreateCommunityCategory: 'CreateCommunityCategory',
    SetCommunityWorkflow: 'SetCommunityWorkflow',
    SetCommunityTemplate: 'SetCommunityTemplate',
    ImportCommunityWorkflow: 'ImportCommunityWorkflow',
    CreateContractTypes: 'CreateContractTypes',
    MergeContractTypes: 'MergeContractTypes',
    UpdateContractType: 'UpdateContractType',
    DeleteContractType: 'DeleteContractType',
    UpdateDocumentType: 'UpdateDocumentType',
    GenerateMetadataImportTemplate: 'GenerateMetadataImportTemplate',
    UploadMetadataImport: 'UploadMetadataImport',
    ConfirmMetadataImport: 'ConfirmMetadataImport',
    DeleteMetadataImports: 'DeleteMetadataImports',
    RevertWorkflowToDraft: 'RevertWorkflowToDraft',
    SetEnvelopeViewed: 'SetEnvelopeViewed',
    SwitchEnvelopeVariant: 'SwitchEnvelopeVariant',
    UpdateEnvelope: 'UpdateEnvelope',
    CreateExtractionJob: 'CreateExtractionJob',
    StartExtractionJobsForDocuments: 'StartExtractionJobsForDocuments',
    RunCoreAiForDocuments: 'RunCoreAiForDocuments',
    CancelExtractionJobs: 'CancelExtractionJobs',
    UpdateExtractionJob: 'UpdateExtractionJob',
    RevertExtractionJob: 'RevertExtractionJob',
    ToggleExtractionJobsLock: 'ToggleExtractionJobsLock',
    StartQuestionGenerationJob: 'StartQuestionGenerationJob',
    CancelQuestionGenerationJob: 'CancelQuestionGenerationJob',
    AcceptGeneratedQuestions: 'AcceptGeneratedQuestions',
    AddQuestionOptions: 'AddQuestionOptions',
    CreateExtractionQuestion: 'CreateExtractionQuestion',
    DeleteQuestionOption: 'DeleteQuestionOption',
    DeleteExtractionQuestion: 'DeleteExtractionQuestion',
    SetQuestionInputs: 'SetQuestionInputs',
    SetQuestionContractTypes: 'SetQuestionContractTypes',
    UpdateQuestionOption: 'UpdateQuestionOption',
    UpdateExtractionQuestion: 'UpdateExtractionQuestion',
    UpdateQuestionCategory: 'UpdateQuestionCategory',
    CreateSignatureField: 'CreateSignatureField',
    DisableSignatureField: 'DisableSignatureField',
    UpdateSignatureField: 'UpdateSignatureField',
    MarkInboxNotificationsRead: 'MarkInboxNotificationsRead',
    MarkInboxNotificationsUnread: 'MarkInboxNotificationsUnread',
    DismissInboxNotification: 'DismissInboxNotification',
    CreateIntakeFormTemplate: 'CreateIntakeFormTemplate',
    UpdateIntakeFormTemplate: 'UpdateIntakeFormTemplate',
    DeleteIntakeFormTemplate: 'DeleteIntakeFormTemplate',
    AttachIntakeFormTemplate: 'AttachIntakeFormTemplate',
    DetachIntakeFormTemplate: 'DetachIntakeFormTemplate',
    UpdateIntakeFormValues: 'UpdateIntakeFormValues',
    CreateApideckSession: 'CreateApideckSession',
    PairCrmTenant: 'PairCrmTenant',
    SyncCrmPairing: 'SyncCrmPairing',
    RotateCrmSigningSecret: 'RotateCrmSigningSecret',
    PushCrmSigningSecret: 'PushCrmSigningSecret',
    SetCrmAppSecret: 'SetCrmAppSecret',
    DisconnectChannelInstallation: 'DisconnectChannelInstallation',
    IntegrateDocuSignForOrg: 'IntegrateDocuSignForOrg',
    IntegrateDocuSignForUser: 'IntegrateDocuSignForUser',
    DeleteDocuSignIntegration: 'DeleteDocuSignIntegration',
    CreateDraftEnvelope: 'CreateDraftEnvelope',
    ConnectExternalToolkit: 'ConnectExternalToolkit',
    DisconnectExternalToolkit: 'DisconnectExternalToolkit',
    SetExternalToolkitPolicy: 'SetExternalToolkitPolicy',
    SetExternalToolGrant: 'SetExternalToolGrant',
    SetExternalToolGrants: 'SetExternalToolGrants',
    BulkCreateFolderSyncJobs: 'BulkCreateFolderSyncJobs',
    DeleteFolderSyncJobs: 'DeleteFolderSyncJobs',
    DismissFailedFiles: 'DismissFailedFiles',
    TriggerFolderSyncSchedule: 'TriggerFolderSyncSchedule',
    RetryFolderSyncFailedFiles: 'RetryFolderSyncFailedFiles',
    SetFolderSyncJobLabels: 'SetFolderSyncJobLabels',
    SetFolderSyncJobAllowedMimeTypes: 'SetFolderSyncJobAllowedMimeTypes',
    StopFolderSyncJob: 'StopFolderSyncJob',
    GenerateAICompletion: 'GenerateAICompletion',
    ImprovePrompt: 'ImprovePrompt',
    FindOrCreateLabel: 'FindOrCreateLabel',
    SetWorkflowLabels: 'SetWorkflowLabels',
    SetDocumentLabels: 'SetDocumentLabels',
    BulkSetDocumentLabels: 'BulkSetDocumentLabels',
    DeleteLabel: 'DeleteLabel',
    SubscribeToActivity: 'SubscribeToActivity',
    UnsubscribeFromActivity: 'UnsubscribeFromActivity',
    CreateParty: 'CreateParty',
    DeleteParty: 'DeleteParty',
    UpdateParty: 'UpdateParty',
    AddPartyToDocument: 'AddPartyToDocument',
    RemovePartyFromDocument: 'RemovePartyFromDocument',
    SetWorkflowParties: 'SetWorkflowParties',
    SetDocumentParties: 'SetDocumentParties',
    BulkDeleteParties: 'BulkDeleteParties',
    MergeParties: 'MergeParties',
    CreatePhase: 'CreatePhase',
    UpdatePhase: 'UpdatePhase',
    DeletePhase: 'DeletePhase',
    ReorderPhases: 'ReorderPhases',
    CancelPlaybookGenerationJob: 'CancelPlaybookGenerationJob',
    StartPlaybookRun: 'StartPlaybookRun',
    StartPlaybookRuleJobs: 'StartPlaybookRuleJobs',
    CancelPlaybookRuleJobs: 'CancelPlaybookRuleJobs',
    ResolvePlaybookRuleJob: 'ResolvePlaybookRuleJob',
    ClearPlaybookRuleJobResolution: 'ClearPlaybookRuleJobResolution',
    ReviewPlaybookSuggestion: 'ReviewPlaybookSuggestion',
    CreatePlaybookRuleCategory: 'CreatePlaybookRuleCategory',
    UpdatePlaybookRuleCategory: 'UpdatePlaybookRuleCategory',
    DeletePlaybookRuleCategory: 'DeletePlaybookRuleCategory',
    ReorderPlaybookRuleCategories: 'ReorderPlaybookRuleCategories',
    MovePlaybookRuleCategory: 'MovePlaybookRuleCategory',
    CreatePlaybookRule: 'CreatePlaybookRule',
    UpdatePlaybookRule: 'UpdatePlaybookRule',
    MovePlaybookRule: 'MovePlaybookRule',
    DeletePlaybookRule: 'DeletePlaybookRule',
    AddPlaybookRulePosition: 'AddPlaybookRulePosition',
    UpdatePlaybookRulePosition: 'UpdatePlaybookRulePosition',
    DeletePlaybookRulePosition: 'DeletePlaybookRulePosition',
    ReorderPlaybookRulePositions: 'ReorderPlaybookRulePositions',
    MovePlaybookRulePositions: 'MovePlaybookRulePositions',
    CreatePlaybook: 'CreatePlaybook',
    UpdatePlaybook: 'UpdatePlaybook',
    DeletePlaybook: 'DeletePlaybook',
    DuplicatePlaybook: 'DuplicatePlaybook',
    CreateReminder: 'CreateReminder',
    UpdateReminder: 'UpdateReminder',
    UpdateReminders: 'UpdateReminders',
    DeleteReminder: 'DeleteReminder',
    DeleteReminders: 'DeleteReminders',
    CreateReport: 'CreateReport',
    DeleteReports: 'DeleteReports',
    StartReportExtraction: 'StartReportExtraction',
    UpdateReport: 'UpdateReport',
    UpdateReportState: 'UpdateReportState',
    SendReportExport: 'SendReportExport',
    GenerateCSRFToken: 'GenerateCSRFToken',
    GrantAccessByRequest: 'GrantAccessByRequest',
    DeleteAnnotations: 'DeleteAnnotations',
    UpsertAnnotations: 'UpsertAnnotations',
    CreateDocFile: 'CreateDocFile',
    CreateFiles: 'CreateFiles',
    CreateFileLocations: 'CreateFileLocations',
    ConfirmDocumentRelationship: 'ConfirmDocumentRelationship',
    BulkCreateDocumentRelationships: 'BulkCreateDocumentRelationships',
    CreateDocumentRelationship: 'CreateDocumentRelationship',
    RejectDocumentRelationship: 'RejectDocumentRelationship',
    DeleteDocumentRelationship: 'DeleteDocumentRelationship',
    SetDocumentRelationshipParentAndConfirm: 'SetDocumentRelationshipParentAndConfirm',
    SetDocumentRelationshipChildAndConfirm: 'SetDocumentRelationshipChildAndConfirm',
    UpdateDocumentRelationshipType: 'UpdateDocumentRelationshipType',
    RestoreDocumentRelationship: 'RestoreDocumentRelationship',
    BulkConfirmDocumentRelationships: 'BulkConfirmDocumentRelationships',
    BulkRejectDocumentRelationships: 'BulkRejectDocumentRelationships',
    SetParentChildRelationshipsEnabled: 'SetParentChildRelationshipsEnabled',
    RetryFailedDocumentRelationships: 'RetryFailedDocumentRelationships',
    DuplicateTemplate: 'DuplicateTemplate',
    ChangeDocumentsType: 'ChangeDocumentsType',
    CreateDocument: 'CreateDocument',
    DeleteDocuments: 'DeleteDocuments',
    DisableDocuments: 'DisableDocuments',
    ForwardDocument: 'ForwardDocument',
    SendDocumentViaEmail: 'SendDocumentViaEmail',
    SendDocumentViaEmailTest: 'SendDocumentViaEmailTest',
    StartOCRForDocuments: 'StartOCRForDocuments',
    RestoreDocuments: 'RestoreDocuments',
    SaveDocument: 'SaveDocument',
    UpdateDocumentProps: 'UpdateDocumentProps',
    SetDocumentsStatus: 'SetDocumentsStatus',
    CancelDocumentStatusJob: 'CancelDocumentStatusJob',
    CopyDocument: 'CopyDocument',
    ImportDocument: 'ImportDocument',
    CreateStaticFileVersion: 'CreateStaticFileVersion',
    CreateStaticFileVersions: 'CreateStaticFileVersions',
    DeleteFileVersion: 'DeleteFileVersion',
    SyncFileVersionToCrm: 'SyncFileVersionToCrm',
    UpdateFileVersion: 'UpdateFileVersion',
    DeleteStorablePermission: 'DeleteStorablePermission',
    UpsertStorablePermissions: 'UpsertStorablePermissions',
    DeleteStorables: 'DeleteStorables',
    DisableStorables: 'DisableStorables',
    FavoriteStorables: 'FavoriteStorables',
    MoveStorables: 'MoveStorables',
    MoveStorablesSimple: 'MoveStorablesSimple',
    RestoreStorables: 'RestoreStorables',
    UpdateStorable: 'UpdateStorable',
    RequestAccessToStorable: 'RequestAccessToStorable',
    CreateTaskField: 'CreateTaskField',
    UpdateTaskField: 'UpdateTaskField',
    DeleteTaskField: 'DeleteTaskField',
    SubmitTaskFieldResponse: 'SubmitTaskFieldResponse',
    ReorderTaskFields: 'ReorderTaskFields',
    CreateTask: 'CreateTask',
    SetTaskAssignees: 'SetTaskAssignees',
    UpdateTask: 'UpdateTask',
    StartTaskAiExecution: 'StartTaskAiExecution',
    SetTaskDelegatedToAi: 'SetTaskDelegatedToAi',
    UpdateTaskDescriptionMarkdown: 'UpdateTaskDescriptionMarkdown',
    UpdateTaskExternalDescriptionMarkdown: 'UpdateTaskExternalDescriptionMarkdown',
    ChangeTaskStatus: 'ChangeTaskStatus',
    DeleteTask: 'DeleteTask',
    SetTaskAssigneeRequired: 'SetTaskAssigneeRequired',
    SetTaskAssigneeRole: 'SetTaskAssigneeRole',
    RequestTaskReview: 'RequestTaskReview',
    UndoTaskReviewRequest: 'UndoTaskReviewRequest',
    ApproveTask: 'ApproveTask',
    StartTask: 'StartTask',
    RequestTaskChanges: 'RequestTaskChanges',
    CompleteTaskForAssignee: 'CompleteTaskForAssignee',
    RemindTaskAssignees: 'RemindTaskAssignees',
    RemindTaskReviewers: 'RemindTaskReviewers',
    RejectTask: 'RejectTask',
    UploadTaskResponseVersion: 'UploadTaskResponseVersion',
    ClearTaskUpload: 'ClearTaskUpload',
    CreateUserDefinedRole: 'CreateUserDefinedRole',
    DeleteUserDefinedRole: 'DeleteUserDefinedRole',
    MergeRoles: 'MergeRoles',
    UpdateUserDefinedRole: 'UpdateUserDefinedRole',
    CreateCannedField: 'CreateCannedField',
    UpdateCannedField: 'UpdateCannedField',
    DeleteCannedField: 'DeleteCannedField',
    CreateDocumentVariable: 'CreateDocumentVariable',
    DisableDocumentVariable: 'DisableDocumentVariable',
    UpdateDocumentVariable: 'UpdateDocumentVariable',
    CreateVariableConfig: 'CreateVariableConfig',
    DeleteVariableConfig: 'DeleteVariableConfig',
    UpdateVariableConfig: 'UpdateVariableConfig',
    MergeVariableConfigs: 'MergeVariableConfigs',
    LinkWorkflowOpportunity: 'LinkWorkflowOpportunity',
    UnlinkWorkflowOpportunity: 'UnlinkWorkflowOpportunity',
    CreateWorkflowFromSalesforce: 'CreateWorkflowFromSalesforce',
    ClearUnusedWorkflowActions: 'ClearUnusedWorkflowActions',
    SetWorkflowFileDocumentRole: 'SetWorkflowFileDocumentRole',
    UpdateWorkflowFileOrder: 'UpdateWorkflowFileOrder',
    SetWorkflowFileInternal: 'SetWorkflowFileInternal',
    CreateWorkflowView: 'CreateWorkflowView',
    MaterializeSystemInsightChart: 'MaterializeSystemInsightChart',
    UpdateWorkflowView: 'UpdateWorkflowView',
    AddWorkflowViewChart: 'AddWorkflowViewChart',
    DeleteWorkflowViewChart: 'DeleteWorkflowViewChart',
    CreateInsightPin: 'CreateInsightPin',
    UpdateInsightPin: 'UpdateInsightPin',
    PublishInsightPinToOrg: 'PublishInsightPinToOrg',
    DeleteInsightPin: 'DeleteInsightPin',
    DeleteWorkflowView: 'DeleteWorkflowView',
    SetSystemInsightChartHidden: 'SetSystemInsightChartHidden',
    CreateWorkflowLaunchConfig: 'CreateWorkflowLaunchConfig',
    UpdateWorkflowLaunchConfig: 'UpdateWorkflowLaunchConfig',
    DeleteWorkflowLaunchConfig: 'DeleteWorkflowLaunchConfig',
    LaunchWorkflowViaConfig: 'LaunchWorkflowViaConfig',
    CreateFilesViaLaunchConfig: 'CreateFilesViaLaunchConfig',
    DeleteFilesViaLaunchConfig: 'DeleteFilesViaLaunchConfig',
    AddWorkflowPermissions: 'AddWorkflowPermissions',
    RemoveWorkflowPermissions: 'RemoveWorkflowPermissions',
    GetOrCreateWorkflowLauncherPermission: 'GetOrCreateWorkflowLauncherPermission',
    UpdateWorkflowPermission: 'UpdateWorkflowPermission',
    CreateWorkflowRecipient: 'CreateWorkflowRecipient',
    ChangeRecipientAction: 'ChangeRecipientAction',
    ReassignRecipient: 'ReassignRecipient',
    DeclineSignatureReminders: 'DeclineSignatureReminders',
    UpdateRecipientName: 'UpdateRecipientName',
    AddDocumentsToWorkflow: 'AddDocumentsToWorkflow',
    RemoveDocumentsFromWorkflow: 'RemoveDocumentsFromWorkflow',
    InitializeWorkflow: 'InitializeWorkflow',
    CreateWorkflowForDocuments: 'CreateWorkflowForDocuments',
    ChangeRecipientAssignment: 'ChangeRecipientAssignment',
    ChangeCollaboratorAssignment: 'ChangeCollaboratorAssignment',
    CreateWorkflowInstance: 'CreateWorkflowInstance',
    DeleteWorkflow: 'DeleteWorkflow',
    CancelWorkflowAiBuild: 'CancelWorkflowAiBuild',
    DeleteWorkflowActions: 'DeleteWorkflowActions',
    FinishFieldActions: 'FinishFieldActions',
    ForwardWorkflow: 'ForwardWorkflow',
    MoveWorkflowStepActions: 'MoveWorkflowStepActions',
    ToggleWorkflowOrder: 'ToggleWorkflowOrder',
    RequestAccessToDocumentWorkflow: 'RequestAccessToDocumentWorkflow',
    RelocateWorkflowToBoard: 'RelocateWorkflowToBoard',
    UpdateWorkflow: 'UpdateWorkflow',
    SetWorkflowCrmPublish: 'SetWorkflowCrmPublish',
    StartWorkflowWork: 'StartWorkflowWork',
    RenotifyCurrentStep: 'RenotifyCurrentStep',
    SendWorkflowForSignature: 'SendWorkflowForSignature',
    FinishSigningOutsideAline: 'FinishSigningOutsideAline',
    SetSignOutsideAline: 'SetSignOutsideAline',
    ApplySignedVersionOutsideAline: 'ApplySignedVersionOutsideAline',
    TogglePublishTemplate: 'TogglePublishTemplate'
  },
  Subscription: {
    OnTaskActivityFeedChanged: 'OnTaskActivityFeedChanged',
    OnWorkflowActivityFeedChanged: 'OnWorkflowActivityFeedChanged',
    AgentSkillDraftChanged: 'AgentSkillDraftChanged',
    OnAgentEvent: 'OnAgentEvent',
    OnAIReminderAutomationUpdated: 'OnAIReminderAutomationUpdated',
    BulkExportUpdated: 'BulkExportUpdated',
    OnDocumentMetadataImportProgress: 'OnDocumentMetadataImportProgress',
    OnInboxNotificationsChanged: 'OnInboxNotificationsChanged',
    OnFolderSyncJobUpdate: 'OnFolderSyncJobUpdate',
    OnCompletionReceived: 'OnCompletionReceived',
    OnImprovedPrompt: 'OnImprovedPrompt',
    OnWorkflowPhasesChanged: 'OnWorkflowPhasesChanged',
    OnRemindersUpdated: 'OnRemindersUpdated',
    ReportUpdated: 'ReportUpdated',
    OnRepositoryMetaUpdated: 'OnRepositoryMetaUpdated',
    OnAnnotationsChanged: 'OnAnnotationsChanged',
    OnDocumentRelationshipUpdated: 'OnDocumentRelationshipUpdated',
    OnDocumentStatusJobProgress: 'OnDocumentStatusJobProgress',
    OnDocumentUpdated: 'OnDocumentUpdated',
    OnDocumentsUpdated: 'OnDocumentsUpdated',
    OnDocPlaybooksUpdated: 'OnDocPlaybooksUpdated',
    OnPlaybookGenerationJobUpdated: 'OnPlaybookGenerationJobUpdated',
    OnQuestionGenerationUpdated: 'OnQuestionGenerationUpdated',
    OnWorkflowsUpdated: 'OnWorkflowsUpdated'
  },
  Fragment: {
    ObservedSkillDraft: 'ObservedSkillDraft',
    DisplayNameUpdate: 'DisplayNameUpdate',
    SkillArtifactThreadForTest: 'SkillArtifactThreadForTest',
    SkillForSkillArtifactTest: 'SkillForSkillArtifactTest',
    WorkflowArtifactThreadForTest: 'WorkflowArtifactThreadForTest',
    SeedAgentThreadForTest: 'SeedAgentThreadForTest',
    ArtifactDocumentFieldsForTest: 'ArtifactDocumentFieldsForTest',
    ArtifactDocumentFields: 'ArtifactDocumentFields',
    ArtifactReportFields: 'ArtifactReportFields',
    AgentThreadIdProbe: 'AgentThreadIdProbe',
    ArtifactSkillFields: 'ArtifactSkillFields',
    ArtifactWorkflowFields: 'ArtifactWorkflowFields',
    AlineChatAdapterMessageData: 'AlineChatAdapterMessageData',
    AgentMessageFields: 'AgentMessageFields',
    StreamingAgentMessageFields: 'StreamingAgentMessageFields',
    StreamingMessageData: 'StreamingMessageData',
    StreamingMessagePlanState: 'StreamingMessagePlanState',
    ThreadTitle: 'ThreadTitle',
    SelectedParty: 'SelectedParty',
    NewDocument: 'NewDocument',
    RelationshipReviewStatus: 'RelationshipReviewStatus',
    CurrentFileVersion: 'CurrentFileVersion',
    NewAutomation: 'NewAutomation',
    NewAnswerOptions: 'NewAnswerOptions',
    NewBoard: 'NewBoard',
    NewComment: 'NewComment',
    NewReply: 'NewReply',
    NewContractType: 'NewContractType',
    UpdateDocument: 'UpdateDocument',
    NewJob: 'NewJob',
    NewPlaybook: 'NewPlaybook',
    CreateDocument: 'CreateDocument',
    DuplicateTemplate: 'DuplicateTemplate',
    CopyDocument: 'CopyDocument',
    ReportColumnOptionsForTest: 'ReportColumnOptionsForTest',
    NewExtractionJob: 'NewExtractionJob',
    NewExtractionQuestionGenerationJob: 'NewExtractionQuestionGenerationJob',
    NewQuestionOption: 'NewQuestionOption',
    NewExtractionQuestion: 'NewExtractionQuestion',
    NewSignature: 'NewSignature',
    NewVersion: 'NewVersion',
    NewSignedVersion: 'NewSignedVersion',
    CreateFiles: 'CreateFiles',
    NewFolderSyncJob: 'NewFolderSyncJob',
    NewGroup: 'NewGroup',
    NewUser: 'NewUser',
    NewLabel: 'NewLabel',
    NewMember: 'NewMember',
    NewParty: 'NewParty',
    NewPhase: 'NewPhase',
    PhaseSigningFlag: 'PhaseSigningFlag',
    PhaseRef: 'PhaseRef',
    ReminderIdentity: 'ReminderIdentity',
    NewReminder: 'NewReminder',
    NewReport: 'NewReport',
    NewRole: 'NewRole',
    NewPermission: 'NewPermission',
    NewTask: 'NewTask',
    NewTaskPermission: 'NewTaskPermission',
    NewVariable: 'NewVariable',
    NewWorkflowPermission: 'NewWorkflowPermission',
    NewWorkflow: 'NewWorkflow',
    AccountBase: 'AccountBase',
    AlineSubscriptionSimple: 'AlineSubscriptionSimple',
    GroupSimple: 'GroupSimple',
    GroupWithUsers: 'GroupWithUsers',
    OnboardingTaskSimple: 'OnboardingTaskSimple',
    OrgBase: 'OrgBase',
    UpgradeRequestBase: 'UpgradeRequestBase',
    UserSettingsSimple: 'UserSettingsSimple',
    UserOnboardingInfo: 'UserOnboardingInfo',
    MinimalUser: 'MinimalUser',
    UserBase: 'UserBase',
    UserFull: 'UserFull',
    AssigneeSimple: 'AssigneeSimple',
    UserWithRecentDocuments: 'UserWithRecentDocuments',
    WithRecentDocuments: 'WithRecentDocuments',
    ActivityItemFields: 'ActivityItemFields',
    ActivityPageFields: 'ActivityPageFields',
    AgentSkillListItem: 'AgentSkillListItem',
    AgentSkillAttachmentFields: 'AgentSkillAttachmentFields',
    AgentSkillSimple: 'AgentSkillSimple',
    AIReminderAutomationSimple: 'AIReminderAutomationSimple',
    AIReminderAutomationWithRelations: 'AIReminderAutomationWithRelations',
    AIReminderAutomationRunSimple: 'AIReminderAutomationRunSimple',
    AnswerOptionBase: 'AnswerOptionBase',
    AnswerOptionsBase: 'AnswerOptionsBase',
    ApiKeyBase: 'ApiKeyBase',
    BoardBase: 'BoardBase',
    BoardWithColumns: 'BoardWithColumns',
    BoardFull: 'BoardFull',
    ColumnBase: 'ColumnBase',
    ColumnWithBoard: 'ColumnWithBoard',
    ColumnWithWorkflows: 'ColumnWithWorkflows',
    CommentFields: 'CommentFields',
    CommentFieldsBase: 'CommentFieldsBase',
    CommentSimple: 'CommentSimple',
    ReplySimple: 'ReplySimple',
    CommunityCategorySimple: 'CommunityCategorySimple',
    ContractTypeSimple: 'ContractTypeSimple',
    DocumentMetadataImportSummaryFields: 'DocumentMetadataImportSummaryFields',
    DocumentMetadataImportHistoryFields: 'DocumentMetadataImportHistoryFields',
    DocumentMetadataImportFields: 'DocumentMetadataImportFields',
    DocumentMetadataImportPreviewFields: 'DocumentMetadataImportPreviewFields',
    DocumentForSignature: 'DocumentForSignature',
    EnvelopeSimple: 'EnvelopeSimple',
    EnvelopeWithFiles: 'EnvelopeWithFiles',
    ExtractionJobSimple: 'ExtractionJobSimple',
    DocLocationSimple: 'DocLocationSimple',
    QuestionGenerationJobSimple: 'QuestionGenerationJobSimple',
    ExtractionQuestionSimple: 'ExtractionQuestionSimple',
    QuestionOptionSimple: 'QuestionOptionSimple',
    FieldActionSimple: 'FieldActionSimple',
    FieldSimple: 'FieldSimple',
    FieldInfo: 'FieldInfo',
    SignatureFieldSimple: 'SignatureFieldSimple',
    SignatureFieldBase: 'SignatureFieldBase',
    InboxNotificationSimple: 'InboxNotificationSimple',
    InboxNotificationsResultSimple: 'InboxNotificationsResultSimple',
    IntakeFormTemplateFull: 'IntakeFormTemplateFull',
    IntakeFormFull: 'IntakeFormFull',
    CrmPairingKeyStatus: 'CrmPairingKeyStatus',
    ApiDeckConnectionSimple: 'ApiDeckConnectionSimple',
    IntegrationFieldSimple: 'IntegrationFieldSimple',
    ChannelInstallationSimple: 'ChannelInstallationSimple',
    ExternalToolkitSimple: 'ExternalToolkitSimple',
    ExternalToolkitPolicyRowSimple: 'ExternalToolkitPolicyRowSimple',
    FolderSyncJobSimple: 'FolderSyncJobSimple',
    DriveSimple: 'DriveSimple',
    FolderFileSimple: 'FolderFileSimple',
    FailedFileSimple: 'FailedFileSimple',
    CompletionFull: 'CompletionFull',
    LabelSimple: 'LabelSimple',
    WorkflowLabelFull: 'WorkflowLabelFull',
    ActivitySubscribersFields: 'ActivitySubscribersFields',
    ActivitySubscriberOptionFields: 'ActivitySubscriberOptionFields',
    PartySimple: 'PartySimple',
    PhaseSimple: 'PhaseSimple',
    PlaybookGenerationProgress: 'PlaybookGenerationProgress',
    PlaybookRuleWithJob: 'PlaybookRuleWithJob',
    PlaybookRuleCategoryWithRuleJobs: 'PlaybookRuleCategoryWithRuleJobs',
    PlaybookRuleJobPositionResultSimple: 'PlaybookRuleJobPositionResultSimple',
    PlaybookRuleProposalSimple: 'PlaybookRuleProposalSimple',
    PlaybookRuleJobSimple: 'PlaybookRuleJobSimple',
    PlaybookRuleJobWithProposals: 'PlaybookRuleJobWithProposals',
    PlaybookWithCategories: 'PlaybookWithCategories',
    PlaybookRuleCategorySimple: 'PlaybookRuleCategorySimple',
    PlaybookRulePositionSimple: 'PlaybookRulePositionSimple',
    PlaybookRuleSimple: 'PlaybookRuleSimple',
    PlaybookRuleCategoryWithRules: 'PlaybookRuleCategoryWithRules',
    PlaybookListItem: 'PlaybookListItem',
    PlaybookSimple: 'PlaybookSimple',
    ReminderSimple: 'ReminderSimple',
    ReminderMeta: 'ReminderMeta',
    ReportColumnOptionBase: 'ReportColumnOptionBase',
    ReportBase: 'ReportBase',
    ReportFullData: 'ReportFullData',
    DocumentExtractionStatus: 'DocumentExtractionStatus',
    DocumentReportRow: 'DocumentReportRow',
    DocumentReportRowQuestionJob: 'DocumentReportRowQuestionJob',
    UpdateReportFragment: 'UpdateReportFragment',
    RepositoryView: 'RepositoryView',
    TokenResponse: 'TokenResponse',
    FileSimple: 'FileSimple',
    FilestackUploadOptionsBase: 'FilestackUploadOptionsBase',
    FilestackDownloadOptionsBase: 'FilestackDownloadOptionsBase',
    FilestackSecurityBase: 'FilestackSecurityBase',
    DocFileSimple: 'DocFileSimple',
    RelationshipCacheFields: 'RelationshipCacheFields',
    DocumentStatusJobFields: 'DocumentStatusJobFields',
    DocumentMetadata: 'DocumentMetadata',
    DocumentFieldsBase: 'DocumentFieldsBase',
    DocumentSimple: 'DocumentSimple',
    DocumentWithFields: 'DocumentWithFields',
    DocumentFileDetailsRelatedDocument: 'DocumentFileDetailsRelatedDocument',
    DocumentFileDetailsRelationship: 'DocumentFileDetailsRelationship',
    DocumentFileDetailsUrlRelationship: 'DocumentFileDetailsUrlRelationship',
    FileVersionSimple: 'FileVersionSimple',
    PermissionWithStorable: 'PermissionWithStorable',
    PermissionSimple: 'PermissionSimple',
    MoveStorableFields: 'MoveStorableFields',
    StorableFields: 'StorableFields',
    StorableSimple: 'StorableSimple',
    TaskFieldSimple: 'TaskFieldSimple',
    TaskSimple: 'TaskSimple',
    TaskAssignmentFields: 'TaskAssignmentFields',
    VersionTaskUpload: 'VersionTaskUpload',
    TaskUploadFields: 'TaskUploadFields',
    TaskReviewFields: 'TaskReviewFields',
    TaskViewerActionFields: 'TaskViewerActionFields',
    TaskUnsubmittedReviewFields: 'TaskUnsubmittedReviewFields',
    DisallowedTaskReasonsSimple: 'DisallowedTaskReasonsSimple',
    UserDefinedRoleSimple: 'UserDefinedRoleSimple',
    CannedFieldFull: 'CannedFieldFull',
    DocumentVariableFull: 'DocumentVariableFull',
    DocumentVariableSimple: 'DocumentVariableSimple',
    VariableConfigSimple: 'VariableConfigSimple',
    VariableConfigFull: 'VariableConfigFull',
    WorkflowStepFragment: 'WorkflowStepFragment',
    TaskActionSimple: 'TaskActionSimple',
    RequesterWorkflowRecipient: 'RequesterWorkflowRecipient',
    WorkflowFileSimple: 'WorkflowFileSimple',
    WorkflowFileWithFields: 'WorkflowFileWithFields',
    LaunchConfigSimple: 'LaunchConfigSimple',
    WorkflowPermissionSimple: 'WorkflowPermissionSimple',
    WorkflowPermissionWithActions: 'WorkflowPermissionWithActions',
    WorkflowRecipientSimple: 'WorkflowRecipientSimple',
    WorkflowRecipientWithFields: 'WorkflowRecipientWithFields',
    WorkflowSigningPhaseSteps: 'WorkflowSigningPhaseSteps',
    WorkflowSigningPhaseStepsSummary: 'WorkflowSigningPhaseStepsSummary',
    WorkflowFragment: 'WorkflowFragment',
    WorkflowWithFiles: 'WorkflowWithFiles',
    WorkflowInboxWorkflow: 'WorkflowInboxWorkflow',
    WorkBlockerWorkflowRecipient: 'WorkBlockerWorkflowRecipient',
    WorkflowStepAllPropsFragment: 'WorkflowStepAllPropsFragment',
    WorkflowSigningPhaseStepsAllProps: 'WorkflowSigningPhaseStepsAllProps'
  }
}